(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["usafactsCovid"] = factory();
	else
		root["usafactsCovid"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00a5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _selection_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e48b");


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new _selection_index_js__WEBPACK_IMPORTED_MODULE_0__[/* Selection */ "a"]([[document.querySelector(selector)]], [document.documentElement])
      : new _selection_index_js__WEBPACK_IMPORTED_MODULE_0__[/* Selection */ "a"]([[selector]], _selection_index_js__WEBPACK_IMPORTED_MODULE_0__[/* root */ "c"]);
});


/***/ }),

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "00fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),

/***/ "00fd":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "03dd":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("eac5"),
    nativeKeys = __webpack_require__("57a5");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "0644":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("3818");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07c7":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "087d":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "08cc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "0906":
/***/ (function(module, exports) {

module.exports = {
  future: {},
  purge: [],
  target: 'relaxed',
  prefix: '',
  important: false,
  separator: ':',
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',

      black: '#000',
      white: '#fff',

      gray: {
        100: '#f7fafc',
        200: '#edf2f7',
        300: '#e2e8f0',
        400: '#cbd5e0',
        500: '#a0aec0',
        600: '#718096',
        700: '#4a5568',
        800: '#2d3748',
        900: '#1a202c',
      },
      red: {
        100: '#fff5f5',
        200: '#fed7d7',
        300: '#feb2b2',
        400: '#fc8181',
        500: '#f56565',
        600: '#e53e3e',
        700: '#c53030',
        800: '#9b2c2c',
        900: '#742a2a',
      },
      orange: {
        100: '#fffaf0',
        200: '#feebc8',
        300: '#fbd38d',
        400: '#f6ad55',
        500: '#ed8936',
        600: '#dd6b20',
        700: '#c05621',
        800: '#9c4221',
        900: '#7b341e',
      },
      yellow: {
        100: '#fffff0',
        200: '#fefcbf',
        300: '#faf089',
        400: '#f6e05e',
        500: '#ecc94b',
        600: '#d69e2e',
        700: '#b7791f',
        800: '#975a16',
        900: '#744210',
      },
      green: {
        100: '#f0fff4',
        200: '#c6f6d5',
        300: '#9ae6b4',
        400: '#68d391',
        500: '#48bb78',
        600: '#38a169',
        700: '#2f855a',
        800: '#276749',
        900: '#22543d',
      },
      teal: {
        100: '#e6fffa',
        200: '#b2f5ea',
        300: '#81e6d9',
        400: '#4fd1c5',
        500: '#38b2ac',
        600: '#319795',
        700: '#2c7a7b',
        800: '#285e61',
        900: '#234e52',
      },
      blue: {
        100: '#ebf8ff',
        200: '#bee3f8',
        300: '#90cdf4',
        400: '#63b3ed',
        500: '#4299e1',
        600: '#3182ce',
        700: '#2b6cb0',
        800: '#2c5282',
        900: '#2a4365',
      },
      indigo: {
        100: '#ebf4ff',
        200: '#c3dafe',
        300: '#a3bffa',
        400: '#7f9cf5',
        500: '#667eea',
        600: '#5a67d8',
        700: '#4c51bf',
        800: '#434190',
        900: '#3c366b',
      },
      purple: {
        100: '#faf5ff',
        200: '#e9d8fd',
        300: '#d6bcfa',
        400: '#b794f4',
        500: '#9f7aea',
        600: '#805ad5',
        700: '#6b46c1',
        800: '#553c9a',
        900: '#44337a',
      },
      pink: {
        100: '#fff5f7',
        200: '#fed7e2',
        300: '#fbb6ce',
        400: '#f687b3',
        500: '#ed64a6',
        600: '#d53f8c',
        700: '#b83280',
        800: '#97266d',
        900: '#702459',
      },
    },
    spacing: {
      px: '1px',
      '0': '0',
      '1': '0.25rem',
      '2': '0.5rem',
      '3': '0.75rem',
      '4': '1rem',
      '5': '1.25rem',
      '6': '1.5rem',
      '8': '2rem',
      '10': '2.5rem',
      '12': '3rem',
      '16': '4rem',
      '20': '5rem',
      '24': '6rem',
      '32': '8rem',
      '40': '10rem',
      '48': '12rem',
      '56': '14rem',
      '64': '16rem',
    },
    backgroundColor: theme => theme('colors'),
    backgroundImage: {
      none: 'none',
      'gradient-to-t': 'linear-gradient(to top, var(--gradient-color-stops))',
      'gradient-to-tr': 'linear-gradient(to top right, var(--gradient-color-stops))',
      'gradient-to-r': 'linear-gradient(to right, var(--gradient-color-stops))',
      'gradient-to-br': 'linear-gradient(to bottom right, var(--gradient-color-stops))',
      'gradient-to-b': 'linear-gradient(to bottom, var(--gradient-color-stops))',
      'gradient-to-bl': 'linear-gradient(to bottom left, var(--gradient-color-stops))',
      'gradient-to-l': 'linear-gradient(to left, var(--gradient-color-stops))',
      'gradient-to-tl': 'linear-gradient(to top left, var(--gradient-color-stops))',
    },
    gradientColorStops: theme => theme('colors'),
    backgroundOpacity: theme => theme('opacity'),
    backgroundPosition: {
      bottom: 'bottom',
      center: 'center',
      left: 'left',
      'left-bottom': 'left bottom',
      'left-top': 'left top',
      right: 'right',
      'right-bottom': 'right bottom',
      'right-top': 'right top',
      top: 'top',
    },
    backgroundSize: {
      auto: 'auto',
      cover: 'cover',
      contain: 'contain',
    },
    borderColor: theme => ({
      ...theme('colors'),
      default: theme('colors.gray.300', 'currentColor'),
    }),
    borderOpacity: theme => theme('opacity'),
    borderRadius: {
      none: '0',
      sm: '0.125rem',
      default: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1rem',
      '3xl': '1.5rem',
      full: '9999px',
    },
    borderWidth: {
      default: '1px',
      '0': '0',
      '2': '2px',
      '4': '4px',
      '8': '8px',
    },
    boxShadow: {
      xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
      sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
      outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
      none: 'none',
    },
    container: {},
    cursor: {
      auto: 'auto',
      default: 'default',
      pointer: 'pointer',
      wait: 'wait',
      text: 'text',
      move: 'move',
      'not-allowed': 'not-allowed',
    },
    divideColor: theme => theme('borderColor'),
    divideOpacity: theme => theme('borderOpacity'),
    divideWidth: theme => theme('borderWidth'),
    fill: {
      current: 'currentColor',
    },
    flex: {
      '1': '1 1 0%',
      auto: '1 1 auto',
      initial: '0 1 auto',
      none: 'none',
    },
    flexGrow: {
      '0': '0',
      default: '1',
    },
    flexShrink: {
      '0': '0',
      default: '1',
    },
    fontFamily: {
      sans: [
        'system-ui',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        '"Noto Sans"',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ],
      serif: ['Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'],
      mono: ['Menlo', 'Monaco', 'Consolas', '"Liberation Mono"', '"Courier New"', 'monospace'],
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '4rem',
    },
    fontWeight: {
      hairline: '100',
      thin: '200',
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800',
      black: '900',
    },
    height: theme => ({
      auto: 'auto',
      ...theme('spacing'),
      full: '100%',
      screen: '100vh',
    }),
    inset: {
      '0': '0',
      auto: 'auto',
    },
    letterSpacing: {
      tighter: '-0.05em',
      tight: '-0.025em',
      normal: '0',
      wide: '0.025em',
      wider: '0.05em',
      widest: '0.1em',
    },
    lineHeight: {
      none: '1',
      tight: '1.25',
      snug: '1.375',
      normal: '1.5',
      relaxed: '1.625',
      loose: '2',
      '3': '.75rem',
      '4': '1rem',
      '5': '1.25rem',
      '6': '1.5rem',
      '7': '1.75rem',
      '8': '2rem',
      '9': '2.25rem',
      '10': '2.5rem',
    },
    listStyleType: {
      none: 'none',
      disc: 'disc',
      decimal: 'decimal',
    },
    margin: (theme, { negative }) => ({
      auto: 'auto',
      ...theme('spacing'),
      ...negative(theme('spacing')),
    }),
    maxHeight: {
      full: '100%',
      screen: '100vh',
    },
    maxWidth: (theme, { breakpoints }) => ({
      none: 'none',
      xs: '20rem',
      sm: '24rem',
      md: '28rem',
      lg: '32rem',
      xl: '36rem',
      '2xl': '42rem',
      '3xl': '48rem',
      '4xl': '56rem',
      '5xl': '64rem',
      '6xl': '72rem',
      full: '100%',
      ...breakpoints(theme('screens')),
    }),
    minHeight: {
      '0': '0',
      full: '100%',
      screen: '100vh',
    },
    minWidth: {
      '0': '0',
      full: '100%',
    },
    objectPosition: {
      bottom: 'bottom',
      center: 'center',
      left: 'left',
      'left-bottom': 'left bottom',
      'left-top': 'left top',
      right: 'right',
      'right-bottom': 'right bottom',
      'right-top': 'right top',
      top: 'top',
    },
    opacity: {
      '0': '0',
      '25': '0.25',
      '50': '0.5',
      '75': '0.75',
      '100': '1',
    },
    order: {
      first: '-9999',
      last: '9999',
      none: '0',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      '10': '10',
      '11': '11',
      '12': '12',
    },
    outline: {
      none: ['2px solid transparent', '2px'],
      white: ['2px dotted white', '2px'],
      black: ['2px dotted black', '2px'],
    },
    padding: theme => theme('spacing'),
    placeholderColor: theme => theme('colors'),
    placeholderOpacity: theme => theme('opacity'),
    space: (theme, { negative }) => ({
      ...theme('spacing'),
      ...negative(theme('spacing')),
    }),
    stroke: {
      current: 'currentColor',
    },
    strokeWidth: {
      '0': '0',
      '1': '1',
      '2': '2',
    },
    textColor: theme => theme('colors'),
    textOpacity: theme => theme('opacity'),
    width: theme => ({
      auto: 'auto',
      ...theme('spacing'),
      '1/2': '50%',
      '1/3': '33.333333%',
      '2/3': '66.666667%',
      '1/4': '25%',
      '2/4': '50%',
      '3/4': '75%',
      '1/5': '20%',
      '2/5': '40%',
      '3/5': '60%',
      '4/5': '80%',
      '1/6': '16.666667%',
      '2/6': '33.333333%',
      '3/6': '50%',
      '4/6': '66.666667%',
      '5/6': '83.333333%',
      '1/12': '8.333333%',
      '2/12': '16.666667%',
      '3/12': '25%',
      '4/12': '33.333333%',
      '5/12': '41.666667%',
      '6/12': '50%',
      '7/12': '58.333333%',
      '8/12': '66.666667%',
      '9/12': '75%',
      '10/12': '83.333333%',
      '11/12': '91.666667%',
      full: '100%',
      screen: '100vw',
    }),
    zIndex: {
      auto: 'auto',
      '0': '0',
      '10': '10',
      '20': '20',
      '30': '30',
      '40': '40',
      '50': '50',
    },
    gap: theme => theme('spacing'),
    gridTemplateColumns: {
      none: 'none',
      '1': 'repeat(1, minmax(0, 1fr))',
      '2': 'repeat(2, minmax(0, 1fr))',
      '3': 'repeat(3, minmax(0, 1fr))',
      '4': 'repeat(4, minmax(0, 1fr))',
      '5': 'repeat(5, minmax(0, 1fr))',
      '6': 'repeat(6, minmax(0, 1fr))',
      '7': 'repeat(7, minmax(0, 1fr))',
      '8': 'repeat(8, minmax(0, 1fr))',
      '9': 'repeat(9, minmax(0, 1fr))',
      '10': 'repeat(10, minmax(0, 1fr))',
      '11': 'repeat(11, minmax(0, 1fr))',
      '12': 'repeat(12, minmax(0, 1fr))',
    },
    gridAutoColumns: {
      auto: 'auto',
      min: 'min-content',
      max: 'max-content',
      fr: 'minmax(0, 1fr)',
    },
    gridColumn: {
      auto: 'auto',
      'span-1': 'span 1 / span 1',
      'span-2': 'span 2 / span 2',
      'span-3': 'span 3 / span 3',
      'span-4': 'span 4 / span 4',
      'span-5': 'span 5 / span 5',
      'span-6': 'span 6 / span 6',
      'span-7': 'span 7 / span 7',
      'span-8': 'span 8 / span 8',
      'span-9': 'span 9 / span 9',
      'span-10': 'span 10 / span 10',
      'span-11': 'span 11 / span 11',
      'span-12': 'span 12 / span 12',
      'span-full': '1 / -1',
    },
    gridColumnStart: {
      auto: 'auto',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      '10': '10',
      '11': '11',
      '12': '12',
      '13': '13',
    },
    gridColumnEnd: {
      auto: 'auto',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      '10': '10',
      '11': '11',
      '12': '12',
      '13': '13',
    },
    gridTemplateRows: {
      none: 'none',
      '1': 'repeat(1, minmax(0, 1fr))',
      '2': 'repeat(2, minmax(0, 1fr))',
      '3': 'repeat(3, minmax(0, 1fr))',
      '4': 'repeat(4, minmax(0, 1fr))',
      '5': 'repeat(5, minmax(0, 1fr))',
      '6': 'repeat(6, minmax(0, 1fr))',
    },
    gridAutoRows: {
      auto: 'auto',
      min: 'min-content',
      max: 'max-content',
      fr: 'minmax(0, 1fr)',
    },
    gridRow: {
      auto: 'auto',
      'span-1': 'span 1 / span 1',
      'span-2': 'span 2 / span 2',
      'span-3': 'span 3 / span 3',
      'span-4': 'span 4 / span 4',
      'span-5': 'span 5 / span 5',
      'span-6': 'span 6 / span 6',
      'span-full': '1 / -1',
    },
    gridRowStart: {
      auto: 'auto',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
    },
    gridRowEnd: {
      auto: 'auto',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
    },
    transformOrigin: {
      center: 'center',
      top: 'top',
      'top-right': 'top right',
      right: 'right',
      'bottom-right': 'bottom right',
      bottom: 'bottom',
      'bottom-left': 'bottom left',
      left: 'left',
      'top-left': 'top left',
    },
    scale: {
      '0': '0',
      '50': '.5',
      '75': '.75',
      '90': '.9',
      '95': '.95',
      '100': '1',
      '105': '1.05',
      '110': '1.1',
      '125': '1.25',
      '150': '1.5',
    },
    rotate: {
      '-180': '-180deg',
      '-90': '-90deg',
      '-45': '-45deg',
      '-12': '-12deg',
      '-6': '-6deg',
      '-3': '-3deg',
      '-2': '-2deg',
      '-1': '-1deg',
      '0': '0',
      '1': '1deg',
      '2': '2deg',
      '3': '3deg',
      '6': '6deg',
      '12': '12deg',
      '45': '45deg',
      '90': '90deg',
      '180': '180deg',
    },
    translate: (theme, { negative }) => ({
      ...theme('spacing'),
      ...negative(theme('spacing')),
      '-full': '-100%',
      '-1/2': '-50%',
      '1/2': '50%',
      full: '100%',
    }),
    skew: {
      '-12': '-12deg',
      '-6': '-6deg',
      '-3': '-3deg',
      '-2': '-2deg',
      '-1': '-1deg',
      '0': '0',
      '1': '1deg',
      '2': '2deg',
      '3': '3deg',
      '6': '6deg',
      '12': '12deg',
    },
    transitionProperty: {
      none: 'none',
      all: 'all',
      default: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
      colors: 'background-color, border-color, color, fill, stroke',
      opacity: 'opacity',
      shadow: 'box-shadow',
      transform: 'transform',
    },
    transitionTimingFunction: {
      linear: 'linear',
      in: 'cubic-bezier(0.4, 0, 1, 1)',
      out: 'cubic-bezier(0, 0, 0.2, 1)',
      'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
    },
    transitionDuration: {
      '75': '75ms',
      '100': '100ms',
      '150': '150ms',
      '200': '200ms',
      '300': '300ms',
      '500': '500ms',
      '700': '700ms',
      '1000': '1000ms',
    },
    transitionDelay: {
      '75': '75ms',
      '100': '100ms',
      '150': '150ms',
      '200': '200ms',
      '300': '300ms',
      '500': '500ms',
      '700': '700ms',
      '1000': '1000ms',
    },
    animation: {
      none: 'none',
      spin: 'spin 1s linear infinite',
      ping: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
      pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
      bounce: 'bounce 1s infinite',
    },
    keyframes: {
      spin: {
        to: { transform: 'rotate(360deg)' },
      },
      ping: {
        '75%, 100%': { transform: 'scale(2)', opacity: '0' },
      },
      pulse: {
        '50%': { opacity: '.5' },
      },
      bounce: {
        '0%, 100%': {
          transform: 'translateY(-25%)',
          animationTimingFunction: 'cubic-bezier(0.8,0,1,1)',
        },
        '50%': {
          transform: 'none',
          animationTimingFunction: 'cubic-bezier(0,0,0.2,1)',
        },
      },
    },
  },
  variants: {
    accessibility: ['responsive', 'focus'],
    alignContent: ['responsive'],
    alignItems: ['responsive'],
    alignSelf: ['responsive'],
    appearance: ['responsive'],
    backgroundAttachment: ['responsive'],
    backgroundClip: ['responsive'],
    backgroundColor: ['responsive', 'hover', 'focus'],
    backgroundImage: ['responsive'],
    gradientColorStops: ['responsive', 'hover', 'focus'],
    backgroundOpacity: ['responsive', 'hover', 'focus'],
    backgroundPosition: ['responsive'],
    backgroundRepeat: ['responsive'],
    backgroundSize: ['responsive'],
    borderCollapse: ['responsive'],
    borderColor: ['responsive', 'hover', 'focus'],
    borderOpacity: ['responsive', 'hover', 'focus'],
    borderRadius: ['responsive'],
    borderStyle: ['responsive'],
    borderWidth: ['responsive'],
    boxShadow: ['responsive', 'hover', 'focus'],
    boxSizing: ['responsive'],
    container: ['responsive'],
    cursor: ['responsive'],
    display: ['responsive'],
    divideColor: ['responsive'],
    divideOpacity: ['responsive'],
    divideStyle: ['responsive'],
    divideWidth: ['responsive'],
    fill: ['responsive'],
    flex: ['responsive'],
    flexDirection: ['responsive'],
    flexGrow: ['responsive'],
    flexShrink: ['responsive'],
    flexWrap: ['responsive'],
    float: ['responsive'],
    clear: ['responsive'],
    fontFamily: ['responsive'],
    fontSize: ['responsive'],
    fontSmoothing: ['responsive'],
    fontVariantNumeric: ['responsive'],
    fontStyle: ['responsive'],
    fontWeight: ['responsive', 'hover', 'focus'],
    height: ['responsive'],
    inset: ['responsive'],
    justifyContent: ['responsive'],
    justifyItems: ['responsive'],
    justifySelf: ['responsive'],
    letterSpacing: ['responsive'],
    lineHeight: ['responsive'],
    listStylePosition: ['responsive'],
    listStyleType: ['responsive'],
    margin: ['responsive'],
    maxHeight: ['responsive'],
    maxWidth: ['responsive'],
    minHeight: ['responsive'],
    minWidth: ['responsive'],
    objectFit: ['responsive'],
    objectPosition: ['responsive'],
    opacity: ['responsive', 'hover', 'focus'],
    order: ['responsive'],
    outline: ['responsive', 'focus'],
    overflow: ['responsive'],
    overscrollBehavior: ['responsive'],
    padding: ['responsive'],
    placeContent: ['responsive'],
    placeItems: ['responsive'],
    placeSelf: ['responsive'],
    placeholderColor: ['responsive', 'focus'],
    placeholderOpacity: ['responsive', 'focus'],
    pointerEvents: ['responsive'],
    position: ['responsive'],
    resize: ['responsive'],
    space: ['responsive'],
    stroke: ['responsive'],
    strokeWidth: ['responsive'],
    tableLayout: ['responsive'],
    textAlign: ['responsive'],
    textColor: ['responsive', 'hover', 'focus'],
    textOpacity: ['responsive', 'hover', 'focus'],
    textDecoration: ['responsive', 'hover', 'focus'],
    textTransform: ['responsive'],
    userSelect: ['responsive'],
    verticalAlign: ['responsive'],
    visibility: ['responsive'],
    whitespace: ['responsive'],
    width: ['responsive'],
    wordBreak: ['responsive'],
    zIndex: ['responsive'],
    gap: ['responsive'],
    gridAutoFlow: ['responsive'],
    gridTemplateColumns: ['responsive'],
    gridAutoColumns: ['responsive'],
    gridColumn: ['responsive'],
    gridColumnStart: ['responsive'],
    gridColumnEnd: ['responsive'],
    gridTemplateRows: ['responsive'],
    gridAutoRows: ['responsive'],
    gridRow: ['responsive'],
    gridRowStart: ['responsive'],
    gridRowEnd: ['responsive'],
    transform: ['responsive'],
    transformOrigin: ['responsive'],
    scale: ['responsive', 'hover', 'focus'],
    rotate: ['responsive', 'hover', 'focus'],
    translate: ['responsive', 'hover', 'focus'],
    skew: ['responsive', 'hover', 'focus'],
    transitionProperty: ['responsive'],
    transitionTimingFunction: ['responsive'],
    transitionDuration: ['responsive'],
    transitionDelay: ['responsive'],
    animation: ['responsive'],
  },
  corePlugins: {},
  plugins: [],
}


/***/ }),

/***/ "09b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatSpecifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormatSpecifier; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),

/***/ "0a20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numbers; });
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});

function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}


/***/ }),

/***/ "0a4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ center; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ collide; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ src_link; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ manyBody; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ radial; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ src_simulation; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ src_x; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ src_y; });

// CONCATENATED MODULE: ./node_modules/d3-force/src/center.js
/* harmony default export */ var center = (function(x, y) {
  var nodes, strength = 1;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  return force;
});

// EXTERNAL MODULE: ./node_modules/d3-quadtree/src/quadtree.js + 13 modules
var quadtree = __webpack_require__("cfa1");

// CONCATENATED MODULE: ./node_modules/d3-force/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/jiggle.js
/* harmony default export */ var jiggle = (function(random) {
  return (random() - 0.5) * 1e-6;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/collide.js




function collide_x(d) {
  return d.x + d.vx;
}

function collide_y(d) {
  return d.y + d.vy;
}

/* harmony default export */ var collide = (function(radius) {
  var nodes,
      radii,
      random,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(quadtree["a" /* default */])(nodes, collide_x, collide_y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(random), l += x * x;
            if (y === 0) y = jiggle(random), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
  };

  return force;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/link.js



function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("node not found: " + nodeId);
  return node;
}

/* harmony default export */ var src_link = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant(30),
      distances,
      nodes,
      count,
      bias,
      random,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle(random);
        y = target.y + target.vy - source.y - source.vy || jiggle(random);
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = new Map(nodes.map((d, i) => [id(d, i, nodes), d])),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
  };

  return force;
});

// EXTERNAL MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var dispatch = __webpack_require__("c68f");

// EXTERNAL MODULE: ./node_modules/d3-timer/src/timer.js
var timer = __webpack_require__("74f4");

// CONCATENATED MODULE: ./node_modules/d3-force/src/lcg.js
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

/* harmony default export */ var lcg = (function() {
  let s = 1;
  return () => (s = (a * s + c) % m) / m;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/simulation.js




function simulation_x(d) {
  return d.x;
}

function simulation_y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ var src_simulation = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = new Map(),
      stepper = Object(timer["c" /* timer */])(step),
      event = Object(dispatch["a" /* default */])("tick", "end"),
      random = lcg();

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick(iterations) {
    var i, n = nodes.length, node;

    if (iterations === undefined) iterations = 1;

    for (var k = 0; k < iterations; ++k) {
      alpha += (alphaTarget - alpha) * alphaDecay;

      forces.forEach(function(force) {
        force(alpha);
      });

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.fx == null) node.x += node.vx *= velocityDecay;
        else node.x = node.fx, node.vx = 0;
        if (node.fy == null) node.y += node.vy *= velocityDecay;
        else node.y = node.fy, node.vy = 0;
      }
    }

    return simulation;
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (node.fx != null) node.x = node.fx;
      if (node.fy != null) node.y = node.fy;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes, random);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    randomSource: function(_) {
      return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.delete(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/manyBody.js





/* harmony default export */ var manyBody = (function() {
  var nodes,
      node,
      random,
      alpha,
      strength = constant(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(quadtree["a" /* default */])(nodes, simulation_x, simulation_y).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = jiggle(random), l += x * x;
        if (y === 0) y = jiggle(random), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = jiggle(random), l += x * x;
      if (y === 0) y = jiggle(random), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/radial.js


/* harmony default export */ var radial = (function(radius, x, y) {
  var nodes,
      strength = constant(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = constant(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/x.js


/* harmony default export */ var src_x = (function(x) {
  var strength = constant(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
  };

  return force;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/y.js


/* harmony default export */ var src_y = (function(y) {
  var strength = constant(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
  };

  return force;
});

// CONCATENATED MODULE: ./node_modules/d3-force/src/index.js










/***/ }),

/***/ "0a78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childMatcher; });
/* harmony default export */ __webpack_exports__["b"] = (function(selector) {
  return function() {
    return this.matches(selector);
  };
});

function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}



/***/ }),

/***/ "0b07":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("34ac"),
    getValue = __webpack_require__("3698");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d03":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}


/***/ }),

/***/ "0d24":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("2b3e"),
    stubFalse = __webpack_require__("07c7");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "0efc":
/***/ (function(module, exports) {

var openParentheses = "(".charCodeAt(0);
var closeParentheses = ")".charCodeAt(0);
var singleQuote = "'".charCodeAt(0);
var doubleQuote = '"'.charCodeAt(0);
var backslash = "\\".charCodeAt(0);
var slash = "/".charCodeAt(0);
var comma = ",".charCodeAt(0);
var colon = ":".charCodeAt(0);
var star = "*".charCodeAt(0);

module.exports = function(input) {
  var tokens = [];
  var value = input;

  var next, quote, prev, token, escape, escapePos, whitespacePos;
  var pos = 0;
  var code = value.charCodeAt(pos);
  var max = value.length;
  var stack = [{ nodes: tokens }];
  var balanced = 0;
  var parent;

  var name = "";
  var before = "";
  var after = "";

  while (pos < max) {
    // Whitespaces
    if (code <= 32) {
      next = pos;
      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);
      token = value.slice(pos, next);

      prev = tokens[tokens.length - 1];
      if (code === closeParentheses && balanced) {
        after = token;
      } else if (prev && prev.type === "div") {
        prev.after = token;
      } else if (
        code === comma ||
        code === colon ||
        (code === slash && value.charCodeAt(next + 1) !== star)
      ) {
        before = token;
      } else {
        tokens.push({
          type: "space",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next;

      // Quotes
    } else if (code === singleQuote || code === doubleQuote) {
      next = pos;
      quote = code === singleQuote ? "'" : '"';
      token = {
        type: "string",
        sourceIndex: pos,
        quote: quote
      };
      do {
        escape = false;
        next = value.indexOf(quote, next + 1);
        if (~next) {
          escapePos = next;
          while (value.charCodeAt(escapePos - 1) === backslash) {
            escapePos -= 1;
            escape = !escape;
          }
        } else {
          value += quote;
          next = value.length - 1;
          token.unclosed = true;
        }
      } while (escape);
      token.value = value.slice(pos + 1, next);

      tokens.push(token);
      pos = next + 1;
      code = value.charCodeAt(pos);

      // Comments
    } else if (code === slash && value.charCodeAt(pos + 1) === star) {
      token = {
        type: "comment",
        sourceIndex: pos
      };

      next = value.indexOf("*/", pos);
      if (next === -1) {
        token.unclosed = true;
        next = value.length;
      }

      token.value = value.slice(pos + 2, next);
      tokens.push(token);

      pos = next + 2;
      code = value.charCodeAt(pos);

      // Dividers
    } else if (code === slash || code === comma || code === colon) {
      token = value[pos];

      tokens.push({
        type: "div",
        sourceIndex: pos - before.length,
        value: token,
        before: before,
        after: ""
      });
      before = "";

      pos += 1;
      code = value.charCodeAt(pos);

      // Open parentheses
    } else if (openParentheses === code) {
      // Whitespaces after open parentheses
      next = pos;
      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);
      token = {
        type: "function",
        sourceIndex: pos - name.length,
        value: name,
        before: value.slice(pos + 1, next)
      };
      pos = next;

      if (name === "url" && code !== singleQuote && code !== doubleQuote) {
        next -= 1;
        do {
          escape = false;
          next = value.indexOf(")", next + 1);
          if (~next) {
            escapePos = next;
            while (value.charCodeAt(escapePos - 1) === backslash) {
              escapePos -= 1;
              escape = !escape;
            }
          } else {
            value += ")";
            next = value.length - 1;
            token.unclosed = true;
          }
        } while (escape);
        // Whitespaces before closed
        whitespacePos = next;
        do {
          whitespacePos -= 1;
          code = value.charCodeAt(whitespacePos);
        } while (code <= 32);
        if (pos !== whitespacePos + 1) {
          token.nodes = [
            {
              type: "word",
              sourceIndex: pos,
              value: value.slice(pos, whitespacePos + 1)
            }
          ];
        } else {
          token.nodes = [];
        }
        if (token.unclosed && whitespacePos + 1 !== next) {
          token.after = "";
          token.nodes.push({
            type: "space",
            sourceIndex: whitespacePos + 1,
            value: value.slice(whitespacePos + 1, next)
          });
        } else {
          token.after = value.slice(whitespacePos + 1, next);
        }
        pos = next + 1;
        code = value.charCodeAt(pos);
        tokens.push(token);
      } else {
        balanced += 1;
        token.after = "";
        tokens.push(token);
        stack.push(token);
        tokens = token.nodes = [];
        parent = token;
      }
      name = "";

      // Close parentheses
    } else if (closeParentheses === code && balanced) {
      pos += 1;
      code = value.charCodeAt(pos);

      parent.after = after;
      after = "";
      balanced -= 1;
      stack.pop();
      parent = stack[balanced];
      tokens = parent.nodes;

      // Words
    } else {
      next = pos;
      do {
        if (code === backslash) {
          next += 1;
        }
        next += 1;
        code = value.charCodeAt(next);
      } while (
        next < max &&
        !(
          code <= 32 ||
          code === singleQuote ||
          code === doubleQuote ||
          code === comma ||
          code === colon ||
          code === slash ||
          code === openParentheses ||
          (code === closeParentheses && balanced)
        )
      );
      token = value.slice(pos, next);

      if (openParentheses === code) {
        name = token;
      } else {
        tokens.push({
          type: "word",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next;
    }
  }

  for (pos = stack.length - 1; pos; pos -= 1) {
    stack[pos].unclosed = true;
  }

  return stack[0].nodes;
};


/***/ }),

/***/ "0f0f":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keysIn = __webpack_require__("9934");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "100e":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("cd9d"),
    overRest = __webpack_require__("2286"),
    setToString = __webpack_require__("c1c9");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "1041":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    getSymbolsIn = __webpack_require__("a029");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "1060":
/***/ (function(module, exports) {

function stringifyNode(node, custom) {
  var type = node.type;
  var value = node.value;
  var buf;
  var customResult;

  if (custom && (customResult = custom(node)) !== undefined) {
    return customResult;
  } else if (type === "word" || type === "space") {
    return value;
  } else if (type === "string") {
    buf = node.quote || "";
    return buf + value + (node.unclosed ? "" : buf);
  } else if (type === "comment") {
    return "/*" + value + (node.unclosed ? "" : "*/");
  } else if (type === "div") {
    return (node.before || "") + value + (node.after || "");
  } else if (Array.isArray(node.nodes)) {
    buf = stringify(node.nodes);
    if (type !== "function") {
      return buf;
    }
    return (
      value +
      "(" +
      (node.before || "") +
      buf +
      (node.after || "") +
      (node.unclosed ? "" : ")")
    );
  }
  return value;
}

function stringify(nodes, custom) {
  var result, i;

  if (Array.isArray(nodes)) {
    result = "";
    for (i = nodes.length - 1; ~i; i -= 1) {
      result = stringifyNode(nodes[i], custom) + result;
    }
    return result;
  }
  return stringifyNode(nodes, custom);
}

module.exports = stringify;


/***/ }),

/***/ "1231":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLocale; });
/* harmony import */ var _locale_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b170");


var locale;
var format;
var formatPrefix;

defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(_locale_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "1290":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "1310":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "135f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1368":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("da03");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "1416":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const stringReplaceAll = (string, substring, replacer) => {
	let index = string.indexOf(substring);
	if (index === -1) {
		return string;
	}

	const substringLength = substring.length;
	let endIndex = 0;
	let returnValue = '';
	do {
		returnValue += string.substr(endIndex, index - endIndex) + substring + replacer;
		endIndex = index + substringLength;
		index = string.indexOf(substring, endIndex);
	} while (index !== -1);

	returnValue += string.substr(endIndex);
	return returnValue;
};

const stringEncaseCRLFWithFirstIndex = (string, prefix, postfix, index) => {
	let endIndex = 0;
	let returnValue = '';
	do {
		const gotCR = string[index - 1] === '\r';
		returnValue += string.substr(endIndex, (gotCR ? index - 1 : index) - endIndex) + prefix + (gotCR ? '\r\n' : '\n') + postfix;
		endIndex = index + 1;
		index = string.indexOf('\n', endIndex);
	} while (index !== -1);

	returnValue += string.substr(endIndex);
	return returnValue;
};

module.exports = {
	stringReplaceAll,
	stringEncaseCRLFWithFirstIndex
};


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1539":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return merge; });
function* flatten(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}

function merge(arrays) {
  return Array.from(flatten(arrays));
}


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "15a7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelix; });
/* unused harmony export Cubehelix */
/* harmony import */ var _define_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("63ad");
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("166a");
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("530a");




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof _color_js__WEBPACK_IMPORTED_MODULE_1__[/* Rgb */ "b"])) o = Object(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* rgbConvert */ "h"])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * _math_js__WEBPACK_IMPORTED_MODULE_2__[/* degrees */ "a"] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Cubehelix, cubehelix, Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "b"])(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* Color */ "a"], {
  brighter: function(k) {
    k = k == null ? _color_js__WEBPACK_IMPORTED_MODULE_1__[/* brighter */ "c"] : Math.pow(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* brighter */ "c"], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? _color_js__WEBPACK_IMPORTED_MODULE_1__[/* darker */ "d"] : Math.pow(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* darker */ "d"], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * _math_js__WEBPACK_IMPORTED_MODULE_2__[/* radians */ "b"],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new _color_js__WEBPACK_IMPORTED_MODULE_1__[/* Rgb */ "b"](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),

/***/ "1602":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ "166a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rgbConvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Rgb; });
/* unused harmony export hslConvert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hsl; });
/* harmony import */ var _define_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("63ad");


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Rgb, rgb, Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "b"])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Hsl, hsl, Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "b"])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),

/***/ "1738":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1809":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return milliseconds; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");


var millisecond = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),

/***/ "1838":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("c05f"),
    get = __webpack_require__("9b02"),
    hasIn = __webpack_require__("8604"),
    isKey = __webpack_require__("f608"),
    isStrictComparable = __webpack_require__("08cc"),
    matchesStrictComparable = __webpack_require__("20ec"),
    toKey = __webpack_require__("f4d6");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "1875":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return quantile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return quantileSorted; });
/* harmony import */ var _max_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("823f");
/* harmony import */ var _min_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9ab5");
/* harmony import */ var _quickselect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5878");
/* harmony import */ var _number_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("0a20");





function quantile(values, p, valueof) {
  values = Float64Array.from(Object(_number_js__WEBPACK_IMPORTED_MODULE_3__[/* numbers */ "b"])(values, valueof));
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return Object(_min_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(values);
  if (p >= 1) return Object(_max_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = Object(_max_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_quickselect_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(values, i0).subarray(0, i0 + 1)),
      value1 = Object(_min_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}

function quantileSorted(values, p, valueof = _number_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]) {
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}


/***/ }),

/***/ "18a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.anchor` method
// https://tc39.github.io/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "18d8":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("234d");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "18e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newInterval; });
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("42a2"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "1a8c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "1b6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
});


/***/ }),

/***/ "1bac":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("7d1f"),
    getSymbolsIn = __webpack_require__("a029"),
    keysIn = __webpack_require__("9934");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c0d":
/***/ (function(module, exports, __webpack_require__) {

const resolveConfigObjects = __webpack_require__("db7a").default
const getAllConfigs = __webpack_require__("5d48").default

module.exports = function resolveConfig(...configs) {
  const [, ...defaultConfigs] = getAllConfigs(configs[0])
  return resolveConfigObjects([...configs, ...defaultConfigs])
}


/***/ }),

/***/ "1c3c":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    Uint8Array = __webpack_require__("2474"),
    eq = __webpack_require__("9638"),
    equalArrays = __webpack_require__("a2be"),
    mapToArray = __webpack_require__("edfa"),
    setToArray = __webpack_require__("ac41");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1cec":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "1d1c":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var defineProperties = __webpack_require__("37e8");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1efc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "1fc8":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "20ec":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "21de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardInfo_vue_vue_type_style_index_0_id_22113fa5_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("67cd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardInfo_vue_vue_type_style_index_0_id_22113fa5_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardInfo_vue_vue_type_style_index_0_id_22113fa5_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardInfo_vue_vue_type_style_index_0_id_22113fa5_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");
var getIteratorMethod = __webpack_require__("35a1");
var callWithSafeIterationClosing = __webpack_require__("9bdd");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),

/***/ "2286":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("85e3");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "234d":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("e380");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "2411":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("f909"),
    createAssigner = __webpack_require__("2ec1");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "242e":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("72af"),
    keys = __webpack_require__("ec69");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "244c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2474":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "2478":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "2524":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "253c":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "25eb":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var parseInt = __webpack_require__("c20d");

// `Number.parseInt` method
// https://tc39.github.io/ecma262/#sec-number.parseint
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "26e8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "26e9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isArray = __webpack_require__("e8b5");

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ "2702":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2739":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcMonday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return utcTuesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return utcWednesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return utcThursday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFriday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcSaturday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return utcSundays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcMondays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return utcTuesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return utcWednesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return utcThursdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFridays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return utcSaturdays; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



function utcWeekday(i) {
  return Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationWeek */ "e"];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),

/***/ "277d":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var isArray = __webpack_require__("e8b5");

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallChartCardView_vue_vue_type_style_index_0_id_73975600_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("135f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallChartCardView_vue_vue_type_style_index_0_id_73975600_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallChartCardView_vue_vue_type_style_index_0_id_73975600_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallChartCardView_vue_vue_type_style_index_0_id_73975600_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "28c9":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "29f3":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "2a2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ascending_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00fb");


/* harmony default export */ __webpack_exports__["a"] = (function(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
});

function ascendingComparator(f) {
  return (d, x) => Object(_ascending_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(f(d), x);
}


/***/ }),

/***/ "2adf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardDrawer_vue_vue_type_style_index_0_id_252962b8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("244c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardDrawer_vue_vue_type_style_index_0_id_252962b8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardDrawer_vue_vue_type_style_index_0_id_252962b8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SmallCardDrawer_vue_vue_type_style_index_0_id_252962b8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2af1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

// `Math.sign` method
// https://tc39.github.io/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ "2af9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (calc, node, precision) {
  var str = stringify(node, precision);

  if (node.type === "MathExpression") {
    // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
  }
  return str;
};

var _reducer = __webpack_require__("7aa5");

var order = {
  "*": 0,
  "/": 0,
  "+": 1,
  "-": 1
};

function round(value, prec) {
  if (prec !== false) {
    var precision = Math.pow(10, prec);
    return Math.round(value * precision) / precision;
  }
  return value;
}

function stringify(node, prec) {
  switch (node.type) {
    case "MathExpression":
      {
        var left = node.left,
            right = node.right,
            op = node.operator;

        var str = "";

        if (left.type === 'MathExpression' && order[op] < order[left.operator]) str += "(" + stringify(left, prec) + ")";else str += stringify(left, prec);

        str += " " + node.operator + " ";

        if (right.type === 'MathExpression' && order[op] < order[right.operator]) str += "(" + stringify(right, prec) + ")";else if (right.type === 'MathExpression' && op === "-" && ["+", "-"].includes(right.operator)) {
          // fix #52 : a-(b+c) = a-b-c
          right.operator = (0, _reducer.flip)(right.operator);
          str += stringify(right, prec);
        } else str += stringify(right, prec);

        return str;
      }
    case "Value":
      return round(node.value, prec);
    case 'CssVariable':
      return node.value;
    default:
      return round(node.value, prec) + node.unit;
  }
}

module.exports = exports["default"];

/***/ }),

/***/ "2b0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) { var repeat, classify, classifyRE, hasConsole; }

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {}
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {}
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {}
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
     false && false;
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {}
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
     false && false;
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
       false && false;

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
     false && false;
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {}
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {}
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {}
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {}
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {}

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {}
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {}
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {}
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {}
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) { var getHandler, hasHandler, isBuiltInModifier, hasProxy, warnReservedPrefix, warnNonPresent, allowedGlobals; }

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

var mark;
var measure;

if (false) { var perf; }

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
       false && false;
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) { var keyInLowerCase; }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {} else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {}
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {}
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
       false && false;
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
       false && false;
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {}
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {}
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {}
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
     false && false;
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {}
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {}
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {} else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {} else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {}
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
       false && false;
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? (undefined)
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) { var lowerCaseEvent; }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {}
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {} else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {}

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {}
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {}
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {}
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {}
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? undefined
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
       false && false;
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) { var hyphenatedKey; } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
     false && false;
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {}
    if (props && hasOwn(props, key)) {
       false && false;
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {}

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {}
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {}
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {}
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {}
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {}

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {} else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {}

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {}
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {}

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {}
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {}
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
       false && false;
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {}

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {}
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {}
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {}

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {}
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {}
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {}
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {}
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {}
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */

/*  */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {}

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {}

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
     false && false;
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {}

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {}

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) { var name, opts; }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {}
    }
    if (false
    ) {}
  }, 0);
}

/*  */

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "2b3e":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("585a");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "2c38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return minutes; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var minute = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationSecond */ "d"]);
}, function(date, step) {
  date.setTime(+date + step * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"]);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");
var bind = __webpack_require__("0366");
var html = __webpack_require__("1be4");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    !fails(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "2d7c":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "2dcb":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("91e9");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "2df2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _postcssValueParser = __webpack_require__("91e0");

var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

var _parser = __webpack_require__("50e2");

var _reducer = __webpack_require__("7aa5");

var _reducer2 = _interopRequireDefault(_reducer);

var _stringifier = __webpack_require__("2af9");

var _stringifier2 = _interopRequireDefault(_stringifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
var MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;

exports.default = function (value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  return (0, _postcssValueParser2.default)(value).walk(function (node) {
    // skip anything which isn't a calc() function
    if (node.type !== 'function' || !MATCH_CALC.test(node.value)) return;

    // stringify calc expression and produce an AST
    var contents = _postcssValueParser2.default.stringify(node.nodes);

    // skip constant() and env()
    if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;

    var ast = _parser.parser.parse(contents);

    // reduce AST to its simplest form, that is, either to a single value
    // or a simplified calc expression
    var reducedAst = (0, _reducer2.default)(ast, precision);

    // stringify AST and write it back
    node.type = 'word';
    node.value = (0, _stringifier2.default)(node.value, reducedAst, precision);
  }, true).toString();
};

module.exports = exports['default'];

/***/ }),

/***/ "2eb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cssUnitConverter = __webpack_require__("72c4");

var _cssUnitConverter2 = _interopRequireDefault(_cssUnitConverter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertNodes(left, right, precision) {
  switch (left.type) {
    case 'LengthValue':
    case 'AngleValue':
    case 'TimeValue':
    case 'FrequencyValue':
    case 'ResolutionValue':
      return convertAbsoluteLength(left, right, precision);
    default:
      return { left: left, right: right };
  }
}

function convertAbsoluteLength(left, right, precision) {
  if (right.type === left.type) {
    right = {
      type: left.type,
      value: (0, _cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
      unit: left.unit
    };
  }
  return { left: left, right: right };
}

exports.default = convertNodes;
module.exports = exports['default'];

/***/ }),

/***/ "2ec1":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("100e"),
    isIterateeCall = __webpack_require__("9aff");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "2ef0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("62e4")(module)))

/***/ }),

/***/ "2fa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardTooltip_vue_vue_type_style_index_0_id_4994a5de_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("55ad");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardTooltip_vue_vue_type_style_index_0_id_4994a5de_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardTooltip_vue_vue_type_style_index_0_id_4994a5de_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardTooltip_vue_vue_type_style_index_0_id_4994a5de_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2fcc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "3092":
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__("4284"),
    baseIteratee = __webpack_require__("badf"),
    baseSome = __webpack_require__("361d"),
    isArray = __webpack_require__("6747"),
    isIterateeCall = __webpack_require__("9aff");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "3099":
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
/* eslint-disable no-mixed-operators */
const cssKeywords = __webpack_require__("1602");

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
	reverseKeywords[cssKeywords[key]] = key;
}

const convert = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

module.exports = convert;

// Hide .channels and .labels properties
for (const model of Object.keys(convert)) {
	if (!('channels' in convert[model])) {
		throw new Error('missing channels property: ' + model);
	}

	if (!('labels' in convert[model])) {
		throw new Error('missing channel labels property: ' + model);
	}

	if (convert[model].labels.length !== convert[model].channels) {
		throw new Error('channel and label counts mismatch: ' + model);
	}

	const {channels, labels} = convert[model];
	delete convert[model].channels;
	delete convert[model].labels;
	Object.defineProperty(convert[model], 'channels', {value: channels});
	Object.defineProperty(convert[model], 'labels', {value: labels});
}

convert.rgb.hsl = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const min = Math.min(r, g, b);
	const max = Math.max(r, g, b);
	const delta = max - min;
	let h;
	let s;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	const l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	let rdif;
	let gdif;
	let bdif;
	let h;
	let s;

	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const v = Math.max(r, g, b);
	const diff = v - Math.min(r, g, b);
	const diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = 0;
		s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}

		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	const r = rgb[0];
	const g = rgb[1];
	let b = rgb[2];
	const h = convert.rgb.hsl(rgb)[0];
	const w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;

	const k = Math.min(1 - r, 1 - g, 1 - b);
	const c = (1 - r - k) / (1 - k) || 0;
	const m = (1 - g - k) / (1 - k) || 0;
	const y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

function comparativeDistance(x, y) {
	/*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/
	return (
		((x[0] - y[0]) ** 2) +
		((x[1] - y[1]) ** 2) +
		((x[2] - y[2]) ** 2)
	);
}

convert.rgb.keyword = function (rgb) {
	const reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	let currentClosestDistance = Infinity;
	let currentClosestKeyword;

	for (const keyword of Object.keys(cssKeywords)) {
		const value = cssKeywords[keyword];

		// Compute comparative distance
		const distance = comparativeDistance(rgb, value);

		// Check if its less, if so set as closest
		if (distance < currentClosestDistance) {
			currentClosestDistance = distance;
			currentClosestKeyword = keyword;
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	let r = rgb[0] / 255;
	let g = rgb[1] / 255;
	let b = rgb[2] / 255;

	// Assume sRGB
	r = r > 0.04045 ? (((r + 0.055) / 1.055) ** 2.4) : (r / 12.92);
	g = g > 0.04045 ? (((g + 0.055) / 1.055) ** 2.4) : (g / 12.92);
	b = b > 0.04045 ? (((b + 0.055) / 1.055) ** 2.4) : (b / 12.92);

	const x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	const y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	const z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	const xyz = convert.rgb.xyz(rgb);
	let x = xyz[0];
	let y = xyz[1];
	let z = xyz[2];

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

	const l = (116 * y) - 16;
	const a = 500 * (x - y);
	const b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	const h = hsl[0] / 360;
	const s = hsl[1] / 100;
	const l = hsl[2] / 100;
	let t2;
	let t3;
	let val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	const t1 = 2 * l - t2;

	const rgb = [0, 0, 0];
	for (let i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}

		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	const h = hsl[0];
	let s = hsl[1] / 100;
	let l = hsl[2] / 100;
	let smin = s;
	const lmin = Math.max(l, 0.01);

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	const v = (l + s) / 2;
	const sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	const h = hsv[0] / 60;
	const s = hsv[1] / 100;
	let v = hsv[2] / 100;
	const hi = Math.floor(h) % 6;

	const f = h - Math.floor(h);
	const p = 255 * v * (1 - s);
	const q = 255 * v * (1 - (s * f));
	const t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	const h = hsv[0];
	const s = hsv[1] / 100;
	const v = hsv[2] / 100;
	const vmin = Math.max(v, 0.01);
	let sl;
	let l;

	l = (2 - s) * v;
	const lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	const h = hwb[0] / 360;
	let wh = hwb[1] / 100;
	let bl = hwb[2] / 100;
	const ratio = wh + bl;
	let f;

	// Wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	const i = Math.floor(6 * h);
	const v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	const n = wh + f * (v - wh); // Linear interpolation

	let r;
	let g;
	let b;
	/* eslint-disable max-statements-per-line,no-multi-spaces */
	switch (i) {
		default:
		case 6:
		case 0: r = v;  g = n;  b = wh; break;
		case 1: r = n;  g = v;  b = wh; break;
		case 2: r = wh; g = v;  b = n; break;
		case 3: r = wh; g = n;  b = v; break;
		case 4: r = n;  g = wh; b = v; break;
		case 5: r = v;  g = wh; b = n; break;
	}
	/* eslint-enable max-statements-per-line,no-multi-spaces */

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	const c = cmyk[0] / 100;
	const m = cmyk[1] / 100;
	const y = cmyk[2] / 100;
	const k = cmyk[3] / 100;

	const r = 1 - Math.min(1, c * (1 - k) + k);
	const g = 1 - Math.min(1, m * (1 - k) + k);
	const b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	const x = xyz[0] / 100;
	const y = xyz[1] / 100;
	const z = xyz[2] / 100;
	let r;
	let g;
	let b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// Assume sRGB
	r = r > 0.0031308
		? ((1.055 * (r ** (1.0 / 2.4))) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * (g ** (1.0 / 2.4))) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * (b ** (1.0 / 2.4))) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	let x = xyz[0];
	let y = xyz[1];
	let z = xyz[2];

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

	const l = (116 * y) - 16;
	const a = 500 * (x - y);
	const b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	const l = lab[0];
	const a = lab[1];
	const b = lab[2];
	let x;
	let y;
	let z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	const y2 = y ** 3;
	const x2 = x ** 3;
	const z2 = z ** 3;
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	const l = lab[0];
	const a = lab[1];
	const b = lab[2];
	let h;

	const hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	const c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	const l = lch[0];
	const c = lch[1];
	const h = lch[2];

	const hr = h / 360 * 2 * Math.PI;
	const a = c * Math.cos(hr);
	const b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args, saturation = null) {
	const [r, g, b] = args;
	let value = saturation === null ? convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	let ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// Optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	const r = args[0];
	const g = args[1];
	const b = args[2];

	// We use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	const ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	let color = args % 10;

	// Handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	const mult = (~~(args > 50) + 1) * 0.5;
	const r = ((color & 1) * mult) * 255;
	const g = (((color >> 1) & 1) * mult) * 255;
	const b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// Handle greyscale
	if (args >= 232) {
		const c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	let rem;
	const r = Math.floor(args / 36) / 5 * 255;
	const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	const b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	const integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	const string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	let colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(char => {
			return char + char;
		}).join('');
	}

	const integer = parseInt(colorString, 16);
	const r = (integer >> 16) & 0xFF;
	const g = (integer >> 8) & 0xFF;
	const b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const max = Math.max(Math.max(r, g), b);
	const min = Math.min(Math.min(r, g), b);
	const chroma = (max - min);
	let grayscale;
	let hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	const s = hsl[1] / 100;
	const l = hsl[2] / 100;

	const c = l < 0.5 ? (2.0 * s * l) : (2.0 * s * (1.0 - l));

	let f = 0;
	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	const s = hsv[1] / 100;
	const v = hsv[2] / 100;

	const c = s * v;
	let f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	const h = hcg[0] / 360;
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	const pure = [0, 0, 0];
	const hi = (h % 1) * 6;
	const v = hi % 1;
	const w = 1 - v;
	let mg = 0;

	/* eslint-disable max-statements-per-line */
	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}
	/* eslint-enable max-statements-per-line */

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	const v = c + g * (1.0 - c);
	let f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	const l = g * (1.0 - c) + 0.5 * c;
	let s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;
	const v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	const w = hwb[1] / 100;
	const b = hwb[2] / 100;
	const v = 1 - b;
	const c = v - w;
	let g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hsv = convert.gray.hsl;

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	const val = Math.round(gray[0] / 100 * 255) & 0xFF;
	const integer = (val << 16) + (val << 8) + val;

	const string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),

/***/ "30c9":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("9520"),
    isLength = __webpack_require__("b218");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "32b3":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("872a"),
    eq = __webpack_require__("9638");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "32f4":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("2d7c"),
    stubArray = __webpack_require__("d327");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "34ac":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("9520"),
    isMasked = __webpack_require__("1368"),
    isObject = __webpack_require__("1a8c"),
    toSource = __webpack_require__("dc57");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "3512":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "] || \"\"";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

function pad(value, width) {
  var s = value + "", length = s.length;
  return length < width ? new Array(width - length + 1).join(0) + s : s;
}

function formatYear(year) {
  return year < 0 ? "-" + pad(-year, 6)
    : year > 9999 ? "+" + pad(year, 6)
    : pad(year, 4);
}

function formatDate(date) {
  var hours = date.getUTCHours(),
      minutes = date.getUTCMinutes(),
      seconds = date.getUTCSeconds(),
      milliseconds = date.getUTCMilliseconds();
  return isNaN(date) ? "Invalid Date"
      : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2)
      + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z"
      : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z"
      : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z"
      : "");
}

/* harmony default export */ __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }

  function formatBody(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(value) {
    return value == null ? ""
        : value instanceof Date ? formatDate(value)
        : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\""
        : value;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatBody: formatBody,
    formatRows: formatRows,
    formatRow: formatRow,
    formatValue: formatValue
  };
});


/***/ }),

/***/ "355f":
/***/ (function(module, exports, __webpack_require__) {

const conversions = __webpack_require__("3099");
const route = __webpack_require__("764e");

const convert = {};

const models = Object.keys(conversions);

function wrapRaw(fn) {
	const wrappedFn = function (...args) {
		const arg0 = args[0];
		if (arg0 === undefined || arg0 === null) {
			return arg0;
		}

		if (arg0.length > 1) {
			args = arg0;
		}

		return fn(args);
	};

	// Preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	const wrappedFn = function (...args) {
		const arg0 = args[0];

		if (arg0 === undefined || arg0 === null) {
			return arg0;
		}

		if (arg0.length > 1) {
			args = arg0;
		}

		const result = fn(args);

		// We're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (let len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// Preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(fromModel => {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	const routes = route(fromModel);
	const routeModels = Object.keys(routes);

	routeModels.forEach(toModel => {
		const fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "361d":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("48a0");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "364b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return styleValue; });
/* harmony import */ var _window_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a317");


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(_window_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),

/***/ "365b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),

/***/ "365e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _count_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8627");


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(Object(_count_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(values)) / Math.LN2) + 1;
});


/***/ }),

/***/ "3671":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Delta_vue_vue_type_style_index_0_id_1d0602ca_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cc69");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Delta_vue_vue_type_style_index_0_id_1d0602ca_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Delta_vue_vue_type_style_index_0_id_1d0602ca_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Delta_vue_vue_type_style_index_0_id_1d0602ca_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3698":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "36d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3729":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    getRawTag = __webpack_require__("00fd"),
    objectToString = __webpack_require__("29f3");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3818":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    arrayEach = __webpack_require__("8057"),
    assignValue = __webpack_require__("32b3"),
    baseAssign = __webpack_require__("5b01"),
    baseAssignIn = __webpack_require__("0f0f"),
    cloneBuffer = __webpack_require__("e5383"),
    copyArray = __webpack_require__("4359"),
    copySymbols = __webpack_require__("54eb"),
    copySymbolsIn = __webpack_require__("1041"),
    getAllKeys = __webpack_require__("a994"),
    getAllKeysIn = __webpack_require__("1bac"),
    getTag = __webpack_require__("42a2"),
    initCloneArray = __webpack_require__("c87c"),
    initCloneByTag = __webpack_require__("c2b6"),
    initCloneObject = __webpack_require__("fa21"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isMap = __webpack_require__("cc45"),
    isObject = __webpack_require__("1a8c"),
    isSet = __webpack_require__("d7ee"),
    keys = __webpack_require__("ec69"),
    keysIn = __webpack_require__("9934");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "3872":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var d3_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("15a7");
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b055");



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(d3_color__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(start)).h, (end = Object(d3_color__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(end)).h),
          s = Object(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(start.s, end.s),
          l = Object(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(start.l, end.l),
          opacity = Object(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* hue */ "c"]));
var cubehelixLong = cubehelix(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);


/***/ }),

/***/ "39ff":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "3b4a":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "3bb4":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("08cc"),
    keys = __webpack_require__("ec69");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3d77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(pluginConfig, plugins) {
  if (pluginConfig === undefined) {
    return plugins;
  }

  const pluginNames = Array.isArray(pluginConfig) ? pluginConfig : plugins.filter(pluginName => {
    return pluginConfig !== false && pluginConfig[pluginName] !== false;
  });
  return pluginNames;
}

/***/ }),

/***/ "3d7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CategorySelector_vue_vue_type_style_index_0_id_0b1bb948_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e850");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CategorySelector_vue_vue_type_style_index_0_id_0b1bb948_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CategorySelector_vue_vue_type_style_index_0_id_0b1bb948_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CategorySelector_vue_vue_type_style_index_0_id_0b1bb948_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3e07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _timer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("74f4");


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new _timer_js__WEBPACK_IMPORTED_MODULE_0__[/* Timer */ "a"];
  delay = delay == null ? 0 : +delay;
  t.restart(elapsed => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "41c3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c"),
    isPrototype = __webpack_require__("eac5"),
    nativeKeysIn = __webpack_require__("ec8c");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "4230":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),

/***/ "4245":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("1290");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "4284":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "42a2":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("b5a7"),
    Map = __webpack_require__("79bc"),
    Promise = __webpack_require__("1cec"),
    Set = __webpack_require__("c869"),
    WeakMap = __webpack_require__("39ff"),
    baseGetTag = __webpack_require__("3729"),
    toSource = __webpack_require__("dc57");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "4359":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "445e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4480":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px'
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardHeader_vue_vue_type_style_index_0_id_bf5efe12_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7637");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardHeader_vue_vue_type_style_index_0_id_bf5efe12_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardHeader_vue_vue_type_style_index_0_id_bf5efe12_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardHeader_vue_vue_type_style_index_0_id_bf5efe12_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4611":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ axisTop; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ axisRight; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ axisBottom; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ axisLeft; });

// CONCATENATED MODULE: ./node_modules/d3-axis/src/array.js
var slice = Array.prototype.slice;

// CONCATENATED MODULE: ./node_modules/d3-axis/src/identity.js
/* harmony default export */ var identity = (function(x) {
  return x;
});

// CONCATENATED MODULE: ./node_modules/d3-axis/src/axis.js



var axis_top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return d => +scale(d);
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis_axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === axis_top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === axis_top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === axis_top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis_axis(axis_top, scale);
}

function axisRight(scale) {
  return axis_axis(right, scale);
}

function axisBottom(scale) {
  return axis_axis(bottom, scale);
}

function axisLeft(scale) {
  return axis_axis(left, scale);
}

// CONCATENATED MODULE: ./node_modules/d3-axis/src/index.js



/***/ }),

/***/ "462d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ dsv["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ csv["f" /* csvParse */]; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ csv["g" /* csvParseRows */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ csv["a" /* csvFormat */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ csv["b" /* csvFormatBody */]; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ csv["d" /* csvFormatRows */]; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ csv["c" /* csvFormatRow */]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ csv["e" /* csvFormatValue */]; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ tsv["f" /* tsvParse */]; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ tsv["g" /* tsvParseRows */]; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ tsv["a" /* tsvFormat */]; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ tsv["b" /* tsvFormatBody */]; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ tsv["d" /* tsvFormatRows */]; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ tsv["c" /* tsvFormatRow */]; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ tsv["e" /* tsvFormatValue */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ autoType; });

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/dsv.js
var dsv = __webpack_require__("3512");

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/csv.js
var csv = __webpack_require__("5626");

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/tsv.js
var tsv = __webpack_require__("c165");

// CONCATENATED MODULE: ./node_modules/d3-dsv/src/autoType.js
function autoType(object) {
  for (var key in object) {
    var value = object[key].trim(), number, m;
    if (!value) value = null;
    else if (value === "true") value = true;
    else if (value === "false") value = false;
    else if (value === "NaN") value = NaN;
    else if (!isNaN(number = +value)) value = number;
    else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
      value = new Date(value);
    }
    else continue;
    object[key] = value;
  }
  return object;
}

// https://github.com/d3/d3-dsv/issues/45
const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
// CONCATENATED MODULE: ./node_modules/d3-dsv/src/index.js






/***/ }),

/***/ "482f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("166a");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _color_js__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _color_js__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _color_js__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony import */ var _lab_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("62f0");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _lab_js__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _lab_js__WEBPACK_IMPORTED_MODULE_1__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _lab_js__WEBPACK_IMPORTED_MODULE_1__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _lab_js__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony import */ var _cubehelix_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("15a7");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _cubehelix_js__WEBPACK_IMPORTED_MODULE_2__["a"]; });






/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "48a0":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("242e"),
    createBaseEach = __webpack_require__("950a");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "49f4":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "4b4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "version", function() { return /* reexport */ version; });
__webpack_require__.d(__webpack_exports__, "bisect", function() { return /* reexport */ src["d" /* bisect */]; });
__webpack_require__.d(__webpack_exports__, "bisectRight", function() { return /* reexport */ src["g" /* bisectRight */]; });
__webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return /* reexport */ src["f" /* bisectLeft */]; });
__webpack_require__.d(__webpack_exports__, "bisectCenter", function() { return /* reexport */ src["e" /* bisectCenter */]; });
__webpack_require__.d(__webpack_exports__, "ascending", function() { return /* reexport */ src["b" /* ascending */]; });
__webpack_require__.d(__webpack_exports__, "bisector", function() { return /* reexport */ src["h" /* bisector */]; });
__webpack_require__.d(__webpack_exports__, "count", function() { return /* reexport */ src["i" /* count */]; });
__webpack_require__.d(__webpack_exports__, "cross", function() { return /* reexport */ src["j" /* cross */]; });
__webpack_require__.d(__webpack_exports__, "cumsum", function() { return /* reexport */ src["k" /* cumsum */]; });
__webpack_require__.d(__webpack_exports__, "descending", function() { return /* reexport */ src["l" /* descending */]; });
__webpack_require__.d(__webpack_exports__, "deviation", function() { return /* reexport */ src["m" /* deviation */]; });
__webpack_require__.d(__webpack_exports__, "extent", function() { return /* reexport */ src["n" /* extent */]; });
__webpack_require__.d(__webpack_exports__, "fsum", function() { return /* reexport */ src["o" /* fsum */]; });
__webpack_require__.d(__webpack_exports__, "Adder", function() { return /* reexport */ src["a" /* Adder */]; });
__webpack_require__.d(__webpack_exports__, "group", function() { return /* reexport */ src["r" /* group */]; });
__webpack_require__.d(__webpack_exports__, "groups", function() { return /* reexport */ src["s" /* groups */]; });
__webpack_require__.d(__webpack_exports__, "index", function() { return /* reexport */ src["u" /* index */]; });
__webpack_require__.d(__webpack_exports__, "indexes", function() { return /* reexport */ src["v" /* indexes */]; });
__webpack_require__.d(__webpack_exports__, "rollup", function() { return /* reexport */ src["L" /* rollup */]; });
__webpack_require__.d(__webpack_exports__, "rollups", function() { return /* reexport */ src["M" /* rollups */]; });
__webpack_require__.d(__webpack_exports__, "bin", function() { return /* reexport */ src["c" /* bin */]; });
__webpack_require__.d(__webpack_exports__, "histogram", function() { return /* reexport */ src["t" /* histogram */]; });
__webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return /* reexport */ src["R" /* thresholdFreedmanDiaconis */]; });
__webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return /* reexport */ src["S" /* thresholdScott */]; });
__webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return /* reexport */ src["T" /* thresholdSturges */]; });
__webpack_require__.d(__webpack_exports__, "max", function() { return /* reexport */ src["y" /* max */]; });
__webpack_require__.d(__webpack_exports__, "maxIndex", function() { return /* reexport */ src["z" /* maxIndex */]; });
__webpack_require__.d(__webpack_exports__, "mean", function() { return /* reexport */ src["A" /* mean */]; });
__webpack_require__.d(__webpack_exports__, "median", function() { return /* reexport */ src["B" /* median */]; });
__webpack_require__.d(__webpack_exports__, "merge", function() { return /* reexport */ src["C" /* merge */]; });
__webpack_require__.d(__webpack_exports__, "min", function() { return /* reexport */ src["D" /* min */]; });
__webpack_require__.d(__webpack_exports__, "minIndex", function() { return /* reexport */ src["E" /* minIndex */]; });
__webpack_require__.d(__webpack_exports__, "pairs", function() { return /* reexport */ src["F" /* pairs */]; });
__webpack_require__.d(__webpack_exports__, "permute", function() { return /* reexport */ src["G" /* permute */]; });
__webpack_require__.d(__webpack_exports__, "quantile", function() { return /* reexport */ src["H" /* quantile */]; });
__webpack_require__.d(__webpack_exports__, "quantileSorted", function() { return /* reexport */ src["I" /* quantileSorted */]; });
__webpack_require__.d(__webpack_exports__, "quickselect", function() { return /* reexport */ src["J" /* quickselect */]; });
__webpack_require__.d(__webpack_exports__, "range", function() { return /* reexport */ src["K" /* range */]; });
__webpack_require__.d(__webpack_exports__, "least", function() { return /* reexport */ src["w" /* least */]; });
__webpack_require__.d(__webpack_exports__, "leastIndex", function() { return /* reexport */ src["x" /* leastIndex */]; });
__webpack_require__.d(__webpack_exports__, "greatest", function() { return /* reexport */ src["p" /* greatest */]; });
__webpack_require__.d(__webpack_exports__, "greatestIndex", function() { return /* reexport */ src["q" /* greatestIndex */]; });
__webpack_require__.d(__webpack_exports__, "scan", function() { return /* reexport */ src["N" /* scan */]; });
__webpack_require__.d(__webpack_exports__, "shuffle", function() { return /* reexport */ src["O" /* shuffle */]; });
__webpack_require__.d(__webpack_exports__, "shuffler", function() { return /* reexport */ src["P" /* shuffler */]; });
__webpack_require__.d(__webpack_exports__, "sum", function() { return /* reexport */ src["Q" /* sum */]; });
__webpack_require__.d(__webpack_exports__, "ticks", function() { return /* reexport */ src["W" /* ticks */]; });
__webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return /* reexport */ src["U" /* tickIncrement */]; });
__webpack_require__.d(__webpack_exports__, "tickStep", function() { return /* reexport */ src["V" /* tickStep */]; });
__webpack_require__.d(__webpack_exports__, "transpose", function() { return /* reexport */ src["X" /* transpose */]; });
__webpack_require__.d(__webpack_exports__, "variance", function() { return /* reexport */ src["Y" /* variance */]; });
__webpack_require__.d(__webpack_exports__, "zip", function() { return /* reexport */ src["Z" /* zip */]; });
__webpack_require__.d(__webpack_exports__, "axisTop", function() { return /* reexport */ d3_axis_src["d" /* axisTop */]; });
__webpack_require__.d(__webpack_exports__, "axisRight", function() { return /* reexport */ d3_axis_src["c" /* axisRight */]; });
__webpack_require__.d(__webpack_exports__, "axisBottom", function() { return /* reexport */ d3_axis_src["a" /* axisBottom */]; });
__webpack_require__.d(__webpack_exports__, "axisLeft", function() { return /* reexport */ d3_axis_src["b" /* axisLeft */]; });
__webpack_require__.d(__webpack_exports__, "brush", function() { return /* reexport */ d3_brush_src["a" /* brush */]; });
__webpack_require__.d(__webpack_exports__, "brushX", function() { return /* reexport */ d3_brush_src["c" /* brushX */]; });
__webpack_require__.d(__webpack_exports__, "brushY", function() { return /* reexport */ d3_brush_src["d" /* brushY */]; });
__webpack_require__.d(__webpack_exports__, "brushSelection", function() { return /* reexport */ d3_brush_src["b" /* brushSelection */]; });
__webpack_require__.d(__webpack_exports__, "chord", function() { return /* reexport */ d3_chord_src["a" /* chord */]; });
__webpack_require__.d(__webpack_exports__, "chordTranspose", function() { return /* reexport */ d3_chord_src["c" /* chordTranspose */]; });
__webpack_require__.d(__webpack_exports__, "chordDirected", function() { return /* reexport */ d3_chord_src["b" /* chordDirected */]; });
__webpack_require__.d(__webpack_exports__, "ribbon", function() { return /* reexport */ d3_chord_src["d" /* ribbon */]; });
__webpack_require__.d(__webpack_exports__, "ribbonArrow", function() { return /* reexport */ d3_chord_src["e" /* ribbonArrow */]; });
__webpack_require__.d(__webpack_exports__, "color", function() { return /* reexport */ d3_color_src["a" /* color */]; });
__webpack_require__.d(__webpack_exports__, "rgb", function() { return /* reexport */ d3_color_src["h" /* rgb */]; });
__webpack_require__.d(__webpack_exports__, "hsl", function() { return /* reexport */ d3_color_src["e" /* hsl */]; });
__webpack_require__.d(__webpack_exports__, "lab", function() { return /* reexport */ d3_color_src["f" /* lab */]; });
__webpack_require__.d(__webpack_exports__, "hcl", function() { return /* reexport */ d3_color_src["d" /* hcl */]; });
__webpack_require__.d(__webpack_exports__, "lch", function() { return /* reexport */ d3_color_src["g" /* lch */]; });
__webpack_require__.d(__webpack_exports__, "gray", function() { return /* reexport */ d3_color_src["c" /* gray */]; });
__webpack_require__.d(__webpack_exports__, "cubehelix", function() { return /* reexport */ d3_color_src["b" /* cubehelix */]; });
__webpack_require__.d(__webpack_exports__, "contours", function() { return /* reexport */ d3_contour_src["b" /* contours */]; });
__webpack_require__.d(__webpack_exports__, "contourDensity", function() { return /* reexport */ d3_contour_src["a" /* contourDensity */]; });
__webpack_require__.d(__webpack_exports__, "Delaunay", function() { return /* reexport */ d3_delaunay_src["a" /* Delaunay */]; });
__webpack_require__.d(__webpack_exports__, "Voronoi", function() { return /* reexport */ d3_delaunay_src["b" /* Voronoi */]; });
__webpack_require__.d(__webpack_exports__, "dispatch", function() { return /* reexport */ d3_dispatch_src["a" /* dispatch */]; });
__webpack_require__.d(__webpack_exports__, "drag", function() { return /* reexport */ d3_drag_src["a" /* drag */]; });
__webpack_require__.d(__webpack_exports__, "dragDisable", function() { return /* reexport */ d3_drag_src["b" /* dragDisable */]; });
__webpack_require__.d(__webpack_exports__, "dragEnable", function() { return /* reexport */ d3_drag_src["c" /* dragEnable */]; });
__webpack_require__.d(__webpack_exports__, "dsvFormat", function() { return /* reexport */ d3_dsv_src["i" /* dsvFormat */]; });
__webpack_require__.d(__webpack_exports__, "csvParse", function() { return /* reexport */ d3_dsv_src["g" /* csvParse */]; });
__webpack_require__.d(__webpack_exports__, "csvParseRows", function() { return /* reexport */ d3_dsv_src["h" /* csvParseRows */]; });
__webpack_require__.d(__webpack_exports__, "csvFormat", function() { return /* reexport */ d3_dsv_src["b" /* csvFormat */]; });
__webpack_require__.d(__webpack_exports__, "csvFormatBody", function() { return /* reexport */ d3_dsv_src["c" /* csvFormatBody */]; });
__webpack_require__.d(__webpack_exports__, "csvFormatRows", function() { return /* reexport */ d3_dsv_src["e" /* csvFormatRows */]; });
__webpack_require__.d(__webpack_exports__, "csvFormatRow", function() { return /* reexport */ d3_dsv_src["d" /* csvFormatRow */]; });
__webpack_require__.d(__webpack_exports__, "csvFormatValue", function() { return /* reexport */ d3_dsv_src["f" /* csvFormatValue */]; });
__webpack_require__.d(__webpack_exports__, "tsvParse", function() { return /* reexport */ d3_dsv_src["o" /* tsvParse */]; });
__webpack_require__.d(__webpack_exports__, "tsvParseRows", function() { return /* reexport */ d3_dsv_src["p" /* tsvParseRows */]; });
__webpack_require__.d(__webpack_exports__, "tsvFormat", function() { return /* reexport */ d3_dsv_src["j" /* tsvFormat */]; });
__webpack_require__.d(__webpack_exports__, "tsvFormatBody", function() { return /* reexport */ d3_dsv_src["k" /* tsvFormatBody */]; });
__webpack_require__.d(__webpack_exports__, "tsvFormatRows", function() { return /* reexport */ d3_dsv_src["m" /* tsvFormatRows */]; });
__webpack_require__.d(__webpack_exports__, "tsvFormatRow", function() { return /* reexport */ d3_dsv_src["l" /* tsvFormatRow */]; });
__webpack_require__.d(__webpack_exports__, "tsvFormatValue", function() { return /* reexport */ d3_dsv_src["n" /* tsvFormatValue */]; });
__webpack_require__.d(__webpack_exports__, "autoType", function() { return /* reexport */ d3_dsv_src["a" /* autoType */]; });
__webpack_require__.d(__webpack_exports__, "easeLinear", function() { return /* reexport */ d3_ease_src["y" /* easeLinear */]; });
__webpack_require__.d(__webpack_exports__, "easeQuad", function() { return /* reexport */ d3_ease_src["D" /* easeQuad */]; });
__webpack_require__.d(__webpack_exports__, "easeQuadIn", function() { return /* reexport */ d3_ease_src["E" /* easeQuadIn */]; });
__webpack_require__.d(__webpack_exports__, "easeQuadOut", function() { return /* reexport */ d3_ease_src["G" /* easeQuadOut */]; });
__webpack_require__.d(__webpack_exports__, "easeQuadInOut", function() { return /* reexport */ d3_ease_src["F" /* easeQuadInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeCubic", function() { return /* reexport */ d3_ease_src["m" /* easeCubic */]; });
__webpack_require__.d(__webpack_exports__, "easeCubicIn", function() { return /* reexport */ d3_ease_src["n" /* easeCubicIn */]; });
__webpack_require__.d(__webpack_exports__, "easeCubicOut", function() { return /* reexport */ d3_ease_src["p" /* easeCubicOut */]; });
__webpack_require__.d(__webpack_exports__, "easeCubicInOut", function() { return /* reexport */ d3_ease_src["o" /* easeCubicInOut */]; });
__webpack_require__.d(__webpack_exports__, "easePoly", function() { return /* reexport */ d3_ease_src["z" /* easePoly */]; });
__webpack_require__.d(__webpack_exports__, "easePolyIn", function() { return /* reexport */ d3_ease_src["A" /* easePolyIn */]; });
__webpack_require__.d(__webpack_exports__, "easePolyOut", function() { return /* reexport */ d3_ease_src["C" /* easePolyOut */]; });
__webpack_require__.d(__webpack_exports__, "easePolyInOut", function() { return /* reexport */ d3_ease_src["B" /* easePolyInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeSin", function() { return /* reexport */ d3_ease_src["H" /* easeSin */]; });
__webpack_require__.d(__webpack_exports__, "easeSinIn", function() { return /* reexport */ d3_ease_src["I" /* easeSinIn */]; });
__webpack_require__.d(__webpack_exports__, "easeSinOut", function() { return /* reexport */ d3_ease_src["K" /* easeSinOut */]; });
__webpack_require__.d(__webpack_exports__, "easeSinInOut", function() { return /* reexport */ d3_ease_src["J" /* easeSinInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeExp", function() { return /* reexport */ d3_ease_src["u" /* easeExp */]; });
__webpack_require__.d(__webpack_exports__, "easeExpIn", function() { return /* reexport */ d3_ease_src["v" /* easeExpIn */]; });
__webpack_require__.d(__webpack_exports__, "easeExpOut", function() { return /* reexport */ d3_ease_src["x" /* easeExpOut */]; });
__webpack_require__.d(__webpack_exports__, "easeExpInOut", function() { return /* reexport */ d3_ease_src["w" /* easeExpInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeCircle", function() { return /* reexport */ d3_ease_src["i" /* easeCircle */]; });
__webpack_require__.d(__webpack_exports__, "easeCircleIn", function() { return /* reexport */ d3_ease_src["j" /* easeCircleIn */]; });
__webpack_require__.d(__webpack_exports__, "easeCircleOut", function() { return /* reexport */ d3_ease_src["l" /* easeCircleOut */]; });
__webpack_require__.d(__webpack_exports__, "easeCircleInOut", function() { return /* reexport */ d3_ease_src["k" /* easeCircleInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeBounce", function() { return /* reexport */ d3_ease_src["e" /* easeBounce */]; });
__webpack_require__.d(__webpack_exports__, "easeBounceIn", function() { return /* reexport */ d3_ease_src["f" /* easeBounceIn */]; });
__webpack_require__.d(__webpack_exports__, "easeBounceOut", function() { return /* reexport */ d3_ease_src["h" /* easeBounceOut */]; });
__webpack_require__.d(__webpack_exports__, "easeBounceInOut", function() { return /* reexport */ d3_ease_src["g" /* easeBounceInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeBack", function() { return /* reexport */ d3_ease_src["a" /* easeBack */]; });
__webpack_require__.d(__webpack_exports__, "easeBackIn", function() { return /* reexport */ d3_ease_src["b" /* easeBackIn */]; });
__webpack_require__.d(__webpack_exports__, "easeBackOut", function() { return /* reexport */ d3_ease_src["d" /* easeBackOut */]; });
__webpack_require__.d(__webpack_exports__, "easeBackInOut", function() { return /* reexport */ d3_ease_src["c" /* easeBackInOut */]; });
__webpack_require__.d(__webpack_exports__, "easeElastic", function() { return /* reexport */ d3_ease_src["q" /* easeElastic */]; });
__webpack_require__.d(__webpack_exports__, "easeElasticIn", function() { return /* reexport */ d3_ease_src["r" /* easeElasticIn */]; });
__webpack_require__.d(__webpack_exports__, "easeElasticOut", function() { return /* reexport */ d3_ease_src["t" /* easeElasticOut */]; });
__webpack_require__.d(__webpack_exports__, "easeElasticInOut", function() { return /* reexport */ d3_ease_src["s" /* easeElasticInOut */]; });
__webpack_require__.d(__webpack_exports__, "blob", function() { return /* reexport */ d3_fetch_src["a" /* blob */]; });
__webpack_require__.d(__webpack_exports__, "buffer", function() { return /* reexport */ d3_fetch_src["b" /* buffer */]; });
__webpack_require__.d(__webpack_exports__, "dsv", function() { return /* reexport */ d3_fetch_src["d" /* dsv */]; });
__webpack_require__.d(__webpack_exports__, "csv", function() { return /* reexport */ d3_fetch_src["c" /* csv */]; });
__webpack_require__.d(__webpack_exports__, "tsv", function() { return /* reexport */ d3_fetch_src["j" /* tsv */]; });
__webpack_require__.d(__webpack_exports__, "image", function() { return /* reexport */ d3_fetch_src["f" /* image */]; });
__webpack_require__.d(__webpack_exports__, "json", function() { return /* reexport */ d3_fetch_src["g" /* json */]; });
__webpack_require__.d(__webpack_exports__, "text", function() { return /* reexport */ d3_fetch_src["i" /* text */]; });
__webpack_require__.d(__webpack_exports__, "xml", function() { return /* reexport */ d3_fetch_src["k" /* xml */]; });
__webpack_require__.d(__webpack_exports__, "html", function() { return /* reexport */ d3_fetch_src["e" /* html */]; });
__webpack_require__.d(__webpack_exports__, "svg", function() { return /* reexport */ d3_fetch_src["h" /* svg */]; });
__webpack_require__.d(__webpack_exports__, "forceCenter", function() { return /* reexport */ d3_force_src["a" /* forceCenter */]; });
__webpack_require__.d(__webpack_exports__, "forceCollide", function() { return /* reexport */ d3_force_src["b" /* forceCollide */]; });
__webpack_require__.d(__webpack_exports__, "forceLink", function() { return /* reexport */ d3_force_src["c" /* forceLink */]; });
__webpack_require__.d(__webpack_exports__, "forceManyBody", function() { return /* reexport */ d3_force_src["d" /* forceManyBody */]; });
__webpack_require__.d(__webpack_exports__, "forceRadial", function() { return /* reexport */ d3_force_src["e" /* forceRadial */]; });
__webpack_require__.d(__webpack_exports__, "forceSimulation", function() { return /* reexport */ d3_force_src["f" /* forceSimulation */]; });
__webpack_require__.d(__webpack_exports__, "forceX", function() { return /* reexport */ d3_force_src["g" /* forceX */]; });
__webpack_require__.d(__webpack_exports__, "forceY", function() { return /* reexport */ d3_force_src["h" /* forceY */]; });
__webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return /* reexport */ d3_format_src["c" /* formatDefaultLocale */]; });
__webpack_require__.d(__webpack_exports__, "format", function() { return /* reexport */ d3_format_src["b" /* format */]; });
__webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return /* reexport */ d3_format_src["e" /* formatPrefix */]; });
__webpack_require__.d(__webpack_exports__, "formatLocale", function() { return /* reexport */ d3_format_src["d" /* formatLocale */]; });
__webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return /* reexport */ d3_format_src["f" /* formatSpecifier */]; });
__webpack_require__.d(__webpack_exports__, "FormatSpecifier", function() { return /* reexport */ d3_format_src["a" /* FormatSpecifier */]; });
__webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return /* reexport */ d3_format_src["g" /* precisionFixed */]; });
__webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return /* reexport */ d3_format_src["h" /* precisionPrefix */]; });
__webpack_require__.d(__webpack_exports__, "precisionRound", function() { return /* reexport */ d3_format_src["i" /* precisionRound */]; });
__webpack_require__.d(__webpack_exports__, "geoArea", function() { return /* reexport */ d3_geo_src["c" /* geoArea */]; });
__webpack_require__.d(__webpack_exports__, "geoBounds", function() { return /* reexport */ d3_geo_src["h" /* geoBounds */]; });
__webpack_require__.d(__webpack_exports__, "geoCentroid", function() { return /* reexport */ d3_geo_src["i" /* geoCentroid */]; });
__webpack_require__.d(__webpack_exports__, "geoCircle", function() { return /* reexport */ d3_geo_src["j" /* geoCircle */]; });
__webpack_require__.d(__webpack_exports__, "geoClipAntimeridian", function() { return /* reexport */ d3_geo_src["k" /* geoClipAntimeridian */]; });
__webpack_require__.d(__webpack_exports__, "geoClipCircle", function() { return /* reexport */ d3_geo_src["l" /* geoClipCircle */]; });
__webpack_require__.d(__webpack_exports__, "geoClipExtent", function() { return /* reexport */ d3_geo_src["m" /* geoClipExtent */]; });
__webpack_require__.d(__webpack_exports__, "geoClipRectangle", function() { return /* reexport */ d3_geo_src["n" /* geoClipRectangle */]; });
__webpack_require__.d(__webpack_exports__, "geoContains", function() { return /* reexport */ d3_geo_src["u" /* geoContains */]; });
__webpack_require__.d(__webpack_exports__, "geoDistance", function() { return /* reexport */ d3_geo_src["v" /* geoDistance */]; });
__webpack_require__.d(__webpack_exports__, "geoGraticule", function() { return /* reexport */ d3_geo_src["C" /* geoGraticule */]; });
__webpack_require__.d(__webpack_exports__, "geoGraticule10", function() { return /* reexport */ d3_geo_src["D" /* geoGraticule10 */]; });
__webpack_require__.d(__webpack_exports__, "geoInterpolate", function() { return /* reexport */ d3_geo_src["F" /* geoInterpolate */]; });
__webpack_require__.d(__webpack_exports__, "geoLength", function() { return /* reexport */ d3_geo_src["G" /* geoLength */]; });
__webpack_require__.d(__webpack_exports__, "geoPath", function() { return /* reexport */ d3_geo_src["N" /* geoPath */]; });
__webpack_require__.d(__webpack_exports__, "geoAlbers", function() { return /* reexport */ d3_geo_src["a" /* geoAlbers */]; });
__webpack_require__.d(__webpack_exports__, "geoAlbersUsa", function() { return /* reexport */ d3_geo_src["b" /* geoAlbersUsa */]; });
__webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualArea", function() { return /* reexport */ d3_geo_src["d" /* geoAzimuthalEqualArea */]; });
__webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualAreaRaw", function() { return /* reexport */ d3_geo_src["e" /* geoAzimuthalEqualAreaRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistant", function() { return /* reexport */ d3_geo_src["f" /* geoAzimuthalEquidistant */]; });
__webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistantRaw", function() { return /* reexport */ d3_geo_src["g" /* geoAzimuthalEquidistantRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoConicConformal", function() { return /* reexport */ d3_geo_src["o" /* geoConicConformal */]; });
__webpack_require__.d(__webpack_exports__, "geoConicConformalRaw", function() { return /* reexport */ d3_geo_src["p" /* geoConicConformalRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoConicEqualArea", function() { return /* reexport */ d3_geo_src["q" /* geoConicEqualArea */]; });
__webpack_require__.d(__webpack_exports__, "geoConicEqualAreaRaw", function() { return /* reexport */ d3_geo_src["r" /* geoConicEqualAreaRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoConicEquidistant", function() { return /* reexport */ d3_geo_src["s" /* geoConicEquidistant */]; });
__webpack_require__.d(__webpack_exports__, "geoConicEquidistantRaw", function() { return /* reexport */ d3_geo_src["t" /* geoConicEquidistantRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoEqualEarth", function() { return /* reexport */ d3_geo_src["w" /* geoEqualEarth */]; });
__webpack_require__.d(__webpack_exports__, "geoEqualEarthRaw", function() { return /* reexport */ d3_geo_src["x" /* geoEqualEarthRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoEquirectangular", function() { return /* reexport */ d3_geo_src["y" /* geoEquirectangular */]; });
__webpack_require__.d(__webpack_exports__, "geoEquirectangularRaw", function() { return /* reexport */ d3_geo_src["z" /* geoEquirectangularRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoGnomonic", function() { return /* reexport */ d3_geo_src["A" /* geoGnomonic */]; });
__webpack_require__.d(__webpack_exports__, "geoGnomonicRaw", function() { return /* reexport */ d3_geo_src["B" /* geoGnomonicRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoIdentity", function() { return /* reexport */ d3_geo_src["E" /* geoIdentity */]; });
__webpack_require__.d(__webpack_exports__, "geoProjection", function() { return /* reexport */ d3_geo_src["O" /* geoProjection */]; });
__webpack_require__.d(__webpack_exports__, "geoProjectionMutator", function() { return /* reexport */ d3_geo_src["P" /* geoProjectionMutator */]; });
__webpack_require__.d(__webpack_exports__, "geoMercator", function() { return /* reexport */ d3_geo_src["H" /* geoMercator */]; });
__webpack_require__.d(__webpack_exports__, "geoMercatorRaw", function() { return /* reexport */ d3_geo_src["I" /* geoMercatorRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoNaturalEarth1", function() { return /* reexport */ d3_geo_src["J" /* geoNaturalEarth1 */]; });
__webpack_require__.d(__webpack_exports__, "geoNaturalEarth1Raw", function() { return /* reexport */ d3_geo_src["K" /* geoNaturalEarth1Raw */]; });
__webpack_require__.d(__webpack_exports__, "geoOrthographic", function() { return /* reexport */ d3_geo_src["L" /* geoOrthographic */]; });
__webpack_require__.d(__webpack_exports__, "geoOrthographicRaw", function() { return /* reexport */ d3_geo_src["M" /* geoOrthographicRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoStereographic", function() { return /* reexport */ d3_geo_src["R" /* geoStereographic */]; });
__webpack_require__.d(__webpack_exports__, "geoStereographicRaw", function() { return /* reexport */ d3_geo_src["S" /* geoStereographicRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoTransverseMercator", function() { return /* reexport */ d3_geo_src["V" /* geoTransverseMercator */]; });
__webpack_require__.d(__webpack_exports__, "geoTransverseMercatorRaw", function() { return /* reexport */ d3_geo_src["W" /* geoTransverseMercatorRaw */]; });
__webpack_require__.d(__webpack_exports__, "geoRotation", function() { return /* reexport */ d3_geo_src["Q" /* geoRotation */]; });
__webpack_require__.d(__webpack_exports__, "geoStream", function() { return /* reexport */ d3_geo_src["T" /* geoStream */]; });
__webpack_require__.d(__webpack_exports__, "geoTransform", function() { return /* reexport */ d3_geo_src["U" /* geoTransform */]; });
__webpack_require__.d(__webpack_exports__, "cluster", function() { return /* reexport */ d3_hierarchy_src["a" /* cluster */]; });
__webpack_require__.d(__webpack_exports__, "hierarchy", function() { return /* reexport */ d3_hierarchy_src["b" /* hierarchy */]; });
__webpack_require__.d(__webpack_exports__, "pack", function() { return /* reexport */ d3_hierarchy_src["c" /* pack */]; });
__webpack_require__.d(__webpack_exports__, "packSiblings", function() { return /* reexport */ d3_hierarchy_src["e" /* packSiblings */]; });
__webpack_require__.d(__webpack_exports__, "packEnclose", function() { return /* reexport */ d3_hierarchy_src["d" /* packEnclose */]; });
__webpack_require__.d(__webpack_exports__, "partition", function() { return /* reexport */ d3_hierarchy_src["f" /* partition */]; });
__webpack_require__.d(__webpack_exports__, "stratify", function() { return /* reexport */ d3_hierarchy_src["g" /* stratify */]; });
__webpack_require__.d(__webpack_exports__, "tree", function() { return /* reexport */ d3_hierarchy_src["h" /* tree */]; });
__webpack_require__.d(__webpack_exports__, "treemap", function() { return /* reexport */ d3_hierarchy_src["i" /* treemap */]; });
__webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return /* reexport */ d3_hierarchy_src["j" /* treemapBinary */]; });
__webpack_require__.d(__webpack_exports__, "treemapDice", function() { return /* reexport */ d3_hierarchy_src["k" /* treemapDice */]; });
__webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return /* reexport */ d3_hierarchy_src["m" /* treemapSlice */]; });
__webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return /* reexport */ d3_hierarchy_src["n" /* treemapSliceDice */]; });
__webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return /* reexport */ d3_hierarchy_src["o" /* treemapSquarify */]; });
__webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return /* reexport */ d3_hierarchy_src["l" /* treemapResquarify */]; });
__webpack_require__.d(__webpack_exports__, "interpolate", function() { return /* reexport */ d3_interpolate_src["a" /* interpolate */]; });
__webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return /* reexport */ d3_interpolate_src["b" /* interpolateArray */]; });
__webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return /* reexport */ d3_interpolate_src["c" /* interpolateBasis */]; });
__webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return /* reexport */ d3_interpolate_src["d" /* interpolateBasisClosed */]; });
__webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return /* reexport */ d3_interpolate_src["g" /* interpolateDate */]; });
__webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function() { return /* reexport */ d3_interpolate_src["h" /* interpolateDiscrete */]; });
__webpack_require__.d(__webpack_exports__, "interpolateHue", function() { return /* reexport */ d3_interpolate_src["m" /* interpolateHue */]; });
__webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return /* reexport */ d3_interpolate_src["o" /* interpolateNumber */]; });
__webpack_require__.d(__webpack_exports__, "interpolateNumberArray", function() { return /* reexport */ d3_interpolate_src["p" /* interpolateNumberArray */]; });
__webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return /* reexport */ d3_interpolate_src["q" /* interpolateObject */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return /* reexport */ d3_interpolate_src["u" /* interpolateRound */]; });
__webpack_require__.d(__webpack_exports__, "interpolateString", function() { return /* reexport */ d3_interpolate_src["v" /* interpolateString */]; });
__webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return /* reexport */ d3_interpolate_src["w" /* interpolateTransformCss */]; });
__webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return /* reexport */ d3_interpolate_src["x" /* interpolateTransformSvg */]; });
__webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return /* reexport */ d3_interpolate_src["y" /* interpolateZoom */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return /* reexport */ d3_interpolate_src["r" /* interpolateRgb */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return /* reexport */ d3_interpolate_src["s" /* interpolateRgbBasis */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return /* reexport */ d3_interpolate_src["t" /* interpolateRgbBasisClosed */]; });
__webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return /* reexport */ d3_interpolate_src["k" /* interpolateHsl */]; });
__webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return /* reexport */ d3_interpolate_src["l" /* interpolateHslLong */]; });
__webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return /* reexport */ d3_interpolate_src["n" /* interpolateLab */]; });
__webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return /* reexport */ d3_interpolate_src["i" /* interpolateHcl */]; });
__webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return /* reexport */ d3_interpolate_src["j" /* interpolateHclLong */]; });
__webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return /* reexport */ d3_interpolate_src["e" /* interpolateCubehelix */]; });
__webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return /* reexport */ d3_interpolate_src["f" /* interpolateCubehelixLong */]; });
__webpack_require__.d(__webpack_exports__, "piecewise", function() { return /* reexport */ d3_interpolate_src["z" /* piecewise */]; });
__webpack_require__.d(__webpack_exports__, "quantize", function() { return /* reexport */ d3_interpolate_src["A" /* quantize */]; });
__webpack_require__.d(__webpack_exports__, "path", function() { return /* reexport */ d3_path_src["a" /* path */]; });
__webpack_require__.d(__webpack_exports__, "polygonArea", function() { return /* reexport */ d3_polygon_src["a" /* polygonArea */]; });
__webpack_require__.d(__webpack_exports__, "polygonCentroid", function() { return /* reexport */ d3_polygon_src["b" /* polygonCentroid */]; });
__webpack_require__.d(__webpack_exports__, "polygonHull", function() { return /* reexport */ d3_polygon_src["d" /* polygonHull */]; });
__webpack_require__.d(__webpack_exports__, "polygonContains", function() { return /* reexport */ d3_polygon_src["c" /* polygonContains */]; });
__webpack_require__.d(__webpack_exports__, "polygonLength", function() { return /* reexport */ d3_polygon_src["e" /* polygonLength */]; });
__webpack_require__.d(__webpack_exports__, "quadtree", function() { return /* reexport */ d3_quadtree_src["a" /* quadtree */]; });
__webpack_require__.d(__webpack_exports__, "randomUniform", function() { return /* reexport */ d3_random_src["q" /* randomUniform */]; });
__webpack_require__.d(__webpack_exports__, "randomInt", function() { return /* reexport */ d3_random_src["i" /* randomInt */]; });
__webpack_require__.d(__webpack_exports__, "randomNormal", function() { return /* reexport */ d3_random_src["n" /* randomNormal */]; });
__webpack_require__.d(__webpack_exports__, "randomLogNormal", function() { return /* reexport */ d3_random_src["l" /* randomLogNormal */]; });
__webpack_require__.d(__webpack_exports__, "randomBates", function() { return /* reexport */ d3_random_src["a" /* randomBates */]; });
__webpack_require__.d(__webpack_exports__, "randomIrwinHall", function() { return /* reexport */ d3_random_src["j" /* randomIrwinHall */]; });
__webpack_require__.d(__webpack_exports__, "randomExponential", function() { return /* reexport */ d3_random_src["f" /* randomExponential */]; });
__webpack_require__.d(__webpack_exports__, "randomPareto", function() { return /* reexport */ d3_random_src["o" /* randomPareto */]; });
__webpack_require__.d(__webpack_exports__, "randomBernoulli", function() { return /* reexport */ d3_random_src["b" /* randomBernoulli */]; });
__webpack_require__.d(__webpack_exports__, "randomGeometric", function() { return /* reexport */ d3_random_src["h" /* randomGeometric */]; });
__webpack_require__.d(__webpack_exports__, "randomBinomial", function() { return /* reexport */ d3_random_src["d" /* randomBinomial */]; });
__webpack_require__.d(__webpack_exports__, "randomGamma", function() { return /* reexport */ d3_random_src["g" /* randomGamma */]; });
__webpack_require__.d(__webpack_exports__, "randomBeta", function() { return /* reexport */ d3_random_src["c" /* randomBeta */]; });
__webpack_require__.d(__webpack_exports__, "randomWeibull", function() { return /* reexport */ d3_random_src["r" /* randomWeibull */]; });
__webpack_require__.d(__webpack_exports__, "randomCauchy", function() { return /* reexport */ d3_random_src["e" /* randomCauchy */]; });
__webpack_require__.d(__webpack_exports__, "randomLogistic", function() { return /* reexport */ d3_random_src["m" /* randomLogistic */]; });
__webpack_require__.d(__webpack_exports__, "randomPoisson", function() { return /* reexport */ d3_random_src["p" /* randomPoisson */]; });
__webpack_require__.d(__webpack_exports__, "randomLcg", function() { return /* reexport */ d3_random_src["k" /* randomLcg */]; });
__webpack_require__.d(__webpack_exports__, "scaleBand", function() { return /* reexport */ d3_scale_src["a" /* scaleBand */]; });
__webpack_require__.d(__webpack_exports__, "scalePoint", function() { return /* reexport */ d3_scale_src["l" /* scalePoint */]; });
__webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return /* reexport */ d3_scale_src["g" /* scaleIdentity */]; });
__webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return /* reexport */ d3_scale_src["i" /* scaleLinear */]; });
__webpack_require__.d(__webpack_exports__, "scaleLog", function() { return /* reexport */ d3_scale_src["j" /* scaleLog */]; });
__webpack_require__.d(__webpack_exports__, "scaleSymlog", function() { return /* reexport */ d3_scale_src["x" /* scaleSymlog */]; });
__webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return /* reexport */ d3_scale_src["k" /* scaleOrdinal */]; });
__webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return /* reexport */ d3_scale_src["h" /* scaleImplicit */]; });
__webpack_require__.d(__webpack_exports__, "scalePow", function() { return /* reexport */ d3_scale_src["m" /* scalePow */]; });
__webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return /* reexport */ d3_scale_src["w" /* scaleSqrt */]; });
__webpack_require__.d(__webpack_exports__, "scaleRadial", function() { return /* reexport */ d3_scale_src["p" /* scaleRadial */]; });
__webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return /* reexport */ d3_scale_src["n" /* scaleQuantile */]; });
__webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return /* reexport */ d3_scale_src["o" /* scaleQuantize */]; });
__webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return /* reexport */ d3_scale_src["y" /* scaleThreshold */]; });
__webpack_require__.d(__webpack_exports__, "scaleTime", function() { return /* reexport */ d3_scale_src["z" /* scaleTime */]; });
__webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return /* reexport */ d3_scale_src["A" /* scaleUtc */]; });
__webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return /* reexport */ d3_scale_src["q" /* scaleSequential */]; });
__webpack_require__.d(__webpack_exports__, "scaleSequentialLog", function() { return /* reexport */ d3_scale_src["r" /* scaleSequentialLog */]; });
__webpack_require__.d(__webpack_exports__, "scaleSequentialPow", function() { return /* reexport */ d3_scale_src["s" /* scaleSequentialPow */]; });
__webpack_require__.d(__webpack_exports__, "scaleSequentialSqrt", function() { return /* reexport */ d3_scale_src["u" /* scaleSequentialSqrt */]; });
__webpack_require__.d(__webpack_exports__, "scaleSequentialSymlog", function() { return /* reexport */ d3_scale_src["v" /* scaleSequentialSymlog */]; });
__webpack_require__.d(__webpack_exports__, "scaleSequentialQuantile", function() { return /* reexport */ d3_scale_src["t" /* scaleSequentialQuantile */]; });
__webpack_require__.d(__webpack_exports__, "scaleDiverging", function() { return /* reexport */ d3_scale_src["b" /* scaleDiverging */]; });
__webpack_require__.d(__webpack_exports__, "scaleDivergingLog", function() { return /* reexport */ d3_scale_src["c" /* scaleDivergingLog */]; });
__webpack_require__.d(__webpack_exports__, "scaleDivergingPow", function() { return /* reexport */ d3_scale_src["d" /* scaleDivergingPow */]; });
__webpack_require__.d(__webpack_exports__, "scaleDivergingSqrt", function() { return /* reexport */ d3_scale_src["e" /* scaleDivergingSqrt */]; });
__webpack_require__.d(__webpack_exports__, "scaleDivergingSymlog", function() { return /* reexport */ d3_scale_src["f" /* scaleDivergingSymlog */]; });
__webpack_require__.d(__webpack_exports__, "tickFormat", function() { return /* reexport */ d3_scale_src["B" /* tickFormat */]; });
__webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return /* reexport */ d3_scale_chromatic_src["R" /* schemeCategory10 */]; });
__webpack_require__.d(__webpack_exports__, "schemeAccent", function() { return /* reexport */ d3_scale_chromatic_src["M" /* schemeAccent */]; });
__webpack_require__.d(__webpack_exports__, "schemeDark2", function() { return /* reexport */ d3_scale_chromatic_src["S" /* schemeDark2 */]; });
__webpack_require__.d(__webpack_exports__, "schemePaired", function() { return /* reexport */ d3_scale_chromatic_src["Z" /* schemePaired */]; });
__webpack_require__.d(__webpack_exports__, "schemePastel1", function() { return /* reexport */ d3_scale_chromatic_src["ab" /* schemePastel1 */]; });
__webpack_require__.d(__webpack_exports__, "schemePastel2", function() { return /* reexport */ d3_scale_chromatic_src["bb" /* schemePastel2 */]; });
__webpack_require__.d(__webpack_exports__, "schemeSet1", function() { return /* reexport */ d3_scale_chromatic_src["ob" /* schemeSet1 */]; });
__webpack_require__.d(__webpack_exports__, "schemeSet2", function() { return /* reexport */ d3_scale_chromatic_src["pb" /* schemeSet2 */]; });
__webpack_require__.d(__webpack_exports__, "schemeSet3", function() { return /* reexport */ d3_scale_chromatic_src["qb" /* schemeSet3 */]; });
__webpack_require__.d(__webpack_exports__, "schemeTableau10", function() { return /* reexport */ d3_scale_chromatic_src["sb" /* schemeTableau10 */]; });
__webpack_require__.d(__webpack_exports__, "interpolateBrBG", function() { return /* reexport */ d3_scale_chromatic_src["b" /* interpolateBrBG */]; });
__webpack_require__.d(__webpack_exports__, "schemeBrBG", function() { return /* reexport */ d3_scale_chromatic_src["O" /* schemeBrBG */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePRGn", function() { return /* reexport */ d3_scale_chromatic_src["o" /* interpolatePRGn */]; });
__webpack_require__.d(__webpack_exports__, "schemePRGn", function() { return /* reexport */ d3_scale_chromatic_src["Y" /* schemePRGn */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePiYG", function() { return /* reexport */ d3_scale_chromatic_src["p" /* interpolatePiYG */]; });
__webpack_require__.d(__webpack_exports__, "schemePiYG", function() { return /* reexport */ d3_scale_chromatic_src["cb" /* schemePiYG */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePuOr", function() { return /* reexport */ d3_scale_chromatic_src["t" /* interpolatePuOr */]; });
__webpack_require__.d(__webpack_exports__, "schemePuOr", function() { return /* reexport */ d3_scale_chromatic_src["fb" /* schemePuOr */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRdBu", function() { return /* reexport */ d3_scale_chromatic_src["x" /* interpolateRdBu */]; });
__webpack_require__.d(__webpack_exports__, "schemeRdBu", function() { return /* reexport */ d3_scale_chromatic_src["ib" /* schemeRdBu */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRdGy", function() { return /* reexport */ d3_scale_chromatic_src["y" /* interpolateRdGy */]; });
__webpack_require__.d(__webpack_exports__, "schemeRdGy", function() { return /* reexport */ d3_scale_chromatic_src["jb" /* schemeRdGy */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRdYlBu", function() { return /* reexport */ d3_scale_chromatic_src["A" /* interpolateRdYlBu */]; });
__webpack_require__.d(__webpack_exports__, "schemeRdYlBu", function() { return /* reexport */ d3_scale_chromatic_src["lb" /* schemeRdYlBu */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRdYlGn", function() { return /* reexport */ d3_scale_chromatic_src["B" /* interpolateRdYlGn */]; });
__webpack_require__.d(__webpack_exports__, "schemeRdYlGn", function() { return /* reexport */ d3_scale_chromatic_src["mb" /* schemeRdYlGn */]; });
__webpack_require__.d(__webpack_exports__, "interpolateSpectral", function() { return /* reexport */ d3_scale_chromatic_src["E" /* interpolateSpectral */]; });
__webpack_require__.d(__webpack_exports__, "schemeSpectral", function() { return /* reexport */ d3_scale_chromatic_src["rb" /* schemeSpectral */]; });
__webpack_require__.d(__webpack_exports__, "interpolateBuGn", function() { return /* reexport */ d3_scale_chromatic_src["c" /* interpolateBuGn */]; });
__webpack_require__.d(__webpack_exports__, "schemeBuGn", function() { return /* reexport */ d3_scale_chromatic_src["P" /* schemeBuGn */]; });
__webpack_require__.d(__webpack_exports__, "interpolateBuPu", function() { return /* reexport */ d3_scale_chromatic_src["d" /* interpolateBuPu */]; });
__webpack_require__.d(__webpack_exports__, "schemeBuPu", function() { return /* reexport */ d3_scale_chromatic_src["Q" /* schemeBuPu */]; });
__webpack_require__.d(__webpack_exports__, "interpolateGnBu", function() { return /* reexport */ d3_scale_chromatic_src["h" /* interpolateGnBu */]; });
__webpack_require__.d(__webpack_exports__, "schemeGnBu", function() { return /* reexport */ d3_scale_chromatic_src["T" /* schemeGnBu */]; });
__webpack_require__.d(__webpack_exports__, "interpolateOrRd", function() { return /* reexport */ d3_scale_chromatic_src["m" /* interpolateOrRd */]; });
__webpack_require__.d(__webpack_exports__, "schemeOrRd", function() { return /* reexport */ d3_scale_chromatic_src["W" /* schemeOrRd */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePuBuGn", function() { return /* reexport */ d3_scale_chromatic_src["s" /* interpolatePuBuGn */]; });
__webpack_require__.d(__webpack_exports__, "schemePuBuGn", function() { return /* reexport */ d3_scale_chromatic_src["eb" /* schemePuBuGn */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePuBu", function() { return /* reexport */ d3_scale_chromatic_src["r" /* interpolatePuBu */]; });
__webpack_require__.d(__webpack_exports__, "schemePuBu", function() { return /* reexport */ d3_scale_chromatic_src["db" /* schemePuBu */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePuRd", function() { return /* reexport */ d3_scale_chromatic_src["u" /* interpolatePuRd */]; });
__webpack_require__.d(__webpack_exports__, "schemePuRd", function() { return /* reexport */ d3_scale_chromatic_src["gb" /* schemePuRd */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRdPu", function() { return /* reexport */ d3_scale_chromatic_src["z" /* interpolateRdPu */]; });
__webpack_require__.d(__webpack_exports__, "schemeRdPu", function() { return /* reexport */ d3_scale_chromatic_src["kb" /* schemeRdPu */]; });
__webpack_require__.d(__webpack_exports__, "interpolateYlGnBu", function() { return /* reexport */ d3_scale_chromatic_src["J" /* interpolateYlGnBu */]; });
__webpack_require__.d(__webpack_exports__, "schemeYlGnBu", function() { return /* reexport */ d3_scale_chromatic_src["ub" /* schemeYlGnBu */]; });
__webpack_require__.d(__webpack_exports__, "interpolateYlGn", function() { return /* reexport */ d3_scale_chromatic_src["I" /* interpolateYlGn */]; });
__webpack_require__.d(__webpack_exports__, "schemeYlGn", function() { return /* reexport */ d3_scale_chromatic_src["tb" /* schemeYlGn */]; });
__webpack_require__.d(__webpack_exports__, "interpolateYlOrBr", function() { return /* reexport */ d3_scale_chromatic_src["K" /* interpolateYlOrBr */]; });
__webpack_require__.d(__webpack_exports__, "schemeYlOrBr", function() { return /* reexport */ d3_scale_chromatic_src["vb" /* schemeYlOrBr */]; });
__webpack_require__.d(__webpack_exports__, "interpolateYlOrRd", function() { return /* reexport */ d3_scale_chromatic_src["L" /* interpolateYlOrRd */]; });
__webpack_require__.d(__webpack_exports__, "schemeYlOrRd", function() { return /* reexport */ d3_scale_chromatic_src["wb" /* schemeYlOrRd */]; });
__webpack_require__.d(__webpack_exports__, "interpolateBlues", function() { return /* reexport */ d3_scale_chromatic_src["a" /* interpolateBlues */]; });
__webpack_require__.d(__webpack_exports__, "schemeBlues", function() { return /* reexport */ d3_scale_chromatic_src["N" /* schemeBlues */]; });
__webpack_require__.d(__webpack_exports__, "interpolateGreens", function() { return /* reexport */ d3_scale_chromatic_src["i" /* interpolateGreens */]; });
__webpack_require__.d(__webpack_exports__, "schemeGreens", function() { return /* reexport */ d3_scale_chromatic_src["U" /* schemeGreens */]; });
__webpack_require__.d(__webpack_exports__, "interpolateGreys", function() { return /* reexport */ d3_scale_chromatic_src["j" /* interpolateGreys */]; });
__webpack_require__.d(__webpack_exports__, "schemeGreys", function() { return /* reexport */ d3_scale_chromatic_src["V" /* schemeGreys */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePurples", function() { return /* reexport */ d3_scale_chromatic_src["v" /* interpolatePurples */]; });
__webpack_require__.d(__webpack_exports__, "schemePurples", function() { return /* reexport */ d3_scale_chromatic_src["hb" /* schemePurples */]; });
__webpack_require__.d(__webpack_exports__, "interpolateReds", function() { return /* reexport */ d3_scale_chromatic_src["C" /* interpolateReds */]; });
__webpack_require__.d(__webpack_exports__, "schemeReds", function() { return /* reexport */ d3_scale_chromatic_src["nb" /* schemeReds */]; });
__webpack_require__.d(__webpack_exports__, "interpolateOranges", function() { return /* reexport */ d3_scale_chromatic_src["n" /* interpolateOranges */]; });
__webpack_require__.d(__webpack_exports__, "schemeOranges", function() { return /* reexport */ d3_scale_chromatic_src["X" /* schemeOranges */]; });
__webpack_require__.d(__webpack_exports__, "interpolateCividis", function() { return /* reexport */ d3_scale_chromatic_src["e" /* interpolateCividis */]; });
__webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return /* reexport */ d3_scale_chromatic_src["g" /* interpolateCubehelixDefault */]; });
__webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return /* reexport */ d3_scale_chromatic_src["w" /* interpolateRainbow */]; });
__webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return /* reexport */ d3_scale_chromatic_src["H" /* interpolateWarm */]; });
__webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return /* reexport */ d3_scale_chromatic_src["f" /* interpolateCool */]; });
__webpack_require__.d(__webpack_exports__, "interpolateSinebow", function() { return /* reexport */ d3_scale_chromatic_src["D" /* interpolateSinebow */]; });
__webpack_require__.d(__webpack_exports__, "interpolateTurbo", function() { return /* reexport */ d3_scale_chromatic_src["F" /* interpolateTurbo */]; });
__webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return /* reexport */ d3_scale_chromatic_src["G" /* interpolateViridis */]; });
__webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return /* reexport */ d3_scale_chromatic_src["l" /* interpolateMagma */]; });
__webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return /* reexport */ d3_scale_chromatic_src["k" /* interpolateInferno */]; });
__webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return /* reexport */ d3_scale_chromatic_src["q" /* interpolatePlasma */]; });
__webpack_require__.d(__webpack_exports__, "create", function() { return /* reexport */ d3_selection_src["a" /* create */]; });
__webpack_require__.d(__webpack_exports__, "creator", function() { return /* reexport */ d3_selection_src["b" /* creator */]; });
__webpack_require__.d(__webpack_exports__, "local", function() { return /* reexport */ d3_selection_src["c" /* local */]; });
__webpack_require__.d(__webpack_exports__, "matcher", function() { return /* reexport */ d3_selection_src["d" /* matcher */]; });
__webpack_require__.d(__webpack_exports__, "namespace", function() { return /* reexport */ d3_selection_src["e" /* namespace */]; });
__webpack_require__.d(__webpack_exports__, "namespaces", function() { return /* reexport */ d3_selection_src["f" /* namespaces */]; });
__webpack_require__.d(__webpack_exports__, "pointer", function() { return /* reexport */ d3_selection_src["g" /* pointer */]; });
__webpack_require__.d(__webpack_exports__, "pointers", function() { return /* reexport */ d3_selection_src["h" /* pointers */]; });
__webpack_require__.d(__webpack_exports__, "select", function() { return /* reexport */ d3_selection_src["i" /* select */]; });
__webpack_require__.d(__webpack_exports__, "selectAll", function() { return /* reexport */ d3_selection_src["j" /* selectAll */]; });
__webpack_require__.d(__webpack_exports__, "selection", function() { return /* reexport */ d3_selection_src["k" /* selection */]; });
__webpack_require__.d(__webpack_exports__, "selector", function() { return /* reexport */ d3_selection_src["l" /* selector */]; });
__webpack_require__.d(__webpack_exports__, "selectorAll", function() { return /* reexport */ d3_selection_src["m" /* selectorAll */]; });
__webpack_require__.d(__webpack_exports__, "style", function() { return /* reexport */ d3_selection_src["n" /* style */]; });
__webpack_require__.d(__webpack_exports__, "window", function() { return /* reexport */ d3_selection_src["o" /* window */]; });
__webpack_require__.d(__webpack_exports__, "arc", function() { return /* reexport */ d3_shape_src["a" /* arc */]; });
__webpack_require__.d(__webpack_exports__, "area", function() { return /* reexport */ d3_shape_src["b" /* area */]; });
__webpack_require__.d(__webpack_exports__, "line", function() { return /* reexport */ d3_shape_src["v" /* line */]; });
__webpack_require__.d(__webpack_exports__, "pie", function() { return /* reexport */ d3_shape_src["A" /* pie */]; });
__webpack_require__.d(__webpack_exports__, "areaRadial", function() { return /* reexport */ d3_shape_src["c" /* areaRadial */]; });
__webpack_require__.d(__webpack_exports__, "radialArea", function() { return /* reexport */ d3_shape_src["C" /* radialArea */]; });
__webpack_require__.d(__webpack_exports__, "lineRadial", function() { return /* reexport */ d3_shape_src["w" /* lineRadial */]; });
__webpack_require__.d(__webpack_exports__, "radialLine", function() { return /* reexport */ d3_shape_src["D" /* radialLine */]; });
__webpack_require__.d(__webpack_exports__, "pointRadial", function() { return /* reexport */ d3_shape_src["B" /* pointRadial */]; });
__webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return /* reexport */ d3_shape_src["x" /* linkHorizontal */]; });
__webpack_require__.d(__webpack_exports__, "linkVertical", function() { return /* reexport */ d3_shape_src["z" /* linkVertical */]; });
__webpack_require__.d(__webpack_exports__, "linkRadial", function() { return /* reexport */ d3_shape_src["y" /* linkRadial */]; });
__webpack_require__.d(__webpack_exports__, "symbol", function() { return /* reexport */ d3_shape_src["Q" /* symbol */]; });
__webpack_require__.d(__webpack_exports__, "symbols", function() { return /* reexport */ d3_shape_src["Y" /* symbols */]; });
__webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return /* reexport */ d3_shape_src["R" /* symbolCircle */]; });
__webpack_require__.d(__webpack_exports__, "symbolCross", function() { return /* reexport */ d3_shape_src["S" /* symbolCross */]; });
__webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return /* reexport */ d3_shape_src["T" /* symbolDiamond */]; });
__webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return /* reexport */ d3_shape_src["U" /* symbolSquare */]; });
__webpack_require__.d(__webpack_exports__, "symbolStar", function() { return /* reexport */ d3_shape_src["V" /* symbolStar */]; });
__webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return /* reexport */ d3_shape_src["W" /* symbolTriangle */]; });
__webpack_require__.d(__webpack_exports__, "symbolWye", function() { return /* reexport */ d3_shape_src["X" /* symbolWye */]; });
__webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return /* reexport */ d3_shape_src["e" /* curveBasisClosed */]; });
__webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return /* reexport */ d3_shape_src["f" /* curveBasisOpen */]; });
__webpack_require__.d(__webpack_exports__, "curveBasis", function() { return /* reexport */ d3_shape_src["d" /* curveBasis */]; });
__webpack_require__.d(__webpack_exports__, "curveBundle", function() { return /* reexport */ d3_shape_src["g" /* curveBundle */]; });
__webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return /* reexport */ d3_shape_src["i" /* curveCardinalClosed */]; });
__webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return /* reexport */ d3_shape_src["j" /* curveCardinalOpen */]; });
__webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return /* reexport */ d3_shape_src["h" /* curveCardinal */]; });
__webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return /* reexport */ d3_shape_src["l" /* curveCatmullRomClosed */]; });
__webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return /* reexport */ d3_shape_src["m" /* curveCatmullRomOpen */]; });
__webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return /* reexport */ d3_shape_src["k" /* curveCatmullRom */]; });
__webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return /* reexport */ d3_shape_src["o" /* curveLinearClosed */]; });
__webpack_require__.d(__webpack_exports__, "curveLinear", function() { return /* reexport */ d3_shape_src["n" /* curveLinear */]; });
__webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return /* reexport */ d3_shape_src["p" /* curveMonotoneX */]; });
__webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return /* reexport */ d3_shape_src["q" /* curveMonotoneY */]; });
__webpack_require__.d(__webpack_exports__, "curveNatural", function() { return /* reexport */ d3_shape_src["r" /* curveNatural */]; });
__webpack_require__.d(__webpack_exports__, "curveStep", function() { return /* reexport */ d3_shape_src["s" /* curveStep */]; });
__webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return /* reexport */ d3_shape_src["t" /* curveStepAfter */]; });
__webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return /* reexport */ d3_shape_src["u" /* curveStepBefore */]; });
__webpack_require__.d(__webpack_exports__, "stack", function() { return /* reexport */ d3_shape_src["E" /* stack */]; });
__webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return /* reexport */ d3_shape_src["G" /* stackOffsetExpand */]; });
__webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return /* reexport */ d3_shape_src["F" /* stackOffsetDiverging */]; });
__webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return /* reexport */ d3_shape_src["H" /* stackOffsetNone */]; });
__webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return /* reexport */ d3_shape_src["I" /* stackOffsetSilhouette */]; });
__webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return /* reexport */ d3_shape_src["J" /* stackOffsetWiggle */]; });
__webpack_require__.d(__webpack_exports__, "stackOrderAppearance", function() { return /* reexport */ d3_shape_src["K" /* stackOrderAppearance */]; });
__webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return /* reexport */ d3_shape_src["L" /* stackOrderAscending */]; });
__webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return /* reexport */ d3_shape_src["M" /* stackOrderDescending */]; });
__webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return /* reexport */ d3_shape_src["N" /* stackOrderInsideOut */]; });
__webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return /* reexport */ d3_shape_src["O" /* stackOrderNone */]; });
__webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return /* reexport */ d3_shape_src["P" /* stackOrderReverse */]; });
__webpack_require__.d(__webpack_exports__, "timeInterval", function() { return /* reexport */ d3_time_src["g" /* timeInterval */]; });
__webpack_require__.d(__webpack_exports__, "timeMillisecond", function() { return /* reexport */ d3_time_src["h" /* timeMillisecond */]; });
__webpack_require__.d(__webpack_exports__, "timeMilliseconds", function() { return /* reexport */ d3_time_src["i" /* timeMilliseconds */]; });
__webpack_require__.d(__webpack_exports__, "utcMillisecond", function() { return /* reexport */ d3_time_src["L" /* utcMillisecond */]; });
__webpack_require__.d(__webpack_exports__, "utcMilliseconds", function() { return /* reexport */ d3_time_src["M" /* utcMilliseconds */]; });
__webpack_require__.d(__webpack_exports__, "timeSecond", function() { return /* reexport */ d3_time_src["r" /* timeSecond */]; });
__webpack_require__.d(__webpack_exports__, "timeSeconds", function() { return /* reexport */ d3_time_src["s" /* timeSeconds */]; });
__webpack_require__.d(__webpack_exports__, "utcSecond", function() { return /* reexport */ d3_time_src["V" /* utcSecond */]; });
__webpack_require__.d(__webpack_exports__, "utcSeconds", function() { return /* reexport */ d3_time_src["W" /* utcSeconds */]; });
__webpack_require__.d(__webpack_exports__, "timeMinute", function() { return /* reexport */ d3_time_src["j" /* timeMinute */]; });
__webpack_require__.d(__webpack_exports__, "timeMinutes", function() { return /* reexport */ d3_time_src["k" /* timeMinutes */]; });
__webpack_require__.d(__webpack_exports__, "timeHour", function() { return /* reexport */ d3_time_src["e" /* timeHour */]; });
__webpack_require__.d(__webpack_exports__, "timeHours", function() { return /* reexport */ d3_time_src["f" /* timeHours */]; });
__webpack_require__.d(__webpack_exports__, "timeDay", function() { return /* reexport */ d3_time_src["a" /* timeDay */]; });
__webpack_require__.d(__webpack_exports__, "timeDays", function() { return /* reexport */ d3_time_src["b" /* timeDays */]; });
__webpack_require__.d(__webpack_exports__, "timeWeek", function() { return /* reexport */ d3_time_src["B" /* timeWeek */]; });
__webpack_require__.d(__webpack_exports__, "timeWeeks", function() { return /* reexport */ d3_time_src["C" /* timeWeeks */]; });
__webpack_require__.d(__webpack_exports__, "timeSunday", function() { return /* reexport */ d3_time_src["t" /* timeSunday */]; });
__webpack_require__.d(__webpack_exports__, "timeSundays", function() { return /* reexport */ d3_time_src["u" /* timeSundays */]; });
__webpack_require__.d(__webpack_exports__, "timeMonday", function() { return /* reexport */ d3_time_src["l" /* timeMonday */]; });
__webpack_require__.d(__webpack_exports__, "timeMondays", function() { return /* reexport */ d3_time_src["m" /* timeMondays */]; });
__webpack_require__.d(__webpack_exports__, "timeTuesday", function() { return /* reexport */ d3_time_src["x" /* timeTuesday */]; });
__webpack_require__.d(__webpack_exports__, "timeTuesdays", function() { return /* reexport */ d3_time_src["y" /* timeTuesdays */]; });
__webpack_require__.d(__webpack_exports__, "timeWednesday", function() { return /* reexport */ d3_time_src["z" /* timeWednesday */]; });
__webpack_require__.d(__webpack_exports__, "timeWednesdays", function() { return /* reexport */ d3_time_src["A" /* timeWednesdays */]; });
__webpack_require__.d(__webpack_exports__, "timeThursday", function() { return /* reexport */ d3_time_src["v" /* timeThursday */]; });
__webpack_require__.d(__webpack_exports__, "timeThursdays", function() { return /* reexport */ d3_time_src["w" /* timeThursdays */]; });
__webpack_require__.d(__webpack_exports__, "timeFriday", function() { return /* reexport */ d3_time_src["c" /* timeFriday */]; });
__webpack_require__.d(__webpack_exports__, "timeFridays", function() { return /* reexport */ d3_time_src["d" /* timeFridays */]; });
__webpack_require__.d(__webpack_exports__, "timeSaturday", function() { return /* reexport */ d3_time_src["p" /* timeSaturday */]; });
__webpack_require__.d(__webpack_exports__, "timeSaturdays", function() { return /* reexport */ d3_time_src["q" /* timeSaturdays */]; });
__webpack_require__.d(__webpack_exports__, "timeMonth", function() { return /* reexport */ d3_time_src["n" /* timeMonth */]; });
__webpack_require__.d(__webpack_exports__, "timeMonths", function() { return /* reexport */ d3_time_src["o" /* timeMonths */]; });
__webpack_require__.d(__webpack_exports__, "timeYear", function() { return /* reexport */ d3_time_src["D" /* timeYear */]; });
__webpack_require__.d(__webpack_exports__, "timeYears", function() { return /* reexport */ d3_time_src["E" /* timeYears */]; });
__webpack_require__.d(__webpack_exports__, "utcMinute", function() { return /* reexport */ d3_time_src["N" /* utcMinute */]; });
__webpack_require__.d(__webpack_exports__, "utcMinutes", function() { return /* reexport */ d3_time_src["O" /* utcMinutes */]; });
__webpack_require__.d(__webpack_exports__, "utcHour", function() { return /* reexport */ d3_time_src["J" /* utcHour */]; });
__webpack_require__.d(__webpack_exports__, "utcHours", function() { return /* reexport */ d3_time_src["K" /* utcHours */]; });
__webpack_require__.d(__webpack_exports__, "utcDay", function() { return /* reexport */ d3_time_src["F" /* utcDay */]; });
__webpack_require__.d(__webpack_exports__, "utcDays", function() { return /* reexport */ d3_time_src["G" /* utcDays */]; });
__webpack_require__.d(__webpack_exports__, "utcWeek", function() { return /* reexport */ d3_time_src["fb" /* utcWeek */]; });
__webpack_require__.d(__webpack_exports__, "utcWeeks", function() { return /* reexport */ d3_time_src["gb" /* utcWeeks */]; });
__webpack_require__.d(__webpack_exports__, "utcSunday", function() { return /* reexport */ d3_time_src["X" /* utcSunday */]; });
__webpack_require__.d(__webpack_exports__, "utcSundays", function() { return /* reexport */ d3_time_src["Y" /* utcSundays */]; });
__webpack_require__.d(__webpack_exports__, "utcMonday", function() { return /* reexport */ d3_time_src["P" /* utcMonday */]; });
__webpack_require__.d(__webpack_exports__, "utcMondays", function() { return /* reexport */ d3_time_src["Q" /* utcMondays */]; });
__webpack_require__.d(__webpack_exports__, "utcTuesday", function() { return /* reexport */ d3_time_src["bb" /* utcTuesday */]; });
__webpack_require__.d(__webpack_exports__, "utcTuesdays", function() { return /* reexport */ d3_time_src["cb" /* utcTuesdays */]; });
__webpack_require__.d(__webpack_exports__, "utcWednesday", function() { return /* reexport */ d3_time_src["db" /* utcWednesday */]; });
__webpack_require__.d(__webpack_exports__, "utcWednesdays", function() { return /* reexport */ d3_time_src["eb" /* utcWednesdays */]; });
__webpack_require__.d(__webpack_exports__, "utcThursday", function() { return /* reexport */ d3_time_src["Z" /* utcThursday */]; });
__webpack_require__.d(__webpack_exports__, "utcThursdays", function() { return /* reexport */ d3_time_src["ab" /* utcThursdays */]; });
__webpack_require__.d(__webpack_exports__, "utcFriday", function() { return /* reexport */ d3_time_src["H" /* utcFriday */]; });
__webpack_require__.d(__webpack_exports__, "utcFridays", function() { return /* reexport */ d3_time_src["I" /* utcFridays */]; });
__webpack_require__.d(__webpack_exports__, "utcSaturday", function() { return /* reexport */ d3_time_src["T" /* utcSaturday */]; });
__webpack_require__.d(__webpack_exports__, "utcSaturdays", function() { return /* reexport */ d3_time_src["U" /* utcSaturdays */]; });
__webpack_require__.d(__webpack_exports__, "utcMonth", function() { return /* reexport */ d3_time_src["R" /* utcMonth */]; });
__webpack_require__.d(__webpack_exports__, "utcMonths", function() { return /* reexport */ d3_time_src["S" /* utcMonths */]; });
__webpack_require__.d(__webpack_exports__, "utcYear", function() { return /* reexport */ d3_time_src["hb" /* utcYear */]; });
__webpack_require__.d(__webpack_exports__, "utcYears", function() { return /* reexport */ d3_time_src["ib" /* utcYears */]; });
__webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return /* reexport */ d3_time_format_src["d" /* timeFormatDefaultLocale */]; });
__webpack_require__.d(__webpack_exports__, "timeFormat", function() { return /* reexport */ d3_time_format_src["c" /* timeFormat */]; });
__webpack_require__.d(__webpack_exports__, "timeParse", function() { return /* reexport */ d3_time_format_src["f" /* timeParse */]; });
__webpack_require__.d(__webpack_exports__, "utcFormat", function() { return /* reexport */ d3_time_format_src["g" /* utcFormat */]; });
__webpack_require__.d(__webpack_exports__, "utcParse", function() { return /* reexport */ d3_time_format_src["h" /* utcParse */]; });
__webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return /* reexport */ d3_time_format_src["e" /* timeFormatLocale */]; });
__webpack_require__.d(__webpack_exports__, "isoFormat", function() { return /* reexport */ d3_time_format_src["a" /* isoFormat */]; });
__webpack_require__.d(__webpack_exports__, "isoParse", function() { return /* reexport */ d3_time_format_src["b" /* isoParse */]; });
__webpack_require__.d(__webpack_exports__, "now", function() { return /* reexport */ d3_timer_src["b" /* now */]; });
__webpack_require__.d(__webpack_exports__, "timer", function() { return /* reexport */ d3_timer_src["d" /* timer */]; });
__webpack_require__.d(__webpack_exports__, "timerFlush", function() { return /* reexport */ d3_timer_src["e" /* timerFlush */]; });
__webpack_require__.d(__webpack_exports__, "timeout", function() { return /* reexport */ d3_timer_src["c" /* timeout */]; });
__webpack_require__.d(__webpack_exports__, "interval", function() { return /* reexport */ d3_timer_src["a" /* interval */]; });
__webpack_require__.d(__webpack_exports__, "transition", function() { return /* reexport */ d3_transition_src["c" /* transition */]; });
__webpack_require__.d(__webpack_exports__, "active", function() { return /* reexport */ d3_transition_src["a" /* active */]; });
__webpack_require__.d(__webpack_exports__, "interrupt", function() { return /* reexport */ d3_transition_src["b" /* interrupt */]; });
__webpack_require__.d(__webpack_exports__, "zoom", function() { return /* reexport */ d3_zoom_src["a" /* zoom */]; });
__webpack_require__.d(__webpack_exports__, "zoomTransform", function() { return /* reexport */ d3_zoom_src["c" /* zoomTransform */]; });
__webpack_require__.d(__webpack_exports__, "zoomIdentity", function() { return /* reexport */ d3_zoom_src["b" /* zoomIdentity */]; });

// CONCATENATED MODULE: ./node_modules/@usafacts/frontend-library-metrics/node_modules/d3/dist/package.js
var package_name = "d3";
var version = "6.7.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "dist/d3.node.js";
var unpkg = "dist/d3.min.js";
var jsdelivr = "dist/d3.min.js";
var package_module = "index.js";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var files = ["dist/**/*.js","index.js"];
var scripts = {"pretest":"rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c","test":"tape 'test/**/*-test.js'","prepublishOnly":"yarn test","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"};
var devDependencies = {"json2module":"0.0","rimraf":"3","rollup":"2","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"5","rollup-plugin-terser":"7","tape":"4","tape-await":"0.1"};
var dependencies = {"d3-array":"2","d3-axis":"2","d3-brush":"2","d3-chord":"2","d3-color":"2","d3-contour":"2","d3-delaunay":"5","d3-dispatch":"2","d3-drag":"2","d3-dsv":"2","d3-ease":"2","d3-fetch":"2","d3-force":"2","d3-format":"2","d3-geo":"2","d3-hierarchy":"2","d3-interpolate":"2","d3-path":"2","d3-polygon":"2","d3-quadtree":"2","d3-random":"2","d3-scale":"3","d3-scale-chromatic":"2","d3-selection":"2","d3-shape":"2","d3-time":"2","d3-time-format":"3","d3-timer":"2","d3-transition":"2","d3-zoom":"2"};

// EXTERNAL MODULE: ./node_modules/d3-array/src/index.js + 27 modules
var src = __webpack_require__("bc17");

// EXTERNAL MODULE: ./node_modules/d3-axis/src/index.js + 3 modules
var d3_axis_src = __webpack_require__("4611");

// EXTERNAL MODULE: ./node_modules/d3-brush/src/index.js + 4 modules
var d3_brush_src = __webpack_require__("5f8f");

// EXTERNAL MODULE: ./node_modules/d3-chord/src/index.js + 5 modules
var d3_chord_src = __webpack_require__("faee");

// EXTERNAL MODULE: ./node_modules/d3-color/src/index.js
var d3_color_src = __webpack_require__("482f");

// EXTERNAL MODULE: ./node_modules/d3-contour/src/index.js + 9 modules
var d3_contour_src = __webpack_require__("ccc7");

// EXTERNAL MODULE: ./node_modules/d3-delaunay/src/index.js + 5 modules
var d3_delaunay_src = __webpack_require__("cfca");

// EXTERNAL MODULE: ./node_modules/d3-dispatch/src/index.js
var d3_dispatch_src = __webpack_require__("df45");

// EXTERNAL MODULE: ./node_modules/d3-drag/src/index.js + 3 modules
var d3_drag_src = __webpack_require__("abe9");

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/index.js + 1 modules
var d3_dsv_src = __webpack_require__("462d");

// EXTERNAL MODULE: ./node_modules/d3-ease/src/index.js + 10 modules
var d3_ease_src = __webpack_require__("fb77");

// EXTERNAL MODULE: ./node_modules/d3-fetch/src/index.js + 7 modules
var d3_fetch_src = __webpack_require__("b2e9");

// EXTERNAL MODULE: ./node_modules/d3-force/src/index.js + 11 modules
var d3_force_src = __webpack_require__("0a4a");

// EXTERNAL MODULE: ./node_modules/d3-format/src/index.js
var d3_format_src = __webpack_require__("ad68");

// EXTERNAL MODULE: ./node_modules/d3-geo/src/index.js + 57 modules
var d3_geo_src = __webpack_require__("9fc0");

// EXTERNAL MODULE: ./node_modules/d3-hierarchy/src/index.js + 32 modules
var d3_hierarchy_src = __webpack_require__("c947");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/index.js + 6 modules
var d3_interpolate_src = __webpack_require__("a43d");

// EXTERNAL MODULE: ./node_modules/d3-path/src/index.js
var d3_path_src = __webpack_require__("f37c");

// EXTERNAL MODULE: ./node_modules/d3-polygon/src/index.js + 6 modules
var d3_polygon_src = __webpack_require__("b548");

// EXTERNAL MODULE: ./node_modules/d3-quadtree/src/index.js
var d3_quadtree_src = __webpack_require__("80ef");

// EXTERNAL MODULE: ./node_modules/d3-random/src/index.js + 19 modules
var d3_random_src = __webpack_require__("ecc4");

// EXTERNAL MODULE: ./node_modules/d3-scale/src/index.js + 22 modules
var d3_scale_src = __webpack_require__("ce24");

// EXTERNAL MODULE: ./node_modules/d3-scale-chromatic/src/index.js + 45 modules
var d3_scale_chromatic_src = __webpack_require__("a1eb");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/index.js + 4 modules
var d3_selection_src = __webpack_require__("fd32");

// EXTERNAL MODULE: ./node_modules/d3-shape/src/index.js + 51 modules
var d3_shape_src = __webpack_require__("f1df");

// EXTERNAL MODULE: ./node_modules/d3-time/src/index.js
var d3_time_src = __webpack_require__("b607");

// EXTERNAL MODULE: ./node_modules/d3-time-format/src/index.js + 2 modules
var d3_time_format_src = __webpack_require__("70e1");

// EXTERNAL MODULE: ./node_modules/d3-timer/src/index.js + 1 modules
var d3_timer_src = __webpack_require__("b5ae");

// EXTERNAL MODULE: ./node_modules/d3-transition/src/index.js + 28 modules
var d3_transition_src = __webpack_require__("b108");

// EXTERNAL MODULE: ./node_modules/d3-zoom/src/index.js + 5 modules
var d3_zoom_src = __webpack_require__("d934");

// CONCATENATED MODULE: ./node_modules/@usafacts/frontend-library-metrics/node_modules/d3/index.js

































/***/ }),

/***/ "4b79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ interpolateTransformCss; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ interpolateTransformSvg; });

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/number.js
var number = __webpack_require__("e317");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/decompose.js
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ var decompose = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/parse.js


var svgNode;

/* eslint-disable no-undef */
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? identity : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}

function parseSvg(value) {
  if (value == null) return identity;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/index.js



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(number["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(number["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(number["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(number["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(number["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(number["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");


/***/ }),

/***/ "4bcd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _basis_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c84a");


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(_basis_js__WEBPACK_IMPORTED_MODULE_0__[/* basis */ "a"])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),

/***/ "4c23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLocale; });
/* harmony import */ var _locale_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a591");


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(_locale_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),

/***/ "4c7e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4cfe":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e14":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4f50":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("b760"),
    cloneBuffer = __webpack_require__("e5383"),
    cloneTypedArray = __webpack_require__("c8fe"),
    copyArray = __webpack_require__("4359"),
    initCloneObject = __webpack_require__("fa21"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isArrayLikeObject = __webpack_require__("dcbe"),
    isBuffer = __webpack_require__("0d24"),
    isFunction = __webpack_require__("9520"),
    isObject = __webpack_require__("1a8c"),
    isPlainObject = __webpack_require__("60ed"),
    isTypedArray = __webpack_require__("73ac"),
    safeGet = __webpack_require__("8adb"),
    toPlainObject = __webpack_require__("8de2");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "4fd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(event) {
  let sourceEvent;
  while (sourceEvent = event.sourceEvent) event = sourceEvent;
  return event;
});


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "50d8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "50e2":
/***/ (function(module, exports, __webpack_require__) {


/* parser generated by jison 0.6.1-215 */

/*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */

        
    
            var parser = (function () {


// See also:
// http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
// but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
// with userland code which might access the derived class in a 'classic' way.
function JisonParserError(msg, hash) {
    Object.defineProperty(this, 'name', {
        enumerable: false,
        writable: false,
        value: 'JisonParserError'
    });

    if (msg == null) msg = '???';

    Object.defineProperty(this, 'message', {
        enumerable: false,
        writable: true,
        value: msg
    });

    this.hash = hash;

    var stacktrace;
    if (hash && hash.exception instanceof Error) {
        var ex2 = hash.exception;
        this.message = ex2.message || msg;
        stacktrace = ex2.stack;
    }
    if (!stacktrace) {
        if (Error.hasOwnProperty('captureStackTrace')) {        // V8/Chrome engine
            Error.captureStackTrace(this, this.constructor);
        } else {
            stacktrace = (new Error(msg)).stack;
        }
    }
    if (stacktrace) {
        Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
}

if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
} else {
    JisonParserError.prototype = Object.create(Error.prototype);
}
JisonParserError.prototype.constructor = JisonParserError;
JisonParserError.prototype.name = 'JisonParserError';




        // helper: reconstruct the productions[] table
        function bp(s) {
            var rv = [];
            var p = s.pop;
            var r = s.rule;
            for (var i = 0, l = p.length; i < l; i++) {
                rv.push([
                    p[i],
                    r[i]
                ]);
            }
            return rv;
        }
    


        // helper: reconstruct the defaultActions[] table
        function bda(s) {
            var rv = {};
            var d = s.idx;
            var g = s.goto;
            for (var i = 0, l = d.length; i < l; i++) {
                var j = d[i];
                rv[j] = g[i];
            }
            return rv;
        }
    


        // helper: reconstruct the 'goto' table
        function bt(s) {
            var rv = [];
            var d = s.len;
            var y = s.symbol;
            var t = s.type;
            var a = s.state;
            var m = s.mode;
            var g = s.goto;
            for (var i = 0, l = d.length; i < l; i++) {
                var n = d[i];
                var q = {};
                for (var j = 0; j < n; j++) {
                    var z = y.shift();
                    switch (t.shift()) {
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;

                    case 0:
                        q[z] = a.shift();
                        break;

                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                    }
                }
                rv.push(q);
            }
            return rv;
        }
    


        // helper: runlength encoding with increment step: code, length: step (default step = 0)
        // `this` references an array
        function s(c, l, a) {
            a = a || 0;
            for (var i = 0; i < l; i++) {
                this.push(c);
                c += a;
            }
        }

        // helper: duplicate sequence from *relative* offset and length.
        // `this` references an array
        function c(i, l) {
            i = this.length - i;
            for (l += i; i < l; i++) {
                this.push(this[i]);
            }
        }

        // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
        function u(a) {
            var rv = [];
            for (var i = 0, l = a.length; i < l; i++) {
                var e = a[i];
                // Is this entry a helper function?
                if (typeof e === 'function') {
                    i++;
                    e.apply(rv, a[i]);
                } else {
                    rv.push(e);
                }
            }
            return rv;
        }
    

var parser = {
    // Code Generator Information Report
    // ---------------------------------
    //
    // Options:
    //
    //   default action mode: ............. ["classic","merge"]
    //   test-compile action mode: ........ "parser:*,lexer:*"
    //   try..catch: ...................... true
    //   default resolve on conflict: ..... true
    //   on-demand look-ahead: ............ false
    //   error recovery token skip maximum: 3
    //   yyerror in parse actions is: ..... NOT recoverable,
    //   yyerror in lexer actions and other non-fatal lexer are:
    //   .................................. NOT recoverable,
    //   debug grammar/output: ............ false
    //   has partial LR conflict upgrade:   true
    //   rudimentary token-stack support:   false
    //   parser table compression mode: ... 2
    //   export debug tables: ............. false
    //   export *all* tables: ............. false
    //   module type: ..................... commonjs
    //   parser engine type: .............. lalr
    //   output main() in the module: ..... true
    //   has user-specified main(): ....... false
    //   has user-specified require()/import modules for main():
    //   .................................. false
    //   number of expected conflicts: .... 0
    //
    //
    // Parser Analysis flags:
    //
    //   no significant actions (parser is a language matcher only):
    //   .................................. false
    //   uses yyleng: ..................... false
    //   uses yylineno: ................... false
    //   uses yytext: ..................... false
    //   uses yylloc: ..................... false
    //   uses ParseError API: ............. false
    //   uses YYERROR: .................... false
    //   uses YYRECOVERING: ............... false
    //   uses YYERROK: .................... false
    //   uses YYCLEARIN: .................. false
    //   tracks rule values: .............. true
    //   assigns rule values: ............. true
    //   uses location tracking: .......... false
    //   assigns location: ................ false
    //   uses yystack: .................... false
    //   uses yysstack: ................... false
    //   uses yysp: ....................... true
    //   uses yyrulelength: ............... false
    //   uses yyMergeLocationInfo API: .... false
    //   has error recovery: .............. false
    //   has error reporting: ............. false
    //
    // --------- END OF REPORT -----------

trace: function no_op_trace() { },
JisonParserError: JisonParserError,
yy: {},
options: {
  type: "lalr",
  hasPartialLrUpgradeOnConflict: true,
  errorRecoveryTokenDiscardCount: 3
},
symbols_: {
  "$accept": 0,
  "$end": 1,
  "ADD": 3,
  "ANGLE": 14,
  "CHS": 20,
  "CSS_VAR": 12,
  "DIV": 6,
  "EMS": 18,
  "EOF": 1,
  "EXS": 19,
  "FREQ": 16,
  "LENGTH": 13,
  "LPAREN": 7,
  "MUL": 5,
  "NESTED_CALC": 9,
  "NUMBER": 11,
  "PERCENTAGE": 26,
  "PREFIX": 10,
  "REMS": 21,
  "RES": 17,
  "RPAREN": 8,
  "SUB": 4,
  "TIME": 15,
  "VHS": 22,
  "VMAXS": 25,
  "VMINS": 24,
  "VWS": 23,
  "css_value": 31,
  "css_variable": 30,
  "error": 2,
  "expression": 27,
  "math_expression": 28,
  "value": 29
},
terminals_: {
  1: "EOF",
  2: "error",
  3: "ADD",
  4: "SUB",
  5: "MUL",
  6: "DIV",
  7: "LPAREN",
  8: "RPAREN",
  9: "NESTED_CALC",
  10: "PREFIX",
  11: "NUMBER",
  12: "CSS_VAR",
  13: "LENGTH",
  14: "ANGLE",
  15: "TIME",
  16: "FREQ",
  17: "RES",
  18: "EMS",
  19: "EXS",
  20: "CHS",
  21: "REMS",
  22: "VHS",
  23: "VWS",
  24: "VMINS",
  25: "VMAXS",
  26: "PERCENTAGE"
},
TERROR: 2,
    EOF: 1,

    // internals: defined here so the object *structure* doesn't get modified by parse() et al,
    // thus helping JIT compilers like Chrome V8.
    originalQuoteName: null,
    originalParseError: null,
    cleanupAfterParse: null,
    constructParseErrorInfo: null,
    yyMergeLocationInfo: null,

    __reentrant_call_depth: 0,      // INTERNAL USE ONLY
    __error_infos: [],              // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
    __error_recovery_infos: [],     // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup

    // APIs which will be set up depending on user action code analysis:
    //yyRecovering: 0,
    //yyErrOk: 0,
    //yyClearIn: 0,

    // Helper APIs
    // -----------

    // Helper function which can be overridden by user code later on: put suitable quotes around
    // literal IDs in a description string.
    quoteName: function parser_quoteName(id_str) {
        return '"' + id_str + '"';
    },

    // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
    //
    // Return NULL when the symbol is unknown to the parser.
    getSymbolName: function parser_getSymbolName(symbol) {
        if (this.terminals_[symbol]) {
            return this.terminals_[symbol];
        }

        // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
        //
        // An example of this may be where a rule's action code contains a call like this:
        //
        //      parser.getSymbolName(#$)
        //
        // to obtain a human-readable name of the current grammar rule.
        var s = this.symbols_;
        for (var key in s) {
            if (s[key] === symbol) {
                return key;
            }
        }
        return null;
    },

    // Return a more-or-less human-readable description of the given symbol, when available,
    // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
    //
    // Return NULL when the symbol is unknown to the parser.
    describeSymbol: function parser_describeSymbol(symbol) {
        if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) {
            return this.terminal_descriptions_[symbol];
        }
        else if (symbol === this.EOF) {
            return 'end of input';
        }
        var id = this.getSymbolName(symbol);
        if (id) {
            return this.quoteName(id);
        }
        return null;
    },

    // Produce a (more or less) human-readable list of expected tokens at the point of failure.
    //
    // The produced list may contain token or token set descriptions instead of the tokens
    // themselves to help turning this output into something that easier to read by humans
    // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
    // expected terminals and nonterminals is produced.
    //
    // The returned list (array) will not contain any duplicate entries.
    collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
        var TERROR = this.TERROR;
        var tokenset = [];
        var check = {};
        // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
        // If so, use that one instead of the less palatable token set.
        if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) {
            return [
                this.state_descriptions_[state]
            ];
        }
        for (var p in this.table[state]) {
            p = +p;
            if (p !== TERROR) {
                var d = do_not_describe ? p : this.describeSymbol(p);
                if (d && !check[d]) {
                    tokenset.push(d);
                    check[d] = true;        // Mark this token description as already mentioned to prevent outputting duplicate entries.
                }
            }
        }
        return tokenset;
    },
productions_: bp({
  pop: u([
  27,
  s,
  [28, 10],
  29,
  29,
  30,
  s,
  [31, 15]
]),
  rule: u([
  2,
  s,
  [3, 5],
  4,
  7,
  s,
  [1, 4],
  2,
  s,
  [1, 15],
  2
])
}),
performAction: function parser__PerformAction(yystate /* action[1] */, yysp, yyvstack) {

          /* this == yyval */

          // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
          var yy = this.yy;
          var yyparser = yy.parser;
          var yylexer = yy.lexer;

          

          switch (yystate) {
case 0:
    /*! Production::    $accept : expression $end */

    // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
    this.$ = yyvstack[yysp - 1];
    // END of default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-)
    break;

case 1:
    /*! Production::    expression : math_expression EOF */

    // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
    this.$ = yyvstack[yysp - 1];
    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
    
    
    return yyvstack[yysp - 1];
    break;

case 2:
    /*! Production::    math_expression : math_expression ADD math_expression */
case 3:
    /*! Production::    math_expression : math_expression SUB math_expression */
case 4:
    /*! Production::    math_expression : math_expression MUL math_expression */
case 5:
    /*! Production::    math_expression : math_expression DIV math_expression */

    this.$ = { type: 'MathExpression', operator: yyvstack[yysp - 1], left: yyvstack[yysp - 2], right: yyvstack[yysp] };
    break;

case 6:
    /*! Production::    math_expression : LPAREN math_expression RPAREN */
case 7:
    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */
case 8:
    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */

    this.$ = yyvstack[yysp - 1];
    break;

case 9:
    /*! Production::    math_expression : css_variable */
case 10:
    /*! Production::    math_expression : css_value */
case 11:
    /*! Production::    math_expression : value */

    this.$ = yyvstack[yysp];
    break;

case 12:
    /*! Production::    value : NUMBER */

    this.$ = { type: 'Value', value: parseFloat(yyvstack[yysp]) };
    break;

case 13:
    /*! Production::    value : SUB NUMBER */

    this.$ = { type: 'Value', value: parseFloat(yyvstack[yysp]) * -1 };
    break;

case 14:
    /*! Production::    css_variable : CSS_VAR */

    this.$ = { type: 'CssVariable', value: yyvstack[yysp] };
    break;

case 15:
    /*! Production::    css_value : LENGTH */

    this.$ = { type: 'LengthValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 16:
    /*! Production::    css_value : ANGLE */

    this.$ = { type: 'AngleValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 17:
    /*! Production::    css_value : TIME */

    this.$ = { type: 'TimeValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 18:
    /*! Production::    css_value : FREQ */

    this.$ = { type: 'FrequencyValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 19:
    /*! Production::    css_value : RES */

    this.$ = { type: 'ResolutionValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 20:
    /*! Production::    css_value : EMS */

    this.$ = { type: 'EmValue', value: parseFloat(yyvstack[yysp]), unit: 'em' };
    break;

case 21:
    /*! Production::    css_value : EXS */

    this.$ = { type: 'ExValue', value: parseFloat(yyvstack[yysp]), unit: 'ex' };
    break;

case 22:
    /*! Production::    css_value : CHS */

    this.$ = { type: 'ChValue', value: parseFloat(yyvstack[yysp]), unit: 'ch' };
    break;

case 23:
    /*! Production::    css_value : REMS */

    this.$ = { type: 'RemValue', value: parseFloat(yyvstack[yysp]), unit: 'rem' };
    break;

case 24:
    /*! Production::    css_value : VHS */

    this.$ = { type: 'VhValue', value: parseFloat(yyvstack[yysp]), unit: 'vh' };
    break;

case 25:
    /*! Production::    css_value : VWS */

    this.$ = { type: 'VwValue', value: parseFloat(yyvstack[yysp]), unit: 'vw' };
    break;

case 26:
    /*! Production::    css_value : VMINS */

    this.$ = { type: 'VminValue', value: parseFloat(yyvstack[yysp]), unit: 'vmin' };
    break;

case 27:
    /*! Production::    css_value : VMAXS */

    this.$ = { type: 'VmaxValue', value: parseFloat(yyvstack[yysp]), unit: 'vmax' };
    break;

case 28:
    /*! Production::    css_value : PERCENTAGE */

    this.$ = { type: 'PercentageValue', value: parseFloat(yyvstack[yysp]), unit: '%' };
    break;

case 29:
    /*! Production::    css_value : SUB css_value */

    var prev = yyvstack[yysp]; prev.value *= -1; this.$ = prev;
    break;

}
},
table: bt({
  len: u([
  24,
  1,
  5,
  23,
  1,
  18,
  s,
  [0, 20],
  s,
  [23, 4],
  c,
  [28, 3],
  0,
  0,
  16,
  6,
  6,
  s,
  [0, 3],
  5,
  1,
  0,
  1,
  23,
  5,
  0
]),
  symbol: u([
  4,
  7,
  9,
  s,
  [11, 21, 1],
  1,
  1,
  s,
  [3, 4, 1],
  c,
  [30, 19],
  c,
  [29, 4],
  7,
  4,
  10,
  11,
  c,
  [22, 14],
  31,
  c,
  [42, 23],
  c,
  [23, 69],
  c,
  [138, 4],
  8,
  c,
  [51, 24],
  4,
  c,
  [137, 15],
  c,
  [184, 5],
  8,
  c,
  [6, 6],
  c,
  [5, 5],
  9,
  7,
  c,
  [87, 28]
]),
  type: u([
  s,
  [2, 19],
  s,
  [0, 5],
  1,
  s,
  [2, 24],
  s,
  [0, 4],
  c,
  [22, 19],
  c,
  [42, 41],
  c,
  [23, 70],
  c,
  [28, 25],
  c,
  [45, 25],
  c,
  [59, 23]
]),
  state: u([
  1,
  2,
  8,
  6,
  7,
  30,
  c,
  [4, 3],
  33,
  36,
  c,
  [5, 3],
  37,
  c,
  [4, 3],
  38,
  c,
  [4, 3],
  39,
  c,
  [4, 3],
  41,
  c,
  [21, 4],
  46,
  c,
  [5, 3]
]),
  mode: u([
  s,
  [1, 177],
  s,
  [2, 3],
  c,
  [5, 5],
  c,
  [6, 4],
  s,
  [1, 31]
]),
  goto: u([
  5,
  3,
  4,
  24,
  s,
  [9, 15, 1],
  s,
  [25, 5, 1],
  c,
  [24, 19],
  31,
  35,
  32,
  34,
  c,
  [18, 14],
  c,
  [37, 19],
  c,
  [19, 57],
  c,
  [117, 4],
  40,
  c,
  [24, 19],
  42,
  35,
  c,
  [16, 14],
  s,
  [2, 3],
  28,
  29,
  2,
  s,
  [3, 3],
  28,
  29,
  3,
  c,
  [52, 4],
  43,
  44,
  45,
  c,
  [78, 23],
  47
])
}),
defaultActions: bda({
  idx: u([
  s,
  [6, 20, 1],
  33,
  34,
  38,
  39,
  40,
  43,
  47
]),
  goto: u([
  9,
  10,
  11,
  s,
  [14, 15, 1],
  12,
  1,
  29,
  13,
  s,
  [4, 5, 1]
])
}),
parseError: function parseError(str, hash, ExceptionClass) {
    if (hash.recoverable) {
        if (typeof this.trace === 'function') {
            this.trace(str);
        }
        hash.destroy();             // destroy... well, *almost*!
    } else {
        if (typeof this.trace === 'function') {
            this.trace(str);
        }
        if (!ExceptionClass) {
            ExceptionClass = this.JisonParserError;
        }
        throw new ExceptionClass(str, hash);
    }
},
parse: function parse(input) {
    var self = this;
    var stack = new Array(128);         // token stack: stores token which leads to state at the same index (column storage)
    var sstack = new Array(128);        // state stack: stores states (column storage)

    var vstack = new Array(128);        // semantic value stack

    var table = this.table;
    var sp = 0;                         // 'stack pointer': index into the stacks


    


    var symbol = 0;



    var TERROR = this.TERROR;
    var EOF = this.EOF;
    var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = (this.options.errorRecoveryTokenDiscardCount | 0) || 3;
    var NO_ACTION = [0, 48 /* === table.length :: ensures that anyone using this new state will fail dramatically! */];

    var lexer;
    if (this.__lexer__) {
        lexer = this.__lexer__;
    } else {
        lexer = this.__lexer__ = Object.create(this.lexer);
    }

    var sharedState_yy = {
        parseError: undefined,
        quoteName: undefined,
        lexer: undefined,
        parser: undefined,
        pre_parse: undefined,
        post_parse: undefined,
        pre_lex: undefined,
        post_lex: undefined      // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
    };

    var ASSERT;
    if (typeof assert !== 'function') {
        ASSERT = function JisonAssert(cond, msg) {
            if (!cond) {
                throw new Error('assertion failed: ' + (msg || '***'));
            }
        };
    } else {
        ASSERT = assert;
    }

    this.yyGetSharedState = function yyGetSharedState() {
        return sharedState_yy;
    };








    function shallow_copy_noclobber(dst, src) {
        for (var k in src) {
            if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) {
                dst[k] = src[k];
            }
        }
    }

    // copy state
    shallow_copy_noclobber(sharedState_yy, this.yy);

    sharedState_yy.lexer = lexer;
    sharedState_yy.parser = this;






    // Does the shared state override the default `parseError` that already comes with this instance?
    if (typeof sharedState_yy.parseError === 'function') {
        this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
            if (!ExceptionClass) {
                ExceptionClass = this.JisonParserError;
            }
            return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
        };
    } else {
        this.parseError = this.originalParseError;
    }

    // Does the shared state override the default `quoteName` that already comes with this instance?
    if (typeof sharedState_yy.quoteName === 'function') {
        this.quoteName = function quoteNameAlt(id_str) {
            return sharedState_yy.quoteName.call(this, id_str);
        };
    } else {
        this.quoteName = this.originalQuoteName;
    }

    // set up the cleanup function; make it an API so that external code can re-use this one in case of
    // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
    // case this parse() API method doesn't come with a `finally { ... }` block any more!
    //
    // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
    //       or else your `sharedState`, etc. references will be *wrong*!
    this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
        var rv;

        if (invoke_post_methods) {
            var hash;

            if (sharedState_yy.post_parse || this.post_parse) {
                // create an error hash info instance: we re-use this API in a **non-error situation**
                // as this one delivers all parser internals ready for access by userland code.
                hash = this.constructParseErrorInfo(null /* no error! */, null /* no exception! */, null, false);
            }

            if (sharedState_yy.post_parse) {
                rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                if (typeof rv !== 'undefined') resultValue = rv;
            }
            if (this.post_parse) {
                rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                if (typeof rv !== 'undefined') resultValue = rv;
            }

            // cleanup:
            if (hash && hash.destroy) {
                hash.destroy();
            }
        }

        if (this.__reentrant_call_depth > 1) return resultValue;        // do not (yet) kill the sharedState when this is a reentrant run.

        // clean up the lingering lexer structures as well:
        if (lexer.cleanupAfterLex) {
            lexer.cleanupAfterLex(do_not_nuke_errorinfos);
        }

        // prevent lingering circular references from causing memory leaks:
        if (sharedState_yy) {
            sharedState_yy.lexer = undefined;
            sharedState_yy.parser = undefined;
            if (lexer.yy === sharedState_yy) {
                lexer.yy = undefined;
            }
        }
        sharedState_yy = undefined;
        this.parseError = this.originalParseError;
        this.quoteName = this.originalQuoteName;

        // nuke the vstack[] array at least as that one will still reference obsoleted user values.
        // To be safe, we nuke the other internal stack columns as well...
        stack.length = 0;               // fastest way to nuke an array without overly bothering the GC
        sstack.length = 0;

        vstack.length = 0;
        sp = 0;

        // nuke the error hash info instances created during this run.
        // Userland code must COPY any data/references
        // in the error hash instance(s) it is more permanently interested in.
        if (!do_not_nuke_errorinfos) {
            for (var i = this.__error_infos.length - 1; i >= 0; i--) {
                var el = this.__error_infos[i];
                if (el && typeof el.destroy === 'function') {
                    el.destroy();
                }
            }
            this.__error_infos.length = 0;


        }

        return resultValue;
    };






































































































































    // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
    //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
    this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
        var pei = {
            errStr: msg,
            exception: ex,
            text: lexer.match,
            value: lexer.yytext,
            token: this.describeSymbol(symbol) || symbol,
            token_id: symbol,
            line: lexer.yylineno,

            expected: expected,
            recoverable: recoverable,
            state: state,
            action: action,
            new_state: newState,
            symbol_stack: stack,
            state_stack: sstack,
            value_stack: vstack,

            stack_pointer: sp,
            yy: sharedState_yy,
            lexer: lexer,
            parser: this,

            // and make sure the error info doesn't stay due to potential
            // ref cycle via userland code manipulations.
            // These would otherwise all be memory leak opportunities!
            //
            // Note that only array and object references are nuked as those
            // constitute the set of elements which can produce a cyclic ref.
            // The rest of the members is kept intact as they are harmless.
            destroy: function destructParseErrorInfo() {
                // remove cyclic references added to error info:
                // info.yy = null;
                // info.lexer = null;
                // info.value = null;
                // info.value_stack = null;
                // ...
                var rec = !!this.recoverable;
                for (var key in this) {
                    if (this.hasOwnProperty(key) && typeof key === 'object') {
                        this[key] = undefined;
                    }
                }
                this.recoverable = rec;
            }
        };
        // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
        this.__error_infos.push(pei);
        return pei;
    };













    function getNonTerminalFromCode(symbol) {
        var tokenName = self.getSymbolName(symbol);
        if (!tokenName) {
            tokenName = symbol;
        }
        return tokenName;
    }


    function stdLex() {
        var token = lexer.lex();
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }

        return token || EOF;
    }

    function fastLex() {
        var token = lexer.fastLex();
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }

        return token || EOF;
    }

    var lex = stdLex;


    var state, action, r, t;
    var yyval = {
        $: true,
        _$: undefined,
        yy: sharedState_yy
    };
    var p;
    var yyrulelen;
    var this_production;
    var newState;
    var retval = false;


    try {
        this.__reentrant_call_depth++;

        lexer.setInput(input, sharedState_yy);

        // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
        // this initial `setInput()` call: hence we can now check and decide
        // whether we'll go with the standard, slower, lex() API or the
        // `fast_lex()` one:
        if (typeof lexer.canIUse === 'function') {
            var lexerInfo = lexer.canIUse();
            if (lexerInfo.fastLex && typeof fastLex === 'function') {
                lex = fastLex;
            }
        } 



        vstack[sp] = null;
        sstack[sp] = 0;
        stack[sp] = 0;
        ++sp;





        if (this.pre_parse) {
            this.pre_parse.call(this, sharedState_yy);
        }
        if (sharedState_yy.pre_parse) {
            sharedState_yy.pre_parse.call(this, sharedState_yy);
        }

        newState = sstack[sp - 1];
        for (;;) {
            // retrieve state number from top of stack
            state = newState;               // sstack[sp - 1];

            // use default actions if available
            if (this.defaultActions[state]) {
                action = 2;
                newState = this.defaultActions[state];
            } else {
                // The single `==` condition below covers both these `===` comparisons in a single
                // operation:
                //
                //     if (symbol === null || typeof symbol === 'undefined') ...
                if (!symbol) {
                    symbol = lex();
                }
                // read action for current state and first input
                t = (table[state] && table[state][symbol]) || NO_ACTION;
                newState = t[1];
                action = t[0];











                // handle parse error
                if (!action) {
                    var errStr;
                    var errSymbolDescr = (this.describeSymbol(symbol) || symbol);
                    var expected = this.collect_expected_token_set(state);

                    // Report error
                    if (typeof lexer.yylineno === 'number') {
                        errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                    } else {
                        errStr = 'Parse error: ';
                    }
                    if (typeof lexer.showPosition === 'function') {
                        errStr += '\n' + lexer.showPosition(79 - 10, 10) + '\n';
                    }
                    if (expected.length) {
                        errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                    } else {
                        errStr += 'Unexpected ' + errSymbolDescr;
                    }
                    // we cannot recover from the error!
                    p = this.constructParseErrorInfo(errStr, null, expected, false);
                    r = this.parseError(p.errStr, p, this.JisonParserError);
                    if (typeof r !== 'undefined') {
                        retval = r;
                    }
                    break;
                }


            }










            switch (action) {
            // catch misc. parse failures:
            default:
                // this shouldn't happen, unless resolve defaults are off
                if (action instanceof Array) {
                    p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                    r = this.parseError(p.errStr, p, this.JisonParserError);
                    if (typeof r !== 'undefined') {
                        retval = r;
                    }
                    break;
                }
                // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                // or a buggy LUT (LookUp Table):
                p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') {
                    retval = r;
                }
                break;

            // shift:
            case 1:
                stack[sp] = symbol;
                vstack[sp] = lexer.yytext;

                sstack[sp] = newState; // push state

                ++sp;
                symbol = 0;




                // Pick up the lexer details for the current symbol as that one is not 'look-ahead' any more:




                continue;

            // reduce:
            case 2:



                this_production = this.productions_[newState - 1];  // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                yyrulelen = this_production[1];










                r = this.performAction.call(yyval, newState, sp - 1, vstack);

                if (typeof r !== 'undefined') {
                    retval = r;
                    break;
                }

                // pop off stack
                sp -= yyrulelen;

                // don't overwrite the `symbol` variable: use a local var to speed things up:
                var ntsymbol = this_production[0];    // push nonterminal (reduce)
                stack[sp] = ntsymbol;
                vstack[sp] = yyval.$;

                // goto new state = table[STATE][NONTERMINAL]
                newState = table[sstack[sp - 1]][ntsymbol];
                sstack[sp] = newState;
                ++sp;









                continue;

            // accept:
            case 3:
                if (sp !== -2) {
                    retval = true;
                    // Return the `$accept` rule's `$$` result, if available.
                    //
                    // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                    // default, action):
                    //
                    //     $accept: <startSymbol> $end
                    //                  %{ $$ = $1; @$ = @1; %}
                    //
                    // which, combined with the parse kernel's `$accept` state behaviour coded below,
                    // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                    // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                    //
                    // In code:
                    //
                    //                  %{
                    //                      @$ = @1;            // if location tracking support is included
                    //                      if (typeof $1 !== 'undefined')
                    //                          return $1;
                    //                      else
                    //                          return true;           // the default parse result if the rule actions don't produce anything
                    //                  %}
                    sp--;
                    if (typeof vstack[sp] !== 'undefined') {
                        retval = vstack[sp];
                    }
                }
                break;
            }

            // break out of loop: we accept or fail with error
            break;
        }
    } catch (ex) {
        // report exceptions through the parseError callback too, but keep the exception intact
        // if it is a known parser or lexer error which has been thrown by parseError() already:
        if (ex instanceof this.JisonParserError) {
            throw ex;
        }
        else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) {
            throw ex;
        }

        p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
        retval = false;
        r = this.parseError(p.errStr, p, this.JisonParserError);
        if (typeof r !== 'undefined') {
            retval = r;
        }
    } finally {
        retval = this.cleanupAfterParse(retval, true, true);
        this.__reentrant_call_depth--;
    }   // /finally

    return retval;
}
};
parser.originalParseError = parser.parseError;
parser.originalQuoteName = parser.quoteName;
/* lexer generated by jison-lex 0.6.1-215 */

/*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */


var lexer = function() {
  /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */
  function JisonLexerError(msg, hash) {
    Object.defineProperty(this, 'name', {
      enumerable: false,
      writable: false,
      value: 'JisonLexerError'
    });

    if (msg == null)
      msg = '???';

    Object.defineProperty(this, 'message', {
      enumerable: false,
      writable: true,
      value: msg
    });

    this.hash = hash;
    var stacktrace;

    if (hash && hash.exception instanceof Error) {
      var ex2 = hash.exception;
      this.message = ex2.message || msg;
      stacktrace = ex2.stack;
    }

    if (!stacktrace) {
      if (Error.hasOwnProperty('captureStackTrace')) {
        // V8
        Error.captureStackTrace(this, this.constructor);
      } else {
        stacktrace = new Error(msg).stack;
      }
    }

    if (stacktrace) {
      Object.defineProperty(this, 'stack', {
        enumerable: false,
        writable: false,
        value: stacktrace
      });
    }
  }

  if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
  } else {
    JisonLexerError.prototype = Object.create(Error.prototype);
  }

  JisonLexerError.prototype.constructor = JisonLexerError;
  JisonLexerError.prototype.name = 'JisonLexerError';

  var lexer = {
    
// Code Generator Information Report
// ---------------------------------
//
// Options:
//
//   backtracking: .................... false
//   location.ranges: ................. false
//   location line+column tracking: ... true
//
//
// Forwarded Parser Analysis flags:
//
//   uses yyleng: ..................... false
//   uses yylineno: ................... false
//   uses yytext: ..................... false
//   uses yylloc: ..................... false
//   uses lexer values: ............... true / true
//   location tracking: ............... false
//   location assignment: ............. false
//
//
// Lexer Analysis flags:
//
//   uses yyleng: ..................... ???
//   uses yylineno: ................... ???
//   uses yytext: ..................... ???
//   uses yylloc: ..................... ???
//   uses ParseError API: ............. ???
//   uses yyerror: .................... ???
//   uses location tracking & editing:  ???
//   uses more() API: ................. ???
//   uses unput() API: ................ ???
//   uses reject() API: ............... ???
//   uses less() API: ................. ???
//   uses display APIs pastInput(), upcomingInput(), showPosition():
//        ............................. ???
//   uses describeYYLLOC() API: ....... ???
//
// --------- END OF REPORT -----------

EOF: 1,
    ERROR: 2,

    // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator

    // options: {},                             /// <-- injected by the code generator

    // yy: ...,                                 /// <-- injected by setInput()

    __currentRuleSet__: null,                   /// INTERNAL USE ONLY: internal rule set cache for the current lexer state  

    __error_infos: [],                          /// INTERNAL USE ONLY: the set of lexErrorInfo objects created since the last cleanup  
    __decompressed: false,                      /// INTERNAL USE ONLY: mark whether the lexer instance has been 'unfolded' completely and is now ready for use  
    done: false,                                /// INTERNAL USE ONLY  
    _backtrack: false,                          /// INTERNAL USE ONLY  
    _input: '',                                 /// INTERNAL USE ONLY  
    _more: false,                               /// INTERNAL USE ONLY  
    _signaled_error_token: false,               /// INTERNAL USE ONLY  
    conditionStack: [],                         /// INTERNAL USE ONLY; managed via `pushState()`, `popState()`, `topState()` and `stateStackSize()`  
    match: '',                                  /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction. `match` is identical to `yytext` except that this one still contains the matched input string after `lexer.performAction()` has been invoked, where userland code MAY have changed/replaced the `yytext` value entirely!  
    matched: '',                                /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks entire input which has been matched so far  
    matches: false,                             /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks RE match result for last (successful) match attempt  
    yytext: '',                                 /// ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction; this value is transferred to the parser as the 'token value' when the parser consumes the lexer token produced through a call to the `lex()` API.  
    offset: 0,                                  /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks the 'cursor position' in the input string, i.e. the number of characters matched so far  
    yyleng: 0,                                  /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: length of matched input for the token under construction (`yytext`)  
    yylineno: 0,                                /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: 'line number' at which the token under construction is located  
    yylloc: null,                               /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks location info (lines + columns) for the token under construction  

    /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */
    constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
      msg = '' + msg;

      // heuristic to determine if the error message already contains a (partial) source code dump
      // as produced by either `showPosition()` or `prettyPrintRange()`:
      if (show_input_position == undefined) {
        show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
      }

      if (this.yylloc && show_input_position) {
        if (typeof this.prettyPrintRange === 'function') {
          var pretty_src = this.prettyPrintRange(this.yylloc);

          if (!/\n\s*$/.test(msg)) {
            msg += '\n';
          }

          msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
        } else if (typeof this.showPosition === 'function') {
          var pos_str = this.showPosition();

          if (pos_str) {
            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') {
              msg += '\n' + pos_str;
            } else {
              msg += pos_str;
            }
          }
        }
      }

      /** @constructor */
      var pei = {
        errStr: msg,
        recoverable: !!recoverable,
        text: this.match,           // This one MAY be empty; userland code should use the `upcomingInput` API to obtain more text which follows the 'lexer cursor position'...  
        token: null,
        line: this.yylineno,
        loc: this.yylloc,
        yy: this.yy,
        lexer: this,

        /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */
        destroy: function destructLexErrorInfo() {
          // remove cyclic references added to error info:
          // info.yy = null;
          // info.lexer = null;
          // ...
          var rec = !!this.recoverable;

          for (var key in this) {
            if (this.hasOwnProperty(key) && typeof key === 'object') {
              this[key] = undefined;
            }
          }

          this.recoverable = rec;
        }
      };

      // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
      this.__error_infos.push(pei);

      return pei;
    },

    /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */
    parseError: function lexer_parseError(str, hash, ExceptionClass) {
      if (!ExceptionClass) {
        ExceptionClass = this.JisonLexerError;
      }

      if (this.yy) {
        if (this.yy.parser && typeof this.yy.parser.parseError === 'function') {
          return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
        } else if (typeof this.yy.parseError === 'function') {
          return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
        }
      }

      throw new ExceptionClass(str, hash);
    },

    /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */
    yyerror: function yyError(str /*, ...args */) {
      var lineno_msg = '';

      if (this.yylloc) {
        lineno_msg = ' on line ' + (this.yylineno + 1);
      }

      var p = this.constructLexErrorInfo(
        'Lexical error' + lineno_msg + ': ' + str,
        this.options.lexerErrorsAreRecoverable
      );

      // Add any extra args to the hash under the name `extra_error_attributes`:
      var args = Array.prototype.slice.call(arguments, 1);

      if (args.length) {
        p.extra_error_attributes = args;
      }

      return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
    },

    /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */
    cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
      // prevent lingering circular references from causing memory leaks:
      this.setInput('', {});

      // nuke the error hash info instances created during this run.
      // Userland code must COPY any data/references
      // in the error hash instance(s) it is more permanently interested in.
      if (!do_not_nuke_errorinfos) {
        for (var i = this.__error_infos.length - 1; i >= 0; i--) {
          var el = this.__error_infos[i];

          if (el && typeof el.destroy === 'function') {
            el.destroy();
          }
        }

        this.__error_infos.length = 0;
      }

      return this;
    },

    /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */
    clear: function lexer_clear() {
      this.yytext = '';
      this.yyleng = 0;
      this.match = '';

      // - DO NOT reset `this.matched`
      this.matches = false;

      this._more = false;
      this._backtrack = false;
      var col = (this.yylloc ? this.yylloc.last_column : 0);

      this.yylloc = {
        first_line: this.yylineno + 1,
        first_column: col,
        last_line: this.yylineno + 1,
        last_column: col,
        range: [this.offset, this.offset]
      };
    },

    /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */
    setInput: function lexer_setInput(input, yy) {
      this.yy = yy || this.yy || {};

      // also check if we've fully initialized the lexer instance,
      // including expansion work to be done to go from a loaded
      // lexer to a usable lexer:
      if (!this.__decompressed) {
        // step 1: decompress the regex list:
        var rules = this.rules;

        for (var i = 0, len = rules.length; i < len; i++) {
          var rule_re = rules[i];

          // compression: is the RE an xref to another RE slot in the rules[] table?
          if (typeof rule_re === 'number') {
            rules[i] = rules[rule_re];
          }
        }

        // step 2: unfold the conditions[] set to make these ready for use:
        var conditions = this.conditions;

        for (var k in conditions) {
          var spec = conditions[k];
          var rule_ids = spec.rules;
          var len = rule_ids.length;
          var rule_regexes = new Array(len + 1);             // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
          var rule_new_ids = new Array(len + 1);

          for (var i = 0; i < len; i++) {
            var idx = rule_ids[i];
            var rule_re = rules[idx];
            rule_regexes[i + 1] = rule_re;
            rule_new_ids[i + 1] = idx;
          }

          spec.rules = rule_new_ids;
          spec.__rule_regexes = rule_regexes;
          spec.__rule_count = len;
        }

        this.__decompressed = true;
      }

      this._input = input || '';
      this.clear();
      this._signaled_error_token = false;
      this.done = false;
      this.yylineno = 0;
      this.matched = '';
      this.conditionStack = ['INITIAL'];
      this.__currentRuleSet__ = null;

      this.yylloc = {
        first_line: 1,
        first_column: 0,
        last_line: 1,
        last_column: 0,
        range: [0, 0]
      };

      this.offset = 0;
      return this;
    },

    /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */
    editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
      var rv = callback.call(this, this._input, cpsArg);

      if (typeof rv !== 'string') {
        if (rv) {
          this._input = '' + rv;
        } 
        // else: keep `this._input` as is.  
      } else {
        this._input = rv;
      }

      return this;
    },

    /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */
    input: function lexer_input() {
      if (!this._input) {
        //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
        return null;
      }

      var ch = this._input[0];
      this.yytext += ch;
      this.yyleng++;
      this.offset++;
      this.match += ch;
      this.matched += ch;

      // Count the linenumber up when we hit the LF (or a stand-alone CR).
      // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
      // and we advance immediately past the LF as well, returning both together as if
      // it was all a single 'character' only.
      var slice_len = 1;

      var lines = false;

      if (ch === '\n') {
        lines = true;
      } else if (ch === '\r') {
        lines = true;
        var ch2 = this._input[1];

        if (ch2 === '\n') {
          slice_len++;
          ch += ch2;
          this.yytext += ch2;
          this.yyleng++;
          this.offset++;
          this.match += ch2;
          this.matched += ch2;
          this.yylloc.range[1]++;
        }
      }

      if (lines) {
        this.yylineno++;
        this.yylloc.last_line++;
        this.yylloc.last_column = 0;
      } else {
        this.yylloc.last_column++;
      }

      this.yylloc.range[1]++;
      this._input = this._input.slice(slice_len);
      return ch;
    },

    /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */
    unput: function lexer_unput(ch) {
      var len = ch.length;
      var lines = ch.split(/(?:\r\n?|\n)/g);
      this._input = ch + this._input;
      this.yytext = this.yytext.substr(0, this.yytext.length - len);
      this.yyleng = this.yytext.length;
      this.offset -= len;
      this.match = this.match.substr(0, this.match.length - len);
      this.matched = this.matched.substr(0, this.matched.length - len);

      if (lines.length > 1) {
        this.yylineno -= lines.length - 1;
        this.yylloc.last_line = this.yylineno + 1;

        // Get last entirely matched line into the `pre_lines[]` array's
        // last index slot; we don't mind when other previously 
        // matched lines end up in the array too. 
        var pre = this.match;

        var pre_lines = pre.split(/(?:\r\n?|\n)/g);

        if (pre_lines.length === 1) {
          pre = this.matched;
          pre_lines = pre.split(/(?:\r\n?|\n)/g);
        }

        this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
      } else {
        this.yylloc.last_column -= len;
      }

      this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
      this.done = false;
      return this;
    },

    /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */
    more: function lexer_more() {
      this._more = true;
      return this;
    },

    /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */
    reject: function lexer_reject() {
      if (this.options.backtrack_lexer) {
        this._backtrack = true;
      } else {
        // when the `parseError()` call returns, we MUST ensure that the error is registered.
        // We accomplish this by signaling an 'error' token to be produced for the current
        // `.lex()` run.
        var lineno_msg = '';

        if (this.yylloc) {
          lineno_msg = ' on line ' + (this.yylineno + 1);
        }

        var p = this.constructLexErrorInfo(
          'Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).',
          false
        );

        this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
      }

      return this;
    },

    /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */
    less: function lexer_less(n) {
      return this.unput(this.match.slice(n));
    },

    /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */
    pastInput: function lexer_pastInput(maxSize, maxLines) {
      var past = this.matched.substring(0, this.matched.length - this.match.length);

      if (maxSize < 0)
        maxSize = past.length;
      else if (!maxSize)
        maxSize = 20;

      if (maxLines < 0)
        maxLines = past.length;          // can't ever have more input lines than this! 
      else if (!maxLines)
        maxLines = 1;

      // `substr` anticipation: treat \r\n as a single character and take a little
      // more than necessary so that we can still properly check against maxSize
      // after we've transformed and limited the newLines in here:
      past = past.substr(-maxSize * 2 - 2);

      // now that we have a significantly reduced string to process, transform the newlines
      // and chop them, then limit them:
      var a = past.replace(/\r\n|\r/g, '\n').split('\n');

      a = a.slice(-maxLines);
      past = a.join('\n');

      // When, after limiting to maxLines, we still have too much to return,
      // do add an ellipsis prefix...
      if (past.length > maxSize) {
        past = '...' + past.substr(-maxSize);
      }

      return past;
    },

    /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */
    upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
      var next = this.match;

      if (maxSize < 0)
        maxSize = next.length + this._input.length;
      else if (!maxSize)
        maxSize = 20;

      if (maxLines < 0)
        maxLines = maxSize;          // can't ever have more input lines than this! 
      else if (!maxLines)
        maxLines = 1;

      // `substring` anticipation: treat \r\n as a single character and take a little
      // more than necessary so that we can still properly check against maxSize
      // after we've transformed and limited the newLines in here:
      if (next.length < maxSize * 2 + 2) {
        next += this._input.substring(0, maxSize * 2 + 2);   // substring is faster on Chrome/V8 
      }

      // now that we have a significantly reduced string to process, transform the newlines
      // and chop them, then limit them:
      var a = next.replace(/\r\n|\r/g, '\n').split('\n');

      a = a.slice(0, maxLines);
      next = a.join('\n');

      // When, after limiting to maxLines, we still have too much to return,
      // do add an ellipsis postfix...
      if (next.length > maxSize) {
        next = next.substring(0, maxSize) + '...';
      }

      return next;
    },

    /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */
    showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
      var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
      var c = new Array(pre.length + 1).join('-');
      return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
    },

    /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */
    deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
      var loc = {
        first_line: 1,
        first_column: 0,
        last_line: 1,
        last_column: 0,
        range: [0, 0]
      };

      if (actual) {
        loc.first_line = actual.first_line | 0;
        loc.last_line = actual.last_line | 0;
        loc.first_column = actual.first_column | 0;
        loc.last_column = actual.last_column | 0;

        if (actual.range) {
          loc.range[0] = actual.range[0] | 0;
          loc.range[1] = actual.range[1] | 0;
        }
      }

      if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
        // plan B: heuristic using preceding and following:
        if (loc.first_line <= 0 && preceding) {
          loc.first_line = preceding.last_line | 0;
          loc.first_column = preceding.last_column | 0;

          if (preceding.range) {
            loc.range[0] = actual.range[1] | 0;
          }
        }

        if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
          loc.last_line = following.first_line | 0;
          loc.last_column = following.first_column | 0;

          if (following.range) {
            loc.range[1] = actual.range[0] | 0;
          }
        }

        // plan C?: see if the 'current' location is useful/sane too:
        if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
          loc.first_line = current.first_line | 0;
          loc.first_column = current.first_column | 0;

          if (current.range) {
            loc.range[0] = current.range[0] | 0;
          }
        }

        if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
          loc.last_line = current.last_line | 0;
          loc.last_column = current.last_column | 0;

          if (current.range) {
            loc.range[1] = current.range[1] | 0;
          }
        }
      }

      // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
      // or plan D heuristics to produce a 'sensible' last_line value:
      if (loc.last_line <= 0) {
        if (loc.first_line <= 0) {
          loc.first_line = this.yylloc.first_line;
          loc.last_line = this.yylloc.last_line;
          loc.first_column = this.yylloc.first_column;
          loc.last_column = this.yylloc.last_column;
          loc.range[0] = this.yylloc.range[0];
          loc.range[1] = this.yylloc.range[1];
        } else {
          loc.last_line = this.yylloc.last_line;
          loc.last_column = this.yylloc.last_column;
          loc.range[1] = this.yylloc.range[1];
        }
      }

      if (loc.first_line <= 0) {
        loc.first_line = loc.last_line;
        loc.first_column = 0;  // loc.last_column; 
        loc.range[1] = loc.range[0];
      }

      if (loc.first_column < 0) {
        loc.first_column = 0;
      }

      if (loc.last_column < 0) {
        loc.last_column = (loc.first_column > 0 ? loc.first_column : 80);
      }

      return loc;
    },

    /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */
    prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
      loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
      const CONTEXT = 3;
      const CONTEXT_TAIL = 1;
      const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
      var input = this.matched + this._input;
      var lines = input.split('\n');
      var l0 = Math.max(1, (context_loc ? context_loc.first_line : loc.first_line - CONTEXT));
      var l1 = Math.max(1, (context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL));
      var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
      var ws_prefix = new Array(lineno_display_width).join(' ');
      var nonempty_line_indexes = [];

      var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
        var lno = index + l0;
        var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
        var rv = lno_pfx + ': ' + line;
        var errpfx = new Array(lineno_display_width + 1).join('^');
        var offset = 2 + 1;
        var len = 0;

        if (lno === loc.first_line) {
          offset += loc.first_column;

          len = Math.max(
            2,
            ((lno === loc.last_line ? loc.last_column : line.length)) - loc.first_column + 1
          );
        } else if (lno === loc.last_line) {
          len = Math.max(2, loc.last_column + 1);
        } else if (lno > loc.first_line && lno < loc.last_line) {
          len = Math.max(2, line.length + 1);
        }

        if (len) {
          var lead = new Array(offset).join('.');
          var mark = new Array(len).join('^');
          rv += '\n' + errpfx + lead + mark;

          if (line.trim().length > 0) {
            nonempty_line_indexes.push(index);
          }
        }

        rv = rv.replace(/\t/g, ' ');
        return rv;
      });

      // now make sure we don't print an overly large amount of error area: limit it 
      // to the top and bottom line count:
      if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
        var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
        var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
        var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
        intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
        rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
      }

      return rv.join('\n');
    },

    /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */
    describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
      var l1 = yylloc.first_line;
      var l2 = yylloc.last_line;
      var c1 = yylloc.first_column;
      var c2 = yylloc.last_column;
      var dl = l2 - l1;
      var dc = c2 - c1;
      var rv;

      if (dl === 0) {
        rv = 'line ' + l1 + ', ';

        if (dc <= 1) {
          rv += 'column ' + c1;
        } else {
          rv += 'columns ' + c1 + ' .. ' + c2;
        }
      } else {
        rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
      }

      if (yylloc.range && display_range_too) {
        var r1 = yylloc.range[0];
        var r2 = yylloc.range[1] - 1;

        if (r2 <= r1) {
          rv += ' {String Offset: ' + r1 + '}';
        } else {
          rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
        }
      }

      return rv;
    },

    /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */
    test_match: function lexer_test_match(match, indexed_rule) {
      var token, lines, backup, match_str, match_str_len;

      if (this.options.backtrack_lexer) {
        // save context
        backup = {
          yylineno: this.yylineno,

          yylloc: {
            first_line: this.yylloc.first_line,
            last_line: this.yylloc.last_line,
            first_column: this.yylloc.first_column,
            last_column: this.yylloc.last_column,
            range: this.yylloc.range.slice(0)
          },

          yytext: this.yytext,
          match: this.match,
          matches: this.matches,
          matched: this.matched,
          yyleng: this.yyleng,
          offset: this.offset,
          _more: this._more,
          _input: this._input,

          //_signaled_error_token: this._signaled_error_token,
          yy: this.yy,

          conditionStack: this.conditionStack.slice(0),
          done: this.done
        };
      }

      match_str = match[0];
      match_str_len = match_str.length;

      // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
      lines = match_str.split(/(?:\r\n?|\n)/g);

      if (lines.length > 1) {
        this.yylineno += lines.length - 1;
        this.yylloc.last_line = this.yylineno + 1;
        this.yylloc.last_column = lines[lines.length - 1].length;
      } else {
        this.yylloc.last_column += match_str_len;
      }

      // }
      this.yytext += match_str;

      this.match += match_str;
      this.matched += match_str;
      this.matches = match;
      this.yyleng = this.yytext.length;
      this.yylloc.range[1] += match_str_len;

      // previous lex rules MAY have invoked the `more()` API rather than producing a token:
      // those rules will already have moved this `offset` forward matching their match lengths,
      // hence we must only add our own match length now:
      this.offset += match_str_len;

      this._more = false;
      this._backtrack = false;
      this._input = this._input.slice(match_str_len);

      // calling this method:
      //
      //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
      token = this.performAction.call(
        this,
        this.yy,
        indexed_rule,
        this.conditionStack[this.conditionStack.length - 1] /* = YY_START */
      );

      // otherwise, when the action codes are all simple return token statements:
      //token = this.simpleCaseActionClusters[indexed_rule];

      if (this.done && this._input) {
        this.done = false;
      }

      if (token) {
        return token;
      } else if (this._backtrack) {
        // recover context
        for (var k in backup) {
          this[k] = backup[k];
        }

        this.__currentRuleSet__ = null;
        return false;  // rule action called reject() implying the next rule should be tested instead. 
      } else if (this._signaled_error_token) {
        // produce one 'error' token as `.parseError()` in `reject()`
        // did not guarantee a failure signal by throwing an exception!
        token = this._signaled_error_token;

        this._signaled_error_token = false;
        return token;
      }

      return false;
    },

    /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */
    next: function lexer_next() {
      if (this.done) {
        this.clear();
        return this.EOF;
      }

      if (!this._input) {
        this.done = true;
      }

      var token, match, tempMatch, index;

      if (!this._more) {
        this.clear();
      }

      var spec = this.__currentRuleSet__;

      if (!spec) {
        // Update the ruleset cache as we apparently encountered a state change or just started lexing.
        // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
        // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
        // speed up those activities a tiny bit.
        spec = this.__currentRuleSet__ = this._currentRules();

        // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
        // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
        if (!spec || !spec.rules) {
          var lineno_msg = '';

          if (this.options.trackPosition) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo(
            'Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!',
            false
          );

          // produce one 'error' token until this situation has been resolved, most probably by parse termination!
          return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
        }
      }

      var rule_ids = spec.rules;
      var regexes = spec.__rule_regexes;
      var len = spec.__rule_count;

      // Note: the arrays are 1-based, while `len` itself is a valid index,
      // hence the non-standard less-or-equal check in the next loop condition!
      for (var i = 1; i <= len; i++) {
        tempMatch = this._input.match(regexes[i]);

        if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
          match = tempMatch;
          index = i;

          if (this.options.backtrack_lexer) {
            token = this.test_match(tempMatch, rule_ids[i]);

            if (token !== false) {
              return token;
            } else if (this._backtrack) {
              match = undefined;
              continue;  // rule action called reject() implying a rule MISmatch. 
            } else {
              // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
              return false;
            }
          } else if (!this.options.flex) {
            break;
          }
        }
      }

      if (match) {
        token = this.test_match(match, rule_ids[index]);

        if (token !== false) {
          return token;
        }

        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
        return false;
      }

      if (!this._input) {
        this.done = true;
        this.clear();
        return this.EOF;
      } else {
        var lineno_msg = '';

        if (this.options.trackPosition) {
          lineno_msg = ' on line ' + (this.yylineno + 1);
        }

        var p = this.constructLexErrorInfo(
          'Lexical error' + lineno_msg + ': Unrecognized text.',
          this.options.lexerErrorsAreRecoverable
        );

        var pendingInput = this._input;
        var activeCondition = this.topState();
        var conditionStackDepth = this.conditionStack.length;
        token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;

        if (token === this.ERROR) {
          // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
          // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
          // has not consumed/modified any pending input or changed state in the error handler:
          if (!this.matches && // and make sure the input has been modified/consumed ...
          pendingInput === this._input && // ...or the lexer state has been modified significantly enough
          // to merit a non-consuming error handling action right now.
          activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) {
            this.input();
          }
        }

        return token;
      }
    },

    /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */
    lex: function lexer_lex() {
      var r;

      // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
      if (typeof this.pre_lex === 'function') {
        r = this.pre_lex.call(this, 0);
      }

      if (typeof this.options.pre_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.options.pre_lex.call(this, r) || r;
      }

      if (this.yy && typeof this.yy.pre_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.yy.pre_lex.call(this, r) || r;
      }

      while (!r) {
        r = this.next();
      }

      if (this.yy && typeof this.yy.post_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.yy.post_lex.call(this, r) || r;
      }

      if (typeof this.options.post_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.options.post_lex.call(this, r) || r;
      }

      if (typeof this.post_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.post_lex.call(this, r) || r;
      }

      return r;
    },

    /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */
    fastLex: function lexer_fastLex() {
      var r;

      while (!r) {
        r = this.next();
      }

      return r;
    },

    /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */
    canIUse: function lexer_canIUse() {
      var rv = {
        fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
      };

      return rv;
    },

    /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */
    begin: function lexer_begin(condition) {
      return this.pushState(condition);
    },

    /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */
    pushState: function lexer_pushState(condition) {
      this.conditionStack.push(condition);
      this.__currentRuleSet__ = null;
      return this;
    },

    /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */
    popState: function lexer_popState() {
      var n = this.conditionStack.length - 1;

      if (n > 0) {
        this.__currentRuleSet__ = null;
        return this.conditionStack.pop();
      } else {
        return this.conditionStack[0];
      }
    },

    /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */
    topState: function lexer_topState(n) {
      n = this.conditionStack.length - 1 - Math.abs(n || 0);

      if (n >= 0) {
        return this.conditionStack[n];
      } else {
        return 'INITIAL';
      }
    },

    /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */
    _currentRules: function lexer__currentRules() {
      if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
        return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
      } else {
        return this.conditions['INITIAL'];
      }
    },

    /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */
    stateStackSize: function lexer_stateStackSize() {
      return this.conditionStack.length;
    },

    options: {
      trackPosition: true
    },

    JisonLexerError: JisonLexerError,

    performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
      var yy_ = this;
      var YYSTATE = YY_START;

      switch (yyrulenumber) {
      case 0:
        /*! Conditions:: INITIAL */
        /*! Rule::       \s+ */
        /* skip whitespace */
        break;

      default:
        return this.simpleCaseActionClusters[yyrulenumber];
      }
    },

    simpleCaseActionClusters: {
      /*! Conditions:: INITIAL */
      /*! Rule::       \* */
      1: 5,

      /*! Conditions:: INITIAL */
      /*! Rule::       \/ */
      2: 6,

      /*! Conditions:: INITIAL */
      /*! Rule::       \+ */
      3: 3,

      /*! Conditions:: INITIAL */
      /*! Rule::       - */
      4: 4,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */
      5: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */
      6: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */
      7: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */
      8: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */
      9: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */
      10: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */
      11: 14,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */
      12: 14,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */
      13: 14,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */
      14: 14,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */
      15: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */
      16: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */
      17: 16,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */
      18: 16,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */
      19: 17,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */
      20: 17,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */
      21: 17,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */
      22: 18,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */
      23: 19,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */
      24: 20,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */
      25: 21,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */
      26: 23,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */
      27: 22,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */
      28: 24,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */
      29: 25,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */
      30: 26,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */
      31: 11,

      /*! Conditions:: INITIAL */
      /*! Rule::       (calc) */
      32: 9,

      /*! Conditions:: INITIAL */
      /*! Rule::       (var\([^\)]*\)) */
      33: 12,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([a-z]+) */
      34: 10,

      /*! Conditions:: INITIAL */
      /*! Rule::       \( */
      35: 7,

      /*! Conditions:: INITIAL */
      /*! Rule::       \) */
      36: 8,

      /*! Conditions:: INITIAL */
      /*! Rule::       $ */
      37: 1
    },

    rules: [
      /*  0: */  /^(?:\s+)/,
      /*  1: */  /^(?:\*)/,
      /*  2: */  /^(?:\/)/,
      /*  3: */  /^(?:\+)/,
      /*  4: */  /^(?:-)/,
      /*  5: */  /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
      /*  6: */  /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
      /*  7: */  /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
      /*  8: */  /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
      /*  9: */  /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
      /* 10: */  /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
      /* 11: */  /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
      /* 12: */  /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
      /* 13: */  /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
      /* 14: */  /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
      /* 15: */  /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
      /* 16: */  /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
      /* 17: */  /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
      /* 18: */  /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
      /* 19: */  /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
      /* 20: */  /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
      /* 21: */  /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
      /* 22: */  /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
      /* 23: */  /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
      /* 24: */  /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
      /* 25: */  /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
      /* 26: */  /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
      /* 27: */  /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
      /* 28: */  /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
      /* 29: */  /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
      /* 30: */  /^(?:(\d+(\.\d*)?|\.\d+)%)/,
      /* 31: */  /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
      /* 32: */  /^(?:(calc))/,
      /* 33: */  /^(?:(var\([^)]*\)))/,
      /* 34: */  /^(?:([a-z]+))/,
      /* 35: */  /^(?:\()/,
      /* 36: */  /^(?:\))/,
      /* 37: */  /^(?:$)/
    ],

    conditions: {
      'INITIAL': {
        rules: [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37
        ],

        inclusive: true
      }
    }
  };

  return lexer;
}();
parser.lexer = lexer;



function Parser() {
  this.yy = {};
}
Parser.prototype = parser;
parser.Parser = Parser;

return new Parser();
})();

        


if (true) {
  exports.parser = parser;
  exports.Parser = parser.Parser;
  exports.parse = function () {
    return parser.parse.apply(parser, arguments);
  };
  
}


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "51de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isNumberArray; });
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
});

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


/***/ }),

/***/ "530a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return degrees; });
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "54eb":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    getSymbols = __webpack_require__("32f4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "55a3":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "55ad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "55f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonths; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");


var utcMonth = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),

/***/ "5626":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return csvParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return csvParseRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csvFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return csvFormatBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return csvFormatRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return csvFormatRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return csvFormatValue; });
/* harmony import */ var _dsv_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3512");


var csv = Object(_dsv_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatBody = csv.formatBody;
var csvFormatRows = csv.formatRows;
var csvFormatRow = csv.formatRow;
var csvFormatValue = csv.formatValue;


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "57a5":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("91e9");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "57f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _namespace_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6cd4");
/* harmony import */ var _namespaces_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e311");



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === _namespaces_js__WEBPACK_IMPORTED_MODULE_1__[/* xhtml */ "b"] && document.documentElement.namespaceURI === _namespaces_js__WEBPACK_IMPORTED_MODULE_1__[/* xhtml */ "b"]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(_namespace_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),

/***/ "5857":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
});


/***/ }),

/***/ "585a":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5878":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return quickselect; });
/* harmony import */ var _ascending_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00fb");


// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare = _ascending_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]) {
  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k - left + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array, k, newLeft, newRight, compare);
    }

    const t = array[k];
    let i = left;
    let j = right;

    swap(array, left, k);
    if (compare(array[right], t) > 0) swap(array, left, right);

    while (i < j) {
      swap(array, i, j), ++i, --j;
      while (compare(array[i], t) < 0) ++i;
      while (compare(array[j], t) > 0) --j;
    }

    if (compare(array[left], t) === 0) swap(array, left, j);
    else ++j, swap(array, j, right);

    if (j <= k) left = j + 1;
    if (k <= j) right = j - 1;
  }
  return array;
}

function swap(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Tabs_vue_vue_type_style_index_0_id_29812017_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4e14");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Tabs_vue_vue_type_style_index_0_id_29812017_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Tabs_vue_vue_type_style_index_0_id_29812017_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Tabs_vue_vue_type_style_index_0_id_29812017_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5b01":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keys = __webpack_require__("ec69");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "5b47":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5b87":
/***/ (function(module, exports) {

var minus = "-".charCodeAt(0);
var plus = "+".charCodeAt(0);
var dot = ".".charCodeAt(0);
var exp = "e".charCodeAt(0);
var EXP = "E".charCodeAt(0);

module.exports = function(value) {
  var pos = 0;
  var length = value.length;
  var dotted = false;
  var sciPos = -1;
  var containsNumber = false;
  var code;

  while (pos < length) {
    code = value.charCodeAt(pos);

    if (code >= 48 && code <= 57) {
      containsNumber = true;
    } else if (code === exp || code === EXP) {
      if (sciPos > -1) {
        break;
      }
      sciPos = pos;
    } else if (code === dot) {
      if (dotted) {
        break;
      }
      dotted = true;
    } else if (code === plus || code === minus) {
      if (pos !== 0) {
        break;
      }
    } else {
      break;
    }

    pos += 1;
  }

  if (sciPos + 1 === pos) pos--;

  return containsNumber
    ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
      }
    : false;
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5d48":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAllConfigs;

var _defaultConfigStub = _interopRequireDefault(__webpack_require__("0906"));

var _featureFlags = __webpack_require__("861a");

var _uniformColorPalette = _interopRequireDefault(__webpack_require__("820a"));

var _extendedSpacingScale = _interopRequireDefault(__webpack_require__("5ed5"));

var _defaultLineHeights = _interopRequireDefault(__webpack_require__("b969"));

var _extendedFontSizeScale = _interopRequireDefault(__webpack_require__("b1fa"));

var _darkModeVariant = _interopRequireDefault(__webpack_require__("aa3a"));

var _standardFontWeights = _interopRequireDefault(__webpack_require__("8000"));

var _additionalBreakpoint = _interopRequireDefault(__webpack_require__("4480"));

var _lodash = __webpack_require__("2ef0");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAllConfigs(config, defaultPresets = [_defaultConfigStub.default]) {
  const configs = (0, _lodash.flatMap)([...(0, _lodash.get)(config, 'presets', defaultPresets)].reverse(), preset => {
    return getAllConfigs(preset, []);
  });
  const features = {
    uniformColorPalette: _uniformColorPalette.default,
    extendedSpacingScale: _extendedSpacingScale.default,
    defaultLineHeights: _defaultLineHeights.default,
    extendedFontSizeScale: _extendedFontSizeScale.default,
    standardFontWeights: _standardFontWeights.default,
    darkModeVariant: _darkModeVariant.default,
    additionalBreakpoint: _additionalBreakpoint.default
  };
  Object.keys(features).forEach(feature => {
    if ((0, _featureFlags.flagEnabled)(config, feature)) {
      configs.unshift(features[feature]);
    }
  });
  return [config, ...configs];
}

/***/ }),

/***/ "5d89":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "5db7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var aFunction = __webpack_require__("1c0b");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flatMap` method
// https://github.com/tc39/proposal-flatMap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A;
    aFunction(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ "5e2e":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("28c9"),
    listCacheDelete = __webpack_require__("69d5"),
    listCacheGet = __webpack_require__("b4c0"),
    listCacheHas = __webpack_require__("fba5"),
    listCacheSet = __webpack_require__("67ca");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "5e81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sourceEvent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fd4");


/* harmony default export */ __webpack_exports__["a"] = (function(event, node) {
  event = Object(_sourceEvent_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(event);
  if (node === undefined) node = event.currentTarget;
  if (node) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      point.x = event.clientX, point.y = event.clientY;
      point = point.matrixTransform(node.getScreenCTM().inverse());
      return [point.x, point.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
});


/***/ }),

/***/ "5ed5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  theme: {
    spacing: {
      px: '1px',
      '0': '0',
      '0.5': '0.125rem',
      '1': '0.25rem',
      '1.5': '0.375rem',
      '2': '0.5rem',
      '2.5': '0.625rem',
      '3': '0.75rem',
      '3.5': '0.875rem',
      '4': '1rem',
      '5': '1.25rem',
      '6': '1.5rem',
      '7': '1.75rem',
      '8': '2rem',
      '9': '2.25rem',
      '10': '2.5rem',
      '11': '2.75rem',
      '12': '3rem',
      '13': '3.25rem',
      '14': '3.5rem',
      '15': '3.75rem',
      '16': '4rem',
      '20': '5rem',
      '24': '6rem',
      '28': '7rem',
      '32': '8rem',
      '36': '9rem',
      '40': '10rem',
      '44': '11rem',
      '48': '12rem',
      '52': '13rem',
      '56': '14rem',
      '60': '15rem',
      '64': '16rem',
      '72': '18rem',
      '80': '20rem',
      '96': '24rem',
      '1/2': '50%',
      '1/3': '33.333333%',
      '2/3': '66.666667%',
      '1/4': '25%',
      '2/4': '50%',
      '3/4': '75%',
      '1/5': '20%',
      '2/5': '40%',
      '3/5': '60%',
      '4/5': '80%',
      '1/6': '16.666667%',
      '2/6': '33.333333%',
      '3/6': '50%',
      '4/6': '66.666667%',
      '5/6': '83.333333%',
      '1/12': '8.333333%',
      '2/12': '16.666667%',
      '3/12': '25%',
      '4/12': '33.333333%',
      '5/12': '41.666667%',
      '6/12': '50%',
      '7/12': '58.333333%',
      '8/12': '66.666667%',
      '9/12': '75%',
      '10/12': '83.333333%',
      '11/12': '91.666667%',
      full: '100%'
    },
    inset: (theme, {
      negative
    }) => ({
      auto: 'auto',
      ...theme('spacing'),
      ...negative(theme('spacing'))
    }),
    minWidth: {
      '0': '0',
      full: '100%',
      min: 'min-content',
      max: 'max-content'
    },
    width: theme => ({
      auto: 'auto',
      ...theme('spacing'),
      screen: '100vw',
      min: 'min-content',
      max: 'max-content'
    }),
    maxWidth: (theme, {
      breakpoints
    }) => ({
      none: 'none',
      '0': '0rem',
      xs: '20rem',
      sm: '24rem',
      md: '28rem',
      lg: '32rem',
      xl: '36rem',
      '2xl': '42rem',
      '3xl': '48rem',
      '4xl': '56rem',
      '5xl': '64rem',
      '6xl': '72rem',
      '7xl': '80rem',
      full: '100%',
      min: 'min-content',
      max: 'max-content',
      ...breakpoints(theme('screens'))
    }),
    maxHeight: theme => ({
      screen: '100vh',
      ...theme('spacing')
    })
  }
};
exports.default = _default;

/***/ }),

/***/ "5edf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return seconds; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var second = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationSecond */ "d"]);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationSecond */ "d"];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),

/***/ "5f8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_brush; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ brushX; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ brushY; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ brushSelection; });

// EXTERNAL MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var dispatch = __webpack_require__("c68f");

// EXTERNAL MODULE: ./node_modules/d3-drag/src/nodrag.js
var nodrag = __webpack_require__("b54f");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/value.js
var value = __webpack_require__("ea1d");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/select.js
var src_select = __webpack_require__("00a5");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/pointer.js
var pointer = __webpack_require__("5e81");

// EXTERNAL MODULE: ./node_modules/d3-transition/src/index.js + 28 modules
var src = __webpack_require__("b108");

// CONCATENATED MODULE: ./node_modules/d3-brush/src/constant.js
/* harmony default export */ var constant = (x => () => x);

// CONCATENATED MODULE: ./node_modules/d3-brush/src/event.js
function BrushEvent(type, {
  sourceEvent,
  target,
  selection,
  mode,
  dispatch
}) {
  Object.defineProperties(this, {
    type: {value: type, enumerable: true, configurable: true},
    sourceEvent: {value: sourceEvent, enumerable: true, configurable: true},
    target: {value: target, enumerable: true, configurable: true},
    selection: {value: selection, enumerable: true, configurable: true},
    mode: {value: mode, enumerable: true, configurable: true},
    _: {value: dispatch}
  });
}

// CONCATENATED MODULE: ./node_modules/d3-brush/src/noevent.js
function nopropagation(event) {
  event.stopImmediatePropagation();
}

/* harmony default export */ var noevent = (function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
});

// CONCATENATED MODULE: ./node_modules/d3-brush/src/brush.js









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

const {abs, max, min} = Math;

function number1(e) {
  return [+e[0], +e[1]];
}

function number2(e) {
  return [number1(e[0]), number1(e[1])];
}

var X = {
  name: "x",
  handles: ["w", "e"].map(brush_type),
  input: function(x, e) { return x == null ? null : [[+x[0], e[0][1]], [+x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(brush_type),
  input: function(y, e) { return y == null ? null : [[e[0][0], +y[0]], [e[1][0], +y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(brush_type),
  input: function(xy) { return xy == null ? null : number2(xy); },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function brush_type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
  return !event.ctrlKey && !event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  if (svg.hasAttribute("viewBox")) {
    svg = svg.viewBox.baseVal;
    return [[svg.x, svg.y], [svg.x + svg.width, svg.y + svg.height]];
  }
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

function defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush_brush(X);
}

function brushY() {
  return brush_brush(Y);
}

/* harmony default export */ var src_brush = (function() {
  return brush_brush(XY);
});

function brush_brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      touchable = defaultTouchable,
      keys = true,
      listeners = Object(dispatch["a" /* default */])("start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([brush_type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(src_select["a" /* default */])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([brush_type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .on("mousedown.brush", started)
      .filter(touchable)
        .on("touchstart.brush", started)
        .on("touchmove.brush", touchmoved)
        .on("touchend.brush touchcancel.brush", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  brush.move = function(group, selection) {
    if (group.tween) {
      group
          .on("start.brush", function(event) { emitter(this, arguments).beforestart().start(event); })
          .on("interrupt.brush end.brush", function(event) { emitter(this, arguments).end(event); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(value["a" /* default */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && selection1 === null ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 !== null && selection1 !== null ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(src["b" /* interrupt */])(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  brush.clear = function(group) {
    brush.move(group, null);
  };

  function redraw() {
    var group = Object(src_select["a" /* default */])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args, clean) {
    var emit = that.__brush.emitter;
    return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
  }

  function Emitter(that, args, clean) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
    this.clean = clean;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function(event, mode) {
      if (this.starting) this.starting = false, this.emit("start", event, mode);
      else this.emit("brush", event);
      return this;
    },
    brush: function(event, mode) {
      this.emit("brush", event, mode);
      return this;
    },
    end: function(event, mode) {
      if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
      return this;
    },
    emit: function(type, event, mode) {
      var d = Object(src_select["a" /* default */])(this.that).datum();
      listeners.call(
        type,
        this.that,
        new BrushEvent(type, {
          sourceEvent: event,
          target: brush,
          selection: dim.output(this.state.selection),
          mode,
          dispatch: listeners
        }),
        d
      );
    }
  };

  function started(event) {
    if (touchending && !event.touches) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = event.target.__data__.type,
        mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (keys && event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx = 0,
        dy = 0,
        moving,
        shifting = signX && signY && keys && event.shiftKey,
        lockX,
        lockY,
        points = Array.from(event.touches || [event], t => {
          const i = t.identifier;
          t = Object(pointer["a" /* default */])(t, that);
          t.point0 = t.slice();
          t.identifier = i;
          return t;
        });

    if (type === "overlay") {
      if (selection) moving = true;
      const pts = [points[0], points[1] || points[0]];
      state.selection = selection = [[
          w0 = dim === Y ? W : min(pts[0][0], pts[1][0]),
          n0 = dim === X ? N : min(pts[0][1], pts[1][1])
        ], [
          e0 = dim === Y ? E : max(pts[0][0], pts[1][0]),
          s0 = dim === X ? S : max(pts[0][1], pts[1][1])
        ]];
      if (points.length > 1) move();
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(src_select["a" /* default */])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    Object(src["b" /* interrupt */])(that);
    var emit = emitter(that, arguments, true).beforestart();

    if (event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = Object(src_select["a" /* default */])(event.view)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);
      if (keys) view
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)

      Object(nodrag["a" /* default */])(event.view);
    }

    redraw.call(that);
    emit.start(event, mode.name);

    function moved(event) {
      for (const p of event.changedTouches || [event]) {
        for (const d of points)
          if (d.identifier === p.identifier) d.cur = Object(pointer["a" /* default */])(p, that);
      }
      if (shifting && !lockX && !lockY && points.length === 1) {
        const point = points[0];
        if (abs(point.cur[0] - point[0]) > abs(point.cur[1] - point[1]))
          lockY = true;
        else
          lockX = true;
      }
      for (const point of points)
        if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
      moving = true;
      noevent(event);
      move(event);
    }

    function move(event) {
      const point = points[0], point0 = point.point0;
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = max(W - w0, min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (points[1]) {
            if (signX) w1 = max(W, min(E, points[0][0])), e1 = max(W, min(E, points[1][0])), signX = 1;
            if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
          } else {
            if (signX < 0) dx = max(W - w0, min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
            else if (signX > 0) dx = max(W - e0, min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
            else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          }
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = max(W, min(E, w0 - dx * signX)), e1 = max(W, min(E, e0 + dx * signX));
          if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush(event, mode.name);
      }
    }

    function ended(event) {
      nopropagation(event);
      if (event.touches) {
        if (event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
      } else {
        Object(nodrag["b" /* yesdrag */])(event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end(event, mode.name);
    }

    function keydowned(event) {
      switch (event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent(event);
    }

    function keyupped(event) {
      switch (event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent(event);
    }
  }

  function touchmoved(event) {
    emitter(this, arguments).moved(event);
  }

  function touchended(event) {
    emitter(this, arguments).ended(event);
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = number2(extent.apply(this, arguments));
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant(number2(_)), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), brush) : filter;
  };

  brush.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), brush) : touchable;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.keyModifiers = function(_) {
    return arguments.length ? (keys = !!_, brush) : keys;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

// CONCATENATED MODULE: ./node_modules/d3-brush/src/index.js



/***/ }),

/***/ "6044":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "60ed":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    getPrototype = __webpack_require__("2dcb"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "62f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lab; });
/* unused harmony export Lab */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hcl; });
/* unused harmony export Hcl */
/* harmony import */ var _define_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("63ad");
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("166a");
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("530a");




// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof _color_js__WEBPACK_IMPORTED_MODULE_1__[/* Rgb */ "b"])) o = Object(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* rgbConvert */ "h"])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Lab, lab, Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "b"])(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* Color */ "a"], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new _color_js__WEBPACK_IMPORTED_MODULE_1__[/* Rgb */ "b"](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * _math_js__WEBPACK_IMPORTED_MODULE_2__[/* degrees */ "a"];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * _math_js__WEBPACK_IMPORTED_MODULE_2__[/* radians */ "b"];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Hcl, hcl, Object(_define_js__WEBPACK_IMPORTED_MODULE_0__[/* extend */ "b"])(_color_js__WEBPACK_IMPORTED_MODULE_1__[/* Color */ "a"], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));


/***/ }),

/***/ "63ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extend; });
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),

/***/ "642a":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("966f"),
    getMatchData = __webpack_require__("3bb4"),
    matchesStrictComparable = __webpack_require__("20ec");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "656b":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("e2e4"),
    toKey = __webpack_require__("f4d6");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6730":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return genericArray; });
/* harmony import */ var _value_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea1d");
/* harmony import */ var _numberArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("51de");



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return (Object(_numberArray_js__WEBPACK_IMPORTED_MODULE_1__[/* isNumberArray */ "b"])(b) ? _numberArray_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"] : genericArray)(a, b);
});

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(_value_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}


/***/ }),

/***/ "6747":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "67ca":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "67cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "694c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {
	stdout: false,
	stderr: false
};


/***/ }),

/***/ "69d5":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6a23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sparkline_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7526");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sparkline_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sparkline_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sparkline_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6ad6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6cd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Explore_vue_vue_type_style_index_0_id_4041c414_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5b47");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Explore_vue_vue_type_style_index_0_id_4041c414_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Explore_vue_vue_type_style_index_0_id_4041c414_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Explore_vue_vue_type_style_index_0_id_4041c414_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6cd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _namespaces_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e311");


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return _namespaces_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].hasOwnProperty(prefix) ? {space: _namespaces_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"][prefix], local: name} : name; // eslint-disable-line no-prototype-builtins
});


/***/ }),

/***/ "6db8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DHAChart_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98e5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DHAChart_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DHAChart_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DHAChart_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6dd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6eb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcDays; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var utcDay = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationDay */ "a"];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "6f6c":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "6fcd":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("50d8"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isIndex = __webpack_require__("c098"),
    isTypedArray = __webpack_require__("73ac");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "6fd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),

/***/ "70e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ defaultLocale["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ defaultLocale["b" /* timeFormat */]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ defaultLocale["c" /* timeParse */]; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ defaultLocale["d" /* utcFormat */]; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ defaultLocale["e" /* utcParse */]; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ locale["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ isoFormat; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ isoParse; });

// EXTERNAL MODULE: ./node_modules/d3-time-format/src/defaultLocale.js
var defaultLocale = __webpack_require__("4c23");

// EXTERNAL MODULE: ./node_modules/d3-time-format/src/locale.js
var locale = __webpack_require__("a591");

// CONCATENATED MODULE: ./node_modules/d3-time-format/src/isoFormat.js


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(defaultLocale["d" /* utcFormat */])(isoSpecifier);

/* harmony default export */ var isoFormat = (formatIso);

// CONCATENATED MODULE: ./node_modules/d3-time-format/src/isoParse.js



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(defaultLocale["e" /* utcParse */])(isoSpecifier);

/* harmony default export */ var isoParse = (parseIso);

// CONCATENATED MODULE: ./node_modules/d3-time-format/src/index.js






/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7165":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "71bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _value_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea1d");


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(_value_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),

/***/ "71d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nopropagation; });
function nopropagation(event) {
  event.stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
});


/***/ }),

/***/ "72af":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("99cd");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "72c4":
/***/ (function(module, exports) {

var conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0/2.54,
        'mm': 96.0/25.4,
        'in': 96,
        'pt': 96.0/72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54/96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54/72.0,
        'pc': 2.54/6.0
    },
    'mm': {
        'px': 25.4/96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4/72.0,
        'pc': 25.4/6.0
    },
    'in': {
        'px': 1.0/96.0,
        'cm': 1.0/2.54,
        'mm': 1.0/25.4,
        'in': 1,
        'pt': 1.0/72.0,
        'pc': 1.0/6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0/2.54,
        'mm': 72.0/25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 6.0/96.0,
        'cm': 6.0/2.54,
        'mm': 6.0/25.4,
        'in': 6,
        'pt': 6.0/72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180/Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400/360,
        'grad': 1,
        'rad': 200/Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI/180,
        'grad': Math.PI/200,
        'rad': 1,
        'turn': Math.PI*2
    },
    'turn': {
        'deg': 1/360,
        'grad': 1/400,
        'rad': 0.5/Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 1/1000
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 1/1000,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0/2.54,
        'dppx': 1/96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54/96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0/2.54,
        'dppx': 1
    }
};

module.exports = function (value, sourceUnit, targetUnit, precision) {
    if (!conversions.hasOwnProperty(targetUnit))
        throw new Error("Cannot convert to " + targetUnit);

    if (!conversions[targetUnit].hasOwnProperty(sourceUnit))
        throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    
    var converted = conversions[targetUnit][sourceUnit] * value;
    
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    
    return converted;
};


/***/ }),

/***/ "72f0":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "73ac":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("743f"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "73d9":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

addToUnscopables('flatMap');


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "742c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return days; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var day = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"]) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationDay */ "a"],
  date => date.getDate() - 1
);

/* harmony default export */ __webpack_exports__["b"] = (day);
var days = day.range;


/***/ }),

/***/ "743f":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isLength = __webpack_require__("b218"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "74f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Timer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return timerFlush; });
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),

/***/ "7526":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7530":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "758c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerTabs_vue_vue_type_style_index_0_id_601b5907_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ba27");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerTabs_vue_vue_type_style_index_0_id_601b5907_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerTabs_vue_vue_type_style_index_0_id_601b5907_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerTabs_vue_vue_type_style_index_0_id_601b5907_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7637":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "764e":
/***/ (function(module, exports, __webpack_require__) {

const conversions = __webpack_require__("3099");

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	const graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	const models = Object.keys(conversions);

	for (let len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	const graph = buildGraph();
	const queue = [fromModel]; // Unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		const current = queue.pop();
		const adjacents = Object.keys(conversions[current]);

		for (let len = adjacents.length, i = 0; i < len; i++) {
			const adjacent = adjacents[i];
			const node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	const path = [graph[toModel].parent, toModel];
	let fn = conversions[graph[toModel].parent][toModel];

	let cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	const graph = deriveBFS(fromModel);
	const conversion = {};

	const models = Object.keys(graph);
	for (let len = models.length, i = 0; i < len; i++) {
		const toModel = models[i];
		const node = graph[toModel];

		if (node.parent === null) {
			// No possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),

/***/ "76dd":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("ce86");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "77ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcYears; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");


var utcYear = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7948":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "79bc":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "7a48":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "7a82":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var objectDefinePropertyModile = __webpack_require__("9bf2");

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),

/***/ "7aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flip = flip;

var _convert = __webpack_require__("2eb7");

var _convert2 = _interopRequireDefault(_convert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce(node, precision) {
  if (node.type === "MathExpression") return reduceMathExpression(node, precision);

  return node;
}

function isEqual(left, right) {
  return left.type === right.type && left.value === right.value;
}

function isValueType(type) {
  switch (type) {
    case 'LengthValue':
    case 'AngleValue':
    case 'TimeValue':
    case 'FrequencyValue':
    case 'ResolutionValue':
    case 'EmValue':
    case 'ExValue':
    case 'ChValue':
    case 'RemValue':
    case 'VhValue':
    case 'VwValue':
    case 'VminValue':
    case 'VmaxValue':
    case 'PercentageValue':
    case 'Value':
      return true;
  }
  return false;
}

function convertMathExpression(node, precision) {
  var nodes = (0, _convert2.default)(node.left, node.right, precision);
  var left = reduce(nodes.left, precision);
  var right = reduce(nodes.right, precision);

  if (left.type === "MathExpression" && right.type === "MathExpression") {

    if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {

      if (isEqual(left.right, right.right)) nodes = (0, _convert2.default)(left.left, right.left, precision);else if (isEqual(left.right, right.left)) nodes = (0, _convert2.default)(left.left, right.right, precision);

      left = reduce(nodes.left, precision);
      right = reduce(nodes.right, precision);
    }
  }

  node.left = left;
  node.right = right;
  return node;
}

function flip(operator) {
  return operator === '+' ? '-' : '+';
}

function flipValue(node) {
  if (isValueType(node.type)) node.value = -node.value;else if (node.type == 'MathExpression') {
    node.left = flipValue(node.left);
    node.right = flipValue(node.right);
  }
  return node;
}

function reduceAddSubExpression(node, precision) {
  var _node = node,
      left = _node.left,
      right = _node.right,
      op = _node.operator;


  if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;

  // something + 0 => something
  // something - 0 => something
  if (right.value === 0) return left;

  // 0 + something => something
  if (left.value === 0 && op === "+") return right;

  // 0 - something => -something
  if (left.value === 0 && op === "-") return flipValue(right);

  // value + value
  // value - value
  if (left.type === right.type && isValueType(left.type)) {
    node = Object.assign({}, left);
    if (op === "+") node.value = left.value + right.value;else node.value = left.value - right.value;
  }

  // value <op> (expr)
  if (isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
    // value + (value + something) => (value + value) + something
    // value + (value - something) => (value + value) - something
    // value - (value + something) => (value - value) - something
    // value - (value - something) => (value - value) + something
    if (left.type === right.left.type) {
      node = Object.assign({}, node);
      node.left = reduce({
        type: 'MathExpression',
        operator: op,
        left: left,
        right: right.left
      }, precision);
      node.right = right.right;
      node.operator = op === '-' ? flip(right.operator) : right.operator;
      return reduce(node, precision);
    }
    // value + (something + value) => (value + value) + something
    // value + (something - value) => (value - value) + something
    // value - (something + value) => (value - value) - something
    // value - (something - value) => (value + value) - something
    else if (left.type === right.right.type) {
        node = Object.assign({}, node);
        node.left = reduce({
          type: 'MathExpression',
          operator: op === '-' ? flip(right.operator) : right.operator,
          left: left,
          right: right.right
        }, precision);
        node.right = right.left;
        return reduce(node, precision);
      }
  }

  // (expr) <op> value
  if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && isValueType(right.type)) {
    // (value + something) + value => (value + value) + something
    // (value - something) + value => (value + value) - something
    // (value + something) - value => (value - value) + something
    // (value - something) - value => (value - value) - something
    if (right.type === left.left.type) {
      node = Object.assign({}, left);
      node.left = reduce({
        type: 'MathExpression',
        operator: op,
        left: left.left,
        right: right
      }, precision);
      return reduce(node, precision);
    }
    // (something + value) + value => something + (value + value)
    // (something - value1) + value2 => something - (value2 - value1)
    // (something + value) - value => something + (value - value)
    // (something - value) - value => something - (value + value)
    else if (right.type === left.right.type) {
        node = Object.assign({}, left);
        if (left.operator === '-') {
          node.right = reduce({
            type: 'MathExpression',
            operator: op === '-' ? '+' : '-',
            left: right,
            right: left.right
          }, precision);
          node.operator = op === '-' ? '-' : '+';
        } else {
          node.right = reduce({
            type: 'MathExpression',
            operator: op,
            left: left.right,
            right: right
          }, precision);
        }
        if (node.right.value < 0) {
          node.right.value *= -1;
          node.operator = node.operator === '-' ? '+' : '-';
        }
        return reduce(node, precision);
      }
  }
  return node;
}

function reduceDivisionExpression(node, precision) {
  if (!isValueType(node.right.type)) return node;

  if (node.right.type !== 'Value') throw new Error('Cannot divide by "' + node.right.unit + '", number expected');

  if (node.right.value === 0) throw new Error('Cannot divide by zero');

  // (expr) / value
  if (node.left.type === 'MathExpression') {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value /= node.right.value;
      node.left.right.value /= node.right.value;
      return reduce(node.left, precision);
    }
    return node;
  }
  // something / value
  else if (isValueType(node.left.type)) {
      node.left.value /= node.right.value;
      return node.left;
    }
  return node;
}

function reduceMultiplicationExpression(node) {
  // (expr) * value
  if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value *= node.right.value;
      node.left.right.value *= node.right.value;
      return node.left;
    }
  }
  // something * value
  else if (isValueType(node.left.type) && node.right.type === 'Value') {
      node.left.value *= node.right.value;
      return node.left;
    }
    // value * (expr)
    else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if (isValueType(node.right.left.type) && isValueType(node.right.right.type)) {
          node.right.left.value *= node.left.value;
          node.right.right.value *= node.left.value;
          return node.right;
        }
      }
      // value * something
      else if (node.left.type === 'Value' && isValueType(node.right.type)) {
          node.right.value *= node.left.value;
          return node.right;
        }
  return node;
}

function reduceMathExpression(node, precision) {
  node = convertMathExpression(node, precision);

  switch (node.operator) {
    case "+":
    case "-":
      return reduceAddSubExpression(node, precision);
    case "/":
      return reduceDivisionExpression(node, precision);
    case "*":
      return reduceMultiplicationExpression(node);
  }
  return node;
}

exports.default = reduce;

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7b83":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("7c64"),
    mapCacheDelete = __webpack_require__("93ed"),
    mapCacheGet = __webpack_require__("2478"),
    mapCacheHas = __webpack_require__("a524"),
    mapCacheSet = __webpack_require__("1fc8");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "7b97":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    equalArrays = __webpack_require__("a2be"),
    equalByTag = __webpack_require__("1c3c"),
    equalObjects = __webpack_require__("b1e5"),
    getTag = __webpack_require__("42a2"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isTypedArray = __webpack_require__("73ac");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "7c64":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("e24b"),
    ListCache = __webpack_require__("5e2e"),
    Map = __webpack_require__("79bc");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7d1f":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("087d"),
    isArray = __webpack_require__("6747");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7dfc":
/***/ (function(module, exports) {

module.exports = function walk(nodes, cb, bubble) {
  var i, max, node, result;

  for (i = 0, max = nodes.length; i < max; i += 1) {
    node = nodes[i];
    if (!bubble) {
      result = cb(node, i, nodes);
    }

    if (
      result !== false &&
      node.type === "function" &&
      Array.isArray(node.nodes)
    ) {
      walk(node.nodes, cb, bubble);
    }

    if (bubble) {
      cb(node, i, nodes);
    }
  }
};


/***/ }),

/***/ "7e64":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e"),
    stackClear = __webpack_require__("efb6"),
    stackDelete = __webpack_require__("2fcc"),
    stackGet = __webpack_require__("802a"),
    stackHas = __webpack_require__("55a3"),
    stackSet = __webpack_require__("d02c");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "7ed2":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "8000":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  theme: {
    fontWeight: {
      thin: '100',
      extralight: '200',
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800',
      black: '900'
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "802a":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "8057":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "808d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "80ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _quadtree_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cfa1");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _quadtree_js__WEBPACK_IMPORTED_MODULE_0__["a"]; });




/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "820a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  theme: {
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      black: '#000000',
      white: '#ffffff',
      gray: {
        '50': '#f9fafb',
        '100': '#f4f5f7',
        '200': '#e5e7eb',
        '300': '#d2d6dc',
        '400': '#9fa6b2',
        '500': '#6b7280',
        '600': '#4b5563',
        '700': '#374151',
        '800': '#252f3f',
        '900': '#161e2e'
      },
      red: {
        '50': '#fdf2f2',
        '100': '#fde8e8',
        '200': '#fbd5d5',
        '300': '#f8b4b4',
        '400': '#f98080',
        '500': '#f05252',
        '600': '#e02424',
        '700': '#c81e1e',
        '800': '#9b1c1c',
        '900': '#771d1d'
      },
      orange: {
        '50': '#fff8f1',
        '100': '#feecdc',
        '200': '#fcd9bd',
        '300': '#fdba8c',
        '400': '#ff8a4c',
        '500': '#ff5a1f',
        '600': '#d03801',
        '700': '#b43403',
        '800': '#8a2c0d',
        '900': '#73230d'
      },
      yellow: {
        '50': '#fdfdea',
        '100': '#fdf6b2',
        '200': '#fce96a',
        '300': '#faca15',
        '400': '#e3a008',
        '500': '#c27803',
        '600': '#9f580a',
        '700': '#8e4b10',
        '800': '#723b13',
        '900': '#633112'
      },
      green: {
        '50': '#f3faf7',
        '100': '#def7ec',
        '200': '#bcf0da',
        '300': '#84e1bc',
        '400': '#31c48d',
        '500': '#0e9f6e',
        '600': '#057a55',
        '700': '#046c4e',
        '800': '#03543f',
        '900': '#014737'
      },
      teal: {
        '50': '#edfafa',
        '100': '#d5f5f6',
        '200': '#afecef',
        '300': '#7edce2',
        '400': '#16bdca',
        '500': '#0694a2',
        '600': '#047481',
        '700': '#036672',
        '800': '#05505c',
        '900': '#014451'
      },
      blue: {
        '50': '#ebf5ff',
        '100': '#e1effe',
        '200': '#c3ddfd',
        '300': '#a4cafe',
        '400': '#76a9fa',
        '500': '#3f83f8',
        '600': '#1c64f2',
        '700': '#1a56db',
        '800': '#1e429f',
        '900': '#233876'
      },
      indigo: {
        '50': '#f0f5ff',
        '100': '#e5edff',
        '200': '#cddbfe',
        '300': '#b4c6fc',
        '400': '#8da2fb',
        '500': '#6875f5',
        '600': '#5850ec',
        '700': '#5145cd',
        '800': '#42389d',
        '900': '#362f78'
      },
      purple: {
        '50': '#f6f5ff',
        '100': '#edebfe',
        '200': '#dcd7fe',
        '300': '#cabffd',
        '400': '#ac94fa',
        '500': '#9061f9',
        '600': '#7e3af2',
        '700': '#6c2bd9',
        '800': '#5521b5',
        '900': '#4a1d96'
      },
      pink: {
        '50': '#fdf2f8',
        '100': '#fce8f3',
        '200': '#fad1e8',
        '300': '#f8b4d9',
        '400': '#f17eb8',
        '500': '#e74694',
        '600': '#d61f69',
        '700': '#bf125d',
        '800': '#99154b',
        '900': '#751a3d'
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "823f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return max; });
function max(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "85a3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chalk = _interopRequireDefault(__webpack_require__("b749"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  info(messages) {
    console.warn('');
    messages.forEach(message => {
      console.warn(_chalk.default.bold.cyan('info'), '-', message);
    });
  },

  warn(messages) {
    console.warn('');
    messages.forEach(message => {
      console.warn(_chalk.default.bold.yellow('warn'), '-', message);
    });
  },

  risk(messages) {
    console.warn('');
    messages.forEach(message => {
      console.warn(_chalk.default.bold.magenta('risk'), '-', message);
    });
  }

};
exports.default = _default;

/***/ }),

/***/ "85e3":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "8604":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("26e8"),
    hasPath = __webpack_require__("e2c0");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "861a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flagEnabled = flagEnabled;
exports.issueFlagNotices = issueFlagNotices;
exports.default = void 0;

var _lodash = _interopRequireDefault(__webpack_require__("2ef0"));

var _chalk = _interopRequireDefault(__webpack_require__("b749"));

var _log = _interopRequireDefault(__webpack_require__("85a3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const featureFlags = {
  future: ['removeDeprecatedGapUtilities', 'purgeLayersByDefault', 'defaultLineHeights', 'standardFontWeights'],
  experimental: ['uniformColorPalette', 'extendedSpacingScale', 'extendedFontSizeScale', 'applyComplexClasses', 'darkModeVariant', 'additionalBreakpoint']
};

function flagEnabled(config, flag) {
  if (featureFlags.future.includes(flag)) {
    return config.future === 'all' || _lodash.default.get(config, ['future', flag], false);
  }

  if (featureFlags.experimental.includes(flag)) {
    return config.experimental === 'all' || _lodash.default.get(config, ['experimental', flag], false);
  }

  return false;
}

function experimentalFlagsEnabled(config) {
  if (config.experimental === 'all') {
    return featureFlags.experimental;
  }

  return Object.keys(_lodash.default.get(config, 'experimental', {})).filter(flag => featureFlags.experimental.includes(flag) && config.experimental[flag]);
}

function futureFlagsAvailable(config) {
  if (config.future === 'all') {
    return [];
  }

  return featureFlags.future.filter(flag => !_lodash.default.has(config, ['future', flag]));
}

function issueFlagNotices(config) {
  if (Object({"NODE_ENV":"production","BASE_URL":"/"}).JEST_WORKER_ID !== undefined) {
    return;
  }

  if (experimentalFlagsEnabled(config).length > 0) {
    const changes = experimentalFlagsEnabled(config).map(s => _chalk.default.yellow(s)).join(', ');

    _log.default.warn([`You have enabled experimental features: ${changes}`, 'Experimental features are not covered by semver, may introduce breaking changes, and can change at any time.']);
  }

  if (futureFlagsAvailable(config).length > 0) {
    const changes = futureFlagsAvailable(config).map(s => _chalk.default.magenta(s)).join(', ');

    _log.default.risk([`There are upcoming breaking changes: ${changes}`, 'We highly recommend opting-in to these changes now to simplify upgrading Tailwind in the future.', 'https://tailwindcss.com/docs/upcoming-changes']);
  }
}

var _default = featureFlags;
exports.default = _default;

/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8627":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return count; });
function count(values, valueof) {
  let count = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count;
      }
    }
  }
  return count;
}


/***/ }),

/***/ "872a":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("3b4a");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "87c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectCenter; });
/* harmony import */ var _ascending_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00fb");
/* harmony import */ var _bisector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2a2d");
/* harmony import */ var _number_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0a20");




const ascendingBisect = Object(_bisector_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ascending_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = Object(_bisector_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_number_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]).center;
/* harmony default export */ __webpack_exports__["d"] = (bisectRight);


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8921":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubicIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cubicOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cubicInOut; });
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8a79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8adb":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "8de2":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keysIn = __webpack_require__("9934");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "8eeb":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("32b3"),
    baseAssignValue = __webpack_require__("872a");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "8fce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardDrawer_vue_vue_type_style_index_0_id_3ace17c3_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("93d6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardDrawer_vue_vue_type_style_index_0_id_3ace17c3_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardDrawer_vue_vue_type_style_index_0_id_3ace17c3_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigCardDrawer_vue_vue_type_style_index_0_id_3ace17c3_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "8ff4":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__("4b4b")):undefined}(window,(function(t){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=51)}([function(t,e,n){t.exports=n(66)()},function(t,e,n){(function(t,r){var i;
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */(function(){var o="Expected a function",a="__lodash_placeholder__",s=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],c="[object Arguments]",l="[object Array]",u="[object Boolean]",d="[object Date]",f="[object Error]",h="[object Function]",p="[object GeneratorFunction]",g="[object Map]",m="[object Number]",y="[object Object]",v="[object RegExp]",b="[object Set]",k="[object String]",w="[object Symbol]",x="[object WeakMap]",A="[object ArrayBuffer]",S="[object DataView]",O="[object Float32Array]",E="[object Float64Array]",M="[object Int8Array]",C="[object Int16Array]",R="[object Int32Array]",j="[object Uint8Array]",I="[object Uint16Array]",B="[object Uint32Array]",D=/\b__p \+= '';/g,T=/\b(__p \+=) '' \+/g,F=/(__e\(.*?\)|\b__t\)) \+\n'';/g,P=/&(?:amp|lt|gt|quot|#39);/g,z=/[&<>"']/g,Q=RegExp(P.source),L=RegExp(z.source),Y=/<%-([\s\S]+?)%>/g,W=/<%([\s\S]+?)%>/g,q=/<%=([\s\S]+?)%>/g,N=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,G=/^\w*$/,J=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,U=/[\\^$.*+?()[\]{}|]/g,K=RegExp(U.source),H=/^\s+/,V=/\s/,Z=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,X=/\{\n\/\* \[wrapped with (.+)\] \*/,_=/,? & /,$=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,tt=/[()=,{}\[\]\/\s]/,et=/\\(\\)?/g,nt=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,rt=/\w*$/,it=/^[-+]0x[0-9a-f]+$/i,ot=/^0b[01]+$/i,at=/^\[object .+?Constructor\]$/,st=/^0o[0-7]+$/i,ct=/^(?:0|[1-9]\d*)$/,lt=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,ut=/($^)/,dt=/['\n\r\u2028\u2029\\]/g,ft="\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",ht="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",pt="[\\ud800-\\udfff]",gt="["+ht+"]",mt="["+ft+"]",yt="\\d+",vt="[\\u2700-\\u27bf]",bt="[a-z\\xdf-\\xf6\\xf8-\\xff]",kt="[^\\ud800-\\udfff"+ht+yt+"\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",wt="\\ud83c[\\udffb-\\udfff]",xt="[^\\ud800-\\udfff]",At="(?:\\ud83c[\\udde6-\\uddff]){2}",St="[\\ud800-\\udbff][\\udc00-\\udfff]",Ot="[A-Z\\xc0-\\xd6\\xd8-\\xde]",Et="(?:"+bt+"|"+kt+")",Mt="(?:"+Ot+"|"+kt+")",Ct="(?:"+mt+"|"+wt+")"+"?",Rt="[\\ufe0e\\ufe0f]?"+Ct+("(?:\\u200d(?:"+[xt,At,St].join("|")+")[\\ufe0e\\ufe0f]?"+Ct+")*"),jt="(?:"+[vt,At,St].join("|")+")"+Rt,It="(?:"+[xt+mt+"?",mt,At,St,pt].join("|")+")",Bt=RegExp("['’]","g"),Dt=RegExp(mt,"g"),Tt=RegExp(wt+"(?="+wt+")|"+It+Rt,"g"),Ft=RegExp([Ot+"?"+bt+"+(?:['’](?:d|ll|m|re|s|t|ve))?(?="+[gt,Ot,"$"].join("|")+")",Mt+"+(?:['’](?:D|LL|M|RE|S|T|VE))?(?="+[gt,Ot+Et,"$"].join("|")+")",Ot+"?"+Et+"+(?:['’](?:d|ll|m|re|s|t|ve))?",Ot+"+(?:['’](?:D|LL|M|RE|S|T|VE))?","\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",yt,jt].join("|"),"g"),Pt=RegExp("[\\u200d\\ud800-\\udfff"+ft+"\\ufe0e\\ufe0f]"),zt=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Qt=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],Lt=-1,Yt={};Yt[O]=Yt[E]=Yt[M]=Yt[C]=Yt[R]=Yt[j]=Yt["[object Uint8ClampedArray]"]=Yt[I]=Yt[B]=!0,Yt[c]=Yt[l]=Yt[A]=Yt[u]=Yt[S]=Yt[d]=Yt[f]=Yt[h]=Yt[g]=Yt[m]=Yt[y]=Yt[v]=Yt[b]=Yt[k]=Yt[x]=!1;var Wt={};Wt[c]=Wt[l]=Wt[A]=Wt[S]=Wt[u]=Wt[d]=Wt[O]=Wt[E]=Wt[M]=Wt[C]=Wt[R]=Wt[g]=Wt[m]=Wt[y]=Wt[v]=Wt[b]=Wt[k]=Wt[w]=Wt[j]=Wt["[object Uint8ClampedArray]"]=Wt[I]=Wt[B]=!0,Wt[f]=Wt[h]=Wt[x]=!1;var qt={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Nt=parseFloat,Gt=parseInt,Jt="object"==typeof t&&t&&t.Object===Object&&t,Ut="object"==typeof self&&self&&self.Object===Object&&self,Kt=Jt||Ut||Function("return this")(),Ht=e&&!e.nodeType&&e,Vt=Ht&&"object"==typeof r&&r&&!r.nodeType&&r,Zt=Vt&&Vt.exports===Ht,Xt=Zt&&Jt.process,_t=function(){try{var t=Vt&&Vt.require&&Vt.require("util").types;return t||Xt&&Xt.binding&&Xt.binding("util")}catch(t){}}(),$t=_t&&_t.isArrayBuffer,te=_t&&_t.isDate,ee=_t&&_t.isMap,ne=_t&&_t.isRegExp,re=_t&&_t.isSet,ie=_t&&_t.isTypedArray;function oe(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}function ae(t,e,n,r){for(var i=-1,o=null==t?0:t.length;++i<o;){var a=t[i];e(r,a,n(a),t)}return r}function se(t,e){for(var n=-1,r=null==t?0:t.length;++n<r&&!1!==e(t[n],n,t););return t}function ce(t,e){for(var n=null==t?0:t.length;n--&&!1!==e(t[n],n,t););return t}function le(t,e){for(var n=-1,r=null==t?0:t.length;++n<r;)if(!e(t[n],n,t))return!1;return!0}function ue(t,e){for(var n=-1,r=null==t?0:t.length,i=0,o=[];++n<r;){var a=t[n];e(a,n,t)&&(o[i++]=a)}return o}function de(t,e){return!!(null==t?0:t.length)&&we(t,e,0)>-1}function fe(t,e,n){for(var r=-1,i=null==t?0:t.length;++r<i;)if(n(e,t[r]))return!0;return!1}function he(t,e){for(var n=-1,r=null==t?0:t.length,i=Array(r);++n<r;)i[n]=e(t[n],n,t);return i}function pe(t,e){for(var n=-1,r=e.length,i=t.length;++n<r;)t[i+n]=e[n];return t}function ge(t,e,n,r){var i=-1,o=null==t?0:t.length;for(r&&o&&(n=t[++i]);++i<o;)n=e(n,t[i],i,t);return n}function me(t,e,n,r){var i=null==t?0:t.length;for(r&&i&&(n=t[--i]);i--;)n=e(n,t[i],i,t);return n}function ye(t,e){for(var n=-1,r=null==t?0:t.length;++n<r;)if(e(t[n],n,t))return!0;return!1}var ve=Oe("length");function be(t,e,n){var r;return n(t,(function(t,n,i){if(e(t,n,i))return r=n,!1})),r}function ke(t,e,n,r){for(var i=t.length,o=n+(r?1:-1);r?o--:++o<i;)if(e(t[o],o,t))return o;return-1}function we(t,e,n){return e==e?function(t,e,n){var r=n-1,i=t.length;for(;++r<i;)if(t[r]===e)return r;return-1}(t,e,n):ke(t,Ae,n)}function xe(t,e,n,r){for(var i=n-1,o=t.length;++i<o;)if(r(t[i],e))return i;return-1}function Ae(t){return t!=t}function Se(t,e){var n=null==t?0:t.length;return n?Ce(t,e)/n:NaN}function Oe(t){return function(e){return null==e?void 0:e[t]}}function Ee(t){return function(e){return null==t?void 0:t[e]}}function Me(t,e,n,r,i){return i(t,(function(t,i,o){n=r?(r=!1,t):e(n,t,i,o)})),n}function Ce(t,e){for(var n,r=-1,i=t.length;++r<i;){var o=e(t[r]);void 0!==o&&(n=void 0===n?o:n+o)}return n}function Re(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}function je(t){return t?t.slice(0,He(t)+1).replace(H,""):t}function Ie(t){return function(e){return t(e)}}function Be(t,e){return he(e,(function(e){return t[e]}))}function De(t,e){return t.has(e)}function Te(t,e){for(var n=-1,r=t.length;++n<r&&we(e,t[n],0)>-1;);return n}function Fe(t,e){for(var n=t.length;n--&&we(e,t[n],0)>-1;);return n}function Pe(t,e){for(var n=t.length,r=0;n--;)t[n]===e&&++r;return r}var ze=Ee({"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"s"}),Qe=Ee({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"});function Le(t){return"\\"+qt[t]}function Ye(t){return Pt.test(t)}function We(t){var e=-1,n=Array(t.size);return t.forEach((function(t,r){n[++e]=[r,t]})),n}function qe(t,e){return function(n){return t(e(n))}}function Ne(t,e){for(var n=-1,r=t.length,i=0,o=[];++n<r;){var s=t[n];s!==e&&s!==a||(t[n]=a,o[i++]=n)}return o}function Ge(t){var e=-1,n=Array(t.size);return t.forEach((function(t){n[++e]=t})),n}function Je(t){var e=-1,n=Array(t.size);return t.forEach((function(t){n[++e]=[t,t]})),n}function Ue(t){return Ye(t)?function(t){var e=Tt.lastIndex=0;for(;Tt.test(t);)++e;return e}(t):ve(t)}function Ke(t){return Ye(t)?function(t){return t.match(Tt)||[]}(t):function(t){return t.split("")}(t)}function He(t){for(var e=t.length;e--&&V.test(t.charAt(e)););return e}var Ve=Ee({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"});var Ze=function t(e){var n,r=(e=null==e?Kt:Ze.defaults(Kt.Object(),e,Ze.pick(Kt,Qt))).Array,i=e.Date,V=e.Error,ft=e.Function,ht=e.Math,pt=e.Object,gt=e.RegExp,mt=e.String,yt=e.TypeError,vt=r.prototype,bt=ft.prototype,kt=pt.prototype,wt=e["__core-js_shared__"],xt=bt.toString,At=kt.hasOwnProperty,St=0,Ot=(n=/[^.]+$/.exec(wt&&wt.keys&&wt.keys.IE_PROTO||""))?"Symbol(src)_1."+n:"",Et=kt.toString,Mt=xt.call(pt),Ct=Kt._,Rt=gt("^"+xt.call(At).replace(U,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),jt=Zt?e.Buffer:void 0,It=e.Symbol,Tt=e.Uint8Array,Pt=jt?jt.allocUnsafe:void 0,qt=qe(pt.getPrototypeOf,pt),Jt=pt.create,Ut=kt.propertyIsEnumerable,Ht=vt.splice,Vt=It?It.isConcatSpreadable:void 0,Xt=It?It.iterator:void 0,_t=It?It.toStringTag:void 0,ve=function(){try{var t=to(pt,"defineProperty");return t({},"",{}),t}catch(t){}}(),Ee=e.clearTimeout!==Kt.clearTimeout&&e.clearTimeout,Xe=i&&i.now!==Kt.Date.now&&i.now,_e=e.setTimeout!==Kt.setTimeout&&e.setTimeout,$e=ht.ceil,tn=ht.floor,en=pt.getOwnPropertySymbols,nn=jt?jt.isBuffer:void 0,rn=e.isFinite,on=vt.join,an=qe(pt.keys,pt),sn=ht.max,cn=ht.min,ln=i.now,un=e.parseInt,dn=ht.random,fn=vt.reverse,hn=to(e,"DataView"),pn=to(e,"Map"),gn=to(e,"Promise"),mn=to(e,"Set"),yn=to(e,"WeakMap"),vn=to(pt,"create"),bn=yn&&new yn,kn={},wn=Co(hn),xn=Co(pn),An=Co(gn),Sn=Co(mn),On=Co(yn),En=It?It.prototype:void 0,Mn=En?En.valueOf:void 0,Cn=En?En.toString:void 0;function Rn(t){if(Ja(t)&&!Ta(t)&&!(t instanceof Dn)){if(t instanceof Bn)return t;if(At.call(t,"__wrapped__"))return Ro(t)}return new Bn(t)}var jn=function(){function t(){}return function(e){if(!Ga(e))return{};if(Jt)return Jt(e);t.prototype=e;var n=new t;return t.prototype=void 0,n}}();function In(){}function Bn(t,e){this.__wrapped__=t,this.__actions__=[],this.__chain__=!!e,this.__index__=0,this.__values__=void 0}function Dn(t){this.__wrapped__=t,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Tn(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}function Fn(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}function Pn(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}function zn(t){var e=-1,n=null==t?0:t.length;for(this.__data__=new Pn;++e<n;)this.add(t[e])}function Qn(t){var e=this.__data__=new Fn(t);this.size=e.size}function Ln(t,e){var n=Ta(t),r=!n&&Da(t),i=!n&&!r&&Qa(t),o=!n&&!r&&!i&&$a(t),a=n||r||i||o,s=a?Re(t.length,mt):[],c=s.length;for(var l in t)!e&&!At.call(t,l)||a&&("length"==l||i&&("offset"==l||"parent"==l)||o&&("buffer"==l||"byteLength"==l||"byteOffset"==l)||so(l,c))||s.push(l);return s}function Yn(t){var e=t.length;return e?t[zr(0,e-1)]:void 0}function Wn(t,e){return Oo(vi(t),Zn(e,0,t.length))}function qn(t){return Oo(vi(t))}function Nn(t,e,n){(void 0!==n&&!ja(t[e],n)||void 0===n&&!(e in t))&&Hn(t,e,n)}function Gn(t,e,n){var r=t[e];At.call(t,e)&&ja(r,n)&&(void 0!==n||e in t)||Hn(t,e,n)}function Jn(t,e){for(var n=t.length;n--;)if(ja(t[n][0],e))return n;return-1}function Un(t,e,n,r){return er(t,(function(t,i,o){e(r,t,n(t),o)})),r}function Kn(t,e){return t&&bi(e,ws(e),t)}function Hn(t,e,n){"__proto__"==e&&ve?ve(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n}function Vn(t,e){for(var n=-1,i=e.length,o=r(i),a=null==t;++n<i;)o[n]=a?void 0:ms(t,e[n]);return o}function Zn(t,e,n){return t==t&&(void 0!==n&&(t=t<=n?t:n),void 0!==e&&(t=t>=e?t:e)),t}function Xn(t,e,n,r,i,o){var a,s=1&e,l=2&e,f=4&e;if(n&&(a=i?n(t,r,i,o):n(t)),void 0!==a)return a;if(!Ga(t))return t;var x=Ta(t);if(x){if(a=function(t){var e=t.length,n=new t.constructor(e);e&&"string"==typeof t[0]&&At.call(t,"index")&&(n.index=t.index,n.input=t.input);return n}(t),!s)return vi(t,a)}else{var D=ro(t),T=D==h||D==p;if(Qa(t))return fi(t,s);if(D==y||D==c||T&&!i){if(a=l||T?{}:oo(t),!s)return l?function(t,e){return bi(t,no(t),e)}(t,function(t,e){return t&&bi(e,xs(e),t)}(a,t)):function(t,e){return bi(t,eo(t),e)}(t,Kn(a,t))}else{if(!Wt[D])return i?t:{};a=function(t,e,n){var r=t.constructor;switch(e){case A:return hi(t);case u:case d:return new r(+t);case S:return function(t,e){var n=e?hi(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.byteLength)}(t,n);case O:case E:case M:case C:case R:case j:case"[object Uint8ClampedArray]":case I:case B:return pi(t,n);case g:return new r;case m:case k:return new r(t);case v:return function(t){var e=new t.constructor(t.source,rt.exec(t));return e.lastIndex=t.lastIndex,e}(t);case b:return new r;case w:return i=t,Mn?pt(Mn.call(i)):{}}var i}(t,D,s)}}o||(o=new Qn);var F=o.get(t);if(F)return F;o.set(t,a),Za(t)?t.forEach((function(r){a.add(Xn(r,e,n,r,t,o))})):Ua(t)&&t.forEach((function(r,i){a.set(i,Xn(r,e,n,i,t,o))}));var P=x?void 0:(f?l?Ki:Ui:l?xs:ws)(t);return se(P||t,(function(r,i){P&&(r=t[i=r]),Gn(a,i,Xn(r,e,n,i,t,o))})),a}function _n(t,e,n){var r=n.length;if(null==t)return!r;for(t=pt(t);r--;){var i=n[r],o=e[i],a=t[i];if(void 0===a&&!(i in t)||!o(a))return!1}return!0}function $n(t,e,n){if("function"!=typeof t)throw new yt(o);return wo((function(){t.apply(void 0,n)}),e)}function tr(t,e,n,r){var i=-1,o=de,a=!0,s=t.length,c=[],l=e.length;if(!s)return c;n&&(e=he(e,Ie(n))),r?(o=fe,a=!1):e.length>=200&&(o=De,a=!1,e=new zn(e));t:for(;++i<s;){var u=t[i],d=null==n?u:n(u);if(u=r||0!==u?u:0,a&&d==d){for(var f=l;f--;)if(e[f]===d)continue t;c.push(u)}else o(e,d,r)||c.push(u)}return c}Rn.templateSettings={escape:Y,evaluate:W,interpolate:q,variable:"",imports:{_:Rn}},Rn.prototype=In.prototype,Rn.prototype.constructor=Rn,Bn.prototype=jn(In.prototype),Bn.prototype.constructor=Bn,Dn.prototype=jn(In.prototype),Dn.prototype.constructor=Dn,Tn.prototype.clear=function(){this.__data__=vn?vn(null):{},this.size=0},Tn.prototype.delete=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e},Tn.prototype.get=function(t){var e=this.__data__;if(vn){var n=e[t];return"__lodash_hash_undefined__"===n?void 0:n}return At.call(e,t)?e[t]:void 0},Tn.prototype.has=function(t){var e=this.__data__;return vn?void 0!==e[t]:At.call(e,t)},Tn.prototype.set=function(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=vn&&void 0===e?"__lodash_hash_undefined__":e,this},Fn.prototype.clear=function(){this.__data__=[],this.size=0},Fn.prototype.delete=function(t){var e=this.__data__,n=Jn(e,t);return!(n<0)&&(n==e.length-1?e.pop():Ht.call(e,n,1),--this.size,!0)},Fn.prototype.get=function(t){var e=this.__data__,n=Jn(e,t);return n<0?void 0:e[n][1]},Fn.prototype.has=function(t){return Jn(this.__data__,t)>-1},Fn.prototype.set=function(t,e){var n=this.__data__,r=Jn(n,t);return r<0?(++this.size,n.push([t,e])):n[r][1]=e,this},Pn.prototype.clear=function(){this.size=0,this.__data__={hash:new Tn,map:new(pn||Fn),string:new Tn}},Pn.prototype.delete=function(t){var e=_i(this,t).delete(t);return this.size-=e?1:0,e},Pn.prototype.get=function(t){return _i(this,t).get(t)},Pn.prototype.has=function(t){return _i(this,t).has(t)},Pn.prototype.set=function(t,e){var n=_i(this,t),r=n.size;return n.set(t,e),this.size+=n.size==r?0:1,this},zn.prototype.add=zn.prototype.push=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this},zn.prototype.has=function(t){return this.__data__.has(t)},Qn.prototype.clear=function(){this.__data__=new Fn,this.size=0},Qn.prototype.delete=function(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n},Qn.prototype.get=function(t){return this.__data__.get(t)},Qn.prototype.has=function(t){return this.__data__.has(t)},Qn.prototype.set=function(t,e){var n=this.__data__;if(n instanceof Fn){var r=n.__data__;if(!pn||r.length<199)return r.push([t,e]),this.size=++n.size,this;n=this.__data__=new Pn(r)}return n.set(t,e),this.size=n.size,this};var er=xi(lr),nr=xi(ur,!0);function rr(t,e){var n=!0;return er(t,(function(t,r,i){return n=!!e(t,r,i)})),n}function ir(t,e,n){for(var r=-1,i=t.length;++r<i;){var o=t[r],a=e(o);if(null!=a&&(void 0===s?a==a&&!_a(a):n(a,s)))var s=a,c=o}return c}function or(t,e){var n=[];return er(t,(function(t,r,i){e(t,r,i)&&n.push(t)})),n}function ar(t,e,n,r,i){var o=-1,a=t.length;for(n||(n=ao),i||(i=[]);++o<a;){var s=t[o];e>0&&n(s)?e>1?ar(s,e-1,n,r,i):pe(i,s):r||(i[i.length]=s)}return i}var sr=Ai(),cr=Ai(!0);function lr(t,e){return t&&sr(t,e,ws)}function ur(t,e){return t&&cr(t,e,ws)}function dr(t,e){return ue(e,(function(e){return Wa(t[e])}))}function fr(t,e){for(var n=0,r=(e=ci(e,t)).length;null!=t&&n<r;)t=t[Mo(e[n++])];return n&&n==r?t:void 0}function hr(t,e,n){var r=e(t);return Ta(t)?r:pe(r,n(t))}function pr(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":_t&&_t in pt(t)?function(t){var e=At.call(t,_t),n=t[_t];try{t[_t]=void 0;var r=!0}catch(t){}var i=Et.call(t);r&&(e?t[_t]=n:delete t[_t]);return i}(t):function(t){return Et.call(t)}(t)}function gr(t,e){return t>e}function mr(t,e){return null!=t&&At.call(t,e)}function yr(t,e){return null!=t&&e in pt(t)}function vr(t,e,n){for(var i=n?fe:de,o=t[0].length,a=t.length,s=a,c=r(a),l=1/0,u=[];s--;){var d=t[s];s&&e&&(d=he(d,Ie(e))),l=cn(d.length,l),c[s]=!n&&(e||o>=120&&d.length>=120)?new zn(s&&d):void 0}d=t[0];var f=-1,h=c[0];t:for(;++f<o&&u.length<l;){var p=d[f],g=e?e(p):p;if(p=n||0!==p?p:0,!(h?De(h,g):i(u,g,n))){for(s=a;--s;){var m=c[s];if(!(m?De(m,g):i(t[s],g,n)))continue t}h&&h.push(g),u.push(p)}}return u}function br(t,e,n){var r=null==(t=yo(t,e=ci(e,t)))?t:t[Mo(Yo(e))];return null==r?void 0:oe(r,t,n)}function kr(t){return Ja(t)&&pr(t)==c}function wr(t,e,n,r,i){return t===e||(null==t||null==e||!Ja(t)&&!Ja(e)?t!=t&&e!=e:function(t,e,n,r,i,o){var a=Ta(t),s=Ta(e),h=a?l:ro(t),p=s?l:ro(e),x=(h=h==c?y:h)==y,O=(p=p==c?y:p)==y,E=h==p;if(E&&Qa(t)){if(!Qa(e))return!1;a=!0,x=!1}if(E&&!x)return o||(o=new Qn),a||$a(t)?Gi(t,e,n,r,i,o):function(t,e,n,r,i,o,a){switch(n){case S:if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case A:return!(t.byteLength!=e.byteLength||!o(new Tt(t),new Tt(e)));case u:case d:case m:return ja(+t,+e);case f:return t.name==e.name&&t.message==e.message;case v:case k:return t==e+"";case g:var s=We;case b:var c=1&r;if(s||(s=Ge),t.size!=e.size&&!c)return!1;var l=a.get(t);if(l)return l==e;r|=2,a.set(t,e);var h=Gi(s(t),s(e),r,i,o,a);return a.delete(t),h;case w:if(Mn)return Mn.call(t)==Mn.call(e)}return!1}(t,e,h,n,r,i,o);if(!(1&n)){var M=x&&At.call(t,"__wrapped__"),C=O&&At.call(e,"__wrapped__");if(M||C){var R=M?t.value():t,j=C?e.value():e;return o||(o=new Qn),i(R,j,n,r,o)}}if(!E)return!1;return o||(o=new Qn),function(t,e,n,r,i,o){var a=1&n,s=Ui(t),c=s.length,l=Ui(e).length;if(c!=l&&!a)return!1;var u=c;for(;u--;){var d=s[u];if(!(a?d in e:At.call(e,d)))return!1}var f=o.get(t),h=o.get(e);if(f&&h)return f==e&&h==t;var p=!0;o.set(t,e),o.set(e,t);var g=a;for(;++u<c;){d=s[u];var m=t[d],y=e[d];if(r)var v=a?r(y,m,d,e,t,o):r(m,y,d,t,e,o);if(!(void 0===v?m===y||i(m,y,n,r,o):v)){p=!1;break}g||(g="constructor"==d)}if(p&&!g){var b=t.constructor,k=e.constructor;b==k||!("constructor"in t)||!("constructor"in e)||"function"==typeof b&&b instanceof b&&"function"==typeof k&&k instanceof k||(p=!1)}return o.delete(t),o.delete(e),p}(t,e,n,r,i,o)}(t,e,n,r,wr,i))}function xr(t,e,n,r){var i=n.length,o=i,a=!r;if(null==t)return!o;for(t=pt(t);i--;){var s=n[i];if(a&&s[2]?s[1]!==t[s[0]]:!(s[0]in t))return!1}for(;++i<o;){var c=(s=n[i])[0],l=t[c],u=s[1];if(a&&s[2]){if(void 0===l&&!(c in t))return!1}else{var d=new Qn;if(r)var f=r(l,u,c,t,e,d);if(!(void 0===f?wr(u,l,3,r,d):f))return!1}}return!0}function Ar(t){return!(!Ga(t)||(e=t,Ot&&Ot in e))&&(Wa(t)?Rt:at).test(Co(t));var e}function Sr(t){return"function"==typeof t?t:null==t?Ks:"object"==typeof t?Ta(t)?jr(t[0],t[1]):Rr(t):nc(t)}function Or(t){if(!ho(t))return an(t);var e=[];for(var n in pt(t))At.call(t,n)&&"constructor"!=n&&e.push(n);return e}function Er(t){if(!Ga(t))return function(t){var e=[];if(null!=t)for(var n in pt(t))e.push(n);return e}(t);var e=ho(t),n=[];for(var r in t)("constructor"!=r||!e&&At.call(t,r))&&n.push(r);return n}function Mr(t,e){return t<e}function Cr(t,e){var n=-1,i=Pa(t)?r(t.length):[];return er(t,(function(t,r,o){i[++n]=e(t,r,o)})),i}function Rr(t){var e=$i(t);return 1==e.length&&e[0][2]?go(e[0][0],e[0][1]):function(n){return n===t||xr(n,t,e)}}function jr(t,e){return lo(t)&&po(e)?go(Mo(t),e):function(n){var r=ms(n,t);return void 0===r&&r===e?ys(n,t):wr(e,r,3)}}function Ir(t,e,n,r,i){t!==e&&sr(e,(function(o,a){if(i||(i=new Qn),Ga(o))!function(t,e,n,r,i,o,a){var s=bo(t,n),c=bo(e,n),l=a.get(c);if(l)return void Nn(t,n,l);var u=o?o(s,c,n+"",t,e,a):void 0,d=void 0===u;if(d){var f=Ta(c),h=!f&&Qa(c),p=!f&&!h&&$a(c);u=c,f||h||p?Ta(s)?u=s:za(s)?u=vi(s):h?(d=!1,u=fi(c,!0)):p?(d=!1,u=pi(c,!0)):u=[]:Ha(c)||Da(c)?(u=s,Da(s)?u=ss(s):Ga(s)&&!Wa(s)||(u=oo(c))):d=!1}d&&(a.set(c,u),i(u,c,r,o,a),a.delete(c));Nn(t,n,u)}(t,e,a,n,Ir,r,i);else{var s=r?r(bo(t,a),o,a+"",t,e,i):void 0;void 0===s&&(s=o),Nn(t,a,s)}}),xs)}function Br(t,e){var n=t.length;if(n)return so(e+=e<0?n:0,n)?t[e]:void 0}function Dr(t,e,n){e=e.length?he(e,(function(t){return Ta(t)?function(e){return fr(e,1===t.length?t[0]:t)}:t})):[Ks];var r=-1;return e=he(e,Ie(Xi())),function(t,e){var n=t.length;for(t.sort(e);n--;)t[n]=t[n].value;return t}(Cr(t,(function(t,n,i){return{criteria:he(e,(function(e){return e(t)})),index:++r,value:t}})),(function(t,e){return function(t,e,n){var r=-1,i=t.criteria,o=e.criteria,a=i.length,s=n.length;for(;++r<a;){var c=gi(i[r],o[r]);if(c){if(r>=s)return c;var l=n[r];return c*("desc"==l?-1:1)}}return t.index-e.index}(t,e,n)}))}function Tr(t,e,n){for(var r=-1,i=e.length,o={};++r<i;){var a=e[r],s=fr(t,a);n(s,a)&&qr(o,ci(a,t),s)}return o}function Fr(t,e,n,r){var i=r?xe:we,o=-1,a=e.length,s=t;for(t===e&&(e=vi(e)),n&&(s=he(t,Ie(n)));++o<a;)for(var c=0,l=e[o],u=n?n(l):l;(c=i(s,u,c,r))>-1;)s!==t&&Ht.call(s,c,1),Ht.call(t,c,1);return t}function Pr(t,e){for(var n=t?e.length:0,r=n-1;n--;){var i=e[n];if(n==r||i!==o){var o=i;so(i)?Ht.call(t,i,1):ti(t,i)}}return t}function zr(t,e){return t+tn(dn()*(e-t+1))}function Qr(t,e){var n="";if(!t||e<1||e>9007199254740991)return n;do{e%2&&(n+=t),(e=tn(e/2))&&(t+=t)}while(e);return n}function Lr(t,e){return xo(mo(t,e,Ks),t+"")}function Yr(t){return Yn(js(t))}function Wr(t,e){var n=js(t);return Oo(n,Zn(e,0,n.length))}function qr(t,e,n,r){if(!Ga(t))return t;for(var i=-1,o=(e=ci(e,t)).length,a=o-1,s=t;null!=s&&++i<o;){var c=Mo(e[i]),l=n;if("__proto__"===c||"constructor"===c||"prototype"===c)return t;if(i!=a){var u=s[c];void 0===(l=r?r(u,c,s):void 0)&&(l=Ga(u)?u:so(e[i+1])?[]:{})}Gn(s,c,l),s=s[c]}return t}var Nr=bn?function(t,e){return bn.set(t,e),t}:Ks,Gr=ve?function(t,e){return ve(t,"toString",{configurable:!0,enumerable:!1,value:Gs(e),writable:!0})}:Ks;function Jr(t){return Oo(js(t))}function Ur(t,e,n){var i=-1,o=t.length;e<0&&(e=-e>o?0:o+e),(n=n>o?o:n)<0&&(n+=o),o=e>n?0:n-e>>>0,e>>>=0;for(var a=r(o);++i<o;)a[i]=t[i+e];return a}function Kr(t,e){var n;return er(t,(function(t,r,i){return!(n=e(t,r,i))})),!!n}function Hr(t,e,n){var r=0,i=null==t?r:t.length;if("number"==typeof e&&e==e&&i<=2147483647){for(;r<i;){var o=r+i>>>1,a=t[o];null!==a&&!_a(a)&&(n?a<=e:a<e)?r=o+1:i=o}return i}return Vr(t,e,Ks,n)}function Vr(t,e,n,r){var i=0,o=null==t?0:t.length;if(0===o)return 0;for(var a=(e=n(e))!=e,s=null===e,c=_a(e),l=void 0===e;i<o;){var u=tn((i+o)/2),d=n(t[u]),f=void 0!==d,h=null===d,p=d==d,g=_a(d);if(a)var m=r||p;else m=l?p&&(r||f):s?p&&f&&(r||!h):c?p&&f&&!h&&(r||!g):!h&&!g&&(r?d<=e:d<e);m?i=u+1:o=u}return cn(o,4294967294)}function Zr(t,e){for(var n=-1,r=t.length,i=0,o=[];++n<r;){var a=t[n],s=e?e(a):a;if(!n||!ja(s,c)){var c=s;o[i++]=0===a?0:a}}return o}function Xr(t){return"number"==typeof t?t:_a(t)?NaN:+t}function _r(t){if("string"==typeof t)return t;if(Ta(t))return he(t,_r)+"";if(_a(t))return Cn?Cn.call(t):"";var e=t+"";return"0"==e&&1/t==-1/0?"-0":e}function $r(t,e,n){var r=-1,i=de,o=t.length,a=!0,s=[],c=s;if(n)a=!1,i=fe;else if(o>=200){var l=e?null:Qi(t);if(l)return Ge(l);a=!1,i=De,c=new zn}else c=e?[]:s;t:for(;++r<o;){var u=t[r],d=e?e(u):u;if(u=n||0!==u?u:0,a&&d==d){for(var f=c.length;f--;)if(c[f]===d)continue t;e&&c.push(d),s.push(u)}else i(c,d,n)||(c!==s&&c.push(d),s.push(u))}return s}function ti(t,e){return null==(t=yo(t,e=ci(e,t)))||delete t[Mo(Yo(e))]}function ei(t,e,n,r){return qr(t,e,n(fr(t,e)),r)}function ni(t,e,n,r){for(var i=t.length,o=r?i:-1;(r?o--:++o<i)&&e(t[o],o,t););return n?Ur(t,r?0:o,r?o+1:i):Ur(t,r?o+1:0,r?i:o)}function ri(t,e){var n=t;return n instanceof Dn&&(n=n.value()),ge(e,(function(t,e){return e.func.apply(e.thisArg,pe([t],e.args))}),n)}function ii(t,e,n){var i=t.length;if(i<2)return i?$r(t[0]):[];for(var o=-1,a=r(i);++o<i;)for(var s=t[o],c=-1;++c<i;)c!=o&&(a[o]=tr(a[o]||s,t[c],e,n));return $r(ar(a,1),e,n)}function oi(t,e,n){for(var r=-1,i=t.length,o=e.length,a={};++r<i;){var s=r<o?e[r]:void 0;n(a,t[r],s)}return a}function ai(t){return za(t)?t:[]}function si(t){return"function"==typeof t?t:Ks}function ci(t,e){return Ta(t)?t:lo(t,e)?[t]:Eo(cs(t))}var li=Lr;function ui(t,e,n){var r=t.length;return n=void 0===n?r:n,!e&&n>=r?t:Ur(t,e,n)}var di=Ee||function(t){return Kt.clearTimeout(t)};function fi(t,e){if(e)return t.slice();var n=t.length,r=Pt?Pt(n):new t.constructor(n);return t.copy(r),r}function hi(t){var e=new t.constructor(t.byteLength);return new Tt(e).set(new Tt(t)),e}function pi(t,e){var n=e?hi(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.length)}function gi(t,e){if(t!==e){var n=void 0!==t,r=null===t,i=t==t,o=_a(t),a=void 0!==e,s=null===e,c=e==e,l=_a(e);if(!s&&!l&&!o&&t>e||o&&a&&c&&!s&&!l||r&&a&&c||!n&&c||!i)return 1;if(!r&&!o&&!l&&t<e||l&&n&&i&&!r&&!o||s&&n&&i||!a&&i||!c)return-1}return 0}function mi(t,e,n,i){for(var o=-1,a=t.length,s=n.length,c=-1,l=e.length,u=sn(a-s,0),d=r(l+u),f=!i;++c<l;)d[c]=e[c];for(;++o<s;)(f||o<a)&&(d[n[o]]=t[o]);for(;u--;)d[c++]=t[o++];return d}function yi(t,e,n,i){for(var o=-1,a=t.length,s=-1,c=n.length,l=-1,u=e.length,d=sn(a-c,0),f=r(d+u),h=!i;++o<d;)f[o]=t[o];for(var p=o;++l<u;)f[p+l]=e[l];for(;++s<c;)(h||o<a)&&(f[p+n[s]]=t[o++]);return f}function vi(t,e){var n=-1,i=t.length;for(e||(e=r(i));++n<i;)e[n]=t[n];return e}function bi(t,e,n,r){var i=!n;n||(n={});for(var o=-1,a=e.length;++o<a;){var s=e[o],c=r?r(n[s],t[s],s,n,t):void 0;void 0===c&&(c=t[s]),i?Hn(n,s,c):Gn(n,s,c)}return n}function ki(t,e){return function(n,r){var i=Ta(n)?ae:Un,o=e?e():{};return i(n,t,Xi(r,2),o)}}function wi(t){return Lr((function(e,n){var r=-1,i=n.length,o=i>1?n[i-1]:void 0,a=i>2?n[2]:void 0;for(o=t.length>3&&"function"==typeof o?(i--,o):void 0,a&&co(n[0],n[1],a)&&(o=i<3?void 0:o,i=1),e=pt(e);++r<i;){var s=n[r];s&&t(e,s,r,o)}return e}))}function xi(t,e){return function(n,r){if(null==n)return n;if(!Pa(n))return t(n,r);for(var i=n.length,o=e?i:-1,a=pt(n);(e?o--:++o<i)&&!1!==r(a[o],o,a););return n}}function Ai(t){return function(e,n,r){for(var i=-1,o=pt(e),a=r(e),s=a.length;s--;){var c=a[t?s:++i];if(!1===n(o[c],c,o))break}return e}}function Si(t){return function(e){var n=Ye(e=cs(e))?Ke(e):void 0,r=n?n[0]:e.charAt(0),i=n?ui(n,1).join(""):e.slice(1);return r[t]()+i}}function Oi(t){return function(e){return ge(Ws(Ds(e).replace(Bt,"")),t,"")}}function Ei(t){return function(){var e=arguments;switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3]);case 5:return new t(e[0],e[1],e[2],e[3],e[4]);case 6:return new t(e[0],e[1],e[2],e[3],e[4],e[5]);case 7:return new t(e[0],e[1],e[2],e[3],e[4],e[5],e[6])}var n=jn(t.prototype),r=t.apply(n,e);return Ga(r)?r:n}}function Mi(t){return function(e,n,r){var i=pt(e);if(!Pa(e)){var o=Xi(n,3);e=ws(e),n=function(t){return o(i[t],t,i)}}var a=t(e,n,r);return a>-1?i[o?e[a]:a]:void 0}}function Ci(t){return Ji((function(e){var n=e.length,r=n,i=Bn.prototype.thru;for(t&&e.reverse();r--;){var a=e[r];if("function"!=typeof a)throw new yt(o);if(i&&!s&&"wrapper"==Vi(a))var s=new Bn([],!0)}for(r=s?r:n;++r<n;){var c=Vi(a=e[r]),l="wrapper"==c?Hi(a):void 0;s=l&&uo(l[0])&&424==l[1]&&!l[4].length&&1==l[9]?s[Vi(l[0])].apply(s,l[3]):1==a.length&&uo(a)?s[c]():s.thru(a)}return function(){var t=arguments,r=t[0];if(s&&1==t.length&&Ta(r))return s.plant(r).value();for(var i=0,o=n?e[i].apply(this,t):r;++i<n;)o=e[i].call(this,o);return o}}))}function Ri(t,e,n,i,o,a,s,c,l,u){var d=128&e,f=1&e,h=2&e,p=24&e,g=512&e,m=h?void 0:Ei(t);return function y(){for(var v=arguments.length,b=r(v),k=v;k--;)b[k]=arguments[k];if(p)var w=Zi(y),x=Pe(b,w);if(i&&(b=mi(b,i,o,p)),a&&(b=yi(b,a,s,p)),v-=x,p&&v<u){var A=Ne(b,w);return Pi(t,e,Ri,y.placeholder,n,b,A,c,l,u-v)}var S=f?n:this,O=h?S[t]:t;return v=b.length,c?b=vo(b,c):g&&v>1&&b.reverse(),d&&l<v&&(b.length=l),this&&this!==Kt&&this instanceof y&&(O=m||Ei(O)),O.apply(S,b)}}function ji(t,e){return function(n,r){return function(t,e,n,r){return lr(t,(function(t,i,o){e(r,n(t),i,o)})),r}(n,t,e(r),{})}}function Ii(t,e){return function(n,r){var i;if(void 0===n&&void 0===r)return e;if(void 0!==n&&(i=n),void 0!==r){if(void 0===i)return r;"string"==typeof n||"string"==typeof r?(n=_r(n),r=_r(r)):(n=Xr(n),r=Xr(r)),i=t(n,r)}return i}}function Bi(t){return Ji((function(e){return e=he(e,Ie(Xi())),Lr((function(n){var r=this;return t(e,(function(t){return oe(t,r,n)}))}))}))}function Di(t,e){var n=(e=void 0===e?" ":_r(e)).length;if(n<2)return n?Qr(e,t):e;var r=Qr(e,$e(t/Ue(e)));return Ye(e)?ui(Ke(r),0,t).join(""):r.slice(0,t)}function Ti(t){return function(e,n,i){return i&&"number"!=typeof i&&co(e,n,i)&&(n=i=void 0),e=rs(e),void 0===n?(n=e,e=0):n=rs(n),function(t,e,n,i){for(var o=-1,a=sn($e((e-t)/(n||1)),0),s=r(a);a--;)s[i?a:++o]=t,t+=n;return s}(e,n,i=void 0===i?e<n?1:-1:rs(i),t)}}function Fi(t){return function(e,n){return"string"==typeof e&&"string"==typeof n||(e=as(e),n=as(n)),t(e,n)}}function Pi(t,e,n,r,i,o,a,s,c,l){var u=8&e;e|=u?32:64,4&(e&=~(u?64:32))||(e&=-4);var d=[t,e,i,u?o:void 0,u?a:void 0,u?void 0:o,u?void 0:a,s,c,l],f=n.apply(void 0,d);return uo(t)&&ko(f,d),f.placeholder=r,Ao(f,t,e)}function zi(t){var e=ht[t];return function(t,n){if(t=as(t),(n=null==n?0:cn(is(n),292))&&rn(t)){var r=(cs(t)+"e").split("e");return+((r=(cs(e(r[0]+"e"+(+r[1]+n)))+"e").split("e"))[0]+"e"+(+r[1]-n))}return e(t)}}var Qi=mn&&1/Ge(new mn([,-0]))[1]==1/0?function(t){return new mn(t)}:_s;function Li(t){return function(e){var n=ro(e);return n==g?We(e):n==b?Je(e):function(t,e){return he(e,(function(e){return[e,t[e]]}))}(e,t(e))}}function Yi(t,e,n,i,s,c,l,u){var d=2&e;if(!d&&"function"!=typeof t)throw new yt(o);var f=i?i.length:0;if(f||(e&=-97,i=s=void 0),l=void 0===l?l:sn(is(l),0),u=void 0===u?u:is(u),f-=s?s.length:0,64&e){var h=i,p=s;i=s=void 0}var g=d?void 0:Hi(t),m=[t,e,n,i,s,h,p,c,l,u];if(g&&function(t,e){var n=t[1],r=e[1],i=n|r,o=i<131,s=128==r&&8==n||128==r&&256==n&&t[7].length<=e[8]||384==r&&e[7].length<=e[8]&&8==n;if(!o&&!s)return t;1&r&&(t[2]=e[2],i|=1&n?0:4);var c=e[3];if(c){var l=t[3];t[3]=l?mi(l,c,e[4]):c,t[4]=l?Ne(t[3],a):e[4]}(c=e[5])&&(l=t[5],t[5]=l?yi(l,c,e[6]):c,t[6]=l?Ne(t[5],a):e[6]);(c=e[7])&&(t[7]=c);128&r&&(t[8]=null==t[8]?e[8]:cn(t[8],e[8]));null==t[9]&&(t[9]=e[9]);t[0]=e[0],t[1]=i}(m,g),t=m[0],e=m[1],n=m[2],i=m[3],s=m[4],!(u=m[9]=void 0===m[9]?d?0:t.length:sn(m[9]-f,0))&&24&e&&(e&=-25),e&&1!=e)y=8==e||16==e?function(t,e,n){var i=Ei(t);return function o(){for(var a=arguments.length,s=r(a),c=a,l=Zi(o);c--;)s[c]=arguments[c];var u=a<3&&s[0]!==l&&s[a-1]!==l?[]:Ne(s,l);if((a-=u.length)<n)return Pi(t,e,Ri,o.placeholder,void 0,s,u,void 0,void 0,n-a);var d=this&&this!==Kt&&this instanceof o?i:t;return oe(d,this,s)}}(t,e,u):32!=e&&33!=e||s.length?Ri.apply(void 0,m):function(t,e,n,i){var o=1&e,a=Ei(t);return function e(){for(var s=-1,c=arguments.length,l=-1,u=i.length,d=r(u+c),f=this&&this!==Kt&&this instanceof e?a:t;++l<u;)d[l]=i[l];for(;c--;)d[l++]=arguments[++s];return oe(f,o?n:this,d)}}(t,e,n,i);else var y=function(t,e,n){var r=1&e,i=Ei(t);return function e(){var o=this&&this!==Kt&&this instanceof e?i:t;return o.apply(r?n:this,arguments)}}(t,e,n);return Ao((g?Nr:ko)(y,m),t,e)}function Wi(t,e,n,r){return void 0===t||ja(t,kt[n])&&!At.call(r,n)?e:t}function qi(t,e,n,r,i,o){return Ga(t)&&Ga(e)&&(o.set(e,t),Ir(t,e,void 0,qi,o),o.delete(e)),t}function Ni(t){return Ha(t)?void 0:t}function Gi(t,e,n,r,i,o){var a=1&n,s=t.length,c=e.length;if(s!=c&&!(a&&c>s))return!1;var l=o.get(t),u=o.get(e);if(l&&u)return l==e&&u==t;var d=-1,f=!0,h=2&n?new zn:void 0;for(o.set(t,e),o.set(e,t);++d<s;){var p=t[d],g=e[d];if(r)var m=a?r(g,p,d,e,t,o):r(p,g,d,t,e,o);if(void 0!==m){if(m)continue;f=!1;break}if(h){if(!ye(e,(function(t,e){if(!De(h,e)&&(p===t||i(p,t,n,r,o)))return h.push(e)}))){f=!1;break}}else if(p!==g&&!i(p,g,n,r,o)){f=!1;break}}return o.delete(t),o.delete(e),f}function Ji(t){return xo(mo(t,void 0,Fo),t+"")}function Ui(t){return hr(t,ws,eo)}function Ki(t){return hr(t,xs,no)}var Hi=bn?function(t){return bn.get(t)}:_s;function Vi(t){for(var e=t.name+"",n=kn[e],r=At.call(kn,e)?n.length:0;r--;){var i=n[r],o=i.func;if(null==o||o==t)return i.name}return e}function Zi(t){return(At.call(Rn,"placeholder")?Rn:t).placeholder}function Xi(){var t=Rn.iteratee||Hs;return t=t===Hs?Sr:t,arguments.length?t(arguments[0],arguments[1]):t}function _i(t,e){var n,r,i=t.__data__;return("string"==(r=typeof(n=e))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==n:null===n)?i["string"==typeof e?"string":"hash"]:i.map}function $i(t){for(var e=ws(t),n=e.length;n--;){var r=e[n],i=t[r];e[n]=[r,i,po(i)]}return e}function to(t,e){var n=function(t,e){return null==t?void 0:t[e]}(t,e);return Ar(n)?n:void 0}var eo=en?function(t){return null==t?[]:(t=pt(t),ue(en(t),(function(e){return Ut.call(t,e)})))}:oc,no=en?function(t){for(var e=[];t;)pe(e,eo(t)),t=qt(t);return e}:oc,ro=pr;function io(t,e,n){for(var r=-1,i=(e=ci(e,t)).length,o=!1;++r<i;){var a=Mo(e[r]);if(!(o=null!=t&&n(t,a)))break;t=t[a]}return o||++r!=i?o:!!(i=null==t?0:t.length)&&Na(i)&&so(a,i)&&(Ta(t)||Da(t))}function oo(t){return"function"!=typeof t.constructor||ho(t)?{}:jn(qt(t))}function ao(t){return Ta(t)||Da(t)||!!(Vt&&t&&t[Vt])}function so(t,e){var n=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==n||"symbol"!=n&&ct.test(t))&&t>-1&&t%1==0&&t<e}function co(t,e,n){if(!Ga(n))return!1;var r=typeof e;return!!("number"==r?Pa(n)&&so(e,n.length):"string"==r&&e in n)&&ja(n[e],t)}function lo(t,e){if(Ta(t))return!1;var n=typeof t;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=t&&!_a(t))||(G.test(t)||!N.test(t)||null!=e&&t in pt(e))}function uo(t){var e=Vi(t),n=Rn[e];if("function"!=typeof n||!(e in Dn.prototype))return!1;if(t===n)return!0;var r=Hi(n);return!!r&&t===r[0]}(hn&&ro(new hn(new ArrayBuffer(1)))!=S||pn&&ro(new pn)!=g||gn&&"[object Promise]"!=ro(gn.resolve())||mn&&ro(new mn)!=b||yn&&ro(new yn)!=x)&&(ro=function(t){var e=pr(t),n=e==y?t.constructor:void 0,r=n?Co(n):"";if(r)switch(r){case wn:return S;case xn:return g;case An:return"[object Promise]";case Sn:return b;case On:return x}return e});var fo=wt?Wa:ac;function ho(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||kt)}function po(t){return t==t&&!Ga(t)}function go(t,e){return function(n){return null!=n&&(n[t]===e&&(void 0!==e||t in pt(n)))}}function mo(t,e,n){return e=sn(void 0===e?t.length-1:e,0),function(){for(var i=arguments,o=-1,a=sn(i.length-e,0),s=r(a);++o<a;)s[o]=i[e+o];o=-1;for(var c=r(e+1);++o<e;)c[o]=i[o];return c[e]=n(s),oe(t,this,c)}}function yo(t,e){return e.length<2?t:fr(t,Ur(e,0,-1))}function vo(t,e){for(var n=t.length,r=cn(e.length,n),i=vi(t);r--;){var o=e[r];t[r]=so(o,n)?i[o]:void 0}return t}function bo(t,e){if(("constructor"!==e||"function"!=typeof t[e])&&"__proto__"!=e)return t[e]}var ko=So(Nr),wo=_e||function(t,e){return Kt.setTimeout(t,e)},xo=So(Gr);function Ao(t,e,n){var r=e+"";return xo(t,function(t,e){var n=e.length;if(!n)return t;var r=n-1;return e[r]=(n>1?"& ":"")+e[r],e=e.join(n>2?", ":" "),t.replace(Z,"{\n/* [wrapped with "+e+"] */\n")}(r,function(t,e){return se(s,(function(n){var r="_."+n[0];e&n[1]&&!de(t,r)&&t.push(r)})),t.sort()}(function(t){var e=t.match(X);return e?e[1].split(_):[]}(r),n)))}function So(t){var e=0,n=0;return function(){var r=ln(),i=16-(r-n);if(n=r,i>0){if(++e>=800)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}function Oo(t,e){var n=-1,r=t.length,i=r-1;for(e=void 0===e?r:e;++n<e;){var o=zr(n,i),a=t[o];t[o]=t[n],t[n]=a}return t.length=e,t}var Eo=function(t){var e=Sa(t,(function(t){return 500===n.size&&n.clear(),t})),n=e.cache;return e}((function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(J,(function(t,n,r,i){e.push(r?i.replace(et,"$1"):n||t)})),e}));function Mo(t){if("string"==typeof t||_a(t))return t;var e=t+"";return"0"==e&&1/t==-1/0?"-0":e}function Co(t){if(null!=t){try{return xt.call(t)}catch(t){}try{return t+""}catch(t){}}return""}function Ro(t){if(t instanceof Dn)return t.clone();var e=new Bn(t.__wrapped__,t.__chain__);return e.__actions__=vi(t.__actions__),e.__index__=t.__index__,e.__values__=t.__values__,e}var jo=Lr((function(t,e){return za(t)?tr(t,ar(e,1,za,!0)):[]})),Io=Lr((function(t,e){var n=Yo(e);return za(n)&&(n=void 0),za(t)?tr(t,ar(e,1,za,!0),Xi(n,2)):[]})),Bo=Lr((function(t,e){var n=Yo(e);return za(n)&&(n=void 0),za(t)?tr(t,ar(e,1,za,!0),void 0,n):[]}));function Do(t,e,n){var r=null==t?0:t.length;if(!r)return-1;var i=null==n?0:is(n);return i<0&&(i=sn(r+i,0)),ke(t,Xi(e,3),i)}function To(t,e,n){var r=null==t?0:t.length;if(!r)return-1;var i=r-1;return void 0!==n&&(i=is(n),i=n<0?sn(r+i,0):cn(i,r-1)),ke(t,Xi(e,3),i,!0)}function Fo(t){return(null==t?0:t.length)?ar(t,1):[]}function Po(t){return t&&t.length?t[0]:void 0}var zo=Lr((function(t){var e=he(t,ai);return e.length&&e[0]===t[0]?vr(e):[]})),Qo=Lr((function(t){var e=Yo(t),n=he(t,ai);return e===Yo(n)?e=void 0:n.pop(),n.length&&n[0]===t[0]?vr(n,Xi(e,2)):[]})),Lo=Lr((function(t){var e=Yo(t),n=he(t,ai);return(e="function"==typeof e?e:void 0)&&n.pop(),n.length&&n[0]===t[0]?vr(n,void 0,e):[]}));function Yo(t){var e=null==t?0:t.length;return e?t[e-1]:void 0}var Wo=Lr(qo);function qo(t,e){return t&&t.length&&e&&e.length?Fr(t,e):t}var No=Ji((function(t,e){var n=null==t?0:t.length,r=Vn(t,e);return Pr(t,he(e,(function(t){return so(t,n)?+t:t})).sort(gi)),r}));function Go(t){return null==t?t:fn.call(t)}var Jo=Lr((function(t){return $r(ar(t,1,za,!0))})),Uo=Lr((function(t){var e=Yo(t);return za(e)&&(e=void 0),$r(ar(t,1,za,!0),Xi(e,2))})),Ko=Lr((function(t){var e=Yo(t);return e="function"==typeof e?e:void 0,$r(ar(t,1,za,!0),void 0,e)}));function Ho(t){if(!t||!t.length)return[];var e=0;return t=ue(t,(function(t){if(za(t))return e=sn(t.length,e),!0})),Re(e,(function(e){return he(t,Oe(e))}))}function Vo(t,e){if(!t||!t.length)return[];var n=Ho(t);return null==e?n:he(n,(function(t){return oe(e,void 0,t)}))}var Zo=Lr((function(t,e){return za(t)?tr(t,e):[]})),Xo=Lr((function(t){return ii(ue(t,za))})),_o=Lr((function(t){var e=Yo(t);return za(e)&&(e=void 0),ii(ue(t,za),Xi(e,2))})),$o=Lr((function(t){var e=Yo(t);return e="function"==typeof e?e:void 0,ii(ue(t,za),void 0,e)})),ta=Lr(Ho);var ea=Lr((function(t){var e=t.length,n=e>1?t[e-1]:void 0;return n="function"==typeof n?(t.pop(),n):void 0,Vo(t,n)}));function na(t){var e=Rn(t);return e.__chain__=!0,e}function ra(t,e){return e(t)}var ia=Ji((function(t){var e=t.length,n=e?t[0]:0,r=this.__wrapped__,i=function(e){return Vn(e,t)};return!(e>1||this.__actions__.length)&&r instanceof Dn&&so(n)?((r=r.slice(n,+n+(e?1:0))).__actions__.push({func:ra,args:[i],thisArg:void 0}),new Bn(r,this.__chain__).thru((function(t){return e&&!t.length&&t.push(void 0),t}))):this.thru(i)}));var oa=ki((function(t,e,n){At.call(t,n)?++t[n]:Hn(t,n,1)}));var aa=Mi(Do),sa=Mi(To);function ca(t,e){return(Ta(t)?se:er)(t,Xi(e,3))}function la(t,e){return(Ta(t)?ce:nr)(t,Xi(e,3))}var ua=ki((function(t,e,n){At.call(t,n)?t[n].push(e):Hn(t,n,[e])}));var da=Lr((function(t,e,n){var i=-1,o="function"==typeof e,a=Pa(t)?r(t.length):[];return er(t,(function(t){a[++i]=o?oe(e,t,n):br(t,e,n)})),a})),fa=ki((function(t,e,n){Hn(t,n,e)}));function ha(t,e){return(Ta(t)?he:Cr)(t,Xi(e,3))}var pa=ki((function(t,e,n){t[n?0:1].push(e)}),(function(){return[[],[]]}));var ga=Lr((function(t,e){if(null==t)return[];var n=e.length;return n>1&&co(t,e[0],e[1])?e=[]:n>2&&co(e[0],e[1],e[2])&&(e=[e[0]]),Dr(t,ar(e,1),[])})),ma=Xe||function(){return Kt.Date.now()};function ya(t,e,n){return e=n?void 0:e,Yi(t,128,void 0,void 0,void 0,void 0,e=t&&null==e?t.length:e)}function va(t,e){var n;if("function"!=typeof e)throw new yt(o);return t=is(t),function(){return--t>0&&(n=e.apply(this,arguments)),t<=1&&(e=void 0),n}}var ba=Lr((function(t,e,n){var r=1;if(n.length){var i=Ne(n,Zi(ba));r|=32}return Yi(t,r,e,n,i)})),ka=Lr((function(t,e,n){var r=3;if(n.length){var i=Ne(n,Zi(ka));r|=32}return Yi(e,r,t,n,i)}));function wa(t,e,n){var r,i,a,s,c,l,u=0,d=!1,f=!1,h=!0;if("function"!=typeof t)throw new yt(o);function p(e){var n=r,o=i;return r=i=void 0,u=e,s=t.apply(o,n)}function g(t){return u=t,c=wo(y,e),d?p(t):s}function m(t){var n=t-l;return void 0===l||n>=e||n<0||f&&t-u>=a}function y(){var t=ma();if(m(t))return v(t);c=wo(y,function(t){var n=e-(t-l);return f?cn(n,a-(t-u)):n}(t))}function v(t){return c=void 0,h&&r?p(t):(r=i=void 0,s)}function b(){var t=ma(),n=m(t);if(r=arguments,i=this,l=t,n){if(void 0===c)return g(l);if(f)return di(c),c=wo(y,e),p(l)}return void 0===c&&(c=wo(y,e)),s}return e=as(e)||0,Ga(n)&&(d=!!n.leading,a=(f="maxWait"in n)?sn(as(n.maxWait)||0,e):a,h="trailing"in n?!!n.trailing:h),b.cancel=function(){void 0!==c&&di(c),u=0,r=l=i=c=void 0},b.flush=function(){return void 0===c?s:v(ma())},b}var xa=Lr((function(t,e){return $n(t,1,e)})),Aa=Lr((function(t,e,n){return $n(t,as(e)||0,n)}));function Sa(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new yt(o);var n=function(){var r=arguments,i=e?e.apply(this,r):r[0],o=n.cache;if(o.has(i))return o.get(i);var a=t.apply(this,r);return n.cache=o.set(i,a)||o,a};return n.cache=new(Sa.Cache||Pn),n}function Oa(t){if("function"!=typeof t)throw new yt(o);return function(){var e=arguments;switch(e.length){case 0:return!t.call(this);case 1:return!t.call(this,e[0]);case 2:return!t.call(this,e[0],e[1]);case 3:return!t.call(this,e[0],e[1],e[2])}return!t.apply(this,e)}}Sa.Cache=Pn;var Ea=li((function(t,e){var n=(e=1==e.length&&Ta(e[0])?he(e[0],Ie(Xi())):he(ar(e,1),Ie(Xi()))).length;return Lr((function(r){for(var i=-1,o=cn(r.length,n);++i<o;)r[i]=e[i].call(this,r[i]);return oe(t,this,r)}))})),Ma=Lr((function(t,e){return Yi(t,32,void 0,e,Ne(e,Zi(Ma)))})),Ca=Lr((function(t,e){return Yi(t,64,void 0,e,Ne(e,Zi(Ca)))})),Ra=Ji((function(t,e){return Yi(t,256,void 0,void 0,void 0,e)}));function ja(t,e){return t===e||t!=t&&e!=e}var Ia=Fi(gr),Ba=Fi((function(t,e){return t>=e})),Da=kr(function(){return arguments}())?kr:function(t){return Ja(t)&&At.call(t,"callee")&&!Ut.call(t,"callee")},Ta=r.isArray,Fa=$t?Ie($t):function(t){return Ja(t)&&pr(t)==A};function Pa(t){return null!=t&&Na(t.length)&&!Wa(t)}function za(t){return Ja(t)&&Pa(t)}var Qa=nn||ac,La=te?Ie(te):function(t){return Ja(t)&&pr(t)==d};function Ya(t){if(!Ja(t))return!1;var e=pr(t);return e==f||"[object DOMException]"==e||"string"==typeof t.message&&"string"==typeof t.name&&!Ha(t)}function Wa(t){if(!Ga(t))return!1;var e=pr(t);return e==h||e==p||"[object AsyncFunction]"==e||"[object Proxy]"==e}function qa(t){return"number"==typeof t&&t==is(t)}function Na(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=9007199254740991}function Ga(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}function Ja(t){return null!=t&&"object"==typeof t}var Ua=ee?Ie(ee):function(t){return Ja(t)&&ro(t)==g};function Ka(t){return"number"==typeof t||Ja(t)&&pr(t)==m}function Ha(t){if(!Ja(t)||pr(t)!=y)return!1;var e=qt(t);if(null===e)return!0;var n=At.call(e,"constructor")&&e.constructor;return"function"==typeof n&&n instanceof n&&xt.call(n)==Mt}var Va=ne?Ie(ne):function(t){return Ja(t)&&pr(t)==v};var Za=re?Ie(re):function(t){return Ja(t)&&ro(t)==b};function Xa(t){return"string"==typeof t||!Ta(t)&&Ja(t)&&pr(t)==k}function _a(t){return"symbol"==typeof t||Ja(t)&&pr(t)==w}var $a=ie?Ie(ie):function(t){return Ja(t)&&Na(t.length)&&!!Yt[pr(t)]};var ts=Fi(Mr),es=Fi((function(t,e){return t<=e}));function ns(t){if(!t)return[];if(Pa(t))return Xa(t)?Ke(t):vi(t);if(Xt&&t[Xt])return function(t){for(var e,n=[];!(e=t.next()).done;)n.push(e.value);return n}(t[Xt]());var e=ro(t);return(e==g?We:e==b?Ge:js)(t)}function rs(t){return t?(t=as(t))===1/0||t===-1/0?17976931348623157e292*(t<0?-1:1):t==t?t:0:0===t?t:0}function is(t){var e=rs(t),n=e%1;return e==e?n?e-n:e:0}function os(t){return t?Zn(is(t),0,4294967295):0}function as(t){if("number"==typeof t)return t;if(_a(t))return NaN;if(Ga(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=Ga(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=je(t);var n=ot.test(t);return n||st.test(t)?Gt(t.slice(2),n?2:8):it.test(t)?NaN:+t}function ss(t){return bi(t,xs(t))}function cs(t){return null==t?"":_r(t)}var ls=wi((function(t,e){if(ho(e)||Pa(e))bi(e,ws(e),t);else for(var n in e)At.call(e,n)&&Gn(t,n,e[n])})),us=wi((function(t,e){bi(e,xs(e),t)})),ds=wi((function(t,e,n,r){bi(e,xs(e),t,r)})),fs=wi((function(t,e,n,r){bi(e,ws(e),t,r)})),hs=Ji(Vn);var ps=Lr((function(t,e){t=pt(t);var n=-1,r=e.length,i=r>2?e[2]:void 0;for(i&&co(e[0],e[1],i)&&(r=1);++n<r;)for(var o=e[n],a=xs(o),s=-1,c=a.length;++s<c;){var l=a[s],u=t[l];(void 0===u||ja(u,kt[l])&&!At.call(t,l))&&(t[l]=o[l])}return t})),gs=Lr((function(t){return t.push(void 0,qi),oe(Ss,void 0,t)}));function ms(t,e,n){var r=null==t?void 0:fr(t,e);return void 0===r?n:r}function ys(t,e){return null!=t&&io(t,e,yr)}var vs=ji((function(t,e,n){null!=e&&"function"!=typeof e.toString&&(e=Et.call(e)),t[e]=n}),Gs(Ks)),bs=ji((function(t,e,n){null!=e&&"function"!=typeof e.toString&&(e=Et.call(e)),At.call(t,e)?t[e].push(n):t[e]=[n]}),Xi),ks=Lr(br);function ws(t){return Pa(t)?Ln(t):Or(t)}function xs(t){return Pa(t)?Ln(t,!0):Er(t)}var As=wi((function(t,e,n){Ir(t,e,n)})),Ss=wi((function(t,e,n,r){Ir(t,e,n,r)})),Os=Ji((function(t,e){var n={};if(null==t)return n;var r=!1;e=he(e,(function(e){return e=ci(e,t),r||(r=e.length>1),e})),bi(t,Ki(t),n),r&&(n=Xn(n,7,Ni));for(var i=e.length;i--;)ti(n,e[i]);return n}));var Es=Ji((function(t,e){return null==t?{}:function(t,e){return Tr(t,e,(function(e,n){return ys(t,n)}))}(t,e)}));function Ms(t,e){if(null==t)return{};var n=he(Ki(t),(function(t){return[t]}));return e=Xi(e),Tr(t,n,(function(t,n){return e(t,n[0])}))}var Cs=Li(ws),Rs=Li(xs);function js(t){return null==t?[]:Be(t,ws(t))}var Is=Oi((function(t,e,n){return e=e.toLowerCase(),t+(n?Bs(e):e)}));function Bs(t){return Ys(cs(t).toLowerCase())}function Ds(t){return(t=cs(t))&&t.replace(lt,ze).replace(Dt,"")}var Ts=Oi((function(t,e,n){return t+(n?"-":"")+e.toLowerCase()})),Fs=Oi((function(t,e,n){return t+(n?" ":"")+e.toLowerCase()})),Ps=Si("toLowerCase");var zs=Oi((function(t,e,n){return t+(n?"_":"")+e.toLowerCase()}));var Qs=Oi((function(t,e,n){return t+(n?" ":"")+Ys(e)}));var Ls=Oi((function(t,e,n){return t+(n?" ":"")+e.toUpperCase()})),Ys=Si("toUpperCase");function Ws(t,e,n){return t=cs(t),void 0===(e=n?void 0:e)?function(t){return zt.test(t)}(t)?function(t){return t.match(Ft)||[]}(t):function(t){return t.match($)||[]}(t):t.match(e)||[]}var qs=Lr((function(t,e){try{return oe(t,void 0,e)}catch(t){return Ya(t)?t:new V(t)}})),Ns=Ji((function(t,e){return se(e,(function(e){e=Mo(e),Hn(t,e,ba(t[e],t))})),t}));function Gs(t){return function(){return t}}var Js=Ci(),Us=Ci(!0);function Ks(t){return t}function Hs(t){return Sr("function"==typeof t?t:Xn(t,1))}var Vs=Lr((function(t,e){return function(n){return br(n,t,e)}})),Zs=Lr((function(t,e){return function(n){return br(t,n,e)}}));function Xs(t,e,n){var r=ws(e),i=dr(e,r);null!=n||Ga(e)&&(i.length||!r.length)||(n=e,e=t,t=this,i=dr(e,ws(e)));var o=!(Ga(n)&&"chain"in n&&!n.chain),a=Wa(t);return se(i,(function(n){var r=e[n];t[n]=r,a&&(t.prototype[n]=function(){var e=this.__chain__;if(o||e){var n=t(this.__wrapped__),i=n.__actions__=vi(this.__actions__);return i.push({func:r,args:arguments,thisArg:t}),n.__chain__=e,n}return r.apply(t,pe([this.value()],arguments))})})),t}function _s(){}var $s=Bi(he),tc=Bi(le),ec=Bi(ye);function nc(t){return lo(t)?Oe(Mo(t)):function(t){return function(e){return fr(e,t)}}(t)}var rc=Ti(),ic=Ti(!0);function oc(){return[]}function ac(){return!1}var sc=Ii((function(t,e){return t+e}),0),cc=zi("ceil"),lc=Ii((function(t,e){return t/e}),1),uc=zi("floor");var dc,fc=Ii((function(t,e){return t*e}),1),hc=zi("round"),pc=Ii((function(t,e){return t-e}),0);return Rn.after=function(t,e){if("function"!=typeof e)throw new yt(o);return t=is(t),function(){if(--t<1)return e.apply(this,arguments)}},Rn.ary=ya,Rn.assign=ls,Rn.assignIn=us,Rn.assignInWith=ds,Rn.assignWith=fs,Rn.at=hs,Rn.before=va,Rn.bind=ba,Rn.bindAll=Ns,Rn.bindKey=ka,Rn.castArray=function(){if(!arguments.length)return[];var t=arguments[0];return Ta(t)?t:[t]},Rn.chain=na,Rn.chunk=function(t,e,n){e=(n?co(t,e,n):void 0===e)?1:sn(is(e),0);var i=null==t?0:t.length;if(!i||e<1)return[];for(var o=0,a=0,s=r($e(i/e));o<i;)s[a++]=Ur(t,o,o+=e);return s},Rn.compact=function(t){for(var e=-1,n=null==t?0:t.length,r=0,i=[];++e<n;){var o=t[e];o&&(i[r++]=o)}return i},Rn.concat=function(){var t=arguments.length;if(!t)return[];for(var e=r(t-1),n=arguments[0],i=t;i--;)e[i-1]=arguments[i];return pe(Ta(n)?vi(n):[n],ar(e,1))},Rn.cond=function(t){var e=null==t?0:t.length,n=Xi();return t=e?he(t,(function(t){if("function"!=typeof t[1])throw new yt(o);return[n(t[0]),t[1]]})):[],Lr((function(n){for(var r=-1;++r<e;){var i=t[r];if(oe(i[0],this,n))return oe(i[1],this,n)}}))},Rn.conforms=function(t){return function(t){var e=ws(t);return function(n){return _n(n,t,e)}}(Xn(t,1))},Rn.constant=Gs,Rn.countBy=oa,Rn.create=function(t,e){var n=jn(t);return null==e?n:Kn(n,e)},Rn.curry=function t(e,n,r){var i=Yi(e,8,void 0,void 0,void 0,void 0,void 0,n=r?void 0:n);return i.placeholder=t.placeholder,i},Rn.curryRight=function t(e,n,r){var i=Yi(e,16,void 0,void 0,void 0,void 0,void 0,n=r?void 0:n);return i.placeholder=t.placeholder,i},Rn.debounce=wa,Rn.defaults=ps,Rn.defaultsDeep=gs,Rn.defer=xa,Rn.delay=Aa,Rn.difference=jo,Rn.differenceBy=Io,Rn.differenceWith=Bo,Rn.drop=function(t,e,n){var r=null==t?0:t.length;return r?Ur(t,(e=n||void 0===e?1:is(e))<0?0:e,r):[]},Rn.dropRight=function(t,e,n){var r=null==t?0:t.length;return r?Ur(t,0,(e=r-(e=n||void 0===e?1:is(e)))<0?0:e):[]},Rn.dropRightWhile=function(t,e){return t&&t.length?ni(t,Xi(e,3),!0,!0):[]},Rn.dropWhile=function(t,e){return t&&t.length?ni(t,Xi(e,3),!0):[]},Rn.fill=function(t,e,n,r){var i=null==t?0:t.length;return i?(n&&"number"!=typeof n&&co(t,e,n)&&(n=0,r=i),function(t,e,n,r){var i=t.length;for((n=is(n))<0&&(n=-n>i?0:i+n),(r=void 0===r||r>i?i:is(r))<0&&(r+=i),r=n>r?0:os(r);n<r;)t[n++]=e;return t}(t,e,n,r)):[]},Rn.filter=function(t,e){return(Ta(t)?ue:or)(t,Xi(e,3))},Rn.flatMap=function(t,e){return ar(ha(t,e),1)},Rn.flatMapDeep=function(t,e){return ar(ha(t,e),1/0)},Rn.flatMapDepth=function(t,e,n){return n=void 0===n?1:is(n),ar(ha(t,e),n)},Rn.flatten=Fo,Rn.flattenDeep=function(t){return(null==t?0:t.length)?ar(t,1/0):[]},Rn.flattenDepth=function(t,e){return(null==t?0:t.length)?ar(t,e=void 0===e?1:is(e)):[]},Rn.flip=function(t){return Yi(t,512)},Rn.flow=Js,Rn.flowRight=Us,Rn.fromPairs=function(t){for(var e=-1,n=null==t?0:t.length,r={};++e<n;){var i=t[e];r[i[0]]=i[1]}return r},Rn.functions=function(t){return null==t?[]:dr(t,ws(t))},Rn.functionsIn=function(t){return null==t?[]:dr(t,xs(t))},Rn.groupBy=ua,Rn.initial=function(t){return(null==t?0:t.length)?Ur(t,0,-1):[]},Rn.intersection=zo,Rn.intersectionBy=Qo,Rn.intersectionWith=Lo,Rn.invert=vs,Rn.invertBy=bs,Rn.invokeMap=da,Rn.iteratee=Hs,Rn.keyBy=fa,Rn.keys=ws,Rn.keysIn=xs,Rn.map=ha,Rn.mapKeys=function(t,e){var n={};return e=Xi(e,3),lr(t,(function(t,r,i){Hn(n,e(t,r,i),t)})),n},Rn.mapValues=function(t,e){var n={};return e=Xi(e,3),lr(t,(function(t,r,i){Hn(n,r,e(t,r,i))})),n},Rn.matches=function(t){return Rr(Xn(t,1))},Rn.matchesProperty=function(t,e){return jr(t,Xn(e,1))},Rn.memoize=Sa,Rn.merge=As,Rn.mergeWith=Ss,Rn.method=Vs,Rn.methodOf=Zs,Rn.mixin=Xs,Rn.negate=Oa,Rn.nthArg=function(t){return t=is(t),Lr((function(e){return Br(e,t)}))},Rn.omit=Os,Rn.omitBy=function(t,e){return Ms(t,Oa(Xi(e)))},Rn.once=function(t){return va(2,t)},Rn.orderBy=function(t,e,n,r){return null==t?[]:(Ta(e)||(e=null==e?[]:[e]),Ta(n=r?void 0:n)||(n=null==n?[]:[n]),Dr(t,e,n))},Rn.over=$s,Rn.overArgs=Ea,Rn.overEvery=tc,Rn.overSome=ec,Rn.partial=Ma,Rn.partialRight=Ca,Rn.partition=pa,Rn.pick=Es,Rn.pickBy=Ms,Rn.property=nc,Rn.propertyOf=function(t){return function(e){return null==t?void 0:fr(t,e)}},Rn.pull=Wo,Rn.pullAll=qo,Rn.pullAllBy=function(t,e,n){return t&&t.length&&e&&e.length?Fr(t,e,Xi(n,2)):t},Rn.pullAllWith=function(t,e,n){return t&&t.length&&e&&e.length?Fr(t,e,void 0,n):t},Rn.pullAt=No,Rn.range=rc,Rn.rangeRight=ic,Rn.rearg=Ra,Rn.reject=function(t,e){return(Ta(t)?ue:or)(t,Oa(Xi(e,3)))},Rn.remove=function(t,e){var n=[];if(!t||!t.length)return n;var r=-1,i=[],o=t.length;for(e=Xi(e,3);++r<o;){var a=t[r];e(a,r,t)&&(n.push(a),i.push(r))}return Pr(t,i),n},Rn.rest=function(t,e){if("function"!=typeof t)throw new yt(o);return Lr(t,e=void 0===e?e:is(e))},Rn.reverse=Go,Rn.sampleSize=function(t,e,n){return e=(n?co(t,e,n):void 0===e)?1:is(e),(Ta(t)?Wn:Wr)(t,e)},Rn.set=function(t,e,n){return null==t?t:qr(t,e,n)},Rn.setWith=function(t,e,n,r){return r="function"==typeof r?r:void 0,null==t?t:qr(t,e,n,r)},Rn.shuffle=function(t){return(Ta(t)?qn:Jr)(t)},Rn.slice=function(t,e,n){var r=null==t?0:t.length;return r?(n&&"number"!=typeof n&&co(t,e,n)?(e=0,n=r):(e=null==e?0:is(e),n=void 0===n?r:is(n)),Ur(t,e,n)):[]},Rn.sortBy=ga,Rn.sortedUniq=function(t){return t&&t.length?Zr(t):[]},Rn.sortedUniqBy=function(t,e){return t&&t.length?Zr(t,Xi(e,2)):[]},Rn.split=function(t,e,n){return n&&"number"!=typeof n&&co(t,e,n)&&(e=n=void 0),(n=void 0===n?4294967295:n>>>0)?(t=cs(t))&&("string"==typeof e||null!=e&&!Va(e))&&!(e=_r(e))&&Ye(t)?ui(Ke(t),0,n):t.split(e,n):[]},Rn.spread=function(t,e){if("function"!=typeof t)throw new yt(o);return e=null==e?0:sn(is(e),0),Lr((function(n){var r=n[e],i=ui(n,0,e);return r&&pe(i,r),oe(t,this,i)}))},Rn.tail=function(t){var e=null==t?0:t.length;return e?Ur(t,1,e):[]},Rn.take=function(t,e,n){return t&&t.length?Ur(t,0,(e=n||void 0===e?1:is(e))<0?0:e):[]},Rn.takeRight=function(t,e,n){var r=null==t?0:t.length;return r?Ur(t,(e=r-(e=n||void 0===e?1:is(e)))<0?0:e,r):[]},Rn.takeRightWhile=function(t,e){return t&&t.length?ni(t,Xi(e,3),!1,!0):[]},Rn.takeWhile=function(t,e){return t&&t.length?ni(t,Xi(e,3)):[]},Rn.tap=function(t,e){return e(t),t},Rn.throttle=function(t,e,n){var r=!0,i=!0;if("function"!=typeof t)throw new yt(o);return Ga(n)&&(r="leading"in n?!!n.leading:r,i="trailing"in n?!!n.trailing:i),wa(t,e,{leading:r,maxWait:e,trailing:i})},Rn.thru=ra,Rn.toArray=ns,Rn.toPairs=Cs,Rn.toPairsIn=Rs,Rn.toPath=function(t){return Ta(t)?he(t,Mo):_a(t)?[t]:vi(Eo(cs(t)))},Rn.toPlainObject=ss,Rn.transform=function(t,e,n){var r=Ta(t),i=r||Qa(t)||$a(t);if(e=Xi(e,4),null==n){var o=t&&t.constructor;n=i?r?new o:[]:Ga(t)&&Wa(o)?jn(qt(t)):{}}return(i?se:lr)(t,(function(t,r,i){return e(n,t,r,i)})),n},Rn.unary=function(t){return ya(t,1)},Rn.union=Jo,Rn.unionBy=Uo,Rn.unionWith=Ko,Rn.uniq=function(t){return t&&t.length?$r(t):[]},Rn.uniqBy=function(t,e){return t&&t.length?$r(t,Xi(e,2)):[]},Rn.uniqWith=function(t,e){return e="function"==typeof e?e:void 0,t&&t.length?$r(t,void 0,e):[]},Rn.unset=function(t,e){return null==t||ti(t,e)},Rn.unzip=Ho,Rn.unzipWith=Vo,Rn.update=function(t,e,n){return null==t?t:ei(t,e,si(n))},Rn.updateWith=function(t,e,n,r){return r="function"==typeof r?r:void 0,null==t?t:ei(t,e,si(n),r)},Rn.values=js,Rn.valuesIn=function(t){return null==t?[]:Be(t,xs(t))},Rn.without=Zo,Rn.words=Ws,Rn.wrap=function(t,e){return Ma(si(e),t)},Rn.xor=Xo,Rn.xorBy=_o,Rn.xorWith=$o,Rn.zip=ta,Rn.zipObject=function(t,e){return oi(t||[],e||[],Gn)},Rn.zipObjectDeep=function(t,e){return oi(t||[],e||[],qr)},Rn.zipWith=ea,Rn.entries=Cs,Rn.entriesIn=Rs,Rn.extend=us,Rn.extendWith=ds,Xs(Rn,Rn),Rn.add=sc,Rn.attempt=qs,Rn.camelCase=Is,Rn.capitalize=Bs,Rn.ceil=cc,Rn.clamp=function(t,e,n){return void 0===n&&(n=e,e=void 0),void 0!==n&&(n=(n=as(n))==n?n:0),void 0!==e&&(e=(e=as(e))==e?e:0),Zn(as(t),e,n)},Rn.clone=function(t){return Xn(t,4)},Rn.cloneDeep=function(t){return Xn(t,5)},Rn.cloneDeepWith=function(t,e){return Xn(t,5,e="function"==typeof e?e:void 0)},Rn.cloneWith=function(t,e){return Xn(t,4,e="function"==typeof e?e:void 0)},Rn.conformsTo=function(t,e){return null==e||_n(t,e,ws(e))},Rn.deburr=Ds,Rn.defaultTo=function(t,e){return null==t||t!=t?e:t},Rn.divide=lc,Rn.endsWith=function(t,e,n){t=cs(t),e=_r(e);var r=t.length,i=n=void 0===n?r:Zn(is(n),0,r);return(n-=e.length)>=0&&t.slice(n,i)==e},Rn.eq=ja,Rn.escape=function(t){return(t=cs(t))&&L.test(t)?t.replace(z,Qe):t},Rn.escapeRegExp=function(t){return(t=cs(t))&&K.test(t)?t.replace(U,"\\$&"):t},Rn.every=function(t,e,n){var r=Ta(t)?le:rr;return n&&co(t,e,n)&&(e=void 0),r(t,Xi(e,3))},Rn.find=aa,Rn.findIndex=Do,Rn.findKey=function(t,e){return be(t,Xi(e,3),lr)},Rn.findLast=sa,Rn.findLastIndex=To,Rn.findLastKey=function(t,e){return be(t,Xi(e,3),ur)},Rn.floor=uc,Rn.forEach=ca,Rn.forEachRight=la,Rn.forIn=function(t,e){return null==t?t:sr(t,Xi(e,3),xs)},Rn.forInRight=function(t,e){return null==t?t:cr(t,Xi(e,3),xs)},Rn.forOwn=function(t,e){return t&&lr(t,Xi(e,3))},Rn.forOwnRight=function(t,e){return t&&ur(t,Xi(e,3))},Rn.get=ms,Rn.gt=Ia,Rn.gte=Ba,Rn.has=function(t,e){return null!=t&&io(t,e,mr)},Rn.hasIn=ys,Rn.head=Po,Rn.identity=Ks,Rn.includes=function(t,e,n,r){t=Pa(t)?t:js(t),n=n&&!r?is(n):0;var i=t.length;return n<0&&(n=sn(i+n,0)),Xa(t)?n<=i&&t.indexOf(e,n)>-1:!!i&&we(t,e,n)>-1},Rn.indexOf=function(t,e,n){var r=null==t?0:t.length;if(!r)return-1;var i=null==n?0:is(n);return i<0&&(i=sn(r+i,0)),we(t,e,i)},Rn.inRange=function(t,e,n){return e=rs(e),void 0===n?(n=e,e=0):n=rs(n),function(t,e,n){return t>=cn(e,n)&&t<sn(e,n)}(t=as(t),e,n)},Rn.invoke=ks,Rn.isArguments=Da,Rn.isArray=Ta,Rn.isArrayBuffer=Fa,Rn.isArrayLike=Pa,Rn.isArrayLikeObject=za,Rn.isBoolean=function(t){return!0===t||!1===t||Ja(t)&&pr(t)==u},Rn.isBuffer=Qa,Rn.isDate=La,Rn.isElement=function(t){return Ja(t)&&1===t.nodeType&&!Ha(t)},Rn.isEmpty=function(t){if(null==t)return!0;if(Pa(t)&&(Ta(t)||"string"==typeof t||"function"==typeof t.splice||Qa(t)||$a(t)||Da(t)))return!t.length;var e=ro(t);if(e==g||e==b)return!t.size;if(ho(t))return!Or(t).length;for(var n in t)if(At.call(t,n))return!1;return!0},Rn.isEqual=function(t,e){return wr(t,e)},Rn.isEqualWith=function(t,e,n){var r=(n="function"==typeof n?n:void 0)?n(t,e):void 0;return void 0===r?wr(t,e,void 0,n):!!r},Rn.isError=Ya,Rn.isFinite=function(t){return"number"==typeof t&&rn(t)},Rn.isFunction=Wa,Rn.isInteger=qa,Rn.isLength=Na,Rn.isMap=Ua,Rn.isMatch=function(t,e){return t===e||xr(t,e,$i(e))},Rn.isMatchWith=function(t,e,n){return n="function"==typeof n?n:void 0,xr(t,e,$i(e),n)},Rn.isNaN=function(t){return Ka(t)&&t!=+t},Rn.isNative=function(t){if(fo(t))throw new V("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Ar(t)},Rn.isNil=function(t){return null==t},Rn.isNull=function(t){return null===t},Rn.isNumber=Ka,Rn.isObject=Ga,Rn.isObjectLike=Ja,Rn.isPlainObject=Ha,Rn.isRegExp=Va,Rn.isSafeInteger=function(t){return qa(t)&&t>=-9007199254740991&&t<=9007199254740991},Rn.isSet=Za,Rn.isString=Xa,Rn.isSymbol=_a,Rn.isTypedArray=$a,Rn.isUndefined=function(t){return void 0===t},Rn.isWeakMap=function(t){return Ja(t)&&ro(t)==x},Rn.isWeakSet=function(t){return Ja(t)&&"[object WeakSet]"==pr(t)},Rn.join=function(t,e){return null==t?"":on.call(t,e)},Rn.kebabCase=Ts,Rn.last=Yo,Rn.lastIndexOf=function(t,e,n){var r=null==t?0:t.length;if(!r)return-1;var i=r;return void 0!==n&&(i=(i=is(n))<0?sn(r+i,0):cn(i,r-1)),e==e?function(t,e,n){for(var r=n+1;r--;)if(t[r]===e)return r;return r}(t,e,i):ke(t,Ae,i,!0)},Rn.lowerCase=Fs,Rn.lowerFirst=Ps,Rn.lt=ts,Rn.lte=es,Rn.max=function(t){return t&&t.length?ir(t,Ks,gr):void 0},Rn.maxBy=function(t,e){return t&&t.length?ir(t,Xi(e,2),gr):void 0},Rn.mean=function(t){return Se(t,Ks)},Rn.meanBy=function(t,e){return Se(t,Xi(e,2))},Rn.min=function(t){return t&&t.length?ir(t,Ks,Mr):void 0},Rn.minBy=function(t,e){return t&&t.length?ir(t,Xi(e,2),Mr):void 0},Rn.stubArray=oc,Rn.stubFalse=ac,Rn.stubObject=function(){return{}},Rn.stubString=function(){return""},Rn.stubTrue=function(){return!0},Rn.multiply=fc,Rn.nth=function(t,e){return t&&t.length?Br(t,is(e)):void 0},Rn.noConflict=function(){return Kt._===this&&(Kt._=Ct),this},Rn.noop=_s,Rn.now=ma,Rn.pad=function(t,e,n){t=cs(t);var r=(e=is(e))?Ue(t):0;if(!e||r>=e)return t;var i=(e-r)/2;return Di(tn(i),n)+t+Di($e(i),n)},Rn.padEnd=function(t,e,n){t=cs(t);var r=(e=is(e))?Ue(t):0;return e&&r<e?t+Di(e-r,n):t},Rn.padStart=function(t,e,n){t=cs(t);var r=(e=is(e))?Ue(t):0;return e&&r<e?Di(e-r,n)+t:t},Rn.parseInt=function(t,e,n){return n||null==e?e=0:e&&(e=+e),un(cs(t).replace(H,""),e||0)},Rn.random=function(t,e,n){if(n&&"boolean"!=typeof n&&co(t,e,n)&&(e=n=void 0),void 0===n&&("boolean"==typeof e?(n=e,e=void 0):"boolean"==typeof t&&(n=t,t=void 0)),void 0===t&&void 0===e?(t=0,e=1):(t=rs(t),void 0===e?(e=t,t=0):e=rs(e)),t>e){var r=t;t=e,e=r}if(n||t%1||e%1){var i=dn();return cn(t+i*(e-t+Nt("1e-"+((i+"").length-1))),e)}return zr(t,e)},Rn.reduce=function(t,e,n){var r=Ta(t)?ge:Me,i=arguments.length<3;return r(t,Xi(e,4),n,i,er)},Rn.reduceRight=function(t,e,n){var r=Ta(t)?me:Me,i=arguments.length<3;return r(t,Xi(e,4),n,i,nr)},Rn.repeat=function(t,e,n){return e=(n?co(t,e,n):void 0===e)?1:is(e),Qr(cs(t),e)},Rn.replace=function(){var t=arguments,e=cs(t[0]);return t.length<3?e:e.replace(t[1],t[2])},Rn.result=function(t,e,n){var r=-1,i=(e=ci(e,t)).length;for(i||(i=1,t=void 0);++r<i;){var o=null==t?void 0:t[Mo(e[r])];void 0===o&&(r=i,o=n),t=Wa(o)?o.call(t):o}return t},Rn.round=hc,Rn.runInContext=t,Rn.sample=function(t){return(Ta(t)?Yn:Yr)(t)},Rn.size=function(t){if(null==t)return 0;if(Pa(t))return Xa(t)?Ue(t):t.length;var e=ro(t);return e==g||e==b?t.size:Or(t).length},Rn.snakeCase=zs,Rn.some=function(t,e,n){var r=Ta(t)?ye:Kr;return n&&co(t,e,n)&&(e=void 0),r(t,Xi(e,3))},Rn.sortedIndex=function(t,e){return Hr(t,e)},Rn.sortedIndexBy=function(t,e,n){return Vr(t,e,Xi(n,2))},Rn.sortedIndexOf=function(t,e){var n=null==t?0:t.length;if(n){var r=Hr(t,e);if(r<n&&ja(t[r],e))return r}return-1},Rn.sortedLastIndex=function(t,e){return Hr(t,e,!0)},Rn.sortedLastIndexBy=function(t,e,n){return Vr(t,e,Xi(n,2),!0)},Rn.sortedLastIndexOf=function(t,e){if(null==t?0:t.length){var n=Hr(t,e,!0)-1;if(ja(t[n],e))return n}return-1},Rn.startCase=Qs,Rn.startsWith=function(t,e,n){return t=cs(t),n=null==n?0:Zn(is(n),0,t.length),e=_r(e),t.slice(n,n+e.length)==e},Rn.subtract=pc,Rn.sum=function(t){return t&&t.length?Ce(t,Ks):0},Rn.sumBy=function(t,e){return t&&t.length?Ce(t,Xi(e,2)):0},Rn.template=function(t,e,n){var r=Rn.templateSettings;n&&co(t,e,n)&&(e=void 0),t=cs(t),e=ds({},e,r,Wi);var i,o,a=ds({},e.imports,r.imports,Wi),s=ws(a),c=Be(a,s),l=0,u=e.interpolate||ut,d="__p += '",f=gt((e.escape||ut).source+"|"+u.source+"|"+(u===q?nt:ut).source+"|"+(e.evaluate||ut).source+"|$","g"),h="//# sourceURL="+(At.call(e,"sourceURL")?(e.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++Lt+"]")+"\n";t.replace(f,(function(e,n,r,a,s,c){return r||(r=a),d+=t.slice(l,c).replace(dt,Le),n&&(i=!0,d+="' +\n__e("+n+") +\n'"),s&&(o=!0,d+="';\n"+s+";\n__p += '"),r&&(d+="' +\n((__t = ("+r+")) == null ? '' : __t) +\n'"),l=c+e.length,e})),d+="';\n";var p=At.call(e,"variable")&&e.variable;if(p){if(tt.test(p))throw new V("Invalid `variable` option passed into `_.template`")}else d="with (obj) {\n"+d+"\n}\n";d=(o?d.replace(D,""):d).replace(T,"$1").replace(F,"$1;"),d="function("+(p||"obj")+") {\n"+(p?"":"obj || (obj = {});\n")+"var __t, __p = ''"+(i?", __e = _.escape":"")+(o?", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n":";\n")+d+"return __p\n}";var g=qs((function(){return ft(s,h+"return "+d).apply(void 0,c)}));if(g.source=d,Ya(g))throw g;return g},Rn.times=function(t,e){if((t=is(t))<1||t>9007199254740991)return[];var n=4294967295,r=cn(t,4294967295);t-=4294967295;for(var i=Re(r,e=Xi(e));++n<t;)e(n);return i},Rn.toFinite=rs,Rn.toInteger=is,Rn.toLength=os,Rn.toLower=function(t){return cs(t).toLowerCase()},Rn.toNumber=as,Rn.toSafeInteger=function(t){return t?Zn(is(t),-9007199254740991,9007199254740991):0===t?t:0},Rn.toString=cs,Rn.toUpper=function(t){return cs(t).toUpperCase()},Rn.trim=function(t,e,n){if((t=cs(t))&&(n||void 0===e))return je(t);if(!t||!(e=_r(e)))return t;var r=Ke(t),i=Ke(e);return ui(r,Te(r,i),Fe(r,i)+1).join("")},Rn.trimEnd=function(t,e,n){if((t=cs(t))&&(n||void 0===e))return t.slice(0,He(t)+1);if(!t||!(e=_r(e)))return t;var r=Ke(t);return ui(r,0,Fe(r,Ke(e))+1).join("")},Rn.trimStart=function(t,e,n){if((t=cs(t))&&(n||void 0===e))return t.replace(H,"");if(!t||!(e=_r(e)))return t;var r=Ke(t);return ui(r,Te(r,Ke(e))).join("")},Rn.truncate=function(t,e){var n=30,r="...";if(Ga(e)){var i="separator"in e?e.separator:i;n="length"in e?is(e.length):n,r="omission"in e?_r(e.omission):r}var o=(t=cs(t)).length;if(Ye(t)){var a=Ke(t);o=a.length}if(n>=o)return t;var s=n-Ue(r);if(s<1)return r;var c=a?ui(a,0,s).join(""):t.slice(0,s);if(void 0===i)return c+r;if(a&&(s+=c.length-s),Va(i)){if(t.slice(s).search(i)){var l,u=c;for(i.global||(i=gt(i.source,cs(rt.exec(i))+"g")),i.lastIndex=0;l=i.exec(u);)var d=l.index;c=c.slice(0,void 0===d?s:d)}}else if(t.indexOf(_r(i),s)!=s){var f=c.lastIndexOf(i);f>-1&&(c=c.slice(0,f))}return c+r},Rn.unescape=function(t){return(t=cs(t))&&Q.test(t)?t.replace(P,Ve):t},Rn.uniqueId=function(t){var e=++St;return cs(t)+e},Rn.upperCase=Ls,Rn.upperFirst=Ys,Rn.each=ca,Rn.eachRight=la,Rn.first=Po,Xs(Rn,(dc={},lr(Rn,(function(t,e){At.call(Rn.prototype,e)||(dc[e]=t)})),dc),{chain:!1}),Rn.VERSION="4.17.21",se(["bind","bindKey","curry","curryRight","partial","partialRight"],(function(t){Rn[t].placeholder=Rn})),se(["drop","take"],(function(t,e){Dn.prototype[t]=function(n){n=void 0===n?1:sn(is(n),0);var r=this.__filtered__&&!e?new Dn(this):this.clone();return r.__filtered__?r.__takeCount__=cn(n,r.__takeCount__):r.__views__.push({size:cn(n,4294967295),type:t+(r.__dir__<0?"Right":"")}),r},Dn.prototype[t+"Right"]=function(e){return this.reverse()[t](e).reverse()}})),se(["filter","map","takeWhile"],(function(t,e){var n=e+1,r=1==n||3==n;Dn.prototype[t]=function(t){var e=this.clone();return e.__iteratees__.push({iteratee:Xi(t,3),type:n}),e.__filtered__=e.__filtered__||r,e}})),se(["head","last"],(function(t,e){var n="take"+(e?"Right":"");Dn.prototype[t]=function(){return this[n](1).value()[0]}})),se(["initial","tail"],(function(t,e){var n="drop"+(e?"":"Right");Dn.prototype[t]=function(){return this.__filtered__?new Dn(this):this[n](1)}})),Dn.prototype.compact=function(){return this.filter(Ks)},Dn.prototype.find=function(t){return this.filter(t).head()},Dn.prototype.findLast=function(t){return this.reverse().find(t)},Dn.prototype.invokeMap=Lr((function(t,e){return"function"==typeof t?new Dn(this):this.map((function(n){return br(n,t,e)}))})),Dn.prototype.reject=function(t){return this.filter(Oa(Xi(t)))},Dn.prototype.slice=function(t,e){t=is(t);var n=this;return n.__filtered__&&(t>0||e<0)?new Dn(n):(t<0?n=n.takeRight(-t):t&&(n=n.drop(t)),void 0!==e&&(n=(e=is(e))<0?n.dropRight(-e):n.take(e-t)),n)},Dn.prototype.takeRightWhile=function(t){return this.reverse().takeWhile(t).reverse()},Dn.prototype.toArray=function(){return this.take(4294967295)},lr(Dn.prototype,(function(t,e){var n=/^(?:filter|find|map|reject)|While$/.test(e),r=/^(?:head|last)$/.test(e),i=Rn[r?"take"+("last"==e?"Right":""):e],o=r||/^find/.test(e);i&&(Rn.prototype[e]=function(){var e=this.__wrapped__,a=r?[1]:arguments,s=e instanceof Dn,c=a[0],l=s||Ta(e),u=function(t){var e=i.apply(Rn,pe([t],a));return r&&d?e[0]:e};l&&n&&"function"==typeof c&&1!=c.length&&(s=l=!1);var d=this.__chain__,f=!!this.__actions__.length,h=o&&!d,p=s&&!f;if(!o&&l){e=p?e:new Dn(this);var g=t.apply(e,a);return g.__actions__.push({func:ra,args:[u],thisArg:void 0}),new Bn(g,d)}return h&&p?t.apply(this,a):(g=this.thru(u),h?r?g.value()[0]:g.value():g)})})),se(["pop","push","shift","sort","splice","unshift"],(function(t){var e=vt[t],n=/^(?:push|sort|unshift)$/.test(t)?"tap":"thru",r=/^(?:pop|shift)$/.test(t);Rn.prototype[t]=function(){var t=arguments;if(r&&!this.__chain__){var i=this.value();return e.apply(Ta(i)?i:[],t)}return this[n]((function(n){return e.apply(Ta(n)?n:[],t)}))}})),lr(Dn.prototype,(function(t,e){var n=Rn[e];if(n){var r=n.name+"";At.call(kn,r)||(kn[r]=[]),kn[r].push({name:e,func:n})}})),kn[Ri(void 0,2).name]=[{name:"wrapper",func:void 0}],Dn.prototype.clone=function(){var t=new Dn(this.__wrapped__);return t.__actions__=vi(this.__actions__),t.__dir__=this.__dir__,t.__filtered__=this.__filtered__,t.__iteratees__=vi(this.__iteratees__),t.__takeCount__=this.__takeCount__,t.__views__=vi(this.__views__),t},Dn.prototype.reverse=function(){if(this.__filtered__){var t=new Dn(this);t.__dir__=-1,t.__filtered__=!0}else(t=this.clone()).__dir__*=-1;return t},Dn.prototype.value=function(){var t=this.__wrapped__.value(),e=this.__dir__,n=Ta(t),r=e<0,i=n?t.length:0,o=function(t,e,n){var r=-1,i=n.length;for(;++r<i;){var o=n[r],a=o.size;switch(o.type){case"drop":t+=a;break;case"dropRight":e-=a;break;case"take":e=cn(e,t+a);break;case"takeRight":t=sn(t,e-a)}}return{start:t,end:e}}(0,i,this.__views__),a=o.start,s=o.end,c=s-a,l=r?s:a-1,u=this.__iteratees__,d=u.length,f=0,h=cn(c,this.__takeCount__);if(!n||!r&&i==c&&h==c)return ri(t,this.__actions__);var p=[];t:for(;c--&&f<h;){for(var g=-1,m=t[l+=e];++g<d;){var y=u[g],v=y.iteratee,b=y.type,k=v(m);if(2==b)m=k;else if(!k){if(1==b)continue t;break t}}p[f++]=m}return p},Rn.prototype.at=ia,Rn.prototype.chain=function(){return na(this)},Rn.prototype.commit=function(){return new Bn(this.value(),this.__chain__)},Rn.prototype.next=function(){void 0===this.__values__&&(this.__values__=ns(this.value()));var t=this.__index__>=this.__values__.length;return{done:t,value:t?void 0:this.__values__[this.__index__++]}},Rn.prototype.plant=function(t){for(var e,n=this;n instanceof In;){var r=Ro(n);r.__index__=0,r.__values__=void 0,e?i.__wrapped__=r:e=r;var i=r;n=n.__wrapped__}return i.__wrapped__=t,e},Rn.prototype.reverse=function(){var t=this.__wrapped__;if(t instanceof Dn){var e=t;return this.__actions__.length&&(e=new Dn(this)),(e=e.reverse()).__actions__.push({func:ra,args:[Go],thisArg:void 0}),new Bn(e,this.__chain__)}return this.thru(Go)},Rn.prototype.toJSON=Rn.prototype.valueOf=Rn.prototype.value=function(){return ri(this.__wrapped__,this.__actions__)},Rn.prototype.first=Rn.prototype.head,Xt&&(Rn.prototype[Xt]=function(){return this}),Rn}();Kt._=Ze,void 0===(i=function(){return Ze}.call(e,n,e,r))||(r.exports=i)}).call(this)}).call(this,n(26),n(53)(t))},function(t,e,n){"use strict";t.exports=n(55)},function(t,e,n){"use strict";n.d(e,"w",(function(){return i})),n.d(e,"a",(function(){return vt})),n.d(e,"b",(function(){return P})),n.d(e,"c",(function(){return kt})),n.d(e,"d",(function(){return yt})),n.d(e,"e",(function(){return U})),n.d(e,"f",(function(){return ut})),n.d(e,"g",(function(){return Ct})),n.d(e,"h",(function(){return A})),n.d(e,"i",(function(){return Tt})),n.d(e,"j",(function(){return Bt})),n.d(e,"k",(function(){return E})),n.d(e,"l",(function(){return M})),n.d(e,"m",(function(){return R})),n.d(e,"n",(function(){return j})),n.d(e,"o",(function(){return W})),n.d(e,"p",(function(){return mt})),n.d(e,"q",(function(){return gt})),n.d(e,"r",(function(){return pt})),n.d(e,"s",(function(){return S})),n.d(e,"t",(function(){return Ft})),n.d(e,"u",(function(){return O})),n.d(e,"v",(function(){return x})),n.d(e,"x",(function(){return wt})),n.d(e,"y",(function(){return C})),n.d(e,"z",(function(){return Qt})),n.d(e,"A",(function(){return qt})),n.d(e,"B",(function(){return Yt})),n.d(e,"C",(function(){return Pt})),n.d(e,"D",(function(){return Wt}));let r=v();const i=t=>p(t,r);let o=v();i.write=t=>p(t,o);let a=v();i.onStart=t=>p(t,a);let s=v();i.onFrame=t=>p(t,s);let c=v();i.onFinish=t=>p(t,c);let l=[];i.setTimeout=(t,e)=>{let n=i.now()+e,r=()=>{let t=l.findIndex(t=>t.cancel==r);~t&&l.splice(t,1),k.count-=~t?1:0},o={time:n,handler:t,cancel:r};return l.splice(u(n),0,o),k.count+=1,g(),o};let u=t=>~(~l.findIndex(e=>e.time>t)||~l.length);i.cancel=t=>{r.delete(t),o.delete(t)},i.sync=t=>{h=!0,i.batchedUpdates(t),h=!1},i.throttle=t=>{let e;function n(){try{t(...e)}finally{e=null}}function r(...t){e=t,i.onStart(n)}return r.handler=t,r.cancel=()=>{a.delete(n),e=null},r};let d="undefined"!=typeof window?window.requestAnimationFrame:()=>{};i.use=t=>d=t,i.now="undefined"!=typeof performance?()=>performance.now():Date.now,i.batchedUpdates=t=>t(),i.catch=console.error,i.frameLoop="always",i.advance=()=>{"demand"!==i.frameLoop?console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"):y()};let f=-1,h=!1;function p(t,e){h?(e.delete(t),t(0)):(e.add(t),g())}function g(){f<0&&(f=0,"demand"!==i.frameLoop&&d(m))}function m(){~f&&(d(m),i.batchedUpdates(y))}function y(){let t=f;f=i.now();let e=u(f);e&&(b(l.splice(0,e),t=>t.handler()),k.count-=e),a.flush(),r.flush(t?Math.min(64,f-t):16.667),s.flush(),o.flush(),c.flush()}function v(){let t=new Set,e=t;return{add(n){k.count+=e!=t||t.has(n)?0:1,t.add(n)},delete:n=>(k.count-=e==t&&t.has(n)?1:0,t.delete(n)),flush(n){e.size&&(t=new Set,k.count-=e.size,b(e,e=>e(n)&&t.add(e)),k.count+=t.size,e=t)}}}function b(t,e){t.forEach(t=>{try{e(t)}catch(t){i.catch(t)}})}const k={count:0,clear(){f=-1,l=[],a=v(),r=v(),s=v(),o=v(),c=v(),k.count=0}};var w=n(2);function x(){}const A=(t,e,n)=>Object.defineProperty(t,e,{value:n,writable:!0,configurable:!0}),S={arr:Array.isArray,obj:t=>!!t&&"Object"===t.constructor.name,fun:t=>"function"==typeof t,str:t=>"string"==typeof t,num:t=>"number"==typeof t,und:t=>void 0===t};function O(t,e){if(S.arr(t)){if(!S.arr(e)||t.length!==e.length)return!1;for(let n=0;n<t.length;n++)if(t[n]!==e[n])return!1;return!0}return t===e}const E=(t,e)=>t.forEach(e);function M(t,e,n){for(const r in t)t.hasOwnProperty(r)&&e.call(n,t[r],r)}const C=t=>S.und(t)?[]:S.arr(t)?t:[t];function R(t,e){if(t.size){const n=Array.from(t);t.clear(),E(n,e)}}const j=(t,...e)=>R(t,t=>t(...e));let I,B,D=null,T=!1,F=x;var P=Object.freeze({__proto__:null,get createStringInterpolator(){return I},get to(){return B},get colors(){return D},get skipAnimation(){return T},get willAdvance(){return F},assign:t=>{t.to&&(B=t.to),t.now&&(i.now=t.now),void 0!==t.colors&&(D=t.colors),null!=t.skipAnimation&&(T=t.skipAnimation),t.createStringInterpolator&&(I=t.createStringInterpolator),t.requestAnimationFrame&&i.use(t.requestAnimationFrame),t.batchedUpdates&&(i.batchedUpdates=t.batchedUpdates),t.willAdvance&&(F=t.willAdvance),t.frameLoop&&(i.frameLoop=t.frameLoop)}});const z=new Set;let Q=[],L=[],Y=0;const W={get idle(){return!z.size&&!Q.length},start(t){Y>t.priority?(z.add(t),i.onStart(q)):(N(t),i(J))},advance:J,sort(t){if(Y)i.onFrame(()=>W.sort(t));else{const e=Q.indexOf(t);~e&&(Q.splice(e,1),G(t))}},clear(){Q=[],z.clear()}};function q(){z.forEach(N),z.clear(),i(J)}function N(t){Q.includes(t)||G(t)}function G(t){Q.splice(function(t,e){const n=t.findIndex(e);return n<0?t.length:n}(Q,e=>e.priority>t.priority),0,t)}function J(t){const e=L;for(let n=0;n<Q.length;n++){const r=Q[n];Y=r.priority,r.idle||(F(r),r.advance(t),r.idle||e.push(r))}return Y=0,L=Q,L.length=0,Q=e,Q.length>0}const U={transparent:0,aliceblue:4042850303,antiquewhite:4209760255,aqua:16777215,aquamarine:2147472639,azure:4043309055,beige:4126530815,bisque:4293182719,black:255,blanchedalmond:4293643775,blue:65535,blueviolet:2318131967,brown:2771004159,burlywood:3736635391,burntsienna:3934150143,cadetblue:1604231423,chartreuse:2147418367,chocolate:3530104575,coral:4286533887,cornflowerblue:1687547391,cornsilk:4294499583,crimson:3692313855,cyan:16777215,darkblue:35839,darkcyan:9145343,darkgoldenrod:3095792639,darkgray:2846468607,darkgreen:6553855,darkgrey:2846468607,darkkhaki:3182914559,darkmagenta:2332068863,darkolivegreen:1433087999,darkorange:4287365375,darkorchid:2570243327,darkred:2332033279,darksalmon:3918953215,darkseagreen:2411499519,darkslateblue:1211993087,darkslategray:793726975,darkslategrey:793726975,darkturquoise:13554175,darkviolet:2483082239,deeppink:4279538687,deepskyblue:12582911,dimgray:1768516095,dimgrey:1768516095,dodgerblue:512819199,firebrick:2988581631,floralwhite:4294635775,forestgreen:579543807,fuchsia:4278255615,gainsboro:3705462015,ghostwhite:4177068031,gold:4292280575,goldenrod:3668254975,gray:2155905279,green:8388863,greenyellow:2919182335,grey:2155905279,honeydew:4043305215,hotpink:4285117695,indianred:3445382399,indigo:1258324735,ivory:4294963455,khaki:4041641215,lavender:3873897215,lavenderblush:4293981695,lawngreen:2096890111,lemonchiffon:4294626815,lightblue:2916673279,lightcoral:4034953471,lightcyan:3774873599,lightgoldenrodyellow:4210742015,lightgray:3553874943,lightgreen:2431553791,lightgrey:3553874943,lightpink:4290167295,lightsalmon:4288707327,lightseagreen:548580095,lightskyblue:2278488831,lightslategray:2005441023,lightslategrey:2005441023,lightsteelblue:2965692159,lightyellow:4294959359,lime:16711935,limegreen:852308735,linen:4210091775,magenta:4278255615,maroon:2147483903,mediumaquamarine:1724754687,mediumblue:52735,mediumorchid:3126187007,mediumpurple:2473647103,mediumseagreen:1018393087,mediumslateblue:2070474495,mediumspringgreen:16423679,mediumturquoise:1221709055,mediumvioletred:3340076543,midnightblue:421097727,mintcream:4127193855,mistyrose:4293190143,moccasin:4293178879,navajowhite:4292783615,navy:33023,oldlace:4260751103,olive:2155872511,olivedrab:1804477439,orange:4289003775,orangered:4282712319,orchid:3664828159,palegoldenrod:4008225535,palegreen:2566625535,paleturquoise:2951671551,palevioletred:3681588223,papayawhip:4293907967,peachpuff:4292524543,peru:3448061951,pink:4290825215,plum:3718307327,powderblue:2967529215,purple:2147516671,rebeccapurple:1714657791,red:4278190335,rosybrown:3163525119,royalblue:1097458175,saddlebrown:2336560127,salmon:4202722047,sandybrown:4104413439,seagreen:780883967,seashell:4294307583,sienna:2689740287,silver:3233857791,skyblue:2278484991,slateblue:1784335871,slategray:1887473919,slategrey:1887473919,snow:4294638335,springgreen:16744447,steelblue:1182971135,tan:3535047935,teal:8421631,thistle:3636451583,tomato:4284696575,turquoise:1088475391,violet:4001558271,wheat:4125012991,white:4294967295,whitesmoke:4126537215,yellow:4294902015,yellowgreen:2597139199},K="[-+]?\\d*\\.?\\d+";function H(...t){return"\\(\\s*("+t.join(")\\s*,\\s*(")+")\\s*\\)"}const V=new RegExp("rgb"+H(K,K,K)),Z=new RegExp("rgba"+H(K,K,K,K)),X=new RegExp("hsl"+H(K,"[-+]?\\d*\\.?\\d+%","[-+]?\\d*\\.?\\d+%")),_=new RegExp("hsla"+H(K,"[-+]?\\d*\\.?\\d+%","[-+]?\\d*\\.?\\d+%",K)),$=/^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,tt=/^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,et=/^#([0-9a-fA-F]{6})$/,nt=/^#([0-9a-fA-F]{8})$/;function rt(t,e,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?t+6*(e-t)*n:n<.5?e:n<2/3?t+(e-t)*(2/3-n)*6:t}function it(t,e,n){const r=n<.5?n*(1+e):n+e-n*e,i=2*n-r,o=rt(i,r,t+1/3),a=rt(i,r,t),s=rt(i,r,t-1/3);return Math.round(255*o)<<24|Math.round(255*a)<<16|Math.round(255*s)<<8}function ot(t){const e=parseInt(t,10);return e<0?0:e>255?255:e}function at(t){return(parseFloat(t)%360+360)%360/360}function st(t){const e=parseFloat(t);return e<0?0:e>1?255:Math.round(255*e)}function ct(t){const e=parseFloat(t);return e<0?0:e>100?1:e/100}function lt(t){let e=function(t){let e;return"number"==typeof t?t>>>0===t&&t>=0&&t<=4294967295?t:null:(e=et.exec(t))?parseInt(e[1]+"ff",16)>>>0:D&&void 0!==D[t]?D[t]:(e=V.exec(t))?(ot(e[1])<<24|ot(e[2])<<16|ot(e[3])<<8|255)>>>0:(e=Z.exec(t))?(ot(e[1])<<24|ot(e[2])<<16|ot(e[3])<<8|st(e[4]))>>>0:(e=$.exec(t))?parseInt(e[1]+e[1]+e[2]+e[2]+e[3]+e[3]+"ff",16)>>>0:(e=nt.exec(t))?parseInt(e[1],16)>>>0:(e=tt.exec(t))?parseInt(e[1]+e[1]+e[2]+e[2]+e[3]+e[3]+e[4]+e[4],16)>>>0:(e=X.exec(t))?(255|it(at(e[1]),ct(e[2]),ct(e[3])))>>>0:(e=_.exec(t))?(it(at(e[1]),ct(e[2]),ct(e[3]))|st(e[4]))>>>0:null}(t);return null===e?t:(e=e||0,`rgba(${(4278190080&e)>>>24}, ${(16711680&e)>>>16}, ${(65280&e)>>>8}, ${(255&e)/255})`)}const ut=(t,e,n)=>{if(S.fun(t))return t;if(S.arr(t))return ut({range:t,output:e,extrapolate:n});if(S.str(t.output[0]))return I(t);const r=t,i=r.output,o=r.range||[0,1],a=r.extrapolateLeft||r.extrapolate||"extend",s=r.extrapolateRight||r.extrapolate||"extend",c=r.easing||(t=>t);return t=>{const e=function(t,e){for(var n=1;n<e.length-1&&!(e[n]>=t);++n);return n-1}(t,o);return function(t,e,n,r,i,o,a,s,c){let l=c?c(t):t;if(l<e){if("identity"===a)return l;"clamp"===a&&(l=e)}if(l>n){if("identity"===s)return l;"clamp"===s&&(l=n)}if(r===i)return r;if(e===n)return t<=e?r:i;e===-1/0?l=-l:n===1/0?l-=e:l=(l-e)/(n-e);l=o(l),r===-1/0?l=-l:i===1/0?l+=r:l=l*(i-r)+r;return l}(t,o[e],o[e+1],i[e],i[e+1],c,a,s,r.map)}};function dt(){return(dt=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}const ft=Symbol.for("FluidValue.get"),ht=Symbol.for("FluidValue.observers"),pt=t=>Boolean(t&&t[ft]),gt=t=>t&&t[ft]?t[ft]():t,mt=t=>t[ht]||null;function yt(t,e){let n=t[ht];n&&n.forEach(t=>{!function(t,e){t.eventObserved?t.eventObserved(e):t(e)}(t,e)})}class vt{constructor(t){if(this[ft]=void 0,this[ht]=void 0,!t&&!(t=this.get))throw Error("Unknown getter");bt(this,t)}}const bt=(t,e)=>xt(t,ft,e);function kt(t,e){if(t[ft]){let n=t[ht];n||xt(t,ht,n=new Set),n.has(e)||(n.add(e),t.observerAdded&&t.observerAdded(n.size,e))}return e}function wt(t,e){let n=t[ht];if(n&&n.has(e)){const r=n.size-1;r?n.delete(e):t[ht]=null,t.observerRemoved&&t.observerRemoved(r,e)}}const xt=(t,e,n)=>Object.defineProperty(t,e,{value:n,writable:!0,configurable:!0}),At=/[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,St=/(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;let Ot;const Et=/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi,Mt=(t,e,n,r,i)=>`rgba(${Math.round(e)}, ${Math.round(n)}, ${Math.round(r)}, ${i})`,Ct=t=>{Ot||(Ot=D?new RegExp(`(${Object.keys(D).join("|")})(?!\\w)`,"g"):/^\b$/);const e=t.output.map(t=>gt(t).replace(St,lt).replace(Ot,lt)),n=e.map(t=>t.match(At).map(Number)),r=n[0].map((t,e)=>n.map(t=>{if(!(e in t))throw Error('The arity of each "output" value must be equal');return t[e]})).map(e=>ut(dt({},t,{output:e})));return t=>{let n=0;return e[0].replace(At,()=>String(r[n++](t))).replace(Et,Mt)}},Rt="react-spring: ",jt=t=>{const e=t;let n=!1;if("function"!=typeof e)throw new TypeError(Rt+"once requires a function parameter");return(...t)=>{n||(e(...t),n=!0)}},It=jt(console.warn);function Bt(){It(Rt+'The "interpolate" function is deprecated in v9 (use "to" instead)')}const Dt=jt(console.warn);function Tt(){Dt(Rt+'Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions')}function Ft(t){return S.str(t)&&("#"==t[0]||/\d/.test(t)||t in(D||{}))}const Pt=t=>Object(w.useEffect)(t,zt),zt=[];function Qt(){const t=Object(w.useState)()[1],e=Object(w.useState)(Lt)[0];return Pt(e.unmount),()=>{e.current&&t({})}}function Lt(){const t={current:!0,unmount:()=>()=>{t.current=!1}};return t}function Yt(t,e){const[n]=Object(w.useState)(()=>({inputs:e,result:t()})),r=Object(w.useRef)(),i=r.current;let o=i;if(o){Boolean(e&&o.inputs&&function(t,e){if(t.length!==e.length)return!1;for(let n=0;n<t.length;n++)if(t[n]!==e[n])return!1;return!0}(e,o.inputs))||(o={inputs:e,result:t()})}else o=n;return Object(w.useEffect)(()=>{r.current=o,i==n&&(n.inputs=n.result=void 0)},[o]),o.result}function Wt(t){const e=Object(w.useRef)();return Object(w.useEffect)(()=>{e.current=t}),e.current}const qt="undefined"!=typeof window&&window.document&&window.document.createElement?w.useLayoutEffect:w.useEffect},function(t,e,n){t.exports=n(52)},function(e,n){e.exports=t},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(62),i=n(63),o=n(38),a=n(64);t.exports=function(t,e){return r(t)||i(t,e)||o(t,e)||a()},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){function n(t,e,n,r,i,o,a){try{var s=t[o](a),c=s.value}catch(t){return void n(t)}s.done?e(c):Promise.resolve(c).then(r,i)}t.exports=function(t){return function(){var e=this,r=arguments;return new Promise((function(i,o){var a=t.apply(e,r);function s(t){n(a,i,o,s,c,"next",t)}function c(t){n(a,i,o,s,c,"throw",t)}s(void 0)}))}},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){"use strict";var r=n(39);n.o(r,"Spring")&&n.d(e,"Spring",(function(){return r.Spring})),n.o(r,"animated")&&n.d(e,"animated",(function(){return r.animated})),n.o(r,"useSpring")&&n.d(e,"useSpring",(function(){return r.useSpring})),n.o(r,"useSprings")&&n.d(e,"useSprings",(function(){return r.useSprings})),n.o(r,"useTransition")&&n.d(e,"useTransition",(function(){return r.useTransition}))},function(t,e,n){var r=n(59),i=n(60),o=n(38),a=n(61);t.exports=function(t){return r(t)||i(t)||o(t)||a()},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t,e,r){return e&&n(t.prototype,e),r&&n(t,r),t},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){function n(e){return t.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},t.exports.default=t.exports,t.exports.__esModule=!0,n(e)}t.exports=n,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(58);t.exports=function(t,e){if(null==t)return{};var n,i,o=r(t,e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(t);for(i=0;i<a.length;i++)n=a[i],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(t,n)&&(o[n]=t[n])}return o},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){"use strict";!function t(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE){0;try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t)}catch(t){console.error(t)}}}(),t.exports=n(54)},function(t,e,n){var r=n(24).default,i=n(27);t.exports=function(t,e){return!e||"object"!==r(e)&&"function"!=typeof e?i(t):e},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){const r=n(65);e.parseFont=r,e.createCanvas=function(t,e){return Object.assign(document.createElement("canvas"),{width:t,height:e})},e.createImageData=function(t,e,n){switch(arguments.length){case 0:return new ImageData;case 1:return new ImageData(t);case 2:return new ImageData(t,e);default:return new ImageData(t,e,n)}},e.loadImage=function(t,e){return new Promise((function(n,r){const i=Object.assign(document.createElement("img"),e);function o(){i.onload=null,i.onerror=null}i.onload=function(){o(),n(i)},i.onerror=function(){o(),r(new Error('Failed to load the image "'+t+'"'))},i.src=t}))}},function(t,e,n){var r=n(25);t.exports=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&r(t,e)},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){"use strict";(function(t){var n=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var n=-1;return t.some((function(t,r){return t[0]===e&&(n=r,!0)})),n}return function(){function e(){this.__entries__=[]}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var n=t(this.__entries__,e),r=this.__entries__[n];return r&&r[1]},e.prototype.set=function(e,n){var r=t(this.__entries__,e);~r?this.__entries__[r][1]=n:this.__entries__.push([e,n])},e.prototype.delete=function(e){var n=this.__entries__,r=t(n,e);~r&&n.splice(r,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var n=0,r=this.__entries__;n<r.length;n++){var i=r[n];t.call(e,i[1],i[0])}},e}()}(),r="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,i=void 0!==t&&t.Math===Math?t:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),o="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(i):function(t){return setTimeout((function(){return t(Date.now())}),1e3/60)};var a=["top","right","bottom","left","width","height","size","weight"],s="undefined"!=typeof MutationObserver,c=function(){function t(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(t,e){var n=!1,r=!1,i=0;function a(){n&&(n=!1,t()),r&&c()}function s(){o(a)}function c(){var t=Date.now();if(n){if(t-i<2)return;r=!0}else n=!0,r=!1,setTimeout(s,e);i=t}return c}(this.refresh.bind(this),20)}return t.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},t.prototype.removeObserver=function(t){var e=this.observers_,n=e.indexOf(t);~n&&e.splice(n,1),!e.length&&this.connected_&&this.disconnect_()},t.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},t.prototype.updateObservers_=function(){var t=this.observers_.filter((function(t){return t.gatherActive(),t.hasActive()}));return t.forEach((function(t){return t.broadcastActive()})),t.length>0},t.prototype.connect_=function(){r&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),s?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},t.prototype.disconnect_=function(){r&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},t.prototype.onTransitionEnd_=function(t){var e=t.propertyName,n=void 0===e?"":e;a.some((function(t){return!!~n.indexOf(t)}))&&this.refresh()},t.getInstance=function(){return this.instance_||(this.instance_=new t),this.instance_},t.instance_=null,t}(),l=function(t,e){for(var n=0,r=Object.keys(e);n<r.length;n++){var i=r[n];Object.defineProperty(t,i,{value:e[i],enumerable:!1,writable:!1,configurable:!0})}return t},u=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||i},d=y(0,0,0,0);function f(t){return parseFloat(t)||0}function h(t){for(var e=[],n=1;n<arguments.length;n++)e[n-1]=arguments[n];return e.reduce((function(e,n){return e+f(t["border-"+n+"-width"])}),0)}function p(t){var e=t.clientWidth,n=t.clientHeight;if(!e&&!n)return d;var r=u(t).getComputedStyle(t),i=function(t){for(var e={},n=0,r=["top","right","bottom","left"];n<r.length;n++){var i=r[n],o=t["padding-"+i];e[i]=f(o)}return e}(r),o=i.left+i.right,a=i.top+i.bottom,s=f(r.width),c=f(r.height);if("border-box"===r.boxSizing&&(Math.round(s+o)!==e&&(s-=h(r,"left","right")+o),Math.round(c+a)!==n&&(c-=h(r,"top","bottom")+a)),!function(t){return t===u(t).document.documentElement}(t)){var l=Math.round(s+o)-e,p=Math.round(c+a)-n;1!==Math.abs(l)&&(s-=l),1!==Math.abs(p)&&(c-=p)}return y(i.left,i.top,s,c)}var g="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof u(t).SVGGraphicsElement}:function(t){return t instanceof u(t).SVGElement&&"function"==typeof t.getBBox};function m(t){return r?g(t)?function(t){var e=t.getBBox();return y(0,0,e.width,e.height)}(t):p(t):d}function y(t,e,n,r){return{x:t,y:e,width:n,height:r}}var v=function(){function t(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=y(0,0,0,0),this.target=t}return t.prototype.isActive=function(){var t=m(this.target);return this.contentRect_=t,t.width!==this.broadcastWidth||t.height!==this.broadcastHeight},t.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},t}(),b=function(t,e){var n,r,i,o,a,s,c,u=(r=(n=e).x,i=n.y,o=n.width,a=n.height,s="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,c=Object.create(s.prototype),l(c,{x:r,y:i,width:o,height:a,top:i,right:r+o,bottom:a+i,left:r}),c);l(this,{target:t,contentRect:u})},k=function(){function t(t,e,r){if(this.activeObservations_=[],this.observations_=new n,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=r}return t.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof u(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new v(t)),this.controller_.addObserver(this),this.controller_.refresh())}},t.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof u(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},t.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},t.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach((function(e){e.isActive()&&t.activeObservations_.push(e)}))},t.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map((function(t){return new b(t.target,t.broadcastRect())}));this.callback_.call(t,e,t),this.clearActive()}},t.prototype.clearActive=function(){this.activeObservations_.splice(0)},t.prototype.hasActive=function(){return this.activeObservations_.length>0},t}(),w="undefined"!=typeof WeakMap?new WeakMap:new n,x=function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var n=c.getInstance(),r=new k(e,n,this);w.set(this,r)};["observe","unobserve","disconnect"].forEach((function(t){x.prototype[t]=function(){var e;return(e=w.get(this))[t].apply(e,arguments)}}));var A=void 0!==i.ResizeObserver?i.ResizeObserver:x;e.a=A}).call(this,n(26))},function(t,e,n){"use strict";n.d(e,"a",(function(){return h})),n.d(e,"b",(function(){return d})),n.d(e,"c",(function(){return u})),n.d(e,"d",(function(){return w})),n.d(e,"e",(function(){return a})),n.d(e,"f",(function(){return m})),n.d(e,"g",(function(){return c})),n.d(e,"h",(function(){return s}));var r=n(3),i=n(2);const o=Symbol.for("Animated:node"),a=t=>t&&t[o],s=(t,e)=>Object(r.h)(t,o,e),c=t=>t&&t[o]&&t[o].getPayload();class l{constructor(){this.payload=void 0,s(this,this)}getPayload(){return this.payload||[]}}class u extends l{constructor(t){super(),this.done=!0,this.elapsedTime=void 0,this.lastPosition=void 0,this.lastVelocity=void 0,this.v0=void 0,this.durationProgress=0,this._value=t,r.s.num(this._value)&&(this.lastPosition=this._value)}static create(t){return new u(t)}getPayload(){return[this]}getValue(){return this._value}setValue(t,e){return r.s.num(t)&&(this.lastPosition=t,e&&(t=Math.round(t/e)*e,this.done&&(this.lastPosition=t))),this._value!==t&&(this._value=t,!0)}reset(){const{done:t}=this;this.done=!1,r.s.num(this._value)&&(this.elapsedTime=0,this.durationProgress=0,this.lastPosition=this._value,t&&(this.lastVelocity=null),this.v0=null)}}class d extends u{constructor(t){super(0),this._string=null,this._toString=void 0,this._toString=Object(r.f)({output:[t,t]})}static create(t){return new d(t)}getValue(){let t=this._string;return null==t?this._string=this._toString(this._value):t}setValue(t){if(r.s.str(t)){if(t==this._string)return!1;this._string=t,this._value=1}else{if(!super.setValue(t))return!1;this._string=null}return!0}reset(t){t&&(this._toString=Object(r.f)({output:[this.getValue(),t]})),this._value=0,super.reset()}}const f={dependencies:null};class h extends l{constructor(t){super(),this.source=t,this.setValue(t)}getValue(t){const e={};return Object(r.l)(this.source,(n,i)=>{var a;(a=n)&&a[o]===a?e[i]=n.getValue(t):Object(r.r)(n)?e[i]=Object(r.q)(n):t||(e[i]=n)}),e}setValue(t){this.source=t,this.payload=this._makePayload(t)}reset(){this.payload&&Object(r.k)(this.payload,t=>t.reset())}_makePayload(t){if(t){const e=new Set;return Object(r.l)(t,this._addToPayload,e),Array.from(e)}}_addToPayload(t){f.dependencies&&Object(r.r)(t)&&f.dependencies.add(t);const e=c(t);e&&Object(r.k)(e,t=>this.add(t))}}class p extends h{constructor(t){super(t)}static create(t){return new p(t)}getValue(){return this.source.map(t=>t.getValue())}setValue(t){const e=this.getPayload();return t.length==e.length?e.map((e,n)=>e.setValue(t[n])).some(Boolean):(super.setValue(t.map(g)),!0)}}function g(t){return(Object(r.t)(t)?d:u).create(t)}function m(t){const e=a(t);return e?e.constructor:r.s.arr(t)?p:Object(r.t)(t)?d:u}function y(){return(y=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}const v=(t,e)=>{const n=!r.s.fun(t)||t.prototype&&t.prototype.isReactComponent;return Object(i.forwardRef)((o,a)=>{const s=Object(i.useRef)(null),c=n&&Object(i.useCallback)(t=>{s.current=function(t,e){t&&(r.s.fun(t)?t(e):t.current=e);return e}(a,t)},[a]),[l,u]=function(t,e){const n=new Set;f.dependencies=n,t.style&&(t=y({},t,{style:e.createAnimatedStyle(t.style)}));return t=new h(t),f.dependencies=null,[t,n]}(o,e),d=Object(r.z)(),p=()=>{const t=s.current;if(n&&!t)return;!1===(!!t&&e.applyAnimatedValues(t,l.getValue(!0)))&&d()},g=new b(p,u),m=Object(i.useRef)();Object(r.A)(()=>{const t=m.current;m.current=g,Object(r.k)(u,t=>Object(r.c)(t,g)),t&&(Object(r.k)(t.deps,e=>Object(r.x)(e,t)),r.w.cancel(t.update))}),Object(i.useEffect)(p,[]),Object(r.C)(()=>()=>{const t=m.current;Object(r.k)(t.deps,e=>Object(r.x)(e,t))});const v=e.getComponentProps(l.getValue());return i.createElement(t,y({},v,{ref:c}))})};class b{constructor(t,e){this.update=t,this.deps=e}eventObserved(t){"change"==t.type&&r.w.write(this.update)}}const k=Symbol.for("AnimatedComponent"),w=(t,{applyAnimatedValues:e=(()=>!1),createAnimatedStyle:n=(t=>new h(t)),getComponentProps:i=(t=>t)}={})=>{const o={applyAnimatedValues:e,createAnimatedStyle:n,getComponentProps:i},a=t=>{const e=x(t)||"Anonymous";return(t=r.s.str(t)?a[t]||(a[t]=v(t,o)):t[k]||(t[k]=v(t,o))).displayName=`Animated(${e})`,t};return Object(r.l)(t,(e,n)=>{r.s.arr(t)&&(n=x(e)),a[n]=a(e)}),{animated:a}},x=t=>r.s.str(t)?t:t&&r.s.str(t.displayName)?t.displayName:r.s.fun(t)&&t.name||null},function(t,e){function n(){return t.exports=n=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},t.exports.default=t.exports,t.exports.__esModule=!0,n.apply(this,arguments)}t.exports=n,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(71),i=n(0);t.exports=function(t,e,n){var i=t[e];if(i){var o=[];if(Object.keys(i).forEach((function(t){-1===r.indexOf(t)&&o.push(t)})),o.length)throw new Error("Prop "+e+" passed to "+n+". Has invalid keys "+o.join(", "))}},t.exports.isRequired=function(e,n,r){if(!e[n])throw new Error("Prop "+n+" passed to "+r+" is required");return t.exports(e,n,r)},t.exports.supportingArrays=i.oneOfType([i.arrayOf(t.exports),t.exports])},function(t,e,n){"use strict";var r=n(28),i=n(84),o=[].slice,a=["keyword","gray","hex"],s={};Object.keys(i).forEach((function(t){s[o.call(i[t].labels).sort().join("")]=t}));var c={};function l(t,e){if(!(this instanceof l))return new l(t,e);if(e&&e in a&&(e=null),e&&!(e in i))throw new Error("Unknown model: "+e);var n,u;if(null==t)this.model="rgb",this.color=[0,0,0],this.valpha=1;else if(t instanceof l)this.model=t.model,this.color=t.color.slice(),this.valpha=t.valpha;else if("string"==typeof t){var d=r.get(t);if(null===d)throw new Error("Unable to parse color from string: "+t);this.model=d.model,u=i[this.model].channels,this.color=d.value.slice(0,u),this.valpha="number"==typeof d.value[u]?d.value[u]:1}else if(t.length){this.model=e||"rgb",u=i[this.model].channels;var f=o.call(t,0,u);this.color=h(f,u),this.valpha="number"==typeof t[u]?t[u]:1}else if("number"==typeof t)t&=16777215,this.model="rgb",this.color=[t>>16&255,t>>8&255,255&t],this.valpha=1;else{this.valpha=1;var p=Object.keys(t);"alpha"in t&&(p.splice(p.indexOf("alpha"),1),this.valpha="number"==typeof t.alpha?t.alpha:0);var g=p.sort().join("");if(!(g in s))throw new Error("Unable to parse color from object: "+JSON.stringify(t));this.model=s[g];var m=i[this.model].labels,y=[];for(n=0;n<m.length;n++)y.push(t[m[n]]);this.color=h(y)}if(c[this.model])for(u=i[this.model].channels,n=0;n<u;n++){var v=c[this.model][n];v&&(this.color[n]=v(this.color[n]))}this.valpha=Math.max(0,Math.min(1,this.valpha)),Object.freeze&&Object.freeze(this)}function u(t,e,n){return(t=Array.isArray(t)?t:[t]).forEach((function(t){(c[t]||(c[t]=[]))[e]=n})),t=t[0],function(r){var i;return arguments.length?(n&&(r=n(r)),(i=this[t]()).color[e]=r,i):(i=this[t]().color[e],n&&(i=n(i)),i)}}function d(t){return function(e){return Math.max(0,Math.min(t,e))}}function f(t){return Array.isArray(t)?t:[t]}function h(t,e){for(var n=0;n<e;n++)"number"!=typeof t[n]&&(t[n]=0);return t}l.prototype={toString:function(){return this.string()},toJSON:function(){return this[this.model]()},string:function(t){var e=this.model in r.to?this:this.rgb(),n=1===(e=e.round("number"==typeof t?t:1)).valpha?e.color:e.color.concat(this.valpha);return r.to[e.model](n)},percentString:function(t){var e=this.rgb().round("number"==typeof t?t:1),n=1===e.valpha?e.color:e.color.concat(this.valpha);return r.to.rgb.percent(n)},array:function(){return 1===this.valpha?this.color.slice():this.color.concat(this.valpha)},object:function(){for(var t={},e=i[this.model].channels,n=i[this.model].labels,r=0;r<e;r++)t[n[r]]=this.color[r];return 1!==this.valpha&&(t.alpha=this.valpha),t},unitArray:function(){var t=this.rgb().color;return t[0]/=255,t[1]/=255,t[2]/=255,1!==this.valpha&&t.push(this.valpha),t},unitObject:function(){var t=this.rgb().object();return t.r/=255,t.g/=255,t.b/=255,1!==this.valpha&&(t.alpha=this.valpha),t},round:function(t){return t=Math.max(t||0,0),new l(this.color.map(function(t){return function(e){return function(t,e){return Number(t.toFixed(e))}(e,t)}}(t)).concat(this.valpha),this.model)},alpha:function(t){return arguments.length?new l(this.color.concat(Math.max(0,Math.min(1,t))),this.model):this.valpha},red:u("rgb",0,d(255)),green:u("rgb",1,d(255)),blue:u("rgb",2,d(255)),hue:u(["hsl","hsv","hsl","hwb","hcg"],0,(function(t){return(t%360+360)%360})),saturationl:u("hsl",1,d(100)),lightness:u("hsl",2,d(100)),saturationv:u("hsv",1,d(100)),value:u("hsv",2,d(100)),chroma:u("hcg",1,d(100)),gray:u("hcg",2,d(100)),white:u("hwb",1,d(100)),wblack:u("hwb",2,d(100)),cyan:u("cmyk",0,d(100)),magenta:u("cmyk",1,d(100)),yellow:u("cmyk",2,d(100)),black:u("cmyk",3,d(100)),x:u("xyz",0,d(100)),y:u("xyz",1,d(100)),z:u("xyz",2,d(100)),l:u("lab",0,d(100)),a:u("lab",1),b:u("lab",2),keyword:function(t){return arguments.length?new l(t):i[this.model].keyword(this.color)},hex:function(t){return arguments.length?new l(t):r.to.hex(this.rgb().round().color)},rgbNumber:function(){var t=this.rgb().color;return(255&t[0])<<16|(255&t[1])<<8|255&t[2]},luminosity:function(){for(var t=this.rgb().color,e=[],n=0;n<t.length;n++){var r=t[n]/255;e[n]=r<=.03928?r/12.92:Math.pow((r+.055)/1.055,2.4)}return.2126*e[0]+.7152*e[1]+.0722*e[2]},contrast:function(t){var e=this.luminosity(),n=t.luminosity();return e>n?(e+.05)/(n+.05):(n+.05)/(e+.05)},level:function(t){var e=this.contrast(t);return e>=7.1?"AAA":e>=4.5?"AA":""},isDark:function(){var t=this.rgb().color;return(299*t[0]+587*t[1]+114*t[2])/1e3<128},isLight:function(){return!this.isDark()},negate:function(){for(var t=this.rgb(),e=0;e<3;e++)t.color[e]=255-t.color[e];return t},lighten:function(t){var e=this.hsl();return e.color[2]+=e.color[2]*t,e},darken:function(t){var e=this.hsl();return e.color[2]-=e.color[2]*t,e},saturate:function(t){var e=this.hsl();return e.color[1]+=e.color[1]*t,e},desaturate:function(t){var e=this.hsl();return e.color[1]-=e.color[1]*t,e},whiten:function(t){var e=this.hwb();return e.color[1]+=e.color[1]*t,e},blacken:function(t){var e=this.hwb();return e.color[2]+=e.color[2]*t,e},grayscale:function(){var t=this.rgb().color,e=.3*t[0]+.59*t[1]+.11*t[2];return l.rgb(e,e,e)},fade:function(t){return this.alpha(this.valpha-this.valpha*t)},opaquer:function(t){return this.alpha(this.valpha+this.valpha*t)},rotate:function(t){var e=this.hsl(),n=e.color[0];return n=(n=(n+t)%360)<0?360+n:n,e.color[0]=n,e},mix:function(t,e){if(!t||!t.rgb)throw new Error('Argument to "mix" was not a Color instance, but rather an instance of '+typeof t);var n=t.rgb(),r=this.rgb(),i=void 0===e?.5:e,o=2*i-1,a=n.alpha()-r.alpha(),s=((o*a==-1?o:(o+a)/(1+o*a))+1)/2,c=1-s;return l.rgb(s*n.red()+c*r.red(),s*n.green()+c*r.green(),s*n.blue()+c*r.blue(),n.alpha()*i+r.alpha()*(1-i))}},Object.keys(i).forEach((function(t){if(-1===a.indexOf(t)){var e=i[t].channels;l.prototype[t]=function(){if(this.model===t)return new l(this);if(arguments.length)return new l(arguments,t);var n="number"==typeof arguments[e]?e:this.valpha;return new l(f(i[this.model][t].raw(this.color)).concat(n),t)},l[t]=function(n){return"number"==typeof n&&(n=h(o.call(arguments),e)),new l(n,t)}}})),t.exports=l},function(t,e){function n(e){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?(t.exports=n=function(t){return typeof t},t.exports.default=t.exports,t.exports.__esModule=!0):(t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.default=t.exports,t.exports.__esModule=!0),n(e)}t.exports=n,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){function n(e,r){return t.exports=n=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},t.exports.default=t.exports,t.exports.__esModule=!0,n(e,r)}t.exports=n,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e){t.exports=function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(42),i=n(72),o={};for(var a in r)r.hasOwnProperty(a)&&(o[r[a]]=a);var s=t.exports={to:{},get:{}};function c(t,e,n){return Math.min(Math.max(e,t),n)}function l(t){var e=t.toString(16).toUpperCase();return e.length<2?"0"+e:e}s.get=function(t){var e,n;switch(t.substring(0,3).toLowerCase()){case"hsl":e=s.get.hsl(t),n="hsl";break;case"hwb":e=s.get.hwb(t),n="hwb";break;default:e=s.get.rgb(t),n="rgb"}return e?{model:n,value:e}:null},s.get.rgb=function(t){if(!t)return null;var e,n,i,o=[0,0,0,1];if(e=t.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)){for(i=e[2],e=e[1],n=0;n<3;n++){var a=2*n;o[n]=parseInt(e.slice(a,a+2),16)}i&&(o[3]=parseInt(i,16)/255)}else if(e=t.match(/^#([a-f0-9]{3,4})$/i)){for(i=(e=e[1])[3],n=0;n<3;n++)o[n]=parseInt(e[n]+e[n],16);i&&(o[3]=parseInt(i+i,16)/255)}else if(e=t.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/)){for(n=0;n<3;n++)o[n]=parseInt(e[n+1],0);e[4]&&(o[3]=parseFloat(e[4]))}else{if(!(e=t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/)))return(e=t.match(/(\D+)/))?"transparent"===e[1]?[0,0,0,0]:(o=r[e[1]])?(o[3]=1,o):null:null;for(n=0;n<3;n++)o[n]=Math.round(2.55*parseFloat(e[n+1]));e[4]&&(o[3]=parseFloat(e[4]))}for(n=0;n<3;n++)o[n]=c(o[n],0,255);return o[3]=c(o[3],0,1),o},s.get.hsl=function(t){if(!t)return null;var e=t.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?[\d\.]+)\s*)?\)$/);if(e){var n=parseFloat(e[4]);return[(parseFloat(e[1])+360)%360,c(parseFloat(e[2]),0,100),c(parseFloat(e[3]),0,100),c(isNaN(n)?1:n,0,1)]}return null},s.get.hwb=function(t){if(!t)return null;var e=t.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);if(e){var n=parseFloat(e[4]);return[(parseFloat(e[1])%360+360)%360,c(parseFloat(e[2]),0,100),c(parseFloat(e[3]),0,100),c(isNaN(n)?1:n,0,1)]}return null},s.to.hex=function(){var t=i(arguments);return"#"+l(t[0])+l(t[1])+l(t[2])+(t[3]<1?l(Math.round(255*t[3])):"")},s.to.rgb=function(){var t=i(arguments);return t.length<4||1===t[3]?"rgb("+Math.round(t[0])+", "+Math.round(t[1])+", "+Math.round(t[2])+")":"rgba("+Math.round(t[0])+", "+Math.round(t[1])+", "+Math.round(t[2])+", "+t[3]+")"},s.to.rgb.percent=function(){var t=i(arguments),e=Math.round(t[0]/255*100),n=Math.round(t[1]/255*100),r=Math.round(t[2]/255*100);return t.length<4||1===t[3]?"rgb("+e+"%, "+n+"%, "+r+"%)":"rgba("+e+"%, "+n+"%, "+r+"%, "+t[3]+")"},s.to.hsl=function(){var t=i(arguments);return t.length<4||1===t[3]?"hsl("+t[0]+", "+t[1]+"%, "+t[2]+"%)":"hsla("+t[0]+", "+t[1]+"%, "+t[2]+"%, "+t[3]+")"},s.to.hwb=function(){var t=i(arguments),e="";return t.length>=4&&1!==t[3]&&(e=", "+t[3]),"hwb("+t[0]+", "+t[1]+"%, "+t[2]+"%"+e+")"},s.to.keyword=function(t){return o[t.slice(0,3)]}},function(t,e,n){"use strict";(function(t,r){
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function o(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function a(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function s(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter((function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable})))),r.forEach((function(e){a(t,e,n[e])}))}return t}function c(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],r=!0,i=!1,o=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){i=!0,o=t}finally{try{r||null==s.return||s.return()}finally{if(i)throw o}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}n.d(e,"a",(function(){return St})),n.d(e,"b",(function(){return At}));var l=function(){},u={},d={},f={mark:l,measure:l};try{"undefined"!=typeof window&&(u=window),"undefined"!=typeof document&&(d=document),"undefined"!=typeof MutationObserver&&MutationObserver,"undefined"!=typeof performance&&(f=performance)}catch(t){}var h=(u.navigator||{}).userAgent,p=void 0===h?"":h,g=u,m=d,y=f,v=(g.document,!!m.documentElement&&!!m.head&&"function"==typeof m.addEventListener&&"function"==typeof m.createElement),b=(~p.indexOf("MSIE")||p.indexOf("Trident/"),function(){try{}catch(t){return!1}}(),[1,2,3,4,5,6,7,8,9,10]),k=b.concat([11,12,13,14,15,16,17,18,19,20]),w={GROUP:"group",SWAP_OPACITY:"swap-opacity",PRIMARY:"primary",SECONDARY:"secondary"},x=(["xs","sm","lg","fw","ul","li","border","pull-left","pull-right","spin","pulse","rotate-90","rotate-180","rotate-270","flip-horizontal","flip-vertical","flip-both","stack","stack-1x","stack-2x","inverse","layers","layers-text","layers-counter",w.GROUP,w.SWAP_OPACITY,w.PRIMARY,w.SECONDARY].concat(b.map((function(t){return"".concat(t,"x")}))).concat(k.map((function(t){return"w-".concat(t)}))),g.FontAwesomeConfig||{});if(m&&"function"==typeof m.querySelector){[["data-family-prefix","familyPrefix"],["data-replacement-class","replacementClass"],["data-auto-replace-svg","autoReplaceSvg"],["data-auto-add-css","autoAddCss"],["data-auto-a11y","autoA11y"],["data-search-pseudo-elements","searchPseudoElements"],["data-observe-mutations","observeMutations"],["data-mutate-approach","mutateApproach"],["data-keep-original-source","keepOriginalSource"],["data-measure-performance","measurePerformance"],["data-show-missing-icons","showMissingIcons"]].forEach((function(t){var e=c(t,2),n=e[0],r=e[1],i=function(t){return""===t||"false"!==t&&("true"===t||t)}(function(t){var e=m.querySelector("script["+t+"]");if(e)return e.getAttribute(t)}(n));null!=i&&(x[r]=i)}))}var A=s({},{familyPrefix:"fa",replacementClass:"svg-inline--fa",autoReplaceSvg:!0,autoAddCss:!0,autoA11y:!0,searchPseudoElements:!1,observeMutations:!0,mutateApproach:"async",keepOriginalSource:!0,measurePerformance:!1,showMissingIcons:!0},x);A.autoReplaceSvg||(A.observeMutations=!1);var S=s({},A);g.FontAwesomeConfig=S;var O=g||{};O.___FONT_AWESOME___||(O.___FONT_AWESOME___={}),O.___FONT_AWESOME___.styles||(O.___FONT_AWESOME___.styles={}),O.___FONT_AWESOME___.hooks||(O.___FONT_AWESOME___.hooks={}),O.___FONT_AWESOME___.shims||(O.___FONT_AWESOME___.shims=[]);var E=O.___FONT_AWESOME___,M=[];v&&((m.documentElement.doScroll?/^loaded|^c/:/^loaded|^i|^c/).test(m.readyState)||m.addEventListener("DOMContentLoaded",(function t(){m.removeEventListener("DOMContentLoaded",t),1,M.map((function(t){return t()}))})));var C,R=function(){},j=void 0!==t&&void 0!==t.process&&"function"==typeof t.process.emit,I=void 0===r?setTimeout:r,B=[];function D(){for(var t=0;t<B.length;t++)B[t][0](B[t][1]);B=[],C=!1}function T(t,e){B.push([t,e]),C||(C=!0,I(D,0))}function F(t){var e=t.owner,n=e._state,r=e._data,i=t[n],o=t.then;if("function"==typeof i){n="fulfilled";try{r=i(r)}catch(t){L(o,t)}}P(o,r)||("fulfilled"===n&&z(o,r),"rejected"===n&&L(o,r))}function P(t,e){var n;try{if(t===e)throw new TypeError("A promises callback cannot return that same promise.");if(e&&("function"==typeof e||"object"===i(e))){var r=e.then;if("function"==typeof r)return r.call(e,(function(r){n||(n=!0,e===r?Q(t,r):z(t,r))}),(function(e){n||(n=!0,L(t,e))})),!0}}catch(e){return n||L(t,e),!0}return!1}function z(t,e){t!==e&&P(t,e)||Q(t,e)}function Q(t,e){"pending"===t._state&&(t._state="settled",t._data=e,T(W,t))}function L(t,e){"pending"===t._state&&(t._state="settled",t._data=e,T(q,t))}function Y(t){t._then=t._then.forEach(F)}function W(t){t._state="fulfilled",Y(t)}function q(e){e._state="rejected",Y(e),!e._handled&&j&&t.process.emit("unhandledRejection",e._data,e)}function N(e){t.process.emit("rejectionHandled",e)}function G(t){if("function"!=typeof t)throw new TypeError("Promise resolver "+t+" is not a function");if(this instanceof G==!1)throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");this._then=[],function(t,e){function n(t){L(e,t)}try{t((function(t){z(e,t)}),n)}catch(t){n(t)}}(t,this)}G.prototype={constructor:G,_state:"pending",_then:null,_data:void 0,_handled:!1,then:function(t,e){var n={owner:this,then:new this.constructor(R),fulfilled:t,rejected:e};return!e&&!t||this._handled||(this._handled=!0,"rejected"===this._state&&j&&T(N,this)),"fulfilled"===this._state||"rejected"===this._state?T(F,n):this._then.push(n),n.then},catch:function(t){return this.then(null,t)}},G.all=function(t){if(!Array.isArray(t))throw new TypeError("You must pass an array to Promise.all().");return new G((function(e,n){var r=[],i=0;function o(t){return i++,function(n){r[t]=n,--i||e(r)}}for(var a,s=0;s<t.length;s++)(a=t[s])&&"function"==typeof a.then?a.then(o(s),n):r[s]=a;i||e(r)}))},G.race=function(t){if(!Array.isArray(t))throw new TypeError("You must pass an array to Promise.race().");return new G((function(e,n){for(var r,i=0;i<t.length;i++)(r=t[i])&&"function"==typeof r.then?r.then(e,n):e(r)}))},G.resolve=function(t){return t&&"object"===i(t)&&t.constructor===G?t:new G((function(e){e(t)}))},G.reject=function(t){return new G((function(e,n){n(t)}))};var J={size:16,x:0,y:0,rotate:0,flipX:!1,flipY:!1};function U(t){if(t&&v){var e=m.createElement("style");e.setAttribute("type","text/css"),e.innerHTML=t;for(var n=m.head.childNodes,r=null,i=n.length-1;i>-1;i--){var o=n[i],a=(o.tagName||"").toUpperCase();["STYLE","LINK"].indexOf(a)>-1&&(r=o)}return m.head.insertBefore(e,r),t}}function K(){for(var t=12,e="";t-- >0;)e+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62*Math.random()|0];return e}function H(t){return"".concat(t).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function V(t){return Object.keys(t||{}).reduce((function(e,n){return e+"".concat(n,": ").concat(t[n],";")}),"")}function Z(t){return t.size!==J.size||t.x!==J.x||t.y!==J.y||t.rotate!==J.rotate||t.flipX||t.flipY}function X(t){var e=t.transform,n=t.containerWidth,r=t.iconWidth,i={transform:"translate(".concat(n/2," 256)")},o="translate(".concat(32*e.x,", ").concat(32*e.y,") "),a="scale(".concat(e.size/16*(e.flipX?-1:1),", ").concat(e.size/16*(e.flipY?-1:1),") "),s="rotate(".concat(e.rotate," 0 0)");return{outer:i,inner:{transform:"".concat(o," ").concat(a," ").concat(s)},path:{transform:"translate(".concat(r/2*-1," -256)")}}}var _={x:0,y:0,width:"100%",height:"100%"};function $(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return t.attributes&&(t.attributes.fill||e)&&(t.attributes.fill="black"),t}function tt(t){var e=t.icons,n=e.main,r=e.mask,i=t.prefix,o=t.iconName,a=t.transform,c=t.symbol,l=t.title,u=t.maskId,d=t.titleId,f=t.extra,h=t.watchable,p=void 0!==h&&h,g=r.found?r:n,m=g.width,y=g.height,v="fak"===i,b=v?"":"fa-w-".concat(Math.ceil(m/y*16)),k=[S.replacementClass,o?"".concat(S.familyPrefix,"-").concat(o):"",b].filter((function(t){return-1===f.classes.indexOf(t)})).filter((function(t){return""!==t||!!t})).concat(f.classes).join(" "),w={children:[],attributes:s({},f.attributes,{"data-prefix":i,"data-icon":o,class:k,role:f.attributes.role||"img",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 ".concat(m," ").concat(y)})},x=v&&!~f.classes.indexOf("fa-fw")?{width:"".concat(m/y*16*.0625,"em")}:{};p&&(w.attributes["data-fa-i2svg"]=""),l&&w.children.push({tag:"title",attributes:{id:w.attributes["aria-labelledby"]||"title-".concat(d||K())},children:[l]});var A=s({},w,{prefix:i,iconName:o,main:n,mask:r,maskId:u,transform:a,symbol:c,styles:s({},x,f.styles)}),O=r.found&&n.found?function(t){var e,n=t.children,r=t.attributes,i=t.main,o=t.mask,a=t.maskId,c=t.transform,l=i.width,u=i.icon,d=o.width,f=o.icon,h=X({transform:c,containerWidth:d,iconWidth:l}),p={tag:"rect",attributes:s({},_,{fill:"white"})},g=u.children?{children:u.children.map($)}:{},m={tag:"g",attributes:s({},h.inner),children:[$(s({tag:u.tag,attributes:s({},u.attributes,h.path)},g))]},y={tag:"g",attributes:s({},h.outer),children:[m]},v="mask-".concat(a||K()),b="clip-".concat(a||K()),k={tag:"mask",attributes:s({},_,{id:v,maskUnits:"userSpaceOnUse",maskContentUnits:"userSpaceOnUse"}),children:[p,y]},w={tag:"defs",children:[{tag:"clipPath",attributes:{id:b},children:(e=f,"g"===e.tag?e.children:[e])},k]};return n.push(w,{tag:"rect",attributes:s({fill:"currentColor","clip-path":"url(#".concat(b,")"),mask:"url(#".concat(v,")")},_)}),{children:n,attributes:r}}(A):function(t){var e=t.children,n=t.attributes,r=t.main,i=t.transform,o=V(t.styles);if(o.length>0&&(n.style=o),Z(i)){var a=X({transform:i,containerWidth:r.width,iconWidth:r.width});e.push({tag:"g",attributes:s({},a.outer),children:[{tag:"g",attributes:s({},a.inner),children:[{tag:r.icon.tag,children:r.icon.children,attributes:s({},r.icon.attributes,a.path)}]}]})}else e.push(r.icon);return{children:e,attributes:n}}(A),E=O.children,M=O.attributes;return A.children=E,A.attributes=M,c?function(t){var e=t.prefix,n=t.iconName,r=t.children,i=t.attributes,o=t.symbol;return[{tag:"svg",attributes:{style:"display: none;"},children:[{tag:"symbol",attributes:s({},i,{id:!0===o?"".concat(e,"-").concat(S.familyPrefix,"-").concat(n):o}),children:r}]}]}(A):function(t){var e=t.children,n=t.main,r=t.mask,i=t.attributes,o=t.styles,a=t.transform;if(Z(a)&&n.found&&!r.found){var c={x:n.width/n.height/2,y:.5};i.style=V(s({},o,{"transform-origin":"".concat(c.x+a.x/16,"em ").concat(c.y+a.y/16,"em")}))}return[{tag:"svg",attributes:i,children:e}]}(A)}var et=function(){},nt=(S.measurePerformance&&y&&y.mark&&y.measure,function(t,e,n,r){var i,o,a,s=Object.keys(t),c=s.length,l=void 0!==r?function(t,e){return function(n,r,i,o){return t.call(e,n,r,i,o)}}(e,r):e;for(void 0===n?(i=1,a=t[s[0]]):(i=0,a=n);i<c;i++)a=l(a,t[o=s[i]],o,t);return a});function rt(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.skipHooks,i=void 0!==r&&r,o=Object.keys(e).reduce((function(t,n){var r=e[n];return!!r.icon?t[r.iconName]=r.icon:t[n]=r,t}),{});"function"!=typeof E.hooks.addPack||i?E.styles[t]=s({},E.styles[t]||{},o):E.hooks.addPack(t,o),"fas"===t&&rt("fa",e)}var it=E.styles,ot=E.shims,at=function(){var t=function(t){return nt(it,(function(e,n,r){return e[r]=nt(n,t,{}),e}),{})};t((function(t,e,n){return e[3]&&(t[e[3]]=n),t})),t((function(t,e,n){var r=e[2];return t[n]=n,r.forEach((function(e){t[e]=n})),t}));var e="far"in it;nt(ot,(function(t,n){var r=n[0],i=n[1],o=n[2];return"far"!==i||e||(i="fas"),t[r]={prefix:i,iconName:o},t}),{})};at();E.styles;function st(t,e,n){if(t&&t[e]&&t[e][n])return{prefix:e,iconName:n,icon:t[e][n]}}function ct(t){var e=t.tag,n=t.attributes,r=void 0===n?{}:n,i=t.children,o=void 0===i?[]:i;return"string"==typeof t?H(t):"<".concat(e," ").concat(function(t){return Object.keys(t||{}).reduce((function(e,n){return e+"".concat(n,'="').concat(H(t[n]),'" ')}),"").trim()}(r),">").concat(o.map(ct).join(""),"</").concat(e,">")}var lt=function(t){var e={size:16,x:0,y:0,flipX:!1,flipY:!1,rotate:0};return t?t.toLowerCase().split(" ").reduce((function(t,e){var n=e.toLowerCase().split("-"),r=n[0],i=n.slice(1).join("-");if(r&&"h"===i)return t.flipX=!0,t;if(r&&"v"===i)return t.flipY=!0,t;if(i=parseFloat(i),isNaN(i))return t;switch(r){case"grow":t.size=t.size+i;break;case"shrink":t.size=t.size-i;break;case"left":t.x=t.x-i;break;case"right":t.x=t.x+i;break;case"up":t.y=t.y-i;break;case"down":t.y=t.y+i;break;case"rotate":t.rotate=t.rotate+i}return t}),e):e};function ut(t){this.name="MissingIcon",this.message=t||"Icon unavailable",this.stack=(new Error).stack}ut.prototype=Object.create(Error.prototype),ut.prototype.constructor=ut;var dt={fill:"currentColor"},ft={attributeType:"XML",repeatCount:"indefinite",dur:"2s"},ht={tag:"path",attributes:s({},dt,{d:"M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"})},pt=s({},ft,{attributeName:"opacity"});s({},dt,{cx:"256",cy:"364",r:"28"}),s({},ft,{attributeName:"r",values:"28;14;28;28;14;28;"}),s({},pt,{values:"1;0;1;1;0;1;"}),s({},dt,{opacity:"1",d:"M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"}),s({},pt,{values:"1;0;0;0;0;1;"}),s({},dt,{opacity:"0",d:"M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"}),s({},pt,{values:"0;0;1;1;0;0;"}),E.styles;function gt(t){var e=t[0],n=t[1],r=c(t.slice(4),1)[0];return{found:!0,width:e,height:n,icon:Array.isArray(r)?{tag:"g",attributes:{class:"".concat(S.familyPrefix,"-").concat(w.GROUP)},children:[{tag:"path",attributes:{class:"".concat(S.familyPrefix,"-").concat(w.SECONDARY),fill:"currentColor",d:r[0]}},{tag:"path",attributes:{class:"".concat(S.familyPrefix,"-").concat(w.PRIMARY),fill:"currentColor",d:r[1]}}]}:{tag:"path",attributes:{fill:"currentColor",d:r}}}}E.styles;function mt(){var t="svg-inline--fa",e=S.familyPrefix,n=S.replacementClass,r='svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';if("fa"!==e||n!==t){var i=new RegExp("\\.".concat("fa","\\-"),"g"),o=new RegExp("\\--".concat("fa","\\-"),"g"),a=new RegExp("\\.".concat(t),"g");r=r.replace(i,".".concat(e,"-")).replace(o,"--".concat(e,"-")).replace(a,".".concat(n))}return r}function yt(){S.autoAddCss&&!xt&&(U(mt()),xt=!0)}function vt(t,e){return Object.defineProperty(t,"abstract",{get:e}),Object.defineProperty(t,"html",{get:function(){return t.abstract.map((function(t){return ct(t)}))}}),Object.defineProperty(t,"node",{get:function(){if(v){var e=m.createElement("div");return e.innerHTML=t.html,e.children}}}),t}function bt(t){var e=t.prefix,n=void 0===e?"fa":e,r=t.iconName;if(r)return st(wt.definitions,n,r)||st(E.styles,n,r)}var kt,wt=new(function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.definitions={}}var e,n,r;return e=t,(n=[{key:"add",value:function(){for(var t=this,e=arguments.length,n=new Array(e),r=0;r<e;r++)n[r]=arguments[r];var i=n.reduce(this._pullDefinitions,{});Object.keys(i).forEach((function(e){t.definitions[e]=s({},t.definitions[e]||{},i[e]),rt(e,i[e]),at()}))}},{key:"reset",value:function(){this.definitions={}}},{key:"_pullDefinitions",value:function(t,e){var n=e.prefix&&e.iconName&&e.icon?{0:e}:e;return Object.keys(n).map((function(e){var r=n[e],i=r.prefix,o=r.iconName,a=r.icon;t[i]||(t[i]={}),t[i][o]=a})),t}}])&&o(e.prototype,n),r&&o(e,r),t}()),xt=!1,At={transform:function(t){return lt(t)}},St=(kt=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.transform,r=void 0===n?J:n,i=e.symbol,o=void 0!==i&&i,a=e.mask,c=void 0===a?null:a,l=e.maskId,u=void 0===l?null:l,d=e.title,f=void 0===d?null:d,h=e.titleId,p=void 0===h?null:h,g=e.classes,m=void 0===g?[]:g,y=e.attributes,v=void 0===y?{}:y,b=e.styles,k=void 0===b?{}:b;if(t){var w=t.prefix,x=t.iconName,A=t.icon;return vt(s({type:"icon"},t),(function(){return yt(),S.autoA11y&&(f?v["aria-labelledby"]="".concat(S.replacementClass,"-title-").concat(p||K()):(v["aria-hidden"]="true",v.focusable="false")),tt({icons:{main:gt(A),mask:c?gt(c.icon):{found:!1,width:null,height:null,icon:{}}},prefix:w,iconName:x,transform:s({},J,r),symbol:o,title:f,maskId:u,titleId:p,extra:{attributes:v,styles:k,classes:m}})}))}},function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=(t||{}).icon?t:bt(t||{}),r=e.mask;return r&&(r=(r||{}).icon?r:bt(r||{})),kt(n,s({},e,{mask:r}))})}).call(this,n(26),n(68).setImmediate)},function(t,e,n){"use strict";n.d(e,"Spring",(function(){return xt})),n.d(e,"useSpring",(function(){return mt})),n.d(e,"useSprings",(function(){return gt})),n.d(e,"useTransition",(function(){return vt}));var r=n(3);n.d(e,"Globals",(function(){return r.b}));var i=n(2),o=n(20);n(40),n(41);function a(){return(a=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}function s(t,...e){return r.s.fun(t)?t(...e):t}const c=(t,e)=>!0===t||!!(e&&t&&(r.s.fun(t)?t(e):Object(r.y)(t).includes(e))),l=(t,e)=>r.s.obj(t)?e&&t[e]:t,u=(t,e)=>!0===t.default?t[e]:t.default?t.default[e]:void 0,d=t=>t,f=(t,e=d)=>{let n=h;t.default&&!0!==t.default&&(t=t.default,n=Object.keys(t));const i={};for(const o of n){const n=e(t[o],o);r.s.und(n)||(i[o]=n)}return i},h=["config","onProps","onStart","onChange","onPause","onResume","onRest"],p={config:1,from:1,to:1,ref:1,loop:1,reset:1,pause:1,cancel:1,reverse:1,immediate:1,default:1,delay:1,onProps:1,onStart:1,onChange:1,onPause:1,onResume:1,onRest:1,onResolve:1,items:1,trail:1,sort:1,expires:1,initial:1,enter:1,update:1,leave:1,children:1,onDestroyed:1,keys:1,callId:1,parentId:1};function g(t){const e=function(t){const e={};let n=0;if(Object(r.l)(t,(t,r)=>{p[r]||(e[r]=t,n++)}),n)return e}(t);if(e){const n={to:e};return Object(r.l)(t,(t,r)=>r in e||(n[r]=t)),n}return a({},t)}function m(t){return t=Object(r.q)(t),r.s.arr(t)?t.map(m):Object(r.t)(t)?r.b.createStringInterpolator({range:[0,1],output:[t,t]})(1):t}function y(t){for(const e in t)return!0;return!1}function v(t){return r.s.fun(t)||r.s.arr(t)&&r.s.obj(t[0])}function b(t,e){var n;null==(n=t.ref)||n.delete(t),null==e||e.delete(t)}function k(t,e){var n;e&&t.ref!==e&&(null==(n=t.ref)||n.delete(t),e.add(t),t.ref=e)}const w=a({},{tension:170,friction:26},{mass:1,damping:1,easing:t=>t,clamp:!1});class x{constructor(){this.tension=void 0,this.friction=void 0,this.frequency=void 0,this.damping=void 0,this.mass=void 0,this.velocity=0,this.restVelocity=void 0,this.precision=void 0,this.progress=void 0,this.duration=void 0,this.easing=void 0,this.clamp=void 0,this.bounce=void 0,this.decay=void 0,this.round=void 0,Object.assign(this,w)}}function A(t,e){if(r.s.und(e.decay)){const n=!r.s.und(e.tension)||!r.s.und(e.friction);!n&&r.s.und(e.frequency)&&r.s.und(e.damping)&&r.s.und(e.mass)||(t.duration=void 0,t.decay=void 0),n&&(t.frequency=void 0)}else t.duration=void 0}const S=[];class O{constructor(){this.changed=!1,this.values=S,this.toValues=null,this.fromValues=S,this.to=void 0,this.from=void 0,this.config=new x,this.immediate=!1}}function E(t,{key:e,props:n,defaultProps:i,state:o,actions:l}){return new Promise((u,d)=>{var f;let h,p,g=c(null!=(f=n.cancel)?f:null==i?void 0:i.cancel,e);if(g)v();else{r.s.und(n.pause)||(o.paused=c(n.pause,e));let t=null==i?void 0:i.pause;!0!==t&&(t=o.paused||c(t,e)),h=s(n.delay||0,e),t?(o.resumeQueue.add(y),l.pause()):(l.resume(),y())}function m(){o.resumeQueue.add(y),o.timeouts.delete(p),p.cancel(),h=p.time-r.w.now()}function y(){h>0?(p=r.w.setTimeout(v,h),o.pauseQueue.add(m),o.timeouts.add(p)):v()}function v(){o.pauseQueue.delete(m),o.timeouts.delete(p),t<=(o.cancelId||0)&&(g=!0);try{l.start(a({},n,{callId:t,cancel:g}),u)}catch(t){d(t)}}})}const M=(t,e)=>1==e.length?e[0]:e.some(t=>t.cancelled)?j(t.get()):e.every(t=>t.noop)?C(t.get()):R(t.get(),e.every(t=>t.finished)),C=t=>({value:t,noop:!0,finished:!0,cancelled:!1}),R=(t,e,n=!1)=>({value:t,finished:e,cancelled:n}),j=t=>({value:t,cancelled:!0,finished:!1});function I(t,e,n,i){const{callId:o,parentId:s,onRest:c}=e,{asyncTo:l,promise:u}=n;return s||t!==l||e.reset?n.promise=(async()=>{n.asyncId=o,n.asyncTo=t;const d=f(e,(t,e)=>"onRest"===e?void 0:t);let h,p;const g=new Promise((t,e)=>(h=t,p=e)),m=t=>{const e=o<=(n.cancelId||0)&&j(i)||o!==n.asyncId&&R(i,!1);if(e)throw t.result=e,p(t),t},y=(t,e)=>{const s=new D,c=new T;return(async()=>{if(r.b.skipAnimation)throw B(n),c.result=R(i,!1),p(c),c;m(s);const l=r.s.obj(t)?a({},t):a({},e,{to:t});l.parentId=o,Object(r.l)(d,(t,e)=>{r.s.und(l[e])&&(l[e]=t)});const u=await i.start(l);return m(s),n.paused&&await new Promise(t=>{n.resumeQueue.add(t)}),u})()};let v;if(r.b.skipAnimation)return B(n),R(i,!1);try{let e;e=r.s.arr(t)?(async t=>{for(const e of t)await y(e)})(t):Promise.resolve(t(y,i.stop.bind(i))),await Promise.all([e.then(h),g]),v=R(i.get(),!0,!1)}catch(t){if(t instanceof D)v=t.result;else{if(!(t instanceof T))throw t;v=t.result}}finally{o==n.asyncId&&(n.asyncId=s,n.asyncTo=s?l:void 0,n.promise=s?u:void 0)}return r.s.fun(c)&&r.w.batchedUpdates(()=>{c(v,i,i.item)}),v})():u}function B(t,e){Object(r.m)(t.timeouts,t=>t.cancel()),t.pauseQueue.clear(),t.resumeQueue.clear(),t.asyncId=t.asyncTo=t.promise=void 0,e&&(t.cancelId=e)}class D extends Error{constructor(){super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."),this.result=void 0}}class T extends Error{constructor(){super("SkipAnimationSignal"),this.result=void 0}}const F=t=>t instanceof z;let P=1;class z extends r.a{constructor(...t){super(...t),this.id=P++,this.key=void 0,this._priority=0}get priority(){return this._priority}set priority(t){this._priority!=t&&(this._priority=t,this._onPriorityChange(t))}get(){const t=Object(o.e)(this);return t&&t.getValue()}to(...t){return r.b.to(this,t)}interpolate(...t){return Object(r.j)(),r.b.to(this,t)}toJSON(){return this.get()}observerAdded(t){1==t&&this._attach()}observerRemoved(t){0==t&&this._detach()}_attach(){}_detach(){}_onChange(t,e=!1){Object(r.d)(this,{type:"change",parent:this,value:t,idle:e})}_onPriorityChange(t){this.idle||r.o.sort(this),Object(r.d)(this,{type:"priority",parent:this,priority:t})}}const Q=Symbol.for("SpringPhase"),L=t=>(1&t[Q])>0,Y=t=>(2&t[Q])>0,W=t=>(4&t[Q])>0,q=(t,e)=>e?t[Q]|=3:t[Q]&=-3,N=(t,e)=>e?t[Q]|=4:t[Q]&=-5;class G extends z{constructor(t,e){if(super(),this.key=void 0,this.animation=new O,this.queue=void 0,this.defaultProps={},this._state={paused:!1,pauseQueue:new Set,resumeQueue:new Set,timeouts:new Set},this._pendingCalls=new Set,this._lastCallId=0,this._lastToId=0,this._memoizedDuration=0,!r.s.und(t)||!r.s.und(e)){const n=r.s.obj(t)?a({},t):a({},e,{from:t});r.s.und(n.default)&&(n.default=!0),this.start(n)}}get idle(){return!(Y(this)||this._state.asyncTo)||W(this)}get goal(){return Object(r.q)(this.animation.to)}get velocity(){const t=Object(o.e)(this);return t instanceof o.c?t.lastVelocity||0:t.getPayload().map(t=>t.lastVelocity||0)}get hasAnimated(){return L(this)}get isAnimating(){return Y(this)}get isPaused(){return W(this)}advance(t){let e=!0,n=!1;const i=this.animation;let{config:a,toValues:s}=i;const c=Object(o.g)(i.to);!c&&Object(r.r)(i.to)&&(s=Object(r.y)(Object(r.q)(i.to))),i.values.forEach((l,u)=>{if(l.done)return;const d=l.constructor==o.b?1:c?c[u].lastPosition:s[u];let f=i.immediate,h=d;if(!f){if(h=l.lastPosition,a.tension<=0)return void(l.done=!0);let e=l.elapsedTime+=t;const n=i.fromValues[u],o=null!=l.v0?l.v0:l.v0=r.s.arr(a.velocity)?a.velocity[u]:a.velocity;let s;if(r.s.und(a.duration))if(a.decay){const t=!0===a.decay?.998:a.decay,r=Math.exp(-(1-t)*e);h=n+o/(1-t)*(1-r),f=Math.abs(l.lastPosition-h)<.1,s=o*r}else{s=null==l.lastVelocity?o:l.lastVelocity;const e=a.precision||(n==d?.005:Math.min(1,.001*Math.abs(d-n))),i=a.restVelocity||e/10,c=a.clamp?0:a.bounce,u=!r.s.und(c),p=n==d?l.v0>0:n<d;let g,m=!1;const y=1,v=Math.ceil(t/y);for(let t=0;t<v&&(g=Math.abs(s)>i,g||(f=Math.abs(d-h)<=e,!f));++t){u&&(m=h==d||h>d==p,m&&(s=-s*c,h=d));s+=(1e-6*-a.tension*(h-d)+.001*-a.friction*s)/a.mass*y,h+=s*y}}else{let r=1;a.duration>0&&(this._memoizedDuration!==a.duration&&(this._memoizedDuration=a.duration,l.durationProgress>0&&(l.elapsedTime=a.duration*l.durationProgress,e=l.elapsedTime+=t)),r=(a.progress||0)+e/this._memoizedDuration,r=r>1?1:r<0?0:r,l.durationProgress=r),h=n+a.easing(r)*(d-n),s=(h-l.lastPosition)/t,f=1==r}l.lastVelocity=s,Number.isNaN(h)&&(console.warn("Got NaN while animating:",this),f=!0)}c&&!c[u].done&&(f=!1),f?l.done=!0:e=!1,l.setValue(h,a.round)&&(n=!0)});const l=Object(o.e)(this),u=l.getValue();if(e){const t=Object(r.q)(i.to);u===t&&!n||a.decay?n&&a.decay&&this._onChange(u):(l.setValue(t),this._onChange(t)),this._stop()}else n&&this._onChange(u)}set(t){return r.w.batchedUpdates(()=>{this._stop(),this._focus(t),this._set(t)}),this}pause(){this._update({pause:!0})}resume(){this._update({pause:!1})}finish(){if(Y(this)){const{to:t,config:e}=this.animation;r.w.batchedUpdates(()=>{this._onStart(),e.decay||this._set(t,!1),this._stop()})}return this}update(t){return(this.queue||(this.queue=[])).push(t),this}start(t,e){let n;return r.s.und(t)?(n=this.queue||[],this.queue=[]):n=[r.s.obj(t)?t:a({},e,{to:t})],Promise.all(n.map(t=>this._update(t))).then(t=>M(this,t))}stop(t){const{to:e}=this.animation;return this._focus(this.get()),B(this._state,t&&this._lastCallId),r.w.batchedUpdates(()=>this._stop(e,t)),this}reset(){this._update({reset:!0})}eventObserved(t){"change"==t.type?this._start():"priority"==t.type&&(this.priority=t.priority+1)}_prepareNode(t){const e=this.key||"";let{to:n,from:i}=t;n=r.s.obj(n)?n[e]:n,(null==n||v(n))&&(n=void 0),i=r.s.obj(i)?i[e]:i,null==i&&(i=void 0);const a={to:n,from:i};return L(this)||(t.reverse&&([n,i]=[i,n]),i=Object(r.q)(i),r.s.und(i)?Object(o.e)(this)||this._set(n):this._set(i)),a}_update(t,e){let n=a({},t);const{key:i,defaultProps:o}=this;n.default&&Object.assign(o,f(n,(t,e)=>/^on/.test(e)?l(t,i):t)),X(this,n,"onProps"),_(this,"onProps",n,this);const s=this._prepareNode(n);if(Object.isFrozen(this))throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");const c=this._state;return E(++this._lastCallId,{key:i,props:n,defaultProps:o,state:c,actions:{pause:()=>{W(this)||(N(this,!0),Object(r.n)(c.pauseQueue),_(this,"onPause",R(this,J(this,this.animation.to)),this))},resume:()=>{W(this)&&(N(this,!1),Y(this)&&this._resume(),Object(r.n)(c.resumeQueue),_(this,"onResume",R(this,J(this,this.animation.to)),this))},start:this._merge.bind(this,s)}}).then(t=>{if(n.loop&&t.finished&&(!e||!t.noop)){const t=U(n);if(t)return this._update(t,!0)}return t})}_merge(t,e,n){if(e.cancel)return this.stop(!0),n(j(this));const i=!r.s.und(t.to),l=!r.s.und(t.from);if(i||l){if(!(e.callId>this._lastToId))return n(j(this));this._lastToId=e.callId}const{key:u,defaultProps:d,animation:f}=this,{to:h,from:p}=f;let{to:g=h,from:y=p}=t;!l||i||e.default&&!r.s.und(g)||(g=y),e.reverse&&([g,y]=[y,g]);const b=!Object(r.u)(y,p);b&&(f.from=y),y=Object(r.q)(y);const k=!Object(r.u)(g,h);k&&this._focus(g);const x=v(e.to),{config:S}=f,{decay:O,velocity:E}=S;(i||l)&&(S.velocity=0),e.config&&!x&&function(t,e,n){n&&(A(n=a({},n),e),e=a({},n,e)),A(t,e),Object.assign(t,e);for(const e in w)null==t[e]&&(t[e]=w[e]);let{mass:i,frequency:o,damping:s}=t;r.s.und(o)||(o<.01&&(o=.01),s<0&&(s=0),t.tension=Math.pow(2*Math.PI/o,2)*i,t.friction=4*Math.PI*s*i/o)}(S,s(e.config,u),e.config!==d.config?s(d.config,u):void 0);let M=Object(o.e)(this);if(!M||r.s.und(g))return n(R(this,!0));const B=r.s.und(e.reset)?l&&!e.default:!r.s.und(y)&&c(e.reset,u),D=B?y:this.get(),T=m(g),F=r.s.num(T)||r.s.arr(T)||Object(r.t)(T),P=!x&&(!F||c(d.immediate||e.immediate,u));if(k){const t=Object(o.f)(g);if(t!==M.constructor){if(!P)throw Error(`Cannot animate between ${M.constructor.name} and ${t.name}, as the "to" prop suggests`);M=this._set(T)}}const z=M.constructor;let Q=Object(r.r)(g),W=!1;if(!Q){const t=B||!L(this)&&b;(k||t)&&(W=Object(r.u)(m(D),T),Q=!W),(Object(r.u)(f.immediate,P)||P)&&Object(r.u)(S.decay,O)&&Object(r.u)(S.velocity,E)||(Q=!0)}if(W&&Y(this)&&(f.changed&&!B?Q=!0:Q||this._stop(h)),!x&&((Q||Object(r.r)(h))&&(f.values=M.getPayload(),f.toValues=Object(r.r)(g)?null:z==o.b?[1]:Object(r.y)(T)),f.immediate!=P&&(f.immediate=P,P||B||this._set(h)),Q)){const{onRest:t}=f;Object(r.k)(Z,t=>X(this,e,t));const i=R(this,J(this,h));Object(r.n)(this._pendingCalls,i),this._pendingCalls.add(n),f.changed&&r.w.batchedUpdates(()=>{f.changed=!B,null==t||t(i,this),B?s(d.onRest,i):null==f.onStart||f.onStart(i,this)})}B&&this._set(D),x?n(I(e.to,e,this._state,this)):Q?this._start():Y(this)&&!k?this._pendingCalls.add(n):n(C(D))}_focus(t){const e=this.animation;t!==e.to&&(Object(r.p)(this)&&this._detach(),e.to=t,Object(r.p)(this)&&this._attach())}_attach(){let t=0;const{to:e}=this.animation;Object(r.r)(e)&&(Object(r.c)(e,this),F(e)&&(t=e.priority+1)),this.priority=t}_detach(){const{to:t}=this.animation;Object(r.r)(t)&&Object(r.x)(t,this)}_set(t,e=!0){const n=Object(r.q)(t);if(!r.s.und(n)){const t=Object(o.e)(this);if(!t||!Object(r.u)(n,t.getValue())){const i=Object(o.f)(n);t&&t.constructor==i?t.setValue(n):Object(o.h)(this,i.create(n)),t&&r.w.batchedUpdates(()=>{this._onChange(n,e)})}}return Object(o.e)(this)}_onStart(){const t=this.animation;t.changed||(t.changed=!0,_(this,"onStart",R(this,J(this,t.to)),this))}_onChange(t,e){e||(this._onStart(),s(this.animation.onChange,t,this)),s(this.defaultProps.onChange,t,this),super._onChange(t,e)}_start(){const t=this.animation;Object(o.e)(this).reset(Object(r.q)(t.to)),t.immediate||(t.fromValues=t.values.map(t=>t.lastPosition)),Y(this)||(q(this,!0),W(this)||this._resume())}_resume(){r.b.skipAnimation?this.finish():r.o.start(this)}_stop(t,e){if(Y(this)){q(this,!1);const n=this.animation;Object(r.k)(n.values,t=>{t.done=!0}),n.toValues&&(n.onChange=n.onPause=n.onResume=void 0),Object(r.d)(this,{type:"idle",parent:this});const i=e?j(this.get()):R(this.get(),J(this,null!=t?t:n.to));Object(r.n)(this._pendingCalls,i),n.changed&&(n.changed=!1,_(this,"onRest",i,this))}}}function J(t,e){const n=m(e),i=m(t.get());return Object(r.u)(i,n)}function U(t,e=t.loop,n=t.to){let r=s(e);if(r){const i=!0!==r&&g(r),o=(i||t).reverse,s=!i||i.reset;return K(a({},t,{loop:e,default:!1,pause:void 0,to:!o||v(n)?n:void 0,from:s?t.from:void 0,reset:s},i))}}function K(t){const{to:e,from:n}=t=g(t),i=new Set;return r.s.obj(e)&&V(e,i),r.s.obj(n)&&V(n,i),t.keys=i.size?Array.from(i):null,t}function H(t){const e=K(t);return r.s.und(e.default)&&(e.default=f(e)),e}function V(t,e){Object(r.l)(t,(t,n)=>null!=t&&e.add(n))}const Z=["onStart","onRest","onChange","onPause","onResume"];function X(t,e,n){t.animation[n]=e[n]!==u(e,n)?l(e[n],t.key):void 0}function _(t,e,...n){var r,i,o,a;null==(r=(i=t.animation)[e])||r.call(i,...n),null==(o=(a=t.defaultProps)[e])||o.call(a,...n)}const $=["onStart","onChange","onRest"];let tt=1;class et{constructor(t,e){this.id=tt++,this.springs={},this.queue=[],this.ref=void 0,this._flush=void 0,this._initialProps=void 0,this._lastAsyncId=0,this._active=new Set,this._changed=new Set,this._started=!1,this._item=void 0,this._state={paused:!1,pauseQueue:new Set,resumeQueue:new Set,timeouts:new Set},this._events={onStart:new Map,onChange:new Map,onRest:new Map},this._onFrame=this._onFrame.bind(this),e&&(this._flush=e),t&&this.start(a({default:!0},t))}get idle(){return!this._state.asyncTo&&Object.values(this.springs).every(t=>t.idle)}get item(){return this._item}set item(t){this._item=t}get(){const t={};return this.each((e,n)=>t[n]=e.get()),t}set(t){for(const e in t){const n=t[e];r.s.und(n)||this.springs[e].set(n)}}update(t){return t&&this.queue.push(K(t)),this}start(t){let{queue:e}=this;return t?e=Object(r.y)(t).map(K):this.queue=[],this._flush?this._flush(this,e):(st(this,e),nt(this,e))}stop(t,e){if(t!==!!t&&(e=t),e){const n=this.springs;Object(r.k)(Object(r.y)(e),e=>n[e].stop(!!t))}else B(this._state,this._lastAsyncId),this.each(e=>e.stop(!!t));return this}pause(t){if(r.s.und(t))this.start({pause:!0});else{const e=this.springs;Object(r.k)(Object(r.y)(t),t=>e[t].pause())}return this}resume(t){if(r.s.und(t))this.start({pause:!1});else{const e=this.springs;Object(r.k)(Object(r.y)(t),t=>e[t].resume())}return this}each(t){Object(r.l)(this.springs,t)}_onFrame(){const{onStart:t,onChange:e,onRest:n}=this._events,i=this._active.size>0,o=this._changed.size>0;(i&&!this._started||o&&!this._started)&&(this._started=!0,Object(r.m)(t,([t,e])=>{e.value=this.get(),t(e,this,this._item)}));const a=!i&&this._started,s=o||a&&n.size?this.get():null;o&&e.size&&Object(r.m)(e,([t,e])=>{e.value=s,t(e,this,this._item)}),a&&(this._started=!1,Object(r.m)(n,([t,e])=>{e.value=s,t(e,this,this._item)}))}eventObserved(t){if("change"==t.type)this._changed.add(t.parent),t.idle||this._active.add(t.parent);else{if("idle"!=t.type)return;this._active.delete(t.parent)}r.w.onFrame(this._onFrame)}}function nt(t,e){return Promise.all(e.map(e=>async function t(e,n,i){const{keys:o,to:a,from:s,loop:c,onRest:l,onResolve:d}=n,f=r.s.obj(n.default)&&n.default;c&&(n.loop=!1);!1===a&&(n.to=null);!1===s&&(n.from=null);const h=r.s.arr(a)||r.s.fun(a)?a:void 0;h?(n.to=void 0,n.onRest=void 0,f&&(f.onRest=void 0)):Object(r.k)($,t=>{const i=n[t];if(r.s.fun(i)){const r=e._events[t];n[t]=({finished:t,cancelled:e})=>{const n=r.get(i);n?(t||(n.finished=!1),e&&(n.cancelled=!0)):r.set(i,{value:null,finished:t||!1,cancelled:e||!1})},f&&(f[t]=n[t])}});const p=e._state;n.pause===!p.paused?(p.paused=n.pause,Object(r.n)(n.pause?p.pauseQueue:p.resumeQueue)):p.paused&&(n.pause=!0);const g=(o||Object.keys(e.springs)).map(t=>e.springs[t].start(n)),m=!0===n.cancel||!0===u(n,"cancel");(h||m&&p.asyncId)&&g.push(E(++e._lastAsyncId,{props:n,state:p,actions:{pause:r.v,resume:r.v,start(t,n){m?(B(p,e._lastAsyncId),n(j(e))):(t.onRest=l,n(I(h,t,p,e)))}}}));p.paused&&await new Promise(t=>{p.resumeQueue.add(t)});const y=M(e,await Promise.all(g));if(c&&y.finished&&(!i||!y.noop)){const r=U(n,c,a);if(r)return st(e,[r]),t(e,r,!0)}d&&r.w.batchedUpdates(()=>d(y,e,e.item));return y}(t,e))).then(e=>M(t,e))}function rt(t,e){const n=a({},t.springs);return e&&Object(r.k)(Object(r.y)(e),t=>{r.s.und(t.keys)&&(t=K(t)),r.s.obj(t.to)||(t=a({},t,{to:void 0})),at(n,t,t=>ot(t))}),it(t,n),n}function it(t,e){Object(r.l)(e,(e,n)=>{t.springs[n]||(t.springs[n]=e,Object(r.c)(e,t))})}function ot(t,e){const n=new G;return n.key=t,e&&Object(r.c)(n,e),n}function at(t,e,n){e.keys&&Object(r.k)(e.keys,r=>{(t[r]||(t[r]=n(r)))._prepareNode(e)})}function st(t,e){Object(r.k)(e,e=>{at(t.springs,e,e=>ot(e,t))})}function ct(t,e){if(null==t)return{};var n,r,i={},o=Object.keys(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||(i[n]=t[n]);return i}const lt=["children"],ut=t=>{let{children:e}=t,n=ct(t,lt);const o=Object(i.useContext)(dt),a=n.pause||!!o.pause,s=n.immediate||!!o.immediate;n=Object(r.B)(()=>({pause:a,immediate:s}),[a,s]);const{Provider:c}=dt;return i.createElement(c,{value:n},e)},dt=(ft=ut,ht={},Object.assign(ft,i.createContext(ht)),ft.Provider._context=ft,ft.Consumer._context=ft,ft);var ft,ht;ut.Provider=dt.Provider,ut.Consumer=dt.Consumer;const pt=()=>{const t=[],e=function(e){Object(r.i)();const i=[];return Object(r.k)(t,(t,o)=>{if(r.s.und(e))i.push(t.start());else{const r=n(e,t,o);r&&i.push(t.start(r))}}),i};e.current=t,e.add=function(e){t.includes(e)||t.push(e)},e.delete=function(e){const n=t.indexOf(e);~n&&t.splice(n,1)},e.pause=function(){return Object(r.k)(t,t=>t.pause(...arguments)),this},e.resume=function(){return Object(r.k)(t,t=>t.resume(...arguments)),this},e.set=function(e){Object(r.k)(t,t=>t.set(e))},e.start=function(e){const n=[];return Object(r.k)(t,(t,i)=>{if(r.s.und(e))n.push(t.start());else{const r=this._getProps(e,t,i);r&&n.push(t.start(r))}}),n},e.stop=function(){return Object(r.k)(t,t=>t.stop(...arguments)),this},e.update=function(e){return Object(r.k)(t,(t,n)=>t.update(this._getProps(e,t,n))),this};const n=function(t,e,n){return r.s.fun(t)?t(n,e):t};return e._getProps=n,e};function gt(t,e,n){const o=r.s.fun(e)&&e;o&&!n&&(n=[]);const s=Object(i.useMemo)(()=>o||3==arguments.length?pt():void 0,[]),c=Object(i.useRef)(0),l=Object(r.z)(),u=Object(i.useMemo)(()=>({ctrls:[],queue:[],flush(t,e){const n=rt(t,e);return c.current>0&&!u.queue.length&&!Object.keys(n).some(e=>!t.springs[e])?nt(t,e):new Promise(r=>{it(t,n),u.queue.push(()=>{r(nt(t,e))}),l()})}}),[]),d=Object(i.useRef)([...u.ctrls]),f=[],h=Object(r.D)(t)||0;function p(t,n){for(let r=t;r<n;r++){const t=d.current[r]||(d.current[r]=new et(null,u.flush)),n=o?o(r,t):e[r];n&&(f[r]=H(n))}}Object(i.useMemo)(()=>{Object(r.k)(d.current.slice(t,h),t=>{b(t,s),t.stop(!0)}),d.current.length=t,p(h,t)},[t]),Object(i.useMemo)(()=>{p(0,Math.min(h,t))},n);const g=d.current.map((t,e)=>rt(t,f[e])),m=Object(i.useContext)(ut),v=Object(r.D)(m),w=m!==v&&y(m);Object(r.A)(()=>{c.current++,u.ctrls=d.current;const{queue:t}=u;t.length&&(u.queue=[],Object(r.k)(t,t=>t())),Object(r.k)(d.current,(t,e)=>{null==s||s.add(t),w&&t.start({default:m});const n=f[e];n&&(k(t,n.ref),t.ref?t.queue.push(n):t.start(n))})}),Object(r.C)(()=>()=>{Object(r.k)(u.ctrls,t=>t.stop(!0))});const x=g.map(t=>a({},t));return s?[x,s]:x}function mt(t,e){const n=r.s.fun(t),[[i],o]=gt(1,n?t:[t],n?e||[]:e);return n||2==arguments.length?[i,o]:i}let yt;function vt(t,e,n){const o=r.s.fun(e)&&e,{reset:c,sort:l,trail:u=0,expires:d=!0,onDestroyed:h,ref:p,config:m}=o?o():e,v=Object(i.useMemo)(()=>o||3==arguments.length?pt():void 0,[]),w=Object(r.y)(t),x=[],A=Object(i.useRef)(null),S=c?null:A.current;Object(r.A)(()=>{A.current=x}),Object(r.C)(()=>()=>Object(r.k)(A.current,t=>{t.expired&&clearTimeout(t.expirationId),b(t.ctrl,v),t.ctrl.stop(!0)}));const O=kt(w,o?o():e,S),E=c&&A.current||[];Object(r.A)(()=>Object(r.k)(E,({ctrl:t,item:e,key:n})=>{b(t,v),s(h,e,n)}));const M=[];if(S&&Object(r.k)(S,(t,e)=>{t.expired?(clearTimeout(t.expirationId),E.push(t)):~(e=M[e]=O.indexOf(t.key))&&(x[e]=t)}),Object(r.k)(w,(t,e)=>{x[e]||(x[e]={key:O[e],item:t,phase:yt.MOUNT,ctrl:new et},x[e].ctrl.item=t)}),M.length){let t=-1;const{leave:n}=o?o():e;Object(r.k)(M,(e,r)=>{const i=S[r];~e?(t=x.indexOf(i),x[t]=a({},i,{item:w[e]})):n&&x.splice(++t,0,i)})}r.s.fun(l)&&x.sort((t,e)=>l(t.item,e.item));let C=-u;const R=Object(r.z)(),j=f(e),I=new Map;Object(r.k)(x,(t,n)=>{const i=t.key,c=t.phase,l=o?o():e;let f,h,y=s(l.delay||0,i);if(c==yt.MOUNT)f=l.enter,h=yt.ENTER;else{const t=O.indexOf(i)<0;if(c!=yt.LEAVE)if(t)f=l.leave,h=yt.LEAVE;else{if(!(f=l.update))return;h=yt.UPDATE}else{if(t)return;f=l.enter,h=yt.ENTER}}if(f=s(f,t.item,n),f=r.s.obj(f)?g(f):{to:f},!f.config){const e=m||j.config;f.config=s(e,t.item,n,h)}C+=u;const v=a({},j,{delay:y+C,ref:p,immediate:l.immediate,reset:!1},f);if(h==yt.ENTER&&r.s.und(v.from)){const i=o?o():e,a=r.s.und(i.initial)||S?i.from:i.initial;v.from=s(a,t.item,n)}const{onResolve:b}=v;v.onResolve=t=>{s(b,t);const e=A.current,n=e.find(t=>t.key===i);if(n&&(!t.cancelled||n.phase==yt.UPDATE)&&n.ctrl.idle){const t=e.every(t=>t.ctrl.idle);if(n.phase==yt.LEAVE){const e=s(d,n.item);if(!1!==e){const r=!0===e?0:e;if(n.expired=!0,!t&&r>0)return void(r<=2147483647&&(n.expirationId=setTimeout(R,r)))}}t&&e.some(t=>t.expired)&&R()}};const k=rt(t.ctrl,v);I.set(t,{phase:h,springs:k,payload:v})});const B=Object(i.useContext)(ut),D=Object(r.D)(B),T=B!==D&&y(B);Object(r.A)(()=>{T&&Object(r.k)(x,t=>{t.ctrl.start({default:B})})},[B]),Object(r.A)(()=>{Object(r.k)(I,({phase:t,payload:e},n)=>{const{ctrl:r}=n;n.phase=t,null==v||v.add(r),T&&t==yt.ENTER&&r.start({default:B}),e&&(k(r,e.ref),r.ref?r.update(e):r.start(e))})},c?void 0:n);const F=t=>i.createElement(i.Fragment,null,x.map((e,n)=>{const{springs:o}=I.get(e)||e.ctrl,s=t(a({},o),e.item,e,n);return s&&s.type?i.createElement(s.type,a({},s.props,{key:r.s.str(e.key)||r.s.num(e.key)?e.key:e.ctrl.id,ref:s.ref})):s}));return v?[F,v]:F}!function(t){t.MOUNT="mount",t.ENTER="enter",t.UPDATE="update",t.LEAVE="leave"}(yt||(yt={}));let bt=1;function kt(t,{key:e,keys:n=e},i){if(null===n){const e=new Set;return t.map(t=>{const n=i&&i.find(n=>n.item===t&&n.phase!==yt.LEAVE&&!e.has(n));return n?(e.add(n),n.key):bt++})}return r.s.und(n)?t:r.s.fun(n)?t.map(n):Object(r.y)(n)}const wt=["children"];function xt(t){let{children:e}=t;return e(mt(ct(t,wt)))}class At extends z{constructor(t,e){super(),this.key=void 0,this.idle=!0,this.calc=void 0,this._active=new Set,this.source=t,this.calc=Object(r.f)(...e);const n=this._get(),i=Object(o.f)(n);Object(o.h)(this,i.create(n))}advance(t){const e=this._get(),n=this.get();Object(r.u)(e,n)||(Object(o.e)(this).setValue(e),this._onChange(e,this.idle)),!this.idle&&Ot(this._active)&&Et(this)}_get(){const t=r.s.arr(this.source)?this.source.map(r.q):Object(r.y)(Object(r.q)(this.source));return this.calc(...t)}_start(){this.idle&&!Ot(this._active)&&(this.idle=!1,Object(r.k)(Object(o.g)(this),t=>{t.done=!1}),r.b.skipAnimation?(r.w.batchedUpdates(()=>this.advance()),Et(this)):r.o.start(this))}_attach(){let t=1;Object(r.k)(Object(r.y)(this.source),e=>{Object(r.r)(e)&&Object(r.c)(e,this),F(e)&&(e.idle||this._active.add(e),t=Math.max(t,e.priority+1))}),this.priority=t,this._start()}_detach(){Object(r.k)(Object(r.y)(this.source),t=>{Object(r.r)(t)&&Object(r.x)(t,this)}),this._active.clear(),Et(this)}eventObserved(t){"change"==t.type?t.idle?this.advance():(this._active.add(t.parent),this._start()):"idle"==t.type?this._active.delete(t.parent):"priority"==t.type&&(this.priority=Object(r.y)(this.source).reduce((t,e)=>Math.max(t,(F(e)?e.priority:0)+1),0))}}function St(t){return!1!==t.idle}function Ot(t){return!t.size||Array.from(t).every(St)}function Et(t){t.idle||(t.idle=!0,Object(r.k)(Object(o.g)(t),t=>{t.done=!0}),Object(r.d)(t,{type:"idle",parent:t}))}r.b.assign({createStringInterpolator:r.g,to:(t,e)=>new At(t,e)});r.o.advance},function(t,e,n){var r=n(86);function i(e,n,o){return"undefined"!=typeof Reflect&&Reflect.get?(t.exports=i=Reflect.get,t.exports.default=t.exports,t.exports.__esModule=!0):(t.exports=i=function(t,e,n){var i=r(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}},t.exports.default=t.exports,t.exports.__esModule=!0),i(e,n,o||e)}t.exports=i,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(13),i=n(25),o=n(89),a=n(90);function s(e){var n="function"==typeof Map?new Map:void 0;return t.exports=s=function(t){if(null===t||!o(t))return t;if("function"!=typeof t)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(t))return n.get(t);n.set(t,e)}function e(){return a(t,arguments,r(this).constructor)}return e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),i(e,t)},t.exports.default=t.exports,t.exports.__esModule=!0,s(e)}t.exports=s,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}},function(t,e,n){var r=n(33),i=n(74),o=n(76),a=Math.max,s=Math.min;t.exports=function(t,e,n){var c,l,u,d,f,h,p=0,g=!1,m=!1,y=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function v(e){var n=c,r=l;return c=l=void 0,p=e,d=t.apply(r,n)}function b(t){return p=t,f=setTimeout(w,e),g?v(t):d}function k(t){var n=t-h;return void 0===h||n>=e||n<0||m&&t-p>=u}function w(){var t=i();if(k(t))return x(t);f=setTimeout(w,function(t){var n=e-(t-h);return m?s(n,u-(t-p)):n}(t))}function x(t){return f=void 0,y&&c?v(t):(c=l=void 0,d)}function A(){var t=i(),n=k(t);if(c=arguments,l=this,h=t,n){if(void 0===f)return b(h);if(m)return clearTimeout(f),f=setTimeout(w,e),v(h)}return void 0===f&&(f=setTimeout(w,e)),d}return e=o(e)||0,r(n)&&(g=!!n.leading,u=(m="maxWait"in n)?a(o(n.maxWait)||0,e):u,y="trailing"in n?!!n.trailing:y),A.cancel=function(){void 0!==f&&clearTimeout(f),p=0,c=h=l=f=void 0},A.flush=function(){return void 0===f?d:x(i())},A}},function(t,e,n){"use strict";var r=n(88);function i(t,e,n){var i,s,c,l;e=e||1;for(var u=0;u<t[0].length;u++){var d=t[0][u];(!u||d[0]<i)&&(i=d[0]),(!u||d[1]<s)&&(s=d[1]),(!u||d[0]>c)&&(c=d[0]),(!u||d[1]>l)&&(l=d[1])}var f=c-i,h=l-s,p=Math.min(f,h),g=p/2;if(0===p){var m=[i,s];return m.distance=0,m}for(var y=new r(void 0,o),v=i;v<c;v+=p)for(var b=s;b<l;b+=p)y.push(new a(v+g,b+g,g,t));var k=function(t){for(var e=0,n=0,r=0,i=t[0],o=0,s=i.length,c=s-1;o<s;c=o++){var l=i[o],u=i[c],d=l[0]*u[1]-u[0]*l[1];n+=(l[0]+u[0])*d,r+=(l[1]+u[1])*d,e+=3*d}return 0===e?new a(i[0][0],i[0][1],0,t):new a(n/e,r/e,0,t)}(t),w=new a(i+f/2,s+h/2,0,t);w.d>k.d&&(k=w);for(var x=y.length;y.length;){var A=y.pop();A.d>k.d&&(k=A,n&&console.log("found best %d after %d probes",Math.round(1e4*A.d)/1e4,x)),A.max-k.d<=e||(g=A.h/2,y.push(new a(A.x-g,A.y-g,g,t)),y.push(new a(A.x+g,A.y-g,g,t)),y.push(new a(A.x-g,A.y+g,g,t)),y.push(new a(A.x+g,A.y+g,g,t)),x+=4)}n&&(console.log("num probes: "+x),console.log("best distance: "+k.d));var S=[k.x,k.y];return S.distance=k.d,S}function o(t,e){return e.max-t.max}function a(t,e,n,r){this.x=t,this.y=e,this.h=n,this.d=function(t,e,n){for(var r=!1,i=1/0,o=0;o<n.length;o++)for(var a=n[o],c=0,l=a.length,u=l-1;c<l;u=c++){var d=a[c],f=a[u];d[1]>e!=f[1]>e&&t<(f[0]-d[0])*(e-d[1])/(f[1]-d[1])+d[0]&&(r=!r),i=Math.min(i,s(t,e,d,f))}return 0===i?0:(r?1:-1)*Math.sqrt(i)}(t,e,r),this.max=this.d+this.h*Math.SQRT2}function s(t,e,n,r){var i=n[0],o=n[1],a=r[0]-i,s=r[1]-o;if(0!==a||0!==s){var c=((t-i)*a+(e-o)*s)/(a*a+s*s);c>1?(i=r[0],o=r[1]):c>0&&(i+=a*c,o+=s*c)}return(a=t-i)*a+(s=e-o)*s}r.default&&(r=r.default),t.exports=i,t.exports.default=i},function(t,e,n){"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/var r=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;function a(t){if(null==t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}t.exports=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map((function(t){return e[t]})).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach((function(t){r[t]=t})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(t){return!1}}()?Object.assign:function(t,e){for(var n,s,c=a(t),l=1;l<arguments.length;l++){for(var u in n=Object(arguments[l]))i.call(n,u)&&(c[u]=n[u]);if(r){s=r(n);for(var d=0;d<s.length;d++)o.call(n,s[d])&&(c[s[d]]=n[s[d]])}}return c}},function(t,e){t.exports=function(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(37);t.exports=function(t,e){if(t){if("string"==typeof t)return r(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(t,e):void 0}},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){"use strict";n.d(e,"animated",(function(){return A}));var r=n(30);n.o(r,"Spring")&&n.d(e,"Spring",(function(){return r.Spring})),n.o(r,"useSpring")&&n.d(e,"useSpring",(function(){return r.useSpring})),n.o(r,"useSprings")&&n.d(e,"useSprings",(function(){return r.useSprings})),n.o(r,"useTransition")&&n.d(e,"useTransition",(function(){return r.useTransition}));var i=n(15),o=n(3),a=n(20);function s(t,e){if(null==t)return{};var n,r,i={},o=Object.keys(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||(i[n]=t[n]);return i}const c=["style","children","scrollTop","scrollLeft"],l=/^--/;function u(t,e){return null==e||"boolean"==typeof e||""===e?"":"number"!=typeof e||0===e||l.test(t)||f.hasOwnProperty(t)&&f[t]?(""+e).trim():e+"px"}const d={};let f={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0};const h=["Webkit","Ms","Moz","O"];f=Object.keys(f).reduce((t,e)=>(h.forEach(n=>t[((t,e)=>t+e.charAt(0).toUpperCase()+e.substring(1))(n,e)]=t[e]),t),f);const p=["x","y","z"],g=/^(matrix|translate|scale|rotate|skew)/,m=/^(translate)/,y=/^(rotate|skew)/,v=(t,e)=>o.s.num(t)&&0!==t?t+e:t,b=(t,e)=>o.s.arr(t)?t.every(t=>b(t,e)):o.s.num(t)?t===e:parseFloat(t)===e;class k extends a.a{constructor(t){let{x:e,y:n,z:r}=t,i=s(t,p);const a=[],c=[];(e||n||r)&&(a.push([e||0,n||0,r||0]),c.push(t=>[`translate3d(${t.map(t=>v(t,"px")).join(",")})`,b(t,0)])),Object(o.l)(i,(t,e)=>{if("transform"===e)a.push([t||""]),c.push(t=>[t,""===t]);else if(g.test(e)){if(delete i[e],o.s.und(t))return;const n=m.test(e)?"px":y.test(e)?"deg":"";a.push(Object(o.y)(t)),c.push("rotate3d"===e?([t,e,r,i])=>[`rotate3d(${t},${e},${r},${v(i,n)})`,b(i,0)]:t=>[`${e}(${t.map(t=>v(t,n)).join(",")})`,b(t,e.startsWith("scale")?1:0)])}}),a.length&&(i.transform=new w(a,c)),super(i)}}class w extends o.a{constructor(t,e){super(),this._value=null,this.inputs=t,this.transforms=e}get(){return this._value||(this._value=this._get())}_get(){let t="",e=!0;return Object(o.k)(this.inputs,(n,r)=>{const i=Object(o.q)(n[0]),[a,s]=this.transforms[r](o.s.arr(i)?i:n.map(o.q));t+=" "+a,e=e&&s}),e?"none":t}observerAdded(t){1==t&&Object(o.k)(this.inputs,t=>Object(o.k)(t,t=>Object(o.r)(t)&&Object(o.c)(t,this)))}observerRemoved(t){0==t&&Object(o.k)(this.inputs,t=>Object(o.k)(t,t=>Object(o.r)(t)&&Object(o.x)(t,this)))}eventObserved(t){"change"==t.type&&(this._value=null),Object(o.d)(this,t)}}const x=["scrollTop","scrollLeft"];r.Globals.assign({batchedUpdates:i.unstable_batchedUpdates,createStringInterpolator:o.g,colors:o.e});const A=Object(a.d)(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"],{applyAnimatedValues:function(t,e){if(!t.nodeType||!t.setAttribute)return!1;const n="filter"===t.nodeName||t.parentNode&&"filter"===t.parentNode.nodeName,r=e,{style:i,children:o,scrollTop:a,scrollLeft:f}=r,h=s(r,c),p=Object.values(h),g=Object.keys(h).map(e=>n||t.hasAttribute(e)?e:d[e]||(d[e]=e.replace(/([A-Z])/g,t=>"-"+t.toLowerCase())));void 0!==o&&(t.textContent=o);for(let e in i)if(i.hasOwnProperty(e)){const n=u(e,i[e]);l.test(e)?t.style.setProperty(e,n):t.style[e]=n}g.forEach((e,n)=>{t.setAttribute(e,p[n])}),void 0!==a&&(t.scrollTop=a),void 0!==f&&(t.scrollLeft=f)},createAnimatedStyle:t=>new k(t),getComponentProps:t=>s(t,x)}).animated},function(t,e){},function(t,e){},function(t,e,n){"use strict";t.exports={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}},function(t,e,n){var r=n(75),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){var r=n(43).Symbol;t.exports=r},function(t,e,n){var r=n(42),i={};for(var o in r)r.hasOwnProperty(o)&&(i[r[o]]=o);var a=t.exports={rgb:{channels:3,labels:"rgb"},hsl:{channels:3,labels:"hsl"},hsv:{channels:3,labels:"hsv"},hwb:{channels:3,labels:"hwb"},cmyk:{channels:4,labels:"cmyk"},xyz:{channels:3,labels:"xyz"},lab:{channels:3,labels:"lab"},lch:{channels:3,labels:"lch"},hex:{channels:1,labels:["hex"]},keyword:{channels:1,labels:["keyword"]},ansi16:{channels:1,labels:["ansi16"]},ansi256:{channels:1,labels:["ansi256"]},hcg:{channels:3,labels:["h","c","g"]},apple:{channels:3,labels:["r16","g16","b16"]},gray:{channels:1,labels:["gray"]}};for(var s in a)if(a.hasOwnProperty(s)){if(!("channels"in a[s]))throw new Error("missing channels property: "+s);if(!("labels"in a[s]))throw new Error("missing channel labels property: "+s);if(a[s].labels.length!==a[s].channels)throw new Error("channel and label counts mismatch: "+s);var c=a[s].channels,l=a[s].labels;delete a[s].channels,delete a[s].labels,Object.defineProperty(a[s],"channels",{value:c}),Object.defineProperty(a[s],"labels",{value:l})}a.rgb.hsl=function(t){var e,n,r=t[0]/255,i=t[1]/255,o=t[2]/255,a=Math.min(r,i,o),s=Math.max(r,i,o),c=s-a;return s===a?e=0:r===s?e=(i-o)/c:i===s?e=2+(o-r)/c:o===s&&(e=4+(r-i)/c),(e=Math.min(60*e,360))<0&&(e+=360),n=(a+s)/2,[e,100*(s===a?0:n<=.5?c/(s+a):c/(2-s-a)),100*n]},a.rgb.hsv=function(t){var e,n,r,i,o,a=t[0]/255,s=t[1]/255,c=t[2]/255,l=Math.max(a,s,c),u=l-Math.min(a,s,c),d=function(t){return(l-t)/6/u+.5};return 0===u?i=o=0:(o=u/l,e=d(a),n=d(s),r=d(c),a===l?i=r-n:s===l?i=1/3+e-r:c===l&&(i=2/3+n-e),i<0?i+=1:i>1&&(i-=1)),[360*i,100*o,100*l]},a.rgb.hwb=function(t){var e=t[0],n=t[1],r=t[2];return[a.rgb.hsl(t)[0],100*(1/255*Math.min(e,Math.min(n,r))),100*(r=1-1/255*Math.max(e,Math.max(n,r)))]},a.rgb.cmyk=function(t){var e,n=t[0]/255,r=t[1]/255,i=t[2]/255;return[100*((1-n-(e=Math.min(1-n,1-r,1-i)))/(1-e)||0),100*((1-r-e)/(1-e)||0),100*((1-i-e)/(1-e)||0),100*e]},a.rgb.keyword=function(t){var e=i[t];if(e)return e;var n,o,a,s=1/0;for(var c in r)if(r.hasOwnProperty(c)){var l=r[c],u=(o=t,a=l,Math.pow(o[0]-a[0],2)+Math.pow(o[1]-a[1],2)+Math.pow(o[2]-a[2],2));u<s&&(s=u,n=c)}return n},a.keyword.rgb=function(t){return r[t]},a.rgb.xyz=function(t){var e=t[0]/255,n=t[1]/255,r=t[2]/255;return[100*(.4124*(e=e>.04045?Math.pow((e+.055)/1.055,2.4):e/12.92)+.3576*(n=n>.04045?Math.pow((n+.055)/1.055,2.4):n/12.92)+.1805*(r=r>.04045?Math.pow((r+.055)/1.055,2.4):r/12.92)),100*(.2126*e+.7152*n+.0722*r),100*(.0193*e+.1192*n+.9505*r)]},a.rgb.lab=function(t){var e=a.rgb.xyz(t),n=e[0],r=e[1],i=e[2];return r/=100,i/=108.883,n=(n/=95.047)>.008856?Math.pow(n,1/3):7.787*n+16/116,[116*(r=r>.008856?Math.pow(r,1/3):7.787*r+16/116)-16,500*(n-r),200*(r-(i=i>.008856?Math.pow(i,1/3):7.787*i+16/116))]},a.hsl.rgb=function(t){var e,n,r,i,o,a=t[0]/360,s=t[1]/100,c=t[2]/100;if(0===s)return[o=255*c,o,o];e=2*c-(n=c<.5?c*(1+s):c+s-c*s),i=[0,0,0];for(var l=0;l<3;l++)(r=a+1/3*-(l-1))<0&&r++,r>1&&r--,o=6*r<1?e+6*(n-e)*r:2*r<1?n:3*r<2?e+(n-e)*(2/3-r)*6:e,i[l]=255*o;return i},a.hsl.hsv=function(t){var e=t[0],n=t[1]/100,r=t[2]/100,i=n,o=Math.max(r,.01);return n*=(r*=2)<=1?r:2-r,i*=o<=1?o:2-o,[e,100*(0===r?2*i/(o+i):2*n/(r+n)),100*((r+n)/2)]},a.hsv.rgb=function(t){var e=t[0]/60,n=t[1]/100,r=t[2]/100,i=Math.floor(e)%6,o=e-Math.floor(e),a=255*r*(1-n),s=255*r*(1-n*o),c=255*r*(1-n*(1-o));switch(r*=255,i){case 0:return[r,c,a];case 1:return[s,r,a];case 2:return[a,r,c];case 3:return[a,s,r];case 4:return[c,a,r];case 5:return[r,a,s]}},a.hsv.hsl=function(t){var e,n,r,i=t[0],o=t[1]/100,a=t[2]/100,s=Math.max(a,.01);return r=(2-o)*a,n=o*s,[i,100*(n=(n/=(e=(2-o)*s)<=1?e:2-e)||0),100*(r/=2)]},a.hwb.rgb=function(t){var e,n,r,i,o,a,s,c=t[0]/360,l=t[1]/100,u=t[2]/100,d=l+u;switch(d>1&&(l/=d,u/=d),r=6*c-(e=Math.floor(6*c)),0!=(1&e)&&(r=1-r),i=l+r*((n=1-u)-l),e){default:case 6:case 0:o=n,a=i,s=l;break;case 1:o=i,a=n,s=l;break;case 2:o=l,a=n,s=i;break;case 3:o=l,a=i,s=n;break;case 4:o=i,a=l,s=n;break;case 5:o=n,a=l,s=i}return[255*o,255*a,255*s]},a.cmyk.rgb=function(t){var e=t[0]/100,n=t[1]/100,r=t[2]/100,i=t[3]/100;return[255*(1-Math.min(1,e*(1-i)+i)),255*(1-Math.min(1,n*(1-i)+i)),255*(1-Math.min(1,r*(1-i)+i))]},a.xyz.rgb=function(t){var e,n,r,i=t[0]/100,o=t[1]/100,a=t[2]/100;return n=-.9689*i+1.8758*o+.0415*a,r=.0557*i+-.204*o+1.057*a,e=(e=3.2406*i+-1.5372*o+-.4986*a)>.0031308?1.055*Math.pow(e,1/2.4)-.055:12.92*e,n=n>.0031308?1.055*Math.pow(n,1/2.4)-.055:12.92*n,r=r>.0031308?1.055*Math.pow(r,1/2.4)-.055:12.92*r,[255*(e=Math.min(Math.max(0,e),1)),255*(n=Math.min(Math.max(0,n),1)),255*(r=Math.min(Math.max(0,r),1))]},a.xyz.lab=function(t){var e=t[0],n=t[1],r=t[2];return n/=100,r/=108.883,e=(e/=95.047)>.008856?Math.pow(e,1/3):7.787*e+16/116,[116*(n=n>.008856?Math.pow(n,1/3):7.787*n+16/116)-16,500*(e-n),200*(n-(r=r>.008856?Math.pow(r,1/3):7.787*r+16/116))]},a.lab.xyz=function(t){var e,n,r,i=t[0];e=t[1]/500+(n=(i+16)/116),r=n-t[2]/200;var o=Math.pow(n,3),a=Math.pow(e,3),s=Math.pow(r,3);return n=o>.008856?o:(n-16/116)/7.787,e=a>.008856?a:(e-16/116)/7.787,r=s>.008856?s:(r-16/116)/7.787,[e*=95.047,n*=100,r*=108.883]},a.lab.lch=function(t){var e,n=t[0],r=t[1],i=t[2];return(e=360*Math.atan2(i,r)/2/Math.PI)<0&&(e+=360),[n,Math.sqrt(r*r+i*i),e]},a.lch.lab=function(t){var e,n=t[0],r=t[1];return e=t[2]/360*2*Math.PI,[n,r*Math.cos(e),r*Math.sin(e)]},a.rgb.ansi16=function(t){var e=t[0],n=t[1],r=t[2],i=1 in arguments?arguments[1]:a.rgb.hsv(t)[2];if(0===(i=Math.round(i/50)))return 30;var o=30+(Math.round(r/255)<<2|Math.round(n/255)<<1|Math.round(e/255));return 2===i&&(o+=60),o},a.hsv.ansi16=function(t){return a.rgb.ansi16(a.hsv.rgb(t),t[2])},a.rgb.ansi256=function(t){var e=t[0],n=t[1],r=t[2];return e===n&&n===r?e<8?16:e>248?231:Math.round((e-8)/247*24)+232:16+36*Math.round(e/255*5)+6*Math.round(n/255*5)+Math.round(r/255*5)},a.ansi16.rgb=function(t){var e=t%10;if(0===e||7===e)return t>50&&(e+=3.5),[e=e/10.5*255,e,e];var n=.5*(1+~~(t>50));return[(1&e)*n*255,(e>>1&1)*n*255,(e>>2&1)*n*255]},a.ansi256.rgb=function(t){if(t>=232){var e=10*(t-232)+8;return[e,e,e]}var n;return t-=16,[Math.floor(t/36)/5*255,Math.floor((n=t%36)/6)/5*255,n%6/5*255]},a.rgb.hex=function(t){var e=(((255&Math.round(t[0]))<<16)+((255&Math.round(t[1]))<<8)+(255&Math.round(t[2]))).toString(16).toUpperCase();return"000000".substring(e.length)+e},a.hex.rgb=function(t){var e=t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);if(!e)return[0,0,0];var n=e[0];3===e[0].length&&(n=n.split("").map((function(t){return t+t})).join(""));var r=parseInt(n,16);return[r>>16&255,r>>8&255,255&r]},a.rgb.hcg=function(t){var e,n=t[0]/255,r=t[1]/255,i=t[2]/255,o=Math.max(Math.max(n,r),i),a=Math.min(Math.min(n,r),i),s=o-a;return e=s<=0?0:o===n?(r-i)/s%6:o===r?2+(i-n)/s:4+(n-r)/s+4,e/=6,[360*(e%=1),100*s,100*(s<1?a/(1-s):0)]},a.hsl.hcg=function(t){var e=t[1]/100,n=t[2]/100,r=1,i=0;return(r=n<.5?2*e*n:2*e*(1-n))<1&&(i=(n-.5*r)/(1-r)),[t[0],100*r,100*i]},a.hsv.hcg=function(t){var e=t[1]/100,n=t[2]/100,r=e*n,i=0;return r<1&&(i=(n-r)/(1-r)),[t[0],100*r,100*i]},a.hcg.rgb=function(t){var e=t[0]/360,n=t[1]/100,r=t[2]/100;if(0===n)return[255*r,255*r,255*r];var i,o=[0,0,0],a=e%1*6,s=a%1,c=1-s;switch(Math.floor(a)){case 0:o[0]=1,o[1]=s,o[2]=0;break;case 1:o[0]=c,o[1]=1,o[2]=0;break;case 2:o[0]=0,o[1]=1,o[2]=s;break;case 3:o[0]=0,o[1]=c,o[2]=1;break;case 4:o[0]=s,o[1]=0,o[2]=1;break;default:o[0]=1,o[1]=0,o[2]=c}return i=(1-n)*r,[255*(n*o[0]+i),255*(n*o[1]+i),255*(n*o[2]+i)]},a.hcg.hsv=function(t){var e=t[1]/100,n=e+t[2]/100*(1-e),r=0;return n>0&&(r=e/n),[t[0],100*r,100*n]},a.hcg.hsl=function(t){var e=t[1]/100,n=t[2]/100*(1-e)+.5*e,r=0;return n>0&&n<.5?r=e/(2*n):n>=.5&&n<1&&(r=e/(2*(1-n))),[t[0],100*r,100*n]},a.hcg.hwb=function(t){var e=t[1]/100,n=e+t[2]/100*(1-e);return[t[0],100*(n-e),100*(1-n)]},a.hwb.hcg=function(t){var e=t[1]/100,n=1-t[2]/100,r=n-e,i=0;return r<1&&(i=(n-r)/(1-r)),[t[0],100*r,100*i]},a.apple.rgb=function(t){return[t[0]/65535*255,t[1]/65535*255,t[2]/65535*255]},a.rgb.apple=function(t){return[t[0]/255*65535,t[1]/255*65535,t[2]/255*65535]},a.gray.rgb=function(t){return[t[0]/100*255,t[0]/100*255,t[0]/100*255]},a.gray.hsl=a.gray.hsv=function(t){return[0,0,t[0]]},a.gray.hwb=function(t){return[0,100,t[0]]},a.gray.cmyk=function(t){return[0,0,0,t[0]]},a.gray.lab=function(t){return[t[0],0,0]},a.gray.hex=function(t){var e=255&Math.round(t[0]/100*255),n=((e<<16)+(e<<8)+e).toString(16).toUpperCase();return"000000".substring(n.length)+n},a.rgb.gray=function(t){return[(t[0]+t[1]+t[2])/3/255*100]}},function(t){t.exports=JSON.parse('{"type":"Topology","bbox":[-179.14733999999999,-14.552548999999999,179.77847,71.352561],"transform":{"scale":[0.003589293992939929,0.0008590596905969058],"translate":[-179.14733999999999,-14.552548999999999]},"objects":{"states":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[1,2,3,4,5]]],"id":"01","properties":{"name":"Alabama"}},{"type":"MultiPolygon","arcs":[[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]],[[62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75]],[[76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[115]],[[116]],[[117]],[[118]],[[119]],[[120]],[[121]],[[122]],[[123]],[[124]],[[125]],[[126]],[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138]],[[139]],[[140]],[[141]],[[142]]],"id":"02","properties":{"name":"Alaska"}},{"type":"Polygon","arcs":[[143,144,145,146,147]],"id":"04","properties":{"name":"Arizona"}},{"type":"Polygon","arcs":[[148,149,150,151,152,153]],"id":"08","properties":{"name":"Colorado"}},{"type":"MultiPolygon","arcs":[[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[163,164,-4]]],"id":"12","properties":{"name":"Florida"}},{"type":"Polygon","arcs":[[165,166,167,168,-164,-3]],"id":"13","properties":{"name":"Georgia"}},{"type":"Polygon","arcs":[[169,170,171,172,173]],"id":"18","properties":{"name":"Indiana"}},{"type":"Polygon","arcs":[[174,175,176,-151]],"id":"20","properties":{"name":"Kansas"}},{"type":"MultiPolygon","arcs":[[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[184,185]]],"id":"23","properties":{"name":"Maine"}},{"type":"MultiPolygon","arcs":[[[186]],[[187]],[[188,189,190,191,192,193,194,195]]],"id":"25","properties":{"name":"Massachusetts"}},{"type":"Polygon","arcs":[[196,197,198,199,200]],"id":"27","properties":{"name":"Minnesota"}},{"type":"Polygon","arcs":[[201,202,203,204,205,206,207,208]],"id":"34","properties":{"name":"New Jersey"}},{"type":"MultiPolygon","arcs":[[[209]],[[210]],[[211,212,213,-167,214]]],"id":"37","properties":{"name":"North Carolina"}},{"type":"Polygon","arcs":[[215,-201,216,217]],"id":"38","properties":{"name":"North Dakota"}},{"type":"Polygon","arcs":[[-152,-177,218,219,220,221]],"id":"40","properties":{"name":"Oklahoma"}},{"type":"Polygon","arcs":[[222,223,-204,224,225,226,227]],"id":"42","properties":{"name":"Pennsylvania"}},{"type":"Polygon","arcs":[[228,-217,-200,229,230,231]],"id":"46","properties":{"name":"South Dakota"}},{"type":"Polygon","arcs":[[-221,232,233,234,235,236,237]],"id":"48","properties":{"name":"Texas"}},{"type":"Polygon","arcs":[[-232,238,-149,239,240,241]],"id":"56","properties":{"name":"Wyoming"}},{"type":"Polygon","arcs":[[-195,242,243,244]],"id":"09","properties":{"name":"Connecticut"}},{"type":"Polygon","arcs":[[245,246,247,248,249,250,251,-219,-176,252]],"id":"29","properties":{"name":"Missouri"}},{"type":"Polygon","arcs":[[253,-227,254,255,256]],"id":"54","properties":{"name":"West Virginia"}},{"type":"Polygon","arcs":[[257,258,259,-174,260,-247]],"id":"17","properties":{"name":"Illinois"}},{"type":"Polygon","arcs":[[-153,-222,-238,261,-147]],"id":"35","properties":{"name":"New Mexico"}},{"type":"Polygon","arcs":[[-252,262,263,264,-235,233,-233,-220]],"id":"05","properties":{"name":"Arkansas"}},{"type":"MultiPolygon","arcs":[[[265]],[[266]],[[267]],[[268]],[[269]],[[270]],[[271]],[[272]],[[273,274,275,-144,276]]],"id":"06","properties":{"name":"California"}},{"type":"MultiPolygon","arcs":[[[-209,277]],[[-225,-203,278,279]]],"id":"10","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[280,281]],"id":"11","properties":{"name":"District of Columbia"}},{"type":"MultiPolygon","arcs":[[[282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]]],"id":"15","properties":{"name":"Hawaii"}},{"type":"Polygon","arcs":[[-199,290,-258,-246,291,-230]],"id":"19","properties":{"name":"Iowa"}},{"type":"MultiPolygon","arcs":[[[-261,-173,292,-257,293,294,-248]],[[295,-250]]],"id":"21","properties":{"name":"Kentucky"}},{"type":"MultiPolygon","arcs":[[[296,297]],[[298]],[[299]],[[-226,-280,300,301,302,303,-281,304,-255]]],"id":"24","properties":{"name":"Maryland"}},{"type":"MultiPolygon","arcs":[[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311]],[[312]],[[313]],[[314,315,-171]],[[316]],[[317,318,319,320,321,322]]],"id":"26","properties":{"name":"Michigan"}},{"type":"MultiPolygon","arcs":[[[323]],[[324]],[[325]],[[326]],[[-264,327,-6,328,329]]],"id":"28","properties":{"name":"Mississippi"}},{"type":"Polygon","arcs":[[330,-218,-229,-242,331]],"id":"30","properties":{"name":"Montana"}},{"type":"Polygon","arcs":[[332,-185,333,-190,334]],"id":"33","properties":{"name":"New Hampshire"}},{"type":"MultiPolygon","arcs":[[[335]],[[336]],[[337]],[[338,-207]],[[339]],[[340]],[[341,342,-196,-245,343,-205,-224]]],"id":"36","properties":{"name":"New York"}},{"type":"MultiPolygon","arcs":[[[344]],[[345]],[[-316,346,-228,-254,-293,-172]]],"id":"39","properties":{"name":"Ohio"}},{"type":"Polygon","arcs":[[347,348,349,274,-275,-274,350]],"id":"41","properties":{"name":"Oregon"}},{"type":"Polygon","arcs":[[-251,-296,-249,-295,351,-215,-166,-2,-328,-263]],"id":"47","properties":{"name":"Tennessee"}},{"type":"Polygon","arcs":[[352,-240,-154,-146,353]],"id":"49","properties":{"name":"Utah"}},{"type":"MultiPolygon","arcs":[[[354]],[[-302,355]],[[356,-297]],[[-256,-305,-282,-304,357,-212,-352,-294]]],"id":"51","properties":{"name":"Virginia"}},{"type":"MultiPolygon","arcs":[[[358]],[[359]],[[360]],[[361]],[[362]],[[363]],[[364]],[[365]],[[366]],[[367]],[[368,-348,369]]],"id":"53","properties":{"name":"Washington"}},{"type":"MultiPolygon","arcs":[[[370]],[[371]],[[372]],[[373]],[[374]],[[375]],[[376]],[[377]],[[378]],[[379]],[[380,-323,321,-321,319,-319,381,-259,-291,-198]]],"id":"55","properties":{"name":"Wisconsin"}},{"type":"MultiPolygon","arcs":[[[382]],[[383]],[[384]]],"id":"60","properties":{"name":"American Samoa"}},{"type":"MultiPolygon","arcs":[[[385]]],"id":"66","properties":{"name":"Guam"}},{"type":"MultiPolygon","arcs":[[[386]],[[387]],[[388]],[[389]],[[390]],[[391]],[[392]],[[393]]],"id":"69","properties":{"name":"Commonwealth of the Northern Mariana Islands"}},{"type":"Polygon","arcs":[[-231,-292,-253,-175,-150,-239]],"id":"31","properties":{"name":"Nebraska"}},{"type":"Polygon","arcs":[[-214,394,-168]],"id":"45","properties":{"name":"South Carolina"}},{"type":"MultiPolygon","arcs":[[[395]],[[396]],[[397]],[[398]],[[399]]],"id":"72","properties":{"name":"Puerto Rico"}},{"type":"MultiPolygon","arcs":[[[400]],[[401]],[[402]]],"id":"78","properties":{"name":"United States Virgin Islands"}},{"type":"Polygon","arcs":[[-369,403,-332,-241,-353,404,-349]],"id":"16","properties":{"name":"Idaho"}},{"type":"Polygon","arcs":[[-275,-350,-405,-354,-145,-276]],"id":"32","properties":{"name":"Nevada"}},{"type":"Polygon","arcs":[[405,-335,-189,-343]],"id":"50","properties":{"name":"Vermont"}},{"type":"MultiPolygon","arcs":[[[406]],[[407]],[[408]],[[409]],[[410]],[[411]],[[412]],[[-265,-330,413,-236]]],"id":"22","properties":{"name":"Louisiana"}},{"type":"MultiPolygon","arcs":[[[-192,414]],[[415]],[[416]],[[417]],[[-243,-194,418]]],"id":"44","properties":{"name":"Rhode Island"}}]},"nation":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[164,4,328,413,236,261,147,276,350,369,403,330,215,196,380,317,381,259,169,314,346,222,341,405,332,185,333,190,414,192,418,243,343,205,338,207,277,201,278,300,355,302,357,212,394,168]],[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]],[[62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75]],[[76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[115]],[[116]],[[117]],[[118]],[[119]],[[120]],[[121]],[[122]],[[123]],[[124]],[[125]],[[126]],[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138]],[[139]],[[140]],[[141]],[[142]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[186]],[[187]],[[209]],[[210]],[[265]],[[266]],[[267]],[[268]],[[269]],[[270]],[[271]],[[272]],[[282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]],[[297,356]],[[298]],[[299]],[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311]],[[312]],[[313]],[[316]],[[323]],[[324]],[[325]],[[326]],[[335]],[[336]],[[337]],[[339]],[[340]],[[344]],[[345]],[[354]],[[358]],[[359]],[[360]],[[361]],[[362]],[[363]],[[364]],[[365]],[[366]],[[367]],[[370]],[[371]],[[372]],[[373]],[[374]],[[375]],[[376]],[[377]],[[378]],[[379]],[[382]],[[383]],[[384]],[[385]],[[386]],[[387]],[[388]],[[389]],[[390]],[[391]],[[392]],[[393]],[[395]],[[396]],[[397]],[[398]],[[399]],[[400]],[[401]],[[402]],[[406]],[[407]],[[408]],[[409]],[[410]],[[411]],[[412]],[[415]],[[416]],[[417]]]}]}},"arcs":[[[25302,52136],[56,31],[1,25],[14,-40],[-9,-28],[-10,16],[-18,-2],[-20,-17],[-14,15]],[[25338,57677],[0,15],[150,-6],[63,0],[160,-13],[93,-2],[37,2],[159,-4],[61,-5]],[[26061,57664],[15,-321],[23,-443],[18,-379],[13,-294],[15,-311],[33,-713],[9,-32],[-4,-36],[13,-45],[5,-149],[10,-72],[17,-69],[3,-82],[9,-36],[-10,-117],[18,-28],[12,-40],[-10,-52],[-11,0],[2,-24],[-14,-21],[-13,-52],[3,-56],[-2,-86],[-7,-86],[-14,-72],[-3,-45],[6,-124],[-2,-44],[19,-87],[3,-120],[-7,-57],[2,-43],[-8,-80],[1,-79],[-7,-21],[5,-51],[-3,-54],[20,-91],[7,-64],[2,-61]],[[26229,53027],[-67,0],[-71,-5],[-110,-4],[-174,0],[-135,7],[-166,-2],[3,-38],[-13,-115],[2,-23],[23,-79],[3,-41],[36,-80],[3,-69],[-15,-102],[3,-55],[20,-51],[-18,-35],[-8,-82],[-9,-15],[7,-24],[-15,-26]],[[25528,52188],[-38,-35],[-40,-24],[-56,-4],[18,41],[12,-26],[35,27],[3,34],[-15,48],[-7,43],[-20,47],[-7,90],[9,74],[-3,76],[-7,48],[-20,32],[-15,-46],[2,-38],[-9,-57],[1,-41],[-6,-32],[-1,-144],[-8,-66],[-15,-4],[1,36],[-20,40],[-15,-16],[-5,23],[-18,-22]],[[25284,52292],[-3,222],[-3,357],[-6,423],[-10,773],[9,283],[21,710],[5,212],[33,1120],[6,160],[19,643],[12,362],[-16,35],[-13,85]],[[8053,88108],[6,38],[18,-11],[-20,-43],[-4,16]],[[7905,86007],[29,90],[15,-17],[-1,-46],[-28,-74],[-15,19],[0,28]],[[7695,85792],[26,-14],[-3,-36],[-23,50]],[[7642,85774],[22,-17],[-7,-33],[-14,14],[-1,36]],[[7602,85813],[20,-2],[-5,-34],[-15,36]],[[7594,84711],[8,45],[20,-13],[-8,-73],[-15,-17],[-5,58]],[[7543,85532],[12,28],[21,-40],[-33,-2],[0,14]],[[7540,87187],[29,79],[8,112],[31,-29],[-28,-64],[-9,-49],[5,-24],[-36,-25]],[[7464,85521],[14,55],[18,-28],[23,-4],[-33,-33],[-22,10]],[[7385,86976],[17,6],[5,-88],[-22,82]],[[7168,84530],[29,89],[15,6],[26,-66],[5,20],[-21,65],[6,54],[9,10],[27,-25],[21,19],[-29,54],[16,56],[29,-31],[15,4],[-14,56],[12,17],[20,-20],[14,45],[-18,6],[-13,33],[20,3],[22,67],[34,18],[-12,35],[-3,68],[27,66],[7,-31],[53,51],[7,-7],[-12,-118],[-13,-18],[-26,-103],[5,-84],[36,11],[2,69],[22,-9],[21,-71],[20,48],[12,-33],[-17,-117],[9,-22],[9,72],[27,47],[7,-25],[-3,-115],[-30,-89],[-32,23],[-11,81],[-21,-26],[13,-99],[-22,-20],[-39,13],[-16,-54],[-8,36],[2,74],[-10,2],[-9,-114],[-8,-24],[-31,-17],[2,-37],[-16,-22],[-45,-13],[-86,76],[-21,-13],[-15,29]],[[7129,86075],[41,28],[18,-43],[-5,-48],[-13,-16],[-29,-3],[-16,59],[4,23]],[[6962,82933],[31,45],[8,-48],[-37,-9],[-2,12]],[[6905,82759],[20,62],[19,20],[11,-11],[25,17],[5,-40],[19,-37],[36,16],[-2,-37],[-19,-31],[-46,-6],[-32,-13],[-32,25],[-4,35]],[[6789,83718],[20,17],[4,76],[18,75],[25,34],[5,44],[15,-8],[34,70],[33,36],[39,-15],[29,1],[0,-112],[26,-57],[4,45],[17,53],[-18,48],[6,25],[53,-14],[-3,35],[-52,44],[-19,-4],[-1,127],[31,61],[29,29],[20,-12],[22,-56],[6,-133],[15,13],[9,77],[-5,55],[35,-38],[7,47],[-37,36],[-21,58],[7,44],[17,-6],[51,-87],[9,4],[30,-41],[11,10],[-31,75],[-20,34],[-7,44],[17,0],[30,-58],[29,12],[41,-29],[7,49],[36,15],[-8,-63],[-39,-106],[-7,-83],[19,-36],[0,95],[16,43],[16,-49],[5,46],[17,32],[5,41],[14,10],[10,-31],[22,72],[17,8],[-4,-45],[28,-16],[-11,-38],[-11,20],[-18,-15],[19,-36],[-5,-49],[19,22],[11,-51],[27,1],[-24,-53],[-16,33],[-24,2],[-15,-48],[16,-9],[-8,-53],[26,-8],[-26,-89],[23,17],[13,47],[5,-35],[47,-4],[-3,-41],[-36,-78],[-13,-110],[-38,13],[-2,39],[-10,-41],[-23,42],[-17,-6],[-23,49],[-15,-13],[-24,19],[-8,-46],[27,1],[15,-17],[45,-87],[-8,-70],[-23,-52],[-11,36],[-19,-50],[-19,30],[-6,38],[-21,18],[-20,-12],[-17,-37],[29,2],[20,-49],[-38,-53],[-34,12],[-4,-20],[25,-34],[14,13],[35,1],[22,-43],[-11,-28],[-24,-8],[-34,-33],[-8,11],[-19,-29],[3,-49],[-27,-50],[-13,20],[7,34],[-23,50],[7,47],[27,62],[-8,24],[-15,-21],[-34,-105],[-3,-24],[-22,32],[-22,-10],[-5,-35],[26,-6],[10,-63],[-16,-61],[-25,-20],[1,-70],[-25,-41],[-12,13],[-23,-82],[-19,-30],[-18,21],[-31,-20],[22,116],[11,11],[26,71],[24,31],[-2,37],[-33,-23],[3,52],[22,102],[29,52],[-7,30],[-15,-45],[-34,-61],[-26,-112],[-24,-59],[-14,-11],[-5,-44],[-19,-30],[-4,84],[-26,58],[-33,27],[3,100],[-4,106],[-13,83],[-11,32],[-23,20],[-27,5],[14,30],[-15,37],[5,23]],[[6782,82633],[27,101],[51,97],[21,-4],[16,-54],[-12,-23],[-55,-73],[-29,-79],[-19,35]],[[6519,81925],[26,41],[5,38],[13,22],[8,-32],[-6,-43],[5,-68],[-7,-33],[-36,13],[-8,62]],[[6240,82171],[5,47],[14,25],[13,-59],[-13,-63],[-19,50]],[[6225,82357],[9,35],[3,-82],[-10,-1],[-2,48]],[[6080,82757],[21,48],[48,-3],[25,-54],[-35,23],[-16,-26],[-43,-6],[0,18]],[[5919,82533],[19,25],[11,-57],[-9,-11],[-21,43]],[[5642,81925],[8,64],[19,12],[27,-58],[-8,-18],[-21,37],[-25,-37]],[[5573,81984],[16,-49],[-27,12],[11,37]],[[5524,80844],[-1,36],[13,24],[20,-25],[-9,-59],[-19,-15],[-4,39]],[[5506,81836],[8,67],[10,10],[11,-62],[-29,-15]],[[5485,80904],[12,85],[-11,46],[31,-2],[4,-99],[-27,-38],[-9,8]],[[5445,80747],[10,13],[16,-42],[-1,-34],[-23,-4],[-2,67]],[[5429,81185],[17,-21],[5,49],[17,46],[5,-22],[-8,-58],[9,-13],[1,-44],[-10,-61],[13,-30],[-7,-19],[-17,22],[-2,-21],[-20,8],[-3,164]],[[5385,80755],[21,25],[11,-30],[-20,-26],[-12,31]],[[5377,81028],[9,39],[23,41],[5,-36],[-23,-38],[-9,-58],[-5,52]],[[5303,81352],[14,11],[5,-42],[-19,31]],[[5265,80882],[33,98],[15,27],[-5,18],[-22,0],[-4,76],[22,50],[27,-44],[-1,38],[-13,52],[30,-13],[18,114],[12,-23],[-2,-43],[-9,-2],[-5,-75],[12,-18],[0,33],[13,1],[-4,-60],[-11,-37],[-22,12],[-1,-45],[-28,-71],[-18,-24],[-31,-141],[-6,77]],[[5246,85264],[5,41],[14,-83],[-7,-25],[-12,67]],[[5238,81460],[22,42],[36,-14],[-1,-78],[-50,12],[-7,38]],[[5213,85252],[8,77],[5,-57],[-13,-20]],[[5096,81334],[16,74],[25,25],[18,-23],[-2,-46],[10,5],[12,47],[15,-32],[26,-26],[26,25],[7,-66],[-9,-60],[-14,40],[-22,3],[-14,23],[-3,40],[-10,-12],[0,-69],[11,-20],[11,-87],[-11,-60],[-36,35],[-10,59],[-18,-18],[-18,-90],[4,58],[-10,43],[0,104],[-4,28]],[[5033,85142],[7,131],[39,52],[21,6],[39,76],[5,-2],[-55,-273],[-22,-32],[-32,-4],[-2,46]],[[4937,81216],[27,3],[-4,-71],[-26,47],[3,21]],[[4863,81217],[10,31],[36,8],[-9,-51],[-37,-10],[0,22]],[[4804,81100],[4,51],[17,20],[25,-19],[12,-29],[35,-42],[6,-41],[-30,44],[-23,-57],[-28,74],[-11,-38],[-7,37]],[[4656,80881],[30,66],[26,-27],[0,-83],[-11,-53],[-13,-21],[-27,58],[-5,60]],[[4587,90956],[19,44],[21,16],[24,-17],[22,6],[9,-37],[-1,-50],[-75,-13],[-18,19],[-1,32]],[[4545,80324],[1,51],[68,-54],[19,-39],[26,0],[18,-28],[-20,-23],[-10,-33],[-22,40],[-17,-9],[-31,37],[-18,-29],[-22,57],[8,30]],[[4451,81463],[14,-1],[-5,-38],[-9,39]],[[3979,80040],[12,22],[16,-18],[-21,-37],[-7,33]],[[3880,79918],[22,34],[33,-11],[24,18],[5,-24],[-9,-45],[-26,-13],[-47,27],[-2,14]],[[3807,79887],[60,24],[9,-35],[-15,-32],[-13,37],[-34,-4],[-7,10]],[[3781,79848],[17,29],[7,-36],[-18,-14],[-6,21]],[[3751,80090],[13,56],[14,-15],[18,18],[12,-21],[-22,-33],[13,-48],[30,0],[1,-41],[-23,3],[-18,-79],[-23,24],[-2,78],[16,35],[-9,20],[-16,-21],[-4,24]],[[3635,79967],[5,36],[28,54],[30,-6],[3,-58],[20,6],[14,-15],[8,-44],[13,13],[-2,-41],[-26,-36],[-12,11],[-18,-45],[-6,28],[-25,1],[-17,-20],[-18,91],[3,25]],[[3608,79782],[7,15],[27,-33],[-32,-11],[-2,29]],[[3261,87028],[35,25],[57,0],[22,-20],[23,10],[9,-24],[21,10],[10,30],[-8,38],[34,68],[37,-11],[0,37],[25,46],[33,-40],[24,32],[23,9],[15,54],[19,-132],[27,-10],[29,34],[29,-20],[27,-40],[-12,-65],[11,-44],[-11,-40],[13,-11],[4,-65],[-13,-38],[21,-54],[2,-58],[21,10],[-11,-34],[2,-48],[-71,-21],[-6,-34],[-20,19],[-26,-18],[-28,-58],[8,-64],[-26,-8],[-23,71],[-38,47],[-57,-4],[-14,35],[-28,18],[-27,58],[-35,42],[-40,19],[-32,72],[-25,10],[-2,70],[-28,97]],[[3147,79003],[17,23],[22,53],[25,5],[37,40],[9,27],[28,-21],[14,19],[8,44],[22,-19],[3,72],[24,-11],[-17,106],[20,32],[8,-16],[15,18],[-18,35],[4,39],[17,23],[29,-1],[9,-68],[15,7],[-7,50],[13,31],[-53,47],[-14,-21],[-32,81],[0,46],[31,92],[42,50],[36,32],[6,-15],[23,13],[16,-63],[-16,-42],[7,-35],[17,-18],[14,53],[6,-33],[15,29],[-1,41],[18,63],[15,-58],[11,26],[20,-62],[-8,-56],[-23,-13],[-24,-70],[-40,-70],[2,-39],[34,54],[58,64],[4,22],[22,22],[7,-19],[-5,-72],[-16,-51],[-26,-34],[-6,-23],[-45,-51],[-30,-20],[12,-46],[-16,-1],[-4,-61],[-16,17],[-7,-70],[-20,25],[-4,-76],[-36,-13],[-22,30],[-10,-31],[-12,23],[-21,-37],[-6,11],[-44,-73],[-3,-31],[-23,4],[-16,-23],[-13,-60],[-28,23],[-9,-45],[-49,40],[-15,36]],[[3070,93368],[7,34],[34,50],[123,108],[63,74],[48,74],[45,56],[42,64],[84,105],[55,56],[146,167],[172,154],[133,90],[87,45],[135,15],[52,-11],[34,-31],[-41,-11],[7,-38],[-10,-71],[-31,-77],[1,-70],[12,-56],[-21,-59],[-49,-33],[-4,-20],[49,7],[42,-151],[40,-3],[36,32],[42,-1],[49,-30],[47,21],[69,15],[32,-58],[50,21],[18,-34],[52,32],[18,26],[84,-65],[18,59],[26,44],[37,150],[18,26],[40,-9],[8,-39],[32,-12],[31,27],[26,0],[-32,110],[-71,55],[-45,24],[-48,-1],[-60,-60],[13,112],[-3,83],[-62,114],[-22,91],[-26,35],[-59,14],[-8,56],[-32,90],[7,50],[27,18],[10,43],[16,-37],[24,28],[27,-89],[36,-91],[24,-10],[-19,-101],[3,-55],[28,-50],[57,-123],[53,-68],[39,18],[30,28],[9,49],[-45,2],[-10,45],[-56,70],[-53,112],[10,52],[0,60],[14,23],[1,57],[33,93],[30,-32],[22,3],[1,28],[-38,55],[-25,-8],[-28,57],[-87,-29],[-32,-37],[-34,0],[-39,-19],[-34,17],[-20,43],[-17,-16],[-21,23],[-4,-51],[-36,39],[-91,42],[-54,31],[-48,15],[-22,30],[1,98],[-22,163],[-52,216],[-20,58],[-36,62],[-91,101],[-145,228],[-21,24],[-51,87],[-50,49],[-54,37],[-51,23],[-29,35],[-19,70],[-54,84],[-45,40],[-81,41],[-42,-6],[37,40],[92,59],[20,46],[3,57],[19,76],[11,236],[-8,117],[179,-31],[68,6],[144,42],[79,28],[77,15],[77,63],[41,65],[29,30],[53,87],[81,192],[21,92],[7,79],[-2,186],[39,233],[84,183],[65,179],[37,77],[129,162],[96,-35],[69,-3],[68,40],[64,53],[93,104],[74,108],[44,86],[114,188],[33,31],[99,63],[7,-47],[55,-44],[82,-12],[68,15],[13,24],[32,-3],[61,17],[73,51],[74,85],[71,121],[36,88],[86,185],[68,76],[12,-68],[47,-38],[39,-2],[39,-20],[16,-82],[27,41],[99,-49],[15,-98],[-54,-71],[-35,-63],[-41,-4],[12,-146],[81,-15],[44,59],[-7,76],[16,8],[31,67],[23,12],[19,-48],[4,63],[-27,43],[35,55],[21,-47],[-3,65],[15,22],[71,-74],[45,-66],[13,-42],[-11,-33],[1,-109],[9,-49],[61,10],[35,-37],[16,-40],[48,62],[30,75],[112,0],[69,42],[53,-11],[40,-34],[84,-2],[61,-32],[45,-35],[9,-34],[-26,-11],[-26,-83],[-26,-30],[14,-93],[25,5],[19,-24],[45,-6],[10,-28],[69,-20],[33,9],[-17,-43],[9,-25],[-53,-26],[-8,-24],[20,-25],[89,6],[72,-41],[14,-33],[28,5],[44,86],[57,15],[24,-18],[10,34],[40,7],[29,-27],[15,-59],[42,27],[38,8],[58,83],[13,-22],[45,20],[21,-15],[34,26],[12,-30],[66,-8],[62,-72],[28,-1],[19,-24],[26,31],[24,-8],[37,-73],[0,-45],[35,-19],[41,51],[1,-63],[26,57],[81,-77],[14,-67],[24,-23],[49,1],[43,-15],[29,36],[23,-73],[48,-10],[29,45],[43,-12],[62,12],[66,-10],[49,-38],[50,-3],[17,28],[65,-95],[28,-8],[32,-54],[45,-16],[20,-30],[45,-12],[17,-26],[27,32],[66,-20],[45,77],[48,6],[9,20],[84,49],[18,24],[86,30],[42,-25],[48,32],[9,-18],[79,-73],[53,-37],[70,-80],[26,-67],[37,-11],[87,-97],[68,-40],[52,-62],[27,-47],[61,-13],[58,-45],[0,-9012],[2,-971],[-1,-889],[130,-95],[17,100],[135,-145],[81,180],[170,20],[1,-39],[-33,-272],[47,-112],[66,-76],[26,-22],[11,-116],[29,-80],[266,-580],[30,-299],[-8,-93],[22,4],[51,108],[111,158],[11,23],[68,8],[32,139],[-2,209],[30,-19],[18,19],[19,71],[-1,39],[-32,47],[45,48],[68,28],[131,158],[62,-115],[28,-88],[11,-2],[24,-70],[0,-104],[-12,-24],[1,-37],[16,-47],[-5,-42],[18,-76],[73,-38],[5,-66],[32,-73],[24,0],[29,-108],[-6,-69],[26,-20],[-6,-46],[22,-71],[114,-152],[32,-119],[46,-120],[50,-110],[-23,-49],[33,-134],[47,-140],[28,-176],[57,-182],[32,-161],[30,-111],[25,-123],[53,-180],[32,-155],[-33,-140],[89,-52],[-21,-205],[71,-81],[-8,-61],[11,-57],[7,-119],[71,14],[33,-77],[82,-115],[23,-48],[85,-47],[44,-115],[44,-33],[11,-116],[23,-15],[27,-36],[40,23],[28,-143],[-3,-90],[-20,-107],[-18,-67],[1,-60],[10,-38],[-5,-118],[12,-104],[11,-46],[6,-133],[12,-63],[-32,-100],[-24,-122],[-1,-33],[-20,-90],[-23,-77],[-37,-97],[-27,-55],[-19,-14],[3,-46],[-19,-23],[-12,40],[-1,56],[-13,24],[-1,-44],[-12,-22],[-18,18],[-13,52],[-4,108],[3,57],[-17,33],[8,103],[-9,6],[-16,56],[-6,64],[30,63],[17,63],[15,-8],[-3,75],[-11,82],[14,122],[-9,190],[-10,67],[-43,164],[-22,55],[-12,48],[-7,-34],[23,-62],[25,-85],[7,-72],[22,-90],[10,-131],[-16,-43],[-2,-79],[7,-92],[11,-62],[-9,-28],[-11,96],[-8,12],[3,-70],[-4,-74],[-36,-102],[-14,-5],[-24,49],[19,73],[11,73],[-3,38],[-25,-10],[10,-72],[-8,-42],[-33,-56],[-7,1],[-23,108],[-11,-45],[-25,54],[-17,18],[-12,50],[-28,68],[0,76],[31,31],[22,51],[-20,47],[7,75],[-9,39],[23,44],[3,24],[-18,1],[-3,74],[7,43],[-41,-17],[6,-45],[11,-16],[-1,-37],[-13,-85],[-1,-60],[-19,-73],[-18,13],[7,-93],[-10,-43],[-24,52],[-25,22],[-9,30],[-12,132],[-16,70],[21,-29],[7,75],[27,37],[12,147],[-8,102],[10,57],[6,-21],[12,42],[7,92],[-21,-11],[-4,-58],[-19,-30],[-21,-61],[13,-113],[-8,-42],[-33,3],[-12,-43],[3,-30],[-17,-14],[-7,34],[4,67],[-19,23],[-12,128],[-32,-17],[0,-48],[-28,118],[-3,123],[8,25],[25,1],[7,66],[13,49],[30,12],[16,-72],[7,63],[-15,168],[9,3],[30,-45],[4,-59],[11,-32],[6,23],[-9,77],[-22,35],[-19,48],[-3,53],[-11,13],[-12,-25],[-10,49],[-23,32],[-5,57],[12,23],[-4,64],[-22,28],[-37,66],[-13,69],[-15,33],[-13,79],[29,43],[-11,58],[-18,-47],[-19,18],[-2,-27],[-23,58],[-31,8],[-11,56],[-27,-28],[-54,76],[-8,75],[15,73],[18,-22],[33,4],[9,48],[-22,3],[-32,36],[2,35],[-18,125],[13,81],[-24,-10],[-15,19],[-16,53],[7,103],[20,2],[16,-36],[33,-24],[63,-89],[5,15],[-25,58],[-20,19],[-66,130],[-3,95],[-17,-15],[-2,-65],[-20,3],[-39,166],[-55,147],[-11,140],[9,65],[-2,52],[27,41],[-13,100],[-8,-2],[-9,-85],[-20,-30],[0,-42],[12,-22],[-13,-57],[-10,10],[-22,-20],[-25,11],[-36,34],[-7,-15],[-35,36],[-40,174],[-4,110],[-42,140],[-13,79],[19,1],[-11,174],[-19,-56],[1,-58],[-35,132],[-8,177],[-8,92],[-21,135],[-32,116],[-36,37],[-5,-16],[28,-38],[4,-41],[17,-39],[20,-131],[-15,11],[-34,140],[-22,36],[-22,10],[41,-92],[13,-85],[17,-29],[-7,-97],[9,-88],[13,-23],[-5,-24],[27,-124],[3,-55],[25,-139],[2,-32],[-14,11],[27,-204],[9,-85],[1,-69],[-12,8],[-1,-61],[12,-64],[-29,23],[-19,32],[-14,-4],[-18,43],[-15,66],[-10,84],[-22,-16],[-33,50],[-27,-37],[-50,-19],[3,81],[-25,16],[-4,19],[30,39],[-10,69],[5,53],[-28,109],[0,36],[-22,84],[13,24],[-2,90],[-19,64],[-12,10],[15,-131],[-12,-125],[-27,-5],[-42,70],[-26,30],[-15,150],[-11,-68],[-13,-22],[-44,54],[-14,-20],[-10,50],[-12,-18],[-3,-54],[45,-35],[7,7],[45,-44],[33,-66],[30,-104],[-11,-44],[-24,-44],[6,-11],[33,44],[7,30],[27,1],[7,-105],[26,-78],[16,-157],[-19,-44],[-43,-32],[-11,10],[9,47],[-18,16],[-12,-17],[7,-39],[-10,-37],[-43,22],[-11,-23],[5,-60],[-8,-35],[-29,5],[-8,78],[-36,35],[3,15],[-28,74],[-17,19],[-29,-19],[-35,70],[-16,15],[-56,107],[-51,75],[-2,50],[-30,70],[-37,64],[-5,28],[4,75],[-15,48],[-55,121],[-30,47],[-96,89],[-36,71],[-43,66],[-98,104],[-42,49],[-91,144],[-30,39],[5,29],[31,89],[24,-14],[-9,-27],[24,3],[0,43],[21,70],[-22,7],[2,77],[-14,116],[7,35],[22,41],[-5,34],[16,30],[-13,56],[-19,-51],[-2,-59],[-25,-21],[-21,-72],[-1,-49],[-107,-100],[-12,-28],[-28,-28],[-95,22],[-67,36],[-26,32],[-123,125],[-17,56],[18,-10],[34,24],[11,71],[-33,131],[3,42],[-20,-17],[-31,44],[6,-50],[45,-120],[-10,-21],[-54,-51],[-39,0],[-49,55],[-61,24],[-32,23],[-81,40],[-45,11],[-59,-4],[-63,-33],[-77,-12],[-80,-28],[-54,-48],[-39,39],[-45,-26],[-64,-120],[-46,-115],[6,65],[36,103],[62,117],[46,2],[-16,66],[-49,48],[-8,25],[-10,-82],[-26,84],[-26,30],[-17,-9],[-16,27],[-71,19],[9,28],[38,23],[-42,33],[-19,-6],[-2,25],[37,156],[-15,15],[-13,-36],[-29,-22],[-1,-57],[-20,-66],[-39,12],[-70,97],[1,31],[-26,36],[-39,26],[-41,-35],[-22,27],[13,29],[31,32],[25,74],[-14,10],[-18,-49],[-79,-93],[-29,-23],[-38,5],[1,-54],[60,27],[11,-24],[2,-53],[-17,2],[-28,-37],[-18,6],[-41,-38],[-41,-77],[-12,2],[-12,48],[47,77],[-37,-12],[-17,11],[-1,54],[23,83],[13,27],[18,2],[20,-31],[24,17],[22,41],[38,13],[57,58],[42,20],[-9,25],[-19,-2],[1,71],[-11,-49],[-19,-20],[1,30],[25,65],[1,21],[-33,-58],[-45,-47],[-19,-3],[-4,30],[63,112],[-6,38],[-29,-60],[-38,-14],[-12,26],[-15,-49],[-20,-14],[-54,13],[-10,58],[27,19],[11,-9],[18,25],[40,16],[29,28],[23,65],[-25,2],[-14,-46],[-23,-19],[-45,-2],[-18,68],[-12,3],[-17,-69],[-21,-8],[-4,59],[16,26],[17,-6],[-11,44],[-3,55],[13,34],[26,114],[96,6],[-7,38],[-91,-5],[-21,-63],[-27,-26],[-21,-77],[-31,-48],[-23,12],[20,36],[-10,113],[-12,53],[18,30],[-22,10],[-14,-23],[-1,-51],[12,-63],[-14,-63],[1,-41],[-13,-15],[-26,48],[-2,-67],[-27,-45],[-21,22],[0,52],[-11,19],[-7,-73],[-9,15],[4,129],[9,62],[-15,11],[-17,-130],[9,-111],[-4,-29],[-19,-9],[1,49],[-27,34],[-7,-46],[16,-65],[-13,-8],[-38,16],[-34,-48],[-28,9],[-5,31],[14,95],[42,151],[1,53],[49,123],[16,81],[-6,18],[-73,-211],[-1,-35],[-18,-58],[-8,8],[-8,69],[-12,-1],[-3,-81],[-11,-54],[-18,-42],[-3,-64],[-16,-68],[-21,27],[-7,-44],[24,-28],[-5,-91],[10,-8],[19,85],[37,6],[11,-22],[4,-91],[-14,-45],[-31,-32],[-22,-76],[1,-63],[21,20],[17,75],[30,44],[30,-89],[0,-44],[10,-43],[-23,-192],[-26,0],[-9,52],[-19,9],[1,-36],[-27,-44],[0,-17],[28,14],[23,-27],[61,-124],[26,-85],[-15,-77],[-13,-26],[-34,-35],[-17,16],[-14,-18],[-29,-6],[9,51],[-26,67],[9,60],[-17,63],[-16,-126],[0,-62],[-12,-41],[-19,69],[-9,-8],[-7,-59],[-18,-33],[-34,50],[-29,-40],[-15,52],[-27,-21],[-22,5],[-9,28],[24,74],[-9,14],[-27,-38],[-29,-175],[-30,-42],[-9,18],[14,55],[13,84],[-15,172],[-16,5],[-5,-28],[1,-81],[13,-53],[-10,-4],[-10,-72],[-17,11],[-8,-20],[-5,-68],[-11,-17],[4,-47],[25,-31],[-6,-74],[-27,32],[-12,127],[8,37],[-11,78],[-17,6],[6,-52],[-8,-49],[5,-196],[-5,-64],[-27,74],[-1,43],[-16,28],[-34,31],[3,-40],[24,-36],[-1,-63],[-69,-158],[-32,-91],[0,-36],[-16,-10],[-9,-86],[-12,2],[-3,70],[34,211],[0,29],[-26,-65],[-19,-111],[-12,11],[-9,142],[-13,-52],[-11,2],[16,-62],[-5,-80],[-39,0],[-8,-61],[-18,-24],[-22,-55],[7,-43],[-15,-41],[-16,-10],[0,54],[-16,36],[-13,-45],[-1,-53],[-22,-17],[-24,31],[-9,-23],[-21,38],[-7,43],[-12,-36],[-21,-27],[6,-35],[-20,0],[-5,-39],[-41,-7],[-6,76],[-22,-14],[-21,22],[3,22],[-21,8],[-3,70],[8,36],[16,18],[5,71],[32,31],[9,-11],[29,51],[33,3],[0,45],[33,21],[34,62],[31,-9],[-11,69],[22,26],[3,32],[37,102],[-13,15],[-24,-22],[-60,-109],[-30,-20],[-18,-39],[-39,16],[-43,67],[-15,40],[-5,46],[18,117],[13,45],[15,133],[27,79],[17,33],[35,99],[11,98],[0,71],[23,32],[5,156],[4,27],[-18,44],[-22,163],[39,35],[5,27],[63,27],[89,164],[92,118],[51,-161],[41,-16],[13,-27],[34,112],[30,8],[36,-45],[19,10],[63,-48],[65,-20],[30,-55],[-1,27],[-22,63],[-29,36],[-38,-14],[-51,63],[-24,-1],[-40,42],[-25,68],[-39,66],[-29,28],[18,55],[24,9],[31,124],[23,18],[8,60],[46,27],[30,45],[-32,50],[-20,4],[-43,-64],[-11,-49],[-19,-14],[-12,-70],[0,-70],[-18,-31],[-25,19],[-36,7],[-74,-17],[-26,43],[-28,16],[-14,-52],[-87,-84],[-39,-154],[-36,-12],[-19,-31],[-33,2],[-39,-63],[-48,-109],[-1,-29],[26,-124],[-2,-23],[-38,25],[-19,-18],[-30,-52],[-21,-92],[-27,-29],[-32,-74],[-6,-73],[8,-34],[19,-24],[-40,-56],[-9,-67],[-13,-4],[-28,-70],[-19,-7],[-9,28],[-25,-11],[4,-68],[16,-13],[-3,-30],[25,-42],[8,-35],[-12,-73],[-19,-47],[-7,-62],[-25,-21],[-4,-22],[-39,-2],[-15,12],[-40,-31],[-18,3],[-19,-60],[23,16],[15,-20],[15,30],[19,1],[7,-50],[-16,-116],[-19,-16],[-26,-51],[-28,37],[5,-34],[-13,-18],[-18,18],[7,35],[2,75],[-22,71],[3,-119],[-9,-55],[-18,-15],[-13,25],[-6,-35],[16,-28],[-9,-53],[-49,-10],[17,-93],[-8,-32],[-27,-21],[-10,8],[-24,-45],[-12,13],[-36,-37],[5,-26],[20,-18],[-23,-32],[-7,-43],[2,-61],[-12,-44],[-24,-35],[24,-26],[-6,-59],[10,-60],[27,63],[59,-23],[16,22],[12,-22],[15,25],[22,-78],[19,-27],[19,13],[23,-34],[18,-53],[8,-53],[15,-22],[-28,-14],[-14,-118],[-12,-39],[-30,-25],[-11,-55],[-24,-33],[-48,0],[-15,-17],[-4,-94],[-12,-33],[-27,1],[-5,-20],[10,-79],[11,-32],[-27,-36],[-20,15],[-2,-45],[20,-46],[-11,-81],[-21,-30],[-6,-33],[9,-24],[-23,0],[-14,-52],[-26,66],[-9,-7],[5,-57],[-4,-40],[-21,-3],[-12,-43],[-17,16],[0,27],[-20,-1],[-4,-39],[-22,-24],[-23,31],[-28,-17],[-35,-69],[15,-52],[-9,-51],[-40,-44],[-28,-2],[1,-53],[14,-25],[-6,-40],[-20,-16],[-36,59],[-10,30],[-20,-20],[-5,-63],[1,-69],[-26,-27],[-3,-97],[-65,-7],[-21,24],[-2,-74],[8,-71],[-20,0],[-12,37],[-21,3],[-4,-39],[-32,-27],[-39,-92],[-15,-12],[-5,-44],[13,-11],[47,64],[4,-50],[-6,-53],[-15,-7],[0,-31],[18,-38],[-10,-38],[-18,-26],[-2,-49],[-26,-44],[-8,-32],[2,-42],[-32,14],[-31,-28],[-4,-70],[-12,-12],[-19,75],[-8,-53],[-27,-42],[-11,-53],[-24,-6],[5,-50],[-17,-27],[-25,43],[-24,67],[-22,-16],[0,-51],[11,-5],[1,-36],[-29,-10],[-13,-67],[6,-32],[18,-6],[5,-52],[-36,-4],[-24,-15],[-17,77],[-51,-38],[-18,-51],[-16,-3],[-9,-49],[19,-1],[27,25],[20,-17],[6,-54],[-16,-47],[-43,44],[-23,11],[-5,-70],[-33,6],[-23,21],[-20,-33],[-27,-88],[2,-44],[47,-20],[32,-36],[-3,-29],[-32,-42],[1,-23],[18,-4],[25,31],[16,-7],[-55,-78],[-23,-63],[1,-52],[-13,50],[-10,-17],[16,-66],[-6,-50],[-7,39],[-10,-2],[-2,-53],[-25,80],[0,95],[-19,-60],[8,-73],[-4,-67],[-24,-6],[3,58],[-35,1],[-16,-80],[-25,-9],[-75,-43],[-29,-22],[-7,-22],[-3,-74],[-17,46],[5,80],[-23,-19],[10,-30],[1,-104],[-16,-71],[6,-46],[-24,-81],[-32,-30],[2,52],[24,4],[-1,40],[-10,4],[2,111],[18,72],[-29,39],[-28,12],[-13,-18],[3,-45],[-12,-21],[-13,22],[-25,-13],[-9,-82],[-35,-74],[-26,-20],[-37,28],[-6,-29],[11,-44],[-20,-81],[1,-31],[-21,-37],[-12,105],[-10,13],[-14,-37],[-11,14],[-18,-31],[31,-13],[-2,-68],[-32,-10],[-16,25],[5,39],[-13,24],[-22,-22],[-19,-90],[-61,-85],[-26,2],[-11,29],[-26,-29],[-13,4],[10,156],[29,96],[1,46],[-15,16],[-31,-2],[-24,-29],[-24,-101],[4,-129],[-40,-140],[-7,-12],[-14,-85],[-21,36],[-19,-12],[13,-65],[10,-17],[1,-56],[-25,-38],[-19,33],[0,45],[-16,15],[-13,-60],[10,-49],[-17,-47],[-14,27],[-32,-8],[-16,18],[-14,74],[32,6],[-21,47],[-8,104],[-21,56],[-11,7],[-16,-33],[-10,-65],[7,-27],[14,0],[18,-70],[-11,-46],[14,-95],[0,-52],[-22,30],[-20,-19],[3,-26],[-17,-30],[-18,-7],[-22,28],[-16,59],[4,36],[-13,56],[-21,37],[-31,-25],[-10,-56],[49,-85],[4,-31],[-50,-111],[-24,-21],[-20,-33],[16,-56],[27,2],[9,24],[22,-50],[13,-83],[-26,6],[8,34],[-17,6],[-10,-28],[-16,22],[-17,62],[-25,-39],[2,-69],[-18,-1],[-28,-50],[-23,18],[-37,10],[-45,-5],[-34,-14],[-41,-40],[-29,-71],[-4,-69],[-29,-53],[-51,-33],[-29,3],[-28,28],[-9,30],[-9,74],[-10,30],[-1,55],[8,29],[44,41],[14,25],[23,110],[19,110],[-1,29],[22,54],[14,13],[25,-46],[38,39],[25,49],[25,0],[37,81],[34,20],[36,-14],[31,5],[1,-37],[28,-72],[9,-61],[-5,-50],[27,24],[-8,52],[2,37],[30,-30],[-15,42],[2,77],[-10,109],[32,46],[26,21],[42,-15],[21,14],[10,69],[-16,4],[4,28],[18,10],[7,38],[18,-4],[26,99],[3,-32],[15,-20],[21,48],[-5,83],[-20,-9],[27,68],[64,206],[33,52],[23,62],[19,13],[27,42],[25,68],[27,14],[35,39],[37,20],[89,70],[30,-9],[10,18],[45,5],[10,-10],[-20,-27],[-1,-47],[14,-2],[-3,-49],[-29,-18],[-3,-85],[38,-98],[11,22],[27,-39],[4,19],[-29,53],[-3,85],[-6,32],[26,-28],[57,3],[7,-86],[23,7],[26,-36],[7,22],[-14,40],[27,15],[-56,89],[-32,36],[1,58],[-16,-7],[39,166],[15,123],[11,56],[23,44],[36,96],[18,13],[40,74],[30,81],[82,96],[41,74],[35,39],[68,106],[17,42],[29,-68],[19,-14],[31,19],[8,59],[-13,47],[-2,46],[15,122],[29,108],[41,130],[24,62],[22,37],[40,41],[21,52],[22,87],[14,15],[26,62],[30,25],[8,-74],[18,-15],[4,41],[-10,105],[-23,-2],[-6,34],[2,95],[9,59],[25,409],[14,42],[38,16],[12,53],[-20,-9],[-34,77],[-3,62],[9,97],[20,106],[27,33],[29,101],[49,102],[4,57],[19,93],[-5,45],[13,33],[-3,43],[13,38],[-20,0],[-11,-32],[0,-38],[-21,-53],[-28,-31],[-38,-27],[-21,-31],[-29,-22],[-5,-21],[-41,-28],[-44,-61],[-79,-73],[-26,5],[-28,53],[-5,73],[-20,49],[-40,38],[2,46],[11,17],[9,167],[-12,-3],[-25,-101],[-41,-54],[-6,-58],[5,-58],[-8,-37],[-14,-12],[-3,-32],[9,-80],[16,-91],[19,-76],[-26,-87],[-28,-21],[-42,32],[-39,161],[-47,208],[-26,73],[-23,42],[-31,13],[16,65],[-16,44],[-25,-9],[-6,-87],[-15,7],[1,-65],[-29,-30],[-24,79],[3,26],[-19,19],[-11,-30],[-16,6],[-1,59],[-22,-18],[-25,61],[18,47],[-17,89],[-44,-52],[-46,-72],[-31,-62],[-20,-95],[-13,57],[-36,-33],[-94,-124],[-10,-41],[0,-49],[-41,-38],[-8,-26],[-22,-10],[-15,-44],[-20,-15],[-4,55],[-29,45],[-54,-20],[-29,33],[49,47],[15,-39],[18,12],[5,50],[25,77],[3,60],[-8,85],[1,81],[-16,74],[5,21],[-16,20],[-29,97],[-20,139],[29,128],[21,23],[24,79],[24,26],[-15,77],[-18,44],[-15,64],[-10,107],[-50,162],[-3,74],[-25,67],[-10,63],[-30,85],[-10,44],[-22,9],[-11,-37],[-2,-74],[6,-37],[-8,-56],[-12,-21],[-27,-10],[-18,21],[-19,-54],[-36,-29],[-50,-68],[-73,-48],[-88,-28],[-75,10],[-51,38],[-13,32],[-13,99],[23,18],[-18,69],[-54,62],[-32,108],[-5,34],[-33,51],[-18,62],[-42,8],[-31,42],[-47,110],[23,32],[24,55],[-2,36],[-24,6],[-38,-54],[-48,10],[-16,51],[11,32],[32,1],[57,128],[10,-4],[17,45],[-16,34],[-4,41],[32,24],[-27,7],[5,70],[27,78],[-17,3],[-18,-48],[-40,42],[-6,40],[22,49],[27,-6],[19,23],[0,45],[-17,-21],[-30,32],[-16,54],[2,23],[-20,7],[-13,35],[-10,-14],[-12,-99],[-14,-6],[-38,16],[-10,21],[-10,66],[1,129],[-11,19],[-43,10],[-18,37],[-10,98],[42,44],[6,38],[-17,46],[-30,31],[-45,-27],[0,-46],[-21,23],[-9,88],[8,147],[6,11],[-2,-107],[92,47],[0,19],[-35,20],[-20,28],[-24,82],[2,18],[36,19],[55,-8],[33,25],[-29,134],[-4,46],[3,84],[21,77],[101,278],[4,29],[27,77],[29,61],[5,70],[18,67],[21,34],[19,-4],[9,23],[-11,115],[26,188],[18,70],[38,61],[-18,24],[4,22],[58,133],[60,46],[48,11],[42,-45],[43,-11],[32,-84],[24,-6],[6,-26],[54,-88],[73,24],[61,124],[4,47],[44,29],[63,172],[23,89],[23,39],[-9,58],[14,5],[28,-28],[22,-5],[13,-77],[52,0],[45,20],[26,-20],[77,28],[48,38],[9,51],[56,128],[38,135],[0,71],[-12,81],[-23,95],[-17,121],[-1,118],[-5,52],[-71,157],[-9,32],[-41,28],[-27,1],[10,97],[27,33],[14,-25],[35,-20],[51,7],[-10,45],[31,10],[41,81],[2,114],[-42,122],[-47,68],[-25,48],[-1,-32],[-27,-48],[-20,-86],[-42,-30],[-42,42],[-59,-93],[-81,-34],[-18,-71],[-85,-103],[-21,-70],[-5,-99],[-44,-70],[-4,93],[-15,110],[-23,50],[-28,-3],[4,34],[-32,46],[-9,36],[-38,-60],[16,-45],[21,-7],[16,-39],[24,11],[2,-48],[-22,-81],[-19,-11],[-22,82],[-55,76],[-41,33],[-64,13],[-41,-27],[-27,12],[-52,3],[-45,-22],[-108,-112],[-58,-17],[-111,74],[-94,45],[-47,14],[-88,40],[-49,79],[-20,96],[1,74],[20,36],[-6,64],[-28,63],[-45,56],[-1,59],[-46,64],[-10,56],[39,-33],[33,3],[9,27],[24,15],[16,32],[-3,55],[35,61],[-38,63],[-19,9],[-29,-16],[-39,15],[-64,52],[-104,21],[-49,52],[-38,63],[-55,60],[-46,30],[-15,93]],[[2812,78476],[27,27],[-1,59],[18,0],[10,36],[0,57],[21,33],[5,57],[-10,16],[11,87],[46,106],[16,-26],[27,16],[28,-3],[-9,65],[-12,5],[9,77],[-6,26],[18,76],[40,67],[54,37],[29,-53],[31,1],[2,-23],[-21,-74],[5,-60],[-55,-95],[-65,-72],[-19,-66],[-1,-36],[-28,-81],[-15,-58],[-25,-10],[-28,-71],[-15,-17],[-4,-51],[-15,21],[-27,-49],[-54,-69],[13,45]],[[2752,78371],[29,49],[-1,-45],[-26,-25],[-2,21]],[[2615,78610],[4,50],[19,16],[4,-44],[-9,-45],[-12,-8],[-6,31]],[[2607,82847],[50,-13],[29,5],[10,-14],[-27,-68],[-23,4],[-9,46],[-20,10],[-10,30]],[[2611,78728],[8,-39],[-15,13],[7,26]],[[2547,78457],[17,17],[23,-3],[-2,19],[27,23],[19,-10],[10,-25],[-17,-105],[-30,50],[-25,-29],[-19,14],[-3,49]],[[2517,78521],[8,26],[23,-16],[1,-31],[-14,-31],[-13,16],[-5,36]],[[2497,78313],[4,72],[33,-18],[-7,-57],[-30,3]],[[2431,83489],[9,43],[22,15],[12,-10],[29,22],[-2,-56],[-32,-62],[-5,31],[-33,17]],[[2316,78170],[5,42],[40,72],[31,-27],[1,-27],[-13,-58],[-19,2],[-17,-26],[-15,-48],[-15,21],[2,49]],[[2228,78152],[9,-32],[-16,2],[7,30]],[[2183,78046],[17,42],[16,-37],[-12,-55],[-19,-1],[-2,51]],[[2036,90914],[2,37],[25,87],[-3,75],[8,18],[-5,57],[21,3],[8,-42],[-4,-48],[12,-34],[64,-57],[77,-48],[55,-20],[58,87],[58,58],[58,-14],[29,-69],[23,-15],[15,-104],[-2,-38],[53,-56],[56,-14],[22,-32],[9,-35],[36,-20],[88,-20],[14,6],[102,-55],[-27,-131],[-22,-43],[-51,35],[-43,-1],[-50,-29],[-44,-89],[-10,-61],[1,-53],[-20,-46],[-30,22],[3,24],[-26,119],[-32,62],[-50,60],[-39,-5],[-11,69],[-17,55],[-54,80],[-86,69],[-65,11],[-47,-44],[-18,-58],[-36,-34],[-28,33],[-49,36],[-24,83],[-7,56],[3,73]],[[1818,77819],[15,59],[33,49],[12,-2],[27,-39],[-1,-41],[-28,-51],[-32,-27],[-22,-1],[-4,53]],[[1695,87369],[6,69],[25,52],[11,-3],[-4,-58],[12,-54],[33,-70],[48,-63],[22,-14],[25,13],[57,-94],[-21,-19],[-9,37],[-51,8],[-26,-17],[-33,46],[-58,136],[-37,31]],[[1687,87598],[8,-5],[5,-84],[-20,42],[7,47]],[[1421,77626],[35,0],[33,-31],[9,30],[14,-2],[33,27],[25,-1],[-6,-28],[10,-29],[8,15],[31,-24],[23,16],[10,-11],[32,11],[5,-12],[41,-7],[-25,-23],[-16,6],[-14,-22],[-44,-1],[-22,-35],[-8,16],[-16,-19],[-19,4],[-18,25],[-52,3],[-9,-15],[-29,19],[-10,49],[-11,-1],[-10,40]],[[1064,77503],[55,37],[11,-28],[25,50],[3,-22],[19,38],[5,29],[18,-29],[27,8],[8,34],[6,-24],[35,37],[1,42],[44,10],[-13,41],[43,-5],[13,34],[-1,36],[-32,7],[-23,29],[5,26],[21,-16],[12,36],[-2,39],[38,46],[33,-32],[22,-76],[1,-31],[-21,-85],[-34,8],[-4,-43],[33,-79],[-3,-24],[-15,21],[-17,-10],[-4,-27],[-16,-4],[-20,23],[-19,-95],[-25,31],[-64,-55],[-13,29],[-29,12],[-23,-6],[-13,-35],[-22,-8],[-33,6],[-32,25]],[[1013,77451],[17,17],[7,-29],[-22,-4],[-2,16]],[[1005,77685],[16,-19],[-11,-12],[-5,31]],[[949,77433],[5,9],[40,-3],[1,-26],[-19,3],[-22,-24],[-5,41]],[[890,77452],[11,14],[28,-1],[15,-90],[-16,5],[-17,49],[-21,23]],[[821,77563],[14,45],[26,-9],[23,-80],[-20,-38],[15,-56],[-13,-34],[-18,-2],[-18,22],[3,57],[-7,2],[-8,77],[3,16]],[[811,77269],[5,56],[12,10],[10,-27],[19,10],[-12,22],[34,30],[10,-23],[-2,-55],[-23,0],[13,-52],[-29,29],[2,-40],[-12,12],[-5,-39],[-7,45],[-15,22]],[[601,77040],[11,67],[15,16],[7,36],[-13,66],[4,27],[32,7],[7,59],[-13,69],[10,45],[15,4],[18,-20],[19,59],[9,-14],[3,-74],[-20,-29],[-2,-50],[13,-20],[19,4],[31,26],[30,5],[7,-64],[-7,-88],[-15,-12],[-36,18],[-13,-52],[-18,-12],[-13,-41],[-23,31],[-6,-25],[6,-48],[-11,17],[-13,-26],[-4,55],[-14,29],[-19,-108],[-14,11],[-2,32]],[[469,77371],[13,9],[2,-26],[-14,-17],[-1,34]],[[402,77131],[18,33],[24,-17],[26,34],[50,39],[21,43],[2,128],[12,16],[16,-10],[15,-44],[-26,-98],[5,-86],[-7,-38],[-33,-31],[-36,61],[-27,-33],[-40,-10],[-1,-43],[-10,5],[-9,51]],[[257,77332],[8,29],[29,17],[39,-5],[11,-42],[-2,-30],[19,-32],[15,17],[18,-17],[33,34],[-10,-40],[-41,-32],[-12,-71],[4,-31],[-12,-31],[-8,16],[-9,-44],[8,-57],[-8,-5],[-9,56],[-14,-24],[-16,48],[-13,8],[4,28],[41,25],[-3,64],[-20,1],[-13,34],[-39,66],[0,18]],[[130,77016],[32,-12],[-3,-18],[-27,7],[-2,23]],[[81,76979],[27,-17],[7,-23],[-25,5],[-9,35]],[[77,77233],[14,52],[20,-35],[0,-61],[-19,-10],[-15,54]],[[43,76751],[8,25],[10,-22],[5,-50],[-12,-2],[-10,-32],[-1,81]],[[3,76640],[12,18],[6,-59],[-18,-25],[0,66]],[[99917,77451],[12,-2],[12,35],[26,14],[31,-61],[-9,-68],[-24,-42],[-12,-5],[-25,29],[-11,29],[0,71]],[[99678,77049],[5,24],[26,-29],[19,3],[27,-24],[4,-31],[24,-42],[27,-78],[25,-26],[11,-57],[44,-11],[21,-33],[-18,-19],[-9,14],[-29,-16],[-15,41],[-41,72],[-30,101],[-30,43],[-17,-8],[-22,25],[-22,51]],[[99628,77446],[9,11],[20,-16],[11,-33],[-14,-49],[-10,-4],[-16,91]],[[99570,77271],[19,-7],[21,-67],[-22,15],[-18,59]],[[99530,77510],[7,22],[17,-22],[3,-34],[-17,-20],[-10,54]],[[99282,77351],[24,27],[15,50],[39,26],[6,63],[16,96],[11,18],[20,-52],[-12,-32],[-8,-57],[-20,-53],[21,-18],[0,-35],[-13,-10],[-42,17],[-17,-31],[-4,-70],[-11,2],[-25,40],[0,19]],[[98911,77903],[26,-13],[-18,-27],[-8,40]],[[98408,78327],[22,-8],[3,-26],[-24,15],[-1,19]],[[98376,78346],[14,-8],[0,-29],[-14,37]],[[98352,78374],[20,-27],[-12,-2],[-8,29]],[[98210,77943],[6,31],[19,27],[23,-6],[26,67],[41,5],[-17,-40],[-5,-37],[10,-104],[-21,0],[-17,52],[-35,-19],[-30,24]],[[97960,78551],[47,86],[33,11],[100,-20],[29,-63],[24,-15],[35,-94],[2,-18],[-35,-8],[-21,38],[-17,-71],[-9,-13],[-38,15],[-26,-41],[-27,32],[-12,40],[-3,63],[-32,56],[-35,-24],[-15,26]],[[13347,81071],[9,23],[10,-28],[-5,-52],[-16,34],[2,23]],[[13279,80906],[61,56],[7,-80],[13,-14],[-20,-68],[-24,-1],[-33,63],[-4,44]],[[13241,80901],[26,65],[8,-25],[-26,-58],[-8,18]],[[13234,81005],[16,62],[-2,43],[13,20],[-14,43],[-2,70],[5,39],[11,9],[19,-32],[5,-35],[13,-7],[17,-40],[0,-165],[-9,-34],[-27,-2],[-13,32],[-23,-36],[-9,33]],[[13172,81388],[4,66],[6,1],[52,-135],[-12,-28],[-1,-68],[-15,-111],[-23,74],[-9,113],[-2,88]],[[12999,82714],[4,48],[9,-30],[-13,-18]],[[12979,82569],[2,29],[21,40],[21,-38],[-1,-22],[-24,-37],[-19,28]],[[12954,82690],[20,33],[17,52],[-5,-50],[-18,-75],[-14,40]],[[12888,80934],[18,6],[-4,-53],[-14,47]],[[12850,82395],[7,53],[10,-24],[22,-97],[10,-68],[-13,-15],[-21,61],[-9,4],[-6,86]],[[12838,82543],[18,86],[21,30],[30,-20],[24,22],[28,-42],[4,-36],[-18,-53],[6,-82],[-16,-19],[-44,-22],[-23,65],[-24,29],[-6,42]],[[12768,81460],[21,27],[-2,-46],[-16,-11],[-3,30]],[[12700,80811],[9,0],[10,-128],[-15,29],[-4,99]],[[12674,81692],[9,23],[1,61],[20,-30],[1,-32],[-22,-72],[-9,50]],[[12659,81749],[12,9],[-1,-36],[-11,27]],[[12637,81497],[8,92],[8,25],[32,-9],[10,-16],[-2,-35],[-16,-42],[8,-16],[20,40],[5,43],[13,-19],[19,68],[19,-2],[16,-39],[-5,-60],[-15,-35],[-19,15],[-13,-35],[17,-22],[-2,-37],[-22,-21],[-22,-50],[-9,-97],[-23,78],[17,61],[-1,78],[-29,51],[-14,-16]],[[12629,82086],[11,22],[24,102],[28,10],[11,20],[-22,13],[-1,47],[15,-22],[9,34],[-36,62],[14,29],[-10,86],[23,49],[45,-24],[71,-17],[24,-82],[11,-73],[-5,-69],[14,-6],[13,-68],[17,-48],[17,5],[57,-119],[12,-52],[33,-111],[3,-126],[29,-29],[8,-82],[8,-32],[31,-50],[13,-58],[-10,-6],[-19,46],[-75,98],[-3,-31],[-23,-74],[11,-8],[14,47],[8,-19],[23,10],[5,-37],[20,-13],[10,-29],[-38,-14],[8,-36],[32,21],[14,-52],[16,-14],[11,-87],[8,-9],[-12,-49],[-20,9],[2,-32],[22,-22],[11,8],[3,46],[14,36],[9,-21],[5,-91],[-15,-34],[4,-36],[-22,-94],[-29,-40],[18,-23],[27,59],[15,-10],[0,-203],[7,-72],[-20,-105],[-37,-9],[-26,48],[-14,-19],[-17,38],[-1,37],[-38,-2],[17,53],[27,-10],[1,39],[-19,42],[-19,13],[-35,78],[9,38],[10,115],[-15,9],[-11,-58],[7,101],[8,28],[-11,39],[-5,-55],[-27,-21],[14,-103],[-18,-58],[-47,56],[-4,35],[17,58],[-18,100],[-20,-5],[-10,50],[-21,3],[12,-78],[18,-65],[6,-72],[-7,-36],[15,-17],[20,-145],[24,-26],[-4,58],[24,18],[28,-65],[4,-124],[-14,-16],[-18,74],[-7,-7],[23,-170],[-29,0],[-26,32],[-2,60],[-20,40],[-49,177],[-10,22],[-2,84],[-12,10],[-8,61],[29,8],[-27,33],[3,119],[-33,-28],[-10,26],[-18,-19],[-9,42],[6,84],[33,30],[11,-63],[17,20],[-13,29],[6,39],[14,20],[14,-14],[22,44],[-29,96],[14,12],[-16,32],[4,66],[-24,-21],[-49,87],[-4,28],[16,-1],[-9,50],[3,35],[-27,18],[6,-57],[-10,-13],[-32,39],[-16,58],[12,52],[28,14],[37,-54],[28,35],[-17,67],[-18,16],[-12,-20],[-9,17],[8,30],[-2,42],[7,63],[-5,16],[-13,-47],[-27,-65],[-22,-33],[-23,38],[-5,45]],[[12611,83642],[15,25],[14,-33],[-27,-31],[-2,39]],[[12594,82026],[14,28],[11,-6],[4,-52],[-8,-48],[-10,3],[-11,75]],[[12476,82024],[28,22],[1,-43],[31,33],[8,75],[7,-2],[-9,-101],[-22,-24],[-20,-56],[-18,17],[8,30],[-14,49]],[[12463,83115],[17,52],[16,17],[7,33],[33,-1],[1,26],[28,-40],[11,-83],[18,-54],[31,-2],[9,-21],[10,26],[-29,44],[-13,80],[-2,55],[-35,79],[11,53],[34,26],[51,-37],[25,-9],[47,-44],[31,-20],[7,14],[57,-11],[30,-74],[14,-82],[3,-56],[9,-23],[23,-11],[16,-48],[5,-46],[33,-52],[9,-64],[15,-34],[-31,-38],[-20,-42],[-26,-24],[-16,16],[-31,4],[-43,24],[5,-48],[-23,-51],[-40,25],[-19,29],[-12,-47],[-15,-20],[-25,-2],[-17,15],[-3,87],[-11,32],[-30,-64],[13,-29],[-2,-90],[-23,-3],[-2,-31],[10,-51],[-11,-51],[-2,-62],[-17,-50],[4,-39],[-9,-64],[-10,-11],[-25,15],[-14,-103],[-15,19],[-12,52],[-7,63],[-1,109],[-10,87],[2,75],[14,48],[-3,57],[15,101],[-12,28],[-22,-1],[5,77],[-20,56],[-8,75],[2,43],[-5,91]],[[12311,84926],[43,-96],[7,-47],[14,-9],[8,-130],[19,1],[21,38],[11,-23],[20,-2],[21,-29],[54,13],[-3,-89],[25,-75],[2,-52],[21,-52],[14,-87],[17,-55],[2,-142],[21,-60],[4,-65],[-9,-2],[-5,47],[-38,120],[-10,115],[-19,37],[-9,53],[-21,0],[26,-101],[4,-34],[-13,-23],[35,-121],[23,-49],[-2,-62],[24,-113],[-19,6],[15,-102],[0,-27],[-25,-62],[-20,26],[-17,-1],[4,-34],[-21,-104],[-38,-83],[-24,-25],[-2,-33],[-31,-65],[-29,3],[-9,89],[-4,135],[21,80],[15,23],[-16,31],[-1,69],[14,6],[12,-39],[6,23],[-40,141],[-1,58],[-18,60],[-5,82],[-11,43],[8,125],[-12,81],[-3,95],[-11,91],[4,44],[-20,93],[-17,45],[-9,77],[-6,101],[3,42]],[[12292,85061],[35,-45],[27,-125],[-10,-5],[-22,115],[-23,19],[-7,41]],[[12202,85643],[15,-71],[0,-46],[-10,29],[-5,88]],[[12106,83714],[16,11],[1,26],[28,65],[-4,68],[36,64],[18,-12],[25,-85],[15,10],[18,-58],[23,-24],[38,4],[22,-14],[12,-79],[-2,-49],[-20,35],[-19,-2],[-1,-22],[21,-25],[11,-46],[29,-278],[-1,-71],[12,-56],[0,-58],[18,-142],[5,-107],[-5,-112],[-11,1],[8,-81],[3,-240],[-9,-111],[-11,6],[-28,70],[-10,86],[-21,59],[-40,212],[4,48],[22,23],[-18,30],[-26,-31],[-14,88],[-11,-15],[-17,42],[-12,55],[2,34],[-14,-22],[-10,24],[-30,2],[-19,96],[19,3],[10,-29],[10,13],[-3,105],[19,53],[6,38],[-39,86],[24,63],[-4,22],[14,35],[4,53],[-33,16],[-21,-28],[-14,79],[-26,72]],[[12097,84881],[16,18],[19,-7],[16,-52],[-29,-6],[-22,47]],[[12062,83572],[4,48],[-3,66],[25,9],[34,-62],[15,-74],[12,-19],[17,30],[23,-10],[-16,-82],[-24,-14],[-27,-161],[-12,6],[-40,-30],[-9,8],[3,102],[25,47],[1,50],[-22,4],[2,29],[-13,31],[5,22]],[[11978,85151],[9,14],[7,-59],[-16,45]],[[11978,84786],[30,41],[3,-53],[-16,-19],[-17,31]],[[11861,84371],[5,174],[16,33],[8,-9],[29,60],[3,51],[-12,92],[32,-2],[0,-54],[12,-60],[28,61],[29,-6],[17,-20],[17,49],[36,50],[14,-55],[41,-30],[25,-53],[-12,-78],[-31,-76],[4,-49],[12,-5],[8,60],[32,108],[15,12],[34,-55],[46,-10],[11,-32],[29,-16],[15,-79],[-4,-67],[-22,-44],[-37,49],[-10,-8],[12,-40],[18,-18],[33,-75],[-21,-29],[-25,-2],[4,-28],[21,-13],[23,24],[7,-95],[14,-69],[12,-143],[-14,-42],[-42,-11],[-17,12],[-44,95],[-65,99],[-27,50],[-22,-26],[-9,29],[-4,-32],[30,-55],[22,-8],[-21,-31],[6,-25],[0,-72],[-9,-50],[-31,-87],[-51,47],[-1,38],[-42,85],[-20,90],[-12,-38],[-19,43],[-10,79],[4,25],[-18,86],[2,24],[-16,57],[-26,30],[-7,49],[-25,36]],[[9331,87212],[28,-14],[12,-44],[-27,-9],[-13,67]],[[9232,87245],[16,14],[58,-26],[-3,-31],[-21,-10],[-50,53]],[[8867,87809],[26,35],[27,3],[15,-16],[-18,-53],[-50,31]],[[8817,87545],[4,86],[28,16],[21,-89],[-11,-44],[-37,-10],[-5,41]],[[8816,87079],[2,14],[43,47],[1,-36],[-40,-59],[-6,34]],[[8698,86532],[8,21],[3,71],[23,12],[-3,42],[21,54],[16,7],[-3,41],[30,34],[9,30],[43,75],[22,118],[27,44],[-3,40],[10,71],[27,34],[4,-43],[24,2],[-17,-51],[9,-17],[24,28],[8,-22],[-11,-37],[-62,-118],[-49,-129],[-8,-80],[-33,-60],[30,-57],[-19,-42],[-23,-8],[-22,15],[-17,-57],[-9,6],[-45,-47],[-14,23]],[[8692,87068],[44,270],[11,-41],[12,13],[-4,66],[44,84],[0,-54],[-12,-32],[-3,-82],[-20,-37],[20,-42],[-24,-97],[2,-46],[-17,-104],[-24,45],[-3,25],[-25,7],[-1,25]],[[8672,87628],[15,31],[17,-19],[17,-48],[-24,-45],[-25,81]],[[17950,55027],[5,31],[24,-13],[25,26],[-2,40],[18,63],[1,79],[-15,136],[-16,8],[-7,-13],[-13,25],[-3,-17],[-14,68],[7,67],[2,142],[-15,41],[9,65],[-8,51],[19,9],[28,138],[9,24],[-4,46],[4,110],[8,12],[-2,74],[-7,64],[1,51],[6,6],[-2,55],[-7,20],[28,116],[0,69],[8,28],[23,29],[10,40],[17,21],[1,19],[25,65],[-1,49],[-11,54],[-14,19],[-31,100],[-13,7],[2,58],[-26,239],[-23,63],[-7,69],[-16,57],[1,147]],[[17974,57684],[6,95],[-10,22],[21,43],[0,72],[-9,178],[-6,65],[-11,47],[-4,58],[6,36],[0,103],[-9,38],[3,39],[-7,31],[3,51],[-5,59],[4,56],[9,24],[-10,31],[-12,97],[4,43],[-7,80],[25,31],[9,29],[5,-14],[12,25],[17,-1],[2,-25],[24,19],[13,-3],[18,-71],[-2,-28],[21,-51],[24,11],[24,183],[5,15],[1,230],[-2,272],[0,437]],[[18136,60011],[200,0],[222,0],[313,1],[97,1],[160,2],[6,-7],[235,0],[162,1]],[[19531,60009],[0,-1691],[-1,-237],[1,-30],[0,-925],[-1,-608],[1,-145],[-1,-113],[0,-2847]],[[19530,53413],[-64,2],[-201,-1],[-128,-1],[-172,0],[-359,476],[-212,269],[-102,136],[-368,471],[5,66],[-5,17],[1,60],[8,16],[17,103]],[[19530,64667],[242,0],[154,2],[327,0],[66,-5],[137,-1],[242,1],[7,2],[217,2]],[[20922,64668],[282,1],[135,0],[140,0],[0,-1163]],[[21479,63506],[1,-381],[0,-434],[1,-193],[0,-1270],[1,-137],[0,-1089]],[[21482,60002],[-183,3],[-22,5],[-62,1]],[[21215,60011],[-204,-3],[-169,-5],[-184,0],[-34,2],[-301,-1],[-186,-2],[-2,9],[-152,-1],[-230,-1],[-222,0]],[[19531,60009],[0,583],[1,36],[0,738],[-5,129],[0,517],[2,216],[0,1857],[1,46],[0,536]],[[27414,45876],[14,60],[5,-33],[-14,-44],[-5,17]],[[27386,45813],[9,39],[11,4],[-5,-33],[-15,-10]],[[27310,45701],[52,90],[6,-30],[-45,-80],[-13,20]],[[27118,45540],[19,106],[20,46],[25,43],[3,23],[36,66],[38,-67],[4,-52],[14,-43],[-4,-11],[-40,-48],[-3,27],[-27,-5],[-3,-24],[-46,-73],[-36,-15],[0,27]],[[27062,45510],[39,24],[-10,-43],[-17,-14],[-13,8],[1,25]],[[27020,45533],[6,35],[12,-10],[-5,-41],[-13,16]],[[26992,48019],[5,-18],[19,-211],[8,-28],[17,-26],[7,17],[14,-21],[-14,-31],[-9,-1],[-21,50],[-7,28],[-13,115],[-6,76],[0,50]],[[26806,45614],[15,13],[4,-23],[-20,-10],[1,20]],[[26322,51623],[29,47],[0,-29],[-16,-37],[-11,-6],[-2,25]],[[26229,53027],[6,-79],[11,-52],[2,-83],[6,-75],[14,-48],[136,-25],[261,-56],[206,-51],[135,-34],[-5,-14],[2,-57],[7,-26],[-3,-71],[11,-76],[37,13],[0,75],[6,47],[3,119],[-12,91],[4,60],[-1,49],[8,16],[-4,24],[12,-8],[9,59],[15,-7],[7,-33],[17,-3],[18,-28],[7,-25],[33,-19],[17,-18],[14,15],[13,-19]],[[27221,52688],[4,-13],[-4,-113],[3,-92],[-4,-22],[10,-25],[4,-95],[1,-113],[23,-389],[13,-129],[0,-51],[28,-302],[32,-288],[29,-229],[65,-412],[38,-200],[4,-63],[10,-83],[-18,-57],[-4,-54],[-1,-87],[5,-130],[6,-96],[16,-145],[35,-269],[15,-166],[5,-84],[5,-29],[11,-140],[17,-152],[9,-66],[6,-94],[13,-109],[17,-258],[-1,-235],[-7,-175],[-5,-210],[-3,-37],[-8,-286],[0,-169],[-3,-80],[-7,-81],[0,-44],[-6,23],[3,51],[-5,20],[-16,-25],[-10,-102],[-6,-17],[-1,-64],[-8,-40],[-2,-78],[5,-33],[-2,-46],[6,-16],[-8,-53],[-8,-13],[-1,-49],[21,39],[25,194],[7,41],[0,-41],[-8,-83],[-34,-222],[-9,-82],[-25,-93],[-34,-139],[-24,-66],[-3,12],[34,122],[14,40],[7,53],[3,81],[5,32],[-6,23],[-9,-11],[-7,26],[-6,-18],[-34,-22],[-14,-41],[-9,-6],[-18,45],[-18,-13],[-7,-41],[-27,-18],[-23,-6],[-17,52],[-8,68],[2,79],[6,60],[6,-3],[-2,49],[-12,97],[-11,47],[2,34],[-8,62],[-11,32],[-5,85],[-6,18],[-11,-15],[-9,101],[-24,31],[-1,16],[-21,38],[-21,55],[-11,-13],[-8,-39],[-16,126],[-15,148],[-5,173],[-7,109],[-7,57],[-28,113],[-11,9],[-1,52],[-12,23],[0,-64],[-14,-11],[-1,66],[-8,113],[-12,51],[3,24],[13,-3],[9,-39],[11,159],[-2,86],[-8,14],[0,40],[8,10],[-4,31],[-12,-4],[-5,-33],[-11,-11],[8,-148],[-9,-20],[-20,-11],[-5,-50],[0,75],[-6,50],[-17,94],[-26,177],[-9,94],[-19,140],[-27,149],[-14,56],[-4,58],[-10,61],[10,-19],[1,-30],[15,30],[10,72],[12,28],[13,98],[13,34],[-2,23],[14,26],[11,84],[-5,75],[-22,21],[5,-113],[-22,30],[6,34],[-1,65],[-5,39],[-38,71],[1,-65],[-11,-28],[11,-37],[16,-6],[11,-110],[-10,-42],[0,-62],[-4,-27],[-21,-6],[-3,-32],[7,-38],[-9,-30],[-4,40],[2,83],[-14,85],[-9,26],[-8,58],[6,182],[-5,66],[-4,164],[9,1],[0,-93],[4,-89],[9,-7],[-4,153],[9,37],[1,41],[8,44],[0,38],[7,50],[0,39],[9,47],[1,91],[5,83],[-6,66],[2,56],[-13,29],[4,42],[-9,109],[12,64],[-21,110],[3,31],[-8,55],[-10,3],[5,33],[-1,49],[-7,13],[-47,23],[-9,-51],[-7,-4],[-9,100],[3,45],[-14,32],[-12,9],[-2,63],[-7,58],[-11,45],[-15,6],[-5,44],[-24,48],[0,111],[-4,67],[-12,7],[-10,38],[-13,17],[-13,61],[0,42],[-9,35],[-5,51],[-14,44],[-28,62],[-40,72],[-26,75],[-11,-2],[-26,-33],[-31,29],[-1,-35],[-26,-69],[9,-99],[-3,-28],[-10,-7],[-15,15],[-5,26],[-24,-22],[-31,-73],[-65,-132],[-6,2],[7,44],[-10,12],[-7,-39],[-15,-41],[-36,1],[13,-49],[2,-38],[16,-22],[30,53],[29,40],[27,84],[3,-13],[-24,-82],[-28,-43],[-35,-66],[-12,-14],[-10,33],[-16,22],[-23,51],[-19,7],[-17,-28],[-13,94],[-5,119],[8,42],[0,-105],[6,-91],[7,-22],[10,39],[1,97],[-17,105],[-18,60],[-17,13],[-15,40],[-16,71],[-27,47],[-22,69],[-41,95],[-47,76],[-58,70],[-31,20],[-62,18],[-33,-5],[-47,-25],[-65,-49],[-32,-15],[-7,10],[-63,-51]],[[26061,57664],[39,-2],[136,6],[183,1]],[[26419,57669],[196,-2],[-1,6],[143,10]],[[26757,57683],[-3,-72],[-31,-68],[-26,-105],[1,-36],[-8,-26],[3,-64],[30,-82],[17,-7],[23,-104],[23,-51],[28,16],[8,-12],[8,-64],[3,-64],[12,-30],[3,-50],[11,-52],[0,-51],[7,-68],[12,-24],[8,-67],[14,-48],[11,-101],[9,-1],[19,-72],[29,-52],[29,-98],[4,-61],[9,-41],[1,-40],[13,-38],[12,-2],[17,-37],[18,-93],[15,-26],[4,-24],[-7,-43],[4,-39],[-4,-32],[28,-82],[-4,-30],[13,-42],[11,5],[-2,-41],[8,-45],[27,-55],[9,1],[16,-58],[19,-43],[-5,-67],[12,-64],[2,-49],[9,-15],[0,-85],[4,-32],[-5,-45],[6,-8],[4,-48],[-5,-41],[12,-48],[25,-26],[0,-23],[23,-81],[-4,-34],[15,-105],[4,4],[6,-76],[-10,-44],[11,-67],[-4,-26],[5,-62],[21,-34],[11,17],[22,-71],[9,-4]],[[27376,54230],[12,-12],[-5,-64],[-14,-29],[-10,15],[-6,-48],[10,-8],[-16,-60],[-21,23],[-3,-56],[11,-11],[-9,-59],[-17,-54],[-17,13],[-3,-16],[12,-33],[8,5],[-1,-84],[-7,-62],[-28,-26],[0,-22],[17,10],[6,-24],[-23,-131],[-6,-91],[7,-13],[-5,-30],[-5,-97],[-13,-22],[-8,-59],[-9,-3],[0,-71],[-7,-69],[-7,2],[-12,-44],[13,-24],[11,24],[1,-81],[-16,-161],[5,-70]],[[25527,65491],[15,-41],[12,20],[7,-15],[-6,-40],[27,-23],[29,1],[28,25],[52,75],[31,59]],[[25722,65552],[90,-1],[198,-1],[187,1],[87,1],[0,-75]],[[26284,65477],[1,-242],[0,-1380],[-3,-437],[0,-441],[-2,-278],[0,-238]],[[26280,62461],[-19,-45],[-2,-20],[16,-71],[2,-31],[-11,-38],[3,-37],[17,-7],[4,-25],[-13,-46],[6,-44],[-22,3],[-16,-23],[-9,5],[-35,-63],[-14,-39],[-19,10],[-10,43],[-26,-7],[-16,7],[-12,-33],[4,-125],[6,-71],[-16,-40],[-7,-44],[-30,-34],[-19,-161],[-19,-39],[-14,24],[-10,-13],[-6,-63],[-16,-72],[1,-87],[-5,-70],[-8,-24],[-23,-18],[-4,-36],[-13,58],[-22,1],[-26,55],[-1,94],[-21,67],[-8,-2],[1,-34],[13,-12],[-1,-25],[-13,-2],[-8,-29],[-8,23],[-9,-29],[9,-17],[-6,-42],[-18,-9],[-2,-94],[5,-38],[-23,-9],[-2,-63],[-11,-29],[-7,24],[5,51],[-10,10],[-10,-25],[-10,22],[-12,89],[-17,-2],[-14,-52],[-29,-27],[-10,-30],[-5,-97],[-7,-27],[-11,-3],[-8,62],[-18,13],[-22,57],[-22,44],[-20,6],[-14,-37],[-14,19],[-6,49],[-8,6],[-7,-66],[11,-64],[-13,-40],[-11,3],[3,56],[-5,30],[-42,-31],[-11,52],[-9,4],[-10,-40],[10,-91],[-12,-47],[-23,32]],[[25386,60941],[-11,2],[-4,34],[12,-9],[-16,92],[24,-8],[-15,29],[15,67],[1,60],[-8,26],[19,19],[2,38],[-12,-19],[22,73],[-14,60],[-4,59],[9,-10],[9,68],[5,-35],[7,41],[8,-33],[13,102],[8,9],[13,84],[-2,38],[24,42],[0,66],[9,83],[7,32],[14,12],[14,76],[-1,42],[-15,94],[11,111],[-18,40],[1,79],[-16,55],[-3,73],[19,60],[-9,50],[2,60],[6,32],[13,9],[0,347],[-1,0],[0,397],[1,12],[0,294],[1,247],[0,1196],[1,254]],[[21479,63506],[257,-1],[104,0],[263,-1],[273,1],[163,0],[279,-1],[263,-1],[144,0],[133,0]],[[23358,63503],[16,-60],[13,-11],[1,-43],[13,6],[5,-36],[26,-14],[8,41],[24,-13],[-4,-28],[7,-33],[11,-11],[-4,-42],[-9,-1],[3,-36],[12,16],[-1,-49],[-10,-6],[-13,24],[-5,-75],[-15,-19],[-7,-41],[2,-41],[-17,-24],[1,-48],[15,-41],[1,-29],[16,-31],[12,-61],[14,0],[5,-21],[-9,-25],[6,-79],[18,-52],[-3,-28],[15,-13],[5,-31],[14,-11],[9,16],[5,-31],[20,-3],[-5,-41],[0,-444],[-1,-120],[0,-696],[-1,-52],[0,-779],[-1,-97],[0,-281]],[[23550,60009],[-249,1],[-196,-1],[-169,0],[-218,0],[-208,-1],[-258,2],[-103,0],[-154,3],[-149,-4],[-209,-4],[-155,-3]],[[30863,68384],[14,7],[-7,-35],[-7,28]],[[30827,68345],[7,83],[6,-34],[19,-55],[-15,-45],[-5,34],[-12,17]],[[30819,68560],[3,42],[11,-71],[-14,29]],[[30732,68434],[14,2],[3,-41],[-17,39]],[[30712,67988],[8,37],[1,-75],[-9,38]],[[30703,68290],[8,41],[25,45],[11,-50],[-9,-8],[14,-78],[-11,-39],[-18,-13],[-12,24],[5,25],[-3,50],[-10,3]],[[30697,68452],[13,68],[2,64],[9,25],[6,-26],[-9,-35],[1,-36],[-8,-70],[-10,-29],[-4,39]],[[30213,67064],[-35,81],[0,69],[6,42],[-41,128],[-9,53],[8,101],[-4,10],[6,88],[-6,23],[-5,313],[0,89],[-11,861],[-15,757]],[[30107,69679],[21,15],[0,33],[25,-41],[-1,-38],[7,-43],[11,-15],[13,85],[2,86],[-6,28],[12,36],[8,-3],[12,-44],[21,-9],[1,39],[-24,83],[-1,32],[22,107],[14,27],[11,43],[8,-1],[15,41],[24,38],[-9,71],[21,66],[23,45],[5,56],[-7,28],[-14,0],[0,66],[10,38],[-8,14],[15,51],[5,46],[-15,44],[16,115],[8,18],[-1,37],[17,32],[14,59],[11,8],[17,324],[215,890],[13,-3],[27,-38],[11,4],[-3,-58],[1,-141],[4,-18],[37,-73],[25,43],[26,30],[28,2],[11,52],[30,11],[25,-12],[0,62],[16,23],[25,-6],[23,-36],[4,-32],[33,-68],[36,-132],[0,-15],[28,-51],[0,-545],[3,-693],[-1,-71],[9,-30],[-15,-39],[14,-70],[-15,-34],[1,-136],[23,-18],[3,20],[10,-57],[19,-28],[30,-23],[14,19],[8,-62],[1,-56],[-13,8],[-11,-22],[7,-68],[16,-63],[-9,-73],[-10,-41],[23,-116],[0,-23],[18,-40],[13,28],[1,46],[18,-30],[19,-3],[13,-56],[6,-51],[-8,-14],[10,-32],[12,-98],[15,-38],[1,-118],[-12,-50],[-10,2],[-4,-32],[-32,-113],[-24,-25],[4,-22],[-15,-8],[6,42],[-4,85],[-27,-30],[12,-58],[-12,-43],[-11,13],[-13,-58],[-13,18],[-10,-12],[2,-35],[16,-40],[-22,-57],[-13,46],[-6,57],[-13,-10],[-3,-38],[-8,3],[-7,59],[-7,-62],[-9,-14],[-8,-74],[-7,19],[-6,-48],[-4,42],[-20,-51],[-5,27],[-12,-92],[-16,39],[0,36],[-10,-21],[-11,9],[2,-66],[-16,-71],[11,-33],[-35,-16],[-23,32],[-16,107],[6,29],[22,27],[-9,45],[-13,-35],[2,44],[-10,-3],[1,-68],[-5,0],[0,64],[-24,-56],[5,-35],[-6,-43],[14,-67],[-3,-45],[-23,-77],[9,-11],[-12,-31],[11,-56],[-5,-69],[-16,-10],[-3,85],[6,4],[-3,55],[-17,45],[-4,64],[15,51],[-19,40],[6,26],[-10,10],[-18,-21],[1,113],[11,44],[1,50],[-7,14],[-7,-46],[-14,-40],[-11,33],[-7,-32],[-15,-4],[14,-81],[-3,-48],[-12,-23],[-10,-71],[-4,-72],[-13,-78],[19,-30],[-13,-28],[10,-57],[-10,-38],[-27,4],[-13,-72],[-15,-1],[-2,-58],[-11,-9],[0,52],[7,37],[-9,15],[-3,-30],[-12,-13],[5,65],[-18,-9],[1,-52],[-16,-37],[-5,-50],[-12,51],[-2,-47],[-15,-32],[-12,26],[-3,-66],[-13,51],[-13,-92],[-23,-27],[-5,-19],[-5,83],[-16,5],[-15,-42],[-5,-39],[-20,4],[-7,-49],[-20,4],[-10,-49],[-3,-50],[5,-29],[-8,-32],[-13,29],[-22,-31],[-9,-46],[6,-67],[-8,-43],[-10,-15],[3,-33],[-14,-24],[-14,4],[-10,-25],[-11,-98],[5,-19],[-14,-80],[1,-22],[-14,-74],[-9,-13]],[[30332,65028],[13,-24],[29,5],[18,17],[12,70],[16,-105],[-1,-30],[-10,-16],[-33,4],[-41,60],[-3,19]],[[30177,65078],[18,0],[19,90],[27,60],[11,-15],[7,-70],[15,-27],[10,40],[-1,-84],[-41,1],[-31,-9],[-18,-47],[-16,61]],[[29500,66699],[224,-22]],[[29724,66677],[199,-23],[126,-12],[10,46],[21,1],[-1,62],[15,36],[19,-18],[9,62],[36,32],[15,-30],[8,13]],[[30181,66846],[2,-72],[9,-136],[25,-47],[12,42],[14,-34],[-16,-90],[-23,-7],[-38,-35],[12,-50],[-18,-50],[-7,9],[-5,-59],[-4,41],[-11,-53],[11,-74],[-13,10],[-5,-28],[8,-26],[-5,-27],[14,-14],[6,36],[14,8],[9,-47],[24,-28],[12,-42],[2,-46],[21,-93],[-1,-50],[-7,-39],[-12,-5],[3,-24],[21,-51],[12,8],[8,-24],[8,-83],[-5,-50],[13,-48],[23,-35],[34,-12],[9,-23],[19,44],[19,8],[27,33],[6,25],[-1,79],[-6,61],[-13,-31],[0,97],[-5,55],[-15,34],[-9,-7],[-5,-39],[-11,59],[13,11],[21,-18],[23,-58],[18,-123],[9,-119],[2,-137],[-15,-129],[-2,-44],[-7,9],[12,112],[-7,23],[-26,-5],[-43,-40],[-30,8],[-7,-28],[-17,-7],[-15,-62],[-33,-10],[-34,-66],[-16,-47],[-21,-28],[-23,-15],[6,26],[35,34],[16,47],[24,49],[5,40],[-2,117],[6,41],[-26,26],[0,-59],[-7,14],[-4,-50],[-14,3],[2,-32],[-31,-11],[-7,-49],[2,-44],[-6,-29],[-25,-23],[-12,17],[-10,-14]],[[30097,65246],[-3,189],[-18,18]],[[30076,65453],[-8,41]],[[30068,65494],[-10,48],[-19,33],[-5,56],[2,81],[-12,-6],[0,147],[-116,-13]],[[29908,65840],[-1,18],[-202,13],[-22,-4],[-42,6],[-3,-39],[-14,-6],[1,45],[-54,3],[-118,14],[-15,-1]],[[29438,65889],[-6,42],[34,395],[34,373]],[[22823,73980],[83,-1],[266,0],[229,-1],[0,449],[27,-37],[28,20],[29,-53],[8,-35],[14,-202],[7,-25],[18,-251],[-6,-69],[4,-54],[14,-43],[29,-45],[24,-12],[8,19],[44,-11],[11,-58],[61,-7],[48,-21],[8,-66],[-3,-49],[6,-12],[42,2],[5,15],[22,-2],[23,20],[-1,48],[33,46],[39,18],[9,-22],[53,0],[72,-98],[26,4],[1,-49],[-19,-7],[-4,-37],[16,-31],[41,13],[15,-54],[-6,-34],[6,-49],[24,-127],[25,27],[-8,84],[13,45],[15,-11],[42,16],[16,-44],[-2,-65],[17,-41],[14,9],[9,-36],[41,-9],[5,-67],[-4,-31],[20,-21],[23,13],[-3,-75],[22,28],[14,-22],[19,24],[34,17],[46,113],[17,13],[13,32],[25,30],[14,-13],[0,-67],[17,-17],[-6,-26],[10,-48],[16,-3],[35,29],[6,-29],[25,15],[26,-18],[19,13],[48,8],[29,-28],[9,-66],[34,-53],[15,35],[20,9],[13,-20],[23,6],[11,-18],[25,22],[-27,-56],[-10,20],[-4,-34],[-17,-15],[-26,-58],[-37,-34],[-14,-37],[-52,-44],[-48,-54],[-15,-6],[-42,-45],[-4,-14],[-51,-77],[-37,-79],[-72,-183],[-17,-69],[-55,-178],[-26,-72],[-26,-41],[-26,-88],[-11,-11],[-28,-83],[-10,-10],[-61,-134],[-9,-25],[8,-50],[14,-46]],[[24276,71309],[-21,50],[-14,-11],[-3,-29],[-16,-14],[9,-19],[-11,-43],[-22,16],[0,-685],[-10,-10],[-6,-59],[-24,7],[-10,-56],[-14,13],[-8,-38],[-25,-23],[-20,-47],[-20,-148],[-22,-49],[-7,-114],[1,-53],[21,-21],[10,9],[14,-32],[-1,-31],[23,-85],[-1,-50],[-15,-47],[1,-29],[-17,-49],[2,-91],[-4,-32],[6,-91],[-16,-58],[11,-34],[-2,-65],[6,-41],[-7,-42],[3,-75],[-12,-80],[5,-36],[16,-27],[31,-87],[-1,-24],[14,-16],[9,-44],[50,-9],[12,-17],[10,-78],[14,-38],[50,-51],[22,-39],[14,-40],[0,-53],[8,-15],[5,-84],[17,-45],[27,-41],[3,-29],[36,-90],[39,-29],[15,-55],[30,-136],[9,-75],[-8,-113],[2,-71],[10,-37],[-4,-44],[8,-53]],[[24498,67577],[-204,0],[-224,0],[-116,-1],[-223,0],[-180,1],[-313,0],[-199,0]],[[23039,67577],[0,1215],[1,101],[-1,302],[0,479],[-10,65],[-36,59],[-18,4],[-14,55],[-9,73],[-26,98],[5,46],[25,62],[22,39],[12,63],[14,46],[4,128]],[[23008,70412],[-4,106],[6,37],[-11,188],[-1,129],[-13,27],[-20,98],[-5,49],[-4,119],[-11,57],[-2,39],[5,68],[-6,112],[5,17],[6,117],[-6,-11],[-11,51],[1,171],[-5,92],[-2,114],[3,50],[-7,103],[1,217],[-5,3],[-7,89],[-11,92],[-8,17],[-11,101],[-3,58],[-11,34],[-5,121],[-16,101],[-3,110],[7,53],[-8,93],[3,52],[-1,107],[-7,59],[7,76],[9,24],[3,62],[-15,80],[-8,124],[-6,24],[-11,98],[3,40]],[[28860,63072],[14,65]],[[28874,63137],[9,32],[5,61],[12,42]],[[28900,63272],[17,44],[38,25],[25,45],[0,69],[16,25],[7,33],[34,72],[18,15],[12,51],[10,-8],[17,39],[-14,71],[-20,41],[-7,52],[-21,54],[-7,68],[-25,19],[-4,45],[2,95],[-10,37],[-17,-5],[-9,14],[-2,83],[7,30],[-8,22],[9,100],[11,-5],[23,113],[-24,120],[13,48],[18,29],[16,56],[-4,24],[17,35],[11,49],[14,124],[22,69],[16,13]],[[29101,65083],[88,-173],[132,-246],[3,-19],[-20,-187],[-12,-65],[-4,-65],[-6,-22]],[[29282,64306],[-7,-34]],[[29275,64272],[-37,-35],[-4,-84],[-9,-16],[-3,-50]],[[29222,64087],[0,-43],[19,-28],[16,18],[24,-44],[14,-9],[4,44],[4,-90],[-3,-107],[-14,-182],[-13,-247],[-5,-173],[-40,-241],[-11,-48],[-9,-9],[3,-32],[-10,-55],[-20,-63],[-1,-19],[-31,-55],[-32,-108],[-21,-118],[-22,-149],[-20,-60],[-19,-14],[-11,14],[6,88],[15,97],[3,69],[-21,37],[-18,4],[-6,25],[-18,-3],[-7,-36],[-9,24],[-2,47],[-18,37],[-3,30],[-10,-12],[-15,68],[-7,-8],[-18,58],[-10,56],[-19,25],[6,140],[-12,29]],[[28861,63044],[-1,28]],[[28814,58772],[18,-19],[12,-74],[1,-47],[-15,9],[2,45],[-18,86]],[[28734,57762],[8,60],[8,0],[47,86],[15,12],[14,33],[12,2],[16,35],[13,10],[5,74],[11,252],[0,54],[-8,95],[-6,105],[3,-2],[11,-106],[5,-95],[-3,-136],[-15,-286],[-24,-8],[-50,-64],[-43,-78],[-19,-43]],[[27156,59531],[84,-16],[55,-3],[95,-15],[37,4],[114,-21],[48,-2],[170,-2],[279,0],[74,4],[264,0],[106,-1],[0,10],[31,-2],[120,0],[142,0]],[[28775,59487],[2,-58],[17,-245],[16,-158],[23,-156],[35,-271],[-9,14],[-18,146],[-14,80],[-13,11],[-9,174],[-16,155],[-8,23],[3,39],[-5,89],[-10,30],[-4,48],[-25,13],[-1,40],[-13,-20],[6,-61],[16,-48],[11,10],[0,-67],[15,-135],[9,-61],[-1,-26],[11,-75],[0,-47],[-19,64],[1,37],[-13,61],[-3,38],[-12,12],[6,-38],[-3,-28],[14,-39],[-31,25],[-32,118],[-15,12],[19,-97],[10,-17],[6,-52],[-9,-23],[-24,-14],[-21,71],[7,-63],[10,-27],[-7,-14],[-31,45],[-13,5],[-5,29],[-18,24],[23,-73],[21,-23],[-7,-19],[-24,-8],[-13,-62],[-16,-22],[-17,1],[-8,31],[-20,12],[-12,121],[0,61],[12,78],[-5,13],[-14,-76],[-2,-76],[8,-94],[11,-77],[-5,-42],[8,-34],[40,10],[37,47],[9,-49],[13,6],[13,30],[26,24],[32,-1],[14,-41],[0,-43],[-14,-78],[3,-55],[2,-164],[9,5],[7,115],[3,150],[14,40],[-6,33],[14,20],[25,-21],[16,-94],[7,-65],[-4,-52],[7,-98],[-8,-25],[4,-54],[-13,-54],[-17,-10],[-6,18],[-10,-16],[-6,-40],[-10,-9],[-3,-43],[-7,-11],[-7,-71],[-13,-15],[-3,-46],[-17,-25],[-3,-24],[-26,25],[-29,-4],[-26,18],[-5,25],[-10,-14],[-15,45],[-13,115],[31,3],[5,45],[-28,-25],[-12,11],[-9,-33],[9,-57],[6,-86],[-7,0],[-29,47],[-14,-10],[-20,34],[-31,30],[-23,48],[-1,-29],[17,-61],[21,-5],[63,-102],[46,-28],[8,-31],[1,-40],[-7,-56],[-13,-54],[1,-28],[-9,-53],[-15,-42],[-50,-112],[-50,112],[1,-65],[24,-55],[36,-43],[36,80],[13,2],[27,30],[4,62],[11,-14],[3,-66],[8,-31],[18,-5],[-9,75],[20,-29],[2,-85],[-17,-75],[-18,-13],[0,-34],[-11,-20],[-14,-84],[-7,-71],[-17,20],[1,80],[-10,19],[1,-82],[-16,-7],[42,-64],[23,123],[33,120],[24,75],[47,176],[8,-21],[-28,-83],[-26,-96],[-22,-62],[-21,-78],[-18,-82],[-21,-115],[-3,-32],[-4,67],[-35,55],[-39,1],[-60,-38],[-29,-33],[-20,-32],[-32,-81],[-39,-75],[-26,-63],[-37,-113],[-14,-55],[-25,-128],[-14,-111],[-10,-112],[-9,-69],[-4,-69],[-13,7],[-3,34],[-21,21],[-23,9],[-28,-2],[-30,-12],[-35,-42],[-8,-17]],[[28030,56345],[-93,330],[-104,362],[-31,116],[-88,302],[-61,1],[-74,7],[-178,10],[4,135],[-42,199],[-30,-73],[-5,21],[7,48],[-2,53],[-55,13],[-105,16],[-188,29],[-23,-20],[-5,39],[-12,-52],[-7,9],[-20,-27],[-6,5],[-29,-47],[-28,-60],[-7,21],[-91,-99]],[[26419,57669],[9,275],[22,48],[3,-26],[28,4],[22,63],[-5,57],[9,25],[-4,44],[17,62],[13,15],[8,48],[16,8],[15,45],[80,7],[11,50],[22,32],[5,26],[10,-7],[16,48],[4,35],[16,4],[8,40],[21,29],[24,-18],[26,115],[-3,63],[10,30],[15,-36],[20,98],[33,70],[10,-40],[-5,-70],[15,-20],[28,62],[15,93],[15,35],[17,21],[12,-5],[9,33],[19,-12],[4,-50],[15,0],[14,28],[33,200],[21,53],[11,12],[8,-23],[17,0],[-10,74],[7,65],[6,12],[-4,80],[9,60]],[[20923,73979],[188,-1],[322,0],[212,0],[92,0],[193,1],[160,-1],[135,0],[141,1],[256,1],[201,0]],[[23008,70412],[-210,-1],[-186,1],[-119,1],[-252,4],[-192,2],[-179,2],[-253,1],[-123,0],[-292,1],[-173,0],[-105,0]],[[20924,70423],[0,2828],[-1,17],[0,711]],[[23550,60009],[0,-581]],[[23550,59428],[6,-130],[7,-206],[6,-127],[14,-355],[4,-82],[15,-387],[-2,-319],[-3,-261],[-1,-235],[-2,-170],[-2,-417],[-5,-642]],[[23587,56097],[-9,-25],[-19,73],[-16,-13],[-1,23],[-17,-1],[-18,79],[-15,-16],[-12,5],[-21,78],[-7,58],[-22,2],[-23,85],[-27,28],[-7,-68],[-11,-32],[-13,-7],[-34,4],[0,15],[-21,-7],[-7,61],[-10,3],[-24,-52],[-20,3],[1,-45],[-13,9],[-9,-31],[-29,61],[-1,-30],[-30,-29],[-15,13],[1,-20],[-14,8],[-8,-90],[-14,-14],[-19,19],[-7,-81],[-12,-3],[-1,22],[-17,79],[-21,-6],[-8,57],[-11,-4],[-16,30],[12,58],[-25,16],[-8,-86],[-18,-9],[-4,42],[-13,14],[-6,-33],[-9,25],[-6,95],[-5,11],[-14,-27],[-6,15],[3,-73],[-16,-57],[-13,19],[11,-42],[-13,-22],[3,-64],[-11,-31],[-11,14],[-12,94],[10,30],[-2,66],[-9,28],[-10,-19],[-2,-42],[-13,19],[-9,-7],[-11,-64],[-20,5],[-5,30],[1,63],[-12,19],[-16,-27],[-11,25],[3,41],[-19,42],[-9,-3],[-12,-58],[-29,-92],[-12,-9],[-16,34],[-9,3],[4,65],[-5,-1],[7,60],[-7,20],[-13,-14],[-19,11],[-10,91],[8,35],[-4,50],[-17,-47],[-20,22],[-15,0],[-19,28],[-11,-40],[-3,-44],[-20,-26],[-24,96],[-21,23],[-12,-37],[-21,4],[-13,26],[-13,3],[-17,24],[-19,46],[-16,-27],[-9,15],[-12,-11],[-2,20],[-18,-3],[-5,140],[-18,56],[4,22],[-16,5],[-18,57],[-4,-92],[-12,-4],[-22,47],[-17,2],[-6,-49],[-30,15],[-24,78],[-37,143],[-20,-19],[0,2257],[-123,0],[-179,0],[-150,0],[-175,1],[-210,0]],[[21214,59429],[1,119],[0,463]],[[27478,65805],[48,61],[45,74],[9,24],[10,60],[13,3],[3,-28],[36,72],[47,74]],[[27689,66145],[0,-314],[1,-2],[247,-1],[77,3],[167,-2],[243,1],[105,3],[111,-4],[169,-1],[107,2],[14,-59],[5,4],[8,-100],[15,4],[27,-34],[10,-49],[-8,-32],[14,-21],[2,-159],[-8,-12],[25,-113],[1,-34],[11,5],[15,-33],[-2,-18],[25,3],[3,-22],[16,8],[-1,-30],[13,-55]],[[28900,63272],[-23,37],[-22,6],[-24,-20],[-15,-34],[-20,-82]],[[28796,63179],[-217,-1],[-118,-1],[-151,0],[-236,3],[-305,-2]],[[27769,63178],[-167,0],[-124,0],[0,1068]],[[27478,64246],[0,1559]],[[20920,69320],[5,4],[0,872],[-1,227]],[[23039,67577],[-40,0],[5,-22],[-7,-37],[22,-64],[-1,-110],[-14,-5],[8,-52],[-3,-31],[24,-3],[2,-83],[9,-35],[-7,-66],[-14,-16],[5,-56],[-8,-28],[6,-21],[-12,-46],[0,-80],[-11,-16],[-3,-52],[-11,-26],[1,-76],[15,-27],[17,-60],[10,-87],[-4,-45],[13,-31]],[[23041,66402],[-17,-7],[-5,30],[-24,-5],[-7,53],[-21,66],[7,52],[-11,16],[-21,3],[-1,40],[-28,35],[-12,-17],[-8,48],[-43,13],[-5,28],[-18,20],[-1,38],[-25,25],[-15,-14],[-15,13],[-7,-23],[-18,14],[-16,-13],[-16,11],[-18,-17],[-25,9],[-20,21],[-8,-11],[-9,-74],[-12,-29],[-19,-9],[-31,69],[-36,62],[-58,85],[-9,59],[-112,0],[-186,-1],[-153,1],[-214,-1],[-206,-2],[-62,4],[-178,0],[-143,1],[-293,1]],[[20922,66996],[0,345],[-1,8],[0,1828],[-1,143]],[[23587,56097],[8,8],[0,-54],[11,-25],[9,6],[-2,-36],[10,-9],[5,27],[8,-18],[3,29],[21,-27],[11,46],[12,-17],[5,-30],[6,21],[16,-22]],[[23710,55996],[0,0]],[[23710,55996],[1,-11],[0,-608]],[[23711,55377],[0,-1196],[8,-12],[11,-72],[18,-31],[9,-83],[15,-55],[-2,-34],[8,-56],[-7,-42],[3,-45],[-7,-28],[6,-51],[9,-32],[13,-6],[3,-35],[-6,-27],[14,-36],[-1,-32],[8,-15],[3,-49],[-6,-53],[12,-47],[6,2],[6,-113],[19,12],[-6,-102],[8,-31],[2,-54],[-13,-21],[-1,-33],[12,-55],[-9,-22],[-3,-38],[4,-63],[-9,-33],[-9,-63],[-3,-73],[-12,-25],[-2,-68],[-14,-30],[-3,-40],[7,-24],[5,-91],[-13,-51],[-6,-74],[16,-52],[1,-53],[-5,-39],[9,-79],[-12,-70],[9,-19],[-11,-51],[-14,-39],[-7,-78],[-13,-74],[-17,-45],[-2,-25],[9,-30],[17,-94]],[[23768,51502],[0,-14],[-46,3],[-37,-40],[-128,-208],[-28,-61],[-10,-54],[-15,7],[22,71],[9,47],[13,-1],[9,19],[8,46],[9,-16],[11,8],[-15,55],[-54,-54],[-8,26],[17,90],[4,80],[0,74],[-12,5],[-5,23],[-17,-29],[-10,-41],[-4,-50],[-15,-24],[-6,46],[-18,-45],[-2,-35],[9,-32],[-10,-50],[10,-55],[20,-17],[-6,-54],[11,-20],[2,-78],[-2,-67],[-8,-31],[-9,10],[-19,-71],[-22,-65],[-3,26],[-13,-8],[-2,-88],[6,-26],[13,44],[26,65],[3,19],[32,99],[15,23],[0,45],[26,-15],[-20,-61],[-62,-153],[-24,-69],[-4,-25],[-32,-91],[-40,-143],[-15,-8],[-69,-146],[-35,-80],[-53,-89],[-61,-112],[-34,-87],[-13,-42],[-15,-74],[-53,-111],[-24,-68],[-47,-155],[-32,-143],[-11,-83],[-14,-59],[-33,-221],[-24,-197],[-11,-127],[-10,-192],[-2,-108],[1,-103],[8,-205],[14,-207],[12,-134],[16,-229],[11,-260],[-7,47],[-5,147],[-12,189],[-11,152],[-24,16],[18,27],[-9,83],[-6,87],[-9,88],[-3,106],[1,138],[-1,122],[11,276],[16,180],[19,148],[14,70],[10,87],[8,35],[-2,47],[13,86],[18,38],[9,45],[18,127],[28,58],[8,53],[16,2],[35,105],[23,49],[24,23],[-4,43],[9,29],[-9,16],[-16,-41],[-20,-35],[-11,-40],[-17,-5],[-6,40],[0,60],[-18,12],[-6,-31],[0,-84],[-5,-25],[6,-41],[-4,-36],[-20,-56],[-17,-61],[-8,-1],[-18,30],[-3,43],[-32,-61],[-17,-67],[21,-22],[24,57],[8,-74],[-7,-23],[-38,-223],[-12,-2],[-6,55],[-21,-10],[-4,18],[-32,-11],[-11,12],[-6,-38],[12,-32],[15,-1],[11,17],[-4,-64],[7,-48],[15,-34],[17,-18],[-19,-146],[-13,-185],[-12,-106],[-20,-27],[-7,-27],[-11,18],[14,21],[3,59],[-8,3],[-6,-31],[-29,-75],[4,-32],[24,-16],[25,38],[8,2],[-5,-116],[3,-4],[-4,-202],[-6,-207],[-4,-3],[10,-230],[8,-65],[1,-84],[9,-1],[23,-215],[5,-29],[-9,-47],[4,-34],[-1,-62],[8,-72],[20,-11],[1,-35],[12,18],[2,-127],[-23,7],[-13,-8],[0,-19],[-21,-12],[-6,-99],[-20,11],[-7,40],[-15,3],[-6,55],[-11,4],[-18,98],[-31,12],[-11,33],[-17,-9],[-7,16],[-23,-17],[-4,18],[-13,-1],[-3,-29],[-10,31],[-20,-14],[-8,22],[-6,-22],[-14,20],[-8,30],[3,25],[-16,1],[-3,44],[-15,-1],[-21,75],[-9,-11],[-25,48],[-19,-22],[-13,35],[-15,69],[-10,8],[-2,33],[-8,12],[-18,-15],[-21,47],[-12,-3],[-8,20],[-12,-19],[-9,44],[6,50],[-10,56],[-11,13],[-3,98],[-6,42],[-3,79],[-8,25],[-1,49],[-7,64],[-17,43],[2,31],[-13,26],[-7,37],[5,20],[-11,46],[-9,7],[-1,52],[6,31],[-3,66],[4,29],[-4,86],[-16,25],[1,37],[-12,11],[9,30],[5,86],[-3,31],[4,60],[-13,10],[5,76],[-12,58],[-7,-14],[-7,46],[-9,-18],[-9,39],[-10,-6],[-18,90],[-9,11],[-3,38],[-8,-9],[-10,38],[0,50],[-7,26],[3,41],[-13,48],[2,47],[-17,16],[-7,81],[-10,23],[-8,70],[-35,53],[-4,53],[-7,-2],[-13,59],[2,38],[-17,100],[3,47],[-9,39],[9,29],[-12,11],[-9,47],[4,39],[-14,28],[1,33],[-15,28],[-4,51],[2,41],[-8,26],[-4,73],[-6,1],[-9,88],[-8,1],[-6,47],[1,76],[-7,106],[-18,46],[-10,40],[3,14],[-9,71],[-23,41],[-2,30],[-17,46],[-18,25],[-13,84],[0,21],[-26,21],[-6,44],[-23,7],[3,57],[-2,65],[-5,5],[-6,-67],[-6,27],[2,53],[-17,27],[-13,108],[-8,-4],[-9,32],[-13,-25],[-7,44],[-8,-27],[-37,-13],[-19,31],[-6,-8],[-15,22],[-22,-14],[-12,24],[-17,-7],[-4,-22],[-26,21],[-11,50],[-13,-3],[-20,40],[-14,-18],[-10,-111],[-34,19],[-9,-37],[-7,11],[-22,-32],[-7,10],[-8,-54],[2,-23],[-13,-40],[0,-50],[-7,0],[-2,-59],[-11,-30],[1,-33],[-7,-58],[2,-52],[-5,-48],[-10,-5],[-3,-72],[-5,-37],[10,-22],[-5,-38],[-18,-38],[-10,8],[-7,-67],[-17,-43],[-7,-36],[-4,-84],[-14,-8],[-17,15],[-15,-11],[-14,46],[-27,24],[-27,111],[-24,33],[-10,-8],[-22,38],[-18,77],[-13,24],[-39,21],[-17,28],[-19,61],[-11,12],[-19,81],[0,24],[-14,47],[-21,7],[-12,27],[-5,34],[-30,78],[-9,43],[-7,110],[-12,56],[-7,60],[-13,63],[0,59],[-7,57],[6,72],[-3,54],[2,55],[-7,68],[-11,30],[-3,44],[-13,39],[-1,30],[-13,34],[2,33],[-13,177],[-7,40],[-12,4],[-11,91],[-15,0],[-14,66],[-12,10],[-3,24],[-15,34],[-12,-4],[-7,28],[-31,39],[0,39],[-44,118],[-13,107],[-12,37],[-18,26],[-9,33],[-9,2],[-2,36],[-24,106],[-20,35],[-4,54],[-14,32],[-21,7],[-35,78],[-11,88],[-10,24],[-6,68],[-13,89],[-9,41],[-19,38],[-11,-19],[-11,41]],[[20232,53938],[-5,28],[-16,20],[1,23],[-10,25],[-3,38],[7,18],[1,101],[331,0],[250,-1],[226,0],[183,1],[0,1212],[2,254],[0,149],[2,417],[2,232],[0,1518],[1,434],[0,809],[-1,213],[11,0]],[[20922,66996],[0,-2328]],[[19530,64667],[-136,-2],[-143,-1],[-52,-3],[-133,1],[-93,2],[0,442],[1,219],[-1,508]],[[18973,65833],[0,676],[1,163],[0,1090],[-1,26],[0,516],[-1,267],[1,140]],[[18973,68711],[-2,175],[-1,282],[1,156],[75,2],[22,-12],[85,2],[11,8],[45,-5],[25,8],[87,-2],[194,5],[11,-7],[221,0],[316,0],[14,-4],[144,-2],[178,-1],[23,7],[132,0],[251,-2],[115,-1]],[[29908,65840],[0,-107],[3,-222],[0,-150],[-3,-209],[-12,-8],[3,-76],[-8,-29]],[[29891,65039],[-7,19],[-17,2],[-21,-24],[-18,3],[-13,-24],[-16,28],[-6,-37],[-49,-35],[-3,20],[-15,0],[-27,-33],[-6,21],[-26,1],[-7,-26],[-18,23],[-40,-27],[-3,60],[-9,-17],[-19,-82],[-12,0],[-22,-73],[-13,23],[-24,-58],[-7,13],[-23,-28],[5,-22],[-10,-32],[-29,-11],[-22,-54],[-9,15],[-15,-35]],[[29390,64649],[1,33],[-20,102],[68,130],[-19,97],[4,161],[5,295],[9,422]],[[23231,64184],[167,-9],[159,-8],[156,3],[130,8],[62,0],[197,12],[152,13],[101,14],[12,-38],[1,-33],[18,-14],[-1,-36],[16,-57],[10,-2],[1,-56],[11,-31],[19,-7]],[[24442,63943],[-8,-18],[-17,-144],[-2,-71],[6,-165],[14,-99],[7,-28],[-8,-66],[5,-38],[15,-34],[4,-28],[-3,-61],[26,-77],[15,-57],[11,-14],[10,-69],[13,-8],[11,-76],[16,-54],[59,-137],[20,-90],[3,-90],[8,-78],[-9,-36],[11,-85],[3,-65],[22,-69],[11,7],[11,32],[9,66],[19,4],[27,-45],[16,-5],[38,-82],[-2,-60],[-12,-29],[-13,-59],[10,-92],[-2,-37],[-22,-96],[-6,-99],[-17,-68],[-7,-52],[-1,-78],[5,-70],[18,-50],[20,-89],[25,-37],[11,-54],[8,0],[17,-60],[16,7],[3,-27],[-12,-24],[6,-50],[20,-5],[10,31],[13,-28],[1,-29],[15,-12],[23,-70],[-2,-40],[14,-3],[9,-42],[19,-24],[0,-57],[11,-68],[-13,-8],[2,-50],[26,-161],[-4,-62],[-15,-12],[-8,-56],[17,-53],[-1,-47],[13,-87],[11,-46],[-1,-53],[24,-56],[10,27],[-15,45],[14,12],[17,-56],[8,-53],[11,14]],[[25079,59990],[9,-21],[-5,-90],[-6,-46],[-10,-9],[-1,-38],[17,-37],[-3,-28],[-16,3],[-4,-44],[11,-58],[-8,-29],[-7,-71],[-13,-18],[-18,78],[-13,-13],[-13,-142]],[[24999,59427],[-8,-40],[-13,7],[2,31]],[[24980,59425],[6,38],[-5,49],[-21,2],[-4,-30],[9,-58]],[[24965,59426],[6,-22],[-7,-64],[10,-59],[-5,-37],[-24,-1],[0,-37],[21,-39],[1,-27],[-15,-15],[-30,16],[-3,-21],[28,-74],[1,-61],[-22,-40],[-3,-75],[-12,-23]],[[24911,58847],[-179,-6],[16,110],[23,58],[0,23],[15,53],[16,28],[3,43],[9,7],[5,133],[-22,44],[3,15],[-5,71],[-349,-1],[-323,1],[-141,0],[-222,1],[-210,1]],[[23358,63503],[-31,56],[8,79],[-24,76],[-2,77],[-20,19],[1,32],[-18,26],[-12,110],[1,39],[-11,34],[-1,40],[13,42],[-11,18],[-1,-33],[-20,3],[1,63]],[[26900,61666],[18,-20],[35,40],[23,11],[5,49],[3,98],[12,28],[16,-7],[6,30],[-3,101],[-10,105],[21,52],[0,67],[14,88],[12,27],[6,37],[13,-40],[11,-1],[12,-79],[-8,-40],[11,-20],[9,22],[3,42],[9,20],[9,-25],[4,111],[-10,29],[-3,43],[19,19],[-3,96],[8,41],[10,12],[3,55],[31,-7],[3,83],[25,76],[17,-19],[6,-52],[11,3],[21,47],[17,8],[11,54],[11,8],[8,48],[16,57],[30,89],[16,9],[4,83],[10,26],[-11,50],[12,48],[0,57],[10,23],[-4,60],[13,-11],[-2,52],[7,20],[0,122],[9,30],[0,58],[10,48],[5,61],[10,23],[5,65],[-3,95],[4,71],[-9,84],[-11,44],[9,50],[14,-1],[18,27]],[[27769,63178],[-3,-600],[10,7],[33,103],[12,-1],[10,67],[31,60],[13,75],[11,-2],[28,-36],[11,54],[38,158],[13,-10],[-13,-14],[13,-18],[2,-26],[20,-34],[17,1],[7,-18],[28,-4],[14,38],[-7,49],[13,-1],[-11,32],[14,-11],[9,37],[19,-23],[28,87],[24,-20],[17,-49],[8,-40],[18,20],[17,-23],[14,4],[0,-37],[-16,-15],[12,-69],[19,-41],[-2,-33],[9,-12],[5,-43],[-6,-63],[10,-14]],[[28258,62713],[-9,-45],[-21,-175],[-78,209],[-66,179],[-4,-62],[5,-28],[-6,-36],[7,-11],[-23,-106],[6,-15],[-11,-54],[10,-36],[-16,-62],[-7,-7],[-24,-88],[6,-16],[-14,-63],[-7,21],[-15,-66],[-10,-24],[0,36],[-23,-71],[-20,-130],[-35,101],[-9,-69],[-17,-82],[-1,-71],[-8,1],[-10,-57],[-15,-138],[-28,-94],[-46,53],[-17,109],[-31,47],[-14,-121],[3,-65],[-12,-60],[-22,-87],[6,-44],[-12,-21],[-25,-81],[-7,-56],[6,-29],[-8,-30],[-6,-60],[-10,-51],[-18,-51],[-30,-104],[-21,-112],[2,-36],[-12,-39],[4,-41],[17,-34],[-12,-40],[-18,-34],[-1,-32],[13,-4],[-4,-29],[-49,-99],[-10,68],[-12,-9],[-19,-47],[-41,-71],[-4,26],[-21,38],[-7,-51],[9,-43],[-19,-47],[-17,-5],[-37,-27],[-31,-51],[-27,75],[-11,45],[-8,-21],[-8,-55],[-23,-17],[-2,-30],[-13,-29],[-34,-7],[-19,48],[0,24],[-12,25],[-18,3],[-7,52],[-14,31],[-2,90],[-15,22],[-1,33],[18,34],[-11,29]],[[27075,60636],[-14,-4],[-28,30],[-3,37],[-8,1],[-7,40],[-9,-2],[-7,42],[-15,11],[-13,134],[-10,19],[-13,61],[1,34],[-15,19],[-8,39],[11,55],[-15,22],[-9,80],[-10,45],[-15,37],[0,38],[8,0],[3,55],[-4,20],[11,33],[1,58],[-8,36],[1,90]],[[24442,63943],[12,16],[-2,50],[4,90],[-11,35],[13,69],[31,43],[18,-1],[18,41],[1,61],[6,49],[1,67],[10,27],[14,66],[11,19],[6,106],[-1,98],[-13,75],[-13,6],[-20,85],[11,77],[2,74],[6,55],[19,21],[13,-15],[23,40],[31,-6],[24,17],[16,56],[10,13],[26,-1],[18,57],[16,21],[-1,66],[9,59],[0,52],[9,29],[28,49],[-1,41],[8,72],[-3,58],[7,61],[-7,37],[1,89],[-13,41],[-47,73],[-15,74],[3,60],[-16,63],[-22,37],[-2,26],[-22,35],[0,47]],[[24658,66423],[45,-2],[227,-2],[51,-5],[194,-11],[41,4],[152,1],[82,-5]],[[25450,66403],[-2,-124],[-8,-97],[10,-109],[21,-117],[12,-37],[3,-54],[13,-139],[4,-75],[14,-93],[8,-20],[2,-47]],[[25386,60941],[-8,-66],[-17,-35],[-11,-56],[7,-105],[20,-68],[-6,-50],[-48,-19],[-12,-11],[-18,-52],[-14,26],[-18,-44],[-2,-55],[-9,-65],[2,-25],[17,-65],[7,-66],[-10,-89],[-15,-10],[-13,13],[-19,52],[-35,40],[-14,39],[-31,42],[-19,5],[-13,-21],[-13,-42],[-9,-65],[-16,-52],[-4,-55],[14,-52]],[[20232,53938],[-214,0],[-254,0],[0,-524],[-234,-1]],[[24911,58847],[4,-38],[18,-49],[0,-45],[-24,23],[-9,-49],[20,-36],[-11,-33],[-11,-1],[-9,-52],[-17,-22],[-9,21],[-15,-41],[6,-68],[9,-17],[12,23],[3,-38],[-26,-42],[1,-53],[9,-10],[-3,-40],[-22,56],[-9,-9],[-5,-58],[9,-42],[-11,-75],[-8,88],[-23,-67],[-3,-46],[12,-6],[2,43],[15,-35],[-9,-47],[0,-45],[-16,-10],[4,-47],[15,-7],[6,-29],[-12,-43],[15,-58],[-10,-25],[-12,21],[-9,-26],[-9,-100],[-25,13],[-3,-49]],[[24751,57677],[17,-55],[0,-45],[-18,-44],[-31,-44],[-4,59],[-11,2],[-2,-29],[8,-44],[-5,-25],[6,-72],[-14,-19],[-5,34],[2,57],[-10,-27],[2,-35],[-7,-14],[6,-40],[20,-2],[2,-31],[-14,-50],[-11,18],[1,49],[-10,-21],[0,-64],[12,-61],[1,-27],[-13,-51],[6,-83],[-25,-57],[0,-63],[-10,1],[3,54],[-19,-1],[-5,-27],[8,-45],[-7,-30],[-19,-15],[-4,-71],[-16,43],[-9,-29],[14,-43],[20,1],[2,-25],[-13,-28],[-16,33],[-12,-32],[9,-51],[11,3],[3,-24],[-8,-61],[-24,-6],[7,-45],[-11,-16],[-5,43],[-16,-23],[-3,-29],[22,-34],[-18,-78],[7,-55],[16,-26],[-10,-34],[-8,18],[-24,-2],[-1,-59],[10,-26],[13,14],[8,-50],[-12,-18],[-16,22],[-7,35],[-17,-16],[-2,-28],[25,-51],[2,-33],[-28,-41],[13,-63],[-14,-80],[18,16],[-1,51],[14,-27],[-4,-54],[-17,-10],[-3,-19],[10,-24],[17,14],[10,73],[5,-32],[-23,-90],[0,-64],[12,-68],[3,42],[10,13],[2,-23],[-13,-52],[2,-75],[-3,-23],[-14,-8],[-11,14],[-5,-39],[23,-62],[-13,-59]],[[24512,55359],[-219,4],[-154,5],[-157,7],[-86,0],[-185,2]],[[16868,55911],[16,-5],[28,-53],[21,-22],[1,-25],[16,-61],[-5,-43],[-13,25],[-26,7],[-6,35],[0,74],[-20,16],[-12,52]],[[16867,55390],[9,4],[22,-117],[40,-130],[-10,4],[-11,-22],[-17,44],[-13,72],[-14,119],[-6,26]],[[16741,55926],[8,7],[1,-41],[-11,7],[2,27]],[[16637,56552],[8,-17],[11,14],[0,-30],[-17,-4],[-9,21],[7,16]],[[16596,55679],[14,7],[20,-35],[8,-31],[-13,-15],[-20,21],[-9,53]],[[16501,56608],[18,-7],[13,-22],[15,5],[19,-43],[19,-4],[7,39],[20,-20],[-11,-43],[-28,-11],[-17,-31],[-42,24],[-1,61],[-12,52]],[[16410,56520],[22,8],[9,21],[13,-8],[13,19],[0,-48],[18,-13],[1,-48],[-41,-54],[-16,37],[-19,86]],[[16354,56562],[16,17],[6,28],[6,-35],[13,-26],[-21,-6],[-20,22]],[[15305,65829],[155,-4],[9,6],[77,-1],[56,12],[28,-8],[115,2],[37,5],[95,-1],[45,-5],[154,-8],[114,-4],[197,0],[92,2]],[[16479,65825],[0,-1]],[[16479,65824],[0,-1448],[1,-34],[0,-756],[-1,-393],[-1,-13],[0,-457],[-1,-122],[2,-263],[26,-77],[115,-330],[114,-336],[63,-182],[99,-298],[125,-377],[62,-186],[127,-394],[313,-989],[234,-759],[70,-234],[147,-492]],[[17950,55027],[-416,-126],[-254,-89],[-3,98],[-9,62],[-8,20],[-14,-23],[-3,66],[1,71],[-8,41],[9,61],[-9,161],[-13,127],[-9,54],[-40,193],[-25,61],[-10,51],[-15,37],[-9,-2],[-19,95],[-26,59],[-14,15],[-20,57],[-25,88],[-24,39],[-2,-47],[-21,-23],[-18,14],[-10,25],[-15,6],[-4,38],[9,34],[1,43],[-14,116],[-11,64],[-17,50],[-35,1],[-22,-8],[-16,-36],[-14,38],[-28,16],[-37,59],[-12,2],[-24,53],[-17,141],[-10,10],[-17,53],[-4,-3],[-20,65],[-21,25],[-6,20],[-32,4],[-16,-24],[-18,25],[-22,-10],[-37,60],[-23,0],[-15,15],[-44,-7],[-48,-22],[-1,31],[-13,66],[-16,30],[-12,-4],[-6,32],[13,143],[-11,60],[8,119],[-17,54],[9,115],[1,140],[-18,56],[-14,7],[-3,-21],[-27,55],[-11,48],[10,131],[-2,50],[-11,53],[-27,14],[-27,102],[-18,101],[-24,25],[-17,66],[-5,81],[-16,47],[-7,37],[-14,35],[-6,99],[-5,35],[-20,29],[-15,104],[-25,94],[-33,64],[-11,45],[-8,80],[1,42],[-11,101],[2,92],[-11,16],[10,74],[18,-38],[9,30],[7,61],[8,141],[-21,149],[-12,43],[-10,11],[-9,-28],[-37,2],[-28,68],[-22,102],[-14,18],[-2,31],[-17,60],[-4,62],[5,129],[-12,89],[-2,52],[-12,14],[-6,33],[-1,64],[5,27],[2,77],[-6,134],[14,28],[16,8],[6,-24],[7,-88],[-9,-9],[11,-107],[-2,-27],[27,-23],[27,-80],[8,5],[14,-63],[12,3],[-6,40],[-12,19],[-10,87],[-7,109],[-21,54],[-2,46],[-22,26],[9,74],[-7,68],[-15,-1],[-14,68],[8,-9],[9,26],[0,40],[19,-2],[10,39],[-10,71],[-26,44],[-13,-30],[-14,-6],[2,-47],[-5,-46],[15,-51],[-12,-25],[-4,-44],[19,-56],[-7,-14],[-11,29],[7,-71],[-15,-16],[-9,38],[-26,61],[-13,-12],[-23,67],[-10,53],[-17,33],[-16,8],[-20,-33],[14,127],[3,48],[-12,92],[7,20],[-16,70],[-11,-10],[-1,67],[-17,106],[-20,51],[-14,19],[-22,64],[-37,176],[-14,29],[-8,41],[-31,90],[-24,116],[14,78],[-1,42],[-14,126],[-16,123],[-7,105],[3,99],[13,132],[-5,52],[0,65],[-14,92],[-4,108],[-16,36],[-6,55],[-35,133],[-7,6],[0,43],[-8,43],[-22,32],[-49,151],[4,63],[-4,70],[-13,74],[9,98],[14,109],[42,265],[11,95],[7,119],[-12,37],[-1,97],[4,2],[11,99],[12,244],[-5,126],[-15,128],[-8,96],[-9,-4],[-17,54],[10,74],[5,110],[-3,67]],[[28861,63044],[-1,28]],[[28874,63137],[-6,7],[-22,-81],[2,-39],[11,-31],[1,-49],[-8,-28],[0,-41],[14,-52],[7,-58],[21,-62],[10,-68],[3,-58],[-5,-35],[2,-126],[16,-48],[7,-43],[2,-74],[34,-137],[16,-29],[10,24],[4,-36],[5,-129],[4,-244]],[[29002,61700],[-105,1],[-74,9],[-2,72],[-25,1311],[0,86]],[[28426,62262],[21,70],[37,-118],[-36,-118]],[[28448,62096],[0,93],[-22,73]],[[6433,39922],[2,44],[19,76],[12,7],[13,93],[16,52],[3,58],[-17,94],[-4,45],[-1,105],[8,37],[18,-9],[18,-32],[3,-32],[22,-44],[15,-47],[12,6],[25,-32],[39,-77],[13,-19],[22,-61],[16,-57],[17,-76],[-3,-47],[1,-90],[8,-10],[16,12],[7,-57],[-1,-57],[22,-82],[22,-39],[5,-21],[-4,-44],[-13,-51],[-17,-47],[-14,-56],[-23,-38],[-20,-47],[-20,-18],[-16,15],[-9,-9],[-18,-66],[-16,-25],[-13,-48],[-14,-16],[-12,-59],[1,-33],[-8,-37],[-5,-59],[-20,-63],[-15,61],[-22,52],[-22,29],[-10,95],[5,113],[4,151],[-10,106],[1,46],[-9,12],[-5,114],[-7,66],[-9,8],[-8,108]],[[6254,41293],[5,69],[11,56],[14,6],[13,-33],[10,-78],[10,-50],[24,29],[18,35],[26,-21],[0,-16],[17,-51],[10,-15],[5,-40],[31,-37],[5,-32],[0,-52],[-8,-43],[-13,-40],[-6,3],[-17,-36],[-14,10],[-30,-53],[-21,-9],[-17,26],[-7,210],[-7,20],[-14,-24],[-26,50],[-13,58],[-6,58]],[[6253,40841],[7,29],[28,57],[10,-30],[-4,-44],[5,-17],[-13,-19],[-5,15],[-18,-23],[-10,32]],[[6153,41274],[7,27],[13,5],[26,-19],[17,-60],[8,-51],[-9,-65],[-19,-29],[-17,-5],[-7,60],[-3,73],[-14,32],[-2,32]],[[6084,41504],[6,52],[9,29],[-2,58],[17,-2],[3,-14],[54,-29],[10,34],[4,-42],[22,-13],[27,18],[17,-25],[-8,-55],[-18,-51],[-20,-21],[-35,32],[-26,31],[-15,-14],[-29,-5],[-16,17]],[[5814,42059],[43,9],[13,49],[4,35],[13,48],[14,15],[6,-27],[6,-70],[20,-84],[4,-52],[-4,-15],[3,-47],[18,-55],[3,57],[12,-2],[-4,-64],[8,-24],[-1,-29],[17,-70],[-12,-37],[-11,18],[-21,-29],[-6,26],[-17,31],[-25,11],[-30,-20],[-7,4],[-7,84],[-11,34],[-1,31],[-14,67],[0,61],[-13,45]],[[5394,42585],[1,40],[11,38],[4,49],[33,72],[8,26],[23,-18],[3,25],[16,-11],[8,14],[15,-20],[10,-37],[5,-45],[0,-46],[-11,-63],[1,-106],[-4,-28],[-28,-78],[-8,15],[-36,12],[-18,71],[-24,29],[-9,61]],[[5266,42374],[4,43],[12,44],[19,45],[2,38],[11,9],[2,-31],[-5,-57],[2,-36],[-20,-28],[-16,-97],[-12,30],[1,40]],[[24498,67577],[-5,-52],[10,-50],[-1,-74],[27,-41],[13,-76],[-18,-60],[-6,-52],[-9,-24],[1,-108],[8,-88],[0,-68],[12,-25],[13,-169],[33,-64],[47,-37],[17,-20],[18,-109],[0,-37]],[[23231,64184],[4,28],[-10,56],[-13,16],[-15,58],[2,37],[13,35],[-4,83],[10,51],[-7,27],[2,66],[-9,20],[1,42],[-7,30],[5,27],[-5,93],[12,17],[-24,24],[4,37],[-5,63],[13,41],[-20,27],[7,29],[-1,116],[-20,10],[2,77],[-9,1],[-2,-37],[-15,28],[3,56],[-11,39],[7,39],[-8,41],[11,18],[-6,54],[8,20],[3,46],[-12,23],[-1,38],[-14,61],[6,11],[3,66],[-16,6],[1,30],[-15,11],[5,16],[-15,25],[1,83],[-22,56],[-3,48],[10,25],[-14,103],[-11,29],[0,76],[9,44],[-4,44],[-14,8]],[[26280,62461],[18,48],[7,-2],[15,-54],[21,-28],[14,29],[14,-3],[8,29],[8,-8],[4,-69],[29,-32],[10,-84],[16,-83],[0,-66],[5,-26],[40,-41],[33,19],[29,-46],[3,-34],[15,-26],[5,-50],[28,-29],[14,66],[26,22],[15,-32],[28,-20],[11,-24],[5,-43],[13,24],[30,-1],[10,53],[18,34],[9,39],[15,0],[21,32],[7,-33],[-3,-44],[9,-111],[13,-37],[21,-6],[21,-79],[13,-35],[2,-44]],[[27075,60636],[-108,-317],[-37,-39],[-22,-41],[-19,-49],[-25,-45],[0,-86],[-16,-39],[-12,-2],[-12,-33],[3,-59],[-6,-45],[-25,-36],[-29,-4],[-16,-80],[-2,-50],[-16,-4],[-33,-35],[-39,-52],[-21,2],[-33,-49],[-8,-27]],[[26599,59546],[-4,-21],[-83,8],[-79,2],[-76,5],[-83,11],[-51,16],[-74,9],[-55,-14],[-96,8],[-56,10],[-83,22],[-49,4],[-16,-22],[-7,22],[-146,-12],[-92,-2],[-114,-8],[1,35],[-61,17],[10,-147],[-6,-64],[-137,6],[-126,0],[-84,6],[-33,-10]],[[24980,59425],[-15,1]],[[28739,61120],[-14,0]],[[28725,61120],[-1,72],[8,28],[11,-40],[-4,-60]],[[28711,61320],[2,79],[11,13],[7,-30],[5,-118],[-15,21],[4,27],[-14,8]],[[28627,62072],[5,20],[5,-46],[-10,26]],[[29002,61700],[-1,-43],[-9,-105],[-5,-15],[-20,-211],[-18,-120]],[[28949,61206],[-107,-38],[-6,-55],[-6,4]],[[28830,61117],[-13,30],[-19,-4],[-22,-64],[-9,-1],[-1,67],[7,70],[17,28],[-17,2],[2,45],[11,40],[-21,9],[-12,-33],[-4,28],[5,58],[26,27],[-6,39],[-9,-13],[-4,36],[15,112],[-15,-24],[-7,-47],[0,-60],[-8,-1],[-11,77],[11,9],[-1,53],[-8,10],[-4,-49],[-9,-33],[6,-27],[-9,-62],[-4,29],[-17,-23],[-9,12],[-16,83],[-9,13],[2,43],[-24,151],[20,14],[5,39],[-8,-7],[-9,51],[8,40],[12,22],[6,-25],[12,26],[1,-36],[22,-9],[13,-39],[4,10],[-16,69],[-17,14],[-8,42],[-7,-3],[-16,77],[-5,-28],[-12,20],[-1,-59],[-7,8],[3,101],[18,92],[14,-45],[8,10],[-3,124],[-8,17],[-17,-47],[-12,4],[1,-48],[-12,-17],[4,104],[16,101],[7,-51],[21,-11],[11,31],[-6,54],[11,55],[-16,-9],[-3,-52],[4,-31],[-12,17],[3,63],[-6,59],[-7,14],[16,136],[12,42],[-2,24],[14,25],[7,37],[30,-6],[-11,24],[18,70],[-10,6],[12,122],[-35,-24],[-6,-48],[12,-24],[4,-32],[-12,-14],[-34,-97],[-7,31],[7,54],[-8,28],[0,-44],[-9,-51],[8,-34],[-7,-46],[-6,96],[-15,14],[6,-103],[-8,8],[-6,-42],[12,-22],[-21,-44],[-7,-28],[-13,8],[-2,26],[-22,46],[3,-46],[9,-13],[2,-41],[27,-54],[2,-67],[-5,-25],[13,-48],[-23,-45],[7,-37],[-3,-40],[-9,4],[-7,-55],[6,-53],[-17,-58],[9,-50],[-2,-54],[6,-73],[-2,-89],[7,-65],[22,-80],[8,-62],[-9,-45],[-14,7],[9,-42],[9,22],[8,-14],[-7,-47],[4,-48],[18,-92],[-5,-22],[5,-97],[-9,19],[-11,58],[-8,4],[-5,64],[-8,-9],[-2,-57],[-7,38],[-8,-3],[-5,48],[-12,45],[-23,23],[-35,3],[-8,129],[-8,13],[-4,-31],[10,-68],[-2,-22],[-22,43],[-2,34],[-13,31],[-12,114],[-20,-44],[-33,-56],[-12,27],[-7,115],[11,82],[15,57],[20,30],[-5,10]],[[28423,61914],[-1,45],[7,27],[18,25],[1,85]],[[28426,62262],[-9,37],[-20,6],[-8,17],[1,48],[-26,42],[-34,15],[-6,39],[-10,13],[1,58],[9,18],[7,49],[-23,43],[-6,45],[-15,-1],[-16,25],[-13,-3]],[[26327,70327],[8,17],[9,-60],[65,-63],[-17,-58],[-23,18],[-14,61],[-28,85]],[[26120,70229],[5,40],[7,-20],[-12,-20]],[[26084,70289],[21,-39],[-4,-36],[-19,38],[2,37]],[[26055,70019],[7,48],[3,69],[6,15],[1,57],[18,-7],[-1,-85],[4,-83],[-19,-44],[-19,30]],[[26035,70180],[13,8],[-5,-54],[-7,1],[-1,45]],[[25984,69839],[13,-17],[1,-59],[-14,76]],[[25933,69486],[6,23],[19,-25],[-6,-96],[-17,52],[-2,46]],[[25908,69335],[11,44],[6,-47],[-17,3]],[[25759,70041],[20,-64],[-8,-22],[-4,36],[-14,43],[6,7]],[[25722,65552],[30,68],[27,87],[37,261],[34,146],[19,134],[10,99],[10,176],[-1,58],[6,87],[-1,163],[-6,182],[-11,120],[-35,230],[-11,94],[-12,138],[-17,119],[0,48],[22,102],[7,50],[1,77],[-9,134],[-14,90],[4,32],[20,51],[24,151],[21,112],[4,124],[9,134],[-11,112],[1,33],[27,43],[20,15],[6,93],[-2,74],[10,36],[13,-18],[16,80],[18,-35],[17,13],[8,32],[9,86],[10,16],[15,94],[11,47],[9,-7],[12,35],[3,-39],[-19,-32],[-3,-42],[12,-81],[-23,-81],[13,19],[0,-74],[-6,-7],[-8,-84],[7,-95],[8,-2],[19,145],[3,98],[13,20],[-8,-158],[-15,-44],[-6,-67],[14,-14],[8,65],[7,13],[22,135],[5,78],[-1,56],[4,82],[-6,85],[5,94],[17,49],[10,3],[18,48],[18,16],[25,-7],[26,14],[12,20],[-1,33],[-33,17],[-14,47],[-8,114],[16,75],[13,14],[20,69],[-2,31],[-18,27],[60,-15],[7,49],[61,-102],[26,-58],[13,20],[11,-16],[13,10],[32,-34],[24,-85],[3,-57],[17,-27],[33,4],[8,-9],[29,-77],[23,-7],[34,-71],[29,6],[21,-78],[11,-25],[-9,-27],[15,-96],[11,-30],[14,-133],[-20,21],[-16,34],[-15,-41],[4,-110],[12,-44],[21,-26],[5,-59],[1,-98],[7,-37],[-4,-71],[-8,-67],[2,-65],[-5,-111],[-1,-121],[-12,-15],[-14,-64],[-24,2],[-8,-30],[-8,-108],[-4,-115],[-19,-5],[-8,-19],[0,-49],[-42,-6],[-13,-35],[-9,-76],[-5,-124],[-8,-42],[13,-91],[16,-32],[9,33],[5,-38],[20,-21],[13,-38],[10,16],[28,120],[14,0],[7,25],[-7,51],[9,44],[9,87],[4,-50],[19,31],[5,29],[-21,31],[24,-3],[11,24],[5,41],[23,10],[34,28],[9,45],[31,30],[11,-30],[23,-25],[15,-39],[17,-123],[10,-37],[7,-97],[5,-208],[17,-178],[4,-247],[10,-143],[18,-110],[2,-48],[-11,-46],[-7,-145],[4,-47],[-12,-113],[-4,-67],[-18,-66],[-15,4],[-12,-42],[1,66],[-9,27],[10,16],[15,62],[-14,26],[-15,-5],[-19,-34],[-7,-32],[9,-27],[2,-45],[-15,4],[-11,-52],[1,-84],[-7,-77],[-17,-53],[-30,-25],[-18,-97],[2,-127],[-3,-44],[-15,-25],[-1,-70],[-16,-39],[-6,-39],[-13,-4],[-7,-65],[-11,-11],[-17,-72],[5,-79],[-8,-9]],[[26661,65520],[-86,-11],[-167,-20],[-124,-12]],[[25045,72671],[21,69],[95,141],[7,-2],[43,98],[31,42],[6,-11],[28,29],[-1,-28],[-12,-16],[-30,-80],[0,-30],[-25,-55],[-51,-53],[-42,-66],[2,-20],[23,0],[-59,-73],[-18,3],[-18,52]],[[24721,71146],[19,40],[12,3],[39,49],[38,34],[31,77],[19,64],[16,27],[33,17],[15,-17],[29,27],[22,-3],[52,75],[30,94],[22,5],[29,23],[10,39],[5,51],[25,65],[14,16],[30,82],[23,23],[21,56],[11,54],[20,52],[58,85],[56,25],[50,-7],[23,-39],[1,-45],[-11,5],[-17,-24],[-19,13],[-21,-10],[5,-47],[-32,-57],[-30,-95],[-19,-20],[-5,-74],[-7,9],[-7,-52],[-14,-26],[-5,-67],[-12,-48],[-9,-6],[-12,-164],[6,-52],[-9,-35],[11,3],[20,87],[3,44],[7,-13],[29,80],[28,43],[-12,-55],[-12,-24],[-15,-77],[30,84],[26,18],[14,-13],[37,1],[15,-30],[8,8],[17,-35],[8,-39],[15,11],[22,-63],[3,-61],[17,-49],[6,-47],[14,-49],[19,-15],[-2,-79],[11,-28],[26,-15],[42,10],[25,43],[11,-8],[14,-72],[12,-27],[19,-4],[8,46],[16,-7],[9,-38],[4,69],[-7,53],[16,20],[7,-32],[-6,-56],[17,-26],[26,72],[40,62],[59,110],[11,-21],[61,42],[46,-16],[35,-3],[30,7],[62,85],[24,12],[30,-7],[32,14],[-22,-84],[-2,-135],[2,-45],[-8,-19],[9,-51],[16,-8],[9,16],[6,-26],[15,3],[17,-28],[34,49],[13,-4],[11,-46],[-1,-35],[25,28],[7,-7],[10,65],[19,24],[23,-19],[11,9],[8,39],[27,-5],[5,-30],[-10,-100],[7,-120],[1,-95],[-29,-2],[-8,-65],[15,-12],[5,21],[15,-4],[8,-38],[19,-19],[-13,-40],[24,-75],[12,-1],[20,-45],[8,38],[14,-35],[8,26],[-16,100],[14,-15],[41,13],[12,-15],[14,-91],[16,-31],[-10,-64],[-14,-20],[-27,39],[-31,-16],[-31,42],[-11,-12],[-27,1],[-27,23],[-60,-26],[-13,-28],[-37,69],[-15,48],[-13,-7],[-13,30],[-10,-41],[2,-51],[-15,-32],[1,-45],[9,-63],[-12,-20],[-24,42],[-3,31],[-21,37],[-5,30],[-22,64],[-38,46],[-13,-7],[-33,49],[-18,-5],[-13,23],[-5,-20],[-19,11],[-25,-75],[-17,-73],[-9,-8],[-32,23],[-23,-15],[-8,-22],[2,-34],[-23,37],[-21,17],[-24,-14],[-10,11],[-23,-24],[-13,-42],[-2,-63],[-9,-72],[-14,4],[-7,-39],[-22,-15],[-6,-46],[-13,-3],[0,-45],[-12,-9],[4,-61],[-20,32],[-9,40],[12,27],[1,34],[11,31],[1,40],[13,-4],[15,87],[-3,43],[-12,10],[-18,-75],[-38,24],[3,-51],[-13,-47],[-5,-56],[-30,-31],[-5,-27],[-6,39],[3,55],[-4,67],[-8,32],[-10,-19],[-5,-120],[3,-12],[-31,-55],[-26,-129],[-17,-146],[-19,-65],[-20,-112],[-41,-174],[6,-33]],[[25508,69434],[-19,14],[-8,47],[-13,28],[-2,29],[15,118],[11,48],[-2,34],[-11,25],[-16,-47],[-27,-10]],[[25436,69720],[0,0]],[[25436,69720],[-7,47],[7,24],[-3,38],[13,34],[6,40],[-3,47],[8,69],[-14,75],[12,13],[-8,44],[-13,18],[-6,33],[-24,4],[-9,43],[-21,-18],[-18,45],[17,52],[-7,21],[0,47],[-40,48],[-14,-14],[-24,47],[-12,-15],[-21,21],[-2,25],[-27,-2],[-3,-32],[-14,0],[-4,29],[-17,16],[-12,-13],[-86,142],[-287,231],[1,27],[-28,167],[-27,16],[-10,24]],[[24739,71113],[0,0]],[[24739,71113],[-12,-6],[-6,39]],[[25252,52115],[30,-13],[-14,-20],[-12,9],[-4,24]],[[25179,52148],[16,13],[30,-29],[6,-15],[-24,5],[-28,26]],[[25119,52114],[15,7],[15,31],[-4,-29],[-21,-27],[-5,18]],[[25071,52140],[21,-1],[8,13],[-5,-43],[-10,-7],[-17,26],[3,12]],[[24751,57677],[229,-2],[156,1],[202,1]],[[25284,52292],[-4,-32],[-7,15],[-10,-40],[-18,27],[-13,-15],[-5,30],[-18,7],[-18,-23],[-23,49],[-2,-28],[-21,38],[-22,-3],[-31,-27],[-28,-42],[-30,-33],[4,54],[-10,30],[-14,-27],[9,-17],[1,-40],[-25,-57],[-8,-80],[-9,10],[-13,-16]],[[24969,52072],[-12,0],[-13,50],[-4,66],[0,69],[-15,77],[0,54],[-10,43],[-11,19],[-4,39],[-10,34],[-4,95],[-8,14],[10,88],[-4,36],[7,25],[9,125],[7,19],[-1,45],[7,22],[-7,36],[-165,-2],[-134,-1],[-226,0],[13,21],[7,58],[-16,50],[-1,28],[10,46],[-3,41],[-12,30],[1,38],[18,-7],[17,20],[2,43],[-12,37],[-1,45],[-7,16],[9,39],[4,-50],[8,-29],[9,7],[0,29],[-13,75],[-1,74],[20,18],[12,35],[-4,32],[-18,-13],[-9,30],[5,38],[10,-28],[18,0],[1,106],[11,35],[23,5],[4,18],[-29,11],[7,94],[12,11],[2,-43],[7,-17],[5,28],[-6,21],[24,78],[-2,50],[7,25],[19,14],[0,50],[-19,26],[5,25],[13,-39],[5,36],[12,22],[9,69],[-15,24],[2,-62],[-32,11],[2,79],[27,20],[7,27],[14,-31],[5,42],[-2,53],[12,-8],[16,79],[-4,18],[-6,-40],[-23,17],[0,58],[8,20],[-8,35],[-10,-20],[-23,49],[3,58],[5,1],[17,-48],[10,7],[-5,26],[-21,50],[14,31],[8,37],[-7,37],[-6,-46],[-20,-26],[-6,14],[-3,52],[9,38],[16,33],[2,27],[-31,30],[1,71],[5,37],[21,52],[2,39],[-9,72],[-11,-4],[1,-67],[-14,-26],[-9,22],[3,48],[10,50]],[[17580,73980],[234,-2],[232,3],[190,-5],[190,2],[348,-2],[211,0],[232,2],[328,0],[141,0],[292,0],[227,1],[143,-1],[294,0],[114,0],[167,1]],[[18973,68711],[-21,23],[-6,49],[-24,59],[2,43],[-28,117],[-17,36],[-8,-52],[-20,-3],[5,-33],[-16,-98],[15,-64],[-32,26],[-9,-16],[-24,13],[-3,-19],[-30,-40],[-13,63],[-22,-8],[-13,-25],[-10,13],[-21,-30],[-8,22],[-14,-8],[-12,35],[-16,7],[-9,-35],[-9,0],[-2,-61],[-8,-45],[-24,38],[-8,-20],[-11,24],[-33,2],[-17,22],[-17,-23],[-15,-72],[6,-53],[-9,-22],[-11,44],[-18,24],[-15,40],[-6,53],[5,34],[-21,81],[9,48],[-5,50],[-18,109],[-32,58],[-26,-44],[-4,40],[-28,53],[-11,97],[14,13],[2,55],[-4,61],[-19,39],[2,26],[-17,15],[-7,73],[-24,73],[-1,35],[-14,54],[2,70],[-8,19],[-6,57],[6,30],[-1,46],[-19,0],[7,95],[-15,25],[-12,-2],[2,26],[-10,44],[-15,26],[-9,-13],[2,-41],[-15,-35],[-19,-82],[-19,-26],[-13,12],[-3,-58],[-24,-42],[-5,36],[-14,22],[-13,60],[-25,0],[4,53],[-8,36],[18,37],[1,48],[-19,74],[18,89],[25,1],[7,44],[-13,54],[6,49],[-19,27],[-4,54],[9,58],[-17,33],[2,49],[19,7],[-1,79],[-6,30],[13,24],[1,116],[13,65],[-7,69],[12,3],[10,123],[-3,58],[-8,10],[-26,-23],[-4,-21],[-22,15],[-19,-5],[-8,39],[6,39],[-7,30],[-14,9],[-4,-30],[-15,-21],[-6,17],[6,55],[-34,58],[-16,59],[4,71],[-20,60],[-13,-1],[-6,60],[-19,82],[-17,54],[-12,13],[-5,37],[-11,7],[2,38],[-9,41],[-24,10],[-32,45],[-7,54],[-47,87],[-11,-2],[12,36],[22,8],[3,22],[-16,7],[-5,57],[-11,5],[2,34],[13,32],[-12,55],[2,63],[-13,24],[-7,47],[-8,-6],[-8,88],[-15,21],[-39,152],[-1,279],[1,109],[0,804]],[[29991,69339],[3,68],[18,64],[-3,15],[11,74],[-13,36],[18,11],[4,26],[22,42],[15,-61],[28,-5],[13,70]],[[30213,67064],[-30,-174],[-2,-44]],[[29724,66677],[-9,53],[-6,-10],[-12,102],[9,73],[1,57],[13,10],[8,45],[-6,52],[9,33],[-5,65],[4,138],[12,64],[-6,60],[10,135],[-5,35],[5,74],[15,33],[6,109],[9,44],[19,43],[6,44],[-1,64],[19,67],[0,85],[12,44],[12,69],[0,47],[-10,68],[6,57],[-6,34],[10,61],[35,32],[10,-13],[16,21],[5,52],[24,14],[14,39],[7,45],[16,22],[-6,59],[11,13],[2,73],[-10,38],[-11,102],[15,52],[4,64],[18,75],[-13,89],[11,30]],[[29842,64964],[3,18],[27,22],[-21,-43],[-9,3]],[[29812,64781],[5,20],[11,-16],[0,-50],[-6,35],[-10,11]],[[29792,64880],[16,16],[-12,-43],[-4,27]],[[29275,64272],[5,-67],[-9,-39],[-38,-78],[-11,-1]],[[28633,68013],[16,50],[-5,-45],[-11,-5]],[[28611,68032],[12,40],[9,-5],[-21,-35]],[[27689,66145],[33,53],[53,111],[29,91],[30,50],[26,25],[11,70],[13,36],[4,52],[36,56],[19,54],[-4,80],[-13,40],[2,43],[-7,37],[-23,35],[1,92],[-18,15],[9,77],[-5,125],[-3,13],[28,22],[38,42],[56,47],[40,20],[33,2],[38,-9],[36,8],[86,-42],[23,-19],[15,-47],[23,-46],[12,-10],[40,49],[35,1],[43,12],[21,-19],[23,-1],[14,25],[30,20],[18,40],[9,1],[19,80],[30,64],[10,8],[19,54],[14,5],[20,-15],[17,19],[9,53],[2,87],[-9,180],[-20,40],[11,50],[14,11],[2,-33],[21,41],[-3,43],[-19,47],[-22,-15],[5,29],[-15,51],[-15,1],[1,80],[16,115],[19,5],[23,42],[0,48],[18,22],[27,55],[9,-5],[16,29],[25,75],[4,46],[12,51],[41,121],[31,100],[56,141],[-1,12],[68,109],[26,62],[18,0],[22,37],[27,-29],[19,10],[91,-8],[53,-1],[107,14],[24,-1],[93,10]],[[29478,69336],[1,-109],[-7,-30],[-4,-63],[13,-57],[-10,-55],[-2,-92],[-4,-31],[4,-70],[19,-88],[4,-69],[-12,-80],[7,-114],[-4,-36],[-19,-63],[-5,-89],[-8,-79],[9,-27],[-1,-103],[10,-67],[-5,-64],[12,-57],[-16,-97],[-7,-114],[10,-26],[7,66],[19,0],[2,-53],[13,-29],[-2,-343],[-6,-422],[0,-74],[-4,-37],[8,-65]],[[29390,64649],[-7,-42],[-21,-42],[-2,-79],[-13,2],[9,-60],[18,87],[11,-15],[10,42],[21,27],[18,2],[4,33],[22,-30],[2,41],[9,-28],[20,-8],[18,-23],[23,28],[2,43],[17,8],[10,-12],[75,3],[39,20],[14,18],[30,63],[9,40],[12,13],[13,50],[21,21],[12,-2],[-18,-52],[-9,-6],[15,-31],[5,-44],[17,-12],[11,25],[16,-72],[15,17],[23,48],[2,28],[17,11],[12,-12],[-5,-21],[-67,-94],[-78,-123],[-50,-62],[-81,-93],[-53,-78],[-43,-41],[-27,-12],[-6,15],[-64,-60],[-61,10],[-46,-55],[3,38],[-23,-2],[3,25],[-11,39],[7,35],[-8,36]],[[26861,65369],[16,17],[-2,-36],[-14,19]],[[26831,65420],[6,90],[11,-35],[-3,-35],[-14,-42],[0,22]],[[26661,65520],[1,-26],[21,-28],[13,17],[37,-82],[25,-20],[11,-21],[18,-66],[19,-29],[18,23],[2,50],[7,13],[14,-55],[19,2],[-1,-37],[29,-96],[16,-33],[22,-21],[41,57],[22,4],[17,35],[51,60],[37,-38],[19,15],[20,-9],[29,61],[29,86],[8,10],[16,58],[44,102],[10,1],[67,108],[30,17],[24,34],[65,69],[17,24]],[[15490,70789],[21,10],[13,-45],[-1,-55],[17,-42],[25,-1],[32,51],[14,-4],[59,-119],[7,-61],[18,-81],[1,-57],[7,-52],[-3,-67],[10,-88],[-4,-41],[3,-50],[33,-54],[46,-35],[11,-19],[17,14],[13,-32],[18,-5],[23,39],[23,7],[54,83],[12,45],[15,16],[21,-15],[29,12],[28,26],[19,-30],[17,-9],[18,14],[34,-40],[9,-75],[14,4],[19,50],[34,4],[13,-16],[11,34],[47,51],[15,35],[21,-9],[21,-51],[22,6],[34,26],[20,5],[11,42],[28,27],[29,46],[46,27],[37,10],[13,57],[14,23],[24,-22],[64,39],[17,-14],[19,6],[28,42],[11,36],[163,1],[250,-3],[164,-3]],[[17338,70482],[16,-107],[11,-27],[16,-75],[18,5],[10,-47],[19,-2],[16,-48],[0,-53],[13,-49],[7,-54],[-24,-108],[-1,-55],[-10,-23],[-24,-150],[1,-36],[-9,-51],[-7,-116],[-13,-40],[-6,-53],[-14,-44],[-3,-51],[7,-58],[-9,-68],[-18,-76],[0,-21],[-32,-49],[-14,-93],[-8,-97],[-10,-66],[-18,-48],[3,-66],[-8,-36],[15,-69],[-8,-56],[13,-35],[19,25],[16,-59],[20,12],[2,-53],[18,-17],[1,-31],[-10,-62],[-12,-17],[1,-42],[11,-32],[-1,-43],[-12,-81],[0,-54],[-11,-11],[-2,-59],[0,-2105]],[[17307,65831],[-166,-2],[-273,-5],[-26,-3],[-143,2],[-220,2]],[[15305,65829],[-21,55],[-15,55],[-7,69],[2,33],[-14,81],[2,32],[-7,63],[-2,126],[13,147],[-7,107],[-17,87],[-11,2],[-11,123],[15,90],[12,96],[6,83],[0,52],[9,80],[6,99],[-6,42],[17,53],[8,43],[16,132],[15,193],[15,283],[7,225],[4,188],[-2,8],[10,197],[-1,69],[7,184],[0,92],[-5,39],[8,91],[12,227],[8,117],[4,157],[-3,66],[3,109],[-4,69],[5,24],[5,176],[-1,76],[-11,41],[6,87],[-2,83],[-7,45],[16,36],[1,109],[-19,193],[27,-79],[14,-14],[-3,38],[23,10],[7,17],[11,-28],[12,31],[15,0],[20,51]],[[26599,59546],[33,-4],[78,1],[5,-5],[157,-1],[61,3],[151,-2],[3,26],[77,-5],[-8,-28]],[[18139,65823],[61,-6],[262,13],[192,2],[5,-5],[196,3],[118,3]],[[18136,60011],[0,880],[1,11],[-1,272],[1,173],[-1,298],[1,318],[0,1661],[1,149],[0,628],[1,266],[0,1156]],[[28738,60998],[7,-15],[-7,-27],[0,42]],[[28949,61206],[-16,-79],[-15,-98],[-8,-27],[-5,21],[-15,-7],[-19,-78],[-12,-70],[-11,-126],[1,-64],[-23,-128],[7,-14],[-18,-91],[-12,-79],[-9,-11],[1,-57],[-11,-86],[-18,-64],[-16,2],[4,-35],[-9,-5],[-1,84],[-10,55],[-4,61],[2,70],[9,59],[3,89],[10,105],[4,76],[16,79],[18,110],[-4,34],[21,17],[15,65],[1,28],[-20,21],[25,54]],[[28739,61120],[-11,-44],[-3,44]],[[28423,61914],[-20,-21],[-13,21],[0,-52],[-18,-113],[-4,-52],[2,-76],[15,-59],[29,15],[6,26],[15,0],[12,38],[9,-30],[-6,-74],[19,-64],[0,-49],[35,-59],[25,-2],[7,-28],[6,21],[24,-9],[4,-44],[16,-39],[8,-59],[13,-15],[15,-54],[20,-23],[30,-68],[-5,-65],[-15,-24],[-2,-107],[4,-29],[-11,-46],[13,-23],[-19,-30],[-31,64],[-11,-27],[-7,25],[0,41],[-13,81],[-19,32],[-8,35],[-12,12],[-21,103],[-11,11],[-4,45],[-13,30],[-2,-30],[28,-89],[20,-114],[15,-24],[1,-25],[16,-14],[10,-96],[11,-53],[30,-4],[7,-36],[31,-24],[-14,-29],[-1,-37],[13,-8],[4,22],[8,-41],[5,-110],[-8,-90],[-18,63],[-21,45],[-9,-42],[11,-39],[7,-55],[9,-14],[-22,-24],[-18,-4],[6,-39],[22,11],[-2,-76],[14,12],[4,-31],[12,-20],[6,-49],[-9,-97],[-4,15],[-16,-18],[-15,-34],[-10,68],[-29,61],[-14,45],[4,48],[-13,71],[-22,-9],[-8,-25],[-10,46],[-18,11],[-4,23],[-21,-35],[11,-33],[12,8],[18,-13],[15,-55],[9,-2],[8,58],[8,-119],[1,-67],[22,-19],[25,-82],[1,-65],[27,4],[9,27],[1,-33],[9,-11],[-3,86],[17,6],[13,-29],[35,-36],[17,27],[11,-11],[8,-128],[12,-140],[9,-71],[7,-94]],[[15775,72069],[4,105],[10,72],[12,-52],[-2,-58],[19,-32],[-18,-27],[-5,-26],[-18,-12],[-2,30]],[[15740,73454],[0,40],[20,-41],[-17,-26],[-3,27]],[[15720,73667],[6,14],[26,-115],[-18,42],[-14,59]],[[15715,73495],[8,29],[12,-47],[-15,-33],[-5,51]],[[15707,73080],[13,89],[14,59],[2,55],[16,11],[7,-19],[0,-49],[19,-38],[3,-26],[-15,-19],[-17,15],[-1,-29],[-13,-34],[-14,-7],[3,-24],[23,10],[11,-42],[8,-84],[-4,-14],[10,-100],[8,27],[-5,67],[10,-3],[16,-57],[16,-13],[7,-94],[-8,-58],[-14,13],[-12,86],[-21,-25],[2,30],[-19,44],[3,93],[-5,56],[-18,-4],[-3,30],[-22,54]],[[15649,73739],[11,-4],[34,-53],[-8,-8],[-22,20],[-15,45]],[[15623,73630],[17,26],[2,-33],[-19,7]],[[15618,73982],[15,0],[4,-29],[-17,-2],[-2,31]],[[15586,73509],[7,30],[20,1],[2,-29],[15,-33],[17,-9],[-18,69],[37,108],[12,-2],[37,-58],[-19,-50],[11,-66],[-2,-62],[-11,-25],[4,-69],[-20,-12],[-15,50],[-9,-12],[-22,11],[-31,62],[-6,76],[-9,20]],[[15577,73617],[18,-10],[18,-54],[-30,41],[-6,23]],[[17306,73978],[-1,-290],[0,-441],[-2,-286],[0,-702],[1,-52],[0,-1247],[-7,-48],[20,-76],[8,-54],[0,-63],[12,-40],[-17,-93],[7,-11],[11,-93]],[[15490,70789],[-34,9],[-3,34],[-12,6],[-10,-31],[-13,10],[-19,-51],[-9,7],[-21,74],[-10,8],[-7,-47],[-10,-10],[6,139],[1,124],[-4,165],[13,-61],[-2,-100],[4,-137],[17,0],[1,37],[-10,40],[0,61],[12,-37],[14,83],[-19,116],[11,42],[25,53],[-17,37],[-6,-27],[-18,-2],[4,-23],[-16,4],[-20,44],[-1,55],[-11,130],[8,8],[6,-52],[11,31],[52,63],[-10,27],[-34,23],[-2,45],[-27,14],[-8,-24],[8,-90],[-16,-21],[3,38],[-4,206],[-14,176],[-24,80],[-9,207],[-5,77],[-15,162],[-14,36],[-4,55],[-14,23],[-5,31],[-19,29],[-12,110],[-8,101],[1,53],[-11,56],[12,58],[9,138],[-19,46],[3,22],[17,1],[40,-55],[32,-64],[10,-1],[25,-39],[6,12],[41,-55],[-1,-20],[35,-41],[56,-11],[21,13],[31,-37],[9,19],[10,-18],[24,7],[12,-32],[41,2],[32,71],[-3,-24],[22,-42],[7,-45],[17,17],[17,-5],[-3,-32],[14,-20],[1,-59],[10,6],[3,53],[-14,34],[0,40],[12,28],[21,10],[3,-31],[-15,-34],[10,-50],[7,6],[2,48],[10,14],[8,-100],[-15,-10],[11,-42],[8,-78],[13,-21],[-8,-25],[-16,2],[2,-42],[-17,-36],[-9,-113],[-14,-9],[11,113],[-6,17],[-19,-101],[-4,-53],[-21,-70],[-38,-183],[-13,-119],[12,8],[23,-13],[12,27],[21,17],[3,38],[-44,-62],[-17,27],[42,226],[31,74],[29,28],[3,73],[16,73],[31,68],[-9,97],[22,-40],[14,-187],[-22,0],[3,-40],[11,-14],[-4,-56],[7,-19],[0,-53],[-14,-38],[-1,-38],[15,-16],[-10,-48],[-6,-87],[4,-21],[-10,-57],[7,-49],[-15,-79],[-27,78],[8,96],[-16,-42],[-6,-63],[30,-83],[-10,-16],[1,-48],[-11,-26],[-16,46],[-20,105],[12,37],[1,61],[-7,25],[0,-51],[-12,-57],[7,-72],[-6,-48],[13,14],[11,-66],[27,-22],[11,37],[0,33],[13,16],[8,79],[10,53],[-2,30],[25,-58],[10,25],[-4,36],[27,34],[0,50],[-8,58],[-8,11],[6,35],[-10,40],[-7,71],[22,38],[-24,58],[16,82],[-6,91],[15,46],[9,119],[22,25],[-1,69],[-14,23],[-23,86],[1,74],[-10,49],[-15,4],[3,-24],[-11,-28],[10,-67],[18,-50],[1,-35],[-26,85],[-12,4],[-7,58],[2,77],[18,24],[16,-22],[10,42],[-10,45],[-28,45],[-13,48],[1,39],[-29,-33],[-7,33],[4,45],[-13,-17],[3,39],[24,28],[13,-15],[9,-49],[19,7],[-10,108],[17,6],[5,34],[-21,66],[-5,66],[8,44],[-13,30],[-17,-6],[-11,-41],[9,-44],[-19,40],[8,57],[-10,25],[-9,-14],[-1,65],[-21,54],[11,21],[-5,36],[-13,16],[16,54],[184,0],[97,-6],[145,5],[143,-2],[190,0],[169,0],[165,1],[178,0],[325,-2]],[[25685,69733],[6,80],[31,-17],[-23,-128],[-14,65]],[[25568,69555],[12,14],[2,-63],[-14,23],[0,26]],[[24707,71654],[8,83],[12,4],[-5,-75],[-15,-12]],[[24691,71507],[21,33],[-14,-47],[-7,14]],[[24655,71564],[5,21],[30,29],[5,-13],[-11,-48],[-24,-11],[-5,22]],[[24625,71464],[3,27],[20,41],[1,-19],[-24,-49]],[[24631,71609],[14,-54],[-13,-3],[-8,37],[7,20]],[[24621,71679],[35,36],[11,-55],[14,34],[2,-44],[-16,-9],[-17,-49],[-11,42],[-16,20],[-2,25]],[[24616,71401],[17,18],[32,86],[14,-32],[-30,-33],[5,-35],[-17,-4],[-20,-37],[-1,37]],[[24563,71635],[15,17],[-1,-44],[-14,27]],[[24276,71309],[20,-30],[34,11],[49,52],[19,27],[18,0],[48,70],[25,27],[6,26],[17,-22],[7,33],[25,10],[22,70],[14,-12],[14,35],[10,-4],[24,-81],[-14,-76],[-24,-78],[9,-73],[-16,-35],[-11,-77],[13,-16],[42,73],[5,54],[42,-108],[13,-22],[9,10],[25,-27]],[[25508,69434],[-10,-58],[-1,-80],[-37,-13],[-21,-40],[3,-47],[-11,-59],[-9,-15],[-11,-83],[-12,-42],[-7,-104],[3,-25],[-13,-50],[20,-42],[12,7],[7,53],[26,64],[10,3],[15,63],[0,36],[31,133],[26,36],[11,-7],[11,34],[15,-32],[-6,46],[12,97],[27,109],[7,100],[12,-5],[21,32],[1,59],[17,60],[22,-3],[-2,-87],[-16,-5],[-2,-142],[-12,-40],[-8,4],[-5,-53],[-14,-52],[5,-43],[-13,-39],[4,-26],[-18,-33],[-13,-62],[-8,-87],[-17,-107],[-9,-26],[-9,-62],[-21,-268],[9,-94],[-2,-71],[-12,-41],[-23,-46],[-3,-62],[-8,-37],[-14,-162],[2,-82],[8,-50],[-2,-102],[-21,-118],[-7,-136],[-20,-107],[-9,-156],[8,-76],[-5,-38],[8,-85],[-7,-57],[14,-62],[0,-85],[6,-63],[16,-59],[-4,-89],[-11,-107],[6,-145]],[[2682,386],[26,11],[1,-51],[-9,8],[-8,-28],[-10,60]],[[2636,452],[21,8],[-4,-21],[-13,-12],[-4,25]],[[2313,271],[13,35],[16,2],[19,68],[4,-20],[27,2],[4,-44],[-7,13],[-29,-30],[-23,-89],[-11,47],[-13,16]],[[90204,32599],[5,15],[34,16],[21,137],[6,65],[7,-11],[7,-43],[14,-11],[-10,-88],[-32,-109],[-9,-44],[-2,-111],[-12,-56],[-18,30],[-7,101],[8,50],[-12,59]],[[90597,35570],[10,43],[4,-16],[-8,-45],[-6,18]],[[90537,37432],[5,20],[1,-49],[-6,29]],[[90507,37973],[14,53],[0,59],[11,0],[0,-66],[-9,-13],[-10,-55],[-6,22]],[[90501,34555],[4,28],[2,101],[9,-12],[20,67],[5,-22],[-14,-80],[4,-63],[-13,7],[0,-73],[-12,18],[-5,29]],[[90487,38800],[6,39],[11,-28],[-1,-51],[-8,-23],[-7,25],[-1,38]],[[90486,35993],[20,2],[3,-36],[-19,-8],[-4,42]],[[90472,34420],[4,45],[13,54],[5,-54],[-4,-24],[7,-40],[-2,-61],[-9,-29],[-14,109]],[[90343,33382],[11,51],[21,35],[15,-9],[-2,-35],[-12,-13],[-8,-39],[-11,-6],[-5,23],[-9,-7]],[[28030,56345],[-13,-8],[-36,-51],[-27,-66],[-35,-121],[-18,-79],[-7,-45],[-16,-58],[-14,-93],[-13,-174],[3,-55],[-7,-48],[-14,-47],[-23,-41],[-9,-97],[-17,10],[-17,-16],[-11,39],[-16,-33],[-10,-63],[3,-31],[8,10],[0,-33],[-15,-20],[-18,-45],[-9,-52],[-34,-59],[-10,38],[-11,-7],[-1,-32],[17,-22],[-5,-59],[-25,-52],[-7,-40],[-10,5],[-24,-22],[-17,-59],[-6,18],[-36,-90],[-8,21],[-15,-28],[-2,30],[-13,-1],[-4,-42],[15,-83],[-7,-74],[-32,-62],[-19,-20],[-2,41],[-19,40],[-11,-22],[-2,-31],[12,-15],[14,-59],[-15,-65],[-25,-59],[-9,0],[-17,-67],[5,-21]],[[31708,38299],[11,-21],[12,13],[9,-36],[-17,-36],[-12,19],[-3,61]],[[31642,38028],[49,54],[35,-32],[-18,-26],[-21,-7],[-11,-24],[-8,12],[-17,-17],[-9,40]],[[31637,38350],[7,-14],[0,-44],[-7,58]],[[31170,38320],[15,18],[17,49],[-4,63],[7,32],[14,12],[20,-6],[17,-25],[50,2],[20,-22],[24,26],[18,-5],[25,-25],[8,20],[28,0],[27,-20],[16,1],[7,-19],[6,24],[37,-35],[4,19],[18,-18],[6,7],[31,-33],[14,-49],[7,13],[5,-27],[10,-6],[14,22],[-5,-40],[3,-84],[13,-30],[-7,-43],[-11,19],[3,-28],[-10,2],[-7,-32],[-13,1],[-11,-59],[-7,-83],[-8,-6],[-1,-44],[-25,-46],[-15,-9],[-12,12],[-7,-27],[-10,13],[-21,-43],[-10,9],[-9,-29],[-8,9],[-18,66],[-12,-10],[-7,-34],[-21,60],[-8,0],[-25,-33],[-14,24],[-12,-19],[-25,47],[-7,-39],[-14,-27],[-21,-3],[-12,-18],[-8,41],[-21,8],[-11,-32],[-19,19],[-12,-12],[1,53],[10,31],[-11,12],[3,65],[5,15],[1,75],[7,31],[-10,101],[-13,21],[-9,78]],[[30985,38023],[20,12],[5,-43],[-15,-38],[-12,32],[2,37]],[[31858,38286],[13,39],[11,-4],[15,-28],[-13,-4],[1,-49],[-9,20],[-13,-5],[-5,31]],[[31828,37522],[7,36],[-4,40],[7,30],[10,-13],[8,22],[17,3],[6,-29],[39,5],[2,-18],[-32,-48],[-41,-30],[-19,2]],[[31779,38288],[6,50],[10,-23],[12,26],[19,-21],[33,6],[-2,-23],[-14,-4],[9,-42],[-16,-11],[-15,23],[-7,-20],[-12,49],[-23,-10]],[[17306,73978],[171,1],[103,1]],[[18139,65823],[-119,3],[-36,-2],[-58,9],[-63,-7],[-79,0],[-293,0],[-184,5]],[[29478,69336],[71,5],[115,0],[40,-9],[62,-5],[57,2],[168,10]],[[25149,51924],[13,-63],[5,-76],[-3,-101],[-10,-105],[-4,3],[8,90],[4,100],[-1,46],[-12,106]],[[25020,51931],[11,38],[32,81],[2,-14],[-13,-63],[2,-28],[13,-33],[-15,-50],[-3,47],[-10,-10],[-17,10],[-2,22]],[[24941,51321],[17,10],[-9,-42],[-8,32]],[[24732,50824],[7,27],[13,-65],[-8,-14],[-12,52]],[[24681,50807],[39,-33],[-19,-8],[-20,41]],[[24628,50763],[25,19],[2,-17],[-26,-20],[-1,18]],[[24275,51386],[10,27],[12,-5],[3,26],[22,-6],[23,-61],[9,7],[6,-29],[-15,-36],[-1,-40],[-14,-19],[-59,115],[4,21]],[[24969,52072],[-17,-35],[-8,7],[-17,-56],[-2,-38],[-12,-15],[3,-40],[-28,17],[-11,-45],[5,-68],[18,-10],[13,25],[-4,-59],[8,-34],[15,-19],[13,11],[6,29],[5,101],[-2,13],[24,54],[3,44],[18,-34],[13,6],[0,-21],[-17,-34],[0,-34],[15,-17],[3,-61],[15,14],[11,82],[16,-25],[-4,-55],[-13,0],[-12,-44],[22,2],[-3,-29],[-31,-22],[13,-66],[11,22],[-7,-59],[-9,26],[-14,11],[-12,-55],[-1,-99],[-9,-5],[-6,86],[-11,1],[-2,-66],[13,-58],[-13,33],[-14,5],[-8,-17],[-15,6],[18,-39],[0,-32],[-23,49],[0,-25],[12,-32],[-12,-14],[1,-34],[11,-36],[20,-11],[-1,-22],[12,-24],[-1,-34],[7,-46],[9,30],[5,-21],[22,-2],[16,-34],[3,30],[20,-91],[11,44],[24,-111],[0,-59],[6,-13],[18,28],[7,-41],[-24,-15],[-2,-33],[16,-3],[-8,-52],[-11,24],[-12,-96],[2,-44],[-21,36],[-2,55],[-8,16],[-31,-138],[-15,-41],[7,67],[9,29],[5,48],[9,21],[0,54],[9,23],[-1,51],[-10,24],[-4,-62],[-16,-29],[-12,29],[-14,77],[-34,43],[-10,45],[-56,33],[-12,-14],[-48,-143],[-46,-115],[-7,10],[4,41],[-12,16],[-2,41],[6,3],[-12,100],[-11,27],[-9,-1],[1,-28],[-8,-36],[2,76],[-10,56],[-13,-64],[-14,14],[-7,-22],[-7,31],[-6,-27],[10,-63],[-12,4],[-7,-27],[-4,-54],[-8,7],[-5,-57],[-8,12],[-19,-33],[-6,-76],[-16,16],[5,21],[-13,67],[-18,57],[-11,-13],[-26,21],[-10,33],[-25,12],[-16,25],[-16,60],[12,14],[7,58],[8,-12],[12,-52],[7,22],[-1,-68],[15,-17],[-4,104],[-23,64],[0,42],[-11,7],[-9,-41],[-13,-13],[2,41],[-10,-7],[3,39],[9,28],[-10,40],[-29,-50],[-10,80],[-10,-8],[-6,118],[-26,1],[6,33],[1,85],[-32,16],[-13,-10],[-20,-38],[-7,57],[8,41],[8,-3],[-2,46],[-16,8],[-14,-22],[-9,20],[-2,-40],[-24,-36],[-14,-34],[-6,32],[-18,-16],[0,-32],[9,-30],[18,-8],[-9,-30],[8,-63],[20,21],[5,-18],[-13,-14],[6,-20],[-32,-6],[-26,-49],[-20,-9],[-82,63],[-35,42],[-57,101],[-23,32],[-41,40],[-33,5],[-14,-14],[-36,7],[-58,-25],[-17,-13],[-26,-53]],[[30097,65246],[-20,-46],[-6,102],[2,64],[-10,22],[2,-159],[-17,2],[-2,-35],[-10,-7],[-1,55],[16,95],[8,68],[17,46]],[[30029,65436],[5,7],[11,-52],[-5,-7],[-11,52]],[[30019,65203],[6,51],[-4,23],[5,57],[4,-20],[0,-85],[-11,-26]],[[29960,64853],[11,80],[5,-14],[1,-76],[-17,10]],[[30068,65494],[-3,-45],[-14,-41],[-6,42],[4,35],[-19,54],[-8,40],[5,-129],[-22,17],[12,-39],[1,-75],[-12,-11],[8,-53],[0,-72],[-10,-45],[-8,-73],[-12,6],[-27,-18],[-27,-34],[-38,-30],[-1,16]]]}')},function(t,e,n){var r=n(34),i=n(33);t.exports=function(t,e,n){var o=!0,a=!0;if("function"!=typeof t)throw new TypeError("Expected a function");return i(n)&&(o="leading"in n?!!n.leading:o,a="trailing"in n?!!n.trailing:a),r(t,e,{leading:o,maxWait:e,trailing:a})}},function(t,e,n){"use strict";var r=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==r)return r;throw new Error("unable to locate global object")}();t.exports=e=r.fetch,r.fetch&&(e.default=r.fetch.bind(r)),e.Headers=r.Headers,e.Request=r.Request,e.Response=r.Response},,,function(t,e,n){t.exports=n(92)},function(t,e,n){var r=function(t){"use strict";var e=Object.prototype,n=e.hasOwnProperty,r="function"==typeof Symbol?Symbol:{},i=r.iterator||"@@iterator",o=r.asyncIterator||"@@asyncIterator",a=r.toStringTag||"@@toStringTag";function s(t,e,n){return Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{s({},"")}catch(t){s=function(t,e,n){return t[e]=n}}function c(t,e,n,r){var i=e&&e.prototype instanceof d?e:d,o=Object.create(i.prototype),a=new A(r||[]);return o._invoke=function(t,e,n){var r="suspendedStart";return function(i,o){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===i)throw o;return O()}for(n.method=i,n.arg=o;;){var a=n.delegate;if(a){var s=k(a,n);if(s){if(s===u)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var c=l(t,e,n);if("normal"===c.type){if(r=n.done?"completed":"suspendedYield",c.arg===u)continue;return{value:c.arg,done:n.done}}"throw"===c.type&&(r="completed",n.method="throw",n.arg=c.arg)}}}(t,n,a),o}function l(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}t.wrap=c;var u={};function d(){}function f(){}function h(){}var p={};p[i]=function(){return this};var g=Object.getPrototypeOf,m=g&&g(g(S([])));m&&m!==e&&n.call(m,i)&&(p=m);var y=h.prototype=d.prototype=Object.create(p);function v(t){["next","throw","return"].forEach((function(e){s(t,e,(function(t){return this._invoke(e,t)}))}))}function b(t,e){var r;this._invoke=function(i,o){function a(){return new e((function(r,a){!function r(i,o,a,s){var c=l(t[i],t,o);if("throw"!==c.type){var u=c.arg,d=u.value;return d&&"object"==typeof d&&n.call(d,"__await")?e.resolve(d.__await).then((function(t){r("next",t,a,s)}),(function(t){r("throw",t,a,s)})):e.resolve(d).then((function(t){u.value=t,a(u)}),(function(t){return r("throw",t,a,s)}))}s(c.arg)}(i,o,r,a)}))}return r=r?r.then(a,a):a()}}function k(t,e){var n=t.iterator[e.method];if(void 0===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=void 0,k(t,e),"throw"===e.method))return u;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return u}var r=l(n,t.iterator,e.arg);if("throw"===r.type)return e.method="throw",e.arg=r.arg,e.delegate=null,u;var i=r.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,u):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,u)}function w(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function x(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function A(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(w,this),this.reset(!0)}function S(t){if(t){var e=t[i];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,o=function e(){for(;++r<t.length;)if(n.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=void 0,e.done=!0,e};return o.next=o}}return{next:O}}function O(){return{value:void 0,done:!0}}return f.prototype=y.constructor=h,h.constructor=f,f.displayName=s(h,a,"GeneratorFunction"),t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===f||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,h):(t.__proto__=h,s(t,a,"GeneratorFunction")),t.prototype=Object.create(y),t},t.awrap=function(t){return{__await:t}},v(b.prototype),b.prototype[o]=function(){return this},t.AsyncIterator=b,t.async=function(e,n,r,i,o){void 0===o&&(o=Promise);var a=new b(c(e,n,r,i),o);return t.isGeneratorFunction(n)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},v(y),s(y,a,"Generator"),y[i]=function(){return this},y.toString=function(){return"[object Generator]"},t.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},t.values=S,A.prototype={constructor:A,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(x),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(n,r){return a.type="throw",a.arg=t,e.next=n,r&&(e.method="next",e.arg=void 0),!!r}for(var i=this.tryEntries.length-1;i>=0;--i){var o=this.tryEntries[i],a=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var s=n.call(o,"catchLoc"),c=n.call(o,"finallyLoc");if(s&&c){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(s){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=t,a.arg=e,o?(this.method="next",this.next=o.finallyLoc,u):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),u},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),x(n),u}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;x(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:S(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=void 0),u}},t}(t.exports);try{regeneratorRuntime=r}catch(t){Function("r","regeneratorRuntime = r")(r)}},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,n){"use strict";
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var r=n(2),i=n(36),o=n(56);function a(t){for(var e="https://reactjs.org/docs/error-decoder.html?invariant="+t,n=1;n<arguments.length;n++)e+="&args[]="+encodeURIComponent(arguments[n]);return"Minified React error #"+t+"; visit "+e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!r)throw Error(a(227));var s=new Set,c={};function l(t,e){u(t,e),u(t+"Capture",e)}function u(t,e){for(c[t]=e,t=0;t<e.length;t++)s.add(e[t])}var d=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement),f=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,h=Object.prototype.hasOwnProperty,p={},g={};function m(t,e,n,r,i,o,a){this.acceptsBooleans=2===e||3===e||4===e,this.attributeName=r,this.attributeNamespace=i,this.mustUseProperty=n,this.propertyName=t,this.type=e,this.sanitizeURL=o,this.removeEmptyString=a}var y={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach((function(t){y[t]=new m(t,0,!1,t,null,!1,!1)})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(t){var e=t[0];y[e]=new m(e,1,!1,t[1],null,!1,!1)})),["contentEditable","draggable","spellCheck","value"].forEach((function(t){y[t]=new m(t,2,!1,t.toLowerCase(),null,!1,!1)})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(t){y[t]=new m(t,2,!1,t,null,!1,!1)})),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach((function(t){y[t]=new m(t,3,!1,t.toLowerCase(),null,!1,!1)})),["checked","multiple","muted","selected"].forEach((function(t){y[t]=new m(t,3,!0,t,null,!1,!1)})),["capture","download"].forEach((function(t){y[t]=new m(t,4,!1,t,null,!1,!1)})),["cols","rows","size","span"].forEach((function(t){y[t]=new m(t,6,!1,t,null,!1,!1)})),["rowSpan","start"].forEach((function(t){y[t]=new m(t,5,!1,t.toLowerCase(),null,!1,!1)}));var v=/[\-:]([a-z])/g;function b(t){return t[1].toUpperCase()}function k(t,e,n,r){var i=y.hasOwnProperty(e)?y[e]:null;(null!==i?0===i.type:!r&&(2<e.length&&("o"===e[0]||"O"===e[0])&&("n"===e[1]||"N"===e[1])))||(function(t,e,n,r){if(null==e||function(t,e,n,r){if(null!==n&&0===n.type)return!1;switch(typeof e){case"function":case"symbol":return!0;case"boolean":return!r&&(null!==n?!n.acceptsBooleans:"data-"!==(t=t.toLowerCase().slice(0,5))&&"aria-"!==t);default:return!1}}(t,e,n,r))return!0;if(r)return!1;if(null!==n)switch(n.type){case 3:return!e;case 4:return!1===e;case 5:return isNaN(e);case 6:return isNaN(e)||1>e}return!1}(e,n,i,r)&&(n=null),r||null===i?function(t){return!!h.call(g,t)||!h.call(p,t)&&(f.test(t)?g[t]=!0:(p[t]=!0,!1))}(e)&&(null===n?t.removeAttribute(e):t.setAttribute(e,""+n)):i.mustUseProperty?t[i.propertyName]=null===n?3!==i.type&&"":n:(e=i.attributeName,r=i.attributeNamespace,null===n?t.removeAttribute(e):(n=3===(i=i.type)||4===i&&!0===n?"":""+n,r?t.setAttributeNS(r,e,n):t.setAttribute(e,n))))}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach((function(t){var e=t.replace(v,b);y[e]=new m(e,1,!1,t,null,!1,!1)})),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach((function(t){var e=t.replace(v,b);y[e]=new m(e,1,!1,t,"http://www.w3.org/1999/xlink",!1,!1)})),["xml:base","xml:lang","xml:space"].forEach((function(t){var e=t.replace(v,b);y[e]=new m(e,1,!1,t,"http://www.w3.org/XML/1998/namespace",!1,!1)})),["tabIndex","crossOrigin"].forEach((function(t){y[t]=new m(t,1,!1,t.toLowerCase(),null,!1,!1)})),y.xlinkHref=new m("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),["src","href","action","formAction"].forEach((function(t){y[t]=new m(t,1,!1,t.toLowerCase(),null,!0,!0)}));var w=r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,x=60103,A=60106,S=60107,O=60108,E=60114,M=60109,C=60110,R=60112,j=60113,I=60120,B=60115,D=60116,T=60121,F=60128,P=60129,z=60130,Q=60131;if("function"==typeof Symbol&&Symbol.for){var L=Symbol.for;x=L("react.element"),A=L("react.portal"),S=L("react.fragment"),O=L("react.strict_mode"),E=L("react.profiler"),M=L("react.provider"),C=L("react.context"),R=L("react.forward_ref"),j=L("react.suspense"),I=L("react.suspense_list"),B=L("react.memo"),D=L("react.lazy"),T=L("react.block"),L("react.scope"),F=L("react.opaque.id"),P=L("react.debug_trace_mode"),z=L("react.offscreen"),Q=L("react.legacy_hidden")}var Y,W="function"==typeof Symbol&&Symbol.iterator;function q(t){return null===t||"object"!=typeof t?null:"function"==typeof(t=W&&t[W]||t["@@iterator"])?t:null}function N(t){if(void 0===Y)try{throw Error()}catch(t){var e=t.stack.trim().match(/\n( *(at )?)/);Y=e&&e[1]||""}return"\n"+Y+t}var G=!1;function J(t,e){if(!t||G)return"";G=!0;var n=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(e)if(e=function(){throw Error()},Object.defineProperty(e.prototype,"props",{set:function(){throw Error()}}),"object"==typeof Reflect&&Reflect.construct){try{Reflect.construct(e,[])}catch(t){var r=t}Reflect.construct(t,[],e)}else{try{e.call()}catch(t){r=t}t.call(e.prototype)}else{try{throw Error()}catch(t){r=t}t()}}catch(t){if(t&&r&&"string"==typeof t.stack){for(var i=t.stack.split("\n"),o=r.stack.split("\n"),a=i.length-1,s=o.length-1;1<=a&&0<=s&&i[a]!==o[s];)s--;for(;1<=a&&0<=s;a--,s--)if(i[a]!==o[s]){if(1!==a||1!==s)do{if(a--,0>--s||i[a]!==o[s])return"\n"+i[a].replace(" at new "," at ")}while(1<=a&&0<=s);break}}}finally{G=!1,Error.prepareStackTrace=n}return(t=t?t.displayName||t.name:"")?N(t):""}function U(t){switch(t.tag){case 5:return N(t.type);case 16:return N("Lazy");case 13:return N("Suspense");case 19:return N("SuspenseList");case 0:case 2:case 15:return t=J(t.type,!1);case 11:return t=J(t.type.render,!1);case 22:return t=J(t.type._render,!1);case 1:return t=J(t.type,!0);default:return""}}function K(t){if(null==t)return null;if("function"==typeof t)return t.displayName||t.name||null;if("string"==typeof t)return t;switch(t){case S:return"Fragment";case A:return"Portal";case E:return"Profiler";case O:return"StrictMode";case j:return"Suspense";case I:return"SuspenseList"}if("object"==typeof t)switch(t.$$typeof){case C:return(t.displayName||"Context")+".Consumer";case M:return(t._context.displayName||"Context")+".Provider";case R:var e=t.render;return e=e.displayName||e.name||"",t.displayName||(""!==e?"ForwardRef("+e+")":"ForwardRef");case B:return K(t.type);case T:return K(t._render);case D:e=t._payload,t=t._init;try{return K(t(e))}catch(t){}}return null}function H(t){switch(typeof t){case"boolean":case"number":case"object":case"string":case"undefined":return t;default:return""}}function V(t){var e=t.type;return(t=t.nodeName)&&"input"===t.toLowerCase()&&("checkbox"===e||"radio"===e)}function Z(t){t._valueTracker||(t._valueTracker=function(t){var e=V(t)?"checked":"value",n=Object.getOwnPropertyDescriptor(t.constructor.prototype,e),r=""+t[e];if(!t.hasOwnProperty(e)&&void 0!==n&&"function"==typeof n.get&&"function"==typeof n.set){var i=n.get,o=n.set;return Object.defineProperty(t,e,{configurable:!0,get:function(){return i.call(this)},set:function(t){r=""+t,o.call(this,t)}}),Object.defineProperty(t,e,{enumerable:n.enumerable}),{getValue:function(){return r},setValue:function(t){r=""+t},stopTracking:function(){t._valueTracker=null,delete t[e]}}}}(t))}function X(t){if(!t)return!1;var e=t._valueTracker;if(!e)return!0;var n=e.getValue(),r="";return t&&(r=V(t)?t.checked?"true":"false":t.value),(t=r)!==n&&(e.setValue(t),!0)}function _(t){if(void 0===(t=t||("undefined"!=typeof document?document:void 0)))return null;try{return t.activeElement||t.body}catch(e){return t.body}}function $(t,e){var n=e.checked;return i({},e,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=n?n:t._wrapperState.initialChecked})}function tt(t,e){var n=null==e.defaultValue?"":e.defaultValue,r=null!=e.checked?e.checked:e.defaultChecked;n=H(null!=e.value?e.value:n),t._wrapperState={initialChecked:r,initialValue:n,controlled:"checkbox"===e.type||"radio"===e.type?null!=e.checked:null!=e.value}}function et(t,e){null!=(e=e.checked)&&k(t,"checked",e,!1)}function nt(t,e){et(t,e);var n=H(e.value),r=e.type;if(null!=n)"number"===r?(0===n&&""===t.value||t.value!=n)&&(t.value=""+n):t.value!==""+n&&(t.value=""+n);else if("submit"===r||"reset"===r)return void t.removeAttribute("value");e.hasOwnProperty("value")?it(t,e.type,n):e.hasOwnProperty("defaultValue")&&it(t,e.type,H(e.defaultValue)),null==e.checked&&null!=e.defaultChecked&&(t.defaultChecked=!!e.defaultChecked)}function rt(t,e,n){if(e.hasOwnProperty("value")||e.hasOwnProperty("defaultValue")){var r=e.type;if(!("submit"!==r&&"reset"!==r||void 0!==e.value&&null!==e.value))return;e=""+t._wrapperState.initialValue,n||e===t.value||(t.value=e),t.defaultValue=e}""!==(n=t.name)&&(t.name=""),t.defaultChecked=!!t._wrapperState.initialChecked,""!==n&&(t.name=n)}function it(t,e,n){"number"===e&&_(t.ownerDocument)===t||(null==n?t.defaultValue=""+t._wrapperState.initialValue:t.defaultValue!==""+n&&(t.defaultValue=""+n))}function ot(t,e){return t=i({children:void 0},e),(e=function(t){var e="";return r.Children.forEach(t,(function(t){null!=t&&(e+=t)})),e}(e.children))&&(t.children=e),t}function at(t,e,n,r){if(t=t.options,e){e={};for(var i=0;i<n.length;i++)e["$"+n[i]]=!0;for(n=0;n<t.length;n++)i=e.hasOwnProperty("$"+t[n].value),t[n].selected!==i&&(t[n].selected=i),i&&r&&(t[n].defaultSelected=!0)}else{for(n=""+H(n),e=null,i=0;i<t.length;i++){if(t[i].value===n)return t[i].selected=!0,void(r&&(t[i].defaultSelected=!0));null!==e||t[i].disabled||(e=t[i])}null!==e&&(e.selected=!0)}}function st(t,e){if(null!=e.dangerouslySetInnerHTML)throw Error(a(91));return i({},e,{value:void 0,defaultValue:void 0,children:""+t._wrapperState.initialValue})}function ct(t,e){var n=e.value;if(null==n){if(n=e.children,e=e.defaultValue,null!=n){if(null!=e)throw Error(a(92));if(Array.isArray(n)){if(!(1>=n.length))throw Error(a(93));n=n[0]}e=n}null==e&&(e=""),n=e}t._wrapperState={initialValue:H(n)}}function lt(t,e){var n=H(e.value),r=H(e.defaultValue);null!=n&&((n=""+n)!==t.value&&(t.value=n),null==e.defaultValue&&t.defaultValue!==n&&(t.defaultValue=n)),null!=r&&(t.defaultValue=""+r)}function ut(t){var e=t.textContent;e===t._wrapperState.initialValue&&""!==e&&null!==e&&(t.value=e)}var dt="http://www.w3.org/1999/xhtml",ft="http://www.w3.org/2000/svg";function ht(t){switch(t){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function pt(t,e){return null==t||"http://www.w3.org/1999/xhtml"===t?ht(e):"http://www.w3.org/2000/svg"===t&&"foreignObject"===e?"http://www.w3.org/1999/xhtml":t}var gt,mt=function(t){return"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(e,n,r,i){MSApp.execUnsafeLocalFunction((function(){return t(e,n)}))}:t}((function(t,e){if(t.namespaceURI!==ft||"innerHTML"in t)t.innerHTML=e;else{for((gt=gt||document.createElement("div")).innerHTML="<svg>"+e.valueOf().toString()+"</svg>",e=gt.firstChild;t.firstChild;)t.removeChild(t.firstChild);for(;e.firstChild;)t.appendChild(e.firstChild)}}));function yt(t,e){if(e){var n=t.firstChild;if(n&&n===t.lastChild&&3===n.nodeType)return void(n.nodeValue=e)}t.textContent=e}var vt={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},bt=["Webkit","ms","Moz","O"];function kt(t,e,n){return null==e||"boolean"==typeof e||""===e?"":n||"number"!=typeof e||0===e||vt.hasOwnProperty(t)&&vt[t]?(""+e).trim():e+"px"}function wt(t,e){for(var n in t=t.style,e)if(e.hasOwnProperty(n)){var r=0===n.indexOf("--"),i=kt(n,e[n],r);"float"===n&&(n="cssFloat"),r?t.setProperty(n,i):t[n]=i}}Object.keys(vt).forEach((function(t){bt.forEach((function(e){e=e+t.charAt(0).toUpperCase()+t.substring(1),vt[e]=vt[t]}))}));var xt=i({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function At(t,e){if(e){if(xt[t]&&(null!=e.children||null!=e.dangerouslySetInnerHTML))throw Error(a(137,t));if(null!=e.dangerouslySetInnerHTML){if(null!=e.children)throw Error(a(60));if("object"!=typeof e.dangerouslySetInnerHTML||!("__html"in e.dangerouslySetInnerHTML))throw Error(a(61))}if(null!=e.style&&"object"!=typeof e.style)throw Error(a(62))}}function St(t,e){if(-1===t.indexOf("-"))return"string"==typeof e.is;switch(t){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}function Ot(t){return(t=t.target||t.srcElement||window).correspondingUseElement&&(t=t.correspondingUseElement),3===t.nodeType?t.parentNode:t}var Et=null,Mt=null,Ct=null;function Rt(t){if(t=_r(t)){if("function"!=typeof Et)throw Error(a(280));var e=t.stateNode;e&&(e=ti(e),Et(t.stateNode,t.type,e))}}function jt(t){Mt?Ct?Ct.push(t):Ct=[t]:Mt=t}function It(){if(Mt){var t=Mt,e=Ct;if(Ct=Mt=null,Rt(t),e)for(t=0;t<e.length;t++)Rt(e[t])}}function Bt(t,e){return t(e)}function Dt(t,e,n,r,i){return t(e,n,r,i)}function Tt(){}var Ft=Bt,Pt=!1,zt=!1;function Qt(){null===Mt&&null===Ct||(Tt(),It())}function Lt(t,e){var n=t.stateNode;if(null===n)return null;var r=ti(n);if(null===r)return null;n=r[e];t:switch(e){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":(r=!r.disabled)||(r=!("button"===(t=t.type)||"input"===t||"select"===t||"textarea"===t)),t=!r;break t;default:t=!1}if(t)return null;if(n&&"function"!=typeof n)throw Error(a(231,e,typeof n));return n}var Yt=!1;if(d)try{var Wt={};Object.defineProperty(Wt,"passive",{get:function(){Yt=!0}}),window.addEventListener("test",Wt,Wt),window.removeEventListener("test",Wt,Wt)}catch(t){Yt=!1}function qt(t,e,n,r,i,o,a,s,c){var l=Array.prototype.slice.call(arguments,3);try{e.apply(n,l)}catch(t){this.onError(t)}}var Nt=!1,Gt=null,Jt=!1,Ut=null,Kt={onError:function(t){Nt=!0,Gt=t}};function Ht(t,e,n,r,i,o,a,s,c){Nt=!1,Gt=null,qt.apply(Kt,arguments)}function Vt(t){var e=t,n=t;if(t.alternate)for(;e.return;)e=e.return;else{t=e;do{0!=(1026&(e=t).flags)&&(n=e.return),t=e.return}while(t)}return 3===e.tag?n:null}function Zt(t){if(13===t.tag){var e=t.memoizedState;if(null===e&&(null!==(t=t.alternate)&&(e=t.memoizedState)),null!==e)return e.dehydrated}return null}function Xt(t){if(Vt(t)!==t)throw Error(a(188))}function _t(t){if(!(t=function(t){var e=t.alternate;if(!e){if(null===(e=Vt(t)))throw Error(a(188));return e!==t?null:t}for(var n=t,r=e;;){var i=n.return;if(null===i)break;var o=i.alternate;if(null===o){if(null!==(r=i.return)){n=r;continue}break}if(i.child===o.child){for(o=i.child;o;){if(o===n)return Xt(i),t;if(o===r)return Xt(i),e;o=o.sibling}throw Error(a(188))}if(n.return!==r.return)n=i,r=o;else{for(var s=!1,c=i.child;c;){if(c===n){s=!0,n=i,r=o;break}if(c===r){s=!0,r=i,n=o;break}c=c.sibling}if(!s){for(c=o.child;c;){if(c===n){s=!0,n=o,r=i;break}if(c===r){s=!0,r=o,n=i;break}c=c.sibling}if(!s)throw Error(a(189))}}if(n.alternate!==r)throw Error(a(190))}if(3!==n.tag)throw Error(a(188));return n.stateNode.current===n?t:e}(t)))return null;for(var e=t;;){if(5===e.tag||6===e.tag)return e;if(e.child)e.child.return=e,e=e.child;else{if(e===t)break;for(;!e.sibling;){if(!e.return||e.return===t)return null;e=e.return}e.sibling.return=e.return,e=e.sibling}}return null}function $t(t,e){for(var n=t.alternate;null!==e;){if(e===t||e===n)return!0;e=e.return}return!1}var te,ee,ne,re,ie=!1,oe=[],ae=null,se=null,ce=null,le=new Map,ue=new Map,de=[],fe="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");function he(t,e,n,r,i){return{blockedOn:t,domEventName:e,eventSystemFlags:16|n,nativeEvent:i,targetContainers:[r]}}function pe(t,e){switch(t){case"focusin":case"focusout":ae=null;break;case"dragenter":case"dragleave":se=null;break;case"mouseover":case"mouseout":ce=null;break;case"pointerover":case"pointerout":le.delete(e.pointerId);break;case"gotpointercapture":case"lostpointercapture":ue.delete(e.pointerId)}}function ge(t,e,n,r,i,o){return null===t||t.nativeEvent!==o?(t=he(e,n,r,i,o),null!==e&&(null!==(e=_r(e))&&ee(e)),t):(t.eventSystemFlags|=r,e=t.targetContainers,null!==i&&-1===e.indexOf(i)&&e.push(i),t)}function me(t){var e=Xr(t.target);if(null!==e){var n=Vt(e);if(null!==n)if(13===(e=n.tag)){if(null!==(e=Zt(n)))return t.blockedOn=e,void re(t.lanePriority,(function(){o.unstable_runWithPriority(t.priority,(function(){ne(n)}))}))}else if(3===e&&n.stateNode.hydrate)return void(t.blockedOn=3===n.tag?n.stateNode.containerInfo:null)}t.blockedOn=null}function ye(t){if(null!==t.blockedOn)return!1;for(var e=t.targetContainers;0<e.length;){var n=_e(t.domEventName,t.eventSystemFlags,e[0],t.nativeEvent);if(null!==n)return null!==(e=_r(n))&&ee(e),t.blockedOn=n,!1;e.shift()}return!0}function ve(t,e,n){ye(t)&&n.delete(e)}function be(){for(ie=!1;0<oe.length;){var t=oe[0];if(null!==t.blockedOn){null!==(t=_r(t.blockedOn))&&te(t);break}for(var e=t.targetContainers;0<e.length;){var n=_e(t.domEventName,t.eventSystemFlags,e[0],t.nativeEvent);if(null!==n){t.blockedOn=n;break}e.shift()}null===t.blockedOn&&oe.shift()}null!==ae&&ye(ae)&&(ae=null),null!==se&&ye(se)&&(se=null),null!==ce&&ye(ce)&&(ce=null),le.forEach(ve),ue.forEach(ve)}function ke(t,e){t.blockedOn===e&&(t.blockedOn=null,ie||(ie=!0,o.unstable_scheduleCallback(o.unstable_NormalPriority,be)))}function we(t){function e(e){return ke(e,t)}if(0<oe.length){ke(oe[0],t);for(var n=1;n<oe.length;n++){var r=oe[n];r.blockedOn===t&&(r.blockedOn=null)}}for(null!==ae&&ke(ae,t),null!==se&&ke(se,t),null!==ce&&ke(ce,t),le.forEach(e),ue.forEach(e),n=0;n<de.length;n++)(r=de[n]).blockedOn===t&&(r.blockedOn=null);for(;0<de.length&&null===(n=de[0]).blockedOn;)me(n),null===n.blockedOn&&de.shift()}function xe(t,e){var n={};return n[t.toLowerCase()]=e.toLowerCase(),n["Webkit"+t]="webkit"+e,n["Moz"+t]="moz"+e,n}var Ae={animationend:xe("Animation","AnimationEnd"),animationiteration:xe("Animation","AnimationIteration"),animationstart:xe("Animation","AnimationStart"),transitionend:xe("Transition","TransitionEnd")},Se={},Oe={};function Ee(t){if(Se[t])return Se[t];if(!Ae[t])return t;var e,n=Ae[t];for(e in n)if(n.hasOwnProperty(e)&&e in Oe)return Se[t]=n[e];return t}d&&(Oe=document.createElement("div").style,"AnimationEvent"in window||(delete Ae.animationend.animation,delete Ae.animationiteration.animation,delete Ae.animationstart.animation),"TransitionEvent"in window||delete Ae.transitionend.transition);var Me=Ee("animationend"),Ce=Ee("animationiteration"),Re=Ee("animationstart"),je=Ee("transitionend"),Ie=new Map,Be=new Map,De=["abort","abort",Me,"animationEnd",Ce,"animationIteration",Re,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",je,"transitionEnd","waiting","waiting"];function Te(t,e){for(var n=0;n<t.length;n+=2){var r=t[n],i=t[n+1];i="on"+(i[0].toUpperCase()+i.slice(1)),Be.set(r,e),Ie.set(r,i),l(i,[r])}}(0,o.unstable_now)();var Fe=8;function Pe(t){if(0!=(1&t))return Fe=15,1;if(0!=(2&t))return Fe=14,2;if(0!=(4&t))return Fe=13,4;var e=24&t;return 0!==e?(Fe=12,e):0!=(32&t)?(Fe=11,32):0!==(e=192&t)?(Fe=10,e):0!=(256&t)?(Fe=9,256):0!==(e=3584&t)?(Fe=8,e):0!=(4096&t)?(Fe=7,4096):0!==(e=4186112&t)?(Fe=6,e):0!==(e=62914560&t)?(Fe=5,e):67108864&t?(Fe=4,67108864):0!=(134217728&t)?(Fe=3,134217728):0!==(e=805306368&t)?(Fe=2,e):0!=(1073741824&t)?(Fe=1,1073741824):(Fe=8,t)}function ze(t,e){var n=t.pendingLanes;if(0===n)return Fe=0;var r=0,i=0,o=t.expiredLanes,a=t.suspendedLanes,s=t.pingedLanes;if(0!==o)r=o,i=Fe=15;else if(0!==(o=134217727&n)){var c=o&~a;0!==c?(r=Pe(c),i=Fe):0!==(s&=o)&&(r=Pe(s),i=Fe)}else 0!==(o=n&~a)?(r=Pe(o),i=Fe):0!==s&&(r=Pe(s),i=Fe);if(0===r)return 0;if(r=n&((0>(r=31-Ne(r))?0:1<<r)<<1)-1,0!==e&&e!==r&&0==(e&a)){if(Pe(e),i<=Fe)return e;Fe=i}if(0!==(e=t.entangledLanes))for(t=t.entanglements,e&=r;0<e;)i=1<<(n=31-Ne(e)),r|=t[n],e&=~i;return r}function Qe(t){return 0!==(t=-1073741825&t.pendingLanes)?t:1073741824&t?1073741824:0}function Le(t,e){switch(t){case 15:return 1;case 14:return 2;case 12:return 0===(t=Ye(24&~e))?Le(10,e):t;case 10:return 0===(t=Ye(192&~e))?Le(8,e):t;case 8:return 0===(t=Ye(3584&~e))&&(0===(t=Ye(4186112&~e))&&(t=512)),t;case 2:return 0===(e=Ye(805306368&~e))&&(e=268435456),e}throw Error(a(358,t))}function Ye(t){return t&-t}function We(t){for(var e=[],n=0;31>n;n++)e.push(t);return e}function qe(t,e,n){t.pendingLanes|=e;var r=e-1;t.suspendedLanes&=r,t.pingedLanes&=r,(t=t.eventTimes)[e=31-Ne(e)]=n}var Ne=Math.clz32?Math.clz32:function(t){return 0===t?32:31-(Ge(t)/Je|0)|0},Ge=Math.log,Je=Math.LN2;var Ue=o.unstable_UserBlockingPriority,Ke=o.unstable_runWithPriority,He=!0;function Ve(t,e,n,r){Pt||Tt();var i=Xe,o=Pt;Pt=!0;try{Dt(i,t,e,n,r)}finally{(Pt=o)||Qt()}}function Ze(t,e,n,r){Ke(Ue,Xe.bind(null,t,e,n,r))}function Xe(t,e,n,r){var i;if(He)if((i=0==(4&e))&&0<oe.length&&-1<fe.indexOf(t))t=he(null,t,e,n,r),oe.push(t);else{var o=_e(t,e,n,r);if(null===o)i&&pe(t,r);else{if(i){if(-1<fe.indexOf(t))return t=he(o,t,e,n,r),void oe.push(t);if(function(t,e,n,r,i){switch(e){case"focusin":return ae=ge(ae,t,e,n,r,i),!0;case"dragenter":return se=ge(se,t,e,n,r,i),!0;case"mouseover":return ce=ge(ce,t,e,n,r,i),!0;case"pointerover":var o=i.pointerId;return le.set(o,ge(le.get(o)||null,t,e,n,r,i)),!0;case"gotpointercapture":return o=i.pointerId,ue.set(o,ge(ue.get(o)||null,t,e,n,r,i)),!0}return!1}(o,t,e,n,r))return;pe(t,r)}jr(t,e,r,null,n)}}}function _e(t,e,n,r){var i=Ot(r);if(null!==(i=Xr(i))){var o=Vt(i);if(null===o)i=null;else{var a=o.tag;if(13===a){if(null!==(i=Zt(o)))return i;i=null}else if(3===a){if(o.stateNode.hydrate)return 3===o.tag?o.stateNode.containerInfo:null;i=null}else o!==i&&(i=null)}}return jr(t,e,r,i,n),null}var $e=null,tn=null,en=null;function nn(){if(en)return en;var t,e,n=tn,r=n.length,i="value"in $e?$e.value:$e.textContent,o=i.length;for(t=0;t<r&&n[t]===i[t];t++);var a=r-t;for(e=1;e<=a&&n[r-e]===i[o-e];e++);return en=i.slice(t,1<e?1-e:void 0)}function rn(t){var e=t.keyCode;return"charCode"in t?0===(t=t.charCode)&&13===e&&(t=13):t=e,10===t&&(t=13),32<=t||13===t?t:0}function on(){return!0}function an(){return!1}function sn(t){function e(e,n,r,i,o){for(var a in this._reactName=e,this._targetInst=r,this.type=n,this.nativeEvent=i,this.target=o,this.currentTarget=null,t)t.hasOwnProperty(a)&&(e=t[a],this[a]=e?e(i):i[a]);return this.isDefaultPrevented=(null!=i.defaultPrevented?i.defaultPrevented:!1===i.returnValue)?on:an,this.isPropagationStopped=an,this}return i(e.prototype,{preventDefault:function(){this.defaultPrevented=!0;var t=this.nativeEvent;t&&(t.preventDefault?t.preventDefault():"unknown"!=typeof t.returnValue&&(t.returnValue=!1),this.isDefaultPrevented=on)},stopPropagation:function(){var t=this.nativeEvent;t&&(t.stopPropagation?t.stopPropagation():"unknown"!=typeof t.cancelBubble&&(t.cancelBubble=!0),this.isPropagationStopped=on)},persist:function(){},isPersistent:on}),e}var cn,ln,un,dn={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(t){return t.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},fn=sn(dn),hn=i({},dn,{view:0,detail:0}),pn=sn(hn),gn=i({},hn,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:En,button:0,buttons:0,relatedTarget:function(t){return void 0===t.relatedTarget?t.fromElement===t.srcElement?t.toElement:t.fromElement:t.relatedTarget},movementX:function(t){return"movementX"in t?t.movementX:(t!==un&&(un&&"mousemove"===t.type?(cn=t.screenX-un.screenX,ln=t.screenY-un.screenY):ln=cn=0,un=t),cn)},movementY:function(t){return"movementY"in t?t.movementY:ln}}),mn=sn(gn),yn=sn(i({},gn,{dataTransfer:0})),vn=sn(i({},hn,{relatedTarget:0})),bn=sn(i({},dn,{animationName:0,elapsedTime:0,pseudoElement:0})),kn=sn(i({},dn,{clipboardData:function(t){return"clipboardData"in t?t.clipboardData:window.clipboardData}})),wn=sn(i({},dn,{data:0})),xn={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},An={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Sn={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function On(t){var e=this.nativeEvent;return e.getModifierState?e.getModifierState(t):!!(t=Sn[t])&&!!e[t]}function En(){return On}var Mn=sn(i({},hn,{key:function(t){if(t.key){var e=xn[t.key]||t.key;if("Unidentified"!==e)return e}return"keypress"===t.type?13===(t=rn(t))?"Enter":String.fromCharCode(t):"keydown"===t.type||"keyup"===t.type?An[t.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:En,charCode:function(t){return"keypress"===t.type?rn(t):0},keyCode:function(t){return"keydown"===t.type||"keyup"===t.type?t.keyCode:0},which:function(t){return"keypress"===t.type?rn(t):"keydown"===t.type||"keyup"===t.type?t.keyCode:0}})),Cn=sn(i({},gn,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0})),Rn=sn(i({},hn,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:En})),jn=sn(i({},dn,{propertyName:0,elapsedTime:0,pseudoElement:0})),In=sn(i({},gn,{deltaX:function(t){return"deltaX"in t?t.deltaX:"wheelDeltaX"in t?-t.wheelDeltaX:0},deltaY:function(t){return"deltaY"in t?t.deltaY:"wheelDeltaY"in t?-t.wheelDeltaY:"wheelDelta"in t?-t.wheelDelta:0},deltaZ:0,deltaMode:0})),Bn=[9,13,27,32],Dn=d&&"CompositionEvent"in window,Tn=null;d&&"documentMode"in document&&(Tn=document.documentMode);var Fn=d&&"TextEvent"in window&&!Tn,Pn=d&&(!Dn||Tn&&8<Tn&&11>=Tn),zn=String.fromCharCode(32),Qn=!1;function Ln(t,e){switch(t){case"keyup":return-1!==Bn.indexOf(e.keyCode);case"keydown":return 229!==e.keyCode;case"keypress":case"mousedown":case"focusout":return!0;default:return!1}}function Yn(t){return"object"==typeof(t=t.detail)&&"data"in t?t.data:null}var Wn=!1;var qn={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Nn(t){var e=t&&t.nodeName&&t.nodeName.toLowerCase();return"input"===e?!!qn[t.type]:"textarea"===e}function Gn(t,e,n,r){jt(r),0<(e=Br(e,"onChange")).length&&(n=new fn("onChange","change",null,n,r),t.push({event:n,listeners:e}))}var Jn=null,Un=null;function Kn(t){Sr(t,0)}function Hn(t){if(X($r(t)))return t}function Vn(t,e){if("change"===t)return e}var Zn=!1;if(d){var Xn;if(d){var _n="oninput"in document;if(!_n){var $n=document.createElement("div");$n.setAttribute("oninput","return;"),_n="function"==typeof $n.oninput}Xn=_n}else Xn=!1;Zn=Xn&&(!document.documentMode||9<document.documentMode)}function tr(){Jn&&(Jn.detachEvent("onpropertychange",er),Un=Jn=null)}function er(t){if("value"===t.propertyName&&Hn(Un)){var e=[];if(Gn(e,Un,t,Ot(t)),t=Kn,Pt)t(e);else{Pt=!0;try{Bt(t,e)}finally{Pt=!1,Qt()}}}}function nr(t,e,n){"focusin"===t?(tr(),Un=n,(Jn=e).attachEvent("onpropertychange",er)):"focusout"===t&&tr()}function rr(t){if("selectionchange"===t||"keyup"===t||"keydown"===t)return Hn(Un)}function ir(t,e){if("click"===t)return Hn(e)}function or(t,e){if("input"===t||"change"===t)return Hn(e)}var ar="function"==typeof Object.is?Object.is:function(t,e){return t===e&&(0!==t||1/t==1/e)||t!=t&&e!=e},sr=Object.prototype.hasOwnProperty;function cr(t,e){if(ar(t,e))return!0;if("object"!=typeof t||null===t||"object"!=typeof e||null===e)return!1;var n=Object.keys(t),r=Object.keys(e);if(n.length!==r.length)return!1;for(r=0;r<n.length;r++)if(!sr.call(e,n[r])||!ar(t[n[r]],e[n[r]]))return!1;return!0}function lr(t){for(;t&&t.firstChild;)t=t.firstChild;return t}function ur(t,e){var n,r=lr(t);for(t=0;r;){if(3===r.nodeType){if(n=t+r.textContent.length,t<=e&&n>=e)return{node:r,offset:e-t};t=n}t:{for(;r;){if(r.nextSibling){r=r.nextSibling;break t}r=r.parentNode}r=void 0}r=lr(r)}}function dr(){for(var t=window,e=_();e instanceof t.HTMLIFrameElement;){try{var n="string"==typeof e.contentWindow.location.href}catch(t){n=!1}if(!n)break;e=_((t=e.contentWindow).document)}return e}function fr(t){var e=t&&t.nodeName&&t.nodeName.toLowerCase();return e&&("input"===e&&("text"===t.type||"search"===t.type||"tel"===t.type||"url"===t.type||"password"===t.type)||"textarea"===e||"true"===t.contentEditable)}var hr=d&&"documentMode"in document&&11>=document.documentMode,pr=null,gr=null,mr=null,yr=!1;function vr(t,e,n){var r=n.window===n?n.document:9===n.nodeType?n:n.ownerDocument;yr||null==pr||pr!==_(r)||("selectionStart"in(r=pr)&&fr(r)?r={start:r.selectionStart,end:r.selectionEnd}:r={anchorNode:(r=(r.ownerDocument&&r.ownerDocument.defaultView||window).getSelection()).anchorNode,anchorOffset:r.anchorOffset,focusNode:r.focusNode,focusOffset:r.focusOffset},mr&&cr(mr,r)||(mr=r,0<(r=Br(gr,"onSelect")).length&&(e=new fn("onSelect","select",null,e,n),t.push({event:e,listeners:r}),e.target=pr)))}Te("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0),Te("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1),Te(De,2);for(var br="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),kr=0;kr<br.length;kr++)Be.set(br[kr],0);u("onMouseEnter",["mouseout","mouseover"]),u("onMouseLeave",["mouseout","mouseover"]),u("onPointerEnter",["pointerout","pointerover"]),u("onPointerLeave",["pointerout","pointerover"]),l("onChange","change click focusin focusout input keydown keyup selectionchange".split(" ")),l("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")),l("onBeforeInput",["compositionend","keypress","textInput","paste"]),l("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" ")),l("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" ")),l("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var wr="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),xr=new Set("cancel close invalid load scroll toggle".split(" ").concat(wr));function Ar(t,e,n){var r=t.type||"unknown-event";t.currentTarget=n,function(t,e,n,r,i,o,s,c,l){if(Ht.apply(this,arguments),Nt){if(!Nt)throw Error(a(198));var u=Gt;Nt=!1,Gt=null,Jt||(Jt=!0,Ut=u)}}(r,e,void 0,t),t.currentTarget=null}function Sr(t,e){e=0!=(4&e);for(var n=0;n<t.length;n++){var r=t[n],i=r.event;r=r.listeners;t:{var o=void 0;if(e)for(var a=r.length-1;0<=a;a--){var s=r[a],c=s.instance,l=s.currentTarget;if(s=s.listener,c!==o&&i.isPropagationStopped())break t;Ar(i,s,l),o=c}else for(a=0;a<r.length;a++){if(c=(s=r[a]).instance,l=s.currentTarget,s=s.listener,c!==o&&i.isPropagationStopped())break t;Ar(i,s,l),o=c}}}if(Jt)throw t=Ut,Jt=!1,Ut=null,t}function Or(t,e){var n=ei(e),r=t+"__bubble";n.has(r)||(Rr(e,t,2,!1),n.add(r))}var Er="_reactListening"+Math.random().toString(36).slice(2);function Mr(t){t[Er]||(t[Er]=!0,s.forEach((function(e){xr.has(e)||Cr(e,!1,t,null),Cr(e,!0,t,null)})))}function Cr(t,e,n,r){var i=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,o=n;if("selectionchange"===t&&9!==n.nodeType&&(o=n.ownerDocument),null!==r&&!e&&xr.has(t)){if("scroll"!==t)return;i|=2,o=r}var a=ei(o),s=t+"__"+(e?"capture":"bubble");a.has(s)||(e&&(i|=4),Rr(o,t,i,e),a.add(s))}function Rr(t,e,n,r){var i=Be.get(e);switch(void 0===i?2:i){case 0:i=Ve;break;case 1:i=Ze;break;default:i=Xe}n=i.bind(null,e,n,t),i=void 0,!Yt||"touchstart"!==e&&"touchmove"!==e&&"wheel"!==e||(i=!0),r?void 0!==i?t.addEventListener(e,n,{capture:!0,passive:i}):t.addEventListener(e,n,!0):void 0!==i?t.addEventListener(e,n,{passive:i}):t.addEventListener(e,n,!1)}function jr(t,e,n,r,i){var o=r;if(0==(1&e)&&0==(2&e)&&null!==r)t:for(;;){if(null===r)return;var a=r.tag;if(3===a||4===a){var s=r.stateNode.containerInfo;if(s===i||8===s.nodeType&&s.parentNode===i)break;if(4===a)for(a=r.return;null!==a;){var c=a.tag;if((3===c||4===c)&&((c=a.stateNode.containerInfo)===i||8===c.nodeType&&c.parentNode===i))return;a=a.return}for(;null!==s;){if(null===(a=Xr(s)))return;if(5===(c=a.tag)||6===c){r=o=a;continue t}s=s.parentNode}}r=r.return}!function(t,e,n){if(zt)return t(e,n);zt=!0;try{Ft(t,e,n)}finally{zt=!1,Qt()}}((function(){var r=o,i=Ot(n),a=[];t:{var s=Ie.get(t);if(void 0!==s){var c=fn,l=t;switch(t){case"keypress":if(0===rn(n))break t;case"keydown":case"keyup":c=Mn;break;case"focusin":l="focus",c=vn;break;case"focusout":l="blur",c=vn;break;case"beforeblur":case"afterblur":c=vn;break;case"click":if(2===n.button)break t;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":c=mn;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":c=yn;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":c=Rn;break;case Me:case Ce:case Re:c=bn;break;case je:c=jn;break;case"scroll":c=pn;break;case"wheel":c=In;break;case"copy":case"cut":case"paste":c=kn;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":c=Cn}var u=0!=(4&e),d=!u&&"scroll"===t,f=u?null!==s?s+"Capture":null:s;u=[];for(var h,p=r;null!==p;){var g=(h=p).stateNode;if(5===h.tag&&null!==g&&(h=g,null!==f&&(null!=(g=Lt(p,f))&&u.push(Ir(p,g,h)))),d)break;p=p.return}0<u.length&&(s=new c(s,l,null,n,i),a.push({event:s,listeners:u}))}}if(0==(7&e)){if(c="mouseout"===t||"pointerout"===t,(!(s="mouseover"===t||"pointerover"===t)||0!=(16&e)||!(l=n.relatedTarget||n.fromElement)||!Xr(l)&&!l[Vr])&&(c||s)&&(s=i.window===i?i:(s=i.ownerDocument)?s.defaultView||s.parentWindow:window,c?(c=r,null!==(l=(l=n.relatedTarget||n.toElement)?Xr(l):null)&&(l!==(d=Vt(l))||5!==l.tag&&6!==l.tag)&&(l=null)):(c=null,l=r),c!==l)){if(u=mn,g="onMouseLeave",f="onMouseEnter",p="mouse","pointerout"!==t&&"pointerover"!==t||(u=Cn,g="onPointerLeave",f="onPointerEnter",p="pointer"),d=null==c?s:$r(c),h=null==l?s:$r(l),(s=new u(g,p+"leave",c,n,i)).target=d,s.relatedTarget=h,g=null,Xr(i)===r&&((u=new u(f,p+"enter",l,n,i)).target=h,u.relatedTarget=d,g=u),d=g,c&&l)t:{for(f=l,p=0,h=u=c;h;h=Dr(h))p++;for(h=0,g=f;g;g=Dr(g))h++;for(;0<p-h;)u=Dr(u),p--;for(;0<h-p;)f=Dr(f),h--;for(;p--;){if(u===f||null!==f&&u===f.alternate)break t;u=Dr(u),f=Dr(f)}u=null}else u=null;null!==c&&Tr(a,s,c,u,!1),null!==l&&null!==d&&Tr(a,d,l,u,!0)}if("select"===(c=(s=r?$r(r):window).nodeName&&s.nodeName.toLowerCase())||"input"===c&&"file"===s.type)var m=Vn;else if(Nn(s))if(Zn)m=or;else{m=rr;var y=nr}else(c=s.nodeName)&&"input"===c.toLowerCase()&&("checkbox"===s.type||"radio"===s.type)&&(m=ir);switch(m&&(m=m(t,r))?Gn(a,m,n,i):(y&&y(t,s,r),"focusout"===t&&(y=s._wrapperState)&&y.controlled&&"number"===s.type&&it(s,"number",s.value)),y=r?$r(r):window,t){case"focusin":(Nn(y)||"true"===y.contentEditable)&&(pr=y,gr=r,mr=null);break;case"focusout":mr=gr=pr=null;break;case"mousedown":yr=!0;break;case"contextmenu":case"mouseup":case"dragend":yr=!1,vr(a,n,i);break;case"selectionchange":if(hr)break;case"keydown":case"keyup":vr(a,n,i)}var v;if(Dn)t:{switch(t){case"compositionstart":var b="onCompositionStart";break t;case"compositionend":b="onCompositionEnd";break t;case"compositionupdate":b="onCompositionUpdate";break t}b=void 0}else Wn?Ln(t,n)&&(b="onCompositionEnd"):"keydown"===t&&229===n.keyCode&&(b="onCompositionStart");b&&(Pn&&"ko"!==n.locale&&(Wn||"onCompositionStart"!==b?"onCompositionEnd"===b&&Wn&&(v=nn()):(tn="value"in($e=i)?$e.value:$e.textContent,Wn=!0)),0<(y=Br(r,b)).length&&(b=new wn(b,t,null,n,i),a.push({event:b,listeners:y}),v?b.data=v:null!==(v=Yn(n))&&(b.data=v))),(v=Fn?function(t,e){switch(t){case"compositionend":return Yn(e);case"keypress":return 32!==e.which?null:(Qn=!0,zn);case"textInput":return(t=e.data)===zn&&Qn?null:t;default:return null}}(t,n):function(t,e){if(Wn)return"compositionend"===t||!Dn&&Ln(t,e)?(t=nn(),en=tn=$e=null,Wn=!1,t):null;switch(t){case"paste":return null;case"keypress":if(!(e.ctrlKey||e.altKey||e.metaKey)||e.ctrlKey&&e.altKey){if(e.char&&1<e.char.length)return e.char;if(e.which)return String.fromCharCode(e.which)}return null;case"compositionend":return Pn&&"ko"!==e.locale?null:e.data;default:return null}}(t,n))&&(0<(r=Br(r,"onBeforeInput")).length&&(i=new wn("onBeforeInput","beforeinput",null,n,i),a.push({event:i,listeners:r}),i.data=v))}Sr(a,e)}))}function Ir(t,e,n){return{instance:t,listener:e,currentTarget:n}}function Br(t,e){for(var n=e+"Capture",r=[];null!==t;){var i=t,o=i.stateNode;5===i.tag&&null!==o&&(i=o,null!=(o=Lt(t,n))&&r.unshift(Ir(t,o,i)),null!=(o=Lt(t,e))&&r.push(Ir(t,o,i))),t=t.return}return r}function Dr(t){if(null===t)return null;do{t=t.return}while(t&&5!==t.tag);return t||null}function Tr(t,e,n,r,i){for(var o=e._reactName,a=[];null!==n&&n!==r;){var s=n,c=s.alternate,l=s.stateNode;if(null!==c&&c===r)break;5===s.tag&&null!==l&&(s=l,i?null!=(c=Lt(n,o))&&a.unshift(Ir(n,c,s)):i||null!=(c=Lt(n,o))&&a.push(Ir(n,c,s))),n=n.return}0!==a.length&&t.push({event:e,listeners:a})}function Fr(){}var Pr=null,zr=null;function Qr(t,e){switch(t){case"button":case"input":case"select":case"textarea":return!!e.autoFocus}return!1}function Lr(t,e){return"textarea"===t||"option"===t||"noscript"===t||"string"==typeof e.children||"number"==typeof e.children||"object"==typeof e.dangerouslySetInnerHTML&&null!==e.dangerouslySetInnerHTML&&null!=e.dangerouslySetInnerHTML.__html}var Yr="function"==typeof setTimeout?setTimeout:void 0,Wr="function"==typeof clearTimeout?clearTimeout:void 0;function qr(t){1===t.nodeType?t.textContent="":9===t.nodeType&&(null!=(t=t.body)&&(t.textContent=""))}function Nr(t){for(;null!=t;t=t.nextSibling){var e=t.nodeType;if(1===e||3===e)break}return t}function Gr(t){t=t.previousSibling;for(var e=0;t;){if(8===t.nodeType){var n=t.data;if("$"===n||"$!"===n||"$?"===n){if(0===e)return t;e--}else"/$"===n&&e++}t=t.previousSibling}return null}var Jr=0;var Ur=Math.random().toString(36).slice(2),Kr="__reactFiber$"+Ur,Hr="__reactProps$"+Ur,Vr="__reactContainer$"+Ur,Zr="__reactEvents$"+Ur;function Xr(t){var e=t[Kr];if(e)return e;for(var n=t.parentNode;n;){if(e=n[Vr]||n[Kr]){if(n=e.alternate,null!==e.child||null!==n&&null!==n.child)for(t=Gr(t);null!==t;){if(n=t[Kr])return n;t=Gr(t)}return e}n=(t=n).parentNode}return null}function _r(t){return!(t=t[Kr]||t[Vr])||5!==t.tag&&6!==t.tag&&13!==t.tag&&3!==t.tag?null:t}function $r(t){if(5===t.tag||6===t.tag)return t.stateNode;throw Error(a(33))}function ti(t){return t[Hr]||null}function ei(t){var e=t[Zr];return void 0===e&&(e=t[Zr]=new Set),e}var ni=[],ri=-1;function ii(t){return{current:t}}function oi(t){0>ri||(t.current=ni[ri],ni[ri]=null,ri--)}function ai(t,e){ri++,ni[ri]=t.current,t.current=e}var si={},ci=ii(si),li=ii(!1),ui=si;function di(t,e){var n=t.type.contextTypes;if(!n)return si;var r=t.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===e)return r.__reactInternalMemoizedMaskedChildContext;var i,o={};for(i in n)o[i]=e[i];return r&&((t=t.stateNode).__reactInternalMemoizedUnmaskedChildContext=e,t.__reactInternalMemoizedMaskedChildContext=o),o}function fi(t){return null!=(t=t.childContextTypes)}function hi(){oi(li),oi(ci)}function pi(t,e,n){if(ci.current!==si)throw Error(a(168));ai(ci,e),ai(li,n)}function gi(t,e,n){var r=t.stateNode;if(t=e.childContextTypes,"function"!=typeof r.getChildContext)return n;for(var o in r=r.getChildContext())if(!(o in t))throw Error(a(108,K(e)||"Unknown",o));return i({},n,r)}function mi(t){return t=(t=t.stateNode)&&t.__reactInternalMemoizedMergedChildContext||si,ui=ci.current,ai(ci,t),ai(li,li.current),!0}function yi(t,e,n){var r=t.stateNode;if(!r)throw Error(a(169));n?(t=gi(t,e,ui),r.__reactInternalMemoizedMergedChildContext=t,oi(li),oi(ci),ai(ci,t)):oi(li),ai(li,n)}var vi=null,bi=null,ki=o.unstable_runWithPriority,wi=o.unstable_scheduleCallback,xi=o.unstable_cancelCallback,Ai=o.unstable_shouldYield,Si=o.unstable_requestPaint,Oi=o.unstable_now,Ei=o.unstable_getCurrentPriorityLevel,Mi=o.unstable_ImmediatePriority,Ci=o.unstable_UserBlockingPriority,Ri=o.unstable_NormalPriority,ji=o.unstable_LowPriority,Ii=o.unstable_IdlePriority,Bi={},Di=void 0!==Si?Si:function(){},Ti=null,Fi=null,Pi=!1,zi=Oi(),Qi=1e4>zi?Oi:function(){return Oi()-zi};function Li(){switch(Ei()){case Mi:return 99;case Ci:return 98;case Ri:return 97;case ji:return 96;case Ii:return 95;default:throw Error(a(332))}}function Yi(t){switch(t){case 99:return Mi;case 98:return Ci;case 97:return Ri;case 96:return ji;case 95:return Ii;default:throw Error(a(332))}}function Wi(t,e){return t=Yi(t),ki(t,e)}function qi(t,e,n){return t=Yi(t),wi(t,e,n)}function Ni(){if(null!==Fi){var t=Fi;Fi=null,xi(t)}Gi()}function Gi(){if(!Pi&&null!==Ti){Pi=!0;var t=0;try{var e=Ti;Wi(99,(function(){for(;t<e.length;t++){var n=e[t];do{n=n(!0)}while(null!==n)}})),Ti=null}catch(e){throw null!==Ti&&(Ti=Ti.slice(t+1)),wi(Mi,Ni),e}finally{Pi=!1}}}var Ji=w.ReactCurrentBatchConfig;function Ui(t,e){if(t&&t.defaultProps){for(var n in e=i({},e),t=t.defaultProps)void 0===e[n]&&(e[n]=t[n]);return e}return e}var Ki=ii(null),Hi=null,Vi=null,Zi=null;function Xi(){Zi=Vi=Hi=null}function _i(t){var e=Ki.current;oi(Ki),t.type._context._currentValue=e}function $i(t,e){for(;null!==t;){var n=t.alternate;if((t.childLanes&e)===e){if(null===n||(n.childLanes&e)===e)break;n.childLanes|=e}else t.childLanes|=e,null!==n&&(n.childLanes|=e);t=t.return}}function to(t,e){Hi=t,Zi=Vi=null,null!==(t=t.dependencies)&&null!==t.firstContext&&(0!=(t.lanes&e)&&(Ba=!0),t.firstContext=null)}function eo(t,e){if(Zi!==t&&!1!==e&&0!==e)if("number"==typeof e&&1073741823!==e||(Zi=t,e=1073741823),e={context:t,observedBits:e,next:null},null===Vi){if(null===Hi)throw Error(a(308));Vi=e,Hi.dependencies={lanes:0,firstContext:e,responders:null}}else Vi=Vi.next=e;return t._currentValue}var no=!1;function ro(t){t.updateQueue={baseState:t.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}function io(t,e){t=t.updateQueue,e.updateQueue===t&&(e.updateQueue={baseState:t.baseState,firstBaseUpdate:t.firstBaseUpdate,lastBaseUpdate:t.lastBaseUpdate,shared:t.shared,effects:t.effects})}function oo(t,e){return{eventTime:t,lane:e,tag:0,payload:null,callback:null,next:null}}function ao(t,e){if(null!==(t=t.updateQueue)){var n=(t=t.shared).pending;null===n?e.next=e:(e.next=n.next,n.next=e),t.pending=e}}function so(t,e){var n=t.updateQueue,r=t.alternate;if(null!==r&&n===(r=r.updateQueue)){var i=null,o=null;if(null!==(n=n.firstBaseUpdate)){do{var a={eventTime:n.eventTime,lane:n.lane,tag:n.tag,payload:n.payload,callback:n.callback,next:null};null===o?i=o=a:o=o.next=a,n=n.next}while(null!==n);null===o?i=o=e:o=o.next=e}else i=o=e;return n={baseState:r.baseState,firstBaseUpdate:i,lastBaseUpdate:o,shared:r.shared,effects:r.effects},void(t.updateQueue=n)}null===(t=n.lastBaseUpdate)?n.firstBaseUpdate=e:t.next=e,n.lastBaseUpdate=e}function co(t,e,n,r){var o=t.updateQueue;no=!1;var a=o.firstBaseUpdate,s=o.lastBaseUpdate,c=o.shared.pending;if(null!==c){o.shared.pending=null;var l=c,u=l.next;l.next=null,null===s?a=u:s.next=u,s=l;var d=t.alternate;if(null!==d){var f=(d=d.updateQueue).lastBaseUpdate;f!==s&&(null===f?d.firstBaseUpdate=u:f.next=u,d.lastBaseUpdate=l)}}if(null!==a){for(f=o.baseState,s=0,d=u=l=null;;){c=a.lane;var h=a.eventTime;if((r&c)===c){null!==d&&(d=d.next={eventTime:h,lane:0,tag:a.tag,payload:a.payload,callback:a.callback,next:null});t:{var p=t,g=a;switch(c=e,h=n,g.tag){case 1:if("function"==typeof(p=g.payload)){f=p.call(h,f,c);break t}f=p;break t;case 3:p.flags=-4097&p.flags|64;case 0:if(null==(c="function"==typeof(p=g.payload)?p.call(h,f,c):p))break t;f=i({},f,c);break t;case 2:no=!0}}null!==a.callback&&(t.flags|=32,null===(c=o.effects)?o.effects=[a]:c.push(a))}else h={eventTime:h,lane:c,tag:a.tag,payload:a.payload,callback:a.callback,next:null},null===d?(u=d=h,l=f):d=d.next=h,s|=c;if(null===(a=a.next)){if(null===(c=o.shared.pending))break;a=c.next,c.next=null,o.lastBaseUpdate=c,o.shared.pending=null}}null===d&&(l=f),o.baseState=l,o.firstBaseUpdate=u,o.lastBaseUpdate=d,Ts|=s,t.lanes=s,t.memoizedState=f}}function lo(t,e,n){if(t=e.effects,e.effects=null,null!==t)for(e=0;e<t.length;e++){var r=t[e],i=r.callback;if(null!==i){if(r.callback=null,r=n,"function"!=typeof i)throw Error(a(191,i));i.call(r)}}}var uo=(new r.Component).refs;function fo(t,e,n,r){n=null==(n=n(r,e=t.memoizedState))?e:i({},e,n),t.memoizedState=n,0===t.lanes&&(t.updateQueue.baseState=n)}var ho={isMounted:function(t){return!!(t=t._reactInternals)&&Vt(t)===t},enqueueSetState:function(t,e,n){t=t._reactInternals;var r=oc(),i=ac(t),o=oo(r,i);o.payload=e,null!=n&&(o.callback=n),ao(t,o),sc(t,i,r)},enqueueReplaceState:function(t,e,n){t=t._reactInternals;var r=oc(),i=ac(t),o=oo(r,i);o.tag=1,o.payload=e,null!=n&&(o.callback=n),ao(t,o),sc(t,i,r)},enqueueForceUpdate:function(t,e){t=t._reactInternals;var n=oc(),r=ac(t),i=oo(n,r);i.tag=2,null!=e&&(i.callback=e),ao(t,i),sc(t,r,n)}};function po(t,e,n,r,i,o,a){return"function"==typeof(t=t.stateNode).shouldComponentUpdate?t.shouldComponentUpdate(r,o,a):!e.prototype||!e.prototype.isPureReactComponent||(!cr(n,r)||!cr(i,o))}function go(t,e,n){var r=!1,i=si,o=e.contextType;return"object"==typeof o&&null!==o?o=eo(o):(i=fi(e)?ui:ci.current,o=(r=null!=(r=e.contextTypes))?di(t,i):si),e=new e(n,o),t.memoizedState=null!==e.state&&void 0!==e.state?e.state:null,e.updater=ho,t.stateNode=e,e._reactInternals=t,r&&((t=t.stateNode).__reactInternalMemoizedUnmaskedChildContext=i,t.__reactInternalMemoizedMaskedChildContext=o),e}function mo(t,e,n,r){t=e.state,"function"==typeof e.componentWillReceiveProps&&e.componentWillReceiveProps(n,r),"function"==typeof e.UNSAFE_componentWillReceiveProps&&e.UNSAFE_componentWillReceiveProps(n,r),e.state!==t&&ho.enqueueReplaceState(e,e.state,null)}function yo(t,e,n,r){var i=t.stateNode;i.props=n,i.state=t.memoizedState,i.refs=uo,ro(t);var o=e.contextType;"object"==typeof o&&null!==o?i.context=eo(o):(o=fi(e)?ui:ci.current,i.context=di(t,o)),co(t,n,i,r),i.state=t.memoizedState,"function"==typeof(o=e.getDerivedStateFromProps)&&(fo(t,e,o,n),i.state=t.memoizedState),"function"==typeof e.getDerivedStateFromProps||"function"==typeof i.getSnapshotBeforeUpdate||"function"!=typeof i.UNSAFE_componentWillMount&&"function"!=typeof i.componentWillMount||(e=i.state,"function"==typeof i.componentWillMount&&i.componentWillMount(),"function"==typeof i.UNSAFE_componentWillMount&&i.UNSAFE_componentWillMount(),e!==i.state&&ho.enqueueReplaceState(i,i.state,null),co(t,n,i,r),i.state=t.memoizedState),"function"==typeof i.componentDidMount&&(t.flags|=4)}var vo=Array.isArray;function bo(t,e,n){if(null!==(t=n.ref)&&"function"!=typeof t&&"object"!=typeof t){if(n._owner){if(n=n._owner){if(1!==n.tag)throw Error(a(309));var r=n.stateNode}if(!r)throw Error(a(147,t));var i=""+t;return null!==e&&null!==e.ref&&"function"==typeof e.ref&&e.ref._stringRef===i?e.ref:((e=function(t){var e=r.refs;e===uo&&(e=r.refs={}),null===t?delete e[i]:e[i]=t})._stringRef=i,e)}if("string"!=typeof t)throw Error(a(284));if(!n._owner)throw Error(a(290,t))}return t}function ko(t,e){if("textarea"!==t.type)throw Error(a(31,"[object Object]"===Object.prototype.toString.call(e)?"object with keys {"+Object.keys(e).join(", ")+"}":e))}function wo(t){function e(e,n){if(t){var r=e.lastEffect;null!==r?(r.nextEffect=n,e.lastEffect=n):e.firstEffect=e.lastEffect=n,n.nextEffect=null,n.flags=8}}function n(n,r){if(!t)return null;for(;null!==r;)e(n,r),r=r.sibling;return null}function r(t,e){for(t=new Map;null!==e;)null!==e.key?t.set(e.key,e):t.set(e.index,e),e=e.sibling;return t}function i(t,e){return(t=Lc(t,e)).index=0,t.sibling=null,t}function o(e,n,r){return e.index=r,t?null!==(r=e.alternate)?(r=r.index)<n?(e.flags=2,n):r:(e.flags=2,n):n}function s(e){return t&&null===e.alternate&&(e.flags=2),e}function c(t,e,n,r){return null===e||6!==e.tag?((e=Nc(n,t.mode,r)).return=t,e):((e=i(e,n)).return=t,e)}function l(t,e,n,r){return null!==e&&e.elementType===n.type?((r=i(e,n.props)).ref=bo(t,e,n),r.return=t,r):((r=Yc(n.type,n.key,n.props,null,t.mode,r)).ref=bo(t,e,n),r.return=t,r)}function u(t,e,n,r){return null===e||4!==e.tag||e.stateNode.containerInfo!==n.containerInfo||e.stateNode.implementation!==n.implementation?((e=Gc(n,t.mode,r)).return=t,e):((e=i(e,n.children||[])).return=t,e)}function d(t,e,n,r,o){return null===e||7!==e.tag?((e=Wc(n,t.mode,r,o)).return=t,e):((e=i(e,n)).return=t,e)}function f(t,e,n){if("string"==typeof e||"number"==typeof e)return(e=Nc(""+e,t.mode,n)).return=t,e;if("object"==typeof e&&null!==e){switch(e.$$typeof){case x:return(n=Yc(e.type,e.key,e.props,null,t.mode,n)).ref=bo(t,null,e),n.return=t,n;case A:return(e=Gc(e,t.mode,n)).return=t,e}if(vo(e)||q(e))return(e=Wc(e,t.mode,n,null)).return=t,e;ko(t,e)}return null}function h(t,e,n,r){var i=null!==e?e.key:null;if("string"==typeof n||"number"==typeof n)return null!==i?null:c(t,e,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case x:return n.key===i?n.type===S?d(t,e,n.props.children,r,i):l(t,e,n,r):null;case A:return n.key===i?u(t,e,n,r):null}if(vo(n)||q(n))return null!==i?null:d(t,e,n,r,null);ko(t,n)}return null}function p(t,e,n,r,i){if("string"==typeof r||"number"==typeof r)return c(e,t=t.get(n)||null,""+r,i);if("object"==typeof r&&null!==r){switch(r.$$typeof){case x:return t=t.get(null===r.key?n:r.key)||null,r.type===S?d(e,t,r.props.children,i,r.key):l(e,t,r,i);case A:return u(e,t=t.get(null===r.key?n:r.key)||null,r,i)}if(vo(r)||q(r))return d(e,t=t.get(n)||null,r,i,null);ko(e,r)}return null}function g(i,a,s,c){for(var l=null,u=null,d=a,g=a=0,m=null;null!==d&&g<s.length;g++){d.index>g?(m=d,d=null):m=d.sibling;var y=h(i,d,s[g],c);if(null===y){null===d&&(d=m);break}t&&d&&null===y.alternate&&e(i,d),a=o(y,a,g),null===u?l=y:u.sibling=y,u=y,d=m}if(g===s.length)return n(i,d),l;if(null===d){for(;g<s.length;g++)null!==(d=f(i,s[g],c))&&(a=o(d,a,g),null===u?l=d:u.sibling=d,u=d);return l}for(d=r(i,d);g<s.length;g++)null!==(m=p(d,i,g,s[g],c))&&(t&&null!==m.alternate&&d.delete(null===m.key?g:m.key),a=o(m,a,g),null===u?l=m:u.sibling=m,u=m);return t&&d.forEach((function(t){return e(i,t)})),l}function m(i,s,c,l){var u=q(c);if("function"!=typeof u)throw Error(a(150));if(null==(c=u.call(c)))throw Error(a(151));for(var d=u=null,g=s,m=s=0,y=null,v=c.next();null!==g&&!v.done;m++,v=c.next()){g.index>m?(y=g,g=null):y=g.sibling;var b=h(i,g,v.value,l);if(null===b){null===g&&(g=y);break}t&&g&&null===b.alternate&&e(i,g),s=o(b,s,m),null===d?u=b:d.sibling=b,d=b,g=y}if(v.done)return n(i,g),u;if(null===g){for(;!v.done;m++,v=c.next())null!==(v=f(i,v.value,l))&&(s=o(v,s,m),null===d?u=v:d.sibling=v,d=v);return u}for(g=r(i,g);!v.done;m++,v=c.next())null!==(v=p(g,i,m,v.value,l))&&(t&&null!==v.alternate&&g.delete(null===v.key?m:v.key),s=o(v,s,m),null===d?u=v:d.sibling=v,d=v);return t&&g.forEach((function(t){return e(i,t)})),u}return function(t,r,o,c){var l="object"==typeof o&&null!==o&&o.type===S&&null===o.key;l&&(o=o.props.children);var u="object"==typeof o&&null!==o;if(u)switch(o.$$typeof){case x:t:{for(u=o.key,l=r;null!==l;){if(l.key===u){switch(l.tag){case 7:if(o.type===S){n(t,l.sibling),(r=i(l,o.props.children)).return=t,t=r;break t}break;default:if(l.elementType===o.type){n(t,l.sibling),(r=i(l,o.props)).ref=bo(t,l,o),r.return=t,t=r;break t}}n(t,l);break}e(t,l),l=l.sibling}o.type===S?((r=Wc(o.props.children,t.mode,c,o.key)).return=t,t=r):((c=Yc(o.type,o.key,o.props,null,t.mode,c)).ref=bo(t,r,o),c.return=t,t=c)}return s(t);case A:t:{for(l=o.key;null!==r;){if(r.key===l){if(4===r.tag&&r.stateNode.containerInfo===o.containerInfo&&r.stateNode.implementation===o.implementation){n(t,r.sibling),(r=i(r,o.children||[])).return=t,t=r;break t}n(t,r);break}e(t,r),r=r.sibling}(r=Gc(o,t.mode,c)).return=t,t=r}return s(t)}if("string"==typeof o||"number"==typeof o)return o=""+o,null!==r&&6===r.tag?(n(t,r.sibling),(r=i(r,o)).return=t,t=r):(n(t,r),(r=Nc(o,t.mode,c)).return=t,t=r),s(t);if(vo(o))return g(t,r,o,c);if(q(o))return m(t,r,o,c);if(u&&ko(t,o),void 0===o&&!l)switch(t.tag){case 1:case 22:case 0:case 11:case 15:throw Error(a(152,K(t.type)||"Component"))}return n(t,r)}}var xo=wo(!0),Ao=wo(!1),So={},Oo=ii(So),Eo=ii(So),Mo=ii(So);function Co(t){if(t===So)throw Error(a(174));return t}function Ro(t,e){switch(ai(Mo,e),ai(Eo,t),ai(Oo,So),t=e.nodeType){case 9:case 11:e=(e=e.documentElement)?e.namespaceURI:pt(null,"");break;default:e=pt(e=(t=8===t?e.parentNode:e).namespaceURI||null,t=t.tagName)}oi(Oo),ai(Oo,e)}function jo(){oi(Oo),oi(Eo),oi(Mo)}function Io(t){Co(Mo.current);var e=Co(Oo.current),n=pt(e,t.type);e!==n&&(ai(Eo,t),ai(Oo,n))}function Bo(t){Eo.current===t&&(oi(Oo),oi(Eo))}var Do=ii(0);function To(t){for(var e=t;null!==e;){if(13===e.tag){var n=e.memoizedState;if(null!==n&&(null===(n=n.dehydrated)||"$?"===n.data||"$!"===n.data))return e}else if(19===e.tag&&void 0!==e.memoizedProps.revealOrder){if(0!=(64&e.flags))return e}else if(null!==e.child){e.child.return=e,e=e.child;continue}if(e===t)break;for(;null===e.sibling;){if(null===e.return||e.return===t)return null;e=e.return}e.sibling.return=e.return,e=e.sibling}return null}var Fo=null,Po=null,zo=!1;function Qo(t,e){var n=zc(5,null,null,0);n.elementType="DELETED",n.type="DELETED",n.stateNode=e,n.return=t,n.flags=8,null!==t.lastEffect?(t.lastEffect.nextEffect=n,t.lastEffect=n):t.firstEffect=t.lastEffect=n}function Lo(t,e){switch(t.tag){case 5:var n=t.type;return null!==(e=1!==e.nodeType||n.toLowerCase()!==e.nodeName.toLowerCase()?null:e)&&(t.stateNode=e,!0);case 6:return null!==(e=""===t.pendingProps||3!==e.nodeType?null:e)&&(t.stateNode=e,!0);case 13:default:return!1}}function Yo(t){if(zo){var e=Po;if(e){var n=e;if(!Lo(t,e)){if(!(e=Nr(n.nextSibling))||!Lo(t,e))return t.flags=-1025&t.flags|2,zo=!1,void(Fo=t);Qo(Fo,n)}Fo=t,Po=Nr(e.firstChild)}else t.flags=-1025&t.flags|2,zo=!1,Fo=t}}function Wo(t){for(t=t.return;null!==t&&5!==t.tag&&3!==t.tag&&13!==t.tag;)t=t.return;Fo=t}function qo(t){if(t!==Fo)return!1;if(!zo)return Wo(t),zo=!0,!1;var e=t.type;if(5!==t.tag||"head"!==e&&"body"!==e&&!Lr(e,t.memoizedProps))for(e=Po;e;)Qo(t,e),e=Nr(e.nextSibling);if(Wo(t),13===t.tag){if(!(t=null!==(t=t.memoizedState)?t.dehydrated:null))throw Error(a(317));t:{for(t=t.nextSibling,e=0;t;){if(8===t.nodeType){var n=t.data;if("/$"===n){if(0===e){Po=Nr(t.nextSibling);break t}e--}else"$"!==n&&"$!"!==n&&"$?"!==n||e++}t=t.nextSibling}Po=null}}else Po=Fo?Nr(t.stateNode.nextSibling):null;return!0}function No(){Po=Fo=null,zo=!1}var Go=[];function Jo(){for(var t=0;t<Go.length;t++)Go[t]._workInProgressVersionPrimary=null;Go.length=0}var Uo=w.ReactCurrentDispatcher,Ko=w.ReactCurrentBatchConfig,Ho=0,Vo=null,Zo=null,Xo=null,_o=!1,$o=!1;function ta(){throw Error(a(321))}function ea(t,e){if(null===e)return!1;for(var n=0;n<e.length&&n<t.length;n++)if(!ar(t[n],e[n]))return!1;return!0}function na(t,e,n,r,i,o){if(Ho=o,Vo=e,e.memoizedState=null,e.updateQueue=null,e.lanes=0,Uo.current=null===t||null===t.memoizedState?Ca:Ra,t=n(r,i),$o){o=0;do{if($o=!1,!(25>o))throw Error(a(301));o+=1,Xo=Zo=null,e.updateQueue=null,Uo.current=ja,t=n(r,i)}while($o)}if(Uo.current=Ma,e=null!==Zo&&null!==Zo.next,Ho=0,Xo=Zo=Vo=null,_o=!1,e)throw Error(a(300));return t}function ra(){var t={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return null===Xo?Vo.memoizedState=Xo=t:Xo=Xo.next=t,Xo}function ia(){if(null===Zo){var t=Vo.alternate;t=null!==t?t.memoizedState:null}else t=Zo.next;var e=null===Xo?Vo.memoizedState:Xo.next;if(null!==e)Xo=e,Zo=t;else{if(null===t)throw Error(a(310));t={memoizedState:(Zo=t).memoizedState,baseState:Zo.baseState,baseQueue:Zo.baseQueue,queue:Zo.queue,next:null},null===Xo?Vo.memoizedState=Xo=t:Xo=Xo.next=t}return Xo}function oa(t,e){return"function"==typeof e?e(t):e}function aa(t){var e=ia(),n=e.queue;if(null===n)throw Error(a(311));n.lastRenderedReducer=t;var r=Zo,i=r.baseQueue,o=n.pending;if(null!==o){if(null!==i){var s=i.next;i.next=o.next,o.next=s}r.baseQueue=i=o,n.pending=null}if(null!==i){i=i.next,r=r.baseState;var c=s=o=null,l=i;do{var u=l.lane;if((Ho&u)===u)null!==c&&(c=c.next={lane:0,action:l.action,eagerReducer:l.eagerReducer,eagerState:l.eagerState,next:null}),r=l.eagerReducer===t?l.eagerState:t(r,l.action);else{var d={lane:u,action:l.action,eagerReducer:l.eagerReducer,eagerState:l.eagerState,next:null};null===c?(s=c=d,o=r):c=c.next=d,Vo.lanes|=u,Ts|=u}l=l.next}while(null!==l&&l!==i);null===c?o=r:c.next=s,ar(r,e.memoizedState)||(Ba=!0),e.memoizedState=r,e.baseState=o,e.baseQueue=c,n.lastRenderedState=r}return[e.memoizedState,n.dispatch]}function sa(t){var e=ia(),n=e.queue;if(null===n)throw Error(a(311));n.lastRenderedReducer=t;var r=n.dispatch,i=n.pending,o=e.memoizedState;if(null!==i){n.pending=null;var s=i=i.next;do{o=t(o,s.action),s=s.next}while(s!==i);ar(o,e.memoizedState)||(Ba=!0),e.memoizedState=o,null===e.baseQueue&&(e.baseState=o),n.lastRenderedState=o}return[o,r]}function ca(t,e,n){var r=e._getVersion;r=r(e._source);var i=e._workInProgressVersionPrimary;if(null!==i?t=i===r:(t=t.mutableReadLanes,(t=(Ho&t)===t)&&(e._workInProgressVersionPrimary=r,Go.push(e))),t)return n(e._source);throw Go.push(e),Error(a(350))}function la(t,e,n,r){var i=Es;if(null===i)throw Error(a(349));var o=e._getVersion,s=o(e._source),c=Uo.current,l=c.useState((function(){return ca(i,e,n)})),u=l[1],d=l[0];l=Xo;var f=t.memoizedState,h=f.refs,p=h.getSnapshot,g=f.source;f=f.subscribe;var m=Vo;return t.memoizedState={refs:h,source:e,subscribe:r},c.useEffect((function(){h.getSnapshot=n,h.setSnapshot=u;var t=o(e._source);if(!ar(s,t)){t=n(e._source),ar(d,t)||(u(t),t=ac(m),i.mutableReadLanes|=t&i.pendingLanes),t=i.mutableReadLanes,i.entangledLanes|=t;for(var r=i.entanglements,a=t;0<a;){var c=31-Ne(a),l=1<<c;r[c]|=t,a&=~l}}}),[n,e,r]),c.useEffect((function(){return r(e._source,(function(){var t=h.getSnapshot,n=h.setSnapshot;try{n(t(e._source));var r=ac(m);i.mutableReadLanes|=r&i.pendingLanes}catch(t){n((function(){throw t}))}}))}),[e,r]),ar(p,n)&&ar(g,e)&&ar(f,r)||((t={pending:null,dispatch:null,lastRenderedReducer:oa,lastRenderedState:d}).dispatch=u=Ea.bind(null,Vo,t),l.queue=t,l.baseQueue=null,d=ca(i,e,n),l.memoizedState=l.baseState=d),d}function ua(t,e,n){return la(ia(),t,e,n)}function da(t){var e=ra();return"function"==typeof t&&(t=t()),e.memoizedState=e.baseState=t,t=(t=e.queue={pending:null,dispatch:null,lastRenderedReducer:oa,lastRenderedState:t}).dispatch=Ea.bind(null,Vo,t),[e.memoizedState,t]}function fa(t,e,n,r){return t={tag:t,create:e,destroy:n,deps:r,next:null},null===(e=Vo.updateQueue)?(e={lastEffect:null},Vo.updateQueue=e,e.lastEffect=t.next=t):null===(n=e.lastEffect)?e.lastEffect=t.next=t:(r=n.next,n.next=t,t.next=r,e.lastEffect=t),t}function ha(t){return t={current:t},ra().memoizedState=t}function pa(){return ia().memoizedState}function ga(t,e,n,r){var i=ra();Vo.flags|=t,i.memoizedState=fa(1|e,n,void 0,void 0===r?null:r)}function ma(t,e,n,r){var i=ia();r=void 0===r?null:r;var o=void 0;if(null!==Zo){var a=Zo.memoizedState;if(o=a.destroy,null!==r&&ea(r,a.deps))return void fa(e,n,o,r)}Vo.flags|=t,i.memoizedState=fa(1|e,n,o,r)}function ya(t,e){return ga(516,4,t,e)}function va(t,e){return ma(516,4,t,e)}function ba(t,e){return ma(4,2,t,e)}function ka(t,e){return"function"==typeof e?(t=t(),e(t),function(){e(null)}):null!=e?(t=t(),e.current=t,function(){e.current=null}):void 0}function wa(t,e,n){return n=null!=n?n.concat([t]):null,ma(4,2,ka.bind(null,e,t),n)}function xa(){}function Aa(t,e){var n=ia();e=void 0===e?null:e;var r=n.memoizedState;return null!==r&&null!==e&&ea(e,r[1])?r[0]:(n.memoizedState=[t,e],t)}function Sa(t,e){var n=ia();e=void 0===e?null:e;var r=n.memoizedState;return null!==r&&null!==e&&ea(e,r[1])?r[0]:(t=t(),n.memoizedState=[t,e],t)}function Oa(t,e){var n=Li();Wi(98>n?98:n,(function(){t(!0)})),Wi(97<n?97:n,(function(){var n=Ko.transition;Ko.transition=1;try{t(!1),e()}finally{Ko.transition=n}}))}function Ea(t,e,n){var r=oc(),i=ac(t),o={lane:i,action:n,eagerReducer:null,eagerState:null,next:null},a=e.pending;if(null===a?o.next=o:(o.next=a.next,a.next=o),e.pending=o,a=t.alternate,t===Vo||null!==a&&a===Vo)$o=_o=!0;else{if(0===t.lanes&&(null===a||0===a.lanes)&&null!==(a=e.lastRenderedReducer))try{var s=e.lastRenderedState,c=a(s,n);if(o.eagerReducer=a,o.eagerState=c,ar(c,s))return}catch(t){}sc(t,i,r)}}var Ma={readContext:eo,useCallback:ta,useContext:ta,useEffect:ta,useImperativeHandle:ta,useLayoutEffect:ta,useMemo:ta,useReducer:ta,useRef:ta,useState:ta,useDebugValue:ta,useDeferredValue:ta,useTransition:ta,useMutableSource:ta,useOpaqueIdentifier:ta,unstable_isNewReconciler:!1},Ca={readContext:eo,useCallback:function(t,e){return ra().memoizedState=[t,void 0===e?null:e],t},useContext:eo,useEffect:ya,useImperativeHandle:function(t,e,n){return n=null!=n?n.concat([t]):null,ga(4,2,ka.bind(null,e,t),n)},useLayoutEffect:function(t,e){return ga(4,2,t,e)},useMemo:function(t,e){var n=ra();return e=void 0===e?null:e,t=t(),n.memoizedState=[t,e],t},useReducer:function(t,e,n){var r=ra();return e=void 0!==n?n(e):e,r.memoizedState=r.baseState=e,t=(t=r.queue={pending:null,dispatch:null,lastRenderedReducer:t,lastRenderedState:e}).dispatch=Ea.bind(null,Vo,t),[r.memoizedState,t]},useRef:ha,useState:da,useDebugValue:xa,useDeferredValue:function(t){var e=da(t),n=e[0],r=e[1];return ya((function(){var e=Ko.transition;Ko.transition=1;try{r(t)}finally{Ko.transition=e}}),[t]),n},useTransition:function(){var t=da(!1),e=t[0];return ha(t=Oa.bind(null,t[1])),[t,e]},useMutableSource:function(t,e,n){var r=ra();return r.memoizedState={refs:{getSnapshot:e,setSnapshot:null},source:t,subscribe:n},la(r,t,e,n)},useOpaqueIdentifier:function(){if(zo){var t=!1,e=function(t){return{$$typeof:F,toString:t,valueOf:t}}((function(){throw t||(t=!0,n("r:"+(Jr++).toString(36))),Error(a(355))})),n=da(e)[1];return 0==(2&Vo.mode)&&(Vo.flags|=516,fa(5,(function(){n("r:"+(Jr++).toString(36))}),void 0,null)),e}return da(e="r:"+(Jr++).toString(36)),e},unstable_isNewReconciler:!1},Ra={readContext:eo,useCallback:Aa,useContext:eo,useEffect:va,useImperativeHandle:wa,useLayoutEffect:ba,useMemo:Sa,useReducer:aa,useRef:pa,useState:function(){return aa(oa)},useDebugValue:xa,useDeferredValue:function(t){var e=aa(oa),n=e[0],r=e[1];return va((function(){var e=Ko.transition;Ko.transition=1;try{r(t)}finally{Ko.transition=e}}),[t]),n},useTransition:function(){var t=aa(oa)[0];return[pa().current,t]},useMutableSource:ua,useOpaqueIdentifier:function(){return aa(oa)[0]},unstable_isNewReconciler:!1},ja={readContext:eo,useCallback:Aa,useContext:eo,useEffect:va,useImperativeHandle:wa,useLayoutEffect:ba,useMemo:Sa,useReducer:sa,useRef:pa,useState:function(){return sa(oa)},useDebugValue:xa,useDeferredValue:function(t){var e=sa(oa),n=e[0],r=e[1];return va((function(){var e=Ko.transition;Ko.transition=1;try{r(t)}finally{Ko.transition=e}}),[t]),n},useTransition:function(){var t=sa(oa)[0];return[pa().current,t]},useMutableSource:ua,useOpaqueIdentifier:function(){return sa(oa)[0]},unstable_isNewReconciler:!1},Ia=w.ReactCurrentOwner,Ba=!1;function Da(t,e,n,r){e.child=null===t?Ao(e,null,n,r):xo(e,t.child,n,r)}function Ta(t,e,n,r,i){n=n.render;var o=e.ref;return to(e,i),r=na(t,e,n,r,o,i),null===t||Ba?(e.flags|=1,Da(t,e,r,i),e.child):(e.updateQueue=t.updateQueue,e.flags&=-517,t.lanes&=~i,ts(t,e,i))}function Fa(t,e,n,r,i,o){if(null===t){var a=n.type;return"function"!=typeof a||Qc(a)||void 0!==a.defaultProps||null!==n.compare||void 0!==n.defaultProps?((t=Yc(n.type,null,r,e,e.mode,o)).ref=e.ref,t.return=e,e.child=t):(e.tag=15,e.type=a,Pa(t,e,a,r,i,o))}return a=t.child,0==(i&o)&&(i=a.memoizedProps,(n=null!==(n=n.compare)?n:cr)(i,r)&&t.ref===e.ref)?ts(t,e,o):(e.flags|=1,(t=Lc(a,r)).ref=e.ref,t.return=e,e.child=t)}function Pa(t,e,n,r,i,o){if(null!==t&&cr(t.memoizedProps,r)&&t.ref===e.ref){if(Ba=!1,0==(o&i))return e.lanes=t.lanes,ts(t,e,o);0!=(16384&t.flags)&&(Ba=!0)}return La(t,e,n,r,o)}function za(t,e,n){var r=e.pendingProps,i=r.children,o=null!==t?t.memoizedState:null;if("hidden"===r.mode||"unstable-defer-without-hiding"===r.mode)if(0==(4&e.mode))e.memoizedState={baseLanes:0},gc(e,n);else{if(0==(1073741824&n))return t=null!==o?o.baseLanes|n:n,e.lanes=e.childLanes=1073741824,e.memoizedState={baseLanes:t},gc(e,t),null;e.memoizedState={baseLanes:0},gc(e,null!==o?o.baseLanes:n)}else null!==o?(r=o.baseLanes|n,e.memoizedState=null):r=n,gc(e,r);return Da(t,e,i,n),e.child}function Qa(t,e){var n=e.ref;(null===t&&null!==n||null!==t&&t.ref!==n)&&(e.flags|=128)}function La(t,e,n,r,i){var o=fi(n)?ui:ci.current;return o=di(e,o),to(e,i),n=na(t,e,n,r,o,i),null===t||Ba?(e.flags|=1,Da(t,e,n,i),e.child):(e.updateQueue=t.updateQueue,e.flags&=-517,t.lanes&=~i,ts(t,e,i))}function Ya(t,e,n,r,i){if(fi(n)){var o=!0;mi(e)}else o=!1;if(to(e,i),null===e.stateNode)null!==t&&(t.alternate=null,e.alternate=null,e.flags|=2),go(e,n,r),yo(e,n,r,i),r=!0;else if(null===t){var a=e.stateNode,s=e.memoizedProps;a.props=s;var c=a.context,l=n.contextType;"object"==typeof l&&null!==l?l=eo(l):l=di(e,l=fi(n)?ui:ci.current);var u=n.getDerivedStateFromProps,d="function"==typeof u||"function"==typeof a.getSnapshotBeforeUpdate;d||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(s!==r||c!==l)&&mo(e,a,r,l),no=!1;var f=e.memoizedState;a.state=f,co(e,r,a,i),c=e.memoizedState,s!==r||f!==c||li.current||no?("function"==typeof u&&(fo(e,n,u,r),c=e.memoizedState),(s=no||po(e,n,s,r,f,c,l))?(d||"function"!=typeof a.UNSAFE_componentWillMount&&"function"!=typeof a.componentWillMount||("function"==typeof a.componentWillMount&&a.componentWillMount(),"function"==typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount()),"function"==typeof a.componentDidMount&&(e.flags|=4)):("function"==typeof a.componentDidMount&&(e.flags|=4),e.memoizedProps=r,e.memoizedState=c),a.props=r,a.state=c,a.context=l,r=s):("function"==typeof a.componentDidMount&&(e.flags|=4),r=!1)}else{a=e.stateNode,io(t,e),s=e.memoizedProps,l=e.type===e.elementType?s:Ui(e.type,s),a.props=l,d=e.pendingProps,f=a.context,"object"==typeof(c=n.contextType)&&null!==c?c=eo(c):c=di(e,c=fi(n)?ui:ci.current);var h=n.getDerivedStateFromProps;(u="function"==typeof h||"function"==typeof a.getSnapshotBeforeUpdate)||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(s!==d||f!==c)&&mo(e,a,r,c),no=!1,f=e.memoizedState,a.state=f,co(e,r,a,i);var p=e.memoizedState;s!==d||f!==p||li.current||no?("function"==typeof h&&(fo(e,n,h,r),p=e.memoizedState),(l=no||po(e,n,l,r,f,p,c))?(u||"function"!=typeof a.UNSAFE_componentWillUpdate&&"function"!=typeof a.componentWillUpdate||("function"==typeof a.componentWillUpdate&&a.componentWillUpdate(r,p,c),"function"==typeof a.UNSAFE_componentWillUpdate&&a.UNSAFE_componentWillUpdate(r,p,c)),"function"==typeof a.componentDidUpdate&&(e.flags|=4),"function"==typeof a.getSnapshotBeforeUpdate&&(e.flags|=256)):("function"!=typeof a.componentDidUpdate||s===t.memoizedProps&&f===t.memoizedState||(e.flags|=4),"function"!=typeof a.getSnapshotBeforeUpdate||s===t.memoizedProps&&f===t.memoizedState||(e.flags|=256),e.memoizedProps=r,e.memoizedState=p),a.props=r,a.state=p,a.context=c,r=l):("function"!=typeof a.componentDidUpdate||s===t.memoizedProps&&f===t.memoizedState||(e.flags|=4),"function"!=typeof a.getSnapshotBeforeUpdate||s===t.memoizedProps&&f===t.memoizedState||(e.flags|=256),r=!1)}return Wa(t,e,n,r,o,i)}function Wa(t,e,n,r,i,o){Qa(t,e);var a=0!=(64&e.flags);if(!r&&!a)return i&&yi(e,n,!1),ts(t,e,o);r=e.stateNode,Ia.current=e;var s=a&&"function"!=typeof n.getDerivedStateFromError?null:r.render();return e.flags|=1,null!==t&&a?(e.child=xo(e,t.child,null,o),e.child=xo(e,null,s,o)):Da(t,e,s,o),e.memoizedState=r.state,i&&yi(e,n,!0),e.child}function qa(t){var e=t.stateNode;e.pendingContext?pi(0,e.pendingContext,e.pendingContext!==e.context):e.context&&pi(0,e.context,!1),Ro(t,e.containerInfo)}var Na,Ga,Ja,Ua={dehydrated:null,retryLane:0};function Ka(t,e,n){var r,i=e.pendingProps,o=Do.current,a=!1;return(r=0!=(64&e.flags))||(r=(null===t||null!==t.memoizedState)&&0!=(2&o)),r?(a=!0,e.flags&=-65):null!==t&&null===t.memoizedState||void 0===i.fallback||!0===i.unstable_avoidThisFallback||(o|=1),ai(Do,1&o),null===t?(void 0!==i.fallback&&Yo(e),t=i.children,o=i.fallback,a?(t=Ha(e,t,o,n),e.child.memoizedState={baseLanes:n},e.memoizedState=Ua,t):"number"==typeof i.unstable_expectedLoadTime?(t=Ha(e,t,o,n),e.child.memoizedState={baseLanes:n},e.memoizedState=Ua,e.lanes=33554432,t):((n=qc({mode:"visible",children:t},e.mode,n,null)).return=e,e.child=n)):(t.memoizedState,a?(i=Za(t,e,i.children,i.fallback,n),a=e.child,o=t.child.memoizedState,a.memoizedState=null===o?{baseLanes:n}:{baseLanes:o.baseLanes|n},a.childLanes=t.childLanes&~n,e.memoizedState=Ua,i):(n=Va(t,e,i.children,n),e.memoizedState=null,n))}function Ha(t,e,n,r){var i=t.mode,o=t.child;return e={mode:"hidden",children:e},0==(2&i)&&null!==o?(o.childLanes=0,o.pendingProps=e):o=qc(e,i,0,null),n=Wc(n,i,r,null),o.return=t,n.return=t,o.sibling=n,t.child=o,n}function Va(t,e,n,r){var i=t.child;return t=i.sibling,n=Lc(i,{mode:"visible",children:n}),0==(2&e.mode)&&(n.lanes=r),n.return=e,n.sibling=null,null!==t&&(t.nextEffect=null,t.flags=8,e.firstEffect=e.lastEffect=t),e.child=n}function Za(t,e,n,r,i){var o=e.mode,a=t.child;t=a.sibling;var s={mode:"hidden",children:n};return 0==(2&o)&&e.child!==a?((n=e.child).childLanes=0,n.pendingProps=s,null!==(a=n.lastEffect)?(e.firstEffect=n.firstEffect,e.lastEffect=a,a.nextEffect=null):e.firstEffect=e.lastEffect=null):n=Lc(a,s),null!==t?r=Lc(t,r):(r=Wc(r,o,i,null)).flags|=2,r.return=e,n.return=e,n.sibling=r,e.child=n,r}function Xa(t,e){t.lanes|=e;var n=t.alternate;null!==n&&(n.lanes|=e),$i(t.return,e)}function _a(t,e,n,r,i,o){var a=t.memoizedState;null===a?t.memoizedState={isBackwards:e,rendering:null,renderingStartTime:0,last:r,tail:n,tailMode:i,lastEffect:o}:(a.isBackwards=e,a.rendering=null,a.renderingStartTime=0,a.last=r,a.tail=n,a.tailMode=i,a.lastEffect=o)}function $a(t,e,n){var r=e.pendingProps,i=r.revealOrder,o=r.tail;if(Da(t,e,r.children,n),0!=(2&(r=Do.current)))r=1&r|2,e.flags|=64;else{if(null!==t&&0!=(64&t.flags))t:for(t=e.child;null!==t;){if(13===t.tag)null!==t.memoizedState&&Xa(t,n);else if(19===t.tag)Xa(t,n);else if(null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break t;for(;null===t.sibling;){if(null===t.return||t.return===e)break t;t=t.return}t.sibling.return=t.return,t=t.sibling}r&=1}if(ai(Do,r),0==(2&e.mode))e.memoizedState=null;else switch(i){case"forwards":for(n=e.child,i=null;null!==n;)null!==(t=n.alternate)&&null===To(t)&&(i=n),n=n.sibling;null===(n=i)?(i=e.child,e.child=null):(i=n.sibling,n.sibling=null),_a(e,!1,i,n,o,e.lastEffect);break;case"backwards":for(n=null,i=e.child,e.child=null;null!==i;){if(null!==(t=i.alternate)&&null===To(t)){e.child=i;break}t=i.sibling,i.sibling=n,n=i,i=t}_a(e,!0,n,null,o,e.lastEffect);break;case"together":_a(e,!1,null,null,void 0,e.lastEffect);break;default:e.memoizedState=null}return e.child}function ts(t,e,n){if(null!==t&&(e.dependencies=t.dependencies),Ts|=e.lanes,0!=(n&e.childLanes)){if(null!==t&&e.child!==t.child)throw Error(a(153));if(null!==e.child){for(n=Lc(t=e.child,t.pendingProps),e.child=n,n.return=e;null!==t.sibling;)t=t.sibling,(n=n.sibling=Lc(t,t.pendingProps)).return=e;n.sibling=null}return e.child}return null}function es(t,e){if(!zo)switch(t.tailMode){case"hidden":e=t.tail;for(var n=null;null!==e;)null!==e.alternate&&(n=e),e=e.sibling;null===n?t.tail=null:n.sibling=null;break;case"collapsed":n=t.tail;for(var r=null;null!==n;)null!==n.alternate&&(r=n),n=n.sibling;null===r?e||null===t.tail?t.tail=null:t.tail.sibling=null:r.sibling=null}}function ns(t,e,n){var r=e.pendingProps;switch(e.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return fi(e.type)&&hi(),null;case 3:return jo(),oi(li),oi(ci),Jo(),(r=e.stateNode).pendingContext&&(r.context=r.pendingContext,r.pendingContext=null),null!==t&&null!==t.child||(qo(e)?e.flags|=4:r.hydrate||(e.flags|=256)),null;case 5:Bo(e);var o=Co(Mo.current);if(n=e.type,null!==t&&null!=e.stateNode)Ga(t,e,n,r),t.ref!==e.ref&&(e.flags|=128);else{if(!r){if(null===e.stateNode)throw Error(a(166));return null}if(t=Co(Oo.current),qo(e)){r=e.stateNode,n=e.type;var s=e.memoizedProps;switch(r[Kr]=e,r[Hr]=s,n){case"dialog":Or("cancel",r),Or("close",r);break;case"iframe":case"object":case"embed":Or("load",r);break;case"video":case"audio":for(t=0;t<wr.length;t++)Or(wr[t],r);break;case"source":Or("error",r);break;case"img":case"image":case"link":Or("error",r),Or("load",r);break;case"details":Or("toggle",r);break;case"input":tt(r,s),Or("invalid",r);break;case"select":r._wrapperState={wasMultiple:!!s.multiple},Or("invalid",r);break;case"textarea":ct(r,s),Or("invalid",r)}for(var l in At(n,s),t=null,s)s.hasOwnProperty(l)&&(o=s[l],"children"===l?"string"==typeof o?r.textContent!==o&&(t=["children",o]):"number"==typeof o&&r.textContent!==""+o&&(t=["children",""+o]):c.hasOwnProperty(l)&&null!=o&&"onScroll"===l&&Or("scroll",r));switch(n){case"input":Z(r),rt(r,s,!0);break;case"textarea":Z(r),ut(r);break;case"select":case"option":break;default:"function"==typeof s.onClick&&(r.onclick=Fr)}r=t,e.updateQueue=r,null!==r&&(e.flags|=4)}else{switch(l=9===o.nodeType?o:o.ownerDocument,t===dt&&(t=ht(n)),t===dt?"script"===n?((t=l.createElement("div")).innerHTML="<script><\/script>",t=t.removeChild(t.firstChild)):"string"==typeof r.is?t=l.createElement(n,{is:r.is}):(t=l.createElement(n),"select"===n&&(l=t,r.multiple?l.multiple=!0:r.size&&(l.size=r.size))):t=l.createElementNS(t,n),t[Kr]=e,t[Hr]=r,Na(t,e),e.stateNode=t,l=St(n,r),n){case"dialog":Or("cancel",t),Or("close",t),o=r;break;case"iframe":case"object":case"embed":Or("load",t),o=r;break;case"video":case"audio":for(o=0;o<wr.length;o++)Or(wr[o],t);o=r;break;case"source":Or("error",t),o=r;break;case"img":case"image":case"link":Or("error",t),Or("load",t),o=r;break;case"details":Or("toggle",t),o=r;break;case"input":tt(t,r),o=$(t,r),Or("invalid",t);break;case"option":o=ot(t,r);break;case"select":t._wrapperState={wasMultiple:!!r.multiple},o=i({},r,{value:void 0}),Or("invalid",t);break;case"textarea":ct(t,r),o=st(t,r),Or("invalid",t);break;default:o=r}At(n,o);var u=o;for(s in u)if(u.hasOwnProperty(s)){var d=u[s];"style"===s?wt(t,d):"dangerouslySetInnerHTML"===s?null!=(d=d?d.__html:void 0)&&mt(t,d):"children"===s?"string"==typeof d?("textarea"!==n||""!==d)&&yt(t,d):"number"==typeof d&&yt(t,""+d):"suppressContentEditableWarning"!==s&&"suppressHydrationWarning"!==s&&"autoFocus"!==s&&(c.hasOwnProperty(s)?null!=d&&"onScroll"===s&&Or("scroll",t):null!=d&&k(t,s,d,l))}switch(n){case"input":Z(t),rt(t,r,!1);break;case"textarea":Z(t),ut(t);break;case"option":null!=r.value&&t.setAttribute("value",""+H(r.value));break;case"select":t.multiple=!!r.multiple,null!=(s=r.value)?at(t,!!r.multiple,s,!1):null!=r.defaultValue&&at(t,!!r.multiple,r.defaultValue,!0);break;default:"function"==typeof o.onClick&&(t.onclick=Fr)}Qr(n,r)&&(e.flags|=4)}null!==e.ref&&(e.flags|=128)}return null;case 6:if(t&&null!=e.stateNode)Ja(0,e,t.memoizedProps,r);else{if("string"!=typeof r&&null===e.stateNode)throw Error(a(166));n=Co(Mo.current),Co(Oo.current),qo(e)?(r=e.stateNode,n=e.memoizedProps,r[Kr]=e,r.nodeValue!==n&&(e.flags|=4)):((r=(9===n.nodeType?n:n.ownerDocument).createTextNode(r))[Kr]=e,e.stateNode=r)}return null;case 13:return oi(Do),r=e.memoizedState,0!=(64&e.flags)?(e.lanes=n,e):(r=null!==r,n=!1,null===t?void 0!==e.memoizedProps.fallback&&qo(e):n=null!==t.memoizedState,r&&!n&&0!=(2&e.mode)&&(null===t&&!0!==e.memoizedProps.unstable_avoidThisFallback||0!=(1&Do.current)?0===Is&&(Is=3):(0!==Is&&3!==Is||(Is=4),null===Es||0==(134217727&Ts)&&0==(134217727&Fs)||dc(Es,Cs))),(r||n)&&(e.flags|=4),null);case 4:return jo(),null===t&&Mr(e.stateNode.containerInfo),null;case 10:return _i(e),null;case 17:return fi(e.type)&&hi(),null;case 19:if(oi(Do),null===(r=e.memoizedState))return null;if(s=0!=(64&e.flags),null===(l=r.rendering))if(s)es(r,!1);else{if(0!==Is||null!==t&&0!=(64&t.flags))for(t=e.child;null!==t;){if(null!==(l=To(t))){for(e.flags|=64,es(r,!1),null!==(s=l.updateQueue)&&(e.updateQueue=s,e.flags|=4),null===r.lastEffect&&(e.firstEffect=null),e.lastEffect=r.lastEffect,r=n,n=e.child;null!==n;)t=r,(s=n).flags&=2,s.nextEffect=null,s.firstEffect=null,s.lastEffect=null,null===(l=s.alternate)?(s.childLanes=0,s.lanes=t,s.child=null,s.memoizedProps=null,s.memoizedState=null,s.updateQueue=null,s.dependencies=null,s.stateNode=null):(s.childLanes=l.childLanes,s.lanes=l.lanes,s.child=l.child,s.memoizedProps=l.memoizedProps,s.memoizedState=l.memoizedState,s.updateQueue=l.updateQueue,s.type=l.type,t=l.dependencies,s.dependencies=null===t?null:{lanes:t.lanes,firstContext:t.firstContext}),n=n.sibling;return ai(Do,1&Do.current|2),e.child}t=t.sibling}null!==r.tail&&Qi()>Ls&&(e.flags|=64,s=!0,es(r,!1),e.lanes=33554432)}else{if(!s)if(null!==(t=To(l))){if(e.flags|=64,s=!0,null!==(n=t.updateQueue)&&(e.updateQueue=n,e.flags|=4),es(r,!0),null===r.tail&&"hidden"===r.tailMode&&!l.alternate&&!zo)return null!==(e=e.lastEffect=r.lastEffect)&&(e.nextEffect=null),null}else 2*Qi()-r.renderingStartTime>Ls&&1073741824!==n&&(e.flags|=64,s=!0,es(r,!1),e.lanes=33554432);r.isBackwards?(l.sibling=e.child,e.child=l):(null!==(n=r.last)?n.sibling=l:e.child=l,r.last=l)}return null!==r.tail?(n=r.tail,r.rendering=n,r.tail=n.sibling,r.lastEffect=e.lastEffect,r.renderingStartTime=Qi(),n.sibling=null,e=Do.current,ai(Do,s?1&e|2:1&e),n):null;case 23:case 24:return mc(),null!==t&&null!==t.memoizedState!=(null!==e.memoizedState)&&"unstable-defer-without-hiding"!==r.mode&&(e.flags|=4),null}throw Error(a(156,e.tag))}function rs(t){switch(t.tag){case 1:fi(t.type)&&hi();var e=t.flags;return 4096&e?(t.flags=-4097&e|64,t):null;case 3:if(jo(),oi(li),oi(ci),Jo(),0!=(64&(e=t.flags)))throw Error(a(285));return t.flags=-4097&e|64,t;case 5:return Bo(t),null;case 13:return oi(Do),4096&(e=t.flags)?(t.flags=-4097&e|64,t):null;case 19:return oi(Do),null;case 4:return jo(),null;case 10:return _i(t),null;case 23:case 24:return mc(),null;default:return null}}function is(t,e){try{var n="",r=e;do{n+=U(r),r=r.return}while(r);var i=n}catch(t){i="\nError generating stack: "+t.message+"\n"+t.stack}return{value:t,source:e,stack:i}}function os(t,e){try{console.error(e.value)}catch(t){setTimeout((function(){throw t}))}}Na=function(t,e){for(var n=e.child;null!==n;){if(5===n.tag||6===n.tag)t.appendChild(n.stateNode);else if(4!==n.tag&&null!==n.child){n.child.return=n,n=n.child;continue}if(n===e)break;for(;null===n.sibling;){if(null===n.return||n.return===e)return;n=n.return}n.sibling.return=n.return,n=n.sibling}},Ga=function(t,e,n,r){var o=t.memoizedProps;if(o!==r){t=e.stateNode,Co(Oo.current);var a,s=null;switch(n){case"input":o=$(t,o),r=$(t,r),s=[];break;case"option":o=ot(t,o),r=ot(t,r),s=[];break;case"select":o=i({},o,{value:void 0}),r=i({},r,{value:void 0}),s=[];break;case"textarea":o=st(t,o),r=st(t,r),s=[];break;default:"function"!=typeof o.onClick&&"function"==typeof r.onClick&&(t.onclick=Fr)}for(d in At(n,r),n=null,o)if(!r.hasOwnProperty(d)&&o.hasOwnProperty(d)&&null!=o[d])if("style"===d){var l=o[d];for(a in l)l.hasOwnProperty(a)&&(n||(n={}),n[a]="")}else"dangerouslySetInnerHTML"!==d&&"children"!==d&&"suppressContentEditableWarning"!==d&&"suppressHydrationWarning"!==d&&"autoFocus"!==d&&(c.hasOwnProperty(d)?s||(s=[]):(s=s||[]).push(d,null));for(d in r){var u=r[d];if(l=null!=o?o[d]:void 0,r.hasOwnProperty(d)&&u!==l&&(null!=u||null!=l))if("style"===d)if(l){for(a in l)!l.hasOwnProperty(a)||u&&u.hasOwnProperty(a)||(n||(n={}),n[a]="");for(a in u)u.hasOwnProperty(a)&&l[a]!==u[a]&&(n||(n={}),n[a]=u[a])}else n||(s||(s=[]),s.push(d,n)),n=u;else"dangerouslySetInnerHTML"===d?(u=u?u.__html:void 0,l=l?l.__html:void 0,null!=u&&l!==u&&(s=s||[]).push(d,u)):"children"===d?"string"!=typeof u&&"number"!=typeof u||(s=s||[]).push(d,""+u):"suppressContentEditableWarning"!==d&&"suppressHydrationWarning"!==d&&(c.hasOwnProperty(d)?(null!=u&&"onScroll"===d&&Or("scroll",t),s||l===u||(s=[])):"object"==typeof u&&null!==u&&u.$$typeof===F?u.toString():(s=s||[]).push(d,u))}n&&(s=s||[]).push("style",n);var d=s;(e.updateQueue=d)&&(e.flags|=4)}},Ja=function(t,e,n,r){n!==r&&(e.flags|=4)};var as="function"==typeof WeakMap?WeakMap:Map;function ss(t,e,n){(n=oo(-1,n)).tag=3,n.payload={element:null};var r=e.value;return n.callback=function(){Ns||(Ns=!0,Gs=r),os(0,e)},n}function cs(t,e,n){(n=oo(-1,n)).tag=3;var r=t.type.getDerivedStateFromError;if("function"==typeof r){var i=e.value;n.payload=function(){return os(0,e),r(i)}}var o=t.stateNode;return null!==o&&"function"==typeof o.componentDidCatch&&(n.callback=function(){"function"!=typeof r&&(null===Js?Js=new Set([this]):Js.add(this),os(0,e));var t=e.stack;this.componentDidCatch(e.value,{componentStack:null!==t?t:""})}),n}var ls="function"==typeof WeakSet?WeakSet:Set;function us(t){var e=t.ref;if(null!==e)if("function"==typeof e)try{e(null)}catch(e){Dc(t,e)}else e.current=null}function ds(t,e){switch(e.tag){case 0:case 11:case 15:case 22:return;case 1:if(256&e.flags&&null!==t){var n=t.memoizedProps,r=t.memoizedState;e=(t=e.stateNode).getSnapshotBeforeUpdate(e.elementType===e.type?n:Ui(e.type,n),r),t.__reactInternalSnapshotBeforeUpdate=e}return;case 3:return void(256&e.flags&&qr(e.stateNode.containerInfo));case 5:case 6:case 4:case 17:return}throw Error(a(163))}function fs(t,e,n){switch(n.tag){case 0:case 11:case 15:case 22:if(null!==(e=null!==(e=n.updateQueue)?e.lastEffect:null)){t=e=e.next;do{if(3==(3&t.tag)){var r=t.create;t.destroy=r()}t=t.next}while(t!==e)}if(null!==(e=null!==(e=n.updateQueue)?e.lastEffect:null)){t=e=e.next;do{var i=t;r=i.next,0!=(4&(i=i.tag))&&0!=(1&i)&&(jc(n,t),Rc(n,t)),t=r}while(t!==e)}return;case 1:return t=n.stateNode,4&n.flags&&(null===e?t.componentDidMount():(r=n.elementType===n.type?e.memoizedProps:Ui(n.type,e.memoizedProps),t.componentDidUpdate(r,e.memoizedState,t.__reactInternalSnapshotBeforeUpdate))),void(null!==(e=n.updateQueue)&&lo(n,e,t));case 3:if(null!==(e=n.updateQueue)){if(t=null,null!==n.child)switch(n.child.tag){case 5:t=n.child.stateNode;break;case 1:t=n.child.stateNode}lo(n,e,t)}return;case 5:return t=n.stateNode,void(null===e&&4&n.flags&&Qr(n.type,n.memoizedProps)&&t.focus());case 6:case 4:case 12:return;case 13:return void(null===n.memoizedState&&(n=n.alternate,null!==n&&(n=n.memoizedState,null!==n&&(n=n.dehydrated,null!==n&&we(n)))));case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(a(163))}function hs(t,e){for(var n=t;;){if(5===n.tag){var r=n.stateNode;if(e)"function"==typeof(r=r.style).setProperty?r.setProperty("display","none","important"):r.display="none";else{r=n.stateNode;var i=n.memoizedProps.style;i=null!=i&&i.hasOwnProperty("display")?i.display:null,r.style.display=kt("display",i)}}else if(6===n.tag)n.stateNode.nodeValue=e?"":n.memoizedProps;else if((23!==n.tag&&24!==n.tag||null===n.memoizedState||n===t)&&null!==n.child){n.child.return=n,n=n.child;continue}if(n===t)break;for(;null===n.sibling;){if(null===n.return||n.return===t)return;n=n.return}n.sibling.return=n.return,n=n.sibling}}function ps(t,e){if(bi&&"function"==typeof bi.onCommitFiberUnmount)try{bi.onCommitFiberUnmount(vi,e)}catch(t){}switch(e.tag){case 0:case 11:case 14:case 15:case 22:if(null!==(t=e.updateQueue)&&null!==(t=t.lastEffect)){var n=t=t.next;do{var r=n,i=r.destroy;if(r=r.tag,void 0!==i)if(0!=(4&r))jc(e,n);else{r=e;try{i()}catch(t){Dc(r,t)}}n=n.next}while(n!==t)}break;case 1:if(us(e),"function"==typeof(t=e.stateNode).componentWillUnmount)try{t.props=e.memoizedProps,t.state=e.memoizedState,t.componentWillUnmount()}catch(t){Dc(e,t)}break;case 5:us(e);break;case 4:vs(t,e)}}function gs(t){t.alternate=null,t.child=null,t.dependencies=null,t.firstEffect=null,t.lastEffect=null,t.memoizedProps=null,t.memoizedState=null,t.pendingProps=null,t.return=null,t.updateQueue=null}function ms(t){return 5===t.tag||3===t.tag||4===t.tag}function ys(t){t:{for(var e=t.return;null!==e;){if(ms(e))break t;e=e.return}throw Error(a(160))}var n=e;switch(e=n.stateNode,n.tag){case 5:var r=!1;break;case 3:case 4:e=e.containerInfo,r=!0;break;default:throw Error(a(161))}16&n.flags&&(yt(e,""),n.flags&=-17);t:e:for(n=t;;){for(;null===n.sibling;){if(null===n.return||ms(n.return)){n=null;break t}n=n.return}for(n.sibling.return=n.return,n=n.sibling;5!==n.tag&&6!==n.tag&&18!==n.tag;){if(2&n.flags)continue e;if(null===n.child||4===n.tag)continue e;n.child.return=n,n=n.child}if(!(2&n.flags)){n=n.stateNode;break t}}r?function t(e,n,r){var i=e.tag,o=5===i||6===i;if(o)e=o?e.stateNode:e.stateNode.instance,n?8===r.nodeType?r.parentNode.insertBefore(e,n):r.insertBefore(e,n):(8===r.nodeType?(n=r.parentNode).insertBefore(e,r):(n=r).appendChild(e),null!==(r=r._reactRootContainer)&&void 0!==r||null!==n.onclick||(n.onclick=Fr));else if(4!==i&&null!==(e=e.child))for(t(e,n,r),e=e.sibling;null!==e;)t(e,n,r),e=e.sibling}(t,n,e):function t(e,n,r){var i=e.tag,o=5===i||6===i;if(o)e=o?e.stateNode:e.stateNode.instance,n?r.insertBefore(e,n):r.appendChild(e);else if(4!==i&&null!==(e=e.child))for(t(e,n,r),e=e.sibling;null!==e;)t(e,n,r),e=e.sibling}(t,n,e)}function vs(t,e){for(var n,r,i=e,o=!1;;){if(!o){o=i.return;t:for(;;){if(null===o)throw Error(a(160));switch(n=o.stateNode,o.tag){case 5:r=!1;break t;case 3:case 4:n=n.containerInfo,r=!0;break t}o=o.return}o=!0}if(5===i.tag||6===i.tag){t:for(var s=t,c=i,l=c;;)if(ps(s,l),null!==l.child&&4!==l.tag)l.child.return=l,l=l.child;else{if(l===c)break t;for(;null===l.sibling;){if(null===l.return||l.return===c)break t;l=l.return}l.sibling.return=l.return,l=l.sibling}r?(s=n,c=i.stateNode,8===s.nodeType?s.parentNode.removeChild(c):s.removeChild(c)):n.removeChild(i.stateNode)}else if(4===i.tag){if(null!==i.child){n=i.stateNode.containerInfo,r=!0,i.child.return=i,i=i.child;continue}}else if(ps(t,i),null!==i.child){i.child.return=i,i=i.child;continue}if(i===e)break;for(;null===i.sibling;){if(null===i.return||i.return===e)return;4===(i=i.return).tag&&(o=!1)}i.sibling.return=i.return,i=i.sibling}}function bs(t,e){switch(e.tag){case 0:case 11:case 14:case 15:case 22:var n=e.updateQueue;if(null!==(n=null!==n?n.lastEffect:null)){var r=n=n.next;do{3==(3&r.tag)&&(t=r.destroy,r.destroy=void 0,void 0!==t&&t()),r=r.next}while(r!==n)}return;case 1:return;case 5:if(null!=(n=e.stateNode)){r=e.memoizedProps;var i=null!==t?t.memoizedProps:r;t=e.type;var o=e.updateQueue;if(e.updateQueue=null,null!==o){for(n[Hr]=r,"input"===t&&"radio"===r.type&&null!=r.name&&et(n,r),St(t,i),e=St(t,r),i=0;i<o.length;i+=2){var s=o[i],c=o[i+1];"style"===s?wt(n,c):"dangerouslySetInnerHTML"===s?mt(n,c):"children"===s?yt(n,c):k(n,s,c,e)}switch(t){case"input":nt(n,r);break;case"textarea":lt(n,r);break;case"select":t=n._wrapperState.wasMultiple,n._wrapperState.wasMultiple=!!r.multiple,null!=(o=r.value)?at(n,!!r.multiple,o,!1):t!==!!r.multiple&&(null!=r.defaultValue?at(n,!!r.multiple,r.defaultValue,!0):at(n,!!r.multiple,r.multiple?[]:"",!1))}}}return;case 6:if(null===e.stateNode)throw Error(a(162));return void(e.stateNode.nodeValue=e.memoizedProps);case 3:return void((n=e.stateNode).hydrate&&(n.hydrate=!1,we(n.containerInfo)));case 12:return;case 13:return null!==e.memoizedState&&(Qs=Qi(),hs(e.child,!0)),void ks(e);case 19:return void ks(e);case 17:return;case 23:case 24:return void hs(e,null!==e.memoizedState)}throw Error(a(163))}function ks(t){var e=t.updateQueue;if(null!==e){t.updateQueue=null;var n=t.stateNode;null===n&&(n=t.stateNode=new ls),e.forEach((function(e){var r=Fc.bind(null,t,e);n.has(e)||(n.add(e),e.then(r,r))}))}}function ws(t,e){return null!==t&&(null===(t=t.memoizedState)||null!==t.dehydrated)&&(null!==(e=e.memoizedState)&&null===e.dehydrated)}var xs=Math.ceil,As=w.ReactCurrentDispatcher,Ss=w.ReactCurrentOwner,Os=0,Es=null,Ms=null,Cs=0,Rs=0,js=ii(0),Is=0,Bs=null,Ds=0,Ts=0,Fs=0,Ps=0,zs=null,Qs=0,Ls=1/0;function Ys(){Ls=Qi()+500}var Ws,qs=null,Ns=!1,Gs=null,Js=null,Us=!1,Ks=null,Hs=90,Vs=[],Zs=[],Xs=null,_s=0,$s=null,tc=-1,ec=0,nc=0,rc=null,ic=!1;function oc(){return 0!=(48&Os)?Qi():-1!==tc?tc:tc=Qi()}function ac(t){if(0==(2&(t=t.mode)))return 1;if(0==(4&t))return 99===Li()?1:2;if(0===ec&&(ec=Ds),0!==Ji.transition){0!==nc&&(nc=null!==zs?zs.pendingLanes:0),t=ec;var e=4186112&~nc;return 0===(e&=-e)&&(0===(e=(t=4186112&~t)&-t)&&(e=8192)),e}return t=Li(),0!=(4&Os)&&98===t?t=Le(12,ec):t=Le(t=function(t){switch(t){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}(t),ec),t}function sc(t,e,n){if(50<_s)throw _s=0,$s=null,Error(a(185));if(null===(t=cc(t,e)))return null;qe(t,e,n),t===Es&&(Fs|=e,4===Is&&dc(t,Cs));var r=Li();1===e?0!=(8&Os)&&0==(48&Os)?fc(t):(lc(t,n),0===Os&&(Ys(),Ni())):(0==(4&Os)||98!==r&&99!==r||(null===Xs?Xs=new Set([t]):Xs.add(t)),lc(t,n)),zs=t}function cc(t,e){t.lanes|=e;var n=t.alternate;for(null!==n&&(n.lanes|=e),n=t,t=t.return;null!==t;)t.childLanes|=e,null!==(n=t.alternate)&&(n.childLanes|=e),n=t,t=t.return;return 3===n.tag?n.stateNode:null}function lc(t,e){for(var n=t.callbackNode,r=t.suspendedLanes,i=t.pingedLanes,o=t.expirationTimes,s=t.pendingLanes;0<s;){var c=31-Ne(s),l=1<<c,u=o[c];if(-1===u){if(0==(l&r)||0!=(l&i)){u=e,Pe(l);var d=Fe;o[c]=10<=d?u+250:6<=d?u+5e3:-1}}else u<=e&&(t.expiredLanes|=l);s&=~l}if(r=ze(t,t===Es?Cs:0),e=Fe,0===r)null!==n&&(n!==Bi&&xi(n),t.callbackNode=null,t.callbackPriority=0);else{if(null!==n){if(t.callbackPriority===e)return;n!==Bi&&xi(n)}15===e?(n=fc.bind(null,t),null===Ti?(Ti=[n],Fi=wi(Mi,Gi)):Ti.push(n),n=Bi):14===e?n=qi(99,fc.bind(null,t)):n=qi(n=function(t){switch(t){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(a(358,t))}}(e),uc.bind(null,t)),t.callbackPriority=e,t.callbackNode=n}}function uc(t){if(tc=-1,nc=ec=0,0!=(48&Os))throw Error(a(327));var e=t.callbackNode;if(Cc()&&t.callbackNode!==e)return null;var n=ze(t,t===Es?Cs:0);if(0===n)return null;var r=n,i=Os;Os|=16;var o=bc();for(Es===t&&Cs===r||(Ys(),yc(t,r));;)try{xc();break}catch(e){vc(t,e)}if(Xi(),As.current=o,Os=i,null!==Ms?r=0:(Es=null,Cs=0,r=Is),0!=(Ds&Fs))yc(t,0);else if(0!==r){if(2===r&&(Os|=64,t.hydrate&&(t.hydrate=!1,qr(t.containerInfo)),0!==(n=Qe(t))&&(r=kc(t,n))),1===r)throw e=Bs,yc(t,0),dc(t,n),lc(t,Qi()),e;switch(t.finishedWork=t.current.alternate,t.finishedLanes=n,r){case 0:case 1:throw Error(a(345));case 2:Oc(t);break;case 3:if(dc(t,n),(62914560&n)===n&&10<(r=Qs+500-Qi())){if(0!==ze(t,0))break;if(((i=t.suspendedLanes)&n)!==n){oc(),t.pingedLanes|=t.suspendedLanes&i;break}t.timeoutHandle=Yr(Oc.bind(null,t),r);break}Oc(t);break;case 4:if(dc(t,n),(4186112&n)===n)break;for(r=t.eventTimes,i=-1;0<n;){var s=31-Ne(n);o=1<<s,(s=r[s])>i&&(i=s),n&=~o}if(n=i,10<(n=(120>(n=Qi()-n)?120:480>n?480:1080>n?1080:1920>n?1920:3e3>n?3e3:4320>n?4320:1960*xs(n/1960))-n)){t.timeoutHandle=Yr(Oc.bind(null,t),n);break}Oc(t);break;case 5:Oc(t);break;default:throw Error(a(329))}}return lc(t,Qi()),t.callbackNode===e?uc.bind(null,t):null}function dc(t,e){for(e&=~Ps,e&=~Fs,t.suspendedLanes|=e,t.pingedLanes&=~e,t=t.expirationTimes;0<e;){var n=31-Ne(e),r=1<<n;t[n]=-1,e&=~r}}function fc(t){if(0!=(48&Os))throw Error(a(327));if(Cc(),t===Es&&0!=(t.expiredLanes&Cs)){var e=Cs,n=kc(t,e);0!=(Ds&Fs)&&(n=kc(t,e=ze(t,e)))}else n=kc(t,e=ze(t,0));if(0!==t.tag&&2===n&&(Os|=64,t.hydrate&&(t.hydrate=!1,qr(t.containerInfo)),0!==(e=Qe(t))&&(n=kc(t,e))),1===n)throw n=Bs,yc(t,0),dc(t,e),lc(t,Qi()),n;return t.finishedWork=t.current.alternate,t.finishedLanes=e,Oc(t),lc(t,Qi()),null}function hc(t,e){var n=Os;Os|=1;try{return t(e)}finally{0===(Os=n)&&(Ys(),Ni())}}function pc(t,e){var n=Os;Os&=-2,Os|=8;try{return t(e)}finally{0===(Os=n)&&(Ys(),Ni())}}function gc(t,e){ai(js,Rs),Rs|=e,Ds|=e}function mc(){Rs=js.current,oi(js)}function yc(t,e){t.finishedWork=null,t.finishedLanes=0;var n=t.timeoutHandle;if(-1!==n&&(t.timeoutHandle=-1,Wr(n)),null!==Ms)for(n=Ms.return;null!==n;){var r=n;switch(r.tag){case 1:null!=(r=r.type.childContextTypes)&&hi();break;case 3:jo(),oi(li),oi(ci),Jo();break;case 5:Bo(r);break;case 4:jo();break;case 13:case 19:oi(Do);break;case 10:_i(r);break;case 23:case 24:mc()}n=n.return}Es=t,Ms=Lc(t.current,null),Cs=Rs=Ds=e,Is=0,Bs=null,Ps=Fs=Ts=0}function vc(t,e){for(;;){var n=Ms;try{if(Xi(),Uo.current=Ma,_o){for(var r=Vo.memoizedState;null!==r;){var i=r.queue;null!==i&&(i.pending=null),r=r.next}_o=!1}if(Ho=0,Xo=Zo=Vo=null,$o=!1,Ss.current=null,null===n||null===n.return){Is=1,Bs=e,Ms=null;break}t:{var o=t,a=n.return,s=n,c=e;if(e=Cs,s.flags|=2048,s.firstEffect=s.lastEffect=null,null!==c&&"object"==typeof c&&"function"==typeof c.then){var l=c;if(0==(2&s.mode)){var u=s.alternate;u?(s.updateQueue=u.updateQueue,s.memoizedState=u.memoizedState,s.lanes=u.lanes):(s.updateQueue=null,s.memoizedState=null)}var d=0!=(1&Do.current),f=a;do{var h;if(h=13===f.tag){var p=f.memoizedState;if(null!==p)h=null!==p.dehydrated;else{var g=f.memoizedProps;h=void 0!==g.fallback&&(!0!==g.unstable_avoidThisFallback||!d)}}if(h){var m=f.updateQueue;if(null===m){var y=new Set;y.add(l),f.updateQueue=y}else m.add(l);if(0==(2&f.mode)){if(f.flags|=64,s.flags|=16384,s.flags&=-2981,1===s.tag)if(null===s.alternate)s.tag=17;else{var v=oo(-1,1);v.tag=2,ao(s,v)}s.lanes|=1;break t}c=void 0,s=e;var b=o.pingCache;if(null===b?(b=o.pingCache=new as,c=new Set,b.set(l,c)):void 0===(c=b.get(l))&&(c=new Set,b.set(l,c)),!c.has(s)){c.add(s);var k=Tc.bind(null,o,l,s);l.then(k,k)}f.flags|=4096,f.lanes=e;break t}f=f.return}while(null!==f);c=Error((K(s.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==Is&&(Is=2),c=is(c,s),f=a;do{switch(f.tag){case 3:o=c,f.flags|=4096,e&=-e,f.lanes|=e,so(f,ss(0,o,e));break t;case 1:o=c;var w=f.type,x=f.stateNode;if(0==(64&f.flags)&&("function"==typeof w.getDerivedStateFromError||null!==x&&"function"==typeof x.componentDidCatch&&(null===Js||!Js.has(x)))){f.flags|=4096,e&=-e,f.lanes|=e,so(f,cs(f,o,e));break t}}f=f.return}while(null!==f)}Sc(n)}catch(t){e=t,Ms===n&&null!==n&&(Ms=n=n.return);continue}break}}function bc(){var t=As.current;return As.current=Ma,null===t?Ma:t}function kc(t,e){var n=Os;Os|=16;var r=bc();for(Es===t&&Cs===e||yc(t,e);;)try{wc();break}catch(e){vc(t,e)}if(Xi(),Os=n,As.current=r,null!==Ms)throw Error(a(261));return Es=null,Cs=0,Is}function wc(){for(;null!==Ms;)Ac(Ms)}function xc(){for(;null!==Ms&&!Ai();)Ac(Ms)}function Ac(t){var e=Ws(t.alternate,t,Rs);t.memoizedProps=t.pendingProps,null===e?Sc(t):Ms=e,Ss.current=null}function Sc(t){var e=t;do{var n=e.alternate;if(t=e.return,0==(2048&e.flags)){if(null!==(n=ns(n,e,Rs)))return void(Ms=n);if(24!==(n=e).tag&&23!==n.tag||null===n.memoizedState||0!=(1073741824&Rs)||0==(4&n.mode)){for(var r=0,i=n.child;null!==i;)r|=i.lanes|i.childLanes,i=i.sibling;n.childLanes=r}null!==t&&0==(2048&t.flags)&&(null===t.firstEffect&&(t.firstEffect=e.firstEffect),null!==e.lastEffect&&(null!==t.lastEffect&&(t.lastEffect.nextEffect=e.firstEffect),t.lastEffect=e.lastEffect),1<e.flags&&(null!==t.lastEffect?t.lastEffect.nextEffect=e:t.firstEffect=e,t.lastEffect=e))}else{if(null!==(n=rs(e)))return n.flags&=2047,void(Ms=n);null!==t&&(t.firstEffect=t.lastEffect=null,t.flags|=2048)}if(null!==(e=e.sibling))return void(Ms=e);Ms=e=t}while(null!==e);0===Is&&(Is=5)}function Oc(t){var e=Li();return Wi(99,Ec.bind(null,t,e)),null}function Ec(t,e){do{Cc()}while(null!==Ks);if(0!=(48&Os))throw Error(a(327));var n=t.finishedWork;if(null===n)return null;if(t.finishedWork=null,t.finishedLanes=0,n===t.current)throw Error(a(177));t.callbackNode=null;var r=n.lanes|n.childLanes,i=r,o=t.pendingLanes&~i;t.pendingLanes=i,t.suspendedLanes=0,t.pingedLanes=0,t.expiredLanes&=i,t.mutableReadLanes&=i,t.entangledLanes&=i,i=t.entanglements;for(var s=t.eventTimes,c=t.expirationTimes;0<o;){var l=31-Ne(o),u=1<<l;i[l]=0,s[l]=-1,c[l]=-1,o&=~u}if(null!==Xs&&0==(24&r)&&Xs.has(t)&&Xs.delete(t),t===Es&&(Ms=Es=null,Cs=0),1<n.flags?null!==n.lastEffect?(n.lastEffect.nextEffect=n,r=n.firstEffect):r=n:r=n.firstEffect,null!==r){if(i=Os,Os|=32,Ss.current=null,Pr=He,fr(s=dr())){if("selectionStart"in s)c={start:s.selectionStart,end:s.selectionEnd};else t:if(c=(c=s.ownerDocument)&&c.defaultView||window,(u=c.getSelection&&c.getSelection())&&0!==u.rangeCount){c=u.anchorNode,o=u.anchorOffset,l=u.focusNode,u=u.focusOffset;try{c.nodeType,l.nodeType}catch(t){c=null;break t}var d=0,f=-1,h=-1,p=0,g=0,m=s,y=null;e:for(;;){for(var v;m!==c||0!==o&&3!==m.nodeType||(f=d+o),m!==l||0!==u&&3!==m.nodeType||(h=d+u),3===m.nodeType&&(d+=m.nodeValue.length),null!==(v=m.firstChild);)y=m,m=v;for(;;){if(m===s)break e;if(y===c&&++p===o&&(f=d),y===l&&++g===u&&(h=d),null!==(v=m.nextSibling))break;y=(m=y).parentNode}m=v}c=-1===f||-1===h?null:{start:f,end:h}}else c=null;c=c||{start:0,end:0}}else c=null;zr={focusedElem:s,selectionRange:c},He=!1,rc=null,ic=!1,qs=r;do{try{Mc()}catch(t){if(null===qs)throw Error(a(330));Dc(qs,t),qs=qs.nextEffect}}while(null!==qs);rc=null,qs=r;do{try{for(s=t;null!==qs;){var b=qs.flags;if(16&b&&yt(qs.stateNode,""),128&b){var k=qs.alternate;if(null!==k){var w=k.ref;null!==w&&("function"==typeof w?w(null):w.current=null)}}switch(1038&b){case 2:ys(qs),qs.flags&=-3;break;case 6:ys(qs),qs.flags&=-3,bs(qs.alternate,qs);break;case 1024:qs.flags&=-1025;break;case 1028:qs.flags&=-1025,bs(qs.alternate,qs);break;case 4:bs(qs.alternate,qs);break;case 8:vs(s,c=qs);var x=c.alternate;gs(c),null!==x&&gs(x)}qs=qs.nextEffect}}catch(t){if(null===qs)throw Error(a(330));Dc(qs,t),qs=qs.nextEffect}}while(null!==qs);if(w=zr,k=dr(),b=w.focusedElem,s=w.selectionRange,k!==b&&b&&b.ownerDocument&&function t(e,n){return!(!e||!n)&&(e===n||(!e||3!==e.nodeType)&&(n&&3===n.nodeType?t(e,n.parentNode):"contains"in e?e.contains(n):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(n))))}(b.ownerDocument.documentElement,b)){null!==s&&fr(b)&&(k=s.start,void 0===(w=s.end)&&(w=k),"selectionStart"in b?(b.selectionStart=k,b.selectionEnd=Math.min(w,b.value.length)):(w=(k=b.ownerDocument||document)&&k.defaultView||window).getSelection&&(w=w.getSelection(),c=b.textContent.length,x=Math.min(s.start,c),s=void 0===s.end?x:Math.min(s.end,c),!w.extend&&x>s&&(c=s,s=x,x=c),c=ur(b,x),o=ur(b,s),c&&o&&(1!==w.rangeCount||w.anchorNode!==c.node||w.anchorOffset!==c.offset||w.focusNode!==o.node||w.focusOffset!==o.offset)&&((k=k.createRange()).setStart(c.node,c.offset),w.removeAllRanges(),x>s?(w.addRange(k),w.extend(o.node,o.offset)):(k.setEnd(o.node,o.offset),w.addRange(k))))),k=[];for(w=b;w=w.parentNode;)1===w.nodeType&&k.push({element:w,left:w.scrollLeft,top:w.scrollTop});for("function"==typeof b.focus&&b.focus(),b=0;b<k.length;b++)(w=k[b]).element.scrollLeft=w.left,w.element.scrollTop=w.top}He=!!Pr,zr=Pr=null,t.current=n,qs=r;do{try{for(b=t;null!==qs;){var A=qs.flags;if(36&A&&fs(b,qs.alternate,qs),128&A){k=void 0;var S=qs.ref;if(null!==S){var O=qs.stateNode;switch(qs.tag){case 5:k=O;break;default:k=O}"function"==typeof S?S(k):S.current=k}}qs=qs.nextEffect}}catch(t){if(null===qs)throw Error(a(330));Dc(qs,t),qs=qs.nextEffect}}while(null!==qs);qs=null,Di(),Os=i}else t.current=n;if(Us)Us=!1,Ks=t,Hs=e;else for(qs=r;null!==qs;)e=qs.nextEffect,qs.nextEffect=null,8&qs.flags&&((A=qs).sibling=null,A.stateNode=null),qs=e;if(0===(r=t.pendingLanes)&&(Js=null),1===r?t===$s?_s++:(_s=0,$s=t):_s=0,n=n.stateNode,bi&&"function"==typeof bi.onCommitFiberRoot)try{bi.onCommitFiberRoot(vi,n,void 0,64==(64&n.current.flags))}catch(t){}if(lc(t,Qi()),Ns)throw Ns=!1,t=Gs,Gs=null,t;return 0!=(8&Os)||Ni(),null}function Mc(){for(;null!==qs;){var t=qs.alternate;ic||null===rc||(0!=(8&qs.flags)?$t(qs,rc)&&(ic=!0):13===qs.tag&&ws(t,qs)&&$t(qs,rc)&&(ic=!0));var e=qs.flags;0!=(256&e)&&ds(t,qs),0==(512&e)||Us||(Us=!0,qi(97,(function(){return Cc(),null}))),qs=qs.nextEffect}}function Cc(){if(90!==Hs){var t=97<Hs?97:Hs;return Hs=90,Wi(t,Ic)}return!1}function Rc(t,e){Vs.push(e,t),Us||(Us=!0,qi(97,(function(){return Cc(),null})))}function jc(t,e){Zs.push(e,t),Us||(Us=!0,qi(97,(function(){return Cc(),null})))}function Ic(){if(null===Ks)return!1;var t=Ks;if(Ks=null,0!=(48&Os))throw Error(a(331));var e=Os;Os|=32;var n=Zs;Zs=[];for(var r=0;r<n.length;r+=2){var i=n[r],o=n[r+1],s=i.destroy;if(i.destroy=void 0,"function"==typeof s)try{s()}catch(t){if(null===o)throw Error(a(330));Dc(o,t)}}for(n=Vs,Vs=[],r=0;r<n.length;r+=2){i=n[r],o=n[r+1];try{var c=i.create;i.destroy=c()}catch(t){if(null===o)throw Error(a(330));Dc(o,t)}}for(c=t.current.firstEffect;null!==c;)t=c.nextEffect,c.nextEffect=null,8&c.flags&&(c.sibling=null,c.stateNode=null),c=t;return Os=e,Ni(),!0}function Bc(t,e,n){ao(t,e=ss(0,e=is(n,e),1)),e=oc(),null!==(t=cc(t,1))&&(qe(t,1,e),lc(t,e))}function Dc(t,e){if(3===t.tag)Bc(t,t,e);else for(var n=t.return;null!==n;){if(3===n.tag){Bc(n,t,e);break}if(1===n.tag){var r=n.stateNode;if("function"==typeof n.type.getDerivedStateFromError||"function"==typeof r.componentDidCatch&&(null===Js||!Js.has(r))){var i=cs(n,t=is(e,t),1);if(ao(n,i),i=oc(),null!==(n=cc(n,1)))qe(n,1,i),lc(n,i);else if("function"==typeof r.componentDidCatch&&(null===Js||!Js.has(r)))try{r.componentDidCatch(e,t)}catch(t){}break}}n=n.return}}function Tc(t,e,n){var r=t.pingCache;null!==r&&r.delete(e),e=oc(),t.pingedLanes|=t.suspendedLanes&n,Es===t&&(Cs&n)===n&&(4===Is||3===Is&&(62914560&Cs)===Cs&&500>Qi()-Qs?yc(t,0):Ps|=n),lc(t,e)}function Fc(t,e){var n=t.stateNode;null!==n&&n.delete(e),0===(e=0)&&(0==(2&(e=t.mode))?e=1:0==(4&e)?e=99===Li()?1:2:(0===ec&&(ec=Ds),0===(e=Ye(62914560&~ec))&&(e=4194304))),n=oc(),null!==(t=cc(t,e))&&(qe(t,e,n),lc(t,n))}function Pc(t,e,n,r){this.tag=t,this.key=n,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=e,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=r,this.flags=0,this.lastEffect=this.firstEffect=this.nextEffect=null,this.childLanes=this.lanes=0,this.alternate=null}function zc(t,e,n,r){return new Pc(t,e,n,r)}function Qc(t){return!(!(t=t.prototype)||!t.isReactComponent)}function Lc(t,e){var n=t.alternate;return null===n?((n=zc(t.tag,e,t.key,t.mode)).elementType=t.elementType,n.type=t.type,n.stateNode=t.stateNode,n.alternate=t,t.alternate=n):(n.pendingProps=e,n.type=t.type,n.flags=0,n.nextEffect=null,n.firstEffect=null,n.lastEffect=null),n.childLanes=t.childLanes,n.lanes=t.lanes,n.child=t.child,n.memoizedProps=t.memoizedProps,n.memoizedState=t.memoizedState,n.updateQueue=t.updateQueue,e=t.dependencies,n.dependencies=null===e?null:{lanes:e.lanes,firstContext:e.firstContext},n.sibling=t.sibling,n.index=t.index,n.ref=t.ref,n}function Yc(t,e,n,r,i,o){var s=2;if(r=t,"function"==typeof t)Qc(t)&&(s=1);else if("string"==typeof t)s=5;else t:switch(t){case S:return Wc(n.children,i,o,e);case P:s=8,i|=16;break;case O:s=8,i|=1;break;case E:return(t=zc(12,n,e,8|i)).elementType=E,t.type=E,t.lanes=o,t;case j:return(t=zc(13,n,e,i)).type=j,t.elementType=j,t.lanes=o,t;case I:return(t=zc(19,n,e,i)).elementType=I,t.lanes=o,t;case z:return qc(n,i,o,e);case Q:return(t=zc(24,n,e,i)).elementType=Q,t.lanes=o,t;default:if("object"==typeof t&&null!==t)switch(t.$$typeof){case M:s=10;break t;case C:s=9;break t;case R:s=11;break t;case B:s=14;break t;case D:s=16,r=null;break t;case T:s=22;break t}throw Error(a(130,null==t?t:typeof t,""))}return(e=zc(s,n,e,i)).elementType=t,e.type=r,e.lanes=o,e}function Wc(t,e,n,r){return(t=zc(7,t,r,e)).lanes=n,t}function qc(t,e,n,r){return(t=zc(23,t,r,e)).elementType=z,t.lanes=n,t}function Nc(t,e,n){return(t=zc(6,t,null,e)).lanes=n,t}function Gc(t,e,n){return(e=zc(4,null!==t.children?t.children:[],t.key,e)).lanes=n,e.stateNode={containerInfo:t.containerInfo,pendingChildren:null,implementation:t.implementation},e}function Jc(t,e,n){this.tag=e,this.containerInfo=t,this.finishedWork=this.pingCache=this.current=this.pendingChildren=null,this.timeoutHandle=-1,this.pendingContext=this.context=null,this.hydrate=n,this.callbackNode=null,this.callbackPriority=0,this.eventTimes=We(0),this.expirationTimes=We(-1),this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0,this.entanglements=We(0),this.mutableSourceEagerHydrationData=null}function Uc(t,e,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:A,key:null==r?null:""+r,children:t,containerInfo:e,implementation:n}}function Kc(t,e,n,r){var i=e.current,o=oc(),s=ac(i);t:if(n){e:{if(Vt(n=n._reactInternals)!==n||1!==n.tag)throw Error(a(170));var c=n;do{switch(c.tag){case 3:c=c.stateNode.context;break e;case 1:if(fi(c.type)){c=c.stateNode.__reactInternalMemoizedMergedChildContext;break e}}c=c.return}while(null!==c);throw Error(a(171))}if(1===n.tag){var l=n.type;if(fi(l)){n=gi(n,l,c);break t}}n=c}else n=si;return null===e.context?e.context=n:e.pendingContext=n,(e=oo(o,s)).payload={element:t},null!==(r=void 0===r?null:r)&&(e.callback=r),ao(i,e),sc(i,s,o),s}function Hc(t){if(!(t=t.current).child)return null;switch(t.child.tag){case 5:default:return t.child.stateNode}}function Vc(t,e){if(null!==(t=t.memoizedState)&&null!==t.dehydrated){var n=t.retryLane;t.retryLane=0!==n&&n<e?n:e}}function Zc(t,e){Vc(t,e),(t=t.alternate)&&Vc(t,e)}function Xc(t,e,n){var r=null!=n&&null!=n.hydrationOptions&&n.hydrationOptions.mutableSources||null;if(n=new Jc(t,e,null!=n&&!0===n.hydrate),e=zc(3,null,null,2===e?7:1===e?3:0),n.current=e,e.stateNode=n,ro(e),t[Vr]=n.current,Mr(8===t.nodeType?t.parentNode:t),r)for(t=0;t<r.length;t++){var i=(e=r[t])._getVersion;i=i(e._source),null==n.mutableSourceEagerHydrationData?n.mutableSourceEagerHydrationData=[e,i]:n.mutableSourceEagerHydrationData.push(e,i)}this._internalRoot=n}function _c(t){return!(!t||1!==t.nodeType&&9!==t.nodeType&&11!==t.nodeType&&(8!==t.nodeType||" react-mount-point-unstable "!==t.nodeValue))}function $c(t,e,n,r,i){var o=n._reactRootContainer;if(o){var a=o._internalRoot;if("function"==typeof i){var s=i;i=function(){var t=Hc(a);s.call(t)}}Kc(e,a,t,i)}else{if(o=n._reactRootContainer=function(t,e){if(e||(e=!(!(e=t?9===t.nodeType?t.documentElement:t.firstChild:null)||1!==e.nodeType||!e.hasAttribute("data-reactroot"))),!e)for(var n;n=t.lastChild;)t.removeChild(n);return new Xc(t,0,e?{hydrate:!0}:void 0)}(n,r),a=o._internalRoot,"function"==typeof i){var c=i;i=function(){var t=Hc(a);c.call(t)}}pc((function(){Kc(e,a,t,i)}))}return Hc(a)}function tl(t,e){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!_c(e))throw Error(a(200));return Uc(t,e,null,n)}Ws=function(t,e,n){var r=e.lanes;if(null!==t)if(t.memoizedProps!==e.pendingProps||li.current)Ba=!0;else{if(0==(n&r)){switch(Ba=!1,e.tag){case 3:qa(e),No();break;case 5:Io(e);break;case 1:fi(e.type)&&mi(e);break;case 4:Ro(e,e.stateNode.containerInfo);break;case 10:r=e.memoizedProps.value;var i=e.type._context;ai(Ki,i._currentValue),i._currentValue=r;break;case 13:if(null!==e.memoizedState)return 0!=(n&e.child.childLanes)?Ka(t,e,n):(ai(Do,1&Do.current),null!==(e=ts(t,e,n))?e.sibling:null);ai(Do,1&Do.current);break;case 19:if(r=0!=(n&e.childLanes),0!=(64&t.flags)){if(r)return $a(t,e,n);e.flags|=64}if(null!==(i=e.memoizedState)&&(i.rendering=null,i.tail=null,i.lastEffect=null),ai(Do,Do.current),r)break;return null;case 23:case 24:return e.lanes=0,za(t,e,n)}return ts(t,e,n)}Ba=0!=(16384&t.flags)}else Ba=!1;switch(e.lanes=0,e.tag){case 2:if(r=e.type,null!==t&&(t.alternate=null,e.alternate=null,e.flags|=2),t=e.pendingProps,i=di(e,ci.current),to(e,n),i=na(null,e,r,t,i,n),e.flags|=1,"object"==typeof i&&null!==i&&"function"==typeof i.render&&void 0===i.$$typeof){if(e.tag=1,e.memoizedState=null,e.updateQueue=null,fi(r)){var o=!0;mi(e)}else o=!1;e.memoizedState=null!==i.state&&void 0!==i.state?i.state:null,ro(e);var s=r.getDerivedStateFromProps;"function"==typeof s&&fo(e,r,s,t),i.updater=ho,e.stateNode=i,i._reactInternals=e,yo(e,r,t,n),e=Wa(null,e,r,!0,o,n)}else e.tag=0,Da(null,e,i,n),e=e.child;return e;case 16:i=e.elementType;t:{switch(null!==t&&(t.alternate=null,e.alternate=null,e.flags|=2),t=e.pendingProps,i=(o=i._init)(i._payload),e.type=i,o=e.tag=function(t){if("function"==typeof t)return Qc(t)?1:0;if(null!=t){if((t=t.$$typeof)===R)return 11;if(t===B)return 14}return 2}(i),t=Ui(i,t),o){case 0:e=La(null,e,i,t,n);break t;case 1:e=Ya(null,e,i,t,n);break t;case 11:e=Ta(null,e,i,t,n);break t;case 14:e=Fa(null,e,i,Ui(i.type,t),r,n);break t}throw Error(a(306,i,""))}return e;case 0:return r=e.type,i=e.pendingProps,La(t,e,r,i=e.elementType===r?i:Ui(r,i),n);case 1:return r=e.type,i=e.pendingProps,Ya(t,e,r,i=e.elementType===r?i:Ui(r,i),n);case 3:if(qa(e),r=e.updateQueue,null===t||null===r)throw Error(a(282));if(r=e.pendingProps,i=null!==(i=e.memoizedState)?i.element:null,io(t,e),co(e,r,null,n),(r=e.memoizedState.element)===i)No(),e=ts(t,e,n);else{if((o=(i=e.stateNode).hydrate)&&(Po=Nr(e.stateNode.containerInfo.firstChild),Fo=e,o=zo=!0),o){if(null!=(t=i.mutableSourceEagerHydrationData))for(i=0;i<t.length;i+=2)(o=t[i])._workInProgressVersionPrimary=t[i+1],Go.push(o);for(n=Ao(e,null,r,n),e.child=n;n;)n.flags=-3&n.flags|1024,n=n.sibling}else Da(t,e,r,n),No();e=e.child}return e;case 5:return Io(e),null===t&&Yo(e),r=e.type,i=e.pendingProps,o=null!==t?t.memoizedProps:null,s=i.children,Lr(r,i)?s=null:null!==o&&Lr(r,o)&&(e.flags|=16),Qa(t,e),Da(t,e,s,n),e.child;case 6:return null===t&&Yo(e),null;case 13:return Ka(t,e,n);case 4:return Ro(e,e.stateNode.containerInfo),r=e.pendingProps,null===t?e.child=xo(e,null,r,n):Da(t,e,r,n),e.child;case 11:return r=e.type,i=e.pendingProps,Ta(t,e,r,i=e.elementType===r?i:Ui(r,i),n);case 7:return Da(t,e,e.pendingProps,n),e.child;case 8:case 12:return Da(t,e,e.pendingProps.children,n),e.child;case 10:t:{r=e.type._context,i=e.pendingProps,s=e.memoizedProps,o=i.value;var c=e.type._context;if(ai(Ki,c._currentValue),c._currentValue=o,null!==s)if(c=s.value,0===(o=ar(c,o)?0:0|("function"==typeof r._calculateChangedBits?r._calculateChangedBits(c,o):1073741823))){if(s.children===i.children&&!li.current){e=ts(t,e,n);break t}}else for(null!==(c=e.child)&&(c.return=e);null!==c;){var l=c.dependencies;if(null!==l){s=c.child;for(var u=l.firstContext;null!==u;){if(u.context===r&&0!=(u.observedBits&o)){1===c.tag&&((u=oo(-1,n&-n)).tag=2,ao(c,u)),c.lanes|=n,null!==(u=c.alternate)&&(u.lanes|=n),$i(c.return,n),l.lanes|=n;break}u=u.next}}else s=10===c.tag&&c.type===e.type?null:c.child;if(null!==s)s.return=c;else for(s=c;null!==s;){if(s===e){s=null;break}if(null!==(c=s.sibling)){c.return=s.return,s=c;break}s=s.return}c=s}Da(t,e,i.children,n),e=e.child}return e;case 9:return i=e.type,r=(o=e.pendingProps).children,to(e,n),r=r(i=eo(i,o.unstable_observedBits)),e.flags|=1,Da(t,e,r,n),e.child;case 14:return o=Ui(i=e.type,e.pendingProps),Fa(t,e,i,o=Ui(i.type,o),r,n);case 15:return Pa(t,e,e.type,e.pendingProps,r,n);case 17:return r=e.type,i=e.pendingProps,i=e.elementType===r?i:Ui(r,i),null!==t&&(t.alternate=null,e.alternate=null,e.flags|=2),e.tag=1,fi(r)?(t=!0,mi(e)):t=!1,to(e,n),go(e,r,i),yo(e,r,i,n),Wa(null,e,r,!0,t,n);case 19:return $a(t,e,n);case 23:case 24:return za(t,e,n)}throw Error(a(156,e.tag))},Xc.prototype.render=function(t){Kc(t,this._internalRoot,null,null)},Xc.prototype.unmount=function(){var t=this._internalRoot,e=t.containerInfo;Kc(null,t,null,(function(){e[Vr]=null}))},te=function(t){13===t.tag&&(sc(t,4,oc()),Zc(t,4))},ee=function(t){13===t.tag&&(sc(t,67108864,oc()),Zc(t,67108864))},ne=function(t){if(13===t.tag){var e=oc(),n=ac(t);sc(t,n,e),Zc(t,n)}},re=function(t,e){return e()},Et=function(t,e,n){switch(e){case"input":if(nt(t,n),e=n.name,"radio"===n.type&&null!=e){for(n=t;n.parentNode;)n=n.parentNode;for(n=n.querySelectorAll("input[name="+JSON.stringify(""+e)+'][type="radio"]'),e=0;e<n.length;e++){var r=n[e];if(r!==t&&r.form===t.form){var i=ti(r);if(!i)throw Error(a(90));X(r),nt(r,i)}}}break;case"textarea":lt(t,n);break;case"select":null!=(e=n.value)&&at(t,!!n.multiple,e,!1)}},Bt=hc,Dt=function(t,e,n,r,i){var o=Os;Os|=4;try{return Wi(98,t.bind(null,e,n,r,i))}finally{0===(Os=o)&&(Ys(),Ni())}},Tt=function(){0==(49&Os)&&(function(){if(null!==Xs){var t=Xs;Xs=null,t.forEach((function(t){t.expiredLanes|=24&t.pendingLanes,lc(t,Qi())}))}Ni()}(),Cc())},Ft=function(t,e){var n=Os;Os|=2;try{return t(e)}finally{0===(Os=n)&&(Ys(),Ni())}};var el={Events:[_r,$r,ti,jt,It,Cc,{current:!1}]},nl={findFiberByHostInstance:Xr,bundleType:0,version:"17.0.2",rendererPackageName:"react-dom"},rl={bundleType:nl.bundleType,version:nl.version,rendererPackageName:nl.rendererPackageName,rendererConfig:nl.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:w.ReactCurrentDispatcher,findHostInstanceByFiber:function(t){return null===(t=_t(t))?null:t.stateNode},findFiberByHostInstance:nl.findFiberByHostInstance||function(){return null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var il=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!il.isDisabled&&il.supportsFiber)try{vi=il.inject(rl),bi=il}catch(t){}}e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=el,e.createPortal=tl,e.findDOMNode=function(t){if(null==t)return null;if(1===t.nodeType)return t;var e=t._reactInternals;if(void 0===e){if("function"==typeof t.render)throw Error(a(188));throw Error(a(268,Object.keys(t)))}return t=null===(t=_t(e))?null:t.stateNode},e.flushSync=function(t,e){var n=Os;if(0!=(48&n))return t(e);Os|=1;try{if(t)return Wi(99,t.bind(null,e))}finally{Os=n,Ni()}},e.hydrate=function(t,e,n){if(!_c(e))throw Error(a(200));return $c(null,t,e,!0,n)},e.render=function(t,e,n){if(!_c(e))throw Error(a(200));return $c(null,t,e,!1,n)},e.unmountComponentAtNode=function(t){if(!_c(t))throw Error(a(40));return!!t._reactRootContainer&&(pc((function(){$c(null,null,t,!1,(function(){t._reactRootContainer=null,t[Vr]=null}))})),!0)},e.unstable_batchedUpdates=hc,e.unstable_createPortal=function(t,e){return tl(t,e,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)},e.unstable_renderSubtreeIntoContainer=function(t,e,n,r){if(!_c(n))throw Error(a(200));if(null==t||void 0===t._reactInternals)throw Error(a(38));return $c(t,e,n,!1,r)},e.version="17.0.2"},function(t,e,n){"use strict";
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var r=n(36),i=60103,o=60106;e.Fragment=60107,e.StrictMode=60108,e.Profiler=60114;var a=60109,s=60110,c=60112;e.Suspense=60113;var l=60115,u=60116;if("function"==typeof Symbol&&Symbol.for){var d=Symbol.for;i=d("react.element"),o=d("react.portal"),e.Fragment=d("react.fragment"),e.StrictMode=d("react.strict_mode"),e.Profiler=d("react.profiler"),a=d("react.provider"),s=d("react.context"),c=d("react.forward_ref"),e.Suspense=d("react.suspense"),l=d("react.memo"),u=d("react.lazy")}var f="function"==typeof Symbol&&Symbol.iterator;function h(t){for(var e="https://reactjs.org/docs/error-decoder.html?invariant="+t,n=1;n<arguments.length;n++)e+="&args[]="+encodeURIComponent(arguments[n]);return"Minified React error #"+t+"; visit "+e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var p={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},g={};function m(t,e,n){this.props=t,this.context=e,this.refs=g,this.updater=n||p}function y(){}function v(t,e,n){this.props=t,this.context=e,this.refs=g,this.updater=n||p}m.prototype.isReactComponent={},m.prototype.setState=function(t,e){if("object"!=typeof t&&"function"!=typeof t&&null!=t)throw Error(h(85));this.updater.enqueueSetState(this,t,e,"setState")},m.prototype.forceUpdate=function(t){this.updater.enqueueForceUpdate(this,t,"forceUpdate")},y.prototype=m.prototype;var b=v.prototype=new y;b.constructor=v,r(b,m.prototype),b.isPureReactComponent=!0;var k={current:null},w=Object.prototype.hasOwnProperty,x={key:!0,ref:!0,__self:!0,__source:!0};function A(t,e,n){var r,o={},a=null,s=null;if(null!=e)for(r in void 0!==e.ref&&(s=e.ref),void 0!==e.key&&(a=""+e.key),e)w.call(e,r)&&!x.hasOwnProperty(r)&&(o[r]=e[r]);var c=arguments.length-2;if(1===c)o.children=n;else if(1<c){for(var l=Array(c),u=0;u<c;u++)l[u]=arguments[u+2];o.children=l}if(t&&t.defaultProps)for(r in c=t.defaultProps)void 0===o[r]&&(o[r]=c[r]);return{$$typeof:i,type:t,key:a,ref:s,props:o,_owner:k.current}}function S(t){return"object"==typeof t&&null!==t&&t.$$typeof===i}var O=/\/+/g;function E(t,e){return"object"==typeof t&&null!==t&&null!=t.key?function(t){var e={"=":"=0",":":"=2"};return"$"+t.replace(/[=:]/g,(function(t){return e[t]}))}(""+t.key):e.toString(36)}function M(t,e,n,r,a){var s=typeof t;"undefined"!==s&&"boolean"!==s||(t=null);var c=!1;if(null===t)c=!0;else switch(s){case"string":case"number":c=!0;break;case"object":switch(t.$$typeof){case i:case o:c=!0}}if(c)return a=a(c=t),t=""===r?"."+E(c,0):r,Array.isArray(a)?(n="",null!=t&&(n=t.replace(O,"$&/")+"/"),M(a,e,n,"",(function(t){return t}))):null!=a&&(S(a)&&(a=function(t,e){return{$$typeof:i,type:t.type,key:e,ref:t.ref,props:t.props,_owner:t._owner}}(a,n+(!a.key||c&&c.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+t)),e.push(a)),1;if(c=0,r=""===r?".":r+":",Array.isArray(t))for(var l=0;l<t.length;l++){var u=r+E(s=t[l],l);c+=M(s,e,n,u,a)}else if("function"==typeof(u=function(t){return null===t||"object"!=typeof t?null:"function"==typeof(t=f&&t[f]||t["@@iterator"])?t:null}(t)))for(t=u.call(t),l=0;!(s=t.next()).done;)c+=M(s=s.value,e,n,u=r+E(s,l++),a);else if("object"===s)throw e=""+t,Error(h(31,"[object Object]"===e?"object with keys {"+Object.keys(t).join(", ")+"}":e));return c}function C(t,e,n){if(null==t)return t;var r=[],i=0;return M(t,r,"","",(function(t){return e.call(n,t,i++)})),r}function R(t){if(-1===t._status){var e=t._result;e=e(),t._status=0,t._result=e,e.then((function(e){0===t._status&&(e=e.default,t._status=1,t._result=e)}),(function(e){0===t._status&&(t._status=2,t._result=e)}))}if(1===t._status)return t._result;throw t._result}var j={current:null};function I(){var t=j.current;if(null===t)throw Error(h(321));return t}var B={ReactCurrentDispatcher:j,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:k,IsSomeRendererActing:{current:!1},assign:r};e.Children={map:C,forEach:function(t,e,n){C(t,(function(){e.apply(this,arguments)}),n)},count:function(t){var e=0;return C(t,(function(){e++})),e},toArray:function(t){return C(t,(function(t){return t}))||[]},only:function(t){if(!S(t))throw Error(h(143));return t}},e.Component=m,e.PureComponent=v,e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=B,e.cloneElement=function(t,e,n){if(null==t)throw Error(h(267,t));var o=r({},t.props),a=t.key,s=t.ref,c=t._owner;if(null!=e){if(void 0!==e.ref&&(s=e.ref,c=k.current),void 0!==e.key&&(a=""+e.key),t.type&&t.type.defaultProps)var l=t.type.defaultProps;for(u in e)w.call(e,u)&&!x.hasOwnProperty(u)&&(o[u]=void 0===e[u]&&void 0!==l?l[u]:e[u])}var u=arguments.length-2;if(1===u)o.children=n;else if(1<u){l=Array(u);for(var d=0;d<u;d++)l[d]=arguments[d+2];o.children=l}return{$$typeof:i,type:t.type,key:a,ref:s,props:o,_owner:c}},e.createContext=function(t,e){return void 0===e&&(e=null),(t={$$typeof:s,_calculateChangedBits:e,_currentValue:t,_currentValue2:t,_threadCount:0,Provider:null,Consumer:null}).Provider={$$typeof:a,_context:t},t.Consumer=t},e.createElement=A,e.createFactory=function(t){var e=A.bind(null,t);return e.type=t,e},e.createRef=function(){return{current:null}},e.forwardRef=function(t){return{$$typeof:c,render:t}},e.isValidElement=S,e.lazy=function(t){return{$$typeof:u,_payload:{_status:-1,_result:t},_init:R}},e.memo=function(t,e){return{$$typeof:l,type:t,compare:void 0===e?null:e}},e.useCallback=function(t,e){return I().useCallback(t,e)},e.useContext=function(t,e){return I().useContext(t,e)},e.useDebugValue=function(){},e.useEffect=function(t,e){return I().useEffect(t,e)},e.useImperativeHandle=function(t,e,n){return I().useImperativeHandle(t,e,n)},e.useLayoutEffect=function(t,e){return I().useLayoutEffect(t,e)},e.useMemo=function(t,e){return I().useMemo(t,e)},e.useReducer=function(t,e,n){return I().useReducer(t,e,n)},e.useRef=function(t){return I().useRef(t)},e.useState=function(t){return I().useState(t)},e.version="17.0.2"},function(t,e,n){"use strict";t.exports=n(57)},function(t,e,n){"use strict";
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var r,i,o,a;if("object"==typeof performance&&"function"==typeof performance.now){var s=performance;e.unstable_now=function(){return s.now()}}else{var c=Date,l=c.now();e.unstable_now=function(){return c.now()-l}}if("undefined"==typeof window||"function"!=typeof MessageChannel){var u=null,d=null,f=function(){if(null!==u)try{var t=e.unstable_now();u(!0,t),u=null}catch(t){throw setTimeout(f,0),t}};r=function(t){null!==u?setTimeout(r,0,t):(u=t,setTimeout(f,0))},i=function(t,e){d=setTimeout(t,e)},o=function(){clearTimeout(d)},e.unstable_shouldYield=function(){return!1},a=e.unstable_forceFrameRate=function(){}}else{var h=window.setTimeout,p=window.clearTimeout;if("undefined"!=typeof console){var g=window.cancelAnimationFrame;"function"!=typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"),"function"!=typeof g&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var m=!1,y=null,v=-1,b=5,k=0;e.unstable_shouldYield=function(){return e.unstable_now()>=k},a=function(){},e.unstable_forceFrameRate=function(t){0>t||125<t?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):b=0<t?Math.floor(1e3/t):5};var w=new MessageChannel,x=w.port2;w.port1.onmessage=function(){if(null!==y){var t=e.unstable_now();k=t+b;try{y(!0,t)?x.postMessage(null):(m=!1,y=null)}catch(t){throw x.postMessage(null),t}}else m=!1},r=function(t){y=t,m||(m=!0,x.postMessage(null))},i=function(t,n){v=h((function(){t(e.unstable_now())}),n)},o=function(){p(v),v=-1}}function A(t,e){var n=t.length;t.push(e);t:for(;;){var r=n-1>>>1,i=t[r];if(!(void 0!==i&&0<E(i,e)))break t;t[r]=e,t[n]=i,n=r}}function S(t){return void 0===(t=t[0])?null:t}function O(t){var e=t[0];if(void 0!==e){var n=t.pop();if(n!==e){t[0]=n;t:for(var r=0,i=t.length;r<i;){var o=2*(r+1)-1,a=t[o],s=o+1,c=t[s];if(void 0!==a&&0>E(a,n))void 0!==c&&0>E(c,a)?(t[r]=c,t[s]=n,r=s):(t[r]=a,t[o]=n,r=o);else{if(!(void 0!==c&&0>E(c,n)))break t;t[r]=c,t[s]=n,r=s}}}return e}return null}function E(t,e){var n=t.sortIndex-e.sortIndex;return 0!==n?n:t.id-e.id}var M=[],C=[],R=1,j=null,I=3,B=!1,D=!1,T=!1;function F(t){for(var e=S(C);null!==e;){if(null===e.callback)O(C);else{if(!(e.startTime<=t))break;O(C),e.sortIndex=e.expirationTime,A(M,e)}e=S(C)}}function P(t){if(T=!1,F(t),!D)if(null!==S(M))D=!0,r(z);else{var e=S(C);null!==e&&i(P,e.startTime-t)}}function z(t,n){D=!1,T&&(T=!1,o()),B=!0;var r=I;try{for(F(n),j=S(M);null!==j&&(!(j.expirationTime>n)||t&&!e.unstable_shouldYield());){var a=j.callback;if("function"==typeof a){j.callback=null,I=j.priorityLevel;var s=a(j.expirationTime<=n);n=e.unstable_now(),"function"==typeof s?j.callback=s:j===S(M)&&O(M),F(n)}else O(M);j=S(M)}if(null!==j)var c=!0;else{var l=S(C);null!==l&&i(P,l.startTime-n),c=!1}return c}finally{j=null,I=r,B=!1}}var Q=a;e.unstable_IdlePriority=5,e.unstable_ImmediatePriority=1,e.unstable_LowPriority=4,e.unstable_NormalPriority=3,e.unstable_Profiling=null,e.unstable_UserBlockingPriority=2,e.unstable_cancelCallback=function(t){t.callback=null},e.unstable_continueExecution=function(){D||B||(D=!0,r(z))},e.unstable_getCurrentPriorityLevel=function(){return I},e.unstable_getFirstCallbackNode=function(){return S(M)},e.unstable_next=function(t){switch(I){case 1:case 2:case 3:var e=3;break;default:e=I}var n=I;I=e;try{return t()}finally{I=n}},e.unstable_pauseExecution=function(){},e.unstable_requestPaint=Q,e.unstable_runWithPriority=function(t,e){switch(t){case 1:case 2:case 3:case 4:case 5:break;default:t=3}var n=I;I=t;try{return e()}finally{I=n}},e.unstable_scheduleCallback=function(t,n,a){var s=e.unstable_now();switch("object"==typeof a&&null!==a?a="number"==typeof(a=a.delay)&&0<a?s+a:s:a=s,t){case 1:var c=-1;break;case 2:c=250;break;case 5:c=1073741823;break;case 4:c=1e4;break;default:c=5e3}return t={id:R++,callback:n,priorityLevel:t,startTime:a,expirationTime:c=a+c,sortIndex:-1},a>s?(t.sortIndex=a,A(C,t),null===S(M)&&t===S(C)&&(T?o():T=!0,i(P,a-s))):(t.sortIndex=c,A(M,t),D||B||(D=!0,r(z))),t},e.unstable_wrapCallback=function(t){var e=I;return function(){var n=I;I=e;try{return t.apply(this,arguments)}finally{I=n}}}},function(t,e){t.exports=function(t,e){if(null==t)return{};var n,r,i={},o=Object.keys(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||(i[n]=t[n]);return i},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(37);t.exports=function(t){if(Array.isArray(t))return r(t)},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(t){if(Array.isArray(t))return t},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=n){var r,i,o=[],a=!0,s=!1;try{for(n=n.call(t);!(a=(r=n.next()).done)&&(o.push(r.value),!e||o.length!==e);a=!0);}catch(t){s=!0,i=t}finally{try{a||null==n.return||n.return()}finally{if(s)throw i}}return o}},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){"use strict";const r="'([^']+)'|\"([^\"]+)\"|[\\w\\s-]+",i=new RegExp("(bold|bolder|lighter|[1-9]00) +","i"),o=new RegExp("(italic|oblique) +","i"),a=new RegExp("(small-caps) +","i"),s=new RegExp("(ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded) +","i"),c=new RegExp("([\\d\\.]+)(px|pt|pc|in|cm|mm|%|em|ex|ch|rem|q) *((?:"+r+")( *, *(?:"+r+"))*)"),l={};t.exports=function(t){if(l[t])return l[t];const e=c.exec(t);if(!e)return;const n={weight:"normal",style:"normal",stretch:"normal",variant:"normal",size:parseFloat(e[1]),unit:e[2],family:e[3].replace(/["']/g,"").replace(/ *, */g,",")};let r,u,d,f,h=t.substring(0,e.index);switch((r=i.exec(h))&&(n.weight=r[1]),(u=o.exec(h))&&(n.style=u[1]),(d=a.exec(h))&&(n.variant=d[1]),(f=s.exec(h))&&(n.stretch=f[1]),n.unit){case"pt":n.size/=.75;break;case"pc":n.size*=16;break;case"in":n.size*=96;break;case"cm":n.size*=96/2.54;break;case"mm":n.size*=96/25.4;break;case"%":break;case"em":case"rem":n.size*=16/.75;break;case"q":n.size*=96/25.4/4}return l[t]=n}},function(t,e,n){"use strict";var r=n(67);function i(){}function o(){}o.resetWarningCache=i,t.exports=function(){function t(t,e,n,i,o,a){if(a!==r){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:o,resetWarningCache:i};return n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){(function(t){var r=void 0!==t&&t||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function o(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new o(i.call(setTimeout,r,arguments),clearTimeout)},e.setInterval=function(){return new o(i.call(setInterval,r,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(r,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout((function(){t._onTimeout&&t._onTimeout()}),e))},n(69),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,n(26))},function(t,e,n){(function(t,e){!function(t,n){"use strict";if(!t.setImmediate){var r,i,o,a,s,c=1,l={},u=!1,d=t.document,f=Object.getPrototypeOf&&Object.getPrototypeOf(t);f=f&&f.setTimeout?f:t,"[object process]"==={}.toString.call(t.process)?r=function(t){e.nextTick((function(){p(t)}))}:!function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?t.MessageChannel?((o=new MessageChannel).port1.onmessage=function(t){p(t.data)},r=function(t){o.port2.postMessage(t)}):d&&"onreadystatechange"in d.createElement("script")?(i=d.documentElement,r=function(t){var e=d.createElement("script");e.onreadystatechange=function(){p(t),e.onreadystatechange=null,i.removeChild(e),e=null},i.appendChild(e)}):r=function(t){setTimeout(p,0,t)}:(a="setImmediate$"+Math.random()+"$",s=function(e){e.source===t&&"string"==typeof e.data&&0===e.data.indexOf(a)&&p(+e.data.slice(a.length))},t.addEventListener?t.addEventListener("message",s,!1):t.attachEvent("onmessage",s),r=function(e){t.postMessage(a+e,"*")}),f.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var i={callback:t,args:e};return l[c]=i,r(c),c++},f.clearImmediate=h}function h(t){delete l[t]}function p(t){if(u)setTimeout(p,0,t);else{var e=l[t];if(e){u=!0;try{!function(t){var e=t.callback,n=t.args;switch(n.length){case 0:e();break;case 1:e(n[0]);break;case 2:e(n[0],n[1]);break;case 3:e(n[0],n[1],n[2]);break;default:e.apply(void 0,n)}}(e)}finally{h(t),u=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,n(26),n(70))},function(t,e){var n,r,i=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{r="function"==typeof clearTimeout?clearTimeout:a}catch(t){r=a}}();var c,l=[],u=!1,d=-1;function f(){u&&c&&(u=!1,c.length?l=c.concat(l):d=-1,l.length&&h())}function h(){if(!u){var t=s(f);u=!0;for(var e=l.length;e;){for(c=l,l=[];++d<e;)c&&c[d].run();d=-1,e=l.length}c=null,u=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===a||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function p(t,e){this.fun=t,this.array=e}function g(){}i.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];l.push(new p(t,e)),1!==l.length||u||s(h)},p.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=g,i.addListener=g,i.once=g,i.off=g,i.removeListener=g,i.removeAllListeners=g,i.emit=g,i.prependListener=g,i.prependOnceListener=g,i.listeners=function(t){return[]},i.binding=function(t){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(t){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(t,e){t.exports=["alignContent","MozAlignContent","WebkitAlignContent","MSAlignContent","OAlignContent","alignItems","MozAlignItems","WebkitAlignItems","MSAlignItems","OAlignItems","alignSelf","MozAlignSelf","WebkitAlignSelf","MSAlignSelf","OAlignSelf","all","MozAll","WebkitAll","MSAll","OAll","animation","MozAnimation","WebkitAnimation","MSAnimation","OAnimation","animationDelay","MozAnimationDelay","WebkitAnimationDelay","MSAnimationDelay","OAnimationDelay","animationDirection","MozAnimationDirection","WebkitAnimationDirection","MSAnimationDirection","OAnimationDirection","animationDuration","MozAnimationDuration","WebkitAnimationDuration","MSAnimationDuration","OAnimationDuration","animationFillMode","MozAnimationFillMode","WebkitAnimationFillMode","MSAnimationFillMode","OAnimationFillMode","animationIterationCount","MozAnimationIterationCount","WebkitAnimationIterationCount","MSAnimationIterationCount","OAnimationIterationCount","animationName","MozAnimationName","WebkitAnimationName","MSAnimationName","OAnimationName","animationPlayState","MozAnimationPlayState","WebkitAnimationPlayState","MSAnimationPlayState","OAnimationPlayState","animationTimingFunction","MozAnimationTimingFunction","WebkitAnimationTimingFunction","MSAnimationTimingFunction","OAnimationTimingFunction","backfaceVisibility","MozBackfaceVisibility","WebkitBackfaceVisibility","MSBackfaceVisibility","OBackfaceVisibility","background","MozBackground","WebkitBackground","MSBackground","OBackground","backgroundAttachment","MozBackgroundAttachment","WebkitBackgroundAttachment","MSBackgroundAttachment","OBackgroundAttachment","backgroundBlendMode","MozBackgroundBlendMode","WebkitBackgroundBlendMode","MSBackgroundBlendMode","OBackgroundBlendMode","backgroundClip","MozBackgroundClip","WebkitBackgroundClip","MSBackgroundClip","OBackgroundClip","backgroundColor","MozBackgroundColor","WebkitBackgroundColor","MSBackgroundColor","OBackgroundColor","backgroundImage","MozBackgroundImage","WebkitBackgroundImage","MSBackgroundImage","OBackgroundImage","backgroundOrigin","MozBackgroundOrigin","WebkitBackgroundOrigin","MSBackgroundOrigin","OBackgroundOrigin","backgroundPosition","MozBackgroundPosition","WebkitBackgroundPosition","MSBackgroundPosition","OBackgroundPosition","backgroundRepeat","MozBackgroundRepeat","WebkitBackgroundRepeat","MSBackgroundRepeat","OBackgroundRepeat","backgroundSize","MozBackgroundSize","WebkitBackgroundSize","MSBackgroundSize","OBackgroundSize","blockSize","MozBlockSize","WebkitBlockSize","MSBlockSize","OBlockSize","border","MozBorder","WebkitBorder","MSBorder","OBorder","borderBlockEnd","MozBorderBlockEnd","WebkitBorderBlockEnd","MSBorderBlockEnd","OBorderBlockEnd","borderBlockEndColor","MozBorderBlockEndColor","WebkitBorderBlockEndColor","MSBorderBlockEndColor","OBorderBlockEndColor","borderBlockEndStyle","MozBorderBlockEndStyle","WebkitBorderBlockEndStyle","MSBorderBlockEndStyle","OBorderBlockEndStyle","borderBlockEndWidth","MozBorderBlockEndWidth","WebkitBorderBlockEndWidth","MSBorderBlockEndWidth","OBorderBlockEndWidth","borderBlockStart","MozBorderBlockStart","WebkitBorderBlockStart","MSBorderBlockStart","OBorderBlockStart","borderBlockStartColor","MozBorderBlockStartColor","WebkitBorderBlockStartColor","MSBorderBlockStartColor","OBorderBlockStartColor","borderBlockStartStyle","MozBorderBlockStartStyle","WebkitBorderBlockStartStyle","MSBorderBlockStartStyle","OBorderBlockStartStyle","borderBlockStartWidth","MozBorderBlockStartWidth","WebkitBorderBlockStartWidth","MSBorderBlockStartWidth","OBorderBlockStartWidth","borderBottom","MozBorderBottom","WebkitBorderBottom","MSBorderBottom","OBorderBottom","borderBottomColor","MozBorderBottomColor","WebkitBorderBottomColor","MSBorderBottomColor","OBorderBottomColor","borderBottomLeftRadius","MozBorderBottomLeftRadius","WebkitBorderBottomLeftRadius","MSBorderBottomLeftRadius","OBorderBottomLeftRadius","borderBottomRightRadius","MozBorderBottomRightRadius","WebkitBorderBottomRightRadius","MSBorderBottomRightRadius","OBorderBottomRightRadius","borderBottomStyle","MozBorderBottomStyle","WebkitBorderBottomStyle","MSBorderBottomStyle","OBorderBottomStyle","borderBottomWidth","MozBorderBottomWidth","WebkitBorderBottomWidth","MSBorderBottomWidth","OBorderBottomWidth","borderCollapse","MozBorderCollapse","WebkitBorderCollapse","MSBorderCollapse","OBorderCollapse","borderColor","MozBorderColor","WebkitBorderColor","MSBorderColor","OBorderColor","borderImage","MozBorderImage","WebkitBorderImage","MSBorderImage","OBorderImage","borderImageOutset","MozBorderImageOutset","WebkitBorderImageOutset","MSBorderImageOutset","OBorderImageOutset","borderImageRepeat","MozBorderImageRepeat","WebkitBorderImageRepeat","MSBorderImageRepeat","OBorderImageRepeat","borderImageSlice","MozBorderImageSlice","WebkitBorderImageSlice","MSBorderImageSlice","OBorderImageSlice","borderImageSource","MozBorderImageSource","WebkitBorderImageSource","MSBorderImageSource","OBorderImageSource","borderImageWidth","MozBorderImageWidth","WebkitBorderImageWidth","MSBorderImageWidth","OBorderImageWidth","borderInlineEnd","MozBorderInlineEnd","WebkitBorderInlineEnd","MSBorderInlineEnd","OBorderInlineEnd","borderInlineEndColor","MozBorderInlineEndColor","WebkitBorderInlineEndColor","MSBorderInlineEndColor","OBorderInlineEndColor","borderInlineEndStyle","MozBorderInlineEndStyle","WebkitBorderInlineEndStyle","MSBorderInlineEndStyle","OBorderInlineEndStyle","borderInlineEndWidth","MozBorderInlineEndWidth","WebkitBorderInlineEndWidth","MSBorderInlineEndWidth","OBorderInlineEndWidth","borderInlineStart","MozBorderInlineStart","WebkitBorderInlineStart","MSBorderInlineStart","OBorderInlineStart","borderInlineStartColor","MozBorderInlineStartColor","WebkitBorderInlineStartColor","MSBorderInlineStartColor","OBorderInlineStartColor","borderInlineStartStyle","MozBorderInlineStartStyle","WebkitBorderInlineStartStyle","MSBorderInlineStartStyle","OBorderInlineStartStyle","borderInlineStartWidth","MozBorderInlineStartWidth","WebkitBorderInlineStartWidth","MSBorderInlineStartWidth","OBorderInlineStartWidth","borderLeft","MozBorderLeft","WebkitBorderLeft","MSBorderLeft","OBorderLeft","borderLeftColor","MozBorderLeftColor","WebkitBorderLeftColor","MSBorderLeftColor","OBorderLeftColor","borderLeftStyle","MozBorderLeftStyle","WebkitBorderLeftStyle","MSBorderLeftStyle","OBorderLeftStyle","borderLeftWidth","MozBorderLeftWidth","WebkitBorderLeftWidth","MSBorderLeftWidth","OBorderLeftWidth","borderRadius","MozBorderRadius","WebkitBorderRadius","MSBorderRadius","OBorderRadius","borderRight","MozBorderRight","WebkitBorderRight","MSBorderRight","OBorderRight","borderRightColor","MozBorderRightColor","WebkitBorderRightColor","MSBorderRightColor","OBorderRightColor","borderRightStyle","MozBorderRightStyle","WebkitBorderRightStyle","MSBorderRightStyle","OBorderRightStyle","borderRightWidth","MozBorderRightWidth","WebkitBorderRightWidth","MSBorderRightWidth","OBorderRightWidth","borderSpacing","MozBorderSpacing","WebkitBorderSpacing","MSBorderSpacing","OBorderSpacing","borderStyle","MozBorderStyle","WebkitBorderStyle","MSBorderStyle","OBorderStyle","borderTop","MozBorderTop","WebkitBorderTop","MSBorderTop","OBorderTop","borderTopColor","MozBorderTopColor","WebkitBorderTopColor","MSBorderTopColor","OBorderTopColor","borderTopLeftRadius","MozBorderTopLeftRadius","WebkitBorderTopLeftRadius","MSBorderTopLeftRadius","OBorderTopLeftRadius","borderTopRightRadius","MozBorderTopRightRadius","WebkitBorderTopRightRadius","MSBorderTopRightRadius","OBorderTopRightRadius","borderTopStyle","MozBorderTopStyle","WebkitBorderTopStyle","MSBorderTopStyle","OBorderTopStyle","borderTopWidth","MozBorderTopWidth","WebkitBorderTopWidth","MSBorderTopWidth","OBorderTopWidth","borderWidth","MozBorderWidth","WebkitBorderWidth","MSBorderWidth","OBorderWidth","bottom","MozBottom","WebkitBottom","MSBottom","OBottom","boxDecorationBreak","MozBoxDecorationBreak","WebkitBoxDecorationBreak","MSBoxDecorationBreak","OBoxDecorationBreak","boxShadow","MozBoxShadow","WebkitBoxShadow","MSBoxShadow","OBoxShadow","boxSizing","MozBoxSizing","WebkitBoxSizing","MSBoxSizing","OBoxSizing","breakAfter","MozBreakAfter","WebkitBreakAfter","MSBreakAfter","OBreakAfter","breakBefore","MozBreakBefore","WebkitBreakBefore","MSBreakBefore","OBreakBefore","breakInside","MozBreakInside","WebkitBreakInside","MSBreakInside","OBreakInside","captionSide","MozCaptionSide","WebkitCaptionSide","MSCaptionSide","OCaptionSide","caretColor","MozCaretColor","WebkitCaretColor","MSCaretColor","OCaretColor","ch","MozCh","WebkitCh","MSCh","OCh","clear","MozClear","WebkitClear","MSClear","OClear","clip","MozClip","WebkitClip","MSClip","OClip","clipPath","MozClipPath","WebkitClipPath","MSClipPath","OClipPath","cm","MozCm","WebkitCm","MSCm","OCm","color","MozColor","WebkitColor","MSColor","OColor","columnCount","MozColumnCount","WebkitColumnCount","MSColumnCount","OColumnCount","columnFill","MozColumnFill","WebkitColumnFill","MSColumnFill","OColumnFill","columnGap","MozColumnGap","WebkitColumnGap","MSColumnGap","OColumnGap","columnRule","MozColumnRule","WebkitColumnRule","MSColumnRule","OColumnRule","columnRuleColor","MozColumnRuleColor","WebkitColumnRuleColor","MSColumnRuleColor","OColumnRuleColor","columnRuleStyle","MozColumnRuleStyle","WebkitColumnRuleStyle","MSColumnRuleStyle","OColumnRuleStyle","columnRuleWidth","MozColumnRuleWidth","WebkitColumnRuleWidth","MSColumnRuleWidth","OColumnRuleWidth","columnSpan","MozColumnSpan","WebkitColumnSpan","MSColumnSpan","OColumnSpan","columnWidth","MozColumnWidth","WebkitColumnWidth","MSColumnWidth","OColumnWidth","columns","MozColumns","WebkitColumns","MSColumns","OColumns","content","MozContent","WebkitContent","MSContent","OContent","counterIncrement","MozCounterIncrement","WebkitCounterIncrement","MSCounterIncrement","OCounterIncrement","counterReset","MozCounterReset","WebkitCounterReset","MSCounterReset","OCounterReset","cursor","MozCursor","WebkitCursor","MSCursor","OCursor","deg","MozDeg","WebkitDeg","MSDeg","ODeg","direction","MozDirection","WebkitDirection","MSDirection","ODirection","display","MozDisplay","WebkitDisplay","MSDisplay","ODisplay","dpcm","MozDpcm","WebkitDpcm","MSDpcm","ODpcm","dpi","MozDpi","WebkitDpi","MSDpi","ODpi","dppx","MozDppx","WebkitDppx","MSDppx","ODppx","em","MozEm","WebkitEm","MSEm","OEm","emptyCells","MozEmptyCells","WebkitEmptyCells","MSEmptyCells","OEmptyCells","ex","MozEx","WebkitEx","MSEx","OEx","filter","MozFilter","WebkitFilter","MSFilter","OFilter","flexBasis","MozFlexBasis","WebkitFlexBasis","MSFlexBasis","OFlexBasis","flexDirection","MozFlexDirection","WebkitFlexDirection","MSFlexDirection","OFlexDirection","flexFlow","MozFlexFlow","WebkitFlexFlow","MSFlexFlow","OFlexFlow","flexGrow","MozFlexGrow","WebkitFlexGrow","MSFlexGrow","OFlexGrow","flexShrink","MozFlexShrink","WebkitFlexShrink","MSFlexShrink","OFlexShrink","flexWrap","MozFlexWrap","WebkitFlexWrap","MSFlexWrap","OFlexWrap","float","MozFloat","WebkitFloat","MSFloat","OFloat","font","MozFont","WebkitFont","MSFont","OFont","fontFamily","MozFontFamily","WebkitFontFamily","MSFontFamily","OFontFamily","fontFeatureSettings","MozFontFeatureSettings","WebkitFontFeatureSettings","MSFontFeatureSettings","OFontFeatureSettings","fontKerning","MozFontKerning","WebkitFontKerning","MSFontKerning","OFontKerning","fontLanguageOverride","MozFontLanguageOverride","WebkitFontLanguageOverride","MSFontLanguageOverride","OFontLanguageOverride","fontSize","MozFontSize","WebkitFontSize","MSFontSize","OFontSize","fontSizeAdjust","MozFontSizeAdjust","WebkitFontSizeAdjust","MSFontSizeAdjust","OFontSizeAdjust","fontStretch","MozFontStretch","WebkitFontStretch","MSFontStretch","OFontStretch","fontStyle","MozFontStyle","WebkitFontStyle","MSFontStyle","OFontStyle","fontSynthesis","MozFontSynthesis","WebkitFontSynthesis","MSFontSynthesis","OFontSynthesis","fontVariant","MozFontVariant","WebkitFontVariant","MSFontVariant","OFontVariant","fontVariantAlternates","MozFontVariantAlternates","WebkitFontVariantAlternates","MSFontVariantAlternates","OFontVariantAlternates","fontVariantCaps","MozFontVariantCaps","WebkitFontVariantCaps","MSFontVariantCaps","OFontVariantCaps","fontVariantEastAsian","MozFontVariantEastAsian","WebkitFontVariantEastAsian","MSFontVariantEastAsian","OFontVariantEastAsian","fontVariantLigatures","MozFontVariantLigatures","WebkitFontVariantLigatures","MSFontVariantLigatures","OFontVariantLigatures","fontVariantNumeric","MozFontVariantNumeric","WebkitFontVariantNumeric","MSFontVariantNumeric","OFontVariantNumeric","fontVariantPosition","MozFontVariantPosition","WebkitFontVariantPosition","MSFontVariantPosition","OFontVariantPosition","fontWeight","MozFontWeight","WebkitFontWeight","MSFontWeight","OFontWeight","fr","MozFr","WebkitFr","MSFr","OFr","grad","MozGrad","WebkitGrad","MSGrad","OGrad","grid","MozGrid","WebkitGrid","MSGrid","OGrid","gridArea","MozGridArea","WebkitGridArea","MSGridArea","OGridArea","gridAutoColumns","MozGridAutoColumns","WebkitGridAutoColumns","MSGridAutoColumns","OGridAutoColumns","gridAutoFlow","MozGridAutoFlow","WebkitGridAutoFlow","MSGridAutoFlow","OGridAutoFlow","gridAutoRows","MozGridAutoRows","WebkitGridAutoRows","MSGridAutoRows","OGridAutoRows","gridColumn","MozGridColumn","WebkitGridColumn","MSGridColumn","OGridColumn","gridColumnEnd","MozGridColumnEnd","WebkitGridColumnEnd","MSGridColumnEnd","OGridColumnEnd","gridColumnGap","MozGridColumnGap","WebkitGridColumnGap","MSGridColumnGap","OGridColumnGap","gridColumnStart","MozGridColumnStart","WebkitGridColumnStart","MSGridColumnStart","OGridColumnStart","gridGap","MozGridGap","WebkitGridGap","MSGridGap","OGridGap","gridRow","MozGridRow","WebkitGridRow","MSGridRow","OGridRow","gridRowEnd","MozGridRowEnd","WebkitGridRowEnd","MSGridRowEnd","OGridRowEnd","gridRowGap","MozGridRowGap","WebkitGridRowGap","MSGridRowGap","OGridRowGap","gridRowStart","MozGridRowStart","WebkitGridRowStart","MSGridRowStart","OGridRowStart","gridTemplate","MozGridTemplate","WebkitGridTemplate","MSGridTemplate","OGridTemplate","gridTemplateAreas","MozGridTemplateAreas","WebkitGridTemplateAreas","MSGridTemplateAreas","OGridTemplateAreas","gridTemplateColumns","MozGridTemplateColumns","WebkitGridTemplateColumns","MSGridTemplateColumns","OGridTemplateColumns","gridTemplateRows","MozGridTemplateRows","WebkitGridTemplateRows","MSGridTemplateRows","OGridTemplateRows","height","MozHeight","WebkitHeight","MSHeight","OHeight","hyphens","MozHyphens","WebkitHyphens","MSHyphens","OHyphens","hz","MozHz","WebkitHz","MSHz","OHz","imageOrientation","MozImageOrientation","WebkitImageOrientation","MSImageOrientation","OImageOrientation","imageRendering","MozImageRendering","WebkitImageRendering","MSImageRendering","OImageRendering","imageResolution","MozImageResolution","WebkitImageResolution","MSImageResolution","OImageResolution","imeMode","MozImeMode","WebkitImeMode","MSImeMode","OImeMode","in","MozIn","WebkitIn","MSIn","OIn","inherit","MozInherit","WebkitInherit","MSInherit","OInherit","initial","MozInitial","WebkitInitial","MSInitial","OInitial","inlineSize","MozInlineSize","WebkitInlineSize","MSInlineSize","OInlineSize","isolation","MozIsolation","WebkitIsolation","MSIsolation","OIsolation","justifyContent","MozJustifyContent","WebkitJustifyContent","MSJustifyContent","OJustifyContent","khz","MozKhz","WebkitKhz","MSKhz","OKhz","left","MozLeft","WebkitLeft","MSLeft","OLeft","letterSpacing","MozLetterSpacing","WebkitLetterSpacing","MSLetterSpacing","OLetterSpacing","lineBreak","MozLineBreak","WebkitLineBreak","MSLineBreak","OLineBreak","lineHeight","MozLineHeight","WebkitLineHeight","MSLineHeight","OLineHeight","listStyle","MozListStyle","WebkitListStyle","MSListStyle","OListStyle","listStyleImage","MozListStyleImage","WebkitListStyleImage","MSListStyleImage","OListStyleImage","listStylePosition","MozListStylePosition","WebkitListStylePosition","MSListStylePosition","OListStylePosition","listStyleType","MozListStyleType","WebkitListStyleType","MSListStyleType","OListStyleType","margin","MozMargin","WebkitMargin","MSMargin","OMargin","marginBlockEnd","MozMarginBlockEnd","WebkitMarginBlockEnd","MSMarginBlockEnd","OMarginBlockEnd","marginBlockStart","MozMarginBlockStart","WebkitMarginBlockStart","MSMarginBlockStart","OMarginBlockStart","marginBottom","MozMarginBottom","WebkitMarginBottom","MSMarginBottom","OMarginBottom","marginInlineEnd","MozMarginInlineEnd","WebkitMarginInlineEnd","MSMarginInlineEnd","OMarginInlineEnd","marginInlineStart","MozMarginInlineStart","WebkitMarginInlineStart","MSMarginInlineStart","OMarginInlineStart","marginLeft","MozMarginLeft","WebkitMarginLeft","MSMarginLeft","OMarginLeft","marginRight","MozMarginRight","WebkitMarginRight","MSMarginRight","OMarginRight","marginTop","MozMarginTop","WebkitMarginTop","MSMarginTop","OMarginTop","mask","MozMask","WebkitMask","MSMask","OMask","maskClip","MozMaskClip","WebkitMaskClip","MSMaskClip","OMaskClip","maskComposite","MozMaskComposite","WebkitMaskComposite","MSMaskComposite","OMaskComposite","maskImage","MozMaskImage","WebkitMaskImage","MSMaskImage","OMaskImage","maskMode","MozMaskMode","WebkitMaskMode","MSMaskMode","OMaskMode","maskOrigin","MozMaskOrigin","WebkitMaskOrigin","MSMaskOrigin","OMaskOrigin","maskPosition","MozMaskPosition","WebkitMaskPosition","MSMaskPosition","OMaskPosition","maskRepeat","MozMaskRepeat","WebkitMaskRepeat","MSMaskRepeat","OMaskRepeat","maskSize","MozMaskSize","WebkitMaskSize","MSMaskSize","OMaskSize","maskType","MozMaskType","WebkitMaskType","MSMaskType","OMaskType","maxHeight","MozMaxHeight","WebkitMaxHeight","MSMaxHeight","OMaxHeight","maxWidth","MozMaxWidth","WebkitMaxWidth","MSMaxWidth","OMaxWidth","minBlockSize","MozMinBlockSize","WebkitMinBlockSize","MSMinBlockSize","OMinBlockSize","minHeight","MozMinHeight","WebkitMinHeight","MSMinHeight","OMinHeight","minInlineSize","MozMinInlineSize","WebkitMinInlineSize","MSMinInlineSize","OMinInlineSize","minWidth","MozMinWidth","WebkitMinWidth","MSMinWidth","OMinWidth","mixBlendMode","MozMixBlendMode","WebkitMixBlendMode","MSMixBlendMode","OMixBlendMode","mm","MozMm","WebkitMm","MSMm","OMm","ms","MozMs","WebkitMs","MSMs","OMs","objectFit","MozObjectFit","WebkitObjectFit","MSObjectFit","OObjectFit","objectPosition","MozObjectPosition","WebkitObjectPosition","MSObjectPosition","OObjectPosition","offsetBlockEnd","MozOffsetBlockEnd","WebkitOffsetBlockEnd","MSOffsetBlockEnd","OOffsetBlockEnd","offsetBlockStart","MozOffsetBlockStart","WebkitOffsetBlockStart","MSOffsetBlockStart","OOffsetBlockStart","offsetInlineEnd","MozOffsetInlineEnd","WebkitOffsetInlineEnd","MSOffsetInlineEnd","OOffsetInlineEnd","offsetInlineStart","MozOffsetInlineStart","WebkitOffsetInlineStart","MSOffsetInlineStart","OOffsetInlineStart","opacity","MozOpacity","WebkitOpacity","MSOpacity","OOpacity","order","MozOrder","WebkitOrder","MSOrder","OOrder","orphans","MozOrphans","WebkitOrphans","MSOrphans","OOrphans","outline","MozOutline","WebkitOutline","MSOutline","OOutline","outlineColor","MozOutlineColor","WebkitOutlineColor","MSOutlineColor","OOutlineColor","outlineOffset","MozOutlineOffset","WebkitOutlineOffset","MSOutlineOffset","OOutlineOffset","outlineStyle","MozOutlineStyle","WebkitOutlineStyle","MSOutlineStyle","OOutlineStyle","outlineWidth","MozOutlineWidth","WebkitOutlineWidth","MSOutlineWidth","OOutlineWidth","overflow","MozOverflow","WebkitOverflow","MSOverflow","OOverflow","overflowWrap","MozOverflowWrap","WebkitOverflowWrap","MSOverflowWrap","OOverflowWrap","overflowX","MozOverflowX","WebkitOverflowX","MSOverflowX","OOverflowX","overflowY","MozOverflowY","WebkitOverflowY","MSOverflowY","OOverflowY","padding","MozPadding","WebkitPadding","MSPadding","OPadding","paddingBlockEnd","MozPaddingBlockEnd","WebkitPaddingBlockEnd","MSPaddingBlockEnd","OPaddingBlockEnd","paddingBlockStart","MozPaddingBlockStart","WebkitPaddingBlockStart","MSPaddingBlockStart","OPaddingBlockStart","paddingBottom","MozPaddingBottom","WebkitPaddingBottom","MSPaddingBottom","OPaddingBottom","paddingInlineEnd","MozPaddingInlineEnd","WebkitPaddingInlineEnd","MSPaddingInlineEnd","OPaddingInlineEnd","paddingInlineStart","MozPaddingInlineStart","WebkitPaddingInlineStart","MSPaddingInlineStart","OPaddingInlineStart","paddingLeft","MozPaddingLeft","WebkitPaddingLeft","MSPaddingLeft","OPaddingLeft","paddingRight","MozPaddingRight","WebkitPaddingRight","MSPaddingRight","OPaddingRight","paddingTop","MozPaddingTop","WebkitPaddingTop","MSPaddingTop","OPaddingTop","pageBreakAfter","MozPageBreakAfter","WebkitPageBreakAfter","MSPageBreakAfter","OPageBreakAfter","pageBreakBefore","MozPageBreakBefore","WebkitPageBreakBefore","MSPageBreakBefore","OPageBreakBefore","pageBreakInside","MozPageBreakInside","WebkitPageBreakInside","MSPageBreakInside","OPageBreakInside","pc","MozPc","WebkitPc","MSPc","OPc","perspective","MozPerspective","WebkitPerspective","MSPerspective","OPerspective","perspectiveOrigin","MozPerspectiveOrigin","WebkitPerspectiveOrigin","MSPerspectiveOrigin","OPerspectiveOrigin","pointerEvents","MozPointerEvents","WebkitPointerEvents","MSPointerEvents","OPointerEvents","position","MozPosition","WebkitPosition","MSPosition","OPosition","pt","MozPt","WebkitPt","MSPt","OPt","px","MozPx","WebkitPx","MSPx","OPx","q","MozQ","WebkitQ","MSQ","OQ","quotes","MozQuotes","WebkitQuotes","MSQuotes","OQuotes","rad","MozRad","WebkitRad","MSRad","ORad","rem","MozRem","WebkitRem","MSRem","ORem","resize","MozResize","WebkitResize","MSResize","OResize","revert","MozRevert","WebkitRevert","MSRevert","ORevert","right","MozRight","WebkitRight","MSRight","ORight","rubyAlign","MozRubyAlign","WebkitRubyAlign","MSRubyAlign","ORubyAlign","rubyMerge","MozRubyMerge","WebkitRubyMerge","MSRubyMerge","ORubyMerge","rubyPosition","MozRubyPosition","WebkitRubyPosition","MSRubyPosition","ORubyPosition","s","MozS","WebkitS","MSS","OS","scrollBehavior","MozScrollBehavior","WebkitScrollBehavior","MSScrollBehavior","OScrollBehavior","scrollSnapCoordinate","MozScrollSnapCoordinate","WebkitScrollSnapCoordinate","MSScrollSnapCoordinate","OScrollSnapCoordinate","scrollSnapDestination","MozScrollSnapDestination","WebkitScrollSnapDestination","MSScrollSnapDestination","OScrollSnapDestination","scrollSnapType","MozScrollSnapType","WebkitScrollSnapType","MSScrollSnapType","OScrollSnapType","shapeImageThreshold","MozShapeImageThreshold","WebkitShapeImageThreshold","MSShapeImageThreshold","OShapeImageThreshold","shapeMargin","MozShapeMargin","WebkitShapeMargin","MSShapeMargin","OShapeMargin","shapeOutside","MozShapeOutside","WebkitShapeOutside","MSShapeOutside","OShapeOutside","tabSize","MozTabSize","WebkitTabSize","MSTabSize","OTabSize","tableLayout","MozTableLayout","WebkitTableLayout","MSTableLayout","OTableLayout","textAlign","MozTextAlign","WebkitTextAlign","MSTextAlign","OTextAlign","textAlignLast","MozTextAlignLast","WebkitTextAlignLast","MSTextAlignLast","OTextAlignLast","textCombineUpright","MozTextCombineUpright","WebkitTextCombineUpright","MSTextCombineUpright","OTextCombineUpright","textDecoration","MozTextDecoration","WebkitTextDecoration","MSTextDecoration","OTextDecoration","textDecorationColor","MozTextDecorationColor","WebkitTextDecorationColor","MSTextDecorationColor","OTextDecorationColor","textDecorationLine","MozTextDecorationLine","WebkitTextDecorationLine","MSTextDecorationLine","OTextDecorationLine","textDecorationStyle","MozTextDecorationStyle","WebkitTextDecorationStyle","MSTextDecorationStyle","OTextDecorationStyle","textEmphasis","MozTextEmphasis","WebkitTextEmphasis","MSTextEmphasis","OTextEmphasis","textEmphasisColor","MozTextEmphasisColor","WebkitTextEmphasisColor","MSTextEmphasisColor","OTextEmphasisColor","textEmphasisPosition","MozTextEmphasisPosition","WebkitTextEmphasisPosition","MSTextEmphasisPosition","OTextEmphasisPosition","textEmphasisStyle","MozTextEmphasisStyle","WebkitTextEmphasisStyle","MSTextEmphasisStyle","OTextEmphasisStyle","textIndent","MozTextIndent","WebkitTextIndent","MSTextIndent","OTextIndent","textOrientation","MozTextOrientation","WebkitTextOrientation","MSTextOrientation","OTextOrientation","textOverflow","MozTextOverflow","WebkitTextOverflow","MSTextOverflow","OTextOverflow","textRendering","MozTextRendering","WebkitTextRendering","MSTextRendering","OTextRendering","textShadow","MozTextShadow","WebkitTextShadow","MSTextShadow","OTextShadow","textTransform","MozTextTransform","WebkitTextTransform","MSTextTransform","OTextTransform","textUnderlinePosition","MozTextUnderlinePosition","WebkitTextUnderlinePosition","MSTextUnderlinePosition","OTextUnderlinePosition","top","MozTop","WebkitTop","MSTop","OTop","touchAction","MozTouchAction","WebkitTouchAction","MSTouchAction","OTouchAction","transform","MozTransform","WebkitTransform","msTransform","OTransform","transformBox","MozTransformBox","WebkitTransformBox","MSTransformBox","OTransformBox","transformOrigin","MozTransformOrigin","WebkitTransformOrigin","MSTransformOrigin","OTransformOrigin","transformStyle","MozTransformStyle","WebkitTransformStyle","MSTransformStyle","OTransformStyle","transition","MozTransition","WebkitTransition","MSTransition","OTransition","transitionDelay","MozTransitionDelay","WebkitTransitionDelay","MSTransitionDelay","OTransitionDelay","transitionDuration","MozTransitionDuration","WebkitTransitionDuration","MSTransitionDuration","OTransitionDuration","transitionProperty","MozTransitionProperty","WebkitTransitionProperty","MSTransitionProperty","OTransitionProperty","transitionTimingFunction","MozTransitionTimingFunction","WebkitTransitionTimingFunction","MSTransitionTimingFunction","OTransitionTimingFunction","turn","MozTurn","WebkitTurn","MSTurn","OTurn","unicodeBidi","MozUnicodeBidi","WebkitUnicodeBidi","MSUnicodeBidi","OUnicodeBidi","unset","MozUnset","WebkitUnset","MSUnset","OUnset","verticalAlign","MozVerticalAlign","WebkitVerticalAlign","MSVerticalAlign","OVerticalAlign","vh","MozVh","WebkitVh","MSVh","OVh","visibility","MozVisibility","WebkitVisibility","MSVisibility","OVisibility","vmax","MozVmax","WebkitVmax","MSVmax","OVmax","vmin","MozVmin","WebkitVmin","MSVmin","OVmin","vw","MozVw","WebkitVw","MSVw","OVw","whiteSpace","MozWhiteSpace","WebkitWhiteSpace","MSWhiteSpace","OWhiteSpace","widows","MozWidows","WebkitWidows","MSWidows","OWidows","width","MozWidth","WebkitWidth","MSWidth","OWidth","willChange","MozWillChange","WebkitWillChange","MSWillChange","OWillChange","wordBreak","MozWordBreak","WebkitWordBreak","MSWordBreak","OWordBreak","wordSpacing","MozWordSpacing","WebkitWordSpacing","MSWordSpacing","OWordSpacing","wordWrap","MozWordWrap","WebkitWordWrap","MSWordWrap","OWordWrap","writingMode","MozWritingMode","WebkitWritingMode","MSWritingMode","OWritingMode","zIndex","MozZIndex","WebkitZIndex","MSZIndex","OZIndex","fontSize","MozFontSize","WebkitFontSize","MSFontSize","OFontSize","flex","MozFlex","WebkitFlex","MSFlex","OFlex","fr","MozFr","WebkitFr","MSFr","OFr","overflowScrolling","MozOverflowScrolling","WebkitOverflowScrolling","MSOverflowScrolling","OOverflowScrolling","userSelect","MozUserSelect","WebkitUserSelect","MSUserSelect","OUserSelect"]},function(t,e,n){"use strict";var r=n(73),i=Array.prototype.concat,o=Array.prototype.slice,a=t.exports=function(t){for(var e=[],n=0,a=t.length;n<a;n++){var s=t[n];r(s)?e=i.call(e,o.call(s)):e.push(s)}return e};a.wrap=function(t){return function(){return t(a(arguments))}}},function(t,e){t.exports=function(t){return!(!t||"string"==typeof t)&&(t instanceof Array||Array.isArray(t)||t.length>=0&&(t.splice instanceof Function||Object.getOwnPropertyDescriptor(t,t.length-1)&&"String"!==t.constructor.name))}},function(t,e,n){var r=n(43);t.exports=function(){return r.Date.now()}},function(t,e,n){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(this,n(26))},function(t,e,n){var r=n(77),i=n(33),o=n(79),a=/^[-+]0x[0-9a-f]+$/i,s=/^0b[01]+$/i,c=/^0o[0-7]+$/i,l=parseInt;t.exports=function(t){if("number"==typeof t)return t;if(o(t))return NaN;if(i(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=i(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=r(t);var n=s.test(t);return n||c.test(t)?l(t.slice(2),n?2:8):a.test(t)?NaN:+t}},function(t,e,n){var r=n(78),i=/^\s+/;t.exports=function(t){return t?t.slice(0,r(t)+1).replace(i,""):t}},function(t,e){var n=/\s/;t.exports=function(t){for(var e=t.length;e--&&n.test(t.charAt(e)););return e}},function(t,e,n){var r=n(80),i=n(83);t.exports=function(t){return"symbol"==typeof t||i(t)&&"[object Symbol]"==r(t)}},function(t,e,n){var r=n(44),i=n(81),o=n(82),a=r?r.toStringTag:void 0;t.exports=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":a&&a in Object(t)?i(t):o(t)}},function(t,e,n){var r=n(44),i=Object.prototype,o=i.hasOwnProperty,a=i.toString,s=r?r.toStringTag:void 0;t.exports=function(t){var e=o.call(t,s),n=t[s];try{t[s]=void 0;var r=!0}catch(t){}var i=a.call(t);return r&&(e?t[s]=n:delete t[s]),i}},function(t,e){var n=Object.prototype.toString;t.exports=function(t){return n.call(t)}},function(t,e){t.exports=function(t){return null!=t&&"object"==typeof t}},function(t,e,n){var r=n(45),i=n(85),o={};Object.keys(r).forEach((function(t){o[t]={},Object.defineProperty(o[t],"channels",{value:r[t].channels}),Object.defineProperty(o[t],"labels",{value:r[t].labels});var e=i(t);Object.keys(e).forEach((function(n){var r=e[n];o[t][n]=function(t){var e=function(e){if(null==e)return e;arguments.length>1&&(e=Array.prototype.slice.call(arguments));var n=t(e);if("object"==typeof n)for(var r=n.length,i=0;i<r;i++)n[i]=Math.round(n[i]);return n};return"conversion"in t&&(e.conversion=t.conversion),e}(r),o[t][n].raw=function(t){var e=function(e){return null==e?e:(arguments.length>1&&(e=Array.prototype.slice.call(arguments)),t(e))};return"conversion"in t&&(e.conversion=t.conversion),e}(r)}))})),t.exports=o},function(t,e,n){var r=n(45);function i(t){var e=function(){for(var t={},e=Object.keys(r),n=e.length,i=0;i<n;i++)t[e[i]]={distance:-1,parent:null};return t}(),n=[t];for(e[t].distance=0;n.length;)for(var i=n.pop(),o=Object.keys(r[i]),a=o.length,s=0;s<a;s++){var c=o[s],l=e[c];-1===l.distance&&(l.distance=e[i].distance+1,l.parent=i,n.unshift(c))}return e}function o(t,e){return function(n){return e(t(n))}}function a(t,e){for(var n=[e[t].parent,t],i=r[e[t].parent][t],a=e[t].parent;e[a].parent;)n.unshift(e[a].parent),i=o(r[e[a].parent][a],i),a=e[a].parent;return i.conversion=n,i}t.exports=function(t){for(var e=i(t),n={},r=Object.keys(e),o=r.length,s=0;s<o;s++){var c=r[s];null!==e[c].parent&&(n[c]=a(c,e))}return n}},function(t,e,n){var r=n(13);t.exports=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=r(t)););return t},t.exports.default=t.exports,t.exports.__esModule=!0},function(t){t.exports=JSON.parse('{"type":"Topology","bbox":[-179.14733999999999,-14.552548999999999,179.77847,71.352561],"transform":{"scale":[0.003589293992939929,0.0008590596905969058],"translate":[-179.14733999999999,-14.552548999999999]},"objects":{"states":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[1,2,3,4,5]]],"id":"01","properties":{"name":"Alabama"}},{"type":"MultiPolygon","arcs":[[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]],[[62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75]],[[76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[115]],[[116]],[[117]],[[118]],[[119]],[[120]],[[121]],[[122]],[[123]],[[124]],[[125]],[[126]],[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138]],[[139]],[[140]],[[141]],[[142]]],"id":"02","properties":{"name":"Alaska"}},{"type":"Polygon","arcs":[[143,144,145,146,147]],"id":"04","properties":{"name":"Arizona"}},{"type":"Polygon","arcs":[[148,149,150,151,152,153]],"id":"08","properties":{"name":"Colorado"}},{"type":"MultiPolygon","arcs":[[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[163,164,-4]]],"id":"12","properties":{"name":"Florida"}},{"type":"Polygon","arcs":[[165,166,167,168,-164,-3]],"id":"13","properties":{"name":"Georgia"}},{"type":"Polygon","arcs":[[169,170,171,172,173]],"id":"18","properties":{"name":"Indiana"}},{"type":"Polygon","arcs":[[174,175,176,-151]],"id":"20","properties":{"name":"Kansas"}},{"type":"MultiPolygon","arcs":[[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[184,185]]],"id":"23","properties":{"name":"Maine"}},{"type":"MultiPolygon","arcs":[[[186]],[[187]],[[188,189,190,191,192,193,194,195]]],"id":"25","properties":{"name":"Massachusetts"}},{"type":"Polygon","arcs":[[196,197,198,199,200]],"id":"27","properties":{"name":"Minnesota"}},{"type":"Polygon","arcs":[[201,202,203,204,205,206,207,208]],"id":"34","properties":{"name":"New Jersey"}},{"type":"MultiPolygon","arcs":[[[209]],[[210]],[[211,212,213,-167,214]]],"id":"37","properties":{"name":"North Carolina"}},{"type":"Polygon","arcs":[[215,-201,216,217]],"id":"38","properties":{"name":"North Dakota"}},{"type":"Polygon","arcs":[[-152,-177,218,219,220,221]],"id":"40","properties":{"name":"Oklahoma"}},{"type":"Polygon","arcs":[[222,223,-204,224,225,226,227]],"id":"42","properties":{"name":"Pennsylvania"}},{"type":"Polygon","arcs":[[228,-217,-200,229,230,231]],"id":"46","properties":{"name":"South Dakota"}},{"type":"Polygon","arcs":[[-221,232,233,234,235,236,237]],"id":"48","properties":{"name":"Texas"}},{"type":"Polygon","arcs":[[-232,238,-149,239,240,241]],"id":"56","properties":{"name":"Wyoming"}},{"type":"Polygon","arcs":[[-195,242,243,244]],"id":"09","properties":{"name":"Connecticut"}},{"type":"Polygon","arcs":[[245,246,247,248,249,250,251,-219,-176,252]],"id":"29","properties":{"name":"Missouri"}},{"type":"Polygon","arcs":[[253,-227,254,255,256]],"id":"54","properties":{"name":"West Virginia"}},{"type":"Polygon","arcs":[[257,258,259,-174,260,-247]],"id":"17","properties":{"name":"Illinois"}},{"type":"Polygon","arcs":[[-153,-222,-238,261,-147]],"id":"35","properties":{"name":"New Mexico"}},{"type":"Polygon","arcs":[[-252,262,263,264,-235,233,-233,-220]],"id":"05","properties":{"name":"Arkansas"}},{"type":"MultiPolygon","arcs":[[[265]],[[266]],[[267]],[[268]],[[269]],[[270]],[[271]],[[272]],[[273,274,275,-144,276]]],"id":"06","properties":{"name":"California"}},{"type":"MultiPolygon","arcs":[[[-209,277]],[[-225,-203,278,279]]],"id":"10","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[280,281]],"id":"11","properties":{"name":"District of Columbia"}},{"type":"MultiPolygon","arcs":[[[282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]]],"id":"15","properties":{"name":"Hawaii"}},{"type":"Polygon","arcs":[[-199,290,-258,-246,291,-230]],"id":"19","properties":{"name":"Iowa"}},{"type":"MultiPolygon","arcs":[[[-261,-173,292,-257,293,294,-248]],[[295,-250]]],"id":"21","properties":{"name":"Kentucky"}},{"type":"MultiPolygon","arcs":[[[296,297]],[[298]],[[299]],[[-226,-280,300,301,302,303,-281,304,-255]]],"id":"24","properties":{"name":"Maryland"}},{"type":"MultiPolygon","arcs":[[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311]],[[312]],[[313]],[[314,315,-171]],[[316]],[[317,318,319,320,321,322]]],"id":"26","properties":{"name":"Michigan"}},{"type":"MultiPolygon","arcs":[[[323]],[[324]],[[325]],[[326]],[[-264,327,-6,328,329]]],"id":"28","properties":{"name":"Mississippi"}},{"type":"Polygon","arcs":[[330,-218,-229,-242,331]],"id":"30","properties":{"name":"Montana"}},{"type":"Polygon","arcs":[[332,-185,333,-190,334]],"id":"33","properties":{"name":"New Hampshire"}},{"type":"MultiPolygon","arcs":[[[335]],[[336]],[[337]],[[338,-207]],[[339]],[[340]],[[341,342,-196,-245,343,-205,-224]]],"id":"36","properties":{"name":"New York"}},{"type":"MultiPolygon","arcs":[[[344]],[[345]],[[-316,346,-228,-254,-293,-172]]],"id":"39","properties":{"name":"Ohio"}},{"type":"Polygon","arcs":[[347,348,349,274,-275,-274,350]],"id":"41","properties":{"name":"Oregon"}},{"type":"Polygon","arcs":[[-251,-296,-249,-295,351,-215,-166,-2,-328,-263]],"id":"47","properties":{"name":"Tennessee"}},{"type":"Polygon","arcs":[[352,-240,-154,-146,353]],"id":"49","properties":{"name":"Utah"}},{"type":"MultiPolygon","arcs":[[[354]],[[-302,355]],[[356,-297]],[[-256,-305,-282,-304,357,-212,-352,-294]]],"id":"51","properties":{"name":"Virginia"}},{"type":"MultiPolygon","arcs":[[[358]],[[359]],[[360]],[[361]],[[362]],[[363]],[[364]],[[365]],[[366]],[[367]],[[368,-348,369]]],"id":"53","properties":{"name":"Washington"}},{"type":"MultiPolygon","arcs":[[[370]],[[371]],[[372]],[[373]],[[374]],[[375]],[[376]],[[377]],[[378]],[[379]],[[380,-323,321,-321,319,-319,381,-259,-291,-198]]],"id":"55","properties":{"name":"Wisconsin"}},{"type":"MultiPolygon","arcs":[[[382]],[[383]],[[384]]],"id":"60","properties":{"name":"American Samoa"}},{"type":"MultiPolygon","arcs":[[[385]]],"id":"66","properties":{"name":"Guam"}},{"type":"MultiPolygon","arcs":[[[386]],[[387]],[[388]],[[389]],[[390]],[[391]],[[392]],[[393]]],"id":"69","properties":{"name":"Commonwealth of the Northern Mariana Islands"}},{"type":"Polygon","arcs":[[-231,-292,-253,-175,-150,-239]],"id":"31","properties":{"name":"Nebraska"}},{"type":"Polygon","arcs":[[-214,394,-168]],"id":"45","properties":{"name":"South Carolina"}},{"type":"MultiPolygon","arcs":[[[395]],[[396]],[[397]],[[398]],[[399]]],"id":"72","properties":{"name":"Puerto Rico"}},{"type":"MultiPolygon","arcs":[[[400]],[[401]],[[402]]],"id":"78","properties":{"name":"United States Virgin Islands"}},{"type":"Polygon","arcs":[[-369,403,-332,-241,-353,404,-349]],"id":"16","properties":{"name":"Idaho"}},{"type":"Polygon","arcs":[[-275,-350,-405,-354,-145,-276]],"id":"32","properties":{"name":"Nevada"}},{"type":"Polygon","arcs":[[405,-335,-189,-343]],"id":"50","properties":{"name":"Vermont"}},{"type":"MultiPolygon","arcs":[[[406]],[[407]],[[408]],[[409]],[[410]],[[411]],[[412]],[[-265,-330,413,-236]]],"id":"22","properties":{"name":"Louisiana"}},{"type":"MultiPolygon","arcs":[[[-192,414]],[[415]],[[416]],[[417]],[[-243,-194,418]]],"id":"44","properties":{"name":"Rhode Island"}}]},"nation":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[164,4,328,413,236,261,147,276,350,369,403,330,215,196,380,317,381,259,169,314,346,222,341,405,332,185,333,190,414,192,418,243,343,205,338,207,277,201,278,300,355,302,357,212,394,168]],[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]],[[62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75]],[[76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[115]],[[116]],[[117]],[[118]],[[119]],[[120]],[[121]],[[122]],[[123]],[[124]],[[125]],[[126]],[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138]],[[139]],[[140]],[[141]],[[142]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[186]],[[187]],[[209]],[[210]],[[265]],[[266]],[[267]],[[268]],[[269]],[[270]],[[271]],[[272]],[[282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]],[[297,356]],[[298]],[[299]],[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311]],[[312]],[[313]],[[316]],[[323]],[[324]],[[325]],[[326]],[[335]],[[336]],[[337]],[[339]],[[340]],[[344]],[[345]],[[354]],[[358]],[[359]],[[360]],[[361]],[[362]],[[363]],[[364]],[[365]],[[366]],[[367]],[[370]],[[371]],[[372]],[[373]],[[374]],[[375]],[[376]],[[377]],[[378]],[[379]],[[382]],[[383]],[[384]],[[385]],[[386]],[[387]],[[388]],[[389]],[[390]],[[391]],[[392]],[[393]],[[395]],[[396]],[[397]],[[398]],[[399]],[[400]],[[401]],[[402]],[[406]],[[407]],[[408]],[[409]],[[410]],[[411]],[[412]],[[415]],[[416]],[[417]]]}]}},"arcs":[[[25302,52136],[56,31],[1,25],[14,-40],[-9,-28],[-10,16],[-18,-2],[-20,-17],[-14,15]],[[25338,57677],[0,15],[150,-6],[63,0],[160,-13],[93,-2],[37,2],[159,-4],[61,-5]],[[26061,57664],[15,-321],[23,-443],[18,-379],[13,-294],[15,-311],[33,-713],[9,-32],[-4,-36],[13,-45],[5,-149],[10,-72],[17,-69],[3,-82],[9,-36],[-10,-117],[18,-28],[12,-40],[-10,-52],[-11,0],[2,-24],[-14,-21],[-13,-52],[3,-56],[-2,-86],[-7,-86],[-14,-72],[-3,-45],[6,-124],[-2,-44],[19,-87],[3,-120],[-7,-57],[2,-43],[-8,-80],[1,-79],[-7,-21],[5,-51],[-3,-54],[20,-91],[7,-64],[2,-61]],[[26229,53027],[-67,0],[-71,-5],[-110,-4],[-174,0],[-135,7],[-166,-2],[3,-38],[-13,-115],[2,-23],[23,-79],[3,-41],[36,-80],[3,-69],[-15,-102],[3,-55],[20,-51],[-18,-35],[-8,-82],[-9,-15],[7,-24],[-15,-26]],[[25528,52188],[-38,-35],[-40,-24],[-56,-4],[18,41],[12,-26],[35,27],[3,34],[-15,48],[-7,43],[-20,47],[-7,90],[9,74],[-3,76],[-7,48],[-20,32],[-15,-46],[2,-38],[-9,-57],[1,-41],[-6,-32],[-1,-144],[-8,-66],[-15,-4],[1,36],[-20,40],[-15,-16],[-5,23],[-18,-22]],[[25284,52292],[-3,222],[-3,357],[-6,423],[-10,773],[9,283],[21,710],[5,212],[33,1120],[6,160],[19,643],[12,362],[-16,35],[-13,85]],[[8053,88108],[6,38],[18,-11],[-20,-43],[-4,16]],[[7905,86007],[29,90],[15,-17],[-1,-46],[-28,-74],[-15,19],[0,28]],[[7695,85792],[26,-14],[-3,-36],[-23,50]],[[7642,85774],[22,-17],[-7,-33],[-14,14],[-1,36]],[[7602,85813],[20,-2],[-5,-34],[-15,36]],[[7594,84711],[8,45],[20,-13],[-8,-73],[-15,-17],[-5,58]],[[7543,85532],[12,28],[21,-40],[-33,-2],[0,14]],[[7540,87187],[29,79],[8,112],[31,-29],[-28,-64],[-9,-49],[5,-24],[-36,-25]],[[7464,85521],[14,55],[18,-28],[23,-4],[-33,-33],[-22,10]],[[7385,86976],[17,6],[5,-88],[-22,82]],[[7168,84530],[29,89],[15,6],[26,-66],[5,20],[-21,65],[6,54],[9,10],[27,-25],[21,19],[-29,54],[16,56],[29,-31],[15,4],[-14,56],[12,17],[20,-20],[14,45],[-18,6],[-13,33],[20,3],[22,67],[34,18],[-12,35],[-3,68],[27,66],[7,-31],[53,51],[7,-7],[-12,-118],[-13,-18],[-26,-103],[5,-84],[36,11],[2,69],[22,-9],[21,-71],[20,48],[12,-33],[-17,-117],[9,-22],[9,72],[27,47],[7,-25],[-3,-115],[-30,-89],[-32,23],[-11,81],[-21,-26],[13,-99],[-22,-20],[-39,13],[-16,-54],[-8,36],[2,74],[-10,2],[-9,-114],[-8,-24],[-31,-17],[2,-37],[-16,-22],[-45,-13],[-86,76],[-21,-13],[-15,29]],[[7129,86075],[41,28],[18,-43],[-5,-48],[-13,-16],[-29,-3],[-16,59],[4,23]],[[6962,82933],[31,45],[8,-48],[-37,-9],[-2,12]],[[6905,82759],[20,62],[19,20],[11,-11],[25,17],[5,-40],[19,-37],[36,16],[-2,-37],[-19,-31],[-46,-6],[-32,-13],[-32,25],[-4,35]],[[6789,83718],[20,17],[4,76],[18,75],[25,34],[5,44],[15,-8],[34,70],[33,36],[39,-15],[29,1],[0,-112],[26,-57],[4,45],[17,53],[-18,48],[6,25],[53,-14],[-3,35],[-52,44],[-19,-4],[-1,127],[31,61],[29,29],[20,-12],[22,-56],[6,-133],[15,13],[9,77],[-5,55],[35,-38],[7,47],[-37,36],[-21,58],[7,44],[17,-6],[51,-87],[9,4],[30,-41],[11,10],[-31,75],[-20,34],[-7,44],[17,0],[30,-58],[29,12],[41,-29],[7,49],[36,15],[-8,-63],[-39,-106],[-7,-83],[19,-36],[0,95],[16,43],[16,-49],[5,46],[17,32],[5,41],[14,10],[10,-31],[22,72],[17,8],[-4,-45],[28,-16],[-11,-38],[-11,20],[-18,-15],[19,-36],[-5,-49],[19,22],[11,-51],[27,1],[-24,-53],[-16,33],[-24,2],[-15,-48],[16,-9],[-8,-53],[26,-8],[-26,-89],[23,17],[13,47],[5,-35],[47,-4],[-3,-41],[-36,-78],[-13,-110],[-38,13],[-2,39],[-10,-41],[-23,42],[-17,-6],[-23,49],[-15,-13],[-24,19],[-8,-46],[27,1],[15,-17],[45,-87],[-8,-70],[-23,-52],[-11,36],[-19,-50],[-19,30],[-6,38],[-21,18],[-20,-12],[-17,-37],[29,2],[20,-49],[-38,-53],[-34,12],[-4,-20],[25,-34],[14,13],[35,1],[22,-43],[-11,-28],[-24,-8],[-34,-33],[-8,11],[-19,-29],[3,-49],[-27,-50],[-13,20],[7,34],[-23,50],[7,47],[27,62],[-8,24],[-15,-21],[-34,-105],[-3,-24],[-22,32],[-22,-10],[-5,-35],[26,-6],[10,-63],[-16,-61],[-25,-20],[1,-70],[-25,-41],[-12,13],[-23,-82],[-19,-30],[-18,21],[-31,-20],[22,116],[11,11],[26,71],[24,31],[-2,37],[-33,-23],[3,52],[22,102],[29,52],[-7,30],[-15,-45],[-34,-61],[-26,-112],[-24,-59],[-14,-11],[-5,-44],[-19,-30],[-4,84],[-26,58],[-33,27],[3,100],[-4,106],[-13,83],[-11,32],[-23,20],[-27,5],[14,30],[-15,37],[5,23]],[[6782,82633],[27,101],[51,97],[21,-4],[16,-54],[-12,-23],[-55,-73],[-29,-79],[-19,35]],[[6519,81925],[26,41],[5,38],[13,22],[8,-32],[-6,-43],[5,-68],[-7,-33],[-36,13],[-8,62]],[[6240,82171],[5,47],[14,25],[13,-59],[-13,-63],[-19,50]],[[6225,82357],[9,35],[3,-82],[-10,-1],[-2,48]],[[6080,82757],[21,48],[48,-3],[25,-54],[-35,23],[-16,-26],[-43,-6],[0,18]],[[5919,82533],[19,25],[11,-57],[-9,-11],[-21,43]],[[5642,81925],[8,64],[19,12],[27,-58],[-8,-18],[-21,37],[-25,-37]],[[5573,81984],[16,-49],[-27,12],[11,37]],[[5524,80844],[-1,36],[13,24],[20,-25],[-9,-59],[-19,-15],[-4,39]],[[5506,81836],[8,67],[10,10],[11,-62],[-29,-15]],[[5485,80904],[12,85],[-11,46],[31,-2],[4,-99],[-27,-38],[-9,8]],[[5445,80747],[10,13],[16,-42],[-1,-34],[-23,-4],[-2,67]],[[5429,81185],[17,-21],[5,49],[17,46],[5,-22],[-8,-58],[9,-13],[1,-44],[-10,-61],[13,-30],[-7,-19],[-17,22],[-2,-21],[-20,8],[-3,164]],[[5385,80755],[21,25],[11,-30],[-20,-26],[-12,31]],[[5377,81028],[9,39],[23,41],[5,-36],[-23,-38],[-9,-58],[-5,52]],[[5303,81352],[14,11],[5,-42],[-19,31]],[[5265,80882],[33,98],[15,27],[-5,18],[-22,0],[-4,76],[22,50],[27,-44],[-1,38],[-13,52],[30,-13],[18,114],[12,-23],[-2,-43],[-9,-2],[-5,-75],[12,-18],[0,33],[13,1],[-4,-60],[-11,-37],[-22,12],[-1,-45],[-28,-71],[-18,-24],[-31,-141],[-6,77]],[[5246,85264],[5,41],[14,-83],[-7,-25],[-12,67]],[[5238,81460],[22,42],[36,-14],[-1,-78],[-50,12],[-7,38]],[[5213,85252],[8,77],[5,-57],[-13,-20]],[[5096,81334],[16,74],[25,25],[18,-23],[-2,-46],[10,5],[12,47],[15,-32],[26,-26],[26,25],[7,-66],[-9,-60],[-14,40],[-22,3],[-14,23],[-3,40],[-10,-12],[0,-69],[11,-20],[11,-87],[-11,-60],[-36,35],[-10,59],[-18,-18],[-18,-90],[4,58],[-10,43],[0,104],[-4,28]],[[5033,85142],[7,131],[39,52],[21,6],[39,76],[5,-2],[-55,-273],[-22,-32],[-32,-4],[-2,46]],[[4937,81216],[27,3],[-4,-71],[-26,47],[3,21]],[[4863,81217],[10,31],[36,8],[-9,-51],[-37,-10],[0,22]],[[4804,81100],[4,51],[17,20],[25,-19],[12,-29],[35,-42],[6,-41],[-30,44],[-23,-57],[-28,74],[-11,-38],[-7,37]],[[4656,80881],[30,66],[26,-27],[0,-83],[-11,-53],[-13,-21],[-27,58],[-5,60]],[[4587,90956],[19,44],[21,16],[24,-17],[22,6],[9,-37],[-1,-50],[-75,-13],[-18,19],[-1,32]],[[4545,80324],[1,51],[68,-54],[19,-39],[26,0],[18,-28],[-20,-23],[-10,-33],[-22,40],[-17,-9],[-31,37],[-18,-29],[-22,57],[8,30]],[[4451,81463],[14,-1],[-5,-38],[-9,39]],[[3979,80040],[12,22],[16,-18],[-21,-37],[-7,33]],[[3880,79918],[22,34],[33,-11],[24,18],[5,-24],[-9,-45],[-26,-13],[-47,27],[-2,14]],[[3807,79887],[60,24],[9,-35],[-15,-32],[-13,37],[-34,-4],[-7,10]],[[3781,79848],[17,29],[7,-36],[-18,-14],[-6,21]],[[3751,80090],[13,56],[14,-15],[18,18],[12,-21],[-22,-33],[13,-48],[30,0],[1,-41],[-23,3],[-18,-79],[-23,24],[-2,78],[16,35],[-9,20],[-16,-21],[-4,24]],[[3635,79967],[5,36],[28,54],[30,-6],[3,-58],[20,6],[14,-15],[8,-44],[13,13],[-2,-41],[-26,-36],[-12,11],[-18,-45],[-6,28],[-25,1],[-17,-20],[-18,91],[3,25]],[[3608,79782],[7,15],[27,-33],[-32,-11],[-2,29]],[[3261,87028],[35,25],[57,0],[22,-20],[23,10],[9,-24],[21,10],[10,30],[-8,38],[34,68],[37,-11],[0,37],[25,46],[33,-40],[24,32],[23,9],[15,54],[19,-132],[27,-10],[29,34],[29,-20],[27,-40],[-12,-65],[11,-44],[-11,-40],[13,-11],[4,-65],[-13,-38],[21,-54],[2,-58],[21,10],[-11,-34],[2,-48],[-71,-21],[-6,-34],[-20,19],[-26,-18],[-28,-58],[8,-64],[-26,-8],[-23,71],[-38,47],[-57,-4],[-14,35],[-28,18],[-27,58],[-35,42],[-40,19],[-32,72],[-25,10],[-2,70],[-28,97]],[[3147,79003],[17,23],[22,53],[25,5],[37,40],[9,27],[28,-21],[14,19],[8,44],[22,-19],[3,72],[24,-11],[-17,106],[20,32],[8,-16],[15,18],[-18,35],[4,39],[17,23],[29,-1],[9,-68],[15,7],[-7,50],[13,31],[-53,47],[-14,-21],[-32,81],[0,46],[31,92],[42,50],[36,32],[6,-15],[23,13],[16,-63],[-16,-42],[7,-35],[17,-18],[14,53],[6,-33],[15,29],[-1,41],[18,63],[15,-58],[11,26],[20,-62],[-8,-56],[-23,-13],[-24,-70],[-40,-70],[2,-39],[34,54],[58,64],[4,22],[22,22],[7,-19],[-5,-72],[-16,-51],[-26,-34],[-6,-23],[-45,-51],[-30,-20],[12,-46],[-16,-1],[-4,-61],[-16,17],[-7,-70],[-20,25],[-4,-76],[-36,-13],[-22,30],[-10,-31],[-12,23],[-21,-37],[-6,11],[-44,-73],[-3,-31],[-23,4],[-16,-23],[-13,-60],[-28,23],[-9,-45],[-49,40],[-15,36]],[[3070,93368],[7,34],[34,50],[123,108],[63,74],[48,74],[45,56],[42,64],[84,105],[55,56],[146,167],[172,154],[133,90],[87,45],[135,15],[52,-11],[34,-31],[-41,-11],[7,-38],[-10,-71],[-31,-77],[1,-70],[12,-56],[-21,-59],[-49,-33],[-4,-20],[49,7],[42,-151],[40,-3],[36,32],[42,-1],[49,-30],[47,21],[69,15],[32,-58],[50,21],[18,-34],[52,32],[18,26],[84,-65],[18,59],[26,44],[37,150],[18,26],[40,-9],[8,-39],[32,-12],[31,27],[26,0],[-32,110],[-71,55],[-45,24],[-48,-1],[-60,-60],[13,112],[-3,83],[-62,114],[-22,91],[-26,35],[-59,14],[-8,56],[-32,90],[7,50],[27,18],[10,43],[16,-37],[24,28],[27,-89],[36,-91],[24,-10],[-19,-101],[3,-55],[28,-50],[57,-123],[53,-68],[39,18],[30,28],[9,49],[-45,2],[-10,45],[-56,70],[-53,112],[10,52],[0,60],[14,23],[1,57],[33,93],[30,-32],[22,3],[1,28],[-38,55],[-25,-8],[-28,57],[-87,-29],[-32,-37],[-34,0],[-39,-19],[-34,17],[-20,43],[-17,-16],[-21,23],[-4,-51],[-36,39],[-91,42],[-54,31],[-48,15],[-22,30],[1,98],[-22,163],[-52,216],[-20,58],[-36,62],[-91,101],[-145,228],[-21,24],[-51,87],[-50,49],[-54,37],[-51,23],[-29,35],[-19,70],[-54,84],[-45,40],[-81,41],[-42,-6],[37,40],[92,59],[20,46],[3,57],[19,76],[11,236],[-8,117],[179,-31],[68,6],[144,42],[79,28],[77,15],[77,63],[41,65],[29,30],[53,87],[81,192],[21,92],[7,79],[-2,186],[39,233],[84,183],[65,179],[37,77],[129,162],[96,-35],[69,-3],[68,40],[64,53],[93,104],[74,108],[44,86],[114,188],[33,31],[99,63],[7,-47],[55,-44],[82,-12],[68,15],[13,24],[32,-3],[61,17],[73,51],[74,85],[71,121],[36,88],[86,185],[68,76],[12,-68],[47,-38],[39,-2],[39,-20],[16,-82],[27,41],[99,-49],[15,-98],[-54,-71],[-35,-63],[-41,-4],[12,-146],[81,-15],[44,59],[-7,76],[16,8],[31,67],[23,12],[19,-48],[4,63],[-27,43],[35,55],[21,-47],[-3,65],[15,22],[71,-74],[45,-66],[13,-42],[-11,-33],[1,-109],[9,-49],[61,10],[35,-37],[16,-40],[48,62],[30,75],[112,0],[69,42],[53,-11],[40,-34],[84,-2],[61,-32],[45,-35],[9,-34],[-26,-11],[-26,-83],[-26,-30],[14,-93],[25,5],[19,-24],[45,-6],[10,-28],[69,-20],[33,9],[-17,-43],[9,-25],[-53,-26],[-8,-24],[20,-25],[89,6],[72,-41],[14,-33],[28,5],[44,86],[57,15],[24,-18],[10,34],[40,7],[29,-27],[15,-59],[42,27],[38,8],[58,83],[13,-22],[45,20],[21,-15],[34,26],[12,-30],[66,-8],[62,-72],[28,-1],[19,-24],[26,31],[24,-8],[37,-73],[0,-45],[35,-19],[41,51],[1,-63],[26,57],[81,-77],[14,-67],[24,-23],[49,1],[43,-15],[29,36],[23,-73],[48,-10],[29,45],[43,-12],[62,12],[66,-10],[49,-38],[50,-3],[17,28],[65,-95],[28,-8],[32,-54],[45,-16],[20,-30],[45,-12],[17,-26],[27,32],[66,-20],[45,77],[48,6],[9,20],[84,49],[18,24],[86,30],[42,-25],[48,32],[9,-18],[79,-73],[53,-37],[70,-80],[26,-67],[37,-11],[87,-97],[68,-40],[52,-62],[27,-47],[61,-13],[58,-45],[0,-9012],[2,-971],[-1,-889],[130,-95],[17,100],[135,-145],[81,180],[170,20],[1,-39],[-33,-272],[47,-112],[66,-76],[26,-22],[11,-116],[29,-80],[266,-580],[30,-299],[-8,-93],[22,4],[51,108],[111,158],[11,23],[68,8],[32,139],[-2,209],[30,-19],[18,19],[19,71],[-1,39],[-32,47],[45,48],[68,28],[131,158],[62,-115],[28,-88],[11,-2],[24,-70],[0,-104],[-12,-24],[1,-37],[16,-47],[-5,-42],[18,-76],[73,-38],[5,-66],[32,-73],[24,0],[29,-108],[-6,-69],[26,-20],[-6,-46],[22,-71],[114,-152],[32,-119],[46,-120],[50,-110],[-23,-49],[33,-134],[47,-140],[28,-176],[57,-182],[32,-161],[30,-111],[25,-123],[53,-180],[32,-155],[-33,-140],[89,-52],[-21,-205],[71,-81],[-8,-61],[11,-57],[7,-119],[71,14],[33,-77],[82,-115],[23,-48],[85,-47],[44,-115],[44,-33],[11,-116],[23,-15],[27,-36],[40,23],[28,-143],[-3,-90],[-20,-107],[-18,-67],[1,-60],[10,-38],[-5,-118],[12,-104],[11,-46],[6,-133],[12,-63],[-32,-100],[-24,-122],[-1,-33],[-20,-90],[-23,-77],[-37,-97],[-27,-55],[-19,-14],[3,-46],[-19,-23],[-12,40],[-1,56],[-13,24],[-1,-44],[-12,-22],[-18,18],[-13,52],[-4,108],[3,57],[-17,33],[8,103],[-9,6],[-16,56],[-6,64],[30,63],[17,63],[15,-8],[-3,75],[-11,82],[14,122],[-9,190],[-10,67],[-43,164],[-22,55],[-12,48],[-7,-34],[23,-62],[25,-85],[7,-72],[22,-90],[10,-131],[-16,-43],[-2,-79],[7,-92],[11,-62],[-9,-28],[-11,96],[-8,12],[3,-70],[-4,-74],[-36,-102],[-14,-5],[-24,49],[19,73],[11,73],[-3,38],[-25,-10],[10,-72],[-8,-42],[-33,-56],[-7,1],[-23,108],[-11,-45],[-25,54],[-17,18],[-12,50],[-28,68],[0,76],[31,31],[22,51],[-20,47],[7,75],[-9,39],[23,44],[3,24],[-18,1],[-3,74],[7,43],[-41,-17],[6,-45],[11,-16],[-1,-37],[-13,-85],[-1,-60],[-19,-73],[-18,13],[7,-93],[-10,-43],[-24,52],[-25,22],[-9,30],[-12,132],[-16,70],[21,-29],[7,75],[27,37],[12,147],[-8,102],[10,57],[6,-21],[12,42],[7,92],[-21,-11],[-4,-58],[-19,-30],[-21,-61],[13,-113],[-8,-42],[-33,3],[-12,-43],[3,-30],[-17,-14],[-7,34],[4,67],[-19,23],[-12,128],[-32,-17],[0,-48],[-28,118],[-3,123],[8,25],[25,1],[7,66],[13,49],[30,12],[16,-72],[7,63],[-15,168],[9,3],[30,-45],[4,-59],[11,-32],[6,23],[-9,77],[-22,35],[-19,48],[-3,53],[-11,13],[-12,-25],[-10,49],[-23,32],[-5,57],[12,23],[-4,64],[-22,28],[-37,66],[-13,69],[-15,33],[-13,79],[29,43],[-11,58],[-18,-47],[-19,18],[-2,-27],[-23,58],[-31,8],[-11,56],[-27,-28],[-54,76],[-8,75],[15,73],[18,-22],[33,4],[9,48],[-22,3],[-32,36],[2,35],[-18,125],[13,81],[-24,-10],[-15,19],[-16,53],[7,103],[20,2],[16,-36],[33,-24],[63,-89],[5,15],[-25,58],[-20,19],[-66,130],[-3,95],[-17,-15],[-2,-65],[-20,3],[-39,166],[-55,147],[-11,140],[9,65],[-2,52],[27,41],[-13,100],[-8,-2],[-9,-85],[-20,-30],[0,-42],[12,-22],[-13,-57],[-10,10],[-22,-20],[-25,11],[-36,34],[-7,-15],[-35,36],[-40,174],[-4,110],[-42,140],[-13,79],[19,1],[-11,174],[-19,-56],[1,-58],[-35,132],[-8,177],[-8,92],[-21,135],[-32,116],[-36,37],[-5,-16],[28,-38],[4,-41],[17,-39],[20,-131],[-15,11],[-34,140],[-22,36],[-22,10],[41,-92],[13,-85],[17,-29],[-7,-97],[9,-88],[13,-23],[-5,-24],[27,-124],[3,-55],[25,-139],[2,-32],[-14,11],[27,-204],[9,-85],[1,-69],[-12,8],[-1,-61],[12,-64],[-29,23],[-19,32],[-14,-4],[-18,43],[-15,66],[-10,84],[-22,-16],[-33,50],[-27,-37],[-50,-19],[3,81],[-25,16],[-4,19],[30,39],[-10,69],[5,53],[-28,109],[0,36],[-22,84],[13,24],[-2,90],[-19,64],[-12,10],[15,-131],[-12,-125],[-27,-5],[-42,70],[-26,30],[-15,150],[-11,-68],[-13,-22],[-44,54],[-14,-20],[-10,50],[-12,-18],[-3,-54],[45,-35],[7,7],[45,-44],[33,-66],[30,-104],[-11,-44],[-24,-44],[6,-11],[33,44],[7,30],[27,1],[7,-105],[26,-78],[16,-157],[-19,-44],[-43,-32],[-11,10],[9,47],[-18,16],[-12,-17],[7,-39],[-10,-37],[-43,22],[-11,-23],[5,-60],[-8,-35],[-29,5],[-8,78],[-36,35],[3,15],[-28,74],[-17,19],[-29,-19],[-35,70],[-16,15],[-56,107],[-51,75],[-2,50],[-30,70],[-37,64],[-5,28],[4,75],[-15,48],[-55,121],[-30,47],[-96,89],[-36,71],[-43,66],[-98,104],[-42,49],[-91,144],[-30,39],[5,29],[31,89],[24,-14],[-9,-27],[24,3],[0,43],[21,70],[-22,7],[2,77],[-14,116],[7,35],[22,41],[-5,34],[16,30],[-13,56],[-19,-51],[-2,-59],[-25,-21],[-21,-72],[-1,-49],[-107,-100],[-12,-28],[-28,-28],[-95,22],[-67,36],[-26,32],[-123,125],[-17,56],[18,-10],[34,24],[11,71],[-33,131],[3,42],[-20,-17],[-31,44],[6,-50],[45,-120],[-10,-21],[-54,-51],[-39,0],[-49,55],[-61,24],[-32,23],[-81,40],[-45,11],[-59,-4],[-63,-33],[-77,-12],[-80,-28],[-54,-48],[-39,39],[-45,-26],[-64,-120],[-46,-115],[6,65],[36,103],[62,117],[46,2],[-16,66],[-49,48],[-8,25],[-10,-82],[-26,84],[-26,30],[-17,-9],[-16,27],[-71,19],[9,28],[38,23],[-42,33],[-19,-6],[-2,25],[37,156],[-15,15],[-13,-36],[-29,-22],[-1,-57],[-20,-66],[-39,12],[-70,97],[1,31],[-26,36],[-39,26],[-41,-35],[-22,27],[13,29],[31,32],[25,74],[-14,10],[-18,-49],[-79,-93],[-29,-23],[-38,5],[1,-54],[60,27],[11,-24],[2,-53],[-17,2],[-28,-37],[-18,6],[-41,-38],[-41,-77],[-12,2],[-12,48],[47,77],[-37,-12],[-17,11],[-1,54],[23,83],[13,27],[18,2],[20,-31],[24,17],[22,41],[38,13],[57,58],[42,20],[-9,25],[-19,-2],[1,71],[-11,-49],[-19,-20],[1,30],[25,65],[1,21],[-33,-58],[-45,-47],[-19,-3],[-4,30],[63,112],[-6,38],[-29,-60],[-38,-14],[-12,26],[-15,-49],[-20,-14],[-54,13],[-10,58],[27,19],[11,-9],[18,25],[40,16],[29,28],[23,65],[-25,2],[-14,-46],[-23,-19],[-45,-2],[-18,68],[-12,3],[-17,-69],[-21,-8],[-4,59],[16,26],[17,-6],[-11,44],[-3,55],[13,34],[26,114],[96,6],[-7,38],[-91,-5],[-21,-63],[-27,-26],[-21,-77],[-31,-48],[-23,12],[20,36],[-10,113],[-12,53],[18,30],[-22,10],[-14,-23],[-1,-51],[12,-63],[-14,-63],[1,-41],[-13,-15],[-26,48],[-2,-67],[-27,-45],[-21,22],[0,52],[-11,19],[-7,-73],[-9,15],[4,129],[9,62],[-15,11],[-17,-130],[9,-111],[-4,-29],[-19,-9],[1,49],[-27,34],[-7,-46],[16,-65],[-13,-8],[-38,16],[-34,-48],[-28,9],[-5,31],[14,95],[42,151],[1,53],[49,123],[16,81],[-6,18],[-73,-211],[-1,-35],[-18,-58],[-8,8],[-8,69],[-12,-1],[-3,-81],[-11,-54],[-18,-42],[-3,-64],[-16,-68],[-21,27],[-7,-44],[24,-28],[-5,-91],[10,-8],[19,85],[37,6],[11,-22],[4,-91],[-14,-45],[-31,-32],[-22,-76],[1,-63],[21,20],[17,75],[30,44],[30,-89],[0,-44],[10,-43],[-23,-192],[-26,0],[-9,52],[-19,9],[1,-36],[-27,-44],[0,-17],[28,14],[23,-27],[61,-124],[26,-85],[-15,-77],[-13,-26],[-34,-35],[-17,16],[-14,-18],[-29,-6],[9,51],[-26,67],[9,60],[-17,63],[-16,-126],[0,-62],[-12,-41],[-19,69],[-9,-8],[-7,-59],[-18,-33],[-34,50],[-29,-40],[-15,52],[-27,-21],[-22,5],[-9,28],[24,74],[-9,14],[-27,-38],[-29,-175],[-30,-42],[-9,18],[14,55],[13,84],[-15,172],[-16,5],[-5,-28],[1,-81],[13,-53],[-10,-4],[-10,-72],[-17,11],[-8,-20],[-5,-68],[-11,-17],[4,-47],[25,-31],[-6,-74],[-27,32],[-12,127],[8,37],[-11,78],[-17,6],[6,-52],[-8,-49],[5,-196],[-5,-64],[-27,74],[-1,43],[-16,28],[-34,31],[3,-40],[24,-36],[-1,-63],[-69,-158],[-32,-91],[0,-36],[-16,-10],[-9,-86],[-12,2],[-3,70],[34,211],[0,29],[-26,-65],[-19,-111],[-12,11],[-9,142],[-13,-52],[-11,2],[16,-62],[-5,-80],[-39,0],[-8,-61],[-18,-24],[-22,-55],[7,-43],[-15,-41],[-16,-10],[0,54],[-16,36],[-13,-45],[-1,-53],[-22,-17],[-24,31],[-9,-23],[-21,38],[-7,43],[-12,-36],[-21,-27],[6,-35],[-20,0],[-5,-39],[-41,-7],[-6,76],[-22,-14],[-21,22],[3,22],[-21,8],[-3,70],[8,36],[16,18],[5,71],[32,31],[9,-11],[29,51],[33,3],[0,45],[33,21],[34,62],[31,-9],[-11,69],[22,26],[3,32],[37,102],[-13,15],[-24,-22],[-60,-109],[-30,-20],[-18,-39],[-39,16],[-43,67],[-15,40],[-5,46],[18,117],[13,45],[15,133],[27,79],[17,33],[35,99],[11,98],[0,71],[23,32],[5,156],[4,27],[-18,44],[-22,163],[39,35],[5,27],[63,27],[89,164],[92,118],[51,-161],[41,-16],[13,-27],[34,112],[30,8],[36,-45],[19,10],[63,-48],[65,-20],[30,-55],[-1,27],[-22,63],[-29,36],[-38,-14],[-51,63],[-24,-1],[-40,42],[-25,68],[-39,66],[-29,28],[18,55],[24,9],[31,124],[23,18],[8,60],[46,27],[30,45],[-32,50],[-20,4],[-43,-64],[-11,-49],[-19,-14],[-12,-70],[0,-70],[-18,-31],[-25,19],[-36,7],[-74,-17],[-26,43],[-28,16],[-14,-52],[-87,-84],[-39,-154],[-36,-12],[-19,-31],[-33,2],[-39,-63],[-48,-109],[-1,-29],[26,-124],[-2,-23],[-38,25],[-19,-18],[-30,-52],[-21,-92],[-27,-29],[-32,-74],[-6,-73],[8,-34],[19,-24],[-40,-56],[-9,-67],[-13,-4],[-28,-70],[-19,-7],[-9,28],[-25,-11],[4,-68],[16,-13],[-3,-30],[25,-42],[8,-35],[-12,-73],[-19,-47],[-7,-62],[-25,-21],[-4,-22],[-39,-2],[-15,12],[-40,-31],[-18,3],[-19,-60],[23,16],[15,-20],[15,30],[19,1],[7,-50],[-16,-116],[-19,-16],[-26,-51],[-28,37],[5,-34],[-13,-18],[-18,18],[7,35],[2,75],[-22,71],[3,-119],[-9,-55],[-18,-15],[-13,25],[-6,-35],[16,-28],[-9,-53],[-49,-10],[17,-93],[-8,-32],[-27,-21],[-10,8],[-24,-45],[-12,13],[-36,-37],[5,-26],[20,-18],[-23,-32],[-7,-43],[2,-61],[-12,-44],[-24,-35],[24,-26],[-6,-59],[10,-60],[27,63],[59,-23],[16,22],[12,-22],[15,25],[22,-78],[19,-27],[19,13],[23,-34],[18,-53],[8,-53],[15,-22],[-28,-14],[-14,-118],[-12,-39],[-30,-25],[-11,-55],[-24,-33],[-48,0],[-15,-17],[-4,-94],[-12,-33],[-27,1],[-5,-20],[10,-79],[11,-32],[-27,-36],[-20,15],[-2,-45],[20,-46],[-11,-81],[-21,-30],[-6,-33],[9,-24],[-23,0],[-14,-52],[-26,66],[-9,-7],[5,-57],[-4,-40],[-21,-3],[-12,-43],[-17,16],[0,27],[-20,-1],[-4,-39],[-22,-24],[-23,31],[-28,-17],[-35,-69],[15,-52],[-9,-51],[-40,-44],[-28,-2],[1,-53],[14,-25],[-6,-40],[-20,-16],[-36,59],[-10,30],[-20,-20],[-5,-63],[1,-69],[-26,-27],[-3,-97],[-65,-7],[-21,24],[-2,-74],[8,-71],[-20,0],[-12,37],[-21,3],[-4,-39],[-32,-27],[-39,-92],[-15,-12],[-5,-44],[13,-11],[47,64],[4,-50],[-6,-53],[-15,-7],[0,-31],[18,-38],[-10,-38],[-18,-26],[-2,-49],[-26,-44],[-8,-32],[2,-42],[-32,14],[-31,-28],[-4,-70],[-12,-12],[-19,75],[-8,-53],[-27,-42],[-11,-53],[-24,-6],[5,-50],[-17,-27],[-25,43],[-24,67],[-22,-16],[0,-51],[11,-5],[1,-36],[-29,-10],[-13,-67],[6,-32],[18,-6],[5,-52],[-36,-4],[-24,-15],[-17,77],[-51,-38],[-18,-51],[-16,-3],[-9,-49],[19,-1],[27,25],[20,-17],[6,-54],[-16,-47],[-43,44],[-23,11],[-5,-70],[-33,6],[-23,21],[-20,-33],[-27,-88],[2,-44],[47,-20],[32,-36],[-3,-29],[-32,-42],[1,-23],[18,-4],[25,31],[16,-7],[-55,-78],[-23,-63],[1,-52],[-13,50],[-10,-17],[16,-66],[-6,-50],[-7,39],[-10,-2],[-2,-53],[-25,80],[0,95],[-19,-60],[8,-73],[-4,-67],[-24,-6],[3,58],[-35,1],[-16,-80],[-25,-9],[-75,-43],[-29,-22],[-7,-22],[-3,-74],[-17,46],[5,80],[-23,-19],[10,-30],[1,-104],[-16,-71],[6,-46],[-24,-81],[-32,-30],[2,52],[24,4],[-1,40],[-10,4],[2,111],[18,72],[-29,39],[-28,12],[-13,-18],[3,-45],[-12,-21],[-13,22],[-25,-13],[-9,-82],[-35,-74],[-26,-20],[-37,28],[-6,-29],[11,-44],[-20,-81],[1,-31],[-21,-37],[-12,105],[-10,13],[-14,-37],[-11,14],[-18,-31],[31,-13],[-2,-68],[-32,-10],[-16,25],[5,39],[-13,24],[-22,-22],[-19,-90],[-61,-85],[-26,2],[-11,29],[-26,-29],[-13,4],[10,156],[29,96],[1,46],[-15,16],[-31,-2],[-24,-29],[-24,-101],[4,-129],[-40,-140],[-7,-12],[-14,-85],[-21,36],[-19,-12],[13,-65],[10,-17],[1,-56],[-25,-38],[-19,33],[0,45],[-16,15],[-13,-60],[10,-49],[-17,-47],[-14,27],[-32,-8],[-16,18],[-14,74],[32,6],[-21,47],[-8,104],[-21,56],[-11,7],[-16,-33],[-10,-65],[7,-27],[14,0],[18,-70],[-11,-46],[14,-95],[0,-52],[-22,30],[-20,-19],[3,-26],[-17,-30],[-18,-7],[-22,28],[-16,59],[4,36],[-13,56],[-21,37],[-31,-25],[-10,-56],[49,-85],[4,-31],[-50,-111],[-24,-21],[-20,-33],[16,-56],[27,2],[9,24],[22,-50],[13,-83],[-26,6],[8,34],[-17,6],[-10,-28],[-16,22],[-17,62],[-25,-39],[2,-69],[-18,-1],[-28,-50],[-23,18],[-37,10],[-45,-5],[-34,-14],[-41,-40],[-29,-71],[-4,-69],[-29,-53],[-51,-33],[-29,3],[-28,28],[-9,30],[-9,74],[-10,30],[-1,55],[8,29],[44,41],[14,25],[23,110],[19,110],[-1,29],[22,54],[14,13],[25,-46],[38,39],[25,49],[25,0],[37,81],[34,20],[36,-14],[31,5],[1,-37],[28,-72],[9,-61],[-5,-50],[27,24],[-8,52],[2,37],[30,-30],[-15,42],[2,77],[-10,109],[32,46],[26,21],[42,-15],[21,14],[10,69],[-16,4],[4,28],[18,10],[7,38],[18,-4],[26,99],[3,-32],[15,-20],[21,48],[-5,83],[-20,-9],[27,68],[64,206],[33,52],[23,62],[19,13],[27,42],[25,68],[27,14],[35,39],[37,20],[89,70],[30,-9],[10,18],[45,5],[10,-10],[-20,-27],[-1,-47],[14,-2],[-3,-49],[-29,-18],[-3,-85],[38,-98],[11,22],[27,-39],[4,19],[-29,53],[-3,85],[-6,32],[26,-28],[57,3],[7,-86],[23,7],[26,-36],[7,22],[-14,40],[27,15],[-56,89],[-32,36],[1,58],[-16,-7],[39,166],[15,123],[11,56],[23,44],[36,96],[18,13],[40,74],[30,81],[82,96],[41,74],[35,39],[68,106],[17,42],[29,-68],[19,-14],[31,19],[8,59],[-13,47],[-2,46],[15,122],[29,108],[41,130],[24,62],[22,37],[40,41],[21,52],[22,87],[14,15],[26,62],[30,25],[8,-74],[18,-15],[4,41],[-10,105],[-23,-2],[-6,34],[2,95],[9,59],[25,409],[14,42],[38,16],[12,53],[-20,-9],[-34,77],[-3,62],[9,97],[20,106],[27,33],[29,101],[49,102],[4,57],[19,93],[-5,45],[13,33],[-3,43],[13,38],[-20,0],[-11,-32],[0,-38],[-21,-53],[-28,-31],[-38,-27],[-21,-31],[-29,-22],[-5,-21],[-41,-28],[-44,-61],[-79,-73],[-26,5],[-28,53],[-5,73],[-20,49],[-40,38],[2,46],[11,17],[9,167],[-12,-3],[-25,-101],[-41,-54],[-6,-58],[5,-58],[-8,-37],[-14,-12],[-3,-32],[9,-80],[16,-91],[19,-76],[-26,-87],[-28,-21],[-42,32],[-39,161],[-47,208],[-26,73],[-23,42],[-31,13],[16,65],[-16,44],[-25,-9],[-6,-87],[-15,7],[1,-65],[-29,-30],[-24,79],[3,26],[-19,19],[-11,-30],[-16,6],[-1,59],[-22,-18],[-25,61],[18,47],[-17,89],[-44,-52],[-46,-72],[-31,-62],[-20,-95],[-13,57],[-36,-33],[-94,-124],[-10,-41],[0,-49],[-41,-38],[-8,-26],[-22,-10],[-15,-44],[-20,-15],[-4,55],[-29,45],[-54,-20],[-29,33],[49,47],[15,-39],[18,12],[5,50],[25,77],[3,60],[-8,85],[1,81],[-16,74],[5,21],[-16,20],[-29,97],[-20,139],[29,128],[21,23],[24,79],[24,26],[-15,77],[-18,44],[-15,64],[-10,107],[-50,162],[-3,74],[-25,67],[-10,63],[-30,85],[-10,44],[-22,9],[-11,-37],[-2,-74],[6,-37],[-8,-56],[-12,-21],[-27,-10],[-18,21],[-19,-54],[-36,-29],[-50,-68],[-73,-48],[-88,-28],[-75,10],[-51,38],[-13,32],[-13,99],[23,18],[-18,69],[-54,62],[-32,108],[-5,34],[-33,51],[-18,62],[-42,8],[-31,42],[-47,110],[23,32],[24,55],[-2,36],[-24,6],[-38,-54],[-48,10],[-16,51],[11,32],[32,1],[57,128],[10,-4],[17,45],[-16,34],[-4,41],[32,24],[-27,7],[5,70],[27,78],[-17,3],[-18,-48],[-40,42],[-6,40],[22,49],[27,-6],[19,23],[0,45],[-17,-21],[-30,32],[-16,54],[2,23],[-20,7],[-13,35],[-10,-14],[-12,-99],[-14,-6],[-38,16],[-10,21],[-10,66],[1,129],[-11,19],[-43,10],[-18,37],[-10,98],[42,44],[6,38],[-17,46],[-30,31],[-45,-27],[0,-46],[-21,23],[-9,88],[8,147],[6,11],[-2,-107],[92,47],[0,19],[-35,20],[-20,28],[-24,82],[2,18],[36,19],[55,-8],[33,25],[-29,134],[-4,46],[3,84],[21,77],[101,278],[4,29],[27,77],[29,61],[5,70],[18,67],[21,34],[19,-4],[9,23],[-11,115],[26,188],[18,70],[38,61],[-18,24],[4,22],[58,133],[60,46],[48,11],[42,-45],[43,-11],[32,-84],[24,-6],[6,-26],[54,-88],[73,24],[61,124],[4,47],[44,29],[63,172],[23,89],[23,39],[-9,58],[14,5],[28,-28],[22,-5],[13,-77],[52,0],[45,20],[26,-20],[77,28],[48,38],[9,51],[56,128],[38,135],[0,71],[-12,81],[-23,95],[-17,121],[-1,118],[-5,52],[-71,157],[-9,32],[-41,28],[-27,1],[10,97],[27,33],[14,-25],[35,-20],[51,7],[-10,45],[31,10],[41,81],[2,114],[-42,122],[-47,68],[-25,48],[-1,-32],[-27,-48],[-20,-86],[-42,-30],[-42,42],[-59,-93],[-81,-34],[-18,-71],[-85,-103],[-21,-70],[-5,-99],[-44,-70],[-4,93],[-15,110],[-23,50],[-28,-3],[4,34],[-32,46],[-9,36],[-38,-60],[16,-45],[21,-7],[16,-39],[24,11],[2,-48],[-22,-81],[-19,-11],[-22,82],[-55,76],[-41,33],[-64,13],[-41,-27],[-27,12],[-52,3],[-45,-22],[-108,-112],[-58,-17],[-111,74],[-94,45],[-47,14],[-88,40],[-49,79],[-20,96],[1,74],[20,36],[-6,64],[-28,63],[-45,56],[-1,59],[-46,64],[-10,56],[39,-33],[33,3],[9,27],[24,15],[16,32],[-3,55],[35,61],[-38,63],[-19,9],[-29,-16],[-39,15],[-64,52],[-104,21],[-49,52],[-38,63],[-55,60],[-46,30],[-15,93]],[[2812,78476],[27,27],[-1,59],[18,0],[10,36],[0,57],[21,33],[5,57],[-10,16],[11,87],[46,106],[16,-26],[27,16],[28,-3],[-9,65],[-12,5],[9,77],[-6,26],[18,76],[40,67],[54,37],[29,-53],[31,1],[2,-23],[-21,-74],[5,-60],[-55,-95],[-65,-72],[-19,-66],[-1,-36],[-28,-81],[-15,-58],[-25,-10],[-28,-71],[-15,-17],[-4,-51],[-15,21],[-27,-49],[-54,-69],[13,45]],[[2752,78371],[29,49],[-1,-45],[-26,-25],[-2,21]],[[2615,78610],[4,50],[19,16],[4,-44],[-9,-45],[-12,-8],[-6,31]],[[2607,82847],[50,-13],[29,5],[10,-14],[-27,-68],[-23,4],[-9,46],[-20,10],[-10,30]],[[2611,78728],[8,-39],[-15,13],[7,26]],[[2547,78457],[17,17],[23,-3],[-2,19],[27,23],[19,-10],[10,-25],[-17,-105],[-30,50],[-25,-29],[-19,14],[-3,49]],[[2517,78521],[8,26],[23,-16],[1,-31],[-14,-31],[-13,16],[-5,36]],[[2497,78313],[4,72],[33,-18],[-7,-57],[-30,3]],[[2431,83489],[9,43],[22,15],[12,-10],[29,22],[-2,-56],[-32,-62],[-5,31],[-33,17]],[[2316,78170],[5,42],[40,72],[31,-27],[1,-27],[-13,-58],[-19,2],[-17,-26],[-15,-48],[-15,21],[2,49]],[[2228,78152],[9,-32],[-16,2],[7,30]],[[2183,78046],[17,42],[16,-37],[-12,-55],[-19,-1],[-2,51]],[[2036,90914],[2,37],[25,87],[-3,75],[8,18],[-5,57],[21,3],[8,-42],[-4,-48],[12,-34],[64,-57],[77,-48],[55,-20],[58,87],[58,58],[58,-14],[29,-69],[23,-15],[15,-104],[-2,-38],[53,-56],[56,-14],[22,-32],[9,-35],[36,-20],[88,-20],[14,6],[102,-55],[-27,-131],[-22,-43],[-51,35],[-43,-1],[-50,-29],[-44,-89],[-10,-61],[1,-53],[-20,-46],[-30,22],[3,24],[-26,119],[-32,62],[-50,60],[-39,-5],[-11,69],[-17,55],[-54,80],[-86,69],[-65,11],[-47,-44],[-18,-58],[-36,-34],[-28,33],[-49,36],[-24,83],[-7,56],[3,73]],[[1818,77819],[15,59],[33,49],[12,-2],[27,-39],[-1,-41],[-28,-51],[-32,-27],[-22,-1],[-4,53]],[[1695,87369],[6,69],[25,52],[11,-3],[-4,-58],[12,-54],[33,-70],[48,-63],[22,-14],[25,13],[57,-94],[-21,-19],[-9,37],[-51,8],[-26,-17],[-33,46],[-58,136],[-37,31]],[[1687,87598],[8,-5],[5,-84],[-20,42],[7,47]],[[1421,77626],[35,0],[33,-31],[9,30],[14,-2],[33,27],[25,-1],[-6,-28],[10,-29],[8,15],[31,-24],[23,16],[10,-11],[32,11],[5,-12],[41,-7],[-25,-23],[-16,6],[-14,-22],[-44,-1],[-22,-35],[-8,16],[-16,-19],[-19,4],[-18,25],[-52,3],[-9,-15],[-29,19],[-10,49],[-11,-1],[-10,40]],[[1064,77503],[55,37],[11,-28],[25,50],[3,-22],[19,38],[5,29],[18,-29],[27,8],[8,34],[6,-24],[35,37],[1,42],[44,10],[-13,41],[43,-5],[13,34],[-1,36],[-32,7],[-23,29],[5,26],[21,-16],[12,36],[-2,39],[38,46],[33,-32],[22,-76],[1,-31],[-21,-85],[-34,8],[-4,-43],[33,-79],[-3,-24],[-15,21],[-17,-10],[-4,-27],[-16,-4],[-20,23],[-19,-95],[-25,31],[-64,-55],[-13,29],[-29,12],[-23,-6],[-13,-35],[-22,-8],[-33,6],[-32,25]],[[1013,77451],[17,17],[7,-29],[-22,-4],[-2,16]],[[1005,77685],[16,-19],[-11,-12],[-5,31]],[[949,77433],[5,9],[40,-3],[1,-26],[-19,3],[-22,-24],[-5,41]],[[890,77452],[11,14],[28,-1],[15,-90],[-16,5],[-17,49],[-21,23]],[[821,77563],[14,45],[26,-9],[23,-80],[-20,-38],[15,-56],[-13,-34],[-18,-2],[-18,22],[3,57],[-7,2],[-8,77],[3,16]],[[811,77269],[5,56],[12,10],[10,-27],[19,10],[-12,22],[34,30],[10,-23],[-2,-55],[-23,0],[13,-52],[-29,29],[2,-40],[-12,12],[-5,-39],[-7,45],[-15,22]],[[601,77040],[11,67],[15,16],[7,36],[-13,66],[4,27],[32,7],[7,59],[-13,69],[10,45],[15,4],[18,-20],[19,59],[9,-14],[3,-74],[-20,-29],[-2,-50],[13,-20],[19,4],[31,26],[30,5],[7,-64],[-7,-88],[-15,-12],[-36,18],[-13,-52],[-18,-12],[-13,-41],[-23,31],[-6,-25],[6,-48],[-11,17],[-13,-26],[-4,55],[-14,29],[-19,-108],[-14,11],[-2,32]],[[469,77371],[13,9],[2,-26],[-14,-17],[-1,34]],[[402,77131],[18,33],[24,-17],[26,34],[50,39],[21,43],[2,128],[12,16],[16,-10],[15,-44],[-26,-98],[5,-86],[-7,-38],[-33,-31],[-36,61],[-27,-33],[-40,-10],[-1,-43],[-10,5],[-9,51]],[[257,77332],[8,29],[29,17],[39,-5],[11,-42],[-2,-30],[19,-32],[15,17],[18,-17],[33,34],[-10,-40],[-41,-32],[-12,-71],[4,-31],[-12,-31],[-8,16],[-9,-44],[8,-57],[-8,-5],[-9,56],[-14,-24],[-16,48],[-13,8],[4,28],[41,25],[-3,64],[-20,1],[-13,34],[-39,66],[0,18]],[[130,77016],[32,-12],[-3,-18],[-27,7],[-2,23]],[[81,76979],[27,-17],[7,-23],[-25,5],[-9,35]],[[77,77233],[14,52],[20,-35],[0,-61],[-19,-10],[-15,54]],[[43,76751],[8,25],[10,-22],[5,-50],[-12,-2],[-10,-32],[-1,81]],[[3,76640],[12,18],[6,-59],[-18,-25],[0,66]],[[99917,77451],[12,-2],[12,35],[26,14],[31,-61],[-9,-68],[-24,-42],[-12,-5],[-25,29],[-11,29],[0,71]],[[99678,77049],[5,24],[26,-29],[19,3],[27,-24],[4,-31],[24,-42],[27,-78],[25,-26],[11,-57],[44,-11],[21,-33],[-18,-19],[-9,14],[-29,-16],[-15,41],[-41,72],[-30,101],[-30,43],[-17,-8],[-22,25],[-22,51]],[[99628,77446],[9,11],[20,-16],[11,-33],[-14,-49],[-10,-4],[-16,91]],[[99570,77271],[19,-7],[21,-67],[-22,15],[-18,59]],[[99530,77510],[7,22],[17,-22],[3,-34],[-17,-20],[-10,54]],[[99282,77351],[24,27],[15,50],[39,26],[6,63],[16,96],[11,18],[20,-52],[-12,-32],[-8,-57],[-20,-53],[21,-18],[0,-35],[-13,-10],[-42,17],[-17,-31],[-4,-70],[-11,2],[-25,40],[0,19]],[[98911,77903],[26,-13],[-18,-27],[-8,40]],[[98408,78327],[22,-8],[3,-26],[-24,15],[-1,19]],[[98376,78346],[14,-8],[0,-29],[-14,37]],[[98352,78374],[20,-27],[-12,-2],[-8,29]],[[98210,77943],[6,31],[19,27],[23,-6],[26,67],[41,5],[-17,-40],[-5,-37],[10,-104],[-21,0],[-17,52],[-35,-19],[-30,24]],[[97960,78551],[47,86],[33,11],[100,-20],[29,-63],[24,-15],[35,-94],[2,-18],[-35,-8],[-21,38],[-17,-71],[-9,-13],[-38,15],[-26,-41],[-27,32],[-12,40],[-3,63],[-32,56],[-35,-24],[-15,26]],[[13347,81071],[9,23],[10,-28],[-5,-52],[-16,34],[2,23]],[[13279,80906],[61,56],[7,-80],[13,-14],[-20,-68],[-24,-1],[-33,63],[-4,44]],[[13241,80901],[26,65],[8,-25],[-26,-58],[-8,18]],[[13234,81005],[16,62],[-2,43],[13,20],[-14,43],[-2,70],[5,39],[11,9],[19,-32],[5,-35],[13,-7],[17,-40],[0,-165],[-9,-34],[-27,-2],[-13,32],[-23,-36],[-9,33]],[[13172,81388],[4,66],[6,1],[52,-135],[-12,-28],[-1,-68],[-15,-111],[-23,74],[-9,113],[-2,88]],[[12999,82714],[4,48],[9,-30],[-13,-18]],[[12979,82569],[2,29],[21,40],[21,-38],[-1,-22],[-24,-37],[-19,28]],[[12954,82690],[20,33],[17,52],[-5,-50],[-18,-75],[-14,40]],[[12888,80934],[18,6],[-4,-53],[-14,47]],[[12850,82395],[7,53],[10,-24],[22,-97],[10,-68],[-13,-15],[-21,61],[-9,4],[-6,86]],[[12838,82543],[18,86],[21,30],[30,-20],[24,22],[28,-42],[4,-36],[-18,-53],[6,-82],[-16,-19],[-44,-22],[-23,65],[-24,29],[-6,42]],[[12768,81460],[21,27],[-2,-46],[-16,-11],[-3,30]],[[12700,80811],[9,0],[10,-128],[-15,29],[-4,99]],[[12674,81692],[9,23],[1,61],[20,-30],[1,-32],[-22,-72],[-9,50]],[[12659,81749],[12,9],[-1,-36],[-11,27]],[[12637,81497],[8,92],[8,25],[32,-9],[10,-16],[-2,-35],[-16,-42],[8,-16],[20,40],[5,43],[13,-19],[19,68],[19,-2],[16,-39],[-5,-60],[-15,-35],[-19,15],[-13,-35],[17,-22],[-2,-37],[-22,-21],[-22,-50],[-9,-97],[-23,78],[17,61],[-1,78],[-29,51],[-14,-16]],[[12629,82086],[11,22],[24,102],[28,10],[11,20],[-22,13],[-1,47],[15,-22],[9,34],[-36,62],[14,29],[-10,86],[23,49],[45,-24],[71,-17],[24,-82],[11,-73],[-5,-69],[14,-6],[13,-68],[17,-48],[17,5],[57,-119],[12,-52],[33,-111],[3,-126],[29,-29],[8,-82],[8,-32],[31,-50],[13,-58],[-10,-6],[-19,46],[-75,98],[-3,-31],[-23,-74],[11,-8],[14,47],[8,-19],[23,10],[5,-37],[20,-13],[10,-29],[-38,-14],[8,-36],[32,21],[14,-52],[16,-14],[11,-87],[8,-9],[-12,-49],[-20,9],[2,-32],[22,-22],[11,8],[3,46],[14,36],[9,-21],[5,-91],[-15,-34],[4,-36],[-22,-94],[-29,-40],[18,-23],[27,59],[15,-10],[0,-203],[7,-72],[-20,-105],[-37,-9],[-26,48],[-14,-19],[-17,38],[-1,37],[-38,-2],[17,53],[27,-10],[1,39],[-19,42],[-19,13],[-35,78],[9,38],[10,115],[-15,9],[-11,-58],[7,101],[8,28],[-11,39],[-5,-55],[-27,-21],[14,-103],[-18,-58],[-47,56],[-4,35],[17,58],[-18,100],[-20,-5],[-10,50],[-21,3],[12,-78],[18,-65],[6,-72],[-7,-36],[15,-17],[20,-145],[24,-26],[-4,58],[24,18],[28,-65],[4,-124],[-14,-16],[-18,74],[-7,-7],[23,-170],[-29,0],[-26,32],[-2,60],[-20,40],[-49,177],[-10,22],[-2,84],[-12,10],[-8,61],[29,8],[-27,33],[3,119],[-33,-28],[-10,26],[-18,-19],[-9,42],[6,84],[33,30],[11,-63],[17,20],[-13,29],[6,39],[14,20],[14,-14],[22,44],[-29,96],[14,12],[-16,32],[4,66],[-24,-21],[-49,87],[-4,28],[16,-1],[-9,50],[3,35],[-27,18],[6,-57],[-10,-13],[-32,39],[-16,58],[12,52],[28,14],[37,-54],[28,35],[-17,67],[-18,16],[-12,-20],[-9,17],[8,30],[-2,42],[7,63],[-5,16],[-13,-47],[-27,-65],[-22,-33],[-23,38],[-5,45]],[[12611,83642],[15,25],[14,-33],[-27,-31],[-2,39]],[[12594,82026],[14,28],[11,-6],[4,-52],[-8,-48],[-10,3],[-11,75]],[[12476,82024],[28,22],[1,-43],[31,33],[8,75],[7,-2],[-9,-101],[-22,-24],[-20,-56],[-18,17],[8,30],[-14,49]],[[12463,83115],[17,52],[16,17],[7,33],[33,-1],[1,26],[28,-40],[11,-83],[18,-54],[31,-2],[9,-21],[10,26],[-29,44],[-13,80],[-2,55],[-35,79],[11,53],[34,26],[51,-37],[25,-9],[47,-44],[31,-20],[7,14],[57,-11],[30,-74],[14,-82],[3,-56],[9,-23],[23,-11],[16,-48],[5,-46],[33,-52],[9,-64],[15,-34],[-31,-38],[-20,-42],[-26,-24],[-16,16],[-31,4],[-43,24],[5,-48],[-23,-51],[-40,25],[-19,29],[-12,-47],[-15,-20],[-25,-2],[-17,15],[-3,87],[-11,32],[-30,-64],[13,-29],[-2,-90],[-23,-3],[-2,-31],[10,-51],[-11,-51],[-2,-62],[-17,-50],[4,-39],[-9,-64],[-10,-11],[-25,15],[-14,-103],[-15,19],[-12,52],[-7,63],[-1,109],[-10,87],[2,75],[14,48],[-3,57],[15,101],[-12,28],[-22,-1],[5,77],[-20,56],[-8,75],[2,43],[-5,91]],[[12311,84926],[43,-96],[7,-47],[14,-9],[8,-130],[19,1],[21,38],[11,-23],[20,-2],[21,-29],[54,13],[-3,-89],[25,-75],[2,-52],[21,-52],[14,-87],[17,-55],[2,-142],[21,-60],[4,-65],[-9,-2],[-5,47],[-38,120],[-10,115],[-19,37],[-9,53],[-21,0],[26,-101],[4,-34],[-13,-23],[35,-121],[23,-49],[-2,-62],[24,-113],[-19,6],[15,-102],[0,-27],[-25,-62],[-20,26],[-17,-1],[4,-34],[-21,-104],[-38,-83],[-24,-25],[-2,-33],[-31,-65],[-29,3],[-9,89],[-4,135],[21,80],[15,23],[-16,31],[-1,69],[14,6],[12,-39],[6,23],[-40,141],[-1,58],[-18,60],[-5,82],[-11,43],[8,125],[-12,81],[-3,95],[-11,91],[4,44],[-20,93],[-17,45],[-9,77],[-6,101],[3,42]],[[12292,85061],[35,-45],[27,-125],[-10,-5],[-22,115],[-23,19],[-7,41]],[[12202,85643],[15,-71],[0,-46],[-10,29],[-5,88]],[[12106,83714],[16,11],[1,26],[28,65],[-4,68],[36,64],[18,-12],[25,-85],[15,10],[18,-58],[23,-24],[38,4],[22,-14],[12,-79],[-2,-49],[-20,35],[-19,-2],[-1,-22],[21,-25],[11,-46],[29,-278],[-1,-71],[12,-56],[0,-58],[18,-142],[5,-107],[-5,-112],[-11,1],[8,-81],[3,-240],[-9,-111],[-11,6],[-28,70],[-10,86],[-21,59],[-40,212],[4,48],[22,23],[-18,30],[-26,-31],[-14,88],[-11,-15],[-17,42],[-12,55],[2,34],[-14,-22],[-10,24],[-30,2],[-19,96],[19,3],[10,-29],[10,13],[-3,105],[19,53],[6,38],[-39,86],[24,63],[-4,22],[14,35],[4,53],[-33,16],[-21,-28],[-14,79],[-26,72]],[[12097,84881],[16,18],[19,-7],[16,-52],[-29,-6],[-22,47]],[[12062,83572],[4,48],[-3,66],[25,9],[34,-62],[15,-74],[12,-19],[17,30],[23,-10],[-16,-82],[-24,-14],[-27,-161],[-12,6],[-40,-30],[-9,8],[3,102],[25,47],[1,50],[-22,4],[2,29],[-13,31],[5,22]],[[11978,85151],[9,14],[7,-59],[-16,45]],[[11978,84786],[30,41],[3,-53],[-16,-19],[-17,31]],[[11861,84371],[5,174],[16,33],[8,-9],[29,60],[3,51],[-12,92],[32,-2],[0,-54],[12,-60],[28,61],[29,-6],[17,-20],[17,49],[36,50],[14,-55],[41,-30],[25,-53],[-12,-78],[-31,-76],[4,-49],[12,-5],[8,60],[32,108],[15,12],[34,-55],[46,-10],[11,-32],[29,-16],[15,-79],[-4,-67],[-22,-44],[-37,49],[-10,-8],[12,-40],[18,-18],[33,-75],[-21,-29],[-25,-2],[4,-28],[21,-13],[23,24],[7,-95],[14,-69],[12,-143],[-14,-42],[-42,-11],[-17,12],[-44,95],[-65,99],[-27,50],[-22,-26],[-9,29],[-4,-32],[30,-55],[22,-8],[-21,-31],[6,-25],[0,-72],[-9,-50],[-31,-87],[-51,47],[-1,38],[-42,85],[-20,90],[-12,-38],[-19,43],[-10,79],[4,25],[-18,86],[2,24],[-16,57],[-26,30],[-7,49],[-25,36]],[[9331,87212],[28,-14],[12,-44],[-27,-9],[-13,67]],[[9232,87245],[16,14],[58,-26],[-3,-31],[-21,-10],[-50,53]],[[8867,87809],[26,35],[27,3],[15,-16],[-18,-53],[-50,31]],[[8817,87545],[4,86],[28,16],[21,-89],[-11,-44],[-37,-10],[-5,41]],[[8816,87079],[2,14],[43,47],[1,-36],[-40,-59],[-6,34]],[[8698,86532],[8,21],[3,71],[23,12],[-3,42],[21,54],[16,7],[-3,41],[30,34],[9,30],[43,75],[22,118],[27,44],[-3,40],[10,71],[27,34],[4,-43],[24,2],[-17,-51],[9,-17],[24,28],[8,-22],[-11,-37],[-62,-118],[-49,-129],[-8,-80],[-33,-60],[30,-57],[-19,-42],[-23,-8],[-22,15],[-17,-57],[-9,6],[-45,-47],[-14,23]],[[8692,87068],[44,270],[11,-41],[12,13],[-4,66],[44,84],[0,-54],[-12,-32],[-3,-82],[-20,-37],[20,-42],[-24,-97],[2,-46],[-17,-104],[-24,45],[-3,25],[-25,7],[-1,25]],[[8672,87628],[15,31],[17,-19],[17,-48],[-24,-45],[-25,81]],[[17950,55027],[5,31],[24,-13],[25,26],[-2,40],[18,63],[1,79],[-15,136],[-16,8],[-7,-13],[-13,25],[-3,-17],[-14,68],[7,67],[2,142],[-15,41],[9,65],[-8,51],[19,9],[28,138],[9,24],[-4,46],[4,110],[8,12],[-2,74],[-7,64],[1,51],[6,6],[-2,55],[-7,20],[28,116],[0,69],[8,28],[23,29],[10,40],[17,21],[1,19],[25,65],[-1,49],[-11,54],[-14,19],[-31,100],[-13,7],[2,58],[-26,239],[-23,63],[-7,69],[-16,57],[1,147]],[[17974,57684],[6,95],[-10,22],[21,43],[0,72],[-9,178],[-6,65],[-11,47],[-4,58],[6,36],[0,103],[-9,38],[3,39],[-7,31],[3,51],[-5,59],[4,56],[9,24],[-10,31],[-12,97],[4,43],[-7,80],[25,31],[9,29],[5,-14],[12,25],[17,-1],[2,-25],[24,19],[13,-3],[18,-71],[-2,-28],[21,-51],[24,11],[24,183],[5,15],[1,230],[-2,272],[0,437]],[[18136,60011],[200,0],[222,0],[313,1],[97,1],[160,2],[6,-7],[235,0],[162,1]],[[19531,60009],[0,-1691],[-1,-237],[1,-30],[0,-925],[-1,-608],[1,-145],[-1,-113],[0,-2847]],[[19530,53413],[-64,2],[-201,-1],[-128,-1],[-172,0],[-359,476],[-212,269],[-102,136],[-368,471],[5,66],[-5,17],[1,60],[8,16],[17,103]],[[19530,64667],[242,0],[154,2],[327,0],[66,-5],[137,-1],[242,1],[7,2],[217,2]],[[20922,64668],[282,1],[135,0],[140,0],[0,-1163]],[[21479,63506],[1,-381],[0,-434],[1,-193],[0,-1270],[1,-137],[0,-1089]],[[21482,60002],[-183,3],[-22,5],[-62,1]],[[21215,60011],[-204,-3],[-169,-5],[-184,0],[-34,2],[-301,-1],[-186,-2],[-2,9],[-152,-1],[-230,-1],[-222,0]],[[19531,60009],[0,583],[1,36],[0,738],[-5,129],[0,517],[2,216],[0,1857],[1,46],[0,536]],[[27414,45876],[14,60],[5,-33],[-14,-44],[-5,17]],[[27386,45813],[9,39],[11,4],[-5,-33],[-15,-10]],[[27310,45701],[52,90],[6,-30],[-45,-80],[-13,20]],[[27118,45540],[19,106],[20,46],[25,43],[3,23],[36,66],[38,-67],[4,-52],[14,-43],[-4,-11],[-40,-48],[-3,27],[-27,-5],[-3,-24],[-46,-73],[-36,-15],[0,27]],[[27062,45510],[39,24],[-10,-43],[-17,-14],[-13,8],[1,25]],[[27020,45533],[6,35],[12,-10],[-5,-41],[-13,16]],[[26992,48019],[5,-18],[19,-211],[8,-28],[17,-26],[7,17],[14,-21],[-14,-31],[-9,-1],[-21,50],[-7,28],[-13,115],[-6,76],[0,50]],[[26806,45614],[15,13],[4,-23],[-20,-10],[1,20]],[[26322,51623],[29,47],[0,-29],[-16,-37],[-11,-6],[-2,25]],[[26229,53027],[6,-79],[11,-52],[2,-83],[6,-75],[14,-48],[136,-25],[261,-56],[206,-51],[135,-34],[-5,-14],[2,-57],[7,-26],[-3,-71],[11,-76],[37,13],[0,75],[6,47],[3,119],[-12,91],[4,60],[-1,49],[8,16],[-4,24],[12,-8],[9,59],[15,-7],[7,-33],[17,-3],[18,-28],[7,-25],[33,-19],[17,-18],[14,15],[13,-19]],[[27221,52688],[4,-13],[-4,-113],[3,-92],[-4,-22],[10,-25],[4,-95],[1,-113],[23,-389],[13,-129],[0,-51],[28,-302],[32,-288],[29,-229],[65,-412],[38,-200],[4,-63],[10,-83],[-18,-57],[-4,-54],[-1,-87],[5,-130],[6,-96],[16,-145],[35,-269],[15,-166],[5,-84],[5,-29],[11,-140],[17,-152],[9,-66],[6,-94],[13,-109],[17,-258],[-1,-235],[-7,-175],[-5,-210],[-3,-37],[-8,-286],[0,-169],[-3,-80],[-7,-81],[0,-44],[-6,23],[3,51],[-5,20],[-16,-25],[-10,-102],[-6,-17],[-1,-64],[-8,-40],[-2,-78],[5,-33],[-2,-46],[6,-16],[-8,-53],[-8,-13],[-1,-49],[21,39],[25,194],[7,41],[0,-41],[-8,-83],[-34,-222],[-9,-82],[-25,-93],[-34,-139],[-24,-66],[-3,12],[34,122],[14,40],[7,53],[3,81],[5,32],[-6,23],[-9,-11],[-7,26],[-6,-18],[-34,-22],[-14,-41],[-9,-6],[-18,45],[-18,-13],[-7,-41],[-27,-18],[-23,-6],[-17,52],[-8,68],[2,79],[6,60],[6,-3],[-2,49],[-12,97],[-11,47],[2,34],[-8,62],[-11,32],[-5,85],[-6,18],[-11,-15],[-9,101],[-24,31],[-1,16],[-21,38],[-21,55],[-11,-13],[-8,-39],[-16,126],[-15,148],[-5,173],[-7,109],[-7,57],[-28,113],[-11,9],[-1,52],[-12,23],[0,-64],[-14,-11],[-1,66],[-8,113],[-12,51],[3,24],[13,-3],[9,-39],[11,159],[-2,86],[-8,14],[0,40],[8,10],[-4,31],[-12,-4],[-5,-33],[-11,-11],[8,-148],[-9,-20],[-20,-11],[-5,-50],[0,75],[-6,50],[-17,94],[-26,177],[-9,94],[-19,140],[-27,149],[-14,56],[-4,58],[-10,61],[10,-19],[1,-30],[15,30],[10,72],[12,28],[13,98],[13,34],[-2,23],[14,26],[11,84],[-5,75],[-22,21],[5,-113],[-22,30],[6,34],[-1,65],[-5,39],[-38,71],[1,-65],[-11,-28],[11,-37],[16,-6],[11,-110],[-10,-42],[0,-62],[-4,-27],[-21,-6],[-3,-32],[7,-38],[-9,-30],[-4,40],[2,83],[-14,85],[-9,26],[-8,58],[6,182],[-5,66],[-4,164],[9,1],[0,-93],[4,-89],[9,-7],[-4,153],[9,37],[1,41],[8,44],[0,38],[7,50],[0,39],[9,47],[1,91],[5,83],[-6,66],[2,56],[-13,29],[4,42],[-9,109],[12,64],[-21,110],[3,31],[-8,55],[-10,3],[5,33],[-1,49],[-7,13],[-47,23],[-9,-51],[-7,-4],[-9,100],[3,45],[-14,32],[-12,9],[-2,63],[-7,58],[-11,45],[-15,6],[-5,44],[-24,48],[0,111],[-4,67],[-12,7],[-10,38],[-13,17],[-13,61],[0,42],[-9,35],[-5,51],[-14,44],[-28,62],[-40,72],[-26,75],[-11,-2],[-26,-33],[-31,29],[-1,-35],[-26,-69],[9,-99],[-3,-28],[-10,-7],[-15,15],[-5,26],[-24,-22],[-31,-73],[-65,-132],[-6,2],[7,44],[-10,12],[-7,-39],[-15,-41],[-36,1],[13,-49],[2,-38],[16,-22],[30,53],[29,40],[27,84],[3,-13],[-24,-82],[-28,-43],[-35,-66],[-12,-14],[-10,33],[-16,22],[-23,51],[-19,7],[-17,-28],[-13,94],[-5,119],[8,42],[0,-105],[6,-91],[7,-22],[10,39],[1,97],[-17,105],[-18,60],[-17,13],[-15,40],[-16,71],[-27,47],[-22,69],[-41,95],[-47,76],[-58,70],[-31,20],[-62,18],[-33,-5],[-47,-25],[-65,-49],[-32,-15],[-7,10],[-63,-51]],[[26061,57664],[39,-2],[136,6],[183,1]],[[26419,57669],[196,-2],[-1,6],[143,10]],[[26757,57683],[-3,-72],[-31,-68],[-26,-105],[1,-36],[-8,-26],[3,-64],[30,-82],[17,-7],[23,-104],[23,-51],[28,16],[8,-12],[8,-64],[3,-64],[12,-30],[3,-50],[11,-52],[0,-51],[7,-68],[12,-24],[8,-67],[14,-48],[11,-101],[9,-1],[19,-72],[29,-52],[29,-98],[4,-61],[9,-41],[1,-40],[13,-38],[12,-2],[17,-37],[18,-93],[15,-26],[4,-24],[-7,-43],[4,-39],[-4,-32],[28,-82],[-4,-30],[13,-42],[11,5],[-2,-41],[8,-45],[27,-55],[9,1],[16,-58],[19,-43],[-5,-67],[12,-64],[2,-49],[9,-15],[0,-85],[4,-32],[-5,-45],[6,-8],[4,-48],[-5,-41],[12,-48],[25,-26],[0,-23],[23,-81],[-4,-34],[15,-105],[4,4],[6,-76],[-10,-44],[11,-67],[-4,-26],[5,-62],[21,-34],[11,17],[22,-71],[9,-4]],[[27376,54230],[12,-12],[-5,-64],[-14,-29],[-10,15],[-6,-48],[10,-8],[-16,-60],[-21,23],[-3,-56],[11,-11],[-9,-59],[-17,-54],[-17,13],[-3,-16],[12,-33],[8,5],[-1,-84],[-7,-62],[-28,-26],[0,-22],[17,10],[6,-24],[-23,-131],[-6,-91],[7,-13],[-5,-30],[-5,-97],[-13,-22],[-8,-59],[-9,-3],[0,-71],[-7,-69],[-7,2],[-12,-44],[13,-24],[11,24],[1,-81],[-16,-161],[5,-70]],[[25527,65491],[15,-41],[12,20],[7,-15],[-6,-40],[27,-23],[29,1],[28,25],[52,75],[31,59]],[[25722,65552],[90,-1],[198,-1],[187,1],[87,1],[0,-75]],[[26284,65477],[1,-242],[0,-1380],[-3,-437],[0,-441],[-2,-278],[0,-238]],[[26280,62461],[-19,-45],[-2,-20],[16,-71],[2,-31],[-11,-38],[3,-37],[17,-7],[4,-25],[-13,-46],[6,-44],[-22,3],[-16,-23],[-9,5],[-35,-63],[-14,-39],[-19,10],[-10,43],[-26,-7],[-16,7],[-12,-33],[4,-125],[6,-71],[-16,-40],[-7,-44],[-30,-34],[-19,-161],[-19,-39],[-14,24],[-10,-13],[-6,-63],[-16,-72],[1,-87],[-5,-70],[-8,-24],[-23,-18],[-4,-36],[-13,58],[-22,1],[-26,55],[-1,94],[-21,67],[-8,-2],[1,-34],[13,-12],[-1,-25],[-13,-2],[-8,-29],[-8,23],[-9,-29],[9,-17],[-6,-42],[-18,-9],[-2,-94],[5,-38],[-23,-9],[-2,-63],[-11,-29],[-7,24],[5,51],[-10,10],[-10,-25],[-10,22],[-12,89],[-17,-2],[-14,-52],[-29,-27],[-10,-30],[-5,-97],[-7,-27],[-11,-3],[-8,62],[-18,13],[-22,57],[-22,44],[-20,6],[-14,-37],[-14,19],[-6,49],[-8,6],[-7,-66],[11,-64],[-13,-40],[-11,3],[3,56],[-5,30],[-42,-31],[-11,52],[-9,4],[-10,-40],[10,-91],[-12,-47],[-23,32]],[[25386,60941],[-11,2],[-4,34],[12,-9],[-16,92],[24,-8],[-15,29],[15,67],[1,60],[-8,26],[19,19],[2,38],[-12,-19],[22,73],[-14,60],[-4,59],[9,-10],[9,68],[5,-35],[7,41],[8,-33],[13,102],[8,9],[13,84],[-2,38],[24,42],[0,66],[9,83],[7,32],[14,12],[14,76],[-1,42],[-15,94],[11,111],[-18,40],[1,79],[-16,55],[-3,73],[19,60],[-9,50],[2,60],[6,32],[13,9],[0,347],[-1,0],[0,397],[1,12],[0,294],[1,247],[0,1196],[1,254]],[[21479,63506],[257,-1],[104,0],[263,-1],[273,1],[163,0],[279,-1],[263,-1],[144,0],[133,0]],[[23358,63503],[16,-60],[13,-11],[1,-43],[13,6],[5,-36],[26,-14],[8,41],[24,-13],[-4,-28],[7,-33],[11,-11],[-4,-42],[-9,-1],[3,-36],[12,16],[-1,-49],[-10,-6],[-13,24],[-5,-75],[-15,-19],[-7,-41],[2,-41],[-17,-24],[1,-48],[15,-41],[1,-29],[16,-31],[12,-61],[14,0],[5,-21],[-9,-25],[6,-79],[18,-52],[-3,-28],[15,-13],[5,-31],[14,-11],[9,16],[5,-31],[20,-3],[-5,-41],[0,-444],[-1,-120],[0,-696],[-1,-52],[0,-779],[-1,-97],[0,-281]],[[23550,60009],[-249,1],[-196,-1],[-169,0],[-218,0],[-208,-1],[-258,2],[-103,0],[-154,3],[-149,-4],[-209,-4],[-155,-3]],[[30863,68384],[14,7],[-7,-35],[-7,28]],[[30827,68345],[7,83],[6,-34],[19,-55],[-15,-45],[-5,34],[-12,17]],[[30819,68560],[3,42],[11,-71],[-14,29]],[[30732,68434],[14,2],[3,-41],[-17,39]],[[30712,67988],[8,37],[1,-75],[-9,38]],[[30703,68290],[8,41],[25,45],[11,-50],[-9,-8],[14,-78],[-11,-39],[-18,-13],[-12,24],[5,25],[-3,50],[-10,3]],[[30697,68452],[13,68],[2,64],[9,25],[6,-26],[-9,-35],[1,-36],[-8,-70],[-10,-29],[-4,39]],[[30213,67064],[-35,81],[0,69],[6,42],[-41,128],[-9,53],[8,101],[-4,10],[6,88],[-6,23],[-5,313],[0,89],[-11,861],[-15,757]],[[30107,69679],[21,15],[0,33],[25,-41],[-1,-38],[7,-43],[11,-15],[13,85],[2,86],[-6,28],[12,36],[8,-3],[12,-44],[21,-9],[1,39],[-24,83],[-1,32],[22,107],[14,27],[11,43],[8,-1],[15,41],[24,38],[-9,71],[21,66],[23,45],[5,56],[-7,28],[-14,0],[0,66],[10,38],[-8,14],[15,51],[5,46],[-15,44],[16,115],[8,18],[-1,37],[17,32],[14,59],[11,8],[17,324],[215,890],[13,-3],[27,-38],[11,4],[-3,-58],[1,-141],[4,-18],[37,-73],[25,43],[26,30],[28,2],[11,52],[30,11],[25,-12],[0,62],[16,23],[25,-6],[23,-36],[4,-32],[33,-68],[36,-132],[0,-15],[28,-51],[0,-545],[3,-693],[-1,-71],[9,-30],[-15,-39],[14,-70],[-15,-34],[1,-136],[23,-18],[3,20],[10,-57],[19,-28],[30,-23],[14,19],[8,-62],[1,-56],[-13,8],[-11,-22],[7,-68],[16,-63],[-9,-73],[-10,-41],[23,-116],[0,-23],[18,-40],[13,28],[1,46],[18,-30],[19,-3],[13,-56],[6,-51],[-8,-14],[10,-32],[12,-98],[15,-38],[1,-118],[-12,-50],[-10,2],[-4,-32],[-32,-113],[-24,-25],[4,-22],[-15,-8],[6,42],[-4,85],[-27,-30],[12,-58],[-12,-43],[-11,13],[-13,-58],[-13,18],[-10,-12],[2,-35],[16,-40],[-22,-57],[-13,46],[-6,57],[-13,-10],[-3,-38],[-8,3],[-7,59],[-7,-62],[-9,-14],[-8,-74],[-7,19],[-6,-48],[-4,42],[-20,-51],[-5,27],[-12,-92],[-16,39],[0,36],[-10,-21],[-11,9],[2,-66],[-16,-71],[11,-33],[-35,-16],[-23,32],[-16,107],[6,29],[22,27],[-9,45],[-13,-35],[2,44],[-10,-3],[1,-68],[-5,0],[0,64],[-24,-56],[5,-35],[-6,-43],[14,-67],[-3,-45],[-23,-77],[9,-11],[-12,-31],[11,-56],[-5,-69],[-16,-10],[-3,85],[6,4],[-3,55],[-17,45],[-4,64],[15,51],[-19,40],[6,26],[-10,10],[-18,-21],[1,113],[11,44],[1,50],[-7,14],[-7,-46],[-14,-40],[-11,33],[-7,-32],[-15,-4],[14,-81],[-3,-48],[-12,-23],[-10,-71],[-4,-72],[-13,-78],[19,-30],[-13,-28],[10,-57],[-10,-38],[-27,4],[-13,-72],[-15,-1],[-2,-58],[-11,-9],[0,52],[7,37],[-9,15],[-3,-30],[-12,-13],[5,65],[-18,-9],[1,-52],[-16,-37],[-5,-50],[-12,51],[-2,-47],[-15,-32],[-12,26],[-3,-66],[-13,51],[-13,-92],[-23,-27],[-5,-19],[-5,83],[-16,5],[-15,-42],[-5,-39],[-20,4],[-7,-49],[-20,4],[-10,-49],[-3,-50],[5,-29],[-8,-32],[-13,29],[-22,-31],[-9,-46],[6,-67],[-8,-43],[-10,-15],[3,-33],[-14,-24],[-14,4],[-10,-25],[-11,-98],[5,-19],[-14,-80],[1,-22],[-14,-74],[-9,-13]],[[30332,65028],[13,-24],[29,5],[18,17],[12,70],[16,-105],[-1,-30],[-10,-16],[-33,4],[-41,60],[-3,19]],[[30177,65078],[18,0],[19,90],[27,60],[11,-15],[7,-70],[15,-27],[10,40],[-1,-84],[-41,1],[-31,-9],[-18,-47],[-16,61]],[[29500,66699],[224,-22]],[[29724,66677],[199,-23],[126,-12],[10,46],[21,1],[-1,62],[15,36],[19,-18],[9,62],[36,32],[15,-30],[8,13]],[[30181,66846],[2,-72],[9,-136],[25,-47],[12,42],[14,-34],[-16,-90],[-23,-7],[-38,-35],[12,-50],[-18,-50],[-7,9],[-5,-59],[-4,41],[-11,-53],[11,-74],[-13,10],[-5,-28],[8,-26],[-5,-27],[14,-14],[6,36],[14,8],[9,-47],[24,-28],[12,-42],[2,-46],[21,-93],[-1,-50],[-7,-39],[-12,-5],[3,-24],[21,-51],[12,8],[8,-24],[8,-83],[-5,-50],[13,-48],[23,-35],[34,-12],[9,-23],[19,44],[19,8],[27,33],[6,25],[-1,79],[-6,61],[-13,-31],[0,97],[-5,55],[-15,34],[-9,-7],[-5,-39],[-11,59],[13,11],[21,-18],[23,-58],[18,-123],[9,-119],[2,-137],[-15,-129],[-2,-44],[-7,9],[12,112],[-7,23],[-26,-5],[-43,-40],[-30,8],[-7,-28],[-17,-7],[-15,-62],[-33,-10],[-34,-66],[-16,-47],[-21,-28],[-23,-15],[6,26],[35,34],[16,47],[24,49],[5,40],[-2,117],[6,41],[-26,26],[0,-59],[-7,14],[-4,-50],[-14,3],[2,-32],[-31,-11],[-7,-49],[2,-44],[-6,-29],[-25,-23],[-12,17],[-10,-14]],[[30097,65246],[-3,189],[-18,18]],[[30076,65453],[-8,41]],[[30068,65494],[-10,48],[-19,33],[-5,56],[2,81],[-12,-6],[0,147],[-116,-13]],[[29908,65840],[-1,18],[-202,13],[-22,-4],[-42,6],[-3,-39],[-14,-6],[1,45],[-54,3],[-118,14],[-15,-1]],[[29438,65889],[-6,42],[34,395],[34,373]],[[22823,73980],[83,-1],[266,0],[229,-1],[0,449],[27,-37],[28,20],[29,-53],[8,-35],[14,-202],[7,-25],[18,-251],[-6,-69],[4,-54],[14,-43],[29,-45],[24,-12],[8,19],[44,-11],[11,-58],[61,-7],[48,-21],[8,-66],[-3,-49],[6,-12],[42,2],[5,15],[22,-2],[23,20],[-1,48],[33,46],[39,18],[9,-22],[53,0],[72,-98],[26,4],[1,-49],[-19,-7],[-4,-37],[16,-31],[41,13],[15,-54],[-6,-34],[6,-49],[24,-127],[25,27],[-8,84],[13,45],[15,-11],[42,16],[16,-44],[-2,-65],[17,-41],[14,9],[9,-36],[41,-9],[5,-67],[-4,-31],[20,-21],[23,13],[-3,-75],[22,28],[14,-22],[19,24],[34,17],[46,113],[17,13],[13,32],[25,30],[14,-13],[0,-67],[17,-17],[-6,-26],[10,-48],[16,-3],[35,29],[6,-29],[25,15],[26,-18],[19,13],[48,8],[29,-28],[9,-66],[34,-53],[15,35],[20,9],[13,-20],[23,6],[11,-18],[25,22],[-27,-56],[-10,20],[-4,-34],[-17,-15],[-26,-58],[-37,-34],[-14,-37],[-52,-44],[-48,-54],[-15,-6],[-42,-45],[-4,-14],[-51,-77],[-37,-79],[-72,-183],[-17,-69],[-55,-178],[-26,-72],[-26,-41],[-26,-88],[-11,-11],[-28,-83],[-10,-10],[-61,-134],[-9,-25],[8,-50],[14,-46]],[[24276,71309],[-21,50],[-14,-11],[-3,-29],[-16,-14],[9,-19],[-11,-43],[-22,16],[0,-685],[-10,-10],[-6,-59],[-24,7],[-10,-56],[-14,13],[-8,-38],[-25,-23],[-20,-47],[-20,-148],[-22,-49],[-7,-114],[1,-53],[21,-21],[10,9],[14,-32],[-1,-31],[23,-85],[-1,-50],[-15,-47],[1,-29],[-17,-49],[2,-91],[-4,-32],[6,-91],[-16,-58],[11,-34],[-2,-65],[6,-41],[-7,-42],[3,-75],[-12,-80],[5,-36],[16,-27],[31,-87],[-1,-24],[14,-16],[9,-44],[50,-9],[12,-17],[10,-78],[14,-38],[50,-51],[22,-39],[14,-40],[0,-53],[8,-15],[5,-84],[17,-45],[27,-41],[3,-29],[36,-90],[39,-29],[15,-55],[30,-136],[9,-75],[-8,-113],[2,-71],[10,-37],[-4,-44],[8,-53]],[[24498,67577],[-204,0],[-224,0],[-116,-1],[-223,0],[-180,1],[-313,0],[-199,0]],[[23039,67577],[0,1215],[1,101],[-1,302],[0,479],[-10,65],[-36,59],[-18,4],[-14,55],[-9,73],[-26,98],[5,46],[25,62],[22,39],[12,63],[14,46],[4,128]],[[23008,70412],[-4,106],[6,37],[-11,188],[-1,129],[-13,27],[-20,98],[-5,49],[-4,119],[-11,57],[-2,39],[5,68],[-6,112],[5,17],[6,117],[-6,-11],[-11,51],[1,171],[-5,92],[-2,114],[3,50],[-7,103],[1,217],[-5,3],[-7,89],[-11,92],[-8,17],[-11,101],[-3,58],[-11,34],[-5,121],[-16,101],[-3,110],[7,53],[-8,93],[3,52],[-1,107],[-7,59],[7,76],[9,24],[3,62],[-15,80],[-8,124],[-6,24],[-11,98],[3,40]],[[28860,63072],[14,65]],[[28874,63137],[9,32],[5,61],[12,42]],[[28900,63272],[17,44],[38,25],[25,45],[0,69],[16,25],[7,33],[34,72],[18,15],[12,51],[10,-8],[17,39],[-14,71],[-20,41],[-7,52],[-21,54],[-7,68],[-25,19],[-4,45],[2,95],[-10,37],[-17,-5],[-9,14],[-2,83],[7,30],[-8,22],[9,100],[11,-5],[23,113],[-24,120],[13,48],[18,29],[16,56],[-4,24],[17,35],[11,49],[14,124],[22,69],[16,13]],[[29101,65083],[88,-173],[132,-246],[3,-19],[-20,-187],[-12,-65],[-4,-65],[-6,-22]],[[29282,64306],[-7,-34]],[[29275,64272],[-37,-35],[-4,-84],[-9,-16],[-3,-50]],[[29222,64087],[0,-43],[19,-28],[16,18],[24,-44],[14,-9],[4,44],[4,-90],[-3,-107],[-14,-182],[-13,-247],[-5,-173],[-40,-241],[-11,-48],[-9,-9],[3,-32],[-10,-55],[-20,-63],[-1,-19],[-31,-55],[-32,-108],[-21,-118],[-22,-149],[-20,-60],[-19,-14],[-11,14],[6,88],[15,97],[3,69],[-21,37],[-18,4],[-6,25],[-18,-3],[-7,-36],[-9,24],[-2,47],[-18,37],[-3,30],[-10,-12],[-15,68],[-7,-8],[-18,58],[-10,56],[-19,25],[6,140],[-12,29]],[[28861,63044],[-1,28]],[[28814,58772],[18,-19],[12,-74],[1,-47],[-15,9],[2,45],[-18,86]],[[28734,57762],[8,60],[8,0],[47,86],[15,12],[14,33],[12,2],[16,35],[13,10],[5,74],[11,252],[0,54],[-8,95],[-6,105],[3,-2],[11,-106],[5,-95],[-3,-136],[-15,-286],[-24,-8],[-50,-64],[-43,-78],[-19,-43]],[[27156,59531],[84,-16],[55,-3],[95,-15],[37,4],[114,-21],[48,-2],[170,-2],[279,0],[74,4],[264,0],[106,-1],[0,10],[31,-2],[120,0],[142,0]],[[28775,59487],[2,-58],[17,-245],[16,-158],[23,-156],[35,-271],[-9,14],[-18,146],[-14,80],[-13,11],[-9,174],[-16,155],[-8,23],[3,39],[-5,89],[-10,30],[-4,48],[-25,13],[-1,40],[-13,-20],[6,-61],[16,-48],[11,10],[0,-67],[15,-135],[9,-61],[-1,-26],[11,-75],[0,-47],[-19,64],[1,37],[-13,61],[-3,38],[-12,12],[6,-38],[-3,-28],[14,-39],[-31,25],[-32,118],[-15,12],[19,-97],[10,-17],[6,-52],[-9,-23],[-24,-14],[-21,71],[7,-63],[10,-27],[-7,-14],[-31,45],[-13,5],[-5,29],[-18,24],[23,-73],[21,-23],[-7,-19],[-24,-8],[-13,-62],[-16,-22],[-17,1],[-8,31],[-20,12],[-12,121],[0,61],[12,78],[-5,13],[-14,-76],[-2,-76],[8,-94],[11,-77],[-5,-42],[8,-34],[40,10],[37,47],[9,-49],[13,6],[13,30],[26,24],[32,-1],[14,-41],[0,-43],[-14,-78],[3,-55],[2,-164],[9,5],[7,115],[3,150],[14,40],[-6,33],[14,20],[25,-21],[16,-94],[7,-65],[-4,-52],[7,-98],[-8,-25],[4,-54],[-13,-54],[-17,-10],[-6,18],[-10,-16],[-6,-40],[-10,-9],[-3,-43],[-7,-11],[-7,-71],[-13,-15],[-3,-46],[-17,-25],[-3,-24],[-26,25],[-29,-4],[-26,18],[-5,25],[-10,-14],[-15,45],[-13,115],[31,3],[5,45],[-28,-25],[-12,11],[-9,-33],[9,-57],[6,-86],[-7,0],[-29,47],[-14,-10],[-20,34],[-31,30],[-23,48],[-1,-29],[17,-61],[21,-5],[63,-102],[46,-28],[8,-31],[1,-40],[-7,-56],[-13,-54],[1,-28],[-9,-53],[-15,-42],[-50,-112],[-50,112],[1,-65],[24,-55],[36,-43],[36,80],[13,2],[27,30],[4,62],[11,-14],[3,-66],[8,-31],[18,-5],[-9,75],[20,-29],[2,-85],[-17,-75],[-18,-13],[0,-34],[-11,-20],[-14,-84],[-7,-71],[-17,20],[1,80],[-10,19],[1,-82],[-16,-7],[42,-64],[23,123],[33,120],[24,75],[47,176],[8,-21],[-28,-83],[-26,-96],[-22,-62],[-21,-78],[-18,-82],[-21,-115],[-3,-32],[-4,67],[-35,55],[-39,1],[-60,-38],[-29,-33],[-20,-32],[-32,-81],[-39,-75],[-26,-63],[-37,-113],[-14,-55],[-25,-128],[-14,-111],[-10,-112],[-9,-69],[-4,-69],[-13,7],[-3,34],[-21,21],[-23,9],[-28,-2],[-30,-12],[-35,-42],[-8,-17]],[[28030,56345],[-93,330],[-104,362],[-31,116],[-88,302],[-61,1],[-74,7],[-178,10],[4,135],[-42,199],[-30,-73],[-5,21],[7,48],[-2,53],[-55,13],[-105,16],[-188,29],[-23,-20],[-5,39],[-12,-52],[-7,9],[-20,-27],[-6,5],[-29,-47],[-28,-60],[-7,21],[-91,-99]],[[26419,57669],[9,275],[22,48],[3,-26],[28,4],[22,63],[-5,57],[9,25],[-4,44],[17,62],[13,15],[8,48],[16,8],[15,45],[80,7],[11,50],[22,32],[5,26],[10,-7],[16,48],[4,35],[16,4],[8,40],[21,29],[24,-18],[26,115],[-3,63],[10,30],[15,-36],[20,98],[33,70],[10,-40],[-5,-70],[15,-20],[28,62],[15,93],[15,35],[17,21],[12,-5],[9,33],[19,-12],[4,-50],[15,0],[14,28],[33,200],[21,53],[11,12],[8,-23],[17,0],[-10,74],[7,65],[6,12],[-4,80],[9,60]],[[20923,73979],[188,-1],[322,0],[212,0],[92,0],[193,1],[160,-1],[135,0],[141,1],[256,1],[201,0]],[[23008,70412],[-210,-1],[-186,1],[-119,1],[-252,4],[-192,2],[-179,2],[-253,1],[-123,0],[-292,1],[-173,0],[-105,0]],[[20924,70423],[0,2828],[-1,17],[0,711]],[[23550,60009],[0,-581]],[[23550,59428],[6,-130],[7,-206],[6,-127],[14,-355],[4,-82],[15,-387],[-2,-319],[-3,-261],[-1,-235],[-2,-170],[-2,-417],[-5,-642]],[[23587,56097],[-9,-25],[-19,73],[-16,-13],[-1,23],[-17,-1],[-18,79],[-15,-16],[-12,5],[-21,78],[-7,58],[-22,2],[-23,85],[-27,28],[-7,-68],[-11,-32],[-13,-7],[-34,4],[0,15],[-21,-7],[-7,61],[-10,3],[-24,-52],[-20,3],[1,-45],[-13,9],[-9,-31],[-29,61],[-1,-30],[-30,-29],[-15,13],[1,-20],[-14,8],[-8,-90],[-14,-14],[-19,19],[-7,-81],[-12,-3],[-1,22],[-17,79],[-21,-6],[-8,57],[-11,-4],[-16,30],[12,58],[-25,16],[-8,-86],[-18,-9],[-4,42],[-13,14],[-6,-33],[-9,25],[-6,95],[-5,11],[-14,-27],[-6,15],[3,-73],[-16,-57],[-13,19],[11,-42],[-13,-22],[3,-64],[-11,-31],[-11,14],[-12,94],[10,30],[-2,66],[-9,28],[-10,-19],[-2,-42],[-13,19],[-9,-7],[-11,-64],[-20,5],[-5,30],[1,63],[-12,19],[-16,-27],[-11,25],[3,41],[-19,42],[-9,-3],[-12,-58],[-29,-92],[-12,-9],[-16,34],[-9,3],[4,65],[-5,-1],[7,60],[-7,20],[-13,-14],[-19,11],[-10,91],[8,35],[-4,50],[-17,-47],[-20,22],[-15,0],[-19,28],[-11,-40],[-3,-44],[-20,-26],[-24,96],[-21,23],[-12,-37],[-21,4],[-13,26],[-13,3],[-17,24],[-19,46],[-16,-27],[-9,15],[-12,-11],[-2,20],[-18,-3],[-5,140],[-18,56],[4,22],[-16,5],[-18,57],[-4,-92],[-12,-4],[-22,47],[-17,2],[-6,-49],[-30,15],[-24,78],[-37,143],[-20,-19],[0,2257],[-123,0],[-179,0],[-150,0],[-175,1],[-210,0]],[[21214,59429],[1,119],[0,463]],[[27478,65805],[48,61],[45,74],[9,24],[10,60],[13,3],[3,-28],[36,72],[47,74]],[[27689,66145],[0,-314],[1,-2],[247,-1],[77,3],[167,-2],[243,1],[105,3],[111,-4],[169,-1],[107,2],[14,-59],[5,4],[8,-100],[15,4],[27,-34],[10,-49],[-8,-32],[14,-21],[2,-159],[-8,-12],[25,-113],[1,-34],[11,5],[15,-33],[-2,-18],[25,3],[3,-22],[16,8],[-1,-30],[13,-55]],[[28900,63272],[-23,37],[-22,6],[-24,-20],[-15,-34],[-20,-82]],[[28796,63179],[-217,-1],[-118,-1],[-151,0],[-236,3],[-305,-2]],[[27769,63178],[-167,0],[-124,0],[0,1068]],[[27478,64246],[0,1559]],[[20920,69320],[5,4],[0,872],[-1,227]],[[23039,67577],[-40,0],[5,-22],[-7,-37],[22,-64],[-1,-110],[-14,-5],[8,-52],[-3,-31],[24,-3],[2,-83],[9,-35],[-7,-66],[-14,-16],[5,-56],[-8,-28],[6,-21],[-12,-46],[0,-80],[-11,-16],[-3,-52],[-11,-26],[1,-76],[15,-27],[17,-60],[10,-87],[-4,-45],[13,-31]],[[23041,66402],[-17,-7],[-5,30],[-24,-5],[-7,53],[-21,66],[7,52],[-11,16],[-21,3],[-1,40],[-28,35],[-12,-17],[-8,48],[-43,13],[-5,28],[-18,20],[-1,38],[-25,25],[-15,-14],[-15,13],[-7,-23],[-18,14],[-16,-13],[-16,11],[-18,-17],[-25,9],[-20,21],[-8,-11],[-9,-74],[-12,-29],[-19,-9],[-31,69],[-36,62],[-58,85],[-9,59],[-112,0],[-186,-1],[-153,1],[-214,-1],[-206,-2],[-62,4],[-178,0],[-143,1],[-293,1]],[[20922,66996],[0,345],[-1,8],[0,1828],[-1,143]],[[23587,56097],[8,8],[0,-54],[11,-25],[9,6],[-2,-36],[10,-9],[5,27],[8,-18],[3,29],[21,-27],[11,46],[12,-17],[5,-30],[6,21],[16,-22]],[[23710,55996],[0,0]],[[23710,55996],[1,-11],[0,-608]],[[23711,55377],[0,-1196],[8,-12],[11,-72],[18,-31],[9,-83],[15,-55],[-2,-34],[8,-56],[-7,-42],[3,-45],[-7,-28],[6,-51],[9,-32],[13,-6],[3,-35],[-6,-27],[14,-36],[-1,-32],[8,-15],[3,-49],[-6,-53],[12,-47],[6,2],[6,-113],[19,12],[-6,-102],[8,-31],[2,-54],[-13,-21],[-1,-33],[12,-55],[-9,-22],[-3,-38],[4,-63],[-9,-33],[-9,-63],[-3,-73],[-12,-25],[-2,-68],[-14,-30],[-3,-40],[7,-24],[5,-91],[-13,-51],[-6,-74],[16,-52],[1,-53],[-5,-39],[9,-79],[-12,-70],[9,-19],[-11,-51],[-14,-39],[-7,-78],[-13,-74],[-17,-45],[-2,-25],[9,-30],[17,-94]],[[23768,51502],[0,-14],[-46,3],[-37,-40],[-128,-208],[-28,-61],[-10,-54],[-15,7],[22,71],[9,47],[13,-1],[9,19],[8,46],[9,-16],[11,8],[-15,55],[-54,-54],[-8,26],[17,90],[4,80],[0,74],[-12,5],[-5,23],[-17,-29],[-10,-41],[-4,-50],[-15,-24],[-6,46],[-18,-45],[-2,-35],[9,-32],[-10,-50],[10,-55],[20,-17],[-6,-54],[11,-20],[2,-78],[-2,-67],[-8,-31],[-9,10],[-19,-71],[-22,-65],[-3,26],[-13,-8],[-2,-88],[6,-26],[13,44],[26,65],[3,19],[32,99],[15,23],[0,45],[26,-15],[-20,-61],[-62,-153],[-24,-69],[-4,-25],[-32,-91],[-40,-143],[-15,-8],[-69,-146],[-35,-80],[-53,-89],[-61,-112],[-34,-87],[-13,-42],[-15,-74],[-53,-111],[-24,-68],[-47,-155],[-32,-143],[-11,-83],[-14,-59],[-33,-221],[-24,-197],[-11,-127],[-10,-192],[-2,-108],[1,-103],[8,-205],[14,-207],[12,-134],[16,-229],[11,-260],[-7,47],[-5,147],[-12,189],[-11,152],[-24,16],[18,27],[-9,83],[-6,87],[-9,88],[-3,106],[1,138],[-1,122],[11,276],[16,180],[19,148],[14,70],[10,87],[8,35],[-2,47],[13,86],[18,38],[9,45],[18,127],[28,58],[8,53],[16,2],[35,105],[23,49],[24,23],[-4,43],[9,29],[-9,16],[-16,-41],[-20,-35],[-11,-40],[-17,-5],[-6,40],[0,60],[-18,12],[-6,-31],[0,-84],[-5,-25],[6,-41],[-4,-36],[-20,-56],[-17,-61],[-8,-1],[-18,30],[-3,43],[-32,-61],[-17,-67],[21,-22],[24,57],[8,-74],[-7,-23],[-38,-223],[-12,-2],[-6,55],[-21,-10],[-4,18],[-32,-11],[-11,12],[-6,-38],[12,-32],[15,-1],[11,17],[-4,-64],[7,-48],[15,-34],[17,-18],[-19,-146],[-13,-185],[-12,-106],[-20,-27],[-7,-27],[-11,18],[14,21],[3,59],[-8,3],[-6,-31],[-29,-75],[4,-32],[24,-16],[25,38],[8,2],[-5,-116],[3,-4],[-4,-202],[-6,-207],[-4,-3],[10,-230],[8,-65],[1,-84],[9,-1],[23,-215],[5,-29],[-9,-47],[4,-34],[-1,-62],[8,-72],[20,-11],[1,-35],[12,18],[2,-127],[-23,7],[-13,-8],[0,-19],[-21,-12],[-6,-99],[-20,11],[-7,40],[-15,3],[-6,55],[-11,4],[-18,98],[-31,12],[-11,33],[-17,-9],[-7,16],[-23,-17],[-4,18],[-13,-1],[-3,-29],[-10,31],[-20,-14],[-8,22],[-6,-22],[-14,20],[-8,30],[3,25],[-16,1],[-3,44],[-15,-1],[-21,75],[-9,-11],[-25,48],[-19,-22],[-13,35],[-15,69],[-10,8],[-2,33],[-8,12],[-18,-15],[-21,47],[-12,-3],[-8,20],[-12,-19],[-9,44],[6,50],[-10,56],[-11,13],[-3,98],[-6,42],[-3,79],[-8,25],[-1,49],[-7,64],[-17,43],[2,31],[-13,26],[-7,37],[5,20],[-11,46],[-9,7],[-1,52],[6,31],[-3,66],[4,29],[-4,86],[-16,25],[1,37],[-12,11],[9,30],[5,86],[-3,31],[4,60],[-13,10],[5,76],[-12,58],[-7,-14],[-7,46],[-9,-18],[-9,39],[-10,-6],[-18,90],[-9,11],[-3,38],[-8,-9],[-10,38],[0,50],[-7,26],[3,41],[-13,48],[2,47],[-17,16],[-7,81],[-10,23],[-8,70],[-35,53],[-4,53],[-7,-2],[-13,59],[2,38],[-17,100],[3,47],[-9,39],[9,29],[-12,11],[-9,47],[4,39],[-14,28],[1,33],[-15,28],[-4,51],[2,41],[-8,26],[-4,73],[-6,1],[-9,88],[-8,1],[-6,47],[1,76],[-7,106],[-18,46],[-10,40],[3,14],[-9,71],[-23,41],[-2,30],[-17,46],[-18,25],[-13,84],[0,21],[-26,21],[-6,44],[-23,7],[3,57],[-2,65],[-5,5],[-6,-67],[-6,27],[2,53],[-17,27],[-13,108],[-8,-4],[-9,32],[-13,-25],[-7,44],[-8,-27],[-37,-13],[-19,31],[-6,-8],[-15,22],[-22,-14],[-12,24],[-17,-7],[-4,-22],[-26,21],[-11,50],[-13,-3],[-20,40],[-14,-18],[-10,-111],[-34,19],[-9,-37],[-7,11],[-22,-32],[-7,10],[-8,-54],[2,-23],[-13,-40],[0,-50],[-7,0],[-2,-59],[-11,-30],[1,-33],[-7,-58],[2,-52],[-5,-48],[-10,-5],[-3,-72],[-5,-37],[10,-22],[-5,-38],[-18,-38],[-10,8],[-7,-67],[-17,-43],[-7,-36],[-4,-84],[-14,-8],[-17,15],[-15,-11],[-14,46],[-27,24],[-27,111],[-24,33],[-10,-8],[-22,38],[-18,77],[-13,24],[-39,21],[-17,28],[-19,61],[-11,12],[-19,81],[0,24],[-14,47],[-21,7],[-12,27],[-5,34],[-30,78],[-9,43],[-7,110],[-12,56],[-7,60],[-13,63],[0,59],[-7,57],[6,72],[-3,54],[2,55],[-7,68],[-11,30],[-3,44],[-13,39],[-1,30],[-13,34],[2,33],[-13,177],[-7,40],[-12,4],[-11,91],[-15,0],[-14,66],[-12,10],[-3,24],[-15,34],[-12,-4],[-7,28],[-31,39],[0,39],[-44,118],[-13,107],[-12,37],[-18,26],[-9,33],[-9,2],[-2,36],[-24,106],[-20,35],[-4,54],[-14,32],[-21,7],[-35,78],[-11,88],[-10,24],[-6,68],[-13,89],[-9,41],[-19,38],[-11,-19],[-11,41]],[[20232,53938],[-5,28],[-16,20],[1,23],[-10,25],[-3,38],[7,18],[1,101],[331,0],[250,-1],[226,0],[183,1],[0,1212],[2,254],[0,149],[2,417],[2,232],[0,1518],[1,434],[0,809],[-1,213],[11,0]],[[20922,66996],[0,-2328]],[[19530,64667],[-136,-2],[-143,-1],[-52,-3],[-133,1],[-93,2],[0,442],[1,219],[-1,508]],[[18973,65833],[0,676],[1,163],[0,1090],[-1,26],[0,516],[-1,267],[1,140]],[[18973,68711],[-2,175],[-1,282],[1,156],[75,2],[22,-12],[85,2],[11,8],[45,-5],[25,8],[87,-2],[194,5],[11,-7],[221,0],[316,0],[14,-4],[144,-2],[178,-1],[23,7],[132,0],[251,-2],[115,-1]],[[29908,65840],[0,-107],[3,-222],[0,-150],[-3,-209],[-12,-8],[3,-76],[-8,-29]],[[29891,65039],[-7,19],[-17,2],[-21,-24],[-18,3],[-13,-24],[-16,28],[-6,-37],[-49,-35],[-3,20],[-15,0],[-27,-33],[-6,21],[-26,1],[-7,-26],[-18,23],[-40,-27],[-3,60],[-9,-17],[-19,-82],[-12,0],[-22,-73],[-13,23],[-24,-58],[-7,13],[-23,-28],[5,-22],[-10,-32],[-29,-11],[-22,-54],[-9,15],[-15,-35]],[[29390,64649],[1,33],[-20,102],[68,130],[-19,97],[4,161],[5,295],[9,422]],[[23231,64184],[167,-9],[159,-8],[156,3],[130,8],[62,0],[197,12],[152,13],[101,14],[12,-38],[1,-33],[18,-14],[-1,-36],[16,-57],[10,-2],[1,-56],[11,-31],[19,-7]],[[24442,63943],[-8,-18],[-17,-144],[-2,-71],[6,-165],[14,-99],[7,-28],[-8,-66],[5,-38],[15,-34],[4,-28],[-3,-61],[26,-77],[15,-57],[11,-14],[10,-69],[13,-8],[11,-76],[16,-54],[59,-137],[20,-90],[3,-90],[8,-78],[-9,-36],[11,-85],[3,-65],[22,-69],[11,7],[11,32],[9,66],[19,4],[27,-45],[16,-5],[38,-82],[-2,-60],[-12,-29],[-13,-59],[10,-92],[-2,-37],[-22,-96],[-6,-99],[-17,-68],[-7,-52],[-1,-78],[5,-70],[18,-50],[20,-89],[25,-37],[11,-54],[8,0],[17,-60],[16,7],[3,-27],[-12,-24],[6,-50],[20,-5],[10,31],[13,-28],[1,-29],[15,-12],[23,-70],[-2,-40],[14,-3],[9,-42],[19,-24],[0,-57],[11,-68],[-13,-8],[2,-50],[26,-161],[-4,-62],[-15,-12],[-8,-56],[17,-53],[-1,-47],[13,-87],[11,-46],[-1,-53],[24,-56],[10,27],[-15,45],[14,12],[17,-56],[8,-53],[11,14]],[[25079,59990],[9,-21],[-5,-90],[-6,-46],[-10,-9],[-1,-38],[17,-37],[-3,-28],[-16,3],[-4,-44],[11,-58],[-8,-29],[-7,-71],[-13,-18],[-18,78],[-13,-13],[-13,-142]],[[24999,59427],[-8,-40],[-13,7],[2,31]],[[24980,59425],[6,38],[-5,49],[-21,2],[-4,-30],[9,-58]],[[24965,59426],[6,-22],[-7,-64],[10,-59],[-5,-37],[-24,-1],[0,-37],[21,-39],[1,-27],[-15,-15],[-30,16],[-3,-21],[28,-74],[1,-61],[-22,-40],[-3,-75],[-12,-23]],[[24911,58847],[-179,-6],[16,110],[23,58],[0,23],[15,53],[16,28],[3,43],[9,7],[5,133],[-22,44],[3,15],[-5,71],[-349,-1],[-323,1],[-141,0],[-222,1],[-210,1]],[[23358,63503],[-31,56],[8,79],[-24,76],[-2,77],[-20,19],[1,32],[-18,26],[-12,110],[1,39],[-11,34],[-1,40],[13,42],[-11,18],[-1,-33],[-20,3],[1,63]],[[26900,61666],[18,-20],[35,40],[23,11],[5,49],[3,98],[12,28],[16,-7],[6,30],[-3,101],[-10,105],[21,52],[0,67],[14,88],[12,27],[6,37],[13,-40],[11,-1],[12,-79],[-8,-40],[11,-20],[9,22],[3,42],[9,20],[9,-25],[4,111],[-10,29],[-3,43],[19,19],[-3,96],[8,41],[10,12],[3,55],[31,-7],[3,83],[25,76],[17,-19],[6,-52],[11,3],[21,47],[17,8],[11,54],[11,8],[8,48],[16,57],[30,89],[16,9],[4,83],[10,26],[-11,50],[12,48],[0,57],[10,23],[-4,60],[13,-11],[-2,52],[7,20],[0,122],[9,30],[0,58],[10,48],[5,61],[10,23],[5,65],[-3,95],[4,71],[-9,84],[-11,44],[9,50],[14,-1],[18,27]],[[27769,63178],[-3,-600],[10,7],[33,103],[12,-1],[10,67],[31,60],[13,75],[11,-2],[28,-36],[11,54],[38,158],[13,-10],[-13,-14],[13,-18],[2,-26],[20,-34],[17,1],[7,-18],[28,-4],[14,38],[-7,49],[13,-1],[-11,32],[14,-11],[9,37],[19,-23],[28,87],[24,-20],[17,-49],[8,-40],[18,20],[17,-23],[14,4],[0,-37],[-16,-15],[12,-69],[19,-41],[-2,-33],[9,-12],[5,-43],[-6,-63],[10,-14]],[[28258,62713],[-9,-45],[-21,-175],[-78,209],[-66,179],[-4,-62],[5,-28],[-6,-36],[7,-11],[-23,-106],[6,-15],[-11,-54],[10,-36],[-16,-62],[-7,-7],[-24,-88],[6,-16],[-14,-63],[-7,21],[-15,-66],[-10,-24],[0,36],[-23,-71],[-20,-130],[-35,101],[-9,-69],[-17,-82],[-1,-71],[-8,1],[-10,-57],[-15,-138],[-28,-94],[-46,53],[-17,109],[-31,47],[-14,-121],[3,-65],[-12,-60],[-22,-87],[6,-44],[-12,-21],[-25,-81],[-7,-56],[6,-29],[-8,-30],[-6,-60],[-10,-51],[-18,-51],[-30,-104],[-21,-112],[2,-36],[-12,-39],[4,-41],[17,-34],[-12,-40],[-18,-34],[-1,-32],[13,-4],[-4,-29],[-49,-99],[-10,68],[-12,-9],[-19,-47],[-41,-71],[-4,26],[-21,38],[-7,-51],[9,-43],[-19,-47],[-17,-5],[-37,-27],[-31,-51],[-27,75],[-11,45],[-8,-21],[-8,-55],[-23,-17],[-2,-30],[-13,-29],[-34,-7],[-19,48],[0,24],[-12,25],[-18,3],[-7,52],[-14,31],[-2,90],[-15,22],[-1,33],[18,34],[-11,29]],[[27075,60636],[-14,-4],[-28,30],[-3,37],[-8,1],[-7,40],[-9,-2],[-7,42],[-15,11],[-13,134],[-10,19],[-13,61],[1,34],[-15,19],[-8,39],[11,55],[-15,22],[-9,80],[-10,45],[-15,37],[0,38],[8,0],[3,55],[-4,20],[11,33],[1,58],[-8,36],[1,90]],[[24442,63943],[12,16],[-2,50],[4,90],[-11,35],[13,69],[31,43],[18,-1],[18,41],[1,61],[6,49],[1,67],[10,27],[14,66],[11,19],[6,106],[-1,98],[-13,75],[-13,6],[-20,85],[11,77],[2,74],[6,55],[19,21],[13,-15],[23,40],[31,-6],[24,17],[16,56],[10,13],[26,-1],[18,57],[16,21],[-1,66],[9,59],[0,52],[9,29],[28,49],[-1,41],[8,72],[-3,58],[7,61],[-7,37],[1,89],[-13,41],[-47,73],[-15,74],[3,60],[-16,63],[-22,37],[-2,26],[-22,35],[0,47]],[[24658,66423],[45,-2],[227,-2],[51,-5],[194,-11],[41,4],[152,1],[82,-5]],[[25450,66403],[-2,-124],[-8,-97],[10,-109],[21,-117],[12,-37],[3,-54],[13,-139],[4,-75],[14,-93],[8,-20],[2,-47]],[[25386,60941],[-8,-66],[-17,-35],[-11,-56],[7,-105],[20,-68],[-6,-50],[-48,-19],[-12,-11],[-18,-52],[-14,26],[-18,-44],[-2,-55],[-9,-65],[2,-25],[17,-65],[7,-66],[-10,-89],[-15,-10],[-13,13],[-19,52],[-35,40],[-14,39],[-31,42],[-19,5],[-13,-21],[-13,-42],[-9,-65],[-16,-52],[-4,-55],[14,-52]],[[20232,53938],[-214,0],[-254,0],[0,-524],[-234,-1]],[[24911,58847],[4,-38],[18,-49],[0,-45],[-24,23],[-9,-49],[20,-36],[-11,-33],[-11,-1],[-9,-52],[-17,-22],[-9,21],[-15,-41],[6,-68],[9,-17],[12,23],[3,-38],[-26,-42],[1,-53],[9,-10],[-3,-40],[-22,56],[-9,-9],[-5,-58],[9,-42],[-11,-75],[-8,88],[-23,-67],[-3,-46],[12,-6],[2,43],[15,-35],[-9,-47],[0,-45],[-16,-10],[4,-47],[15,-7],[6,-29],[-12,-43],[15,-58],[-10,-25],[-12,21],[-9,-26],[-9,-100],[-25,13],[-3,-49]],[[24751,57677],[17,-55],[0,-45],[-18,-44],[-31,-44],[-4,59],[-11,2],[-2,-29],[8,-44],[-5,-25],[6,-72],[-14,-19],[-5,34],[2,57],[-10,-27],[2,-35],[-7,-14],[6,-40],[20,-2],[2,-31],[-14,-50],[-11,18],[1,49],[-10,-21],[0,-64],[12,-61],[1,-27],[-13,-51],[6,-83],[-25,-57],[0,-63],[-10,1],[3,54],[-19,-1],[-5,-27],[8,-45],[-7,-30],[-19,-15],[-4,-71],[-16,43],[-9,-29],[14,-43],[20,1],[2,-25],[-13,-28],[-16,33],[-12,-32],[9,-51],[11,3],[3,-24],[-8,-61],[-24,-6],[7,-45],[-11,-16],[-5,43],[-16,-23],[-3,-29],[22,-34],[-18,-78],[7,-55],[16,-26],[-10,-34],[-8,18],[-24,-2],[-1,-59],[10,-26],[13,14],[8,-50],[-12,-18],[-16,22],[-7,35],[-17,-16],[-2,-28],[25,-51],[2,-33],[-28,-41],[13,-63],[-14,-80],[18,16],[-1,51],[14,-27],[-4,-54],[-17,-10],[-3,-19],[10,-24],[17,14],[10,73],[5,-32],[-23,-90],[0,-64],[12,-68],[3,42],[10,13],[2,-23],[-13,-52],[2,-75],[-3,-23],[-14,-8],[-11,14],[-5,-39],[23,-62],[-13,-59]],[[24512,55359],[-219,4],[-154,5],[-157,7],[-86,0],[-185,2]],[[16868,55911],[16,-5],[28,-53],[21,-22],[1,-25],[16,-61],[-5,-43],[-13,25],[-26,7],[-6,35],[0,74],[-20,16],[-12,52]],[[16867,55390],[9,4],[22,-117],[40,-130],[-10,4],[-11,-22],[-17,44],[-13,72],[-14,119],[-6,26]],[[16741,55926],[8,7],[1,-41],[-11,7],[2,27]],[[16637,56552],[8,-17],[11,14],[0,-30],[-17,-4],[-9,21],[7,16]],[[16596,55679],[14,7],[20,-35],[8,-31],[-13,-15],[-20,21],[-9,53]],[[16501,56608],[18,-7],[13,-22],[15,5],[19,-43],[19,-4],[7,39],[20,-20],[-11,-43],[-28,-11],[-17,-31],[-42,24],[-1,61],[-12,52]],[[16410,56520],[22,8],[9,21],[13,-8],[13,19],[0,-48],[18,-13],[1,-48],[-41,-54],[-16,37],[-19,86]],[[16354,56562],[16,17],[6,28],[6,-35],[13,-26],[-21,-6],[-20,22]],[[15305,65829],[155,-4],[9,6],[77,-1],[56,12],[28,-8],[115,2],[37,5],[95,-1],[45,-5],[154,-8],[114,-4],[197,0],[92,2]],[[16479,65825],[0,-1]],[[16479,65824],[0,-1448],[1,-34],[0,-756],[-1,-393],[-1,-13],[0,-457],[-1,-122],[2,-263],[26,-77],[115,-330],[114,-336],[63,-182],[99,-298],[125,-377],[62,-186],[127,-394],[313,-989],[234,-759],[70,-234],[147,-492]],[[17950,55027],[-416,-126],[-254,-89],[-3,98],[-9,62],[-8,20],[-14,-23],[-3,66],[1,71],[-8,41],[9,61],[-9,161],[-13,127],[-9,54],[-40,193],[-25,61],[-10,51],[-15,37],[-9,-2],[-19,95],[-26,59],[-14,15],[-20,57],[-25,88],[-24,39],[-2,-47],[-21,-23],[-18,14],[-10,25],[-15,6],[-4,38],[9,34],[1,43],[-14,116],[-11,64],[-17,50],[-35,1],[-22,-8],[-16,-36],[-14,38],[-28,16],[-37,59],[-12,2],[-24,53],[-17,141],[-10,10],[-17,53],[-4,-3],[-20,65],[-21,25],[-6,20],[-32,4],[-16,-24],[-18,25],[-22,-10],[-37,60],[-23,0],[-15,15],[-44,-7],[-48,-22],[-1,31],[-13,66],[-16,30],[-12,-4],[-6,32],[13,143],[-11,60],[8,119],[-17,54],[9,115],[1,140],[-18,56],[-14,7],[-3,-21],[-27,55],[-11,48],[10,131],[-2,50],[-11,53],[-27,14],[-27,102],[-18,101],[-24,25],[-17,66],[-5,81],[-16,47],[-7,37],[-14,35],[-6,99],[-5,35],[-20,29],[-15,104],[-25,94],[-33,64],[-11,45],[-8,80],[1,42],[-11,101],[2,92],[-11,16],[10,74],[18,-38],[9,30],[7,61],[8,141],[-21,149],[-12,43],[-10,11],[-9,-28],[-37,2],[-28,68],[-22,102],[-14,18],[-2,31],[-17,60],[-4,62],[5,129],[-12,89],[-2,52],[-12,14],[-6,33],[-1,64],[5,27],[2,77],[-6,134],[14,28],[16,8],[6,-24],[7,-88],[-9,-9],[11,-107],[-2,-27],[27,-23],[27,-80],[8,5],[14,-63],[12,3],[-6,40],[-12,19],[-10,87],[-7,109],[-21,54],[-2,46],[-22,26],[9,74],[-7,68],[-15,-1],[-14,68],[8,-9],[9,26],[0,40],[19,-2],[10,39],[-10,71],[-26,44],[-13,-30],[-14,-6],[2,-47],[-5,-46],[15,-51],[-12,-25],[-4,-44],[19,-56],[-7,-14],[-11,29],[7,-71],[-15,-16],[-9,38],[-26,61],[-13,-12],[-23,67],[-10,53],[-17,33],[-16,8],[-20,-33],[14,127],[3,48],[-12,92],[7,20],[-16,70],[-11,-10],[-1,67],[-17,106],[-20,51],[-14,19],[-22,64],[-37,176],[-14,29],[-8,41],[-31,90],[-24,116],[14,78],[-1,42],[-14,126],[-16,123],[-7,105],[3,99],[13,132],[-5,52],[0,65],[-14,92],[-4,108],[-16,36],[-6,55],[-35,133],[-7,6],[0,43],[-8,43],[-22,32],[-49,151],[4,63],[-4,70],[-13,74],[9,98],[14,109],[42,265],[11,95],[7,119],[-12,37],[-1,97],[4,2],[11,99],[12,244],[-5,126],[-15,128],[-8,96],[-9,-4],[-17,54],[10,74],[5,110],[-3,67]],[[28861,63044],[-1,28]],[[28874,63137],[-6,7],[-22,-81],[2,-39],[11,-31],[1,-49],[-8,-28],[0,-41],[14,-52],[7,-58],[21,-62],[10,-68],[3,-58],[-5,-35],[2,-126],[16,-48],[7,-43],[2,-74],[34,-137],[16,-29],[10,24],[4,-36],[5,-129],[4,-244]],[[29002,61700],[-105,1],[-74,9],[-2,72],[-25,1311],[0,86]],[[28426,62262],[21,70],[37,-118],[-36,-118]],[[28448,62096],[0,93],[-22,73]],[[6433,39922],[2,44],[19,76],[12,7],[13,93],[16,52],[3,58],[-17,94],[-4,45],[-1,105],[8,37],[18,-9],[18,-32],[3,-32],[22,-44],[15,-47],[12,6],[25,-32],[39,-77],[13,-19],[22,-61],[16,-57],[17,-76],[-3,-47],[1,-90],[8,-10],[16,12],[7,-57],[-1,-57],[22,-82],[22,-39],[5,-21],[-4,-44],[-13,-51],[-17,-47],[-14,-56],[-23,-38],[-20,-47],[-20,-18],[-16,15],[-9,-9],[-18,-66],[-16,-25],[-13,-48],[-14,-16],[-12,-59],[1,-33],[-8,-37],[-5,-59],[-20,-63],[-15,61],[-22,52],[-22,29],[-10,95],[5,113],[4,151],[-10,106],[1,46],[-9,12],[-5,114],[-7,66],[-9,8],[-8,108]],[[6254,41293],[5,69],[11,56],[14,6],[13,-33],[10,-78],[10,-50],[24,29],[18,35],[26,-21],[0,-16],[17,-51],[10,-15],[5,-40],[31,-37],[5,-32],[0,-52],[-8,-43],[-13,-40],[-6,3],[-17,-36],[-14,10],[-30,-53],[-21,-9],[-17,26],[-7,210],[-7,20],[-14,-24],[-26,50],[-13,58],[-6,58]],[[6253,40841],[7,29],[28,57],[10,-30],[-4,-44],[5,-17],[-13,-19],[-5,15],[-18,-23],[-10,32]],[[6153,41274],[7,27],[13,5],[26,-19],[17,-60],[8,-51],[-9,-65],[-19,-29],[-17,-5],[-7,60],[-3,73],[-14,32],[-2,32]],[[6084,41504],[6,52],[9,29],[-2,58],[17,-2],[3,-14],[54,-29],[10,34],[4,-42],[22,-13],[27,18],[17,-25],[-8,-55],[-18,-51],[-20,-21],[-35,32],[-26,31],[-15,-14],[-29,-5],[-16,17]],[[5814,42059],[43,9],[13,49],[4,35],[13,48],[14,15],[6,-27],[6,-70],[20,-84],[4,-52],[-4,-15],[3,-47],[18,-55],[3,57],[12,-2],[-4,-64],[8,-24],[-1,-29],[17,-70],[-12,-37],[-11,18],[-21,-29],[-6,26],[-17,31],[-25,11],[-30,-20],[-7,4],[-7,84],[-11,34],[-1,31],[-14,67],[0,61],[-13,45]],[[5394,42585],[1,40],[11,38],[4,49],[33,72],[8,26],[23,-18],[3,25],[16,-11],[8,14],[15,-20],[10,-37],[5,-45],[0,-46],[-11,-63],[1,-106],[-4,-28],[-28,-78],[-8,15],[-36,12],[-18,71],[-24,29],[-9,61]],[[5266,42374],[4,43],[12,44],[19,45],[2,38],[11,9],[2,-31],[-5,-57],[2,-36],[-20,-28],[-16,-97],[-12,30],[1,40]],[[24498,67577],[-5,-52],[10,-50],[-1,-74],[27,-41],[13,-76],[-18,-60],[-6,-52],[-9,-24],[1,-108],[8,-88],[0,-68],[12,-25],[13,-169],[33,-64],[47,-37],[17,-20],[18,-109],[0,-37]],[[23231,64184],[4,28],[-10,56],[-13,16],[-15,58],[2,37],[13,35],[-4,83],[10,51],[-7,27],[2,66],[-9,20],[1,42],[-7,30],[5,27],[-5,93],[12,17],[-24,24],[4,37],[-5,63],[13,41],[-20,27],[7,29],[-1,116],[-20,10],[2,77],[-9,1],[-2,-37],[-15,28],[3,56],[-11,39],[7,39],[-8,41],[11,18],[-6,54],[8,20],[3,46],[-12,23],[-1,38],[-14,61],[6,11],[3,66],[-16,6],[1,30],[-15,11],[5,16],[-15,25],[1,83],[-22,56],[-3,48],[10,25],[-14,103],[-11,29],[0,76],[9,44],[-4,44],[-14,8]],[[26280,62461],[18,48],[7,-2],[15,-54],[21,-28],[14,29],[14,-3],[8,29],[8,-8],[4,-69],[29,-32],[10,-84],[16,-83],[0,-66],[5,-26],[40,-41],[33,19],[29,-46],[3,-34],[15,-26],[5,-50],[28,-29],[14,66],[26,22],[15,-32],[28,-20],[11,-24],[5,-43],[13,24],[30,-1],[10,53],[18,34],[9,39],[15,0],[21,32],[7,-33],[-3,-44],[9,-111],[13,-37],[21,-6],[21,-79],[13,-35],[2,-44]],[[27075,60636],[-108,-317],[-37,-39],[-22,-41],[-19,-49],[-25,-45],[0,-86],[-16,-39],[-12,-2],[-12,-33],[3,-59],[-6,-45],[-25,-36],[-29,-4],[-16,-80],[-2,-50],[-16,-4],[-33,-35],[-39,-52],[-21,2],[-33,-49],[-8,-27]],[[26599,59546],[-4,-21],[-83,8],[-79,2],[-76,5],[-83,11],[-51,16],[-74,9],[-55,-14],[-96,8],[-56,10],[-83,22],[-49,4],[-16,-22],[-7,22],[-146,-12],[-92,-2],[-114,-8],[1,35],[-61,17],[10,-147],[-6,-64],[-137,6],[-126,0],[-84,6],[-33,-10]],[[24980,59425],[-15,1]],[[28739,61120],[-14,0]],[[28725,61120],[-1,72],[8,28],[11,-40],[-4,-60]],[[28711,61320],[2,79],[11,13],[7,-30],[5,-118],[-15,21],[4,27],[-14,8]],[[28627,62072],[5,20],[5,-46],[-10,26]],[[29002,61700],[-1,-43],[-9,-105],[-5,-15],[-20,-211],[-18,-120]],[[28949,61206],[-107,-38],[-6,-55],[-6,4]],[[28830,61117],[-13,30],[-19,-4],[-22,-64],[-9,-1],[-1,67],[7,70],[17,28],[-17,2],[2,45],[11,40],[-21,9],[-12,-33],[-4,28],[5,58],[26,27],[-6,39],[-9,-13],[-4,36],[15,112],[-15,-24],[-7,-47],[0,-60],[-8,-1],[-11,77],[11,9],[-1,53],[-8,10],[-4,-49],[-9,-33],[6,-27],[-9,-62],[-4,29],[-17,-23],[-9,12],[-16,83],[-9,13],[2,43],[-24,151],[20,14],[5,39],[-8,-7],[-9,51],[8,40],[12,22],[6,-25],[12,26],[1,-36],[22,-9],[13,-39],[4,10],[-16,69],[-17,14],[-8,42],[-7,-3],[-16,77],[-5,-28],[-12,20],[-1,-59],[-7,8],[3,101],[18,92],[14,-45],[8,10],[-3,124],[-8,17],[-17,-47],[-12,4],[1,-48],[-12,-17],[4,104],[16,101],[7,-51],[21,-11],[11,31],[-6,54],[11,55],[-16,-9],[-3,-52],[4,-31],[-12,17],[3,63],[-6,59],[-7,14],[16,136],[12,42],[-2,24],[14,25],[7,37],[30,-6],[-11,24],[18,70],[-10,6],[12,122],[-35,-24],[-6,-48],[12,-24],[4,-32],[-12,-14],[-34,-97],[-7,31],[7,54],[-8,28],[0,-44],[-9,-51],[8,-34],[-7,-46],[-6,96],[-15,14],[6,-103],[-8,8],[-6,-42],[12,-22],[-21,-44],[-7,-28],[-13,8],[-2,26],[-22,46],[3,-46],[9,-13],[2,-41],[27,-54],[2,-67],[-5,-25],[13,-48],[-23,-45],[7,-37],[-3,-40],[-9,4],[-7,-55],[6,-53],[-17,-58],[9,-50],[-2,-54],[6,-73],[-2,-89],[7,-65],[22,-80],[8,-62],[-9,-45],[-14,7],[9,-42],[9,22],[8,-14],[-7,-47],[4,-48],[18,-92],[-5,-22],[5,-97],[-9,19],[-11,58],[-8,4],[-5,64],[-8,-9],[-2,-57],[-7,38],[-8,-3],[-5,48],[-12,45],[-23,23],[-35,3],[-8,129],[-8,13],[-4,-31],[10,-68],[-2,-22],[-22,43],[-2,34],[-13,31],[-12,114],[-20,-44],[-33,-56],[-12,27],[-7,115],[11,82],[15,57],[20,30],[-5,10]],[[28423,61914],[-1,45],[7,27],[18,25],[1,85]],[[28426,62262],[-9,37],[-20,6],[-8,17],[1,48],[-26,42],[-34,15],[-6,39],[-10,13],[1,58],[9,18],[7,49],[-23,43],[-6,45],[-15,-1],[-16,25],[-13,-3]],[[26327,70327],[8,17],[9,-60],[65,-63],[-17,-58],[-23,18],[-14,61],[-28,85]],[[26120,70229],[5,40],[7,-20],[-12,-20]],[[26084,70289],[21,-39],[-4,-36],[-19,38],[2,37]],[[26055,70019],[7,48],[3,69],[6,15],[1,57],[18,-7],[-1,-85],[4,-83],[-19,-44],[-19,30]],[[26035,70180],[13,8],[-5,-54],[-7,1],[-1,45]],[[25984,69839],[13,-17],[1,-59],[-14,76]],[[25933,69486],[6,23],[19,-25],[-6,-96],[-17,52],[-2,46]],[[25908,69335],[11,44],[6,-47],[-17,3]],[[25759,70041],[20,-64],[-8,-22],[-4,36],[-14,43],[6,7]],[[25722,65552],[30,68],[27,87],[37,261],[34,146],[19,134],[10,99],[10,176],[-1,58],[6,87],[-1,163],[-6,182],[-11,120],[-35,230],[-11,94],[-12,138],[-17,119],[0,48],[22,102],[7,50],[1,77],[-9,134],[-14,90],[4,32],[20,51],[24,151],[21,112],[4,124],[9,134],[-11,112],[1,33],[27,43],[20,15],[6,93],[-2,74],[10,36],[13,-18],[16,80],[18,-35],[17,13],[8,32],[9,86],[10,16],[15,94],[11,47],[9,-7],[12,35],[3,-39],[-19,-32],[-3,-42],[12,-81],[-23,-81],[13,19],[0,-74],[-6,-7],[-8,-84],[7,-95],[8,-2],[19,145],[3,98],[13,20],[-8,-158],[-15,-44],[-6,-67],[14,-14],[8,65],[7,13],[22,135],[5,78],[-1,56],[4,82],[-6,85],[5,94],[17,49],[10,3],[18,48],[18,16],[25,-7],[26,14],[12,20],[-1,33],[-33,17],[-14,47],[-8,114],[16,75],[13,14],[20,69],[-2,31],[-18,27],[60,-15],[7,49],[61,-102],[26,-58],[13,20],[11,-16],[13,10],[32,-34],[24,-85],[3,-57],[17,-27],[33,4],[8,-9],[29,-77],[23,-7],[34,-71],[29,6],[21,-78],[11,-25],[-9,-27],[15,-96],[11,-30],[14,-133],[-20,21],[-16,34],[-15,-41],[4,-110],[12,-44],[21,-26],[5,-59],[1,-98],[7,-37],[-4,-71],[-8,-67],[2,-65],[-5,-111],[-1,-121],[-12,-15],[-14,-64],[-24,2],[-8,-30],[-8,-108],[-4,-115],[-19,-5],[-8,-19],[0,-49],[-42,-6],[-13,-35],[-9,-76],[-5,-124],[-8,-42],[13,-91],[16,-32],[9,33],[5,-38],[20,-21],[13,-38],[10,16],[28,120],[14,0],[7,25],[-7,51],[9,44],[9,87],[4,-50],[19,31],[5,29],[-21,31],[24,-3],[11,24],[5,41],[23,10],[34,28],[9,45],[31,30],[11,-30],[23,-25],[15,-39],[17,-123],[10,-37],[7,-97],[5,-208],[17,-178],[4,-247],[10,-143],[18,-110],[2,-48],[-11,-46],[-7,-145],[4,-47],[-12,-113],[-4,-67],[-18,-66],[-15,4],[-12,-42],[1,66],[-9,27],[10,16],[15,62],[-14,26],[-15,-5],[-19,-34],[-7,-32],[9,-27],[2,-45],[-15,4],[-11,-52],[1,-84],[-7,-77],[-17,-53],[-30,-25],[-18,-97],[2,-127],[-3,-44],[-15,-25],[-1,-70],[-16,-39],[-6,-39],[-13,-4],[-7,-65],[-11,-11],[-17,-72],[5,-79],[-8,-9]],[[26661,65520],[-86,-11],[-167,-20],[-124,-12]],[[25045,72671],[21,69],[95,141],[7,-2],[43,98],[31,42],[6,-11],[28,29],[-1,-28],[-12,-16],[-30,-80],[0,-30],[-25,-55],[-51,-53],[-42,-66],[2,-20],[23,0],[-59,-73],[-18,3],[-18,52]],[[24721,71146],[19,40],[12,3],[39,49],[38,34],[31,77],[19,64],[16,27],[33,17],[15,-17],[29,27],[22,-3],[52,75],[30,94],[22,5],[29,23],[10,39],[5,51],[25,65],[14,16],[30,82],[23,23],[21,56],[11,54],[20,52],[58,85],[56,25],[50,-7],[23,-39],[1,-45],[-11,5],[-17,-24],[-19,13],[-21,-10],[5,-47],[-32,-57],[-30,-95],[-19,-20],[-5,-74],[-7,9],[-7,-52],[-14,-26],[-5,-67],[-12,-48],[-9,-6],[-12,-164],[6,-52],[-9,-35],[11,3],[20,87],[3,44],[7,-13],[29,80],[28,43],[-12,-55],[-12,-24],[-15,-77],[30,84],[26,18],[14,-13],[37,1],[15,-30],[8,8],[17,-35],[8,-39],[15,11],[22,-63],[3,-61],[17,-49],[6,-47],[14,-49],[19,-15],[-2,-79],[11,-28],[26,-15],[42,10],[25,43],[11,-8],[14,-72],[12,-27],[19,-4],[8,46],[16,-7],[9,-38],[4,69],[-7,53],[16,20],[7,-32],[-6,-56],[17,-26],[26,72],[40,62],[59,110],[11,-21],[61,42],[46,-16],[35,-3],[30,7],[62,85],[24,12],[30,-7],[32,14],[-22,-84],[-2,-135],[2,-45],[-8,-19],[9,-51],[16,-8],[9,16],[6,-26],[15,3],[17,-28],[34,49],[13,-4],[11,-46],[-1,-35],[25,28],[7,-7],[10,65],[19,24],[23,-19],[11,9],[8,39],[27,-5],[5,-30],[-10,-100],[7,-120],[1,-95],[-29,-2],[-8,-65],[15,-12],[5,21],[15,-4],[8,-38],[19,-19],[-13,-40],[24,-75],[12,-1],[20,-45],[8,38],[14,-35],[8,26],[-16,100],[14,-15],[41,13],[12,-15],[14,-91],[16,-31],[-10,-64],[-14,-20],[-27,39],[-31,-16],[-31,42],[-11,-12],[-27,1],[-27,23],[-60,-26],[-13,-28],[-37,69],[-15,48],[-13,-7],[-13,30],[-10,-41],[2,-51],[-15,-32],[1,-45],[9,-63],[-12,-20],[-24,42],[-3,31],[-21,37],[-5,30],[-22,64],[-38,46],[-13,-7],[-33,49],[-18,-5],[-13,23],[-5,-20],[-19,11],[-25,-75],[-17,-73],[-9,-8],[-32,23],[-23,-15],[-8,-22],[2,-34],[-23,37],[-21,17],[-24,-14],[-10,11],[-23,-24],[-13,-42],[-2,-63],[-9,-72],[-14,4],[-7,-39],[-22,-15],[-6,-46],[-13,-3],[0,-45],[-12,-9],[4,-61],[-20,32],[-9,40],[12,27],[1,34],[11,31],[1,40],[13,-4],[15,87],[-3,43],[-12,10],[-18,-75],[-38,24],[3,-51],[-13,-47],[-5,-56],[-30,-31],[-5,-27],[-6,39],[3,55],[-4,67],[-8,32],[-10,-19],[-5,-120],[3,-12],[-31,-55],[-26,-129],[-17,-146],[-19,-65],[-20,-112],[-41,-174],[6,-33]],[[25508,69434],[-19,14],[-8,47],[-13,28],[-2,29],[15,118],[11,48],[-2,34],[-11,25],[-16,-47],[-27,-10]],[[25436,69720],[0,0]],[[25436,69720],[-7,47],[7,24],[-3,38],[13,34],[6,40],[-3,47],[8,69],[-14,75],[12,13],[-8,44],[-13,18],[-6,33],[-24,4],[-9,43],[-21,-18],[-18,45],[17,52],[-7,21],[0,47],[-40,48],[-14,-14],[-24,47],[-12,-15],[-21,21],[-2,25],[-27,-2],[-3,-32],[-14,0],[-4,29],[-17,16],[-12,-13],[-86,142],[-287,231],[1,27],[-28,167],[-27,16],[-10,24]],[[24739,71113],[0,0]],[[24739,71113],[-12,-6],[-6,39]],[[25252,52115],[30,-13],[-14,-20],[-12,9],[-4,24]],[[25179,52148],[16,13],[30,-29],[6,-15],[-24,5],[-28,26]],[[25119,52114],[15,7],[15,31],[-4,-29],[-21,-27],[-5,18]],[[25071,52140],[21,-1],[8,13],[-5,-43],[-10,-7],[-17,26],[3,12]],[[24751,57677],[229,-2],[156,1],[202,1]],[[25284,52292],[-4,-32],[-7,15],[-10,-40],[-18,27],[-13,-15],[-5,30],[-18,7],[-18,-23],[-23,49],[-2,-28],[-21,38],[-22,-3],[-31,-27],[-28,-42],[-30,-33],[4,54],[-10,30],[-14,-27],[9,-17],[1,-40],[-25,-57],[-8,-80],[-9,10],[-13,-16]],[[24969,52072],[-12,0],[-13,50],[-4,66],[0,69],[-15,77],[0,54],[-10,43],[-11,19],[-4,39],[-10,34],[-4,95],[-8,14],[10,88],[-4,36],[7,25],[9,125],[7,19],[-1,45],[7,22],[-7,36],[-165,-2],[-134,-1],[-226,0],[13,21],[7,58],[-16,50],[-1,28],[10,46],[-3,41],[-12,30],[1,38],[18,-7],[17,20],[2,43],[-12,37],[-1,45],[-7,16],[9,39],[4,-50],[8,-29],[9,7],[0,29],[-13,75],[-1,74],[20,18],[12,35],[-4,32],[-18,-13],[-9,30],[5,38],[10,-28],[18,0],[1,106],[11,35],[23,5],[4,18],[-29,11],[7,94],[12,11],[2,-43],[7,-17],[5,28],[-6,21],[24,78],[-2,50],[7,25],[19,14],[0,50],[-19,26],[5,25],[13,-39],[5,36],[12,22],[9,69],[-15,24],[2,-62],[-32,11],[2,79],[27,20],[7,27],[14,-31],[5,42],[-2,53],[12,-8],[16,79],[-4,18],[-6,-40],[-23,17],[0,58],[8,20],[-8,35],[-10,-20],[-23,49],[3,58],[5,1],[17,-48],[10,7],[-5,26],[-21,50],[14,31],[8,37],[-7,37],[-6,-46],[-20,-26],[-6,14],[-3,52],[9,38],[16,33],[2,27],[-31,30],[1,71],[5,37],[21,52],[2,39],[-9,72],[-11,-4],[1,-67],[-14,-26],[-9,22],[3,48],[10,50]],[[17580,73980],[234,-2],[232,3],[190,-5],[190,2],[348,-2],[211,0],[232,2],[328,0],[141,0],[292,0],[227,1],[143,-1],[294,0],[114,0],[167,1]],[[18973,68711],[-21,23],[-6,49],[-24,59],[2,43],[-28,117],[-17,36],[-8,-52],[-20,-3],[5,-33],[-16,-98],[15,-64],[-32,26],[-9,-16],[-24,13],[-3,-19],[-30,-40],[-13,63],[-22,-8],[-13,-25],[-10,13],[-21,-30],[-8,22],[-14,-8],[-12,35],[-16,7],[-9,-35],[-9,0],[-2,-61],[-8,-45],[-24,38],[-8,-20],[-11,24],[-33,2],[-17,22],[-17,-23],[-15,-72],[6,-53],[-9,-22],[-11,44],[-18,24],[-15,40],[-6,53],[5,34],[-21,81],[9,48],[-5,50],[-18,109],[-32,58],[-26,-44],[-4,40],[-28,53],[-11,97],[14,13],[2,55],[-4,61],[-19,39],[2,26],[-17,15],[-7,73],[-24,73],[-1,35],[-14,54],[2,70],[-8,19],[-6,57],[6,30],[-1,46],[-19,0],[7,95],[-15,25],[-12,-2],[2,26],[-10,44],[-15,26],[-9,-13],[2,-41],[-15,-35],[-19,-82],[-19,-26],[-13,12],[-3,-58],[-24,-42],[-5,36],[-14,22],[-13,60],[-25,0],[4,53],[-8,36],[18,37],[1,48],[-19,74],[18,89],[25,1],[7,44],[-13,54],[6,49],[-19,27],[-4,54],[9,58],[-17,33],[2,49],[19,7],[-1,79],[-6,30],[13,24],[1,116],[13,65],[-7,69],[12,3],[10,123],[-3,58],[-8,10],[-26,-23],[-4,-21],[-22,15],[-19,-5],[-8,39],[6,39],[-7,30],[-14,9],[-4,-30],[-15,-21],[-6,17],[6,55],[-34,58],[-16,59],[4,71],[-20,60],[-13,-1],[-6,60],[-19,82],[-17,54],[-12,13],[-5,37],[-11,7],[2,38],[-9,41],[-24,10],[-32,45],[-7,54],[-47,87],[-11,-2],[12,36],[22,8],[3,22],[-16,7],[-5,57],[-11,5],[2,34],[13,32],[-12,55],[2,63],[-13,24],[-7,47],[-8,-6],[-8,88],[-15,21],[-39,152],[-1,279],[1,109],[0,804]],[[29991,69339],[3,68],[18,64],[-3,15],[11,74],[-13,36],[18,11],[4,26],[22,42],[15,-61],[28,-5],[13,70]],[[30213,67064],[-30,-174],[-2,-44]],[[29724,66677],[-9,53],[-6,-10],[-12,102],[9,73],[1,57],[13,10],[8,45],[-6,52],[9,33],[-5,65],[4,138],[12,64],[-6,60],[10,135],[-5,35],[5,74],[15,33],[6,109],[9,44],[19,43],[6,44],[-1,64],[19,67],[0,85],[12,44],[12,69],[0,47],[-10,68],[6,57],[-6,34],[10,61],[35,32],[10,-13],[16,21],[5,52],[24,14],[14,39],[7,45],[16,22],[-6,59],[11,13],[2,73],[-10,38],[-11,102],[15,52],[4,64],[18,75],[-13,89],[11,30]],[[29842,64964],[3,18],[27,22],[-21,-43],[-9,3]],[[29812,64781],[5,20],[11,-16],[0,-50],[-6,35],[-10,11]],[[29792,64880],[16,16],[-12,-43],[-4,27]],[[29275,64272],[5,-67],[-9,-39],[-38,-78],[-11,-1]],[[28633,68013],[16,50],[-5,-45],[-11,-5]],[[28611,68032],[12,40],[9,-5],[-21,-35]],[[27689,66145],[33,53],[53,111],[29,91],[30,50],[26,25],[11,70],[13,36],[4,52],[36,56],[19,54],[-4,80],[-13,40],[2,43],[-7,37],[-23,35],[1,92],[-18,15],[9,77],[-5,125],[-3,13],[28,22],[38,42],[56,47],[40,20],[33,2],[38,-9],[36,8],[86,-42],[23,-19],[15,-47],[23,-46],[12,-10],[40,49],[35,1],[43,12],[21,-19],[23,-1],[14,25],[30,20],[18,40],[9,1],[19,80],[30,64],[10,8],[19,54],[14,5],[20,-15],[17,19],[9,53],[2,87],[-9,180],[-20,40],[11,50],[14,11],[2,-33],[21,41],[-3,43],[-19,47],[-22,-15],[5,29],[-15,51],[-15,1],[1,80],[16,115],[19,5],[23,42],[0,48],[18,22],[27,55],[9,-5],[16,29],[25,75],[4,46],[12,51],[41,121],[31,100],[56,141],[-1,12],[68,109],[26,62],[18,0],[22,37],[27,-29],[19,10],[91,-8],[53,-1],[107,14],[24,-1],[93,10]],[[29478,69336],[1,-109],[-7,-30],[-4,-63],[13,-57],[-10,-55],[-2,-92],[-4,-31],[4,-70],[19,-88],[4,-69],[-12,-80],[7,-114],[-4,-36],[-19,-63],[-5,-89],[-8,-79],[9,-27],[-1,-103],[10,-67],[-5,-64],[12,-57],[-16,-97],[-7,-114],[10,-26],[7,66],[19,0],[2,-53],[13,-29],[-2,-343],[-6,-422],[0,-74],[-4,-37],[8,-65]],[[29390,64649],[-7,-42],[-21,-42],[-2,-79],[-13,2],[9,-60],[18,87],[11,-15],[10,42],[21,27],[18,2],[4,33],[22,-30],[2,41],[9,-28],[20,-8],[18,-23],[23,28],[2,43],[17,8],[10,-12],[75,3],[39,20],[14,18],[30,63],[9,40],[12,13],[13,50],[21,21],[12,-2],[-18,-52],[-9,-6],[15,-31],[5,-44],[17,-12],[11,25],[16,-72],[15,17],[23,48],[2,28],[17,11],[12,-12],[-5,-21],[-67,-94],[-78,-123],[-50,-62],[-81,-93],[-53,-78],[-43,-41],[-27,-12],[-6,15],[-64,-60],[-61,10],[-46,-55],[3,38],[-23,-2],[3,25],[-11,39],[7,35],[-8,36]],[[26861,65369],[16,17],[-2,-36],[-14,19]],[[26831,65420],[6,90],[11,-35],[-3,-35],[-14,-42],[0,22]],[[26661,65520],[1,-26],[21,-28],[13,17],[37,-82],[25,-20],[11,-21],[18,-66],[19,-29],[18,23],[2,50],[7,13],[14,-55],[19,2],[-1,-37],[29,-96],[16,-33],[22,-21],[41,57],[22,4],[17,35],[51,60],[37,-38],[19,15],[20,-9],[29,61],[29,86],[8,10],[16,58],[44,102],[10,1],[67,108],[30,17],[24,34],[65,69],[17,24]],[[15490,70789],[21,10],[13,-45],[-1,-55],[17,-42],[25,-1],[32,51],[14,-4],[59,-119],[7,-61],[18,-81],[1,-57],[7,-52],[-3,-67],[10,-88],[-4,-41],[3,-50],[33,-54],[46,-35],[11,-19],[17,14],[13,-32],[18,-5],[23,39],[23,7],[54,83],[12,45],[15,16],[21,-15],[29,12],[28,26],[19,-30],[17,-9],[18,14],[34,-40],[9,-75],[14,4],[19,50],[34,4],[13,-16],[11,34],[47,51],[15,35],[21,-9],[21,-51],[22,6],[34,26],[20,5],[11,42],[28,27],[29,46],[46,27],[37,10],[13,57],[14,23],[24,-22],[64,39],[17,-14],[19,6],[28,42],[11,36],[163,1],[250,-3],[164,-3]],[[17338,70482],[16,-107],[11,-27],[16,-75],[18,5],[10,-47],[19,-2],[16,-48],[0,-53],[13,-49],[7,-54],[-24,-108],[-1,-55],[-10,-23],[-24,-150],[1,-36],[-9,-51],[-7,-116],[-13,-40],[-6,-53],[-14,-44],[-3,-51],[7,-58],[-9,-68],[-18,-76],[0,-21],[-32,-49],[-14,-93],[-8,-97],[-10,-66],[-18,-48],[3,-66],[-8,-36],[15,-69],[-8,-56],[13,-35],[19,25],[16,-59],[20,12],[2,-53],[18,-17],[1,-31],[-10,-62],[-12,-17],[1,-42],[11,-32],[-1,-43],[-12,-81],[0,-54],[-11,-11],[-2,-59],[0,-2105]],[[17307,65831],[-166,-2],[-273,-5],[-26,-3],[-143,2],[-220,2]],[[15305,65829],[-21,55],[-15,55],[-7,69],[2,33],[-14,81],[2,32],[-7,63],[-2,126],[13,147],[-7,107],[-17,87],[-11,2],[-11,123],[15,90],[12,96],[6,83],[0,52],[9,80],[6,99],[-6,42],[17,53],[8,43],[16,132],[15,193],[15,283],[7,225],[4,188],[-2,8],[10,197],[-1,69],[7,184],[0,92],[-5,39],[8,91],[12,227],[8,117],[4,157],[-3,66],[3,109],[-4,69],[5,24],[5,176],[-1,76],[-11,41],[6,87],[-2,83],[-7,45],[16,36],[1,109],[-19,193],[27,-79],[14,-14],[-3,38],[23,10],[7,17],[11,-28],[12,31],[15,0],[20,51]],[[26599,59546],[33,-4],[78,1],[5,-5],[157,-1],[61,3],[151,-2],[3,26],[77,-5],[-8,-28]],[[18139,65823],[61,-6],[262,13],[192,2],[5,-5],[196,3],[118,3]],[[18136,60011],[0,880],[1,11],[-1,272],[1,173],[-1,298],[1,318],[0,1661],[1,149],[0,628],[1,266],[0,1156]],[[28738,60998],[7,-15],[-7,-27],[0,42]],[[28949,61206],[-16,-79],[-15,-98],[-8,-27],[-5,21],[-15,-7],[-19,-78],[-12,-70],[-11,-126],[1,-64],[-23,-128],[7,-14],[-18,-91],[-12,-79],[-9,-11],[1,-57],[-11,-86],[-18,-64],[-16,2],[4,-35],[-9,-5],[-1,84],[-10,55],[-4,61],[2,70],[9,59],[3,89],[10,105],[4,76],[16,79],[18,110],[-4,34],[21,17],[15,65],[1,28],[-20,21],[25,54]],[[28739,61120],[-11,-44],[-3,44]],[[28423,61914],[-20,-21],[-13,21],[0,-52],[-18,-113],[-4,-52],[2,-76],[15,-59],[29,15],[6,26],[15,0],[12,38],[9,-30],[-6,-74],[19,-64],[0,-49],[35,-59],[25,-2],[7,-28],[6,21],[24,-9],[4,-44],[16,-39],[8,-59],[13,-15],[15,-54],[20,-23],[30,-68],[-5,-65],[-15,-24],[-2,-107],[4,-29],[-11,-46],[13,-23],[-19,-30],[-31,64],[-11,-27],[-7,25],[0,41],[-13,81],[-19,32],[-8,35],[-12,12],[-21,103],[-11,11],[-4,45],[-13,30],[-2,-30],[28,-89],[20,-114],[15,-24],[1,-25],[16,-14],[10,-96],[11,-53],[30,-4],[7,-36],[31,-24],[-14,-29],[-1,-37],[13,-8],[4,22],[8,-41],[5,-110],[-8,-90],[-18,63],[-21,45],[-9,-42],[11,-39],[7,-55],[9,-14],[-22,-24],[-18,-4],[6,-39],[22,11],[-2,-76],[14,12],[4,-31],[12,-20],[6,-49],[-9,-97],[-4,15],[-16,-18],[-15,-34],[-10,68],[-29,61],[-14,45],[4,48],[-13,71],[-22,-9],[-8,-25],[-10,46],[-18,11],[-4,23],[-21,-35],[11,-33],[12,8],[18,-13],[15,-55],[9,-2],[8,58],[8,-119],[1,-67],[22,-19],[25,-82],[1,-65],[27,4],[9,27],[1,-33],[9,-11],[-3,86],[17,6],[13,-29],[35,-36],[17,27],[11,-11],[8,-128],[12,-140],[9,-71],[7,-94]],[[15775,72069],[4,105],[10,72],[12,-52],[-2,-58],[19,-32],[-18,-27],[-5,-26],[-18,-12],[-2,30]],[[15740,73454],[0,40],[20,-41],[-17,-26],[-3,27]],[[15720,73667],[6,14],[26,-115],[-18,42],[-14,59]],[[15715,73495],[8,29],[12,-47],[-15,-33],[-5,51]],[[15707,73080],[13,89],[14,59],[2,55],[16,11],[7,-19],[0,-49],[19,-38],[3,-26],[-15,-19],[-17,15],[-1,-29],[-13,-34],[-14,-7],[3,-24],[23,10],[11,-42],[8,-84],[-4,-14],[10,-100],[8,27],[-5,67],[10,-3],[16,-57],[16,-13],[7,-94],[-8,-58],[-14,13],[-12,86],[-21,-25],[2,30],[-19,44],[3,93],[-5,56],[-18,-4],[-3,30],[-22,54]],[[15649,73739],[11,-4],[34,-53],[-8,-8],[-22,20],[-15,45]],[[15623,73630],[17,26],[2,-33],[-19,7]],[[15618,73982],[15,0],[4,-29],[-17,-2],[-2,31]],[[15586,73509],[7,30],[20,1],[2,-29],[15,-33],[17,-9],[-18,69],[37,108],[12,-2],[37,-58],[-19,-50],[11,-66],[-2,-62],[-11,-25],[4,-69],[-20,-12],[-15,50],[-9,-12],[-22,11],[-31,62],[-6,76],[-9,20]],[[15577,73617],[18,-10],[18,-54],[-30,41],[-6,23]],[[17306,73978],[-1,-290],[0,-441],[-2,-286],[0,-702],[1,-52],[0,-1247],[-7,-48],[20,-76],[8,-54],[0,-63],[12,-40],[-17,-93],[7,-11],[11,-93]],[[15490,70789],[-34,9],[-3,34],[-12,6],[-10,-31],[-13,10],[-19,-51],[-9,7],[-21,74],[-10,8],[-7,-47],[-10,-10],[6,139],[1,124],[-4,165],[13,-61],[-2,-100],[4,-137],[17,0],[1,37],[-10,40],[0,61],[12,-37],[14,83],[-19,116],[11,42],[25,53],[-17,37],[-6,-27],[-18,-2],[4,-23],[-16,4],[-20,44],[-1,55],[-11,130],[8,8],[6,-52],[11,31],[52,63],[-10,27],[-34,23],[-2,45],[-27,14],[-8,-24],[8,-90],[-16,-21],[3,38],[-4,206],[-14,176],[-24,80],[-9,207],[-5,77],[-15,162],[-14,36],[-4,55],[-14,23],[-5,31],[-19,29],[-12,110],[-8,101],[1,53],[-11,56],[12,58],[9,138],[-19,46],[3,22],[17,1],[40,-55],[32,-64],[10,-1],[25,-39],[6,12],[41,-55],[-1,-20],[35,-41],[56,-11],[21,13],[31,-37],[9,19],[10,-18],[24,7],[12,-32],[41,2],[32,71],[-3,-24],[22,-42],[7,-45],[17,17],[17,-5],[-3,-32],[14,-20],[1,-59],[10,6],[3,53],[-14,34],[0,40],[12,28],[21,10],[3,-31],[-15,-34],[10,-50],[7,6],[2,48],[10,14],[8,-100],[-15,-10],[11,-42],[8,-78],[13,-21],[-8,-25],[-16,2],[2,-42],[-17,-36],[-9,-113],[-14,-9],[11,113],[-6,17],[-19,-101],[-4,-53],[-21,-70],[-38,-183],[-13,-119],[12,8],[23,-13],[12,27],[21,17],[3,38],[-44,-62],[-17,27],[42,226],[31,74],[29,28],[3,73],[16,73],[31,68],[-9,97],[22,-40],[14,-187],[-22,0],[3,-40],[11,-14],[-4,-56],[7,-19],[0,-53],[-14,-38],[-1,-38],[15,-16],[-10,-48],[-6,-87],[4,-21],[-10,-57],[7,-49],[-15,-79],[-27,78],[8,96],[-16,-42],[-6,-63],[30,-83],[-10,-16],[1,-48],[-11,-26],[-16,46],[-20,105],[12,37],[1,61],[-7,25],[0,-51],[-12,-57],[7,-72],[-6,-48],[13,14],[11,-66],[27,-22],[11,37],[0,33],[13,16],[8,79],[10,53],[-2,30],[25,-58],[10,25],[-4,36],[27,34],[0,50],[-8,58],[-8,11],[6,35],[-10,40],[-7,71],[22,38],[-24,58],[16,82],[-6,91],[15,46],[9,119],[22,25],[-1,69],[-14,23],[-23,86],[1,74],[-10,49],[-15,4],[3,-24],[-11,-28],[10,-67],[18,-50],[1,-35],[-26,85],[-12,4],[-7,58],[2,77],[18,24],[16,-22],[10,42],[-10,45],[-28,45],[-13,48],[1,39],[-29,-33],[-7,33],[4,45],[-13,-17],[3,39],[24,28],[13,-15],[9,-49],[19,7],[-10,108],[17,6],[5,34],[-21,66],[-5,66],[8,44],[-13,30],[-17,-6],[-11,-41],[9,-44],[-19,40],[8,57],[-10,25],[-9,-14],[-1,65],[-21,54],[11,21],[-5,36],[-13,16],[16,54],[184,0],[97,-6],[145,5],[143,-2],[190,0],[169,0],[165,1],[178,0],[325,-2]],[[25685,69733],[6,80],[31,-17],[-23,-128],[-14,65]],[[25568,69555],[12,14],[2,-63],[-14,23],[0,26]],[[24707,71654],[8,83],[12,4],[-5,-75],[-15,-12]],[[24691,71507],[21,33],[-14,-47],[-7,14]],[[24655,71564],[5,21],[30,29],[5,-13],[-11,-48],[-24,-11],[-5,22]],[[24625,71464],[3,27],[20,41],[1,-19],[-24,-49]],[[24631,71609],[14,-54],[-13,-3],[-8,37],[7,20]],[[24621,71679],[35,36],[11,-55],[14,34],[2,-44],[-16,-9],[-17,-49],[-11,42],[-16,20],[-2,25]],[[24616,71401],[17,18],[32,86],[14,-32],[-30,-33],[5,-35],[-17,-4],[-20,-37],[-1,37]],[[24563,71635],[15,17],[-1,-44],[-14,27]],[[24276,71309],[20,-30],[34,11],[49,52],[19,27],[18,0],[48,70],[25,27],[6,26],[17,-22],[7,33],[25,10],[22,70],[14,-12],[14,35],[10,-4],[24,-81],[-14,-76],[-24,-78],[9,-73],[-16,-35],[-11,-77],[13,-16],[42,73],[5,54],[42,-108],[13,-22],[9,10],[25,-27]],[[25508,69434],[-10,-58],[-1,-80],[-37,-13],[-21,-40],[3,-47],[-11,-59],[-9,-15],[-11,-83],[-12,-42],[-7,-104],[3,-25],[-13,-50],[20,-42],[12,7],[7,53],[26,64],[10,3],[15,63],[0,36],[31,133],[26,36],[11,-7],[11,34],[15,-32],[-6,46],[12,97],[27,109],[7,100],[12,-5],[21,32],[1,59],[17,60],[22,-3],[-2,-87],[-16,-5],[-2,-142],[-12,-40],[-8,4],[-5,-53],[-14,-52],[5,-43],[-13,-39],[4,-26],[-18,-33],[-13,-62],[-8,-87],[-17,-107],[-9,-26],[-9,-62],[-21,-268],[9,-94],[-2,-71],[-12,-41],[-23,-46],[-3,-62],[-8,-37],[-14,-162],[2,-82],[8,-50],[-2,-102],[-21,-118],[-7,-136],[-20,-107],[-9,-156],[8,-76],[-5,-38],[8,-85],[-7,-57],[14,-62],[0,-85],[6,-63],[16,-59],[-4,-89],[-11,-107],[6,-145]],[[2682,386],[26,11],[1,-51],[-9,8],[-8,-28],[-10,60]],[[2636,452],[21,8],[-4,-21],[-13,-12],[-4,25]],[[2313,271],[13,35],[16,2],[19,68],[4,-20],[27,2],[4,-44],[-7,13],[-29,-30],[-23,-89],[-11,47],[-13,16]],[[90204,32599],[5,15],[34,16],[21,137],[6,65],[7,-11],[7,-43],[14,-11],[-10,-88],[-32,-109],[-9,-44],[-2,-111],[-12,-56],[-18,30],[-7,101],[8,50],[-12,59]],[[90597,35570],[10,43],[4,-16],[-8,-45],[-6,18]],[[90537,37432],[5,20],[1,-49],[-6,29]],[[90507,37973],[14,53],[0,59],[11,0],[0,-66],[-9,-13],[-10,-55],[-6,22]],[[90501,34555],[4,28],[2,101],[9,-12],[20,67],[5,-22],[-14,-80],[4,-63],[-13,7],[0,-73],[-12,18],[-5,29]],[[90487,38800],[6,39],[11,-28],[-1,-51],[-8,-23],[-7,25],[-1,38]],[[90486,35993],[20,2],[3,-36],[-19,-8],[-4,42]],[[90472,34420],[4,45],[13,54],[5,-54],[-4,-24],[7,-40],[-2,-61],[-9,-29],[-14,109]],[[90343,33382],[11,51],[21,35],[15,-9],[-2,-35],[-12,-13],[-8,-39],[-11,-6],[-5,23],[-9,-7]],[[28030,56345],[-13,-8],[-36,-51],[-27,-66],[-35,-121],[-18,-79],[-7,-45],[-16,-58],[-14,-93],[-13,-174],[3,-55],[-7,-48],[-14,-47],[-23,-41],[-9,-97],[-17,10],[-17,-16],[-11,39],[-16,-33],[-10,-63],[3,-31],[8,10],[0,-33],[-15,-20],[-18,-45],[-9,-52],[-34,-59],[-10,38],[-11,-7],[-1,-32],[17,-22],[-5,-59],[-25,-52],[-7,-40],[-10,5],[-24,-22],[-17,-59],[-6,18],[-36,-90],[-8,21],[-15,-28],[-2,30],[-13,-1],[-4,-42],[15,-83],[-7,-74],[-32,-62],[-19,-20],[-2,41],[-19,40],[-11,-22],[-2,-31],[12,-15],[14,-59],[-15,-65],[-25,-59],[-9,0],[-17,-67],[5,-21]],[[31708,38299],[11,-21],[12,13],[9,-36],[-17,-36],[-12,19],[-3,61]],[[31642,38028],[49,54],[35,-32],[-18,-26],[-21,-7],[-11,-24],[-8,12],[-17,-17],[-9,40]],[[31637,38350],[7,-14],[0,-44],[-7,58]],[[31170,38320],[15,18],[17,49],[-4,63],[7,32],[14,12],[20,-6],[17,-25],[50,2],[20,-22],[24,26],[18,-5],[25,-25],[8,20],[28,0],[27,-20],[16,1],[7,-19],[6,24],[37,-35],[4,19],[18,-18],[6,7],[31,-33],[14,-49],[7,13],[5,-27],[10,-6],[14,22],[-5,-40],[3,-84],[13,-30],[-7,-43],[-11,19],[3,-28],[-10,2],[-7,-32],[-13,1],[-11,-59],[-7,-83],[-8,-6],[-1,-44],[-25,-46],[-15,-9],[-12,12],[-7,-27],[-10,13],[-21,-43],[-10,9],[-9,-29],[-8,9],[-18,66],[-12,-10],[-7,-34],[-21,60],[-8,0],[-25,-33],[-14,24],[-12,-19],[-25,47],[-7,-39],[-14,-27],[-21,-3],[-12,-18],[-8,41],[-21,8],[-11,-32],[-19,19],[-12,-12],[1,53],[10,31],[-11,12],[3,65],[5,15],[1,75],[7,31],[-10,101],[-13,21],[-9,78]],[[30985,38023],[20,12],[5,-43],[-15,-38],[-12,32],[2,37]],[[31858,38286],[13,39],[11,-4],[15,-28],[-13,-4],[1,-49],[-9,20],[-13,-5],[-5,31]],[[31828,37522],[7,36],[-4,40],[7,30],[10,-13],[8,22],[17,3],[6,-29],[39,5],[2,-18],[-32,-48],[-41,-30],[-19,2]],[[31779,38288],[6,50],[10,-23],[12,26],[19,-21],[33,6],[-2,-23],[-14,-4],[9,-42],[-16,-11],[-15,23],[-7,-20],[-12,49],[-23,-10]],[[17306,73978],[171,1],[103,1]],[[18139,65823],[-119,3],[-36,-2],[-58,9],[-63,-7],[-79,0],[-293,0],[-184,5]],[[29478,69336],[71,5],[115,0],[40,-9],[62,-5],[57,2],[168,10]],[[25149,51924],[13,-63],[5,-76],[-3,-101],[-10,-105],[-4,3],[8,90],[4,100],[-1,46],[-12,106]],[[25020,51931],[11,38],[32,81],[2,-14],[-13,-63],[2,-28],[13,-33],[-15,-50],[-3,47],[-10,-10],[-17,10],[-2,22]],[[24941,51321],[17,10],[-9,-42],[-8,32]],[[24732,50824],[7,27],[13,-65],[-8,-14],[-12,52]],[[24681,50807],[39,-33],[-19,-8],[-20,41]],[[24628,50763],[25,19],[2,-17],[-26,-20],[-1,18]],[[24275,51386],[10,27],[12,-5],[3,26],[22,-6],[23,-61],[9,7],[6,-29],[-15,-36],[-1,-40],[-14,-19],[-59,115],[4,21]],[[24969,52072],[-17,-35],[-8,7],[-17,-56],[-2,-38],[-12,-15],[3,-40],[-28,17],[-11,-45],[5,-68],[18,-10],[13,25],[-4,-59],[8,-34],[15,-19],[13,11],[6,29],[5,101],[-2,13],[24,54],[3,44],[18,-34],[13,6],[0,-21],[-17,-34],[0,-34],[15,-17],[3,-61],[15,14],[11,82],[16,-25],[-4,-55],[-13,0],[-12,-44],[22,2],[-3,-29],[-31,-22],[13,-66],[11,22],[-7,-59],[-9,26],[-14,11],[-12,-55],[-1,-99],[-9,-5],[-6,86],[-11,1],[-2,-66],[13,-58],[-13,33],[-14,5],[-8,-17],[-15,6],[18,-39],[0,-32],[-23,49],[0,-25],[12,-32],[-12,-14],[1,-34],[11,-36],[20,-11],[-1,-22],[12,-24],[-1,-34],[7,-46],[9,30],[5,-21],[22,-2],[16,-34],[3,30],[20,-91],[11,44],[24,-111],[0,-59],[6,-13],[18,28],[7,-41],[-24,-15],[-2,-33],[16,-3],[-8,-52],[-11,24],[-12,-96],[2,-44],[-21,36],[-2,55],[-8,16],[-31,-138],[-15,-41],[7,67],[9,29],[5,48],[9,21],[0,54],[9,23],[-1,51],[-10,24],[-4,-62],[-16,-29],[-12,29],[-14,77],[-34,43],[-10,45],[-56,33],[-12,-14],[-48,-143],[-46,-115],[-7,10],[4,41],[-12,16],[-2,41],[6,3],[-12,100],[-11,27],[-9,-1],[1,-28],[-8,-36],[2,76],[-10,56],[-13,-64],[-14,14],[-7,-22],[-7,31],[-6,-27],[10,-63],[-12,4],[-7,-27],[-4,-54],[-8,7],[-5,-57],[-8,12],[-19,-33],[-6,-76],[-16,16],[5,21],[-13,67],[-18,57],[-11,-13],[-26,21],[-10,33],[-25,12],[-16,25],[-16,60],[12,14],[7,58],[8,-12],[12,-52],[7,22],[-1,-68],[15,-17],[-4,104],[-23,64],[0,42],[-11,7],[-9,-41],[-13,-13],[2,41],[-10,-7],[3,39],[9,28],[-10,40],[-29,-50],[-10,80],[-10,-8],[-6,118],[-26,1],[6,33],[1,85],[-32,16],[-13,-10],[-20,-38],[-7,57],[8,41],[8,-3],[-2,46],[-16,8],[-14,-22],[-9,20],[-2,-40],[-24,-36],[-14,-34],[-6,32],[-18,-16],[0,-32],[9,-30],[18,-8],[-9,-30],[8,-63],[20,21],[5,-18],[-13,-14],[6,-20],[-32,-6],[-26,-49],[-20,-9],[-82,63],[-35,42],[-57,101],[-23,32],[-41,40],[-33,5],[-14,-14],[-36,7],[-58,-25],[-17,-13],[-26,-53]],[[30097,65246],[-20,-46],[-6,102],[2,64],[-10,22],[2,-159],[-17,2],[-2,-35],[-10,-7],[-1,55],[16,95],[8,68],[17,46]],[[30029,65436],[5,7],[11,-52],[-5,-7],[-11,52]],[[30019,65203],[6,51],[-4,23],[5,57],[4,-20],[0,-85],[-11,-26]],[[29960,64853],[11,80],[5,-14],[1,-76],[-17,10]],[[30068,65494],[-3,-45],[-14,-41],[-6,42],[4,35],[-19,54],[-8,40],[5,-129],[-22,17],[12,-39],[1,-75],[-12,-11],[8,-53],[0,-72],[-10,-45],[-8,-73],[-12,6],[-27,-18],[-27,-34],[-38,-30],[-1,16]]]}')},function(t,e,n){"use strict";n.r(e),n.d(e,"default",(function(){return r}));class r{constructor(t=[],e=i){if(this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(let t=(this.length>>1)-1;t>=0;t--)this._down(t)}push(t){this.data.push(t),this.length++,this._up(this.length-1)}pop(){if(0===this.length)return;const t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}peek(){return this.data[0]}_up(t){const{data:e,compare:n}=this,r=e[t];for(;t>0;){const i=t-1>>1,o=e[i];if(n(r,o)>=0)break;e[t]=o,t=i}e[t]=r}_down(t){const{data:e,compare:n}=this,r=this.length>>1,i=e[t];for(;t<r;){let r=1+(t<<1),o=e[r];const a=r+1;if(a<this.length&&n(e[a],o)<0&&(r=a,o=e[a]),n(o,i)>=0)break;e[t]=o,t=r}e[t]=i}}function i(t,e){return t<e?-1:t>e?1:0}},function(t,e){t.exports=function(t){return-1!==Function.toString.call(t).indexOf("[native code]")},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){var r=n(25),i=n(91);function o(e,n,a){return i()?(t.exports=o=Reflect.construct,t.exports.default=t.exports,t.exports.__esModule=!0):(t.exports=o=function(t,e,n){var i=[null];i.push.apply(i,e);var o=new(Function.bind.apply(t,i));return n&&r(o,n.prototype),o},t.exports.default=t.exports,t.exports.__esModule=!0),o.apply(null,arguments)}t.exports=o,t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e){t.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}},t.exports.default=t.exports,t.exports.__esModule=!0},function(t,e,n){"use strict";n.r(e),n.d(e,"Chart",(function(){return Dp})),n.d(e,"ChartModel",(function(){return Ip})),n.d(e,"Cartogram",(function(){return Hd})),n.d(e,"SourcesAndFootnotes",(function(){return en})),n.d(e,"VALUE_FORMATS",(function(){return $})),n.d(e,"TOOLTIP_FORMATS",(function(){return tt}));var r=n(8),i=n.n(r),o=n(11),a=n.n(o),s=n(12),c=n.n(s),l=n(4),u=n.n(l),d=n(1),f=n.n(d),h=n(15),p=n.n(h),g={PerCapita:"Adjusted per capita",Inflation:"Adjusted for inflation"},m={LineChart:0,Map:1,DotPlot:2,BarChart:3,SmallMultiples:4,BubbleChart:5,Sankey:6,IncomeDistribution:7,TimeBarChart:9,Beeswarm:10,MosaicPlot:11,SankeyVertical:12,SOTU2021Education:13,GroupedBars:14,LineChartReactMigration:100,MapReactMigration:101,DotPlotReactMigration:102,BarChartReactMigration:103,LineChartReact:200,MapReact:201,DotPlotReact:202,BarChartReact:203,TimeSeriesBarChart:209,CartogramReact:215},y={US:"United States","01":"Alabama","02":"Alaska","04":"Arizona","05":"Arkansas","06":"California","08":"Colorado","09":"Connecticut",10:"Delaware",11:"District of Columbia",12:"Florida",13:"Georgia",15:"Hawaii",16:"Idaho",17:"Illinois",18:"Indiana",19:"Iowa",20:"Kansas",21:"Kentucky",22:"Louisiana",23:"Maine",24:"Maryland",25:"Massachusetts",26:"Michigan",27:"Minnesota",28:"Mississippi",29:"Missouri",30:"Montana",31:"Nebraska",32:"Nevada",33:"New Hampshire",34:"New Jersey",35:"New Mexico",36:"New York",37:"North Carolina",38:"North Dakota",39:"Ohio",40:"Oklahoma",41:"Oregon",42:"Pennsylvania",44:"Rhode Island",45:"South Carolina",46:"South Dakota",47:"Tennessee",48:"Texas",49:"Utah",50:"Vermont",51:"Virginia",53:"Washington",54:"West Virginia",55:"Wisconsin",56:"Wyoming"},v={"United States":"US",Alabama:"AL",Alaska:"AK",Arkansas:"AR",Arizona:"AZ",California:"CA",Colorado:"CO",Connecticut:"CT","District of Columbia":"DC",Delaware:"DE",Florida:"FL",Georgia:"GA",Hawaii:"HI",Iowa:"IA",Idaho:"ID",Illinois:"IL",Indiana:"IN",Kansas:"KS",Kentucky:"KY",Louisiana:"LA",Massachusetts:"MA",Maryland:"MD",Maine:"ME",Michigan:"MI",Minnesota:"MN",Missouri:"MO",Mississippi:"MS",Montana:"MT","North Carolina":"NC","North Dakota":"ND",Nebraska:"NE","New Hampshire":"NH","New Jersey":"NJ","New Mexico":"NM",Nevada:"NV","New York":"NY",Ohio:"OH",Oklahoma:"OK",Oregon:"OR",Pennsylvania:"PA","Rhode Island":"RI","South Carolina":"SC","South Dakota":"SD",Tennessee:"TN",Texas:"TX",Utah:"UT",Virginia:"VA",Vermont:"VT",Washington:"WA",Wisconsin:"WI","West Virginia":"WV",Wyoming:"WY"},b={sequentialYellowGreen:["#E6F1A3","#8DDEAA","#42C4A2","#109D7B","#007358","#004837"],sequentialMagentaPurple:["#E8D7FA","#E39DDC","#DE5BBA","#BB1C91","#6F1B7C","#091A60"],sequentialYellowBlue:["#E0EB9D","#67D7B5","#00B5DA","#067EC2","#004288","#05074B"],sequentialPurpleGreen:["#A5C8FF","#56C3EA","#04B8BC","#00909A","#004D7C","#02093C"],divergingYellowGreen:["#CC6A19","#D99522","#E5BD3F","#F2E289","#97DFC7","#65C2A5","#00664E","#012B2D"],divergingPurpleGreen:["#461B71","#7E589F","#B697CE","#F0DBFF","#97DFC7","#65C2A5","#00664E","#012B2D"],divergingMagentaBlue:["#A7004C","#F2618B","#F1D1DA","#B8DAEB","#1E8CC8","#043D70"]},k=n(14),w=n.n(k),x=n(6),A=n.n(x),S=n(10),O=n.n(S),E=n(7),M=n.n(E),C=n(5),R=n(17);function j(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function I(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?j(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):j(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var B,D,T=function(){function t(e,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"title",i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];a()(this,t),this.margins=I({left:0,right:0,top:0,bottom:0},i);var s=e.node().offsetWidth;this.container=n,this.grandparent=e,this.parent=e.append("div").classed("info-wrapper",!0).classed("chart-info","chart"===r),this.parent.append("div").classed("info-icon",!0).classed("footnote",o),this.tooltip=this.parent.append("div").classed("info-tooltip",!0).style("max-width","".concat(s,"px"));var c=this.tooltip.append("div").classed("info-content",!0);c.append("div").classed("info-title",!0),c.append("div").classed("info-body",!0);var l="0px";"chart"===r&&(l="-12px"),this.parent.style("margin-left","calc(".concat(this.margins.left," + ").concat(l,")")).style("margin-right","calc(".concat(this.margins.right)).style("margin-top","calc(".concat(this.margins.top," + ").concat(l,")")).style("margin-bottom","calc(".concat(this.margins.bottom,")"))}return c()(t,[{key:"onHover",value:function(t){var e=this,n=t.title,r=t.content;return this.parent.on("mousemove",(function(){e.draw({title:n,content:r})})).on("mouseout",(function(){e.hide()}))}},{key:"draw",value:function(t){var e=t.title,n=t.content,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:4,i=this.parent.select(".info-icon").node().getBoundingClientRect(),o=this.tooltip.node().getBoundingClientRect(),a=this.container.node().getBoundingClientRect(),s=i.width,c=-o.height-i.height-r;i.top+c<a.top&&(c=r),this.tooltip.style("transform","translate(".concat(s,"px, ").concat(c,"px)")),this.container.select("div.info-content").style("transform","translateX(".concat(Math.min(0,a.right-o.right),"px)")),this.tooltip.select("div.info-title").text(e),this.tooltip.select("div.info-body").text(n),this.show()}},{key:"show",value:function(){this.tooltip.classed("show",!0),this.grandparent.style("z-index",2)}},{key:"hide",value:function(){this.tooltip.classed("show",!1),this.grandparent.style("z-index",1)}}],[{key:"inChart",value:function(e,n){var r=n.info;e.select(".info-wrapper").empty()&&new t(e,e,"chart",{left:"98%",top:"2%"},r.isFootnote).onHover(r)}}]),t}(),F=n(24),P=n.n(F),z=n(18),Q=n.n(z),L=n(25),Y=n.n(L);function W(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function q(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?W(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):W(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function N(){N=function(t,e){return new n(t,void 0,e)};var t=RegExp.prototype,e=new WeakMap;function n(t,r,i){var o=new RegExp(t,r);return e.set(o,i||e.get(t)),Y()(o,n.prototype)}function r(t,n){var r=e.get(n);return Object.keys(r).reduce((function(e,n){return e[n]=t[r[n]],e}),Object.create(null))}return Q()(n,RegExp),n.prototype.exec=function(e){var n=t.exec.call(this,e);return n&&(n.groups=r(n,this)),n},n.prototype[Symbol.replace]=function(n,i){if("string"==typeof i){var o=e.get(this);return t[Symbol.replace].call(this,n,i.replace(/\$<([^>]+)>/g,(function(t,e){return"$"+o[e]})))}if("function"==typeof i){var a=this;return t[Symbol.replace].call(this,n,(function(){var t=arguments;return"object"!==P()(t[t.length-1])&&(t=[].slice.call(t)).push(r(t,a)),i.apply(this,t)}))}return t[Symbol.replace].call(this,n,i)},N.apply(this,arguments)}var G=(B={},A()(B,void 0,{long:"",short:""}),A()(B,"k",{long:" thousand",short:"K"}),A()(B,"M",{long:" million",short:"M"}),A()(B,"G",{long:" billion",short:"B"}),A()(B,"T",{long:" trillion",short:"T"}),A()(B,"P",{long:" quadrillion",short:"Q"}),B),J=function(t){var e=Math.abs(t);return Number.isInteger(e)?0:e<.01?function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return 0===Number(t)?0:String(t).match(N(/\.(0+)/,{zeros:1})).groups.zeros.length+e}(e,2):e<1?2:1},U=function(t){var e=Math.abs(10*t);return e<.1?2:e<1?1:e>=1?0:1},K=(D={},A()(D,void 0,J),A()(D,"percent",U),A()(D,"dollars",(function(t){var e=Math.abs(t);return Number.isInteger(e)?0:e<100?2:J(e)})),D),H=function(t){for(var e=Math.abs(t),n=0,r=t<0?-1:1;e>=1e3;)e/=1e3,n+=1;return{value:r*e,divides:n}},V=function(t,e){if(Object.prototype.hasOwnProperty.call(t,"decimals"))return{decimals:t.decimals,divides:null};if(!t.ticks)return{decimals:null,divides:0};var n=function(t){for(var e=t,n=0;e.some((function(t){return Math.abs(t)>=1e3}));)e=e.map((function(t){return Math.abs(t)/1e3})),n+=1;return{ticks:e,divides:n}}(t.ticks),r=n.ticks,i=n.divides,o="percent"===e?r.map((function(t){return 100*t})):r,a=0,s=Math.abs(o[1]-o[0]);if(s<1&&(a="dollars"===e?2:1),s<.1&&(a=2),s<.01)if(t.autoSmallDecimals){var c=function(t){for(var e=t.map((function(t){return{number:t.toPrecision(12).split(".")[1],sign:Math.sign(t)<0?"-":""}})),n=1,r=[];r.length!==t.length;){if((n+=1)>12)return null;r=f.a.uniqBy(e,(function(t){var e=t.number,r=t.sign;return"".concat(r).concat(e.slice(0,n))}))}return n}(r);Number.isFinite(c)&&(a=c,"percent"===e&&(a-=2))}else a=Math.max.apply(Math,O()(o.map((function(t){var e=t.toPrecision(12).match(/\..*/);return e?e[0].replace(/0+$/,"").length-1:0}))));return 0===s&&(a=2),{decimals:a,divides:i}},Z=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=C.format("s")(t*e).match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+)?|\.[0-9]+/g);return Math.abs(t)>1?n[1]:void 0},X=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.suffixLength,r=e.type,i=e.truncate,o=H(t).value;if(!i){if(Math.abs(t)<1e3){var a=K[r](o);return t.toFixed(a)}return C.format(",d")(Math.round(t))}if(e.ticks&&0===t)return 0;var s=V(e,r),c=s.decimals,l=s.divides;null===l&&(l=H(t).divides);var u=1;if(null===c)c=K[r](o);else{var d=t/Math.pow(1e3,l);u=o/d,o=d}var f=Z(t,u);return"".concat(o.toFixed(c)).concat(G[f][n||"short"])},_=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.values,r=void 0===n?[t]:n,i=e.type,o=void 0===i?"":i,a=f.a.some(r,(function(t){return Math.abs(t.value)<1e3})),s=C.formatLocale({minus:"-",currency:["$",""]}),c=s.format(",.2f");return"percent"===o.toLowerCase()?"".concat(parseFloat(c(100*t)),"%"):"dollars"===o.toLowerCase()?a&&Math.abs(t)<1e4?s.format("$")(c(t)):"".concat(s.format("$")(parseFloat(c(H(t).value)))).concat(G[Z(t)].short):a&&Math.abs(t)<1e4?parseFloat(c(t)):"".concat(parseFloat(c(H(t).value))).concat(G[Z(t)].short)},$={default:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return X(t,q({truncate:!0},e))},percent:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=V(e,"percent"),r=n.decimals;return null===r&&(r=U(t)),"".concat((100*(t+Number.EPSILON)).toFixed(r),"%")},dollars:function(t,e){return"".concat(t<0?"-":"","$").concat(X(Math.abs(t),q(q({truncate:!0},e),{},{type:"dollars"})))}},tt={default:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return X(t,q({truncate:!1},e))},percent:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=V(e,"percent"),r=n.decimals;null===r&&(r=2);var i=(100*(t+Number.EPSILON)).toFixed(r).replace(/(\..)0+$/,"$1");return"".concat(i.replace(/(\.[^0]*)0+$/,"$1").replace(/\.$/,""),"%")},dollars:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return"".concat(t<0?"-":"","$").concat(X(Math.abs(t),q(q({truncate:!1},e),{},{type:"dollars"})))}},et={chartcolourdefault0:"#e3007d",chartcolourdefault1:"#015193",chartcolourdefault2:"#00906e",chartcolourdefault3:"#249edc",chartcolourdefault4:"#082d51",chartcolourdefault5:"#960f5a",chartcolourdefault6:"#64c5ab",chartcolourdefault7:"#522882",chartcolourdefault8:"#004837",chartcolourdefault9:"#9c54cf",chartcolourdefault10:"#e1b128",chartcolourdefault11:"#d66c16",chartcolourgrey:"#999",chartcolourgreycartogram:"#ddd",chartcolourgreylight:"#d9d9d9",chartcolourdiverging0:"#5d2882",chartcolourdiverging1:"#9c54cf",chartcolourdiverging2:"#cba3e5",chartcolourdiverging3:"#e9f8fa",chartcolourdiverging4:"#52d1af",chartcolourdiverging5:"#00906e",chartcolourdiverging6:"#004837"},nt='"Source Sans Pro","system-ui","BlinkMacSystemFont","-apple-system","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","sans-serif"',rt="20px",it="1.25em",ot="#212121",at="#4d4d4d",st='"Noto Sans",sans-serif',ct="14px",lt="1.25em",ut="#4d4d4d",dt="#4d4d4d",ft="#e6e6e6",ht=["key"],pt=["key"];function gt(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function mt(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?gt(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):gt(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var yt=function(t,e){var n=e.labelTextMode;return n||(t.length<2?void 0:f.a.every(t,(function(e){return e.metric.geo_id===t[0].metric.geo_id}))?"metrics":f.a.every(t,(function(e){return e.metric.id===t[0].metric.id}))?"states":void 0)},vt=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return void 0===t.labelText||n?"states"===e?t.metric.geo_name:"metrics"===e?t.metric.name:t.metric.geo_name&&"US"!==t.metric.geo_id?t.metric.geo_name:t.metric.name:t.labelText},bt={jan:0,january:0,feb:1,february:1,mar:2,march:2,apr:3,april:3,may:4,jun:5,june:5,jul:6,july:6,aug:7,august:7,sep:8,september:8,oct:9,october:9,nov:10,november:10,dec:11,december:11,"01":0,"02":1,"03":2,"04":3,"05":4,"06":5,"07":6,"08":7,"09":8,10:9,11:10,12:11,q1:0,q2:3,q3:6,q4:9},kt={jan:"Q1",january:"Q1",feb:"Q1",february:"Q1",mar:"Q1",march:"Q1",apr:"Q2",april:"Q2",may:"Q2",jun:"Q2",june:"Q2",jul:"Q3",july:"Q3",aug:"Q3",august:"Q3",sep:"Q3",september:"Q3",oct:"Q4",october:"Q4",nov:"Q4",november:"Q4",dec:"Q4",december:"Q4"},wt=function(t){try{var e=new Date(Date.UTC(t,0));if("Invalid Date"!==e.toString())return e}catch(t){return!1}return!1},xt=function(t){try{var e=null,n=t.split(/[ -/]/),r=M()(n,2),i=r[0],o=r[1];if("Invalid Date"!==(e=void 0!==bt[i.toLowerCase()]?new Date(Date.UTC(o,bt[i.toLowerCase()])):void 0!==bt[o.toLowerCase()]?new Date(Date.UTC(i,bt[o.toLowerCase()])):new Date(Date.UTC(o,i))).toString())return e}catch(t){return!1}return!1},At=function(t){try{var e=null,n=t.split(/[ /-]/g),r=M()(n,3),i=r[0],o=r[1],a=r[2];if(void 0!==bt[i.toLowerCase()]){var s=Number.parseInt(o,10);e=new Date(Date.UTC(a,bt[i.toLowerCase()],s))}else{var c=Number.parseInt(a,10);e=void 0!==bt[o.toLowerCase()]?new Date(Date.UTC(i,bt[o.toLowerCase()],c)):new Date(Date.UTC(i,o,c))}if("Invalid Date"!==e.toString())return e}catch(t){return!1}return!1},St=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"years";if("items"===e.toLowerCase())return t;try{var n=null;if(n="months"===e.toLowerCase()||"monthly"===e.toLowerCase()||"quarters"===e.toLowerCase()||"quarterly"===e.toLowerCase()?xt(t):"days"===e.toLowerCase()||"daily"===e.toLowerCase()||"weeks"===e.toLowerCase()||"weekly"===e.toLowerCase()?At(t):new Date(Date.UTC(t,0)))return n}catch(e){var r=wt(t);if(r)return r;throw new Error("Date ".concat(t," is invalid"))}var i=wt(t);if(i)return i;throw new Error("Date ".concat(t," is invalid"))},Ot=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"years";if("items"===e.toLowerCase())return t;var n=t.toUTCString().split(" "),r=M()(n,4),i=r[1],o=r[2],a=r[3];return"months"===e.toLowerCase()||"months"===e.toLowerCase()?"".concat(o," ").concat(a):"quarters"===e.toLowerCase()||"quarterly"===e.toLowerCase()?"".concat(kt[o.toLowerCase()]," ").concat(a):"days"===e.toLowerCase()||"daily"===e.toLowerCase()||"weeks"===e.toLowerCase()||"weekly"===e.toLowerCase()?"".concat(o," ").concat(i.replace(/^0+/,""),", ").concat(a):a},Et=function(t,e){var n=t.node().getComputedTextLength(),r=t.text();n<=e||function t(e,n,r,i,o){var a=Math.floor((i+o)/2),s=n.slice(0,a);e.text("".concat(s,"..."));var c=e.node().getComputedTextLength();c===r||o-i<=1||(c>r?t(e,n,r,i,a):t(e,n,r,a,o))}(t,r,e,0,r.length-1)},Mt=function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:Object(R.createCanvas)(500,500),o=[],a=[],s=t.trim().split(" "),c=i.getContext("2d");c.font=n;for(var l=0,u=1;u<=s.length;u+=1){var d=s.slice(l,u).join(" "),f=c.measureText(d).width;if(f>e){var h=Math.max(u-1,l+1),p=s.slice(l,h).join(" ");if(o.push(p),o.length>=r){var g=s.slice(l,s.length).join(" ");return c.measureText(g).width>Math.max.apply(Math,O()(a.map((function(t){return t.width}))))?c.measureText("".concat(o[o.length-1],"...")).width<=e?o[o.length-1]="".concat(o[o.length-1],"..."):o[o.length-1]="".concat(s.slice(l,h-1).join(" "),"..."):o[o.length-1]=g,o}a.push(c.measureText(p)),l=h}}return o.push(s.slice(l,s.length).join(" ")),o},Ct=function(t){if(t.datasets){var e=t.datasets[0];e.id=t.id;var n=e.x_type||e.xType||e.xtype;return mt(mt({},t),{},{xType:n,yType:e.y_type||e.yType||e.ytype,geo_name:e.geo_name||e.geoName,geo_id:e.geo_id||e.geoId,data:f()(e.data).filter((function(t){return null!==t.value})).map((function(t){var e=t.key,r=w()(t,ht);return mt(mt({key:St(e,n)},r),{},{rawKey:e})})).sortBy("key").value()})}return mt(mt({},t),{},{yType:t.y_type||t.yType,xType:t.x_type||t.xType,data:f()(t.data).filter((function(t){return null!==t.value})).map((function(e){var n=e.key,r=w()(e,pt);return mt(mt({key:St(n,t.x_type||t.xType||t.xtype)},r),{},{rawKey:n})})).sortBy("key").value()})},Rt=function(t){if(t.metric&&t.metric.datasets){var e=!0===t.allStates&&t.states&&f.a.includes(f.a.map(t.states,"fips"),t.fips);return mt(mt({},t),{},{selectedState:e})}return t},jt=function(t){return Array.isArray(t)?t.map(Rt):Rt(t)},It=function(){var t=i()(u.a.mark((function t(e){var n;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(e){t.next=2;break}return t.abrupt("return",null);case 2:return t.prev=2,t.next=5,e;case 5:return n=t.sent,t.abrupt("return",jt(n));case 9:if(t.prev=9,t.t0=t.catch(2),"StoreError"!==t.t0.name){t.next=13;break}return t.abrupt("return",jt(t.t0));case 13:throw t.t0;case 14:case"end":return t.stop()}}),t,null,[[2,9]])})));return function(e){return t.apply(this,arguments)}}(),Bt=function(){var t=i()(u.a.mark((function t(e){var n;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(e){t.next=2;break}return t.abrupt("return",null);case 2:if(!Array.isArray(e)){t.next=7;break}return t.next=5,Promise.all(e);case 5:return n=t.sent,t.abrupt("return",n.map(jt));case 7:return t.t0=jt,t.next=10,e;case 10:return t.t1=t.sent,t.abrupt("return",(0,t.t0)(t.t1));case 12:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}(),Dt=function(t){return"".concat(t.metric.id).concat(t.fips?"-".concat(t.fips):"")},Tt=function(t){var e=Array.isArray(t)?t:[t],n=f()(e).map((function(t){var e;return null!=t&&null!==(e=t.metric)&&void 0!==e&&e.yType?String(t.metric.yType).toLowerCase():void 0})).uniq().compact().value();return 0===n.length?null:n.length>1?"default":n[0]},Ft=function(t){var e=t.data,n=t.parent,r=t.params.tooltipFormat||Tt(e)||(n?n.metric.yType:null)||"default";return tt[r.toLowerCase()]||tt.default},Pt=function(t){var e=t.data,n=t.parent,r=t.params.format||Tt(e)||(n?n.metric.yType:null)||"default";return $[r.toLowerCase()]||$.default},zt=function(t){var e=t.data,n=t.parent,r=t.options,i=(r=void 0===r?{}:r).title,o=r.subtitle,a=Array.isArray(e[0])?f.a.flatten(e)[0]:e[0],s="",c=null!=o?o:"";if(a){s=a.metric.name;var l=a.metric.current_adjustment;l&&g[l]&&(c=c?"".concat(c,", ").concat(g[l].toLowerCase()):g[l])}return n&&void 0!==n.metric.name&&(s=n.metric.name),void 0!==i&&(s=i),{title:s,subtitle:c}},Qt=function(t){var e=t.data,n=t.parent,r=t.options,i=r.title,o=r.subtitle,a=r.margins,s=r.format,c=r.titleVerticalPosition,l=void 0===c?"top":c,u=r.titleHorizontalAlignment,d=void 0===u?"left":u,f=r.fontSize,h=void 0===f?13:f,p=r.titleFontSize,g=void 0===p?parseFloat(rt):p,m=r.subtitleFontSize,y=void 0===m?parseFloat(ct):m,v=r.fontFamily,b=void 0===v?nt:v,k=r.info,w=r.startYear,x=r.endYear,A=r.startDate,S=r.endDate,O=r.selectedYear,E=r.selectedYear2,M=r.selectedDropdown,C=r.selectedDropdown2,R=r.forceYear,j=r.forceDropdown,I=r.chartFootnotes,B=r.hideMetricFootnotes,D=r.chartSources,T=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return mt(mt({margins:mt(mt({},T),a)},zt({data:e,parent:n,options:{title:i,subtitle:o}})),{},{format:s,titleVerticalPosition:l,titleHorizontalAlignment:d,fontSize:h,titleFontSize:g,subtitleFontSize:y,fontFamily:b,info:k,startDate:A||w,endDate:S||x,selectedYear:O,selectedYear2:E,forceYear:R,selectedDropdown:M,selectedDropdown2:C,forceDropdown:j,chartFootnotes:I,hideMetricFootnotes:B,chartSources:D})},Lt=function(t,e,n){if(t.primaryColor)return t.primaryColor;if(n.primaryColor)return n.primaryColor;var r=Object.keys(et).filter((function(t){return t.startsWith("chartcolourdefault")}));return null!==t.colorIndex&&void 0!==t.colorIndex?et["chartcolourdefault".concat(t.colorIndex%r.length)]:et["chartcolourdefault".concat(e%r.length)]},Yt=function(t,e){var n=t.primaryColor;return e&&e.primaryColor?e.primaryColor:n||et.chartcolourdefault0},Wt=function(t,e){var n=t.secondaryColor;return e&&e.secondaryColor?e.secondaryColor:n||et.chartcolourgrey},qt=function(t,e,n){var r=t.append("div").classed(n,!0).classed("drop-down-wrapper",!0);return r.append("select").classed("chart-dropdown",!0).selectAll("option").data(e).enter().append("option").attr("value",(function(t){return t})).text((function(t){return t})),r},Nt=function(t,e,n,r,i){var o=this,a=n.params,s=n.years,c=n.keys,l=a.title,u=a.subtitle,d=a.selectableYears,f=void 0===d||d,h=a.selectableDropdowns,p=void 0===h||h,g=a.titleHorizontalAlignment,m=void 0===g?"left":g,y=a.margins,v=a.info,b=void 0===v?{}:v;t.style("font-size","".concat(a.titleFontSize,"px")).style("z-index",1).text("".concat(l," ")),e.style("font-size","".concat(a.subtitleFontSize,"px")).style("z-index",1).text(u),"center"===m.toLowerCase()||"centre"===m.toLowerCase()?(t.style("text-align","center").style("margin-left",null),e.style("text-align","center").style("margin-left",null),this.isSubchart&&t.style("width",this.width)):(t.style("text-align",null).style("margin-left","".concat(y.left,"px")),e.style("text-align",null).style("margin-left","".concat(y.left,"px")));var k,w=Yt(a);if(void 0!==i&&(k=w,w=Wt(a)),f&&p){var x=t.select(".year-left"),A=t.select(".year-right");r&&(x.empty()&&(x=qt(t,s||c,"year-left")),x.style("color",w).select("select").property("value",r).on("change",(function(t){var e=t.currentTarget;o.setDropdownSelected&&o.setDropdownSelected(e.value,0),o.redrawContent()}))),i&&(A.empty()&&(t.append("span").classed("chart-title-vs",!0).html("&nbsp;vs&nbsp;"),A=qt(t,s||c,"year-right not-first")),A.style("color",k).select("select").property("value",i).on("change",(function(t){var e=t.currentTarget;o.setDropdownSelected&&o.setDropdownSelected(e.value,1),o.redrawContent()})))}else{var S=[];r&&S.push({text:"&nbsp;".concat(r),color:w,class:"year-left"}),i&&(S.push({text:"&nbsp;vs",color:null,class:"chart-title-vs"}),S.push({text:"&nbsp;".concat(i),color:k,class:"year-right"})),t.selectAll("span").data(S).join("span").attr("class",(function(t){return t.class})).style("color",(function(t){return t.color})).html((function(t){return t.text}))}"title"===b.position&&new T(t,C.select(t.node().parentNode),b.position,{},b.isFootnote).onHover(b)},Gt=function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"years",i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:Dt,o=t.map((function(t){return(Array.isArray(t)?t.flatMap((function(t){return t.metric.data})):t.metric.data).map((function(e){var n=Array.isArray(t)?t[0]:t;return mt(mt({},e),{},{dataset:i(n),metric:n})})).filter((function(t){return null!==t.value}))}));if("items"!==r.toLowerCase()){var a=e?St(e,r):new Date(0),s=n?St(n,r):new Date,c=o.map((function(t){return t.filter((function(t){return!(null!=e&&!Number.isNaN(a.getTime())&&t.key<a)&&!(null!=n&&!Number.isNaN(s.getTime())&&t.key>s)})).map((function(e,n){return mt(mt({},e),{},{fromEnd:t.length-n-1})}))})),l=f.a.flatten(c);if(l.length>0)return l}return f()(o).map((function(t){return t.map((function(t,e){return mt(mt({},t),{},{fromEnd:t.length-e-1})}))})).flatten().value()},Jt=function(t){var e=Object.keys(v).find((function(e){return e.toLowerCase()===t.toLowerCase()}));return e?v[e]:t},Ut=function(t,e,n){var r=f.a.clone(t);return[3,4,5,2,2].slice(n||0).forEach((function(t){r.length>e&&(r=r.filter((function(e,n){return n%t==0})))})),r},Kt=function(t){return t instanceof Element?C.select(t):t instanceof C.selection?t:null},Ht=n(16),Vt=n.n(Ht),Zt=n(13),Xt=n.n(Zt),_t=n(19);function $t(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function te(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function ee(){return(ee=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}function ne(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function re(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(!n){if(Array.isArray(t)||(n=function(t,e){if(t){if("string"==typeof t)return ne(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?ne(t,e):void 0}}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var r=0,i=function(){};return{s:i,n:function(){return r>=t.length?{done:!0}:{done:!1,value:t[r++]}},e:function(t){throw t},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,a=!0,s=!1;return{s:function(){n=n.call(t)},n:function(){var t=n.next();return a=t.done,t},e:function(t){s=!0,o=t},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw o}}}}function ie(t,e){var n=[],r=[];return t.length&&function t(e,i){if(1===e.length)n.push(e[0]),r.push(e[0]);else{for(var o=Array(e.length-1),a=0;a<o.length;a++)0===a&&n.push(e[0]),a===o.length-1&&r.push(e[a+1]),o[a]=[(1-i)*e[a][0]+i*e[a+1][0],(1-i)*e[a][1]+i*e[a+1][1]];t(o,i)}}(t,e),{left:n,right:r.reverse()}}function oe(t){var e={};return 4===t.length&&(e.x2=t[2][0],e.y2=t[2][1]),t.length>=3&&(e.x1=t[1][0],e.y1=t[1][1]),e.x=t[t.length-1][0],e.y=t[t.length-1][1],4===t.length?e.type="C":3===t.length?e.type="Q":e.type="L",e}function ae(t,e,n){var r=[[t.x,t.y]];return null!=e.x1&&r.push([e.x1,e.y1]),null!=e.x2&&r.push([e.x2,e.y2]),r.push([e.x,e.y]),function(t,e){for(var n=[],r=t,i=1/(e=e||2),o=0;o<e-1;o++){var a=ie(r,i/(1-i*o));n.push(a.left),r=a.right}return n.push(r),n}(r,n).map(oe)}var se=/[MLCSTQAHVZmlcstqahv]|-?[\d.e+-]+/g,ce={M:["x","y"],L:["x","y"],H:["x"],V:["y"],C:["x1","y1","x2","y2","x","y"],S:["x2","y2","x","y"],Q:["x1","y1","x","y"],T:["x","y"],A:["rx","ry","xAxisRotation","largeArcFlag","sweepFlag","x","y"],Z:[]};function le(t,e){for(var n=Array(t),r=0;r<t;r++)n[r]=e;return n}function ue(t){return"".concat(t.type).concat(ce[t.type].map((function(e){return t[e]})).join(","))}function de(t,e,n){var r=t.length-1,i=e.length-1,o=r/i,a=le(i).reduce((function(e,r,i){var a=Math.floor(o*i);if(n&&a<t.length-1&&n(t[a],t[a+1])){var s=o*i%1<.5;e[a]&&(s?a>0?a-=1:a<t.length-1&&(a+=1):a<t.length-1?a+=1:a>0&&(a-=1))}return e[a]=(e[a]||0)+1,e}),[]).reduce((function(e,n,r){if(r===t.length-1){var i=le(n,ee({},t[t.length-1]));return"M"===i[0].type&&i.forEach((function(t){t.type="L"})),e.concat(i)}return e.concat(function(t,e,n){var r=[];if("L"===e.type||"Q"===e.type||"C"===e.type)r=r.concat(ae(t,e,n));else{var i=ee({},t);"M"===i.type&&(i.type="L"),(r=r.concat(le(n-1).map((function(){return i})))).push(e)}return r}(t[r],t[r+1],n))}),[]);return a.unshift(t[0]),a}function fe(t){for(var e,n,r=(t||"").match(se)||[],i=[],o=0;o<r.length;++o)if(e=ce[r[o]]){n={type:r[o]};for(var a=0;a<e.length;++a)n[e[a]]=+r[o+a+1];o+=e.length,i.push(n)}return i}function he(t,e,n){var r=null==t?[]:t.slice(),i=null==e?[]:e.slice();if(!r.length&&!i.length)return function(){return[]};var o=!(0!==r.length&&"Z"!==r[r.length-1].type||0!==i.length&&"Z"!==i[i.length-1].type);r.length>0&&"Z"===r[r.length-1].type&&r.pop(),i.length>0&&"Z"===i[i.length-1].type&&i.pop(),r.length?i.length||i.push(r[0]):r.push(i[0]),0!==Math.abs(i.length-r.length)&&(i.length>r.length?r=de(r,i,n):i.length<r.length&&(i=de(i,r,n)));var a=(r=r.map((function(t,e){return function(t,e){var n={x1:"x",y1:"y",x2:"x",y2:"y"},r=["xAxisRotation","largeArcFlag","sweepFlag"];if(t.type!==e.type&&"M"!==e.type.toUpperCase()){var i={};Object.keys(e).forEach((function(o){var a=e[o],s=t[o];void 0===s&&(r.includes(o)?s=a:(void 0===s&&n[o]&&(s=t[n[o]]),void 0===s&&(s=0))),i[o]=s})),i.type=e.type,t=i}return t}(t,i[e])}))).map((function(t){return function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?$t(Object(n),!0).forEach((function(e){te(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):$t(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}({},t)}));return o&&(a.push({type:"Z"}),r.push({type:"Z"})),function(t){if(1===t)return null==e?[]:e;if(0===t)return r;for(var n=0;n<a.length;++n){var o,s=r[n],c=i[n],l=a[n],u=re(ce[l.type]);try{for(u.s();!(o=u.n()).done;){var d=o.value;l[d]=(1-t)*s[d]+t*c[d],"largeArcFlag"!==d&&"sweepFlag"!==d||(l[d]=Math.round(l[d]))}}catch(t){u.e(t)}finally{u.f()}}return a}}function pe(t,e,n){var r=fe(t),i=fe(e);if(!r.length&&!i.length)return function(){return""};var o=he(r,i,n);return function(t){if(1===t)return null==e?"":e;var n,r="",i=re(o(t));try{for(i.s();!(n=i.n()).done;){r+=ue(n.value)}}catch(t){i.e(t)}finally{i.f()}return r}}function ge(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function me(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ge(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ge(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}Object.keys(ce).forEach((function(t){ce[t.toLowerCase()]=ce[t]}));var ye={top:20,bottom:50,left:0,right:10,xAxis:10,minRightLabel:0,maxRightLabelRatio:void 0},ve={default:{name:"default",colourFunction:function(t,e,n,r){return Lt(e,n,r)},dataSelector:function(t){var e=t.selector||t.fips;return"".concat(t.metric.id).concat(e?"-".concat(e):"")},externalHoverOpacities:{inactive:.25,hovered:.5,active:1},lineHoverOpacities:{inactive:.25,hovered:.25,active:1},margins:ye,showInactiveLabels:!0,strokeWidth:function(t,e,n){return t.lineSize||e.lineSize||(n?2:null)}},spaghetti:{name:"spaghetti",colourFunction:function(t,e,n,r){if(t.isHighlighted(e,r)){if(e.primaryColor)return e.primaryColor;if(void 0!==e.states){var i=e.states.find((function(t){return t.fips===e.fips}));if(i&&i.primaryColor)return i.primaryColor}return r.primaryColor?r.primaryColor:et.chartcolourdefault0}return et.chartcolourgrey},dataSelector:function(t){return t.selector||t.fips},legendShowBox:function(t,e,n){return t.isHighlighted(e,n)},legendSortOrder:function(t,e){return"US"===t.selector?-1:"US"===e.selector?1:0},externalHoverOpacities:{inactive:.25,hovered:1,active:1},lineHoverOpacities:{inactive:.25,hovered:1,active:1},margins:me(me({},ye),{},{left:0,xAxis:20}),showInactiveLabels:!1,strokeWidth:function(t){return t.lineSize||2}}};function be(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}var ke=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:2;return e+(t.length-1)*(e+2*n)},we=function(t,e){var n=t.params,r=n.yValueLabels,i=n.yValueExtraLabels,o=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?be(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):be(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}({},r);if(i){var a=f.a.max(e.map((function(t){return t.value}))),s=Object.keys(i).map((function(t){return Number(t)})),c=f.a.min(s.filter((function(t){return t>=a})));void 0===c&&(c=f.a.max(s)),s.filter((function(t){return t<=c})).forEach((function(t){o[t]=i[t]}))}return o};function xe(t,e,n){var r=this,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2,o=t.params,a=o.fontSize,s=o.yValueLabels,c=o.boldValueLabels,l="".concat(a,"px ").concat(nt),u=we(t,this.allDataPoints),d=Object.values(u).map((function(t){return Mt(t,r.maxYAxisOffset(),l,3).filter((function(t){return t.length>0}))})),f=Object.keys(u),h=d.flatMap((function(t,e){return t.map((function(n,r){return{id:"".concat(e,"-").concat(r),yValue:f[e],index:r,text:n,texts:t,textHeight:ke(t,a),bold:c&&Number(s[f[e]])!==Number(f[e])}}))}));this.group.select(".axis.y-labels").selectAll("rect.y-label-back").data(h,(function(t){return t.id})).join("rect").classed("y-label-back",!0).attr("x",e.range()[0]-20-5).attr("y",(function(t){return n(t.yValue)-t.textHeight/2-a/2+t.index*(a+2*i)})).attr("width",10).attr("height",2*a),this.group.select(".axis.y-labels").selectAll("text.y-label").data(h,(function(t){return t.id})).join("text").classed("y-label",!0).attr("x",e.range()[0]-20).attr("y",(function(t){return n(t.yValue)-t.textHeight/2+a/2+t.index*(a+2*i)})).style("font-size","".concat(a,"px")).style("font-weight",(function(t){return t.bold?"bold":null})).style("opacity",(function(t){return t.bold?.8:1})).attr("dy","0.32em").text((function(t){return t.text}))}function Ae(t,e,n){var r=n.range(),i=M()(r,2),o=i[0],a=i[1],s=we(t,this.allDataPoints);this.group.select(".axis.y-labels").selectAll("line.axis-connector").data([e.range()[0]-20-3]).join("line").classed("axis-connector",!0).attr("x1",(function(t){return t})).attr("y1",s?n(f.a.maxBy(Object.keys(s),(function(t){return Number(t)}))):a).attr("x2",(function(t){return t})).attr("y2",o)}var Se=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(t){return t},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Dt,r=t.data,i=t.params,o=r.filter(e);if(0===o.length)return[];var a=o[0].metric?o[0].metric.xType:"years";return Gt(o,i.startDate,i.endDate,a,n)},Oe=function(t,e,n,r){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:Dt,o=Se(t,r,i),a=o.map((function(t){return[e(t.key),n(t.value)]}));return{"2d":C.Delaunay.from(a),x:C.Delaunay.from(a.map((function(t){return[M()(t,1)[0],0]}))),points:o}},Ee=["annotations","annotateEnd","annotationColour","annotationColourEnd","areaFill","axisTextColor","boldValueLabels","chartStyle","chartStyleOptions","circlesVisible","gridColor","heightToWidthRatio","hideAxisLabels","hideGridlines","hideLineLabels","hideTitle","hideTooltip","highlighted","intro","labelOpacities","labelTextMode","lineSize","primaryColor","showLastPoint","showLegend","showSourcesAndFootnotes","showXGridlines","showZeroLine","smallSubtitleColor","smallTitleColor","tooltipOnTap","tooltipOptions","transition","useStateAbbreviations","xDomain","xTickFormat","xValues","yDomain","yValueExtraLabels","yValueLabels","yValues"],Me=["y","text"],Ce=["y","text"];function Re(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function je(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Re(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Re(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Ie=function(t,e){var n=ve[t]||ve.default;return Object.assign(n,e)},Be=function(t){var e=t.data,n=t.parent,r=t.options,i=r.annotations,o=void 0===i?[]:i,a=r.annotateEnd,s=void 0!==a&&a,c=r.annotationColour,l=void 0===c?null:c,u=r.annotationColourEnd,d=void 0===u?null:u,f=r.areaFill,h=void 0!==f&&f,p=r.axisTextColor,g=void 0===p?dt:p,m=r.boldValueLabels,y=void 0===m||m,v=r.chartStyle,b=void 0===v?"default":v,k=r.chartStyleOptions,x=void 0===k?{}:k,A=r.circlesVisible,S=void 0!==A&&A,O=r.gridColor,E=void 0===O?null:O,M=r.heightToWidthRatio,C=void 0===M?null:M,R=r.hideAxisLabels,j=void 0!==R&&R,I=r.hideGridlines,B=void 0!==I&&I,D=r.hideLineLabels,T=void 0!==D&&D,F=r.hideTitle,P=void 0!==F&&F,z=r.hideTooltip,Q=void 0!==z&&z,L=r.highlighted,Y=void 0===L?[]:L,W=r.intro,q=void 0!==W&&W,N=r.labelOpacities,G=void 0===N?null:N,J=r.labelTextMode,U=void 0===J?null:J,K=r.lineSize,H=void 0===K?null:K,V=r.primaryColor,Z=void 0===V?null:V,X=r.showLastPoint,_=void 0!==X&&X,$=r.showLegend,tt=void 0===$?null:$,et=r.showSourcesAndFootnotes,nt=void 0===et||et,rt=r.showXGridlines,it=void 0!==rt&&rt,ot=r.showZeroLine,at=void 0!==ot&&ot,st=r.smallSubtitleColor,ct=void 0===st?null:st,lt=r.smallTitleColor,ut=void 0===lt?null:lt,ft=r.tooltipOnTap,ht=void 0===ft||ft,pt=r.tooltipOptions,gt=void 0===pt?{}:pt,mt=r.transition,yt=void 0!==mt&&mt,vt=r.useStateAbbreviations,bt=void 0!==vt&&vt,kt=r.xDomain,wt=void 0===kt?null:kt,xt=r.xTickFormat,At=void 0===xt?null:xt,St=r.xValues,Ot=void 0===St?null:St,Et=r.yDomain,Mt=void 0===Et?null:Et,Ct=r.yValueExtraLabels,Rt=void 0===Ct?null:Ct,jt=r.yValueLabels,It=void 0===jt?null:jt,Bt=r.yValues,Dt=void 0===Bt?null:Bt,Tt=w()(r,Ee),Ft=Ie(b,x);return je(je({},Qt({data:e,parent:n,options:Tt},Ft.margins||ve.default.margins)),{},{annotations:o,annotationColour:l,annotateEnd:s,annotationColourEnd:d,areaFill:h,axisTextColor:g,boldValueLabels:y,chartStyle:Ft,circlesVisible:S,gridColor:E,heightToWidthRatio:C,hideAxisLabels:j,hideGridlines:B,hideLineLabels:T,hideTitle:P,hideTooltip:Q,highlighted:Y,intro:q,labelOpacities:G,labelTextMode:U,lineSize:H,primaryColor:Z,showXGridlines:it,showLastPoint:_,showLegend:tt,showSourcesAndFootnotes:nt,showZeroLine:at,smallTitleColor:ut,smallSubtitleColor:ct,tooltipOnTap:ht,tooltipOptions:gt,transition:yt,useStateAbbreviations:bt,xDomain:wt,xTickFormat:At,xValues:Ot,yDomain:Mt,yValueExtraLabels:Rt,yValueLabels:It,yValues:Dt})},De=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.fontSize,r=void 0===n?16:n,i=e.padding,o=void 0===i?2:i,a=e.pushBy,s=void 0===a?2:a,c=e.minY,l=void 0===c?0:c,u=e.maxY,d=void 0===u?500:u,h=e.labelLineHeight,p=2e3,g=f.a.map(t,(function(t){return je({y:t.y,text:t.text},w()(t,Me))}));function m(t){return Array.isArray(t)?r+2*o+(t.length-1)*r*h:r+2*o}var y,v=function(t,e){var n=t.y,r=t.text,i=w()(t,Ce),o=0,a=0;return g.forEach((function(t,i){var c=t.y,l=t.text;if(e!==i){var u=(m(r)+m(l))/2,d=n-c;d>0&&d<u&&(o=Math.max(Math.min(s,u-d),o)),d<0&&-d<u&&(a=Math.min(Math.max(-s,-u-d),a)),0===d&&(e<i?a=Math.min(Math.max(-s,-u),a):o=Math.max(Math.min(s,u),o))}})),je({pushDown:o,pushUp:a,y:0===a||0===o?n+o+a:n+(a+o)/2,text:r},i)};do{g=g.map(v),p-=1}while(f()(g).map((function(t){var e=t.pushUp,n=t.pushDown;return Math.abs(e)+Math.abs(n)})).sum()>0&&p>0);void 0!==d&&(g=f()(g).sortBy("y").reverse().map((function(t){var e=m(t.text),n=t.y;return void 0===y&&(y=d+e/2),t.y+e/2>y&&(n=y-=e/2,y-=e/2),je(je({},t),{},{y:n})})));if(void 0!==l){var b=l;g=f()(g).sortBy("y").map((function(t){var e=m(t.text),n=t.y;return t.y-(e-(r+2*o))/2<b&&(n=b+=e/2,b+=e/2),je(je({},t),{},{y:n})}))}return g.map((function(t){return je(je({},t),{},{y:t.y-(m(t.text)-(r+2*o))/2})})).sortBy("sortIndex")},Te=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:16,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"600",i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:nt,o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:n,a=Object(R.createCanvas)(500,500).getContext("2d"),s=n,c=r;a.font="".concat(c," ").concat(s,"px ").concat(i);var l=f()(t).map((function(t){return a.measureText(t).width})).max();if(l>e-10)for(;l>e-10&&s>o;)s-=1,a.font="".concat(c," ").concat(s,"px ").concat(i),l=f()(t).map((function(t){return a.measureText(t).width})).max();return{width:Math.min(l,e),fontSize:s,fontWeight:c}},Fe=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>1?arguments[1]:void 0,n=arguments.length>2?arguments[2]:void 0,r=arguments.length>3?arguments[3]:void 0,i=arguments.length>4?arguments[4]:void 0,o=t.find((function(t){var i=t.metric,o=t.key;return i===n&&e.getTime()===St(o,r).getTime()}));return f.a.isNil(o)?f.a.isString(i)?{title:i,metric:n,key:e}:f.a.isObject(i)?{annotation:i,metric:n,key:e}:null:je(je({},o),{},{key:e})},Pe=[[1,0,0,0,0,0,0,0,0,0,0,1],[0,0,0,0,0,0,0,0,0,1,1,0],[0,1,1,1,1,1,0,1,0,1,1,1],[0,1,1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,1,1,0,0,0],[1,0,0,0,1,0,0,1,0,0,0,0]],ze=[[1,0,0,0,0,0,1,0,0,0,0,1],[0,0,0,0,0,0,0,0,0,1,1,0],[0,1,1,1,1,1,0,1,0,1,1,1],[0,1,1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,1,1,0,0,0],[1,0,0,0,1,0,0,1,0,0,0,0]],Qe=[{abbr:"AK",name:"Alaska",fips:"02"},{abbr:"ME",name:"Maine",fips:"23"},{abbr:"VT",name:"Vermont",fips:"50"},{abbr:"NH",name:"New Hampshire",fips:"33"},{abbr:"WA",name:"Washington",fips:"53"},{abbr:"MT",name:"Montana",fips:"30"},{abbr:"ND",name:"North Dakota",fips:"38"},{abbr:"MN",name:"Minnesota",fips:"27"},{abbr:"WI",name:"Wisconsin",fips:"55"},{abbr:"MI",name:"Michigan",fips:"26"},{abbr:"NY",name:"New York",fips:"36"},{abbr:"MA",name:"Massachusetts",fips:"25"},{abbr:"RI",name:"Rhode Island",fips:"44"},{abbr:"ID",name:"Idaho",fips:"16"},{abbr:"WY",name:"Wyoming",fips:"56"},{abbr:"SD",name:"South Dakota",fips:"46"},{abbr:"IA",name:"Iowa",fips:"19"},{abbr:"IL",name:"Illinois",fips:"17"},{abbr:"IN",name:"Indiana",fips:"18"},{abbr:"OH",name:"Ohio",fips:"39"},{abbr:"PA",name:"Pennsylvania",fips:"42"},{abbr:"NJ",name:"New Jersey",fips:"34"},{abbr:"CT",name:"Connecticut",fips:"09"},{abbr:"OR",name:"Oregon",fips:"41"},{abbr:"NV",name:"Nevada",fips:"32"},{abbr:"CO",name:"Colorado",fips:"08"},{abbr:"NE",name:"Nebraska",fips:"31"},{abbr:"MO",name:"Missouri",fips:"29"},{abbr:"KY",name:"Kentucky",fips:"21"},{abbr:"WV",name:"West Virginia",fips:"54"},{abbr:"VA",name:"Virginia",fips:"51"},{abbr:"MD",name:"Maryland",fips:"24"},{abbr:"DE",name:"Delaware",fips:"10"},{abbr:"CA",name:"California",fips:"06"},{abbr:"UT",name:"Utah",fips:"49"},{abbr:"NM",name:"New Mexico",fips:"35"},{abbr:"KS",name:"Kansas",fips:"20"},{abbr:"AR",name:"Arkansas",fips:"05"},{abbr:"TN",name:"Tennessee",fips:"47"},{abbr:"NC",name:"North Carolina",fips:"37"},{abbr:"SC",name:"South Carolina",fips:"45"},{abbr:"DC",name:"District of Columbia",fips:"11"},{abbr:"AZ",name:"Arizona",fips:"04"},{abbr:"OK",name:"Oklahoma",fips:"40"},{abbr:"LA",name:"Louisiana",fips:"22"},{abbr:"MS",name:"Mississippi",fips:"28"},{abbr:"AL",name:"Alabama",fips:"01"},{abbr:"GA",name:"Georgia",fips:"13"},{abbr:"HI",name:"Hawaii",fips:"15"},{abbr:"TX",name:"Texas",fips:"48"},{abbr:"FL",name:"Florida",fips:"12"}],Le=[Qe[0],{abbr:"US",name:"US",fips:"US"}].concat(O()(Qe.slice(1))),Ye=function(t){return f()(t).flatMap((function(t,e){return t.map((function(t,n){return t?[e,n]:null}))})).filter((function(t){return t})).value().map((function(t,e){var n=M()(t,2);return{i:n[0],j:n[1],properties:Qe[e]}}))},We=function(t){return f()(t).flatMap((function(t,e){return t.map((function(t,n){return t?[e,n]:null}))})).filter((function(t){return t})).value().map((function(t,e){var n=M()(t,2);return{i:n[0],j:n[1],properties:Le[e]}}))};function qe(t,e,n,r,i){var o=i?1.4:1,a=Math.sin(Math.PI/6),s=n/Pe[0].length*o/2,c=s/Math.cos(Math.PI/6);return{x:((t%2==1?2*s:s)+e*(2*s))/o,y:c+t*(a*c+c)/o,radius:c,apothem:s,hexDi:2*c}}function Ne(t,e,n){var r=t.i,i=t.j,o=arguments.length>3&&void 0!==arguments[3]&&arguments[3],a=qe(r,i,e,0,o),s=a.x,c=a.y,l=a.radius,u=a.apothem,d=Math.sin(Math.PI/6);return[[s,c-l],[s+u,c-d*l],[s+u,c+d*l],[s,c+l],[s-u,c+d*l],[s-u,c-d*l]]}function Ge(t,e,n,r){return r&&n.fillSelected?n.fillSelected:n.greyHexes?et.chartcolourgreycartogram:e(t)}function Je(t,e,n,r){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:parseFloat(rt),o=t.getContext("2d");o.textBaseline="middle",o.textAlign="left",o.font="600 ".concat(i,"px ").concat(nt);var a=0;r.forEach((function(t){var r=t.text,i=t.color;o.fillStyle=i,o.fillText(r,e+a,n),a+=o.measureText("".concat(r," ")).width}))}var Ue={drawTitles:function(t,e,n,r,i,o){var a=e.title,s=e.subtitle,c=e.margins,l=e.titleFontSize,u=e.subtitleFontSize,d=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,f=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,h=t.getContext("2d"),p=parseFloat(it)*l,g=parseFloat(lt)*u,m=c.left+d,y=f,v=[{text:a,color:ot}];void 0!==n&&v.push({text:n,color:r}),void 0!==i&&(v.push({text:"vs",color:ot}),v.push({text:i,color:o})),h.font="bold ".concat(rt,"px ").concat(nt),Je(t,m,y+p/2,v,l),y+=p,h.font="".concat(u,"px ").concat(st),h.fillStyle=ut,void 0!==s&&h.fillText(s,m,y+g/2)},drawAxis:function(t,e,n,r){var i,o,a=n.hideAxisLabels,s=n.hideGridlines,c=n.fontSize,l=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"top",u=arguments.length>5?arguments[5]:void 0,d=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,f=arguments.length>7&&void 0!==arguments[7]?arguments[7]:function(t){return t},h=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,p=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,g=t.getContext("2d"),m=r.ticks(u),y=10,v=function(){};if("left"===l)i="left",o=function(t){g.fillText(f(t),h-y,p+r(t))};else if("right"===l)i="right",o=function(t){g.fillText(f(t),h+r(t),p-y)};else if("top"===l)i="center",o=function(t){g.fillText(f(t),h+r(t),p-y)},v=function(t){g.moveTo(h+r(t),p),g.lineTo(h+r(t),p+d)};else{if("bottom"!==l)return void console.warn("Invalid position parameter - ".concat(l,". Must be 'left', 'right', 'top' or 'bottom'"));i="center",o=function(t){g.fillText(f(t),h+r(t),p+y)}}g.font="".concat(c,"px ").concat(nt),g.fillStyle=dt,g.lineWidth=1,g.strokeStyle=ft,g.textBaseline="middle",g.textAlign=i,g.beginPath(),m.forEach((function(t){a||o(t),s||v(t)})),g.stroke()},drawMapLegend:function(t,e,n,r,i,o){var a=r.fontSize,s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:function(t){return t},c=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,u=t.getContext("2d"),d=e.map((function(t){var e=t.metric.data.find((function(e){return t.metric.xType&&"items"===t.metric.xType.toLowerCase()?e.key===n:e.key.getTime()===St(n,t.metric.xType).getTime()}));return void 0!==e?e.value:null})),h=f.a.min(d),p=f.a.max(d),g=f.a.reverse(f.a.flattenDeep([h,i.domain(),p])),m=f.a.reverse(i.range());u.lineWidth=5,u.textBaseline="middle",u.textAlign="left",u.font="".concat(a,"px ").concat(nt),u.fillStyle="#646464",m.forEach((function(t,e){u.strokeStyle=t,u.beginPath(),u.moveTo(c,l+e*o/m.length),u.lineTo(c,l+(e+1)*o/m.length),u.stroke(),u.fillText(s(g[e]),c+5,l+e*o/m.length)})),u.fillText(s(g[g.length-1]),c+5,l+o)},drawLineChartAxis:function(t,e,n,r,i){var o,a=n.hideAxisLabels,s=n.hideGridlines,c=n.fontSize,l=arguments.length>5&&void 0!==arguments[5]?arguments[5]:function(t){return t},u=arguments.length>6?arguments[6]:void 0,d=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,f=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,h=t.getContext("2d"),p=r.range(),g=M()(p,2),m=g[0],y=g[1],v=m,b=y-m;o=b>760?8:b>400?4:3;var k=r.ticks(o),w=i.ticks(u),x=r.tickFormat(),A=l,S=10;h.font="".concat(c,"px ").concat(nt),h.fillStyle=dt,h.lineWidth=1,h.strokeStyle=ft;var O,E=v-S+d;h.textBaseline="middle",h.textAlign="right",h.beginPath(),w.forEach((function(t){O=i(t)+f,a||h.fillText(A(t),E,O),s||(h.moveTo(r.range()[0],O),h.lineTo(r.range()[1],O))})),h.stroke(),h.textBaseline="top",h.textAlign="center",O=i.range()[0]+S+f,k.forEach((function(t){E=r(t)+d,a||h.fillText(x(t),E,O)}))},drawDots:function(t,e,n,r,i,o,a){var s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,c=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,l=arguments.length>9?arguments[9]:void 0,u=arguments.length>10?arguments[10]:void 0,d=arguments.length>11&&void 0!==arguments[11]?arguments[11]:et.chartcolourgrey,h=t.getContext("2d"),p=function(t,e){var n=e.metric.data.find((function(n){return e.metric.xType&&"items"===e.metric.xType.toLowerCase()?n.key===t:n.key.getTime()===St(t,e.metric.xType).getTime()}));return void 0!==n?n.value:null},g=f.a.some(e,(function(t){return t.selectedState})),m=function(t,n,r){e.forEach((function(e){var i=p(t,e);if(null!==i){g&&!e.selectedState?h.globalAlpha=.4:h.globalAlpha=1;var l=o(i)+s,u=a(Dt(e))+c;h.beginPath(),h.arc(l,u,n,0,2*Math.PI),r&&h.stroke(),h.fill()}})),h.globalAlpha=1},y=n.fontSize/14*7,v=n.fontSize/14*5;h.strokeStyle=d,e.forEach((function(t){var e=p(r,t),n=p(i,t);if(null!==e&&null!==n){g&&!t.selectedState?h.globalAlpha=.4:h.globalAlpha=1;var l=1;n<e&&(l=-1);var u=o(e)+s+v*l,d=o(n)+s-y*l;if(!(1===l&&d-u<0||-1===l&&d-u>0)){var f=a(Dt(t))+c;h.beginPath(),h.moveTo(u,f),h.lineTo(d,f),h.stroke()}}})),h.globalAlpha=1,h.fillStyle=u,m(i,y),h.fillStyle=l,h.strokeStyle="#FFF",m(r,v,!0)},drawBars:function(t,e,n,r,i,o){var a=n.margins,s=n.fontSize,c=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,l=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,u=arguments.length>8?arguments[8]:void 0,d=arguments.length>9&&void 0!==arguments[9]?arguments[9]:function(t){return t},h=t.getContext("2d"),p=e.map((function(t){var e=t.metric.data.find((function(e){return t.metric.xType&&"items"===t.metric.xType.toLowerCase()?e.key===r:e.key.getTime()===St(r,t.metric.xType).getTime()}));return void 0!==e?e.value:null}));h.textBaseline="middle",h.textAlign="left",h.font="".concat(s,"px ").concat(nt);var g=f.a.some(e,(function(t){return t.selectedState}));e.forEach((function(t,e){if(null!==p[e]){g&&!t.selectedState?h.globalAlpha=.4:h.globalAlpha=1;var n=i(p[e])-i(0),r=o.bandwidth(),s=i(0),f=o(Dt(t))+l;h.fillStyle=u(t)||et.chartcolourdefault0,h.fillRect(s,f-r/2,n,r),h.fillStyle=ot;var m=Math.max(i(0),i(p[e]))+c;h.fillText(d(p[e]),m+a.valueLabelPadding,f)}})),h.globalAlpha=1},drawLeftLabels:function(t,e,n,r,i){var o,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,c=t.getContext("2d"),l=f.a.every(e,(function(t){return t.metric.geo_id===e[0].metric.geo_id}));l&&(o="metrics");var u=f.a.every(e,(function(t){return t.metric.id===e[0].metric.id}));u&&(o="states");var d=f.a.map(e,(function(t){return vt(t,o)})),h=n.fontSize;c.textBaseline="middle",c.textAlign="left",c.font="".concat(h,"px ").concat(nt),c.fillStyle=ot;var p=f.a.max(d.map((function(t){return c.measureText(t).width}))),g=f.a.some(e,(function(t){return t.selectedState}));return e.forEach((function(t,e){g&&!t.selectedState?c.globalAlpha=.4:c.globalAlpha=1,c.fillText(d[e],a,r(Dt(t))+s)})),c.globalAlpha=1,{fontSize:h,longestLabelWidth:p}},drawLineLabels:function(t,e,n,r,i,o){var a=arguments.length>6&&void 0!==arguments[6]?arguments[6]:20,s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,c=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,l=e.getContext("2d");l.textBaseline="middle",l.textAlign="left",l.font="bold ".concat(a,"px ").concat(nt);var u=i.range()[1]+o;n.forEach((function(e,n){l.fillStyle=t.colourFunction(e,n,r),e.text.forEach((function(t,n){l.fillText(t,u+s,e.y+c+n*a*.9)}))}))},drawLines:function(t,e,n,r,i,o){var a=arguments.length>6&&void 0!==arguments[6]&&arguments[6],s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,c=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,l=e.getContext("2d"),u=C.line().x((function(t){return i(t.key)+s})).y((function(t){return o(t.value)+c})).context(l);n.forEach((function(e,n){if(l.lineCap="round",a){l.lineCap="butt";var d=l.createLinearGradient(0,o.range()[1]+c,0,o.range()[0]+c);d.addColorStop(0,t.colourFunction(e,n,r)),d.addColorStop(1,"rgb(247, 250, 253)");var f=e.metric.data[e.metric.data.length-1].key,h=e.metric.data[0].key;l.beginPath(),u(e.metric.data.filter((function(t){return null!==t.value}))),l.lineTo(i(f)+s,o.range()[0]+c),l.lineTo(i(h)+s,o.range()[0]+c),l.fillStyle=d,l.fill()}l.lineWidth=e.lineSize||r.lineSize||4,l.strokeStyle=t.colourFunction(e,n,r),l.beginPath(),u(e.metric.data.filter((function(t){return null!==t.value}))),l.stroke()}))},drawMap:function(t,e,n,r){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,a=arguments.length>6?arguments[6]:void 0,s=90,c=t.getContext("2d"),l=C.geoAlbersUsa().translate(),u=M()(l,2),d=u[0],h=u[1],p=r/(2*(d-s)),g=C.geoAlbersUsa().scale(),m=C.geoAlbersUsa().scale(p*g).translate([p*(d-s)+i,p*h+o]),y=C.geoPath(m).context(c);c.lineWidth=2*p;var v=f.a.map(e[0].states,"fips");f()(n).sortBy((function(t){var e=t.id;return f.a.includes(v,e)})).forEach((function(t){c.fillStyle=a(e,t.properties.name),c.beginPath(),y(t),c.fill(),c.strokeStyle=f.a.includes(v,t.id)?"#616161":"white",c.stroke()}))},drawCartogram:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,o=arguments.length>5?arguments[5]:void 0,a=t.getContext("2d"),s=960,c=n/s,l=4*c;a.strokeStyle="white",a.lineWidth=l,Ye(Pe).forEach((function(t){var s=t.i,c=t.j,u=t.properties;a.fillStyle=o(e,u.name),a.beginPath(),Ne({i:s,j:c,properties:u},n,l).forEach((function(t,e){var n=t[0]+r,o=t[1]+i;0===e?a.moveTo(n,o):a.lineTo(n,o)})),a.closePath(),a.stroke(),a.fill();var d=qe(s,c,n),f=d.x,h=d.y;a.textBaseline="middle",a.textAlign="center",a.fillStyle="white",a.font="bold 16px ".concat(nt),a.fillText(u.abbr,f+r,h+i)}))},drawSparklineDecorators:function(t,e,n,r,i,o){var a=n.hideAxisLabels,s=n.hideGridlines,c=n.fontSize,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:function(t){return t},u=arguments.length>7?arguments[7]:void 0,d=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,h=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,p=t.getContext("2d"),g=f()(e).flatMap(f.a.property(["metric","data"])).sortBy("key").value(),m=f()(e).flatMap(f.a.property(["metric","xType"])).first(),y=f()(e).flatMap(f.a.property(["metric","yType"])).first()||"",v=i.ticks(),b=r.range(),k=M()(b,1),w=k[0],x=[v[0],v[v.length-1]],A=10,S=function(){p.moveTo(d+w,h+i.range()[0]),p.lineTo(d+w,h+i.range()[1])},O=function(t){p.fillText(l(t),d+w-A/2,h+i(t))};p.font="".concat(c,"px ").concat(nt),p.fillStyle=dt,p.lineWidth=1,p.strokeStyle=ft,p.textBaseline="middle",p.textAlign="right",p.beginPath(),x.forEach((function(t){a||O(t),s||S(t)})),p.stroke(),p.textBaseline="alphabetic";var E=[f.a.first(g),f.a.last(g)];if(E.forEach((function(t,e){p.textAlign=0===e?"left":"right",p.fillText(Ot(t.key,m),d+r(t.key)+(0===e?-3:3),h+i.range()[0]+1.5*A)})),p.fillStyle=o,E.forEach((function(t,e){p.textAlign=0===e?"left":"right",p.fillText(_(t.value,{values:E,type:y}),d+r(t.key)+(0===e?-3:3),h+i.range()[0]+1.5*A+c)})),x[0]<0&&x[1]>0){var C=h+i(0);p.beginPath(),p.moveTo(d+r.range()[0],C),p.lineTo(d+r.range()[1],C),p.stroke(),Math.abs(i(0)-i(x[0]))>c&&Math.abs(i(0)-i(x[1]))>c&&(p.fillStyle=dt,p.textBaseline="middle",p.beginPath(),O(0),p.fill())}p.fillStyle=o,p.beginPath(),E.forEach((function(t){var e=d+r(t.key),n=h+i(t.value);p.ellipse(e,n,u,u,0,0,2*Math.PI)})),p.fill()},drawFooter:function(t,e,n){var r=t.getContext("2d");r.textBaseline="alphabetic",r.textAlign="center",r.font="".concat(12,"px ",nt),r.fillStyle="#555",r.fillText("Explore the data and source at usafacts.org © 2019 USAFacts.org. All rights reserved.",e/2,n)},drawLogo:function(t,e,n){var r=arguments;return i()(u.a.mark((function i(){var o,a;return u.a.wrap((function(i){for(;;)switch(i.prev=i.next){case 0:return o=n.margins,a=r.length>3&&void 0!==r[3]?r[3]:40,i.abrupt("return",new Promise((function(n,r){var i=R.Image?new R.Image:new window.Image;i.onload=function(){var r=t.getContext("2d");r.drawImage(i,o.left,a,162,20),r.textBaseline="alphabetic",r.textAlign="right",r.font="".concat(20,"px ",nt),r.fillStyle="#555";for(var s="OUR NATION, IN NUMBERS",c=a+20,l=e-o.right,u=s.length-1;u>=0;u-=1)r.fillText(s[u],l,c),l=l-r.measureText(s[u]).width-2;r.beginPath(),r.moveTo(o.left,a+20+10),r.lineTo(e-o.right,a+20+10),r.closePath(),r.strokeStyle=ft,r.lineWidth=2,r.stroke(),n()},i.onerror=function(t){console.error(t),r()},i.src="data:image/png;base64,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"})));case 3:case"end":return i.stop()}}),i)})))()}};function Ke(t,e,n,r,i,o,a,s){var c=this,l=i.getContext("2d"),u=Math.min(150,.4*this.width),d=void 0===n.margins.maxRightLabel?u:n.margins.maxRightLabel,f=r&&(!this.isSubchart||t.length>1),h=yt(t,n),p=t.map((function(t){return c.getLabel(t,c.isSubchart,h,n)})),g=Te(p,d,n.fontSize),m=this.createScales({data:t,params:n},f?g.width:0),y=m.xScale,v=m.yScale;if(r){if(f){var b=t.map((function(t,e){var r=c.getLabel(t,c.isSubchart,h,n);return{text:Mt(r,g.width,"".concat(g.fontWeight," ").concat(g.fontSize,"px ").concat(nt)),y:v(t.metric.data.slice(-1)[0].value),primaryColor:c.colourFunction(t,e,n)}}));Ue.drawLineLabels(this,i,De(b,{maxY:v.range()[0],fontSize:n.fontSize,labelLineHeight:.9}),n,y,10,n.fontSize,o,a)}Ue.drawLineChartAxis(i,t,n,y,v,(function(r){return Pt({data:t,parent:e,params:n})(r,{ticks:v.ticks(c.yTicks)})}),this.yTicks,o,a)}if(Ue.drawLines(this,i,t,n,y,v,n.areaFill&&1===t.length,o,a),void 0!==s){var k=t[0].lineSize||n.lineSize||4,w=this.circleR*k/4,x=y(s.key)+o,A=v(s.value)+a;l.fillStyle=this.colourFunction(t[0],0,n),l.beginPath(),l.ellipse(x,A,w,w,0,0,2*Math.PI),l.fill()}}function He(){return(He=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,h,p,g,m,y,v,b,k,w,x,A,S,O,E,M,C,j,I,B,D,T,F,P,z,Q,L,Y,W,q,N,G,J,U,K,H,V,Z,X,_,$=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return o=$.length>1&&void 0!==$[1]?$[1]:{},a=$.length>2?$[2]:void 0,s=a.margin,c=void 0===s?40:s,l=a.width,d=void 0===l?720:l,h=a.scale,p=void 0===h?3:h,g=a.key,m=void 0===g?void 0:g,y=a.showText,v=void 0===y||y,b=a.showBranding,k=void 0===b||b,w=a.xOffset,x=void 0===w?0:w,A=a.yOffset,S=void 0===A?0:A,O=$.length>3&&void 0!==$[3]?$[3]:Object(R.createCanvas)(d,d),t.next=5,this.data(e,o);case 5:if(E=t.sent){t.next=8;break}return t.abrupt("return",null);case 8:if(M=E.data,C=E.parent,j=(null===(n=M[0])||void 0===n||null===(r=n.metric)||void 0===r?void 0:r.data)||[],I=void 0!==m?m:null===(i=j[j.length-1])||void 0===i?void 0:i.key,B=Be({data:M,parent:C,options:o}),null!==c&&(B.margins.left=c,B.margins.right=c),!1===v&&(B.margins.fixedAxis=0),D=1===M.length&&!this.isSubchart,T=c+(v&&k?40:0),F=v?B.titleFontSize*parseFloat(it):0,P=v&&""!==B.subtitle,z=P?B.subtitleFontSize*parseFloat(lt):0,Q=v&&D?B.titleFontSize*parseFloat(it):0,L=c+(v&&k?20:0),Y=d*(B.heightToWidthRatio||.5),O.width=d*p,O.height=(Y+T+F+z+Q+L)*p,(W=O.getContext("2d")).fillStyle="white",W.fillRect(0,0,O.width,O.height),W.scale(p,p),D&&I&&(void 0===(q=f()(M[0].metric.data).find((function(t){return t.key.getTime()===I.getTime()})))&&(q=f()(M[0].metric.data).maxBy("key")),N=4,G=M[0].lineSize||B.lineSize||N,J=this.circleR*G/N,B.margins.right=Math.max(J,B.margins.right)),U=S+T+F+z+Q,!v){t.next=37;break}if(Ue.drawTitles.call(this,O,B,void 0,void 0,void 0,void 0,x,S+T),q&&(W.textBaseline="alphabetic",W.font="600 ".concat(B.titleFontSize,"px ").concat(nt),W.fillStyle=this.colourFunction(M[0],0,B),K=S+T+F+z+(Q+B.titleFontSize)/2,W.fillText(Ft({data:M,parent:C,params:B})(q.value),B.margins.left,K),H=W.measureText("".concat(Ft({data:M,parent:C,params:B})(q.value)," ")).width,W.font="".concat(B.subtitleFontSize,"px ").concat(nt),W.fillStyle=ut,V=M[0].metric.xType,Z="days"===V||"daily"===V?"on":"in",W.fillText("".concat(Z," ").concat(Ot(q.key,M[0].metric.xType)),B.margins.left+H,K)),!k){t.next=37;break}return t.next=36,Ue.drawLogo(O,d,B,c);case 36:Ue.drawFooter(O,d,U+d*(B.heightToWidthRatio||.5)+20);case 37:return X=this.width,_=this.height,this.width=d,this.height=Y,Ke.call(this,M,C,B,v,O,x,U,q),this.width=X,this.height=_,t.abrupt("return",O);case 45:case"end":return t.stop()}}),t,this)})))).apply(this,arguments)}var Ve=function(t){return He.apply(this,arguments)},Ze=function(){this.container.append("div").classed("chart-error",!0).append("div").text("Unable to load data")},Xe=function(){var t=i()(u.a.mark((function t(e){var n,r,i,o,a;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,n=e.data,r=e.topMetrics,i=e.bottomMetrics,o=e.parent,t.next=4,Promise.all([n,r,i,o]);case 4:return a=t.sent,t.abrupt("return",{data:a[0],topMetrics:a[1],bottomMetrics:a[2],parent:a[3]});case 8:return t.prev=8,t.t0=t.catch(0),console.warn(t.t0.message),this.container&&(this.container.select(".chart-error").style("display","initial"),this.container.select(".chart-loading").style("display","none"),this.container.select(".".concat(this.cssPrefix)).style("visibility","hidden")),t.abrupt("return",null);case 13:case"end":return t.stop()}}),t,this,[[0,8]])})));return function(e){return t.apply(this,arguments)}}(),_e=function(){function t(e){a()(this,t),this.container=e.classed("text-expander",!0),this.initGroups()}return c()(t,[{key:"initGroups",value:function(){var t=this;this.title=this.container.append("div").classed("text-ex-title",!0);var e=this.container.append("div").classed("text-ex-expander",!0);this.content=e.append("div").classed("text-ex-content",!0),this.textLess=e.append("div").classed("text-ex-less",!0).on("click",(function(){t.collapse()})),this.textLess.append("div").classed("less-text",!0).text("see less"),this.textLess.append("div").classed("arrow",!0);var n=this.container.append("div").classed("text-ex-summary",!0);this.summary=n.append("span").classed("summary-content",!0),this.textMore=n.append("div").classed("text-ex-more",!0).on("click",(function(){t.expand()})),this.textMore.append("div").classed("more-text",!0).text("see more"),this.textMore.append("div").classed("arrow",!0)}},{key:"setTitle",value:function(t){this.title.text("".concat(t,":"))}},{key:"expand",value:function(){this.container.select(".text-ex-summary").style("display","none"),this.container.select(".text-ex-expander").style("display",null)}},{key:"collapse",value:function(){this.container.select(".text-ex-expander").style("display","none"),this.container.select(".text-ex-summary").style("display",null)}},{key:"show",value:function(){this.container.style("display",null)}},{key:"hide",value:function(){this.container.style("display","none")}}]),t}();function $e(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function tn(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?$e(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):$e(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var en=function(){function t(e){if(a()(this,t),this.container=Kt(e),null===this.container)throw new Error("[SourcesAndFootnotes] Constructor argument is not an Element or D3 selection, or two instances of D3 are being used");this.container.classed("chart-saf",!0),this.initGroups(),this.hide()}return c()(t,[{key:"initGroups",value:function(){var t=this.container.append("div").classed("saf-sources",!0);this.sources=new _e(t),this.sources.collapse();var e=this.container.append("div").classed("saf-footnotes",!0);this.footnotes=new _e(e),this.footnotes.collapse()}},{key:"draw",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.chartFootnotes,i=n.chartSources,o=n.hideMetricFootnotes,a=t.getSources(e,i),s=a.sources,c=a.summary,l=t.getFootnotes(e,r,o),u=l.footnotes,d=l.summary;s.length>0?(this.drawSources(s,c),this.sources.show()):this.sources.hide(),u.length>0?(this.drawFootnotes(u,d),this.footnotes.show()):this.footnotes.hide(),this.container.style("display",null)}},{key:"drawSources",value:function(t,e){this.sources.setTitle("Sources"),this.sources.summary.text(e);var n=this.sources.content.selectAll("div.source-long").data(t,(function(t){return t[0]})).join("div").classed("source-long",!0);n.selectAll("div.long-title").data((function(t){return[t[0]]})).join("div").classed("long-title",!0).text((function(t){return t}));var r=n.selectAll("div.long-entry").data((function(t){return t[1]})).join("div").classed("long-entry",!0),i=r.selectAll("a.long-link").data((function(t){return[t]})).join("a").classed("long-link",!0).attr("href",(function(t){return t.url?t.url:"#"})).attr("target","_blank");i.selectAll("span.long-link-text").data((function(t){return[t]})).join("span").classed("long-link-text",!0).text((function(t){return t.name})),i.selectAll("div.external-icon").data((function(t){return[t]})).join("div").classed("external-icon",!0),r.selectAll("span.long-updated").data((function(t){return[t]})).join("span").classed("long-updated",!0).text((function(t){return t.lastupdated?"(updated ".concat(t.lastupdated,")"):""}))}},{key:"drawFootnotes",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";this.footnotes.setTitle("Footnotes");var n=e&&e.length>50?"".concat(e.substr(0,50),"..."):e;this.footnotes.summary.text(n);var r=this.footnotes.content.selectAll("div.footnote-long").data(t,(function(t){return t[0]})).join("div").classed("footnote-long",!0);r.selectAll("div.long-title").data((function(t){return[t[0]]})).join("div").classed("long-title",!0).text((function(t){return t})),r.selectAll("div.long-data").data((function(t){return t[1]})).join("div").classed("long-data",!0).text((function(t){return t.data}))}},{key:"hide",value:function(){this.sources.hide(),this.footnotes.hide()}}],[{key:"getSources",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=t.flatMap((function(t){var e;if(!t.metric)return[];if(t.metric.sources)return t.metric.sources.map((function(t){return tn(tn({},t),{},{name:t.name||t.url||""})}));if(null!==(e=t.metric.metadata)&&void 0!==e&&e.source){var n=t.metric.metadata;return[tn(tn({},n),{},{agencyname:n.agencyname||n.source,name:n.sourceName||n.sourceURL||"",url:n.sourceURL})]}return[]})),r=f()(e).concat(n).uniqBy((function(t){return t.url})).groupBy((function(t){return t.agencyname})).entries().value();return{sources:r,summary:"".concat(r.map((function(t){return t[0]})).join("; "),".")}}},{key:"getFootnotes",value:function(t){var e,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],r=arguments.length>2?arguments[2]:void 0,i=r?[]:f()(t).flatMap((function(t){var e,n;return t.metric?null!==(e=t.metric.metadata)&&void 0!==e&&e.footnote?[{metric:t.metric.name,data:t.metric.metadata.footnote}]:null!=t&&null!==(n=t.metric)&&void 0!==n&&n.datasets?t.metric.datasets.flatMap((function(e){var n;return(null===(n=e.meta)||void 0===n?void 0:n.map((function(e){return tn(tn({},e),{},{metric:t.metric.name})})).filter((function(t){return"footnote"===t.type.toLowerCase()})))||[]})):[]:[]})).uniqBy((function(t){return"".concat(t.metric," | ").concat(t.data)})).value(),o=n.concat(i);return{footnotes:f()(o).groupBy((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.title,n=void 0===e?"":e,r=t.metric,i=void 0===r?n:r;return i})).entries().value(),summary:null==o||null===(e=o[0])||void 0===e?void 0:e.data}}}]),t}(),nn=function(){function t(e){a()(this,t),this.container=e.append("div").classed("below",!0).classed("tooltip-wrapper",!0),this.container.append("div").classed("tooltip-arrow",!0).classed("tooltip-shadow",!0);var n=this.container.append("div").classed("tooltip-content",!0);this.container.append("div").classed("tooltip-arrow",!0),n.append("div").classed("tooltip-title",!0),n.append("div").classed("tooltip-total",!0),n.append("div").classed("tooltip-subtitle",!0),n.append("div").classed("tooltip-grid",!0),this.rowFuncs={value:t.rowValue,annotationTitle:t.rowAnnotationTitle,annotationText:t.rowAnnotationText,keyValues:t.rowKeyValues,keyValueLeft:t.rowKeyValueLeft,bar:t.rowBar,breakdown:t.rowBreakdown},this.shouldShow=!1,this.fullTableWidth=4}return c()(t,[{key:"draw",value:function(t,e,n,r,i){var o=this,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:4,s=arguments.length>6?arguments[6]:void 0;this.drawHeader(n,i),this.drawTable(r,i),this.container.style("transform","translateX(".concat(t,"px)")),this.shouldShow=!0,requestAnimationFrame((function(){requestAnimationFrame((function(){var n=o.container.node().parentNode.getBoundingClientRect(),r=o.container.node().getBoundingClientRect();o.container.select("div.tooltip-content").style("transform","translate(".concat(Math.max(-r.width/2,-t)+Math.min(0,n.right+r.width/2-r.right),"px, ").concat("center"===s?"-50%":"0",")")),"below"===s||"above"!==s&&n.height-e+a+5+r.height>n.height?o.container.classed("below",!0).classed("above",!1).classed("centered",!1).style("bottom",null).style("top","".concat(e+a,"px")):"center"===s?o.container.classed("centered",!0).classed("below",!1).classed("above",!1).style("bottom",null).style("top","".concat(e+a,"px")):o.container.classed("above",!0).classed("below",!1).classed("centered",!1).style("top",null).style("bottom","".concat(n.height-e+a+5,"px")),o.shouldShow&&o.show()}))}))}},{key:"drawHeader",value:function(t,e){var n=t.title,r=t.total,i=t.subtitle,o=e.primaryColour;n?this.container.select("div.tooltip-title").style("color",n.colour||o||"black").text(n.value):this.container.select("div.tooltip-title").text(""),r?this.container.select("div.tooltip-total").style("color",r.colour||o||"black").text(r.value):this.container.select("div.tooltip-total").text(""),i?this.container.select("div.tooltip-subtitle").style("color",i.colour).text(i.value):this.container.select("div.tooltip-subtitle").text("")}},{key:"drawTable",value:function(t,e){var n=this,r=this.container.select(".tooltip-grid").selectAll("div.tooltip-row").data(t,(function(t){return"".concat(t.type,"-").concat(t.key)}));r.enter().append("div").classed("tooltip-row",!0),r.exit().remove(),this.container.select(".tooltip-grid").selectAll("div.tooltip-row").each((function(t){n.rowFuncs[t.type](C.select(this),t,e)})),this.container.classed("tooltip-large",!r.selectAll(".tooltip-bar").empty()||!r.selectAll(".tooltip-breakdown").empty())}},{key:"show",value:function(){this.container.classed("show",!0)}},{key:"hide",value:function(){this.container.classed("show",!1),this.shouldShow=!1}}],[{key:"colour",value:function(t,e){return t.colour||e||"black"}},{key:"rowValue",value:function(e,n,r){var i=r.primaryColour,o=e.select(".tooltip-value");o.empty()&&(o=e.append("div").classed("tooltip-value",!0)),n.html?o.html(n.value):o.style("color",t.colour(n,i)).text(n.value),n.styles&&Object.keys(n.styles).forEach((function(t){o.style(t,n.styles[t])}))}},{key:"rowAnnotationTitle",value:function(t,e){var n=t.select(".tooltip-annotation-title");n.empty()&&(n=t.append("div").classed("tooltip-annotation-title",!0)),n.text(e.value)}},{key:"rowAnnotationText",value:function(t,e){var n=t.select(".tooltip-annotation-text");n.empty()&&(n=t.append("div").classed("tooltip-annotation-text",!0)),n.text(e.value)}},{key:"rowKeyValues",value:function(e,n,r){var i=r.primaryColour;e.classed("shrink-left",!0),e.selectAll("div.tooltip-key").data(n.values,(function(t){return t.key})).join((function(t){var n=null;return t.each((function(t){var r=e.append("div").classed("tooltip-key",!0).datum(t);e.append("div").classed("tooltip-key-value",!0).datum(t),n=n?n.merge(r):r})),n}),(function(t){return t}),(function(t){t.each((function(t){e.selectAll("div.tooltip-key-value").filter((function(e){return t.key===e.key})).remove()})).remove()})).each((function(r){var o=e.selectAll("div.tooltip-key-value").style("color",t.colour(n,i)).filter((function(t){return r.key===t.key})).datum(r).text((function(t){return t.value}));r.styles&&Object.keys(r.styles).forEach((function(t){o.style(t,r.styles[t])}))})).text((function(t){return t.key})).each((function(t){var e=this;t.styles&&Object.keys(t.styles).forEach((function(n){C.select(e).style(n,t.styles[n])}))}))}},{key:"rowKeyValueLeft",value:function(e,n,r){var i=r.primaryColour,o=e.select(".tooltip-value-left");o.empty()&&(o=e.append("div").classed("tooltip-value-left",!0));var a=e.select(".tooltip-key-left");a.empty()&&(a=e.append("div").classed("tooltip-key-left",!0)),e.select(".tooltip-key-left").text(n.key),e.select(".tooltip-value-left").style("color",t.colour(n,i)).text(n.value)}},{key:"rowBar",value:function(e,n,r){var i=r.primaryColour,o=e.select(".tooltip-bar");o.empty()&&(o=e.append("div").classed("tooltip-bar",!0),o.append("div").classed("tooltip-bar-back",!0),o.append("div").classed("tooltip-bar-percent",!0)),o.select(".tooltip-bar-percent").style("transform","translate(-".concat(50*(1-n.value),"%, 0) scaleX(").concat(n.value,")")).style("background",t.colour(n,i))}},{key:"rowBreakdown",value:function(e,n,r){var i=r.primaryColour,o=r.secondaryColour,a=e.select(".tooltip-breakdown-left");a.empty()&&((a=e.append("div").classed("tooltip-breakdown-left",!0)).append("div").classed("tooltip-breakdown-title",!0),a.append("div").classed("tooltip-breakdown-total",!0));var s=e.select(".tooltip-breakdown-right");s.empty()&&(s=e.append("div").classed("tooltip-breakdown-right",!0)),a.select(".tooltip-breakdown-title").text(n.key),a.select(".tooltip-breakdown-total").style("color",t.colour(n,i)).text(n.value),s.selectAll("div").remove(),s.selectAll("div.breakdown-row-value").data(n.breakdown,(function(t){return t.key})).join((function(t){t.each((function(t){s.append("div").classed("breakdown-row-sign",!0).datum(t),s.append("div").classed("breakdown-row-value",!0).datum(t),s.append("div").classed("breakdown-row-key",!0).datum(t)}))}),(function(t){return t}),(function(t){t.each((function(t){s.selectAll("div.breakdown-row-sign").filter((function(e){return t.key===e.key})).remove(),s.selectAll("div.breakdown-row-key").filter((function(e){return t.key===e.key})).remove()})).remove()}));var c=s.selectAll("div.breakdown-row-value");c.each((function(e){s.selectAll("div.breakdown-row-key").filter((function(t){return e.key===t.key})).datum(e).text((function(t){return" ".concat(t.key)})),s.selectAll("div.breakdown-row-sign").filter((function(t){return e.key===t.key})).datum(e).style("color",t.colour(n,o)).text((function(t){return t.sign||""}))})),c.style("color",t.colour(n,o)).text((function(t){return t.value}))}}]),t}(),rn=function(){function t(){a()(this,t),this.actions={},this.cache={}}return c()(t,[{key:"on",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if("function"!=typeof e)throw new Error("Callback for event ".concat(t," is not a function"));this.actions[t]=e,n&&Object.prototype.hasOwnProperty.call(this.cache,"tag")&&e(this.cache[t])}},{key:"trigger",value:function(t,e,n){var r=this,i=Object.keys(this.actions).filter((function(e){return e.startsWith(t)}));return this.cache[t]=e,0!==i.length&&(i.forEach((function(t){r.actions[t](e,n)})),!0)}},{key:"hasAction",value:function(t){return Object.keys(this.actions).filter((function(e){return e.startsWith(t)})).length>0}}]),t}(),on=["data"];function an(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function sn(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?an(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):an(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function cn(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}function ln(t,e,n){var r=t.params.tooltipOptions,i=r.tooltipStyle,o=void 0===i?"bubble":i,a=r.hoverStyle,s=void 0===a?null:a,c=this.getHoverDatum(t,this.delaunays,e,n,s),l=this.svg.selectAll("circle.".concat(this.cssPrefix,"-circle"));if(c){var u=c.datum,d=c.xDiff,f=c.yDiff,h=function(t){return t.dataset===u.dataset&&t.key.getTime()===u.key.getTime()};this.tooltip&&("scrub"===o?this.showScrub(e,l,h):this.tooltipDatum=this.showTooltip(t,u,l,h,{xDiff:d,yDiff:f})),this.trigger("point",u)}else this.showLastPoint(t),this.hideTooltip(),this.svg.select(".".concat(this.cssPrefix,"-scrub")).style("opacity",0),this.trigger("point",null)}function un(t,e,n){var r=this,i=t.params,o=t.params.tooltipOptions.hoverStyle,a=void 0===o?null:o,s=this.getHoverDatum(t,this.lineDelaunays,e,n,a);if(!s)return this.showLastPoint(t),void this.hideTooltip();var c=s.datum,l=this.dataSelector(c.metric,i),u=!1;this.group.select(".".concat(this.cssPrefix,"-chart")).selectAll("path.".concat(this.cssPrefix,"-line")).each((function(e){(c.metric.selector?e.selector===c.metric.selector:e.id===c.metric.id&&r.dataSelector(e,i)===l)&&(u=!0,r.setLineOpacity(t,null,l),r.setLegendOpacity(t,null,l),r.onlyDrawLabels(t,null,l),r.trigger("hover",e))})),u||(this.setLineOpacity(t),this.setLegendOpacity(t),this.onlyDrawLabels(t),this.trigger("hover",null))}function dn(t,e,n){var r=t.params,i=this.getHoverDatum(t,this.lineDelaunays,e,n);if(i){var o=i.datum,a=this.dataSelector(o.metric,r);a===this.highlighted[0]?(this.highlighted=[],this.trigger("click",null)):(this.highlighted=[a],this.trigger("click",o.metric))}else this.highlighted=[],this.trigger("click",null);this.drawContent(t)}var fn=function(t){Q()(s,t);var e,n,r,o=cn(s);function s(t,e,n,r,i){var c;return a()(this,s),(c=o.call(this)).chartType=m.LineChart,c.container=t,c.cssPrefix=i||"line-chart",c.yTicks=4,c.xTicks=8,c.width=n||1e3,c.height=r||500,c.circleR=5,c.maxHoverDistance=200,c.delaunays=null,c.isSubchart=e,c.preventMouseMove=!1,c.touchTimer=null,c.firstTouch=null,c.preventDefault=null,c.dragging=!1,c.tooltipDatum=null,c.highlighted=[],void 0===c.container?(c.draw=c.drawCanvas,Vt()(c)):(c.title=t.append("div").classed("chart-title",!0),c.subtitle=t.append("div").classed("chart-subtitle",!0),c.legend=t.append("div").classed("chart-legend",!0),c.svg=t.classed(c.cssPrefix,!0).classed("dh-chart-wrapper",!0).append("svg").classed(c.cssPrefix,!0).attr("viewBox","0 0 ".concat(c.width," ").concat(c.height)),c.defs=c.svg.append("defs"),c.group=c.svg.append("g").classed("".concat(c.cssPrefix,"-all"),!0),c.sourceContainer=c.container.append("div"),c.sources=new en(c.sourceContainer),c.tooltip=new nn(t),c.initGroups(),c.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;e!==c.width&&requestAnimationFrame((function(){c.resizeContent(e)}))}))})),c.ro.observe(t.node()),c)}return c()(s,[{key:"initGroups",value:(r=i()(u.a.mark((function t(){var e,n=this;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:this.group.append("g").classed("axis",!0).classed("y",!0),this.group.append("g").attr("class","axis y-labels"),this.group.append("g").classed("axis",!0).classed("x",!0),this.group.append("g").classed("".concat(this.cssPrefix,"-chart"),!0),this.group.append("path").classed("".concat(this.cssPrefix,"-delaunay"),!0),(e=this.group.append("g").classed("".concat(this.cssPrefix,"-overlay"),!0).on("mouseleave",(function(){n.preventDefault=null,n.firstTouch=null,n.showLastPoint(n.cachedParams),n.hideTooltip(),n.svg.select(".".concat(n.cssPrefix,"-scrub")).style("opacity",0),n.trigger("point",null),n.dragging=!1}),{passive:!0}).on("touchend",(function(){n.preventDefault=null,n.firstTouch=null,n.dragging&&(n.setLineOpacity(n.cachedParams),n.setLegendOpacity(n.cachedParams),n.onlyDrawLabels(n.cachedParams),n.showLastPoint(n.cachedParams),n.hideTooltip()),n.svg.select(".".concat(n.cssPrefix,"-scrub")).style("opacity",0),n.dragging=!1}))).append("line").classed("".concat(this.cssPrefix,"-scrub"),!0).style("opacity",0).classed("bold",!0),e.append("rect").classed("".concat(this.cssPrefix,"-mouse"),!0),this.legend.append("div").classed("legend-title",!0),this.legend.append("div").classed("legend-items",!0),Ze.call(this);case 11:case"end":return t.stop()}}),t,this)}))),function(){return r.apply(this,arguments)})},{key:"data",value:(n=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return i=r.data,o=r.parent,a=n.startDate||n.startYear,s=n.endDate||n.endYear,c=i.filter((function(t){return t.metric.data&&t.metric.data.length>0})).map((function(t,e){var n=t.metric.data.filter((function(e){var n=e.key,r=e.value;return!(null==r||a&&n<St(a,t.metric.xType)||s&&n>St(s,t.metric.xType))}));return sn(sn({},t),{},{metric:sn(sn({},t.metric),{},{data:n}),sortIndex:e})})),t.abrupt("return",{data:c,parent:o});case 10:case"end":return t.stop()}}),t,this)}))),function(t,e){return n.apply(this,arguments)})},{key:"colourFunction",value:function(t,e,n){return s.getChartStyleParam(n,"colourFunction")(this,t,e,n)}},{key:"dataSelector",value:function(t,e){return s.getChartStyleParam(e,"dataSelector").call(this,t)}},{key:"createYScale",value:function(t){var e=t.data,n=t.params,r=n.yDomain,i=n.yValues,o=n.margins;if(i){var a=[i[0],i.slice(-1)[0]];return C.scaleLinear().domain(a).range([this.height-o.bottom,o.top])}var s=f.a.flatMap(e,(function(t){return t.metric.data.map((function(t){var e=t.value;return Number(e)}))})),c=[f.a.min(s),f.a.max(s)];if(c[0]>=0&&c[1]>=0){var l=c[1]-c[0];c[0]-l<=0&&(c=[0,c[1]])}else if(c[0]<=0&&c[1]<=0){var u=c[0]-c[1];c[1]+u>=0&&(c=[c[0],0])}return this.height>300?this.yTicks=4:this.yTicks=3,C.scaleLinear().domain(r||c).range([this.height-o.bottom,o.top]).nice(this.yTicks)}},{key:"maxYAxisOffset",value:function(){return Math.min(80,.12*this.width)}},{key:"yAxisOffset",value:function(t,e){var n=t.params,r=n.fontSize,i=n.hideAxisLabels,o=n.margins,a=n.yValueLabels,s=a?function(t,e,n){var r="".concat(n,"px ").concat(nt),i=Object.values(t).flatMap((function(t){return Mt(t,e,r,3)})),o=Object(R.createCanvas)(300,300).getContext("2d");return o.font=r,f.a.max(i.map((function(t){return o.measureText(t).width})))+10}(a,this.maxYAxisOffset(),r):function(t,e,n){var r=Object(R.createCanvas)(300,300).getContext("2d");r.font="".concat(n,"px ").concat(nt);var i=Pt(t);return f.a.max(e.map((function(t){return r.measureText(i(t,{ticks:e})).width})))}(t,e.ticks(this.yTicks),r),c=void 0===o.fixedAxis?s:parseFloat(o.fixedAxis);return!0===i||"y"===i?0:c}},{key:"createXScale",value:function(t,e,n){var r=t.data,i=t.params,o=i.xDomain,a=i.margins,s=Math.max(n,a.minRightLabel),c=this.width-a.right-s-10,l=f.a.flatMap(r,(function(t){return f.a.map(t.metric.data,"key")})),u=[f.a.min(l),f.a.max(l)];return C.scaleUtc().domain(o||u).range([a.left+this.yAxisOffset(t,e)+a.xAxis,c])}},{key:"createScales",value:function(t,e){var n=this.createYScale(t);return{xScale:this.createXScale(t,n,e),yScale:n}}},{key:"strokeWidth",value:function(t,e){return s.getChartStyleParam(e,"strokeWidth")(t,e,this.isSubchart)}},{key:"getLabel",value:function(t,e,n,r){var i=r.hideLineLabels,o=r.useStateAbbreviations;if(i)return"";var a=function(t,e,n){return void 0!==t.labelText?t.labelText:"states"===n?t.metric.geo_name:"metrics"===n?t.metric.name:"categories"===n?t.metric.geo_name:e&&void 0!==t.metric.lexiconName?t.metric.lexiconName:!e&&t.metric.geo_name&&"US"!==t.metric.geo_id?t.metric.geo_name:t.metric.name}(t,e,n);return o||this.width<650?Jt(a):a}},{key:"draw",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=c.length>1&&void 0!==c[1]?c[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=7;break}return this.trigger("dataLoaded",!1),t.abrupt("return",!1);case 7:return i=r.data,o=r.parent,a=Be({data:i,parent:o,options:n}),s={data:i,parent:o,params:a},this.drawContent(s),this.trigger("finishDraw"),this.trigger("dataLoaded",!0),t.abrupt("return",!0);case 14:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})},{key:"redrawContent",value:function(){this.cachedParams&&this.drawContent(this.cachedParams)}},{key:"resizeContent",value:function(t){this.cachedParams&&this.width!==t&&this.drawContent(this.cachedParams,!1)}},{key:"handleMouseEvent",value:function(t,e,n){var r=this,i=t.data,o=w()(t,on);this.touchTimer=null;var a=e.clientX,s=e.clientY;e.touches&&(a=e.touches[0].clientX,s=e.touches[0].clientY);var c=this.svg.select(".".concat(this.cssPrefix,"-mouse")).node().getBoundingClientRect();a<c.left&&(a=c.left),a>c.right&&(a=c.right);var l,u,d,f,h=e.target.ownerSVGElement.getBoundingClientRect(),p=h.top,g=h.left,m=this.getHoverDatum(t,this.delaunays,a-g,s-p),y=!1;"click"===e.type&&(m&&(l=this,u=m.datum,f=l.tooltipDatum,!l.dragging&&f&&u&&u.dataset===f.dataset&&u.key.getTime()===(null===(d=f.key)||void 0===d?void 0:d.getTime()))&&(this.hideTooltip(),y=!0),dn.call(this,t,a-g,s-p));var v=i.filter((function(t){return r.isHighlighted(t,o.params)}));y||"click"===e.type&&!o.params.tooltipOnTap||ln.call(this,sn({data:v},o),a-g,s-p),"click"!==e.type&&un.call(this,t,a-g,s-p),n.forEach((function(e){e(t,a-g,s-p)}))}},{key:"setPreventDefault",value:function(t){if(null!==this.preventDefault)return this.preventDefault;if(null!==this.firstTouch){var e=t.touches[0];return Math.abs(e.pageX-this.firstTouch.pageX)>Math.abs(e.pageY-this.firstTouch.pageY)?(this.preventDefault=!0,!0):(this.preventDefault=!1,!1)}return null}},{key:"setHoverListener",value:function(t){for(var e=this,n=arguments.length,r=new Array(n>1?n-1:0),i=1;i<n;i++)r[i-1]=arguments[i];this.group.select(".".concat(this.cssPrefix,"-mouse")).on("contextmenu",(function(t){t.preventDefault()})).on("touchstart",(function(n){e.preventMouseMove=!0;var i=n.touches;e.firstTouch=i.length?i[0]:null,e.touchTimer||(e.touchTimer=setTimeout((function(){e.handleMouseEvent(t,n,r)}),500))}),{passive:!0}).on("mousemove touchmove",f.a.throttle((function(n){return e.preventMouseMove?e.preventMouseMove=!1:"touchmove"!==n.type?e.handleMouseEvent(t,n,r):e.setPreventDefault(n)&&(e.dragging=!0,n.preventDefault(),n.stopPropagation(),e.handleMouseEvent(t,n,r)),clearTimeout(e.touchTimer),e.touchTimer=null,!1}),1e3/60,{trailing:!1}),{passive:!1})}},{key:"setClickListener",value:function(t){for(var e=this,n=arguments.length,r=new Array(n>1?n-1:0),i=1;i<n;i++)r[i-1]=arguments[i];this.group.select(".".concat(this.cssPrefix,"-mouse")).on("click",(function(n){e.handleMouseEvent(t,n,r)}))}},{key:"setHovered",value:function(t){this.cachedParams&&(this.setLineOpacity(this.cachedParams,"externalHoverOpacities",t),this.onlyDrawLabels(this.cachedParams,"externalHoverOpacities",t),this.setLegendOpacity(this.cachedParams,"externalHoverOpacities",t))}},{key:"onlyDrawLabels",value:function(t,e,n){var r=this,i=t.data,o=t.params,a=!this.showLegend(o)&&(!this.isSubchart||i.length>1),s=Math.min(150,.4*this.width),c=void 0===o.margins.maxRightLabel?s:o.margins.maxRightLabel,l=yt(i,o),u=i.map((function(t){return r.getLabel(t,r.isSubchart,l,o)})),d=Te(u,c,o.fontSize);this.drawLabels({data:i,params:o},this.yScale,this.xScale.range()[1]+10,c,d,a,n,!1,e)}},{key:"showLegend",value:function(t){return!0===t.showLegend||null===t.showLegend&&this.width<=768}},{key:"drawContent",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.cachedParams=t;var r=t.data,i=t.params,o=null!=n?n:i.transition,a=i.titleVerticalPosition,c=i.hideTitle,l=i.showSourcesAndFootnotes,u=i.heightToWidthRatio,d=i.margins,f=i.fontSize,h=i.yValueExtraLabels,p=i.startDate,g=i.endDate,m=i.areaFill,y=i.annotateEnd,v=i.info,b=i.hideTooltip;if(this.width=this.container.node().getBoundingClientRect().width,0===this.highlightedData(t).length&&(this.highlighted=[]),"top"===a?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node()),this.container.node().insertBefore(this.subtitle.node(),this.svg.node()),this.container.node().insertBefore(this.legend.node(),this.svg.node())):"bottom"===a&&(this.title.classed("below",!0),this.container.node().insertBefore(this.legend.node(),this.svg.node()),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node()),this.container.node().append(this.sourceContainer.node())),c||Nt.call(this,this.title,this.subtitle,t),this.drawLegend(t,this.showLegend(i)),l&&this.sources.draw(r,i),u)this.height=u*this.width;else{var k=this.title.node().getBoundingClientRect(),w=k.height,x=this.subtitle.node().getBoundingClientRect(),A=x.height,S=this.legend.node().getBoundingClientRect(),O=S.height,E=this.sourceContainer.node().getBoundingClientRect(),M=E.height,R=this.container.node().getBoundingClientRect(),j=R.height;this.height=j-w-A-O-M}C.select(this.svg.node()).attr("viewBox","0 0 ".concat(this.width," ").concat(this.height));var I=!this.showLegend(i)&&(!this.isSubchart||r.length>1),B=Math.min(150,.4*this.width),D=void 0===d.maxRightLabel?B:d.maxRightLabel,F=yt(r,i),P=r.map((function(t){return e.getLabel(t,e.isSubchart,F,i)})),z=Te(P,D,f),Q=this.createScales({data:r,params:i},I?z.width:0),L=Q.xScale,Y=Q.yScale;this.xScale=L,this.yScale=Y;var W=h?"".concat(this.yAxisOffset({data:r,params:i},this.yScale)+d.xAxis,"px"):null;this.title.style("margin-left",W),this.legend.style("margin-left",W);var q=s.getChartStyleParam(i,"dataSelector");this.allDataPoints=Gt(r,p,g,r[0]?r[0].metric.xType:"years",q),this.group.select(".".concat(this.cssPrefix,"-mouse")).attr("x",L.range()[0]-10).attr("y",Y.range()[1]-10),this.setHoverListener(t),this.group.select(".".concat(this.cssPrefix,"-mouse")).on("mouseleave",(function(){e.trigger("hover",null),e.setLineOpacity(t),e.onlyDrawLabels(t),e.setLegendOpacity(t)})),this.setClickListener(t),this.delaunays=Oe(t,L,Y,(function(t){return e.isHighlighted(t,i)}),q),this.lineDelaunays=Oe(t,L,Y,q);var N=Math.max(0,L.range()[1]-L.range()[0]),G=Math.max(0,Y.range()[0]-Y.range()[1]);this.svg.select(".".concat(this.cssPrefix,"-mouse")).attr("width",N>0?N+20:0).attr("height",G>0?G+20:0),this.svg.select(".".concat(this.cssPrefix,"-scrub")).attr("y1",Y.range()[0]).attr("y2",Y.range()[1]);var J=m&&1===r.length,U=this.newDefsID(r),K="".concat(this.cssPrefix,"-area-gradient-").concat(U),H="".concat(this.cssPrefix,"-mask-wipein-").concat(U);this.drawArea(t,J,K);var V=y?24:10;this.drawLabels(t,Y,L.range()[1]+V,D,z,I,null,o),this.drawLines(t,L,Y,J,H,o),y&&this.drawEndAnnotations(t,L,Y),this.drawAxes(t,L,Y),v&&"chart"===v.position&&!this.isSubchart&&T.inChart(this.container,i),b&&(this.tooltip=null)}},{key:"newDefsID",value:function(t){for(var e=0,n="".concat(this.cssPrefix,"-area-gradient"),r="".concat(t.map((function(t){return t.metric.id})).join("-"),"-").concat(e),i="".concat(n,"-").concat(r),o=C.select("#".concat(i));!o.empty()&&e<1e3;)e+=1,r="".concat(r.split("-").slice(0,-1).join("-"),"-").concat(e),i="".concat(n,"-").concat(r),o=C.select("#".concat(i));return r}},{key:"drawArea",value:function(t,e,n){var r=this,i=t.data,o=t.params,a=C.area().x((function(t){return r.xScale(t.key)})).y0(this.yScale.range()[0]).y1((function(t){return r.yScale(t.value)})),s=this.svg.select("g.".concat(this.cssPrefix,"-chart")),c=this.defs.select("linearGradient"),l=s.select("path.".concat(this.cssPrefix,"-area"));l.empty()&&((c=this.defs.append("linearGradient").attr("gradientUnits","userSpaceOnUse").attr("x1",0).attr("x2",0).attr("y1",0).attr("y2",this.yScale.range()[0])).append("stop").classed("gradient-primary",!0).attr("offset",0),c.append("stop").attr("offset","100%").attr("stop-color","rgb(247,250,253)"),l=s.append("path").classed("".concat(this.cssPrefix,"-area"),!0)),c.attr("y2",this.yScale.range()[0]),c.select(".gradient-primary").attr("stop-color",this.colourFunction(i[0],0,o)),c.attr("id",n),l.datum(i[0].metric.data).attr("d",(function(t){return a(t)})).attr("fill",e?"url(#".concat(n,")"):"rgba(255,255,255,0)")}},{key:"drawLabels",value:function(t,e,n,r,i,o){var a=this,c=t.data,l=t.params,u=i.fontSize,d=i.fontWeight,h=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,p=arguments.length>7&&void 0!==arguments[7]&&arguments[7],g=arguments.length>8&&void 0!==arguments[8]?arguments[8]:"lineHoverOpacities",m=s.getChartStyleParam(l,"showInactiveLabels"),y=m?c:this.highlightedLabels({data:c,params:l},h),v=this.svg.select("g.".concat(this.cssPrefix,"-chart")),b=yt(c,l),k=[];o&&(k=y.map((function(t){var n=a.getLabel(t,a.isSubchart,b,l),i=void 0!==t.labelText,o=t.metric.data.slice(-1)[0];return sn({text:Mt(n,r,"".concat(d," ").concat(u,"px ").concat(nt),i?1/0:2),y:e(o?o.value:0),dataset:a.dataSelector(t,l)},t)})));var w=this.defs.select("mask").empty(),x=v.selectAll("text.".concat(this.cssPrefix,"-label")).data(De(k,{maxY:e.range()[0],fontSize:u,labelLineHeight:.9}),(function(t){return a.dataSelector(t,l)})).join((function(t){var e=t.append("text").style("fill",(function(t,e){return a.colourFunction(t,t.sortIndex||e,l)})).attr("x",n).attr("y",(function(t){return t.y}));return p&&!w&&e.style("opacity",0),e}),(function(t){return t})).classed("".concat(this.cssPrefix,"-label"),!0);x.on("mousemove",f.a.throttle((function(t,e){return a.onLabelHover(a.cachedParams,e)}),1e3/60,{trailing:!1})).on("mouseout",(function(){a.preventMouseMove||(a.showLastPoint(a.cachedParams),a.hideTooltip()),a.setLineOpacity({data:c,params:l},g),a.setLabelOpacity({data:c,params:l},g),a.setLegendOpacity({data:c,params:l},g),a.dragging=!1})).on("click",(function(t,e){a.onLabelClick(a.cachedParams,e)})).style("font-size","".concat(u,"px")).style("font-weight",d).style("display",this.isSubchart&&1===c.length?"none":null);var A=x.selectAll("tspan").data((function(t){return t.text})).join((function(t){return t.append("tspan").attr("x",n)}),(function(t){return t}),(function(t){p?t.call((function(t){return t.transition().duration(1e3).style("opacity",0).on("end",(function(){return t.remove()}))})):t.remove()})).text((function(t){return t}));p?(x.transition("labelMove").duration(1e3).style("fill",(function(t,e){return a.colourFunction(t,t.sortIndex||e,l)})).attr("y",(function(t){return t.y})),A.transition("spanMove").duration(1e3).attr("dy",(function(t,e){return e?"".concat(.9,"em"):null})).attr("x",n)):(x.style("fill",(function(t,e){return a.colourFunction(t,t.sortIndex||e,l)})).attr("y",(function(t){return t.y})),A.attr("dy",(function(t,e){return e?"".concat(.9,"em"):null})).attr("x",n));var S=v.selectAll("text.".concat(this.cssPrefix,"-label"));return w?(l.intro?S.style("opacity",0):p&&S.style("opacity",(function(t){return a.getLabelOpacity(t,{data:c,params:l},null,g)})),S.attr("x",n).attr("y",(function(t){return t.y}))):l.intro&&v.attr("mask")?S.style("opacity",0).attr("x",n).attr("y",(function(t){return t.y})):p?S.transition("fadeIn").duration(1e3).style("opacity",(function(t){return a.getLabelOpacity(t,{data:c,params:l},null,g)})).attr("x",n).attr("y",(function(t){return t.y})):S.style("opacity",(function(t){return a.getLabelOpacity(t,{data:c,params:l},null,g)})).attr("x",n).attr("y",(function(t){return t.y})),S}},{key:"onLabelHover",value:function(t,e){var n=this,r=t.data,i=t.parent,o=t.params;if(this.preventMouseMove)this.preventMouseMove=!1;else{var a=this.dataSelector(e,o);if(this.setLineOpacity({data:r,params:o},"externalHoverOpacities",a),this.setLabelOpacity({data:r,params:o},"externalHoverOpacities",a),this.setLegendOpacity({data:r,params:o},"externalHoverOpacities",a),this.tooltip){var s=f.a.find(r,(function(t){return n.dataSelector(t,o)===e.dataset})),c=f()(s.metric.data).maxBy("key"),l=this.svg.selectAll("circle.".concat(this.cssPrefix,"-circle"));this.tooltipDatum=this.showTooltip({data:r,parent:i,params:o},sn(sn({},e),c),l,(function(t){return t.dataset===e.dataset&&t.key.getTime()===c.key.getTime()}),{xDiff:null,yDiff:null})}}}},{key:"onLabelClick",value:function(t,e){var n=t.params;if(e){var r=this.dataSelector(e,n);r===this.highlighted[0]?(this.highlighted=[],this.trigger("click",null)):(this.highlighted=[r],this.trigger("click",e))}else this.highlighted=[],this.trigger("click",null);this.showLastPoint(this.cachedParams),this.hideTooltip(),this.drawContent(t)}},{key:"getEntryOpacity",value:function(t,e,n,r){var i,o=e.data,a=e.params,c=null!==(i=s.getChartStyleParam(a,n))&&void 0!==i?i:s.getChartStyleParam(a,"lineHoverOpacities");return this.getEntryOpacityFromOpacities(t,{data:o,params:a},c,r)}},{key:"getEntryOpacityFromOpacities",value:function(t,e,n,r){var i=this,o=e.data,a=e.params,s=o.map((function(t){return i.dataSelector(t,a)}));return this.isHighlighted(t,a)?s.includes(this.dataSelector(t,a))?n.active:0:this.dataSelector(t,a)===r?n.hovered:n.inactive}},{key:"getLabelOpacity",value:function(t,e,n,r){var i=e.data,o=e.params;return o.labelOpacities?this.getEntryOpacityFromOpacities(t,{data:i,params:o},o.labelOpacities,r):this.getEntryOpacity(t,{data:i,params:o},n,r)}},{key:"setLineOpacity",value:function(t,e,n){var r=this,i=t.data,o=t.params,a=this.highlighted;Array.isArray(o.highlighted)&&(a=a.concat(o.highlighted));var s={data:this.highlightedData({data:i,params:o},n),params:o};this.group.select(".".concat(this.cssPrefix,"-chart")).selectAll("g.".concat(this.cssPrefix,"-series")).sort((function(t,e){var n=r.isHighlighted(t,o),i=r.isHighlighted(e,o);return n||i?n&&!i?1:!n&&i?-1:a.indexOf(r.dataSelector(e,o))-a.indexOf(r.dataSelector(t,o)):0})).style("opacity",(function(t){return r.getEntryOpacity(t,s,e,n)}))}},{key:"setLabelOpacity",value:function(t,e,n){var r=this,i=t.data,o=t.params;this.svg.select("g.".concat(this.cssPrefix,"-chart")).selectAll("text.".concat(this.cssPrefix,"-label")).style("opacity",(function(t){return r.getLabelOpacity(t,{data:i,params:o},e,n)}))}},{key:"setLegendOpacity",value:function(t,e,n){var r=this,i=t.data,o=t.params;this.legend.select(".legend-items").selectAll("div.chart-legend-item").style("opacity",(function(t){return r.getEntryOpacity(t,{data:i,params:o},e,n)}))}},{key:"drawLines",value:function(t,e,n){var r=this,i=t.data,o=t.params,a=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=arguments.length>4?arguments[4]:void 0,c=arguments.length>5&&void 0!==arguments[5]&&arguments[5],l=this.svg.select("g.".concat(this.cssPrefix,"-chart")),u=C.line().x((function(t){return e(t.key)})).y((function(t){return n(t.value)})),d=this.defs.select("mask").empty();d&&this.defs.append("mask");var h=function(t){t.style("stroke","currentColor").attr("d",(function(t){var e=t.metric,n=f.a.sortBy(e.data,"key");return u(n)}))},p=l.selectAll("g.".concat(this.cssPrefix,"-series")).data(i,(function(t){return r.dataSelector(t,o)})).join((function(t){return t.append("g").style("opacity",(function(t){return c&&!d?0:r.getEntryOpacity(t,{data:i,params:o})}))}),(function(t){return t})).classed("".concat(this.cssPrefix,"-series"),!0).style("color",(function(t,e){return r.colourFunction(t,e,o)})),g=p.selectAll("path.".concat(this.cssPrefix,"-line")).data((function(t){return[t]})).join((function(t){return t.append("path").call(h).classed("".concat(r.cssPrefix,"-line"),!0)}),(function(t){return t})).style("stroke-linecap",a?"butt":"round").style("stroke-width",(function(t){return r.strokeWidth(t,o)})),m=p.selectAll("g.".concat(this.cssPrefix,"-annotation")).data((function(t,e){var n=t.metric,r=void 0===n?{}:n,i=t.id,a=r.data;return(void 0===a?[]:a).map((function(t){var n=Fe(o.annotations,t.key,i,r.xType,t.annotation);return n?sn(sn(sn({},t),n),{},{metricIndex:e}):null})).filter((function(t){return null!==t}))})).join((function(t){return t.append("g").call(h).classed("".concat(r.cssPrefix,"-annotation"),!0)}),(function(t){return t})).attr("transform",(function(t){var r=t.key,i=t.value;return"translate(".concat(e(r),", ").concat(n(i),")")})),y=10,v=5,b=1,k=8;if(m.selectAll("text.".concat(this.cssPrefix,"-annotation-text")).data((function(t){return[t]})).join("text").classed("".concat(this.cssPrefix,"-annotation-text"),!0).attr("y",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.position;return("below"===e?1:-1)*(y+b+k)})).style("dominant-baseline","middle").style("display",(function(t){return t.showOnChart?null:"none"})).text((function(t){return t.title})),m.selectAll("circle.".concat(this.cssPrefix,"-annotation-bg")).data((function(t){return[t]})).join("circle").classed("".concat(this.cssPrefix,"-annotation-bg"),!0).attr("r",y).attr("fill",o.annotationColour||"currentColor").attr("fill-opacity",.3).attr("stroke",o.annotationColour||"currentColor").style("stroke-width",b),m.selectAll("circle.".concat(this.cssPrefix,"-annotation-fg")).data((function(t){return[t]})).join("circle").classed("".concat(this.cssPrefix,"-annotation-fg"),!0).attr("fill",o.annotationColour||"currentColor").attr("r",v),o.intro)if(d){l.attr("mask","url(#".concat(s,")"));var w=this.defs.select("mask").attr("id",s);w.append("rect").attr("x",0).attr("y",0).attr("width",0).attr("height",5e3).attr("fill","white").transition("wipeIn").ease(C.easeLinear).duration(3e3).attrTween("width",(function(){return function(t){var e=r.xScale.range()[1];return C.interpolate(0,e)(t)}})).on("end",(function(){l.attr("mask",null),l.selectAll("text.".concat(r.cssPrefix,"-label")).transition().duration(1e3).style("opacity",1)})),g.call(h)}else l.attr("mask")?(this.defs.select("mask").select("rect").attr("width",this.xScale.range()[1]),g.call(h)):l.attr("mask",null);return c&&!d?(p.transition("lineStyle").duration(1e3).style("opacity",(function(t){return r.getEntryOpacity(t,{data:i,params:o})})).style("color",(function(t,e){return r.colourFunction(t,e,o)})),g.transition("lineStyle").duration(1e3).attrTween("d",(function(t,e,n){var r=t.metric,i=C.select(n[e]).attr("d"),o=f.a.sortBy(r.data,"key");return pe(i,u(o))}))):(p.style("opacity",(function(t){return r.getEntryOpacity(t,{data:i,params:o})})).style("color",(function(t,e){return r.colourFunction(t,e,o)})),g.call(h)),this.drawCircles(l,i,o,d,c),g}},{key:"drawCircles",value:function(t,e,n,r){var i=this,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4],a={};e.forEach((function(t,e){a[i.dataSelector(t,n)]=e}));var s=function(t){return"".concat(i.dataSelector(t,n),"-").concat(t.fromEnd)},c=function(t){t.attr("cx",(function(t){return i.xScale(t.key)})).attr("cy",(function(t){return i.yScale(t.value)}))},l=t.selectAll("circle.".concat(this.cssPrefix,"-circle")).data(this.delaunays.points,(function(t){return s(t)})).join((function(t){return t.append("circle").call(c)}),(function(t){return t})).classed("".concat(this.cssPrefix,"-circle"),!0).classed("always-visible",n.circlesVisible).attr("fill",(function(t){return i.colourFunction(t.metric,a[i.dataSelector(t.metric,n)],n)})).attr("r",this.circleR);o&&!r?l.transition("circleStyle").duration(1e3).call(c):l.call(c),this.showLastPoint({params:n})}},{key:"showLastPoint",value:function(t){var e=this.svg.selectAll("circle.".concat(this.cssPrefix,"-circle"));t&&t.params.showLastPoint?e.classed("visible",(function(t){return 0===t.fromEnd})):e.classed("visible",!1)}},{key:"drawLegend",value:function(t){var e=this,n=t.data,r=t.params,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=yt(n,r),a=s.getChartStyleParam(r,"legendShowBox"),c=s.getChartStyleParam(r,"legendSortOrder"),l=[];i&&(l=n.map((function(t){return sn(sn({},t),{},{legendLabelText:e.getLabel(t,e.isSubchart,o,r),dataset:e.dataSelector(t,r),legendShowBox:!a||a(e,t,r)})})),c&&l.sort(c)),this.legend.style("display",i?null:"none");var u=this.legend.select(".legend-items"),d=u.selectAll("div.chart-legend-item").data(l,(function(t){return e.dataSelector(t,r)})).join((function(t){var e=t.append("div").classed("chart-legend-item",!0);return e.append("div").classed("legend-box",!0),e.append("div").classed("legend-label",!0),e.append("div").classed("legend-item-overlay",!0),e}),(function(t){return t}));d.on("touchstart",(function(){e.preventMouseMove=!0})).on("mousemove",f.a.throttle((function(t,n){e.onLabelHover(e.cachedParams,n)}),1e3/60,{trailing:!1})).on("mouseout",(function(){e.showLastPoint(e.cachedParams),e.hideTooltip(),e.setLineOpacity({data:n,params:r}),e.setLabelOpacity({data:n,params:r}),e.setLegendOpacity({data:n,params:r}),d.style("opacity",(function(t){return e.getEntryOpacity(t,{data:n,params:r})}))})).on("click",(function(t,n){e.onLabelClick(e.cachedParams,n)})),d.each((function(t,e){var n=d.selectAll(".legend-box").nodes()[e],r=d.selectAll(".legend-label").nodes()[e],i=d.selectAll(".legend-item-overlay").nodes()[e];C.select(n).datum(t),C.select(r).datum(t),C.select(i).datum(t)}));var h=function(t){return!1!==t.showLegendBox?.75*r.fontSize:0};d.style("opacity",(function(t){return e.getEntryOpacity(t,{data:l,params:r})})),d.select("div.legend-label").text((function(t){return t.legendLabelText})).style("font-size","".concat(r.fontSize,"px")).style("color",(function(t){return e.colourFunction(t,t.sortIndex,r)})),d.select("div.legend-box").style("width",(function(t){return"".concat(h(t),"px")})).style("height","".concat(.75*r.fontSize,"px")).style("background-color",(function(t){return e.colourFunction(t,t.sortIndex,r)})),d.select(".legend-item-overlay").style("width",(function(t,e,n){var r=n[e].parentElement.querySelector(".legend-label");return"".concat(r.getBoundingClientRect().width+h(t)+10,"px")})).style("height","".concat(1.5*r.fontSize,"px")),d.exit().remove(),this.legend.select(".legend-title").text("Select a line")}},{key:"drawEndAnnotations",value:function(t,e,n){var r=this,i=t.data,o=t.params,a=this.svg.select("g.".concat(this.cssPrefix,"-chart")),s=i.map((function(t){return sn({metric:{id:t.metric.id},fips:t.fips},t.metric.data[t.metric.data.length-1])}));a.selectAll("circle.".concat(this.cssPrefix,"-end-annotation-bg")).data(s,(function(t){return r.dataSelector(t,o)})).join("circle").classed("".concat(this.cssPrefix,"-annotation-bg"),!0).attr("cx",(function(t){return e(t.key)})).attr("cy",(function(t){return n(t.value)})).attr("r",16).attr("fill",(function(t,e){return o.annotationColourEnd||r.colourFunction(t,e,o)})).attr("fill-opacity",.3).attr("stroke",(function(t,e){return o.annotationColourEnd||r.colourFunction(t,e,o)})).attr("stroke-opacity",1).style("stroke-width",2).style("stroke-dasharray","3,2"),a.selectAll("circle.".concat(this.cssPrefix,"-end-annotation-fg")).data(s,(function(t){return r.dataSelector(t,o)})).join("circle").classed("".concat(this.cssPrefix,"-annotation-fg"),!0).attr("cx",(function(t){return e(t.key)})).attr("cy",(function(t){return n(t.value)})).attr("opacity",1).attr("fill",(function(t,e){return o.annotationColourEnd||r.colourFunction(t,e,o)})).attr("r",5)}},{key:"createXAxis",value:function(t,e,n){var r=t.data,i=t.params,o=i.margins,a=i.xValues,s=i.xTickFormat,c=i.showXGridlines,l=f()(r).flatMap((function(t){return t.metric.data})).uniqBy((function(t){return t.key.getTime()})).map((function(t){return t.key})).value(),u=f.a.min(l),d=f.a.max(l),h=n.range(),p=M()(h,2),g=p[0],m=p[1],y=C.axisBottom(e).tickSize(c?g-m+o.xAxis:0),v=C.utcYear.count(u,d),b=C.utcMonth.count(u,d);if(a)y.tickValues(a);else if(v>1)y.ticks(v<this.xTicks?C.utcYear:this.xTicks),y.tickFormat((function(t){return C.utcFormat("%Y")(t)}));else if(1===v){y.ticks(b<this.xTicks?C.utcMonth:this.xTicks);var k=Number(this.width);y.tickFormat((function(t){return 0===t.getUTCMonth()?C.utcFormat("%Y")(t):C.utcFormat(k&&k>400?"%B":"%b")(t)}))}else if(b>1){y.ticks(b<this.xTicks?C.utcMonth:this.xTicks);var w=Number(this.width),x=w&&w>400?"%B":"%b";y.tickFormat((function(t){return C.utcFormat(x)(t)}))}else{y.ticks(C.utcWeek);var A=null;y.tickFormat((function(t){return t.getUTCMonth()!==A?(A=t.getUTCMonth(),C.utcFormat("%b %_d")(t)):C.utcFormat("%_d")(t)}))}s&&y.tickFormat(s);var S=c?m:g+o.xAxis;return this.svg.select(".axis.x").attr("transform","translate(0, ".concat(S,")")).call(y)}},{key:"createYAxis",value:function(t,e,n){var r=this,i=t.params,o=i.margins,a=i.yValues,s=e.range(),c=M()(s,2),l=c[0],u=c[1],d=C.axisLeft(n);a?d.tickValues(a).tickFormat((function(){return""})).tickSize(l-u-o.xAxis):d.ticks(this.yTicks).tickFormat((function(e){return Pt(t)(e,{ticks:n.ticks(r.yTicks)})})).tickSize(l-u);var f=this.svg.select(".axis.y").call(d);return a&&f.selectAll(".tick line").attr("transform","translate(".concat(-o.xAxis,", 0)")),f}},{key:"drawAxes",value:function(t,e,n){var r=t.params,i=r.margins,o=r.hideGridlines,a=r.showZeroLine,s=r.hideAxisLabels,c=r.axisTextColor,l=r.gridColor,u=r.fontSize,d=r.yValueLabels,f=e.range(),h=M()(f,2),p=h[0],g=h[1]-p;this.xTicks=g>760?8:g>400?4:g>180?3:2;var m=this.createXAxis(t,e,n);m.selectAll(".tick text").style("display",!0===s||"x"===s?"none":null).style("fill",c).style("font-size","".concat(u,"px"));var y=this.createYAxis(t,e,n);return y.selectAll(".tick line").classed("bold",(function(t){return!n.domain().includes(0)&&0===t})).classed("zero-line",(function(t){return 0===t})).style("display",(function(t){return a&&0===t?null:o?"none":null})).style("stroke",l),y.selectAll(".tick text").style("fill",c).style("display",!0===s||"y"===s?"none":null).style("font-size","".concat(u,"px")),this.svg.select(".axis.y").attr("transform","translate(".concat(p,", 0)")).selectAll("text").attr("x",-i.xAxis),d&&(Ae.call(this,t,e,n),xe.call(this,t,e,n)),{xAxis:m,yAxis:y}}},{key:"getHoverDatum",value:function(t,e,n,r,i){var o=t.data,a=i||(o.length>1?"2d":"x"),s=e[a],c=e.points[s.find(n,r)];if(!c)return null;var l=n-this.xScale(c.key),u=r-this.yScale(c.value);return"2d"!==a||Math.sqrt(Math.pow(l,2)+Math.pow(u,2))<=this.maxHoverDistance?{datum:c,xDiff:l,yDiff:u}:null}},{key:"showTooltip",value:function(t,e,n,r,i){var o,a,s,c=this,l=t.data,u=t.parent,d=t.params,f=t.params.tooltipOptions,h=f.title,p=f.position,g=l.findIndex((function(t){return c.dataSelector(t,d)===e.dataset})),m=l[g],y=n.filter(r);if(y.empty())return null;var v=y.node().getBoundingClientRect().left;n.classed("visible",r);var b=this.svg.node().getBoundingClientRect(),k=this.container.node().getBoundingClientRect(),w=this.circleR,x=b.top-k.top+this.yScale(e.value)+w,A=Ft({data:[m],parent:u,params:d}),S=(h||m.metric.lexiconName||m.metric.name)+(m.metric.geo_id&&"US"!==m.metric.geo_id?" in ".concat(m.metric.geo_name):""),O=i.yDiff,E=p||(O<0?"below":"above"),M={title:{value:null!==(o=null!==(a=e.tooltipTitle)&&void 0!==a?a:null===(s=e.metric)||void 0===s?void 0:s.tooltipTitle)&&void 0!==o?o:S},subtitle:{value:Ot(e.key,m.metric.xType)}},C=Fe(d.annotations,e.key,m.id,m.metric.xType,e.annotation),R=[];return C&&C.title&&R.push({type:"annotationTitle",value:C.title}),C&&C.text&&R.push({type:"annotationText",value:C.text}),"scrub"!==d.tooltipOptions.tooltipStyle&&this.tooltip.draw(v+w-b.left,x,M,[{type:"value",value:A(e.value)}].concat(R),{primaryColour:this.colourFunction(l[g],l[g].sortIndex,d)},4,E),e}},{key:"hideTooltip",value:function(){this.tooltip&&(this.tooltip.hide(),this.tooltipDatum=null)}},{key:"showScrub",value:function(t,e,n){e.classed("visible",n),this.svg.select(".".concat(this.cssPrefix,"-scrub")).attr("x1",t).attr("x2",t).style("opacity",1)}},{key:"isHighlighted",value:function(t,e){var n=this.highlighted;return Array.isArray(e.highlighted)&&(n=n.concat(e.highlighted)),0===n.length||n.includes(this.dataSelector(t,e))}},{key:"highlightedLabels",value:function(t,e){var n=this,r=t.data,i=t.params,o=this.highlightedData({data:r,params:i},e);return o.length>4&&(o=r.filter((function(t){return"default"===i.chartStyle.name||(!(!e||n.dataSelector(t,i)!==e)||Array.isArray(i.highlighted)&&t.selector&&i.highlighted.includes(t.selector))}))),o}},{key:"highlightedData",value:function(t,e){var n=this,r=t.data,i=t.params;return r.filter((function(t){return!(!e||n.dataSelector(t,i)!==e)||n.isHighlighted(t,i)}))}},{key:"drawCanvas",value:function(t,e,n,r){return Ve.call(this,t,e,n,r)}}],[{key:"getChartStyleParam",value:function(t,e){var n;return null!==(n=t.chartStyle[e])&&void 0!==n?n:ve.default[e]}}]),s}(rn);fn.margins={top:20,bottom:50,left:0,right:10,xAxis:10,minRightLabel:0,maxRightLabelRatio:void 0};var hn=n(2),pn=n.n(hn),gn=n(21),mn=n.n(gn),yn=function(t){var e=[],n=null,r=function(){for(var r=arguments.length,i=new Array(r),o=0;o<r;o++)i[o]=arguments[o];e=i,n||(n=requestAnimationFrame((function(){n=null,t.apply(void 0,e)})))};return r.cancel=function(){n&&(cancelAnimationFrame(n),n=null)},r},vn=n(34),bn=n.n(vn),kn=n(47),wn=n.n(kn),xn={debounce:bn.a,throttle:wn.a},An=function(t){return"function"==typeof t},Sn=function(){return"undefined"==typeof window},On=function(t){return t instanceof Element||t instanceof HTMLDocument};function En(t){return(En="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Mn(t,e){if(null==t)return{};var n,r,i=function(t,e){if(null==t)return{};var n,r,i={},o=Object.keys(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||(i[n]=t[n]);return i}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(t,n)&&(i[n]=t[n])}return i}function Cn(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function Rn(t,e){return(Rn=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function jn(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Dn(t);if(e){var i=Dn(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return In(this,n)}}function In(t,e){return!e||"object"!==En(e)&&"function"!=typeof e?Bn(t):e}function Bn(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Dn(t){return(Dn=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Tn(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var Fn=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Rn(t,e)}(o,t);var e,n,r,i=jn(o);function o(t){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,o),Tn(Bn(e=i.call(this,t)),"cancelHandler",(function(){e.resizeHandler&&e.resizeHandler.cancel&&(e.resizeHandler.cancel(),e.resizeHandler=null)})),Tn(Bn(e),"rafClean",(function(){e.raf&&e.raf.cancel&&(e.raf.cancel(),e.raf=null)})),Tn(Bn(e),"attachObserver",(function(){var t=e.props.targetRef;t&&t.current&&(e.targetRef.current=t.current);var n=e.getElement();n&&(e.observableElement&&e.observableElement===n||(e.observableElement=n,e.resizeObserver.observe(n)))})),Tn(Bn(e),"getElement",(function(){var t=e.props,n=t.querySelector,r=t.targetDomEl;if(!Sn()){if(n)return document.querySelector(n);if(r&&On(r))return r;if(e.targetRef&&On(e.targetRef.current))return e.targetRef.current;var i=Object(h.findDOMNode)(Bn(e));if(i)switch(e.getRenderType()){case"renderProp":case"childFunction":case"child":case"childArray":return i;default:return i.parentElement}}})),Tn(Bn(e),"createUpdater",(function(){return e.rafClean(),e.raf=yn((function(t){var n=t.width,r=t.height,i=e.props.onResize;An(i)&&i(n,r),e.setState({width:n,height:r})})),e.raf})),Tn(Bn(e),"createResizeHandler",(function(t){var n=e.state,r=n.width,i=n.height,o=e.props,a=o.handleWidth,s=o.handleHeight;if(a||s){var c=e.createUpdater();t.forEach((function(t){var n=t&&t.contentRect||{},o=n.width,l=n.height,u=a&&r!==o||s&&i!==l;!e.skipOnMount&&u&&!Sn()&&c({width:o,height:l}),e.skipOnMount=!1}))}})),Tn(Bn(e),"getRenderType",(function(){var t=e.props,n=t.render,r=t.children;return An(n)?"renderProp":An(r)?"childFunction":Object(hn.isValidElement)(r)?"child":Array.isArray(r)?"childArray":"parent"}));var n=t.skipOnMount,r=t.refreshMode,a=t.refreshRate,s=t.refreshOptions;e.state={width:void 0,height:void 0},e.skipOnMount=n,e.raf=null,e.unmounted=!1,e.targetRef=Object(hn.createRef)(),e.observableElement=null;var c=xn[r];return e.resizeHandler=c?c(e.createResizeHandler,a,s):e.createResizeHandler,e.resizeObserver=new _t.a(e.resizeHandler),e}return e=o,(n=[{key:"componentDidMount",value:function(){this.attachObserver()}},{key:"componentDidUpdate",value:function(){this.attachObserver()}},{key:"componentWillUnmount",value:function(){this.resizeObserver.disconnect(),this.rafClean(),this.cancelHandler(),this.unmounted=!0}},{key:"render",value:function(){var t=this.props,e=t.render,n=t.children,r=t.nodeType,i=this.state,o={width:i.width,height:i.height,targetRef:this.targetRef};switch(this.getRenderType()){case"renderProp":return e(o);case"childFunction":return n(o);case"child":if("string"==typeof n.type){var a=Mn(o,["targetRef"]);return Object(hn.cloneElement)(n,a)}return Object(hn.cloneElement)(n,o);case"childArray":return n.map((function(t){return!!t&&Object(hn.cloneElement)(t,o)}));default:return pn.a.createElement(r,null)}}}])&&Cn(e.prototype,n),r&&Cn(e,r),o}(hn.PureComponent);Fn.defaultProps={handleWidth:!0,handleHeight:!0,skipOnMount:!1,refreshRate:1e3,refreshMode:void 0,refreshOptions:void 0,querySelector:null,targetDomEl:null,targetRef:null,onResize:null,render:void 0,children:null,nodeType:"div"};var Pn=Fn,zn=n(0),Qn=n.n(zn),Ln="_2xzzvovFz3-0DEDKFRet1p",Yn="_1WLEXI6U7ijm4mmQZ4ogOE",Wn="_3fQ9ksBRahm4yGQYz-eSTw",qn="uZeO64582Sg91pVDb0Dlv",Nn="zipa3ZwN_-M5YphrhnJtg",Gn="dUQNjm4WoJgZ1c-NiR6Bu",Jn="bpRj58gCozfBIX-athnsH",Un="_2vS4LMX4VpI68VpcNvsJW1",Kn="_24XF2mM7G5tiGcAh9h8haK",Hn="_23DngjQpFszIvxJb9G2Rfs",Vn="PpxbiP_69VrcJiJxVl-Uj",Zn="_3BhyzjcIdMuYvDz0BFKu2i",Xn=n(9),_n=n(29);function $n(t){return($n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function tr(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function er(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function nr(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?er(Object(n),!0).forEach((function(e){tr(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):er(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function rr(t,e){if(null==t)return{};var n,r,i=function(t,e){if(null==t)return{};var n,r,i={},o=Object.keys(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||(i[n]=t[n]);return i}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(r=0;r<o.length;r++)n=o[r],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(t,n)&&(i[n]=t[n])}return i}function ir(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function or(t){return e=t,(e-=0)==e?t:(t=t.replace(/[\-_\s]+(.)?/g,(function(t,e){return e?e.toUpperCase():""}))).substr(0,1).toLowerCase()+t.substr(1);var e}function ar(t){return t.split(";").map((function(t){return t.trim()})).filter((function(t){return t})).reduce((function(t,e){var n,r=e.indexOf(":"),i=or(e.slice(0,r)),o=e.slice(r+1).trim();return i.startsWith("webkit")?t[(n=i,n.charAt(0).toUpperCase()+n.slice(1))]=o:t[i]=o,t}),{})}var sr=!1;try{sr=!0}catch(t){}function cr(t){return t&&"object"===$n(t)&&t.prefix&&t.iconName&&t.icon?t:_n.b.icon?_n.b.icon(t):null===t?null:t&&"object"===$n(t)&&t.prefix&&t.iconName?t:Array.isArray(t)&&2===t.length?{prefix:t[0],iconName:t[1]}:"string"==typeof t?{prefix:"fas",iconName:t}:void 0}function lr(t,e){return Array.isArray(e)&&e.length>0||!Array.isArray(e)&&e?tr({},t,e):{}}function ur(t){var e=t.forwardedRef,n=rr(t,["forwardedRef"]),r=n.icon,i=n.mask,o=n.symbol,a=n.className,s=n.title,c=n.titleId,l=cr(r),u=lr("classes",[].concat(ir(function(t){var e,n=t.spin,r=t.pulse,i=t.fixedWidth,o=t.inverse,a=t.border,s=t.listItem,c=t.flip,l=t.size,u=t.rotation,d=t.pull,f=(tr(e={"fa-spin":n,"fa-pulse":r,"fa-fw":i,"fa-inverse":o,"fa-border":a,"fa-li":s,"fa-flip-horizontal":"horizontal"===c||"both"===c,"fa-flip-vertical":"vertical"===c||"both"===c},"fa-".concat(l),null!=l),tr(e,"fa-rotate-".concat(u),null!=u&&0!==u),tr(e,"fa-pull-".concat(d),null!=d),tr(e,"fa-swap-opacity",t.swapOpacity),e);return Object.keys(f).map((function(t){return f[t]?t:null})).filter((function(t){return t}))}(n)),ir(a.split(" ")))),d=lr("transform","string"==typeof n.transform?_n.b.transform(n.transform):n.transform),f=lr("mask",cr(i)),h=Object(_n.a)(l,nr({},u,{},d,{},f,{symbol:o,title:s,titleId:c}));if(!h)return function(){var t;!sr&&console&&"function"==typeof console.error&&(t=console).error.apply(t,arguments)}("Could not find icon",l),null;var p=h.abstract,g={ref:e};return Object.keys(n).forEach((function(t){ur.defaultProps.hasOwnProperty(t)||(g[t]=n[t])})),dr(p[0],g)}ur.displayName="FontAwesomeIcon",ur.propTypes={border:Qn.a.bool,className:Qn.a.string,mask:Qn.a.oneOfType([Qn.a.object,Qn.a.array,Qn.a.string]),fixedWidth:Qn.a.bool,inverse:Qn.a.bool,flip:Qn.a.oneOf(["horizontal","vertical","both"]),icon:Qn.a.oneOfType([Qn.a.object,Qn.a.array,Qn.a.string]),listItem:Qn.a.bool,pull:Qn.a.oneOf(["right","left"]),pulse:Qn.a.bool,rotation:Qn.a.oneOf([0,90,180,270]),size:Qn.a.oneOf(["lg","xs","sm","1x","2x","3x","4x","5x","6x","7x","8x","9x","10x"]),spin:Qn.a.bool,symbol:Qn.a.oneOfType([Qn.a.bool,Qn.a.string]),title:Qn.a.string,transform:Qn.a.oneOfType([Qn.a.string,Qn.a.object]),swapOpacity:Qn.a.bool},ur.defaultProps={border:!1,className:"",mask:null,fixedWidth:!1,inverse:!1,flip:null,icon:null,listItem:!1,pull:null,pulse:!1,rotation:null,size:null,spin:!1,symbol:!1,title:"",transform:null,swapOpacity:!1};var dr=function t(e,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if("string"==typeof n)return n;var i=(n.children||[]).map((function(n){return t(e,n)})),o=Object.keys(n.attributes||{}).reduce((function(t,e){var r=n.attributes[e];switch(e){case"class":t.attrs.className=r,delete n.attributes.class;break;case"style":t.attrs.style=ar(r);break;default:0===e.indexOf("aria-")||0===e.indexOf("data-")?t.attrs[e.toLowerCase()]=r:t.attrs[or(e)]=r}return t}),{attrs:{}}),a=r.style,s=void 0===a?{}:a,c=rr(r,["style"]);return o.attrs.style=nr({},o.attrs.style,{},s),e.apply(void 0,[n.tag,nr({},o.attrs,{},c)].concat(ir(i)))}.bind(null,pn.a.createElement),fr={prefix:"far",iconName:"question-circle",icon:[512,512,[],"f059","M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"]},hr=function(t){var e=t.top,n=t.left,r=t.onMouseOver,i=t.onMouseOut,o=Object(Xn.useSpring)({top:e,left:n});return pn.a.createElement(Xn.animated.div,{className:Gn,style:o,onMouseOver:r,onMouseOut:i},pn.a.createElement(ur,{icon:fr}))};
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */hr.propTypes={top:zn.number,left:zn.number,onMouseOver:zn.func,onMouseOut:zn.func};var pr,gr,mr=hr,yr={jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11,"01":0,"02":1,"03":2,"04":3,"05":4,"06":5,"07":6,"08":7,"09":8,10:9,11:10,12:11,q1:0,q2:3,q3:6,q4:9},vr={jan:"January",feb:"February",mar:"March",apr:"April",may:"May",jun:"June",jul:"July",aug:"August",sep:"September",oct:"October",nov:"November",dec:"December"},br={jan:"Q1",feb:"Q1",mar:"Q1",apr:"Q2",may:"Q2",jun:"Q2",jul:"Q3",aug:"Q3",sep:"Q3",oct:"Q4",nov:"Q4",dec:"Q4"},kr=function(t){try{var e=new Date(Date.UTC(t,0));if("Invalid Date"!==e.toString())return e}catch(t){return!1}return!1},wr=function(t){try{var e=null,n=t.split(/[ -/]/),r=M()(n,2),i=r[0],o=r[1];if("Invalid Date"!==(e=void 0!==yr[i.toLowerCase()]?new Date(Date.UTC(o,yr[i.toLowerCase()])):void 0!==yr[o.toLowerCase()]?new Date(Date.UTC(i,yr[o.toLowerCase()])):new Date(Date.UTC(o,i))).toString())return e}catch(t){return!1}return!1},xr=function(t){try{var e=null,n=t.split(/[ -/]/),r=M()(n,3),i=r[0],o=r[1],a=r[2],s=a?Number.parseInt(a,10):1;if("Invalid Date"!==(e=void 0!==yr[o.toLowerCase()]?new Date(Date.UTC(i,yr[o.toLowerCase()],s)):new Date(Date.UTC(i,o,s))).toString())return e}catch(t){return!1}return!1},Ar=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"years";if("items"===e.toLowerCase())return t;var n=t.toUTCString().split(" "),r=M()(n,4),i=r[1],o=r[2],a=r[3];return"months"===e.toLowerCase()||"monthly"===e.toLowerCase()?"".concat(o," ").concat(a):"monthsfull"===e.toLowerCase()||"monthlyfull"===e.toLowerCase()?"".concat(vr[o.toLowerCase()]," ").concat(a):"quarters"===e.toLowerCase()||"quarterly"===e.toLowerCase()?"".concat(br[o.toLowerCase()]," ").concat(a):"days"===e.toLowerCase()||"daily"===e.toLowerCase()||"weeks"===e.toLowerCase()||"weekly"===e.toLowerCase()?"".concat(o," ").concat(i.replace(/^0+/,""),", ").concat(a):"dailyfull"===e.toLowerCase()||"daysfull"===e.toLowerCase()?"".concat(vr[o.toLowerCase()]," ").concat(i.replace(/^0+/,""),", ").concat(a):a},Sr=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"years";if(!Vr(e.toLowerCase()))return t;try{var n=null;if(n="months"===e.toLowerCase()||"monthly"===e.toLowerCase()||"quarters"===e.toLowerCase()||"quarterly"===e.toLowerCase()?wr(t):"days"===e.toLowerCase()||"daily"===e.toLowerCase()||"weeks"===e.toLowerCase()||"weekly"===e.toLowerCase()?xr(t):new Date(Date.UTC(t,0)))return n}catch(e){var r=kr(t);if(r)return r;throw new Error("Date ".concat(t," is invalid"))}var i=kr(t);if(i)return i;throw new Error("Date ".concat(t," is invalid"))},Or=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=f()(t).map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.x_type,n=t.data,r=void 0===n?[]:n;return f()(r).map((function(t){return{key:t.key,x_type:e}})).filter((function(t){return t.key})).value()})).sortBy("key").value(),n=f.a.intersectionWith.apply(f.a,O()(e).concat([function(t,e){return t.key===e.key&&t.x_type===e.x_type}]));return f()(n).map((function(t){var e=t.key,n=t.x_type,r=Sr(e,n);return{key:r,formatted:Ar(r,n),unformatted:e}})).sortBy((function(t){return t.key.getTime()})).value()};function Er(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Mr(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Er(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Er(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Cr(){Cr=function(t,e){return new n(t,void 0,e)};var t=RegExp.prototype,e=new WeakMap;function n(t,r,i){var o=new RegExp(t,r);return e.set(o,i||e.get(t)),Y()(o,n.prototype)}function r(t,n){var r=e.get(n);return Object.keys(r).reduce((function(e,n){return e[n]=t[r[n]],e}),Object.create(null))}return Q()(n,RegExp),n.prototype.exec=function(e){var n=t.exec.call(this,e);return n&&(n.groups=r(n,this)),n},n.prototype[Symbol.replace]=function(n,i){if("string"==typeof i){var o=e.get(this);return t[Symbol.replace].call(this,n,i.replace(/\$<([^>]+)>/g,(function(t,e){return"$"+o[e]})))}if("function"==typeof i){var a=this;return t[Symbol.replace].call(this,n,(function(){var t=arguments;return"object"!==P()(t[t.length-1])&&(t=[].slice.call(t)).push(r(t,a)),i.apply(this,t)}))}return t[Symbol.replace].call(this,n,i)},Cr.apply(this,arguments)}var Rr=(pr={},A()(pr,void 0,{long:"",short:""}),A()(pr,"k",{long:" thousand",short:"K"}),A()(pr,"M",{long:" million",short:"M"}),A()(pr,"G",{long:" billion",short:"B"}),A()(pr,"T",{long:" trillion",short:"T"}),A()(pr,"P",{long:" quadrillion",short:"Q"}),pr),jr=function(t){var e=Math.abs(t);return Number.isInteger(e)?0:e<.01?function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return 0===Number(t)?0:String(t).match(Cr(/\.(0+)/,{zeros:1})).groups.zeros.length+e}(e,2):e<1?2:1},Ir=function(t){var e=Math.abs(10*t);return e<.1?2:e<1?1:e>=1?0:1},Br=(gr={},A()(gr,void 0,jr),A()(gr,"percent",Ir),A()(gr,"dollars",(function(t){var e=Math.abs(t);return Number.isInteger(e)?0:e<100?2:jr(e)})),gr),Dr=function(t){for(var e=Math.abs(t),n=0,r=t<0?-1:1;e>=1e3;)e/=1e3,n+=1;return{value:r*e,divides:n}},Tr=function(t,e){if(!f.a.isNil(t.decimals))return{decimals:t.decimals,divides:null};if(!t.ticks)return{decimals:null,divides:0};var n=function(t){for(var e=t,n=0;e.some((function(t){return Math.abs(t)>=1e3}));)e=e.map((function(t){return Math.abs(t)/1e3})),n+=1;return{ticks:e,divides:n}}(t.ticks),r=n.ticks,i=n.divides,o="percent"===e?r.map((function(t){return 100*t})):r,a=0,s=Math.abs(o[1]-o[0]);if(s<1&&(a="dollars"===e?2:1),s<.1&&(a=2),s<.01)if(t.autoSmallDecimals){var c=function(t){for(var e=t.map((function(t){return{number:t.toPrecision(12).split(".")[1],sign:Math.sign(t)<0?"-":""}})),n=1,r=[];r.length!==t.length;){if((n+=1)>12)return null;r=f.a.uniqBy(e,(function(t){var e=t.number,r=t.sign;return"".concat(r).concat(e.slice(0,n))}))}return n}(r);Number.isFinite(c)&&(a=c,"percent"===e&&(a-=2))}else a=Math.max.apply(Math,O()(o.map((function(t){var e=t.toPrecision(12).match(/\..*/);return e?e[0].replace(/0+$/,"").length-1:0}))));return 0===s&&(a=2),{decimals:a,divides:i}},Fr=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=C.format("s")(t*e).match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+)?|\.[0-9]+/g);return Math.abs(t)>1?n[1]:void 0},Pr=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.suffixLength,r=e.type,i=e.truncate,o=Dr(t).value;if(!i){if(Math.abs(t)<1e3){var a=Br[r](o);return t.toFixed(a)}return C.format(",d")(Math.round(t))}if(e.ticks&&0===t)return 0;var s=Tr(e,r),c=s.decimals,l=s.divides;null===l&&(l=Dr(t).divides);var u=1;if(null===c)c=Br[r](o);else{var d=t/Math.pow(1e3,l);u=o/d,o=d}var f=Fr(t,u);return"".concat(o.toFixed(c)).concat(Rr[f][n||"short"])};function zr(t,e){try{return Ar(new Date(t),e)}catch(e){throw new Error("Date ".concat(t," is invalid"))}}var Qr={items:function(t){return t},unformatted:function(t){return t},default:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return Pr(t,Mr({truncate:!0},e))},linear:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return Pr(t,Mr({truncate:!0},e))},percent:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=Tr(e,"percent"),r=n.decimals;return null===r&&(r=Ir(t)),"".concat((100*(t+Number.EPSILON)).toFixed(r),"%")},dollars:function(t,e){return"".concat(t<0?"-":"","$").concat(Pr(Math.abs(t),Mr(Mr({truncate:!0},e),{},{type:"dollars"})))},years:function(t){return zr(t,"years")},yearly:function(t){return zr(t,"yearly")},monthsfull:function(t){return zr(t,"monthsfull")},monthlyfull:function(t){return zr(t,"monthlyfull")},months:function(t){return zr(t,"months")},monthly:function(t){return zr(t,"monthly")},quarters:function(t){return zr(t,"quarters")},quarterly:function(t){return zr(t,"quarterly")},weeks:function(t){return zr(t,"weeks")},weekly:function(t){return zr(t,"weekly")},days:function(t){return zr(t,"days")},daily:function(t){return zr(t,"daily")},daysfull:function(t){return zr(t,"daysfull")},dailyfull:function(t){return zr(t,"dailyfull")}},Lr={default:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return Pr(t,Mr({truncate:!1},e))},percent:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=Tr(e,"percent"),r=n.decimals;null===r&&(r=2);var i=(100*(t+Number.EPSILON)).toFixed(r).replace(/(\..)0+$/,"$1");return"".concat(i.replace(/(\.[^0]*)0+$/,"$1").replace(/\.$/,""),"%")},dollars:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return"".concat(t<0?"-":"","$").concat(Pr(Math.abs(t),Mr(Mr({truncate:!1},e),{},{type:"dollars"})))}},Yr='source sans pro,system-ui,blinkmacsystemfont,-apple-system,roboto,oxygen,ubuntu,cantarell,fira sans,droid sans,helvetica neue,"sans-serif"',Wr=f()(Qr).omit(["default"]).keys().value();function qr(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Nr(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?qr(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):qr(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Gr=function(t,e){return t&&t.key&&["Enter"," "].includes(t.key)?e():void 0},Jr=function(t){var e=t.data,n=t.parent,r=t.params,i=r.format,o=r.basic,a=i||function(t){var e=Array.isArray(t)?t:[t],n=f()(e).map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.metric,n=(e=void 0===e?{}:e).y_type;return n?String(n).toLowerCase():void 0})).uniq().compact().value();return 0===n.length?null:n.length>1?"default":n[0]}(e)||(n&&n.metric?n.metric.y_type:null)||"default";return o?Lr[a.toLowerCase()]||Lr.default:Qr[a.toLowerCase()]||Qr.default},Ur=function(t){return f.a.map(t,(function(t){if(t.datasets&&f.a.isArray(t.datasets)){var e=f.a.first(t.datasets)||{};return Nr(Nr(Nr({},t),e),{},{id:(e.id||t.id).toString(),sources:t.sources})}return t}))},Kr=function(t){return t.datasets&&f.a.isArray(t.datasets)?{datasets:t.datasets||{},sources:t.sources}:t},Hr=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=f()(t).map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.x_type,n=t.data,r=void 0===n?[]:n;return f()(r).map((function(t){return{key:t.key,x_type:e}})).filter((function(t){return t.key})).value()})).sortBy("key").value();return f()(n).flatten().map((function(t){var n=t.key,r=t.x_type;return{key:n,formatted:"function"==typeof e?e(n,r):n}})).uniqBy((function(t){return t.key})).sortBy((function(t){return t.key})).value()},Vr=function(t){return["years","yearly","quarters","quarterly","months","monthly","weeks","weekly","days","daily"].includes(String(t).toLowerCase())},Zr=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";return Wr.includes(String(t).toLowerCase())},Xr=function(t,e){if(!1===["x","y"].includes(e))return!1;var n=Object.entries(f()(t).groupBy("".concat(e,"_type")).value()).map((function(t){var e=M()(t,2),n=e[0],r=e[1];return{type:n.toLowerCase(),count:r.length}})).sort((function(t,e){return t.count>e.count?-1:1}));return!(!n.length||!Zr(n[0].type))&&n[0].type};function _r(t,e,n){var r,i="x"===t?"x_type":"y_type";return Vr(e)?Hr([(r={},A()(r,i,e),A()(r,"data",n.map((function(t){return{key:t,value:null}}))),r)],(function(t,e){return Sr(t,e)})).map((function(t){return t.formatted})):n}function $r(t,e){return t&&Array.isArray(t)?t.some((function(t){return Number.isNaN(parseFloat(t))&&!f.a.isDate(t)&&void 0!==t}))?e:[void 0!==t[0]?t[0]:e[0],void 0!==t[1]?t[1]:e[1]]:e}function ti(t){var e=t.axisType,n=t.scale,r=t.count,i=void 0===r?5:r,o=t.customTicks,a=void 0===o?void 0:o,s=n.domain(),c="y"===e&&s[0]<0&&s[1]>0,l=Array.isArray(a)&&a.length>0?a:n.ticks(i);if(c&&!l.includes(0)){var u=l.findIndex((function(t){return t>0}));l.splice(u,0,0)}return l}function ei(t,e){return Vr(t)?Object(C.scaleUtc)().domain(e):Object(C.scaleLinear)().domain(e)}function ni(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:50;return new Promise((function(e){return setTimeout(e,t)}))}function ri(t,e,n){return ii.apply(this,arguments)}function ii(){return(ii=i()(u.a.mark((function t(e,n,r){var i,o=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!(i=o.length>3&&void 0!==o[3]&&o[3])){t.next=6;break}return t.next=4,i(e,n,r);case 4:t.next=8;break;case 6:return t.next=8,n(e);case 8:case"end":return t.stop()}}),t)})))).apply(this,arguments)}function oi(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"id",r=Array.isArray(e)?e:[];return t.map((function(t){return r.find((function(e){return e[n]===t[n]}))||{id:t.id}}))}function ai(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],r=f.a.concat(["id","data"],f.a.isArray(n)?n:[]);return t.map((function(t){var n=f.a.pick(t,r),i=e.find((function(t){return t.id===n.id}));return Nr(Nr({},n),{},{metric:i,data:n.data.filter((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.value;return Number.isFinite(e)}))})})).filter((function(t){return t}))}var si=function(t,e,n,r){var i=[f.a.min(n),f.a.max(n)],o=i[0],a=i[1],s=C.utcYear.count(o,a),c=C.utcMonth.count(o,a),l=new Date(t);if(!l)return null;var u=e>0&&new Date(n[e-1]),d=function(t){switch(String(t).toLowerCase()){default:case"years":case"yearly":return"%Y";case"quarters":case"quarterly":return"Q%q";case"months":case"monthly":return"%b";case"weeks":case"weekly":return"%_d";case"days":case"daily":return"%_d"}}(r);return s>=1&&u&&(0!==u.getUTCMonth()&&0===l.getUTCMonth()||u.getUTCFullYear()!==l.getUTCFullYear())?"%Y":["weeks","weekly","days","daily"].includes(String(r).toLowerCase())&&c>=1&&(!u||u.getUTCMonth()!==l.getUTCMonth())?"%b":d},ci=function(t){var e=t.dataType,n=t.isMobile,r=void 0!==n&&n;if(!e||!Vr(e))return Jr({params:{format:e}});return function(t,n){var i=n.ticks,o=new Date(t);if(!o)return Jr({params:{format:e}})(t,{ticks:i});var a=i.findIndex((function(e){return e.getTime()===t})),s=si(t,a,i,e);if(0===a){var c=i.map((function(t,n){return si(t,n,i,e)})).slice(1);if(c.every((function(t){return t===c[0]})))s=M()(c,1)[0]}var l=Object(C.utcFormat)(s)(o);return!0===r&&"%b"===s&&(l=l.substr(0,1)),l}},li="dt_array",ui="dt_object",di="dt_primitive",fi=function(t){return[li,ui,di].includes(t)?t:f.a.isArray(t)?li:f.a.isPlainObject(t)?ui:di},hi=function(t){return fi(t)===li},pi=function(t){return fi(t)===ui},gi=function t(e){var n=fi(e);if(fi(n)===di)return e;var r=pi(n)?{}:[];return f.a.reduce(e,(function(e,r,i){var o=fi(r);return void 0===r||hi(o)&&0===r.length||pi(o)&&0===f.a.keys(r).length?e:hi(o)?Nr(Nr({},e),{},A()({},i,r.map((function(e){return t(e)})))):pi(o)?Nr(Nr({},e),{},A()({},i,t(r))):hi(n)?[].concat(O()(e),[r]):Nr(Nr({},e),{},A()({},i,r))}),r)},mi=function(t,e,n){var r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];return r?t>=e&&t<=n:t>e&&t<n},yi=function(t){var e=t.values,n=t.category,r=t.color,i=t.parentValues;return pn.a.createElement("div",{style:{width:"90%",maxWidth:500}},e.map((function(t){var e=t.value,o=t.name,a=t.unit,s=(f.a.find(i,(function(t){return t.name===o}))||{}).value,c=void 0===s?1:s,l=o===n;return pn.a.createElement("div",{className:"".concat(Un," ").concat(l?Kn:""),key:o},pn.a.createElement("div",{style:{lineHeight:"1.1em"}},pn.a.createElement("span",{className:Hn,style:l?{color:r}:{}},Jr({params:{format:"percent"}})(e/c)),pn.a.createElement("span",null,a?" ".concat(a):"")),pn.a.createElement("div",{className:Vn},pn.a.createElement("div",{className:Zn,style:{background:l?r:null,width:"".concat(e/c*100,"%")}})))})))};yi.propTypes={values:Object(zn.arrayOf)(Object(zn.shape)({value:zn.number.isRequired,name:zn.string.isRequired,unit:zn.string})).isRequired,category:zn.string.isRequired,color:zn.string.isRequired,parentValues:Object(zn.arrayOf)(Object(zn.shape)({name:zn.string,value:zn.number}))};var vi=yi,bi="_2A2CZ_335dcis3DITBiY6p",ki=function(){return pn.a.createElement("div",{className:bi},pn.a.createElement("img",{src:"data:image/gif;base64,R0lGODlhpAEeAff/APfK4v3v9+2DvfP2+eUijeplruQUhvXB3pKyzelbqbrM2hBamYmsyqC91PGkzuhJoOdDne6LwUyDseDp8f31+vjQ5vrh7nSewfn7/LvP4P75/MTS3u3b5fKo0OlWpuc9mu+SxeUokC1tpP3w9/W72uzB2eTs8wlWl/3y+Oy61uY0ldXh7EV+ruQYiO3j6fbG4O3U4ultsmyYvuyYx5250c3c6QRSlex1tj14q+qbx+MEfvbg7PjU6IOoyNLb4+3y9+uz0uMKgfrl8eyrzsTV5ICmxrHI3OTo632kxezM3qnC2Ouky+xxtNHf6nCavhphnSNmodjk7e7p7Ojv9TJxpqvC1Zm2zvnZ6q7F2jVzqO/v7+x4uOrs7utqsSZpovDW5OYwlJa10FWJterw9mCQufTb6Th1qfGfzP/8/frc7P7+/vOx1ViLthZfnOdSo3qixOUei1yNt+Y6mPT09O19ut3n8F6OuOdOovv7++hRpPnq8s7Y4vHx8eQNg/39/fDw8OLm6fj4+Pzq9N/k6fr6+vn5+fCZyf////Os0+MGgEB6rOh2tfPz82mVu/Ly8o6vy/C11fz8/PX3+cna5+lfqtzm7w5Zmfb29vf391qMtvX19bbJ2e/s7qTA11CGs/zs9R1jnvCVx2aUvOUukv34+4aqyOl+uMfU3+jq7KS90gdUluUsknegwhJcmt3j6PGcyvOu1KO80R9ln3ihw7DF1+MBfbPH2H2jw0J8reqWxNng5gJRlOhorpy4z+Y3l+/w8el6t+uRwhRdm+Yuk//+/v7+/+MCfeQPhANSlP/9/uMDfvS11/3+/u/0+Pz9/vnc7KvF2mWTu/rf7u7t7vzo88fY5u7r7exvs/Sz1sDT4vr7/cbV4rTK3fj5+++YyOUrkeYrkuhztPj6/PfO5QtXl/r5+e7n6u3g5/Hr7vrb7Je20eqVw7jN38LU5PS32fK41/b09fHx8u7v78/c5+7H3Nji6vDx8ai/0/jW6e+PxOx6uUiAr36kxOlhrO7u7v///yH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTA2NUE4ODMzQUUyMTFFQUFGQTRFM0QwRjkyODM0MzIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTA2NUE4ODQzQUUyMTFFQUFGQTRFM0QwRjkyODM0MzIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMDY1QTg4MTNBRTIxMUVBQUZBNEUzRDBGOTI4MzQzMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMDY1QTg4MjNBRTIxMUVBQUZBNEUzRDBGOTI4MzQzMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAUDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVO1RSgjtCVOrLOmKLI2DsbS+ys5noXagNOEDl0KrwQqgwqptnPPUsQ7Bl2FtpAbf+6hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTG1MJRKKIEQV5yYaSKMNcGkJ3LvYHLMJCCM3z0RGRRvacGxztzzIDsVUN04RJGMrXnl2sctWWhvSCf3VBtq1T13Z913id13q913y914S8Fw19g2u9pRZRv7+8VnR8TW1dENRmyWf82KhCyabRdTeHuGGjoBhRrPZ01jd4YTm22BJCPm0M2WYMUaFlKyo52EX01H85gFbHmpK6EpU2BwtM2k7r1WjBh140aZQ6yyYhvHfLzAezNV0jPbYtxWmsH55dIb79EXiKSE9s1KNNr+ksE86sOoNTOBYTreDS3d7//d3gHd7iPd7kDTC4fRZrU55ml4X7mNJe+WkB1ry0/BbM6Jt/HW9D19wcIVkzyK5tZNDzbRarmcUu8aLeSYT67BhgFdXuptEBDhZV2yuSnTUXxgfRLRAA6MryOtbrsUgPrhXb27sRKlIcJYSO8MSCSz0RRW1tvDwO/uFQsSe3Jt+aW3cFTjknXhErXZg1dpw4Ks+cDeObVY2K2b0EUUyMp6djLXgRwXHihz15ZtPzLOR3lbHMi20IgV9JDJyenaMpJF/lKxGbY83x7F7NQ+XjSAgFtJhns+IjkrUbZJAznRBeVb2ZjQnT7U7tdV3NYyxoThI2WttafEE2HhPmDKOs/00QNQiQG1rbeYYtA+sukj7plF7pln7pmJ7plZ7jkuFlYBbLZqOiEaFmNdHUMp05K7WsgKPmxn3crr4x9+0USiulGrOo3mRZE+7cHH4rz7hSE80RdsbG1vzqj73lU6E1FMMvuFxypPyXpwLaDnXMvJLrp4EH+4JkxJ7tJP5xY5vda+ozyy4j2MyG3XXeEmK3vPLra/VlRpbB/ZKo2s6xFCQVBZlp6fgn8L448YwJZyQSxZTcQO3jKaPLf14TSeivRcPvpilGqm7d6K5kpFrwMoGGYlPmm4LbqHfhJPHORGOdEt8Suq0x0sUImnKweqJM0L4RK1XbZqPwHz9lQugv8/+CycFiFygHFPUkxzfhVZDRbOTaRgDDqC/vETan8TcRUuEMEzzP2HosYCR/crH+4YcE50thWUlOg1eZEJFg5c5a5j5t7oxSTEW7FKjX8CmxUh639RoLNCPP0/mHXWAPJFWk800hfDOB9hSxxq2e0IFCsIUirYeSf9pKtoRf+IZ/+Iif+Iq/+Iyv+H2t11HfaHMb98yU9ftl+Wu5NYcc75wvNJmbFaiX9EghVsY+ecBU+pQWpb3Z+azPK6i/jKci+kchX68fq/A7ZXNRMZg27K3/2OreFLhFr5TPf3CWbW1j9AkkMRTDM+j4J73v6infEyst+0YRSb+fZaeCtI0WMar/U7ZBqd3bHa1HVt7kX/7mD97lkv7qb7tgMf3DzxGR5M1EKSPCXR3/PhZ0SP04BpJgBBBz/A0k+CfSP4QJFS5k2NDhQ4gRJU6kWNHixYt4CA78owbjR5AhRRLaOJCPH5EpVUq8VNKfwZUN8fxx6QhlTJw5de7UqYbmRjw8hQ5lSLIkTKJJIwZy6Q/ToZxqBLqcA1XpVaxZQbbceEnr15R4tJTUEhQs1kJjS/Ixm1INJrUlA52lW1ern7j+HFm12xeiWJeF/A6N9LOkppsf1VzKS5DtYMiRU3IdqCWxZMmFXV7ii1mlGkZN/c1pO1FNodCiNXn03Np1QzV5Mb2W7IeP/0tGrGmHDNS44CVClxX6IYTJkWiTpXcvl1xooxbdzO2qOb72oHSMfqoj/+OIESNHjgwj96clUGfs6etOHahJfd9D7AlqEfy+IqHx5PVXxhTd/v+sxlMOQK0waWo1AiM6JJDb9iPPkUD8S3BCnvwoSUIKlSLEt5MyfIiQOXzTzxFMrvPwRJ2MGsgRFO9q8Ln6WlRIDUIucURELfhgBBNCMJTxx48MJMgrIJWSqqncilxIDT8iicQPP3xUckqLNNkoRiqFSsulPwjJ8kswU9rOHxPD1CmSFzeaQzgz23RTofGkfBOkQ6x0ybw582zzkI3+0DPF/FYs809CZVRjIz4Kxf9JDTtdQlBRSDO00LFIY8KvKS36q3RT+yY1idPPGj2qEPRANdWzQ+c7NaVIxkSU1FVjlSwvOWWNaMum+IDVVl7PGtPLXjFaTMSXIgz2WKUo88c9ZC/yQ1SyEGt22pxUfKlUaiGKRD7cds3224ti2whYcCfaljwtNBmwXHYZko+Rdil6lliOLlk33nI1Agpf0zAJ9ChNeuQXyEMiwYOQQgIJBJNLLsEkkEIIwYPNlNKEd2CJDinEVdFIxKNWjGkjDpM5xHOwzx2DS8laf8gNGSI//D3ZEU0CiQTblyE7BA9MGKH35LWAw1miNP8YOueEdtbkZy4ZuSQQQiIBGemh/Aj/xGegs36ONIz0JWg2qjPGQ5N/T9aiu/C+U3tttefQxOFCPg67opg51vpuf/gwtqLUCBp07oci6ZlpvPX7Y45AKJ5b475P7s7thwuRPOGFLym5bLI0nQivjfYCvKKdBy98dEbuffktwvOeg0fFIVIDj0DmwPwl0xcS8uvPP/KjkEsYmX30puaYulxGmXYEuOEpEjzNksBWkPnac5dIjUgICUSTkvlIXWukQkYdOS3mKCR5kCJh7MCjEYrkKPKlp0gNJqGUH0on6z844d7LLivkmZBjROCsqCEQgWJWRG43kDm4LzJWsxuW2HUkTGGidUZS1kCcBxFXzUWBkcED85aV/75efY9L5xnMhkoSvX9wbiN/22BdQFOTCeaJSU6CEvxgE4lChAhTJORgXvgAQpZ1pIU641Z5XKYnAfoOXX9gItOE1xrnbESDEakgI0A4RKwcEHd6Ohfw1oJCu8jHaBlzFZGw6BcTlqQqb3qWFzN3xenkxYEO8UN+5njGs2gHN3BEEa7cmLe9LUdZF5OI1yrDQjx+5RAV9IcVwfRC0ehoDnP4jiP4wIcmakGTfKBZIWLoGU+VB45M6dMnE6mUKG6kgFPqX00CqaRfVQRanjulXQBzJZD44X5Ra99XtGiSI07pgAmkyCFctcpansWQ5UEkHS/xLz5cwpRagWTz+OihUP9CpyI+Kckdk5mVVHJkan4oYvCmqRTNHKWZUxrTBSUSibwI8Zt0qaAjapVGB9EHPr8cTS9PFE55UiScTpknXYy5FsUtEm/u1EqrmjLFN3FzixWRjzYLChaJzoeHCNHYv7RAM01oAmuBAQseGlcQMFKJlJU5Zwq7edE8Bip8mCCZiPhACPQcghAeTOlKNiaaJBEqo428iKgICdO7/M5RQ1Poc9YZkw4iB6KEGqg3HbK+jfgTqSnRYz6tqhAt8kGrE2kqkloKpjFZxiJpCuZWlbIgpj1qIrO85jZP6pi2FgqrBKHlRJRlRrdSExMe/IM0L3JQVe6EOsHr6ZxW2p6KhPP/qIH9CnEkpzKQDJWgObkrI86ap5NO9SGh9BNlEwTPkuQ1SGT56qY021qOlqSupvXMMtWqkr1WprGKuiVBVAunrNI2QY/N21gT4qrdQmqg+4tImj4rXMxUkJghWSZDe6VFLfz2H2N6KnR3g1iCwBYijfthtqDlj6+O6bnejcxQLZqd1ILrvNZFiHPZS6BlTvcij01Uuc4b1IXkZbb3lUwFu9uQxtG3WYw0T2dIS2ACHcJiHxFQvIjLkRIxaUyThbB6lnngGT1nwKvq7X7E2+HXNA6Z70TUwLpquBGjeDCGfO9ErMVhdsEVXcmVsWTSBFiJWEu//BpWU/7A4x5H5rE1zI7IjZGm095xUnwxTvJghjrkv2wEx1XmMk6Ie+Lc9rfLY86JhE9oGhGTWc1QJYt2ETIeEK9Zzg/55VMiIh/RzlnPFCmiI9b52C3vWdAOic+BFJdbLVB50GOuk2jmwEI4L1rSEulNJF/ZODdPetEORQ7X/tG4E2t60IWY3dnOLGpUN0RjHhRNolP9apnokDyhhvWiBcjqzdZa1wwxX4PCF+ddp9q4wSZ2sY19bGQnW9nLZnaznf1saEdb2tOmdrWtfW1sZ1vb2+Z2t2sdEAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwOAHYAFAAGAAAISgD/CRz4L8AzAO4chNJHCUIIOQLDwTl2LEitixgzYuQgD4zGjx9L/BsFsuTFJPLymPyoQ4XAJcfgyBw2zNeDBF3o5HNwwAKagQEBACH5BAUDAP8ALA4AbwAsAA0AAAi6AP8JHEiwoMGDCAkmg5ewocOGabbAUSHloUWH1EB8UFar44yLIAlaCLWxo0ljEEJapIAtRgiTME0SmKbyYBoHBcDoiMmzFgEQNQXyyFdAzjFjPXkG8UCCWEI1fiIRKhTo0hxGfPz9+5C059IOFAr++aOlrL+zaNOmhdBVZgFYYQ+qnUvXX4yexlq4yXflYd2/Z0twrHXMVxcHFkICpvtH4DtsiYP+Kzv2Dx8+jhjN0YQpUCE8fg5JPhgQACH5BAkDAP8ALCEAYwAvABgAAAjxAP8JHEiwoMGDCA+SSJGwocOH/ygwMUZACsSLFwGEqMVxyDSMIA+S2qKDI8dFIVMOPLDRJMcYKkN+KmDMJUcDV2JeJPbKgE2OdwTphHjA189aBhwMffjMw9FaCYQuTfilX6KjBJZNpcoryNEgAkhtPUgvwdWjHqSNLYhmDYSntXwdWHsQ7qgldAWqCTTD2MCfdz+u9RPIkT9/M/66/ADLz1g1hDTxOUyZQ5C/OjwA2OqnkGTKoCmjFChAyFA8gTQ50hK6NWVOwca6nu1Py5xCatbSBv1HE6HceWn/mRPIcV6CoLU40lTI+PGDmAg5f54wIAAh+QQFAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vfz7+///8ABijggAQWaOCBCCao4IITXbGDPAxOloYHxnwjRYSQjcBEIrV0GAGEGDLWQQsdlvhBiItZ8ECJLBqAImLE5BMEiyWGgM2Lhn0BAY0dGuBNMjgWlssxPCrTxQhBEsbBHTzWMswLSRL2Dok0JiIAGlEKpsENxvA4Cj1ZCoYPGDzqEM6FYQLmzYw0wpFCmoB9kkeTHiAJ51T+5Knnnv78cUkkHZHQQpcs9nHGnVXxqaiejhRyCEYUMEEoi76kgWhVh+ARCCNaLLrnH5ioUREAIZRJB5aXYpXpJX94mqcWl/j/EREpW+jAIwFQptpVJKy6qoUmojZ0QKk8JoCCrmHhMYevoSr0SQGTlmgAIsiSpQYmrS76RyEIFcIkj3cIUq1ZhxTCh6eOADoQHo5MA4MBLTowrlqEnLvoJWr4sWye0yRBZi0JiDuvWuVmy2enik6TAj4Du3UIJgi76o8WmDza8Ft+MCLxHLJe7DAhGrt6icdu+dGrxHnOESzJZqkRiCMSR6wnHx2zHJYfL6PsCCFqaKKoFoTY3JUahGhi78bqClSIzHkGIvRVfhRiNMp5glozQX4cracmFj/dlKaaOMK0r3PgsZAa++7JyMpeK0X1nlrMUQjbC2GiqCN0t23U239o/8LzRIQwTbPeSbn6xxyBXE1RJAZXrTjhQsHtiCaFPH6RH433mTTkQs2BCSGWc6SG1hNzbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745Jdv/vnop6/++uy37/778Mcv//z012///fjnr//+/Pfv//8ADKAAB0jAAhrwgAhMoAIXyMAGOvCBEIygBCdIwQpa8IIYzKAGN8jBDnrwgyAMoQhHSMISmvCEKEyhClfIwha68IUwjKEMZ0jDGtrwhjjMoQ53yMMe+vCHQAyiEBuHSMQiGvGISEyiEpfIxCY68YlQjKIUp4icgAAAIfkECQMA/wAsQwBRADkAHAAACPcA/wkcSLCgwYMIC4444I2JBwgqhoEb9eHODUPjiCXcyPEgCkQFQhirRbKkSZMhOqpMSMHBg0QnY8qstbLmwDTXDMzcadKAzZU8POjgSZTkg58refaBwMQQCR6fUPwLYOFAqAIEgCBNehIMHQBotopFSNKYgRv4xqolG+KMhrVwDSLSGLeu3bt48+pVeUnF3rGHLvmb8XdrJD7+EscobDOQlsSQc0BgzFHNHMiY56ihnBDPH8yJtRTijFCNYND+HPkhffAwan+YDrEuGPj1HzyzC+JBjFpz7oFqNL3WQug3wceoGW02LnD4aOYEQfuGbtDfn+LUCQYEACH5BAUDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABHbmDx+BqFHSCAd4w4QHEKgwDDijfHDHDYaMk0yBZvnjoRaaRPIRCogUEIIxtaSo4oorGpCHAxRwKJaHNPrDCB4aaeDAA4mw6OOPKvbRDw8yflVjjY7gWJEfl7gB5JNQPgBAkVxpcWSNjIgYUSRzeJgHlGD+aIwHFlCZlRqF8HEljXP44ZAfXXoojwA+9gEBE4aQwMMnKPwTgAUHhFIAAU8GEQEaZmaFByNreniJggmpccmVHPSRIhh0AIBoQ+nQQeiPKuCTaFZcNvpHIQgV8kejOdwg6kTEwP+iwo9BeDMqqXFeyYibA/nB6Jp8FHJIRmuE8KMHfd56VSSOrKlFIMMGYuWVfBDSERoRBOEjOGkoixUhq17pSLNXPjvsR8984KMBB3h71SGYTNsojZpAGhIxAujAYiJnuHuVr/MeqGRJB8DhowD+XjXpmpqce5IQvvgYAzEJS3XIwo0GopIGCfiYwKYVNxWJmgH7M4e9J9HhIyUhNyVtueHWyAevKL2izIoFtKyUGrnWeDLP5Q58EiI91gIHBzojhUfMNGqB6kCFyEujximREMQoSSRtlKRrOkLzQJEw7ajDJglhjdZFjbwmJmQTpAa5WKKMNloXr/mH0Acdoom4cs//TRYeJB95skOBUPu132GpsXe51kJEiNT+/KEl4mBFvSYjfTeEB+Ra4E35Vs4+TZEfYnf+uVdXDn6RGoF/6PnpVtX4R+MZvX2kFrTDrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9+Oev//789+///wAMoAAHSMACGvCACEygAhfIwAY68IEQjKAEJ0jBClrwghjMoAY3yMEOevCDIAyhCEdIwhKa8IQoTKEKV8jCFrrwhTCMoQxnSMMa2vCGOMyhDnfIwx768IdADKIQUIdIxCIa8YhITKISl8jEJjrxiVCMohSnSMUqWvGKWMyiFrfIxS568YtgDKMYx0jGMprxjGhMoxrXyMY2uvGNcIyjHOdIxzra8Y54zKMebxIQACH5BAkDAP8ALGQAUQBAACYAAAj/AP8JHChQDZ5Al+YwcsSnoSNGl/QQnEixosWLFdUQ0sTHn8ePID26aIGxpEmMagoxCskyJLCTMGMK1NKy5sdvMnOWtMkzkTGdQCfW1AIxEJ5IatT8U+MHz6ugUAeC5IMp0qGoWE1quRQpq9evYMOKHUu2rNmzaNOqXcu2rUUPGtxCrfUgrtyctfI+IHU3Zt6/d6z1Nfmiz9+8HgQPxvji2OFaiRdjTGH4cIJyki+mCPK4ALHMFacB4Xz4BmiLkEj/FXC64rJEj/O1pohI2eMzsyeeeayjQ26CIB4nWvZ7oIDDxhIdKC7wxuM+L5j/K/DYQAXmxBI8bnGFOZo7yFtYG2CuAYKxw7mkU5Dzl9I06f8CqCCwDv5ATgQDAgAh+QQJAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vfz7+///8ABijggAQapwYegVwyByOO8OGgI4xcUkgkhxS4mBqEaMKHPxx26OGHWsxRiBoWEqZGIYx8qOKKHmqhSSQlAnaJFizWaCMjMMbIl4082jiHHzrqxaIWEQaCRyRqkKiGHwhq8keNWmBSYZB2fcgHJhQ65AcmT67IR45UzsWhFpeAKREhjqyoRSAamRkmVXwUMuVFhGyo4hwkWhSIFm/SdcieKvJBCkVqpOhPn3X5kWaH04RjwAFn0sghonZh0iEvtdSSyBkPqTHHh5TahccfQGRqqgANEdKlh6Ha5cwNppr/GgMxCamhiZet2qVBArFmmgAaB4264iV55loXHb3W4oEGBKlxyYp/4GFsXq8o0+sDzP6Dh50falLstHchksi1pNyq4h+EgMsXCUH0eoc1d36r7lNzmvRCH716AO+YhcxLFSPykvTCMfnCi6e/VPnjSMAheZoCvrEmUA7CVXHIB5AkAepPCu3GWgCtFEvV4R9udhTJohxOA0THpt4QssgdaiGtR86yCAnLmaL68lMgzryRql5Ku8y4seazs1PcjunzRX58uqKUAyFibaycHr2UGiiPma5Fh2Ai6YeOYEzQGb3q0IHVVxvq4dYT1almvwiB0Gsiy6Ct1CFqd8j2Q37k/+3hwQoJEKsxiUBqN1KHOL12pzMG7RCssfbxwuGIm7s4Q4Ws2mIg9TJUQK8GVEA5UpbrrRAeWf/N8ELE8BprC1eMflTpHO49UNMs8rF0RGjcMXgLO8huFO3+7O3s15t3LpEGEBgTKwEwCF8U8emq4TWL3mpEgRy9hsCB9ETRHqXmHjIitkYBqNDrN9+DL5TiNjqye0Z9n/NNryro4b5cHNwfqwoB2B9c5AEDAuAvgAJ8SxkM+D8EJrAtFmCgqQD4QLdEsFfDEEQFISjBTIXAAhtkywWfF7sQqmWEmTJGC3hgQrVQAxygA0AL0/IJ9UWOBDNEywg+4DxTJcIBOTwLBf8ekKwIBNEsGvBAsgqQjCOShRgxSJY+nFiWCMQqCPT4AxXJ0oF29WEIWzQLAGIAA3mE8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJTnryk6AMpShHScpSmvKUqEylKlfJyla68pWwjKUsZ0nLWtrylrjMpS53ycte+vKXwAymMIdJzGIa85jITKYyl8nMZjrzmdCMpjSnSc1qWvOa2MymNrfJzW5685vgDKc4x0nOcprznOhMpzrXyc52uvOd8IynPOdJz3ra8574zKc+98kQz376858ADahAB0rQgt4lIAAh+QQJAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3btywPRSJUqBAhP3Dz6kVKiJEWf4AD/7mEd6/hwzkjOQrMmLGWQogjS35J6G/jy4ADTd7MmSQezKABR+pMunRGNX8uO9J06ZLfxoxMy54NERPs0QTVaGpcmLbv3wT5MNaE8FDqwJiAK/etxrGahIEYO1pO3XQkxrET+uFdvfvm64GzJ/9cHFiz9/OHmwfms9B2ePTw9x73p2Xhdsa94+tfKzwwQ/KAzbHfgGoB6M9zChXSGGQENkiWgQgmdEh/gGmBh4MYggUhQ4RcZl6GIGY1nz8O7daYI/mFqGJUltHn0CGMXPbYijQ+dR9g7DmkRoyXJVfjj0l1GJiADx1yCWYfAqmkUEciJxEeFFaY4pJU7mQgIRMdYmJgl1Tp5U7qBRahRE0CNt2XaNoUXWBnUhSmP3+kKedMBiYpEXg42hQJJozw8YcWWvzBhyNzaIJJIIREMuac6H2Gn0VzMEakTH4YGFpjgxpaiKKMUscjYOJNJGRgWFI64qWowrkaJoku2ulmowL/diFFkbToDx+HzPRpqrzKOGihlxxaCB6R+KGGq6+mhZp0Fflx6qwxvemYrb1WC1qggjriCCNzdOvtt98yIu645JKr7bnoosvHuuy22+4f8MK77raFYjLslD/5UYhrfgKa7RysIgvXIZZCG5EaUfrT5UyO4kjImGr4gQchgVyiSZ/UWqvxxhx3nKoWqxWCb02H4KHJqZfyoQkeueYFY2PETaSGpYy0LFOsMes4FyaaOIKyx0AHLXRof8xRiMAuRaJJxtUONvJZlWKKtEIzS10TzhepEUkhmMzhCB9MDy322NVqwUghNrd0SCEJAz2HwWdFcgm1WuAW0cuM/TE1S3j6/zMpR1pPXEggmFjs9dfwAkr24otrocnTI6mByc+YKd4rI3aLVfLJlcP9UKR5Q95S36G2dKwfkUSCx+qss57667DHnroftNdu++3GHqv77rw/pzvqdPHMCOWXvY2SGnNfqgXAePhhs9ZcOxI2YJrsbZXJ01tIUZkVZk6TgkNypgYefE4PqvcfST79YJGknZAahMwR9h+lbrV22yeKDl1jdds0/paA8RFpSnYJ/A3JehRZG/GMJ7NAGLB6WVEgqv4QCPc9pGGB8ZxL/MA5zKCPNEoLmxYq2BEoXQsTCFzIIQiBPz58EComDM3yjlaRZTGGQTJZE2hy5ptDOBA0KNKIH/9AdxkKpvBFgcjYjKZiJKJdgmUYIWIAaQLA4lnQNyysHA4TmMTKoRAkapAil6SCt+JBMSOx8htN3IMZPmyROhIs3hELEsPLXGKOFClExuZwRaSUcTj6g4hx8oZHkWAQMH9gxBP1g7w2BjI3VRzSIzMSNdgUkieRZMQkHwK+DM5kQo55434i0TbtOYQQP+ODBkeiJdVcMiedrJAoNRKlv8FEh4CZ5X6aeBld5kaMFcJEH0uCSzO90iZ+sJUpPXLITUZuRLbEUGU8pBBUYmYOzvzINBnDh2PSxFL18wgAo+kSXGohm93xQ9sE+EvM0I9h1HKEN2MSS3+w0yMjWuVKBjn/xhrtyI4FseZlIEiTWp1oni5Rg60cMUyMvEkLDU1JGhG6nFY2ZmG6cac+X2JQ7EQ0J9zzxws1gsHSvUSK5FxRSO2Jh58RFCcdDQwP83XRkWBNJgplzEZDxMZL/WGnMsEDte7ZEwDqbSSxXBg9ufmlnmLmpTw5pD98eZMbZYYkSZ2JFImqJKcKJpw+qac/gKpVbn4UI7FKqUoOYSt0DiiMmGEERVfi1HP2xKpTLYlVcwQTDPKVSi0FTTeLUsXB7kSKfx1Ji+oTE+4pVUmH8CpsznqTP6pRJ3gFa0gOkTeZGIisDqokpmpKFIQ1xk41AWBiRbLXaDVmrsvZZt7wYNob/xYlprLCSWZPUtKYYLBN/oyk3xCUTMeMlCdptKtNVIuSnj62JT3VwqC2xS3W2CtRzhtlKd94yKMSxalqbUlxA0NVj+xKsysBJq/+QKhLDAu2bikmjvBVTIYWZVf+QO1LVEtZSr42JgbcWCLde1zJ/NOOw6zic4GS08D0j1K2Km9HuAdclwhXaGZ7InzBItC8oZcgBGvMh3uSRsPChL8n6Vteo4VfxjkCE+1DDC8t2ZDxdo+wjQnvSfAq4Y3UFpH9TcnpUCc4wmnCa8RD1fIephdSIgkiJd7wSUBp25PmLcgWcTJj9AuUQ0hsX32y1pKx3JUuYqrABwFvUWxMH7eSdP9BJfEhtUyaFLkUome9chxouQLXgb4Sv1wN64nIrBEq44jQEVFMEaVsk5KVL1V8CASjDTK+is2BEV+blyI3hegSokwLI26IDT1JFAWzJKShPo1w+eBmohAwwBXSBJplRghNwJp/Rps0Q2YsnVYLBLfKFcqPAZNqbeZ4JJH4mVy94odAWOoyjNjzQtRQiBaLWdYpES1jhKmRepo4KMD2dUSc5RhxK0S+9OHyVtTg7Es5QtoG8UPyxIY5k+ixiPBmSBVnCpT6dvpgCetxRSSrybjNO66zLkgk1Ds0bIqkzzmWcoi3XBQxBtojYuQ3R8T6B4F3hdoBdniNGe5gRQaCWMf/+kfE8BCIDnrx3wkJLP88LhE2j7W0pyo2RgqraxX7Y9luwYO1AXNHqq2UmzCmrB8mJ9iEv+joQTRkY/5g7pWoONgfCSnWO2Joou9l4aDpOEIKQTktXMLpBiHEs9OtES1fFOYOKea3+221j9Q13xCpp8bfAva45scPQ3cj3P+RRTlexMyzRYkYdawTMdbMIyvVeUW6bt/IKFpGJEQ8NyVfJM3P103WnoOui2OpBftk2P7YewKBqW6NpBHta+mwdNY+wsEfRNsVyrdsHUxzjpCb4kOx+cXH/ezWawSlA8SE+WQ6eoFI1uMQ73XSqMX5mkjV+A2ROfAfbivYuwXwKcM7/0W07yQO/YzblOGf+GEi1uFPe6WgLolfe7LwcXUrWJ3oBBFMwIybHD31tvcQuKcwVLNq3hcSxbR1P+FVl0Bmspd7JuFYPNFgl7EAu3CBqiAL/EBgAZhA/3dVKXEIwMRHB0F+XNJ8ZDJ1VacSKxV12bd2LkgS54VcoAEIF3iDu3ABDuYI7oWCBuF2oSF6KuFVJDgQjYRvOCFGVEcU8PdF71MIaweAKGErPngRPgcYp4CDFxgGQPREHQgdSoQyrKYSYvV4/1BHw1GFWYJfSzgURzdDnBI4j+ZO1XcandUTklUFWrgLGTBBK/OFRqheohd9EChR0MZBdDiBltKGQiFWHP8DVSZBOj+hNakjOPNQBI0gASIgDLtwBL3CPp4mI1t0b6elEkLFP9ekhlmziCuYEsnmMfW2ErGkekPxAyyHZ7ziCGjjUFA3Ja/4dilxijLUezBRNXlzgNFycL0yB8ioEbjkfkZRMoHwGj7lhBMBhMjRR8aIHap4hmEjhMKWMMskFPKWZGYSCK1IET2FfXWGB5eQZGbnTLwmGDtlUdKhhoRYIXVYE9tIXtFIPl7jJ+ylSEwmEwBEjEchN8TjOCmEhgcUd5cxhiThecNxFP1IdIBoFgC0j0qBBySnBdZ4EBklI3W4e3DSjA1xeaGRAwJwFCIIbd2oFVK0fkkhOZQjdgf/QYo09iR0Q5Pv83/yAximUAu10JLRuFJ/gJJsMZNgcT9AlDl4QHsIORC/52A+mXapdCGEIA9AQJREmQ8aoTV0EQhkiSicIhLoxo6GwZRiUXh2FDEMB44WgXrjaBFDBBroR3gQ4JVEeQYVsSfDM0FzgI4gIYzSVxpsqTlkVzlhx5EIcZHxZxGRxTQxKBAOwJe1oAMdEBHuaI6CFZJCVEpqCReJORaT+TF5GZYt5piEhz9LdBAggJmJsAyi9kNB4zjpaI/SoZRlUZpkAX5BmI4DYVn+sI/AaXgKIQB8aQyJcABGt3wbI3IbYZLUE5NQIUWsGRUrNHReJxIvKWIPgTxM/6NKDnEDmNkHLyCSyuhOjGAoZSk88Fh0G3GcjkFCkXGQv/mOvCKXH6GbxNYQi4l5QVYAmGkAFQBiykc0RiM6+hKUGtUROpk39mkY3DOaUsFuUVghESmcBRFJoRaVoMGfDkEMCYCZLXAFAvGAkkIIWMZuDwRf+YhIkmYYPQWNUtFsGWomDxNJkRkSHnp7DEeeFIEGd7CcLbADQ/cHoCkRbslN6eiQDkYYeoFLpjcV8GNrqcKMBBGhIOijlxFO4lk5E0oRGgABxsCXBAADRTSjGSFnosh1AYoZupiRUHFTVKEvWJoqSoov6jRQdCoQP6o+OzRXFCAHmBkCHOBgS+pQ6v+lCV9okzI0ByzKFr1lI7coPXnGQO8DTEAHElUEkpRTcBwRACqAmd+QqJDYESoqTx7BbvCYa2nRWqUFPINzCZd2a5UDqw7hVawaEiQnHVcZb4xwDt+AmSqgByVxYMfYn2wDaZdQkKbpGBM4B4ljOUPzB5oArVBGLRLZn7+Kk6pqGRxQrHypAgEQZ/CXnQvhkdB5K4NJW2ExIhzKEb/KMUVDmFZ4KoyoqlEIkoA4koAhDzBAAMZ6riVBnRYqERhqLeylKc3zpzgxgzrhmR8TMulYlYjEmwGVo1O5ENgIGGVAsOVqsCTxsVXqe+3WMdJFL5rAGsFSljAbszI7szNbFzb/e7N1QbM6u7M6Wyc7wZ1EQyisMq9GKI4aS3g5WogbQZEu9A8WILJeaa4mcZF+A7FGWAjUyjhau7XRuROA5y/yMijVJSwPqxKQiZJOGXbqF5bq1YAD8bSYOQyCYBL+6Q+9GomBkLVcu7d8y1QGhl8PdjCBQDyYY1l1eY2fpllwy5chYAEn4VX7ehLj0zVg07eWSzarZRiWFbnTxnSgEYv/YLg0iW6iahCL65UEgKL2JiPBehESUzEX4yeXO7vWoq5ksbmBFEJBiD5nKzPq5X6nWwvG0AI8wFsZ07GRQ2SEsLw427yDw7PQu7POO73UW703e7SmiV9zB2J9cSla+piW/xK4DmGCcEJW1AAOBQoAKYYyNposV3GRd2uEnls5j8MQvQuRMPkQn1CqfNkHJCC5zyai7vtxNGMzC5c9iwq+aztt1paw/zACH3CmXpkIDiC5wFSZA8xnCVM9tilYbAoRkLlR5PtTFEEBD4CZtRABKIGUrZvBRoGxqcII2RnCBxFZqWgRGuABKFwAyXAS6Na+LhwVNke/GkvDBDGA+ZURxBADKPwAKGC8yBnEWLF0txZpMPps9UOdSckREYDCqyANO9Y2JCzFd5qykdrCBaGs5AWwkiJlHRAEy2kAzjm1v2u1ZMwSONor28sRxPlpDvwQB2AAsgkCKIFuTXvHSSE3uP8KbRD7naFxyCHxDOiLmZRAAbx1fn3kZRMDu5eWadUKKKAcyqI8yqRcyqZ8yqicyqq8yqFcunBxpZ45ZqXHSiTnqCWBAieMmWCQBhbcRhfiB4TAMz5Du8RczGbyFgSUtOFBQwIxark0Eui2YiaBBuaJmceACIXcrsa8zbPLWMpCPtQYw8yscMqEvQVBnweVEh3QByjcBZZsEirKzfJMzHQGFvpyCcrsYLqaEGnkXRxBkVNnzg1RASGAwuBwoCEBy43Dygzd0A790BDdykQbFMDsGhQrGNnaXyFVzxSBxJXrGGjcECigw7KZD8TQEdQWzmVDKO45LMWScojsusHcM9r/XHIwRhGA1qaSpTAlkzF/fBEgkAgo/AHP0KbxU9MyIp8xPZc7E7tILR1emDUJo65Qeit206cwY8cFMQ4FjZlBAAIn3dHzmzIAszRBGNI0cgi/QzuVOJaFc6sXrTyMgAnwuhHh5iYM57a58WzxWxKkQKAoLAfFm2j1CieaMM4qt555gwkTTSAfyDh8MJgxBhL1VHmdN54v5Mj0qBJr0AISPMFb8M4MAaLudtPaYdaPzNguLFVkI13vqoamdkGumZoH8cMqEQAkjZlwAMbVlKOOgK+iptiYkq3WSRvRrLJCexdqA04pOXSurBCGGR4xiQgtgMJAALoEQdruJKUNtMg8/7gpc4JXecZec3AJZlncCMFmCnjEF/ZOEIHViZcSI1AAn90H5kA9vXGXQLSLGOGRK20oiaLVpSF052J/wCIshNA86B0RaWTZuSHcCnNJMarXKHEAk7wIjkEYCXpNAq1y1Wav9PKydbG8rVPiJn7iKJ7iKr7iLL7ijb0XsS2/YfPcEsGlVq0SaBABdyAF1fK9CV1tTz3P8vzTs9F1N6dyGx6Rrfux9iTg7L2fHa4QjpbPQi7PEBVatpKUST51/B2WBmh13AmuK1Fpc7DIVU7MC44WjuhFk0adER6COz0kaC0zW9M1mHrm28zR8XFhUdp86IxItiuAVK6LaW4Qaq06g/9TOBbTsuDS6I7+6JAe6ZI+6ZQOMIVuFmuToWanhgBN48z0aQHmOFG+1FBRjjLE3Sjx50Sna5IlhGqXMqpN6mexnTHsEnEqoV+o2fpIR/X62y8u6z6hu71C5KomWIEuEAOIwcgO4euxSMCuFVSMKjKcMKP+ECp5Irb7i8MRUdSmzMsD3M8OFXtya6L+a3Vn65TjCKwZ3fRBc6aup5Lt5OHune6Iq1ZcEMXEeMkK4YIXERwnftiTZ9892fPuE83moMqDbQiBX8jre3yupCkkX92aQCYT1zhS3vdS8PxICAXEK2bT5Y85IuL7EvpdOaiOEF7VqRmxJ1TuTu11Xc1jLBr/TxJ4auY/h9jreu4x0Xf7fUVESKdXavN5hi1h6y5Gf/RIn/RKv/RM3/RJr+6T4WVgVtNm88G1cWw1UfLbnTkrdbIozfF3judizzG/7hSvS9Mag63aKhGWRewhIW/mE2ny1iP7tDX4bPFjf+YNTxViWTEYwzFmY9qncSrVnjVjzStu72N4sC9IlveOHxiFP4HKm+i26jNBzj9zfUYlNHWXXhzdyytAvE9fZmSd3C/W+vh9S0FS4ZGZJpB/cvqLE9l0bcfFpOeUop+owgdRPfM1cYVcWzR0HZNi5PWf9PlKNphlz/sMEedDE9kEluaod+wk8djutKDK3xJrrjHS1Z72/1K2vV/OPLFSNh/4dX39cdavgTIvLB0sdoFyQFFP/nwTXgUZzQa0bQQwa2/+HWFz0g8Q/wQOJFjQ4EGECRVe8tewoSM1CiVOpKgQk0OHhQqqIaTpD0aQIR3+YaQpEB4/FVWuZNnS5UuYMWXOZIkHpJZINHXuHHiIEcg5PHdeBKkxYaRAc7SIZHqTz5xLgQhFiijU6lWsWbUKDQTyT8qtYROq4QPyktiVDIuqRDrnY1O4GLXwYQQ1UKGpfqqi5dvX79+DmrzuBbzVz1KMmAofVIvRaEs/hS45QhzX8k0tf/g4qqtJ06VLmALdLVSa0GnUqVWvZt3a9WvYrfHMpl3b9v/t2WAX7/YJkg/h3Vdtrg3+TzBxmYciSWb09vJz6NGlT6deXSSjQ8ULkwUJUTvWQiEfAz40RzxWNXgCaWpu3f17+PGtj//O14/zh8Dr0+yK3K+an/zbSjlCArmEEUfwk29BBht8TrH9/Iqksvwi5KmxjP7yoyyQCCnuED/wKBATTeZwhI8/KHRwRRapy8nCvvBQ0TsYaTousb4iUVALPGos6BA1/IhEREIKGQ0T0C7xbMk5mnTySSijlHJKKqu0MkpGstRySy61DAlCH9GSsTv9wmTpRocuyS6s/uTq0Uw4v2uzIUbiRIuQkGi088yQGClzJzXM8+rFPQv1a7iR/jT/dCc8fdNt0YkwbOgPQoXCQ0F/HHkUUk6vUkPBNzu9qlGMKBVVojkdwmRNnQIVaQ5WT5WVJknPmtWqMd289aBCVPSHj1BjUgMTX/0JZFdkYToMI0diTXamXB17diAdRdJk05XUuKRYYKf1tiIMtcD225eqNcvZXQFkao5gJ1KjkACtVZRcctWgEEx6Zdqwz3lPDaRYf/64hJBx//GDEEwcgavbfBsuKDyHtOjXYYrUUNi3SpP14+Km/uAMwQQv0yIQdCmmV9CGNDF5pvJC0oK+ZAnB1DotMJl45WTxaxdnl4gCSZObOT0kEA6tcySQoHm+1Q+QklYaIUJ85aPgXQlR/0o6RzDJ+Ol8Sc2Ua32LjhjmZzmarNi5GMGEEKfBvtVnf2x1+yVX+aU4yEgi8UOvublGk+y+Veo1pD88DPzwfDn2Z2vEK4pEbIfmoLpxyjnFr+3K/zkEzYiPzfxzoUsFvSWZRXKE8dFTt1ANjPhQPVvOHQL6ddojZNoh12uvqHSXbdb998Vubyh34CVSI/ZJCym5eOatYj3i5ieKRPHWlY/+eqsoxFz3wUXiw3rsw5dJccPFP0hbgP9A2nz208JI5fYP8gP5hrS4Nn78oS51+fgjQfk68OUvf/bCSPkESBD/wcV+Oztg+P5XpwYaZH4Am9QlGBjB4iGqIRds4LBmVv8qTbANg7tSjoiMFAgkheYuhECJUMQGwRH+qBDUY0rW8LC9GBbmYJgw0Qc7pjaCycRr/jBgDgfiB0z4sDsmiQT/jPiXQ+ABE4ygIHX4MDAnKkRsf8giBqOoiSoSjhFRmQoOn/gSPwSCii2qH7taokF/4OuMBPmiEuOSGUfksUtdmsNnMFGIG85RIUikIRuHtz6VxKshqBPkPyIxxTA66A9zCMTkvAgv6Xisj6IpTWmOdIkeisx3FFmWQ5rVSIVEEZKG7BMHDzisSP5qDmuz5PnU4xa4/MGVBIFbHFFZkcgcyI4LmoMZgXe8MDpiYMY0yCMhh6OJHAJyu/ylQdQQiQL/lehEscwkI80Hy6ZoYQ6FYKb0tmWtLkZiMNWkiRqCtDd47i1v8zShgdojEh4d8FJNYYQI+aKGQGAKfhLpZVDYGbxAFBJw16tb72qZFW19iSLU89xBF4OHZ2qii7UDJ+FIpp2ogYSapXSINy0aFnV156FKw5ve9FKmaxbiai77aH2i9asuDvEP5TwpTFp2kyKCDaD3ZEpm/pCiuBQTRhBzSEUXAhLs9HQxvWyIHJWWwAUxrEb/42I0qSc3qf4lpEDZqLfmx6CalXUxBMzQRO4joLDah4ZRxVn34sMHRMIJQzCUCBxxElfySMofdHVYSr1Xlzlk6UQoSpEWHLsZTRRi/6X1EZ4/tFDWVH0FsIBhquwots885ZVe5FMJ50652UOpaKESCVGRyhgmqv4qqPSCm0EpcgjqDRS1fPGrSQvih0vM7IqTRYthE6PWXVVWYir5FFx3u5XOBuxmfvhfUyT3HXOVyrffUpxVFTKhUvH0uSqRlJ6gxk3LrlYsh4itUp/W2Z2uJLreHS9WcOsohBxCsJehr1imJxKnshQ//UXI/5ZbX7E0Vy41FcghCjEzLThiSWs8z6EUORJqOmxO4lpJZf2hXgTv5K03mSUPuUUIZx2CEM/MsE5myBQ/BU7BdOKTQ/gaYq2MGDoaTYh+b7JdmWC0KQGeW3RBjMCm4VgsG/97zsso0svfZMXHMCauyRTHYZWIbbZKtsrQwji7ipgWucy9MO623Dd1MkutGAIrl7UyrGcKrMr3fZ/zCunG0aVKtxLp7I3dbJgi4aXKBJlxVYVSZkYMmmsXJjJCKvuHP0MKvAUcyk2OjLhCf/i2IBlzpLXjV0U38yYtbtxNiUiRy3l6UamK8vhEyrzo5lMiYgu1qncjKdu+BI4EVl0vtXBmgSgOyLauD53b+hJF8qHTlIvdahVXa2JvBz8HhkyHwhe7/tI62oaCY65XMifiYS92MTYIhZa97VuDZNgEUSSvfyfYkcXq0eg2lDQx4mdUY4TUtEvVpLQWJMXhm95hguP/uv/xvPqde3SmhsulB14fRe5Zeq3LH5Mt09WH70mD1KaI1wQePi8rcN8Z147Y2iwRr3k7fugTiS5JbqgNJ83jXiTEgTYzToW/XNoYUXlCNPhxnQddJam6dJqHJ3Skv8Te+q6YXHKe9Jf7FdgDwY/BoZ50qq5KIv9r9NW9fpDqZsqbcwL6183+058VzOiWfbrZB765dTGu6m6nO0L+xRS8EkaRU6+71/9r3Tcp0uF9T/qDFQgqwieejoV4ZlHbrviH42GmTRk85K8O0Mb70vKbL0gkLsEhcVqd824X7+hNf3rUp171q2d9613/etjHXvazp33tbX973Ode97vnfe99Bf/7SAcEACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8weaYALOAEbqJXrR14ASBW0cNIYQaClcKBRixTFQZRKk8xNakzpFJjxgUy128AQXsAKeJiNbdG+n/6USQsU/15SFWYOHIpgSyeYx9bYSsaR6Q1FpeBYaoLALpGgGnYABDgV1U5KJb5cSkShDvQcTVZM3BBgtB9crc1CLGoFL7mcUJRMIrxEYp0CKxLgLbVAEY1ARMYgcfTSL2EGJVhg2MyhsCbNMQiFvSWYmgXCJFNFT2FdneHAJqVEKxViM5OAEJnA3R/dTKhRJ8nQScVghZFgTzkhevkg+XuMn7KVITCYTABSLRxEJNCAL5ViMJyADP+AQV3hAcXcZUkgSTyhTR1GPRNeEZgFA85gUxZABcaAKBUmK/PCDCJFRMkKGuwcnutgQl3cpptdlwAR0syFF65cUY1AKBFmMqv+gC3CiS45IY09CNzP5PkfnN0N1FBaIkrQhk2ARCQ0gAsQoBtKROXhAewA5EL/nYEGZdql0IWmUXxqhNXQRCGKJKJwiEuj2jYahlGFRDNDglApgRxHDcNNoEahnjRYxRKCBfoTXS8rIJ9lYNNsIEq8ofaWhlmLBDNzwM/OTkSNpKfFnEZHFNCgoEGJFhuGYjYIlkhuhTphXmDplFpH5MXr5lS3GmISHP0t0EPKlc+x2a7ziONxoUSeSkmZhmGUBfjLIjQNhWf4wj7hpeApxd0a3fBsjchtxktQDjVEhRaYZFSs0dF4nEhl4GZyHPEyjSg6hdRpknRJoKGMpPElmdvD/9ZuOQUKR8Y9kgY28MpcfIZuk0hBkVznmWSL8kzmhGXZGIzr6Ij9hl5UF0ZN5M597wT1oORXsJoQV4pC6WRCRFGpTCRrs+TkhKBAMKCmEgGWtuUPwFY+IJGmG0VO9KBXNhqBm8jCR9Jgh0aC3x3DYmUBbKHRhp5mi0kLcuJAORhh6gUstKRXwY2upkosEAaBXJRIqeoO36GACqoXr5aEZIWeMyHXxCURo8xY3RRX64qOp8geYgC+cCTMWORAqqj4a+pUkqgUyehrqpQlEKDnEM2Zs0Vs2wnI9Q5wVwkDv85KjV0VmSjkFBzhtMw2pN3oV+o4dwW7hmWtp0VqlBTyD/3MJl+aaMoKoDuFVhAoSJCcd/lkQ5AkYSwABelASB0aL7ck2kHYJ/TgWnOVgEDgHiWM5Q6OGpwpl1PKQ7XmpYucRyLkExlALKhAAcQZ/zbkQeMCfkDYHJ6ecNzEiC8oRl5qGxipurCgYy6p2J9SEJNkYLmAAtbCtvWoSyFmgDUSiRbQq+pcVKqgTmPkxIcONV4lItJl2JFqVC7GMRLcE23qv3VoS9Lqjm9luHSNd9KIJrIF/Y1mwBnuwCHuwdbGwDFsXCfuwEPuwdbIT0Ek0hMIqy3qD1fiuFCqu9JGpA/GELvQPn0AA98qtvgqqz2aDkVMIrMo4MBuzxbkTgOcv8v8yKNUlLM3zpVTjmCl5P0Sjfl+pXgo4EBZgsic7DIJgEu5pTCgRCYHwsjI7tVTLVAaGXw92MIFAPJhjWXY5EdHqYJp1tCdbCyFgASfhVXl4PPhYiFX7tmOzWoZhWWvLEGwaGpv4D147k+jWpwZBtidLAFdwEmL1tSohMRVzMX4Ct4xrLcFKFnQbSCEkg+hDkVkLERzqfoC7rcbQAjzAWxkjr5FDZIRQug17uoMTsaoLsajbuq77ugzLsZCLX3MHYn1xKUDamPUZER0IJ2RFDeBQtgYAACmGMiGaLFdBkZV6g0x3LY9jtz77EH17RJ+gAmXbByQAjyuLrMh7ExRZhf//sHDZc6bv45hAFarb9xAj8AG7eq+J4ADwCEyT2b18ljDV80OhEWmFZLkb1bvsOBEU8ABlWwsRgBIr9b/0y2zpGh7Nyb8HEVmTaBEa4AEDXADJcBLodrwJHBU2VznY5lDmq6lrB64JQQwxMMAPgAKgC5wbjBVLd2v6CzjPVj/I+QeyKxARMMCrIA071jYI3MIi6q8yZKeF2mJHI1wRmhEdEAQnawwGcADxixmjCcRLMaK9UrscwZufRsIQcQDaerKJAAIogW4jS8VJITeQOlnS2axlHBLPELxlSwkUwFvn10deNjGJe2mZ1qqA0sd+/MeAHMiCPMiEXMiGfMiI7Md+/wsXPYqZY1Z6rERyaloSKCDAZQsGaRDFDnkhfkAIPOMzjRvKomwmb0FAHgsqNCQQo5ZLI4FuK2YSaHADA3wMiDDGdDrKuMy4jKUs5BOMqXI2yAJsN6yp0Lm8JdEBfTDAXTDH3rrAufzMMktnYKEvl3DKdZrKCZFG3sURESmqKFEBITDA4FABD1drzpxniZzO6rzO7NzOipyxQdHJrnHOsNpfISXNFAGAtwKUKYECFFy2iZAPxFCo1XbLjkEo3jksxZJyZnwRnfzJBl0hjABjFAFoTYqGCjiY5aESIJAIA/wBz9Ck8RPR/FN0DZ01O6O4JM0mTJg1CROsNnordtOlw//BswgxDuFctkEAAgOdz82LKnwAMEsjgyD7I4fwO7QjiGFZOI96ztcy0bTFEeHmJgxXtLnxbMZMEqRQAANcC3LwuYnWrHCiCdisckeaN1tKxUMJs0EdCBT4EfVUeZ13nS80nVNX1A6xBi3Qvu67BczMEA/qbhStHUOdv2lNv1JFNtJlrFFtEqZ2Qag5xQaRwSoRAP9ctnBQy9VEoo4QmDpy1piiCbE6J678rxd7F2oDTio5dIusEBoNKsqJCC3Q1RAA1nSEoE7jJviLKku4KXOCV3nGXnNwCWTJvQjBZgdIEHVohxBB04KB1w0xAgXA1/eqAwUgBFZJco4wpRgxrGX/syqJYtOzIXTnYn/AIiyE0DzGHRFpJNe5AdoKc0kcatUocQBwrNP6EADKB6HDrMrVlob0gn91UbqtU+AGfuAInuAKvuAMvuDwbBiPzbxh09oSIaQyrRJoEAHH0NUGYAouUDz9TWkFDc0kXi1c3EMJMyti2kaZSq/2JN4HQQ2UQN332uHnECAhrhCOZs0ljssQFVq2YsP77U7c/ZUDuBIVAAFdXQt9EAM7kFAsNwdp3OOMu95osYdeNGnIGd8YiAlDMApLnggJ8ALRsjVdIz1Ujsv4HB8XdqPNt6mI9LgPUUnTsASrsOS8egZ/LRNHrTqDUzgWI7DgMuiEXuiGfuiI/57oig4wVn4Wa4Og4onBTEPhzHQqnJADd77kx1AAxHvS3yeOMoSj2TZ0Jm13k0gMayAHeF4LqyAAaOvpjn67qLLmWPUzFESEdu0YYHUAbqADeK4D6ODZsL6Uhc0rJ+5jF8YHci4QADi/AmEBN/DFZfsA67FIw64VLzzrhRcYOQ4RK3kijxu21BNRFHAG7Ou+9ACojvGs1z4Ve3JrjoMbKobFKRGlqmGar52aDZEGWwAHibAEE2Ssb93u91hAkMakIXtssgjfghcRHId3xDACxa5kvT3wBM8TzUasyvPBB4Ffout7ba6lKSRftJpAJuPUQe1ezXPx9EgIBv8xZxNRq/98uS+Bl9ci6gnhVTCZEXvC4+M63NfVPMbC8iRxpVMOzBdUdzLRd1J6RTX4pT065egcL4LiLlZ/9Vif9Vq/9Vzf9VrvCMv+FV4GZgZtNghfGwpPEzYfdmdHECvFr4Dj8mie5nS/MQ8OFYg7pxoDq95kWcc+EvJmPpEmbz2yT1tTzU5d9yT+8VQBlhWDMSw40Te8yiKFE3drLX9fqHiwL0im+J5f+R9Hun/uqD6z0vwD1RbZXY0uIbKeKhq8T19mZHrcL676+VRLQVIxrJmmj39S+4sT1JhwRmYJGxgP6kDd0kRfE0kos0UT/MopRnDP562vPOye/DGBhmKT8pti5aj/F/Yjsdb4KTLW3xJYrjHSxQiasrN6okzdzhErNeVm4/zjP2VC6C/zgtDBYhcoBxT1BBB/1PwjWNDgQYQJFS5kWBCTP4gRC/3zE4hRRIwZM/KZg4nQwIYhRY4kWdLkSZQpVa5kudCPloyEWs6kmfBSRkcga9Z8mHGiQTWENP3RWDTjH0aaAuHxs9PpU6hRpU5diCejlkhUtTI8dBHjnK0ne2L8qTBSoDkwja6FqIXjpUCEIukMW9fuXbwlAx1tmnerGj4ZL/ldeNMnybNziLJl3JYPozlwC8n1Q5fwZcyZUWo6allzzZcZMX3+Z5hsSj+FLjlS29h1RC1a/vBxBFmT/6ZLlzAFClTI92RCwYUPJ17c+HHkyZUbx9Pc+XPo0Zv3JW2360bP1VlaPZyZc3eWhyKpZrT49Xn06dWvZ8+e0SHtdQHjzB4/ZSGNZfMempM/qho8AtGkvPYKNPBABNvTz76p/DAPopwYnGkv8O5Sw6vTwhKPkEAuYcSRBxMUcUQSXxtNQq0iaQ3C+lAkyTSJ8PIjsJgyO8QPPDjERJM5HOHjjxVLFHLI9bJykSo8gozwyJS+w+jEsCIJUQs8mDxEDT8iyZGQQnjDJLdLbhNzDjLLNPNMNNNUc00220STETjjlHPOODWCkkmpkqQPz800ugQ+rSjEiEo+C81LUIgYMf90KkI0WnJRkZyMiJEWZ1Kjv6OMhHTTPDvjFKpGN6LuU4VghOgPTZ3CI0R/HBmVVFhZUiPEKmPdKVSMULU1IUQjwgRQmi4tag5gdzXWJFMHO5YmPQetddl/CgnSHz6eXUkNTKb1JxBouxUptIgcKdbblJrNEFopi9Lk1ZLUuETbasmVt9RB2Z3XpHQFG3fXC42aw9qQ1CgEQ400qfTeZdVY8U6EUZpRI0q9DURbf/64hBB7KSIEE0fYirfhhvGD7WCQG1Kj441SPdYPlNf6o7YPQXRNi0D2LdlbTCHS5OaV+NNIiwWPJYTV9rTAhGSed30Q4KRNGgsjg709JBAa23P/JBCkm47Vj4yy1johQqblI+NdCUkrPUcwUflrcnFtlW2VHr4q6IQJWU1btxjxyGu4Y31a2b5PEhZivknFMpJI/Kgs8KQlpZtxkaTV6A+ZILe825b9WfvykCKp+iuyORe90AcLF/0QSWHjdnTWFz0k19ZNGrooRzaP/fbq1MCID9xJUiP1iKLuffjPuI6Id+JFmv3no5N3Pi/jIUL+eYZ+N+qPQmymfvuddIeN+4YiyXz37ME3f6cVTSde8qL4KP98+FXKvPL4EXKX4j+wrn//kWDcmX+E+AF4sFkXAA2IELf9QXv8i0TOisKI9x0QgArDCP0kWJAGskULmmDaBc3n/0BFefAgAqTYqS7RQRE6jzsRQeEFsUW0XGniIym0lXhy1KVAfEk3vSEEU5zyuRDS0CCHKMT4jJI2PKhPiNDbWI9g6DK9YYwlbvOHBZdIED9g4ok4UUokFnjFuxwCD5hgRAnXw4eLfZEhn1MgGA8iRk2YcXKMgItclOjGk1SkjERqy79OskKIMAyP/4DjFhkjG0ckkk50mgNuMFGIJA5SIVk0Ih+lpz+SEExzkkxIJMgoxxL9YQ6BCJ0IiajJxryskbv5DQ6/5MSZNe9bKxIXJxUixk9aEmItlCC2QEmtjkjRJABCyxb/wEuDPM0fgrRlAMljSBHN4Y7O+50cHXGxaf8ixJOfE41IDsFNZDYTKJHgEI989Mv06MqF2VqLFuZQiGx27l3qUuM/IuEpcV4LS4rjp+IQ988bdohARSHUAVe1FkbMUD6BYNX/GqJMsOQTeoGo5OPANzjmlXIq7rKTSMa3OonmBQ/c9Icm6jk8XxYlfyfVStgyEk5wRcR2IdVKv3Ci0aYdLnGVyY4axnO2n9WsOuaiVj2pKBCa7seBbbHi19RgkS3K5g9AYow07SOyiICUIaZ6T1LzosxAwi2DIvoYgxzYxoYcYnyA86pdXJoRYjVNgCMyGksJQ8EYhcRBFWprWFgGMbsai30I4gMmjwSjIDYEkP7ASl/DaCp/dLX/YTZtH2TmACcf/QhIsXGLIzRRCJxWJ3qMZWmv/hBax9YEq8Fr2EEdZVh5zY8kqatlautCVH9YtCE44pIdUQRWajVVXk+LqDfH51DbbmWxjSWJHy5BNDSiNiyUfVJgbTVaLXhtVnxN7lRWWzGk+WGp/pLuVPKVq5nOK3PMXIiKchXP7vZvTwx568x0u5VDANeqTVstUknyXfbG1ylqFdUtIeuaAKeoklpN2nZ9ZRIHZlfANZ2SUAtCRKJpwbO32aN/7oIHVFYsnAhDlBakO9rcTlgre71KRzAB1I0QYlyHIARJR0yTIholYn1zcKJMIqnEqjgqLD6PSRdyCFMxdyoj/10Lg+H23fse5J4Yga+QGfJX+4pEmXyockKQjNDyNixzJi7J54Rr5Z1MTY7CixROrDsS6u7uzH2bcrjsCiO2ovk/mCCpxcpLYKg95WTDuvHXeoXchqw2yHqWih+4NJkwF6THYd0JKhkR6aZp0smThB2jC+XeCvJkbsSbdIpD8jqMvNnTl1kupqV8lUJDDrdzNkjpVl2oXnG5JeOLteW+W9A1YsTVt86LqYpbrm5uT5laoPU/MpdeYmsH0HlNCcH4oGrLAU+3mRt2tC30IAk7rEbmA16AP9dtb9tlscfWy+7iB7wdH2RF2E53sTMCbYUQLMHOgyzNijXaP9SbT9/EyP+iRbK0/fXqVGrDUuYMLnAGLRbfB/FeW+jNOtyyJcoQJw3BEN05dwMQy4xBK8ePBMhwj8RtDz+fmjXYa5Nf5nN5bojb2M2/+6kU5jEnTIm9tnJT2o0RtHnnxXn+7a+QBJAsP3rTG9Krjdsz5E6n+kgIjpERV5y0Ved6SJbbbII8aOJdpzpYf9UQB26a7Gv/x3hrxxBEMZ3tVfdZwTJW563PXe+EHKA/5rA5se9d8BMzSmHpQjCwC77p4mOLH/9BsKgr/uiFiCqtJK94IpLUKFow+uXrjQcYGyXynqf6UzW/TNKnniCRuASN3Dl21c+9y7Gnfe1tf3vc5173u+d9730Y/3vgB1/4wyd+8Y1/fOQnX/nLZ37zkxcQACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHZULAx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpeBCoqwCXeoEf4YfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPhloxRCruADDKACg5WlWrZYgMpEEoZSvsjYqL2Q0HjONDYjdKxkmXBl2QBfv4wCMKwC54pAhvgN9A4EJblD+KomYanEHdndMu3MSK3EQ1JPcQYFVKUmGTUF4EhA565myegDqwETJyHPEyjSg6hdRoknBJoKEFpZFopQ0W3EajpGCQUGe6YmdbIGNNwATawm7spBgMgEpRJbA3/QZaYF2RV9GAC4ZdhZzSioy/yE3Y4SRAfmTfTaRjco5dRwW5C6A8KAAXc+ZlRMBKRFGoyCRpOCRE7WBgMKCmEgGXs9kDwBY5wImmG0VO3KBXNtp9mQggDQAb/uQutwA0CehnoNZVttH6W9VND9wd3KRGLuR7QWI8ORhh6gUsTKRXwY2upMosE0QmW8J828Agj6pg3GIsOVp8JNHRTR6EZIWeKyHXkiRmhCJBPcVNUoS86miosii9RIAIfKgrOIBIDqnLKt0Nz5Y/806IOpV6aQIQbKUNz0KBs0Vs2wnI905oVwkAJMQBi8KH7IAlimqaUU3CAA6EisaDy5BHsdo25/5YWrVVawDM4l3Bpt1Y5jdoQxVAKyPCfWTAGIkFy0hGfBBGdjGGbEHFgrvgRL4kqfHAJ7NiXjgGBc5A4ljM0aviqEKEEJ/CfXjABmwWqHdkRsckmL6iNbPkRBYmnfMCVtBUWIzKaHQGqaciV4jYJbfCfpQCthCeEB9mECuluRxib+Hkw7dY0q6J/WaGCOlGXHxMy0FgH/rkLqoAADimsGkqTC/GLRJcwiVoS+nqj0FmuLDgo1cUa+LecCJuwCruwClsXDvuwdcGwEjuxElsnO6GkREMorKKtAzEGVGAJVeBglqmYGtqAHPGELvQPNmlMJoGmNhg5hTCrjDOzNOuaO/8BeP4iLwRbL/nXPFSaEM0wD/zzkKvqTuqnluqlgDV5KnO3WZHUr38YCDJbs1RbtUxlYPiFnqcaCMSDOZYVlb74aZq1srfCsQbhVXp4POdoiFbbtmOzWoaRopv0pqCRif/wtXKIboQab6eStkglI6LaLCxnMX3Crm57uKTCGXILkUsjg+izlgQIju5HtirJWxmDr5FDZISwuRDbuUBJsaArsZ47uqRbug87smRhWU1LmrjpuO9jKVqbfSjzU6KWjKgLkShzoclyFf4ItTfIdNfyOAwBuQ+ht0e0loE7bc92oLvrFf5Yhf+wcNmjpiQJu0CFqtv3EGiKuQcDTHDZvHz/ljDVA5mCxaSnar0K0YFwIn7YO0UnsVK0C75fQbaowgimirwHEVmR2JZiVAICgAYngW66K79RYXOVg20Ohb6junbjihBNMg0pEAS18AAoYLmpScBYsXS3FmkR+mz1E5uVuxG2YQ5wUAsmvArSsGNtE78YPBUZqmR62hHtO1XfKilSVggzYMImbAwGcAAnIbk/28LiJbCsOnql+WkN7BBXYAA6bMKJAAIogW4pK8RJITeVCm0/m4GsersI8Qzg0MQmTAkUwFvn10deNjEVc2SYti60Cihu/MZwHMdyPMd0XMd2fMd4nMdvvLdwkaN1OWal95uh0aYlgQIPAMa1AAZp//DD6kWcfkAIPOMziDvJlGwmb0FAJRseNNSGp8K9DIFuK2YSaHADiHwMiBDFeFrJqny4jKUs5LOLqXI2yAJsXDyqSuq7JdEBfYDIXTDGJrGgqxzMk0xnYKEvl5DJDnapCZFG3nWyyxfCJ1EBIYDI4FABD1drhls2erzN3NzN3vzNe2y2QPHIrpHNcKIJclqcsOF7a8e2N5kSKOABiJwI+UAMMlxtqewYhKKcw1IsKUfFF/HIkZzPFcIIMEYRgNakaKiAX1keKgECiYDIH/AMTRo/BM0/zwnQT7kzF+POGrOEZ1RDCWOqVthCdqNOAxXEBjEO0wzGQQAC9kwRS8euy//KM9MTw0J8CL9DO4NIF4QzqYWLYQbdrBsRbm7CcEqbG8+GyyRBCgWAyLUgBzxwJ9J6zpvchkaaN5ggzgNydDS7rIFAgR9RT5XXecP5Qlo8dcnbEGvQAsYAxomwBb7MEAXqbgetHY0bGnyw1fIrVWQjXcyahaZ2QfjTrQshwCoRAPKMyHBwytWkoY7QlTqS1ZiCzrPpG6DcMSADMHehNuAEkUPHx+mbMRZ5EojQAlANAVNtEHXtTjTaQFe8hJsyJ3iVZ+w1B5eAKJwyE2x2gKN6Ye8EESit1ioxAgXw1mCsAwUgBDVJclOaEQVZNquSKCptGkJ3LvYHLMJCCM1z2aL/MmgJSdkKc0ngmNQocQBfjMhBoA8BUKbXVMsqV21pSC/4Vxeb2zr4nd/6vd/83d/+/d/+zdV6Mdi/GzaiLRHziSPwzRBoEAHHANUGYAouUDwLnhv4LMwYXi1JPBtdd3NkGjbEmRH6ak/VXRDUQAnIDcYRfg4BUuHFQT7InOGrDFGhZSsq6d5FJIo+NoArUQEQANW10AcxsAMJxXJzcMUyjrjerRZ86EWTNqwZbRKRNQSjAOSJkAAvEC1b0zXSk+SqTMz6cWEz2nykikgkLdzkMQ1LsApAXgsqcAZzLRM6rTqDUzgWowlHBi56vud83ud+/ueAHujUCx9rs59ml4X7/3jgzHQqnJADbA7kx1AAAKDRb8GMzingBVHmRKdrkiV6xLAGctDmtbAKAmABlI4WK4SxoOISUUqfRJjWjgFWB+AGOiDqKhABpn7qYRFCGp5QF8YHZ16TSz0yFnADTCzqw6APLxDTup7BmHBr9pswLu4QEXkiZ26KwxFRFHAGH5DiQG4AHuANKdzsUrEnt+Y4uKFiq5sSrS4dttnQ9EFzabAFJSzqJkwACRAKFZAM5E6NBQRp5isQxcR4JYGcbaTjnJSDEkEMB9AFx27vQf4B13AGFQDA/Z4vUtua6J4Q+OXJQiTmLJpC8pWPFYEGJNAF9Q7xTgwOebAFZzACmH7x2v9LCP/+MWcTUaNGH9M+bgb52gnhVaWNEeNAB3JQ6yqvw0sgD6qC29fVPMYi8ySBpUj+c1dN13UnE30HRAhPEDUIkCgAC10QAt7e5iWQZ9iis+6S9mq/9mzf9m7/9nDP9o4Q7C5pzLBs8wH/EGpWEyYadmdHECsFsBzxCWtwAx+wyxDOCV6++KER80whMS3X5Ydo2W2JXxvOWuKNI8+4UgPMEcnAAw7ABBCA2iYsAIx/+lepFlpDMfxy0QV916dxKjtfQ8Db6zERAC9AAvCAZKiP+rOvExGjOj5dOEjm+vwz1GzYXUu+a62bKp2/Vl9mZJeGOG7c+25LQVJRkJmWjn//UquMU9MhXYDrfLPXyapMCPV6grhFgwlErXiktROpzivLI9noDxNoKDbLSmDLr3IjDRD/BA4kWNDgQYQJFR685M/hQ4gRHf6ZU8jPQowZNW7k2NHjR5AhRY78WEjiSZQQtfBhpAlTITx+DpGkWTCSFpWRau5kKJFPSolaGGHCo4bnUaRJlS5l6vGQI5RatPzhw8eRozmaLr0khCeS0aY8TUL8AzYsSEwSC/3zE4gR0JN85mAiZPbsXbx59S71gxMiob15G0J0ZDdwwrQR1xJUQ0jTH7gn/7QMFPPwZcyZD+OJqEWnZqWH3kKcA9pgYoiLEUYKNMdv5KByLwUi9NX0/23cuTMGivjnou6aan5CvJR7cOqNrOdAhg10JaM5swvV9mMY+HXsYTX1tp69Y9+ImG4ff6j6e6FLjl43hy2VqiPomrRuDRSo0P3phPTv59/f/38AAxRwwP/wMPBABBNU0MDfvAtttIf46M5BjThTDLTtLiTpkEjQY4Q59kIUcUQSSzQRNkZmohAp4SIqbMWS1MLskDlkTEoNPALR5MMTe/TxRyBDNA/GmvwA0aEXieSINw33UgPC8vDikJBALmHEkSOD1HJLLoEST0mebnJxQjB7ahIvP4b7S7ND/MCDSkw0mcMRPv5Yr0s88wzxszJrwuPOJPtcKEOIvrwrkiy1wP+DwkPU8COSNwkppD5MLrFUPkzn0HRTTjv19FNQQxV1VE8ZMfVUVFM9VSJDBaXpzzFdHVSiS1RsikmVFpV115pwdYgRXmsiRKJAgyWI0IcYIZMmNWrsjU9jo+XIwofKknakYSPio8FryZsIWp7wyNIfR7i99tyE1MhSV3RBypYscKP19SFMbGXW2YjmsLddfgnytrh+QYI113YLudMfPtgVSQ1MDvYnkIAjHgi8hxzZV+IKDx4yWkRP0sRcjtS4xOGEMZaYPC1ANjmjjiOqFd0nUZpDYYzUKATKiDRZduVg1VivVZ43SlMiZdsNxGF//riEEJXZIgQTqFIqOeh+x3L/SIudqT5Ijagh4iNeY/3oGqU/4LsSy/YCuVhrafH1RxO2nXL76o2jJWRcE7XAJOu4ZT2S5r4zQg0inds9JBA1S3QkEL4DF9SPiBp3fCBCDt62X0JcE9ERTMCe3G7CPv8ucboDbiw9h5+jS3LRBR0c4NY1avakoiV2NJJI/KgudpORrZv3hAyW6A/AgDd+17E9P96gSEh3aI6ml5ceuyNZN/4QZB/SAuLpu8/uELK8z+jukxxRXnz0nfQ6/YXUyP6hwtmXfy/II5xfIfKD2vt+/puq3yE+9A8h7iNbIdYmQASCRA0qSeBBIjE2rxmwgRMEyXqslz7hxUWCFORgRsZW/7wOCkRkSPsD40J4QoOQB24oFIgf3qe9j7EQhe9K2gE5GIm5RYQRG5ThBH22ph4KBIfO0QTggng/twHriC3UBNImcgkjLlF81HJIFFnIMLyRRRN1kaKsOPSmSQWiUvSZjmV4kjgldvEfhygEBFHCuaKo0Tt+eNqcspiSydAlehqhoT9AKEc/YOKOLtJEICJhQzlKCQ+YYIQTScSHpSFSIYn7gyR7eAg8NDFEk5lNbS6YyI+0pZF68ocWZuYRKvoDaKDE5GPyVrarqEpVWdkKTD7JwkC6kZQIM+FGcHY+OUaCkY7sEkUCscdL3kxEZcsKJuyDH0pdwo7t2V9GKIYkS//KEZPD3KUOrYhChhETgHNhmkdw1JpB/uGbBBmcKkEpNA8NUktzuKX83EdMRyytng7EhPPolZFDkG6d79xaJKgkJzqJc0R/ACYCw5kSUxZinywbmccsGQnuEDQ4jtJdR3WHO5CCsUo8OomiUCiulDCCi3hRQyDGtcKFtLM0GsVMW3T5u/7NrqSYQCZTRMYqD0aEezTFDB6cp4lseu+hw1MbaCoXkYFe0yENJWpTYuainmrtdrmrTnfU0CHNBaWptxkYAC3ZR2tV9TI0Csof+9ZSkkblD3MlJj2BYzWHDFUh3kqRWjHTToesMmhDDNLUruO2SmLkKS7zK2aemq+knsv/hVrSW2QP88MoYcRIZ2qsXsRGNMsaK4M/4kMvHUSeNC4klZ7p7GEO4S1/9BVjV40LdOZgKjrVyU5SWYkjNGERJf2vlEmdl29aexi8OgSmAUMpsUzbrw9uJHsWO25gyuoQnC7ETZLyZHYAizC3BmxwMwUoBJdbXbyslqoTuwTeIJnVvNC2UKHllXCxthF1cRa9Z0luWrWbw5NAzzQtg5fWxibYhIipWhPdr0e8VayDPLY92T3LIb5rV63h1b8ZSS6CGxwaCF7uIK8lkYfD8sCT6JVq+f0nR9x23w/fhcXaG6tA2Ig3LfhWPqO0UV7wgLOJDFRivkoZR4TrDwrHmCeb/+3MXDARVm0RYl+HIITzhFyTNqKkdoGbcWw7gqzUKtl/8pQIUhNC4pyExagpUXHgkptkgmAUIgwWs0Y+O2HBaYvOCEEz7eDLs7EVeSOJC2+dQ3M0uMQvI9Olb0bk67VCT07OFYsseWBn6LAwzHlK+7ONzcsiXZ5yefM6r0LwGmZMh4WO9ymnArNk4o8AmRGd7hvO2owQ4f4h1X1S8EMi/ZF2agHOousykgEakUbvWjOrpfVqOnPl1l3XjxmpnrLLNC8JkQSC0I5dck26kMQ129qg8RZ5BRYe/gX71wJJ3rjBtFjkhARKfEi26N6X3bGJ292Z6TKMPXLkdYvvfR4O9/++wZRKcy9pfQl835YJsp56G/wy3lpvQaAE6/TBdnv2yrXE343Gj/yNgvOaSOccNTZUe9xBqay4CFUSceNJGyjDVjluoFTqhUwaYSG8M1wSW3MiUdHf44NIyhN4OEd+G+hEStylMULDhHNwhJLh9tJNQ2TJ0dDoFKSylaxSEZhbPTBdjnpCqLh1sae9I/Mats4DqHa4hySgUHX0y+N+d1R2JuACOVLL8Y53wNZrIW679d8Nf5Acmk8hvkL74R3P1jI3TedaCLvjVY49mYGt75bnPEIQHZfnQmnvnf87ilMiaijRnPR3L8Qgp0L31cd+IGz0Z0krL/ua4wHKKFE97v873tLaY9z3pI/EJYZjSr8Pv/N7Vn7znf986Edf+tOnfvWtf33sZ1/72+d+973/ffCHX/zjJ3/5zU/6gAAAIfkECQMA/wAsAAAAAKQBHgEACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27csD0UiVKgQIT9w8+pFSoiRFn+AA/+5hHev4cM5IzkKzJixlkKII0t+Sehv48uAA03ezJkkHsygAUfqTLp0RjV/LjvSdOmS38aMTMueDRET7NEE1WhqXJi2798E+TDWhPBQ6sCYgCv3rcaxmoSBGDtaTt10JMaxE/rhXb375uuBsyf/XBxYs/fzh5sH5rPQdnj08Pce96dl4XbGvePrXys8MEPygM2x34BqAejPcwoV0hhkBDZIloEIJnRIf4BpgYeDGIIFIUOEXGZehiBmNZ8/Du3WmCP5hahiVJbR59AhjFz22Io0PnUfYOw5pEaMlyVX449JdRiYgA8dcglmHwKppFBHIicRHhRWmOKSVO5kICETHWJiYJdU6eVO6gUWoURNAjbdl2jaFF1gZ1IUpj9/pCnnTAYmKRF4ONoUCSaM8PGHFlr8wYcjc2iCSSCERDLmnOh9hp9FczBGpEx+GBhaY4MaWoiijFLHI2DiTSRkYFhSOuKlqMK5GiaJLtrpZqMC/3YhRZG06A8fh8z0aaq8yjhooZccWggekfihhquvpoWadBX5ceqsMb3pmK29VgtaoII64ggjc3Tr7bffMiLuuOSSq+256KLLx7rsttvuH/DCu+62hWIy7JQ/+VGIa34Cmu0crCIL1yGWQhuRGlH60+VMjuJIyJhq+IEHIYFcokmf1Fqr8cYcd5yqFqsVgm9Nh+ChyamX8qEJHrnmBWNjxE2khqWMtCxTrDHrOBcmmjiCssdABy10aH/MUYjALkWiScbVDjbyWZViirRCM0tdE84XqRFJIZjM4QgfTA8t9tjVasFIITa3dEghCQM9h8FnRXIJtVrgFtHLjP0xNUt4+v8zKUdaT1xIIJhY7PXX8AJK9uKLa6HJ0yOpgcnPmCneKyN2i1XyyZXD/VCkeUPeUt+htnSsH5FEgsfqrLOe+uuwx566H7TXbvvtxh6r++68P6c76nTxzAjll72NkhpzX6oFwHj4YbPWXDsSNmCa7G2VydNbSFGZFWZOk4JDcqYGHnxOD6r3H0k+/WCRpJ2QGoTMEfYfpW61dtsnig5dY3XbNP6WgPERaUp2CfwNyXoUWRvxjCezQBiwellRIKr+EAj3PaRhgfGcS/zAOcygjzRKC5sWKtgRKF0LEwhcyCEIgT8+fBAqJgzN8o5WkWUxhkEyWRNocuabQzgQNCjSiB//QHcZCqbwRYHI2IymYiSiXYJlGCFiAGkCwOJZ0DcsrBwOE5jEyqEQJGqQIpekgrfiQTEjsfIbTdyDGT5skToSLN4RCxLDy1xijhQpRMbmcEWklHE4+oOIcfKGR5FgEDB/YMQT9YO8NgYyN1Uc0iMzEjXYFJInkWTEJB8CvgzOZEKOeeN+ItE27TmEED/jgwZHoiXVXDInnayQKDUSpb/BRIeAmeV+mngZXeZGjBXCRB9LgkszvdImfrCVKT1yyE1GbkS2xFBlPKQQVGJmDs78yDQZw4dj0sRS9fMIAKPpElxqIZvd8UPbBPhLzNCPYdRyhDdjEkt/sNMjI1rlSgY5/8Ya7ciOBbHmZSBIk1qdaJ4uUYOtHDFMjLxJCw1NSRoRupxWNmZhunGnPl9iUOxENCfc88cLNYLB0r1EiuRcUUjtiYefERQnHQ0MD/N10ZFgTSYKZcxGQ8TGS/1hpzLBA7Xu2RMA6m0ksVwYPbn5pZ5i5qU8OaQ/fHmTG2WGJEmdiRSJqiSnCiacPqmnP4CqVW5+FCOxSqlKDmErdA4ojJhhBEVX4tRz9sSqUy2JVXMEEwzylUotBU03i1LFwe5Ein8dSYvqExPuKVVJh/AqbM56kz+qUSd4BWtIDpE3mRiIrA6qJKZqShSENcZONQFgYkWy12g1Zq7L2Wbe8GDaG/8WJaaywklmT1LSmGCwTf6MpN8QlEzHjJQnabSrTVSLkp4+tiU91cKgtsUt1tgrUc4bZSnfeMijEsWpam1JcQNDVY/sSrMrASav/kCoSwwLtm4pJo7wVUyGFmVX/kDtS1RLWUq+NiYG3Fgi3XtcyfzTjsOs4nOBktPA9I9StipvR7gHXJcIV2hmeyJ8wSLQvKGXIARrzId7kkbDwoS/J+lbXqOFX8Y5AhPtQwwvLdmQ8XaPsI0J70nwKuGN1BaR/U3J6VAnOMJpwmvEQ9XyHqYXUiIJIiXe8ElAaduT5i3IFnEyY/QLlENIbF99staSsdyVLmKqwAcBb1FsTB+3knT/QSXxIbVMmhS5FKJnvXIcaLkC14G+Er9cDeuJyKwRKuOI0BFRTBGlbJOSlS9VfAgEow0yvorNgRFfm5ciN4XoEqJMCyNuiA09SRQFsySkoT6NcPngZqIQMMAV0gSaZUYITcCaf0abNENmLJ1WCwS3yhXKjwGTam3meCSR+JlcveKHQFjqMozY80LUUIgWi1nWKREtY4SpkXqaOCjA9nVEnOUYcStEvvTh8lbU4OxLOULaBvFD8sSGOZPosYjwZkgVZwqU+nb6YAnrcUUkq8m4zTuusy5IJNQ7NGyKpM85lnKIt1wUMQbaI2LkN0fE+geBd4XaAXZ4jRnuYEUGgljH//pHxPAQiA568d8JCSz/PC4RNo+1tKcqNkYKq2sV+2PZbsGDtQFzR6qtlJswpqwfJifYhL/o6EE0ZGP+YO6VqDjYHwkp1jtiaKLvZeGg6ThCCkE5LVzC6QYhxLPTrREtXxTmDinmt/tttY/UNd8QqafG3wL2uObHD0N3I9z/kUU5XsTMs0WJGHWsEzHWzCMr1XlFum7fyChaRiREPDclXyTNz9dN1p6DrotjqQX7ZNj+2HsCgalujaQR7WvpsHTWPsLBH0TbFcq3bB1Mc46Qm+JDsfnFx/3s1msEpQPEhPlkOnqBSNbjEO910qjF+ZpI1fgNkTnwH24r2LsF8CnDO/9FtO8kDv2M25Thn/hhItbhT3uloC6JX3uy8HF1K1iBuJftJ7zD/TsE9wpDNavmfSFRTFv3E151CWQme7lnEo7FEw02QZsWYy7Ba9SUEocATHx0EOTHJc1HJlNXdSqxUlGXfWtXgiRxXsjFMSDjXh9oEG4XGqKnEl61gQPRSPiGE2JEdUQBf1/0PoWwdqnnfwxhKy94ET63MY7wRESIEJ5HHyjDaiohVo/3D3U0HEeYJfjFg0NxdDPEKYHzaO5UfafRWT0hWRzzByvThAIRfQfkhvSxfhWRRj/HQWMIgZbChUIhVhwDVSZBOj+hNalTZMIDNtbCPp4mI1t0b6elEkL/xT/XlIVZk4cimBLJ5jH1thKxpHpDUWl4xiuOgDYOBXVTcolvlxKPKEO9BxNVkzcEGC0H1ytz8IoagUvuZxQlEwiv4VM/OBExiBx91IrYIYlWGDYzKGwJs0xCIW9JZiaBUIkU0VPYV2d4cAlJZnbOZIGItFMWJR1ZCIf0QYY1IYzkhYvk4zV+wl6KxGQyAUCreBRyQzyOk0JXeEBxdxlSSBJPKFNHQY5Ex4ZlAUDiqBR4QHJa0IsHkVEyQoa7Bye02BCXdymm12XABHSzIUVyiBSSQzlidxCMSGNPQjcZiRA4WDxDdRTa+AcPyRYYCRb3A0SZgwe0944D8XsONpIB/5VKF0KH0yhqczE4gRCUrTIS6NaTe9GSYlF4dhQxDHeMFoF6ymgRQwQa6Ed4vVQRezI8EzQHzwgSqSh9pYGUmkN2lRN2A0mSlhJ/FhFZTIOCAiFWZFiNzShYCClEpWSUbyGWY8GWH1OVGnFgjHGWhIc/S3QQ8qVz7HZrvOI40NiN0rGSZaGXZAF+MgiNA2FZ/iCOlGl4CnF3Rrd8GyNyG9GQ1EOMUSFFghkVKzR0XicSGXgZnIc8TKNKDqF1GiSbEmgoQWlkWilDRbcRm+kYJBQZ7jiZ1sgrTvkRjklsDUGWmBdkVfRgAsGXYWc0oqMv8hN2OEkQH5k3w2kY3IOXUf/BbkJYIfhomQURSaEmk6CRnJ8TggLBgJJCCFiWmDsEX+AIJ5JmGD11i1LRbOVpJg8TSWoZEup5ewxHmwm0hUIXdnUpEUrJTdBYjw5GGHqBSxMpFfBja6kyi9yZMeIpEQd6g7HoYN+5oOu1nxkhZ4rIdc6JGaEIkE9xU1ShLxyaKn+ACfiiTgMlo/9woOpzn38ZoAcpZeCoCUS4kTI0B/TJFr1lIyzXM6BZIQz0PhU5etHJdH7XEajHfCIhn/LkEex2jbmWFq1VWsAzOJdwaYopI2XqEF4VpiFBctKxnQQRnIFZEoApGJB5EC+JKnxwCey4l44BgXOQOJYzNGo4qFD/Ri35qJx02pEdQZps8oLaWKDMlJ2QxpW0FRYjgp4cQadpyJXiZop8ChJqd0JNqJDudoSkGaIQQZ6HuCr6lxUqqBNz+TEhA4026Q+D4AlNMKkBSpML8YtElzByShLGmqHA2W4dI130ogmsgX+7Wa3Weq3Yeq11sa3cWhfZ+q3g+q11shOsSTSEwiqgeoPCoQWn4AW70AbBikYB2oAc8YQu9A+96g/JGjnPZoORUwiHyjgCO7ChuROA5y/yMijVJSzN46NoSQutsAsSC69ryTZEo35/qV4KWJOnMnebFUn7qqyBELAEW7Imy1SSoQ37ILEsS7ESMaahgTmWFZW++Gma/5Wvj0oSXqWHx3OOhniyQDs2q2UYGCABLCuxTxAFsaqlCHeZ+EWzEIFuBXd7p8KzSCUjdtosLGcxfZKrQfu1pMIZRXu0uwAKEwCRSyOD6OOP0hmr6uV++aqSvJUxxBo5REYIeNuteguU4dq337q3gBu4gsutfUoWY3u0XjAGEtIXl+KhaMk/sNeBcEJWUFm4EIky/pksVyEJikC2WTAAlMa0MvI4DMG2Tie1R8S2WTtt/WqamosTkpAFZMsCGDAQC5c9D/o+aQlUe1oeL/tsdXswwOSWr8sVzSACZEsG9hkakVZIqqsQkvtToNcjKLFS0lu8X2ECskC2t3ApjJCaz/9rEJEViWsJTEh6EuiWudgbFVEgDGTbC6Pbp+Fbk2sHqwexUhbpGXvkuuv7EkvHB5twAkerCpuwHio6pLA5EKQptxvhVTk7Ejw6davbv7rlrIBBA2TbCntQpVzaYkcjXO6ZEd0ZhycBjn5JwUsBoKDBD2TrBc3gmi32afabfSCKEuh2ryicFHKjmHFAthLADK4pqjgcEhGMhbx1fn3kZRNTMUeGaeuCqIASxVI8xVRcxVZ8xVicxVq8xVwsxVObFxs6l0umDbhAtqzASiR3viTRu7eSrpSmXrTpB4TAMz4DtnZ8x2byFgQ0r+FBQwLxA1BAtp1AlKARvHcDf6kpEfv/iMeM3MiMpSzks4upcjbI0gSWcLTkUAMggafemBIjnHpZKJ+NPMp2TGdgoS+XwMcO9qYJAQ2YnApStsinihLGOsTpU2teWzZdvMu83Mu+/Mte7MZAIceukctwoglN6hBvILFesAE/53tr97M3KWTqNcNAKMllQyi6OSzFknI5fBFyTMdT6hiMAGMTUQwSIAGAUH4XMb6YoYBf6bspgW7EmyXxM86V85vf/JQ7czHSrDFLeEYVIQ72IGIXQaG3YjdFLFMOC4MJkwK+AALE0Cyiy7wAk7btOcErcgi/QzuDSBeEs6Zdi2Hl3KkbEW5uwnAbmxvPFrJrbCLyAASJUAu1/yAHPHAnonrMftyGJZo3OorCRzewfMCVFPgR9VR5nTebL/SaEqwSqGQOLUDTNJ0IW0ABDsGe7mbO2oHRdCnM8CFVZCNdnJqFpnZBhHnCBpG+KqEGkCDVbg0HiLAQqRoajtCVOtLTmILM/Dsb6OYxIAMwd6E24ASRQ/fFCxHPoGKaiBDVbk3TEHDTBoHV7mShDdSmS7gpc4JXecZec3AJiMIpM8FmB3inF/ZOELHQ26gSI1AAxtDYtaADBSAENUlyMZoRBZnNhpIoDW0aQncu9gcswkIIzbPXEZFGSJ0beK0wlwSOK40SBwAOrl0LQaAPAaB87Wm5N1htaUgv+FcXeP/bOuAd3uI93uRd3uZ93ubt1XpR1jdo3VtqEZ9syyaBBhFwDNFtAKbgAsWD3QlZbfhMygBuzabRdTencu6Nj9tprPa02wVBDZTQ2q6N3+cQIPytQuSjygA+yhAVWraikgc+daLoYwO4EhUAAdFdC30QAzuQUCw3B22a4XZM3GjBh140aZSqzyYRWUMwCieeCAnwAtGyNV0jPTDeyKasHxdWoc3HyXCSyKdNHtOwBKtw4rWgAmdg1TTB0aozOIVjMdIKLmAe5mI+5mRe5mZ+5gAj42exNuVpdlm4j4btlafCCTkw5Sd+DAUAAPv8Fszom+pdEEyu3CEhWaJHDGsgB1T/XgurIAAWsOdosZqT7BIv6p1EyNSOAVYH4AY6kOgqEAGN7uhhEULVIuBZc2F84OT0qxojYwE3YACJXgvDoA8vMNGgnhX/iyrfmzAVnmhC6AhObqoMvRAUcAYfAOFUbgAe4A3SUOtTsSe35ji4oWIeO4WU4+sVgdiF2RBpsAVw8Oo0TQAJEAoVkAzMTo0FBGkHLBDFxHh6mtyCFxEch3fEcABd4OrejuIfcA1nUAFoUO7DPLKgCe0JgV+GLERJnqMpJF8PLBFoQAJd0O33PtXgkAdbcAYvINv+ThPwc+4fczYRNWr0sesUMZXXQtkJ4VX5ixHjQAdysOkR79aJQAAQ/5AANyAAZ4ANL3AFQoACGU8SNvriP7fTDHFI0z46dFrbBlGDAIkCsNAFIWDsL5/ofXAMcFD1cDAMWE8J7rL1XN/1Xv/1YB/2Ys/11i4ZXgZm+Gw26f4QalYTJB92Z0cQK8WsHPEJa3ADH9AHUb/3xsABRR60f94UEtNyRH6Ier2W+EXqHyFv5hNp8ka9KpEMPOAATAABjL33iV4Cfw+0Ba+hc1ExGMOC5Wy5IC9SOKGk1qL4GREAL/AKN+ABKnD5mF8Lmr/5Jivyp3e3XL6mPvPflVPSbNhdar645bptOqEBV3AAHQACdFAAHvAAHzAMBGAAx3AMM+3WQWAOtk+wFP8kFQWZaen4J4nKOEONCQJdgLDBE30OqEzY83oCtkVj/qYpRnQvE5D+MaTq/jKBhmIDEHzmXCoUSc0/hAkVLmTY0OFDhGr4+KNIkRBEjBk1bkR4qeJHkCD/zCnkh+NJlClVrmTZ0uVLmCsLhaRZ86MWPow0YSqEx8+hmEH/RdJyM5JQpAk9gpxoE6QWRpjwHExa1epVrFm1JjzkqKYWLX/48HHkaI6mSzwJ4TG4NejMj3+ouk2JKWShf34CMXJKUyAmQnPpDiZc2LBLP0U/Xjy8dWlFR4IbN7QLEq9CNYQ0/elL84/OQD4njyZdWiuep0dNJz3E9+Oc1Qorf7zsMFL/oDmKO4fEOTAQobaxhQ8nrjCQSJPFX0oEeUn444q1M96ew3m3U5yMfBcC7keycvDhk2oS+V08x8QgMa2GTlH6ST+FLjnSfX03WLGOtGtCmzZQoEIC5I4QAgs08EAEE1RwQQYbTBAPCCOUcEIKIUzuPNZcq4gP8zDMCDXLSiMvxJcOiUQ+Rqyzb0UWW3TxRRh3YwQoD4Vi7qPIakQJLtomO2SOu6xSA49ANEkxRiSTVHLJFd/TETEVKcrxyY2OI7EwNTSMji4TCQnkEkYciZJJMss006n1qIyJKJCmVBOj9vxxUis/mlqMtEP8wMNLTDSZwxE+/qjvTEILXVG1N1/C/2NQNxN1aMSP0nQrkjG1wOO8Q9TwI5I9CSnkP0wuEZU/Uucw9VRUU1V1VVZbdfVVVRmRdVZaa501JEkddWnRNjvU9R9IK7qExqysvOnSX5NtyViKGFH2JUJCavRZYENixFeY1ABSJESp9fbD8r5lKVqmLvQ2zj+6FQqPMf1xxFxx411IjTGRlTclcuNS91lmK8KE2Gy3BWkOgO81uD3nDFaJ12PjLWRQf/iwtyU1MIHYn0AU1jiv+hwpeGONGO5RXEpp0gTek9S45GKJQVYYOi1Qdnm6docVN8ua5pg4IzUK0RIkTbCd+Vc16st16I3qtFboRAO52J8/LiFE5rwIwf/EK5taRlpeHv3Rgumt58X6Iz72VdaPsWv6Q78wxbwvkI/DflZgfzSRG6UfeZtTWULahVELTMC++80odx48o9k+CjreQwKx80VHAhH8cCr9AGlyyv8hBGI+qOY7NxYdwcTszPnGsXT4HqdIi72fzWy+i7MDDHPUqUw84do10pamazfWNJJI/PAu942DbZ14hh4O6Q/GkHf+zbRJf36hSFSnaA7Pp9d+uChpJ/6QYCvSIuPtyy/ukLjMz6hvmhyRXn34B1OD7PghUiP8ihavf//BLN+Q/4ewjzeBA2ABr+I/ivDBgA25n9oKEbcFRjAl8xOfBBkSibSR7YEW5GBK6uP/PfUpzy8b7GAJMZK25plQZU/7g+RM+EKGQMduMESIH/AnvpPREIb5ghoEOxgJulmLhDq0YNHuRESEABE7mjAcEvlHN2c5sYaaeBpFotZEKZoPRBXBIg0r5re4aCIwWXSUifb0qUCEyj/cEY1QHhdFMv7jEIXIYE1EN5U4hscPVvsTGG3yGcBkTyM89EcK4+gHTPixTZoIRCR8mEcu4QETjKiii/ggtUdC5HF/yCQRD4EHKq7oM5f4TXAgmRW9UNJQXtNZSrZIkaOd8pOb+dvaymIrW50lLT0BIQ0RWcdVRsyFHPnZ+/IYiUlW8kwjCYQgdTjHn3VmbWfBBIAEBKpL//TxPgTUSHog08k8fjKZwQQJI7oIw4opM4FzCOQEiVQdp/zhnLJRzynRgyJFkmkOvazf/ZTpCKnxsyHItJ6/NHII1c3TngyMhJf8BCh1tihdOkynTbRAEoFqJBIrM1knIxGuhWZLU8IjqfCAd9IzfulINLEUDNllE0aMkS5qCES7ZoiRxPkDNiGdjF6AeTz+7Y6lmHDmVVSGK41kkHw8nQwerKcJcJavosuDW2k2BxKFerMixmSqVnDWpqIi7XfB84551HAi0PGmqqsRWcQ6SUi5dNVHQfSaIeVG05V+5Q97VeY+idM1jGmkPTOS62RyCsvBKZFJWisO3TiZka40p/+wk7nqwKL6LRuSCXCXPYwRt5QRP4wJqJPFCtqsxVlliVBJfBimeKADR4y80mtcJa1VDhEnwvoumhvSzhxkBahACQosOHGEJkqiIwR6Lar9+kNYa5sUwNZtYy+VVmvvhUKOhM9jzzVMW+W0Ej15CjgZzcphI2bXeyVupwfN4E25OxjZaoG2CfHDJfx2See65avqQe2vkvs1jtDrSu+lC2DjClq60gR7pikZt7aWtlhChE0VOTCB6dKeaTGksvcZbVYOYV6/bq1rFdYIYCNs4atElmxUu62LTrwVDNJkqVsTsEFPQjcAo1i/lVorQuboNy0Ulz+qDBJh8LBbeR6OWTH/g8+AdYzKdl0UE5hIK1MIUbBDEMJ6Cn0LMP3Ru8PVuFkoCRZsnwxlFkH1IS02ymkKSpEZHw6wHU7IRz9C3jMnzct600hOOZTiOFWEEfkFWdqYzJHHoTfPVWmcMvWnEe32V3e7PS/y7PxNjkAHd4v2KiasFzVCqzh/SVEDMFv5vH65FyNdMzOn6eQp7hAaM2N68UqiOejy/SzOD0nuH1ytpglXRNEqySnr1Cdm9xwUJJL+NWniK+uBPoXLtfPusBXSvWZTqV9/dkkGp507wLYUI4+DdrZJ0571rkS2tdZesa39j+iZ+0miTjZLtMQHZpcOf8dLW7nlPRlk5zglyS3k/wLx92Jy//tJsk33SZilwAjiD8wLqU++Fd6Y9sx3IVpiN/ziND6A9fri836jSgrHwX5ZcXSaSlurRy4e2Wo8IjexOPK86xQ6vzw2WlL1dOhXQtNKs+Y6L8wrBT7Ij7g8go3GzreJvprHbXp9r/EiR5fn9KebZsmT46HSOZhlMJGFJEPPOpai1HCIvNLrZWc7SvpF50tHrO1zbwlCsao7mtNd7658yrsREiWZ733vh/0XRui2a8En3iF0dR9EmLV2xUc+byHJYbTFR/bIjxx8OTMb4DP/eYc4rSasFYyW/A56wcfYJqfWUs5Rr/dCKDIsd3997blSiDfzBvO2fzkeqj9cE9fzXvA0fXPHhY/6jTblooE/Pujx3HzoR1/606d+9a1/fexnX/vb5373vf998Idf/OMnf/nNf370p//1AQEAIfkECQMA/wAsAAAAAKQBHgEACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27csD0UiVKgQIT9w8+pFSoiRFn+AA/+5hHev4cM5IzkKzJixlkKII0t+Sehv48uAA03ezJkkHsygAUfqTLp0RjV/LjvSdOmS38aMTMueDRET7NEE1WhqXJi2798E+TDWhPBQ6sCYgCv3rcaxmoSBGDtaTt10JMaxE/rhXb375uuBsyf/XBxYs/fzh5sH5rPQdnj08Pce96dl4XbGvePrXys8MEPygM2x34BqAejPcwoV0hhkBDZIloEIJnRIf4BpgYeDGIIFIUOEXGZehiBmNZ8/Du3WmCP5hahiVJbR59AhjFz22Io0PnUfYOw5pEaMlyVX449JdRiYgA8dcglmHwKppFBHIicRHhRWmOKSVO5kICETHWJiYJdU6eVO6gUWoURNAjbdl2jaFF1gZ1IUpj9/pCnnTAYmKRF4ONoUCSaM8PGHFlr8wYcjc2iCSSCERDLmnOh9hp9FczBGpEx+GBhaY4MaWoiijFLHI2DiTSRkYFhSOuKlqMK5GiaJLtrpZqMC/3YhRZG06A8fh8z0aaq8yjhooZccWggekfihhquvpoWadBX5ceqsMb3pmK29VgtaoII64ggjc3Tr7bffMiLuuOSSq+256KLLx7rsttvuH/DCu+62hWIy7JQ/+VGIa34Cmu0crCIL1yGWQhuRGlH60+VMjuJIyJhq+IEHIYFcokmf1Fqr8cYcd5yqFqsVgm9Nh+ChyamX8qEJHrnmBWNjxE2khqWMtCxTrDHrOBcmmjiCssdABy10aH/MUYjALkWiScbVDjbyWZViirRCM0tdE84XqRFJIZjM4QgfTA8t9tjVasFIITa3dEghCQM9h8FnRXIJtVrgFtHLjP0xNUt4+v8zKUdaT1xIIJhY7PXX8AJK9uKLa6HJ0yOpgcnPmCneKyN2i1XyyZXD/VCkeUPeUt+htnSsH5FEgsfqrLOe+uuwx566H7TXbvvtxh6r++68P6c76nTxzAjll72NkhpzX6oFwHj4YbPWXDsSNmCa7G2VydNbSFGZFWZOk4JDcqYGHnxOD6r3H0k+/WCRpJ2QGoTMEfYfpW61dtsnig5dY3XbNP6WgPERaUp2CfwNyXoUWRvxjCezQBiwellRIKr+EAj3PaRhgfGcS/zAOcygjzRKC5sWKtgRKF0LEwhcyCEIgT8+fBAqJgzN8o5WkWUxhkEyWRNocuabQzgQNCjSiB//QHcZCqbwRYHI2IymYiSiXYJlGCFiAGkCwOJZ0DcsrBwOE5jEyqEQJGqQIpekgrfiQTEjsfIbTdyDGT5skToSLN4RCxLDy1xijhQpRMbmcEWklHE4+oOIcfKGR5FgEDB/YMQT9YO8NgYyN1Uc0iMzEjXYFJInkWTEJB8CvgzOZEKOeeN+ItE27TmEED/jgwZHoiXVXDInnayQKDUSpb/BRIeAmeV+mngZXeZGjBXCRB9LgkszvdImfrCVKT1yyE1GbkS2xFBlPKQQVGJmDs78yDQZw4dj0sRS9fMIAKPpElxqIZvd8UPbBPhLzNCPYdRyhDdjEkt/sNMjI1rlSgY5/8Ya7ciOBbHmZSBIk1qdaJ4uUYOtHDFMjLxJCw1NSRoRupxWNmZhunGnPl9iUOxENCfc88cLNYLB0r1EiuRcUUjtiYefERQnHQ0MD/N10ZFgTSYKZcxGQ8TGS/1hpzLBA7Xu2RMA6m0ksVwYPbn5pZ5i5qU8OaQ/fHmTG2WGJEmdiRSJqiSnCiacPqmnP4CqVW5+FCOxSqlKDmErdA4ojJhhBEVX4tRz9sSqUy2JVXMEEwzylUotBU03i1LFwe5Ein8dSYvqExPuKVVJh/AqbM56kz+qUSd4BWtIDpE3mRiIrA6qJKZqShSENcZONQFgYkWy12g1Zq7L2Wbe8GDaG/8WJaaywklmT1LSmGCwTf6MpN8QlEzHjJQnabSrTVSLkp4+tiU91cKgtsUt1tgrUc4bZSnfeMijEsWpam1JcQNDVY/sSrMrASav/kCoSwwLtm4pJo7wVUyGFmVX/kDtS1RLWUq+NiYG3Fgi3XtcyfzTjsOs4nOBktPA9I9StipvR7gHXJcIV2hmeyJ8wSLQvKGXIARrzId7kkbDwoS/J+lbXqOFX8Y5AhPtQwwvLdmQ8XaPsI0J70nwKuGN1BaR/U3J6VAnOMJpwmvEQ9XyHqYXUiIJIiXe8ElAaduT5i3IFnEyY/QLlENIbF99staSsdyVLmKqwAcBb1FsTB+3knT/QSXxIbVMmhS5FKJnvXIcaLkC14G+Er9cDeuJyKwRKuOI0BFRTBGlbJOSlS9VfAgEow0yvorNgRFfm5ciN4XoEqJMCyNuiA09SRQFsySkoT6NcPngZqIQMMAV0gSaZUYITcCaf0abNENmLJ1WCwS3yhXKjwGTam3meCSR+JlcveKHQFjqMozY80LUUIgWi1nWKREtY4SpkXqaOCjA9nVEnOUYcStEvvTh8lbU4OxLOULaBvFD8sSGOZPosYjwZkgVZwqU+nb6YAnrcUUkq8m4zTuusy5IJNQ7NGyKpM85lnKIt1wUMQbaI2LkN0fE+geBd4XaAXZ4jRnuYEUGgljH//pHxPAQiA568d8JCSz/PC4RNo+1tKcqNkYKq2sV+2PZbsGDtQFzR6qtlJswpqwfJifYhL/o6EE0ZGP+YO6VqDjYHwkp1jtiaKLvZeGg6ThCCkE5LVzC6QYhxLPTrREtXxTmDinmt/tttY/UNd8QqafG3wL2uObHD0N3I9z/kUU5XsTMs0WJGHWsEzHWzCMr1XlFum7fyChaRiREPDclXyTNz9dN1p6DrotjqQX7ZNj+2HsCgalujaQR7WvpsHTWPsLBH0TbFcq3bB1Mc46Qm+JDsfnFx/3s1msEpQPEhPlkOnqBSNbjEO910qjF+ZpI1fgNkTnwH24r2LsF8CnDO/9FtO8kDv2M25Thn/hhItbhT3uloC6JX3uy8HF1K1iBuJftJ7zD/TsE9wpDNavmfSFRTFv3E151CWQme7lnEo7FEw02QZsWYy7Ba9SUEocATHx0EOTHJc1HJlNXdSqxUlGXfWtXgiRxXsjFMSDjXh9oEG4XGqKnEl61gQPRSPiGE2JEdUQBf1/0PoWwdqnnfwxhKy94ET63MY7wRESIEJ5HHyjDaiohVo/3D3U0HEeYJfjFg0NxdDPEKYHzaO5UfafRWT0hWRzzByvThAIRfQfkhvSxfhWRRj/HQWMIgZbChUIhVhwDVSZBOj+hNalTZMIDNtbCPp4mI1t0b6elEkL/xT/XlIVZk4cimBLJ5jH1thKxpHpDUWl4xiuOgDYOBXVTcolvlxKPKEO9BxNVkzcEGC0H1ytz8IoagUvuZxQlEwiv4VM/OBExiBx91IrYIYlWGDYzKGwJs0xCIW9JZiaBUIkU0VPYV2d4cAlJZnbOZIGItFMWJR1ZCIf0QYY1IYzkhYvk4zV+wl6KxGQyAUCreBRyQzyOk0JXeEBxdxlSSBJPKFNHQY5Ex4ZlAUDiqBR4QHJa0IsHkVEyQoa7Bye02BCXdymm12XABHSzIUVyiBSSQzlidxCMSGNPQjcZiRA4WDxDdRTa+AcPyRYYCRb3A0SZgwe0944D8XsONpIB/5VKF0KH0yhqczE4gRCUrTIS6NaTe9GSYlF4dhQxDHeMFoF6ymgRQwQa6Ed4vVQRezI8EzQHzwgSqSh9pYGUmkN2lRN2A0mSlhJ/FhFZTIOCAiFWZFiNzShYCClEpWSUbyGWY8GWH1OVGnFgjHGWhIc/S3QQ8qVz7HZrvOI40NiN0rGSZaGXZAF+MgiNA2FZ/iCOlGl4CnF3Rrd8GyNyG9GQ1EOMUSFFghkVKzR0XicSGXgZnIc8TKNKDqF1GiSbEmgoQWlkWilDRbcRm+kYJBQZ7jiZ1sgrTvkRjklsDUGWmBdkVfRgAsGXYWc0oqMv8hN2OEkQH5k3w2kY3IOXUf/BbkJYIfhomQURSaEmk6CRnJ8TggLBgJJCCFiWmDsEX+AIJ5JmGD11i1LRbOVpJg8TSWoZEup5ewxHmwm0hUIXdnUpEUrJTdBYjw5GGHqBSxMpFfBja6kyi9yZMeIpEQd6g7HoYN+5oOu1nxkhZ4rIdc6JGaEIkE9xU1ShLxyaKn+ACfiiTgMlo/9woOpzn38ZoAcpZeCoCUS4kTI0B/TJFr1lIyzXM6BZIQz0PhU5etHJdH7XEajHfCIhn/LkEex2jbmWFq1VWsAzOJdwaYopI2XqEF4VpiFBctKxnQQRnIFZEoApGJB5EC+JKnxwCey4l44BgXOQOJYzNGo4qFD/Ri35qJx02pEdQZps8oLaWKDMlJ2QxpW0FRYjgp4cQadpyJXiZoqCAapqd0JNqJDudoSkGaIQQZ6HuCr6lxUqqBNz+TEhA402iUh9ShCpGho0uRC/SHQJI6ckUawZCpzt1jHSRS+awBr4t5vUWq3Weq3WWhfauq11ga3e+q3eWic7wZpEQyisAqo3mIy/GqzKY6cC8YQu9A+96g/IGjnPZoORUwiHyjj82q+huROA5y/yMijVJSzN46NoyT8P+afupH5/qV4KWJOnMnebFUn1mqyBsK/+urEcy1QGhl/SGauBQDyYY1lR6Yufplnz+qgk4VV6eDznaIgdO7Njs1qG/2FZL8sQSgoamfgPJiuH6FZwt3cqOSsSYnWyKiExFXMxfkKzTmstqVkWOBtIISSD6OOPIfsQ4Oh+86qSvJUxwxo5REYIZMutZguU4Jq23nq2bNu2brutv7qX+EWxl9kXl+KhCWtcEdGBcEJWUBm3DGGq5ZcsYuGPF6tyWlo5j6Ozael0QXtEWOuu03avpkm4OOGPVfgPC5c9D/o+aQlUe1oeEuGPK6anwOSWlstnCVM9PxQakVZIkasQfPtToNcjKLFStJu6XzGvqMIIqRm7BhFZkbiWwISkJ4Fu/qm7/wmajtOnwFuTawerB7FSFukZe1S5yvsSS3drrws4z1Y/pP/ptRvhVSw7Ejw6dZKbvbrVrEuavm3YYkcjXO6ZEd0ZhyextQirviwBoL1CtxuBmZ8mvdkHoiiBbvGqv0khN20aGPKwBzLADK4pqgccEueLhbx1fn3kZROztJeWaYgKKCAcwiI8wiRcwiZ8wiicwiq8wiEstHmxoXM5ZuRxD62wC6zASiRnvCQRureCrpSmXrTpB4TAMz7ztEZ8xGbyFgQUoNhBQ20oD06wC1K8C51AlKARthJxqVEbEfuIxF78xYylLOSzi6lyNshSCZYwxbtADjUAEnjqjSlRv6mXhfL5xXZsxHQGFvpyCUzsGG+aENCgxrsgCz/gEV3Mp5bYNhP/nD61lqtixsKQHMmSPMmU3MI+DBRC7BqOjEia0KQO8QaCvA/FAJxrJ7M3KWTqJcBASMZlQyi6OSzFknIIfBFCTMRT6hiMAGMTUQwSIMhFsKJoqIBfKbopgW6omyXxc8uV85uz/JQ7w7TKfCJMeBED4AVqbAPscBEUeit2U8Eylb8Kd5dSmbgpAzBLI4PuqyKH8Du0M4h0QThr2iebLEO53Kkb0QTkoMZtMAFuwnARmxvPdriRI1yO4H1951Oa4MRtWKJ5o6P6e3T9ygdcSYEf0QCCnAXacDf7uMggBky5ixJ1zMwLwZ7upsvacc6u69CpK1VkI12cmoWiIMgXABHb/3yQEYW8KgGO71RNAeoIXakjDI0pnYy9s4FuHgMyAHMXLSEOWSDI3ACRQ+fCI50x1WsSddyzBEHS7mShDdSmS7gpc4JXecZec3AJiMIpMzEBNTzFbWACCmGHdwgR3ryNOX1hiysQUwlEoogRBdnKhpIo4FwaQncu9gcswkIIzUPUERHIaowDzpCQQa0wlwSO/4wSNU0YyteegNuG1ZaG9IJ/dUG2rTPapF3apn3aqJ3aqp3al7wXMiDIb1AQQbqlFiHHHB1nh3xNm01p1RbNd3zHqmwa4kAF15wBbZjZbbSdxWpPgQ1Jl2IOAbLbCuFoffzbdwxRDoLGavwEJoDcRf+01385gFbXYvKQA30QAzuQUCw3Bwts3U+r2GjRCYLMAtPgRZNGqSIdZ5I1CrVQC4mQAC8QLVvTNdLj3l+cx/oRDb7MP/ntEW8MJ1v8EADoDxzQ3xZeCypwBhRAMoEzOIVjMdEKLiI+4iRe4iZ+4iie4gAD32exNlwgAmqsCgpQIQ1egEwj1V75aXxQAhd+4cdQAADQzG/BjIBxCvk8xaAwCFyNEg8u2SEhWTOIAnLQ4z2+CgJgAUKOFqt5GQggyBLgEi/qnUT4mvwDVgfgBjpA5ReuAhGA5VkeFlULGmIgyAiQUBfGBxGO1wE9MhZwAwag5hc+DPrwAsTw5lqxvb3/+wPWPMWq0MZJI4SOsMWCSz0RRQFn8AHGAOgWbgAe4A3SYOhTsSe31rwCUQOqoMZeMADsRzmRXhHDTB80lwZbAAeafuEEkAChUAHJAOrUWECQpqID0eVqrASwGDaCFxEch3fEcABd8Oe1buF98AHXcAYVgAa8jskZy7zYhhC9vAsn0Aulq70XBieda5jneRFoQAJdQOvPfuGJAA55sAVn8AJCcO3jSAi+/jFnE1E/AAptMOP0Id0UkdfLLDpeVdUXMQ50IAdp3u5UnggEAAEJcAMCcAbY8AJXIAQoYO8kYaPtbcYPUQM+wE0sThAHDaPgTRA1CJAoAAtdEAKZ7vAy/98HxwAHNg8Hw5DzOr/zPN/zPu8L6OAuQj/0RF/0Rn/0Qt/qkuFlYKbMZgPstXFsNUHwW505K7WsHPEJa3ADH9AHMv/1YC/zQ1DfBo4qrQ2lLVfghzjUa4lfwe3GkY0jz7hSydsRycADDsAEENACYd/3fh8BZZ8qWEwVWkMx/OLbFZLLcTtqonG55Mwrb68RAfACr3ADHqACfO/3mq/muSAPgX8pAn96Y+vha+oziM8/9cyG3VXyxWG3vFL3K6EBV3AAHQACdFAAHvAAHzAMBGAAx3AMibD5tZ4Enx92kZ8TBZlp6fgnico4Eo0JZyQSxYTgM0HkgDrNHF8TSeivRf8D/aYpRlgvE1v+MaSa/TKBhmIj0QQG36iX5yQB0URjnebfEny4MdLFCJpysHqiTKEPEP8EDiRY0KDBS/4ULuSz0OHDhVoYYcKj5uBFjBk1buTY0eNHkCFFjiRZcuAhRxAVatHyhw8fR47maLqEqRAhPJEsmuT5sdDDPzt7Di2ICWKhf34CMVLZVCGfOZgICSVa1epVrFm1hvSj5SGhrWE5JnToiKrYj0YfIiWohpCmP06d/mGkKRAeP2j17uXbFyueh1oi+d17iKnDOYQ3qnXI9mKkQHO8ynWqBeqlQIR0Kubc2TPaQEDzfs6qpqHDS6QJkm3sEfKcuJRlW2Y0B/P/zUh+zqrm3Zu3JqC7fZfs+hATb9YLHYP0U+iSo8mypUdsCbO2Jpo1AwUq1P0mIfDhxY8nX978efTpy+Nh3979e/jsRw9Ha/ghH+H0RQJeSxp4f54OicQ5RmKb7kAEE1RwQQYZZOQQ/cQy7SGzIuTpJwAVO2SOo0rDIxBNCmxwRBJLNLHB5SzEyg8DFapQRZJCy7AvNQ5rTS8BCQnkEkYcafFEIIMUcrrjYNQqkuhczM/IjZJTKEW0/DjNIbA8O8QPPHTERJM5HOHjjySHFHPMBQdjMis8wnzxzI/+c6hIvSL5UQs8jDxEDT8iyZKQQrbD5BJAsRN0DkILNfRQRBNV/3RRRhtFlBFII5V00kghgpPNq9KkcElMD3JzoUsgFEtGh+js9FTQHmIEVawIgWhNVjH6VCFGOOVJDQ6BMjNWXonib6Ggeq3K1fvmE7YgJ/35Y1er8PjRH0eMPXZakNT4sU5qeyLWoWWzJYjUN0UdCleV5hDXW3Q1cjK1dE3StFRs0S0kTH/4iLckNTCh159A2vUXo+IWcuTcf0N690Z05VRJE2k/UuOSfe0teOLVSm2YYteeDTXdGpua496N1CjERog0sRXjadVI8lKUmZtyoVrbDWRfZS8h5OKkCMEkJackbnliDFc6+eeL1ODZIT6YzdaPo5v6wxFIY3pWJS0CIf+Y6HRzVUgTrEfaECItoKSWkKkZ1AKTobvutUWQ1faIMYdMbveQQF5e0JFA0nY7Vj8e0ntvggihlw+cpyVEsgQdwURpwNPdFtrGRZISbLGzdeu5fWmT6u/IY4Wb3c4d1tqhmCnGM5LcdAv9508rXz2jeSH6o8rXa5+2acZtzygSuxWao3Ddg4exRc5tP2TWlfoVfnkmD+GWeY/IVsmR3KG3/jM1kL6eIzWQ37r47cO3qm+GxN9IerDRNn/9vch/iv2Mune6kKvht7+n7CO6H6NImkaa/v0FkCdJAt/1YqcSPgBQgAsESdNox8CBPIxmf8gbBC2YkeRw7YIE8YP3VsL/sA2GUCCP+0P9LBiJ0UGEEQoUIQNVRqUWEgSFctGCJtoWQ/iNblU4HEgHaaaQP1zihjzc3q8UMkQR5qtswNLEVIjYKwFlqU+B+JN2boIXq7xsh08UyCEK4b+mKK4iXISRH3TWpSU6bSI3M8nj/PFAMvoBE2ksi10iYUIy9uUQeMAEI364ID7YDI8aeVkJ80iQPWrij7JjBGY0U8BDMmcpiyyRFj5mMONEsiCJpCMNnxYTSlFqJjUpxBg1aRA5gpFMDKmgR0jmj+pFMhJ9pKSQ/jCHQAAvhl58pWyeNhNMcMc7froEGqVztrQFzEWDjOQeablKlTACiSHMVy2hIhVd/x5EDR+CjVz+ME2CwM0fLDvlRZrDo06eaA6QFF/3FukIm7HTILPs3ULIeZBD2A2c5SyIGiKhIy55qZYJ6lYS9VWZORRCnhuJBMQWxsx/RCI4/LwVnvxwUYzmCXWok+KORES1fcLPWU5hhBP3ooZAPEuDGhFnYiiqGKWo0nXwIxfVMJFNrTzMUhzxn/Jeqhg89E4TEL1eNVVCQaKKRXAP2acyFRLLn0qol9Gy3elSpwbh+LMQiAOb1XpzsHpB1I3BiiphvhYYOLoNpR9tSkv+ACbKrJM+QVOITzGoqqSW9SriVMg9fzZDIPlMP6MzpEZQ8hDQ6bUvS32IubrWwSCdLf+vinmhcjjCohkptn1gfBDRDmgiPrQSRsnZokaM6A/BaNYvh0hWZzHWsabwoTZziNpL3soSlsBEE4XAaW/ch9qkgktZvVVtVei6NYyN9FWi/ZcDPTKrgRW3L2D1x0wzgiU+PdJCfK1XWv8FN5dy5LBxk+50AwNVVF5iaoEkrl5ga5zJHuu3WtCbtTJb3rAcl6wa8UMKPdberShMV11rml8fk6T94lcsToLVQRh7TOuK5RDclWvX6JrgjRzXwAq2yngZgjPWLmjDYemfSuyKNfvaEySjoy+H0ZLiiHj1JIWYmhYcISg/qiTCmeqlskI6MXBpob2/ra6Lo/QsS2ICE1z/vQ8hCHYIQvTuxz35YlNKBzgY+6O0HPnUlo2cFcwiaKgYCXGp0NuToDrlxIA77o4HIlGHLPTLG2HadMLGEXHiRytljiaAMdY0IX/kZd6dc4dnRhm5dQS68e3Ie5usOzgLLK/JSWyhc4qJ3gURwB5GrlWMVq4pq024K80w6SzdPj7dxM8R/NGIQ9JLRqy6a69cszmfd2pMIekrRBHnnYv6ox07zyGMxrVnThtonkR6JaHuHHUJXRDiFRtTwtWzSfzH7NAd11SEdIispc0ZJ4V3JKd1tfB6/WyB4O7bbOJ0kUlCMj4Qe3XIm2nTvL1uwmS5xZLb9f2QZ+CX3Rvffjmt/7g/Ai4+CBB5VyZIkuQ9cMU46cwHIVm5r5esqp3rt3+AOLu1KBK2MVC4QFwcnprm5Y5b6LQTb0upHh486srFzSlXDclIzRFlJ9yCdfbly2lu3oj87XEoDyDd/rjtnzPpZZXWyOMMDkEJHhXbSe9MkPU29F0SgkcwSajPqU6jFj0dI0Yk+tfN3hHhujnnZ2d7SPLJVO65vO1z78ix0T2QFrGc7m3nKyaYObpa713wA/Ev9TICrrIPfu9nfQgID6JsLXhd8fg+nsdyl/fJZ/5bNAstVUh2d823vcROueQ/SDbz0Judxp6Ee+pT78V6Uk3yroc4HpjcFNTTvu0ojb3FdTQ/+IaexpJ6/33m5Vx85Cdf+ctnfvOd/3zoR1/606d+9a1/fexnX/vb5373vf998Icf1wEBACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVO1RSgjtCVOrLOmKLI2DsbS+ys5noXagNOEDl0KrwQqgwqptnPPUsQ7Bl2FtpAbf+6hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTG1MJRKKIEQV5yYaSKMNcGkJ3LvYHLMJCCM3z0RGRRvacGxztzzIDsVUN04RJGMrXnl2sctWWhvSCf3VBtq1T13Z913id13q913y914S8Fw19g2u9pRZRv7+8VnR8TW1dENRmyWf82KhCyabRdTeHuGGjoBhRrPZ01jd4YTm22BJCPm0M2WYMUaHVIlzwBiYw2EX01H85gFbHmpK6EpU2BwtM2k7r1WgBPq6gCLvAAtPgRZNGqbNsEsJ7t8x8MFvTNdKD21KcxvqhCRsgC7tQ3UXAP8X9EXiKSE9s1KP/Ta/pLBPOrDqDUzgWE63gkt7qvd7s3d7u/d7wDTC6fRZr8wtUUN3VrQoKUCHZLRL7mNJe+WkB1ry0/BbMCBinQA74vQugMAgzjRLbTXS6JlkzyK5tZNAFbhareRkIsOC7IAEu8aLeSYT67BhgFdXuptEZDhZVCxpi4OEIkFAXxgfdLRAA6MryOtZsUgYvQAwrrhXb27s/4AULrgo1wFFC6AhPLLjUE1HUFqD9UAsG4AHeIA0/PhV7cmsE/g81oAoL7gUDwH6Uo+QVsdKFWWPHeRkqUAtszuYEkAChUAHJcOXUWECQpqID0eELngmweNmu7RAcJ37Ywxij0OaGzuZ9//AB13AGFYAGdF7IGcu82IYQEuDhDUApnp2jKSRf5SsRm/MH03AHhz7qbZ4I4JAHW3AGLyAEjz6OhGDnH3M2EfUDoLDg5NAEQG2QD44QXlW9mQ0AcqADpD7shp4IBAABCXADAnAG2PACVyAEKNDqJGGjt63FD0EENoDfyADmBUWnMZpmVgQSKAALXRACxkDs6E7sfXAMcNDucDAM8B7v8j7v9F7v9n7v9z4E7rLv/N7v/j4vNf4VXgZmsWw2eA4RPeDhbIBMkXp2BLFSy8oRn7AGN/ABfZDuGJ/xGr/xHN/mvOC0fw2lLdfch+jRFsEMLADjVaXjt/KMKzXRHJEMPP/gAEwAAS3Q8Tif8zp/6JTgtElMFVpDMfyCyyVHyhoxBrWO36owCZd7zLwi2RsRAC/wCjfgASpw8zuf9Vp/6MDgtKB9emNb3mvqM0QvI9jMhkTg5fgtCz+QExvOKzCvEhpwBQfQASBABwXgAQ/wAcNAAAZwDMeQCFs/+KNuDCUwsxQkFQWZaen4J4nKOPGMCWckEo/g4ftQDACb5imjy9JeE0nor0Uj+ab54gv+Bj3x9kpGqp0vE2goNvFMYLo9AES+4NDgE+9MNNa5+i3BhxsjXYygKQdrE02g4PhtCbi+Eyt122Yj+ro/ZULoL/OCycFiFygHFA3g4bIwBTrhVZD/0Wzk2kYAw6jN7xE2F/A3cQEebgaSgBPcz9h6LGC/f3Ihf+WHlLVM4Qz74OFigPk1ARCY/A0kWOjfQYQJIwWao4XgQ4gRB2rhM+dSIEKR1CTk2NHjR5AhRY4kWdLkSZQpVa40GQjiHz8sZc40+cPLLpw4ndDkmfBSRIMlF875I9HoUYqMLAYqlNHPxp5RpU6lWtUqR00voV7lOrJOm5w4GXQ9+RNi0JR+Cl1y5PDo27datPzh40ipJk2XLmEKxLTQX0KBBQ8mXNjwYcSJFR/G09jxY8iRG8ckW1nlIUYQ+Wy13PlfO1VhdzXwDDLrWZ6HIq1lVBTua9ixZc+mXds2/0RGh0rvBqmGD0RHnHlz7WQjrA3Sw/8dmgPUqho8gTS1vl3d+nXs2f2hVa7cj2uCwbt3RSAa+XA1mVFbVk0o0CVGjsBrp1/fvmxM48dHchteuH6p3jCPnd38+A0iQvQ7xA883MNEkzkc4eOP/u6z8MLbIgGwOzwq9Ee8DakSJSxFUMmvs0jm80cLPEIM6RA1/IikQUIK6QsTvS7Ba8c5evTxRyCDFHJIIos0MkhGklRySSaVjOhEF3nrELj/omSpmGhwyuKIgS7RjSyXIGLRSjLL5ChMghgxczdCIgJxzZWwFEGXhxipMio1mntJQzj73BAPrfzsrE3NKBP0pGK4iP/oDz6pwkPFDw09dFLP1FCxRUrJIvQhRjNtSSJMvuwpT4nmENVTVK8yi6BLUu1qyofGdDWkQjz0hw9MZ1IDE1v9CWRWYKfyo0JHTg1WKlgf4u5YhFKUSBNJUVLjkl5xZfZamVZdMVpseXIWIi+7PSg9o+bIlSQ1ClHv2TvFdbcjNSqE8l2eDIzIzncD6dWfPy4hhNuD/CAEE0fespZehEEqJNZ2E5a2YM0a7dYPiI/6w6745INNi0CMdfhjPQfS5OOemItIi2WxJQTS6rTApGGS353v3JhlEigiTWB29ZBADqzOkUB0rnliiIQeeiRCbOUD4GsJaYg2RzCR+GiSN/3/kOp6fSYI5YTVIIStXpPChBCjse725i7NponUe8sGNsZIIvHjKbXrPm2glOtOqdZFE9T775gr9mdqwFGKRGuC5mC6cMaDnc/txhM65O5Yf438cmAP4RTzlVaWyBHCORcdTjUe4mP0lNSg/KGcUXfdTD9Mfx0lz09+eXbcAYydoNNzL0l1o/4oxGPfi++q9K2NF0pw04dX/nmuKoTcd74l4sN56LOPSnC/te+N2uCD9n78lbQdmXyQ/Fg9VmjRdx9pTol//59IQpaIEezn1/+feB/qfn+F2O9kmqAZAMdnPzUZsCPq29dA+lVABSoPUA+BoAJ3xTJOaYJsEWSWahpk/6NA4GgvTCEEHha3Eq0lkIMcOUQhmGeUqOFheiv0zsAihEGLMWJsJySJ1fzxPxoixA+YwCFwNBGISMgviLw5BB4wwYgG2oYP/lKiSLT2hypysImaiOKiGHGRjMxwiSzxQyCgiKGJmCslEyTIvMYoOTxooohwmYsj7NikJs0hL5gohAzfGJIhvhCNA+GD+EyyroGE7o8HicQTu3ifP8whEDxUYAsRCZuL6ZEvf/nLjS5xw43djiTDekixFvkiJ55xkLipoAF39chbzWGHqYsOUd7yh1ZyBG0DceMp08eaOdJnDmI0nuq66Ah/EdMjjUTcQ3rpkUMgLpe+9IgaIuEeCP9JCJa06ZQreYWUORRCmSSJBPhwlkX6BYqaa4vR3Nw5t7jF84PvoY5EZKW/Rx2FERvsjBoCAanziWSX/pjDOrtTRkHmTXtssx0lrzKtJ5GEeZYzqHLw0ExNoBN3r5TIHzoGoKRBZJr/IOVDFFlRy5ALOA6lGtzk9pQqWbMQTzvZR0OUrFuh04d/GCdKZWIyMQFRbf6sp1Hm8gcKwWWYZFrYQygaEm35Izc+Vc5Aeam3+tXnYGWyHxZHcgjmtYqqwwkpREyFNfXVx2Ua7U7/CjJKFSl0rGSh2L3Yiq3qZaeQPbWMtlQoEjZO5KRz5cohoirVuwZLpdZTyhySJKEJUUj/LhRxhCYKwdIQ7W4ibEWTAzFLWKk0lXUky6ebDJkw7plkdaYEbWlwup2VMKhGYVyTVW8lVITtsqAlAStEAtrazgR2RYNd4CVYNsXPVmaxzkzssTS7orJZaj3A7YxoHSg0PwiwXMm9yrc4RVx6Ce6ZIOEPp/hKXZNE9U0fKevG5Moe2y4Va9bl6Ums64/xorcqvTUd0wxrm/ySJRKCfGpL5xNgj9hPC+fV70ikW7lTtZBlWqgsXlQ53eBe0oEj/VhntfDZ58K2wZX5zslkiQmaaoYQxjoEIZrJ4Z640Cj4+tuDB/JXklAOxyO+Solnk1GQ/DdW4KXJRY9SYL3d970d/4lE0XhMYkHac8kHGehmriLk+3H3Y4L78Em0htsnU4VnXWxdSVbb3N9pmJBg/luTS3lXbYk1zGTZVTP7lVz+EuS3oxKkGkfXWX/smVZ1mrNnBAYYLY9LRQhOiYYZkWiqXRLJH3nuHwrtqfL6LyoD5dpG40oSzT0EzZfWj3C7TBM3bw3GjXstmxPyOFJnCtBWngnzVh25+94TJFqDdKyVE9XdskS4jB4dp139D8ER2dcuyjPeZIJIPoy6cet7r+B6vWze2Bi6sUWQ99aXX15jm1LCDTZKOts7b7fNIxWStrh/DRFlcwSRxMbdYTl2qkq7m1LRJHRKZuY+QDtQajES3P+O9Q0n4cZ7XLFqt+he+5YpHzxKiBS0SFJ9K/3V9TVelfihArvgk1jN4OMbc1xu3XEAaU3OPXxIuec3rV7hEuWU8nDZRB7BFsOnLuFs+MyzPR+XhySwI/d50U8C6Iink3dGZ/pK+E1BdDG86VM/iamPfZD5KJzqTbdqqERiv0lvXewc0S7oQtJZoo997ED1LdMuroWeq13fkytX6LIud7x3RF9G2WtCEHn1vE99wG/xMyKTHvimF6KIcxEp4h1/kBY206hxf/zB8ZBioxy+8lT3p+Txu3nQK+QSB9LCHLQeerUzGPWrZ33rXf962Mde9rOnfe1tf3vc5173u+d9730M/3vgB1/4wyf+GwMCACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVO1RSgjtCVOrLOmKLI2DsbS+ys5noXagNOEDl0KrwQqgwqptnPPUsQ7Bl2FtpAbf+6hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTG1MJRKKIEQV5yYaSKMNcGkJ3LvYHLMJCCM3z0RGRRvacGxztzzIDsVUN04RJGMrXnl2sctWWhvSCf3VBtq1T13Z913id13q913y914S8Fw19g2u9pRZRv7+8VnR8TW1dENRmyWf82KhCyabRdTeHuGGjoBhRrPZ01jd4YTm22BJCPm0M2WYMUaFlKyo52EX01H85gFbHmpK6EpU2BwtM2k7r1WjBh140aZQ6yyYhvHfLzAezNV0jPbYtxWmsH55dIb79EXiKSE9s1KNNr+ksE86sOoNTOBYTreDS3d7//d3gHd7iPd7kDTC4fRZrU55ml4X7mNJe+WkB1ry0/BbM6Jt/HW9D19wcIVkzyK5tZNDzbRarmcUu8aLeSYT67BhgFdXuptEBDhZV2yuSnTUXxgfRLRAA6MryOtbrsUgPrhXb27sRKlIcJYSO8MSCSz0RRW1tvDwO/uFQsSe3Jt+aW3cFTjknXhErXZg1dpw4Ks+cDeObVY2K2b0EUUyMp6djLXgRwXHihz15ZtPzLOR3lbHMi20IgV9JDJyenaMpJF/lKxGbY83xfAn48AJCQOXjSAgFtJhns+IjkrUbZJAznRBeVb2ZjQnTHRhgUAu1kAgEAAEJcAMCcAbY8AJX/yAEKKDmJGGjta3FF2TjMWHOMMraBFGDALmhiukCxuDnnv7poF4LfXAMcFDqcDAMqJ7qqr7qrN7qrv7qsB7rsj4MMeAutj4oF/4VXgZmsWw2KhoRalYTTS3TmbNSywo4bG7clwEDod7szv7s0B7t0j7t1B7tYNAr9+0USiulGrOo3mRZE+7cHH4rz7hSE80RdsbGqTENLlDt7v7u8B7v7u4LvbLlU6E1FMMvuFxypPyXpwLaDnXMvBLup4EHhQACHqACLSDvDN/wDh/tBdArAN8TEaM60lw4SLbvMoLNbHhItPADOTHgvHLuKqEBV3AAHQACdFAAHvAAHzAMBGAAx/9wDInw8DZ/86FeAjhK8DhRkJmWjn+SqIwTz5hwRiKhQ49gA/tQDADr4ymjy4xeE0nor0VT9KY5B9PACruw9W/QEyKvZKQa9TKBhmJT5puC22pwAVu/9tDgE+9MNNYp9i2h2xojXYygKQdrE01ADmu/C5bQBDyxUrVtNlYv91MmhP4yL5gcLHaBckDRAH2/C7IwBTrhVZDRbOTaRgDDqIbvETaX6zeh9n1vBpKAE5bP2HosYHd/ctn+4Yck50vhDPsQ+WLA9DVx+gkRCVburGXu0+fdKcVUtEvxA14Q+U5QEyvlcbqvsUBj9zydf9j1+0pSRXLsFHXQBpHPADOR/BT/scbKntCBQrCFIq2Hkn/aSrbon/7qv/7s3/7u//7w7/59rdet32hzK/0f0Q6qEPkNABD/BA4kWNDgQYQJCWry19BhIYURCR6KVOgSoz8ONW7k2NHjR5AhRY4kWdKkR0aHJK5k2dLly4Jq+Gx0pAbmTZw5B3ayscvnLhsNdA79d2gOR4hED6rBE0gTxpNRpU6lWlVqUqVZta70k1Fjza1hiSL46TOoWJZqGCFFi5AioUAXHXm1WtfuXbz+MLXlGzaSFpo2+w6O+KYsUBqEDfqZuZGQ4oiH/OCBi0nTHEd8/gDO29lz3kiQRcPEw9kh2NGjRR3exWB0JLoNteBJjfOQ/xo/kSgTKhQoEKZLwTUNHz7H+HHkyZUvZ97c+XPljKRPp159Ose9tbVHLB14O+Fi0Vg7caY4EMfZ39Wvb3teIyP28QUS4oha/tbwrFk066vm6MY/QrtvQAJXwgNAwQrcjr6N+PBDQaWKuYA1KCZpC4/YGnLkQQg7hFCNDGnzUDsGNQpwRJ0eYU2VHpjZyr+O5lAJRRrju2SjS2qsrTuN0tPxpU5OYI0KIpRSAxPTNArkRya18yNJR2ZsUjEeNcJqyohqkIU1ZMiIIic1LknSIT5ExPLMvm50SAsO0RwMNo4ukdJNg8ZggTWgxCCimJbUKGQtjzRJkE5CjUwyu0L5Yv+MI0YGTfQfZhAQEk9QnDDCBIT8IAQTR0Aq81FQdSqkR0dD1UqNThsU0NQocMCzrCeyYGEfFuLJ0CMtApnTVF5X+q8hTXpFyyj0rgwVGiheZe0UkbTApFRhoz0oNjOl1QqTjgTtFQN1RFD2JytAciQQaK019x8/Nir3XJwIGdMfB4Uthh0xJsVTho4cwWRVdvud7yt/tVp0Iy2MNVUSbi7AoY3DFPFHCz4YwYSQdQO2FluHcrTYyF/fqxhUSSaooYZKTPh443MZegjlrAp594/HWJbZ4lQb4ndmnCJpbKM52sT5Z2FjOxlohQ5RmeAliVb60UNMXFonQm71x5Gbn7b/+kc1NOLjapzUOHojbbkWG8V0yRz7pqg7cnbos9sereyGtnbbJa89+qOQXefWe7Ss19zbpUhqbhDvvwuHLEm2DXfZIz4IN/xxtASPGfKIwny3oT/IpXxzotQElnOJ/PiaYE18Bv10iUr054+8UScoko4Zddx12mNKcvLaDYIdJC00qTZ31zuGD/hMNbncoT8u+Z14yg/UaHnmBTpSahM1oTh6pnXjzTfgLsEkkEIIwcN0onb2Z3jsDTqkEME/0hePxNOPT1NMMKP+oz8kJoT8l1T3B3f5EcQPmLgfTTQRiEi0LoDfOQQeMMGI402FD5cghAIlYj7WLfAgDTSeSfJ3/4lAECIS8dMgUfwQCAh+pkdzgB53NoKoEhaEgwUMiRb+4AgcWsc6c9CE9woBvxgqZIDtU2GDNNcSQDmkakEcSCQeGEEV/mEOgeBfANeXRJLckIffK0QXe/ObS9hvJGtjyZO+YkEmFsWBKSxiRxjRQuYdCYpkmsPEqqgQpgRiDgX8AxwLgjGHwDCNQrQIVNrokDmQEHJem6MjKKhIhTjRfC9cySEm6cdBLiUScLlMZuYolRPFEUkf0cIcCgFJwIkpW2gUSCQQlEkj4cYPs6RlbiJxS+315iLU81HuMPQRRlxPNGoIxK2CJRFANmQOsFTPCYnoD4NxDkZqw8QdCRMm7P+spH1JY+Z38DBJf2iClXqTY0cyN07FuGsjmETXmJbYzWFiUUPWZBlubjlLNUBLDRWZw+VyhU7RVAle4/TfH1AJT6UQi2AArCcKC2jDP2wmJIlU0KiUtBLPNSQlCP1OMgM5s93h5VMd6lgGI9M+jXGURO+S0cZElxdnAfQ7akhSNBeTIZuqlDB+IOJG/bW4u/DhiCjKKPpc2KN36nQwh8ioRmVKKLV8JGLGkU5mNLMZLWSVD47QRCHoWSC4PQyg7kHeV5WKFotq5JjW+mV9hhotybVkdFE6647GlNOITIY3IjyoYjwaN4ZGK5nLZMkh2rfWugaUYEk9iB8uIbUJmpX/b/JsCCaeWqiwaiFxINoIXhOL1leGLnYe6Zl84AQgxsJVI4KMyF9M1NfPwqSp9kGIOklSsPUc4q/+oOjG0rq6+P1WL7EVjWEbVEWmSoW1oglcR7i5Mc5+1CUd0yxxIRPdNelqIoWQmha4Ohw2dnZHlF0dO81F1odJViBhhaZ1IdMV9NSxfpfjQwVlSAhwmrdlzzwfbB+F3fO95GtGdW9f4GsScSYkuUglzDc/8lycCdezBXGlRvxbYK7wt1gr8SgfLuyWpr5Hvf0SHJtcYr7AYlgshwjEHMO2krleNi3khVeKcVbh08g0oylV8WCOBM7kjbgohxULqmKkX5ahN5wt//ktgXs8GE11cX9gytBydUJZRgiZZfKEcELC+ocnT8m1GrExTDyK27kBuL0SaZpGZBxm9jhvTVo+CI5lg2SiCfR/KxEanJukZA8TpX14Vppwe5kQ89HZz+tpKmFzIufKQu7MZf6H4FK76AIZ10pX1tqblTa6NSNEcIrG9ExjU92bsJfSbgO1lf+R6FIzCdK8xQl65cY5UDfqIEnydKy/09RLHwSLri5ciP8pQKf5+keWfM9NqOU6JWNuX7gRnJOVPaJZB5sgfZNNr7mmZ5BM+NoEwiJiV2LnW7uOpyMx6bhrBGlUs0R11gYdi6F4aHfTyHw8Tp1GHJ07y5mT0PlmD8x6491vh9DbdYcgxEW2akpvE1w7AP73UTUqcYwTRcni/ge6M/5x21xyJdwWK8hN7pJZa2HV/4iNtk9+8r9aNiId6/LLbW6Q0VJNIehV+M1vrlCwVdHOWoi4z5VtNNIuseVGZ7pBWsy4t2Jx5U0HeXM/wkKBYJHjVAc5d3kXIq6HXSDrAyeuii72a+OhnyHZOtpPTsyyD9ftc2/iJRpTSpfTnekf1nvf/f53wAde8IMnfOENf3jEJ17xi2d84x3/eMhHXvKTp3zlLR/EgAAAIfkECQMA/wAsAAAAAKQBHgEACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27csD0UiVKgQIT9w8+pFSoiRFn+AA/+5hHev4cM5IzkKzJixlkKII0t+Sehv48uAA03ezJkkHsygAUfqTLp0RjV/LjvSdOmS38aMTMueDRET7NEE1WhqXJi2798E+TDWhPBQ6sCYgCv3rcaxmoSBGDtaTt10JMaxE/rhXb375uuBsyf/XBxYs/fzh5sH5rPQdnj08Pce96dl4XbGvePrXys8MEPygM2x34BqAejPcwoV0hhkBDZIloEIJnRIf4BpgYeDGIIFIUOEXGZehiBmNZ8/Du3WmCP5hahiVJbR59AhjFz22Io0PnUfYOw5pEaMlyVX449JdRiYgA8dcglmHwKppFBHIicRHhRWmOKSVO5kICETHWJiYJdU6eVO6gUWoURNAjbdl2jaFF1gZ1IUpj9/pCnnTAYmKRF4ONoUCSaM8PGHFlr8wYcjc2iCSSCERDLmnOh9hp9FczBGpEx+GBhaY4MaWoiijFLHI2DiTSRkYFhSOuKlqMK5GiaJLtrpZqMC/3YhRZG06A8fh8z0aaq8yjhooZccWggekfihhquvpoWadBX5ceqsMb3pmK29VgtaoII64ggjc3Tr7bffMiLuuOSSq+256KLLx7rsttvuH/DCu+62hWIy7JQ/+VGIa34Cmu0crCIL1yGWQhuRGlH60+VMjuJIyJhq+IEHIYFcokmf1Fqr8cYcd5yqFqsVgm9Nh+ChyamX8qEJHrnmBWNjxE2khqWMtCxTrDHrOBcmmjiCssdABy10aH/MUYjALkWiScbVDjbyWZViirRCM0tdE84XqRFJIZjM4QgfTA8t9tjVasFIITa3dEghCQM9h8FnRXIJtVrgFtHLjP0xNUt4+v8zKUdaT1xIIJhY7PXX8AJK9uKLa6HJ0yOpgcnPmCneKyN2i1XyyZXD/VCkeUPeUt+htnSsH5FEgsfqrLOe+uuwx566H7TXbvvtxh6r++68P6c76nTxzAjll72NkhpzX6oFwHj4YbPWXDsSNmCa7G2VydNbSFGZFWZOk4JDcqYGHnxOD6r3H0k+/WCRpJ2QGoTMEfYfpW61dtsnig5dY3XbNP6WgPERaUp2CfwNyXoUWRvxjCezQBiwellRIKr+EAj3PaRhgfGcS/zAOcygjzRKC5sWKtgRKF0LEwhcyCEIgT8+fBAqJgzN8o5WkWUxhkEyWRNocuabQzgQNCjSiB//QHcZCqbwRYHI2IymYiSiXYJlGCFiAGkCwOJZ0DcsrBwOE5jEyqEQJGqQIpekgrfiQTEjsfIbTdyDGT5skToSLN4RCxLDy1xijhQpRMbmcEWklHE4+oOIcfKGR5FgEDB/YMQT9YO8NgYyN1Uc0iMzEjXYFJInkWTEJB8CvgzOZEKOeeN+ItE27TmEED/jgwZHoiXVXDInnayQKDUSpb/BRIeAmeV+mngZXeZGjBXCRB9LgkszvdImfrCVKT1yyE1GbkS2xFBlPKQQVGJmDs78yDQZw4dj0sRS9fMIAKPpElxqIZvd8UPbBPhLzNCPYdRyhDdjEkt/sNMjI1rlSgY5/8Ya7ciOBbHmZSBIk1qdaJ4uUYOtHDFMjLxJCw1NSRoRupxWNmZhunGnPl9iUOxENCfc88cLNYLB0r1EiuRcUUjtiYefERQnHQ0MD/N10ZFgTSYKZcxGQ8TGS/1hpzLBA7Xu2RMA6m0ksVwYPbn5pZ5i5qU8OaQ/fHmTG2WGJEmdiRSJqiSnCiacPqmnP4CqVW5+FCOxSqlKDmErdA4ojJhhBEVX4tRz9sSqUy2JVXMEEwzylUotBU03i1LFwe5Ein8dSYvqExPuKVVJh/AqbM56kz+qUSd4BWtIDpE3mRiIrA6qJKZqShSENcZONQFgYkWy12g1Zq7L2Wbe8GDaG/8WJaaywklmT1LSmGCwTf6MpN8QlEzHjJQnabSrTVSLkp4+tiU91cKgtsUt1tgrUc4bZSnfeMijEsWpam1JcQNDVY/sSrMrASav/kCoSwwLtm4pJo7wVUyGFmVX/kDtS1RLWUq+NiYG3Fgi3XtcyfzTjsOs4nOBktPA9I9StipvR7gHXJcIV2hmeyJ8wSLQvKGXIARrzId7kkbDwoS/J+lbXqOFX8Y5AhPtQwwvLdmQ8XaPsI0J70nwKuGN1BaR/U3J6VAnOMJpwmvEQ9XyHqYXUiIJIiXe8ElAaduT5i3IFnEyY/QLlENIbF99staSsdyVLmKqwAcBb1FsTB+3knT/QSXxIbVMmhS5FKJnvXIcaLkC14G+Er9cDeuJyKwRKuOI0BFRTBGlbJOSlS9VfAgEow0yvorNgRFfm5ciN4XoEqJMCyNuiA09SRQFsySkoT6NcPngZqIQMMAV0gSaZUYITcCaf0abNENmLJ1WCwS3yhXKjwGTam3meCSR+JlcveKHQFjqMozY80LUUIgWi1nWKREtY4SpkXqaOCjA9nVEnOUYcStEvvTh8lbU4OxLOULaBvFD8sSGOZPosYjwZkgVZwqU+nb6YAnrcUUkq8m4zTuusy5IJNQ7NGyKpM85lnKIt1wUMQbaI2LkN0fE+geBd4XaAXZ4jRnuYEUGgljH//pHxPAQiA568d8JCSz/PC4RNo+1tKcqNkYKq2sV+2PZbsGDtQFzR6qtlJswpqwfJifYhL/o6EE0ZGP+YO6VqDjYHwkp1jtiaKLvZeGg6ThCCkE5LVzC6QYhxLPTrREtXxTmDinmt/tttY/UNd8QqafG3wL2uObHD0N3I9z/kUU5XsTMs0WJGHWsEzHWzCMr1XlFum7fyChaRiREPDclXyTNz9dN1p6DrotjqQX7ZNj+2HsCgalujaQR7WvpsHTWPsLBH0TbFcq3bB1Mc46Qm+JDsfnFx/3s1msEpQPEhPlkOnqBSNbjEO910qjF+ZpI1fgNkTnwH24r2LsF8CnDO/9FtO8kDv2M25Thn/hhItbhT3uloC6JX3uy8HF1K1iBuJftJ7zD/TsE9wpDNavmfSFRTFv3E151CWQme7lnEo7FEw02QZsWYy7Ba9SUEocATHx0EOTHJc1HJlNXdSqxUlGXfWtXgiRxXsjFMSDjXh9oEG4XGqKnEl61gQPRSPiGE2JEdUQBf1/0PoWwdqnnfwxhKy94ET63MY7wRESIEJ5HHyjDaiohVo/3D3U0HEeYJfjFg0NxdDPEKYHzaO5UfafRWT0hWRzzByvThAIRfQfkhvSxfhWRRj/HQWMIgZbChUIhVhwDVSZBOj+hNalTZMIDNtbCPp4mI1t0b6elEkL/xT/XlIVZk4cimBLJ5jH1thKxpHpDUWl4xiuOgDYOBXVTcolvlxKPKEO9BxNVkzcEGC0H1ytz8IoagUvuZxQlEwiv4VM/OBExiBx91IrYIYlWGDYzKGwJs0xCIW9JZiaBUIkU0VPYV2d4cAlJZnbOZIGItFMWJR1ZCIf0QYY1IYzkhYvk4zV+wl6KxGQyAUCreBRyQzyOk0JXeEBxdxlSSBJPKFNHQY5Ex4ZlAUDiqBR4QHJa0IsHkVEyQoa7Bye02BCXdymm12XABHSzIUVyiBSSQzlidxCMSGNPQjcZiRA4WDxDdRTa+AcPyRYYCRb3A0SZgwe0944D8XsONpIB/5VKF0KH0yhqczE4gRCUrTIS6NaTe9GSYlF4dhQxDHeMFoF6ymgRQwQa6Ed4vVQRezI8EzQHzwgSqSh9pYGUmkN2lRN2A0mSlhJ/FhFZTIOCAiFWZFiNzShYCClEpWSUbyGWY8GWH1OVGnFgjHGWhIc/S3QQ8qVz7HZrvOI40NiN0rGSZaGXZAF+MgiNA2FZ/iCOlGl4CnF3Rrd8GyNyG9GQ1EOMUSFFghkVKzR0XicSGXgZnIc8TKNKDqF1GiSbEmgoQWlkWilDRbcRm+kYJBQZ7jiZ1sgrTvkRjklsDUGWmBdkVfRgAsGXYWc0oqMv8hN2OEkQH5k3w2kY3IOXUf/BbkJYIfhomQURSaEmk6CRnJ8TggLBgJJCCFiWmDsEX+AIJ5JmGD11i1LRbOVpJg8TSWoZEup5ewxHmwm0hUIXdnUpEUrJTdBYjw5GGHqBSxMpFfBja6kyi9yZMeIpEQd6g7HoYN+5oOu1nxkhZ4rIdc6JGaEIkE9xU1ShLxyaKn+ACfiiTgMlo/9woOpzn38ZoAcpZeCoCUS4kTI0B/TJFr1lIyzXM6BZIQz0PhU5etHJdH7XEajHfCIhn/LkEex2jbmWFq1VWsAzOJdwaYopI2XqEF4VpiFBctKxnQQRnIFZEoApGJB5EC+JKnxwCey4l44BgXOQOJYzNGo4qFD/Ri35qJx02pEdQZps8oLaWKDMlJ2QxpW0FRYjgp4cQadpyJXiZoqCAapqd0JNqJDudoSkGaIQQZ6HuCr6lxUqqBNz+TEhA402iUh9ShCpGho0uRC/SHQJI6ckUawZCpzt1jHSRS+awBr4t5vUWq3Weq3WWhfauq11ga3e+q3eWic7wZpEQyisAqo3mIy/GqzKY6cC8YQu9A+96g/IGjnPZoORUwiHyjj82q+huROA5y/yMijVJSzN46NoyT8P+afupH5/qV4KWJOnMnebFUn1mqyBsK/+urEcy1QGhl/SGauBQDyYY1lR6Yufplnz+qgk4VV6eDznaIgdO7Njs1qG/2FZL8sQSgoamfgPJiuH6FZwt3cqOSsSYnWyKiExFXMxfkKzTmstqVkWOBtIISSD6OOPIfsQ4Oh+86qSvJUxwxo5REYIZMutZguU4Jq23nq2bNu2brutv7qX+EWxl9kXl+KhCWtcEdGBcEJWUBm3DGGq5ZcsYuGPF6tyWlo5j6Ozael0QXtEWOuu03avpkm4OOGPVfgPC5c9D/o+aQlUe1oeEuGPK6anwOSWlstnCVM9PxQakVZIkasQfPtToNcjKLFStJu6XzGvqMIIqRm7BhFZkbiWwISkJ4Fu/qm7/wmajtOnwFuTawerB7FSFukZe1S5yvsSS3drrws4z1Y/pP/ptRvhVSw7Ejw6dZKbvbrVrEuavm3YYkcjXO6ZEd0ZhyextQirviwBoL1CtxuBmZ8mvdkHoiiBbvGqv0khN206Wa4pqgccEueLhbx1fn3kZROztJeWaYgKKBzcwR78wSAcwiI8wiRcwiZ8wh0stHmxoXM5ZqXHSiRnvCQRureCrpSmXrTpB4TAMz7ztD78w2byFgQUoNhBQ214KmHbEOhWunEGf1EbEfsIxFI8xYylLOSzi6lyNsgCbIB7p6x5uEiVMX74pbk6xWa8sXQGFvpyCUTsGG+aEGnkXRwRxXxqiW3zwOlTa2VcNijcx378x4AcyClsw0Chw66xx3CiCU3/Wpuw4XtrJ7M3KWTqJcBAiMVlQyi6OSzFknIIfBE6zMNT6hiMAGMUAWgrioYK+JWimxLohrpZEj+hXDm/2clPuTNMG8snwoRZkzBRS6G3YjcRLFP5q3B3KZWJmzIAszQy6L4qcgi/QzuDSBeEs6Z9gsjXMsqduhHh5iYMF7G58Wxg/HDC5Qje13c+pQlG3IYlmjc6qr9H1698wJUU+BH1VHmdN5sv9JroqxLyqTD0SMQvdlwcZD580M6pK1VkI12cmoWmdkGE6ZeGiRnJCzjq9U7VFKCO0JU6ss6YosjYOxtL7KzmehdqA04QOXQqvBCqDCqm2c89SxDsGXYW2kBt/7qEmzIneJVn7DUHl4AonDITbHaAd3phFv0QwbyNKsGqMNMbUwlEoogRBXnJhpIow1waQncu9gcswkIIzfPREZFG9pwbHO3PMgOxVQ3ThEkYyteeXaxy1ZaG9IJ/dUG2rVPXdn3XeJ3Xer3XfL3XhLwXDX2Da72lFlG/v7xWdHxNbV0Q1GbJZ/zYqELJptF1N4e4YaOgGFGs9nTWN3hhObbYEkI+bQzZZgxRoWUrKjnYRfTUfzmAVseakroSlTYHC0zaTuvVaMGHXjRplDrLJiG8d8vMB7M1XSM9ti3Faawfnl0hvv0ReIpIT2zUo02v6SwTzqw6g1M4FhOt4NLd3v/93eAd3uI93uQNMLh9FmtTnmaXhfuY0l75aQHWvLT8Fszom38db0PX3BwhWTPIrm1k0PNtFquZxS7xot5JhPrsGGAV1e6m0QEOFlXbK5KdNRfGB9EtEADoyvI61uuxSA+uFdvbuxEqUhwlhI7wxIJLPRFFbW28PA7+4VCxJ7cm35pbdwVOOSdeEStdmDV2nDgqz5wN45tVjYrZvQRRTIynp2MteBHBceKHPXlm0/Ms5HeVscyLbQiBX0kMnJ6doykkX+UrEZtjzfHsXs1D5eNICAW0mGez4iOStRtkkDOdEF5VvZmNCdPtTu11Xc1jLGhOEjZa21p8QTYeE+YMo6z/TRA1CJAbWtt5FijBAAdwMAyUXumWfumYnumavumc3ume/unD8AHLMBleBmaxbDYqGhFqVhNNLdOZs1LLCjhqbtxiMwq1cOu4nuu6vuu83uu+/uvAHuzCnuuJkAZ7obRSqjGL6k2WNeHOzeG38owrNdEcYWdsbM2NkQjDvu3c3u3ezu1nsBZaQzH8gsslR8p/eSqg7VDHzCvOfhp4sC9IVi3a/u32fu/4Luzj4BURozrSXDhIZu4ygs1s2F3nLSF2yyvUvlZfZmQZ3C+AAgb5PvEUf+/GYAAgIBUFmWnp+CeJyjjxjAlnJBLFlNxA7eMpo8t/XhNJ6K9FI/KmKUax/27dCa9kpLryMoGGYlPmm4LbqHfhJPHORGOdON8Suq0x0sUImnKweqJM674RK1XbZgPzRT9lQugv84LJwWIXKAcU9STHN+FVkNFs5NpGAMOoVe8RNgf0NxFS4QwTYs/YeixgSn9y9w3jhwTnS2FZSU6DV5kQkWDlzlrmPn3wjFJMRbsUqDfzKbFSHhf4Ggs0Sc/T+Yddhg8kVQT2TSF8M+H4FLHGtJ7QgUKwhSKth5J/2kq2qr/6rN/6rv/6sB/7sg/7fa3Xd19Zc3v5zPT3+8X7a7k1h3zcwt+xmZsVqPf2SCFWW068vg84Udqbwx/9Q7P8RDGvyH8U8kX9EiEJXP/Q/K45FxWDadgu/cO/8E2BW/Sq+/wHZylhAlSwD9OQpy9hwRTDM+j4J+Sf/yTuFSsNEI7U/CNY0OBBhAkVLmTY0GFBTf4kTsT00OLDSU927SoiUQueiyFFPjykxk8kPIQIFQoUCNMlmJpkypxT0+ZNnDl17uTZ02dORkGFDiUqdCLFkUmVLk2KR8tRfwKZTqXqMOJRQAycVXWoTtXGXTZsfeRa1uxZtGgDQWWU1u3bgoSgRh0I127Dq/5Q4drFohncZmzAgqUi7u5hxImV4oH6p65iyCLlQuXjJ3LiS/6mCd4IZZLbDLIGbzRj4vJp1IjV/IEKMvVrhZOP/okE+y3/pgujVfVgZnZKptEb4xi2Xdy40sxHLx0/7hQqWeZlO50IToVI1QFFLAVXhSD6d/AJ/Tyd6OhQeNjOoRZCP7WG6NHIyERZOmVWq+C7vFRr3z96co8s8w+1SFiD6pLzBhRpDBbys0EMIoq5aAAlJPgqP1EkUXDD1NQgT6KKOLzMDz7mYuQxERtiBgHq8gPFCSNMQ6iYCYxAQpEL8xMhmxR7VKyQo7RA0cfD1HBkLj5qI5KhKHDIb7AnsmBhHxyykCXHJ3dp4xFtlvTyrTmO0uTLxA4J8zn2yEwIGiiydPPJNooYQE06yzJQItfqtAuTufzRZEg6MVBHhDcLzUIdDfVU/3QpP6ACdNGzCPlwosog/acYdsRosdCNbMgCCfosFTUk2aIa9S0S59IiTUsl4eYCHNrIbwERPEHCiB9O1dUiPidable01DiTrUcXlWSCGmqoY4I5gXX2obz8YfXZsgqZVKI/CKF2W24VOnIiJbutKpIS55pDQHHTdfZOf4pVV6RDop1Ii0DetVfUQ2a7typC2C0v3H0D9lKNo/gQeCo15J3oz4MbTrFRSh1mqt8+tcDEXYkzLg5iiQzWOKmE+/Tnj0IS/Phk2wieF+WkIvkWyZJZlvm0STGeOSFrReYj5pt7tutlf7T12SI1Lrl2oj8CsXlopkUC0M+mLfJD4Xk1Qf83aqwlm83krBeKZNg+GeG5a7IX8vAoocv2GmxVNclTbbj/AbutuBea+ujZLnm7bqwZO2pvvg1SAxN/5/pDE0KWDpzDQ1BaqaWXLsEkkEIIwePqqsqViO7FEzqkEKBFjgoTPBTv/Dg/CMFkDkcKFx1bRjAhBPORSg36dLsJf/0oRzQJJBKucbftEDwwYQTv3V/n4xJCgr9I85GdF54g4jVBXuQ/GLkkEEIiMX36svwI5Pjky39dizkAd8hvpMBXqHrXzdfiD0fqL6qoOTSRvJDS3W/ID0yEznwD1JnSQsIIqADMfwiJhPGuR0AC/mEOgaDd9D6HwAg6In+TK0QHWeL/kkuwLn7PuZjUJmWeBTaEeA6EYAtNpL7FDe6BlJqD7CrYEDXgIRBzGOHIYIiQXrUvhQ/xQyEuwYgeulB0c/he1BI2Q0cwr4kOaSD0oBIiFVrxh0M0WyQIEQhNsI4PM3QhbWKIieuhrxBTHEkkjNYnTUjvIJFoDBu5qBA1mMQPe+TjSSLxR8ex5Ijxg07c8DBCRiROMWoIROHG5JAgSmQOd3yN+AQoLbgJS2QWu2GRngaih4SuXpR8DR6s6Cc59kyGfUpaKhUjqdY4ZDwJJOVr1IBB3nUyXSb54x7zmBA1RKIQc8AbvVwZGfV07Jj/sJ1japkaM6kqbepiJBLP9wds/86Qid8B0lFG2ZBPMmKZz4RLJIXYra8pUWdbhA3Y/rDMQ4TuV+Q8DSyhModxLmpq6qwYJvKJmrNNZFp289dA6akYPwhQnNTKGT8LZkD/PI1zDWGfRxR40DJ90h8L3dUtRccHRtQkKI7gAx+yqQWU8qF3hdDldzjmDy3kcy2zaSlG39JNMe3qkH1yBERHBbRp4gUqKLQpMq9lUKmlpHLeQ485OxbUUUVykhaJJ1QeWVTIVBSmF2WIHy7huuXVFDIenYs/n/VSIV1kNevBamRwii3F+YFtIjtXcQpkOK7qCmhYfEgkJuXMtirmk1JhiD3Lt6rXHMKp/tgmt94KWIu81f8ffA3sXapasBseQqPlo6xiXNanb3Jrred8CNjSWlnV+MuYBvmc67TQO5mQby5ItQsecDkbdu5qpgEKyUsxiVrE+KFw6MPE6vDGh+Yd5BCEOGVuq3XJjdpxUaPdnEiiNVHg2kW4EIzjQjT7nLyaxZSiC+27JEtbhdDxKNLN7kgSKj/0GsScfGCvQ74rMkaIlVpA04J+CQI9qLbXLYcIxAwZZhF5EfUsZEVSgO2l3vL882nzFPBdBnfKP1zCv9QL3VXLYqQ+pU9ju5WIhxvyVuxW+C6p6+DslkJdUJrltpvbcLpmXF676UvFKfIrVBycFHMilmUw/q0KofLPHTfnOTX/Tu9znCuwZErkxwZhV32TjBoS+4O+VAndkw8m2UIuBHpMvrJtPjnVpWi1szIL8pT/AbTwljk8lxUoU27LByQ3TGHxBRqZ5WxLdp3WvT7GmsLW/N+j+PnPqdEqmkVCYo8V2kSPmlSeF21mWo7ktof2mUZXW5CX/uHSIjoE9FL8EHZ5GWVZxhYmvPfeiZx61O3RapyBGSRLfyzKu4vvrMFzWxNTsWBxg/Xu3ulrDlVU0A8playxRuAHhhnZA4IehR1SKkdn8o2GU/W0i0PiZTek2Z1b7hFVOoexeVtBMM42QyrqbHXH+9Fs7euw5X3vpZQ6lg5RmUdyjW98a1ULbiYIlrtsDXCEA7GsxwQbjhP+cIXM1RFxJjG8IX7xaM7Fak2e178v7u140ZWrBv94yRVS4AKi6LYEN3nCP7tE19y21y2HeCF6OL9901zn1CvEKTfp8Z2rGw/E5HXQjS64QPh8skdnukHcWC70HbzpOrfy1K1+daxnXetb53rXvf51sIdd7GMne9nNfna0p13ta2d7293+di4GBAAh+QQJAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3btywPRSJUqBAhP3Dz6kVKiJEWf4AD/7mEd6/hwzkjOQrMmLGWQogjS35J6G/jy4ADTd7MmSQezKABR+pMunRGNX8uO9J06ZLfxoxMy54NERPs0QTVaGpcmLbv3wT5MNaE8FDqwJiAK/etxrGahIEYO1pO3XQkxrET+uFdvfvm64GzJ/9cHFiz9/OHmwfms9B2ePTw9x73p2Xhdsa94+tfKzwwQ/KAzbHfgGoB6M9zChXSGGQENkiWgQgmdEh/gGmBh4MYggUhQ4RcZl6GIGY1nz8O7daYI/mFqGJUltHn0CGMXPbYijQ+dR9g7DmkRoyXJVfjj0l1GJiADx1yCWYfAqmkUEciJxEeFFaY4pJU7mQgIRMdYmJgl1Tp5U7qBRahRE0CNt2XaNoUXWBnUhSmP3+kKedMBiYpEXg42hQJJozw8YcWWvzBhyNzaIJJIIREMuac6H2Gn0VzMEakTH4YGFpjgxpaiKKMUscjYOJNJGRgWFI64qWowrkaJoku2ulmowL/diFFkbToDx+HzPRpqrzKOGihlxxaCB6R+KGGq6+mhZp0Fflx6qwxvemYrb1WC1qggjriCCNzdOvtt98yIu645JKr7bnoosvHuuy22+4f8MK77raFYjLslD/5UYhrfgKa7RysIgvXIZZCG5EaUfrT5UyO4kjImGr4gQchgVyiSZ/UWqvxxhx3nKoWqxWCb02H4KHJqZfyoQkeueYFY2PETaSGpYy0LFOsMes4FyaaOIKyx0AHLXRof8xRiMAuRaJJxtUONvJZlWKKtEIzS10TzhepEUkhmMzhCB9MDy322NVqwUghNrd0SCEJAz2HwWdFcgm1WuAW0cuM/TE1S3j6/zMpR1pPXEggmFjs9dfwAkr24otrocnTI6mByc+YKd4rI3aLVfLJlcP9UKR5Q95S36G2dKwfkUSCx+qss57667DHnroftNdu++3GHqv77rw/pzvqdPHMCOWXvY2SGnNfqgXAePhhs9ZcOxI2YJrsbZXJ01tIUZkVZk6TgkNypgYefE4PqvcfST79YJGknZAahMwR9h+lbrV22yeKDl1jdds0/paA8RFpSnYJ/A3JehRZG/GMJ7NAGLB6WVEgqv4QCPc9pGGB8ZxL/MA5zKCPNEoLmxYq2BEoXQsTCFzIIQiBPz58EComDM3yjlaRZTGGQTJZE2hy5ptDOBA0KNKIH/9AdxkKpvBFgcjYjKZiJKJdgmUYIWIAaQLA4lnQNyysHA4TmMTKoRAkapAil6SCt+JBMSOx8htN3IMZPmyROhIs3hELEsPLXGKOFClExuZwRaSUcTj6g4hx8oZHkWAQMH9gxBP1g7w2BjI3VRzSIzMSNdgUkieRZMQkHwK+DM5kQo55434i0TbtOYQQP+ODBkeiJdVcMiedrJAoNRKlv8FEh4CZ5X6aeBld5kaMFcJEH0uCSzO90iZ+sJUpPXLITUZuRLbEUGU8pBBUYmYOzvzINBnDh2PSxFL18wgAo+kSXGohm93xQ9sE+EvM0I9h1HKEN2MSS3+w0yMjWuVKBjn/xhrtyI4FseZlIEiTWp1oni5Rg60cMUyMvEkLDU1JGhG6nFY2ZmG6cac+X2JQ7EQ0J9zzxws1gsHSvUSK5FxRSO2Jh58RFCcdDQwP83XRkWBNJgplzEZDxMZL/WGnMsEDte7ZEwDqbSSxXBg9ufmlnmLmpTw5pD98eZMbZYYkSZ2JFImqJKcKJpw+qac/gKpVbn4UI7FKqUoOYSt0DiiMmGEERVfi1HP2xKpTLYlVcwQTDPKVSi0FTTeLUsXB7kSKfx1Ji+oTE+4pVUmH8CpsznqTP6pRJ3gFa0gOkTeZGIisDqokpmpKFIQ1xk41AWBiRbLXaDVmrsvZZt7wYNob/xYlprLCSWZPUtKYYLBN/oyk3xCUTMeMlCdptKtNVIuSnj62JT3VwqC2xS3W2CtRzhtlKd94yKMSxalqbUlxA0NVj+xKsysBJq/+QKhLDAu2bikmjvBVTIYWZVf+QO1LVEtZSr42JgbcWCLde1zJ/NOOw6zic4GS08D0j1K2Km9HuAdclwhXaGZ7InzBItC8oZcgBGvMh3uSRsPChL8n6Vteo4VfxjkCE+1DDC8t2ZDxdo+wjQnvSfAq4Y3UFpH9TcnpUCc4wmnCa8RD1fIephdSIgkiJd7wSUBp25PmLcgWcTJj9AuUQ0hsX32y1pKx3JUuYqrABwFvUWxMH7eSdP9BJfEhtUyaFLkUome9chxouQLXgb4Sv1wN64nIrBEq44jQEVFMEaVsk5KVL1V8CASjDTK+is2BEV+blyI3hegSokwLI26IDT1JFAWzJKShPo1w+eBmohAwwBXSBJplRghNwJp/Rps0Q2YsnVYLBLfKFcqPAZNqbeZ4JJH4mVy94odAWOoyjNjzQtRQiBaLWdYpES1jhKmRepo4KMD2dUSc5RhxK0S+9OHyVtTg7Es5QtoG8UPyxIY5k+ixiPBmSBVnCpT6dvpgCetxRSSrybjNO66zLkgk1Ds0bIqkzzmWcoi3XBQxBtojYuQ3R8T6B4F3hdoBdniNGe5gRQaCWMf/+kfE8BCIDnrx3wkJLP88LhE2j7W0pyo2RgqraxX7Y9luwYO1AXNHqq2UmzCmrB8mJ9iEv+joQTRkY/5g7pWoONgfCSnWO2Joou9l4aDpOEIKQTktXMLpBiHEs9OtES1fFOYOKea3+221j9Q13xCpp8bfAva45scPQ3cj3P+RRTlexMyzRYkYdawTMdbMIyvVeUW6bt/IKFpGJEQ8NyVfJM3P103WnoOui2OpBftk2P7YewKBqW6NpBHta+mwdNY+wsEfRNsVyrdsHUxzjpCb4kOx+cXH/ezWawSlA8SE+WQ6eoFI1uMQ73XSqMX5mkjV+A2ROfAfbivYuwXwKcM7/0W07yQO/YzblOGf+GEi1uFPe6WgLolfe7LwcXUrWIG4l+0nvMP9OwT3CkM1q+Z9IVFMW/cTXnUJZCZ7uWcSjsUTDTZBmxZjLsFr1JQShwBMfHQQ5MclzUcmU1d1KrFSUZd9a1eCJHFeyMUxIONeH2gQbhcaoqcSXrWBA9FI+IYTYkR1RAF/X/Q+hbB2qed/DGErL3gRPrcxjvBERIgQnkcfKMNqKiFWj/cPdTQcR5gl+MWDQ3F0M8QpgfNo7lR9p9FZPSFZHPMHK9OEAhF9B+SG9LF+FZFGP8dBYwiBlsKFQiFWHANVJkE6P6E1qVNkwgM21sI+niYjW3Rvp6USQv/FP9eUhVmThyKYEsnmMfW2ErGkekNRaXjGK46ANg4FdVNyiW+XEo8oQ70HE1WTNwQYLQfXK3PwihqBS+5nFCUTCK/hUz84ETGIHH3UitghiVYYNjMobAmzTEIhb0lmJoFQiRTRU9hXZ3hwCUlmds5kgYi0UxYlHVkIh/RBhjUhjOSFi+TjNX7CXorEZDIBQKt4FHJDPI6TQld4QHF3GVJIEk8oU0dBjkTHhmUBQOKoFHhAclrQiweRUTJChrsHJ7TYEJd3KabXZcAEdLMhRXKIFJJDOWJ3EIxIY09CNxmJEDhYPEN1FNr4Bw/JFhgJFvcDRJmDB7T3jgPxew42kgH/lUoXQofTKGpzMTiBEJStMhLo1pN70ZJiUXh2FDEMd4wWgXrKaBFDBBroR3i9VBF7MjwTNAfPCBKpKH2lgZSaQ3aVE3YDSZKWEn8WEVlMg4ICIVZkWI3NKFgIKUSlZJRvIZZjwZYfU5UacWCMcZaEhz9LdBDypXPsdmu84jjQ2I3SsZJloZdkAX4yCI0DYVn+II6UaXgKcXdGt3wbI3Ib0ZDUQ4xRIUWCGRUrNHReJxIZeBmchzxMo0oOoXUaJJsSaChBaWRaKUNFtxGb6RgkFBnuOJnWyCtO+RGOSWwNQZaYF2RV9GACwZdhZzSioy/yE3Y4SRAfmTfDaRjcg5dR/8FuQlgh+GiZBRFJoSaToJGcnxOCAsGAkkIIWJaYOwRf4AgnkmYYPXWLUtFs5WkmDxNJahkS6nl7DEebCbSFQhd2dSkRSslN0FiPDkYYeoFLEykV8GNrqTKL3Jkx4ikRB3qDsehg37mg67WfGSFnish1zokZoQiQT3FTVKEvHJoqf4AJ+KJOAyWj/3Cg6nOffxmgByll4KgJRLiRMjQH9MkWvWUjLNczoFkhDPQ+FTl60cl0ftcRqMd8IiGf8uQR7HaNuZYWrVVawDM4l3BpiikjZeoQXhWmIUFy0rGdBBGcgVkSgCkYkHkQL4kqfHAJ7LiXjgGBc5A4ljM0ajioUP9GLfmonHTakR1BmmzygtpYoMyUnZDGlbQVFiOCnhxBp2nIleJmioIBqmp3Qk2okO52hKQZohBBnoe4KvqXFSqoE3P5MSEDjTaJSH1KEKkaGjS5EL9IdAkjpyRRrBkKnO3WMdJFL5rAGvi3m9RardZ6rdZaF9q6rXWBrd76rd5aJzvBmkRDKKwCqjeYjL8arMpjpwLxhC70D73qD8gaOc9mg5FTCIfKOPzar6G5E4DnL/IyKNUlLM3jo2jJPw/5p+6kfn+pXgpYk6cyd5sVSfWarIGwr/66sRzLVAaGX9IZq4FAPJhjWVHpi5+mWfP6qCThVXp4POdoiB07s2OzWob/YVkvyxBKChqZ+A8mK4foVnC3dyo5KxJidbIqITEVczF+QrNOay2pWRY4G0ghJIPo448h+xDg6H7zqpK8lTHDGjlERghky61mC5TgmrbeerZs27Zuu62/upf4RbGX2ReX4qEJa1wR0YFwQlZQGbcMYarllyxi4Y8Xq3JaWjmPo7Np6XRBe0RY667Tdq+mSbg44Y9V+A8Llz0P+j5pCVR7Wh4S4Y8rpqfA5JaWy2cJUz0/FBqRVkiRqxB8+1Og1yMosVK0m7pfMa+owgipGbsGEVmRuJbAhKQngW7+qbv/CZqO06fAW5NrB6sHsVIW6Rl7VLnK+xJLd2uvCzjPVj+k/+m1G+FVLDsSPDp1kpu9utWsS5q+bdhiRyNc7pkR3RmHJ7G1CKu+LAGgvUK3G4GZnya92QeiKIFu8aq/SSE3bTpZrimqBxwS54uFvHV+feRlE7O0l5ZpiAooHNzBHvzBIBzCIjzCJFzCJnzCHSy0ebGhczlmpcdKJGe8JBG6t4KulKZetOkHhMAzPvO0PvzDZvIWBBSg2EFDbXgqYdsQ6Fa6cQZ/URsR+wjEUjzFjKUs5LOLqXI2yAJsgHunrHm4SJUxfviluTrFZryxdAYW+nIJROwYb5oQaeRdHBHFfGqJbfPA6VNrZVw2KNzHfvzHgBzIKWzDQKHDrrHHcKIJTf9am7Dhe2snszcpZOolwECIxWVDKLo5LMWScgh8ETrMw1PqGIwAYxQBaCuKhgr4laKbEuiGulkSP6FcOb/ZyU+5M0wbyyfChFmTMFFLobdiNxEsU/mrcHcplYmbMgCzNDLovipyCL9DO4NIF4Szpn2CyNcyyp26EeHmJgwXsbnxbGD8cMLlCN7Xdz6lCUbchiWaNzqqv0fXr3zAlRT4EfVUeZ03my/0muirEvKpMPRIxC92XBxkPnzQzqkrVWQjXZyahaZ2QYTpl4aJGckLOOr1TtUUoI7QlTqyzpiiyNg7G0vsrOZ6F2oDThA5dCq8EKoMKqbZzz1LEOwZdhbaQG3/uoSbMid4lWfsNQeXgCicMhNsdoB3emEW/RDBvI0qwaow0xtTCUSiiBEFecmGkijDXBpCdy72ByzCQgjN89ERkUb2nBsc7c8yA7FVDdOESRjK155drHLVlob0gn91QbatU9d2fdd4ndd6vdd8vdeEvBcNfYNrvaUWUb+/vFZ0fE1tXRDUZsln/NioQsmm0XU3h7hho6AYUaz2dNY3eGE5ttgSQj5tDNlmDFGhZSsqOdhF9NR/OYBWx5qSuhKVNgcLTNpO69VowYdeNGmUOssmIbx3y8wHszVdIz22LcVprB+eXSG+/RF4ikhPbNSjTa/pLBPOrDqDUzgWE63g0t3e//3d4B3e4j3e5A0wuH0Wa1OeZpeF+5jSXvlpAda8tPwWzOibfx1vQ9fcHCFZM8iubWTQ820Wq5nFLvGi3kmE+uwYYBXV7qbRAQ4WVdsrkp01F8YH0S0QAOjK8jrW67FID64V29u7ESpSHCWEjvDEgks9EUVtbbw8Dv7hULEntybfmlt3BU45J14RK12YNXacOCrPnA3jm1WNitm9BFFMjKenYy14EcFx4oc9eWbT8yzkd5WxzIttCIFfSQycnp2jKRQGVoApvrY51hzP7tU8VD6OhFBAi3k2Kz4iWbtBBjnTCcEAu2ADqRAe8LUn0+1O7XVdzWMsaU4SNlrbWnxBNv8eE+YMo6xNEEiwC5CuClXgNwC5obWdZ9gysO6y6ewyBMPw6aAe6qI+6qRe6qZ+6qhu6h+wDJPhZWAWy2ajohGhZjXR1DKdORcA6bpODvVgEvDDxrjMOHdQC8Re7MZ+7Mie7Mq+7Mze7MyeCGmwF0orpRqzqN5kWRPu3Bx+K8+Y67oO6QywT1vDxtYsNGDg7Oie7uq+7sl+BmuhNRTDL8FeIaMct6MmGpd7zJfhBN++C8iAADiFB/uCZBv7Aex+8Aif8MU+Dl4RMaojzYWDZPPOP9jMht113hJit/ve7zbQADphwdl9ZJjWL4laLdMQAwqf8iqv7MZgACAgFQWZaen/+CclvzjxjAlnJBLFlNxA7eP+wO/fbgNhHqg5P+gzkYT+WjQ4b5pitKyf1BdAr+tCj2svbvQugYZiY+abgtuod+Ek4e1SH+ZEY51W3xK6rTHSxQiacrB6okygzRFvwPG9UDbYjPEBPnEyEijzgsnBYhcoBxT1JMc30QMc7/HNRq5tBDCMWvbOTX1SEVLhDBOEH/Qenxt6LGBqf3L3DeOHFOdLYVlJrhKTL/WVjxCRYOXOauY+bfdzUkxFuxSo5/QqwQqF/xCnr7FAk/Y8nX/Yxfo/UkWC3xTCJxPFAPaQ3vEUscbG3Th6D63Seij5p61kO/3UX/3Wf/3Yn/3av/3Z/9/Xer35lTW3vl9CV/kSxRANtY8RdnbIx93+HZu5WYF6kY8UYrXlFqENcZD+YhqlvQkQ/gQOJFjQ4EGECRUuZNjQ4UOHhf5NpFjR4kWMGTVu5NjR40Q/fwo6UvPR5EmUKf8FMihR5cuKkljsoklTlRKYKQ9FIhToEiNHIiEOJVrU6FGImHIuZdo0kpaRJZtOpTrxUsuqH01QqWkTS1aVh/zg6YlJ0xxHfP5ARdrW7dujkcDOpTsRD9uBJOvu/ajJoFK+FSc96brrRIbATQ+p8ROJLKFCgQJhulRZ0+XLczRv5tzZ82fQoUWP9szI9GnUqU//Tdw6592ormVP9Fvw0v+hxOpUFW5FZPZv4MFZEmQU3PhGQgb1Ht9bm7hUus3YFN4lawVz7Nmn4in4B7p25skL8vEDHuzV7nLnZpBF3YwJ8/Hlc1QjdCCe+eEN/lGff+nwgjDBjaopMqFulzjE8W/B/NAb6BIGjYONIC3wi/ClQvAaiA8LlxqgCEuoUwWBC0vMzg8NHRnQRNkmJMglFk2KxD6CNCnvpSlmaeVAL6qJ8cffHPRHixuBbG1Gg24zsiM1GEFojg49GkAJCXY7UBRJltRyLzU0BGzLwPzgwyBGvgPTokA0JOiPSwgpsqJiJjACCUWsPFCEbM7Us6pCKDRzT7DUcMQgPvoDFKRBFfr/YxBc9sEhC1nsPJCmNh7R5lBMYZqjxkzrOmTTgrSAMVNCaDQog0knbaOIATp1FSUao3y1KkwO0uTPPQ8JZMyDqki1sCzUyXJWYjnyoyBci12KEDX9IW9WQuZQ04pfbcgCiSiU1VYj8QRyZNusxDRIVGLVIOQSR6AqorAFRPAECSN+AHfei2p9kF6q1AC1oDK1VeOHGmqoY4JW8TXYIuf8GfXgnDLcjxCGIzY4UYEMlfilSHgtaI43L/bYVRqT/fijQxIeSItARlb50EPWXDmnUg9yxOKXa2ZRDYL4sPklNUwe6Nadg77w2A2FVinmcTER2WimgyNaIJ2bPqlnhP4o/2RFqbP+DeeTtT4pEorHu9prslvTcOmyK3L4ID7GTvvtrMKGGG76LmlWoD8CQZtuvjkSUpO+jfX5ZBsDN/yjbv35A+vDLYpk34MYcbtxyinqkqC5K7/ocYW00ERWzQOHvLjQMfJDk7sHYhP00tPmjiDWW1cDE1P304SQvVtncSeyIpusMkwCKYQQPDpmSmN/SNf9okMKCTshRzDBI/flwfODEEzQqn2hPxjBxM1lC8q8eov8oN0hRzQJJBLGyWfuEDwwYSR1o/hos/2PkF/cfYzgRx2i7l0iEISIBPX4NxU/BGJ+cEmIFqCUktcN5EsHtIj/tucQLfzBERtUjWrmoP+JS2CiENOj4EbM9zwGKoQPejuJkwhCsxJSJBLyo18K1zSHQBjPfc1z4UM0+MHgFUKIvqOM9hqiBaV9BEUEUVEMNwI/GtqQIYyIXelmV8MNzeF7OqQPHgIxhwvirYoWsZcEnajEQvwkjDacgwHp1jMsOqJNbuzIDJEXII8c4o5jPCNG1MCTQJwlLVgsCn9khwn6ObAQdExJJOxmK/w5rjuM7KMfGeMHTGayMZHgpGMg4xNGXLBCocNDGBmBO9moIRC1A1xHyiiQOVTyOAlEocIopy+EIJGLiVGDkAQyQY08L2WyPA4e7ugPTUSSbFc8SN6UKRtmFYSP/1jiC4l5nCb/KWeXEWMMJzGpBlz9sRDSOgjKnvkbFznrnP9InOIoec2pfGpc4+OmAteYwT+sZSFtnE+fCDJMv/FrnfCsyyvNGDHOMZBDC4Lc/jhyiOdBiKDBiebGBtqp06UQiRc1zuUGsrCMhKQgIJ1oa/yAQkZwFFBre8sK3xkk4nwkggLRAgxLGphD+DJ5KgVTNhHCB0ZoxjRpUctatHBUPqSvENucz9OGdFEA4Y2pN6WLPzmlrFLKjIXFkptJTNZEqs4mnbZUyVggQ8CXJsagUKMnsV4ZS5I9r5VhbVGobBrSS2zPflOdjU8DxNMzOVULBqzPSOk6G6viLXd+gFxCOKYdJKVn/2IEASZHnrKmtB42Jb5cDrcIeTKSyuYQa/UHPw2WWO+cJLH+qKxmPfW8Z/VPpw1p7ZFqCVCDFfagJoHcYF3bGt2eLBBYa972tJC+yywQK2Lt4ZqmqayoEukkTiXrb8NUOwdiInt34wMhGHcIQhzzuVNxHkL6dbHgJg8lCVOedfkiUogkUyM5tWtgjJkQ3F5staHNSCSQ5d7EnBSD/K2IQfmQ2SfOViCM4Cu9wiZdkyCvrQCei66wCLS+jASwHvHreCbsMf8ykaNCkiiFAzO7Y7KpwRSBaEHmmq9aPjBoUUWmSRLbXhOHCTLDW/FF0svarDR3wT2OmJDzqxGn/iHHQP+6LOaoYlBySe3HBGZxQTa8ZObMdEhE7m+oxquysX7YIiHD8o9ofGCmPO/LK1vtKDmCPC6XGTu+hCtMtFzbpkFZzBMJ213lnJ8WvygnzeXDlUfmMwKHLc5/xiaNfFtW8fHNZ3iGM6NjpOU6oySqUZM0mXClIUNbOji+9LNGmotnsunUnBVJsqhjpMeYpiRWh6Mx3jBRQAEPBMeujpCWS+1jCoXaZmNVCJV5LZ/mvtgjIYZa5XLNPWEfW6x+Oknidh04C3duzdLODvJK7JHEZfqWj9zPtrmNnega0Nq6A+9PkjqHyZ27ROkV90Zmem1551vThl12zvT975fAGnYcDjaiwA1+Ei1rYc8UodGvD/7wf6xVQByB3JEhfvGKNNYfM9tIVPGN8YvL0yCFwwiznwpylFekZE+CYcNT/vKJpOmnW51IcxcOc4CDTSEybq6xcQ7wQtzTVOb+Obebd8xcRrvorsYDOYu9dKirEulAhnrV/+FIXjnQ4VZPOYK5/nWwh13sYyd72c1+drSnXe1rZ3vb3f52uMdd7nOne93tfne8ly0gACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVOCsEOruBuXakj64wpioy9s7HEzmqud6E24ASRQ6fCC6HKoGKa/dyzBFENirALZP/gThbaQG26hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTGyaQCbsw1argA9IhihhRkJdsKIkyzKUhdOdif8AiLITQPCAdEWlkz7nR0f4sMxDr1QThy2bXDaVADlN91zXtN12sctWWhvSCf3VBtq0z2IRd2IZ92Iid2Iqd2IS8Fw19g8rHs75Wv7+8Vk+oAF5w15p9Akew1wVBbZZ8xqKNKpRsGl13c4gbNgqKEcVqT3B9g1uCCjJgA5p9156wAijhaG082mYMUaFlKyoZ2e6E1X85gFbHCJhd27uADCKQDQnFcnOwwLzttGeNFnzoRZNGqbNsEs6ABLT/Xdut8Ahc4DfMfDBb0zXSM91SnMb6cWEV2nx4ikhP/BAmMNPKbQcZfdXVHbyBMziFYzHRCi4CPuAEXuAGfuAInuAAs99msTblaXZZuI8qDRIZ0AbKDQq0IEPYRsvfd5zXctMoEd9Ep2ul8N2abQfNQHgBWtCNzeGuZre96xIv6p1EKA5SDd7QQEei6ggb7eJgUbW9UtpZc2F8MN8CYQJZoNxZUAkIIW/LF6jl7eOYhQm35rsJ49kQEZEn8sRNAArKLQMYMG1B+DGkKuVTsSe31ry/VncyTjmOIJjZsAC1fQINABHMuF7y/NpmvlnVqJjdSxDFxHh6ytaCFxFKoAq1/90G1TB+yryYOj3Pe35XGcu8G34Q+JXEwOneOZpCYWDiU00FJnARm2PN8exezRPp40gIBbSYZxNRo0YfWD4RU/nhosMAys0CksARe7LbYdde19U8xoLqJGGj0q3FF8TmMWHOMErcBIEE943lGyrdeYYtA+su1n7t2H7tQDAM3N7t3v7t4B7u4j7u5D4MH7AMk+FlYBbLZqOiEaFmNTHrYXd2BHEBys0KxaCnqp7e6p0qMVALAB/wAj/wBF/wBn/wCA/wiZAGe6G0Uqoxi+pNliXkH+HkKfOM9l7bDLBPW8PG1gzElJDwIj/yJG/wZ7AWWkMx/ILLJUfKf3kqsZ41x/98GU5Q28iAADiFB/uCZP2+CCX/80CP8OPgFRGjOtJcOEjG8jKCzWzYXQxeHDDeGDWv2TZQ5zlhwf59ZJjWL4nKsSkQ9GAf9MZgACAgFQWZaen4J12/OPGMCWckEsXE3kTt4f4w9XdtA1ZwK7os7DWRhP5aNG5vmmK0rJ/UF3Y/1XiPaz3O9y+BhmJT6ptS3ahn5CSR8Xef90RjnYzfEtetMdLFCJpysHqiTDGvEW9Q2zbQC2WDzU/P4RMnI4EyL5gcLHaBckBRT3J8Ez2A+nXebOTaRgDDqJtf8dQnFSEVzjCx+1Rv9TeoxwIG+ifX4mZ+SFnLFJYl6Cqh/HfP/Af/EQmT7qylLtStLyfFVLRLgXqErxKswPsP4f0aCzSfD9T5h13jXyNVlPtNIXwyUQyWDxC7dtlo8M/gQYQJE/opdMmRFn8RJU6kWNFiRC1a/vBxxGiOJk2XLmEKFKjQyUKEVK5k2dLlS5gxZc6EicfmTZw5ddr0o9DnT6BBhQ4lWvTgIUYU+agx2tTpU6N4KhaCWhVosWgCtRK0ivBQpIaM/lwkW9bsWbRp1a5lu5bRoa5x5cZVw4eiI6Zz9e41WGgq36fa4mgVyBWwQTV4AmkS29bxY8iRJaOletiyZT9jJ+K93LlpoL+egUpiQXiXKiWivUYiFOgSI0eaJ8+mXXsy/ybVua1Ggrg5r27gBi+FDm6CimlVWIL/POQHT2tMmuY44vOnt23s2WtHWt59KJ7rETl7z62pIm7gk56YPpGBvNNDavxEek6oUElMIi+B5D/H/38AAxRwQAILNPBAARlRcEEGG1zwvPciVAi8u36T0DLzKLoELtXUUcW0Voi4cEQS4wJtIkZKvJCQisZTca8MUbTwsGbYMG0XWVZ4cUcef5Jqoj9m7BE4FpXqaci4hqPoD+4sy0CWG80wAUkqX1RDtojwqLK7IoFscsunTqQIEw71EieTG3eJQxww24xQSYkucTM4CifSQss5jSokvIj4wJMuTLSwAzkE8jQUOD/Cc/+kzEM9q3OiyhoNKhIsJdLkSKjUuKS3QdYTyItqJBX1Mjj90QLTUS+jtKINU/VJjaQsmuNPotQoJNaJUhFIFElc9VUuNcJD71fM7KKIESF9DYRPif64hBBUEfKDEEwcKUuGbIjVtiq/JNIi2W2BtVapL7X1Y1yy/ugIttjQ0iIQRsOVV6g5JtJk3sMOqZciLSLdlpBKI9MCE3DxNfggLGk9eC5MLNKk4FEPCcRYyBwJBOKF8fWDIowzdooQZvmIVltC5mDWLEcwKddjlv/p0h9HWt7LD4q99TdcNQhx6GQt+GAEE0I6lnnehuMcWi819j1WaFfliyQSP/xg+miDY/T/52aqrdqzoj8Iyfrro9H1Z2WwoYqkZonmGLlstrfFcuq2fTrEam8DiftuYg8BEu+uALbIEbL5FrxNNSbiY/Cq1KDbUrgRd/y9jSU6/PGn/K5o4MYp11y1yPvc3CnFL/qjkHg/Nz24wr09valIxDac9NVj1y28zE3f2iI+YJd9d8vE9pr3oTQ92Z8/Lgb+eLlKvRd5ofxY3NtLmZe+qZf/KH16hCJR2iJGdMf++4SCneh38H3SviwtNFG4/Om3T5H9n5wfPiJn14ef9x8lsv/+f9TAJOAlaSJo/PvVV55zn0DkZyQmIQQe1taVmr2PgAo5RCFcd5GU4aF2E4QctaYD/8Cy/OFn0IrLy/xBPg4u5H9pcYQmAhGJ66XwPYfAAyYYMT/H8OFZMRxKzawnQ7nhQRM45BojLhEIQkRig0Csih8CcUPt2GlWT8lfRIbFxITQUBMgdJe6HLEuBzHoIyMphAaxGBQ/VCuKZeGD8YyCq4gE7owGiYQNiZidP8whEA/kYAXhiBZ1fYQkKEFgfj7oLoIVJVGb4eEc/0FDO67xIozY3/38d0d/8GEOQOMjUBITiDlwkXiVTEjRJHJFR6IxLKK0zRyWuDrFEdERz3qlQuqItomgkjloI2UqX8WaxUyHD5hkC5P4d0myaGEOhajlUCKxKYc1ko5LaqYv+yefqP9lM2pP4+YBXdMYi9wJfnjgIiMGCBw1BCJgyxOKKSMyB2tGyIkXvBr4knaRgXVSNJqC0FBcZ7d4RggPuNSENE2HTK7Ba0Qgo0gv/7HIicgxoLqBVYv0STWnQU1qyVIDWEwWToWW6FGZNKgJgzTRGW4PIyj8WjrBic8/xJSIruRRtyQCUKGUyh9vQel73HlKsJ2vNn5C0vZ+KJRDuE5OPSUPQykyB4PKy3m2GVhUIyQ+iWDNJ5mhiFaZmptzVYSnLbvdbNpYzdyUSoJCqaKpJPpVzxxCpzu1atP+aDiPzEFB1KmOdTLSsxYW4qIv6pyprCom+g0WroexqaUyRs6/udH/YL4zCt0WtdjujLSeUHGOfZKI1sv8tE8sNZg74VmUpFKEnZgFTlu18FaF+OESANShYtF5V3+QqWWF/ZZRrtRV1i6nscQTmh9UehG1kWhVS4LtvMSmy0mF56TBBY5OXfQTp7rLq8A5hGj9QdOjNXa6RRkudKl7mdQa7oFydYx5c9M6i+D0aL8FalO219vz5oa+dWNUBQGohRaCBIrEaS1u/+DQhSH2VE0p7Gbzy7mAKRMTmPhoRfhAiHgdghC4RLBeLDhJ0I5qvzt1itXW+mDPcHUtBQUKe+3UXLkMlCzyLdtwt2s+jqEYrPQM540P8tOldMbF3LMty8S2YKPUjLQ6/7aMxIj4sMrepa5NqSjulsy2SEjZKKVaKpNV4z9cOqvIj3TdapFGzyk6DrH+MHNQGntiL4tmWichYeIq5d6q3JURY87aH2kMlML+Ic6G4g1FrgyVn/broJXysUH0NpEpD5pEruUzju3U4btp9tAIeZuk87TmIMfFdZjG23DFKZSaVdrTEtLpaa3SVjxTLtGb/ofYYLxqFaU3q12BIx8izbfF3Vhsqsb1e0aM36c0mNabW5x7U13sObXV1U5B7OSQtzhk+SQ8v4Y2qyly64TAMdanm+u7GBXobs/pEBGESsKwt2b6qUw+YoNzuqnUVnAjxk7cfpxmy9Joe78Ijm0WSvGWJVe+sJ7lqAEHUxWRTZSX1Zt5TkYfqRk+opp1GeITmbY9ock1i1/8QgqeWsQJqOHXcGSZ/Ba5sbHU8aBUUeItp/lngEsUg3uu5juHyrobWqt981zoTXHtsv+BpXwPneei1W1QtvdnpUddIccFXFAQO3OpS11fDntgzg2bdbBT8HnfDRzSw352hCzrImdFCByNjvadw5csaYYjwOHO80KIUiM/v/vdK4hLfLK87xfHQ4XJYvfBKz2dgM9t4h2fvUsYS5lJf3zWQ1x5zGde85vnfOc9/3nQh170oyd96U1/etSnXvWrZ33rXf962MeeiQEBACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl6qVAx+QAg84zNP+8NAbCZvQUABih001IanErYNgW6lG2fwF7URgXh7YAWNgANmEMRYjMWMpSzks4upcjbIAmyAe6esebhIlTF+KBJNwAAS0Aa78Ma7oAqokMV07LR0Bhb6cglF7BhvmhBp5F0csY+uaIlt88AfIQlYQAZP/wDHjPzGG8CCKBzJkjzJlFzJKWzDQLHDrpGrgqEJTVqbsOF7ayezNylk6iXACTEAneAJJ9DIrrwLVsA/hKKbw1IsKYfAF7HDPTyljsEIMEYRgLaiaKiAXym6KYFuqCsz3CAGrfzKrqwKpcA/v4nLT7kzTMvLqsGEWZMwUUuht2I3ESxT+atwd2kRJlAEoODMjewFdhAG28AFMui+KnIIv0M7g0gXhLOmfcLJyuPLnboR4eYmDBexufFsZvxwwuUI3jcJbKAK6vzGUBANSjAGuVGieaOj+nt0/coHXEmBH1FPldd5s/lCr4m+KiGfCpNCGaAID40MOMAAK6AQHGQ+fP+A0akrVWQjXZyahaZ2QYTpl4aJGckLOOr1TgrBDlnw0GaAACagtRaNKZ6MvbPBxM5qrnehNuAEkUOnwgtRzKBimijdswRRDSztzG3AClHgJq2LKku4KXOCV3nGXnNwCYjCKTPBZgd4pxdm1A8RztuoEqwKM71hApmgzjigBNqQEQVZNquSKONcGkJ3LvYHLMJCCM0j1RGRRiFd0WEzzbEKsY9NEN5sdt1QCuTwysggBpMgptWWhvSCf3VBtq0z27Rd27Z927id27qd25i8Fz19g8rHs75Wv9+8Vk+oAF7wyjYQB2n9cNWGzXUc3ahsGl13c4gbNgqKEcVqT6F9g1v/ggoyYAOv7AkxPWXks8fRXccQFVq2opLB7U6i6GMDaHWMgNyujAwikA0JxXJzsMDp/bSYjRZ86EWTRqmeXRLOgATi3cit8AjwXKUJtTVdIz3/ncV3rB8XVqHNh6eIBMUPYQJl3ch24AoncsSfFDiDUzgWE63g0uIu/uIwHuMyPuM0DjABfhZrU55ml4X7yNUgkQFu3MigQAsyhG3U/H3HeS0Wmm1Dd+AcUQoLzsh20AyEF6A13dtH7mp227su8aLeSYTiUNgMDg10JKqO0JVZHhZV2yvTnTUXxgceLhAmkNSNnAWVgBDytnyBKs9pDrCYcGu+mzBjfCdC6AhQ3ATp/9zIMoAB0xaEH0OqfT4Ve3JrzftrddfllGPoFZENC9DIJ9AAEMGM69XR3R3pm1WNitm9BFFMjKenT30r8f0QSuDQjNwG1TB+S5Nnbe3Rpn5XGcu8Rn4Q+KXEwJnhOZpCYRDlb0wFTb2WJsPPODLX99Lr40gIBbSYZxNRo0Yfg94sBrnkCcEArswCksARe4LeYdde19U8xkLtJGGj/g3GF3TpMdF3QBTrBIEErmwH3a5ytebfeYYtA+suBF/wBn/wCF/w9DAMDN/wDv/wEB/xEj8MH7AMk+FlYIbNZqOiEaFmNTGVTpQ5F+DKrFAMemrtFF7h/boOtdDyLv/yMB/zMv8/8y2fCGmwF0orpRqzqN5kWW3+EXmeMs848o3MAPu0NXoM7SqPKsFA807/9DR/BmuhNRTDL9Bdcr/8l6fS7w6VuJjhBI2MDAiAU3iwL0i29ByTAlC/9mw/Dl4RMaqDz4WDZFcvI/7Mht114xKy5Y0B9oxsA6CeExac4keGaf2SqGjPCXDA9owf88ZgACAgFQWZaen4J4i/OByNCWckEsV04Xed5P7g93BsA7G856Xu7hD5tEWj+aYpRsv6SX0h+m9M+riG5qgPE2goNhxNYAGOenFOEkQ/+rFMNNZ5+y0x4BojXYygKQerJ8rE9RvxBo1sA71QNv6s91k+cTISKPP/MsvBYhcoBxT1BMg3EQbTD+rNRq5tBDCMavxAT31SEVIHjft7IAyjH/g3WGtKDyfLDxCB8Pj5V9DgQYQJFS5k2NDhQ4gRJU6kWNHixYl4/G3cqCUSRpAhJR5ixHHjHJEpE2LauEnVLhsNGkYKNEeLSZw5cWrhM+dSIEKR1KgkWtToUaRJJwbC+YegUqgQ1fDBeSlqxUsme8WUSHPOH51hxfJk5DNQoaB+hl5l29bt24qamq6F29bPTZOY6jLMinPeRT+FLjnCK9bwWC1/+Dgqq0nTpUuYAp0tVJnQZcyZNW/m3NnzZ9Cd8YwmXdr06dFP964+SBInH7qslWrEWUi2/0G5tVMeiiSYEdjDwYUPJ17c+HHkOBkdus16Kk5HsZsbLZTTNutDc6wnVYMnkKbfycWPJ1/evL/r0+v6Ac4xunqkTHXvVVNyPlvehAJdYuSo/XkAAxSQOL3gqyuSwjZ6z8Ci+jIpPbf8oAonQpo7xA889MNEkzkc4eOPBAcUcUTkPmIQLjxCXPDElHLL661I/vNHCzxYTOgQNfyIJENCCpkME8gucWzIOYo08kgkk1RySSabdDJJRqKUckoqpcypQBvdShE66bK0yEWOLmHuKvlMotFLNBkscyNG0nSLkJxWdJMiMNnssig1tGvKxDn73Is2jv6400+j4HxNNUIhcv8wUD6NwkNGfxxBNFFKlVJDxhorVcpQk/5oVNOF1uQIkzFVylOnOUoFdVWiFvXHKlaR2tLMTGNNqJAQ/eGjVpDUwCRXfwKxddiQ7jLJEVWJTWnWB5U9KEadNJl0IjUuAXZXZ7OdaFEtptUWI2irSnbY+sKag9eH1CjEvmgH/fbdgtRIEEt4i53QJEbcZTUQYP354xJCvP3HD0IwccQwbOtVGKHqONJC34UjUuPg1z4l1g+KxfqDsf78E06LQMaNGF49N9JkZJGyy0kLCJ0lBFLxtMAEYpSd/Q/dmi1iKSdNaNb0kEDuTc6RQHzOeVg/cDL6aIYIyZUPgYclxCbjHMH/xGKm4eU00qztXbnlbNUgZDBgycKEkKW7HnbnjWBV+6JTc8o34hwjicQPtd7OGkyw9Z4I15z+qNBvwuvN2B+sC4coEqE5miNqxSOv9L+0JS/okDo7EtZyzis9pNPOK3pZJ0cSD/10BtUwiQ/Uqc3c5Mpbl/2qpDliffaIRl95Ztx7Z632jW733SE1Xve3EJGHV/4o1R1e/qFIDl8d+eerPyrB2HEHXCc+qLf++5AOHxx8hart94+iyVd/W5NOXl8hP4yfUdr3619o6z+Sfz+SknVixHv72U9eJhlfAJ/Vv5VpAmcG/F7/2sTAhMSvXxv51wIhODxAbcSCDPQVzDql/wm0XXBYvMmQjwIBpMichRADMYrQHihChByiENILi9XwkD0YroZgmOiQBzXGiLNBDiJb80cBc2gQP2DCh9DRRCAiob8j1uUQeMAEIyaIHD4ADIoNEVr+ongjPGjiioFjxE+CgsMvWsQPgbAiiTpyropk0B/0SqNBpqiJJR4mMY7gY5WqNIfHYKIQN6wjQ5JIQzcGL30SYddGTFfHSFRxjAP6wxwCIUQIyrCRwtkYICVTmcr86BI9/BjvIGIs92yxjlOUZCLltkED+mqSuppDECvSnZos8Q+wPAjbNkLHQjYkMPzJI4DmgEbfFW+MjgAYMhMSyca96CGHaBwvg1m+SP/oh0MemqVxPAVBWY5lDoVwJvSsFS1VRmIu1zRVjvD2TrzZTZ4l3E94dHKmAD5KLIwIoVvUEAhIuc8hvvQHStgpmzUism/Wi9vuMGkpV80RItLb3EFlg4doakKVswtn4EI2HafhxJqo5MgjLcqWckHnoUer293Ucic19IZqK/sofJilK1USUVAnlY3KdmLErv3TnmFJzB9AdJhjsqhhHKloQ1y1HJ7KhqC/fBv/ApQwG/XPiw45hPTcFtW9hBQnqWJa/AIks43KZoAcWShC2HMfsK6HhlCt2fbMw4dFpmlRL3SIHD0S19UcIqJ0XVhKuVeWOUTJQx8CkRYcuxhNFGL/pfAB3ozSKiqnAHY1S+WIQOulzzjlFV7ik0idkKXZP4WorQ7BUI/O6KWp6gqo8PKlQSHSVZx4FrVa2olJ3XoJmGVxsm0xbF7SejEzLe1ScN1tWzjrL5/5AYHmGi5UwtUp337rcMCcSYJ22ty3uEpOChHrx1aLn9gmlWmc/W5Enstd8CoFt6sTmGCRA1+2RE8nTWXpf/C7kP49LL7+lBHIVCVDmGnBEUNq43ZQtEkKWnNha+rWRCqLngFHCFJaqCUPr0WIZB2CENGUsEpmGJa56W25HOErRMDU4gxD5a3F0ShD7Gum7IYEo2Lh79uee16EqNMk5YxxRDA2HJZBhKCw/5FvRFlc3YgdrsISEdpsi4wUoI2xZ6WFznGpBeHgWVlvQk6lRBb11StHxVfR/Fd159tZ5iESjqETlW4bwlkYpzkqBLMMlA2y4lEZBcKM8DPTNtnjhVT2D3quFIIoRBSCJpmjMgLyPz5nEi8z2qY7KXSQd1Jixd20iBChnKYpJSomh0+kynsuPrlokk6bWjausu1F5Phf1EVazAU5XI5lbaA3b6TSDGkkHzItucyt9nCx/vVqAD0jHF5417PLHH6Fxuxm/2msF1mT8KyXuRQjJEHHznZzXOXrgzQS172LqIEPouhyJ4qa+LLIzdYnKgpeLUeHy3O80SRHdP+jeR0h9//pRG2YYfvbQI20s0PIrCv7HTk4W1V4nzIoYIlsrd/fy7JhXF3xPgkNzQ7ZWq3rZz6d7BLkiaLw0jR+QRHzZzHjLPjK1fofkzckgxu3ec8pIqphP9zbPid6ReZtEgkP3LJFZ3ocf0pqkwS86UyfKqkc0j9ET13rCplu6RqyJp5vXew+za3AHq6Fmosd5JgzF9b+I3W1+5xfYcFrbBo57bhvXb9imXMjE573phdiiYlZNeANH8NCRJOoaT+8zfEwU7H8vfFa/6fiJTp5zCskEpeYEIfhnnm1Exn0oyd96U1/etSnXvWrZ33rXf962Mde9rOnfe1tf3vc5173u+e94QMBAgAh+QQFAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3btywPRSJUqBAhP3Dz6kVKiJEWf4AD/7mEd6/hwzkjOQrMmLGWQogjS35J6G/jy4ADTd7MmSQezKABR+pMunRGNX8uO9J06ZLfxoxMy54NERPs0QTVaGpcmLbv3wT5MNaE8FDqwJiAK/etxrGahIEYO1pO3XQkxrET+uFdvfvm64GzJ/9cHFiz9/OHmwfms9B2ePTw9x73p2Xhdsa94+tfKzwwQ/KAzbHfgGoB6M9zChXSGGQENkiWgQgmdEh/gGmBh4MYggUhQ4RcZl6GIGY1nz8O7daYI/mFqGJUltHn0CGMXPbYijQ+dR9g7DmkRoyXJVfjj0l1GJiADx1yCWYfAqmkUEciJxEeFFaY4pJU7mQgIRMdYmJgl1Tp5U7qBRahRE0CNt2XaNoUXWBnUhSmP3+kKedMBiYpEXg42hQJJozw8YcWWvzBhyNzaIJJIIREMuac6H2Gn0VzMEakTH4YGFpjgxpaiKKMUscjYOJNJGRgWFI64qWowrkaJoku2ulmowL/diFFkbToDx+HzPRpqrzKOGihlxxaCB6R+KGGq6+mhZp0Fflx6qwxvemYrb1WC1qggjriCCNzdOvtt98yIu645JKr7bnoosvHuuy22+4f8MK77raFYjLslD/5UYhrfgKa7RysIgvXIZZCG5EaUfrT5UyO4kjImGr4gQchgVyiSZ/UWqvxxhx3nKoWqxWCb02H4KHJqZfyoQkeueYFY2PETaSGpYy0LFOsMes4FyaaOIKyx0AHLXRof8xRiMAuRaJJxtUONvJZlWKKtEIzS10TzhepEUkhmMzhCB9MDy322NVqwUghNrd0SCEJAz2HwWdFcgm1WuAW0cuM/TE1S3j6/zMpR1pPXEggmFjs9dfwAkr24otrocnTI6mByc+YKd4rI3aLVfLJlcP9UKR5Q95S36G2dKwfkUSCx+qss57667DHnroftNdu++3GHqv77rw/pzvqdPHMCOWXvY2SGnNfqgXAePhhs9ZcOxI2YJrsbZXJ01tIUZkVZk6TgkNypgYefE4PqvcfST79YJGknZAahMwR9h+lbrV22yeKDl1jdds0/paA8RFpSnYJ/A3JehRZG/GMJ7NAGLB6WVEgqv4QCPc9pGGB8ZxL/MA5zKCPNEoLmxYq2BEoXQsTCFzIIQiBPz58EComDM3yjlaRZTGGQTJZE2hy5ptDOBA0KNKIH/9AdxkKpvBFgcjYjKZiJKJdgmUYIWIAaQLA4lnQNyysHA4TmMTKoRAkapAil6SCt+JBMSOx8htN3IMZPmyROhIs3hELEsPLXGKOFClExuZwRaSUcTj6g4hx8oZHkWAQMH9gxBP1g7w2BjI3VRzSIzMSNdgUkieRZMQkHwK+DM5kQo55434i0TbtOYQQP+ODBkeiJdVcMiedrJAoNRKlv8FEh4CZ5X6aeBld5kaMFcJEH0uCSzO90iZ+sJUpPXLITUZuRLbEUGU8pBBUYmYOzvzINBnDh2PSxFL18wgAo+kSXGohm93xQ9sE+EvM0I9h1HKEN2MSS3+w0yMjWuVKBjn/xhrtyI4FseZlIEiTWp1oni5Rg60cMUyMvEkLDU1JGhG6nFY2ZmG6cac+X2JQ7EQ0J9zzxws1gsHSvUSK5FxRSO2Jh58RFCcdDQwP83XRkWBNJgplzEZDxMZL/WGnMsEDte7ZEwDqbSSxXBg9ufmlnmLmpTw5pD98eZMbZYYkSZ2JFImqJKcKJpw+qac/gKpVbn4UI7FKqUoOYSt0DiiMmGEERVfi1HP2xKpTLYlVcwQTDPKVSi0FTTeLUsXB7kSKfx1Ji+oTE+4pVUmH8CpsznqTP6pRJ3gFa0gOkTeZGIisDqokpmpKFIQ1xk41AWBiRbLXaDVmrsvZZt7wYNob/xYlprLCSWZPUtKYYLBN/oyk3xCUTMeMlCdptKtNVIuSnj62JT3VwqC2xS3W2CtRzhtlKd94yKMSxalqbUlxA0NVj+xKsysBJq/+QKhLDAu2bikmjvBVTIYWZVf+QO1LVEtZSr42JgbcWCLde1zJ/NOOw6zic4GS08D0j1K2Km9HuAdclwhXaGZ7InzBItC8oZcgBGvMh3uSRsPChL8n6Vteo4VfxjkCE+1DDC8t2ZDxdo+wjQnvSfAq4Y3UFpH9TcnpUCc4wmnCa8RD1fIephdSIgkiJd7wSUBp25PmLcgWcTJj9AuUQ0hsX32y1pKx3JUuYqrABwFvUWxMH7eSdP9BJfEhtUyaFLkUome9chxouQLXgb4Sv1wN64nIrBEq44jQEVFMEaVsk5KVL1V8CASjDTK+is2BEV+blyI3hegSokwLI26IDT1JFAWzJKShPo1w+eBmohAwwBXSBJplRghNwJp/Rps0Q2YsnVYLBLfKFcqPAZNqbeZ4JJH4mVy94odAWOoyjNjzQtRQiBaLWdYpES1jhKmRepo4KMD2dUSc5RhxK0S+9OHyVtTg7Es5QtoG8UPyxIY5k+ixiPBmSBVnCpT6dvpgCetxRSSrybjNO66zLkgk1Ds0bIqkzzmWcoi3XBQxBtojYuQ3R8T6B4F3hdoBdniNGe5gRQaCWMf/+kfE8BCIDnrx3wkJLP88LhE2j7W0pyo2RgqraxX7Y9luwYO1AXNHqq2UmzCmrB8mJ9iEv+joQTRkY/5g7pWoONgfCSnWO2Joou9l4aDpOEIKQTktXMLpBiHEs9OtES1fFOYOKea3+221j9Q13xCpp8bfAva45scPQ3cj3P+RRTlexMyzRYkYdawTMdbMIyvVeUW6bt/IKFpGJEQ8NyVfJM3P103WnoOui2OpBftk2P7YewKBqW6NpBHta+mwdNY+wsEfRNsVyrdsHUxzjpCb4kOx+cXH/ezWawSlA8SE+WQ6eoFI1uMQ73XSqMX5mkjV+A2ROfAfbivYuwXwKcM7/0W07yQO/YzblOGf+GEi1uFPe6WgLolfe7LwcXUrWIG4l+0nvMP9OwT3CkM1q+Z9IVFMW/cTXnUJZCZ7uWcSjsUTDTZBmxZjLsFr1JQShwBMfHQQ5MclzUcmU1d1KrFSUZd9a1eCJHFeyMUxIONeH2gQbhcaoqcSXrWBA9FI+IYTYkR1RAF/X/Q+hbB2qed/DGErL3gRPrcxjvBERIgQnkcfKMNqKiFWj/cPdTQcR5gl+MWDQ3F0M8QpgfNo7lR9p9FZPSFZHPMHK9OEAhF9B+SG9LF+FZFGP8dBYwiBlsKFQiFWHANVJkE6P6E1qVNkwgM21sI+niYjW3Rvp6USQv/FP9eUhVmThyKYEsnmMfW2ErGkekNRaXjGK46ANg4FdVNyiW+XEo8oQ70HE1WTNwQYLQfXK3PwihqBS+5nFCUTCK/hUz84ETGIHH3UitghiVYYNjMobAmzTEIhb0lmJoFQiRTRU9hXZ3hwCUlmds5kgYi0UxYlHVkIh/RBhjUhjOSFi+TjNX7CXorEZDIBQKt4FHJDPI6TQld4QHF3GVJIEk8oU0dBjkTHhmUBQOKoFHhAclrQiweRUTJChrsHJ7TYEJd3KabXZcAEdLMhRXKIFJJDOWJ3EIxIY09CNxmJEDhYPEN1FNr4Bw/JFhgJFvcDRJmDB7T3jgPxew42kgH/lUoXQofTKGpzMTiBEJStMhLo1pN70ZJiUXh2FDEMd4wWgXrKaBFDBBroR3i9VBF7MjwTNAfPCBKpKH2lgZSaQ3aVE3YDSZKWEn8WEVlMg4ICIVZkWI3NKFgIKUSlZJRvIZZjwZYfU5UacWCMcZaEhz9LdBDypXPsdmu84jjQ2I3SsZJloZdkAX4yCI0DYVn+II6UaXgKcXdGt3wbI3Ib0ZDUQ4xRIUWCGRUrNHReJxIZeBmchzxMo0oOoXUaJJsSaChBaWRaKUNFtxGb6RgkFBnuOJnWyCtO+RGOSWwNQZaYF2RV9GACwZdhZzSioy/yE3Y4SRAfmTfDaRjcg5dR/8FuQlgh+GiZBRFJoSaToJGcnxOCAsGAkkIIWJaYOwRf4AgnkmYYPXWLUtFs5WkmDxNJahkS6nl7DEebCbSFQhd2dSkRSslN0FiPDkYYeoFLEykV8GNrqTKL3Jkx4ikRB3qDsehg37mg67WfGSFnish1zokZoQiQT3FTVKEvHJoqf4AJ+KJOAyWj/3Cg6nOffxmgByll4KgJRLiRMjQH9MkWvWUjLNczoFkhDPQ+FTl60cl0ftcRqMd8IiGf8uQR7HaNuZYWrVVawDM4l3BpiikjZeoQXhWmIUFy0rGdBBGcgVkSgCkYkHkQL4kqfHAJ7LiXjgGBc5A4ljM0ajioUP9GLfmonHTakR1BmmzygtpYoMyUnZDGlbQVFiOCnhxBp2nIleJmioIBqmp3Qk2okO52hKQZohBBnoe4KvqXFSqoE3P5MSEDjTaJSH1KEKkaGjS5EL9IdAkjpyRRrBkKnO3WMdJFL5rAGvi3m9RardZ6rdZaF9q6rXWBrd76rd5aJzvBmkRDKKwCqjeYjL8arMpjpwLxhC70D73qD8gaOc9mg5FTCIfKOPzar6G5E4DnL/IyKNUlLM3jo2jJPw/5p+6kfn+pXgpYk6cyd5sVSfWarIGwr/66sRzLVAaGX9IZq4FAPJhjWVHpi5+mWfP6qCThVXp4POdoiB07s2OzWob/YVkvyxBKChqZ+A8mK4foVnC3dyo5KxJidbIqITEVczF+QrNOay2pWRY4G0ghJIPo448h+xDg6H7zqpK8lTHDGjlERghky61mC5TgmrbeerZs27Zuu62/upf4RbGX2ReX4qEJa1wR0YFwQlZQGbcMYarllyxi4Y8Xq3JaWjmPo7Np6XRBe0RY667Tdq+mSbg44Y9V+A8Llz0P+j5pCVR7Wh4S4Y8rpqfA5JaWy2cJUz0/FBqRVkiRqxB8+1Og1yMosVK0m7pfMa+owgipGbsGEVmRuJbAhKQngW7+qbv/CZqO06fAW5NrB6sHsVIW6Rl7VLnK+xJLd2uvCzjPVj+k/+m1G+FVLDsSPDp1kpu9utWsS5q+bdhiRyNc7pkR3RmHJ7G1CKu+LAGgvUK3G4GZnya92QeiKIFu8aq/SSE3bTpZrimqBxwS54uFvHV+faQNE0AESoAAbyADbLAPiiACXiALT7AAJFzCEgAoKJzCKrzCLNzCLvzCMBzDMizDQpsXGzqXY1Z6rERyxksSoXsr6Epp6qVKxVAHRsAAZKAIsmADu9DETvzEUPzEbPC0VBw0FaYWBBSg2EFDbXgqYdsQ6Fa6cQZ/URsRiLcHVtAIOGAJUdzGbgzFMlDFcsyCazE+YpgqZ4MswAa4d8qah4tUGeOHItEEDCABbfDGiJzIu/9QBHPcyNVCZ2ChL5egxY7xpgmRRt7FEfvoipbYNg/8EZKABWTwBIpcyk98AiVMwjQww6zcyq78yrCcwjW8u4TgGrkqGJrQpLUJG763djJ7k0KmXgKcEAPQCZ5wAqb8xG2QBZ4gCkWgDkqQATVQB2PQDAiMEX5ACDwjPRpjNjBGEYC2omiogF8puimBbqgrM9wgBshcyqogAmxwC7FwCkdgdthbJVqjzUw7pTDKhFmTMFFLobdiNxEsU/mrcHdpESZQBKBQyl5gB2GwDVwgg+6rIofwO7QziHRBOGvaJ7esPIyACZ26EeHmJgwXsbnxbH/8cMLlCN43CWygCokMBdH/oARjkBslmjc6qr9H1698wJUU+BH1VHmdN5sv9JroqxLyqTAplAGKgMjIgAMMsAIKwUHmwwc7nbpSRTbSxalZaGoXRJh+aZiYkbyAo17vpBDskAWIbAYIYAJam9OYksv3LBth7KzmehdqA04QOXSzLLsZU70msdQ9SxDV8NRu3AasEAVu0rqosoSbMid4lWfsNQeXgCicMhNsdoB3emFp/RAFvY0qwaow0xsmkAlvjANKoA0ZUZBlsyqJctClIXTnYn/AIiyE0Dx1DWWDlpByzdQyA7GyTRACbXbdUArk0MbIIAaTIKbVlob0gn91QbatU93Wfd3Ynd3avd3cvd1B/2wYYH2Dysezvla/A71WT6gAXtDGNhAHjP1w1cbPjjzf5kwgXXdziBs2CooRxWpPw32DW4IKMsDEUewJVD1l5EPJ9D3fEBVatqKS4+1OouhjA2h1jKDeUYwMIpANCcVyc7DAC/60u30WfOhFk0apv3kSzoAEBP7ErfAIE12lCbU1XcPNIT7HkKwfF1ahzYeniFTGD2ECiA3FduAKJ8LFnxQ4g1M4FhOt4PLkUB7lUj7lVF7lVg4wI24Wa1Oe9ny8TPPXH5EBhwzFoEALMoRt1/wWzOib3317Q5fiHlEKLe7EdmDN7NpGWZ3mZ7GaeOwSL+qdRCgOqA3FrQANdCSqjv/QlXouFlXbK8PsUBfGB0AuECbA1lCcBZWAEPK2fIFa0YvOE9vbuxEqUhwlhI5QxmPQ0HCMAdMWhB9Dqp9OFXtya837a3Xn55Rz6hUhVAxwyg0AEWuOo0D937HumtWomN1LEMXEeHr624IXEZ3ED03cBtUwfkuTZ5Ad1MXuE82mqcqD5geBX18MnDueoylkTk5ABXC9libz0Thi2fey7f5Ty21qNhP+PiOStRtkkBbamdAmDhyxJwoedu11Xc1jLPKuV3cG4nl8QbceE30HRPdOEDUIkBsK4nmGLQPrLhzf8R7/8SAf8iK/LvFwDsNw8iif8iqP8h+wDJPhZWAm32b/o6IRoWY1MZVOlDkrtayAU8s2fuMhXgK1MPREX/RGX/SJkAZ7obRSqjGL6k2W9eggsekp84wrZdYcYWeT7O5AvzjyQA9HH/ZhfwZ1PBcVgzEsGNJxO2qicbmJ6+g4hQf7gmRdT7NScAzGIPZ6Xwvj4BURozobXThIJt/XEtJnVEJTl+XFYbe8gvVr9WVGdmmIg8J1HzQxsPdHbwwGAAJSUZCZlo5/kqiM89Minb/FlOOafZyA6s8JrydPWzQibZpixPMyweevruitHxNoKDY/TWC7jXqTThI9TTTWmft+PjTSxQiacrB6okx8nHX4WDaGr/h6PnEyEijzQijWZRco/wcU9ZTJN+FVkNFs5NpGAMOoxj/11CcVIbXSMCH+BXHDAqb8J9fm235I+r4UlsXsNAgQ/gQOLPTP4EGEkQLN0TLQ4UOIArXwmXMpEKFIahBu5NjR40eQIUWOJFnS5EmUKVWWDPTwj5+VMWWWVMPn4aWZORFegliQpMI5fyIOJTqRUcVAhTD60ajT6VOoUaVO3ajJZVOqWUX6aegQk1aTPB/6ROmn0CVHXYmuLarlDx9HRzVpunQJU6CkhfQS4tvX71/AgQUPJlxYMB7EiRUvZowYJljIKQ8xesgHa2TM//D0zPzR6tichyKdZSSU7WnUqVWvZt3a9UNGhzrP/ljzof+jy7SzFuKs+9+hOb2jqsETSFPp18mVL2fe3B9Z3779mB6IO7rWlqBpq6GsHbJoQoEuMXJE3fl59OlVf70ePZJagdbbTxXrEHpkPzYfEmp/yA+e8DDRZA5H+PgDPvUSVNC1SOaLDg8E5XMQqs+8yiwS8/zRAo8JQTpEDT8iAZCQQvDCpK5L5lJxDhZbdPFFGGOUcUYaa4SRERxz1HHHHCFir0PaILwtNyBlqnCgS2QDKzuHNizySSg3YlIgRqKcjRCIJLRSpSOpJPIpNYJzqcEty3RwM4f++NLMqbCs7DE2T6pvoD/IjAqPDP1xBM44+8xMjQw59BMsN9O0c1CRphz/CBMldQozojkaRXRSqub0BydKsxKySUEz/agQBP3ho9OY1MAkVH8C8XRVqLhyyBFJWX1qU/tk7QjDiDTh8yQ1LkF1VFuDjWlOLXYVNidcb4rVVu6GmoNUkdQopLtc1zz2Wo/UgO9HbHXKDyJGrF01EFT9+eMSQow1yA9CMHFkLWC7lTck3gbSQtx5eX23skOF9WNfov6Ii7zyUNMikGXzVfgfMQXSZGGdgINIi/uEJSTP5LTABF+IsTUP2o5XwqTabg8JRL/kHAmE45CP9eMhllsWiZBQ+VA3WEIYYs0RTPqVeeFC9fw5p28fojhfNQhBC1WjMCEk5qGPHRnJqGd6/xRcqFcFMZJI/GCqarCPrBhslECF6A/+yFa7Y4D98XltkyJB2aE5bob7blbNyxpvhA7pUiJV+RZ81UPSHFyliyNy5O3DG7dSDYf4cBwlNf52eO/JM8/s5YEk19ykxCfe+HPS5+NcIM9LH6nyof4oJGHVY88Kcntl/6ntyF+3ffes4MO8dLMj4kN33ot3qu20ja/N19ZXVv55leZ8GPqP/LBcIl2p137mNGHfPpKGI2KE+O3LP0hbh5I3fyPw19JCE5DXfz78KuXvyPpyBTo3fvttR3Mg/tnPVBhLkyae1r9giQZAJQrEieySFELgwW4qmVv9EMiRQxQCd0PhGR5+d/9B6bSLQAQMGCOcNsGRBM0f6gMhQvyACRLeRhOBiIT3WkibQ+ABE4zIn2v4gC4bgmRufwgiAnOoiR6ejREWwcgHb7gSPwSChwuSyLNQ8j+BcOuJGzliDNniFkeEkUc8mgNdMFEID24xJC/cIBVR57ySUEsgjFOjQSKxwySq5w9zCAQK+5dBOaJGYGW8i170YqJLjNBgoxuJq6pTRDXmEI9uBFcA5WeqPIpqDiekXHGCspY/WBIhU1tUHU1ilvF48TxzcGLsKpdER6CrlRy549weokWPHMKWojRltiIRngEVKJOsqVP/MFmUORRiliKJBPMgookiRuIqvXSKGkDkNWz/eo1r21ygeJATESetD09EYcQBMaOGQORpeiEhpUDmQM32RLGNYzPe1UTnR6r0ykcjwV3g4HkdPNjSH9CE3jHPhrD50OwhvHTkQOj4z3MGUk/4/NnWusaUL6lhNDqbGEInRCtRFVGFaoLodSRmNBZWDZ3fHIpb/nAgtrDySfUaiD9BYqnYlPQ67Swl2Np3nnhBKXxEFMkhcIcpnfpGoQ+J1NCshx6NQTI66CNIIzNEz6TiZ4M5bVnwmsMHOJZpThYMCRY19NCsauUQlvIHVxfWrKHw4ShzwFGBDHQgLeQVLpooBEUndDoNSVVRL0mrb2g6kHXma5xZCuu8kFeSLsGq/7C6AelzVPIfEjXRSjxFXUrn1c53ksSoD0nsZDNjVi2gdSN+uATGfujXyMD1llINFmDvRZOrmpY2hzUXy/wQPqLUzUHJMtTQ2oZLkLwnTcvULUospaWOLNVgWI3MITjrD5kO7bAkLQlvkdvcrIw2cjdbq2u+C5lItNGmFTXPeT0SvtuC95wZOpikMogxLThCRVMUDmbwIFFz8XJhUyrWKb0jX8hMZ2KbxARHK0OIWB2CEAIVsE40OJRwrQ1QDiHrSI7UYQRrRcGrIWguLZVasASUKOslG2+pS0uYhRgz/0rN0UTCU8tQpbwYhi3bmgTbuXlWxlMxWRI1AbXI0tYksv998OGk+SrazgmpQ4aMqQR6rh6LF7HDaaMVHaeo0oLksCCmMljYtZceI2TDFnqKRBmR5qgFksUeAewfykwp5abPKTy18efWXNWiPkTJd+4QauEMY07FrrJC3ojeCD0pReVYJrirsOB4G04hOuTQj26PpUK7ErO6N3N8ZrRB2qZaTj9JywJ5cUjkyIdBC+5v1G3bplM9VfPEtyz7Ud7fzjs3W9/aN2b99EmmlDrj/S3DHIFPrIU9H0uhmiNyFLXq2FpfFxru2YPSJYdT8jHtKUp/PQNR28i87TKZVdrna5KzJ1fZtbQa3U+SY5hD8mTUmY/GpyHqvP2ERV2n0NvmK7Lj+yrt7w7NbcrcG0ixy9crVIUS4YgiMNSCdm7tSXg8cEmmuyd+nT9jtyRYxPjHTZ4SRcn7H/gW1cldPpNuO0TAtJOIx1/+ctSW+iDmWffNfT5KHwUxfHP+edE/Alw9PXRKJTd60w1yUtLejOVasLnTEe43Z72N51bnukfIFdfGylHnXTd6etfiZTmqnOw/L0QM3bLQtce9b4UQaEurLveJ48HBQ1E73o2Ozrr7o9p+J3sz9aOFOfSc8GRn7uId/3jIR17yk6d85S1/ecxnXvOb53znPf950Ide9KMnfelNf/q1BwQAIfkEBQMA/wAswgCIAKoAIQAACP8A/wkcSLCgwYMIEypcaHCBw4cQI0qUuIGhxYsYM2rcyHHjro8gQ4ocOXLDtI4oU6pcydIgyZcwQVZsSbOmzZv/Yuoc6QOnz59AGU4cSvRhz6BIkypdyrSp06dQo0qdSrWq1atYs2rdyrUrVRNew1r1M4eLF7Fon/rBpMWfv1hp4yp1S9fftCxy8+Ksy9eW3r8t+db9Uwiw4Y6HMAmue7hxRj+OFrt1TNkinj+CtfCpzFmhYsFz1HQeXfDQnMyESKsWCFmwIz+rVUfCzFfTodir+WopjDs23T94euN2ywe28N6ijytfnpWP8+fQo0d3lJq5WMnY6xq3zjW7d3+8uXcN/y45kniv5Pn+CfQvIAAh+QQJAwD/ACzTAIgAbQAQAAAItgD/CRxIsKDBgwgTKlzIkOCChxAjSpwokUXDixgzajy4q6PHjyBDgsSxsaTJkwRFqlzZkSTKlzAZspw5MqMaQppQqYrJUyHFn0AfulyophAjLf6SDu3JtOnCQ4TmIE1KtYjTq1gH+sH0h6rXpBuyiu0Zac7Xs/5+XRjL1iQeR2i9OsIUqa3djITgxvXnKJCfu4Abvt3759LfwIgX7nVU6FDix4q/zqkLuXJCr5Mta76cebNnggEBACH5BAUDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABBZo4IEIJqjgggw26OCDEEYo4YQUVmjhhRhmqOGGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRiklTnj84c+VWPqDySEIHeIHHoQEgoAMbOyjiAheyPLEAmy26eabcMYp55x01mmnnLG0qMYcWWLJBx7/+EEIJpo4YmWWZuyi6KKMNuroo5BGKumklFa6KAIvBqJFn5x26g8LloYq6qikWorpi4Qc6qmnnpTq6quwUv/KAItqEKKJqqt6SgakJ9zp66/ABkvnIymqUQgjm+baqRaOzKEJJu0okUENdYzRzJQsHULIHMkq66kWl6iBrUx+YILrqnzMQWi3nM4B6LgsRcKnsn9oUoi4A6lxCbt9/oGJH/CehIcjyjqCSSQK+aEJv33y8W/AIRFC8KqOBAKwQ/oy3LAmhOALMUYDr/rHJRdLpEYgfHjrjyOXFILwxxRRXAiXIM+rMrPPEhIJzTAv1OkcL3NkLCMqc/qHI4zMcQkmgRRSCCGE4CH11FRXbfXVWL9bY59AjzS0xkWHLbayN2LZ9UmH4IHJxGO37XaWPcct99x012333XjnrffefPec7fffgAcu+OCEF2744YgnrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9CAUEACH5BAUDAP8ALPsAiAB5AAYAAAh8AC9pmsPIER8+f/5oWciwoZYq/yJKnEixosWLGDNqvLigo8ePIEN6xDXBn8mTKFOmRLCxpcuXMCfumkmzps2bNXGo3LmzR8yfQIPiHEp0lyWeSE+yCsq0qcaiUGviQuqwqhOnWLNGFMmVaysWEwIVwhPJjxo1WtOqXTsxIAAh+QQFAwD/ACwPAYgAFQAFAAAIIQC1CBxIsGBBH/4SKlzIkOGehhAbTtsQsaLCDQYzZtwQEAAh+QQFAwD/ACwiAYgAFwAFAAAIIwC1CBxIsKBBLaD8KVzIsKFDf08eSnwoa6LFhbIOajQoT0RAACH5BAUDAP8ALDcBiAAWAAUAAAggALUIHEiwoEE7/hIqXMiwYaaGECM+jEhRYSaDGDM6CQgAIfkEBQMA/wAsTAGIABUABQAACCAAtQgcSLBgwV7+EipcyJAhgoYQIaaKSFFhKoMYMdoKCAA7",alt:"Loading..."}))},wi=n(22),xi=n.n(wi),Ai=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.data,n=t.x_type,r=arguments.length>1?arguments[1]:void 0;if(f.a.isArray(e)&&f.a.isDate(r)){var i=f.a.find(e,(function(t){var e=t.key;return Sr(e,n).getTime()===r.getTime()}))||{},o=i.value;return o}},Si=function(t,e){return!t||!e||e<=0?0:1===t[0].nodes.length?e:e-3*(t[0].nodes.length-1)},Oi=function(t,e,n,r,i,o,a){var s={},c={},l={};return e.filter((function(t){var e=t.source,n=t.target;return e&&n})).forEach((function(e){var u=e.source,d=e.target,h=e.color,p=e.metrics,g=f.a.find(r,(function(t){return t.id===u})),m=f.a.find(r,(function(t){return t.id===d}));if(!f.a.isNil(g)&&!f.a.isNil(m)){c[u]||(c[u]=g.x),l[d]||(l[d]=m.x);var y=(f.a.find(p,(function(t){return t.name===o}))||{}).id,v=f.a.find(n,(function(t){return t.id===y})),b=Ai(v,a),k=function(t,e,n,r,i){var o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,a=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,s=f.a.find(e,(function(t){return t.id===n})),c=f.a.find(e,(function(t){return t.id===r})),l="target"===i?c.color:i;return{position:{color:l||s.color||c.color,bottomLeft:{x:a,y:c.y},bottomRight:{x:a+t,y:c.y},id:"".concat(n,"|").concat(r),source:n,target:r,topLeft:{x:o,y:s.y+s.height},topRight:{x:o+t,y:s.y+s.height}},sourceAcc:o+t,targetAcc:a+t}}(Si(t,i)*b,r,u,d,h,c[u],l[d]),w=k.position,x=k.sourceAcc,A=k.targetAcc;s["".concat(u,"|").concat(d)]=w,c[u]=x,l[d]=A}})),s},Ei=function(t,e,n,r,i,o,a,s,c,l,u){var d=[];return t.forEach((function(h,p){var g=h.nodes,m=s;g.forEach((function(s){var h=function(t,e,n,r,i){var o=f.a.filter(t,(function(t){return t.target===n})),a=f()(o).map((function(t){var n=t.metrics,o=(f.a.find(n,(function(t){return t.name===r}))||{}).id;if(void 0!==o){var a=f.a.find(e,(function(t){return t.id===o}));return Ai(a,i)}})).compact().value();return f.a.sum(a)}(e,r,s,l,u),g=Si(t,i)*h,y=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.id,n=t.color,r=t.label,i=arguments.length>1?arguments[1]:void 0,o=arguments.length>2?arguments[2]:void 0,a=arguments.length>3?arguments[3]:void 0,s=arguments.length>4?arguments[4]:void 0,c=arguments.length>5?arguments[5]:void 0,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0;return{layout:{id:e,color:n,label:f.a.isNil(r)?"":r,x:l,y:c+s*(o+a),width:i,height:o},acc:l+i+3}}(n.find((function(t){var e=t.id;return s===e})),g,o,a,p,c,m),v=y.layout,b=y.acc;d.push(v),m=b}))})),d},Mi=function(t){return Or(t)},Ci=function(t){var e=f()(t).map((function(t){var e=t.metrics;return(void 0===e?[]:e).map((function(t){return t.name}))})).compact();return f.a.intersectionBy.apply(f.a,O()(e))},Ri=function(t,e,n,r,i,o,a,s,c){var l=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,u=arguments.length>10&&void 0!==arguments[10]?arguments[10]:{},d=u.top,h=void 0===d?20:d,p=u.left,g=void 0===p?0:p,m=u.right,y=void 0===m?0:m,v=Or(t),b=v.find((function(t){var e=t.formatted;return c===e}))||{},k=b.key;if(!s||!c||!k)return{nodes:[],links:[],levels:[]};var w=l+g,x=h,A=i-w-y,S=Ei(e,n,r,t,A,o,a,w,x,s,k);return{nodes:S,links:Oi(e,n,t,S,A,s,k),levels:e.map((function(t,e){var n=t.title,r=t.label,i=t.nodes;return{title:n,label:r,y:x+e*(o+a),x:g,width:f()(i).map((function(t){var e=f.a.find(S,(function(e){return e.id===t}))||{};if(!f.a.isNaN(e.x)&&!f.a.isNaN(e.width))return e.x+e.width})).max()-g,height:o}}))}},ji=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>1?arguments[1]:void 0;if(Array.isArray(t)){var n=f.a.find(t,(function(t){var n=t.formatted;return e===n})),r=n||{},i=r.key;return i}},Ii=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[],i=f.a.find(n,(function(e){return e.target===t}))||{},o=i.metrics;return void 0===t||void 0===e||void 0===o?[]:f()(o).map((function(t){var n=t.name,i=t.id,o=t.unit,a=r.find((function(t){var e=t.id;return i===e}))||{},s=a.y_type,c=a.x_type,l=a.data,u=void 0===l?[]:l,d=(f.a.find(u,(function(t){var n=t.key,r=Sr(n,c);if(r instanceof Date&&e instanceof Date)return r.getTime()===e.getTime()}))||{}).value;return{name:n,value:d,unit:o,format:s,formattedValue:Jr({params:{format:s}})(d)}})).value()},Bi=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Sankey options object";return t?Array.isArray(t)?0===t.length?["".concat(n," key '").concat(e,"' is empty")]:[]:["".concat(n," key '").concat(e,"' is not an array")]:["".concat(n," contains no key '").concat(e,"'")]},Di=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(t){return t.id},r=[];t.forEach((function(t,i){t&&n(t)||r.push("'".concat(e,"[").concat(i,"]' has no id"))}));var i=f()(t).filter(n).groupBy(n).pickBy((function(t){return t.length>1})).keys().value();return i.length>0&&r.push("Duplicate node IDs found in '".concat(e,"': ").concat(i.join(", "))),r},Ti=function(t,e){var n=Bi(t,"levels");if(n.length>0)return n;var r=Di(t,"levels");if(r.length>0)return r;var i=[];t.forEach((function(t,e){var n=Bi(t.nodes,"nodes","levels[".concat(e,"]"));n.length>0&&(r=r.concat(n)),Array.isArray(t.nodes)&&(i=i.concat(t.nodes))})),r=r.concat(Di(i,"levels",(function(t){return t})));var o=e.map((function(t){return t.id}));return r=r.concat(function(t,e,n,r){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"Node",o=[],a=f.a.difference(t,n);a.length>0&&o.push("".concat(i," IDs found in '").concat(e,"' but not in '").concat(r,"': ").concat(a.join(", ")));var s=f.a.difference(n,t);return s.length>0&&o.push("".concat(i," IDs found in '").concat(r,"' but not in '").concat(e,"': ").concat(s.join(", "))),o}(i,"levels",o,"nodes"))},Fi=n(28),Pi=n.n(Fi);function zi(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Qi(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?zi(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):zi(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Li="usa",Yi={magenta:"#E62790","navy-blue":"#00347B",cyan:"#249EDC","teal-green":"#00906E",purple:"#6929C4","mid-blue":"#20659D",pink:"#CF77AD","dark-magenta":"#851C6A","light-purple":"#A56EFF","emerald-green":"#006600",blue:"#015193",gray:"#949494","dark-green":"#004837",republican:"#D5205E",democrat:"#1571A9",independent:"#00906E"},Wi={"yellow-teal-9-bin":["#CC6A19","#D99522","#E5BD3F","#F2E289","#F1F1F1","#97DFC7","#5CB79A","#00906E","#004837"],"purple-teal-9-bin":["#3C2A9A","#7756B2","#A786CB","#D3B9E6","#F1F1F1","#97DFC7","#5CB79A","#00906E","#004837"],"red-blue-9-bin":["#A7004C","#EC2D66","#F28BA9","#F1D1DA","#F1F1F1","#B8DAEB","#3DA8DF","#1571A9","#043D70"],"yellow-teal-6-bin":["#CC6A19","#E5BD3F","#F2E289","#97DFC7","#00906E","#004837"],"purple-teal-6-bin":["#3C2A9A","#7756B2","#D3B9E6","#97DFC7","#00906E","#004837"],"red-blue-6-bin":["#EC2D66","#F28BA9","#F1D1DA","#B8DAEB","#3DA8DF","#1571A9"],"yellow-teal-5-bin":["#CC6A19","#E5BD3F","#F1F1F1","#5CB79A","#004837"],"purple-teal-5-bin":["#3C2A9A","#A786CB","#F1F1F1","#5CB79A","#004837"],"red-blue-5-bin":["#A7004C","#F28BA9","#F1F1F1","#3DA8DF","#043D70"]},qi={"magenta-9-bin":["#E8D7FA","#E2B5ED","#E390D6","#E565B7","#E62790","#B4228E","#7F2386","#4A2076","#091A60"],"blue-9-bin":["#D4DAFA","#B7C9F4","#95BAED","#6BACE5","#249EDC","#037BC0","#005AA2","#013A82","#091A60"],"teal-9-bin":["#E8FACF","#BCDFB0","#8EC495","#5AAA7F","#00906E","#00777E","#005C88","#003E7F","#091A60"],"purple-9-bin":["#DED9FB","#C0B2F6","#A58CED","#8D63E2","#7735D4","#5831B8","#3C2A9A","#22237D","#091A60"],"magenta-6-bin":["#E8D7FA","#E390D6","#E62790","#B4228E","#4A2076","#091A60"],"blue-6-bin":["#D4DAFA","#95BAED","#249EDC","#037BC0","#013A82","#091A60"],"teal-6-bin":["#E8FACF","#8EC495","#00906E","#00777E","#003E7F","#091A60"],"purple-6-bin":["#DED9FB","#A58CED","#7735D4","#5831B8","#22237D","#091A60"],"magenta-5-bin":["#E8D7FA","#E390D6","#E62790","#7F2386","#091A60"],"blue-5-bin":["#D4DAFA","#95BAED","#249EDC","#005AA2","#091A60"],"teal-5-bin":["#E8FACF","#8EC495","#00906E","#005C88","#091A60"],"purple-5-bin":["#DED9FB","#A58CED","#7735D4","#3C2A9A","#091A60"]},Ni=[{key:Li,list:Yi},{key:Li,list:Wi},{key:Li,list:qi}].reduce((function(t,e){var n=e.key,r=e.list;return Qi(Qi({},t),Object.keys(r).reduce((function(t,e){return Qi(Qi({},t),{},A()({},"".concat(n,"-").concat(e),r[e]))}),{}))}),{}),Gi=Object.values(Yi),Ji=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",e=arguments.length>1?arguments[1]:void 0;return Ni[t]?Ni[t]:Pi.a.get(t)?t:e},Ui={"dropdown-wrapper":"_1U1YcieytD_eox7k6v6pAg","dropdown-select":"_3g-FMwc9cvy3ZkYeiNzQXl","as-select":"DzkEUyxkTPUwo-Jfn-MqT","dropdown-single":"_3sVlTvMdEjcX1h_HVZFH6C","dropdown-spacer":"_2DS8hBhdC3tEQFvy2UnWT-"},Ki=function(t){var e=t.options,n=t.onChange,r=t.parser,i=void 0===r?function(t){return t}:r,o=t.defaultValue,a=t.value,s=t.color,c=t.label,l=e.length>1;return pn.a.createElement("span",{className:"".concat(Ui["dropdown-wrapper"]," ").concat(Ui[l&&"as-select"]),style:{color:Ji(s,"")}},c&&pn.a.createElement("span",{className:Ui["dropdown-spacer"]},c),l?pn.a.createElement("select",{className:Ui["dropdown-select"],onChange:n,defaultValue:o,value:a},e.map((function(t){var e=i(t);return pn.a.createElement("option",{key:e},e)}))):pn.a.createElement("span",{className:Ui["dropdown-single"]},i(e[0])))};Ki.propTypes={options:zn.array.isRequired,onChange:zn.func.isRequired,parser:zn.func,defaultValue:zn.string,value:zn.string,color:zn.string,label:zn.string};var Hi=Ki,Vi={"chart-container":"_3gOA9rQcuzn1rbdvsD_Qgm","chart-title":"_2CS49RZHV7PmvDn8P_Qjqn","chart-content":"_2Xm_EMyNdkAFi63v_lwMXK","title-text":"_2vuKAALZ5jkczlVR7v9ABW","chart-subtitle":"_1dK0VgGno09paDcQZqHwow"};function Zi(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Xi(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Zi(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Zi(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var _i={title:zn.string,titleFontSize:zn.number,subtitleFontSize:zn.number,subtitle:zn.string},$i=function(t){var e=t.children,n=void 0===e?null:e,r=t.title,i=void 0===r?"":r,o=t.titleFontSize,a=void 0===o?20:o,s=t.style,c=void 0===s?{}:s,l=t.subtitle,u=void 0===l?"":l,d=t.dropdowns,f=void 0===d?[]:d,h=t.className,p=void 0===h?"":h,g=t.subtitleFontSize,m=void 0===g?14:g;return pn.a.createElement("div",{className:"".concat(Vi["chart-container"]," ").concat(p),style:c},(i||0!==f.length)&&pn.a.createElement("div",{className:Vi["chart-title"],style:{fontSize:a}},i&&pn.a.createElement("span",{className:Vi["title-text"]},i),0!==f.length&&pn.a.createElement("span",{className:Vi["dropdown-container"]},f.map((function(t,e){return pn.a.createElement(Hi,mn()({key:e},t))})))),u&&pn.a.createElement("div",{className:Vi["chart-subtitle"],style:{fontSize:m}},u),pn.a.createElement("div",{style:{position:"relative"},className:Vi["chart-content"]},n))};$i.propTypes=Xi(Xi({},_i),{},{children:zn.node,style:zn.object,dropdowns:Object(zn.arrayOf)(Object(zn.shape)({options:zn.array.isRequired,onChange:zn.func.isRequired,parser:zn.func,defaultValue:zn.string})),className:zn.string});var to={"tooltip-wrapper":"_2QJT9PjAh_Xr6dDkjPckUZ","tooltip-content":"jd1CRwMRdotD4CD8m-RPI","tooltip-subtitle":"_2qqMsta1CmyUmUwHaqq2Dr","tooltip-title":"_2wjYGuFJCpXf_HZaDl0Cxw","tooltip-total":"_1QMGWYdPUvy_SLV5U_JeUR","tooltip-grid":"_24_BmQXN4B2Tc96q4Ttfp4","tooltip-row":"_2wyzVrfw--oQri_8tg_BnJ","shrink-left":"_1k7ZNSuud9P91LCJOLrV7c","tooltip-value":"_3Rwjxm71nkemrD85UJYsw4","tooltip-key":"_2z_BrEMEKAaAyHlhMwyLD","tooltip-key-value":"_3nfEHWoqmsiB27gtFfYjDY","tooltip-key-left":"HzGwQD8J49uTDVK-DQY37","tooltip-value-left":"TBcj1JpELxEjxzjB21oOr","tooltip-bar":"_1MhImqgU1HV4Axu3CuD65M","tooltip-bar-back":"sYoKH404cYu75ZnaZraDq","tooltip-bar-percent":"VSB0AQlYNd7tGjNVrGs6I","tooltip-breakdown-left":"_3sJgX6M2-D8PQafjgGvwdJ","tooltip-breakdown-title":"_2jSNpeaRiYjlhZOCJnRzGp","tooltip-breakdown-total":"A7bN-PssAVR4fWVcYzwMq","tooltip-breakdown-right":"_1NwFIT6I99fdSAOlKx3m9c","breakdown-row-value":"_3TpoHxi2k8SaR4NFa1Bypd","breakdown-row-key":"_2xamx8ZfBosB_UucR3Trs8","tooltip-annotation-title":"_1q4r7fcKNUytzOH7j-bRvp","tooltip-annotation-text":"_1nmywUoNOmWV8OdQxTDCDT","tooltip-arrow":"_1oit60ZL_UgBZ4nd_cHbeJ","tooltip-shadow":"_1T0LNbjiqG_b1rIOYool76",above:"_2WqYkUTrR1I2KjAMBkoeoy",below:"x53peNqgBpUu3zDILwBBt"};function eo(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function no(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?eo(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):eo(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var ro=["above","below"],io=function(t){var e=t.children,n=t.x,r=t.y,i=t.direction,o=void 0===i?"below":i,a=t.contentTransform,s=t.style,c=void 0===s?{}:s,l=t.width,u=Object(hn.useRef)(),d=Object(hn.useState)("translateX(-50%)"),f=M()(d,2),h=f[0],p=f[1],g=Object(hn.useRef)(!1),m=Object(hn.useState)(!0),y=M()(m,2),v=y[0],b=y[1];return Object(hn.useEffect)((function(){if(l){var t=u.current.clientWidth,e=Math.max(t/2-n,0)||Math.min(0,l-n-t/2);g.current=e/t<-.25,p("translateX(".concat(e/t*100-50,"%)"))}b(!1)}),[l,n]),pn.a.createElement("div",{ref:u,className:"".concat(to["tooltip-wrapper"]," ").concat(to[o]),style:no({top:"below"===o?r:void 0,bottom:"above"===o?"calc(100% - ".concat(r,"px)"):void 0,left:n,opacity:v?0:1},c)},!g.current&&pn.a.createElement("div",{className:"".concat(to["tooltip-arrow"]," ").concat(to["tooltip-shadow"])}),pn.a.createElement("div",{className:to["tooltip-content"],style:{transform:a||h}},e),pn.a.createElement("div",{className:to["tooltip-arrow"]}))};io.propTypes={children:zn.node,x:zn.number.isRequired,y:zn.number.isRequired,direction:Object(zn.oneOf)(ro),contentTransform:zn.string,style:xi.a,width:zn.number};var oo=io,ao=Object(zn.shape)({name:zn.string,url:zn.string.isRequired,agencyname:zn.string.isRequired,lastupdated:zn.string}),so=Object(zn.shape)({agencyname:zn.string.isRequired,source:zn.string,sourceURL:zn.string.isRequired,sourceName:zn.string}),co=Object(zn.shape)({sources:Object(zn.arrayOf)(ao),metadata:so}),lo=Object(zn.shape)({agencyname:zn.string.isRequired,sources:Object(zn.arrayOf)(ao)}),uo=Object(zn.shape)({meta:Object(zn.arrayOf)(Object(zn.shape)({data:zn.string.isRequired})).isRequired,name:zn.string}),fo=Object(zn.shape)({footnotes:Object(zn.arrayOf)(Object(zn.shape)({data:zn.string.isRequired,name:zn.string.isRequired})),name:zn.string}),ho="_240DGU12KI94w_vpRVPwqJ",po={"text-expander":"vRBHVu4Dowi3PZHDNooI1","text-ex-title":"_3GJKZXm3O0Uh32Xh3mRCmx","text-ex-expander":"_10X-iTD9YhPnqLOumx0SMi","text-ex-content":"KdgdWkgOdKy041NSESBlL",arrow:"_3In7Jih0NvYhL4tMFXw2Od","text-ex-less":"WTyuDG3_FLYqKYGf6aefe","text-ex-more":"_1GnImGXHLqFmdsQahUORBV","source-long":"_28w_S8DSV2Dw3U4lXwQbis","long-title":"_2rar_90k7fHo1Am9YYDupH","summary-content":"_1QVGCSmzleYbUcM3WiMBbz","long-link-text":"_3HjRZke3ceIRc0zhDwSK_1","external-icon":"_2V44BL29HWEbSLhaANv4ox"},go=function(t){var e=t.data,n=t.chartSources,r=void 0===n?[]:n,i=f()(r).flatMap((function(t){var e=t.url,n=void 0===e?"":e,r=t.name,i=void 0===r?n:r,o=t.agencyname,a=void 0===o?"":o,s=t.lastupdated;return{name:i,url:n,agencyname:a,lastupdated:void 0===s?"":s}})).value(),o=f()(e).flatMap((function(t){var e=t.sources,n=void 0===e?[]:e,r=t.metadata,i=void 0===r?{}:r;return n?n.map((function(t){var e=t.url,n=t.name;return{name:void 0===n?e:n,url:e,agencyname:t.agencyname}})):i.source?[{agencyname:i.agencyname||i.source,name:i.sourceName||i.sourceURL||"",url:i.sourceURL}]:[]})).concat(i).uniqBy((function(t){return t.url})).groupBy((function(t){return t.agencyname})).map((function(t,e){return{agencyname:e,sources:t}})).value();return{sources:o,summary:"".concat(o.map((function(t){return t.agencyname})).join("; "),".")}};go.propTypes={data:Object(zn.arrayOf)(co).isRequired,chartSources:Object(zn.arrayOf)(ao)};var mo=function(t){var e,n,r=t.sources,i=t.summary,o=void 0===i?"":i,a=t.style,s=void 0===a?{fontSize:14,lineHeight:1.5,marginBottom:"0.5em"}:a,c=Object(hn.useState)(!0),l=M()(c,2),u=l[0],d=l[1];function f(t){var e=t.agencyname,n=t.sources.map((function(t){return n=(e=t).url,r=e.name,i=e.lastupdated,pn.a.createElement("div",{className:po["long-entry"],key:n},pn.a.createElement("a",{className:po["long-link"],href:n},pn.a.createElement("span",{className:po["long-link-text"]},r),pn.a.createElement("div",{className:po["external-icon"]})),pn.a.createElement("span",{className:po["long-updated"]},i&&"(updated ".concat(i,")")));var e,n,r,i}));return n?pn.a.createElement("div",{className:po["source-long"],key:e},pn.a.createElement("div",{className:po["long-title"]},e),n):null}function h(t){return t.length>50?"".concat(t.substr(0,50),"..."):t}if(0===r.length)return pn.a.createElement("div",{className:"".concat(po["text-expander"]),style:s},pn.a.createElement("div",{className:po["text-ex-title"]},"No additional source information"));var p=r.map((function(t){return f(t)})).filter((function(t){return null!==t}));return 1===r.length&&1===(null===(e=r[0])||void 0===e||null===(n=e.sources)||void 0===n?void 0:n.length)?pn.a.createElement("div",{className:"".concat(po["text-expander"]," sources"),style:s},pn.a.createElement("div",{className:po["text-ex-title"]},"Source:"),pn.a.createElement("div",{className:po["long-entry"]},pn.a.createElement("a",{className:po["long-link"],href:"usafacts.org"},pn.a.createElement("span",{className:po["long-link-text"]},h(o)),pn.a.createElement("div",{className:po["external-icon"]})))):pn.a.createElement("div",{className:"".concat(po["text-expander"]," sources"),style:s},pn.a.createElement("div",{className:po["text-ex-title"]},"Sources:"),u?pn.a.createElement("div",{className:po["text-ex-summary"]},pn.a.createElement("span",{className:po["summary-content"]},h(o)),pn.a.createElement("div",{className:po["text-ex-more"],role:"button",tabIndex:0,onKeyDown:function(t){Gr(t,(function(){d(!1)}))},onClick:function(){return d(!1)}},pn.a.createElement("div",{className:po["more-text"]},"see more"),pn.a.createElement("div",{className:po.arrow}))):pn.a.createElement("div",{className:po["text-ex-expander"]},pn.a.createElement("div",{className:po["text-ex-content"]},p),pn.a.createElement("div",{className:po["text-ex-less"],role:"button",tabIndex:0,onKeyDown:function(t){Gr(t,(function(){d(!0)}))},onClick:function(){return d(!0)}},pn.a.createElement("div",{className:po["less-text"]},"see less"),pn.a.createElement("div",{className:po.arrow}))))};mo.propTypes={sources:Object(zn.arrayOf)(lo).isRequired,summary:zn.string,style:xi.a};var yo=mo,vo={"text-expander":"_3E0eQ6p6AjpvGdFU3yg8Bp","text-ex-title":"_14UsoDQLUVD2Cgvk0cc-M2","text-ex-expander":"_1X1Bcnhfw95jdxe3fEKUkE","text-ex-content":"_32VZi4QJP0k6OAaoiD1pJb",arrow:"uY1rxDSemD7oTTPswetli","text-ex-less":"_11RJCwRrup2DtK3pUzfu_6","text-ex-more":"x5vEXCYHC8lwlAXp4tHdn","footnote-long":"QgBfqp7meLD4YAqqwoYRt","long-title":"_3QdSa_fdSBI1DwfRAuVNFH","external-icon":"_1QLHgvYX4zZ05mT3pp78Qk"},bo=function(t){var e=t.data,n=t.chartFootnotes,r=void 0===n?[]:n,i=t.showMetricFootnotes,o=void 0===i||i,a=f()(r).flatMap((function(t){var e=t.title,n=void 0===e?"":e,r=t.data;return{data:void 0===r?"":r,name:n}})).value();return o?{footnotes:f()(e).flatMap((function(t){var e=t.meta,n=void 0===e?[]:e,r=t.name,i=void 0===r?[]:r;return n?n.map((function(t){return{data:t.data,name:i}})):[]})).concat(a).uniqBy((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.data;return e})).groupBy((function(t){return t.name})).map((function(t,e){return{footnotes:t,name:e}})).value()}:!f.a.isNil(a)&&a.length>0?{footnotes:f()(a).uniqBy((function(t){return t.data})).groupBy((function(t){return t.name})).map((function(t,e){return{footnotes:t,name:e}})).value()}:[]};bo.propTypes={data:Object(zn.arrayOf)(uo).isRequired,chartFootnotes:Object(zn.arrayOf)(Object(zn.shape)({data:zn.string,title:zn.string})),showMetricFootnotes:zn.bool};var ko=function(t){var e=t.footnotes,n=t.style,r=void 0===n?{fontSize:14,lineHeight:1.5,marginBottom:"0.5em"}:n,i=Object(hn.useState)(!0),o=M()(i,2),a=o[0],s=o[1];function c(t){var e=t.footnotes,n=t.name,r=e.map((function(t){return e=t.data,pn.a.createElement("div",{className:vo["long-data"],key:e},e);var e}));return 0===r.length?null:pn.a.createElement("div",{className:vo["footnote-long"],key:n},pn.a.createElement("div",{className:vo["long-title"]},n),r)}if(f.a.isNil(e)||0===e.length)return null;var l,u=e.map((function(t){return c(t)})),d=e[0].footnotes[0].data;return pn.a.createElement("div",{className:"".concat(vo["text-expander"]," footnotes"),style:r},pn.a.createElement("div",{className:vo["text-ex-title"]},"Footnotes:"),a?pn.a.createElement("div",{className:vo["text-ex-summary"]},pn.a.createElement("span",{className:vo["footnote-preview"],key:d},(l=d).length>50?"".concat(l.substr(0,50),"..."):l),pn.a.createElement("div",{className:vo["text-ex-more"],role:"button",tabIndex:0,onKeyDown:function(t){Gr(t,(function(){s(!1)}))},onClick:function(){return s(!1)}},pn.a.createElement("div",{className:vo["more-text"]},"see more"),pn.a.createElement("div",{className:vo.arrow}))):pn.a.createElement("div",{className:vo["text-ex-expander"]},pn.a.createElement("div",{className:vo["text-ex-content"]},u),pn.a.createElement("div",{className:vo["text-ex-less"],role:"button",tabIndex:0,onKeyDown:function(t){Gr(t,(function(){s(!0)}))},onClick:function(){return s(!0)}},pn.a.createElement("div",{className:vo["less-text"]},"see less"),pn.a.createElement("div",{className:vo.arrow}))))};ko.propTypes={footnotes:Object(zn.arrayOf)(fo).isRequired,style:xi.a};var wo=ko,xo=function(t){var e=t.sources,n=t.summary,r=t.footnotes,i=t.fontSize,o=void 0===i?13:i,a=(Boolean(e&&e.length)+Boolean(r&&r.length))*o*2;return pn.a.createElement("div",{className:ho,style:{height:a,boxSizing:"content-box",backgroundColor:"#FFFFFF",zIndex:10}},pn.a.createElement(yo,{sources:e,summary:n,style:{fontSize:o,lineHeight:1.5,backgroundColor:"#FFFFFF"}}),pn.a.createElement(wo,{footnotes:r,style:{fontSize:o,lineHeight:1.5,marginBottom:"".concat(.5,"em"),backgroundColor:"#FFFFFF"}}))};xo.propTypes={sources:Object(zn.arrayOf)(lo).isRequired,summary:zn.string,footnotes:Object(zn.arrayOf)(fo).isRequired,fontSize:zn.number};var Ao=xo,So={name:zn.string,agencyname:zn.string,url:zn.string},Oo={x_type:zn.string,y_type:zn.string,name:zn.string.isRequired,id:Object(zn.oneOfType)([zn.string,zn.number]).isRequired,sources:Object(zn.arrayOf)(Object(zn.shape)(So)),footnote:zn.string,meta:Object(zn.arrayOf)(Object(zn.shape)({data:zn.string,type:zn.string})),data:Object(zn.arrayOf)(Object(zn.shape)({key:zn.string.isRequired,value:zn.number})).isRequired};function Eo(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Mo(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Eo(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Eo(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Co=function(t){var e=t.title,n=t.subtitle,r=t.titleFontSize,i=t.levels,o=t.nodes,a=t.links,s=t.data,c=t.width,l=t.nodeHeight,u=void 0===l?40:l,d=t.linkHeight,h=void 0===d?55:d,p=t.levelsLabelWidth,g=t.margins,m=void 0===g?{top:20,left:0,right:0,bottom:0}:g,y=t.hideFooter,v=void 0!==y&&y,b=t.customTooltip,k=void 0===b?function(t,e,n){var r=(t.find((function(t){return t.name===e}))||{}).formattedValue;return pn.a.createElement("div",{className:to["tooltip-grid"]},r&&pn.a.createElement("div",{className:to["tooltip-row"]},pn.a.createElement("div",{className:to["tooltip-value"],style:{color:n}},r)))}:b,w=t.categoryCallback,x=void 0===w?function(){}:w,A=t.dateCallback,S=void 0===A?function(){}:A,O=t.hoverCallback,E=void 0===O?function(){}:O,C=t.tooltipStyle,R=void 0===C?{}:C,j=Ur(s),I=[i,o,a,j,c];if(f.a.some(I,f.a.isNil))return null;if(!f.a.isEmpty(function(t){var e=Bi(t,"nodes");return e.length>0?e:Di(t,"nodes")}(o))||!f.a.isEmpty(Ti(i,o))||!f.a.isEmpty(function(t,e,n){var r=Bi(t,"links");if(r.length>0)return r;var i=[];return t.forEach((function(t,n){var r=t.source,o=t.target;r&&!e.find((function(t){return t.id===r}))&&i.push("'links[".concat(n,"]' source ID not found in 'nodes': ").concat(r)),o?e.find((function(t){return t.id===o}))||i.push("'links[".concat(n,"]' target ID not found in 'nodes': ").concat(o)):i.push("'links[".concat(n,"]' has no target"))})),i.length>0||t.forEach((function(t,e){var r=t.source,o=t.target,a=t.metrics,s=-1;r&&(s=n.findIndex((function(t){return t.nodes.includes(r)})));var c=n.findIndex((function(t){return t.nodes.includes(o)}));s===c&&i.push("'links[".concat(e,"]' source and target IDs are from same sankey level: ").concat(r,"/").concat(o)),s>c&&i.push("'links[".concat(e,"]' source ID is from a higher sankey level than target ID: ").concat(r," > ").concat(o));var l=Bi(a,"metrics","links[".concat(e,"]"));l.length>0&&(i=i.concat(l))})),i}(a,o,i)))return null;var B=Ci(a),D=Mi(j);if(f.a.isEmpty(B)||f.a.isEmpty(D)||void 0===f.a.last(D))return null;var T,F=Object(hn.useState)(f.a.first(B)),P=M()(F,2),z=P[0],Q=P[1],L=Object(hn.useState)(f.a.last(D).formatted),Y=M()(L,2),W=Y[0],q=Y[1],N=Object(hn.useState)({position:{x:null,y:null},node:null}),G=M()(N,2),J=G[0],U=G[1],K=Object(hn.useMemo)((function(){return f.a.debounce((function(t){E(t.node),U(t)}),33)}),[]),H=Ri(j,i,a,o,c,u,h,z,W,p,m),V=Object(Xn.useSprings)(Object.values(H.nodes).length,Object.values(H.nodes).map((function(t){var e=t.x,n=t.y,r=t.width,i=t.height;return{x:e,y:n,width:r,height:i,label:t.label,color:t.color,textX:e+r/2,textY:n+i/2}}))),Z=Object(Xn.useSprings)(Object.values(H.links).length,Object.values(H.links).map((function(t){var e=t.color,n=t.topLeft,r=t.topRight,i=t.bottomLeft,o=t.bottomRight;return{color:e,d:"M".concat(n.x,",").concat(n.y,"L").concat(r.x,",").concat(r.y,"L").concat(o.x,",").concat(o.y,"L").concat(i.x,",").concat(i.y,"Z")}}))),X=Object(Xn.useSprings)(H.levels.length,H.levels.map((function(t){var e=t.x,n=t.y,r=t.width,i=t.height,o=t.label,a=t.title;return{width:r,label:o,title:void 0===a?"":a,labelY:i/2,levelTransform:"translate(".concat(e,",").concat(n,")")}}))),_=f()(H.nodes).map((function(t){return t.y+t.height})).max()+m.bottom,$=[{options:D,parser:function(t){return t.formatted},defaultValue:W,label:e?" ":"",onChange:function(t){var e=t.target;q(e.value),S(e.value)}},{options:B,defaultValue:z,label:" ",onChange:function(t){var e=t.target;Q(e.value),x(e.value)}}],tt=[],et=[];if(!v){var nt=go({data:j}),rt=bo({data:j});tt=nt.sources,T=nt.summary,et=rt.footnotes}return pn.a.createElement($i,{className:"vertical-sankey",title:e,subtitle:n,titleFontSize:r,dropdowns:$},pn.a.createElement("svg",{width:c,height:_},V.map((function(t,e){var n=t.x,r=t.y,i=t.width,o=t.height,a=t.label,s=t.color,c=t.textX,l=t.textY;return pn.a.createElement(Xn.animated.g,{className:"node",key:e},pn.a.createElement(Xn.animated.rect,{x:n,y:r,width:i,height:o,fill:s,onMouseOver:function(t){if(t&&t.target&&t.target.ownerSVGElement){if(H.nodes.length<=e)return;var a=H.nodes[e].id;K({position:{x:n.get()+i.get()/2,y:r.get()+o.get()},node:a})}else K({position:{x:null,y:null},node:null})},onMouseOut:function(){K({position:{x:null,y:null},node:null})}}),pn.a.createElement(Xn.animated.text,{x:c,y:l,dy:"0.35em"},a))})),Z.map((function(t,e){var n=t.color,r=t.d;return pn.a.createElement(Xn.animated.path,{className:"link",fill:n,key:e,d:r})})),X.map((function(t,e){var n=t.title,r=t.label,i=t.width,o=t.labelY,a=t.levelTransform;return pn.a.createElement(Xn.animated.g,{className:"level-labels",transform:a,key:e},""!==n.lastPosition&&pn.a.createElement(Xn.animated.g,{className:"level-title"},pn.a.createElement(Xn.animated.text,{dy:"-7px"},n),pn.a.createElement(Xn.animated.line,{x1:"0",x2:i})),pn.a.createElement(Xn.animated.text,{y:o,dy:"0.35em"},r))}))),!f.a.isNil(J.position.x)&&!f.a.isNil(J.position.y)&&pn.a.createElement(oo,mn()({},J.position,{style:R,width:c}),pn.a.createElement("div",null,pn.a.createElement("div",{className:to["tooltip-title"]},function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];if(null===t)return"";var n=e.findIndex((function(e){var n=e.nodes;return(void 0===n?[]:n).find((function(e){return e===t}))}));if(-1===n)return"";for(var r=e[n].title;n>0&&void 0===r;)r=e[--n].title;return r}(J.node,i)),pn.a.createElement("div",{className:to["tooltip-subtitle"]},function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[];if(null===t||null===e)return"";var i=n.find((function(e){return e.id===t})),o=r.find((function(e){var n=e.nodes;return(void 0===n?[]:n).find((function(e){return e===t}))})),a=i||{},s=a.label,c=void 0===s?"":s,l=o||{},u=l.label,d=void 0===u?"":u;return"".concat(d," ").concat(c,", ").concat(e)}(J.node,z,o,i)),pn.a.createElement("div",{className:to["tooltip-title"]},W),k(Ii(J.node,ji(D,W),a,j),z,f.a.find(H.nodes,(function(t){return t.id===J.node})).color,Ii(function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];if(null!==t){var n=f.a.find(e,(function(e){return e.target===t}))||{};return n.source}}(J.node,a),ji(D,W),a,j)))),!v&&pn.a.createElement(Ao,{sources:tt,summary:T,footnotes:et}))};Co.propTypes=Mo(Mo({},_i),{},{width:zn.number.isRequired,nodeHeight:zn.number,linkHeight:zn.number,levelsLabelWidth:zn.number,levels:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,title:zn.string,label:zn.string,nodes:Object(zn.arrayOf)(zn.string).isRequired})).isRequired,nodes:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string,color:zn.string})).isRequired,links:Object(zn.arrayOf)(Object(zn.shape)({source:zn.string.isRequired,target:zn.string.isRequired,metrics:Object(zn.arrayOf)(Object(zn.shape)({name:zn.string.isRequired,id:zn.string.isRequired,unit:zn.string})).isRequired})),data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,margins:Object(zn.shape)({top:zn.number,bottom:zn.number,left:zn.number,right:zn.number}),customTooltip:zn.func,categoryCallback:zn.func,dateCallback:zn.func,hoverCallback:zn.func,hideFooter:zn.bool,tooltipStyle:xi.a});var Ro=Co;function jo(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Io(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?jo(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):jo(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Bo=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.key,n=t.value,r=t.label,i=void 0===r?e:r,o=t.color,a=void 0===o?"red":o,s=arguments.length>1?arguments[1]:void 0,c=arguments.length>2?arguments[2]:void 0,l=arguments.length>3?arguments[3]:void 0,u=arguments.length>4?arguments[4]:void 0,d=arguments.length>5?arguments[5]:void 0,f=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,h=0===s?0:l*n/s;return{layout:{key:e,color:a,label:i,value:n,x:f,y:c,width:h,height:u},acc:f+h+d}},Do=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.metrics,n=void 0===e?[]:e,r=arguments.length>1?arguments[1]:void 0,i=arguments.length>2?arguments[2]:void 0,o=arguments.length>3?arguments[3]:void 0,a=n.find((function(t){return t.name===i})),s=a||{},c=s.id,l=r.find((function(t){return t.id===c})),u=l||{},d=u.data,f=void 0===d?[]:d,h=u.x_type,p=f.find((function(t){var e=t.key;return Sr(e,h).getTime()===o.getTime()}))||{},g=p.value;return g},To=function(t,e,n,r,i,o,a,s,c){var l=[],u=function(t,e){var r=Do(e,n,s,c);return isNaN(r)?t:t+r},d=f()(t).groupBy("group").mapValues((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return f.a.reduce(t,u,0)})).value(),h=f()(d).values().sum(),p=o,g=r-3*(e.length-1);return e.forEach((function(t){var e=Bo(Io(Io({},t),{},{value:d[t.key]}),h,a,g,i,3,p),n=e.layout,r=e.acc;l.push(n),p=r})),l},Fo=function(t,e,n,r,i,o){var a=[];return f()(t).groupBy("group").map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>1?arguments[1]:void 0;return{key:e,breakdown:t}})).value().forEach((function(t){var s=n.find((function(e){return e.key===t.key}));if(void 0!==s){var c=s.x,l=s.y,u=s.height,d=s.value,f=s.width,h=s.color,p=c,g=l+u+3,m=f-3*(t.breakdown.length-1);t.breakdown.forEach((function(t){var n=Do(t,e,i,o),s=Bo(Io(Io({},t),{},{value:n,color:h}),d,g,m,r,3,p),c=s.layout,l=s.acc;a.push(c),p=l}))}})),a},Po=function(t,e,n,r){return f()(e).filter((function(e){return e.group===t})).flatMap("metrics").groupBy("name").map((function(t,e){var i=f()(t).map((function(t){var e=t.id;return f.a.find(n,(function(t){var n=t.id;return e===n}))})).value(),o=f.a.map(i,"y_type"),a=f.a.first(o),s=f()(i).map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.data,n=t.x_type;return f.a.find(e,(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.key;return Sr(e,n).getTime()===r.getTime()}))})).sumBy("value");return{name:e,value:s,format:a,formattedValue:Jr({params:{format:a}})(s)}})).value()},zo=function(t,e,n,r,i){var o=(Or(n).find((function(t){var e=t.formatted;return r===e}))||{}).key;return"group"===i?Po(t,e,n,o):function(t,e,n,r){var i=f.a.find(e,(function(e){return e.key===t}));return f()(i.metrics).map((function(t){var e=t.name,i=t.id,o=f.a.find(n,(function(t){var e=t.id;return i===e}))||{},a=o.data,s=o.x_type,c=o.y_type,l=(f.a.find(a,(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.key;return Sr(e,s).getTime()===r.getTime()}))||{}).value;return{name:e,value:l,format:c,formattedValue:Jr({params:{format:c}})(l)}})).value()}(t,e,n,o)};function Qo(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Lo(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Qo(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Qo(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Yo=function(t){var e=t.title,n=t.subtitle,r=t.titleFontSize,i=t.subtitleFontSize,o=t.groupsTitle,a=t.groupsLabel,s=t.groups,c=t.breakdown,l=t.data,u=t.width,d=t.barHeight,h=void 0===d?40:d,p=t.levelsLabelWidth,g=t.margins,m=void 0===g?{top:25,left:0,right:0}:g,y=t.customTooltip,v=void 0===y?function(t,e,n){var r=(t.find((function(t){return t.name===e}))||{}).formattedValue;return pn.a.createElement("div",{className:to["tooltip-grid"]},r&&pn.a.createElement("div",{className:to["tooltip-row"]},pn.a.createElement("div",{className:to["tooltip-value"],style:{color:n}},r)))}:y,b=t.showDropdowns,k=t.tooltipDirection,w=void 0===k?"below":k,x=t.date,A=t.category,S=t.hoverCallback,E=void 0===S?function(){}:S,C=t.categoryCallback,R=void 0===C?function(){}:C,j=t.dateCallback,I=void 0===j?function(){}:j,B=t.tooltipStyle,D=void 0===B?{}:B,T=Ur(l),F=function(t){return Or(t)}(T),P=function(t){var e=f()(t).map((function(t){var e=t.metrics;return f()(e).map((function(t){return t.name})).filter((function(t){return t})).value()})).compact();return f.a.intersectionBy.apply(f.a,O()(e))}(c),z=Object(hn.useState)(f.a.first(P)),Q=M()(z,2),L=Q[0],Y=Q[1],W=Object(hn.useState)(f.a.last(F).formatted),q=M()(W,2),N=q[0],G=q[1],J=Object(hn.useState)(void 0),U=M()(J,2),K=U[0],H=U[1],V=Object(hn.useState)(void 0),Z=M()(V,2),X=Z[0],_=Z[1],$=Object(hn.useState)({position:{x:null,y:null},node:null}),tt=M()($,2),et=tt[0],nt=tt[1];x!==K&&(G(x),H(x)),A!==X&&(Y(A),_(A));var rt=function(t,e,n,r,i,o,a,s){var c=arguments.length>8&&void 0!==arguments[8]?arguments[8]:{},l=c.top,u=void 0===l?20:l,d=c.left,f=void 0===d?0:d,h=c.right,p=void 0===h?0:h,g=Or(n),m=g.find((function(t){var e=t.formatted;return a===e}))||{},y=m.key,v=s+f,b=u,k=r-v-p,w=To(t,e,n,k,i,v,b,o,y),x=Fo(t,n,w,i,o,y);return{groups:w,breakdowns:x}}(c,s,T,u,h,L,N,p,m),it=Object(Xn.useSprings)(rt.groups.length,rt.groups.map((function(t){return{x:t.x,y:t.y,width:t.width,height:t.height,label:t.label,color:t.color}}))),ot=Object(Xn.useSprings)(rt.breakdowns.length,rt.breakdowns.map((function(t){var e=t.x,n=t.y,r=t.width,i=t.height;return{x:e,y:n,width:r,height:i,label:t.label,color:t.color,key:t.key,textTransform:"translate(".concat(e+r/2,",").concat(n+i+5,") rotate(-45)")}}))),at=b?[{options:F,parser:function(t){return t.formatted},defaultValue:N,label:e?" ":"",onChange:function(t){var e=t.target;G(e.value),I(e.value)}},{options:P,defaultValue:L,label:" ",onChange:function(t){var e=t.target;Y(e.value),R(e.value)}}]:[];return pn.a.createElement($i,{className:"education-bars",title:e,subtitle:n,titleFontSize:r,subtitleFontSize:i,dropdowns:at},pn.a.createElement("div",{className:"chart-content"},pn.a.createElement("svg",{width:u,height:200},it.map((function(t,e){var n=t.x,r=t.y,i=t.width,o=t.height,a=t.color;return pn.a.createElement(Xn.animated.g,{key:s[e].key},pn.a.createElement(Xn.animated.rect,{x:n,y:r,width:i,height:o,fill:a,onMouseOver:function(){E(rt.groups[e].key),nt({position:{x:n.get()+i.get()/2,y:r.get()+("below"===w?o.get():0)},node:rt.groups[e].key,color:rt.groups[e].color,type:"group"})},onMouseOut:function(){E(null),nt({position:{x:null,y:null},node:null})}}))})),ot.map((function(t,e){var n=t.x,r=t.y,i=t.width,o=t.height,a=t.label,s=t.color,l=t.textTransform;return pn.a.createElement(Xn.animated.g,{key:c[e].key},pn.a.createElement(Xn.animated.rect,{x:n,y:r,width:i,height:o,fill:s,onMouseOver:function(){et.node!==rt.breakdowns[e].key&&E(rt.breakdowns[e].key),nt({position:{x:n.get()+i.get()/2,y:r.get()+("below"===w?o.get():0)},node:rt.breakdowns[e].key,color:rt.breakdowns[e].color,type:"breakdown"})},onMouseOut:function(){E(null),nt({position:{x:null,y:null},node:null})}}),pn.a.createElement(Xn.animated.text,{style:{pointerEvents:"none"},transform:l,fill:"black",textAnchor:"end",dy:"0.35em"},a))})),pn.a.createElement("g",{className:"level-labels",transform:"translate(".concat(m.left,",").concat(m.top,")")},pn.a.createElement("line",{stroke:"black",x1:"0",x2:u}))),it.map((function(t,e){var n=t.x,r=t.y,i=t.width,o=t.height,a=t.label;return pn.a.createElement(Xn.animated.div,{key:s[e].key,style:{position:"absolute",textAlign:"center",color:"white",display:"flex",alignItems:"center",pointerEvents:"none",justifyContent:"center",height:o,width:i,top:r,left:n}},pn.a.createElement(Xn.animated.div,null,a))})),pn.a.createElement("div",{className:"groups-title",style:{position:"absolute",bottom:"calc(100% - ".concat(m.top-5,"px)"),width:p}},o),pn.a.createElement("div",{className:"groups-label",style:{position:"absolute",top:"".concat(m.top+5,"px"),width:p}},a),null!==et.position.x&&null!==et.position.y&&pn.a.createElement(oo,mn()({direction:w},et.position,{style:D,width:u}),pn.a.createElement("div",null,pn.a.createElement("div",{className:to["tooltip-title"]},o),pn.a.createElement("div",{className:to["tooltip-subtitle"]},function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=arguments.length>1?arguments[1]:void 0,n=arguments.length>2?arguments[2]:void 0,r=arguments.length>3?arguments[3]:void 0,i=arguments.length>4?arguments[4]:void 0,o=e.find((function(e){return e.key===t})),a=n.find((function(e){return e.key===t}));if(void 0===o&&void 0===a)return"";var s=o||a||{},c=s.key,l=void 0===c?"":c,u=s.label,d=void 0===u?l:u;return"".concat(i," ").concat(d,", ").concat(r)}(et.node,s,c,L,a)),pn.a.createElement("div",{className:to["tooltip-title"]},N),v(zo(et.node,c,T,N,et.type),L,et.color,function(t,e,n,r){var i=(Or(n).find((function(t){var e=t.formatted;return r===e}))||{}).key,o=e.find((function(e){return e.key===t}));if(void 0===o)return[];var a=o.group;return Po(a,o,n,i)}(et.node,c,T,N))))))};Yo.propTypes=Lo(Lo({},_i),{},{width:zn.number.isRequired,barHeight:zn.number,levelsLabelWidth:zn.number,groupsTitle:zn.string,groupsLabel:zn.string,groups:Object(zn.arrayOf)(Object(zn.shape)({key:zn.string.isRequired,label:zn.string,color:zn.string})).isRequired,breakdown:Object(zn.arrayOf)(Object(zn.shape)({group:zn.string.isRequired,key:zn.string.isRequired,label:zn.string,metrics:Object(zn.arrayOf)(Object(zn.shape)({name:zn.string.isRequired,id:zn.string.isRequired}))})).isRequired,data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,margins:Object(zn.shape)({top:zn.number,bottom:zn.number,left:zn.number,right:zn.number}),showDropdowns:zn.bool,date:zn.string,category:zn.string,tooltipDirection:zn.string,customTooltip:zn.func,hoverCallback:zn.func,categoryCallback:zn.func,dateCallback:zn.func,tooltipStyle:xi.a});var Wo=Yo;function qo(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function No(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?qo(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):qo(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Go=[{id:"hsGrad",title:"High school",label:"Graduated?",nodes:["hsGradYes","hsGradNo"]},{id:"colEnroll",title:"College",label:"Enrolled?",nodes:["colEnroll2yrYes","colEnroll4yrYes","colEnrollNo"]},{id:"colGrad",label:"Graduated?",nodes:["colGrad2yrYes","colGrad2yrNo","colGrad4yrYes","colGrad4yrNo"]}],Jo=[{source:"",target:"hsGradYes",metrics:[{name:"All races",id:"sotu583",unit:"of all HS students"},{name:"White",id:"sotu584",unit:"of white HS students"},{name:"Black",id:"sotu585",unit:"of black HS students"},{name:"Hispanic",id:"sotu586",unit:"of hispanic HS students"},{name:"Asian",id:"sotu587",unit:"of asian HS students"}]},{source:"",target:"hsGradNo",metrics:[{name:"All races",id:"sotu588",unit:"of all HS students"},{name:"White",id:"sotu589",unit:"of white HS students"},{name:"Black",id:"sotu590",unit:"of black HS students"},{name:"Hispanic",id:"sotu591",unit:"of hispanic HS students"},{name:"Asian",id:"sotu592",unit:"of asian HS students"}]},{source:"hsGradYes",target:"colEnroll2yrYes",metrics:[{name:"All races",id:"sotu593",unit:"of all HS grads"},{name:"White",id:"sotu594",unit:"of white HS grads"},{name:"Black",id:"sotu595",unit:"of black HS grads"},{name:"Hispanic",id:"sotu596",unit:"of hispanic HS grads"},{name:"Asian",id:"sotu597",unit:"of asian HS grads"}]},{source:"hsGradYes",target:"colEnroll4yrYes",metrics:[{name:"All races",id:"sotu598",unit:"of all HS grads"},{name:"White",id:"sotu599",unit:"of white HS grads"},{name:"Black",id:"sotu600",unit:"of black HS grads"},{name:"Hispanic",id:"sotu601",unit:"of hispanic HS grads"},{name:"Asian",id:"sotu602",unit:"of asian HS grads"}]},{source:"hsGradYes",target:"colEnrollNo",metrics:[{name:"All races",id:"sotu603",unit:"of all HS grads"},{name:"White",id:"sotu604",unit:"of white HS grads"},{name:"Black",id:"sotu605",unit:"of black HS grads"},{name:"Hispanic",id:"sotu606",unit:"of hispanic HS grads"},{name:"Asian",id:"sotu607",unit:"of asian HS grads"}]},{source:"colEnroll2yrYes",target:"colGrad2yrYes",metrics:[{name:"All races",id:"sotu608",unit:"of all 2 year college students"},{name:"White",id:"sotu609",unit:"of white 2 year college students"},{name:"Black",id:"sotu610",unit:"of black 2 year college students"},{name:"Hispanic",id:"sotu611",unit:"of hispanic 2 year college students"},{name:"Asian",id:"sotu612",unit:"of asian 2 year college students"}]},{source:"colEnroll2yrYes",target:"colGrad2yrNo",color:"target",metrics:[{name:"All races",id:"sotu658",unit:"of all 2 year college students"},{name:"White",id:"sotu659",unit:"of white 2 year college students"},{name:"Black",id:"sotu660",unit:"of black 2 year college students"},{name:"Hispanic",id:"sotu661",unit:"of hispanic 2 year college students"},{name:"Asian",id:"sotu662",unit:"of asian 2 year college students"}]},{source:"colEnroll4yrYes",target:"colGrad4yrYes",metrics:[{name:"All races",id:"sotu613",unit:"of all 4 year college students"},{name:"White",id:"sotu614",unit:"of white 4 year college students"},{name:"Black",id:"sotu615",unit:"of black 4 year college students"},{name:"Hispanic",id:"sotu616",unit:"of hispanic 4 year college students"},{name:"Asian",id:"sotu617",unit:"of asian 4 year college students"}]},{source:"colEnroll4yrYes",target:"colGrad4yrNo",color:"target",metrics:[{name:"All races",id:"sotu663",unit:"of all 4 year college students"},{name:"White",id:"sotu664",unit:"of white 4 year college students"},{name:"Black",id:"sotu665",unit:"of black 4 year college students"},{name:"Hispanic",id:"sotu666",unit:"of hispanic 4 year college students"},{name:"Asian",id:"sotu667",unit:"of asian 4 year college students"}]}],Uo=[{id:"hsGradYes",label:"Yes",color:"#249EDC"},{id:"hsGradNo",label:"No",color:"#7EB6CE"},{id:"colEnroll2yrYes",label:"2 yr",color:"#082D51"},{id:"colEnroll4yrYes",label:"4 yr",color:"#082D51"},{id:"colEnrollNo",label:"No",color:"#249EDC"},{id:"colGrad2yrYes",label:"Yes",color:"#082D51"},{id:"colGrad2yrNo",label:"No",color:"#249EDC"},{id:"colGrad4yrYes",label:"Yes",color:"#082D51"},{id:"colGrad4yrNo",label:"No",color:"#249EDC"}],Ko=f.a.map(Uo,(function(t){return No(No({},t),{},{label:"colGrad2yrYes"===t.id?"Y":t.label})})),Ho=[{key:"college",label:"College",color:"#082D51"},{key:"hsgrad",label:"HS Grad",color:"#249EDC"},{key:"dnf",label:"No HS",color:"#7EB6CE"}],Vo=[{group:"college",key:"Advanced",label:"Advanced degrees",metrics:[{name:"All races",id:"sotu633"},{name:"White",id:"sotu634"},{name:"Black",id:"sotu635"},{name:"Hispanic",id:"sotu636"},{name:"Asian",id:"sotu637"}]},{group:"college",key:"Bachelors",metrics:[{name:"All races",id:"sotu638"},{name:"White",id:"sotu639"},{name:"Black",id:"sotu640"},{name:"Hispanic",id:"sotu641"},{name:"Asian",id:"sotu642"}]},{group:"college",key:"Associates",metrics:[{name:"All races",id:"sotu643"},{name:"White",id:"sotu644"},{name:"Black",id:"sotu645"},{name:"Hispanic",id:"sotu646"},{name:"Asian",id:"sotu647"}]},{group:"hsgrad",key:"somecollege",label:"Some college",metrics:[{name:"All races",id:"sotu648"},{name:"White",id:"sotu649"},{name:"Black",id:"sotu650"},{name:"Hispanic",id:"sotu651"},{name:"Asian",id:"sotu652"}]},{group:"hsgrad",key:"grad",label:"HS grad",metrics:[{name:"All races",id:"sotu653"},{name:"White",id:"sotu654"},{name:"Black",id:"sotu655"},{name:"Hispanic",id:"sotu656"},{name:"Asian",id:"sotu657"}]},{group:"dnf",key:"dnfhs",label:"No HS",metrics:[{name:"All races",id:"sotu628"},{name:"White",id:"sotu629"},{name:"Black",id:"sotu630"},{name:"Hispanic",id:"sotu631"},{name:"Asian",id:"sotu632"}]}];function Zo(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Xo(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Zo(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Zo(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var _o={"All races":" of individuals 25+",White:" of white 25+",Black:" of black 25+",Hispanic:" of hispanic 25+",Asian:" of asian 25+"},$o={hsGradNo:"Some individuals do not finish high school, others do not enroll",colGrad4yrNo:"Those who don't complete college often do so due to affordability and debt"},ta=function(t){var e=t.titleFontSize,n=void 0===e?14:e,r=t.title,i=void 0===r?"US educational attainment":r,o=t.subtitle,a=t.width,s=Object(hn.useState)(!1),c=M()(s,2),l=c[0],u=c[1],d=Object(hn.useState)(!1),h=M()(d,2),p=h[0],g=h[1],m=Object(hn.useState)(!1),y=M()(m,2),v=y[0],b=y[1],k=Object(hn.useState)(null),w=M()(k,2),x=w[0],A=w[1],S=Object(hn.useState)(null),E=M()(S,2),C=E[0],R=E[1],j=Object(hn.useState)(null),I=M()(j,2),B=I[0],D=I[1],T=Object(hn.useState)(null),F=M()(T,2),P=F[0],z=F[1],Q=Object(hn.useState)(f.a.first(Ci(Jo))),L=M()(Q,2),Y=L[0],W=L[1],q=Object(hn.useState)(null),N=M()(q,2),G=N[0],J=N[1],U=Object(hn.useState)(null),K=M()(U,2),H=K[0],V=K[1],Z=G?["hsGradNo","colGrad4yrNo"]:[];Object(hn.useEffect)((function(){var t=f()(Jo).flatMap("metrics").map("id").value(),e=f()(Vo).flatMap("metrics").map("id").value(),n="https://sotu.usafacts.org/api/v1/metrics?Ids=".concat(O()(new Set([].concat(O()(t),O()(e)))).join(","));window.fetch(n).then((function(t){return t.json()})).catch((function(t){z("Could not fetch: ".concat(t.toString())),R("Could not fetch: ".concat(t.toString()))})).then((function(n){var r=n.filter((function(e){var n=e.id;return t.includes(n)})),i=n.filter((function(t){var n=t.id;return e.includes(n)}));r?(A(r),J(f.a.last(Mi(r)).formatted)):R("Unable to load Sankey. Checks IDs: ".concat(t.join(","))),i?D(i):z("Unable to load Attainments. Check IDs: ".concat(e.join(",")))})).finally((function(){return b(!0)}))}),[]);var X=f.a.concat(Ur(x),Ur(B)),_=go({data:X}),$=_.sources,tt=_.summary,et=bo({data:X}).footnotes,nt=x&&x.length&&B&&B.length;return pn.a.createElement("div",{className:Ln},!v&&!nt&&pn.a.createElement(ki,null),v&&!nt&&pn.a.createElement("div",null,pn.a.createElement("div",null,"Unable to load data"),P&&pn.a.createElement("div",null,P),C&&pn.a.createElement("div",null,C)),v&&nt&&pn.a.createElement(Pn,{handleWidth:!0},(function(t){var e=t.width,r=void 0===e?a:e;if(!r)return pn.a.createElement("div",null);var s=r<500?Ko:Uo,c=Ri(x,Go,Jo,Ko,r,30,50,Y,G,100),d=Z.map((function(t){return function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.height,r=t.width,i=t.x,o=t.y;if(f.a.isFinite(e)&&f.a.isFinite(r)&&f.a.isFinite(i)&&f.a.isFinite(o)){var a=9;return{left:i+r/2,top:o+e+a+1.25*n}}return{left:0,top:0}}(f.a.find(c.nodes,(function(e){return e.id===t})))}));return pn.a.createElement("div",{className:"charts-container"},pn.a.createElement("div",{className:"".concat(Yn," ").concat(p?Nn:""),style:{marginBottom:20}},pn.a.createElement(Ro,{hideFooter:!0,data:x,levels:Go,nodes:s,links:Jo,linkHeight:50,title:i,subtitle:o,titleFontSize:n,width:r,nodeHeight:30,levelsLabelWidth:100,dateCallback:function(t){J(t)},categoryCallback:function(t){W(t)},hoverCallback:function(t){u(null!==t)},customTooltip:function(t,e,n,r){return pn.a.createElement(vi,{values:t,category:e,color:n,parentValues:r})},tooltipStyle:{width:"90%",maxWidth:500}}),d.map((function(t,e){return pn.a.createElement(mr,mn()({key:Z[e]},t,{onMouseOver:function(){V(Xo({node:Z[e]},t))},onMouseOut:function(){V(null)}}))}))),pn.a.createElement("div",{className:"".concat(Wn," ").concat(l?Nn:"")},pn.a.createElement("div",{className:qn,style:{left:100,marginBottom:20}},"Individuals may later graduate college or high school (GED)"),pn.a.createElement(Wo,{width:r,levelsLabelWidth:100,hoverCallback:function(t){g(null!==t)},customTooltip:function(t,e,n){return pn.a.createElement(vi,{values:t.map((function(t){return Xo(Xo({},t),{},{unit:_o[t.name]})})),category:e,color:n})},data:B,margins:{top:30,left:0},barHeight:30,groups:Ho,breakdown:Vo,tooltipDirection:"above",groupsTitle:"Maximum attainment",groupsLabel:"All individuals 25+",date:G,category:Y})),H&&pn.a.createElement("div",{className:Jn},pn.a.createElement(oo,{x:H.left,y:H.top+20,width:r},pn.a.createElement("div",null,$o[H.node]))),pn.a.createElement(Ao,{sources:$,summary:tt,footnotes:et}))})))};ta.propTypes=Xo(Xo({},_i),{},{width:zn.number});var ea=ta,na={"bar-chart":"_1mRr-kGDzN9_TCZypBP0Ot","bar-chart-wrapper":"_3a1EOXi9OLDn4XgTN9NexC"},ra=Object(R.createCanvas)(0,0).getContext("2d"),ia=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Yr;if(f.a.isNil(t))return 0;ra.font="".concat(e,"px ").concat(n);var r=ra.measureText(t),i=r.actualBoundingBoxLeft,o=r.actualBoundingBoxRight,a=r.fontBoundingBoxAscent,s=r.fontBoundingBoxDescent;return{width:i+o,height:a+s}},oa={"chart-wrapper":"_1QTZw6Lo8lGUZhRc29n607","chart-title":"_2fh_7kwfqrh-9tQptKRiFp","chart-subtitle":"_23QvBpkCsPkhPNjtE9Uejk","title-text":"_24tcVFWMa_vc7GWmQ8vYxG","chart-content":"_1vcjAq2eawolxeCGFJ6zXh"};function aa(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function sa(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?aa(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):aa(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function ca(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return t?f.a.isFunction(t)?t.apply(void 0,O()(e)):t:null}var la=function(t){var e=t.children,n=t.slotAboveChart,r=t.slotBelowChart,i=t.title,o=void 0===i?"":i,a=t.subtitle,s=void 0===a?"":a,c=t.titleFontSize,l=void 0===c?20:c,u=t.subtitleFontSize,d=void 0===u?16:u,f=t.footerSources,h=void 0===f?[]:f,p=t.footerSummary,g=t.footnotes,m=void 0===g?[]:g,y=t.showFooter,v=void 0===y||y,b=t.width,k=t.height,w=void 0===k?"auto":k,x=t.fontSize,A=void 0===x?13:x,S=t.className,O=void 0===S?"":S,E=t.style,M=void 0===E?{}:E,C=t.dropdowns,R=void 0===C?[]:C,j=t.onMouseLeave,I=void 0===j?function(){}:j,B="auto"===w;return pn.a.createElement("div",{className:"".concat(oa["chart-wrapper"]," ").concat(O),style:sa(sa({},M),{},{width:b||null,height:w,fontSize:A})},(o||0!==R.length)&&pn.a.createElement("div",{className:oa["chart-title"],style:{fontSize:l}},o&&pn.a.createElement("span",{className:"title-text"},o),0!==R.length&&pn.a.createElement("span",{className:oa["dropdown-container"]},R.map((function(t){return pn.a.createElement(Hi,mn()({key:JSON.stringify(t)},t))})))),s&&pn.a.createElement("div",{className:oa["chart-subtitle"],style:{fontSize:d}},s),pn.a.createElement("div",{className:oa["chart-content"]},ca(n),pn.a.createElement(Pn,{handleHeight:!0,handleWidth:!0},(function(t){var n=t.height,r=void 0===n?w:n,i=t.width,o=void 0===i?b:i,a=B||r;return pn.a.createElement("div",{style:{flex:1,display:"flex"},onMouseLeave:I,onBlur:function(){}},a&&o?ca(e,[{chartWidth:o,chartHeight:r}]):null)})),ca(r,[])),v&&pn.a.createElement(Ao,{sources:h,summary:p,footnotes:m,fontSize:A}))},ua={children:Object(zn.oneOfType)([zn.node,zn.func]),slotLegend:Object(zn.oneOfType)([zn.node,zn.func]),title:zn.string,subtitle:zn.string,titleFontSize:zn.number,subtitleFontSize:zn.number,footerSources:Object(zn.arrayOf)(lo),footerSummary:zn.string,footnotes:Object(zn.arrayOf)(fo),showFooter:zn.bool,width:zn.number,height:Object(zn.oneOfType)([zn.number,zn.string]),fontSize:zn.number,transitionDuration:zn.number,className:zn.string,style:zn.object,dropdowns:Object(zn.arrayOf)(Object(zn.shape)({options:zn.array.isRequired,color:zn.string,label:zn.string,value:Object(zn.oneOfType)([zn.string,zn.number]),defaultValue:zn.string,parser:zn.func,onChange:zn.func.isRequired})),onMouseLeave:zn.func};la.propTypes=sa({},ua);var da=["config","delay","immediate"];function fa(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function ha(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?fa(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):fa(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var pa=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=Object(hn.useState)(!0),i=M()(r,2),o=i[0],a=i[1],s=n||{},c=s.config,l=s.delay,u=void 0===l?0:l,d=s.immediate,f=void 0!==d&&d,h=w()(s,da),p=c||{},g=p.easing,m=p.duration,y=void 0===m?0:m;Object(hn.useEffect)((function(){a(!1)}),[]);var v=ha(ha({},h||{}),{},{config:ha(ha({},c||{}),{},{easing:o?void 0:g,duration:o?0:y}),keys:e,delay:o?0:u,immediate:!!o||f});return Object(Xn.useTransition)(t,v)};function ga(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function ma(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ga(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ga(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var ya=f.a.keyBy(["top","right","bottom","left"]),va=function(t){var e=t.position,n=t.chartWidth,r=t.chartHeight,o=t.ticks,a=t.formatter,s=void 0===a?function(t){return t}:a,c=t.fontSize,l=void 0===c?13:c,d=t.fontWeight,f=void 0===d?400:d,h=t.opacity,p=void 0===h?1:h,g=t.textColor,m=void 0===g?"#4D4D4D":g,y=t.transitionDuration,v=void 0===y?250:y,b=t.onClick,k=void 0===b?function(){}:b,w=t.onMouseOver,x=void 0===w?function(){}:w,A=t.onMouseOut,S=void 0===A?function(){}:A,E=t.transitionControllers,M=void 0===E?{}:E,R=e===ya.top,j=e===ya.bottom,I=e===ya.left,B=R||j,D=!B,T="end";B&&(T="middle");var F="auto";D?F="middle":R&&(F="hanging");var P=Ji(m,"#4D4D4D"),z=Object(hn.useRef)(o.map((function(t){return t.data}))),Q=Math.max.apply(Math,O()(z.current.map((function(t){var e=t.data;return ia(s(e,{ticks:z.current})).width})))),L=pa(o.map((function(t,e){var i,o="number"==typeof(i=t.data)?i:i instanceof Date?i.getTime():void 0,a=n;B?a=t.point:I&&(a=Q);var s=r;return D?s=t.point:R&&(s=0),ma(ma({},void 0!==o?{label:o}:{}),{},{key:void 0!==o?o:e,x:a,y:s,fontSize:l,fontWeight:f,fill:P,opacity:p})})),(function(t){return t.key}),{config:{easing:C.easeQuad,duration:v},initial:function(t){return ma(ma({},t),{},{opacity:t.opacity})},from:function(t){return ma(ma({},t),{},{opacity:0})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(ma(ma({},t),{},{opacity:t.opacity}),n,r,M.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(ma(ma({},t),{},{opacity:0}),n,r,M.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(ma(ma({},t),{},{opacity:t.opacity}),n,r,M.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",{className:"".concat(e,"-axis-component")},L((function(t,e,n,r){return o[r]&&(z.current[r]=o[r].data),t&&pn.a.createElement(Xn.animated.text,{key:e.key,className:"axis-component-label",textAnchor:T,dominantBaseline:F,opacity:t.opacity,fontSize:t.fontSize,fontWeight:t.fontWeight,fill:t.fill,x:t.x,y:t.y,onMouseOver:function(t){return x(t,r)},onMouseOut:function(t){return S(t,r)},onClick:function(t){return k(t,r)}},t.label?t.label.to((function(t){return s(t,{ticks:z.current})})):s(z.current[r],{ticks:z.current}))})))};va.propTypes={position:Object(zn.oneOf)(f.a.values(ya)).isRequired,chartWidth:zn.number.isRequired,chartHeight:zn.number.isRequired,ticks:Object(zn.arrayOf)(Object(zn.shape)({data:Object(zn.oneOfType)([zn.string,zn.number,zn.object]),point:zn.number})).isRequired,formatter:zn.func,fontSize:zn.number,fontWeight:zn.number,opacity:zn.number,textColor:zn.string,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var ba=va,ka=f.a.pick(ya,[ya.top,ya.bottom]),wa={color:void 0,height:17,negativeColor:void 0},xa={enabled:!0,selectedItem:void 0,show:!0,type:void 0},Aa={fontSize:13,footnotes:void 0,show:!0,showMetricFootnotes:!0,sources:void 0},Sa={fontSize:16,text:void 0},Oa={fontSize:20,text:void 0},Ea={decimals:void 0,position:"below",show:!0,showSubtitle:!0},Ma={decimals:void 0,displayRangeMin:void 0,displayRangeMax:void 0,displayTicks:void 0,floatingAxis:void 0,fontSize:13,type:void 0,showGridlines:void 0,ticks:void 0,textColor:"#4D4D4D"},Ca={maxLines:1,maxWidth:void 0,color:"#4D4D4D",fontSize:13,showValueLabels:!0,valueLabelDecimals:void 0};function Ra(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function ja(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Ra(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Ra(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Ia(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}function Ba(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Da(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Ba(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Ba(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Ta=function(t){var e=t.bars,n=void 0===e?[]:e,r=t.transitionDuration,o=void 0===r?250:r,a=t.transitionControllers,s=void 0===a?{}:a,c=t.onMouseOver,l=void 0===c?function(){}:c,d=t.onMouseOut,h=void 0===d?function(){}:d,p=t.onClick,g=void 0===p?function(){}:p,m=n.map((function(t,e){var n=t.width||0,r=t.x||0;return n<0&&(r+=n),{key:t.key||e,width:n,height:t.height||0,x:r,y:t.y||0,color:Ni[t.color]||t.color||Gi[0],opacity:1,forceRedraw:f.a.uniqueId()}})),y=pa(m.map((function(t){return t})),(function(t){return t.key}),{config:{easing:Ia,duration:o},initial:function(t){return t},from:function(t){return Da(Da({},t),{},{width:0,opacity:0,forceRedraw:f.a.uniqueId()})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(Da(Da({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,s.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(Da(Da({},t),{},{width:0,opacity:0}),n,r,s.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(Da(Da({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,s.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",null,y((function(t,e,n,r){var i=t.x,o=t.y,a=t.width,s=t.height,c=t.color,u=t.opacity;return f.a.keys(t).length&&pn.a.createElement(Xn.animated.g,{key:e.key,onMouseOver:function(t){return l(t,r,e)},onMouseOut:function(t){return h(t,r,e)},onClick:function(t){return g(t,r,e)}},pn.a.createElement(Xn.animated.rect,{x:i,y:o,width:a.to((function(t){return Math.abs(t)})),height:s,style:{fill:c,opacity:u}}))})))};Ta.propTypes={bars:Object(zn.arrayOf)(Object(zn.shape)({key:Object(zn.oneOfType)([zn.string,zn.number]),height:zn.number.isRequired,width:zn.number.isRequired,color:zn.string,x:zn.number,y:zn.number})).isRequired,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var Fa=Ta,Pa=function(t){var e=t.fontSize,n=void 0===e?13:e,r=t.fontFamily,i=void 0===r?Yr:r,o=t.maxWidth,a=void 0===o?200:o,s=t.maxLines,c=void 0===s?3:s,l=t.dominantBaseline,u=void 0===l?"auto":l,d=t.label,f=void 0===d?"":d,h=function(t){return ia(t,n,i).width},p=f.split(" ");if(0!==p.length){if(h(p[0])>a)return function(t){for(var e=t.split(" ")[0];h("".concat(e,"..."))>a;){if(0===e.length)return pn.a.createElement("tspan",null);e=e.substring(0,e.length-1)}return[pn.a.createElement("tspan",{key:0,dx:0,dy:0},"".concat(e,"..."))]}(f);var g=function(t){var e=Array.apply(null,Array(c)).map((function(){if(!t)return"";var e=t.shift();if(h(e)>a)return t="","...";for(;h("".concat(e," ").concat(t[0]))<=a&&0!==t.length;)e+=" ".concat(t.shift());return e})).filter((function(t){return void 0!==t}));return t.length>0&&function(t){for(var e=t[t.length-1];h("".concat(e,"..."))>a&&""!==(e=e.substring(0,e.lastIndexOf(" "))););t[t.length-1]="".concat(e,"...")}(e),e}(p);return pn.a.createElement(pn.a.Fragment,null,function(t){var e=ia(t[0],n,i).height||n;return t.map((function(n,r){var i=e;if(0===r)switch(u){case"auto":i=-(t.length-r-1)*e;break;case"middle":i=(r+.5-t.length/2)*e;break;case"hanging":i=r*e;break;default:i=(t.length-r-1)*e}return pn.a.createElement("tspan",{key:r,dy:i,dx:0===r?0:-h(t[r-1])},n)}))}(g))}};Pa.propTypes={label:zn.string.isRequired,fontSize:zn.number,fontFamily:zn.string,maxWidth:zn.number,maxLines:zn.number,dominantBaseline:zn.string};var za=Pa,Qa=["gridColor","opacity","strokeCap","strokeDasharray","strokeWidth"];function La(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Ya(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?La(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):La(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Wa=f.a.keyBy(["horizontal","vertical"]),qa=function(t){var e=t.gridColor,n=t.onClick,r=void 0===n?function(){}:n,o=t.onMouseOut,a=void 0===o?function(){}:o,s=t.onMouseOver,c=void 0===s?function(){}:s,l=t.orientation,d=t.range,f=t.strokeWidth,h=void 0===f?1:f,p=t.ticks,g=t.transitionControllers,m=void 0===g?{}:g,y=t.transitionDuration,v=void 0===y?250:y,b=l===Wa.horizontal,k=M()(d,2),w=k[0],x=k[1],A=Ji(e,"#E6E6E6"),S=pa(p.map((function(t,e){var n=t.strokeWidth||h,r="0 0";return"dot"===t.strokeStyle?r="1 ".concat(2*n):"dash"===t.strokeStyle&&(r="".concat(2*n," ").concat(2*n)),Ya(Ya({key:e},b?{x1:w,x2:x,y1:t.point,y2:t.point}:{x1:t.point,x2:t.point,y1:w,y2:x}),{},{gridColor:Ji(t.gridColor,A),strokeCap:t.strokeCap,strokeDasharray:r,strokeWidth:n,opacity:1})})),(function(t){return t.key}),{config:{easing:C.easeQuad,duration:v},initial:function(t){return t},from:function(t){return Ya(Ya({},t),{},{width:0,opacity:0})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,m.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(Ya(Ya({},t),{},{width:0,opacity:0}),n,r,m.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,m.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",{className:"gridlines ".concat(l,"-gridlines")},S((function(t,e){var n=t.gridColor,i=t.strokeCap,o=t.strokeWidth,s=t.strokeDasharray,l=t.x1,u=t.x2,d=t.y1,f=t.y2,h=t.opacity;return pn.a.createElement(Ga,{key:e.key,gridColor:n,strokeCap:i,strokeDasharray:s,strokeWidth:o,x1:l,x2:u,y1:d,y2:f,opacity:h,onMouseOver:function(t){return c(t,e)},onMouseOut:function(t){return a(t,e)},onClick:function(t){return r(t,e)}})})))};qa.propTypes={gridColor:zn.string,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,orientation:Object(zn.oneOf)(f.a.values(Wa)).isRequired,range:function(t,e,n){if(2!==t[e].length)return new Error("Invalid array length ".concat(t[e].length," (expected 2) for prop ").concat(e," supplied to ").concat(n,". Validation failed."))},strokeWidth:zn.number,ticks:Object(zn.arrayOf)(Object(zn.shape)({gridColor:zn.string,point:zn.number.isRequired,strokeCap:Object(zn.oneOf)(["butt","round","square"]),strokeStyle:Object(zn.oneOf)(["solid","dot","dash"]),strokeWidth:zn.number})).isRequired,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func}),transitionDuration:zn.number};var Na=qa,Ga=function(t){var e=t.gridColor,n=t.opacity,r=void 0===n?1:n,i=t.strokeCap,o=t.strokeDasharray,a=t.strokeWidth,s=void 0===a?1:a,c=w()(t,Qa),l=Ya(Ya({},c.x1&&c.x2?f.a.pick(c,["x1","x2"]):{}),c.y1&&c.y2?f.a.pick(c,["y1","y2"]):{});return pn.a.createElement(Xn.animated.line,mn()({className:"gridline",stroke:e,strokeLinecap:i,strokeDasharray:o,strokeWidth:s,opacity:r},l))};function Ja(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Ua(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Ja(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Ja(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}Ga.propTypes={gridColor:zn.object,opacity:zn.object,strokeCap:zn.object,strokeDasharray:zn.object,strokeWidth:zn.object,style:zn.object,x1:zn.object,x2:zn.object,y1:zn.object,y2:zn.object};var Ka=function(t){var e=t.labels,n=void 0===e?[]:e,r=t.onClick,o=void 0===r?function(){}:r,a=t.onMouseOver,s=void 0===a?function(){}:a,c=t.onMouseOut,l=void 0===c?function(){}:c,d=t.formatter,h=void 0===d?function(t,e){return e}:d,p=t.transitionDuration,g=void 0===p?250:p,m=t.transitionControllers,y=void 0===m?{}:m,v=function(t,e,r){var i=n[r].style?n[r].style[t]:null;return f.a.isNil(i)?e:i},b=n.map((function(t,e){var n=t.style&&(Ni[t.style.fill]||t.style.fill)||Gi[0],r=v("opacity",1,e),i=v("fontSize",13,e),o=v("fontWeight",100,e),a=v("letterSpacing",0,e);return{key:t.key||e,x:t.x||0,y:t.y||0,opacity:r,fontSize:i,fill:n,fontWeight:o,letterSpacing:a,forceRedraw:f.a.uniqueId(),content:Number.isNaN(parseFloat(t.content))?0:parseFloat(t.content)}})),k=Object(hn.useRef)(n.map((function(t){return t.style}))),w=pa(b.map((function(t){return Ua(Ua({},t),{},{opacity:t.opacity})})),(function(t){return t.key}),{config:{easing:C.easeQuad,duration:g},initial:function(t){return t},from:function(t){return Ua(Ua({},t),{},{opacity:0})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,y.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(Ua(Ua({},t),{},{opacity:0}),n,r,y.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,y.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",{className:"labels"},w((function(t,e,r,i){return n[i]&&(k.current[i]=n[i].style),f.a.keys(t).length&&pn.a.createElement(Xn.animated.text,{key:e.key,textAnchor:"start",x:t.x,y:t.y,style:Ua(Ua({},k.current[i]),{},{opacity:t.opacity,fontSize:t.fontSize,fill:t.fill,fontWeight:t.fontWeight,letterSpacing:t.letterSpacing}),onMouseOver:function(t){return s(t,i)},onMouseOut:function(t){return l(t,i)},onClick:function(t){return o(t,i)}},n[i]&&h(t.content,n[i].content,n[i].key))})))};Ka.propTypes={labels:Object(zn.arrayOf)(Object(zn.shape)({content:zn.node,x:zn.number,y:zn.number,key:Object(zn.oneOfType)([zn.string,zn.number]),style:zn.object})).isRequired,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,formatter:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var Ha=Ka,Va=function(t){var e=t.title,n=t.subtitle,r=t.color,i=t.value,o=t.annotation,a=t.decimals,s=t.type;return pn.a.createElement(pn.a.Fragment,null,e&&pn.a.createElement("div",{className:to["tooltip-title"],style:{color:r}},e),n&&pn.a.createElement("div",{className:to["tooltip-subtitle"]},n),pn.a.createElement("div",{className:to["tooltip-grid"]},pn.a.createElement("div",{className:to["tooltip-row"]},pn.a.createElement("div",{className:to["tooltip-value"],style:{color:r}},function(t,e,n){return null==t||Number.isNaN(t)?"No Data":e?Jr({params:{format:n}})(t,{decimals:e}):Jr({params:{format:n,basic:!0}})(t)}(i,a,s))),o&&pn.a.createElement(pn.a.Fragment,null,o.title&&pn.a.createElement("div",{className:to["tooltip-row"]},pn.a.createElement("div",{className:to["tooltip-annotation-title"]},o.title)),o.text&&pn.a.createElement("div",{className:to["tooltip-row"]},pn.a.createElement("div",{className:to["tooltip-annotation-text"]},o.text)))))};Va.propTypes={title:zn.node,subtitle:zn.node,value:zn.node,color:zn.string,annotation:Object(zn.shape)({title:zn.string,text:zn.string}),decimals:zn.number,type:zn.string};var Za=Va;function Xa(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function _a(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Xa(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Xa(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var $a=f()(Qr).omit(["default"]).keys().value(),ts=function(t){var e=t.barOptions,n=void 0===e?wa:e,r=t.data,o=t.dataSeriesOptions,a=void 0===o?[]:o,s=t.dropdownOptions,c=void 0===s?xa:s,l=t.featuredPosition,d=t.footerOptions,h=void 0===d?Aa:d,p=t.labelOptions,g=void 0===p?Ca:p,m=t.sort,y=void 0===m?"descending":m,v=t.subtitleOptions,b=void 0===v?Sa:v,k=t.titleOptions,w=void 0===k?Oa:k,x=t.tooltipOptions,A=void 0===x?Ea:x,S=t.transitionDuration,E=void 0===S?250:S,C=t.width,R=t.xAxisOptions,j=void 0===R?Ma:R;if(!r||!r.length)return null;var I=f.a.defaultsDeep({},n,wa),B=f.a.defaultsDeep({},c,xa),D=f.a.defaultsDeep({},h,Aa),T=f.a.defaultsDeep({},b,Sa),F=f.a.defaultsDeep({},w,Oa),P=f.a.defaultsDeep({},A,Ea),z=f.a.defaultsDeep({},j,Ma),Q=f.a.defaultsDeep({},g,Ca),L=Object(hn.useMemo)((function(){var t=Ur(r),e=function(t,e){var n=e.color,r=e.negativeColor;return t.map((function(t){return{id:t.id,color:Ji(t.color||n,Gi[0]),negativeColor:Ji(t.negativeColor||r,Gi[1]),featured:Boolean(t.featured),labelText:t.labelText,tooltipTitle:t.tooltipTitle}}))}(oi(t,a),{color:I.color,negativeColor:I.negativeColor});return{data:ai(t,e,["name","x_type","y_type","sources","meta"]).map((function(t){return _a(_a({},t),{},{sources:t.sources||[],name:t.metric.labelText||t.name,tooltipTitle:t.metric.tooltipTitle||t.name})})),dataSeriesOptions:e}}),[r,a,I]).data,Y=Zr(z.type)?z.type:Xr(L,"y")||"linear",W=Zr(B.type)?B.type:Xr(L,"x")||"items",q=Jr({params:{format:Y}}),N=Jr({params:{format:W}}),G=Hr(L,Sr).map((function(t){return _a(_a({},t),{},{parsed:N(t.key)})})),J=Object(hn.useState)(null),U=M()(J,2),K=U[0],H=U[1],V=Object(hn.useState)(!!G.length&&f.a.last(G).key),Z=M()(V,2),X=Z[0],_=Z[1];Object(hn.useEffect)((function(){var t=f.a.find(G,{key:B.selectedItem});t&&_(t.key)}),[B.selectedItem,G]);var $=function(t){var e,n=t.type,r=t.values,i=t.customDomain,o=void 0===i?[void 0,void 0]:i,a=t.customTicks,s=void 0===a?void 0:a,c=[f.a.min([].concat(O()(r),[0])),f.a.max([].concat(O()(r),[0]))],l=$r(c,[]);if(o){var u=_r("y",n,o);l=$r(u,c)}var d=ei(n,l);return s&&(e=_r("y",n,s),void 0===o[0]&&void 0===o[1]?d=ei(n,l=[Math.min(c[0],e[0]),Math.max(c[1],e[e.length-1])]):e=e.filter((function(t){return t>=l[0]&&t<=l[1]}))),e=ti({axisType:"y",scale:d,customTicks:e}),{domain:l,ticks:e,scale:d.nice()}}({type:Y,values:L.flatMap((function(t){return t.data})).filter((function(t){var e=t.key;return!z.floatingAxis||e===X})).map((function(t){return t.value})),customDomain:[z.displayRangeMin,z.displayRangeMax],customTicks:z.ticks}),tt=$.ticks,et=$.scale,nt=et.domain()[1]<=0,rt=!nt&&et.domain()[0]<0&&et.domain()[1]>0,it=.33*I.height,ot=f.a.min([Q.maxWidth,f.a.max(O()(L.map((function(t){return ia(t.name,Q.fontSize).width}))))]),at=z.displayTicks&&!Q.showValueLabels?ia(z.formatter?z.formatter(f.a.last(tt)):q(f.a.last(tt),f.a.isNil(z.decimals)?{ticks:tt}:{decimals:z.decimals}),z.fontSize).width/2:0,st=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=f()(t).map((function(t){return ja(ja({},t),{},{data:f.a.find(t.data,{key:e})})}));return r&&(i=i.orderBy([function(t){return f.a.get(t,"data.value",0)}],["ascending"===r?"asc":"desc"])),n&&(i=i.orderBy([function(t){return t.metric.featured}],["bottom"===n?"asc":"desc"])),i.value()}(L,X,l,y),ct=function(t){var e=t.barFontSize,n=t.barHeight,r=t.barSpacing,i=t.data,o=t.initialY,a=void 0===o?0:o,s=t.textColor,c=[],l=[];return i.forEach((function(t,i,o){var u=t.id,d=t.name,f=t.data,h=t.metric,p=h.color,g=h.negativeColor,m=h.featured,y=f&&f.value>0,v={fill:s,opacity:1,fontSize:e,fontWeight:400},b=i*(n+r)+l.length*(2+r)+a;i>0&&o[i-1].metric.featured!==m&&(l.push({height:2,color:"#999999",y:b}),b+=2+r);var k=b+n/2+e/4;c.push({data:o[i],label:{key:u,content:d,y:k,style:v},bar:{key:u,height:n,color:y?p:g,y:b},value:{key:u,content:f?f.value:null,y:k,style:v}})})),{segments:c,spacers:l}}({barFontSize:Q.fontSize,barHeight:I.height,barSpacing:it,data:st,initialY:f.a.includes(z.displayTicks,ka.top)?1.2*z.fontSize:0,textColor:Ji(Q.color,"#4D4D4D"),xTicks:tt}),lt=ct.segments,ut=ct.spacers,dt=f.a.includes(z.displayTicks,ka.top)?1.2*z.fontSize:0,ft=f.a.includes(z.displayTicks,ka.bottom)?1.2*z.fontSize:0,ht=f.a.last(lt.map((function(t){return t.bar}))),pt=ht.y+ht.height,gt=dt+pt+ft,mt=Math.max.apply(Math,O()(st.map((function(t){return ia(q(t.data?t.data.value:"NO DATA",f.a.isNil(Q.valueLabelDecimals)?{}:{decimals:Q.valueLabelDecimals}),Q.fontSize).width})))),yt=[];G.length&&(yt=B.enabled?G.map((function(t){return t.key})).sort((function(t,e){return t<e?-1:1})):[f.a.find(G,{key:X}).key]);var vt=B.show&&yt.length?[{options:yt,parser:N,label:F.text?" ":"",value:X?f.a.find(G,{key:X}).parsed:"",onChange:function(t){var e=t.target.value;_(f.a.find(G,{parsed:e}).key)}}]:[],bt=D.show?go({data:L,chartSources:D.sources}):{sources:[],summary:""},kt=bt.sources,wt=bt.summary,xt=(D.show?bo({data:L,chartFootnotes:D.footnotes,showMetricFootnotes:D.showMetricFootnotes}):{footnotes:[]}).footnotes;function At(){H(null)}return pn.a.createElement(la,{className:na["bar-chart"],title:F.text,subtitle:T.text,titleFontSize:F.fontSize,subtitleFontSize:T.fontSize,footerSources:kt,footerSummary:wt,footnotes:xt,showFooter:D.show,showMetricFootnotes:D.showMetricFootnotes,dropdowns:vt,width:C,height:"auto",fontSize:D.fontSize,onMouseLeave:At},(function(t){var e=t.chartWidth;et.range([ot+10+((rt||nt)&&Q.showValueLabels?mt:10),e-(!rt&&nt||!Q.showValueLabels?0:mt)-at]);var n,r,o,a=function(t){var e=t.segments,n=t.spacers,r=t.xScale,i=t.chartWidth,o=t.maxValueWidth,a=t.valuesCrossZero,s=t.valuesAllNegative,c=a?r(0):0;return{spacers:n.map((function(t){return ja(ja({},t),{},{width:i,x:0})})),segments:e.map((function(t){var e=0,n=r.range()[0],i=r.range()[0]+10;if(t.data.data){var l=t.data.data.value,u=r(l),d=l>0;if(i+=e=u-c-r.range()[0],s){e=u-c-r.range()[1];var f=r.range();n=M()(f,2)[1],i=r.range()[1]-Math.abs(e)-10-o}else a&&(e=u-c,n=c,i=d?c+Math.abs(e)+10:c-Math.abs(e)-10-o)}return{label:ja(ja({},t.label),{},{x:0}),bar:ja(ja({},t.bar),{},{width:e,x:n}),value:ja(ja({},t.value),{},{x:i})}}))}}({segments:lt,spacers:ut,xScale:et,chartWidth:e,maxValueWidth:Q.showValueLabels?mt:0,valuesCrossZero:rt,valuesAllNegative:nt}),s=a.segments,c=a.spacers,l=s.map((function(t){return t.label})),d=s.map((function(t){return t.bar})),h=s.map((function(t){return t.value}));function p(t,e){var n=d[e],r=st[e];r&&n&&H({position:{x:n.x+n.width/2,y:n.y+n.height/2+20},value:r.data.value,direction:P.position,title:r.tooltipTitle||r.name,color:r.data&&r.data.value<0?r.metric.negativeColor:r.metric.color,label:r.data?N(r.data.key):"",type:r.y_type})}return pn.a.createElement("div",{style:{position:"relative"},className:na["bar-chart-wrapper"]},pn.a.createElement("svg",{style:{overflow:"visible",height:"".concat(gt,"px"),flex:1},className:na["bar-chart-svg"]},f.a.includes(z.displayTicks,ka.top)&&pn.a.createElement(ba,{position:ka.top,chartWidth:e,chartHeight:pt+dt,fontSize:z.fontSize,textColor:Ji(z.textColor,"#4D4D4D"),ticks:tt.map((function(t){return{data:t,point:et(t)}})),formatter:z.formatter?z.formatter:function(t){return q(t,f.a.isNil(z.decimals)?{ticks:tt}:{decimals:z.decimals})},transitionDuration:E}),f.a.includes(z.displayTicks,ka.bottom)&&pn.a.createElement(ba,{position:ka.bottom,chartWidth:e,chartHeight:pt+ft,fontSize:z.fontSize,textColor:Ji(z.textColor,"#4D4D4D"),ticks:tt.map((function(t){return{data:t,point:et(t)}})),formatter:z.formatter?z.formatter:function(t){return q(t,f.a.isNil(z.decimals)?{ticks:tt}:{decimals:z.decimals})},transitionDuration:E}),(z.showGridlines||rt)&&pn.a.createElement(Na,{orientation:Wa.vertical,range:[dt,pt],strokeWidth:1,gridColor:"#E6E6E6",ticks:tt.filter((function(t){return z.showGridlines||0===t})).map((function(t){return{point:et(t),strokeWidth:rt&&0===t&&z.showGridlines?3:1}})),transitionDuration:E}),pn.a.createElement(Ha,{labels:l.map((function(t){return _a(_a({},t),{},{content:pn.a.createElement(za,{dominantBaseline:"hanging",label:t.content,fontSize:t.style.fontSize,maxWidth:ot,maxLines:Q.maxLines})})})),transitionDuration:E,transitionControllers:{update:(o=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=["x"],t.next=3,n(f.a.pick(e,r));case 3:return t.next=5,n(f.a.omit(e,r));case 5:case"end":return t.stop()}}),t)}))),function(t,e){return o.apply(this,arguments)})},onMouseOver:p,onMouseOut:At}),pn.a.createElement(Fa,{bars:d,transitionDuration:E,transitionControllers:{update:(r=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=["width","color","x"],t.next=3,n(f.a.pick(e,r));case 3:return t.next=5,n(f.a.omit(e,r));case 5:case"end":return t.stop()}}),t)}))),function(t,e){return r.apply(this,arguments)})},onMouseOver:p,onMouseOut:At}),c.length>0&&pn.a.createElement(Fa,{bars:c}),Q.showValueLabels&&pn.a.createElement(Ha,{labels:h,transitionDuration:E,transitionControllers:{update:(n=i()(u.a.mark((function t(e,n){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,n({x:e.x,index:e.index,content:e.content});case 2:return t.next=4,n(f.a.omit(e,["x","index","content"]));case 4:case"end":return t.stop()}}),t)}))),function(t,e){return n.apply(this,arguments)})},formatter:function(t,e){var n=function(t){return q(t,f.a.isNil(Q.valueLabelDecimals)?{}:{decimals:Q.valueLabelDecimals})};return null!==e?t.to(n):"no data"},onMouseOver:p,onMouseOut:At})),P.show&&K&&pn.a.createElement("div",{className:na["tooltip-container"]},pn.a.createElement(oo,{direction:K.direction,x:K.position.x,y:K.position.y,width:e},pn.a.createElement(Za,{title:K.title,subtitle:P.showSubtitle?K.label:void 0,value:K.value,color:K.color,decimals:P.decimals,type:K.type}))))}))};ts.propTypes=_a(_a({},ua),{},{barOptions:Object(zn.shape)({color:zn.string,height:zn.number,negativeColor:zn.string}),data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({id:Object(zn.oneOfType)([zn.string,zn.number]).isRequired,color:zn.string,featured:zn.bool,labelText:zn.string,tooltipTitle:zn.string})),featuredPosition:Object(zn.oneOf)(["top","bottom"]),dropdownOptions:Object(zn.shape)({enabled:zn.bool,selectedItem:Object(zn.oneOfType)([zn.string,zn.number]),show:zn.bool,type:Object(zn.oneOf)($a)}),footerOptions:Object(zn.shape)({fontSize:zn.number,footnotes:ua.footnotes,show:ua.showFooter,showMetricFootnotes:zn.bool,sources:ua.footerSources}),labelOptions:Object(zn.shape)({maxWidth:zn.number,maxLines:zn.number,color:zn.string,fontSize:zn.number,showValueLabels:zn.bool,valueLabelDecimals:zn.number}),sort:Object(zn.oneOf)(["ascending","descending",!1]),subtitleOptions:Object(zn.shape)({fontSize:ua.subtitleFontSize,text:ua.subtitle}),titleOptions:Object(zn.shape)({fontSize:ua.titleFontSize,text:ua.title}),tooltipOptions:Object(zn.shape)({decimals:zn.number,position:Object(zn.oneOf)(ro),show:zn.bool,showSubtitle:zn.bool}),transitionDuration:zn.number,width:zn.number,xAxisOptions:Object(zn.shape)({decimals:zn.number,displayRangeMax:Object(zn.oneOfType)([zn.number,zn.string]),displayRangeMin:Object(zn.oneOfType)([zn.number,zn.string]),displayTicks:Object(zn.arrayOf)(Object(zn.oneOf)(f.a.values(ka))),floatingAxis:zn.bool,fontSize:zn.number,formatter:zn.func,showGridlines:zn.bool,ticks:Object(zn.arrayOf)(Object(zn.oneOfType)([zn.number,zn.string])),type:Object(zn.oneOf)($a),textColor:zn.string})});var es=ts,ns="_1Hn2csosJUSqzwGJ8UU0SL",rs="_2LztrTObNPXfGwnXd7zfaK",is="_3gFCwi6qMnrFhu4jv9DkcJ",os="_9XNNaChkqI6CGWUy9Ef6Y",as="_15ivKgtMYH1VjfMyscoRYe",ss="_213lsOu0lgclhwUGRxgJzM",cs="_16CAUtx0Z6zXg0on5EMus2",ls="_3569D8lAQdjdSrN7ztotSE",us="P15y3XYFJR6qoZHpfBMpQ",ds=f.a.fill(f.a.range(6),Yi.gray),fs={strokeWidth:2,strokeColor:"#FFFFFF",onMouseOver:function(){},onClick:function(){},onMouseOut:function(){}};function hs(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function ps(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?hs(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):hs(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var gs=f()(Qr).omit(["default"]).keys().value(),ms=function(t){var e=t.colorScale,n=void 0===e?ds:e,r=t.bulletsOpacity,o=void 0===r?.3:r,a=t.max,s=t.min,c=t.currentValue,l=t.fontSize,d=void 0===l?13:l,h=t.fontColor,p=void 0===h?"#4D4D4D":h,g=t.type,m=void 0===g?"default":g,y=t.transitionDuration,v=void 0===y?250:y,b=t.transitionControllers,k=void 0===b?{}:b,w=t.indicatorOptions,x=void 0===w?fs:w;if(!n||n.length<1||void 0===s||void 0===a||!Qr[m])return null;var A=Qr[m],S=f.a.defaultsDeep({},x,{radius:8},fs);S.strokeColor=Ji(S.strokeColor,"#FFFFFF");var O=(a-s)/n.length,E=Math.floor((c-s)/O),M=((c-s)/(a-s)*100).toFixed(2),R={left:"calc(".concat(M,"% - ").concat(8,"px)")};c<=s?E=0:a<=c&&(E=n.length-1);var j=n[E],I=A(s),B=A(a),D=A(c),T=null,F={right:"calc(100% - ".concat(ia(I,d).width,"px)")},P={left:"calc(100% - ".concat(ia(B,d).width,"px)")};0==E?I===D?T="left":R={right:"calc(100% - ".concat(ia(I,d).width,"px)"),transform:"translateX(100%)",paddingLeft:"6px"}:E===n.length-1&&(B===D?T="right":R={left:"calc(100% - ".concat(ia(B,d).width,"px)"),transform:"translateX(-100%)",paddingRight:"6px"});var z=pa(n.map((function(t,e){return{color:t,key:e,opacity:o}})),(function(t){return t.key}),{config:{easing:C.easeQuad,duration:v},order:["leave","update","enter"],initial:function(t){return t},from:function(t){return ps(ps({},t),{},{opacity:0})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,k.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(ps(ps({},t),{},{opacity:0}),n,r,k.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,k.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement(Xn.animated.div,{className:ns},pn.a.createElement(Xn.animated.div,{className:rs,style:{fontSize:"".concat(d,"px"),color:Ji(p,"#4D4D4D"),height:ia(I,d).height}},pn.a.createElement(Xn.animated.div,{className:"".concat(is," ").concat(as," ").concat("left"===T?os:""),style:F},A(s)),!T&&pn.a.createElement(Xn.animated.div,{className:"".concat(is," ").concat(os),style:R},A(c)),pn.a.createElement(Xn.animated.div,{className:"".concat(is," ").concat(ss," ").concat("right"===T?os:""),style:P},A(a))),pn.a.createElement(Xn.animated.div,{className:cs},z((function(t,e){var n=t.color,r=t.opacity;return pn.a.createElement(Xn.animated.div,{key:e.key,className:us,style:{opacity:r,backgroundColor:n,height:10}})})),pn.a.createElement(Xn.animated.div,{className:ls,style:{width:"".concat(2*S.radius,"px"),height:"".concat(2*S.radius,"px"),backgroundColor:"".concat(j),left:"calc(".concat(M,"% - 7px)"),borderWidth:"".concat(S.strokeWidth,"px"),borderColor:"".concat(S.strokeColor)}})))};ms.propTypes={colorScale:Object(zn.arrayOf)(zn.string),bulletsOpacity:zn.number,currentValue:zn.number.isRequired,min:zn.number.isRequired,max:zn.number.isRequired,fontSize:zn.number,fontColor:zn.string,type:Object(zn.oneOf)(gs),transitionDuration:zn.number,transitionControllers:Object(zn.shape)({from:zn.func,enter:zn.func,leave:zn.func,update:zn.func}),indicatorOptions:Object(zn.shape)({strokeWidth:zn.number,strokeColor:zn.string,onMouseOver:zn.func,onClick:zn.func,onMouseOut:zn.func})};var ys=n(23),vs=n.n(ys),bs=[{abbr:"AK",name:"Alaska",fips:"02"},{abbr:"ME",name:"Maine",fips:"23"},{abbr:"VT",name:"Vermont",fips:"50"},{abbr:"NH",name:"New Hampshire",fips:"33"},{abbr:"WA",name:"Washington",fips:"53"},{abbr:"MT",name:"Montana",fips:"30"},{abbr:"ND",name:"North Dakota",fips:"38"},{abbr:"MN",name:"Minnesota",fips:"27"},{abbr:"WI",name:"Wisconsin",fips:"55"},{abbr:"MI",name:"Michigan",fips:"26"},{abbr:"NY",name:"New York",fips:"36"},{abbr:"MA",name:"Massachusetts",fips:"25"},{abbr:"RI",name:"Rhode Island",fips:"44"},{abbr:"ID",name:"Idaho",fips:"16"},{abbr:"WY",name:"Wyoming",fips:"56"},{abbr:"SD",name:"South Dakota",fips:"46"},{abbr:"IA",name:"Iowa",fips:"19"},{abbr:"IL",name:"Illinois",fips:"17"},{abbr:"IN",name:"Indiana",fips:"18"},{abbr:"OH",name:"Ohio",fips:"39"},{abbr:"PA",name:"Pennsylvania",fips:"42"},{abbr:"NJ",name:"New Jersey",fips:"34"},{abbr:"CT",name:"Connecticut",fips:"09"},{abbr:"OR",name:"Oregon",fips:"41"},{abbr:"NV",name:"Nevada",fips:"32"},{abbr:"CO",name:"Colorado",fips:"08"},{abbr:"NE",name:"Nebraska",fips:"31"},{abbr:"MO",name:"Missouri",fips:"29"},{abbr:"KY",name:"Kentucky",fips:"21"},{abbr:"WV",name:"West Virginia",fips:"54"},{abbr:"VA",name:"Virginia",fips:"51"},{abbr:"MD",name:"Maryland",fips:"24"},{abbr:"DE",name:"Delaware",fips:"10"},{abbr:"CA",name:"California",fips:"06"},{abbr:"UT",name:"Utah",fips:"49"},{abbr:"NM",name:"New Mexico",fips:"35"},{abbr:"KS",name:"Kansas",fips:"20"},{abbr:"AR",name:"Arkansas",fips:"05"},{abbr:"TN",name:"Tennessee",fips:"47"},{abbr:"NC",name:"North Carolina",fips:"37"},{abbr:"SC",name:"South Carolina",fips:"45"},{abbr:"DC",name:"Washington, DC",fips:"11"},{abbr:"AZ",name:"Arizona",fips:"04"},{abbr:"OK",name:"Oklahoma",fips:"40"},{abbr:"LA",name:"Louisiana",fips:"22"},{abbr:"MS",name:"Mississippi",fips:"28"},{abbr:"AL",name:"Alabama",fips:"01"},{abbr:"GA",name:"Georgia",fips:"13"},{abbr:"HI",name:"Hawaii",fips:"15"},{abbr:"TX",name:"Texas",fips:"48"},{abbr:"FL",name:"Florida",fips:"12"}],ks=[[1,0,0,0,0,0,1,0,0,0,0,1],[0,0,0,0,0,0,0,0,0,1,1,0],[0,1,1,1,1,1,0,1,0,1,1,1],[0,1,1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,1,1,0,0,0],[1,0,0,0,1,0,0,1,0,0,0,0]],ws=[bs[0],{abbr:"US",name:"US",fips:"US"}].concat(O()(bs.slice(1))),xs={},As=function(t){var e=t.data,n=void 0===e?[]:e,r=t.strokeWidth,o=void 0===r?2:r,a=t.fontColor,s=void 0===a?"#212121":a,c=t.fontSize,l=void 0===c?12:c,d=t.fontWeight,h=void 0===d?600:d,p=t.spacing,g=void 0===p?4:p,m=t.backgroundColor,y=void 0===m?"usa-gray":m,v=t.strokeColor,b=void 0===v?y:v,k=t.width,w=void 0===k?500:k,x=t.showUSA,A=void 0!==x&&x,S=t.makeUSABigger,O=void 0===S||S,E=t.transitionDuration,R=void 0===E?250:E,j=t.onMouseOver,I=void 0===j?function(){}:j,B=t.onMouseOut,D=void 0===B?function(){}:B,T=t.onClick,F=void 0===T?function(){}:T,P=t.transitionControllers,z=void 0===P?{}:P;if(0===w)return null;var Q,L=w/ks[0].length,Y=1.1547*L,W=f.a.isNumber(o)?o:2,q=f.a.chain((Q=ks,f()(Q).flatMap((function(t,e){return t.map((function(t,n){return t?[e,n]:null}))})).filter((function(t){return t})).value().map((function(t,e){var n=M()(t,2);return{i:n[0],j:n[1],properties:ws[e]}})))).map((function(t){var e=f.a.chain(n).filter({fips:t.properties.fips}).first().value(),r=t.j*L+(t.i%2>0?L/2:0),i=t.i*Y-.288675*t.i*Y,o=f.a.min([f.a.get(e,"strokeWidth",W),.4*(L-g)]),a=r+g/2+o/2,c=i+g/2+o/2,u=L-g-o,d=Y-g-o;"US"===t.properties.fips&&O&&(a-=(1.6*u-u)/2,u*=1.6,d*=1.6);var p=[[a+u/2,c],[a+u,c+.288675*d],[a+u,c+.711325*d],[a+u/2,c+d],[a,c+.711325*d],[a,c+.288675*d]],m=[a+u/2,c+d/2];return{fips:t.properties.fips,hexStrokeWidth:o,hexagon:{points:p.flat(),strokeWidth:o,stroke:Ji(f.a.get(e,"strokeColor",b),Ni["usa-gray"]),fill:Ji(f.a.get(e,"backgroundColor",y),Ni["usa-gray"])},label:{x:m[0],y:m[1]+.35*l,text:t.properties.abbr,fontSize:f.a.get(e,"fontSize",l),fill:Ji(f.a.get(e,"fontColor",s),"#212121"),fontWeight:f.a.get(e,"fontWeight",h)},opacity:1}})).orderBy(["hexagon.stroke"],["desc"]).value(),N=pa(q.filter((function(t){return!(!1===A&&"US"===t.fips)})),(function(t){return t.fips}),{config:{easing:C.easeQuad,duration:R},initial:function(t){var e=t.hexagon,n=e.strokeWidth,r=e.fill,i=e.stroke,o=e.points,a=t.label;return{points:o,hexFill:r,hexStrokeWidth:n,hexStroke:i,labelFill:a.fill,labelFontSize:a.fontSize,labelFontWeight:a.fontWeight,x:a.x,y:a.y,opacity:t.opacity}},from:function(t){var e=t.hexagon,n=e.strokeWidth,r=e.fill,i=e.stroke,o=e.points,a=t.label;return{points:o,hexFill:r,hexStrokeWidth:n,hexStroke:i,labelFill:a.fill,labelFontSize:a.fontSize,labelFontWeight:a.fontWeight,x:a.x,y:a.y,opacity:0}},enter:function(t){var e=t.hexagon,n=e.strokeWidth,r=e.fill,o=e.stroke,a=e.points,s=t.label,c=s.fill,l=s.fontSize,d=s.fontWeight,f=s.x,h=s.y,p=t.opacity;return function(){var t=i()(u.a.mark((function t(e,i){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ri({points:a,hexFill:r,hexStrokeWidth:n,hexStroke:o,labelFill:c,labelFontSize:l,labelFontWeight:d,x:f,y:h,opacity:p},e,i,z.enter);case 2:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}()},leave:function(t){var e=t.hexagon,n=e.strokeWidth,r=e.fill,o=e.stroke,a=e.points,s=t.label,c=s.fill,l=s.fontSize,d=s.fontWeight,f=s.x,h=s.y;return function(){var t=i()(u.a.mark((function t(e,i){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ri({points:a,hexFill:r,hexStrokeWidth:n,hexStroke:o,labelFill:c,labelFontSize:l,labelFontWeight:d,x:f,y:h,opacity:0},e,i,z.leave);case 2:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}()},update:function(t){var e=t.hexagon,n=e.strokeWidth,r=e.fill,o=e.stroke,a=e.points,s=t.label,c=s.fill,l=s.fontSize,d=s.fontWeight,f=s.x,h=s.y,p=t.opacity;return function(){var t=i()(u.a.mark((function t(e,i){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ri({points:a,hexFill:r,hexStrokeWidth:n,hexStroke:o,labelFill:c,labelFontSize:l,labelFontWeight:d,x:f,y:h,opacity:p},e,i,z.update);case 2:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}()}});return pn.a.createElement(Xn.animated.g,{className:xs["cartogram-component"]},N((function(t,e){var n=t.points,r=t.hexFill,i=t.hexStrokeWidth,o=t.hexStroke,a=t.labelFill,s=t.labelFontSize,c=t.labelFontWeight,l=t.x,u=t.y;return pn.a.createElement(Xn.animated.g,{className:xs["cartogram-hex-".concat(e.fips)],key:e.fips},pn.a.createElement(Xn.animated.polygon,{className:xs.hexagon,fill:r,stroke:o,strokeWidth:i,points:n,onMouseOver:function(t){return I(t,e.fips)},onMouseOut:function(t){return D(t,e.fips)},onClick:function(t){return F(t,e.fips)}}),pn.a.createElement(Xn.animated.text,{className:xs["hex-label"],textAnchor:"middle",fill:a,x:l,y:u,fontWeight:c,fontSize:s,style:{pointerEvents:"none"}},e.label.text))})))};As.propTypes={data:Object(zn.arrayOf)(Object(zn.shape)({strokeColor:zn.string,strokeWidth:zn.number,backgroundColor:zn.string,fips:zn.string.isRequired,fontColor:zn.string,fontSize:zn.number,fontWeight:zn.number})),strokeColor:zn.string,backgroundColor:zn.string,strokeWidth:zn.number,fontColor:zn.string,fontSize:zn.number,fontWeight:zn.number,spacing:zn.number,width:zn.number,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func}),showUSA:zn.bool,makeUSABigger:zn.bool};var Ss=As;function Os(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Es(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Os(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Os(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Ms=function(t){var e=t.colorScale,n=void 0===e?Wi["yellow-teal-9-bin"]:e,r=t.values,o=void 0===r?[]:r,a=t.fontSize,s=void 0===a?13:a,c=t.fontColor,l=t.width,d=void 0===l?300:l,h=t.height,p=void 0===h?10:h,g=t.x,m=t.y,y=t.formatter,v=void 0===y?function(t){return t}:y,b=t.transitionDuration,k=void 0===b?250:b,w=t.showNoData,x=void 0!==w&&w,A=t.noDataColor,S=void 0===A?"usa-gray":A,O=t.onClick,E=void 0===O?function(){}:O,M=t.onMouseOver,R=void 0===M?function(){}:M,j=t.onMouseMove,I=void 0===j?function(){}:j,B=t.onMouseOut,D=void 0===B?function(){}:B,T=t.transitionControllers,F=void 0===T?{}:T;if(o.length<2||n.length<1||void 0===g||void 0===m)return null;var P=f.a.sortBy(o).slice(0,n.length+1),z=P[0],Q=P[P.length-1],L=Ji(c,"#4D4D4D"),Y=Math.min(n.length&&P.length-1),W=x?ia("NO DATA",s,Yr).width+s/1.5:0,q=x?(d-W)/(Y+1):0,N=g+W+q,G=d-W-q,J=P.map((function(t){return{data:t,point:N+G*(t-z)/(Q-z)}})),U=P.map((function(t,e){if(e<n.length&&e<P.length-1){var r=N+G*(t-z)/(Q-z),i=N+G*(P[e+1]-z)/(Q-z);return{key:e,value:t,color:Ji(n[e],"usa-gray"),x1:r,x2:i,y:m,opacity:1,height:p}}})).filter((function(t){return void 0!==t})),K=x?[{x:g,y:m+.35*s,content:"NO DATA",style:{fontSize:s,fill:L,fontWeight:400}}]:void 0;x&&U.unshift({value:"",color:Ji(S,"usa-gray"),x1:g+W,x2:g+W+q/2,y:m,opacity:1,height:p,key:"no data"});var H=pa(U.map((function(t){return Es({},t)})),(function(t){return t.key}),{config:{easing:C.easeQuad,duration:k},order:["leave","update","enter"],initial:function(t){return t},from:function(t){return Es(Es({},t),{},{opacity:0,x1:g+d,x2:g+d})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,F.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(Es(Es({},t),{},{opacity:0,x1:g+d,x2:g+d}),n,r,F.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,F.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",{className:"scale"},K&&pn.a.createElement(Ha,{labels:K,transitionDuration:k}),H((function(t,e){var n=t.x1,r=t.x2,i=t.color,o=t.y,a=t.height;return pn.a.createElement(Xn.animated.line,{key:e.key,stroke:i,strokeWidth:a,x1:n,x2:r,y1:o,y2:o,onMouseOver:function(t){return R(t,e)},onMouseMove:function(t){return I(t,e)},onMouseOut:function(t){return D(t,e)},onClick:function(t){return E(t,e)}})})),pn.a.createElement(ba,{position:"bottom",chartHeight:m-p/2-s/1.5,chartWidth:d,ticks:J,formatter:v,fontSize:s,textColor:L,transitionDuration:k}))};Ms.propTypes={colorScale:Object(zn.arrayOf)(zn.string).isRequired,values:Object(zn.arrayOf)(zn.number).isRequired,fontSize:zn.number,fontColor:zn.string,width:zn.number,height:zn.number,x:zn.number.isRequired,y:zn.number.isRequired,formatter:zn.func,transitionDuration:zn.number,showNoData:zn.bool,noDataColor:zn.string,onClick:zn.func,onMouseOver:zn.func,onMouseMove:zn.func,onMouseOut:zn.func,transitionControllers:Object(zn.shape)({from:zn.func,enter:zn.func,leave:zn.func,update:zn.func})};var Cs=Ms,Rs=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:100;if(t.length<2||"number"!=typeof e||"number"!=typeof n)return[];if(n<=e)return[];var r=(n-e)/t;return Array.apply(null,Array(t+1)).map((function(t,n){return e+r*n}))},js=function(t,e,n){if(null==t)return Ji("usa-gray");var r=Math.min(e.length-2,n.length-1),i=Math.max(Math.min(e.filter((function(e){return t>e})).length-1,r),0);return Ji(n[i],"usa-gray")},Is=function(t,e,n){if(null==t)return Ji("usa-gray");var r=js(t,e,n),i=n.indexOf(r);return 2*i==e.length-2?"#212121":2*i<e.length-1?n[0]:n[e.length-2]},Bs={fontSize:13,footnotes:void 0,show:!0,showMetricFootnotes:!0,sources:void 0},Ds={color:void 0,scrubberColor:"usa-gray",showVerticalLines:!1,showHorizontalLines:!0,showVerticalScrubber:!1,showHorizontalScrubber:!1,style:void 0},Ts={fontSize:13,show:void 0,width:150},Fs={show:void 0,fontSize:13},Ps={fontSize:16,text:void 0},zs={fontSize:20,text:void 0},Qs={color:void 0,decimals:void 0,show:!0,showMarker:!1,showSubtitle:!0},Ls={displayRangeMin:void 0,displayRangeMax:void 0,displayTicks:["bottom"],labelPadding:10,textColor:void 0,ticks:void 0,type:void 0,fontSize:13},Ys={displayRangeMin:void 0,displayRangeMax:void 0,displayTicks:["left"],labelPadding:10,textColor:void 0,ticks:void 0,type:void 0,fontSize:13},Ws={dataSeriesOptions:{color:"black",endMarker:!0,annotations:[]},footerOptions:{show:!1},gridLineOptions:{showVerticalLines:!1,showHorizontalLines:!1,showVerticalScrubber:!1,showHorizontalScrubber:!1},labelOptions:{show:!1},legendOptions:{show:!1},subtitleOptions:{text:""},titleOptions:{text:""},tooltipOptions:{show:!1,showMarker:!1},xAxisOptions:{displayTicks:[]},yAxisOptions:{displayTicks:[]}},qs={text:"",fontSize:20},Ns={text:"",fontSize:16},Gs={show:!0,showSubtitle:!0,color:"scale-darkest",decimals:void 0},Js=qi["teal-9-bin"],Us={colorScale:Js,reverseColorOrder:!1,fontColor:void 0,width:void 0,height:10,x:void 0,y:void 0,values:[],centeredScale:!1,floatingScale:!1,fontSize:13},Ks={enabled:!0,selectedItem:void 0,show:!0,type:void 0},Hs={fontSize:13,footnotes:void 0,show:!0,sources:void 0};function Vs(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Zs(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Vs(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Vs(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Xs=function(t){var e=t.titleOptions,n=void 0===e?qs:e,r=t.subtitleOptions,i=void 0===r?Ns:r,o=t.data,a=t.dataSeriesOptions,s=void 0===a?[]:a,c=t.footerOptions,l=void 0===c?Hs:c,u=t.width,d=t.hexLabelFontSize,h=void 0===d?14:d,p=t.fontWeight,g=void 0===p?400:p,m=t.backgroundColor,y=void 0===m?"usa-gray":m,v=t.transitionDuration,b=void 0===v?250:v,k=t.tooltipOptions,w=void 0===k?Gs:k,x=t.scaleOptions,A=void 0===x?Us:x,S=t.keyType,E=t.strokeColor,R=t.strokeWidth,j=void 0===R?2:R,I=t.spacing,B=void 0===I?4:I,D=t.showUSA,T=void 0!==D&&D,F=t.makeUSABigger,P=void 0===F||F,z=t.dropdownOptions,Q=void 0===z?Ks:z;if(!o||!o.datasets||!o.datasets.length)return null;var L=Kr(o);if(!L.datasets)return null;var Y=oi(L.datasets,s,"geo_id"),W=T?[].concat(O()(bs.map((function(t){return t.fips}))),["US"]):bs.map((function(t){return t.fips}));L.datasets=L.datasets.filter((function(t){var e=t.geo_id;return W.includes(e)}));var q=n||{},N=q.text,G=q.fontSize,J=void 0===G?20:G,U=i||{},K=U.text,H=U.fontSize,V=void 0===H?16:H,Z=w.show,X=void 0===Z||Z,_=w.showSubtitle,$=void 0===_||_,tt=w.color,et=void 0===tt?"scale-darkest":tt,nt=w.decimals,rt=A.colorScale,it=void 0===rt?Js:rt,ot=A.reverseColorOrder,at=void 0!==ot&&ot,st=A.fontColor,ct=A.width,lt=A.height,ut=void 0===lt?10:lt,dt=A.x,ft=A.y,ht=A.values,pt=void 0===ht?[]:ht,gt=A.centeredScale,mt=void 0!==gt&&gt,yt=A.floatingScale,vt=void 0!==yt&&yt,bt=A.fontSize,kt=void 0===bt?13:bt,wt=Q||{},xt=wt.enabled,At=void 0===xt||xt,St=wt.selectedItem,Ot=wt.show,Et=void 0===Ot||Ot,Mt=wt.type,Ct=l||{},Rt=Ct.sources,jt=Ct.footnotes,It=Ct.show,Bt=void 0===It||It,Dt=Ct.fontSize,Tt=void 0===Dt?13:Dt,Ft=it.slice().map((function(t,e){return Ji(t,Js[e%Js.length])}));Array.isArray(Ji(it[0],void 0))&&(Ft=Ji(it[0],void 0)),at&&Ft.reverse();var Pt,zt=Zr(S)?S:(Pt=L.datasets[0].y_type,Zr(Pt)?Pt:"linear"),Qt=Jr({params:{format:zt}}),Lt=Zr(Mt)?Mt:Xr(L.datasets,"x");Lt||(Lt="unformatted");var Yt=Jr({params:{format:Lt}}),Wt=f()(L.datasets).map((function(t){return t.data.map((function(t){var e=t.key,n=t.x_type;return{key:e,formatted:Sr(e,n)}}))})).flatMap().uniqBy((function(t){return t.key})).sortBy((function(t){return t.formatted})).map((function(t){return Zs(Zs({},t),{},{parsed:Yt(t.key)})})).value(),qt=f.a.find(Wt,{key:St}),Nt=Object(hn.useState)(qt?qt.key:f.a.last(Wt).key||null),Gt=M()(Nt,2),Jt=Gt[0],Ut=Gt[1],Kt=L.datasets.map((function(t){return t.data.map((function(t){var e=t.value,n=t.key;if(!vt||n===Jt)return e}))})).flat().filter((function(t){return void 0!==t})),Ht=W.some((function(t){var e=L.datasets.find((function(e){return e.geo_id===t}));return!e||!e.data||Wt.some((function(t){var n=t.key;if(!vt||n===Jt){var r=e.data.find((function(t){return t.key===n}));if(!r||!r.value)return!0}return!1}))})),Vt=Math.max.apply(Math,O()(Kt.map((function(t){return Math.abs(t)})))),Zt=mt?Vt:Math.max.apply(Math,O()(Kt)),Xt=mt?-Vt:Math.min.apply(Math,O()(Kt)),_t=pt.length>1?pt:Rs(Ft.length,Xt,Zt),$t=L.datasets.map((function(t){var e=t.geo_id,n=t.data,r=(n.filter((function(t){return t.key===Jt}))[0]?n.filter((function(t){return t.key===Jt}))[0]:{}).value,i=js(r,_t,Ft),o=f.a.find(Y,{geo_id:e})||{},a=o.strokeColor,s=o.strokeWidth;return{fips:e||"00",backgroundColor:i,fontColor:vs()(i).isDark()?"#FFFFFF":"#212121",strokeColor:Ji(a,E||i),strokeWidth:s||j}})),te=[];Wt.length&&(te=At?Wt.map((function(t){return t.key})):[f.a.find(Wt,{key:Jt}).parsed]);var ee=Et&&te.length?[{options:te,parser:Yt,label:N?" ":"",defaultValue:Jt?f.a.find(Wt,{key:Jt}).key:"",onChange:function(t){var e=t.target.value;Ut(f.a.find(Wt,{parsed:e}).key)}}]:[],ne=Object(hn.useState)({position:{x:null,y:null},value:void 0,title:"",subtitle:"",color:"usa-gray",type:zt}),re=M()(ne,2),ie=re[0],oe=re[1],ae=function(t,e){if(t){var n=L.datasets.filter((function(t){return t.geo_id===e}))[0],r=n&&n.data.filter((function(t){return t.key===Jt}))[0]?n.data.filter((function(t){return t.key===Jt}))[0].value:null,i=null,o=null;t.target&&"polygon"===t.target.nodeName&&t.target.points&&(Array.from(t.target.points).forEach((function(t){var e=t.x,n=t.y;i+=e,o+=n})),i/=t.target.points.length,o/=t.target.points.length);var a=(f.a.find(Y,{geo_id:e})||{}).tooltipTitle;oe({position:{x:i||ie.position.x||0,y:o||ie.position.y||0},value:null!=r?r:null,title:a||(s=e,"US"===s?"US":bs[bs.findIndex((function(t){return t.fips===s}))].name),subtitle:Yt(Jt)||Jt,color:function(){var t,e,n=et||"scale-darkest";if(null==r)return Ji("usa-gray");switch(n){case"scale-min":return Ft[0];case"scale-max":return Ft[_t.length-2];case"scale-extents":return Is(r,_t,Ft);case"scale-darkest":return e=(t=Ft).map((function(t){return Object(C.hsl)(t).l})),t[e.indexOf(Math.min.apply(Math,O()(e)))];default:return Ji(n,"usa-gray")}}(),type:n&&Zr(n.y_type)?n.y_type:zt})}else oe({position:{x:null,y:null},value:void 0,title:"",subtitle:"",color:"usa-gray",type:zt});var s},se=[L],ce=Bt?go({data:se,chartSources:Rt}):{sources:[],summary:""},le=ce.sources,ue=ce.summary,de=(Bt?bo({dataArray:se,chartFootnotes:jt}):{footnotes:[]}).footnotes;return pn.a.createElement(la,{className:"cartogram-chart",title:N,subtitle:K,titleFontSize:J,subtitleFontSize:V,footerSources:le,footerSummary:ue,footnotes:de,showFooter:Bt,dropdowns:ee,width:u,fontSize:Tt,onMouseLeave:function(){return ae()}},(function(t){var e=t.chartWidth,n=Math.max(Math.round(.002*e*h),8),r=pn.a.createElement(Ss,{data:$t,strokeColor:E,strokeWidth:j,fontSize:n,fontWeight:g,spacing:B,backgroundColor:y,width:e,showUSA:T,makeUSABigger:P,transitionDuration:b,onMouseOver:function(t,e){return ae(t,e)}}),i=e/1.711325+1.5*kt+20,o=_t.length>1&&pn.a.createElement(Cs,{colorScale:Ft,values:_t,fontColor:st,fontSize:kt,width:ct||4*e/5,height:ut,x:dt||e/10,y:ft||i,formatter:Qt,transitionDuration:b,showNoData:Ht,noDataColor:"usa-gray"});return pn.a.createElement("div",{style:{height:i+ut+20,position:"relative"}},pn.a.createElement("div",{style:{height:20}}),pn.a.createElement("svg",{style:{overflow:"visible"},className:"cartogram-svg"},pn.a.createElement("g",{width:e,className:"cartogram-g"},r),_t.length>1&&o),!1!==X&&null!==ie.position.x&&null!==ie.position.y&&pn.a.createElement("div",{className:"tooltip-container"},pn.a.createElement(oo,{x:ie.position.x,y:ie.position.y,direction:"above",width:e},pn.a.createElement(Za,{title:ie.title,subtitle:$?ie.subtitle:void 0,value:ie.value,color:ie.color,decimals:nt,type:ie.type}))))}))};Xs.propTypes=Zs(Zs({},ua),{},{titleOptions:Object(zn.shape)({text:zn.string,fontSize:zn.number}),subtitleOptions:Object(zn.shape)({text:zn.string,fontSize:zn.number}),data:Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)({geo_id:zn.string.isRequired,x_type:zn.string,y_type:zn.string,data:Object(zn.arrayOf)(Object(zn.shape)({key:zn.string.isRequired,value:zn.number})).isRequired})).isRequired,sources:Object(zn.arrayOf)(Object(zn.shape)(So))}).isRequired,dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({geo_id:zn.string.isRequired,tooltipTtile:zn.string,strokeWidth:zn.number,strokeColor:zn.string})),footerOptions:Object(zn.shape)({fontSize:zn.number,footnotes:ua.footnotes,show:ua.showFooter,sources:ua.footerSources}),width:zn.number,hexLabelFontSize:zn.number,fontWeight:zn.number,backgroundColor:zn.string,transitionDuration:zn.number,tooltipOptions:Object(zn.shape)({decimals:zn.number,showSubtitle:zn.bool,show:zn.bool,color:zn.string}),scaleOptions:Object(zn.shape)({colorScale:Object(zn.arrayOf)(zn.string),reverseColorOrder:zn.bool,fontColor:zn.string,width:zn.number,height:zn.number,x:zn.number,y:zn.number,values:Object(zn.arrayOf)(zn.number),centeredScale:zn.bool,floatingScale:zn.bool,fontSize:zn.number}),keyType:zn.string,strokeColor:zn.string,strokeWidth:zn.number,spacing:zn.number,showUSA:zn.bool,makeUSABigger:zn.bool,dropdownOptions:Object(zn.shape)({enabled:zn.bool,selectedItem:zn.string,show:zn.bool,type:zn.string})});var _s=Xs,$s={"dot-chart":"_1AhEh2-wi4G4i5RAaHLcOw","dot-plot-wrapper":"FBAco3I3VHfOXYx0mWWax"},tc=f.a.pick(ya,[ya.top,ya.bottom]),ec={dot1Color:"usa-gray",dot1Radius:4,dot1StokeWidth:1,dot1StrokeColor:"#ffffff",dot2Color:"usa-magenta",dot2Radius:6.5,dot2StokeWidth:0,dot2StrokeColor:"#ffffff",lineColor:"usa-gray",lineWidth:1},nc={enabled:!0,selectedItem1:void 0,selectedItem2:void 0,show:!0,type:void 0},rc={fontSize:13,footnotes:void 0,show:!0,showMetricFootnotes:!0,sources:void 0},ic={fontSize:16,text:void 0},oc={fontSize:20,text:void 0},ac={decimals:void 0,position:"below",show:!0,showSubtitle:!0},sc=[ya.top],cc={decimals:void 0,displayRangeMin:void 0,displayRangeMax:void 0,displayTicks:sc,floatingAxis:void 0,fontSize:13,showGridlines:!0,ticks:void 0,type:void 0,textColor:"#4D4D4D"},lc={maxLines:1,maxWidth:void 0,color:"#4D4D4D",fontSize:13};function uc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function dc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?uc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):uc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function fc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function hc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?fc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):fc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var pc=function(t){var e=t.dots,n=void 0===e?[]:e,r=t.lineColor,o=void 0===r?Ni["usa-gray"]:r,a=t.lineWidth,s=void 0===a?1:a,c=t.transitionDuration,l=void 0===c?250:c,d=t.transitionControllers,h=void 0===d?{}:d,p=t.onMouseOver,g=void 0===p?function(){}:p,m=t.onMouseOut,y=void 0===m?function(){}:m,v=t.onClick,b=void 0===v?function(){}:v,k=[],w=[];n.forEach((function(t,e){k.push({key:t.key||e,color:t.color||(0===e?Ni["usa-magenta"]:Ni["usa-gray"]),opacity:void 0!==t.opacity?t.opacity:1,radius:t.radius||6.5,strokeColor:t.strokeColor||"transparent",strokeWidth:t.strokeWidth||0,x:t.x,y:t.y,forceRedraw:f.a.uniqueId()}),e>0&&w.push({key:"line-".concat(t.key||e),x1:n[e-1].x,y1:n[e-1].y,x2:n[e].x,y2:n[e].y,opacity:n[e].opacity||1,color:o,width:s,forceRedraw:f.a.uniqueId()})}));var x=pa(k,(function(t){return t.key}),{config:{easing:C.easeQuad,duration:l},initial:function(t){return t},from:function(t){return hc(hc({},t),{},{radius:0,forceRedraw:f.a.uniqueId()})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(hc(hc({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,h.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(hc(hc({},t),{},{radius:0,forceRedraw:f.a.uniqueId()}),n,r,h.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(hc(hc({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,h.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}}),A=pa(w,(function(t){return t.key}),{config:{easing:C.easeQuad,duration:l},initial:function(t){return t},from:function(t){return hc(hc({},t),{},{forceRedraw:f.a.uniqueId()})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(hc(hc({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,h.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(hc(hc({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,h.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(hc(hc({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,h.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",null,A((function(t,e){var n=t.x1,r=t.y1,i=t.x2,o=t.y2,a=t.color,s=t.width,c=t.opacity;return pn.a.createElement(Xn.animated.line,{key:e.key,x1:n,y1:r,x2:i,y2:o,stroke:a,strokeWidth:s,style:{opacity:c}})})),x((function(t,e,n,r){var i=t.x,o=t.y,a=t.radius,s=t.color,c=t.strokeColor,l=t.strokeWidth,u=t.opacity;return pn.a.createElement(Xn.animated.circle,{key:e.key,onMouseOver:function(t){return g(t,r,e)},onMouseOut:function(t){return y(t,r,e)},onClick:function(t){return b(t,r,e)},cx:i,cy:o,r:a,fill:s,stroke:c,strokeWidth:l,style:{opacity:u}})})))};pc.propTypes={dots:Object(zn.arrayOf)(Object(zn.shape)({key:Object(zn.oneOfType)([zn.string,zn.number]),color:zn.string,opacity:zn.number,radius:zn.number,strokeColor:zn.string,strokeWidth:zn.number,x:zn.number.isRequired,y:zn.number.isRequired})),lineWidth:zn.number,lineColor:zn.string,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var gc=pc;function mc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function yc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?mc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):mc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var vc=f()(Qr).omit(["default"]).keys().value(),bc=function(t){var e=t.data,n=t.dataSeriesHeight,r=void 0===n?17:n,o=t.dataSeriesOptions,a=void 0===o?[]:o,s=t.dotOptions,c=void 0===s?ec:s,l=t.dropdownOptions,d=void 0===l?nc:l,h=t.featuredPosition,p=void 0===h?"top":h,g=t.footerOptions,m=void 0===g?rc:g,y=t.labelOptions,v=void 0===y?lc:y,b=t.sort,k=void 0===b?"descending":b,w=t.subtitleOptions,x=void 0===w?ic:w,A=t.titleOptions,S=void 0===A?oc:A,E=t.tooltipOptions,C=void 0===E?ac:E,R=t.transitionDuration,j=void 0===R?250:R,I=t.width,B=t.xAxisOptions,D=void 0===B?cc:B;if(!e||!e.length)return null;var T=f.a.defaultsDeep({},c,ec),F=f.a.defaultsDeep({},d,nc),P=f.a.defaultsDeep({},m,rc),z=f.a.defaultsDeep({},x,ic),Q=f.a.defaultsDeep({},S,oc),L=f.a.defaultsDeep({},C,ac),Y=f.a.defaultsDeep({},D,cc),W=f.a.defaultsDeep({},v,lc),q=Object(hn.useMemo)((function(){var t=Ur(e),n=function(t,e){return t.map((function(t){var n=f.a.defaultsDeep({},t,e);return dc(dc({},n),{},{dot1Color:Ji(n.dot1Color,"usa-gray"),dot1StrokeColor:Ji(n.dot1StrokeColor,"#ffffff"),dot2Color:Ji(n.dot2Color,"usa-magenta"),dot2StrokeColor:Ji(n.dot2StrokeColor,"#ffffff"),lineColor:Ji(n.lineColor,"usa-gray"),featured:Boolean(t.featured),selected:Boolean(t.selected)})}))}(oi(t,a),T);return{data:ai(t,n,["name","x_type","y_type","sources","meta"]).map((function(t){return yc(yc({},t),{},{sources:t.sources||[],name:t.metric.labelText||t.name,tooltipTitle:t.metric.tooltipTitle||t.name})})),dataSeriesOptions:n}}),[e,a,T]).data,N=Zr(Y.type)?Y.type:Xr(q,"y")||"linear",G=Zr(F.type)?F.type:Xr(q,"x")||"items",J=Jr({params:{format:N}}),U=Jr({params:{format:G}}),K=Hr(q,Sr).map((function(t){return yc(yc({},t),{},{parsed:U(t.key)})})),H=Object(hn.useState)(null),V=M()(H,2),Z=V[0],X=V[1],_=Object(hn.useState)(!!K.length&&f.a.first(K).key),$=M()(_,2),tt=$[0],et=$[1],nt=Object(hn.useState)(!!K.length&&f.a.last(K).key),rt=M()(nt,2),it=rt[0],ot=rt[1];Object(hn.useEffect)((function(){var t=f.a.find(K,{key:F.selectedItem1});t&&et(t.key)}),[F.selectedItem1,K]),Object(hn.useEffect)((function(){var t=f.a.find(K,{key:F.selectedItem2});t&&ot(t.key)}),[F.selectedItem2,K]);var at=function(t){var e,n=t.type,r=t.values,i=t.customDomain,o=void 0===i?[void 0,void 0]:i,a=t.customTicks,s=void 0===a?void 0:a,c=[f.a.min([].concat(O()(r),[0])),f.a.max([].concat(O()(r),[0]))],l=$r(c,[]);if(o){var u=_r("y",n,o);l=$r(u,c)}var d=ei(n,l);return s&&(e=_r("y",n,s),void 0===o[0]&&void 0===o[1]?d=ei(n,l=[Math.min(c[0],e[0]),Math.max(c[1],e[e.length-1])]):e=e.filter((function(t){return t>=l[0]&&t<=l[1]}))),e=ti({axisType:"y",scale:d,customTicks:e}),{domain:l,ticks:e,scale:d.nice()}}({type:N,values:q.flatMap((function(t){return t.data})).filter((function(t){var e=t.key;return!Y.floatingAxis||e===tt||e===it})).map((function(t){return t.value})),customDomain:[Y.displayRangeMin,Y.displayRangeMax],customTicks:Y.ticks}),st=at.ticks,ct=at.scale,lt=!(ct.domain()[1]<=0)&&ct.domain()[0]<0&&ct.domain()[1]>0,ut=f.a.min([W.maxWidth,f.a.max(O()(q.map((function(t){return ia(t.name,W.fontSize).width}))))]),dt=Y.displayTicks?ia(J(f.a.last(st),f.a.isNil(Y.decimals)?{ticks:st}:{decimals:Y.decimals}),Y.fontSize).width/2:0,ft=function(t){var e=t.data,n=t.selectedKey1,r=t.selectedKey2,i=t.featuredPosition,o=void 0!==i&&i,a=t.sort,s=void 0!==a&&a,c=f()(e).map((function(t){return dc(dc({},t),{},{data1:f.a.find(t.data,{key:n}),data2:f.a.find(t.data,{key:r})})}));return s&&(c=c.orderBy([function(t){return f.a.get(t,"data2.value",0)}],["ascending"===s?"asc":"desc"])),o&&(c=c.orderBy([function(t){return t.metric.featured}],["bottom"===o?"asc":"desc"])),c.value()}({data:q,selectedKey1:tt,selectedKey2:it,featuredPosition:p,sort:k}),ht=function(t){var e=t.fontSize,n=t.height,r=t.data,i=t.initialY,o=void 0===i?0:i,a=t.textColor,s=[],c=[],l=r.some((function(t){return t.metric.selected}));return r.forEach((function(t,r,i){var u=t.id,d=t.name,f=t.metric,h=t.metric,p=h.featured,g=h.selected,m=h.lineColor,y=h.lineWidth,v=r*(n+n/2)+c.length*(2+n/2)+o;r>0&&i[r-1].metric.featured!==p&&(c.push({height:2,color:"#999999",y:v}),v+=2+n/2);var b=i[r],k=[];[b.data1,b.data2].forEach((function(t,e,r){var i,o=e+1,a="".concat(u,"-").concat(o),s=1===o?.7:1;l&&!g&&(s=.5),t?i=dc({},t):0===e&&r[1]?(i=dc({},r[1]),s=0):1===e&&r[0]&&(i=dc({},r[0]),s=0),k.push({data:i,dot:{key:a,color:f["dot".concat(o,"Color")],opacity:s,radius:f["dot".concat(o,"Radius")],strokeColor:f["dot".concat(o,"StrokeColor")],strokeWidth:f["dot".concat(o,"StokeWidth")],y:v+n/2}})})),s.push({label:{key:u,content:d,y:v+e,style:{fill:a,opacity:!l||g?1:.5,fontSize:e,fontWeight:400}},dots:k,line:{width:y,color:m}})})),{segments:s,spacers:c}}({fontSize:W.fontSize,height:r,data:ft,initialY:f.a.includes(Y.displayTicks,tc.top)?1.2*Y.fontSize:0,textColor:Ji(W.color,"#4D4D4D")}),pt=ht.segments,gt=ht.spacers,mt=f.a.includes(Y.displayTicks,tc.top)?1.2*Y.fontSize:0,yt=f.a.includes(Y.displayTicks,tc.bottom)?1.2*Y.fontSize:0,vt=f.a.max(f.a.flatMap(pt,(function(t){return t.dots})).map((function(t){var e=t.dot;return e.y+e.radius}))),bt=mt+vt+yt,kt=[];if(F.show&&K.length){var wt=F.enabled?K.filter((function(t){return t.key!==it})).map((function(t){return t.key})).sort((function(t,e){return t<e?-1:1})):[f.a.find(K,{key:tt}).key];kt.push({options:wt,color:T.dot1Color,parser:U,label:Q.text?" ":"",value:tt?f.a.find(K,{key:tt}).parsed:"",onChange:function(t){var e=t.target.value;et(f.a.find(K,{parsed:e}).key)}});var xt=F.enabled?K.filter((function(t){return t.key!==tt})).map((function(t){return t.key})).sort((function(t,e){return t<e?-1:1})):[f.a.find(K,{key:it}).key];kt.push({options:xt,color:T.dot2Color,parser:U,label:" vs ",value:it?f.a.find(K,{key:it}).parsed:"",onChange:function(t){var e=t.target.value;ot(f.a.find(K,{parsed:e}).key)}})}var At=go({data:q,chartSources:P.sources}),St=At.sources,Ot=At.summary,Et=bo({data:q,chartFootnotes:P.footnotes,showMetricFootnotes:P.showMetricFootnotes}).footnotes;function Mt(){X(null)}return pn.a.createElement(la,{className:$s["dot-chart"],title:Q.text,subtitle:z.text,titleFontSize:Q.fontSize,subtitleFontSize:z.fontSize,footerSources:P.show?St:[],footerSummary:P.show?Ot:"",footnotes:P.show?Et:[],showFooter:P.show,showMetricFootnotes:P.showMetricFootnotes,dropdowns:kt,width:I,height:"auto",fontSize:P.fontSize,onMouseLeave:Mt},(function(t){var e=t.chartWidth;ct.range([ut+10+10,e-dt]);var n,r=function(t){var e=t.segments,n=t.spacers,r=t.xScale,i=t.chartWidth;return{spacers:n.map((function(t){return dc(dc({},t),{},{width:i,x:0})})),segments:e.map((function(t){return{label:dc(dc({},t.label),{},{x:0}),line:t.line,dots:t.dots.filter((function(t){return void 0!==t.data})).map((function(t){var e=t.data;return{data:e,dot:dc(dc({},t.dot),{},{x:r(e.value)})}}))}}))}}({segments:pt,spacers:gt,xScale:ct,chartWidth:e}),o=r.segments,a=r.spacers;function s(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,r=o[e];if(r){var i=void 0===n?0:n,a=ft[e],s=O()(r.dots).reverse(),c=s[i].data,l=s[i].dot;a&&c&&l&&X({position:{x:l.x,y:l.y+20},value:c.value,direction:L.position,title:a.tooltipTitle||a.name,color:l.color,label:U(c.key),type:a.y_type})}}return pn.a.createElement("div",{style:{position:"relative"},className:$s["dot-plot-wrapper"]},pn.a.createElement("svg",{style:{overflow:"visible",height:"".concat(bt,"px"),flex:1},className:$s["dot-chart-svg"]},f.a.includes(Y.displayTicks,tc.top)&&pn.a.createElement(ba,{position:tc.top,chartWidth:e,chartHeight:vt+mt,fontSize:Y.fontSize,textColor:Ji(Y.textColor,"#4D4D4D"),ticks:st.map((function(t){return{data:t,point:ct(t)}})),formatter:function(t){return J(t,f.a.isNil(Y.decimals)?{ticks:st}:{decimals:Y.decimals})},transitionDuration:j}),f.a.includes(Y.displayTicks,tc.bottom)&&pn.a.createElement(ba,{position:tc.bottom,chartWidth:e,chartHeight:vt+yt,fontSize:Y.fontSize,textColor:Ji(Y.textColor,"#4D4D4D"),ticks:st.map((function(t){return{data:t,point:ct(t)}})),formatter:function(t){return J(t,f.a.isNil(Y.decimals)?{ticks:st}:{decimals:Y.decimals})},transitionDuration:j}),(Y.showGridlines||lt)&&pn.a.createElement(Na,{orientation:Wa.vertical,range:[mt,vt],strokeWidth:1,gridColor:"#E6E6E6",ticks:st.filter((function(t){return Y.showGridlines||0===t})).map((function(t){return{point:ct(t),strokeWidth:lt&&0===t&&Y.showGridlines?3:1}})),transitionDuration:j}),pn.a.createElement(Ha,{labels:o.map((function(t){var e=t.label;return yc(yc({},e),{},{content:pn.a.createElement(za,{dominantBaseline:"hanging",label:e.content,fontSize:e.style.fontSize,maxWidth:ut,maxLines:W.maxLines})})})),transitionDuration:j,transitionControllers:{update:(n=i()(u.a.mark((function t(e,n){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ni(j);case 2:return t.next=4,n(e);case 4:case"end":return t.stop()}}),t)}))),function(t,e){return n.apply(this,arguments)})},onMouseOver:function(t,e){return s(t,e)},onMouseOut:Mt}),o.map((function(t,e){var n,r=t.label.key,o=t.dots,a=t.line;return pn.a.createElement(gc,{key:r,dots:o.map((function(t){return t.dot})).reverse(),lineWidth:a.width,lineColor:a.color,transitionDuration:j,transitionControllers:{update:(n=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=["x","x1","x2","width","opacity"],t.next=3,n(f.a.pick(e,r));case 3:return t.next=5,n(f.a.omit(e,r));case 5:case"end":return t.stop()}}),t)}))),function(t,e){return n.apply(this,arguments)})},onMouseOver:function(t,n){return s(t,e,n)},onMouseOut:Mt})})),a.length>0&&pn.a.createElement(Fa,{bars:a})),L.show&&Z&&pn.a.createElement("div",{className:$s["tooltip-container"]},pn.a.createElement(oo,{direction:Z.direction,x:Z.position.x,y:Z.position.y,width:e},pn.a.createElement(Za,{title:Z.title,subtitle:L.showSubtitle?Z.label:void 0,value:Z.value,color:Z.color,decimals:L.decimals,type:Z.type}))))}))};bc.propTypes=yc(yc({},ua),{},{data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,dataSeriesHeight:zn.number,dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,dot1Color:zn.string,dot1Radius:zn.number,dot1StokeWidth:zn.number,dot1StrokeColor:zn.string,dot2Color:zn.string,dot2Radius:zn.number,dot2StokeWidth:zn.number,dot2StrokeColor:zn.string,lineColor:zn.string,lineWidth:zn.number,featured:zn.bool,selected:zn.bool,labelText:zn.string,tooltipTitle:zn.string})),dotOptions:Object(zn.shape)({dot1Color:zn.string,dot1Radius:zn.number,dot1StokeWidth:zn.number,dot1StrokeColor:zn.string,dot2Color:zn.string,dot2Radius:zn.number,dot2StokeWidth:zn.number,dot2StrokeColor:zn.string,lineColor:zn.string,lineWidth:zn.number}),dropdownOptions:Object(zn.shape)({enabled:zn.bool,selectedItem1:zn.string,selectedItem2:zn.string,show:zn.bool,type:Object(zn.oneOf)(vc)}),featuredPosition:Object(zn.oneOf)(["top","bottom"]),footerOptions:Object(zn.shape)({fontSize:zn.number,footnotes:ua.footnotes,show:ua.showFooter,showMetricFootnotes:zn.bool,sources:ua.footerSources}),labelOptions:Object(zn.shape)({maxWidth:zn.number,maxLines:zn.number,color:zn.string,fontSize:zn.number}),sort:Object(zn.oneOf)(["ascending","descending",!1]),subtitleOptions:Object(zn.shape)({fontSize:ua.subtitleFontSize,text:ua.subtitle}),titleOptions:Object(zn.shape)({fontSize:ua.titleFontSize,text:ua.title}),tooltipOptions:Object(zn.shape)({decimals:zn.number,position:Object(zn.oneOf)(ro),show:zn.bool,showSubtitle:zn.bool}),transitionDuration:zn.number,width:zn.number,xAxisOptions:Object(zn.shape)({decimals:zn.number,displayRangeMin:Object(zn.oneOfType)([zn.number,zn.string]),displayRangeMax:Object(zn.oneOfType)([zn.number,zn.string]),displayTicks:Object(zn.arrayOf)(Object(zn.oneOf)(f.a.values(tc))),floatingAxis:zn.bool,fontSize:zn.number,showGridlines:zn.bool,ticks:Object(zn.arrayOf)(Object(zn.oneOfType)([zn.number,zn.string])),type:Object(zn.oneOf)(vc),textColor:zn.string})});var kc=bc,wc={"grouped-bars":"_1vcA1dLmufhdRJpgoikxvE","group-section":"_1gDrIuhuIk_FEkPwyWILKh","group-name-section":"_2ekDDsUf6tJEoHz12zs87h","horiz-bars-section":"ke5ZyqX44wpwdXO-VP40k","bar-value-text":"_1fjNEQG56En-pIZ3HyMdZe","horiz-bars-row":"mn-TxEBmYbXRYBPYt1KW0","bar-group":"_33nwThQwQl-6wvOcxuC5DI",bar:"_2Q5LimUfx9EzFOmvXtK11F",label:"_3tS43KYy1K-yL32fdGK9xM",title:"_9BWmCZuFVB-lJ5Qhpi-PH","bar-box":"_2tjxkXV9w7Q0BOwlic86MN",axis:"_1oqg-oVsabH2ygbwUTP_06","inner-chart-content":"_2ZoNjxg0wc9MfPvcZki5wt",column:"_3dvfe9dcZLdrRzvCX90onc","axis-label":"PXnKbJxS56d7L-P2fjVHT","tooltip-container":"_1W6VKGWKBxBZI41U-BK7W-"},xc=["opacity","x","content"],Ac=["width","x","forceRedraw"];function Sc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Oc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Sc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Sc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Ec=Object(R.createCanvas)(0,0),Mc=function(t){var e=t.axisTextColor,n=t.barHeight,r=t.categories,o=t.data,a=t.date,s=t.floatingAxis,c=t.fontSize,l=t.gridColor,d=t.groups,h=t.groupSpacing,p=t.hideAxis,g=t.hideBottomXTicks,m=t.hideGridlines,y=t.hideTooltip,v=t.hideTooltipYear,b=t.hideTopXTicks,k=t.hideValueLabel,x=t.metrics,A=t.selectedKeys,S=t.throttledSetTooltip,O=t.tooltip,E=t.transitionDuration,M=t.width,R=t.xAxisTicks;if(0===r.length||0===x.length||0===d.length||null==M)return pn.a.createElement("div",null);var j=Object(hn.createRef)(),I=Ec.getContext("2d"),B=function(t){if(f.a.isNil(t))return 0;I.font="".concat(c,"px ").concat(Yr);var e=I.measureText(t);return e.actualBoundingBoxLeft+e.actualBoundingBoxRight},D=Object(hn.useRef)(new Array(d.length).fill(null).map((function(){return new Array(r.length).fill(null)}))),T=function(t,e,n){if(e){var r=t.map((function(t){return{value:t.data.filter((function(t){return n===t.key}))[0].value,type:t.data.filter((function(t){return n===t.key}))[0].y_type}}));return f()(r).map((function(t){var e=t.value,n=t.y_type,r=Jr({params:{format:n}}),i=null!==e?r(e):"no data";return B(i)})).max()}var i=t.map((function(t){return t.data.map((function(t){return{value:t.value,y_type:t.y_type}}))}));return f()(i).flatten().map((function(t){var e=t.value,n=t.y_type,r=Jr({params:{format:n}}),i=null!==e?r(e):"no data";return B(i)})).max()}(o,s,a),F=function(t,e,n){return e?t.map((function(t){return t.data.filter((function(t){return n===t.key}))[0].value})).filter(Number.isFinite).sort().pop():t.map((function(t){return t.data.map((function(t){return null===t.value?0:t.value}))})).flat().filter(Number.isFinite).sort().pop()}(o,s,a),P=function(t,e,n){return e?t.map((function(t){return t.data.filter((function(t){return n===t.key}))[0].value})).filter(Number.isFinite).sort().shift():t.map((function(t){return t.data.map((function(t){return null===t.value?0:t.value}))})).flat().filter(Number.isFinite).sort().shift()}(o,s,a),z=f()(d).map((function(t){var e=t.label;return B(e)})).max()+10,Q=M-z-(F>0?T:0)-(P<0?T:0),L=Object(C.scaleLinear)().domain([Math.min(P,0),Math.max(F,0)]).range([0,Q]).nice(),Y=5;Q<150?Y=2:Q<300&&(Y=3);var W,q,N=z+L(0)+(P<0?T:0),G=f.a.map(d,(function(t,e){var i=t.id,s=t.key;return f()(r).map((function(t,l){var u=t.id,d=t.key,g=t.color,m=t.label,y=g||Gi[l%Gi.length],v=(f.a.find(x,(function(t){var e=t.group,n=t.category;return e===i&&n===u}))||{}).metrics;return(void 0===v?[{}]:v).map((function(t){var i=t.id,u=o.find((function(t){return t.id===i}))||{},f=u.data,g=void 0===f?[]:f,v=u.y_type,k=u.x_type,w=(g.find((function(t){var e=t.key;return A.length?[s,d].includes(e):e===a}))||{}).value,x=void 0===w?null:w,S=D.current[e][l],O=Number.isFinite(x)&&Number.isFinite(S)&&x*S<0||!Number.isFinite(x)&&S<0||!Number.isFinite(S)&&x<0;return D.current[e][l]=x,{width:null===x?0:L(x)-L(0),x:N,y:e*(h+r.length*n)+l*n+(p||b?0:c)+10,height:n,color:y,value:x,y_type:v,x_type:k,categoryLabel:m,signChange:O,key:e*r.length+l}}))})).flatten().value()})),J=(d.length-1)*h+d.length*r.length*n+c,U=L.ticks(R||Y),K=f.a.first(o).y_type,H=Jr({params:{format:K}}),V=p||g?0:c,Z=U.map((function(t){return{data:t,point:L(t)+z+(P<0?T:0),strokeWidth:1}}));return pn.a.createElement("div",{style:{position:"relative"},ref:j,className:wc["inner-chart-content"]},pn.a.createElement("svg",{style:{overflow:"visible",height:"".concat(J,"px"),flex:1},className:wc["grouped-bar-svg"]},!b&&!p&&pn.a.createElement(ba,{position:"top",chartWidth:Q,chartHeight:J+(p||b?0:c),fontSize:c,textColor:Ji(e,"#4D4D4D"),ticks:Z,formatter:function(t){return H(t,{ticks:U})},transitionDuration:E}),!g&&!p&&pn.a.createElement(ba,{position:"bottom",chartWidth:Q,chartHeight:J+(p||b?0:c)+V,fontSize:c,textColor:Ji(e,"#4D4D4D"),ticks:Z,formatter:function(t){return H(t,{ticks:U})},transitionDuration:E}),!m&&!p&&pn.a.createElement(Na,{orientation:"vertical",range:[p||b?0:c+5,J+(p||b?0:c)],strokeWidth:1,gridColor:Ji(l,"#4D4D4D"),ticks:Z,transitionDuration:E}),!k&&pn.a.createElement(Ha,{labels:G.map((function(t,e){return t.map((function(n,r){var i=n.value,o=n.width,a=n.height,s=n.y_type,l=n.x,u=n.y,d=Jr({params:{format:s}}),f=null!==i?d(i):"no data";return{x:l+o+3-(o<0?B(f)+6:0),y:u+.35*c+a/2,key:e*t.length+r,content:i,style:{fill:Ji("#4D4D4D"),fontWeight:400}}}))})).flat(),transitionDuration:E,formatter:function(t,e,n){var i=G[Math.floor(n/r.length)][n%r.length].y_type,o=Jr({params:{format:i}});return null!==e?t.to(o):"no data"},transitionControllers:{update:(q=i()(u.a.mark((function t(e,n){var i,o,a,s,c;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=G[Math.floor(e.key/r.length)][e.key%r.length],o=e.opacity,a=e.x,s=e.content,c=w()(e,xc),!i.signChange){t.next=7;break}return t.next=5,n([{x:N+3,opacity:-1,content:0},Oc({x:a,opacity:o,content:s},c)]);case 5:t.next=9;break;case 7:return t.next=9,n(e);case 9:case"end":return t.stop()}}),t)}))),function(t,e){return q.apply(this,arguments)})}}),pn.a.createElement(Fa,{bars:G.flat(),transitionDuration:E,transitionControllers:{update:(W=i()(u.a.mark((function t(e,n){var i,o,a,s,c;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=G[Math.floor(e.key/r.length)][e.key%r.length],o=e.width,a=e.x,s=e.forceRedraw,c=w()(e,Ac),!i.signChange){t.next=7;break}return t.next=5,n([{x:N,width:0,forceRedraw:s+1},Oc({x:a,width:o},c)]);case 5:t.next=9;break;case 7:return t.next=9,n(e);case 9:case"end":return t.stop()}}),t)}))),function(t,e){return W.apply(this,arguments)})},onMouseOver:function(t,e){var n=G[Math.floor(e/r.length)][e%r.length],i=t.target.getBoundingClientRect(),o=i.width,a=i.top,s=i.height,c=i.bottom,l=N+o/2*(n.value>0?1:-1),u=a+s/2,f=j.current.getBoundingClientRect(),h=f.top,p=f.height,g=f.bottom,m=u>h+p/2?"above":"below";S({position:{x:l,y:"above"===m?u-g:-(g-c+s/2)},group:d[Math.floor(e/r.length)].label,category:r[e%r.length].label,value:n.value,color:n.color,x_type:n.x_type,y_type:n.y_type,direction:m})},onMouseOut:function(){S({position:{x:null,y:null}})}}),pn.a.createElement("g",{className:wc["group-labels"]},pn.a.createElement(Ha,{labels:d.map((function(t,e){var i=t.label;return{x:0,y:(n*r.length+h)*e+n*r.length/2+(p||b?0:c)+10+.35*c,key:i,content:pn.a.createElement(za,{dominantBaseline:"hanging",label:i,fontSize:c,maxWidth:z,maxLines:1}),style:{fill:Ji("#4D4D4D"),fontWeight:400}}})),transitionDuration:E}))),!y&&null!==O.position.x&&null!==O.position.y&&pn.a.createElement("div",{className:wc["tooltip-container"]},pn.a.createElement(oo,mn()({direction:O.direction},O.position,{width:M}),pn.a.createElement(Za,{title:pn.a.createElement("div",null,"".concat(O.group,","),pn.a.createElement("span",{style:{color:O.color}}," ".concat(O.category))),subtitle:v?void 0:Jr({params:{format:O.x_type}})(a),value:O.value,type:O.y_type,color:O.color}))))};Mc.propTypes={width:zn.number,barHeight:zn.number,groups:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired})).isRequired,categories:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,color:zn.string})),metrics:Object(zn.arrayOf)(Object(zn.shape)({group:zn.string.isRequired,category:zn.string.isRequired,metrics:Object(zn.arrayOf)(Object(zn.shape)({name:zn.string,id:zn.string.isRequired,color:zn.string}))})).isRequired,data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,date:zn.string.isRequired,floatingAxis:zn.bool,hideValueLabel:zn.bool,hideAxis:zn.bool,hideGridlines:zn.bool,xAxisTicks:zn.number,tooltip:zn.object,throttledSetTooltip:zn.func,hideTooltip:zn.bool,axisTextColor:zn.string,gridColor:zn.string,hideBottomXTicks:zn.bool,hideTopXTicks:zn.bool,hideTooltipYear:zn.bool,fontSize:zn.number,groupSpacing:zn.number,selectedKeys:Object(zn.arrayOf)(zn.string),transitionDuration:zn.number};var Cc=Mc,Rc="_2IYKkHsP8X_hCdFIM-6thu",jc="_3CUWIKxu7uc_sjfxLKuBnC",Ic="_34jvAfkAGzyLdfB9XAyKKN",Bc="_3OISaUTq6IOWFgB1Le_edt";function Dc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Tc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Dc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Dc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Fc=function(t){var e=t.categories,n=void 0===e?[]:e,r=t.fontSize,i=void 0===r?13:r,o=t.transitionDuration,a=void 0===o?250:o,s=t.style,c=void 0===s?{}:s,l=t.entryStyle,u=void 0===l?{}:l,d=t.onMouseOver,f=void 0===d?function(){}:d,h=t.onMouseOut,p=void 0===h?function(){}:h,g=t.onClick,m=void 0===g?function(){}:g,y=n.every((function(t){return!t.highlighted})),v=Object(Xn.useSprings)(n.length,n.map((function(t){var e=t.highlighted,n=.25;return(y||e)&&(n=1),{config:{duration:a},opacity:n}})));return pn.a.createElement("div",{className:Rc,style:c},n.map((function(t,e){return pn.a.createElement(Xn.animated.div,{className:jc,style:Tc(Tc({},u),{},{opacity:v[e].opacity,paddingBottom:i>13?i-13:0}),key:e,onMouseOver:function(n){return f(n,e,t)},onMouseOut:function(n){return p(n,e,t)},onClick:function(n){return m(n,e,t)}},pn.a.createElement("div",{className:Ic,style:{backgroundColor:Ni[t.color]||t.color||Gi[e%Gi.length],width:i,height:i}}),pn.a.createElement("div",{className:Bc,style:{color:Ni[t.color]||t.color||Gi[e%Gi.length],fontSize:i}},t.label))})))};Fc.propTypes={categories:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,color:zn.string,highlighted:zn.bool})).isRequired,fontSize:zn.number,style:Object(zn.shape)(),entryStyle:Object(zn.shape)(),transitionDuration:zn.number,onMouseOver:zn.func,onMouseOut:zn.func,onClick:zn.func};var Pc=Fc;function zc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Qc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?zc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):zc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Lc=function(t){var e=t.axisTextColor,n=void 0===e?"#4D4D4D":e,r=t.barHeight,i=void 0===r?30:r,o=t.categories,a=t.data,s=t.floatingAxis,c=void 0!==s&&s,l=t.fontSize,u=void 0===l?13:l,d=t.gridColor,h=void 0===d?"#E6E6E6":d,p=t.groups,g=t.groupSpacing,m=void 0===g?10:g,y=t.hideAxis,v=void 0!==y&&y,b=t.hideFooter,k=void 0!==b&&b,w=t.hideGridlines,x=void 0!==w&&w,A=t.hideLegend,S=void 0!==A&&A,O=t.hideSubtitle,E=void 0!==O&&O,C=t.hideTitle,R=void 0!==C&&C,j=t.hideTooltip,I=void 0!==j&&j,B=t.hideTooltipYear,D=void 0!==B&&B,T=t.hideValueLabel,F=void 0!==T&&T,P=t.hideXTicks,z=void 0!==P&&P,Q=t.hideYear,L=void 0!==Q&&Q,Y=t.hideTopXTicks,W=void 0!==Y&&Y,q=t.hideBottomXTicks,N=void 0!==q&&q,G=t.metrics,J=t.selectedDate,U=t.subtitle,K=t.subtitleFontSize,H=void 0===K?14:K,V=t.title,Z=t.titleFontSize,X=void 0===Z?20:Z,_=t.transitionDuration,$=void 0===_?250:_,tt=t.width,et=t.xAxisTicks,nt=W,rt=N;z&&(nt=!0,rt=!0);var it=Ur(a),ot=Or(it),at=ot.find((function(t){return t.unformatted&&t.unformatted===J})),st=Object(hn.useState)((null==at?void 0:at.unformatted)||(ot&&ot.length?ot[ot.length-1].unformatted:null)),ct=M()(st,2),lt=ct[0],ut=ct[1],dt=Object(hn.useState)({position:{x:null,y:null},group:null,category:null,value:null,color:null,y_type:null,direction:"below"}),ft=M()(dt,2),ht=ft[0],pt=ft[1],gt=Object(hn.useMemo)((function(){return f.a.debounce((function(t){pt(t)}),33)}),[]),mt=[{options:ot,label:V?" ":"",parser:function(t){return t.formatted},defaultValue:ot.find((function(t){return t.unformatted===lt})).formatted,onChange:function(t){var e=t.target;ut(ot.find((function(t){return t.formatted===e.value})).unformatted)}}];L&&(mt=[]);var yt,vt=[],bt=[];if(!k){var kt=go({data:it}),wt=bo({data:it});vt=kt.sources,yt=kt.summary,bt=wt.footnotes}var xt=Object(hn.useMemo)((function(){try{return function(t){var e=t.data,n=t.groups,r=t.categories,i=f.a.some(n,"key"),o=f.a.some(r,"key");if(!i&&!o)return[];if(i&&o)throw new Error("Key cannot be present in 'groups' and 'categories' props at the same time.");var a=[];if(i){if(!f.a.every(n,"key"))throw new Error("Key must be present on items in 'groups' prop.");a=f.a.map(n,"key")}if(o){if(!f.a.every(r,"key"))throw new Error("Key must be present on items in 'categories' prop.");a=f.a.map(r,"key")}var s=f.a.chain(e).flatMap((function(t){return t.data.map((function(t){return t.key}))})).uniq().value();if(!a.every((function(t){return s.includes(t)})))throw new Error("Some or all of the selected keys provided do not exist in the data.");return a}({data:it,groups:p,categories:o})}catch(t){return console.warn(t.message),null}}),[it,p,o]);return null===xt?pn.a.createElement("div",null):(xt.length&&!L&&mt.length&&(console.warn("Dropdowns are disabled when selecting keys from groups/categories."),mt=[]),pn.a.createElement($i,{className:wc["grouped-bars"],title:R?null:V,subtitle:E?null:U,style:{width:tt||null},dropdowns:mt,titleFontSize:X,subtitleFontSize:H},!S&&pn.a.createElement(Pc,{categories:o,fontSize:u}),pn.a.createElement(Pn,{handleWidth:!0,handleHeight:!0},(function(t){return pn.a.createElement("div",null,pn.a.createElement(Cc,{axisTextColor:n,barHeight:i,categories:o,data:it,date:lt,floatingAxis:c,fontSize:u,gridColor:h,groups:p,groupSpacing:m,hideAxis:v,hideBottomXTicks:rt,hideGridlines:x,hideTooltip:I,hideTooltipYear:D,hideTopXTicks:nt,hideValueLabel:F,metrics:G,selectedKeys:xt,throttledSetTooltip:gt,tooltip:ht,transitionDuration:$,xAxisTicks:et,width:t.width||tt}),!k&&pn.a.createElement(Ao,{sources:vt,summary:yt,footnotes:bt,fontSize:u}))}))))};Lc.propTypes=Qc(Qc({},_i),{},{width:zn.number,barHeight:zn.number,groups:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,key:zn.string})).isRequired,categories:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,color:zn.string,key:zn.string})),metrics:Object(zn.arrayOf)(Object(zn.shape)({group:zn.string.isRequired,category:zn.string.isRequired,metrics:Object(zn.arrayOf)(Object(zn.shape)({name:zn.string,id:zn.string.isRequired,color:zn.string}))})).isRequired,data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,hideFooter:zn.bool,hideLegend:zn.bool,hideYear:zn.bool,selectedDate:zn.string,floatingAxis:zn.bool,hideValueLabel:zn.bool,hideAxis:zn.bool,hideGridlines:zn.bool,xAxisTicks:zn.number,hideTooltip:zn.bool,axisTextColor:zn.string,hideTitle:zn.bool,hideSubtitle:zn.bool,gridColor:zn.string,hideXTicks:zn.bool,hideBottomXTicks:zn.bool,hideTopXTicks:zn.bool,hideTooltipYear:zn.bool,fontSize:zn.number,groupSpacing:zn.number,transitionDuration:zn.number});var Yc=Lc,Wc={"line-chart":"_2ouwLePSXax5p3D4GsvrzL","tooltip-container":"_2vOLHOJkoNC5NwC5Inbjvu","line-chart-label":"pcPYFve-p7aG0VYsoAfE-"};function qc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Nc(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?qc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):qc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Gc=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n={x:t.x,y:t.y},r=e.map((function(t){return t.data.findIndex((function(t){return t.x===n.x&&t.y===n.y}))})),i=r.findIndex((function(t){return-1!==t}));return[i,r[i]]},Jc=function(t,e,n,r){var i=e[t].find(n,r);return e.points[i]},Uc=function(t,e,n,r,i){var o=e-r(t.x),a=n-i(t.y);return Math.sqrt(Math.pow(o,2)+Math.pow(a,2))<=200?a>0?"above":"below":null},Kc=function(t,e,n,r,i){var o=e[n].id,a=r.points.map((function(t,e){return Nc(Nc({},t),{},{index:e})})).filter((function(t){return t.id===o})),s=i(t.x),c=a.map((function(t){var e=t.x;return Math.abs(i(e)-s)})),l=a[c.indexOf(Math.min.apply(Math,O()(c)))].index;return r.points[l]},Hc=function(t,e,n,r,i,o,a){var s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:[],c=0===s.length&&t.length>1?"2d":"x",l=Jc(c,n,r,i);if("2d"!==c){var u=e.findIndex((function(t){var e=t.id;return s.includes(e)}));-1!==u&&(l=Kc(l,e,u,n,o))}if(!l)return null;var d=Uc(l,r,i,o,a);if("2d"!==c||d){var f=Gc(l,e),h=t.find((function(t){return t.id===e[f[0]].id}));return{datum:l,line:h,direction:d,lineNum:f[0]}}return null};function Vc(t,e){if(!t)return t;var n=e.find((function(e){return e.x===t.datum.x&&e.y===t.datum.y}));return Nc(Nc({},t),{},{annotation:n})}var Zc=function(t,e,n){return function(r,i){var o=r.id,a=r.name,s=r.x_type,c=r.data,l=void 0===c?[]:c,u=Nc(Nc({},n),t.find((function(t){return t.id===o}))),d=u.color,h=u.displayRangeMax,p=u.displayRangeMin,g=u.endMarker,m=u.fontSize,y=u.labelText,v=u.lineStyle,b=u.lineWeight,k=u.markerColor,w=u.markerWeight,x=u.tooltipTitle,A=l.map((function(t){var e=t.key,n=t.value;return{x:Sr(e,s),y:n,key:e}})).filter((function(t){var n=t.x;if(Vr(s)){var r=n.getTime();return r>=e[0].getTime()&&r<=e[1].getTime()}return n>=e[0]&&n<=e[1]})),S=Ji(d,Gi[i]),O=function(t,e,n){return t.map((function(t,r){var i=f.a.isArray(e)&&e[r]?e[r]:e,o=f.a.isArray(e)&&Gi[r]?Gi[r]:Gi[0];return n&&(o=f.a.isArray(n)&&n[r]?n[r]:n),Ji(i,o)}))}(A,k,S),E=w||1.3*b,M=p&&Vr(s)?Sr(p,s):p,C=h&&Vr(s)?Sr(h,s):h;return{color:S,customDomain:ei(s,[M||e[0],C||e[1]]).domain(),data:A,endMarker:g,fontSize:m,id:o,labelText:y,lineStyle:v,lineWeight:b,markerColor:O,markerWeight:E,name:a,tooltipTitle:x}}};function Xc(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function _c(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Xc(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Xc(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function $c(t){var e,n=t.axisType,r=t.type,i=t.domain,o=t.customTicks,a=t.customDomain.some((function(t){return void 0!==t})),s=O()(i);o&&(e=o.map((function(t){return Sr(t,r)})),a?e=e.filter((function(t){return t>=s[0]&&t<=s[1]})):s=[f.a.min([s[0],e[0]]),f.a.max([s[1],f.a.last(e)])]);var c=ei(r,s);return{ticks:e=ti({axisType:n,scale:c,customTicks:e}),scale:c,domain:s}}var tl=function(t,e){if(!t)throw new Error("Invariant failed")},el=!1;if("undefined"!=typeof window)try{var nl={get passive(){return el=!0,!0}};window.addEventListener("test",nl,nl),window.removeEventListener("test",nl,nl)}catch(t){el=!1}var rl=el,il=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t},ol={},al={capture:!0},sl={capture:!0,passive:!0},cl={passive:!0},ll={capture:!0,passive:!1},ul=function(t){var e=t.passive,n=t.capture;return rl?!(!e&&!n)&&(e&&n?sl:e?cl:!1!==e||ll):!!n};function dl(t){return Object.keys(t).filter((function(t){return 0===t.indexOf("on")}))}var fl,hl=function(t,e){t.forEach((function(t){var n=t.name.toLowerCase(),r="capture"===n.substr(-7),i=n.substring(2);i=r?i.substring(0,i.length-7):i,e(i,t.cb,r?al:{},!0===t.options?al:t.options||ol)}))},pl=function(t,e){hl(e,(function(e,n,r,i){return function(t,e,n,r){n&&t.addEventListener(e,n,r)}(t,e,n,ul(il({},i,r)))}))},gl=function(t,e){hl(e,(function(e,n,r,i){return function(t,e,n,r){n&&t.removeEventListener(e,n,r)}(t,e,n,ul(il({},i,r)))}))},ml={children:Object(zn.oneOfType)([zn.node,zn.func]),pure:zn.bool,settings:Object(zn.shape)({passive:zn.bool,capture:zn.bool})},yl={},vl=(fl=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}fl(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),bl=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t};function kl(t,e,n){return t.reduce((function(t,r){return t.push({name:r,options:n,cb:e[r]}),t}),[])}var wl=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ref=null,e.state={injectedEvents:[]},e.setRef=function(t){var n=e.props.settings,r=void 0===n?{}:n;t!==e.ref&&(e.ref&&(gl(e.ref,kl(dl(e.props),e.props,r)),gl(e.ref,e.state.injectedEvents)),e.ref=t,e.ref&&(tl(e.ref.addEventListener,"React-event-injector: Target should be EventTarget compatible, or any DOM Element"),pl(e.ref,kl(dl(e.props),e.props,r)),pl(e.ref,e.state.injectedEvents)))},e.dispatchEvent=function(){return!1},e.addEventListener=function(t,n,r){var i="on"+t;e.setState((function(t){return{injectedEvents:t.injectedEvents.concat([{name:i,cb:n,options:r}])}}))},e.removeEventListener=function(t,n,r){var i="on"+t;e.setState((function(t){return{injectedEvents:t.injectedEvents.filter((function(t){return!(t.name===i&&t.cb===n&&t.options===r)}))}}))},e}return vl(e,t),e.prototype.componentWillUnmount=function(){this.ref&&(gl(this.ref,kl(dl(this.props),this.props,this.props.settings)),gl(this.ref,this.state.injectedEvents))},e.prototype.componentDidUpdate=function(t,e){var n=this,r=this.props,i=r.pure;if(!i||i!==t.pure){var o=t.settings,a=void 0===o?{}:o,s=dl(t).filter((function(e){return t[e]!==r[e]&&t[e]}));this.ref&&gl(this.ref,kl(s,t,a));var c=this.props.settings,l=void 0===c?{}:c,u=dl(r).filter((function(e){return t[e]!==r[e]&&r[e]}));this.ref&&pl(this.ref,kl(u,r,l))}if(this.ref&&e!==this.state){s=e.injectedEvents.filter((function(t){return n.state.injectedEvents.indexOf(t)<0}));gl(this.ref,s);u=this.state.injectedEvents.filter((function(t){return e.injectedEvents.indexOf(t)<0}));pl(this.ref,u)}},e.prototype.render=function(){var t=this.props.children;return"function"==typeof t?t(this.setRef):hn.cloneElement(hn.Children.only(t),{ref:this.setRef})},e.propTypes=bl({},yl,ml),e}(hn.Component),xl=function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),Al=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t},Sl={passive:!0},Ol=(function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ref=hn.createRef(),e.addEventListener=function(t,n,r){e.ref.current&&e.ref.current.addEventListener(t,n,r)},e.removeEventListener=function(t,n,r){e.ref.current&&e.ref.current.removeEventListener(t,n,r)},e}xl(e,t),e.prototype.render=function(){return hn.createElement(wl,Al({},this.props,{settings:Sl,ref:this.ref}))},e.propTypes=Al({},yl)}(hn.Component),function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}()),El=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t},Ml={passive:!1},Cl=(function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ref=hn.createRef(),e.addEventListener=function(t,n,r){e.ref.current&&e.ref.current.addEventListener(t,n,r)},e.removeEventListener=function(t,n,r){e.ref.current&&e.ref.current.removeEventListener(t,n,r)},e}Ol(e,t),e.prototype.render=function(){return hn.createElement(wl,El({},this.props,{settings:Ml,ref:this.ref}))},e.propTypes=El({},yl)}(hn.Component),function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}()),Rl=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t},jl=function(t,e){var n={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(n[r]=t[r]);if(null!=t&&"function"==typeof Object.getOwnPropertySymbols){var i=0;for(r=Object.getOwnPropertySymbols(t);i<r.length;i++)e.indexOf(r[i])<0&&(n[r[i]]=t[r[i]])}return n};!function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.ref=hn.createRef(),e.addEventListener=function(t,n,r){e.ref.current&&e.ref.current.addEventListener(t,n,r)},e.removeEventListener=function(t,n,r){e.ref.current&&e.ref.current.removeEventListener(t,n,r)},e}Cl(e,t),e.prototype.componentDidMount=function(){this.setState({})},e.prototype.render=function(){var t=this.props,e=t.target,n=jl(t,["target"]);return hn.createElement(wl,Rl({},n,{ref:this.ref}),(function(t){return t("function"==typeof e?e():e),null}))},e.propTypes=Rl({},yl,{target:Object(zn.oneOfType)([zn.func,zn.any])})}(hn.Component);function Il(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Bl(t){return function(t){if(Array.isArray(t))return Dl(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||function(t,e){if(t){if("string"==typeof t)return Dl(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?Dl(t,e):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Dl(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}var Tl={a:7,c:6,h:1,l:2,m:2,q:4,s:4,t:2,v:1,z:0},Fl=/([astvzqmhlc])([^astvzqmhlc]*)/gi,Pl=/-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi,zl=function(t,e,n,r){var i=this;Il(this,"x0",void 0),Il(this,"x1",void 0),Il(this,"y0",void 0),Il(this,"y1",void 0),Il(this,"getTotalLength",(function(){return Math.sqrt(Math.pow(i.x0-i.x1,2)+Math.pow(i.y0-i.y1,2))})),Il(this,"getPointAtLength",(function(t){var e=t/Math.sqrt(Math.pow(i.x0-i.x1,2)+Math.pow(i.y0-i.y1,2));e=Number.isNaN(e)?1:e;var n=(i.x1-i.x0)*e,r=(i.y1-i.y0)*e;return{x:i.x0+n,y:i.y0+r}})),Il(this,"getTangentAtLength",(function(t){var e=Math.sqrt((i.x1-i.x0)*(i.x1-i.x0)+(i.y1-i.y0)*(i.y1-i.y0));return{x:(i.x1-i.x0)/e,y:(i.y1-i.y0)/e}})),Il(this,"getPropertiesAtLength",(function(t){var e=i.getPointAtLength(t),n=i.getTangentAtLength(t);return{x:e.x,y:e.y,tangentX:n.x,tangentY:n.y}})),this.x0=t,this.x1=e,this.y0=n,this.y1=r},Ql=function(t,e,n,r,i,o,a,s,c){var l=this;Il(this,"x0",void 0),Il(this,"y0",void 0),Il(this,"rx",void 0),Il(this,"ry",void 0),Il(this,"xAxisRotate",void 0),Il(this,"LargeArcFlag",void 0),Il(this,"SweepFlag",void 0),Il(this,"x1",void 0),Il(this,"y1",void 0),Il(this,"length",void 0),Il(this,"getTotalLength",(function(){return l.length})),Il(this,"getPointAtLength",(function(t){t<0?t=0:t>l.length&&(t=l.length);var e=Ll({x:l.x0,y:l.y0},l.rx,l.ry,l.xAxisRotate,l.LargeArcFlag,l.SweepFlag,{x:l.x1,y:l.y1},t/l.length);return{x:e.x,y:e.y}})),Il(this,"getTangentAtLength",(function(t){t<0?t=0:t>l.length&&(t=l.length);var e,n=.05,r=l.getPointAtLength(t);t<0?t=0:t>l.length&&(t=l.length);var i=(e=t<l.length-n?l.getPointAtLength(t+n):l.getPointAtLength(t-n)).x-r.x,o=e.y-r.y,a=Math.sqrt(i*i+o*o);return t<l.length-n?{x:-i/a,y:-o/a}:{x:i/a,y:o/a}})),Il(this,"getPropertiesAtLength",(function(t){var e=l.getTangentAtLength(t),n=l.getPointAtLength(t);return{x:n.x,y:n.y,tangentX:e.x,tangentY:e.y}})),this.x0=t,this.y0=e,this.rx=n,this.ry=r,this.xAxisRotate=i,this.LargeArcFlag=o,this.SweepFlag=a,this.x1=s,this.y1=c;var u=Yl(300,(function(l){return Ll({x:t,y:e},n,r,i,o,a,{x:s,y:c},l)}));this.length=u.arcLength},Ll=function(t,e,n,r,i,o,a,s){e=Math.abs(e),n=Math.abs(n),r=Wl(r,360);var c=ql(r);if(t.x===a.x&&t.y===a.y)return{x:t.x,y:t.y,ellipticalArcAngle:0};if(0===e||0===n)return{x:0,y:0,ellipticalArcAngle:0};var l=(t.x-a.x)/2,u=(t.y-a.y)/2,d={x:Math.cos(c)*l+Math.sin(c)*u,y:-Math.sin(c)*l+Math.cos(c)*u},f=Math.pow(d.x,2)/Math.pow(e,2)+Math.pow(d.y,2)/Math.pow(n,2);f>1&&(e=Math.sqrt(f)*e,n=Math.sqrt(f)*n);var h=(Math.pow(e,2)*Math.pow(n,2)-Math.pow(e,2)*Math.pow(d.y,2)-Math.pow(n,2)*Math.pow(d.x,2))/(Math.pow(e,2)*Math.pow(d.y,2)+Math.pow(n,2)*Math.pow(d.x,2));h=h<0?0:h;var p=(i!==o?1:-1)*Math.sqrt(h),g=p*(e*d.y/n),m=p*(-n*d.x/e),y={x:Math.cos(c)*g-Math.sin(c)*m+(t.x+a.x)/2,y:Math.sin(c)*g+Math.cos(c)*m+(t.y+a.y)/2},v={x:(d.x-g)/e,y:(d.y-m)/n},b=Jl({x:1,y:0},v),k=Jl(v,{x:(-d.x-g)/e,y:(-d.y-m)/n});!o&&k>0?k-=2*Math.PI:o&&k<0&&(k+=2*Math.PI);var w=b+(k%=2*Math.PI)*s,x=e*Math.cos(w),A=n*Math.sin(w);return{x:Math.cos(c)*x-Math.sin(c)*A+y.x,y:Math.sin(c)*x+Math.cos(c)*A+y.y,ellipticalArcStartAngle:b,ellipticalArcEndAngle:b+k,ellipticalArcAngle:w,ellipticalArcCenter:y,resultantRx:e,resultantRy:n}},Yl=function(t,e){t=t||500;for(var n,r=0,i=[],o=[],a=e(0),s=0;s<t;s++){var c=Gl(s*(1/t),0,1);n=e(c),r+=Nl(a,n),o.push([a,n]),i.push({t:c,arcLength:r}),a=n}return n=e(1),o.push([a,n]),r+=Nl(a,n),i.push({t:1,arcLength:r}),{arcLength:r,arcLengthMap:i,approximationLines:o}},Wl=function(t,e){return(t%e+e)%e},ql=function(t){return t*(Math.PI/180)},Nl=function(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))},Gl=function(t,e,n){return Math.min(Math.max(t,e),n)},Jl=function(t,e){var n=t.x*e.x+t.y*e.y,r=Math.sqrt((Math.pow(t.x,2)+Math.pow(t.y,2))*(Math.pow(e.x,2)+Math.pow(e.y,2)));return(t.x*e.y-t.y*e.x<0?-1:1)*Math.acos(n/r)},Ul=[[],[],[-.5773502691896257,.5773502691896257],[0,-.7745966692414834,.7745966692414834],[-.33998104358485626,.33998104358485626,-.8611363115940526,.8611363115940526],[0,-.5384693101056831,.5384693101056831,-.906179845938664,.906179845938664],[.6612093864662645,-.6612093864662645,-.2386191860831969,.2386191860831969,-.932469514203152,.932469514203152],[0,.4058451513773972,-.4058451513773972,-.7415311855993945,.7415311855993945,-.9491079123427585,.9491079123427585],[-.1834346424956498,.1834346424956498,-.525532409916329,.525532409916329,-.7966664774136267,.7966664774136267,-.9602898564975363,.9602898564975363],[0,-.8360311073266358,.8360311073266358,-.9681602395076261,.9681602395076261,-.3242534234038089,.3242534234038089,-.6133714327005904,.6133714327005904],[-.14887433898163122,.14887433898163122,-.4333953941292472,.4333953941292472,-.6794095682990244,.6794095682990244,-.8650633666889845,.8650633666889845,-.9739065285171717,.9739065285171717],[0,-.26954315595234496,.26954315595234496,-.5190961292068118,.5190961292068118,-.7301520055740494,.7301520055740494,-.8870625997680953,.8870625997680953,-.978228658146057,.978228658146057],[-.1252334085114689,.1252334085114689,-.3678314989981802,.3678314989981802,-.5873179542866175,.5873179542866175,-.7699026741943047,.7699026741943047,-.9041172563704749,.9041172563704749,-.9815606342467192,.9815606342467192],[0,-.2304583159551348,.2304583159551348,-.44849275103644687,.44849275103644687,-.6423493394403402,.6423493394403402,-.8015780907333099,.8015780907333099,-.9175983992229779,.9175983992229779,-.9841830547185881,.9841830547185881],[-.10805494870734367,.10805494870734367,-.31911236892788974,.31911236892788974,-.5152486363581541,.5152486363581541,-.6872929048116855,.6872929048116855,-.827201315069765,.827201315069765,-.9284348836635735,.9284348836635735,-.9862838086968123,.9862838086968123],[0,-.20119409399743451,.20119409399743451,-.3941513470775634,.3941513470775634,-.5709721726085388,.5709721726085388,-.7244177313601701,.7244177313601701,-.8482065834104272,.8482065834104272,-.937273392400706,.937273392400706,-.9879925180204854,.9879925180204854],[-.09501250983763744,.09501250983763744,-.2816035507792589,.2816035507792589,-.45801677765722737,.45801677765722737,-.6178762444026438,.6178762444026438,-.755404408355003,.755404408355003,-.8656312023878318,.8656312023878318,-.9445750230732326,.9445750230732326,-.9894009349916499,.9894009349916499],[0,-.17848418149584785,.17848418149584785,-.3512317634538763,.3512317634538763,-.5126905370864769,.5126905370864769,-.6576711592166907,.6576711592166907,-.7815140038968014,.7815140038968014,-.8802391537269859,.8802391537269859,-.9506755217687678,.9506755217687678,-.9905754753144174,.9905754753144174],[-.0847750130417353,.0847750130417353,-.2518862256915055,.2518862256915055,-.41175116146284263,.41175116146284263,-.5597708310739475,.5597708310739475,-.6916870430603532,.6916870430603532,-.8037049589725231,.8037049589725231,-.8926024664975557,.8926024664975557,-.9558239495713977,.9558239495713977,-.9915651684209309,.9915651684209309],[0,-.16035864564022537,.16035864564022537,-.31656409996362983,.31656409996362983,-.46457074137596094,.46457074137596094,-.600545304661681,.600545304661681,-.7209661773352294,.7209661773352294,-.8227146565371428,.8227146565371428,-.9031559036148179,.9031559036148179,-.96020815213483,.96020815213483,-.9924068438435844,.9924068438435844],[-.07652652113349734,.07652652113349734,-.22778585114164507,.22778585114164507,-.37370608871541955,.37370608871541955,-.5108670019508271,.5108670019508271,-.636053680726515,.636053680726515,-.7463319064601508,.7463319064601508,-.8391169718222188,.8391169718222188,-.912234428251326,.912234428251326,-.9639719272779138,.9639719272779138,-.9931285991850949,.9931285991850949],[0,-.1455618541608951,.1455618541608951,-.2880213168024011,.2880213168024011,-.4243421202074388,.4243421202074388,-.5516188358872198,.5516188358872198,-.6671388041974123,.6671388041974123,-.7684399634756779,.7684399634756779,-.8533633645833173,.8533633645833173,-.9200993341504008,.9200993341504008,-.9672268385663063,.9672268385663063,-.9937521706203895,.9937521706203895],[-.06973927331972223,.06973927331972223,-.20786042668822127,.20786042668822127,-.34193582089208424,.34193582089208424,-.469355837986757,.469355837986757,-.5876404035069116,.5876404035069116,-.6944872631866827,.6944872631866827,-.7878168059792081,.7878168059792081,-.8658125777203002,.8658125777203002,-.926956772187174,.926956772187174,-.9700604978354287,.9700604978354287,-.9942945854823992,.9942945854823992],[0,-.1332568242984661,.1332568242984661,-.26413568097034495,.26413568097034495,-.3903010380302908,.3903010380302908,-.5095014778460075,.5095014778460075,-.6196098757636461,.6196098757636461,-.7186613631319502,.7186613631319502,-.8048884016188399,.8048884016188399,-.8767523582704416,.8767523582704416,-.9329710868260161,.9329710868260161,-.9725424712181152,.9725424712181152,-.9947693349975522,.9947693349975522],[-.06405689286260563,.06405689286260563,-.1911188674736163,.1911188674736163,-.3150426796961634,.3150426796961634,-.4337935076260451,.4337935076260451,-.5454214713888396,.5454214713888396,-.6480936519369755,.6480936519369755,-.7401241915785544,.7401241915785544,-.820001985973903,.820001985973903,-.8864155270044011,.8864155270044011,-.9382745520027328,.9382745520027328,-.9747285559713095,.9747285559713095,-.9951872199970213,.9951872199970213]],Kl=[[],[],[1,1],[.8888888888888888,.5555555555555556,.5555555555555556],[.6521451548625461,.6521451548625461,.34785484513745385,.34785484513745385],[.5688888888888889,.47862867049936647,.47862867049936647,.23692688505618908,.23692688505618908],[.3607615730481386,.3607615730481386,.46791393457269104,.46791393457269104,.17132449237917036,.17132449237917036],[.4179591836734694,.3818300505051189,.3818300505051189,.27970539148927664,.27970539148927664,.1294849661688697,.1294849661688697],[.362683783378362,.362683783378362,.31370664587788727,.31370664587788727,.22238103445337448,.22238103445337448,.10122853629037626,.10122853629037626],[.3302393550012598,.1806481606948574,.1806481606948574,.08127438836157441,.08127438836157441,.31234707704000286,.31234707704000286,.26061069640293544,.26061069640293544],[.29552422471475287,.29552422471475287,.26926671930999635,.26926671930999635,.21908636251598204,.21908636251598204,.1494513491505806,.1494513491505806,.06667134430868814,.06667134430868814],[.2729250867779006,.26280454451024665,.26280454451024665,.23319376459199048,.23319376459199048,.18629021092773426,.18629021092773426,.1255803694649046,.1255803694649046,.05566856711617366,.05566856711617366],[.24914704581340277,.24914704581340277,.2334925365383548,.2334925365383548,.20316742672306592,.20316742672306592,.16007832854334622,.16007832854334622,.10693932599531843,.10693932599531843,.04717533638651183,.04717533638651183],[.2325515532308739,.22628318026289723,.22628318026289723,.2078160475368885,.2078160475368885,.17814598076194574,.17814598076194574,.13887351021978725,.13887351021978725,.09212149983772845,.09212149983772845,.04048400476531588,.04048400476531588],[.2152638534631578,.2152638534631578,.2051984637212956,.2051984637212956,.18553839747793782,.18553839747793782,.15720316715819355,.15720316715819355,.12151857068790319,.12151857068790319,.08015808715976021,.08015808715976021,.03511946033175186,.03511946033175186],[.2025782419255613,.19843148532711158,.19843148532711158,.1861610000155622,.1861610000155622,.16626920581699392,.16626920581699392,.13957067792615432,.13957067792615432,.10715922046717194,.10715922046717194,.07036604748810812,.07036604748810812,.03075324199611727,.03075324199611727],[.1894506104550685,.1894506104550685,.18260341504492358,.18260341504492358,.16915651939500254,.16915651939500254,.14959598881657674,.14959598881657674,.12462897125553388,.12462897125553388,.09515851168249279,.09515851168249279,.062253523938647894,.062253523938647894,.027152459411754096,.027152459411754096],[.17944647035620653,.17656270536699264,.17656270536699264,.16800410215645004,.16800410215645004,.15404576107681028,.15404576107681028,.13513636846852548,.13513636846852548,.11188384719340397,.11188384719340397,.08503614831717918,.08503614831717918,.0554595293739872,.0554595293739872,.02414830286854793,.02414830286854793],[.1691423829631436,.1691423829631436,.16427648374583273,.16427648374583273,.15468467512626524,.15468467512626524,.14064291467065065,.14064291467065065,.12255520671147846,.12255520671147846,.10094204410628717,.10094204410628717,.07642573025488905,.07642573025488905,.0497145488949698,.0497145488949698,.02161601352648331,.02161601352648331],[.1610544498487837,.15896884339395434,.15896884339395434,.15276604206585967,.15276604206585967,.1426067021736066,.1426067021736066,.12875396253933621,.12875396253933621,.11156664554733399,.11156664554733399,.09149002162245,.09149002162245,.06904454273764123,.06904454273764123,.0448142267656996,.0448142267656996,.019461788229726478,.019461788229726478],[.15275338713072584,.15275338713072584,.14917298647260374,.14917298647260374,.14209610931838204,.14209610931838204,.13168863844917664,.13168863844917664,.11819453196151841,.11819453196151841,.10193011981724044,.10193011981724044,.08327674157670475,.08327674157670475,.06267204833410907,.06267204833410907,.04060142980038694,.04060142980038694,.017614007139152118,.017614007139152118],[.14608113364969041,.14452440398997005,.14452440398997005,.13988739479107315,.13988739479107315,.13226893863333747,.13226893863333747,.12183141605372853,.12183141605372853,.10879729916714838,.10879729916714838,.09344442345603386,.09344442345603386,.0761001136283793,.0761001136283793,.057134425426857205,.057134425426857205,.036953789770852494,.036953789770852494,.016017228257774335,.016017228257774335],[.13925187285563198,.13925187285563198,.13654149834601517,.13654149834601517,.13117350478706238,.13117350478706238,.12325237681051242,.12325237681051242,.11293229608053922,.11293229608053922,.10041414444288096,.10041414444288096,.08594160621706773,.08594160621706773,.06979646842452049,.06979646842452049,.052293335152683286,.052293335152683286,.03377490158481415,.03377490158481415,.0146279952982722,.0146279952982722],[.13365457218610619,.1324620394046966,.1324620394046966,.12890572218808216,.12890572218808216,.12304908430672953,.12304908430672953,.11499664022241136,.11499664022241136,.10489209146454141,.10489209146454141,.09291576606003515,.09291576606003515,.07928141177671895,.07928141177671895,.06423242140852585,.06423242140852585,.04803767173108467,.04803767173108467,.030988005856979445,.030988005856979445,.013411859487141771,.013411859487141771],[.12793819534675216,.12793819534675216,.1258374563468283,.1258374563468283,.12167047292780339,.12167047292780339,.1155056680537256,.1155056680537256,.10744427011596563,.10744427011596563,.09761865210411388,.09761865210411388,.08619016153195327,.08619016153195327,.0733464814110803,.0733464814110803,.05929858491543678,.05929858491543678,.04427743881741981,.04427743881741981,.028531388628933663,.028531388628933663,.0123412297999872,.0123412297999872]],Hl=[[1],[1,1],[1,2,1],[1,3,3,1]],Vl=function(t,e,n){return{x:(1-n)*(1-n)*(1-n)*t[0]+3*(1-n)*(1-n)*n*t[1]+3*(1-n)*n*n*t[2]+n*n*n*t[3],y:(1-n)*(1-n)*(1-n)*e[0]+3*(1-n)*(1-n)*n*e[1]+3*(1-n)*n*n*e[2]+n*n*n*e[3]}},Zl=function(t,e,n){return _l([3*(t[1]-t[0]),3*(t[2]-t[1]),3*(t[3]-t[2])],[3*(e[1]-e[0]),3*(e[2]-e[1]),3*(e[3]-e[2])],n)},Xl=function(t,e,n){var r,i,o;r=n/2,i=0;for(var a=0;a<20;a++)o=r*Ul[20][a]+r,i+=Kl[20][a]*eu(t,e,o);return r*i},_l=function(t,e,n){return{x:(1-n)*(1-n)*t[0]+2*(1-n)*n*t[1]+n*n*t[2],y:(1-n)*(1-n)*e[0]+2*(1-n)*n*e[1]+n*n*e[2]}},$l=function(t,e,n){void 0===n&&(n=1);var r=t[0]-2*t[1]+t[2],i=e[0]-2*e[1]+e[2],o=2*t[1]-2*t[0],a=2*e[1]-2*e[0],s=4*(r*r+i*i),c=4*(r*o+i*a),l=o*o+a*a;if(0===s)return n*Math.sqrt(Math.pow(t[2]-t[0],2)+Math.pow(e[2]-e[0],2));var u=c/(2*s),d=n+u,f=l/s-u*u,h=d*d+f>0?Math.sqrt(d*d+f):0,p=u*u+f>0?Math.sqrt(u*u+f):0,g=u+Math.sqrt(u*u+f)!==0?f*Math.log(Math.abs((d+h)/(u+p))):0;return Math.sqrt(s)/2*(d*h-u*p+g)},tu=function(t,e,n){return{x:2*(1-n)*(t[1]-t[0])+2*n*(t[2]-t[1]),y:2*(1-n)*(e[1]-e[0])+2*n*(e[2]-e[1])}};function eu(t,e,n){var r=nu(1,n,t),i=nu(1,n,e),o=r*r+i*i;return Math.sqrt(o)}var nu=function t(e,n,r){var i,o,a=r.length-1;if(0===a)return 0;if(0===e){o=0;for(var s=0;s<=a;s++)o+=Hl[a][s]*Math.pow(1-n,a-s)*Math.pow(n,s)*r[s];return o}i=new Array(a);for(var c=0;c<a;c++)i[c]=a*(r[c+1]-r[c]);return t(e-1,n,i)},ru=function(t,e,n){for(var r=1,i=t/e,o=(t-n(i))/e,a=0;r>.001;){var s=n(i+o),c=Math.abs(t-s)/e;if(c<r)r=c,i+=o;else{var l=n(i-o),u=Math.abs(t-l)/e;u<r?(r=u,i-=o):o/=2}if(++a>500)break}return i},iu=function(t,e,n,r,i,o,a,s){var c=this;Il(this,"a",void 0),Il(this,"b",void 0),Il(this,"c",void 0),Il(this,"d",void 0),Il(this,"length",void 0),Il(this,"getArcLength",void 0),Il(this,"getPoint",void 0),Il(this,"getDerivative",void 0),Il(this,"getTotalLength",(function(){return c.length})),Il(this,"getPointAtLength",(function(t){var e=[c.a.x,c.b.x,c.c.x,c.d.x],n=[c.a.y,c.b.y,c.c.y,c.d.y],r=ru(t,c.length,(function(t){return c.getArcLength(e,n,t)}));return c.getPoint(e,n,r)})),Il(this,"getTangentAtLength",(function(t){var e=[c.a.x,c.b.x,c.c.x,c.d.x],n=[c.a.y,c.b.y,c.c.y,c.d.y],r=ru(t,c.length,(function(t){return c.getArcLength(e,n,t)})),i=c.getDerivative(e,n,r),o=Math.sqrt(i.x*i.x+i.y*i.y);return o>0?{x:i.x/o,y:i.y/o}:{x:0,y:0}})),Il(this,"getPropertiesAtLength",(function(t){var e,n=[c.a.x,c.b.x,c.c.x,c.d.x],r=[c.a.y,c.b.y,c.c.y,c.d.y],i=ru(t,c.length,(function(t){return c.getArcLength(n,r,t)})),o=c.getDerivative(n,r,i),a=Math.sqrt(o.x*o.x+o.y*o.y);e=a>0?{x:o.x/a,y:o.y/a}:{x:0,y:0};var s=c.getPoint(n,r,i);return{x:s.x,y:s.y,tangentX:e.x,tangentY:e.y}})),Il(this,"getC",(function(){return c.c})),Il(this,"getD",(function(){return c.d})),this.a={x:t,y:e},this.b={x:n,y:r},this.c={x:i,y:o},void 0!==a&&void 0!==s?(this.getArcLength=Xl,this.getPoint=Vl,this.getDerivative=Zl,this.d={x:a,y:s}):(this.getArcLength=$l,this.getPoint=_l,this.getDerivative=tu,this.d={x:0,y:0}),this.length=this.getArcLength([this.a.x,this.b.x,this.c.x,this.d.x],[this.a.y,this.b.y,this.c.y,this.d.y],1)},ou=function(t){var e=this;Il(this,"length",0),Il(this,"partial_lengths",[]),Il(this,"functions",[]),Il(this,"initial_point",null),Il(this,"getPartAtLength",(function(t){t<0?t=0:t>e.length&&(t=e.length);for(var n=e.partial_lengths.length-1;e.partial_lengths[n]>=t&&n>0;)n--;return n++,{fraction:t-e.partial_lengths[n-1],i:n}})),Il(this,"getTotalLength",(function(){return e.length})),Il(this,"getPointAtLength",(function(t){var n=e.getPartAtLength(t),r=e.functions[n.i];if(r)return r.getPointAtLength(n.fraction);if(e.initial_point)return e.initial_point;throw new Error("Wrong function at this part.")})),Il(this,"getTangentAtLength",(function(t){var n=e.getPartAtLength(t),r=e.functions[n.i];if(r)return r.getTangentAtLength(n.fraction);if(e.initial_point)return{x:0,y:0};throw new Error("Wrong function at this part.")})),Il(this,"getPropertiesAtLength",(function(t){var n=e.getPartAtLength(t),r=e.functions[n.i];if(r)return r.getPropertiesAtLength(n.fraction);if(e.initial_point)return{x:e.initial_point.x,y:e.initial_point.y,tangentX:0,tangentY:0};throw new Error("Wrong function at this part.")})),Il(this,"getParts",(function(){for(var t=[],n=0;n<e.functions.length;n++)if(null!==e.functions[n]){e.functions[n]=e.functions[n];var r={start:e.functions[n].getPointAtLength(0),end:e.functions[n].getPointAtLength(e.partial_lengths[n]-e.partial_lengths[n-1]),length:e.partial_lengths[n]-e.partial_lengths[n-1],getPointAtLength:e.functions[n].getPointAtLength,getTangentAtLength:e.functions[n].getTangentAtLength,getPropertiesAtLength:e.functions[n].getPropertiesAtLength};t.push(r)}return t}));for(var n,r=function(t){var e=(t&&t.length>0?t:"M0,0").match(Fl);if(!e)throw new Error("No path elements found in string ".concat(t));return e.reduce((function(t,e){var n=e.charAt(0),r=n.toLowerCase(),i=function(t){var e=t.match(Pl);return e?e.map(Number):[]}(e.substr(1));for("m"===r&&i.length>2&&(t.push([n].concat(Bl(i.splice(0,2)))),r="l",n="m"===n?"l":"L");i.length>=0;){if(i.length===Tl[r]){t.push([n].concat(Bl(i.splice(0,Tl[r]))));break}if(i.length<Tl[r])throw new Error('Malformed path data: "'.concat(n,'" must have ').concat(Tl[r]," elements and has ").concat(i.length,": ").concat(e));t.push([n].concat(Bl(i.splice(0,Tl[r]))))}return t}),[])}(t),i=[0,0],o=[0,0],a=[0,0],s=0;s<r.length;s++){if("M"===r[s][0])a=[(i=[r[s][1],r[s][2]])[0],i[1]],this.functions.push(null),0===s&&(this.initial_point={x:r[s][1],y:r[s][2]});else if("m"===r[s][0])a=[(i=[r[s][1]+i[0],r[s][2]+i[1]])[0],i[1]],this.functions.push(null);else if("L"===r[s][0])this.length+=Math.sqrt(Math.pow(i[0]-r[s][1],2)+Math.pow(i[1]-r[s][2],2)),this.functions.push(new zl(i[0],r[s][1],i[1],r[s][2])),i=[r[s][1],r[s][2]];else if("l"===r[s][0])this.length+=Math.sqrt(Math.pow(r[s][1],2)+Math.pow(r[s][2],2)),this.functions.push(new zl(i[0],r[s][1]+i[0],i[1],r[s][2]+i[1])),i=[r[s][1]+i[0],r[s][2]+i[1]];else if("H"===r[s][0])this.length+=Math.abs(i[0]-r[s][1]),this.functions.push(new zl(i[0],r[s][1],i[1],i[1])),i[0]=r[s][1];else if("h"===r[s][0])this.length+=Math.abs(r[s][1]),this.functions.push(new zl(i[0],i[0]+r[s][1],i[1],i[1])),i[0]=r[s][1]+i[0];else if("V"===r[s][0])this.length+=Math.abs(i[1]-r[s][1]),this.functions.push(new zl(i[0],i[0],i[1],r[s][1])),i[1]=r[s][1];else if("v"===r[s][0])this.length+=Math.abs(r[s][1]),this.functions.push(new zl(i[0],i[0],i[1],i[1]+r[s][1])),i[1]=r[s][1]+i[1];else if("z"===r[s][0]||"Z"===r[s][0])this.length+=Math.sqrt(Math.pow(a[0]-i[0],2)+Math.pow(a[1]-i[1],2)),this.functions.push(new zl(i[0],a[0],i[1],a[1])),i=[a[0],a[1]];else if("C"===r[s][0])n=new iu(i[0],i[1],r[s][1],r[s][2],r[s][3],r[s][4],r[s][5],r[s][6]),this.length+=n.getTotalLength(),i=[r[s][5],r[s][6]],this.functions.push(n);else if("c"===r[s][0])(n=new iu(i[0],i[1],i[0]+r[s][1],i[1]+r[s][2],i[0]+r[s][3],i[1]+r[s][4],i[0]+r[s][5],i[1]+r[s][6])).getTotalLength()>0?(this.length+=n.getTotalLength(),this.functions.push(n),i=[r[s][5]+i[0],r[s][6]+i[1]]):this.functions.push(new zl(i[0],i[0],i[1],i[1]));else if("S"===r[s][0]){if(s>0&&["C","c","S","s"].indexOf(r[s-1][0])>-1){if(n){var c=n.getC();n=new iu(i[0],i[1],2*i[0]-c.x,2*i[1]-c.y,r[s][1],r[s][2],r[s][3],r[s][4])}}else n=new iu(i[0],i[1],i[0],i[1],r[s][1],r[s][2],r[s][3],r[s][4]);n&&(this.length+=n.getTotalLength(),i=[r[s][3],r[s][4]],this.functions.push(n))}else if("s"===r[s][0]){if(s>0&&["C","c","S","s"].indexOf(r[s-1][0])>-1){if(n){var l=n.getC(),u=n.getD();n=new iu(i[0],i[1],i[0]+u.x-l.x,i[1]+u.y-l.y,i[0]+r[s][1],i[1]+r[s][2],i[0]+r[s][3],i[1]+r[s][4])}}else n=new iu(i[0],i[1],i[0],i[1],i[0]+r[s][1],i[1]+r[s][2],i[0]+r[s][3],i[1]+r[s][4]);n&&(this.length+=n.getTotalLength(),i=[r[s][3]+i[0],r[s][4]+i[1]],this.functions.push(n))}else if("Q"===r[s][0]){if(i[0]==r[s][1]&&i[1]==r[s][2]){var d=new zl(r[s][1],r[s][3],r[s][2],r[s][4]);this.length+=d.getTotalLength(),this.functions.push(d)}else n=new iu(i[0],i[1],r[s][1],r[s][2],r[s][3],r[s][4],void 0,void 0),this.length+=n.getTotalLength(),this.functions.push(n);i=[r[s][3],r[s][4]],o=[r[s][1],r[s][2]]}else if("q"===r[s][0]){if(0!=r[s][1]||0!=r[s][2])n=new iu(i[0],i[1],i[0]+r[s][1],i[1]+r[s][2],i[0]+r[s][3],i[1]+r[s][4],void 0,void 0),this.length+=n.getTotalLength(),this.functions.push(n);else{var f=new zl(i[0]+r[s][1],i[0]+r[s][3],i[1]+r[s][2],i[1]+r[s][4]);this.length+=f.getTotalLength(),this.functions.push(f)}o=[i[0]+r[s][1],i[1]+r[s][2]],i=[r[s][3]+i[0],r[s][4]+i[1]]}else if("T"===r[s][0]){if(s>0&&["Q","q","T","t"].indexOf(r[s-1][0])>-1)n=new iu(i[0],i[1],2*i[0]-o[0],2*i[1]-o[1],r[s][1],r[s][2],void 0,void 0),this.functions.push(n),this.length+=n.getTotalLength();else{var h=new zl(i[0],r[s][1],i[1],r[s][2]);this.functions.push(h),this.length+=h.getTotalLength()}o=[2*i[0]-o[0],2*i[1]-o[1]],i=[r[s][1],r[s][2]]}else if("t"===r[s][0]){if(s>0&&["Q","q","T","t"].indexOf(r[s-1][0])>-1)n=new iu(i[0],i[1],2*i[0]-o[0],2*i[1]-o[1],i[0]+r[s][1],i[1]+r[s][2],void 0,void 0),this.length+=n.getTotalLength(),this.functions.push(n);else{var p=new zl(i[0],i[0]+r[s][1],i[1],i[1]+r[s][2]);this.length+=p.getTotalLength(),this.functions.push(p)}o=[2*i[0]-o[0],2*i[1]-o[1]],i=[r[s][1]+i[0],r[s][2]+i[0]]}else if("A"===r[s][0]){var g=new Ql(i[0],i[1],r[s][1],r[s][2],r[s][3],1===r[s][4],1===r[s][5],r[s][6],r[s][7]);this.length+=g.getTotalLength(),i=[r[s][6],r[s][7]],this.functions.push(g)}else if("a"===r[s][0]){var m=new Ql(i[0],i[1],r[s][1],r[s][2],r[s][3],1===r[s][4],1===r[s][5],i[0]+r[s][6],i[1]+r[s][7]);this.length+=m.getTotalLength(),i=[i[0]+r[s][6],i[1]+r[s][7]],this.functions.push(m)}this.partial_lengths.push(this.length)}},au=function(t){var e=this;if(Il(this,"inst",void 0),Il(this,"getTotalLength",(function(){return e.inst.getTotalLength()})),Il(this,"getPointAtLength",(function(t){return e.inst.getPointAtLength(t)})),Il(this,"getTangentAtLength",(function(t){return e.inst.getTangentAtLength(t)})),Il(this,"getPropertiesAtLength",(function(t){return e.inst.getPropertiesAtLength(t)})),Il(this,"getParts",(function(){return e.inst.getParts()})),this.inst=new ou(t),!(this instanceof au))return new au(t)};function su(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function cu(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?su(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):su(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var lu=function(t){var e=t.data,n=t.transitionDuration,r=void 0===n?250:n,o=t.onClick,a=void 0===o?function(){}:o,s=t.onMouseOver,c=void 0===s?function(){}:s,l=t.onMouseOut,d=void 0===l?function(){}:l,f=t.transitionControllers,h=void 0===f?{}:f,p=pa(e.map((function(t,e){var n=t.x,r=void 0===n?0:n,i=t.y,o=void 0===i?0:i,a=t.title,s=void 0===a?"":a,c=t.position,l=void 0===c?"above":c,u=t.color,d=t.showTitleOnChart,f=void 0===d||d,h=t.opacity,p=void 0===h?1:h,g=t.fontSize,m=void 0===g?13:g;return{key:s||e,x:r,y:o,textPosition:o+23*("below"===l?1:-1),title:s,position:l,color:Ji(u,"#5E5E5E"),labelOpacity:f?1:0,opacity:p,innerRadius:5,outerRadius:10,fontSize:m}})),(function(t){return t.key}),{config:{easing:C.easeQuad,duration:r},initial:function(t){return t},from:function(t){return cu(cu({},t),{},{opacity:0,labelOpacity:0})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,h.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(cu(cu({},t),{},{opacity:0,labelOpacity:0}),n,r,h.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(t,n,r,h.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",{className:"annotations"},p((function(t,e,n,r){if(t){var i=t.x,o=t.y,s=(t.position,t.textPosition),l=t.color,u=t.opacity,f=t.innerRadius,h=t.outerRadius,p=t.fontSize,g=t.labelOpacity;return pn.a.createElement(Xn.animated.g,{key:e.key,opacity:u},pn.a.createElement(Xn.animated.circle,{cx:i,cy:o,r:h,fill:l,fillOpacity:.3,stroke:l,strokeWidth:1,onMouseOver:function(t){return c(t,r)},onMouseOut:function(t){return d(t,r)},onClick:function(t){return a(t,r)}}),pn.a.createElement(Xn.animated.circle,{cx:i,cy:o,r:f,fill:l,pointerEvents:"none"}),pn.a.createElement(Xn.animated.text,{textAnchor:"middle",dominantBaseline:"text-top",x:i,y:s,fontSize:p,dy:"0.35em",fill:"#212121",opacity:g,pointerEvents:"none"},e.title))}})))};lu.propTypes={data:Object(zn.arrayOf)(Object(zn.shape)({title:zn.string.isRequired,x:zn.number.isRequired,y:zn.number.isRequired,showTitleOnChart:zn.bool,position:Object(zn.oneOf)(["above","below"]),color:zn.string,fontSize:zn.number,opacity:zn.number,radius:zn.number})).isRequired,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var uu=lu;function du(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function fu(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?du(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):du(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var hu=function(t){var e,n,r=t.lines,o=void 0===r?[]:r,a=t.transitionDuration,s=void 0===a?250:a,c=t.transitionControllers,l=void 0===c?{}:c,d=t.onMouseOver,h=void 0===d?function(){}:d,p=t.onMouseMove,g=void 0===p?function(){}:p,m=t.onMouseOut,y=void 0===m?function(){}:m,v=t.onClick,b=void 0===v?function(){}:v,k=Object(hn.useState)([]),w=M()(k,2),x=w[0],A=w[1],S=Object(hn.useRef)([]),O=Object(hn.useRef)(),E=Object(hn.useRef)();n=x,(e=o).length===n.length&&e.every((function(t,e){var r=t||{},i=r.cap,o=void 0===i?"":i,a=r.clipPath,s=void 0===a?"":a,c=r.color,l=void 0===c?"":c,u=r.cursor,d=void 0===u?"":u,f=r.durationMultiplier,h=void 0===f?"":f,p=r.endMarker,g=void 0===p?"":p,m=r.id,y=void 0===m?"":m,v=r.line,b=void 0===v?"":v,k=r.opacity,w=void 0===k?"":k,x=r.style,A=void 0===x?"":x,S=r.weight,O=void 0===S?"":S,E=n[e]||{},M=E.cap,C=void 0===M?"":M,R=E.clipPath,j=void 0===R?"":R,I=E.color,B=void 0===I?"":I,D=E.cursor,T=void 0===D?"":D,F=E.durationMultiplier,P=void 0===F?"":F,z=E.endMarker,Q=void 0===z?"":z,L=E.id,Y=void 0===L?"":L,W=E.line,q=void 0===W?"":W,N=E.opacity,G=void 0===N?"":N,J=E.style,U=void 0===J?"":J,K=E.weight;return o===C&&s===j&&l===B&&d===T&&g===Q&&y===Y&&b===q&&h===P&&w===G&&A===U&&O===(void 0===K?"":K)}))||(S.current=x,E.current=o.map((function(t){var e=t.line,n=t.id,r=S.current.find((function(t){var e=t.id;return n===e}));return{interpolator:void 0!==r?pe(r.line,e):function(){return e},id:n}})),O.current=o.map((function(t){var e=t.clipPath,n=t.id,r=S.current.find((function(t){var e=t.id;return n===e}));return{interpolator:void 0!==r?pe(r.clipPath,e):function(){return e},id:n}})),A(o.map((function(t){return{cap:t.cap,clipPath:t.clipPath,color:t.color,cursor:t.cursor,durationMultiplier:t.durationMultiplier,endMarker:t.endMarker,id:t.id,line:t.line,opacity:t.opacity,style:t.style,weight:t.weight}}))));var C=Object(hn.useMemo)((function(){return x.map((function(t,e){var n=t.cap,r=void 0===n?"round":n,i=t.clipPath,o=t.color,a=t.cursor,s=t.endMarker,c=t.id,l=t.opacity,u=void 0===l?1:l,d=t.style,f=void 0===d?"solid":d,h=t.weight,p=void 0===h?4:h,g="0 0";return"dot"===f?g="1 ".concat(2*p):"dash"===f&&(g="".concat(2*p," ").concat(2*p)),{cap:r,clipPath:i,color:Ni[o]||o||Gi[e],cursor:null!=a?a:E.current.length>1?"pointer":"default",endMarkerX:s?s.x:0,endMarkerY:s?s.y:0,endMarkerColor:s?s.color:"",endMarkerWeight:s?s.weight:0,key:c,opacity:u,strokeDasharray:g,weight:p}}))}),[x]),R=pa(C.map((function(t){return t})),(function(t){return t.key}),{expires:!1,config:{duration:s,easing:Ia},initial:function(t){return t},from:function(t){return fu(fu({},t),{},{opacity:0})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(fu({},t),n,r,l.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(fu(fu({},t),{},{opacity:0}),n,r,l.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(fu({},t),n,r,l.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}});return pn.a.createElement("g",{className:"lines"},Object(hn.useMemo)((function(){return R((function(t,e,n,r){var i=(E.current.find((function(t){return t.id===e.key}))||{}).interpolator,o=(O.current.find((function(t){return t.id===e.key}))||{}).interpolator,a=(x.find((function(t){return t.id===e.key}))||{}).durationMultiplier,c=void 0===a?1:a,l=f.a.uniqueId("".concat(e.key,"_mask_"));return f.a.keys(t).length&&pn.a.createElement(Xn.Spring,{reset:!0,from:{t:0},to:{t:1},config:{duration:Math.round(c*s)}},(function(n){var a=n.t;return pn.a.createElement("g",null,e.clipPath&&pn.a.createElement("clipPath",{id:l},pn.a.createElement(Xn.animated.path,{strokeWidth:0,d:void 0!==o?a.to(o):S.current.find((function(t){return t.id===e.key})).clipPath})),pn.a.createElement(Xn.animated.path,{className:"renderedPath",key:e.key,fill:"none",stroke:t.color,strokeWidth:t.weight,strokeLinecap:t.cap,strokeLinejoin:"round",strokeDasharray:t.strokeDasharray,clipPath:"url(#".concat(l,")"),d:void 0!==i?a.to(i):S.current.find((function(t){return t.id===e.key})).line,style:{opacity:t.opacity,cursor:e.cursor},onMouseOver:function(t){return h(t,r)},onMouseMove:function(t){return g(t,r)},onMouseOut:function(t){return y(t,r)},onClick:function(t){return b(t,r)}}),e.endMarkerX&&e.endMarkerY?pn.a.createElement(Xn.animated.circle,{cx:t.endMarkerX,cy:t.endMarkerY,r:t.endMarkerWeight,fill:t.endMarkerColor,pointerEvents:"none"}):null)}))}))}),[R,O,x,E,b,y,g,h,s]))};hu.propTypes={lines:Object(zn.arrayOf)(Object(zn.shape)({cap:Object(zn.oneOf)(["butt","round","square"]),clipPath:zn.string,color:zn.string,cursor:zn.string,durationMultiplier:zn.number,endMarker:Object(zn.shape)({color:zn.string.isRequired,x:zn.number.isRequired,y:zn.number.isRequired}),id:zn.string.isRequired,line:zn.string.isRequired,opacity:zn.number,style:Object(zn.oneOf)(["solid","dot","dash"]),weight:zn.number})).isRequired,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func}),onMouseOver:zn.func,onMouseMove:zn.func,onMouseOut:zn.func,onClick:zn.func};var pu=hu;function gu(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function mu(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?gu(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):gu(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var yu=function(t){var e=t.color,n=t.line,r=t.xMin,o=t.xMax,a=t.yMin,s=t.yMax,c=t.yZero,l=t.transitionDuration,d=void 0===l?250:l,h=t.onClick,p=void 0===h?function(){}:h,g=t.onMouseOver,m=void 0===g?function(){}:g,y=t.onMouseOut,v=void 0===y?function(){}:y,b=t.transitionControllers,k=void 0===b?{}:b,w=Object(hn.useRef)(),x=Object(hn.useRef)();x.current=w.current,w.current="".concat(n,"L").concat(o,",").concat(c,"L").concat(r,",").concat(c,"Z");var A={key:0,color:Ji(e,Gi[0]),forceRedraw:f.a.uniqueId()},S=pa([A],(function(t){return t.key}),{config:{frequency:d/1e3},initial:function(t){return mu(mu({},t),{},{forceRedraw:f.a.uniqueId()})},from:function(t){return mu(mu({},t),{},{forceRedraw:f.a.uniqueId()})},enter:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(mu(mu({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,k.enter);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},leave:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(mu(mu({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,k.leave);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},update:function(t){return function(){var e=i()(u.a.mark((function e(n,r){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,ri(mu(mu({},t),{},{forceRedraw:f.a.uniqueId()}),n,r,k.update);case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()}}),O=x.current?pe(x.current,w.current):function(){return w.current},E="line-gradient-".concat(f.a.uniqueId()),M=100;return c!==s&&(M=Math.round(c/(s+a)*100)),pn.a.createElement("g",null,S((function(t,e){return f.a.keys(t).length&&pn.a.createElement(Xn.animated.g,{key:e.key},pn.a.createElement(Xn.animated.defs,null,pn.a.createElement(Xn.animated.linearGradient,{id:E,x1:"0%",x2:"0%",y1:"0%",y2:"100%",onMouseOver:function(t){return m(t)},onMouseOut:function(t){return v(t)},onClick:function(t){return p(t)}},pn.a.createElement(Xn.animated.stop,{offset:"0%",stopColor:t.color,stopOpacity:"0.5"}),pn.a.createElement(Xn.animated.stop,{offset:"".concat(M,"%"),stopColor:"#FFFFFF",stopOpacity:"0.5"}),M<100&&pn.a.createElement(Xn.animated.stop,{offset:"100%",stopColor:t.color,stopOpacity:"0.5"}))),pn.a.createElement(Xn.Spring,{reset:!0,from:{t:0},to:{t:1},config:{frequency:d/1e3}},(function(t){var e=t.t;return pn.a.createElement(Xn.animated.path,{fill:"url(#".concat(E,")"),d:e.to(O)})})))})))};yu.propTypes={line:zn.string.isRequired,color:zn.string,xMin:zn.number.isRequired,xMax:zn.number.isRequired,yMin:zn.number.isRequired,yMax:zn.number.isRequired,yZero:zn.number.isRequired,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var vu=yu,bu=["lineId","x","y"];function ku(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function wu(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?ku(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):ku(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var xu=pn.a.memo((function(t){var e=t.annotationData,n=void 0===e?[]:e,r=t.chartHeight,i=t.chartWidth,o=t.data,a=void 0===o?[]:o,s=t.dataSeriesOptions,c=void 0===s?[]:s,l=t.fillToOrigin,u=t.forceLegend,h=void 0===u?function(){}:u,p=t.hoveredLabel,g=t.isAnimating,m=t.isSpark,y=t.lastTouchPoint,v=t.lineData,b=void 0===v?[]:v,k=t.moveTooltip,x=void 0===k?function(){}:k,A=t.onClickLine,S=t.onMouseOutLine,E=t.onMouseOverLine,R=t.onMouseOverTooltip,j=void 0===R?function(){}:R,I=t.optsGridLine,B=void 0===I?{}:I,D=t.optsLabel,T=void 0===D?{}:D,F=t.optsTooltip,P=void 0===F?{}:F,z=t.optsXAxis,Q=void 0===z?{}:z,L=t.optsYAxis,Y=void 0===L?{}:L,W=t.refittedXdomain,q=t.scrubStartPoint,N=t.selectedLines,G=t.setHoveredLabel,J=void 0===G?function(){}:G,U=t.setIsAnimating,K=void 0===U?function(){}:U,H=t.setlastTouchPoint,V=void 0===H?function(){}:H,Z=t.setLine,X=void 0===Z?function(){}:Z,_=t.setScrubStartPoint,$=void 0===_?function(){}:_,tt=t.setTooltipToLineEnd,et=void 0===tt?function(){}:tt,nt=t.tooltip,rt=void 0===nt?{}:nt,it=t.transitionDuration,ot=t.xScale,at=t.xTicks,st=t.xType,ct=t.yScale,lt=t.yTicks,ut=t.yType,dt=Object(hn.useState)(!1),ft=M()(dt,2),ht=ft[0],pt=ft[1],gt=Object(hn.useState)(void 0),mt=M()(gt,2),yt=mt[0],vt=mt[1],bt=Object(hn.useRef)([]),kt=Object(hn.useRef)({}),wt=Object(hn.useRef)(null),xt=Object(hn.useRef)(null),At=T.show||!1!==T.show&&i>768,St=At?(T.width||Math.min(Math.max.apply(Math,O()(b.map((function(t){return ia(t.name).width})))),150))+10:0,Ot=ci({dataType:st,isMobile:i<365}),Et=ci({dataType:ut}),Mt=Math.max.apply(Math,O()(lt.map((function(t){return ia(Et(t,{ticks:lt}),Y.fontSize).width})))),Ct=lt.some((function(t){return t>0}))&&lt.some((function(t){return t<0}));ot.range([10+(f.a.includes(Y.displayTicks,"left")?Mt+10:0),i-10-(f.a.includes(Y.displayTicks,"right")?Mt+10:0)-St]),ct.range([r-(f.a.includes(Q.displayTicks,"bottom")?Q.fontSize+10:0),f.a.includes(Q.displayTicks,"top")?Q.fontSize+10:0]).nice();var Rt=Object(hn.useMemo)((function(){return function(t,e,n){var r=t.map((function(t){return[e(t.x),n(t.y)]}));return{"2d":C.Delaunay.from(r),x:C.Delaunay.from(r.map((function(t){return[M()(t,1)[0],0]}))),points:t}}(function(t,e){return t.map((function(t){var n=t.data,r=t.id,i=t.customDomain;return n.filter((function(t){var n=t.x;if(Vr(e)){var r=n.getTime();return r>=i[0].getTime()&&r<=i[1].getTime()}return n>=i[0]&&n<=i[1]})).map((function(t){var e=t.x,n=t.y,i=t.key;return{x:e,y:n,id:r,key:i}}))})).flat()}(b,st),ot,ct)}),[b,ot,st,ct]),jt=l&&1===b.length,It=Object(hn.useMemo)((function(){return b.map((function(t){var e=t.color,n=t.customDomain,o=t.data,a=t.endMarker,s=t.id,c=t.lineStyle,l=t.lineWeight,u=t.markerColor,d=t.markerWeight,h=.25;!N.length||N.includes(s)?h=1:p===s&&(h=.5);var g=Object(C.line)().x((function(t){var e=t.x;return ot(e)})).y((function(t){var e=t.y;return ct(e)}))(o.filter((function(t){var e=t.y;return Number.isFinite(e)}))),y=new au(g),v=n.map((function(t){return ot(t)}))[0],b=n.map((function(t){return ot(t)}))[1],k=a?{x:ot(f.a.last(o).x),y:ct(f.a.last(o).y),color:f.a.last(u),weight:d}:null,w=y.getParts().filter((function(t){var e=t.start,n=t.end;return e.x>=v&&n.x<=b})),x=w.length&&[{x:w[0].start.x,y:w[0].start.y}].concat(O()(w.map((function(t){var e=t.end;return{x:e.x,y:e.y}})))),A="M ".concat(Math.min.apply(Math,O()(x.map((function(t){return t.x}))))," ").concat(-l/2," L ").concat(Math.max.apply(Math,O()(x.map((function(t){return t.x}))))," ").concat(-l/2," L ").concat(Math.max.apply(Math,O()(x.map((function(t){return t.x}))))," ").concat(r+l/2," L ").concat(Math.min.apply(Math,O()(x.map((function(t){return t.x}))))," ").concat(r+l/2," Z"),S="M ".concat(x[0].x+l/2,", ").concat(x[0].y-l/2," m -").concat(l/2,", 0 a ").concat(l/2,",").concat(l/2," 0 1,0 0,").concat(l),E="M ".concat(x[x.length-1].x+l/2,", ").concat(x[x.length-1].y+l/2," m -").concat(l/2,", 0 a ").concat(l/2,",").concat(l/2," 0 1,0 0,-").concat(l),M=1,R=bt.current.findIndex((function(t){var e=t.id;return s===e}));return-1!==R?(kt.current[0]===W[0]&&kt.current[1]===W[1]&&(M=10*Math.abs(b-v-bt.current[R].range)/i),bt.current[R]={id:s,range:b-v}):bt.current.push({id:s,range:b-v}),{cap:jt?"butt":"round",clipPath:A.concat(S).concat(E),color:e,cursor:m?"default":void 0,durationMultiplier:M,endMarker:k,id:s,line:g,opacity:h,style:c,weight:l}}))}),[r,i,p,m,b,W,N,jt,ot,ct]);kt.current=W;var Bt=b.map((function(t){var e=t.id,n=t.name,r=t.color,i=t.data,o=t.fontSize,a=t.labelText,s=.25;return!N.length||N.includes(e)?s=1:p===e&&(s=.5),{content:void 0===a?n:a,x:ot.range()[1]+10,y:ct(i[i.length-1].y)+.35*o,key:e,style:{opacity:s,fontSize:o,fill:r,fontWeight:600,cursor:"pointer"}}}));Bt=Bt.map((function(t){return wu(wu({},t),{},{content:pn.a.createElement(za,{fontSize:t.style.fontSize||13,fontFamily:Yr,maxWidth:St,maxLines:1,dominantBaseline:"auto",label:t.content})})}));var Dt=n.map((function(t){var e=t.lineId,n=t.x,r=t.y;return wu(wu({},w()(t,bu)),{},{opacity:!N.length||N.includes(e)?1:.25,x:ot(n),y:ct(r)})}));try{Bt=function(t,e){var n=t.map((function(t,e){return Nr(Nr({},t),{},{index:e,wasAdjusted:!1})})),r=0,i=0;if(n.sort((function(t,e){return t.point<e.point?-1:1})).forEach((function(t,n,o){var a=t.point,s=t.size,c=o[n],l=o[n-1];if(0!==n){var u=a-l.point;if(u>=s)i+=u-s;else{var d=s-u;l.wasAdjusted||(d/=2,l.wasAdjusted=!0,l.point-=d,l.point<0&&(d+=0-l.point,l.point=0)),c.wasAdjusted=!0,c.point+=d,c.point>=e&&(r+=c.point-e,c.point=e)}}else i=a})),r>i)throw new Error("Cannot distribute all data properly, not enough available range.");return r&&n.reverse().some((function(t,n,r){var i=t.point,o=t.size,a=r[n],s=r[n-1],c=r[n+1];return i>e&&(a.point=e),0!==n&&(a.point=s.point-o,c&&c.point<i-o)})),n.sort((function(t,e){return t.index<e.index?-1:1})),n}(Bt.map((function(t){return{point:t.y,size:t.style.fontSize}})),Math.max.apply(Math,O()(ct.range()))).map((function(t,e){var n=Bt.find((function(t,n){return n===e}));return n.y=t.point,n}))}catch(t){h()}var Tt,Ft,Pt=b[0].data.filter((function(t){var e=t.x;if(Vr(st)){var n=e.getTime();return n>=b[0].customDomain[0].getTime()&&n<=b[0].customDomain[1].getTime()}return e>=b[0].customDomain[0]&&e<=b[0].customDomain[1]})),zt=Object(C.line)().x((function(t){var e=t.x;return ot(e)})).y((function(t){var e=t.y;return ct(e)}))(Pt.filter((function(t){var e=t.y;return Number.isFinite(e)}))),Qt=function(){wt.current=null,xt.current=null},Lt=function(t){var e=t.currentTarget.getBoundingClientRect(),n=e.top,r=e.left,i=t.clientX,o=t.clientY;t.touches&&t.touches.length&&(i=t.touches[0].clientX,o=t.touches[0].clientY);var a=i-r,s=o-n;B.showVerticalScrubber?mi.apply(void 0,[a].concat(O()(f.a.sortBy(ot.range()))))&&(wt.current=i-r):wt.current=null,B.showHorizontalScrubber?mi.apply(void 0,[s].concat(O()(f.a.sortBy(ct.range()))))&&(xt.current=o-n):xt.current=null},Yt=Object(hn.useCallback)((function(t,e){if(!g.current){var n=t.nativeEvent.path[3].getBoundingClientRect(),r=n.top,i=n.left;J(b[e]?b[e].id:void 0),void 0===y&&j(t,r,i,Rt,void 0,b[e]?b[e].id:void 0),"function"==typeof E&&E(t,e,{key:rt.key,value:rt.value})}}),[Rt,g,y,b,j,J,E,rt]),Wt=Object(d.throttle)((function(t,e){if(!g.current){var n=t.nativeEvent.path[3].getBoundingClientRect(),r=n.top,i=n.left;J(b[e]?b[e].id:void 0),void 0===y&&j(t,r,i,Rt,void 0,b[e]?b[e].id:void 0)}})),qt=Object(hn.useCallback)((function(t,e){g.current||(J(void 0),"function"==typeof S&&S(t,e,{key:rt.key,value:rt.value}))}),[g,J,S,rt]),Nt=Object(hn.useCallback)((function(t,e){g.current||(t.stopPropagation(),X(t,e),"function"==typeof A&&A(t,e,{key:rt.key,value:rt.value}))}),[g,X,A,rt]),Gt=Object(hn.useRef)(It.map((function(t){return{cap:t.cap,clipPath:t.clipPath,color:t.color,cursor:t.cursor,durationMultiplier:t.durationMultiplier,endMarker:t.endMarker,id:t.id,line:t.line,opacity:t.opacity,style:t.style,weight:t.weight}})));if(Tt=It,Ft=Gt.current,Tt.length!==Ft.length||!Tt.every((function(t,e){var n=t||{},r=n.cap,i=void 0===r?"":r,o=n.clipPath,a=void 0===o?"":o,s=n.color,c=void 0===s?"":s,l=n.cursor,u=void 0===l?"":l,d=n.durationMultiplier,f=void 0===d?"":d,h=n.id,p=void 0===h?"":h,g=n.line,m=void 0===g?"":g,y=n.opacity,v=void 0===y?"":y,b=n.style,k=void 0===b?"":b,w=n.weight,x=void 0===w?"":w,A=Ft[e]||{},S=A.cap,O=void 0===S?"":S,E=A.clipPath,M=void 0===E?"":E,C=A.color,R=void 0===C?"":C,j=A.cursor,I=void 0===j?"":j,B=A.durationMultiplier,D=void 0===B?"":B,T=A.id,F=void 0===T?"":T,P=A.line,z=void 0===P?"":P,Q=A.opacity,L=void 0===Q?"":Q,Y=A.style,W=void 0===Y?"":Y,q=A.weight;return i===O&&a===M&&c===R&&u===I&&p===F&&m===z&&f===D&&v===L&&k===W&&x===(void 0===q?"":q)}))){Gt.current=It.map((function(t){return{cap:t.cap,clipPath:t.clipPath,color:t.color,cursor:t.cursor,durationMultiplier:t.durationMultiplier,endMarker:t.endMarker,id:t.id,line:t.line,opacity:t.opacity,style:t.style,weight:t.weight}}));var Jt=Math.max.apply(Math,O()(Gt.current.map((function(t){return t.durationMultiplier}))));K(it>0),setTimeout((function(){K(!1)}),Math.round(it*Jt))}return pn.a.createElement("div",{style:{display:"flex",flex:1,height:"100%"}},pn.a.createElement(wl,{onTouchMove:function(t){if(!g.current){var e=t.currentTarget.getBoundingClientRect(),n=e.top,r=e.left;!function(t){if(!g.current&&null===ht){var e=t.touches[0];pt(Math.abs(e.pageX-q.pageX)>Math.abs(e.pageY-q.pageY))}}(t),ht&&(j(t,n,r,Rt,void 0,yt),Lt(t)),(ht||B.showHorizontalScrubber||B.showVerticalScrubber)&&(t.preventDefault(),t.stopPropagation())}},settings:{passive:!1}},pn.a.createElement("svg",{style:{overflow:"visible",flex:1,height:r,width:i,zIndex:11},className:Wc["line-chart-svg"],onMouseMove:Object(d.throttle)((function(t){if(!g.current&&t.currentTarget){var e=t.currentTarget.getBoundingClientRect(),n=e.top,r=e.left;void 0===y?void 0===p&&j(t,n,r,Rt):V(j(t,n,r,Rt,y)),Lt(t)}}),17),onMouseLeave:function(){g.current||Qt()},onClick:function(t){g.current||void 0===y&&function(t,e){if(!ht){var n=t.currentTarget.getBoundingClientRect(),r=n.top,i=n.left,o=t.clientX-i,s=t.clientY-r,l=Hc(a,b,e,o,s,ot,ct);if(l&&c[l.lineNum]){var u=b.findIndex((function(t){return t.id===c[l.lineNum].id}));X(null,u,c[l.lineNum])}}}(t,Rt)},onTouchStart:function(t){g.current||(!function(t,e){if(!ht){var n=t.currentTarget.getBoundingClientRect(),r=n.top,i=n.left,o=t.touches[0].clientX-i,s=t.touches[0].clientY-r,l=Hc(a,b,e,o,s,ot,ct);l&&c[l.lineNum]&&vt([l.line.id])}}(t,Rt),void 0===y&&V(null),pt(null),$(t.touches[0]),Lt(t))},onTouchEnd:function(){g.current||(pt(!1),x(),Qt())}},f.a.includes(Q.displayTicks,"bottom")&&pn.a.createElement(ba,{position:ya.bottom,chartWidth:i,chartHeight:r,fontSize:Q.fontSize,textColor:Ji(Q.textColor,Q.textColor),ticks:at.map((function(t){return{data:t,point:ot(t)}})),formatter:Q.labelFormatter?Q.labelFormatter:Ot,transitionDuration:it}),f.a.includes(Q.displayTicks,"top")&&pn.a.createElement(ba,{position:ya.top,chartWidth:i,chartHeight:r,fontSize:Q.fontSize,textColor:Ji(Q.textColor,Q.textColor),ticks:at.map((function(t){return{data:t,point:ot(t)}})),formatter:Q.labelFormatter?Q.labelFormatter:Ot,transitionDuration:it}),B.showVerticalLines&&pn.a.createElement(Na,{orientation:Wa.vertical,range:ct.range(),strokeWidth:1,gridColor:Ji(B.color,B.color),ticks:at.map((function(t){return{point:ot(t),strokeWidth:1,strokeCap:"square",strokeStyle:B.style||"solid"}})),transitionDuration:it}),f.a.includes(Y.displayTicks,"left")&&pn.a.createElement(ba,{position:ya.left,chartWidth:i,chartHeight:r,fontSize:Y.fontSize,textColor:Ji(Y.textColor,Y.textColor),ticks:lt.map((function(t){return{data:t,point:ct(t)}})),formatter:Y.labelFormatter?Y.labelFormatter:Et,transitionDuration:it}),f.a.includes(Y.displayTicks,"right")&&pn.a.createElement(ba,{position:ya.right,chartWidth:i,chartHeight:r,fontSize:Y.fontSize,textColor:Ji(Y.textColor,Y.textColor),ticks:lt.map((function(t){return{data:t,point:ct(t)}})),formatter:Y.labelFormatter?Y.labelFormatter:Et,transitionDuration:it}),B.showHorizontalLines&&pn.a.createElement(Na,{orientation:Wa.horizontal,range:ot.range(),strokeWidth:1,gridColor:Ji(B.color,B.color),ticks:lt.map((function(t){return{point:ct(t),strokeWidth:Ct&&0===t?3:1,strokeCap:"square",strokeStyle:B.style||"solid"}})),transitionDuration:it}),jt&&pn.a.createElement(vu,{line:zt,color:Gt.current[0].color,xMin:f.a.min(Pt.map((function(t){var e=t.x;return ot(e)}))),xMax:f.a.max(Pt.map((function(t){var e=t.x;return ot(e)}))),yMin:f.a.min(Pt.filter((function(t){var e=t.y;return Number.isFinite(e)})).map((function(t){var e=t.y;return ct(e)}))),yMax:f.a.max(Pt.filter((function(t){var e=t.y;return Number.isFinite(e)})).map((function(t){var e=t.y;return ct(e)}))),yZero:lt.includes(0)?ct(0):f.a.max(Pt.filter((function(t){var e=t.y;return Number.isFinite(e)})).map((function(t){var e=t.y;return ct(e)}))),transitionDuration:it}),pn.a.createElement(pu,{lines:Gt.current.map((function(t){return f.a.pick(t,["cap","clipPath","color","cursor","durationMultiplier","endMarker","id","line","opacity","style","weight"])})),transitionDuration:it,onMouseOver:Yt,onMouseMove:Wt,onMouseOut:qt,onClick:Nt}),wt.current&&pn.a.createElement(Na,{orientation:Wa.vertical,range:ct.range(),gridColor:Ji(B.scrubberColor,B.scrubberColor),ticks:[{point:wt.current,strokeCap:"square",strokeStyle:"dash",strokeWidth:2}],transitionDuration:0}),xt.current&&pn.a.createElement(Na,{orientation:Wa.horizontal,range:ot.range(),gridColor:Ji(B.scrubberColor,B.scrubberColor),ticks:[{point:xt.current,strokeCap:"square",strokeStyle:"dash",strokeWidth:2}],transitionDuration:0}),At&&pn.a.createElement(Ha,{labels:Bt,onClick:function(t,e){g.current||(X(t,e),t.stopPropagation())},onMouseOver:function(t,e){g.current||(void 0===y&&et(t,e),J(b[e]?b[e].id:void 0))},onMouseMove:function(t){g.current||t.stopPropagation()},onMouseOut:function(){g.current||J(void 0)},transitionDuration:it}),n.length>0&&pn.a.createElement(uu,{data:Dt,transitionDuration:it}),(!1!==P.show||!1!==P.showMarker)&&null!==rt.value&&pn.a.createElement("circle",{className:"tooltip-marker",cx:rt.position.x,cy:rt.dotY,r:rt.dotWeight,fill:rt.color,pointerEvents:"none"}))),!1!==P.show&&null!==rt.value&&pn.a.createElement("div",{className:Wc["tooltip-container"]},pn.a.createElement(oo,{direction:rt.direction,x:rt.position.x,y:rt.position.y,width:i},pn.a.createElement(Za,{title:rt.title,subtitle:P.showSubtitle?rt.xLabel:null,value:rt.value,color:P.color||rt.color,annotation:rt.annotation,decimals:P.decimals,type:rt.type}))))}));xu.propTypes={chartHeight:zn.number,chartWidth:zn.number.isRequired,optsGridLine:Object(zn.shape)({showVerticalLines:zn.bool.isRequired,showHorizontalLines:zn.bool.isRequired,color:zn.string}).isRequired,optsLabel:Object(zn.shape)({show:zn.bool,width:zn.number.isRequired}).isRequired,optsXAxis:Object(zn.shape)({displayTicks:Object(zn.arrayOf)(zn.string).isRequired,fontSize:zn.number.isRequired,textColor:zn.string,labelFormatter:zn.func}).isRequired,optsYAxis:Object(zn.shape)({displayTicks:Object(zn.arrayOf)(zn.string).isRequired,fontSize:zn.number.isRequired,textColor:zn.string,labelFormatter:zn.func}).isRequired,optsTooltip:Object(zn.shape)({show:zn.bool.isRequired,showSubtitle:zn.bool.isRequired,decimals:zn.number}).isRequired,data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,lineData:Object(zn.arrayOf)(Object(zn.shape)({color:zn.string.isRequired,customDomain:Object(zn.arrayOf)(Object(zn.oneOfType)([Qn.a.instanceOf(Date),zn.number])).isRequired,data:Object(zn.arrayOf)(Object(zn.shape)({x:Object(zn.oneOfType)([Qn.a.instanceOf(Date),zn.number]).isRequired,y:zn.number.isRequired,key:zn.string.isRequired})).isRequired,fontSize:zn.number.isRequired,id:zn.string.isRequired,labelText:zn.string,lineStyle:zn.string.isRequired,lineWeight:zn.number.isRequired,name:zn.string.isRequired,tooltipTitle:zn.string})).isRequired,annotationData:Object(zn.arrayOf)(Object(zn.shape)({color:zn.string,fontSize:zn.number,key:zn.string,lineID:zn.string,radius:zn.number,showTitleOnChart:zn.bool,text:zn.string,title:zn.string,x:Object(zn.oneOfType)([Qn.a.instanceOf(Date),zn.number]).isRequired,y:zn.number.isRequired})),dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({color:zn.string,endMarker:zn.bool,id:zn.string.isRequired,labelText:zn.string,lineStyle:Object(zn.oneOf)(["solid","dot","dash"]),lineWeight:zn.number,markerColor:Object(zn.oneOfType)([zn.string,Object(zn.arrayOf)(zn.string)]),markerWeight:zn.number,tooltipTitle:zn.string,annotations:Object(zn.arrayOf)(Object(zn.shape)({color:zn.string,fontSize:zn.number,key:zn.string.isRequired,position:Object(zn.oneOf)(["above","below"]),showTitleOnChart:zn.bool,text:zn.string,title:zn.string}))})),xTicks:Object(zn.arrayOf)(Object(zn.oneOfType)([Qn.a.instanceOf(Date),zn.number])).isRequired,yTicks:Object(zn.arrayOf)(Object(zn.oneOfType)([Qn.a.instanceOf(Date),zn.number])).isRequired,xType:zn.string.isRequired,yType:zn.string.isRequired,xScale:zn.func.isRequired,yScale:zn.func.isRequired,hoveredLabel:zn.string,setHoveredLabel:zn.func.isRequired,selectedLines:Object(zn.oneOfType)([Object(zn.arrayOf)(zn.string),zn.string]).isRequired,setLine:zn.func.isRequired,lastTouchPoint:zn.string,setlastTouchPoint:zn.func.isRequired,scrubStartPoint:zn.string,setScrubStartPoint:zn.func.isRequired,forceLegend:zn.func.isRequired,tooltip:Object(zn.shape)({color:zn.string,direction:zn.string,dotWeight:zn.number,dotY:zn.number,position:Object(zn.shape)({x:zn.number,y:zn.number}),title:zn.string,value:zn.number,xLabel:zn.string}).isRequired,moveTooltip:zn.func.isRequired,onClickLine:zn.func,onMouseOutLine:zn.func,onMouseOverLine:zn.func,onMouseOverTooltip:zn.func.isRequired,setTooltipToLineEnd:zn.func.isRequired,fillToOrigin:zn.bool.isRequired,refittedXdomain:Object(zn.arrayOf)(Object(zn.oneOfType)([zn.number,zn.string])).isRequired,transitionDuration:zn.number,isAnimating:zn.object.isRequired,isSpark:zn.bool.isRequired,setIsAnimating:zn.func.isRequired};var Au=xu,Su=["key","color","fontSize"];function Ou(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Eu(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Ou(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Ou(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Mu=function(t){var e=t.data,n=t.dataSeriesOptions,r=void 0===n?[]:n,i=t.fillToOrigin,o=void 0!==i&&i,a=t.footerOptions,s=void 0===a?Bs:a,c=t.gridLineOptions,l=void 0===c?Ds:c,u=t.height,d=void 0===u?"500":u,h=t.isSpark,p=void 0!==h&&h,g=t.labelOptions,m=void 0===g?Ts:g,y=t.legendOptions,v=void 0===y?Fs:y,b=t.onMouseOver,k=t.onMouseOut,x=t.onClick,A=t.selectedLineId,S=void 0===A?"":A,E=t.subtitleOptions,C=void 0===E?Ps:E,R=t.titleOptions,j=void 0===R?zs:R,I=t.tooltipOptions,B=void 0===I?Qs:I,D=t.transitionDuration,T=void 0===D?250:D,F=t.width,P=t.xAxisOptions,z=void 0===P?Ls:P,Q=t.yAxisOptions,L=void 0===Q?Ys:Q;if(!e||!e.length)return null;var Y=Object(hn.useRef)(!1),W=function(t){Y.current=t},q=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},s,Bs)}),[s]),N=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},l,Ds)}),[l]),G=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},m,Ts)}),[m]),J=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},v,Fs)}),[v]),U=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},C,Ps)}),[C]),K=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},j,zs)}),[j]),H=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},B,Qs)}),[B]),V=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},z,Ls)}),[z]),Z=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},L,Ys)}),[L]),X=o;p&&(q=Eu(Eu({},q),Ws.footerOptions),N=Eu(Eu({},N),Ws.gridLineOptions),G=Eu(Eu({},G),Ws.labelOptions),J=Eu(Eu({},J),Ws.legendOptions),U=Eu(Eu({},U),Ws.subtitleOptions),K=Eu(Eu({},K),Ws.titleOptions),H=Eu(Eu({},H),Ws.tooltipOptions),V=Eu(Eu({},V),Ws.xAxisOptions),Z=Eu(Eu({},Z),Ws.yAxisOptions),X=!1),0===f.a.get(z,"displayTicks.length",-1)&&(V.displayTicks=[]),0===f.a.get(L,"displayTicks.length",-1)&&(Z.displayTicks=[]);var _=J.show,$=Object(hn.useMemo)((function(){return"auto"!==F&&F?parseInt(F,10):void 0}),[F]),tt=Object(hn.useMemo)((function(){return"auto"===d?"100%":parseInt(d,10)}),[d]),et=Object(hn.useMemo)((function(){var t=Ur(e),n=oi(t,r).map((function(t){return Eu(Eu({},t),p?Ws.dataSeriesOptions:{})}));return{data:ai(t,n,["name","x_type","y_type","sources","meta"]).map((function(t){return Eu(Eu({},t),{},{sources:t.sources||[],meta:t.meta||[],data:t.data.map((function(e){var n=e.key,r=e.value;return{key:n,formatted:Sr(n,t.x_type),value:r}}))})})),dataSeriesOptions:n}}),[e,r,p]),nt=et.data,rt=et.dataSeriesOptions,it=Hr(nt,Sr),ot=nt.flatMap((function(t){return t.data})).map((function(t){return{key:t.key,formatted:t.formatted,value:t.value}})),at=Object(hn.useMemo)((function(){return Zr(V.type)?V.type:Xr(nt,"x")||"years"}),[nt,V.type]),st=Object(hn.useMemo)((function(){return Zr(Z.type)?Z.type:Xr(nt,"y")||"linear"}),[nt,Z.type]),ct=rt.map((function(t){var e=t.displayRangeMin,n=t.id;return e?[e]:nt.find((function(t){return t.id===n})).data.map((function(t){return t.key}))})).flat(),lt=rt.map((function(t){var e=t.displayRangeMax,n=t.id;return e?[e]:nt.find((function(t){return t.id===n})).data.map((function(t){return t.key}))})).flat(),ut=ct.length>0?Vr(at)?ct.reduce((function(t,e){return Sr(t,at)<Sr(e,at)?t:e})):Math.min.apply(Math,O()(ct)):void 0,dt=lt.length>0?Vr(at)?lt.reduce((function(t,e){return Sr(t,at)>Sr(e,at)?t:e})):Math.max.apply(Math,O()(lt)):void 0,ft=Object(hn.useMemo)((function(){return[z.displayRangeMin||ut,z.displayRangeMax||dt]}),[ut,dt,z.displayRangeMax,z.displayRangeMin]),ht=Object(hn.useMemo)((function(){return function(t){var e=t.type,n=t.keys,r=t.values,i=t.customDomain,o=void 0===i?[void 0,void 0]:i,a=t.customTicks,s=void 0===a?void 0:a,c=$r(o.map((function(t){return void 0!==t?Sr(t,e):void 0})),[n[0].formatted,f.a.last(n).formatted]),l=r.filter((function(t){var e=t.formatted;return e>=c[0]&&e<=c[1]})).map((function(t){return t.value}));return _c(_c({},$c({axisType:"x",type:e,domain:c,customDomain:o,customTicks:s})),{},{values:l})}({type:at,keys:it,values:ot,customDomain:ft,customTicks:z.ticks})}),[ot,it,ft,z.ticks,at]),pt=ht.ticks,gt=ht.scale,mt=ht.values,yt=Object(hn.useMemo)((function(){return function(t){var e=t.type,n=t.values,r=t.customDomain,i=void 0===r?[void 0,void 0]:r,o=t.customTicks,a=void 0===o?void 0:o,s=[f.a.min(n),f.a.max(n)],c=i.every((function(t){return void 0!==t})),l=$r(i.map((function(t){return void 0!==t?Sr(t,e):void 0})),s),u=s.every((function(t){return t>=0})),d=s.every((function(t){return t<=0}));if(!c&&(u||d)){var h=n.map((function(t){return Math.abs(t)}));f.a.min(h)<.5*f.a.max(h)&&(l[u?0:1]=0)}return $c({axisType:"y",type:e,domain:l,customDomain:i,customTicks:a})}({type:st,values:mt,customDomain:[L.displayRangeMin,L.displayRangeMax],customTicks:L.ticks})}),[mt,L.displayRangeMax,L.displayRangeMin,L.ticks,st]),vt=yt.ticks,bt=yt.scale,kt=S;-1===rt.findIndex((function(t){return t.id===S}))&&(kt="");var wt=Object(hn.useState)(kt?[kt]:[]),xt=M()(wt,2),At=xt[0],St=xt[1];Object(hn.useEffect)((function(){St(kt)}),[kt]);var Ot=Object(hn.useState)(void 0),Et=M()(Ot,2),Mt=Et[0],Ct=Et[1],Rt=Object(hn.useCallback)((function(t,e){if(!Y.current&&!p){var n=rt[e];At.includes(n.id)?St([]):St([n.id])}}),[rt,At,p]),jt=Object(hn.useState)(void 0),It=M()(jt,2),Bt=It[0],Dt=It[1],Tt=Object(hn.useState)(void 0),Ft=M()(Tt,2),Pt=Ft[0],zt=Ft[1];Object(hn.useMemo)((function(){At&&At.length&&(rt.length<2||!rt.map((function(t){return t.id})).includes(At[0]))&&St([])}),[rt,At]);var Qt=Object(hn.useMemo)((function(){var t={endMarker:!1,fontSize:G.fontSize,lineStyle:"solid",lineWeight:5};return nt.map(Zc(rt,gt.domain(),t)).filter((function(t){return t.data.length>1}))}),[nt,rt,G.fontSize,gt]);if(0===Qt.length)return null;var Lt=Object(hn.useMemo)((function(){return rt.map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.id,n=t.lineWeight,r=t.annotations,i=void 0===r?[]:r,o=Qt.find((function(t){return t.id===e}))||{},a=o.color,s=o.fontSize,c=o.data,l=void 0===c?[]:c;return i.map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.key,i=t.color,o=t.fontSize,c=void 0===o?s:o,u=w()(t,Su),d=l.find((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.key;return r===e}));if(!d)return null;var f=d.x,h=d.y;return Eu(Eu({},u),{},{key:r,color:Ji(i,a),fontSize:c,radius:n,x:f,y:h,lineId:e})})).filter((function(t){return t}))})).flat()}),[rt,Qt]),Yt=Object(hn.useMemo)((function(){return Qt.map((function(t,e){var n=nt[nt.map((function(t){return t.id})).indexOf(t.id)];return{id:t.id,color:Ji(t.color,Gi[e]),label:n.name,highlighted:At.includes(t.id)}}))}),[nt,Qt,At]),Wt=function(){_=!0},qt=function(t){var e=t.lineData,n=t.annotationData,r=t.data,i=t.xScale,o=t.yScale,a=t.selectedLines,s=void 0===a?[]:a,c=Object(hn.useState)({position:{x:null,y:null},key:null,value:null,direction:"below",title:"",color:Gi[0],xLabel:"",dotY:null,dotWeight:5}),l=M()(c,2),u=l[0],d=l[1],h=Object(hn.useMemo)((function(){return f.a.throttle((function(t){d(t)}),17)}),[]),p=Object(hn.useCallback)((function(t){if(t){var n=r.findIndex((function(e){return e.id===t.line.id})),a=e.find((function(e){return e.id===t.line.id})),s=t.line.data.findIndex((function(e){return e.key===t.datum.key}));return h({position:{x:i(t.datum.x),y:o(t.datum.y)+5*("below"===t.direction?1:-1)},key:t.datum.x,value:t.datum.y,direction:t.direction,title:a.tooltipTitle||a.name,type:t.line.y_type,color:Ji(a.markerColor[s],Gi[n]),xLabel:Ar(t.datum.x,t.line.x_type),dotY:o(t.datum.y),dotWeight:5,annotation:t.annotation}),t}return h({value:null}),null}),[r,e,h,i,o]),g=Object(hn.useCallback)((function(t,e){if(!(t&&e&&t.datum&&e.datum))return!1;var n=t.datum,r=n.key,i=n.y,o=e.datum,a=o.key,s=o.y;return r===a&&i===s}),[]),m=Object(hn.useCallback)((function(t,a,c,l,u,d){var f,h;t.clientX&&t.clientY?(f=t.clientX-c,h=t.clientY-a):t.touches&&t.touches.length&&(f=t.touches[0].clientX-c,h=t.touches[0].clientY-a);var m=Hc(r,e,l,f,h,i,o,0!==s.length?s:d);return m=Vc(m,n),void 0!==u&&g(m,u)?p():p(m)}),[n,r,g,e,p,s,i,o]);return{tooltip:u,setTooltip:d,throttledSetTooltip:h,mouseOver:m,moveTooltip:p}}({lineData:Qt,annotationData:Lt,data:nt,xScale:gt,yScale:bt,selectedLines:At}),Nt=qt.tooltip,Gt=qt.mouseOver,Jt=qt.moveTooltip,Ut=q.show?go({data:nt,chartSources:q.sources}):{sources:[],summary:""},Kt=Ut.sources,Ht=Ut.summary,Vt=(q.show?bo({data:nt,chartFootnotes:q.footnotes,showMetricFootnotes:q.showMetricFootnotes}):{footnotes:[]}).footnotes,Zt=Object(hn.useCallback)((function(t,e){if(!At||!At.length||At.includes(Qt[e].id)){var n=Qt.map((function(t){var e=t.data,n=t.customDomain;return e.filter((function(t){var e=t.x;if(Vr(at)){var r=e.getTime();return r>=n[0].getTime()&&r<=n[1].getTime()}return e>=n[0]&&e<=n[1]}))}));if(!Qt[e])return;var r=n[e].filter((function(t){var e=t.y;return Number.isFinite(e)})),i={datum:r[r.length-1],direction:"above",line:nt.find((function(t){return t.id===Qt[e].id})),lineNum:e};i=Vc(i,Lt),Jt(i,gt,bt)}}),[Lt,nt,Qt,Jt,At,gt,at,bt]);return pn.a.createElement(la,{className:Wc["line-chart"],title:K.text,subtitle:U.text,titleFontSize:K.fontSize,subtitleFontSize:U.fontSize,footerSources:Kt,footerSummary:Ht,footnotes:Vt,showFooter:q.show,width:$,height:tt,fontSize:q.fontSize,onMouseLeave:function(){Y.current||Jt()}},(function(t){var e=t.chartWidth,n=void 0===_&&e<=768;return pn.a.createElement("div",{style:{display:"flex",flexDirection:"column"}},_||n?pn.a.createElement("div",{style:{margin:"".concat(V.fontSize,"px 0")},onMouseOut:function(){Y.current||Jt()},onBlur:function(){Y.current||Jt()},className:Wc["chart-header"]},pn.a.createElement("div",{style:{color:"#4D4D4D",fontSize:J.fontSize,letterSpacing:"2px",lineHeight:1,marginBottom:"0.5em"}},"SELECT A LINE"),pn.a.createElement(Pc,{categories:Yt,fontSize:J.fontSize,transitionDuration:T,onMouseOver:function(t,e){Y.current||(void 0===Bt&&Zt(t,e),Ct(Qt[e].id))},onMouseOut:function(){Y.current||Ct(void 0)},onClick:Rt,style:{cursor:"pointer"}})):pn.a.createElement("div",{style:{height:20}}),pn.a.createElement(Pn,{handleHeight:!0},(function(t){var n=t.height;return pn.a.createElement("div",{style:{flex:1}},n&&pn.a.createElement(Au,{annotationData:Lt,chartHeight:n,chartWidth:e,data:nt,dataSeriesOptions:rt,fillToOrigin:X,forceLegend:Wt,hoveredLabel:Mt,isAnimating:Y,isSpark:p,lastTouchPoint:Bt,lineData:Qt,moveTooltip:Jt,onClickLine:x,onMouseOutLine:k,onMouseOverLine:b,onMouseOverTooltip:Gt,optsGridLine:N,optsLabel:G,optsTooltip:H,optsXAxis:V,optsYAxis:Z,refittedXdomain:ft,scrubStartPoint:Pt,selectedLines:At,setHoveredLabel:Ct,setIsAnimating:W,setlastTouchPoint:Dt,setLine:Rt,setScrubStartPoint:zt,setTooltipToLineEnd:Zt,tooltip:Nt,transitionDuration:T,xScale:gt,xTicks:pt,xType:at,yScale:bt,yTicks:vt,yType:st}))})))}))};Mu.propTypes=Eu(Eu({},ua),{},{data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({color:zn.string,endMarker:zn.bool,id:zn.string.isRequired,labelText:zn.string,lineStyle:Object(zn.oneOf)(["solid","dot","dash"]),lineWeight:zn.number,markerColor:Object(zn.oneOfType)([zn.string,Object(zn.arrayOf)(zn.string)]),markerWeight:zn.number,tooltipTitle:zn.string,annotations:Object(zn.arrayOf)(Object(zn.shape)({color:zn.string,fontSize:zn.number,key:zn.string.isRequired,position:Object(zn.oneOf)(["above","below"]),showTitleOnChart:zn.bool,text:zn.string,title:zn.string}))})),footerOptions:Object(zn.shape)({fontSize:zn.number,footnotes:ua.footnotes,show:ua.showFooter,showMetricFootnotes:zn.bool,sources:ua.footerSources}),fillToOrigin:zn.bool,gridLineOptions:Object(zn.shape)({color:zn.string,scrubberColor:zn.string,showVerticalLines:zn.bool,showHorizontalLines:zn.bool,showVerticalScrubber:zn.bool,showHorizontalScrubber:zn.bool,style:Object(zn.oneOf)(["solid","dot","dash"])}),height:Object(zn.oneOfType)([zn.string,zn.number]),isSpark:zn.bool,labelOptions:Object(zn.shape)({fontSize:zn.number,show:zn.bool,width:zn.number}),legendOptions:Object(zn.shape)({show:zn.bool,fontSize:zn.number}),onMouseOver:zn.func,onMouseOut:zn.func,onClick:zn.func,selectedLineId:zn.string,subtitleOptions:Object(zn.shape)({fontSize:zn.number,text:zn.string}),titleOptions:Object(zn.shape)({fontSize:zn.number,text:zn.string}),tooltipOptions:Object(zn.shape)({color:zn.string,decimals:zn.number,show:zn.bool,showSubtitle:zn.bool}),transitionDuration:zn.number,width:Object(zn.oneOfType)([zn.string,zn.number]),xAxisOptions:Object(zn.shape)({displayRangeMin:Object(zn.oneOfType)([zn.number,zn.string]),displayRangeMax:Object(zn.oneOfType)([zn.number,zn.string]),displayTicks:Object(zn.arrayOf)(Object(zn.oneOf)(f.a.values(ya))),labelFormatter:zn.func,textColor:zn.string,ticks:Object(zn.arrayOf)(zn.number),type:Object(zn.oneOf)(Wr),fontSize:zn.number}),yAxisOptions:Object(zn.shape)({displayRangeMin:Object(zn.oneOfType)([zn.number,zn.string]),displayRangeMax:Object(zn.oneOfType)([zn.number,zn.string]),displayTicks:Object(zn.arrayOf)(Object(zn.oneOf)(f.a.values(ya))),labelFormatter:zn.func,textColor:zn.string,ticks:Object(zn.arrayOf)(zn.number),type:Object(zn.oneOf)(Wr),fontSize:zn.number})});var Cu=Mu,Ru=function(t,e,n,r,i,o,a,s,c,l,u){return function(d,h){var p,g=h.name,m=h.id,y=h.color,v=void 0===y?u:y;if(!o)return f.a.concat(d,{x:l,y:e,height:n,width:0,group:a,category:s,metric:m,label:g,color:v});var b=Math.max(0,i[m]/c*r);if(f.a.isEmpty(d))p=t;else{var k=f.a.last(d);p=k.x+k.width+2}return f.a.concat(d,{x:p,y:e,height:n,width:b,group:a,category:s,metric:m,label:g,color:v})}},ju=function(t,e,n,r,i,o,a,s){var c=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0;return function(l,u,d){var h,p=u.id,g=u.label,m=u.color||Gi[d%Gi.length],y=f()(o[p]).map(f.a.identity).sum(),v=f.a.includes(r,p),b=y/s*n;if(f.a.isEmpty(l))h=c;else{var k=f.a.last(l);h=k.x+k.width+2}var w=v?h:h+b,x=i[p].reduce(Ru(h,t,e,b-2*(i[p].length-1),o[p],v,a,p,y,w,m),[]);return f.a.concat(l,{x:h,y:t,height:e,width:v?0:b,group:a,category:p,metric:null,label:g,color:m},x)}},Iu=function(t){return function(e){var n=e.data,r=e.x_type;return(f.a.find(n,(function(e){var n=e.key;return Sr(n,r).getTime()===t.getTime()}))||{}).value}},Bu=function(t){var e=t.template,n=[],r=O()(e.matchAll(/(?:\*{([^*{}]*)}\*)|(?:_{([^_{}]*)}_)|(?:{([^{}]*)})|(\n)/g)),i=0;if(0===r.length)return pn.a.createElement("span",null,e);for(var o=0;o<r.length;o++){var a=r[o],s=a.index,c=a.index+a[0].length;if(i<s&&n.push(pn.a.createElement("span",{key:"token-".concat(i,"-").concat(s)},e.slice(i,s))),a[4])n.push(pn.a.createElement("br",{key:"token-".concat(s,"-").concat(c)}));else{var l=a[0].startsWith("*")?"color":a[0].startsWith("_")?"bold":"normal",u=(a[1]||a[2]||a[3]).split("."),d=M()(u,2),f=d[0],h=d[1];n.push(pn.a.createElement("span",{key:"token-".concat(s,"-").concat(c),style:{fontWeight:"normal"===l?"normal":"bold",color:"color"===l?t.emphasisColor:"",textTransform:h||"unset"}},"".concat(t[f])))}i=c,o===r.length-1&&c!==e.length&&n.push(pn.a.createElement("span",{key:o},e.slice(c,e.length)))}return n};Bu.propTypes={template:zn.string.isRequired,label:zn.string,value:zn.string,yType:zn.string,rowLabel:zn.string,rowPercent:zn.string,totalPercent:zn.string};var Du=Bu,Tu=function(t){var e=t.hovered,n=t.descriptionLines,r=t.descriptionTemplate,i=t.selectedDescriptionTemplate,o=t.emphasisColor,a=t.yType,s=t.label,c=t.value,l=t.rowLabel,u=t.rowPercent,d=t.totalPercent,f=t.fontSize,h=void 0===f?14:f;return pn.a.createElement("span",{className:"description-root",style:{fontSize:"".concat(h,"px"),minHeight:"".concat(h*n,"px"),maxHeight:"".concat(h*n,"px")}},pn.a.createElement(Du,{template:e?i:r,emphasisColor:o,yType:a,label:s,value:c,rowLabel:l,rowPercent:u,totalPercent:d}))};Tu.propTypes={hovered:Object(zn.shape)({group:zn.string.isRequired,category:zn.string.isRequired,metric:zn.string}),descriptionLines:zn.number,descriptionTemplate:zn.string.isRequired,selectedDescriptionTemplate:zn.string.isRequired,emphasisColor:zn.string,yType:zn.string,label:zn.string,value:zn.string,rowLabel:zn.string,rowPercent:zn.string,totalPercent:zn.string,fontSize:zn.number};var Fu=Tu,Pu=Object(R.createCanvas)(0,0),zu=function(t,e,n,r){return t<=e&&n<=r},Qu=function(t){return t.actualBoundingBoxLeft+t.actualBoundingBoxRight},Lu=function(t){var e=t.width,n=t.height,r=t.text,i=t.fontSize,o=t.fontFamily,a=t.canvas,s=(void 0===a?Pu:a).getContext("2d");s.font="".concat(i,"px ").concat(o);var c=Qu(s.measureText(r)),l=r.split(" "),u=f()(l).map((function(t){return Qu(s.measureText(t))})).max(),d=i*l.length,h=zu(c,e,i,n)||zu(u,e,d,n),p=zu(i,e,c,n)||zu(d,e,u,n),g=!h&&!p;return pn.a.createElement("div",{className:"fitted-label ".concat(h?"":"rotated"," ").concat(g?"removed":""),style:{fontSize:"".concat(i,"px"),width:h?e:n}},r)};Lu.propTypes={width:zn.number.isRequired,height:zn.number.isRequired,text:zn.string.isRequired,fontSize:zn.number.isRequired,fontFamily:zn.string.isRequired,canvas:zn.object};var Yu=Lu,Wu=function(t){var e=t.height,n=t.width,r=t.groups,i=t.categories,o=t.selectedCategories,a=t.metricsByGroupByCategory,s=t.proportionsBySubgroup,c=t.setSelected,l=t.unitSpan,u=t.targetRef,d=t.fontSize,h=void 0===d?14:d;if(!e||!n)return pn.a.createElement("div",{className:"mosaic",ref:u});var p=f.a.mapValues(s,(function(t){return f()(t).flatMap((function(t){return f.a.map(t,(function(t){return t}))})).sum()})),g=Object(hn.useState)(null),m=M()(g,2),y=m[0],v=m[1],b=e-6*(r.length-1),k=n-85-2*(i.length-1),w=function(t,e,n,r,i){return t.reduce((function(t,o){var a,s=o.id,c=o.label,l=e[s]*n,u=Math.max(i+2,l+r);if(f.a.isEmpty(t))a=0;else{var d=f.a.last(t);a=d.height+d.y}return l<i&&(a+=l/2-.35*i),f.a.concat(t,{y:a,height:u,group:s,label:c})}),[])}(r,p,b,6,h),x=function(t,e,n,r,i,o,a){var s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0;return t.reduce((function(t,c){var l,u=c.id,d=f()(a[u]).flatMap((function(t){return f.a.map(t,f.a.identity)})).sum(),h=d*n;if(f.a.isEmpty(t))l=0;else{var p=f.a.last(t);l=p.height+p.y+6}var g=f()(e).reduce(ju(l,h,r,i,o[u],a[u],u,d,s),[]);return f.a.concat(t,g)}),[])}(r,i,b,k,o,a,s,85),A=Object(Xn.useSprings)(x.length,x.map((function(t){var e=t.x,n=t.y,r=t.width;return{x:e,y:n,width:r,height:t.height,opacity:r?1:0}}))),S=Object(Xn.useSprings)(w.length,w.map((function(t){var e=t.y,n=t.height,r=t.group;return{y:e,height:n,value:p[r]}}))).map((function(t,e){var n=t.height,r=t.value,i=t.y;return pn.a.createElement(Xn.animated.div,{className:"label",key:e,style:{height:n,top:i,position:"absolute",width:"".concat(85,"px"),fontSize:"".concat(h,"px")}},pn.a.createElement("span",{className:"group-label"},w[e].label),w[e].height>2*h&&pn.a.createElement(Xn.animated.span,{className:"group-value"},r.to((function(t){return"".concat(Math.round(100*t),"%")}))),0===e?pn.a.createElement("span",{className:"group-units"},l):null)})),O=x.map((function(t,e){var n=t.width,r=t.height,i=t.label;return pn.a.createElement(Yu,{key:e,text:i,width:n-16,height:r-12,fontSize:h,fontFamily:Yr})})),E=A.map((function(t,e){var n=t.x,r=t.y,i=t.width,o=t.height,a=t.opacity,s=x[e]||{},l=s.group,u=s.category,d=s.metric,f=s.color,h=y&&y.category===u&&y.group===l&&y.metric===d?Math.min(4,x[e].width/2):0;return pn.a.createElement(Xn.animated.div,{key:e,className:"rect",style:{position:"absolute",top:r,left:n,height:o,width:i,boxSizing:"border-box",border:"".concat(vs()(f).mix(vs()("white"),.5).string()," solid ").concat(h,"px"),background:f,opacity:a.to({range:[0,.1,1],output:[0,1,1]}),paddingTop:o.to((function(t){return"".concat(Math.max(0,Math.min(6,t/2)-h),"px")})),paddingLeft:i.to((function(t){return"".concat(Math.max(0,Math.min(8,t/2)-h),"px")}))},onMouseOver:function(){v({group:l,category:u,metric:d}),c({group:l,category:u,metric:d})}},O[e])}));return pn.a.createElement("div",{className:"mosaic",ref:u,onMouseLeave:function(){v(null),c(null)}},pn.a.createElement("div",{className:"labels-container"},S),pn.a.createElement("div",{className:"rects-container"},E))};Wu.propTypes={width:zn.number,height:zn.number,groups:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired})).isRequired,categories:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,color:zn.string})),selectedCategories:Object(zn.arrayOf)(zn.string).isRequired,metricsByGroupByCategory:zn.object.isRequired,proportionsBySubgroup:zn.object.isRequired,setSelected:zn.func.isRequired,unitSpan:zn.element.isRequired,targetRef:Object(zn.shape)({current:zn.object}),fontSize:zn.number};var qu=Wu,Nu=function(t,e){var n=[];return Array.isArray(t)?(0===t.length&&n.push("".concat(e," array is empty")),n):["".concat(e," argument is not of type Array")]},Gu=function(t,e,n,r,i){var o=[];return r in t?P()(t[r])!==i&&o.push("".concat(e," at index ").concat(n,": Property '").concat(r,"' must be of type '").concat(i,"'")):o.push("".concat(e," at index ").concat(n," does not contain '").concat(r,"' property")),o},Ju=function(t,e,n,r){var i=[];return"string"!=typeof t?i.push("".concat(n," at index ").concat(r,": Property ").concat(e," is not of type 'string'")):function(t){return null!==Pi.a.get(t)}(t)||i.push("".concat(n," at index ").concat(r,": Property ").concat(e," is not a valid CSS color")),i},Uu=function(t,e){for(var n=[],r=["capitalize","uppercase","lowercase"],i=O()(t.matchAll(/(?:\*{([^*{}]*)}\*)|(?:_{([^_{}]*)}_)|(?:{([^{}]*)})|(\n)/g)),o=0;o<i.length;o++){var a=i[o];if(!a[4]){var s=(a[1]||a[2]||a[3]).split("."),c=M()(s,2),l=c[0],u=c[1];f.a.includes(e,l)||n.push("Template variable '".concat(l,"' is not a valid prop")),u&&!r.includes(u)&&n.push("Template variable text transform '".concat(u,"' is not a valid CSS text-transform"))}}return n},Ku="_29bqi8hB8TVTWmt7UEazcv",Hu="_3LXT0xxzBkYFAbKgtk2gao",Vu="_309y8TeV-nZrlqASEw7eel",Zu="_9dHEn2dszq-NAo_YHC31g",Xu=function(t){var e=t.categories,n=t.onButtonClick;return 0===e.length?null:pn.a.createElement("div",{className:Ku},pn.a.createElement("span",{className:Hu},"Tap button for category breakdown"),pn.a.createElement("div",{className:Vu},e.map((function(t){var e=t.id,r=t.label,i=t.color,o=t.selected;return pn.a.createElement("div",{key:e,className:Zu,style:{color:"".concat(o?"white":i),backgroundColor:"".concat(o?i:"white"),borderColor:"".concat(o?i:"#BDBDBD")},onClick:function(){return n(e)},"aria-hidden":"true"},r)}))))};Xu.propTypes={categories:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,color:zn.string.isRequired,selected:zn.bool}).isRequired).isRequired,onButtonClick:zn.func.isRequired};var _u=Xu;function $u(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function td(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?$u(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):$u(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var ed=function(t){var e=t.title,n=t.subtitle,r=t.titleFontSize,i=t.subtitleFontSize,o=t.width,a=t.mosaicHeight,s=t.autosize,c=void 0!==s&&s,l=t.data,u=t.groups,d=t.categories,h=t.metrics,p=t.defaultSelected,g=void 0===p?[]:p,m=t.descriptionTemplate,y=t.selectedDescriptionTemplate,v=t.descriptionLines,b=t.yType,k=t.groupLabelTemplate,w=void 0===k?"":k,x=t.hideFooter,A=void 0!==x&&x,S=["yType","label","value","rowLabel","rowPercent","totalPercent"];if(!(f.a.isEmpty(function(t){var e=[].concat(Nu(t,"Groups")),n=[["id","string"],["label","string"]];return t.forEach((function(t,r){"object"!==P()(t)||null===t?e.push("Group at index ".concat(r," is not of type 'object'")):n.forEach((function(n){var i=M()(n,2),o=i[0],a=i[1];e.concat(Gu(t,"Group",r,o,a))}))})),e}(u))&&f.a.isEmpty(function(t){var e=[].concat(Nu(t,"Categories")),n=[["id","string"],["label","string"]];return t.forEach((function(t,r){"object"!==P()(t)||null===t?e.push("Category at index ".concat(r," is not of type 'object'")):(n.forEach((function(n){var i=M()(n,2),o=i[0],a=i[1];e.concat(Gu(t,"Category",r,o,a))})),"color"in t&&e.concat(Ju(t.color,"color","Category",r)))})),e}(d))&&f.a.isEmpty(function(t,e,n){var r=[].concat(Nu(n)),i=t.map((function(t){return t.id})),o=e.map((function(t){return t.id})),a=[["group","string"],["category","string"],["metrics","object"]];return n.forEach((function(t,e){if(a.forEach((function(n){var i=M()(n,2),o=i[0],a=i[1];r.concat(Gu(t,"Metric",e,o,a))})),"group"in t&&!i.includes(t.group)&&r.push("Metric at index ".concat(e,": Property 'group' is not a valid group")),"category"in t&&!o.includes(t.category)&&r.push("Metric at index ".concat(e,": Property 'category' is not a valid category")),"metrics"in t){var n=[["id","string"],["name","string"]];t.metrics.forEach((function(t){n.forEach((function(n){var i=M()(n,2),o=i[0],a=i[1];r.concat(Gu(t,"Metric",e,"metrics.".concat(o),a))})),"color"in t&&r.concat(Ju(t.color,"metrics.color","Metric",e))}))}})),r}(u,d,h))&&f.a.isEmpty(Uu(m,S))&&f.a.isEmpty(Uu(y,S))&&f.a.isEmpty(Uu(w,["yType"]))))return null;var O=Ur(l),E=Or(O),C=Object(hn.useState)(f.a.last(E).formatted),R=M()(C,2),j=R[0],I=R[1],B=Object(hn.useState)(g),D=M()(B,2),T=D[0],F=D[1],z=Object(hn.useState)(null),Q=M()(z,2),L=Q[0],Y=Q[1],W=(f.a.find(E,(function(t){return t.formatted===j}))||{}).key,q=f()(O).map(Iu(W)).sum(),N=f()(O).keyBy("id").mapValues(Iu(W)).value(),G=f()(h).groupBy("group").mapValues((function(t){return f()(t).keyBy("category").mapValues((function(t){return t.metrics})).value()})).value(),J=f()(h).groupBy("group").mapValues((function(t){return f()(t).flatMap("metrics").map("id").value()})).mapValues((function(t){return f.a.sumBy(t,(function(t){return N[t]}))})).value(),U=f()(h).groupBy("group").mapValues((function(t){return f()(t).keyBy("category").mapValues((function(t){var e=t.metrics;return f.a.sumBy(e,(function(t){var e=t.id;return N[e]}))})).value()})).value(),K=f()(h).groupBy("group").mapValues((function(t){return f()(t).keyBy("category").mapValues((function(t){var e=t.metrics;return f()(e).keyBy("id").mapValues((function(t){var e=t.id;return N[e]/q})).value()})).value()})).value(),H=f()(h).groupBy("category").mapValues((function(t){return f()(t).flatMap("metrics").map("name").uniq().value()})).value(),V={};d.forEach((function(t,e){var n=t.id,r=t.color;V[n]=r||Gi[e]}));var Z=L||{},X=Z.category,_=Z.group,$=Z.metric,tt=X?V[X]:null,et=_?_.toLowerCase():null,nt=q,rt=null,it=null,ot=null,at=Qr.percent;if(L)if($){var st=(f.a.chain(h).find({group:_,category:X}).get("metrics").find({id:$}).value()||{}).name;rt=(void 0===st?"":st).toLowerCase(),nt=N[$],it=at(N[$]/J[_]),ot=at(N[$]/q)}else{var ct=(f.a.find(d,{id:X})||{}).label;rt=(void 0===ct?"":ct).toLowerCase(),nt=U[_][X],it=at(U[_][X]/J[_]),ot=at(U[_][X]/q)}var lt,ut=d.filter((function(t){var e=t.id;return H[e].length>1})).map((function(t){var e=t.id;return{id:e,label:t.label,color:V[e],selected:T.includes(e)}})),dt=[],ft=[];if(!A){var ht=go({data:O}),pt=bo({data:O});dt=ht.sources,lt=ht.summary,ft=pt.footnotes}return pn.a.createElement($i,{className:"mosaic-plot",title:e,subtitle:n,titleFontSize:r,subtitleFontSize:i,style:{width:o||null,height:c?"100%":null},dropdowns:[{options:E,label:e?" ":"",parser:function(t){return t.formatted},defaultValue:j,onChange:function(t){var e=t.target;I(e.value)}}]},pn.a.createElement(Pc,{categories:d,fontSize:14,style:{marginBottom:12}}),pn.a.createElement(Fu,{hovered:L,descriptionTemplate:m,selectedDescriptionTemplate:y,descriptionLines:v,value:Qr.default(nt,{truncate:!1}),label:rt,emphasisColor:tt,rowLabel:et,rowPercent:it,totalPercent:ot,yType:b,fontSize:14}),pn.a.createElement("div",{style:{display:"flex",flexGrow:1,height:c?null:a}},pn.a.createElement(Pn,{handleWidth:!0,handleHeight:!0},(function(t){return pn.a.createElement(qu,{groups:u,categories:d,metricsByGroupByCategory:G,selectedCategories:T,proportionsBySubgroup:K,setSelected:Y,height:c?t.height:a,width:t.width||o,targetRef:t.targetRef,unitSpan:pn.a.createElement(Du,{template:w,yType:b}),fontSize:14})}))),pn.a.createElement(_u,{categories:ut,onButtonClick:function(t){T.includes(t)?F(f.a.without(T,t)):F(T.concat([t]))}}),!A&&pn.a.createElement(Ao,{sources:dt,summary:lt,footnotes:ft}))};ed.propTypes=td(td({},_i),{},{width:zn.number,mosaicHeight:zn.number,autosize:zn.bool,groups:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired})).isRequired,categories:Object(zn.arrayOf)(Object(zn.shape)({id:zn.string.isRequired,label:zn.string.isRequired,color:zn.string})),metrics:Object(zn.arrayOf)(Object(zn.shape)({group:zn.string.isRequired,category:zn.string.isRequired,metrics:Object(zn.arrayOf)(Object(zn.shape)({name:zn.string.isRequired,id:zn.string.isRequired,color:zn.string}))})).isRequired,data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,defaultSelected:Object(zn.arrayOf)(zn.string),descriptionTemplate:zn.string.isRequired,selectedDescriptionTemplate:zn.string.isRequired,descriptionLines:zn.number.isRequired,yType:zn.string.isRequired,groupLabelTemplate:zn.string,hideFooter:zn.bool});var nd=ed,rd=f.a.pick(ya,[ya.top,ya.bottom,ya.left,ya.right]),id={fontSize:13,footnotes:void 0,show:!0,showMetricFootnotes:!0,sources:void 0},od={fontSize:16,text:void 0},ad={fontSize:20,text:void 0},sd={color:void 0,spacing:0,negativeColor:void 0},cd={decimals:void 0,position:"above",show:!0,showSubtitle:!0},ld={displayRangeMin:void 0,displayRangeMax:void 0,displayTicks:["bottom"],fontSize:13,showGridlines:void 0,textColor:"#4D4D4D",ticks:void 0,type:void 0},ud={decimals:void 0,displayRangeMin:void 0,displayRangeMax:void 0,displayTicks:["left"],fontSize:13,showGridlines:void 0,textColor:"#4D4D4D",ticks:void 0,type:void 0},dd={"time-series-bar-chart":"_3VqfI0HbQlzXzAUhm5_qYS","chart-container":"_3aMTktrsUPtp43Njki_Wak"};function fd(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function hd(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?fd(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):fd(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var pd=f()(Qr).omit(["default"]).keys().value(),gd=function(t){var e=t.barOptions,n=void 0===e?sd:e,r=t.data,o=t.height,a=void 0===o?300:o,s=t.onClick,c=t.onMouseOut,l=t.onMouseOver,d=t.tooltipOptions,h=void 0===d?cd:d,p=t.transitionDuration,g=void 0===p?250:p,m=t.xAxisOptions,y=void 0===m?ld:m,v=t.yAxisOptions,b=void 0===v?ud:v,k=f.a.defaultsDeep({},n,sd),w=f.a.defaultsDeep({},h,cd),x=f.a.defaultsDeep({},y,ld),A=f.a.defaultsDeep({},b,ud),S=Object(hn.useRef)([]),E=Object(hn.useRef)(0),R=Object(hn.useState)(null),j=M()(R,2),I=j[0],B=j[1],D=Object(hn.useMemo)((function(){var t=["id","data","name","x_type","y_type"];if(!r||t.some((function(t){return!f.a.has(r,t)})))return{};var e=f.a.pick(hd({data:[]},r),[].concat(t,["tooltipTitle"])),n=e.data.filter((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.value;return Number.isFinite(e)})),i=Hr([hd(hd({},e),{},{data:n})],Sr).map((function(t){var e=n.find((function(e){return e.key===t.key})).value;return hd(hd({},t),{},{value:e})})).sort((function(t,e){return t.formatted<e.formatted?-1:1})),o=Zr(x.type)?x.type:Xr([e],"x")||"years",a=Jr({params:{format:o}}),s=[x.displayRangeMin,x.displayRangeMax].some((function(t){return void 0!==t})),c=[x.displayRangeMin?Sr(x.displayRangeMin,o):f.a.first(i).formatted,x.displayRangeMax?Sr(x.displayRangeMax,o):f.a.last(i).formatted];x.ticks&&!s&&(c[0]=f.a.min([c[0],Sr(x.ticks[0],o)]),c[1]=f.a.max([c[1],Sr(f.a.last(x.ticks),o)]));var l=Zr(A.type)?A.type:Xr([e],"y")||"linear",u=Jr({params:{format:l}}),d=i.map((function(t){return t.value})),h=[A.displayRangeMin||f.a.min(d),A.displayRangeMax||f.a.max(d)];!A.displayRangeMin&&d.every((function(t){return t>=0}))&&(h[0]=0),!A.displayRangeMax&&d.every((function(t){return t<=0}))&&(h[1]=0);var p=[A.displayRangeMin,A.displayRangeMax].some((function(t){return void 0!==t}));A.ticks&&!p&&(h[0]=f.a.min([h[0],A.ticks[0]]),h[1]=f.a.max([h[1],f.a.last(A.ticks)]));var g=i.filter((function(t){var e=t.formatted,n=t.value;return!(e<c[0]||e>c[1])&&!(n<h[0]||n>h[1])})),m=g.reduce((function(t,e,n){var r=t.color,i=t.negativeColor;return f.a.isArray(k.color)?r.push(Ji(k.color[n],Gi[n]||Gi[0])):r.push(Ji(k.color,Gi[0])),f.a.isArray(k.negativeColor)?i.push(Ji(k.negativeColor[n],Gi[n+1]||Gi[1])):i.push(Ji(k.negativeColor,Gi[1])),{color:r,negativeColor:i}}),{color:[],negativeColor:[]}),y=m.color,v=m.negativeColor;return{data:hd(hd({},e),{},{data:g,tooltipTitle:e.tooltipTitle||e.name,color:y,negativeColor:v}),xType:o,xDomain:c,xAxisFormat:a,yType:l,yDomain:h,yAxisFormat:u,hasCustomXDomain:s,hasCustomYDomain:p}}),[r,k,x,A]),T=D.data,F=D.xType,P=D.xDomain,z=D.xAxisFormat,Q=D.yType,L=D.yDomain,Y=D.yAxisFormat,W=D.hasCustomXDomain,q=D.hasCustomYDomain,N=Object(hn.useCallback)((function(t,e){var n=T.data[e],r=S.current[e];if(n&&r){var i=w.position,o=r.y;"above"===w.position?(o+=-10,r.y<100&&(i="below",o=r.y+10)):"below"===w.position&&(o+=r.height+10,r.y+r.height>E.current-100&&(i="above",o=r.y+r.height-10)),B({position:{x:r.x+r.width/2,y:o},value:n.value,direction:i,title:T.tooltipTitle||T.name,color:n.value<0?T.negativeColor[e]:T.color[e],label:z(n.key),type:T.y_type}),"function"==typeof l&&l(t,e,n)}}),[T,l,w,z]),G=Object(hn.useCallback)((function(t,e){I&&B(null);var n=T.data[e];n&&"function"==typeof c&&c(t,e,n)}),[T,I,c]),J=Object(hn.useCallback)((function(t,e){var n=T.data[e];n&&"function"==typeof s&&s(t,e,n)}),[T,s]);return T&&T.data.length?pn.a.createElement("div",{className:dd["time-series-bar-chart"]},pn.a.createElement(Pn,{handleHeight:!0,handleWidth:!0},(function(t){var e,n=t.width,r=void 0===n?1:n,o=t.height,s=void 0===o?parseInt(a,10):o,c=a?parseInt(a,10):s,l=1.2*(f.a.includes(x.displayTicks,rd.top)?x.fontSize:0),d=1.2*(f.a.includes(x.displayTicks,rd.bottom)?x.fontSize:0),h=function(t){var e,n=t.type,r=t.range,i=t.domain,o=t.hasCustomDomain,a=t.customTicks,s=void 0===a?void 0:a,c=O()(i);s&&(e=_r("y",n,s),o?e=e.filter((function(t){return t>=c[0]&&t<=c[1]})):c=[f.a.min([c[0],e[0]]),f.a.max([c[1],f.a.last(e)])]);var l=ei(n,c).range(r).nice();return e=ti({axisType:"y",scale:l,customTicks:e}),{domain:c,ticks:e,scale:l}}({type:Q,range:[c-d-0,l+0],domain:L,hasCustomDomain:q,customTicks:A.ticks}),p=h.ticks,m=h.scale,y=f.a.max(p.map((function(t){return ia(Y(t),A.fontSize).width}))),v=f.a.includes(A.displayTicks,rd.left)?y:0,b=f.a.includes(A.displayTicks,rd.right)?y:0,M=[v+5,r-b-5],R=function(t){var e=t.type,n=t.data,r=t.range,i=t.spacing,o=t.customDomain,a=void 0===o?[void 0,void 0]:o,s=a.some((function(t){return void 0!==t})),c=n.data.map((function(t){return t.formatted})).filter((function(t){return!s||(!!(a[0]&&t>=Sr(a[0],e))||!!(a[1]&&t<=Sr(a[1],e)))})),l=Object(C.scaleBand)().domain(c).range(r),u=l.bandwidth(),d=f.a.min([f.a.round(i/u,2),1]);return l.paddingInner(d),{scale:l}}({type:F,data:T,range:M,spacing:k.spacing}).scale,j=R.bandwidth(),B=function(t){var e,n=t.type,r=t.range,i=t.domain,o=t.hasCustomDomain,a=t.customTicks,s=void 0===a?void 0:a,c=O()(i);s&&(e=s.map((function(t){return Sr(t,n)})),o?e=e.filter((function(t){return t>=c[0]&&t<=c[1]})):c=[f.a.min([c[0],e[0]]),f.a.max([c[1],f.a.last(e)])]);var l=ei(n,c).range(r).nice();return e=ti({axisType:"x",scale:l,customTicks:e}),{domain:c,ticks:e,scale:l}}({type:F,range:[R(f.a.first(T.data).formatted)+j/2,R(f.a.last(T.data).formatted)+j/2],domain:P,hasCustomDomain:W,customTicks:x.ticks}),D=B.ticks,U=B.scale,K=m.domain()[0]<0&&m.domain()[1]>0,H=function(t){var e=t.data,n=t.barScale,r=t.yScale,i=r(0);return e.data.map((function(t,o){var a=t.key,s=t.formatted,c=t.value,l=c>=0,u=r(c),d=l?u:i,f=l?i-d:u-i,h=n(s);return{key:a,width:n.bandwidth(),height:f,color:l?e.color[o]:e.negativeColor[o],x:h,y:d}}))}({data:T,barScale:R,yScale:m});return S.current=H,E.current=c,pn.a.createElement("div",{className:dd["chart-container"],style:{height:c}},pn.a.createElement("svg",{style:{overflow:"visible",height:c,flex:1}},f()(rd).pick([rd.top,rd.bottom]).values().intersection(x.displayTicks).value().map((function(t){return pn.a.createElement(ba,{key:t,position:t,chartWidth:r,chartHeight:c,fontSize:x.fontSize,textColor:Ji(x.textColor,"#4D4D4D"),ticks:D.map((function(t){return{data:t,point:U(t)}})),formatter:function(t){return z(t,{ticks:D})},transitionDuration:g})})),f()(rd).pick([rd.left,rd.right]).values().intersection(A.displayTicks).value().map((function(t){return pn.a.createElement(ba,{key:t,position:t,chartWidth:r,chartHeight:c,fontSize:A.fontSize,textColor:Ji(A.textColor,"#4D4D4D"),ticks:p.map((function(t){return{data:t,point:m(t)}})),formatter:function(t){return Y(t,{ticks:p})},transitionDuration:g})})),(x.showGridlines||K)&&pn.a.createElement(Na,{orientation:Wa.vertical,range:m.range(),strokeWidth:1,gridColor:"#E6E6E6",ticks:D.filter((function(t){return x.showGridlines||0===t})).map((function(t){return{point:U(t)}})),transitionDuration:g}),(A.showGridlines||K)&&pn.a.createElement(Na,{orientation:Wa.horizontal,range:M,strokeWidth:1,gridColor:"#E6E6E6",ticks:p.filter((function(t){return A.showGridlines||0===t})).map((function(t){return{point:m(t),strokeWidth:K&&0===t&&A.showGridlines?3:1}})),transitionDuration:g}),pn.a.createElement(Fa,{bars:H,transitionDuration:g,transitionControllers:{update:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=["height","y","color"],t.next=3,n(f.a.pick(e,r));case 3:return t.next=5,n(f.a.omit(e,r));case 5:case"end":return t.stop()}}),t)}))),function(t,n){return e.apply(this,arguments)})},onMouseOver:N,onMouseOut:G,onClick:J})),w.show&&I&&pn.a.createElement("div",{className:"tooltip-container"},pn.a.createElement(oo,{direction:I.direction,x:I.position.x,y:I.position.y,width:r},pn.a.createElement(Za,{title:I.title,subtitle:w.showSubtitle?I.label:void 0,value:I.value,color:I.color,decimals:w.decimals,type:I.type}))))}))):(console.warn("No data was provided."),null)},md={barOptions:Object(zn.shape)({color:Object(zn.oneOfType)([zn.string,Object(zn.arrayOf)(zn.string)]),spacing:zn.number,negativeColor:Object(zn.oneOfType)([zn.string,Object(zn.arrayOf)(zn.string)])}),data:Object(zn.shape)({data:Object(zn.arrayOf)(Object(zn.shape)({key:zn.string.isRequired,value:zn.number})).isRequired,id:Object(zn.oneOfType)([zn.string,zn.number]).isRequired,name:zn.string.isRequired,tooltipTitle:zn.string,x_type:zn.string,y_type:zn.string}).isRequired,height:zn.number,tooltipOptions:Object(zn.shape)({decimals:zn.number,position:Object(zn.oneOf)(ro),show:zn.bool,showSubtitle:zn.bool}),transitionDuration:zn.number,xAxisOptions:Object(zn.shape)({displayRangeMax:Object(zn.oneOfType)([zn.number,zn.string]),displayRangeMin:Object(zn.oneOfType)([zn.number,zn.string]),displayTicks:Object(zn.arrayOf)(Object(zn.oneOf)(f.a.values(rd))),fontSize:zn.number,showGridlines:zn.bool,textColor:zn.string,ticks:Object(zn.arrayOf)(Object(zn.oneOfType)([zn.number,zn.string])),type:Object(zn.oneOf)(pd)}),yAxisOptions:Object(zn.shape)({decimals:zn.number,displayRangeMax:Object(zn.oneOfType)([zn.number,zn.string]),displayRangeMin:Object(zn.oneOfType)([zn.number,zn.string]),displayTicks:Object(zn.arrayOf)(Object(zn.oneOf)(f.a.values(rd))),fontSize:zn.number,showGridlines:zn.bool,textColor:zn.string,ticks:Object(zn.arrayOf)(Object(zn.oneOfType)([zn.number,zn.string])),type:Object(zn.oneOf)(pd)}),onMouseOver:zn.func,onMouseOut:zn.func,onClick:zn.func};gd.propTypes=hd({},md);var yd=gd;function vd(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function bd(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?vd(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):vd(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var kd=function(t){var e=t.barOptions,n=void 0===e?sd:e,r=t.data,i=t.dataSeriesOptions,o=void 0===i?[]:i,a=t.footerOptions,s=void 0===a?id:a,c=t.height,l=void 0===c?300:c,u=t.onClick,d=t.onMouseOut,h=t.onMouseOver,p=t.subtitleOptions,g=void 0===p?od:p,m=t.titleOptions,y=void 0===m?ad:m,v=t.tooltipOptions,b=void 0===v?cd:v,k=t.transitionDuration,w=void 0===k?250:k,x=t.width,A=void 0===x?"auto":x,S=t.xAxisOptions,O=void 0===S?ld:S,E=t.yAxisOptions,M=void 0===E?ud:E,C=f.a.defaultsDeep({},n,sd),R=f.a.defaultsDeep({},s,id),j=f.a.defaultsDeep({},g,od),I=f.a.defaultsDeep({},y,ad),B=f.a.defaultsDeep({},b,cd),D=f.a.defaultsDeep({},O,ld),T=f.a.defaultsDeep({},M,ud),F=Object(hn.useMemo)((function(){var t=Ur(r),e=ai(t,oi(t,o),["name","x_type","y_type","sources"]).map((function(t){return bd(bd({},t),{},{sources:t.sources||[],name:t.metric.labelText||t.name,tooltipTitle:t.metric.tooltipTitle||t.name})}));return{data:e,chartData:f.a.first(e)}}),[r,o]),P=F.data,z=F.chartData,Q=Object(hn.useMemo)((function(){return R.show?bd(bd({},go({data:P,chartSources:R.sources})),bo({data:P,chartFootnotes:R.footnotes,showMetricFootnotes:R.showMetricFootnotes})):{footnotes:[],sources:[],summary:""}}),[R,P]),L=Q.footnotes,Y=Q.sources,W=Q.summary,q=Object(hn.useMemo)((function(){return"auto"===A?void 0:parseInt(A,10)}),[A]),N=Object(hn.useMemo)((function(){return"auto"===l?"100%":parseInt(l,10)}),[l]);return r&&r.length?pn.a.createElement(la,{className:dd["time-series-bar-chart-wrapped"],fontSize:R.fontSize,footerSources:Y,footerSummary:W,footnotes:L,height:N,showFooter:R.show,showMetricFootnotes:R.showMetricFootnotes,subtitle:j.text,subtitleFontSize:j.fontSize,title:I.text,titleFontSize:I.fontSize,width:q},(function(t){var e=t.chartHeight;return pn.a.createElement("div",{style:{marginTop:"".concat(20,"px"),width:"100%"}},pn.a.createElement(yd,{barOptions:C,data:z,height:e-20,tooltipOptions:B,transitionDuration:w,xAxisOptions:D,yAxisOptions:T,onMouseOver:h,onMouseOut:d,onClick:u}))})):(console.warn("No data was provided."),null)};kd.propTypes=bd(bd(bd({},ua),f.a.omit(md,["data"])),{},{data:Object(zn.oneOfType)([Object(zn.arrayOf)(Object(zn.shape)(Oo)),Object(zn.arrayOf)(Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)(Oo)),sources:Object(zn.arrayOf)(Object(zn.shape)(So))}))]).isRequired,dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({id:Object(zn.oneOfType)([zn.string,zn.number]).isRequired,tooltipTitle:zn.string})),footerOptions:Object(zn.shape)({fontSize:zn.number,footnotes:ua.footnotes,show:ua.showFooter,showMetricFootnotes:zn.bool,sources:ua.footerSources}),height:Object(zn.oneOfType)([zn.string,zn.number]),subtitleOptions:Object(zn.shape)({fontSize:ua.subtitleFontSize,text:ua.subtitle}),titleOptions:Object(zn.shape)({fontSize:ua.titleFontSize,text:ua.title}),width:Object(zn.oneOfType)([zn.string,zn.number])});function wd(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function xd(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?wd(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):wd(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Ad=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];return t.flatMap((function(t){var n=t.id,r=t.states,i=(void 0===r?[]:r).concat(e.map((function(t){return{fips:t}})));return i&&i.length?i.map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.fips;return{id:"".concat(n,"-").concat(e),geo_id:e,strokeColor:"black"}})):{id:String(n)}}))},Sd=function(t){if(t&&t.length){var e=t[0];return f.a.isString(e)&&e.endsWith("-US")?e.substring(0,e.length-"-US".length):e}};function Od(t,e,n){var r=f.a.first(t);if(!r)return n;var i=e.map((function(t){return f.a.get(r,t,void 0)})).find((function(t){return void 0!==t}));return i&&Zr(i)?i.toLowerCase():n}var Ed=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.metric,n=void 0===e?{}:e;return xd(xd({},n),{},{id:n.geo_id&&"US"!==n.geo_id?"".concat(n.id,"-").concat(n.geo_id):String(n.id),data:n.data.map((function(t){var e=t.value;return{key:t.rawKey||!1,value:e}})),x_type:n.xType||n.x_type,y_type:n.yType||n.y_type})},Md=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=t&&t.length&&t[0]&&t[0].metric?t[0].metric:{};return xd(xd({},e),{},{datasets:t.map(Ed)})},Cd=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments.length>1?arguments[1]:void 0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.primaryColor,i=n.lineSize,o=n.annotations,a=void 0===o?[]:o,s=e.some((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.geo_id;return e&&"US"!==e}));return t.flatMap((function(t){var n=t.id,o=t.lineSize,c=void 0===o?i:o,l=t.primaryColor,u=void 0===l?r:l,d=t.states,f=t.labelText,h=t.tooltipTitle,p=t.featured;if(d&&d.length)return d.map((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.fips,i=a.filter((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.metric;return String(e)==="".concat(n,"-").concat(r)})).map((function(t){return xd(xd({},t),{},{showTitleOnChart:t.showOnChart})})),o=e.find((function(t){return t.id==="".concat(n,"-").concat(r)}));return{id:"".concat(n,"-").concat(r),lineWeight:c,color:u,labelText:f||s&&o&&o.geo_name||o.name,tooltipTitle:h||s&&o&&o.geo_name||o.name,annotations:i,featured:p}}));var g=a.filter((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.metric;return String(e)===String(n)})).map((function(t){return xd(xd({},t),{},{key:String(t.key),showTitleOnChart:t.showOnChart})})),m=e.find((function(t){return t.id===String(n)}));return{id:String(n),lineWeight:c,color:u,labelText:f||s&&m&&m.geo_name||m.name,tooltipTitle:h||s&&m&&m.geo_name||m.name,annotations:g,featured:p}}))},Rd=function(t){var e=t.title,n=t.subtitle,r=t.metrics,i=t.titleFontSize,o=t.subtitleFontSize,a=t.fontSize,s=t.startYear,c=t.startDate,l=t.selectedYear,u=t.chartSources,d=t.chartFootnotes,f=t.hideMetricsFootnotes,h=t.hideTitle,p=t.hideTooltip,g=t.hideTooltipYear,m=t.showSourcesAndFootnotes,y=t.hideYear,v=t.selectedStates,b=t.colourBins,k=t.centeredScale,w=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],x=Od(w,["metric.xType","metric.x_type"],"years"),A=Od(w,["metric.yType","metric.y_type"],"linear"),S=l||c||s||void 0;return gi({showUSA:!1,titleOptions:{text:h?"":e,fontSize:i},subtitleOptions:{text:h?"":n,fontSize:o},footerOptions:{footnotes:d,sources:u,show:m,showMetricFootnotes:!f,fontSize:a},dropdownOptions:{selectedItem:S?String(S):void 0,show:!y,type:x.toLowerCase()},dataSeriesOptions:Ad(r,w,v),tooltipOptions:{show:!p,showSubtitle:!g},keyType:A.toLowerCase(),scaleOptions:{colorScale:b,centeredScale:k,fontSize:a}})},jd=function(t){var e=t.title,n=t.subtitle,r=t.metrics,i=void 0===r?[]:r,o=t.topMetrics,a=void 0===o?[]:o,s=t.titleFontSize,c=t.subtitleFontSize,l=t.fontSize,u=t.chartSources,d=t.chartFootnotes,f=t.hideMetricsFootnotes,h=t.axisTextColor,p=t.hideGridlines,g=void 0===p||p,m=t.hideTitle,y=t.hideTooltip,v=t.hideTooltipYear,b=t.showSourcesAndFootnotes,k=t.hideYear,w=t.primaryColor,x=t.sortRows,A=t.metricHeight,S=t.hideAxisLabels,O=void 0===S||S,E=t.selectedYear,M=t.selectedDropdown,C=t.domain,R=void 0===C?[]:C,j=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],I=Od(j,["xType","x_type"],"linear"),B=Od(j,["yType","y_type"],"items"),D=i.some((function(t){return t.allStates}));return gi({titleOptions:{text:m?"":e,fontSize:s},featuredPosition:"top",subtitleOptions:{text:m?"":n,fontSize:c},footerOptions:{footnotes:d,sources:u,show:b,showMetricFootnotes:!f,fontSize:l},barOptions:{height:A||(D?14:void 0)},dropdownOptions:{selectedItem:M||E,show:!k,type:I},sort:!1!==x&&"descending",dataSeriesOptions:Cd(i.concat(a.map((function(t){return xd(xd({},t),{},{featured:!0})}))),j,{primaryColor:w}),xAxisOptions:{textColor:h,displayRangeMin:R[0],displayRangeMax:R[1],showGridlines:!g,displayTicks:O?[]:["top"],type:B,fontSize:l},tooltipOptions:{show:!y,showSubtitle:!v},labelOptions:{fontSize:l}})},Id=function(t){var e=t.title,n=t.subtitle,r=t.metrics,i=void 0===r?[]:r,o=t.topMetrics,a=void 0===o?[]:o,s=t.titleFontSize,c=t.subtitleFontSize,l=t.fontSize,u=t.startYear,d=t.endYear,f=t.selectedYear2,h=t.startDate,p=t.endDate,g=t.selectedYear,m=t.chartSources,y=t.chartFootnotes,v=t.hideMetricsFootnotes,b=t.axisTextColor,k=t.hideGridlines,w=t.hideTitle,x=t.hideTooltip,A=t.hideTooltipYear,S=t.showSourcesAndFootnotes,O=t.hideYear,E=t.primaryColor,M=t.sortRows,C=t.metricHeight,R=t.hideAxisLabels,j=t.domain,I=void 0===j?[]:j,B=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],D=Od(B,["xType","x_type"],"linear"),T=Od(B,["yType","y_type"],"items"),F=B.some((function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.geo_id;return e&&"US"!==e})),P=i.some((function(t){return t.allStates})),z=g||h||u||void 0,Q=f||p||d||void 0;return gi({titleOptions:{text:w?"":e,fontSize:s},featuredPosition:"top",subtitleOptions:{text:w?"":n,fontSize:c},footerOptions:{footnotes:y,sources:m,show:S,showMetricFootnotes:!v,fontSize:l},dataSeriesHeight:C||(P?14:void 0),dropdownOptions:{selectedItem1:z?String(z):void 0,selectedItem2:Q?String(Q):void 0,show:!O,type:D},sort:!1!==M&&"descending",dataSeriesOptions:[{metrics:i,overrides:{featured:!1}},{metrics:a,overrides:{featured:!0}}].reduce((function(t,e){var n=e.metrics,r=e.overrides;return t.concat(n.map((function(t){var e=B.find((function(e){return e.id===String(t.id)}));return xd({id:t.id,dot2Color:E||t.primaryColor,labelText:t.labelText||F&&e&&e.geo_name||e.name,tooltipTitle:t.tooltipTitle||F&&e&&e.geo_name||e.name,selected:t.id===z||t.id===Q},r)})))}),[]),dotOptions:{dot2Color:E},fontSize:l,xAxisOptions:{textColor:b,showGridlines:!k,displayTicks:R?[]:["top"],displayRangeMin:I[0],displayRangeMax:I[1],type:T,fontSize:l},tooltipOptions:{show:!x,showSubtitle:!A},labelOptions:{fontSize:l}})},Bd=function(t,e){var n=t.title,r=t.subtitle,i=t.metrics,o=t.titleFontSize,a=t.subtitleFontSize,s=t.fontSize,c=t.startYear,l=t.endYear,u=t.startDate,d=t.endDate,f=t.chartSources,h=t.chartFootnotes,p=t.hideMetricsFootnotes,g=t.axisTextColor,m=t.gridColor,y=t.hideGridlines,v=t.hideLineLabels,b=t.hideTitle,k=t.hideTooltip,w=t.hideTooltipYear,x=t.highlighted,A=t.showLegend,S=t.showSourcesAndFootnotes,O=t.showXGridlines,E=t.yDomain,M=void 0===E?[]:E,C=t.areaFill,R=t.annotations,j=t.lineSize,I=t.primaryColor,B=Od(e,["xType","x_type"],"years"),D=Od(e,["yType","y_type"],"linear");return gi({titleOptions:{text:b?"":n,fontSize:o},subtitleOptions:{text:b?"":r,fontSize:a},dataSeriesOptions:Cd(i,e,{primaryColor:I,lineSize:j,annotations:R?R.map((function(t){return xd(xd({},t),{},{fontSize:s})})):[]}),xAxisOptions:{textColor:g,displayRangeMin:u||c,displayRangeMax:d||l,displayTicks:["bottom"],type:B,fontSize:s},yAxisOptions:{textColor:g,displayTicks:["left"],displayRangeMin:M[0],displayRangeMax:M[1],type:D,fontSize:s},gridLineOptions:{color:m,showVerticalLines:O,showHorizontalLines:!y},labelOptions:{show:void 0!==v?!v:!1===A||void 0,fontSize:s},tooltipOptions:{show:!k,showSubtitle:!w},selectedLineId:Sd(x),legendOptions:{show:A,fontSize:s},footerOptions:{show:S,sources:f,footnotes:h,showMetricFootnotes:!p,fontSize:s},fillToOrigin:C})};function Dd(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Td(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Dd(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Dd(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Fd=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c,l;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:return r=t.t0,t.next=8,e.parent;case 8:i=t.sent,o=zt({data:r,parent:i,options:n}),a=o.title,s=o.subtitle,c=r.map(Ed),l=Bd(Td(Td({},n),{},{title:a,subtitle:s}),c),p.a.render(pn.a.createElement(Cu,Td(Td({},l),{},{data:c})),this.container.node());case 13:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function Pd(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function zd(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Pd(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Pd(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Qd=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:r=t.t0,p.a.render(pn.a.createElement(Cu,zd(zd({},n),{},{data:r.map(Ed)})),this.container.node());case 7:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}(),Ld=function(t){return t},Yd=function(t){if(null==t)return Ld;var e,n,r=t.scale[0],i=t.scale[1],o=t.translate[0],a=t.translate[1];return function(t,s){s||(e=n=0);var c=2,l=t.length,u=new Array(l);for(u[0]=(e+=t[0])*r+o,u[1]=(n+=t[1])*i+a;c<l;)u[c]=t[c],++c;return u}},Wd=function(t,e){return"string"==typeof e&&(e=t.objects[e]),"GeometryCollection"===e.type?{type:"FeatureCollection",features:e.geometries.map((function(e){return qd(t,e)}))}:qd(t,e)};function qd(t,e){var n=e.id,r=e.bbox,i=null==e.properties?{}:e.properties,o=Nd(t,e);return null==n&&null==r?{type:"Feature",properties:i,geometry:o}:null==r?{type:"Feature",id:n,properties:i,geometry:o}:{type:"Feature",id:n,bbox:r,properties:i,geometry:o}}function Nd(t,e){var n=Yd(t.transform),r=t.arcs;function i(t,e){e.length&&e.pop();for(var i=r[t<0?~t:t],o=0,a=i.length;o<a;++o)e.push(n(i[o],o));t<0&&function(t,e){for(var n,r=t.length,i=r-e;i<--r;)n=t[i],t[i++]=t[r],t[r]=n}(e,a)}function o(t){return n(t)}function a(t){for(var e=[],n=0,r=t.length;n<r;++n)i(t[n],e);return e.length<2&&e.push(e[0]),e}function s(t){for(var e=a(t);e.length<4;)e.push(e[0]);return e}function c(t){return t.map(s)}return function t(e){var n,r=e.type;switch(r){case"GeometryCollection":return{type:r,geometries:e.geometries.map(t)};case"Point":n=o(e.coordinates);break;case"MultiPoint":n=e.coordinates.map(o);break;case"LineString":n=a(e.arcs);break;case"MultiLineString":n=e.arcs.map(a);break;case"Polygon":n=c(e.arcs);break;case"MultiPolygon":n=e.arcs.map(c);break;default:return null}return{type:r,coordinates:n}}(e)}var Gd=n(31),Jd=n.n(Gd);function Ud(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}function Kd(t,e){var n=this.container.node().getBoundingClientRect(),r=e.getBoundingClientRect(),i=r.x,o=r.y,a=r.width,s=r.height,c=this.cachedParams.cartogramOptions.tooltipTextFunction(t);this.tooltip.draw(i-n.left+a/2,o-n.top+s/2,{title:{value:null},subtitle:{value:null}},[{type:"value",value:c,html:!0}],{primaryColour:"black"},4)}var Hd=function(t){Q()(n,t);var e=Ud(n);function n(t){var r,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};a()(this,n),r=e.call(this);var o=i.width,s=i.height,c=i.hide,l=i.standalone,u=void 0===l||l,d=Kt(t);if(null===d)throw new Error("[Cartogram] Constructor argument is not an Element or D3 selection, or two instances of D3 are being used");return r.container=u?d.append("svg").classed("cartogram-standalone",!0):d,r.containerG=r.container.append("g").classed("cartogram",!0),r.width=o||1e3,r.height=s||600,r.stroke=4,r.scale=2,r.standalone=u,r.tooltip=new nn(d),r.initializeMap(c,u),r}return c()(n,[{key:"on",value:function(t,e){Jd()(Xt()(n.prototype),"on",this).call(this,t,e),this.setListeners()}},{key:"setListeners",value:function(){var t=this,e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],n=null,r=null,i=null,o=this.containerG.selectAll("g.cartogram-hex .inner-polygon");e&&(n=f.a.throttle((function(e,n){t.setHovered(n.properties.fips),t.trigger("hover",n,e),t.cachedParams&&t.cachedParams.cartogramOptions.tooltipTextFunction&&"US"!==n.properties.fips&&(Kd.call(t,n,e.currentTarget),e.stopPropagation())}),1e3/60,{trailing:!1}),r=function(){t.setHovered(null),t.tooltip.hide(),t.trigger("mouseout")},i=function(e,n){t.trigger("click",n)}),o.on("mousemove",n).on("mouseout",r).on("click",i)}},{key:"initializeMap",value:function(t,e){var n=this;t&&this.containerG.classed("hidden",!0),this.drawUSA(Ye(Pe)),this.setListeners(),e&&(this.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;n.width!==e&&0!==e&&requestAnimationFrame((function(){n.width=e,n.redraw()}))}))})),this.ro.observe(this.container.node()))}},{key:"drawUSA",value:function(t,e){var n=this;this.containerG.selectAll("g.cartogram-hex").data(t,(function(t){return t.fips||t.selector})).join((function(t){var e=t.append("g").classed("cartogram-hex",!0);return e.append("polygon").classed("outer-polygon",!0),e.append("polygon").classed("inner-polygon",!0),e.append("text").classed("cartogram-label",!0),e}),(function(t){return t}));var r=this.containerG.selectAll("g.cartogram-hex");r.select(".outer-polygon").attr("points",(function(t){return Ne(t,n.width,n.stroke,"US"===t.properties.fips&&e.cartogramOptions.makeUSABigger).map((function(t){return t.join(",")}))})),r.select(".inner-polygon").attr("points",(function(t){return(r=t,i=n.width,n.stroke,o=n.stroke/2,a="US"===t.properties.fips&&e.cartogramOptions.makeUSABigger,s=qe(r.i,r.j,i,0,a),c=s.x,l=s.y,u=s.radius-o,d=s.apothem-o,f=Math.sin(Math.PI/6),[[c,l-u],[c+d,l-f*u],[c+d,l+f*u],[c,l+u],[c-d,l+f*u],[c-d,l-f*u]]).map((function(t){return t.join(",")}));var r,i,o,a,s,c,l,u,d,f})).style("stroke-width",this.stroke/2).style("stroke","white"),r.select(".cartogram-label").attr("x",(function(t){return qe(t.i,t.j,n.width,n.stroke).x})).attr("y",(function(t){return qe(t.i,t.j,n.width,n.stroke,"US"===t.properties.fips&&e.cartogramOptions.makeUSABigger).y})).text((function(t){return t.properties.abbr})),C.selectAll("g.cartogram-hex.selected").raise()}},{key:"draw",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.cachedParams=t,this.standalone&&this.container.attr("viewBox","0 0 ".concat(this.width," ").concat(this.height));var e=t.cartogramOptions;t.usaData&&e.showUSA?(this.drawUSA(We(ze),t),this.containerG.selectAll("g.cartogram-hex").classed("usa",(function(t){return"US"===t.properties.fips}))):this.drawUSA(Ye(Pe),t),this.setSelected(t),this.setPointerEvents(t)}},{key:"setSelected",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.cartogramOptions,n=t.selectedStates,r=e.colourFunction||function(){return et.chartcolourgreycartogram},i=e.outlineFunction||function(){return"white"},o=this.containerG.selectAll("g.cartogram-hex").attr("fill",(function(t){return Ge(t,r,e,!1)}));o.selectAll("text.cartogram-label").style("fill",(function(t){return e.autoLabelColour&&vs()(Ge(t,r,e,!1)).isDark()?"white":e.lighterUnselectedText?"#999999":null})),e.selectableCartogram&&o.classed("selected",(function(t){return f.a.some(n,(function(e){return e===t.properties.fips}))}));var a=C.selectAll("g.cartogram-hex.selected").raise();a.attr("fill",(function(t){return Ge(t,r,e,!0)})),a.select("polygon").style("stroke",(function(t){return i(t)})),a.selectAll("text.cartogram-label").style("fill",(function(t){return e.autoLabelColour&&vs()(Ge(t,r,e,!0)).isDark()?"white":null})),this.setListeners()}},{key:"setHovered",value:function(t){var e=this.cachedParams,n=e.cartogramOptions,r=e.selectedStates,i=n.colourFunction||function(){return et.chartcolourgreycartogram};this.containerG.selectAll("g.cartogram-hex:not(.selected)").attr("fill",(function(e){var o=Ge(e,i,n,!1);return e.properties.fips===t&&r&&void 0===r.find((function(t){return t===e.properties.fips}))&&n.fillHovered?n.fillHovered(e,o):o}))}},{key:"redraw",value:function(){this.cachedParams&&this.draw.apply(this,O()(this.cachedParams))}},{key:"setPointerEvents",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.cartogramOptions;e.disabled?(this.containerG.selectAll("g").style("opacity","0.3"),this.setListeners(!1)):(this.containerG.selectAll("g").style("opacity","1"),this.setListeners())}}]),n}(rn),Vd=["cartogram","hideYear","hideDropdown","colourBins","colourScale","selectedStates","centeredScale","primaryColor","useLegendExtremesTooltipColour","cartogramOptions","hideLegend","useCartogramBounds","hideTitle","showSourcesAndFootnotes","tooltipTitle"];function Zd(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Xd(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Zd(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Zd(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var _d=n(87);function $d(t,e,n){return n&&"items"===n.toLowerCase()?t===e:e.getTime?t.getTime()===e.getTime():t.getTime()===St(e,n).getTime()}function tf(t,e,n){var r=f.a.find(t,(function(t){return t.metric.geo_name===e}));if(void 0!==r){var i=f.a.find(r.metric.data,(function(t){return $d(t.key,n,r.metric.xType)}));return void 0===i?null:i.value}}function ef(t,e,n){var r,i,o,a=f()(t).map("metric").flatMap((function(t){return t.data.map((function(e){return Xd(Xd({},e),{},{type:t.xType})}))})).filter((function(t){return $d(t.key,e,t.type)})).map("value").value();return n.centeredScale?C.scaleThreshold().domain((r=f.a.min(a),i=f.a.max(a),o=n.colourBins.length-1,-1*r>i?f.a.map(Array(o),(function(t,e){return-2*r/(o+1)*(e+1)+r})):f.a.map(Array(o),(function(t,e){return 2*i/(o+1)*(e+1)-i})))).range(n.colourBins):C.scaleThreshold().domain(function(t,e,n){return f.a.map(Array(n),(function(r,i){return t+(e-t)/(n+1)*(i+1)}))}(f.a.min(a),f.a.max(a),n.colourBins.length-1)).range(n.colourBins)}function nf(t,e){var n=t.domain()[t.domain().length-1]-t.domain()[0],r=t.domain()[t.domain().length-1]+n,i=t.domain()[0]-n;return null==e||e>r||e<i?"rgb(185, 185, 185)":t(e)}function rf(t,e,n){return null==e?"N/A":t(e,n)}function of(t,e){var n=this,r=t.data,i=t.params,o=i.margins,a=i.fontSize,s=ef(r,this.dropdownSelected,i),c=f()(r).map("metric").flatMap((function(t){return t.data.map((function(e){return Xd(Xd({},e),{},{type:t.xType})}))})).filter((function(t){return $d(t.key,n.dropdownSelected,t.type)})).map("value").value(),l=f.a.min(c),u=f.a.max(c);i.centeredScale&&(l>=0||-1*l<u?l=-1*u:u=-1*l);var d=f.a.flattenDeep([l,s.domain(),u]),h=s.range(),p=this.height/4,g=this.height/2,m=this.width-o.right-o.legendPosition,y=[],v=this.svg.append("g");v.selectAll(".dummyText").data(d).enter().append("text").style("font-size","".concat(a,"px")).text((function(t){return rf(e,t,{ticks:d,autoSmallDecimals:!0})})).each((function(){var t=this.getComputedTextLength();y.push(t),this.remove()})),v.remove();var b=Math.max.apply(Math,y);this.svg.selectAll("g.legend").data([s]).enter().append("g").classed("legend",!0);var k=this.svg.selectAll("g.legend"),w=k.selectAll("line.color").data(h);w.enter().append("line").classed("color",!0).merge(w).attr("stroke-width",5).attr("x1",m).attr("x2",m).attr("y1",(function(t,e){return p+g/h.length*(h.length-e)})).attr("y2",(function(t,e){return p+g/h.length*(h.length-e-1)})).attr("stroke",(function(t){return t})),w.exit().remove();var x=k.selectAll("text.tick").data(d);x.enter().append("text").classed("tick",!0).merge(x).style("font-size","".concat(a,"px")).attr("x",m+5+5+b).attr("y",(function(t,e){return p+g/h.length*(h.length-e)})).style("user-select","none").text((function(t){return rf(e,t,{ticks:d,autoSmallDecimals:!0})})),x.exit().remove()}function af(t,e,n,r){var i=t.data,o=t.params,a=o.cartogramOptions,s=o.cartogram,c=o.tooltipTitle,l=o.usaData;this.svg.selectAll("path").style("stroke-width",null),C.select(n.currentTarget).style("stroke-width",4),this.hoveredArea!==e.properties.fips&&(s?C.select(n.currentTarget.parentNode).raise():C.select(n.currentTarget).raise(),f.a.some(a.selectedStates,(function(t){return t!==e.properties.fips}))||C.selectAll("g.cartogram-hex.selected").raise(),this.hoveredArea=e.properties.fips);var u=this.container.node().getBoundingClientRect(),d=n.clientX,h=n.clientY,p=d-u.left,g=h-u.top,m=Ft(t),y=tf(i.concat(l),e.properties.name,this.dropdownSelected),v=rf(m,y),b=function(t,e,n){var r=t.params,i=r.useLegendExtremesTooltipColour,o=r.colourBins,a=r.primaryColor;if(i){var s=Math.floor(o.length/2);return o.indexOf(e(0))===s?n<0?o[0]:n>=0?o[o.length-1]:"rgb(185, 185, 185)":o.indexOf(e(n))>=s?o[o.length-1]:o.indexOf(e(n))>=0?o[0]:"rgb(185, 185, 185)"}return a}(t,r,y),k={title:{value:null!=c?c:e.properties.name},subtitle:{value:this.dropdownSelected}};this.tooltip.draw(p,g,k,[{type:"value",value:v}],{primaryColour:b})}function sf(t){var e=this,n=t.data,r=t.params.margins,i=this;this.mapArea.on("mouseout",(function(){e.tooltip.hide(),e.svg.selectAll("path").style("stroke-width",null).filter((function(t){return t.metric&&t.metric.selectedState})).raise()}));var o=C.geoAlbersUsa().translate(),a=M()(o,2),s=a[0],c=a[1],l=C.geoAlbersUsa().scale(),u=(this.width-r.left-r.right-r.legendPosition)/(2*(s-90)),d=C.geoAlbersUsa().scale(u*l).translate([u*(s-90)+r.left,u*c+r.top]),h=ef(n,this.dropdownSelected,t.params),p=Wd(_d,_d.objects.states).features.map((function(t){var e=f.a.find(n,(function(e){return e.fips===t.id}));return Xd(Xd({},t),{},{metric:e})}));this.mapArea.selectAll("path").data(p,(function(t){return t.id})).join("path").attr("d",C.geoPath(d)).on("mousemove",f.a.throttle((function(e,n){af.call(i,t,n,e,h)}),1e3/60,{trailing:!1})).style("fill",(function(t){return nf(h,tf(n,t.properties.name,e.dropdownSelected))})).each((function(t){var e=C.select(this),n=t.metric&&t.metric.selectedState;n&&e.raise(),e.classed("selected",n)}))}function cf(t){var e=this,n=t.data,r=t.params,i=r.margins,o=r.usaData,a=this,s=ef(n,this.dropdownSelected,t.params),c=this.width-i.left-2*i.right-i.legendPosition,l=C.geoAlbersUsa().translate(),u=c/(2*M()(l,1)[0]),d=qe(0,0,this.width).radius,f=t.params;f.cartogramOptions.colourFunction=function(t){return nf(s,tf(n.concat(o),t.properties.name,e.dropdownSelected))},f.cartogramOptions.outlineFunction=function(r){return i=tf(n.concat(o),r.properties.name,e.dropdownSelected),a=t.params,null!==(s=a.cartogramOptions).posNegOutlineColours?i>=0?s.posNegOutlineColours[0]:s.posNegOutlineColours[1]:s.cartogramOutlineColour;var i,a,s},this.svg.select("g.cartogram").attr("transform","scale(".concat(u,") translate(").concat(i.left,",").concat(i.top+d/2,")")),this.cartogram.draw(f),this.cartogram.on("hover.__mapDefault",(function(e,n){af.call(a,t,e,n,s)})),this.cartogram.on("mouseout.__mapDefault",(function(){e.tooltip.hide()})),this.cartogram.on("click.__mapDefault",(function(){e.tooltip.hide()}))}function lf(t){this.cachedParams=t;var e=Pt(t),n=t.data,r=t.params,i=r.margins,o=r.info,a=r.hideYear,s=r.hideDropdown,c=r.useCartogramBounds,l=r.hideLegend,u=r.hideTitle,d=r.showSourcesAndFootnotes,f=C.geoAlbersUsa().translate(),h=M()(f,2),p=h[0],g=h[1],m=this.width-i.left-i.right-i.legendPosition;if(this.height=g/(p-90)*m+i.top+i.bottom,c){var y=qe(1,0,1e3).hexDi;this.height=(7*y*.75+2*y)/(12*y)*m+i.top+i.bottom}this.svg.attr("viewBox","0 0 ".concat(this.width," ").concat(this.height)),u||Nt.call(this,this.title,this.subtitle,t,a||s?null:this.dropdownSelected),l||of.call(this,t,e),this.isCartogram?(cf.call(this,t),this.svg.select("g.map-area").classed("hidden",!0),this.svg.select("g.cartogram").classed("hidden",!1)):(sf.call(this,t),this.svg.select("g.map-area").classed("hidden",!1),this.svg.select("g.cartogram").classed("hidden",!0)),o&&"chart"===o.position&&T.inChart(this.container,{info:o}),d&&this.sources.draw(n,t.params)}var uf=function(){function t(e){var n=this;a()(this,t),this.chartType=m.Map,this.cssPrefix="map",this.dropdownSelected=null,this.margins={top:20,bottom:20,left:10,right:20,legendPosition:60},this.width=960,this.isCartogram=!1,this.container=e,void 0!==this.container?(this.title=e.append("div").classed("chart-title",!0),this.subtitle=e.append("div").classed("chart-subtitle",!0),this.svg=e.classed("map",!0).classed("dh-chart-wrapper",!0).append("svg"),this.cartogram=new Hd(this.svg,{width:this.width,height:this.height,hide:!0,standalone:!1}),this.hoveredArea=null,this.mapArea=this.svg.append("g").classed("map-area",!0),this.sourceContainer=e.append("div"),this.sources=new en(this.sourceContainer),this.tooltip=new nn(e),Ze.call(this),this.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;n.width!==e&&0!==e&&requestAnimationFrame((function(){n.width=e,n.redrawContent()}))}))})),this.ro.observe(e.node())):this.draw=this.drawCanvas}var e,n,r;return c()(t,[{key:"setDropdownSelected",value:function(t){this.dropdownSelected=t}},{key:"redrawContent",value:function(){this.cachedParams&&lf.call(this,this.cachedParams)}},{key:"data",value:(r=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c,l,d,h,p,g;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return i=r.data,o=r.topMetrics,a=r.parent,s=f.a.map(Qe,"name"),c=f()(i).filter((function(t){return f.a.includes(s,t.metric.geo_name)})).map((function(t){return Xd(Xd({},t),{},{metric:Xd(Xd({},t.metric),{},{data:f.a.sortBy(t.metric.data,(function(t){return t.key}))})})})).value(),l=[],o&&o.length>0&&(l=[Xd(Xd({},o[0]),{},{metric:Xd(Xd({},o[0].metric),{},{geo_name:"USA",data:f.a.sortBy(o[0].metric.data,(function(t){return t.key}))}),selector:"US",fips:"00"})]),d=!0,h=n.startDate||n.startYear,p=n.endDate||n.endYear,g=f()(c).flatMap((function(t){return t.metric.data.map((function(e){var n=e.key;return t.metric.xType&&"items"===t.metric.xType.toLowerCase()&&(d=!1),{key:n,xType:t.metric.xType}}))})).filter((function(t){return!((!t.xType||"items"!==t.xType.toLowerCase())&&(h&&t.key.getTime()<St(h,t.xType).getTime()||p&&t.key.getTime()>St(p,t.xType).getTime()))})).map((function(t){return Ot(t.key,t.xType)})).uniq().value(),null!==this.dropdownSelected&&g.includes(this.dropdownSelected)||(void 0!==n.selectedYear&&g.includes(n.selectedYear.toString())?this.dropdownSelected=n.selectedYear:void 0!==n.selectedDropdown&&g.includes(n.selectedDropdown.toString())?this.dropdownSelected=n.selectedDropdown:this.dropdownSelected=d?f.a.maxBy(g,(function(t){return new Date(t)})):f.a.first(g)),n.forceYear&&g.includes(n.forceYear.toString())&&(this.dropdownSelected=n.forceYear),n.forceDropdown&&g.includes(n.forceDropdown.toString())&&(this.dropdownSelected=n.forceDropdown),t.abrupt("return",{data:c,usaData:l,parent:a,keys:g});case 18:case"end":return t.stop()}}),t,this)}))),function(t,e){return r.apply(this,arguments)})},{key:"getDrawParams",value:function(e){var n=e.data,r=e.usaData,i=e.parent,o=e.options,a=o.cartogram,s=void 0!==a&&a,c=o.hideYear,l=void 0!==c&&c,u=o.hideDropdown,d=void 0!==u&&u,f=o.colourBins,h=void 0===f?null:f,p=o.colourScale,g=void 0===p?null:p,m=o.selectedStates,y=void 0===m?[]:m,v=o.centeredScale,b=void 0!==v&&v,k=o.primaryColor,x=void 0===k?null:k,A=o.useLegendExtremesTooltipColour,S=void 0!==A&&A,O=o.cartogramOptions,E=void 0===O?{}:O,M=o.hideLegend,C=void 0!==M&&M,R=o.useCartogramBounds,j=void 0!==R&&R,I=o.hideTitle,B=void 0!==I&&I,D=o.showSourcesAndFootnotes,T=void 0===D||D,F=o.tooltipTitle,P=void 0===F?null:F,z=w()(o,Vd),Q=t.getColourBins(h,g,b);return Xd(Xd({},Qt({data:n,parent:i,options:z},this.margins)),{},{usaData:r,cartogram:s,hideYear:l,hideDropdown:d,colourBins:Q,selectedStates:y,centeredScale:b,primaryColor:x||Q.slice(-1)[0]||et.chartcolourdefault8,useLegendExtremesTooltipColour:S,cartogramOptions:Xd({autoLabelColour:!0,cartogramOutlineColour:"#015193",makeUSABigger:!1,posNegOutlineColours:null,selectableCartogram:!1,showUSA:!1},E),hideLegend:C,useCartogramBounds:j,hideTitle:B,showSourcesAndFootnotes:T,tooltipTitle:P})}},{key:"draw",value:(n=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=d.length>1&&void 0!==d[1]?d[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=r.data,o=r.usaData,a=r.parent,s=r.keys,(c=this.getDrawParams({data:i,usaData:o,parent:a,options:n})).hideLegend&&(c.margins.legendPosition=0),c.selectableYears=!Object.prototype.hasOwnProperty.call(n,"selectableYears")||n.selectableYears,c.selectableDropdowns=!Object.prototype.hasOwnProperty.call(n,"selectableDropdowns")||n.selectableDropdowns,l={data:i,parent:a,keys:s,params:c},this.isCartogram=n.cartogram,"top"===c.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node()),this.container.node().insertBefore(this.subtitle.node(),this.svg.node())):"bottom"===c.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node()),this.container.node().append(this.sourceContainer.node())),lf.call(this,l),t.abrupt("return",!0);case 16:case"end":return t.stop()}}),t,this)}))),function(t){return n.apply(this,arguments)})},{key:"drawCanvas",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,f,h,p,g,m,y,v,b,k,w,x,A,S,O,E,j,I,B,D,T,F,P,z,Q,L,Y,W,q,N,G,J,U,K,H,V=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=V.length>1&&void 0!==V[1]?V[1]:{},r=V.length>2?V[2]:void 0,i=r.margin,o=void 0===i?40:i,a=r.width,s=void 0===a?720:a,c=r.scale,l=void 0===c?3:c,d=r.key,f=void 0===d?void 0:d,h=r.showText,p=void 0===h||h,g=r.showBranding,m=void 0===g||g,y=r.xOffset,v=void 0===y?0:y,b=r.yOffset,k=void 0===b?0:b,w=V.length>3&&void 0!==V[3]?V[3]:Object(R.createCanvas)(s,s),t.next=5,this.data(e,n);case 5:if(x=t.sent){t.next=8;break}return t.abrupt("return",w);case 8:if(A=x.data,S=x.parent,O=this.getDrawParams({data:A,parent:S,options:n},this.margins),E=O.margins,null!==o&&(O.margins.left=o,O.margins.right=o),j=f||this.dropdownSelected,I=ef(A,j,O),B=20+o+20,D=O.titleFontSize*parseFloat(it),T=""!==O.subtitle,F=T?O.subtitleFontSize*parseFloat(lt):0,P=o+20,z=C.geoAlbersUsa().translate(),Q=M()(z,2),L=Q[0],Y=Q[1],W=s-E.left-E.right-(p?E.legendPosition:0),q=W/(L-90)*Y,N=this.width,G=this.height,this.width=s,this.height=q+E.top+E.bottom,w.width=s*l,w.height=(this.height+B+D+F+P)*l,(J=w.getContext("2d")).fillStyle="white",J.fillRect(0,0,w.width,w.height),J.scale(l,l),U=Wd(_d,_d.objects.states),K=U.features,Ue.drawMap(w,A,K,W,E.left,B+D+F,(function(t,e){return nf(I,tf(t,e,j))})),H=k+B+D+F,!p){t.next=42;break}if(Ue.drawMapLegend(w,A,j,O,I,q/2,Pt({data:A,parent:S,params:O}),s-E.right-E.legendPosition,q/4+B+D+F),Ue.drawTitles.call(this,w,O,j,Yt(O),void 0,void 0,v,k+B),!m){t.next=42;break}return t.next=41,Ue.drawLogo(w,s,O,o);case 41:Ue.drawFooter(w,s,H+q+E.top+E.bottom+20);case 42:return this.width=N,this.height=G,t.abrupt("return",w);case 45:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})}],[{key:"getColourBins",value:function(t,e,n){return Array.isArray(t)&&t.length>2?t:e&&void 0!==b[e]?b[e]:n?b.divergingYellowGreen:b.sequentialYellowGreen}}]),t}(),df=n(35),ff=n.n(df),hf={},pf=C.geoAlbersUsa().translate(),gf=M()(pf,2),mf=gf[0],yf=gf[1],vf=1.85*(mf-20)/(2*yf),bf=function(t){var e=t.data,r=void 0===e?[]:e,o=t.strokeColor,a=void 0===o?"#FFFFFF":o,s=t.backgroundColor,c=void 0===s?"usa-gray":s,l=t.width,d=void 0===l?425.5:l,f=t.transitionDuration,h=void 0===f?50:f,p=t.onMouseOver,g=void 0===p?function(){}:p,m=t.onMouseOut,y=void 0===m?function(){}:m,v=t.onClick,b=void 0===v?function(){}:v,k=t.transitionControllers,w=void 0===k?{}:k;if(0===d)return null;var x=Object(hn.useMemo)((function(){var t=n(46),e=C.geoAlbersUsa().scale(),r=C.geoAlbersUsa().scale(e).translate([mf-20,yf]),i=C.geoPath(r);return Wd(t,t.objects.states).features.map((function(t){return{fips:t.id,path:i(t)}})).filter((function(t){return t.path}))}),[]),A=d/(1.85*(mf-20)),S=x.map((function(t){var e=t.fips,n=t.path,i=r.find((function(t){var n=t.fips;return e===n}))||{},o=i.stateBackgroundColor,s=void 0===o?c:o,l=i.strokeColor,u=i.strokeWidth,d=void 0===u?2:u;return{path:n,fill:Ji(s,"usa-gray"),strokeWidth:d/A,stroke:Ji(l||a,"#FFFFFF"),sortToFront:void 0!==l,fips:e,opacity:1}})).sort((function(t,e){return t.sortToFront-e.sortToFront})),O=Object(Xn.useSpring)({scale:A,config:{easing:C.easeQuad,duration:h}}).scale,E=pa(S,(function(t){return t.fips}),{config:{easing:C.easeQuad,duration:h},initial:function(t){return{fill:t.fill,strokeWidth:t.strokeWidth,stroke:t.stroke,opacity:t.opacity}},from:function(t){return{fill:t.fill,strokeWidth:t.strokeWidth,stroke:t.stroke,opacity:0}},enter:function(t){var e=t.fill,n=t.strokeWidth,r=t.stroke,o=t.opacity;return function(){var t=i()(u.a.mark((function t(i,a){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ri({fill:e,strokeWidth:n,stroke:r,opacity:o},i,a,w.enter);case 2:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}()},leave:function(t){var e=t.fill,n=t.strokeWidth,r=t.stroke;return function(){var t=i()(u.a.mark((function t(i,o){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ri({fill:e,strokeWidth:n,stroke:r,opacity:0},i,o,w.leave);case 2:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}()},update:function(t){var e=t.fill,n=t.strokeWidth,r=t.stroke,o=t.opacity;return function(){var t=i()(u.a.mark((function t(i,a){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ri({fill:e,strokeWidth:n,stroke:r,opacity:o},i,a,w.update);case 2:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}()}});return pn.a.createElement(Xn.animated.g,{className:hf["usa-map"],transform:O.to((function(t){return"scale(".concat(t,")")}))},E((function(t,e){var n=t.fill,r=t.strokeWidth,i=t.stroke,o=e.path,a=e.fips;return pn.a.createElement(Xn.animated.path,{key:a,className:hf["state-".concat(a)],d:o,fill:n,strokeWidth:r,stroke:i,onMouseOver:function(t){return g(t,a)},onMouseOut:function(t){return y(t,a)},onClick:function(t){return b(t,a)}})})))};bf.propTypes={data:Object(zn.arrayOf)(Object(zn.shape)({strokeColor:zn.string,strokeWidth:zn.number,stateBackgroundColor:zn.string,fips:zn.string.isRequired})),strokeColor:zn.string,backgroundColor:zn.string,width:zn.number,onClick:zn.func,onMouseOver:zn.func,onMouseOut:zn.func,transitionDuration:zn.number,transitionControllers:Object(zn.shape)({enter:zn.func,leave:zn.func,update:zn.func})};var kf=bf,wf=qi["teal-6-bin"],xf={enabled:!0,selectedItem:void 0,show:!0,type:void 0},Af={fontSize:13,footnotes:void 0,show:!0,sources:void 0},Sf={centeredScale:!1,colorScale:wf,floatingScale:!1,fontColor:void 0,fontSize:13,height:10,reverseColorOrder:!1,values:[],width:void 0,x:void 0,y:void 0},Of={fontSize:16,text:""},Ef={fontSize:20,text:""},Mf={color:"scale-darkest",decimals:void 0,show:!0,showSubtitle:!0};function Cf(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Rf(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Cf(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Cf(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var jf=function(t){var e=t.backgroundColor,r=void 0===e?"usa-gray":e,i=t.data,o=void 0===i?void 0:i,a=t.dataSeriesOptions,s=void 0===a?[]:a,c=t.dropdownOptions,l=void 0===c?xf:c,u=t.footerOptions,d=void 0===u?Af:u,h=t.keyType,p=void 0===h?void 0:h,g=t.scaleOptions,m=void 0===g?Sf:g,y=t.strokeColor,v=void 0===y?"rgb(255, 255, 255)":y,b=t.subtitleOptions,k=void 0===b?Of:b,w=t.titleOptions,x=void 0===w?Ef:w,A=t.tooltipOptions,S=void 0===A?Mf:A,E=t.transitionDuration,R=void 0===E?250:E,j=t.width,I=void 0===j?void 0:j,B=Object(hn.useState)(),D=M()(B,2),T=D[0],F=D[1],P=Object(hn.useState)(),z=M()(P,2),Q=z[0],L=z[1],Y=Object(hn.useMemo)((function(){var t=f.a.defaultsDeep({},l,xf);return Rf(Rf({},t),{},{selectedItem:t.selectedItem?String(t.selectedItem):void 0})}),[l]),W=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},d,Af)}),[d]),q=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},m,Sf)}),[m]),N=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},k,16)}),[k]),G=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},x,Ef)}),[x]),J=Object(hn.useMemo)((function(){return f.a.defaultsDeep({},S,Mf)}),[S]),U=Object(hn.useMemo)((function(){var t=o;if(!t||!t.datasets)return{data:null,dataSeriesOptions:[],validFipsList:[]};var e=Kr(t),n=oi(e.datasets,s,"geo_id"),r=bs.map((function(t){return t.fips}));return e.datasets=e.datasets.filter((function(t){var e=t.geo_id;return r.includes(e)})),{data:e,dataSeriesOptions:n,validFipsList:r}}),[o,s]),K=U.data,H=U.dataSeriesOptions,V=U.validFipsList,Z=Object(hn.useMemo)((function(){var t=q.colorScale.slice().map((function(t,e){return Ji(t,wf[e%wf.length])}));return Array.isArray(Ji(q.colorScale[0],void 0))&&(t=Ji(q.colorScale[0],void 0)),q.reverseColorOrder&&t.reverse(),t}),[q]),X=Object(hn.useMemo)((function(){if(!K)return{};var t,e=Zr(p)?p:(t=K.datasets[0].y_type,Zr(t)?t:"linear");return{validScaleType:e,scaleFormatter:Jr({params:{format:e}})}}),[p,K]),_=X.validScaleType,$=X.scaleFormatter,tt=Object(hn.useMemo)((function(){if(!K||!W.show)return{footnotes:[],sources:[],summary:""};var t=[K];return Rf(Rf({},go({data:t,chartSources:W.sources})),bo({data:t,chartFootnotes:W.footnotes}))}),[K,W]),et=tt.footnotes,nt=tt.sources,rt=tt.summary,it=Object(hn.useMemo)((function(){if(!K)return{dropDownKeys:[],dropdownFormatter:null};var t=Zr(Y.type)?Y.type:"unformatted",e=Jr({params:{format:t}});return{dropDownKeys:f()(K.datasets).map((function(t){return t.data.map((function(t){var e=t.key,n=t.x_type;return{key:e,formatted:Sr(e,n)}}))})).flatMap().uniqBy((function(t){return t.key})).sortBy((function(t){return t.formatted})).map((function(t){return Rf(Rf({},t),{},{parsed:e(t.key)})})).value(),dropdownFormatter:e}}),[K,Y]),ot=it.dropDownKeys,at=it.dropdownFormatter,st=Object(hn.useMemo)((function(){return V.some((function(t){var e=K.datasets.find((function(e){return e.geo_id===t}));return!e||!e.data||ot.some((function(t){var n=t.key;if(!q.floatingScale||n===T){var r=e.data.find((function(t){return t.key===n}));if(!r||!r.value)return!0}return!1}))}))}),[V,K,ot,q,T]),ct=Object(hn.useMemo)((function(){if(!K)return[];var t=K.datasets.map((function(t){return t.data.map((function(t){var e=t.value,n=t.key;if(!q.floatingScale||n===T)return e}))})).flat().filter((function(t){return void 0!==t})),e=Math.max.apply(Math,O()(t.map((function(t){return Math.abs(t)})))),n=q.centeredScale?e:Math.max.apply(Math,O()(t)),r=q.centeredScale?-e:Math.min.apply(Math,O()(t));return q.values.length>1?q.values:Rs(Z.length,r,n)}),[K,T,q,Z]),lt=Object(hn.useMemo)((function(){return K?K.datasets.map((function(t){var e=t.geo_id,n=t.data,r=n.filter((function(t){return t.key===T}))[0]?n.filter((function(t){return t.key===T}))[0].value:null,i=f.a.find(H,{geo_id:e})||{},o=i.strokeColor,a=i.strokeWidth;return{fips:e||"00",stateBackgroundColor:js(r,ct,Z),strokeColor:Ji(o,void 0),strokeWidth:a}})):[]}),[K,H,T,ct,Z]),ut=Object(hn.useMemo)((function(){var t=[];return ot.length&&(t=Y.enabled?ot.map((function(t){return t.key})):[f.a.find(ot,{key:T}).parsed]),Y.show&&t.length?[{options:t,parser:at,label:G.text?" ":"",defaultValue:T?f.a.find(ot,{key:T}).key:"",onChange:function(t){var e=t.target.value;F(f.a.find(ot,{parsed:e}).key)}}]:[]}),[Y,at,G,T,ot]),dt=function(t,e,r){if(t){var i,o=K.datasets.filter((function(t){return t.geo_id===e}))[0],a=o&&o.data.filter((function(t){return t.key===T}))[0]?o.data.filter((function(t){return t.key===T}))[0].value:null,s=function(t,e){var r=n(46),i=Wd(r,r.objects.states).features.map((function(e){if(e.id===t)return{coordinates:e.geometry.coordinates,fips:e.id}})).filter((function(t){return void 0!==t})),o=C.geoAlbersUsa().scale(),a=C.geoAlbersUsa().scale(o).translate([mf-20,yf]),s=i.map((function(t){var e=t.coordinates;return 1===e.length?a(ff()(e).slice(0,2)):a(e.map((function(t){return ff()(t)})).sort((function(t,e){return e.distance-t.distance}))[0].slice(0,2))}))[0];return[s[0]*e/(1.85*(mf-20)),s[1]*e/(1.85*(mf-20))]}(e,r),c=M()(s,2),l=c[0],u=c[1],d=(f.a.find(H,{geo_id:e})||{}).tooltipTitle;L({position:{x:l,y:u+20},value:a||null,title:d||(i=e,bs[bs.findIndex((function(t){return t.fips===i}))].name),subtitle:at(T)||T,color:function(){var t,e,n=J.color||"scale-darkest";if(null==a)return Ji("usa-gray");switch(n){case"scale-min":return Z[0];case"scale-max":return Z[ct.length-2];case"scale-extents":return Is(a,ct,Z);case"scale-darkest":return e=(t=Z).map((function(t){return Object(C.hsl)(t).l})),t[e.indexOf(Math.min.apply(Math,O()(e)))];default:return Ji(n,"usa-gray")}}(),type:o&&Zr(o.y_type)?o.y_type:_})}else L(null)};return Object(hn.useEffect)((function(){if(Y.selectedItem){var t=f.a.find(ot,{key:Y.selectedItem});F(t?t.key:null)}else ot.length&&F(f.a.last(ot).key||null)}),[Y.selectedItem,ot]),Y.selectedItem&&!T?(console.error("Selected item '".concat(Y.selectedItem,"' could not be found in the data.'")),null):o&&o.datasets&&o.datasets.length?pn.a.createElement(la,{className:"map-chart",title:G.text,subtitle:N.text,titleFontSize:G.fontSize,subtitleFontSize:N.fontSize,footerSources:nt,footerSummary:rt,footnotes:et,showFooter:W.show,dropdowns:ut,width:I,fontSize:W.fontSize,onMouseLeave:function(){return dt()}},(function(t){var e=t.chartWidth,n=pn.a.createElement(kf,{data:lt,backgroundColor:r,strokeColor:Ji(v,"rgb(255, 255, 255)"),width:e,transitionDuration:R,onMouseOver:function(t,n){return dt(t,n,e)}}),i=e/vf+1.5*q.fontSize+20,o=ct.length>1&&pn.a.createElement(Cs,{colorScale:Z,values:ct,fontColor:q.fontColor,fontSize:q.fontSize,width:q.width||4*e/5,height:q.height,x:q.x||e/10,y:q.y||i,formatter:$,transitionDuration:R,showNoData:st,noDataColor:"usa-gray"});return pn.a.createElement("div",{className:"map-body",style:{height:i+q.height+20,position:"relative"}},pn.a.createElement("div",{style:{height:20}}),pn.a.createElement("svg",{style:{overflow:"visible"},className:"map-svg"},pn.a.createElement("g",{width:e,className:"map-g"},n),ct.length>1&&o),!1!==J.show&&Q&&Q.position.x&&Q.position.y&&pn.a.createElement("div",{className:"tooltip-container"},pn.a.createElement(oo,{x:Q.position.x,y:Q.position.y,direction:"above",width:e},pn.a.createElement(Za,{title:Q.title,subtitle:J.showSubtitle?Q.subtitle:void 0,value:Q.value,color:Q.color,decimals:J.decimals,type:Q.type}))))})):null};jf.propTypes=Rf(Rf({},ua),{},{titleOptions:Object(zn.shape)({text:zn.string,fontSize:zn.number}),subtitleOptions:Object(zn.shape)({text:zn.string,fontSize:zn.number}),data:Object(zn.shape)({datasets:Object(zn.arrayOf)(Object(zn.shape)({geo_id:zn.string.isRequired,x_type:zn.string,y_type:zn.string,data:Object(zn.arrayOf)(Object(zn.shape)({key:zn.string.isRequired,value:zn.number})).isRequired})).isRequired,sources:Object(zn.arrayOf)(Object(zn.shape)(So))}).isRequired,dataSeriesOptions:Object(zn.arrayOf)(Object(zn.shape)({geo_id:zn.string.isRequired,tooltipTtile:zn.string,strokeWidth:zn.number,strokeColor:zn.string})),footerOptions:Object(zn.shape)({fontSize:zn.number,footnotes:ua.footnotes,show:ua.showFooter,sources:ua.footerSources}),width:zn.number,backgroundColor:zn.string,transitionDuration:zn.number,tooltipOptions:Object(zn.shape)({decimals:zn.number,showSubtitle:zn.bool,show:zn.bool,color:zn.string}),scaleOptions:Object(zn.shape)({colorScale:Object(zn.arrayOf)(zn.string),reverseColorOrder:zn.bool,fontColor:zn.string,width:zn.number,height:zn.number,x:zn.number,y:zn.number,values:Object(zn.arrayOf)(zn.number),centeredScale:zn.bool,floatingScale:zn.bool,fontSize:zn.number}),keyType:zn.string,strokeColor:zn.string,dropdownOptions:Object(zn.shape)({enabled:zn.bool,selectedItem:Object(zn.oneOfType)([zn.string,zn.number]),show:zn.bool,type:zn.string})});var If=jf;function Bf(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Df(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Bf(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Bf(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Tf=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:return r=t.sent,t.next=5,e.parent;case 5:i=t.sent,o=zt({data:r,parent:i,options:n}),a=o.title,s=o.subtitle,c=Rd(Df(Df({},n),{},{title:a,subtitle:s}),r),n.cartogram?p.a.render(pn.a.createElement(_s,Df(Df({},c),{},{data:Md(r)})),this.container.node()):p.a.render(pn.a.createElement(If,Df(Df({},c),{},{data:Md(r)})),this.container.node());case 9:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function Ff(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Pf(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Ff(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Ff(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var zf=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:r=t.sent,p.a.render(pn.a.createElement(If,Pf(Pf({},n),{},{data:Md(r)})),this.container.node());case 4:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function Qf(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Lf(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Qf(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Qf(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Yf=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:r=t.t0,p.a.render(pn.a.createElement(kd,Lf(Lf({},n),{},{data:r.map(Ed)})),this.container.node());case 7:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function Wf(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function qf(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Wf(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Wf(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Nf=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:r=t.sent,p.a.render(pn.a.createElement(_s,qf(qf({},n),{},{data:Md(r)})),this.container.node());case 4:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function Gf(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var Jf=function(t){Q()(n,t);var e=Gf(n);function n(t,r,i,o){var s;return a()(this,n),(s=e.call(this)).width=r,s.compressedHeight=i,s.name=o,s.expanded=null,s.didFirstDraw=!1,void 0===t?Vt()(s):(s.container=t.classed(o,!0).classed("dh-chart-wrapper",!0),s.expanderSection=t.append("div").classed("expandable",!0).classed(o,!0),s.svg=s.expanderSection.append("svg"),s.expander=s.expanderSection.append("div").classed("hidden",!0).classed("chart-expander",!0),s)}return c()(n,[{key:"initExpand",value:function(){this.expander.append("div").classed("arrow",!0).classed("down",!0),this.expander.append("div").classed("text",!0).text("Show More"),this.expander.append("div").classed("arrow",!0).classed("down",!0)}},{key:"currentHeight",value:function(t,e){var n=this.height(t,e);return this.expanded?n+25:Math.min(this.compressedHeight,n)}},{key:"drawExpander",value:function(t,e,n){var r=this;null===this.expanded&&(this.expanded=e.expanded),e.uncollapsible&&(this.expanded=!0);var i=this.expander,o=this.height(t,e),a=this.currentHeight(t,e),s=this.expanded?"Show Less":"Show More";if(e.autosize)return this.expanderSection.style("height","".concat(o,"px")),void i.classed("hidden",!0);this.expanderSection.transition().style("height","".concat(a,"px")),i.style("display",e.uncollapsible?"none":null),i.select(".expand-rect").attr("height",100).attr("transform","translate(0, ".concat(-100,")"));var c=i.select(".text");i.style("opacity",1).classed("up",this.expanded).classed("down",!this.expanded).style("position",this.expanded?null:"absolute").classed("hidden",this.height(t,e)<=this.compressedHeight),c.text(s),i.on("click",(function(){r.expanded=!r.expanded,i.select(".expand-rect").attr("fill",r.expanded?"transparent":"url(#".concat(r.name,"-expander-gradient)")),n()}))}}],[{key:"height",value:function(){return 0}}]),n}(rn),Uf=function(t){t.style("opacity",1)},Kf=function(t){t.style("opacity",0)},Hf=function(t){return C.transition().duration(t.transitionDuration)},Vf=function(t){return C.transition().delay(t.transitionDuration).duration(t.transitionDuration)},Zf=["hideAxisLabels","hideGridlines","selectableYears","selectableDropdowns","sortRows","primaryColor","secondaryColor","axisTextColor","gridColor","labelColor","metricHeight","autosize","defaultToOverlapYears","expanded","uncollapsible","hideTitle","floatingAxis","showSourcesAndFootnotes","transition","transitionDuration"];function Xf(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function _f(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Xf(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Xf(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function $f(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var th=[et.chartcolourgrey,et.chartcolourdefault0],eh=function(t){Q()(s,t);var e,n,r,o=$f(s);function s(t,e){var n;return a()(this,s),(n=o.call(this,t,1e3,300,e||"dot-plot",!1)).chartType=m.DotPlot,n.cssPrefix=e||"dot-plot",n.initialDraw=!0,n.margins={top:25,bottom:20,left:10,right:20,labelPadding:20},n.ySpacing=30,n.xScale=C.scaleLinear(),n.yScale=C.scalePoint(),n.startKey=null,n.endKey=null,void 0===t?(n.draw=n.drawCanvas,Vt()(n)):(n.title=t.insert("div","div.expandable").classed("chart-title",!0),n.title.append("span").classed("chart-title-main",!0),n.subtitle=t.insert("div","div.expandable").classed("chart-subtitle",!0),n.sourceContainer=t.append("div"),n.sources=new en(n.sourceContainer),n.tooltip=new nn(t),n.initGroups(),n.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;requestAnimationFrame((function(){n.resizeContent(e)}))}))})),n.ro.observe(t.node()),n)}return c()(s,[{key:"initGroups",value:function(){this.svg.append("g").classed("axis",!0).classed("".concat(this.cssPrefix,"-xaxis"),!0);var t=this.svg.append("g").classed("".concat(this.cssPrefix,"-chart"),!0);t.append("g").classed("".concat(this.cssPrefix,"-chart-labels"),!0),t.append("g").classed("".concat(this.cssPrefix,"-chart-area"),!0),this.initExpand(),Ze.call(this)}},{key:"createScales",value:function(t,e,n,r){var i=this,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:[],c=10,l=C.extent(Gt(f.a.flattenDeep([t,o,a]),e.startDate,e.endDate,t[0]?t[0].metric.xType:"years"),(function(t){return t.value})),u=M()(l,2),d=u[0],h=u[1],p=.5,g=[Math.min(0,d),Math.max(0,h)];if(e.floatingAxis){var m=C.extent(f.a.filter(Gt(f.a.flattenDeep([t,o,a]),e.startDate,e.endDate,t[0]?t[0].metric.xType:"years"),(function(t){return s.keyMatches(t.key,i.startKey,t.metric.metric.xType)||s.keyMatches(t.key,i.endKey,t.metric.metric.xType)})),(function(t){return t.value})),y=M()(m,2),v=y[0],b=y[1];g=[v,b]}var k,w,x=C.scaleLinear().domain(g).nice(),A=n.top,S=r;if(e.autosize){var O=this.chartArea(0,t,e).height,E=(o.height?c:0)+(a.height?c:0);this.ySpacing=(O-E)/(t.length+o.length+a.length),S=this.ySpacing}var R=e.sortRows?f()(o).orderBy((function(t){var e=t.metric.data.find((function(e){return s.keyMatches(e.key,i.endKey,t.metric.xType)}));return e&&Number.isFinite(e.value)?e.value:-1/0}),"desc").value():o,j=e.sortRows?f()(a).orderBy((function(t){var e=t.metric.data.find((function(e){return s.keyMatches(e.key,i.endKey,t.metric.xType)}));return e&&Number.isFinite(e.value)?e.value:-1/0}),"desc").value():a,I=e.sortRows?f()(t).orderBy((function(t){var e=t.metric.data.find((function(e){return s.keyMatches(e.key,i.endKey,t.metric.xType)}));return e&&Number.isFinite(e.value)?e.value:-1/0}),"desc").value():t;R.length&&(k=C.scalePoint().padding(p).domain(R.map(Dt)).range([A,A+R.length*S]),A+=R.length*S+c);var B=C.scalePoint().padding(p).domain(I.map(Dt)).range([A,A+t.length*S]);A+=t.length*S,j.length&&(A+=+c,w=C.scalePoint().padding(p).domain(j.map(Dt)).range([A,A+j.length*S]),A+=j.length*S);var D=function(t){return k&&Number.isFinite(k(t))?k(t):w&&Number.isFinite(w(t))?w(t):B(t)};return D.range=function(){return[n.top,A]},{xScale:x,yScale:D}}},{key:"chartArea",value:function(t,e,n){var r=n.margins;return{width:this.width-r.right-(t||0),height:this.height(e,n)-r.top-r.bottom}}},{key:"height",value:function(t,e){return e.autosize?this.container.node().getBoundingClientRect().height-this.title.node().getBoundingClientRect().height-this.subtitle.node().getBoundingClientRect().height-this.sourceContainer.node().getBoundingClientRect().height:t.length*this.ySpacing+this.margins.top+this.margins.bottom}},{key:"setDropdownSelected",value:function(t,e){void 0!==e?0===e?this.startKey=t:1===e&&(this.endKey=t):this.dropdownSelected=t}},{key:"data",value:(r=i()(u.a.mark((function t(e,n){var r,i,o,a,c,l,d,h,p,g,m,y,v,b,k=this;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return i=r.data,o=r.topMetrics,a=r.bottomMetrics,c=r.parent,l=i.filter((function(t){return t.metric.data&&t.metric.data.length>0})),d=n.startDate||n.startYear,h=n.endDate||n.endYear,p=function(t){return!("items"!==t.xType&&(d&&t.key.getTime()<St(d,t.xType).getTime()||h&&t.key.getTime()>St(h,t.xType).getTime()))},g=!0,m=function(t){return t.metric.xType&&"items"===t.metric.xType.toLowerCase()&&(g=!1),t.metric.data.map((function(e){return{key:e.key,xType:t.metric.xType}}))},y=f()(l).flatMap(m).filter(p),g&&(y=y.sortBy("key").map((function(t){return Ot(t.key,t.xType)}))),y=y.uniq().value(),v=f()(l).map(m).thru((function(t){return f.a.intersectionWith.apply(f.a,O()(t).concat([function(t,e){return g?t.key.getTime()===e.key.getTime():t.key===e.key}]))})).filter(p),g&&(v=v.sortBy("key").map((function(t){return Ot(t.key,t.xType)}))),null!==this.startKey&&y.includes(this.startKey)||(void 0!==n.selectedYear&&y.includes(n.selectedYear.toString())?this.startKey=n.selectedYear:void 0!==n.selectedDropdown&&y.includes(n.selectedDropdown.toString())?this.startKey=n.selectedDropdown:n.defaultToOverlapYears?this.startKey=f.a.first(v.value()):this.startKey=f.a.first(y)),null!==this.endKey&&y.includes(this.endKey)||(void 0!==n.selectedYear2&&y.includes(n.selectedYear2.toString())?this.endKey=n.selectedYear2:void 0!==n.selectedDropdown2&&y.includes(n.selectedDropdown2.toString())?this.endKey=n.selectedDropdown2:n.defaultToOverlapYears?this.endKey=f.a.last(v.value()):this.endKey=f.a.last(y)),b=void 0===n.sortRows||n.sortRows,l=b?f()(l).orderBy((function(t){var e=t.metric.data.find((function(e){return s.keyMatches(e.key,k.endKey,t.metric.xType)}));return e&&Number.isFinite(e.value)?e.value:-1/0}),"desc").value():l,t.abrupt("return",{data:l,topMetrics:o||[],bottomMetrics:a||[],parent:c,keys:y});case 22:case"end":return t.stop()}}),t,this)}))),function(t,e){return r.apply(this,arguments)})},{key:"getDrawParams",value:function(t){var e=t.data,n=t.parent,r=t.options,i=r.hideAxisLabels,o=void 0!==i&&i,a=r.hideGridlines,s=void 0!==a&&a,c=r.selectableYears,l=void 0===c||c,u=r.selectableDropdowns,d=void 0===u||u,f=r.sortRows,h=void 0===f||f,p=r.primaryColor,g=void 0===p?et.chartcolourdefault0:p,m=r.secondaryColor,y=void 0===m?et.chartColourgrey:m,v=r.axisTextColor,b=void 0===v?null:v,k=r.gridColor,x=void 0===k?null:k,A=r.labelColor,S=void 0===A?null:A,O=r.metricHeight,E=void 0===O?!0===e[0].allStates?17:30:O,M=r.autosize,C=void 0!==M&&M,R=r.defaultToOverlapYears,j=void 0!==R&&R,I=r.expanded,B=void 0!==I&&I,D=r.uncollapsible,T=void 0!==D&&D,F=r.hideTitle,P=void 0!==F&&F,z=r.floatingAxis,Q=void 0===z||z,L=r.showSourcesAndFootnotes,Y=void 0===L||L,W=r.transition,q=void 0!==W&&W,N=r.transitionDuration,G=void 0===N?1e3:N,J=w()(r,Zf);return _f(_f({},Qt({data:e,parent:n,options:J},this.margins)),{},{hideAxisLabels:o,hideGridlines:s,selectableYears:l,selectableDropdowns:d,sortRows:h,primaryColor:g,secondaryColor:y,axisTextColor:b,gridColor:x,labelColor:S,metricHeight:E,autosize:C,defaultToOverlapYears:j,expanded:B,uncollapsible:T,transition:q,transitionDuration:G,hideTitle:P,floatingAxis:Q,showSourcesAndFootnotes:Y})}},{key:"draw",value:(n=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,f=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=f.length>1&&void 0!==f[1]?f[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=r.data,o=r.topMetrics,a=r.bottomMetrics,s=r.parent,c=r.keys,l=this.getDrawParams({data:i,parent:s,options:n}),d={data:i,topMetrics:o,bottomMetrics:a,parent:s,params:l,keys:c},"top"===l.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node().parentNode),this.container.node().insertBefore(this.subtitle.node(),this.svg.node().parentNode)):"bottom"===l.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node()),this.container.node().append(this.sourceContainer.node())),this.drawContent(d),t.abrupt("return",!0);case 12:case"end":return t.stop()}}),t,this)}))),function(t){return n.apply(this,arguments)})},{key:"resizeContent",value:function(t){this.cachedParams&&(this.cachedParams.params.autosize||this.width!==t)&&this.drawContent(this.cachedParams,!1)}},{key:"redrawContent",value:function(){this.cachedParams&&this.drawContent(this.cachedParams)}},{key:"drawContent",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.cachedParams=t;var r=t.data,i=t.topMetrics,o=t.bottomMetrics,a=t.params,s=null!=n?n:a.transition;this.width=this.container.node().getBoundingClientRect().width,this.ySpacing=a.metricHeight;var c=f.a.concat(i||[],r,o||[]),l=_f(_f({},t),{},{data:c});a.hideTitle||Nt.call(this,this.title,this.subtitle,l,this.startKey,this.endKey),a.showSourcesAndFootnotes&&this.sources.draw(c,a);var u=this.createScales.call(this,r,a,a.margins,this.ySpacing,i,o),d=u.xScale,h=u.yScale;this.xScale=d,this.yScale=h,this.drawEntries(l,s),this.drawAxis(l,s),this.drawSectionLines({data:r,topMetrics:i,bottomMetrics:o,params:a},h,s),a.info&&"chart"===a.info.position&&T.inChart(this.container,a),this.initialDraw=!1,this.drawExpander(c,a,(function(){return e.drawContent(t)}))}},{key:"xAccessor",value:function(t,e){var n=s.valueAccessor(t,e);return n?this.xScale(n.value):null}},{key:"leftAccessor",value:function(t){return this.xAccessor(t,this.startKey)}},{key:"rightAccessor",value:function(t){return this.xAccessor(t,this.endKey)}},{key:"yAccessor",value:function(t){return this.yScale(Dt(t))}},{key:"ellipsizeWidth",value:function(t){var e=t.data,n=f.a.some(e,(function(t){return void 0!==t.labelText}));return this.width*(n?.5:.4)}},{key:"showTooltip",value:function(t,e,n,r){var i,o=this.container.node().getBoundingClientRect(),a=this.svg.node().getBoundingClientRect(),c=s.valueAccessor(e,n),l=this.xAccessor(e,n),u=a.top-o.top+this.yAccessor(e),d=Ft(t),f=(e.metric.lexiconName||e.metric.name)+(e.metric.geo_id&&"US"!==e.metric.geo_id?" in ".concat(e.metric.geo_name):""),h={title:{value:null!==(i=e.tooltipTitle)&&void 0!==i?i:f},subtitle:{value:n}};this.tooltip.draw(l,u,h,[{type:"value",value:d(c.value)}],{primaryColour:r})}},{key:"drawEntries",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=t.data,r=t.params,i=yt(n,r),o=this.drawEntryLabels(t,i,e),a=this.chartArea(o,n,r);this.xScale.range([o,o+a.width]);var c=this.svg.select("g.".concat(this.cssPrefix,"-chart")),l=c.select("g.".concat(this.cssPrefix,"-chart-area")),u=l.selectAll("g.".concat(this.cssPrefix,"-entry")).data(n,Dt),d=u.enter().append("g").classed("".concat(this.cssPrefix,"-entry"),!0).style("opacity",(function(e,n){return s.entryOpacity(e,n,t)})),f=u.exit(),h={enter:d,update:u,exit:f},p={bigCircleSize:function(t){return(t.fontSize||r.fontSize)/14*7},smallCircleSize:function(t){return(t.fontSize||r.fontSize)/14*5}};return this.drawEntryLine(t,h,p,e),this.drawRightCircle(t,h,p,e),this.drawLeftCircle(t,h,p,e),e&&!this.initialDraw?(u.transition(Hf(r)).style("opacity",(function(e,n){return s.entryOpacity(e,n,t)})),f.transition(Hf(r)).remove()):(u.style("opacity",(function(e,n){return s.entryOpacity(e,n,t)})),f.remove()),l.selectAll("g.".concat(this.cssPrefix,"-entry")).style("cursor",this.hasAction("click")?"pointer":null),o}},{key:"drawEntryLabels",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=t.data,o=t.params,a=this,c=this.svg.select("g.".concat(this.cssPrefix,"-chart")),l=c.select("g.".concat(this.cssPrefix,"-chart-labels")).attr("transform","translate(".concat(o.margins.left,", 0)")),u=l.selectAll("text.entry-label").data(i,Dt),d=u.enter().append("text").classed("entry-label",!0).style("font-size","".concat(o.fontSize,"px")).text((function(t){return vt(t,e)})).each((function(){Et(C.select(this),a.ellipsizeWidth(t))})),h=u.exit(),p=function(t){t.attr("y",(function(t){return n.yAccessor(t)})).style("fill",(function(t){return t.labelColor||o.labelColor})).style("font-size","".concat(o.fontSize,"px")).style("opacity",0)},g=function(e){e.style("opacity",(function(e,n){return s.entryOpacity(e,n,t)}))},m=function(e){e.attr("y",(function(t){return n.yAccessor(t)})).style("fill",(function(t){return t.labelColor||o.labelColor})).style("font-size","".concat(o.fontSize,"px")).style("opacity",(function(e,n){return s.entryOpacity(e,n,t)}))};r&&!this.initialDraw?(d.call(p).transition(Vf(o)).call(g),u.text((function(t){return vt(t,e)})).transition(Vf(o)).call(m),h.transition(Hf(o)).call(Kf).remove()):(d.call(p).call(g),u.call(m),h.remove());var y=o.margins.left+o.margins.labelPadding+l.node().getBBox().width;return u.on("mousemove",f.a.throttle((function(e,r){null!==n.rightAccessor(r)?n.showTooltip(t,r,n.endKey,Yt(o,r)):null!==n.leftAccessor(r)&&n.showTooltip(t,r,n.startKey,Wt(o,r))}),1e3/60,{trailing:!1})).on("mouseout",(function(){n.tooltip.hide()})),d.on("mousemove",f.a.throttle((function(e,r){null!==n.rightAccessor(r)?n.showTooltip(t,r,n.endKey,Yt(o,r)):null!==n.leftAccessor(r)&&n.showTooltip(t,r,n.startKey,Wt(o,r))}),1e3/60,{trailing:!1})).on("mouseout",(function(){n.tooltip.hide()})),y}},{key:"drawLeftCircle",value:function(t,e,n){var r=this,i=e.enter,o=e.update,a=e.exit,s=n.smallCircleSize,c=arguments.length>3&&void 0!==arguments[3]&&arguments[3],l=t.params;i.append("circle").classed("entry-left",!0);var u=o.select(".entry-left"),d=i.select(".entry-left"),h=a.select(".entry-left"),p=function(t){t.attr("r",s).attr("fill",(function(t){return Wt(l,t)})).attr("stroke","#FFF").attr("stroke-width","1px").attr("cx",(function(t,e,n){var i=C.select(n[e]).attr("cx");Number.isNaN(i)&&(i=null);var o=r.leftAccessor(t);return null!==o?o:i})).attr("cy",(function(t){return r.yAccessor(t)})).style("opacity",0)},g=function(t){t.style("opacity",(function(t){return null!==r.leftAccessor(t)?.7:0}))},m=function(t){t.attr("stroke","#FFF").attr("stroke-width","1px").attr("cx",(function(t,e,n){var i=C.select(n[e]).attr("cx");Number.isNaN(i)&&(i=0);var o=r.leftAccessor(t);return null!==o?o:i}))},y=function(t){t.attr("cy",(function(t){return r.yAccessor(t)}))};c&&!this.initialDraw?(d.call(p).transition(Vf(l)).call(g),u.attr("r",s).attr("fill",(function(t){return Wt(l,t)})).transition(Hf(l)).call(m).call(g).transition(Hf(l)).call(y),h.transition(Hf(l)).call(Kf)):(d.call(p).call(g),u.attr("r",s).attr("fill",(function(t){return Wt(l,t)})).call(m).call(y).call(g)),d.on("mousemove",f.a.throttle((function(e,n){r.showTooltip(t,n,r.startKey,Wt(l,n))}),1e3/60,{trailing:!1})).on("mouseout",(function(){r.tooltip.hide()})),u.on("mousemove",f.a.throttle((function(e,n){r.showTooltip(t,n,r.startKey,Wt(l,n))}),1e3/60,{trailing:!1})).on("mouseout",(function(){r.tooltip.hide()}))}},{key:"drawRightCircle",value:function(t,e,n){var r=this,i=e.enter,o=e.update,a=e.exit,s=n.bigCircleSize,c=arguments.length>3&&void 0!==arguments[3]&&arguments[3],l=t.params;i.append("circle").classed("entry-right",!0);var u=function(t){t.style("opacity",(function(t){return null!==r.rightAccessor(t)?1:0}))},d=o.select(".entry-right"),h=i.select(".entry-right"),p=a.select(".entry-right"),g=function(t){t.attr("fill",(function(t){return Yt(l,t)})).attr("r",s).attr("cx",(function(t,e,n){var i=C.select(n[e]).attr("cx");Number.isNaN(i)&&(i=null);var o=r.rightAccessor(t);return null!==o?o:i})).attr("cy",r.yAccessor.bind(r)).style("opacity",0)},m=function(t){t.attr("cx",(function(t,e,n){var i=C.select(n[e]).attr("cx");Number.isNaN(i)&&(i=0);var o=r.rightAccessor(t);return null!==o?o:i})).call(u)},y=function(t){t.attr("cy",r.yAccessor.bind(r))};c&&!this.initialDraw?(h.call(g).transition(Vf(l)).call(u),d.attr("r",s).attr("fill",(function(t){return Yt(l,t)})).transition(Hf(l)).call(m).transition(Hf(l)).call(y),p.transition(Hf(l)).call(Kf)):(h.call(g).call(u),d.attr("r",s).attr("fill",(function(t){return Yt(l,t)})).call(m).call(y).call(u)),h.on("mousemove",f.a.throttle((function(e,n){r.showTooltip(t,n,r.endKey,Yt(l,n))}),1e3/60,{trailing:!1})).on("mouseout",(function(){r.tooltip.hide()})),d.on("mousemove",f.a.throttle((function(e,n){r.showTooltip(t,n,r.endKey,Yt(l,n))}),1e3/60,{trailing:!1})).on("mouseout",(function(){r.tooltip.hide()}))}},{key:"drawEntryLine",value:function(t,e,n){var r=this,i=t.params,o=e.enter,a=e.update,s=e.exit,c=n.smallCircleSize,l=arguments.length>3&&void 0!==arguments[3]&&arguments[3];o.append("line").classed("entry-line",!0);var u=a.select(".entry-line"),d=o.select(".entry-line"),f=s.select(".exit-line"),h=function(t){t.attr("stroke",et.chartcolourgrey).attr("x1",(function(t){var e=r.leftAccessor(t),n=r.rightAccessor(t);if(null===e||null===n)return null;var i=0;return e>n?i=-c(t):e<n&&(i=c(t)),e+i})).attr("y1",r.yAccessor.bind(r)).attr("x2",r.rightAccessor.bind(r)).attr("y2",r.yAccessor.bind(r)).style("opacity",0)},p=function(t){t.style("opacity",(function(t){return null!==r.leftAccessor(t)&&null!==r.rightAccessor(t)?.8:0}))},g=function(t){t.attr("stroke",et.chartcolourgrey).attr("x1",(function(t,e,n){var i=r.leftAccessor(t),o=r.rightAccessor(t),a=C.select(n[e]).attr("x1");if(null===i||null===o)return a;var s=0;return i>o?s=-c(t):i<o&&(s=c(t)),i+s})).attr("x2",(function(t,e,n){var i=r.rightAccessor(t),o=C.select(n[e]).attr("x2");return null===i?o:i}))},m=function(t){t.attr("y1",r.yAccessor.bind(r)).attr("y2",r.yAccessor.bind(r))};l&&!this.initialDraw?(d.call(h).transition(Vf(i)).call(p),u.transition(Hf(i)).call(g).call(p).transition(Hf(i)).call(m),f.transition(Hf(i)).call(Kf)):(d.call(h).call(p),u.call(g).call(m).call(p))}},{key:"drawAxis",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=t.params,i=r.hideGridlines,o=r.fontSize,a=r.gridColor,s=r.hideAxisLabels,c=r.axisTextColor,l=r.transitionDuration,u=this.svg.select("g.".concat(this.cssPrefix,"-xaxis")),d=this.yScale.range(),f=M()(d,2),h=f[0],p=f[1],g=this.xScale.range(),m=M()(g,2),y=m[0],v=m[1],b=v-y,k=5;b<150?k=2:b<300&&(k=3),n&&!this.initialDraw?u.transition().duration(l).attr("transform","translate(0, ".concat(h,")")).call(C.axisTop(this.xScale).tickSize(i?0:-(p-h)).tickFormat((function(n){return Pt(t)(n,{ticks:e.xScale.ticks(k)})})).ticks(k)):u.attr("transform","translate(0, ".concat(h,")")).call(C.axisTop(this.xScale).tickSize(i?0:-(p-h)).tickFormat((function(n){return Pt(t)(n,{ticks:e.xScale.ticks(k)})})).ticks(k)),u.selectAll(".tick line").classed("bold",(function(t){return!e.xScale.domain().includes(0)&&0===t})).style("stroke",a),u.selectAll(".tick text").style("display",s?"none":null).style("fill",c).style("font-size","".concat(o,"px"))}},{key:"drawSectionLines",value:function(t){var e=t.topMetrics,n=t.data,r=t.bottomMetrics,i=t.params,o=[];if(e.length>0){var a=(this.yAccessor(e[e.length-1])+this.yAccessor(n[0]))/2;o.push(a)}if(r.length>0){var s=(this.yAccessor(n[n.length-1])+this.yAccessor(r[0]))/2;o.push(s)}this.svg.selectAll("line.section").data(o).join("line").classed("section",!0).style("stroke",et.chartcolourgrey).style("stroke-width",2).attr("y1",f.a.identity).attr("y2",f.a.identity).attr("x1",i.margins.left).attr("x2",this.width-i.margins.right)}},{key:"drawCanvas",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,h,p,g,m,y,v,b,k,w,x,A,S,O,E,C,j,I,B,D,T,F,P,z,Q,L,Y,W,q,N,G,J,U,K,H,V,Z,X,_,$,tt,nt,rt=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=rt.length>1&&void 0!==rt[1]?rt[1]:{},r=rt.length>2?rt[2]:void 0,i=r.margin,o=void 0===i?40:i,a=r.width,s=void 0===a?720:a,c=r.scale,l=void 0===c?3:c,d=r.showBranding,h=void 0===d||d,p=r.xOffset,g=void 0===p?0:p,m=r.yOffset,y=void 0===m?0:m,v=rt.length>3&&void 0!==rt[3]?rt[3]:Object(R.createCanvas)(s,s),t.next=5,this.data(e,n);case 5:if(b=t.sent){t.next=8;break}return t.abrupt("return",null);case 8:if(k=b.data,w=b.parent,x=b.topMetrics,A=void 0===x?[]:x,S=b.bottomMetrics,O=void 0===S?[]:S,E=this.getDrawParams({data:k,parent:w,options:n}),null!==o&&(E.margins.left=o,E.margins.right=o),C=20+o+20,j=E.titleFontSize*parseFloat(it),I=""!==E.subtitle,B=I?E.subtitleFontSize*parseFloat(lt):0,D=(null!=o?o:0)+20,T=this.createScales.call(this,k,E,E.margins,E.metricHeight,A,O),F=T.xScale,P=T.yScale,z=this.width,this.width=s,v.width=s*l,Q=E.metricHeight*k.length+E.margins.top+E.margins.bottom,v.height=(Q+C+j+B+D)*l,(L=v.getContext("2d")).fillStyle="white",L.fillRect(0,0,v.width,v.height),L.scale(l,l),Y=E.margins.left,Ue.drawTitles.call(this,v,E,this.startKey,th[0],this.endKey,th[1],g,y+C),W=f()([A,k,O]).map((function(t){return Ue.drawLeftLabels(v,t,E,P,s,Y,C+j+B)})).map("longestLabelWidth").max(),F.range([E.margins.left+E.margins.labelPadding+W,s-E.margins.right]),q=P.range(),N=M()(q,2),G=N[0],J=N[1],U=F.range(),K=M()(U,2),H=K[0],V=K[1],Z=V-H>300?5:3,X=Math.abs(J-G),_=function(t){return Pt({data:k,parent:w,params:E})(t,{ticks:F.ticks(Z)})},Ue.drawAxis(v,k,E,F,"top",Z,X,_,0,G+C+j+B),$=C+j+B,A.length>0&&(tt=$+(this.yAccessor(A[A.length-1])+this.yAccessor(k[0]))/2,L.strokeStyle=et.chartcolourgrey,L.lineWidth=2,L.beginPath(),L.moveTo(E.margins.left,tt),L.lineTo(s-E.margins.right,tt),L.stroke(),Ue.drawDots.call(this,v,A,E,this.startKey,this.endKey,F,P,0,$,th[0],th[1])),Ue.drawDots.call(this,v,k,E,this.startKey,this.endKey,F,P,0,$,th[0],th[1]),O.length>0&&(nt=$+(this.yAccessor(k[k.length-1])+this.yAccessor(O[0]))/2,L.strokeStyle=et.chartcolourgrey,L.lineWidth=2,L.beginPath(),L.moveTo(E.margins.left,nt),L.lineTo(s-E.margins.right,nt),L.stroke(),Ue.drawDots.call(this,v,O,E,this.startKey,this.endKey,F,P,0,$,th[0],th[1])),!h){t.next=45;break}return t.next=44,Ue.drawLogo(v,s,E,o);case 44:Ue.drawFooter(v,s,Q+C+j+B+20);case 45:return this.width=z,t.abrupt("return",v);case 47:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})}],[{key:"isTopOrBottom",value:function(t,e){var n=e.data,r=void 0===n?[]:n,i=e.topMetrics,o=void 0===i?[]:i,a=e.bottomMetrics,s=void 0===a?[]:a;return t<o.length||t>=r.length-s.length}},{key:"keyMatches",value:function(t,e,n){return n&&"items"===n.toLowerCase()?t===e:e.getTime?t.getTime()===e.getTime():t.getTime()===St(e,n).getTime()}},{key:"valueAccessor",value:function(t,e){return t.metric.data.find((function(n){return s.keyMatches(n.key,e,t.metric.xType)}))||null}},{key:"entryOpacity",value:function(t,e,n){var r=n.data,i=n.topMetrics,o=n.bottomMetrics;return f.a.some(r,(function(t){return t.selectedState}))?t.selectedState||s.isTopOrBottom(e,{data:r,topMetrics:i,bottomMetrics:o})?null:.4:null}}]),s}(Jf);function nh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function rh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?nh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):nh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var ih=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c,l,d;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:return r=t.t0,t.next=8,e.topMetrics;case 8:if(t.t1=t.sent,t.t1){t.next=11;break}t.t1=[];case 11:return i=t.t1,t.next=14,e.parent;case 14:o=t.sent,a=zt({data:r,parent:o,options:n}),s=a.title,c=a.subtitle,l=r.concat(i).map(Ed),d=Id(rh(rh({},n),{},{title:s,subtitle:c}),l),p.a.render(pn.a.createElement(kc,rh(rh({},d),{},{data:l})),this.container.node());case 19:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function oh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function ah(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?oh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):oh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var sh=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:r=t.t0,p.a.render(pn.a.createElement(kc,ah(ah({},n),{},{data:r.map(Ed)})),this.container.node());case 7:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}(),ch=["hideAxisLabels","hideGridlines","selectableYears","selectableDropdowns","sortRows","primaryColor","axisTextColor","gridColor","labelColor","metricHeight","autosize","defaultToOverlapYears","positiveColour","negativeColour","bottomXTicks","xAxisTicks","expanded","uncollapsible","hideDrawLine","selectedMetrics","labelAsValueLabel","hideLabels","transition","transitionDuration","hideYear","hideDropdown","domain","floatingAxis","niceScale","hideSeparator","dataSelector","hideTitle","showSourcesAndFootnotes"];function lh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function uh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?lh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):lh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function dh(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var fh=function(t){Q()(s,t);var e,n,r,o=dh(s);function s(t,e){var n;return a()(this,s),(n=o.call(this,t,1e3,300,e||"bar-chart",!1)).chartType=m.BarChart,n.cssPrefix=e||"bar-chart",n.initialDraw=!0,n.overrideDataSelector=null,n.margins={top:20,bottom:20,left:10,right:35,labelPadding:20,valueLabelPadding:10,maxLabelWidth:null},n.ySpacing=30,n.dropdownSelected=null,void 0===t?Vt()(n):(n.title=t.insert("div","div.expandable").classed("chart-title",!0),n.subtitle=t.insert("div","div.expandable").classed("chart-subtitle",!0),n.sourceContainer=t.append("div"),n.sources=new en(n.sourceContainer),n.tooltip=new nn(t),n.initGroups(),n.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;requestAnimationFrame((function(){n.resizeContent(e)}))}))})),n.ro.observe(t.node()),n)}return c()(s,[{key:"initGroups",value:function(){this.svg.append("g").classed("axis",!0).classed("".concat(this.cssPrefix,"-xaxis"),!0),this.svg.append("g").classed("axis",!0).classed("".concat(this.cssPrefix,"-xline"),!0);var t=this.svg.append("g").classed("".concat(this.cssPrefix,"-chart"),!0);t.append("rect").classed("".concat(this.cssPrefix,"-touch-area"),!0),t.append("g").classed("".concat(this.cssPrefix,"-labels"),!0),t.append("g").classed("".concat(this.cssPrefix,"-area"),!0),this.initExpand(),Ze.call(this)}},{key:"createScales",value:function(t,e,n,r){var i=this,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:[],c=10,l=C.extent(Gt(f.a.flattenDeep([t,o,a]),e.startDate,e.endDate,t[0]?t[0].metric.xType:"years"),(function(t){return t.value})),u=M()(l,2),d=u[0],h=u[1],p=[Math.min(0,d),Math.max(0,h)];if(e.floatingAxis){var g=C.extent(f.a.filter(Gt(f.a.flattenDeep([t,o,a]),e.startDate,e.endDate,t[0]?t[0].metric.xType:"years"),(function(t){return s.keyMatches(t.key,i.dropdownSelected,t.metric.metric.xType)})),(function(t){return t.value})),m=M()(g,2),y=m[0],v=m[1];p=[Math.min(0,y),Math.max(0,v)]}var b=C.scaleLinear().domain(p);e.niceScale&&b.nice(),null!==e.domain&&(b=C.scaleLinear().domain(e.domain));var k,w,x=n.top,A=r;if(!1!==e.autosize){var S=this.chartArea(0,t,e).height,O=(o.height?c:0)+(a.height?c:0),E=t.length+1+o.length+a.length,R=Number.isFinite(e.autosize)&&e.autosize>0?Math.max(e.autosize+1,E):E;this.ySpacing=(S-O)/R,A=this.ySpacing}var j=function(t){var e=t.metric.data.find((function(e){return s.keyMatches(e.key,i.dropdownSelected,t.metric.xType)}));return e&&Number.isFinite(e.value)?e.value:-1/0},I=e.sortRows?f()(o).orderBy(j,"desc").value():o,B=e.sortRows?f()(a).orderBy(j,"desc").value():a,D=e.sortRows?f()(t).orderBy(j,"desc").value():t;I.length&&(k=C.scaleBand().paddingInner(.2).domain(I.map(this.dataSelector.bind(this))).range([x,x+I.length*A]),x+=I.length*A+c);var T=C.scaleBand().paddingInner(.2).domain(D.map(this.dataSelector.bind(this))).range([x,x+t.length*A]);x+=D.length*A,B.length&&(x+=c,w=C.scaleBand().paddingInner(.2).domain(B.map(this.dataSelector.bind(this))).range([x,x+B.length*A]),x+=B.length*A);var F=function(t){return k&&Number.isFinite(k(t))?k(t):w&&Number.isFinite(w(t))?w(t):T(t)};return F.range=function(){return[n.top,x]},F.bandwidth=function(){return T.bandwidth()},{xScale:b,yScale:F}}},{key:"dataSelector",value:function(t){return this.overrideDataSelector?this.overrideDataSelector(t):Dt(t)}},{key:"chartArea",value:function(t,e,n){return{width:this.width-n.margins.right-(t||0),height:this.height(e,n)-n.margins.top-n.margins.bottom}}},{key:"longestBarValueLabelLength",value:function(t,e,n){var r,i=this,o=e.params,a=yt(t.filter((function(t,n){return!s.isTopOrBottom(n,e)})),o),c=Pt(e);if(0===(r=n?t.filter((function(t){return i.valueAccessor(t)<0})):t.filter((function(t){return i.valueAccessor(t)>=0}))).length)return 0;var l=r.map((function(t){return i.widthAccessor(t)})),u=r.map((function(t){return function(t){if(o.labelAsValueLabel)return s.getValueLabelText(t,a);var e=i.valueAccessor(t);return Number.isFinite(e)?c(e):""}(t)})),d=[],h=this.svg.append("g");h.selectAll(".dummyText").data(u).enter().append("text").style("font-size","".concat(o.fontSize,"px")).attr("opacity",0).text((function(t){return t})).each((function(){var t=this.getComputedTextLength();d.push(t),this.remove()}));var p=f.a.map(d,(function(t,e){return t+l[e]}));return h.remove(),d[f.a.indexOf(p,Math.max.apply(Math,O()(p)))]}},{key:"headerHeight",value:function(){return this.title.node().getBoundingClientRect().height+this.subtitle.node().getBoundingClientRect().height}},{key:"extraUIHeight",value:function(){return this.headerHeight()+this.sourceContainer.node().getBoundingClientRect().height}},{key:"dataHeight",value:function(t){return(t.length+1)*this.ySpacing+this.margins.top+this.margins.bottom}},{key:"height",value:function(t,e){return e.autosize?this.container.node().getBoundingClientRect().height-this.extraUIHeight():this.dataHeight(t)}},{key:"showTooltip",value:function(t,e,n,r,i){var o,a=this.container.node().getBoundingClientRect(),s=this.svg.node().getBoundingClientRect(),c=this.valueAccessor(e);if(null!=c){var l=r+this.xAccessor(e)+this.widthAccessor(e)/2,u=s.top-a.top+this.yAccessor(e),d=(e.metric.lexiconName||e.metric.name)+(e.metric.geo_id&&"US"!==e.metric.geo_id?" in ".concat(e.metric.geo_name):""),f=Ft(t),h={title:{value:null!==(o=e.tooltipTitle)&&void 0!==o?o:d},subtitle:{value:n}};this.tooltip.draw(l,u,h,[{type:"value",value:f(c)}],{primaryColour:i})}}},{key:"data",value:(r=i()(u.a.mark((function t(e,n){var r,i,o,a,c,l,d,h,p,g,m,y,v,b,k,w=this;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return i=r.data,o=r.topMetrics,a=r.bottomMetrics,c=r.parent,l=i.filter((function(t){return t.metric.data&&t.metric.data.length>0})),d=n.startDate||n.startYear,h=n.endDate||n.endYear,p=function(t){return!("items"!==t.xType&&(d&&t.key.getTime()<St(d,t.xType).getTime()||h&&t.key.getTime()>St(h,t.xType).getTime()))},g=!0,m=function(t){return t.metric.xType&&"items"===t.metric.xType.toLowerCase()&&(g=!1),t.metric.data.map((function(e){return{key:e.key,xType:t.metric.xType}}))},y=f()(l).flatMap(m).filter(p),g&&(y=y.sortBy("key").map((function(t){return Ot(t.key,t.xType)}))),y=y.uniq().value(),v=f()(l).map(m).thru((function(t){return f.a.intersectionWith.apply(f.a,O()(t).concat([function(t,e){return g?t.key.getTime()===e.key.getTime():t.key===e.key}]))})).filter(p),g&&(v=v.sortBy("key").map((function(t){return Ot(t.key,t.xType)}))),null!==this.dropdownSelected&&y.includes(this.dropdownSelected)||(void 0!==n.selectedYear&&y.includes(n.selectedYear.toString())?this.dropdownSelected=n.selectedYear:void 0!==n.selectedDropdown&&y.includes(n.selectedDropdown.toString())?this.dropdownSelected=n.selectedDropdown:n.defaultToOverlapYears?this.dropdownSelected=f.a.last(v.value()):this.dropdownSelected=g?f.a.last(y):f.a.first(y)),n.forceYear&&y.includes(n.forceYear.toString())&&(this.dropdownSelected=n.forceYear),n.forceDropdown&&y.includes(n.forceDropdown.toString())&&(this.dropdownSelected=n.forceDropdown),b=void 0===n.sortRows||n.sortRows,k=function(t){var e=t.metric.data.find((function(e){return s.keyMatches(e.key,w.dropdownSelected,t.metric.xType)}));return e&&Number.isFinite(e.value)?e.value:-1/0},l=b?f()(l).orderBy(k,"desc").value():l,t.abrupt("return",{data:l,topMetrics:o||[],bottomMetrics:a||[],parent:c,keys:y});case 24:case"end":return t.stop()}}),t,this)}))),function(t,e){return r.apply(this,arguments)})},{key:"getDrawParams",value:function(t){var e=t.data,n=t.parent,r=t.options,i=r.hideAxisLabels,o=void 0===i||i,a=r.hideGridlines,s=void 0===a||a,c=r.selectableYears,l=void 0===c||c,u=r.selectableDropdowns,d=void 0===u||u,f=r.sortRows,h=void 0===f||f,p=r.primaryColor,g=void 0===p?et.chartcolourdefault0:p,m=r.axisTextColor,y=void 0===m?null:m,v=r.gridColor,b=void 0===v?null:v,k=r.labelColor,x=void 0===k?null:k,A=r.metricHeight,S=void 0===A?!0===e[0].allStates?17:30:A,O=r.autosize,E=void 0!==O&&O,M=r.defaultToOverlapYears,C=void 0!==M&&M,R=r.positiveColour,j=void 0===R?null:R,I=r.negativeColour,B=void 0===I?null:I,D=r.bottomXTicks,T=void 0!==D&&D,F=r.xAxisTicks,P=void 0===F?5:F,z=r.expanded,Q=void 0!==z&&z,L=r.uncollapsible,Y=void 0!==L&&L,W=r.hideDrawLine,q=void 0!==W&&W,N=r.selectedMetrics,G=void 0===N?[]:N,J=r.labelAsValueLabel,U=void 0!==J&&J,K=r.hideLabels,H=void 0!==K&&K,V=r.transition,Z=void 0!==V&&V,X=r.transitionDuration,_=void 0===X?1e3:X,$=r.hideYear,tt=void 0!==$&&$,nt=r.hideDropdown,rt=void 0!==nt&&nt,it=r.domain,ot=void 0===it?null:it,at=r.floatingAxis,st=void 0===at||at,ct=r.niceScale,lt=void 0===ct||ct,ut=r.hideSeparator,dt=void 0!==ut&&ut,ft=r.dataSelector,ht=void 0===ft?null:ft,pt=r.hideTitle,gt=void 0!==pt&&pt,mt=r.showSourcesAndFootnotes,yt=void 0===mt||mt,vt=w()(r,ch);return uh(uh({},Qt({data:e,parent:n,options:vt},this.margins)),{},{hideAxisLabels:o,hideGridlines:s,selectableYears:l,selectableDropdowns:d,sortRows:h,primaryColor:g,axisTextColor:y,gridColor:b,labelColor:x,metricHeight:S,autosize:E,defaultToOverlapYears:C,positiveColour:j,negativeColour:B,bottomXTicks:T,xAxisTicks:P,expanded:Q,uncollapsible:Y,hideDrawLine:q,selectedMetrics:G,labelAsValueLabel:U,hideLabels:H,transition:Z,transitionDuration:_,hideYear:tt,hideDropdown:rt,domain:ot,floatingAxis:st,niceScale:lt,hideSeparator:dt,dataSelector:ht,hideTitle:gt,showSourcesAndFootnotes:yt})}},{key:"draw",value:(n=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,f=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=f.length>1&&void 0!==f[1]?f[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=r.data,o=r.topMetrics,a=r.bottomMetrics,s=r.parent,c=r.keys,l=this.getDrawParams({data:i,parent:s,options:n}),d={data:i,topMetrics:o,bottomMetrics:a,parent:s,keys:c,params:l},this.overrideDataSelector=l.dataSelector,this.hasPosNegColours=null!==l.positiveColour&&null!==l.negativeColour,"top"===l.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node().parentNode),this.container.node().insertBefore(this.subtitle.node(),this.svg.node().parentNode)):"bottom"===l.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node()),this.container.node().append(this.sourceContainer.node())),this.drawContent(d),t.abrupt("return",!0);case 14:case"end":return t.stop()}}),t,this)}))),function(t){return n.apply(this,arguments)})},{key:"setDropdownSelected",value:function(t){this.dropdownSelected=t}},{key:"resizeContent",value:function(t){if(this.cachedParams&&(!1!==this.cachedParams.params.autosize||this.width!==t)){var e=this.cachedParams,n=e.data,r=e.params;this.drawContent(this.cachedParams,!1),this.trigger("resize",{width:t,height:this.height(n,r),headerHeight:this.headerHeight(),extraUIHeight:this.extraUIHeight(),dataHeight:this.dataHeight(n)})}}},{key:"setHovered",value:function(t){var e=this;if(this.cachedParams){var n=this.svg.select("g.".concat(this.cssPrefix,"-area")).selectAll("g.".concat(this.cssPrefix,"-entry"));n.style("opacity",(function(n,r){return e.entryOpacity(n,r,e.cachedParams,t)})),n.selectAll(".entry-value-label").style("display",(function(n){return null===e.displayCheck(n,e.cachedParams.params)||e.dataSelector(n)===t?null:"none"}))}}},{key:"redrawContent",value:function(){this.cachedParams&&this.drawContent(this.cachedParams)}},{key:"drawContent",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,r=f.a.cloneDeep(this.cachedParams);this.cachedParams=t;var i=t.data,o=t.topMetrics,a=t.bottomMetrics,s=t.params,c=null!=n?n:s.transition;this.width=this.container.node().getBoundingClientRect().width,this.ySpacing=s.metricHeight;var l=o||[],u=f.a.concat(l,i,a),d=uh(uh({},t),{},{data:u});s.hideTitle||Nt.call(this,this.title,this.subtitle,d,s.hideYear||s.hideDropdown?null:this.dropdownSelected),s.showSourcesAndFootnotes&&this.sources.draw(u,s);var h=this.createScales.call(this,i,s,s.margins,this.ySpacing,o,a),p=h.xScale,g=h.yScale;this.xScale=p,this.yScale=g,s.hideSeparator||this.drawSectionLines(t,c),this.drawEntries(d,c),this.drawAxis(d,c);var m=this.expanderSection.node().getBoundingClientRect().height||this.yScale.range()[1]-this.yScale.range()[0]+this.yScale.bandwidth();this.svg.select(".".concat(this.cssPrefix,"-touch-area")).attr("x",0).attr("y",0).attr("width",this.width).attr("height",m).on("click",(function(){"ontouchstart"in window&&e.tooltip.hide()})),s.info&&"chart"===s.info.position&&T.inChart(this.container,s),this.initialDraw=!1,this.drawExpander(u,s,(function(){return e.drawContent(t)})),r&&(Number.isFinite(s.autosize)||s.autosize!==r.autosize)&&this.trigger("resize",{width:this.width,height:this.height(i,s),headerHeight:this.headerHeight(),extraUIHeight:this.extraUIHeight(),dataHeight:this.dataHeight(i)})}},{key:"valueAccessor",value:function(t){var e=this,n=t.metric.data.find((function(n){return s.keyMatches(n.key,e.dropdownSelected,t.metric.xType)}));return n?n.value:null}},{key:"xAccessor",value:function(t){return this.xScale(Math.min(0,this.valueAccessor(t)))}},{key:"widthAccessor",value:function(t){return Math.abs(this.xScale(this.valueAccessor(t))-this.xScale(0))}},{key:"yAccessor",value:function(t){return this.yScale(this.dataSelector(t))+this.yScale.bandwidth()}},{key:"posNegColours",value:function(t,e){return this.xAccessor(e)===this.xScale(0)?t.positiveColour:t.negativeColour}},{key:"displayCheck",value:function(t,e){return e.selectedMetrics&&e.selectedMetrics.length>0?f.a.includes(e.selectedMetrics,this.dataSelector(t))?null:"none":null}},{key:"entryOpacity",value:function(t,e,n,r){var i=n.data,o=n.topMetrics,a=n.bottomMetrics,c=n.params;return f.a.some(i,(function(t){return t.selectedState}))||c.selectedMetrics&&0!==c.selectedMetrics.length?c.selectedMetrics&&c.selectedMetrics.includes(this.dataSelector(t))||this.dataSelector(t)===r||s.isTopOrBottom(e,{data:i,topMetrics:o,bottomMetrics:a})?1:.4:1}},{key:"entryColour",value:function(t,e){var n=t.primaryColor||(this.hasPosNegColours?this.posNegColours(e,t):Yt(e,t));return e.selectedMetrics.length>0?f.a.includes(e.selectedMetrics,this.dataSelector(t))?n:et.chartcolourgrey:n}},{key:"valueLabelColour",value:function(t,e){return t.labelColor?t.labelColor:this.hasPosNegColours?this.valueAccessor(t)>=0?e.positiveColour:e.negativeColour:e.labelColor}},{key:"tooltipColour",value:function(t,e){return this.hasPosNegColours?this.posNegColours(e,t):Yt(e,t)}},{key:"ellipsizeWidth",value:function(t){var e=t.data,n=t.params,r=f.a.some(e,(function(t){return void 0!==t.labelText})),i=this.width*(r?.5:.4);return null!==n.margins.maxLabelWidth?Math.min(n.margins.maxLabelWidth,i):i}},{key:"drawEntries",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=t.data,i=t.params,o=yt(r.filter((function(e,n){return!s.isTopOrBottom(n,t)})),i),a=this.drawEntryLabels(t,o,n),c=this.chartArea(a,r,i);this.xScale.range([0,c.width]);var l=this.svg.select("g.".concat(this.cssPrefix,"-chart")),u=l.select("g.".concat(this.cssPrefix,"-area")),d=this.longestBarValueLabelLength(r,t,!0),h=this.longestBarValueLabelLength(r,t,!1);u.attr("transform","translate(".concat(a,", 0)")),c.width-h-d>0&&this.xScale.range([d+i.margins.valueLabelPadding,c.width-h-i.margins.valueLabelPadding]);var p=u.selectAll("g.".concat(this.cssPrefix,"-entry")).data(r,(function(t){return e.dataSelector(t)})).on("mousemove",f.a.throttle((function(n,r){e.showTooltip(t,r,e.dropdownSelected,a,e.tooltipColour(r,i)),e.setHovered(e.dataSelector(r)),e.trigger("hover",r)}),1e3/60,{trailing:!1})).on("mouseout",(function(){e.tooltip.hide(),e.setHovered(),e.trigger("mouseout")})).on("click",(function(t,n){e.trigger("click",n)})),g=p.enter().append("g").classed("".concat(this.cssPrefix,"-entry"),!0).style("opacity",(function(n,r){return e.entryOpacity(n,r,t)})).on("mousemove",f.a.throttle((function(n,r){e.showTooltip(t,r,e.dropdownSelected,a,e.tooltipColour(r,i)),e.setHovered(e.dataSelector(r)),e.trigger("hover",r)}),1e3/60,{trailing:!1})).on("mouseout",(function(){e.tooltip.hide(),e.setHovered(),e.trigger("mouseout")})).on("click",(function(t,n){e.trigger("click",n)})),m=p.exit(),y={enter:g,update:p,exit:m};return this.drawEntryRects(t,y,n),this.drawEntryValueLabels(t,y,o,n),n&&!this.initialDraw?(p.transition(Hf(i)).style("opacity",(function(n,r){return e.entryOpacity(n,r,t)})),m.transition(Hf(i)).remove()):(p.style("opacity",(function(n,r){return e.entryOpacity(n,r,t)})),m.remove()),u.selectAll("g.".concat(this.cssPrefix,"-entry")).style("cursor",this.hasAction("click")?"pointer":null),a}},{key:"drawEntryLabels",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=t.data,o=t.params,a=this,s=this.svg.select("g.".concat(this.cssPrefix,"-chart")),c=s.select("g.".concat(this.cssPrefix,"-labels")).attr("transform","translate(".concat(o.margins.left,", 0)")),l=c.selectAll("text.entry-label").data(i,(function(t){return n.dataSelector(t)})),u=l.enter().append("text").classed("entry-label",!0).style("font-size","".concat(o.fontSize,"px")).text((function(t){return vt(t,e)})).each((function(){Et(C.select(this),a.ellipsizeWidth(t))})),d=l.exit(),h=function(t){t.attr("y",(function(t){return n.yAccessor(t)})).style("fill",(function(t){return t.labelColor||o.labelColor})).style("font-size","".concat(o.fontSize,"px")).style("display",o.hideLabels?"none":null).style("opacity",0)},p=function(e){e.style("opacity",(function(e,r){return n.entryOpacity(e,r,t)}))},g=function(e){e.attr("y",(function(t){return n.yAccessor(t)})).style("fill",(function(t){return t.labelColor||o.labelColor})).style("font-size","".concat(o.fontSize,"px")).style("display",o.hideLabels?"none":null).style("opacity",(function(e,r){return n.entryOpacity(e,r,t)}))};r&&!this.initialDraw?(u.call(h).transition(Vf(o)).call(p),l.text((function(t){return vt(t,e)})).each((function(){Et(C.select(this),a.ellipsizeWidth(t))})).transition(Vf(o)).call(g),d.transition(Hf(o)).call(Kf).remove()):(u.call(h).call(p),l.text((function(t){return vt(t,e)})).each((function(){Et(C.select(this),a.ellipsizeWidth(t))})).call(g),d.remove());var m=o.margins.left+o.margins.labelPadding+c.node().getBBox().width;return l.on("mousemove",f.a.throttle((function(e,r){n.showTooltip(t,r,n.dropdownSelected,m,n.tooltipColour(r,o)),n.setHovered(n.dataSelector(r)),n.trigger("hover",r)}),1e3/60,{trailing:!1})).on("mouseout",(function(){n.tooltip.hide(),n.setHovered(),n.trigger("mouseout")})).on("click",(function(t,e){n.trigger("click",e)})),u.on("mousemove",f.a.throttle((function(e,r){n.showTooltip(t,r,n.dropdownSelected,m,n.tooltipColour(r,o)),n.setHovered(n.dataSelector(r)),n.trigger("hover",r)}),1e3/60,{trailing:!1})).on("mouseout",(function(){n.tooltip.hide(),n.setHovered(),n.trigger("mouseout")})).on("click",(function(t,e){n.trigger("click",e)})),m}},{key:"drawEntryRects",value:function(t,e){var n=this,r=t.params,i=e.enter,o=e.update,a=e.exit,s=arguments.length>2&&void 0!==arguments[2]&&arguments[2];i.append("rect").classed("entry-rect",!0);var c=o.select(".entry-rect"),l=i.select(".entry-rect"),u=a.select(".entry-rect"),d=function(t){t.attr("width",(function(t){return n.widthAccessor(t)})).attr("height",n.yScale.bandwidth()).attr("fill",(function(t){return n.entryColour(t,r)})).attr("x",(function(t){return n.xAccessor(t)})).attr("y",(function(t){return n.yAccessor(t)-n.yScale.bandwidth()/2})).style("opacity",0)},f=function(t){t.attr("x",(function(t){return n.xAccessor(t)})).attr("width",(function(t){return n.widthAccessor(t)})).attr("height",n.yScale.bandwidth()).style("opacity",1)},h=function(t){t.attr("y",(function(t){return n.yAccessor(t)-n.yScale.bandwidth()/2}))};s&&!this.initialDraw?(l.call(d).transition(Vf(r)).call(Uf),c.attr("fill",(function(t){return n.entryColour(t,r)})).transition(Hf(r)).call(f).transition(Hf(r)).call(h),u.transition(Hf(r)).call(Kf)):(l.call(d).call(Uf),c.attr("fill",(function(t){return n.entryColour(t,r)})).call(f).call(h))}},{key:"drawEntryValueLabels",value:function(t,e,n){var r=this,i=e.enter,o=e.update,a=e.exit,c=arguments.length>3&&void 0!==arguments[3]&&arguments[3],l=t.params,u=Pt(t),d=function(t){if(l.labelAsValueLabel)return s.getValueLabelText(t,n);var e=r.valueAccessor(t);return Number.isFinite(e)?u(e):""};i.append("text").classed("entry-value-label",!0);var f=o.select(".entry-value-label"),h=i.select(".entry-value-label"),p=a.select(".entry-value-label"),g=function(t){t.attr("x",(function(t){var e=r.valueAccessor(t);return e<0?r.xScale(e)-l.margins.valueLabelPadding:r.xScale(Math.max(0,e))+l.margins.valueLabelPadding})).attr("text-anchor",(function(t){return r.valueAccessor(t)<0?"end":"start"})).attr("y",(function(t){return r.yAccessor(t)})).style("fill",(function(t){return"none"===r.displayCheck(t,l)?et.chartcolourgrey:r.valueLabelColour(t,l)})).style("font-size","".concat(l.fontSize,"px")).style("display",(function(t){return r.displayCheck(t,l)})).text((function(t){return d(t)})).style("opacity",0)},m=function(t){t.attr("x",(function(t){var e=r.valueAccessor(t);return e<0?r.xScale(e)-l.margins.valueLabelPadding:r.xScale(Math.max(0,e))+l.margins.valueLabelPadding})).attr("text-anchor",(function(t){return r.valueAccessor(t)<0?"end":"start"})).style("fill",(function(t){return"none"===r.displayCheck(t,l)?et.chartcolourgrey:r.valueLabelColour(t,l)})).style("font-size","".concat(l.fontSize,"px")).style("display",(function(t){return r.displayCheck(t,l)})).style("opacity",1).text((function(t){return d(t)}))},y=function(t){t.attr("y",(function(t){return r.yAccessor(t)}))};c&&!this.initialDraw?(h.call(g).transition(Vf(l)).call(Uf),f.transition(Hf(l)).call(m).transition(Hf(l)).call(y),p.transition(Hf(l)).call(Kf)):(h.call(g).call(Uf),f.call(m).call(y))}},{key:"drawAxis",value:function(t){var e,n=this,r=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=t.data,o=t.params,a=o.hideGridlines,s=o.hideAxisLabels,c=o.axisTextColor,l=o.gridColor,u=o.fontSize,d=o.margins,f=o.bottomXTicks,h=o.xAxisTicks,p=o.hideDrawLine,g=o.transitionDuration,m=this.svg.select("g.".concat(this.cssPrefix,"-chart")),y=m.select("g.".concat(this.cssPrefix,"-labels")),v=this.svg.select("g.".concat(this.cssPrefix,"-xaxis")),b=d.left+d.labelPadding+y.node().getBBox().width,k=this.yScale.range(),w=M()(k,2),x=w[0],A=w[1],S=this.xScale.range(),O=M()(S,2),E=O[0],R=O[1],j=R-E,I=A-x,B=d.top+d.valueLabelPadding+I+this.yScale.bandwidth()/2,D=h;j<150?D=2:j<300&&(D=3),e=f?C.axisBottom(this.xScale):C.axisTop(this.xScale);var T=u+1;f&&(T=B),r&&!this.initialDraw?(v.transition().duration(g).attr("transform","translate(".concat(b,", ").concat(T,")")).call(e.tickSize(-(B-d.top)).tickFormat((function(e){return Pt(t)(e,{ticks:n.xScale.ticks(D)})})).ticks(D)),v.selectAll(".tick text").style("display",s?"none":null).style("fill",c).style("font-size","".concat(u,"px"))):v.attr("transform","translate(".concat(b,", ").concat(T,")")).call(e.tickSize(-(B-d.top)).tickFormat((function(e){return Pt(t)(e,{ticks:n.xScale.ticks(D)})})).ticks(D)).selectAll(".tick text").style("display",s?"none":null).style("fill",c).style("font-size","".concat(u,"px")),v.selectAll(".tick line").style("display",a?"none":null).classed("bold",(function(t){return!n.xScale.domain().includes(0)&&0===t})).style("stroke",l),i.length>0&&!p&&this.drawLine(t,b)}},{key:"drawLine",value:function(t,e){var n=this,r=t.data,i=t.params,o=r.map(this.yAccessor.bind(this));this.svg.select("g.".concat(this.cssPrefix,"-xline")).style("display",null).selectAll("line").data([0]).join("line").classed("bold",!0).style("opacity",this.xScale.domain().includes(0)?0:1).style("stroke",i.axisTextColor).attr("x1",(function(t){return e+n.xScale(t)})).attr("x2",(function(t){return e+n.xScale(t)})).attr("y1",Math.min.apply(Math,O()(o))-this.yScale.bandwidth()/2-10).attr("y2",Math.max.apply(Math,O()(o))+this.yScale.bandwidth()/2+10)}},{key:"drawSectionLines",value:function(t){var e=this,n=t.topMetrics,r=t.data,i=t.bottomMetrics,o=t.params,a=o.margins,s=o.transitionDuration,c=arguments.length>1&&void 0!==arguments[1]&&arguments[1],l=[];if(n.length>0){var u=(this.yAccessor(n[n.length-1])+this.yAccessor(r[0]))/2;l.push(u)}if(i.length>0){var d=(this.yAccessor(r[r.length-1])+this.yAccessor(i[0]))/2;l.push(d)}c&&!this.initialDraw?this.svg.selectAll("line.section").data(l).join((function(t){return t.append("line").classed("section",!0).style("stroke",et.chartcolourgrey).style("stroke-width",2).attr("y1",f.a.identity).attr("y2",f.a.identity).attr("x1",a.left).attr("x2",e.width-a.right).style("opacity",0).call((function(t){return t.transition().delay(s).duration(s).style("opacity",1)}))}),(function(t){return t}),(function(t){return t.call((function(t){return t.transition().duration(s).style("opacity",0).remove()}))})):this.svg.selectAll("line.section").data(l).join("line").classed("section",!0).style("stroke",et.chartcolourgrey).style("stroke-width",2).attr("y1",f.a.identity).attr("y2",f.a.identity).attr("x1",a.left).attr("x2",this.width-a.right)}},{key:"drawCanvas",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,h,p,g,m,y,v,b,k,w,x,A,S,O,E,M,C,j,I,B,D,T,F,P,z,Q,L,Y,W,q,N,G,J,U,K,H=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=H.length>1&&void 0!==H[1]?H[1]:{},r=H.length>2?H[2]:void 0,i=r.margin,o=void 0===i?40:i,a=r.width,s=void 0===a?720:a,c=r.scale,l=void 0===c?3:c,d=r.key,h=void 0===d?void 0:d,p=r.showBranding,g=void 0===p||p,m=r.xOffset,y=void 0===m?0:m,v=r.yOffset,b=void 0===v?0:v,k=H.length>3&&void 0!==H[3]?H[3]:Object(R.createCanvas)(s,s),t.next=5,this.data(e,n);case 5:if(w=t.sent){t.next=8;break}return t.abrupt("return",k);case 8:if(x=w.data,A=w.parent,S=w.topMetrics,O=w.bottomMetrics,E=this.getDrawParams({data:x,parent:A,options:n}),null!==o&&(E.margins.left=o,E.margins.right=o),M=h||this.dropdownSelected,C=20+o+20,j=E.titleFontSize*parseFloat(it),I=""!==E.subtitle,B=I?E.subtitleFontSize*parseFloat(lt):0,D=(null!=o?o:0)+20,T=this.createScales.call(this,x,E,E.margins,E.metricHeight,S,O),F=T.xScale,P=T.yScale,z=this.width,this.width=s,k.width=s*l,Q=E.metricHeight*x.length+E.margins.top+E.margins.bottom,k.height=(Q+C+j+B+D)*l,(L=k.getContext("2d")).fillStyle="white",L.fillRect(0,0,k.width,k.height),L.scale(l,l),Y=E.margins.left,Ue.drawTitles.call(this,k,E,E.hideYear||E.hideDropdown?null:M,Yt(E),void 0,void 0,y,b+C),W=f()([S,x,O]).map((function(t){return Ue.drawLeftLabels(k,t,E,P,s,Y,C+j+B)})).map("longestLabelWidth").max(),q=40,F.range([E.margins.left+E.margins.labelPadding+W,s-E.margins.right-q]),L.strokeStyle=E.axisTextColor,N=C+j+B,G=F(0),L.beginPath(),L.moveTo(G,P.range()[0]-P.bandwidth()/2+N),L.lineTo(G,P.range()[1]-P.bandwidth()/2+N),L.stroke(),J=Pt({data:x,parent:A,params:E}),S.length>0&&(U=N+this.yAccessor(S[S.length-1]),L.strokeStyle=et.chartcolourgrey,L.lineWidth=2,L.beginPath(),L.moveTo(E.margins.left,U),L.lineTo(s-E.margins.right,U),L.stroke(),Ue.drawBars.call(this,k,S,E,M,F,P,0,N,(function(t){return Yt(E,t)}),J)),Ue.drawBars.call(this,k,x,E,M,F,P,0,N,(function(t){return Yt(E,t)}),J),O.length>0&&(K=N+(this.yAccessor(x[x.length-1-O.length])+this.yAccessor(O[0]))/2,L.strokeStyle=et.chartcolourgrey,L.lineWidth=2,L.beginPath(),L.moveTo(E.margins.left,K),L.lineTo(s-E.margins.right,K),L.stroke(),Ue.drawBars.call(this,k,O,E,M,F,P,0,N,(function(t){return Yt(E,t)}),J)),!g){t.next=47;break}return t.next=46,Ue.drawLogo(k,s,E,o);case 46:Ue.drawFooter(k,s,Q+C+j+B+20);case 47:return this.width=z,t.abrupt("return",k);case 49:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})}],[{key:"isTopOrBottom",value:function(t,e){var n=e.data,r=void 0===n?[]:n,i=e.topMetrics,o=void 0===i?[]:i,a=e.bottomMetrics,s=void 0===a?[]:a;return t<o.length||t>=r.length+o.length-s.length}},{key:"getValueLabelText",value:function(t,e){return Jt(vt(t,e))}},{key:"keyMatches",value:function(t,e,n){return n&&"items"===n.toLowerCase()?t===e:e.getTime?t.getTime()===e.getTime():t.getTime()===St(e,n).getTime()}}]),s}(Jf);function hh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function ph(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?hh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):hh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var gh=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c,l,d;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:return r=t.t0,t.next=8,e.topMetrics;case 8:if(t.t1=t.sent,t.t1){t.next=11;break}t.t1=[];case 11:return i=t.t1,t.next=14,e.parent;case 14:o=t.sent,a=zt({data:r,parent:o,options:n}),s=a.title,c=a.subtitle,l=r.concat(i).map(Ed),d=jd(ph(ph({},n),{},{title:s,subtitle:c}),r.concat(i).map(Ed)),p.a.render(pn.a.createElement(es,ph(ph({},d),{},{data:l})),this.container.node());case 19:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}();function mh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function yh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?mh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):mh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var vh=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:if(t.t0=t.sent,t.t0){t.next=5;break}t.t0=[];case 5:r=t.t0,p.a.render(pn.a.createElement(es,yh(yh({},n),{},{data:r.map(Ed)})),this.container.node());case 7:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}]),t}(),bh=n(27),kh=n.n(bh);function wh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function xh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?wh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):wh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Ah(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var Sh=function(t){Q()(s,t);var e,n,r,o=Ah(s);function s(t,e){var n;return a()(this,s),(n=o.call(this,t,1e3,300,e||"small-multiples",!0)).chartType=m.SmallMultiples,n.cssPrefix=e||"small-multiples",n.margins={top:20,bottom:50,left:10,right:10,minRightLabel:0,maxRightLabelRatio:.4},n.betweenPadding=.1,n.columns=2,n.charts={},void 0===t?(n.draw=n.drawCanvas,Vt()(n)):(n.title=t.insert("div",".expandable").classed("chart-title",!0),n.subtitle=t.insert("div",".expandable").classed("chart-subtitle",!0),n.container=t,n.sourceContainer=t.append("div"),n.sources=new en(n.sourceContainer),n.initExpand(),n.svg.remove(),n.expandable=t.select("div.expandable"),n.content=t.select("div.expandable").insert("div",".chart-expander").classed(n.cssPrefix,!0),Ze.call(kh()(n)),n.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;n.width!==e&&0!==e&&requestAnimationFrame((function(){n.width=e,n.redrawContent()}))}))})),n.ro.observe(t.node()),n)}return c()(s,[{key:"data",value:(r=i()(u.a.mark((function t(e){var n,r,i,o,a;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(n=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return r=n.data,i=n.topMetrics,o=n.parent,a=r.filter((function(t){return f.a.flattenDeep([t]).some((function(t){return t.metric.data&&t.metric.data.length>0}))})),t.abrupt("return",{data:a,topMetrics:i,parent:o});case 8:case"end":return t.stop()}}),t,this)}))),function(t){return r.apply(this,arguments)})},{key:"createMultiples",value:function(t,e){var n=this;return t.append("div").classed("small-multiple",!0).each((function(t){var r=n.chartWidth(),i=r*s.heightToWidthRatio(r,e);n.charts[s.id(t)]=new fn(C.select(this),!0,r,i)}))}},{key:"destroyMultiples",value:function(t){var e=this;return t.each((function(t){delete e.charts[s.id(t)]})).remove()}},{key:"chartWidth",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.width;return t/this.columns}},{key:"height",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.width,r=s.heightToWidthRatio(this.chartWidth(n),e),i=20,o=1.25,a=16,c=e.titleFontSize,l=Math.ceil(t.length/this.columns),u=this.chartWidth(n)*r;return(u+a*o)*l+i+c*o}},{key:"transform",value:function(t,e,n){var r=this.chartWidth()*this.betweenPadding+this.chartWidth()*(1+this.betweenPadding)*(e%this.columns),i=this.chartWidth()*(n.heightToWidthRatio+this.betweenPadding)*Math.floor(e/this.columns);return"translate(".concat(r,", ").concat(i,")")}},{key:"getDrawParams",value:function(t,e,n){var r,i=t.data,o=t.parent,a=t.options,c=Ie("default",{}),l=xh(xh({},null!==(r=null==c?void 0:c.margins)&&void 0!==r?r:fn.margins),this.margins),u=a.startDate||a.startYear,d=a.endDate||a.endYear,h=Qt({data:i,parent:o,options:a},l),p=Gt(e,u,d,i[0]?i[0].metric.xType:"years"),g=C.extent(p,(function(t){return t.key})),m=[Math.min(0,C.min(p,(function(t){return t.value}))),Math.max(0,C.max(p,(function(t){return t.value})))],y=i.some((function(t){return Object.prototype.hasOwnProperty.call(t,"states")||t.allStates})),v=(Array.isArray(e[n])?e[n][0].title:e[n].title)||(y?i[0].metric.geo_name:i[0].metric.name),b=Object.prototype.hasOwnProperty.call(a,"heightToWidthRatio")?a.heightToWidthRatio:.5;return xh(xh({},f.a.omit(h,["title","subtitle"])),{},{title:v,xDomain:g,yDomain:m,hideAxisLabels:!!Object.prototype.hasOwnProperty.call(a,"hideAxisLabels")&&a.hideAxisLabels,hideGridlines:!Object.prototype.hasOwnProperty.call(a,"hideGridlines")||a.hideGridlines,areaFill:!Object.prototype.hasOwnProperty.call(a,"areaFill")||a.areaFill,heightToWidthRatio:s.heightToWidthRatio(this.chartWidth(),{heightToWidthRatio:b}),primaryColor:a.primaryColor||null,gridColor:a.gridColor||null,axisTextColor:a.axisTextColor||null,smallTitleColor:a.smallTitleColor||null,smallSubtitleColor:a.smallSubtitleColor||null,lineSize:a.lineSize||null,fontSize:12,titleFontSize:16,tooltipOptions:{},showSourcesAndFootnotes:!1,chartStyle:c})}},{key:"draw",value:(n=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,h=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=h.length>1&&void 0!==h[1]?h[1]:{},t.next=3,this.data(e,r);case 3:if(i=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return o=i.data,a=i.topMetrics,s=i.parent,c=xh(xh({expanded:!0},r),{},{showSourcesAndFootnotes:null===(n=r.showSourcesAndFootnotes)||void 0===n||n},Qt({data:o,topMetrics:a,parent:s,options:r},this.margins)),l=o.map((function(t){return f.a.flattenDeep([t]).map((function(t){var e=t.metric.data.filter((function(e){var n=e.key,r=e.value;return!(null==r||c.startDate&&n<St(c.startDate,t.metric.xType)||c.endDate&&n>St(c.endDate,t.metric.xType))}));return xh(xh({},t),{},{metric:xh(xh({},t.metric),{},{data:e})})}))})),d={data:l,topMetrics:a,parent:s,params:c},this.drawContent(d),t.abrupt("return",!0);case 12:case"end":return t.stop()}}),t,this)}))),function(t){return n.apply(this,arguments)})},{key:"redrawContent",value:function(){this.cachedParams&&this.drawContent(this.cachedParams)}},{key:"drawContent",value:function(t){var e=this;this.cachedParams=t;var n=t.topMetrics,r=t.parent,i=t.params,o=t.data;"top"===i.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.expandable.node()),this.container.node().insertBefore(this.subtitle.node(),this.expandable.node())):"bottom"===i.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node()),this.container.node().append(this.sourceContainer.node())),n&&(o=n.concat(o)),this.content.selectAll("div.small-multiple").data(o,(function(t){return s.id(t)})).join((function(t){return e.createMultiples(t,i)}),(function(t){return t}),(function(t){return e.destroyMultiples(t)})).each((function(t,n){var a=f.a.flattenDeep([t]),c=f.a.omit(e.getDrawParams({data:a,parent:r,options:i},o,n),"info"),l={data:a,parent:r,params:c};e.charts[s.id(t)].drawContent(l)})),Nt.call(this,this.title,this.subtitle,t),i.showSourcesAndFootnotes&&this.sources.draw(o,i),this.drawExpander(o,i,(function(){return e.drawContent(t)}))}},{key:"drawCanvas",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d,h,p,g,m,y,v,b,k,w,x,A,S,O,E,M,C,j,I,B,D,T,F,P=this,z=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=z.length>1&&void 0!==z[1]?z[1]:{},r=z.length>2?z[2]:void 0,i=r.margin,o=void 0===i?40:i,a=r.width,s=void 0===a?720:a,c=r.scale,l=void 0===c?1:c,d=r.showBranding,h=void 0===d||d,p=r.xOffset,g=void 0===p?0:p,m=r.yOffset,y=void 0===m?0:m,v=z.length>3&&void 0!==z[3]?z[3]:Object(R.createCanvas)(s,s),t.next=5,this.data(e,n);case 5:if(b=t.sent){t.next=8;break}return t.abrupt("return",null);case 8:if(k=b.data,w=b.topMetrics,x=b.parent,A=Qt({data:k,topMetrics:w,parent:x,options:n},this.margins),null!==o&&(A.margins.left=o,A.margins.right=o),S=Object.prototype.hasOwnProperty.call(n,"heightToWidthRatio")?n.heightToWidthRatio:.5,O=20+o+20,E=A.titleFontSize*parseFloat(it),M=""!==A.subtitle,C=M?A.subtitleFontSize*parseFloat(lt):0,j=o+20,I=w?w.concat(k):k,B=20,this.width=s,v.width=s*l,T=((D=s/2)*S+B)*Math.ceil(I.length/2)+A.margins.top,v.height=(T+O+E+C+j)*l,(F=v.getContext("2d")).scale(l,l),F.fillStyle="white",F.fillRect(0,0,v.width,v.height),Ue.drawTitles.call(this,v,A,void 0,void 0,void 0,void 0,g,y+O),I.forEach((function(t,e){var n=f.a.flattenDeep([t]),r=P.getDrawParams({data:n,parent:x,options:A},I,e),i=new fn(void 0,!0,D,D*S),o=e%2?D:0,a=Math.floor(e/2)*(D*S+B)+O+E+C+A.margins.top;e%2?r.margins.left/=2:r.margins.right/=2,Ue.drawTitles(v,r,void 0,void 0,void 0,void 0,o,a),Ke.call(i,n,x,r,!0,v,o,a+B)})),!h){t.next=34;break}return t.next=33,Ue.drawLogo(v,s,A,o);case 33:Ue.drawFooter(v,s,T+O+E+C+20);case 34:return t.abrupt("return",v);case 35:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})}],[{key:"heightToWidthRatio",value:function(t,e){return Math.max(150/t,e.heightToWidthRatio||.5)}},{key:"id",value:function(t){return Array.isArray(t)?t.map((function(t){return"".concat(t.metric.id,"-").concat(t.metric.name,"-").concat(t.metric.geo_id)})).join():"".concat(t.metric.id,"-").concat(t.metric.name,"-").concat(t.metric.geo_id)}}]),s}(Jf),Oh=["metricLabels","hideGridlines","hideAxisLabels","primaryColor","axisTextColor","gridColor","xLabel","yLabel","heightToWidthRatio","maxRadiusPercent","safeMargins","hideYear","startDate","verticalLine","horizontalLine","showSourcesAndFootnotes"];function Eh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Mh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Eh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Eh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Ch(t){var e=t.data,n=t.params,r=n.startDate,i=n.endDate,o=n.xDomain,a=n.yDomain,s=n.margins,c=n.maxRadiusPercent,l=this.chartArea(s),u=l.height,d=l.width,f=Gt(e,r,i,e[0]?e[0].metric.xType:"years"),h=[Math.min(0,C.min(f,(function(t){return t.x}))),Math.max(0,C.max(f,(function(t){return t.x})))],p=[Math.min(0,C.min(f,(function(t){return t.y}))),Math.max(0,C.max(f,(function(t){return t.y})))],g=[0,C.max(f,(function(t){return t.value}))],m=d*c;return{xScale:C.scaleLinear().domain(o||h).range([0,d]).nice(),yScale:C.scaleLinear().domain(a||p).range([u,0]).nice(),bubbleScale:C.scalePow().exponent(.5).domain(g).range([0,m])}}var Rh=function(){function t(e,n,r){var i=this;a()(this,t),this.chartType=m.BubbleChart,this.cssPrefix="bubble-chart",this.margins={top:0,bottom:20,left:50,right:0},this.yTicks=6,this.xTicks=8,this.width=n||1e3,this.height=r||200,this.title=e.append("div").classed("chart-title",!0),this.subtitle=e.append("div").classed("chart-subtitle",!0),this.controls=e.append("div").classed("bubble-chart-controls",!0),this.container=e.classed("bubble-chart",!0).classed("dh-chart-wrapper",!0),this.svg=e.append("svg").classed("bubble-chart",!0),this.sourceContainer=e.append("div").classed("footer",!0),this.tooltip=new nn(e),this.sources=new en(this.sourceContainer),this.dropdownSelected=null,this.playingID=null,this.selected=null,this.firstDraw=!0,this.initGroups(),this.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;i.width!==e&&0!==e&&requestAnimationFrame((function(){i.width=e,i.redrawContent()}))}))})),this.ro.observe(e.node())}var e,n;return c()(t,[{key:"initGroups",value:function(){this.svgAll=this.svg.append("g").classed("bubble-chart-all",!0),this.svgAll.append("g").classed("axis",!0).classed("x",!0),this.svgAll.append("g").classed("axis",!0).classed("axis-back",!0).classed("y",!0),this.svgAll.append("g").classed("axis",!0).classed("x-label",!0),this.svgAll.append("g").classed("axis",!0).classed("y-label",!0),this.svgAll.append("line").classed("vertical-line",!0),this.svgAll.append("text").classed("vertical-label",!0),this.svgAll.append("line").classed("horizontal-line",!0),this.svgAll.append("text").classed("horizontal-label",!0),this.svgAll.append("rect").classed("bubble-chart-clickout",!0),this.svgAll.append("g").classed("bubble-chart-chart",!0),this.svgAll.append("g").classed("axis",!0).classed("axis-front",!0).classed("y",!0),Ze.call(this)}},{key:"data",value:(n=i()(u.a.mark((function e(n){var r,i,o,a,s,c;return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,Xe.call(this,n);case 2:if(r=e.sent){e.next=5;break}return e.abrupt("return",null);case 5:return i=r.data,o=r.parent,a=i.map((function(e){var n=M()(e,3),r=n[0],i=n[1],o=n[2];return Mh(Mh({},r),{},{metric:Mh(Mh({},r.metric),{},{data:r.metric.data.map((function(e){return Mh(Mh({},e),{},{x:i.metric.data.find((function(n){return t.keyMatches(n.key,e.key,i.metric.xType)})).value,y:o.metric.data.find((function(n){return t.keyMatches(n.key,e.key,o.metric.xType)})).value})}))}),xMetric:i,yMetric:o,bubbleMetric:r})})),s=!0,c=f()(a).flatMap((function(t){return t.metric.data.map((function(e){var n=e.key;return t.metric.xType&&"items"===t.metric.xType.toLowerCase()?(s=!1,n):Ot(n,t.metric.xType)}))})).uniq().value(),null!==this.dropdownSelected&&c.includes(this.dropdownSelected)||(this.dropdownSelected=s?f.a.last(c):f.a.first(c)),e.abrupt("return",{data:a,parent:o,keys:c});case 11:case"end":return e.stop()}}),e,this)}))),function(t){return n.apply(this,arguments)})},{key:"chartArea",value:function(t){return{width:this.width-t.left-t.right,height:this.height-t.top-t.bottom}}},{key:"getAdjustedMargins",value:function(t){var e=t.safeMargins,n=t.maxRadiusPercent,r=t.margins,i=t.xLabel,o=t.yLabel,a=r.top,s=r.right,c=r.bottom,l=r.left;return e?{top:Math.max(a,n*this.width),right:Math.max(s,n*this.width),bottom:Math.max(c,n*this.width),left:Math.max(l,n*this.width)}:{top:this.margins.top+(a||0)+(o?30:0),right:this.margins.right+(s||0)+20,bottom:this.margins.bottom+(c||0)+(i?20:0),left:this.margins.left+(l||0)}}},{key:"getDrawParams",value:function(t){var e=t.data,n=t.parent,r=t.options,i=r.metricLabels,o=void 0===i?["","",""]:i,a=r.hideGridlines,s=void 0===a||a,c=r.hideAxisLabels,l=void 0!==c&&c,u=r.primaryColor,d=void 0===u?null:u,f=r.axisTextColor,h=void 0===f?dt:f,p=r.gridColor,g=void 0===p?null:p,m=r.xLabel,y=void 0===m?"":m,v=r.yLabel,b=void 0===v?"":v,k=r.heightToWidthRatio,x=void 0===k?null:k,A=r.maxRadiusPercent,S=void 0===A?.1:A,O=r.safeMargins,E=void 0===O||O,M=r.hideYear,C=void 0!==M&&M,R=r.startDate,j=void 0===R?null:R,I=r.verticalLine,B=void 0===I?{}:I,D=r.horizontalLine,T=void 0===D?{}:D,F=r.showSourcesAndFootnotes,P=void 0===F||F,z=w()(r,Oh),Q=Mh(Mh({},Qt({data:e,parent:n,options:z},this.margins)),{},{metricLabels:o,hideGridlines:s,hideAxisLabels:l,primaryColor:d,axisTextColor:h,gridColor:g,xLabel:y,yLabel:b,heightToWidthRatio:x,maxRadiusPercent:S,safeMargins:E,hideYear:C,startDate:j,verticalLine:B,horizontalLine:T,showSourcesAndFootnotes:P});return Q.margins=this.getAdjustedMargins(Q),Q}},{key:"setDropdownSelected",value:function(t){this.dropdownSelected=t}},{key:"redrawContent",value:function(){this.cachedParams&&this.drawContent(this.cachedParams)}},{key:"showTooltip",value:function(e,n,r,i,o){var a,s=e.parent,c=e.params,l=this.container.node().getBoundingClientRect(),u=this.svg.node().getBoundingClientRect(),d=l.width,f=this.xScale(this.xAccessor(n)),h=this.yScale(this.yAccessor(n)),p=this.valueAccessor(n),g=(i+f)*d/this.width,m=u.top-l.top+h+c.margins.top,y=t.getTooltipFormats(n,s),v=y.bubbleFormat,b=y.xFormat,k=y.yFormat,w=[{type:"keyValues",key:"bubble",values:[{key:c.metricLabels[0],value:v(p,{truncate:!0})},{key:c.metricLabels[1],value:b(this.xAccessor(n),{truncate:!0}),styles:{"font-size":"0.6em"}},{key:c.metricLabels[2],value:k(this.yAccessor(n),{truncate:!0}),styles:{"font-size":"0.6em"}}]}],x={title:{value:null!==(a=n.tooltipTitle)&&void 0!==a?a:n.metric.name},subtitle:{value:r}};this.tooltip.draw(g,m,x,w,{primaryColour:o},this.bubbleScale(p))}},{key:"draw",value:(e=i()(u.a.mark((function t(e){var n,r,i,o=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=Mh(Mh({},r),{},{options:n}),this.drawContent(i),t.abrupt("return",!0);case 9:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})},{key:"drawContent",value:function(t){var e=this,n=t.data,r=t.parent,i=t.keys,o=t.options;this.cachedParams={data:n,parent:r,keys:i,options:o};var a=this.getDrawParams({data:n,parent:r,options:o});if(i.includes(a.startDate)&&this.firstDraw&&(this.dropdownSelected=a.startDate),"top"===a.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node()),this.container.node().insertBefore(this.subtitle.node(),this.svg.node()),this.container.node().insertBefore(this.controls.node(),this.svg.node())):"bottom"===a.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.controls.node()),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node())),this.drawTitleContent({params:a,keys:i}),a.showSourcesAndFootnotes&&this.sources.draw(n,a),a.heightToWidthRatio)this.height=a.heightToWidthRatio*this.width;else{var s=this.title.node().getBoundingClientRect().height,c=this.subtitle.node().getBoundingClientRect().height,l=this.controls.node().getBoundingClientRect().height,u=this.container.node().getBoundingClientRect().height,d=this.sourceContainer.node().getBoundingClientRect().height;this.height=Math.max(200,u-s-c-l-d)}C.select(this.svg.node()).attr("viewBox","0 0 ".concat(this.width," ").concat(this.height));var f=Ch.call(this,{data:n,params:a});this.xScale=f.xScale,this.yScale=f.yScale,this.bubbleScale=f.bubbleScale,this.svg.select("rect.bubble-chart-clickout").attr("x",-a.margins.left).attr("y",-a.margins.top).attr("width",this.width).attr("height",this.height).on("click",(function(){e.selected&&(e.selected=null,e.redrawContent())})),this.drawAllBubbles({data:n,parent:r,params:a}),this.drawAxes({data:n,parent:r,params:a},f),a.info&&"chart"===a.info.position&&T.inChart(this.container,a),this.firstDraw=!1,this.svg.select("g.bubble-chart-all").attr("transform","translate(".concat(a.margins.left,", ").concat(a.margins.top,")"))}},{key:"xAccessor",value:function(e,n){var r=this,i=e.metric.data.find((function(i){return t.keyMatches(i.key,n||r.dropdownSelected,e.metric.xType)}));return i?i.x:null}},{key:"yAccessor",value:function(e,n){var r=this,i=e.metric.data.find((function(i){return t.keyMatches(i.key,n||r.dropdownSelected,e.metric.xType)}));return i?i.y:null}},{key:"valueAccessor",value:function(e,n){var r=this,i=e.metric.data.find((function(i){return t.keyMatches(i.key,n||r.dropdownSelected,e.metric.xType)}));return i?i.value:null}},{key:"drawTitleContent",value:function(t){var e=this,n=t.params,r=t.keys;Nt.call(this,this.title,this.subtitle,{params:n});var i=Mh(Mh({},n),{},{title:"",info:{}});if(Nt.call(this,this.controls,this.subtitle,{params:i,keys:r},this.dropdownSelected),n.hideYear)this.controls.style("display","none");else{"center"===n.titleHorizontalAlignment&&(this.title.style("margin-left",0),this.subtitle.style("margin-left",0));var o=this.controls.select("div.bubble-back");o.empty()&&(o=this.controls.insert("div",".drop-down-wrapper").classed("bubble-back",!0).text("ᐸ"));var a=this.controls.select("div.bubble-forward");a.empty()&&(a=this.controls.append("div").classed("bubble-forward",!0).text("ᐳ"));var s=this.controls.select("div.bubble-play");s.empty()&&(s=this.controls.append("div").classed("bubble-play",!0).text(this.playingID?"◼":"▶")),s.on("click",(function(){e.playingID?(clearInterval(e.playingID),s.text("▶"),e.playingID=null,e.playingstartDate=null,e.redrawContent()):(e.playingstartDate=e.dropdownSelected,e.playingID=setInterval((function(){var t=r.findIndex((function(t){return t===e.dropdownSelected}));e.dropdownSelected=r[(t+1)%r.length],e.redrawContent()}),1e3),s.text("◼"))})),o.on("click",(function(){var t=r.findIndex((function(t){return t===e.dropdownSelected}));e.dropdownSelected=r[(t+r.length-1)%r.length],e.playingID&&(clearInterval(e.playingID),s.text("▶"),e.playingID=null,e.playingstartDate=null),e.redrawContent()})),a.on("click",(function(){var t=r.findIndex((function(t){return t===e.dropdownSelected}));e.dropdownSelected=r[(t+1)%r.length],e.playingID&&(clearInterval(e.playingID),s.text("▶"),e.playingID=null,e.playingstartDate=null),e.redrawContent()}))}}},{key:"getBubbleColour",value:function(t,e,n,r,i,o){var a=r;if(t.id===this.selected)a=i;else if(this.selected&&o)return"rgba(0,0,0,0)";return a||(this.selected?t.id===this.selected?Lt(t,e,n):"rgb(234,234,234)":Lt(t,e,n))}},{key:"drawAllBubbles",value:function(t){var e=t.data,n=t.parent,r=t.params;this.drawBubbles({data:e,parent:n,params:r},this.dropdownSelected-2,"back2","rgb(247,247,247)","rgb(173,173,173)",!1,this.firstDraw),this.drawBubbles({data:e,parent:n,params:r},this.dropdownSelected-1,"back1","rgb(234,234,234)","rgb(164,164,164)",!1,this.firstDraw),this.drawBubbles({data:e,parent:n,params:r},this.dropdownSelected,"now",null,null,!0,this.firstDraw,!0)}},{key:"drawBubbles",value:function(t,e,n,r,i,o,a,s){var c=this,l=t.data,u=t.parent,d=t.params,h=this,p=this.svg.select("g.bubble-chart-chart").selectAll("g.bubble-chart-entry-".concat(n)).data(l,(function(t){return"".concat(t.id,"|").concat(n)})).join((function(t){var e=t.append("g").classed("bubble-chart-entry-".concat(n),!0);return e.append("circle").classed("bubble-chart-circle-".concat(n),!0),e.append("text").classed("bubble-chart-label",!0),e}),(function(t){return t})),g=this.playingstartKey||e;p.sort((function(t,e){return c.bubbleScale(c.valueAccessor(e,g))-c.bubbleScale(c.valueAccessor(t,g))})).selectAll("circle").style("cursor",o?"pointer":null).each((function(t){var n="0"===C.select(this.parentNode).style("opacity");(a||n)&&C.select(this).style("fill",h.getBubbleColour(t,l.findIndex((function(e){return e.id===t.id})),d,r,i,!o)).attr("cx",h.xScale(h.xAccessor(t,e))).attr("cy",h.yScale(h.yAccessor(t,e))),n&&C.select(this).attr("r",h.bubbleScale(h.valueAccessor(t,e)))})),p.transition().duration(750).style("opacity",(function(t){return null===c.valueAccessor(t,e)?0:1})),p.filter((function(t){return null!==c.valueAccessor(t,e)})).selectAll("circle").transition().duration(750).style("fill",(function(t){return c.getBubbleColour(t,l.findIndex((function(e){return e.id===t.id})),d,r,i,!o)})).attr("cx",(function(t){return c.xScale(c.xAccessor(t,e))})).attr("cy",(function(t){return c.yScale(c.yAccessor(t,e))})).attr("r",(function(t){return c.bubbleScale(c.valueAccessor(t,e))})),s&&(p.selectAll("text").text((function(t){return void 0!==t.labelText?t.labelText:t.metric.name})).each((function(t){h.firstDraw&&C.select(this).attr("x",h.xScale(h.xAccessor(t,h.key))).attr("y",h.yScale(h.yAccessor(t,h.key)))})),p.filter((function(t){return null!==c.valueAccessor(t,e)})).selectAll("text").transition().duration(750).style("font-size",(function(t){return t.labelSize?"".concat(t.labelSize,"px"):null})).attr("x",(function(t){return c.xScale(c.xAccessor(t,c.dropdownSelected))})).attr("y",(function(t){return c.yScale(c.yAccessor(t,c.dropdownSelected))})).style("opacity",(function(t){return c.selected&&t.id!==c.selected?0:1}))),p.filter((function(t){return c.selected===t.id})).raise(),p.selectAll("circle").on("mousemove",f.a.throttle((function(t,e){if(o){var n=r||Lt(e,l.findIndex((function(t){return t.id===e.id})),d);c.showTooltip({parent:u,params:d},e,c.dropdownSelected,d.margins.left,n)}}),1e3/60,{trailing:!1})).on("mouseout",(function(){c.tooltip.hide()})).on("click",(function(t,e){o&&c.selected!==e.id?c.selected=e.id:c.selected=null,c.redrawContent()}))}},{key:"drawAxes",value:function(t,e){var n=t.data,r=t.parent,i=t.params,o=e.xScale,a=e.yScale,s=this.svg.select("g.bubble-chart-all"),c=o.range(),l=M()(c,2),u=l[0],d=l[1],h=a.range(),p=M()(h,2),g=p[0],m=p[1],y=d-u,v=this.xTicks;y<150?v=3:y<300&&(v=4);var b=g-m,k=this.yTicks;b<150?k=3:b<300&&(k=4);if(i.verticalLine){var w=o.domain(),x=Mh({lineColor:"#000000",lineSize:1,labelVerticalPos:"top",labelHorizontalPos:"right",labelText:"",labelColor:i.axisTextColor,fontSize:i.fontSize},i.verticalLine),A=x.xValue,S=x.lineColor,O=x.lineSize,E=x.labelVerticalPos,R=x.labelHorizontalPos,j=x.labelText,I=x.labelColor,B=x.fontSize;if(A>=w[0]&&A<=w[1]){var D=y*(A-w[0])/(w[1]-w[0]);s.select(".vertical-line").attr("stroke",S).attr("y2",b).attr("transform","translate(".concat(D,", 0)")).attr("stroke-width",O);var T=[D+("left"===R?-(2+O/2):2+O/2),"top"===E?B:b];s.select(".vertical-label").attr("transform","translate(".concat(T[0],", ").concat(T[1],")")).attr("text-anchor","left"===R?"end":"start").attr("font-size",B).attr("fill",I);var F=j.split("\n");"top"!==E&&(F=F.reverse()),s.select(".vertical-label").selectAll("tspan").data(F).join("tspan").text((function(t){return t})).attr("x",0).attr("y",(function(t,e){return B*("top"===E?1:-1)*e}))}}if(i.horizontalLine){var P=a.domain(),z=Mh({lineColor:"#000000",lineSize:1,labelVerticalPos:"top",labelHorizontalPos:"right",labelText:"",labelColor:i.axisTextColor,fontSize:i.fontSize},i.horizontalLine),Q=z.yValue,L=z.lineColor,Y=z.lineSize,W=z.labelVerticalPos,q=z.labelHorizontalPos,N=z.labelText,G=z.labelColor,J=z.fontSize;if(Q>=P[0]&&Q<=P[1]){var U=b*(Q-P[0])/(P[1]-P[0]);s.select(".horizontal-line").attr("stroke",L).attr("x2",y).attr("transform","translate(0, ".concat(b-U,")")).attr("stroke-width",Y);var K=["left"===q?2:y-2,b-U-("top"===W?2+Y/2:-(J+2+Y/2))];s.select(".horizontal-label").attr("transform","translate(".concat(K[0],", ").concat(K[1],")")).attr("text-anchor","left"===q?"start":"end").attr("font-size",J).attr("fill",G);var H=N.split("\n");"top"===W&&(H=H.reverse()),s.select(".horizontal-label").selectAll("tspan").data(H).join("tspan").text((function(t){return t})).attr("x",0).attr("y",(function(t,e){return J*("top"===W?-1:1)*e}))}}var V=C.axisBottom(o).ticks(v).tickFormat(Pt({parent:r,params:i,data:n.map((function(t){return t.xMetric}))})).tickSize(i.hideGridlines?6:m-g),Z=s.select(".axis.x").attr("transform","translate(0, ".concat(g,")")).call(V),X=Z.selectAll(".tick text").attr("transform","translate(0, ".concat(3,")")).style("font-size","".concat(i.fontSize,"px")).style("display",i.hideAxisLabels?"none":null).style("fill",i.axisTextColor);Z.selectAll(".tick line").classed("bold",(function(t){return!o.domain().includes(0)&&0===t})).style("stroke",i.gridColor);var _=C.axisLeft(a).ticks(k).tickSize(0).tickFormat(Pt({parent:r,params:i,data:n.map((function(t){return t.yMetric}))})),$=s.select(".axis-front.y").call(_);$.selectAll(".tick text").style("fill",i.axisTextColor).style("display",i.hideAxisLabels?"none":null),$.selectAll("text").style("font-size","".concat(i.fontSize,"px")).attr("x",-15);var tt=s.select(".axis-back.y").call(C.axisLeft(a).ticks(k).tickFormat(Pt({data:n,parent:r,params:i})).tickSize(i.hideGridlines?6:u-d));tt.selectAll(".tick line").classed("bold",(function(t){return!a.domain().includes(0)&&0===t})).style("stroke",i.gridColor),tt.selectAll("text").style("font-size","".concat(i.fontSize,"px")).attr("x",-15),this.svg.select(".x-label").selectAll("text").data([i.xLabel]).enter().append("text");var et=f.a.maxBy(X.nodes(),(function(t){return t.getBoundingClientRect().x})).getBoundingClientRect().width/2;this.svg.selectAll(".x-label text").attr("transform","translate(0, ".concat(g,")")).attr("x",d+et).attr("y",29).attr("dy","0.32em").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor).text((function(t){return t})),this.svg.select(".y-label").selectAll("text").data([i.yLabel]).enter().append("text"),this.svg.selectAll(".y-label text").attr("x",-15).attr("y",-20).attr("dy","0.32em").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor).text((function(t){return t}))}}],[{key:"getTooltipFormats",value:function(t,e){return{bubbleFormat:Ft({data:[t.bubbleMetric],parent:e,params:{}}),xFormat:Ft({data:[t.xMetric],parent:e,params:{}}),yFormat:Ft({data:[t.yMetric],parent:e,params:{}})}}},{key:"keyMatches",value:function(t,e,n){return n&&"items"===n.toLowerCase()?t===e:e.getTime?t.getTime()===e.getTime():t.getTime()===St(e,n).getTime()}}]),t}(),jh=function(){function t(e,n,r,i,o){a()(this,t),this.container=e,this.containerWidth=r,this.containerHeight=i,this.heightScale=o,this.nodeWidths=[.04*r,.7*r],this.linkWidths=[0,.12*r],this.middlePadding=.04*r,this.nodeOffset=.06*i,this.betweenPadding=.03*i,this.yStart=50,this.levels=2,this.tooltip=n}return c()(t,[{key:"color",value:function(t){return t.primaryColor}},{key:"xOffset",value:function(t){return f.a.sumBy(this.nodeWidths.map((function(t,e){return[t,e]})),(function(e){var n=M()(e,2),r=n[0];return n[1]<t?r:0}))+f.a.sumBy(this.linkWidths.map((function(t,e){return[t,e]})),(function(e){var n=M()(e,2),r=n[0];return n[1]<=t?r:0}))}},{key:"yAccessor",value:function(t,e){return Object.prototype.hasOwnProperty.call(e,"padding")?t-this.betweenPadding+e.padding:t}},{key:"xAccessor",value:function(){return 0}},{key:"xStart",value:function(){return 0}},{key:"drawLinkLevel",value:function(){}},{key:"drawExtra",value:function(){}},{key:"draw",value:function(t,e,n){var r=t.data,i=t.params,o=r,a=Object.keys(o)[0];return n&&(o.sankey__extra={name:i.extraName,total:n,padding:0,class:"sankey-extra",pattern:"sankey-mask-diagonal"},o[a].children.sankey__extra={name:i.extraName,total:n,class:"sankey-extra",pattern:"sankey-mask-diagonal",linkClass:"sankey-extra"}),this.drawNodeLevel(this.container,o,i,this.yStart,0,e,o[a]),this}},{key:"drawNodeLevel",value:function(e,n,r,i,o,a,s){var c=this,l=this.xOffset(o),u=this.xStart(a),d=i,h=i,p=e.append("g").classed("sankey-branch",!0);return Object.keys(n).forEach((function(e){var i=p.append("g").classed("sankey-node",!0),g=n[e].total,m=c.heightScale(Math.abs(g)),y=c.nodeWidths[o]/a,v=c.xAccessor(u,o,a,y),b=c.yAccessor(h,n[e]),k=i.append("rect").attr("x",v).attr("y",b).attr("width",y).attr("height",m).attr("fill",g<0?"rgb(100,100,100)":c.color(r)).on("mousemove",f.a.throttle((function(t){c.showTooltip(n[e],r,t,s)}),1e3/60,{trailing:!1})).on("mouseout",(function(){c.tooltip.hide()}));if(i.append("rect").classed("sankey-stroke-rect",!0).attr("x",v).attr("y",b).attr("width",y).attr("height",m).attr("fill","none").attr("stroke",g<0?"rgb(100,100,100)":c.color(r)),n[e].class&&k.classed(n[e].class,!0),n[e].pattern&&k.attr("mask","url(#".concat(n[e].pattern,")")),o>0){var w=c.xLabel(u,o,a,y);t.drawLabel(i,w,b,m,n[e]);var x={xOffset:l,yOffset:d,yOffsetWithPadding:b};c.drawLinkLevel(p,n[e],r,x,o,a)}o<c.levels-1&&n[e].children&&c.drawNodeLevel(p,n[e].children,r,d+c.nodeOffset,o+1,a,s);var A=g>0?m:0,S=Object.prototype.hasOwnProperty.call(n[e],"padding")?n[e].padding:c.betweenPadding;d+=A,h+=A+S})),p}},{key:"showTooltip",value:function(t,e,n,r){var i=this.container.node().getBoundingClientRect(),o=n.clientX,a=n.clientY,s=o-i.left,c=a-i.top,l=[];t.children&&Object.entries(t.children).forEach((function(e){var n=M()(e,2),r=n[0],i=n[1];l.push({type:"keyValueLeft",key:r,value:$.dollars(i.total)}),l.push({type:"bar",key:r,value:i.total/t.total})}));var u=t.total/r.total,d={title:{value:t.name,colour:at},total:{value:$.dollars(t.total,{suffixLength:"long"})}};r.name!==t.name?d.subtitle={value:"".concat($.percent(u)," of Total ").concat(r.name)}:delete d.subtitle,this.tooltip.draw(s,c,d,l,{primaryColour:this.color(e),secondaryColour:this.color(e)})}}],[{key:"drawLabel",value:function(t,e,n,r,i,o){var a=t.append("rect").classed("text-background",!0),s=t.append("text").attr("x",e).attr("y",n+r/2).style("text-anchor",o||"start").text(i.name).node().getBBox();a.attr("x",e-5-("end"===o?s.width:0)).attr("y",n-1).attr("width",s.width+10).attr("height",s.height).style("fill",s.height>r+2?"white":null)}}]),t}();function Ih(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var Bh=function(t){Q()(n,t);var e=Ih(n);function n(){return a()(this,n),e.apply(this,arguments)}return c()(n,[{key:"color",value:function(t){return t.primaryColor}},{key:"xAccessor",value:function(t,e,n){return t+this.xOffset(e)/n}},{key:"xLabel",value:function(t,e,n){var r=this.nodeWidths[e]/n;return this.xAccessor(t,e,n)+.05*r}},{key:"xStart",value:function(t){return(this.containerWidth+this.middlePadding)/2*(t-1)}},{key:"drawLinkLevel",value:function(t,e,n,r,i,o){var a=r.xOffset,s=r.yOffset,c=r.yOffsetWithPadding,l=this.xStart(o),u=this.heightScale(Math.abs(e.total)),d=l+this.nodeWidths[i-1]/o,f=t.append("path").classed("sankey-link",!0).attr("fill",e.total<0?"rgb(100,100,100)":this.color(n)).attr("d","\n                M".concat(d,",").concat(s-this.nodeOffset,"\n                L").concat(l+a/o,",").concat(c,"\n                L").concat(l+a/o,",").concat(c+u,"\n                L").concat(d,",").concat(s-this.nodeOffset+u,"\n            "));e.linkClass&&f.classed(e.linkClass,!0)}}]),n}(jh);function Dh(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var Th=function(t){Q()(n,t);var e=Dh(n);function n(){return a()(this,n),e.apply(this,arguments)}return c()(n,[{key:"color",value:function(t){return t.secondaryColor||t.primaryColor}},{key:"xAccessor",value:function(t,e,n,r){return t-this.xOffset(e)/n-r}},{key:"xLabel",value:function(t,e,n){var r=this.nodeWidths[e]/n;return this.xAccessor(t,e,n,r)+.95*r}},{key:"xStart",value:function(t){return this.containerWidth-(this.containerWidth+this.middlePadding)/2*(t-1)}},{key:"drawLabel",value:function(t,e,r,i,o){Jd()(Xt()(n.prototype),"drawLabel",this).call(this,t,e,r,i,o,"end")}},{key:"drawLinkLevel",value:function(t,e,n,r,i,o){var a=r.yOffset,s=r.yOffsetWithPadding,c=this.xStart(o),l=this.nodeWidths[i]/o,u=this.xAccessor(c,i,o,l),d=this.heightScale(Math.abs(e.total)),f=c-this.nodeWidths[i-1]/o,h=t.append("path").classed("sankey-link",!0).attr("fill",e.total<0?"rgb(100,100,100)":this.color(n)).attr("d","\n                M".concat(f,",").concat(a-this.nodeOffset,"\n                L").concat(u+l,",").concat(s,"\n                L").concat(u+l,",").concat(s+d,"\n                L").concat(f,",").concat(a-this.nodeOffset+d,"\n            "));e.linkClass&&h.classed(e.linkClass,!0)}}]),n}(jh);function Fh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Ph(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Fh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Fh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var zh=function(){function t(e){var n=this;a()(this,t),this.chartType=m.Sankey,this.cssPrefix="sankey",this.container=e.classed("sankey",!0).classed("dh-chart-wrapper",!0),this.margins={top:0,bottom:0,left:0,right:0},this.svg=this.container.append("svg"),this.sourceContainer=e.append("div"),this.sources=new en(this.sourceContainer),this.tooltip=new nn(e),this.initPattern(),Ze.call(this),this.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect,r=e.width,i=e.height;requestAnimationFrame((function(){n.svg.attr("viewBox","0 0 ".concat(r," ").concat(i)),n.resizeContent(r,i)}))}))})),this.ro.observe(e.node())}var e,n;return c()(t,[{key:"initPattern",value:function(){var t=this.svg.append("defs");t.append("pattern").attr("id","sankey-pattern-diagonal").attr("patternUnits","userSpaceOnUse").attr("width",8).attr("height",8).append("path").attr("d","M-1,1 l2,-2 M0,8 l8,-8 M7,9 l2,-2").style("stroke","white").style("stroke-width",1),t.append("mask").attr("id","sankey-mask-diagonal").attr("x",0).attr("y",0).attr("width",1).attr("height",1).append("rect").attr("x",0).attr("y",0).attr("width",5e3).attr("height",5e3).attr("fill","url(#sankey-pattern-diagonal)")}},{key:"data",value:(n=i()(u.a.mark((function t(e){var n;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(n=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return t.abrupt("return",{data:n.data});case 6:case"end":return t.stop()}}),t,this)}))),function(t){return n.apply(this,arguments)})},{key:"getDrawParams",value:function(t){var e=t.data,n=t.options;return Ph(Ph({},Qt({data:e,options:n},this.margins)),{},{titleFontSize:Object.prototype.hasOwnProperty.call(n,"titleFontSize")?n.titleFontSize:null,leftSankey:n.leftSankey,rightSankey:n.rightSankey,extraName:Object.prototype.hasOwnProperty.call(n,"extraName")?n.extraName:"",primaryColor:n.primaryColor||et.chartcolourdefault0,secondaryColor:n.secondaryColor||et.chartcolourdefault3,primaryTitleColor:n.primaryTitleColor||n.primaryColor||et.chartcolourdefault0,secondaryTitleColor:n.secondaryTitleColor||n.secondaryColor||et.chartcolourdefault3,labelColor:n.labelColor||null,rootHeight:n.rootHeight||500,containerWidth:n.containerWidth||1e3,containerHeight:n.containerHeight||700,rootHeightToSankeyHeightRatio:n.rootHeightToSankeyHeightRatio,showSourcesAndFootnotes:n.showSourcesAndFootnotes})}},{key:"draw",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l,d=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=d.length>1&&void 0!==d[1]?d[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=r.data,o=this.getDrawParams({data:i,options:n}),a={data:i[0],params:o},s=this.container.node().getBoundingClientRect(),c=s.height,l=s.width,this.drawContent(a,l,c),t.abrupt("return",!0);case 12:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})},{key:"resizeContent",value:function(t,e){this.cachedParams&&this.drawContent(this.cachedParams,t,e)}},{key:"drawContent",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1e3,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:700,i=e.data,o=e.params;o.showSourcesAndFootnotes&&this.sources.draw([i],o);var a=this.sourceContainer.node().getBoundingClientRect(),s=a.height;o.rootHeightToSankeyHeightRatio&&(o.rootHeight=(r-50-s)*o.rootHeightToSankeyHeightRatio),this.cachedParams=e;var c=f.a.compact([o.leftSankey,o.rightSankey]).length;if(c<1)console.warn("leftSankey and rightSankey were not specified; not drawing anything");else{if(this.heightScale=t.createScales(e).heightScale,this.svg.selectAll("g").remove(),this.svg.append("g").classed("sankey-title",!0).attr("transform","translate(".concat(.5*n,", 0)")).append("text").attr("dy","1em").style("font-size",o.titleFontSize).text(o.title),o.rightSankey&&(this.drawTotal(o.rightSankey,i.metric[o.rightSankey].total,o.primaryTitleColor,"right",n),new Bh(this.svg,this.tooltip,n,o.rootHeight,this.heightScale).draw({data:A()({},o.rightSankey,i.metric[o.rightSankey]),params:o},c)),o.leftSankey){this.drawTotal(o.leftSankey,i.metric[o.leftSankey].total,o.secondaryTitleColor,"left",n);var l=0;o.rightSankey&&i.metric[o.rightSankey].total>i.metric[o.leftSankey].total&&(l=i.metric[o.rightSankey].total-i.metric[o.leftSankey].total);var u=new Th(this.svg,this.tooltip,n,o.rootHeight,this.heightScale);if(o.rightSankey){var d=f.a.keys(i.metric[o.leftSankey].children).filter((function(t){return"sankey__extra"!==t})).length-1+(l?1:0),h=f.a.keys(i.metric[o.rightSankey].children).length-1;h>d&&(u.betweenPadding=u.betweenPadding/d*h)}u.draw({data:A()({},o.leftSankey,i.metric[o.leftSankey]),params:o},c,l)}this.svg.attr("viewBox","0 0 ".concat(n," ").concat(r-s))}}},{key:"drawTotal",value:function(t,e,n,r,i){var o="right"===r?.95*i:.05*i,a=this.svg.append("g").attr("class","sankey-total sankey-total-".concat(r)).attr("transform","translate(".concat(o,", 0)"));a.append("text").attr("dy","1em").classed("sankey-total-title",!0).attr("fill",n).text("Total ".concat(t)),a.append("text").classed("sankey-total-value",!0).attr("dy","1em").attr("y",20).attr("fill",n).text($.dollars(e,{suffixLength:"long"}))}}],[{key:"createScales",value:function(t){var e=t.data,n=t.params,r=Math.max(e.metric[n.leftSankey]?e.metric[n.leftSankey].total:0,e.metric[n.rightSankey]?e.metric[n.rightSankey].total:0);return{heightScale:C.scaleLinear().domain([0,r]).range([0,n.rootHeight])}}}]),t}(),Qh=["margins","primaryColor","axisTextColor","quintileColor","cutoffFontSize","lineBreak","smallBarWidthRatio","betweenWidth","allKeyword","showSourcesAndFootnotes"];function Lh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Yh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Lh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Lh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Wh={quintiles:170,brackets:60},qh=[{bracket:0,small:!1},{bracket:1,small:!1},{bracket:21,small:!0},{bracket:101,small:!0}],Nh={1:0,2:1e4,3:2e4,4:3e4,5:4e4,6:5e4,7:6e4,8:7e4,9:8e4,10:9e4,11:1e5,12:11e4,13:12e4,14:13e4,15:14e4,16:15e4,17:16e4,18:17e4,19:18e4,20:19e4,21:2e5,31:3e5,41:4e5,51:5e5,61:6e5,71:7e5,81:8e5,91:9e5,101:1e6},Gh={0:"≤$0",21:"$200K",101:"$1M+"},Jh={1:"Bottom",2:"Second",3:"Middle",4:"Fourth",5:"Top",9999:"Top"};function Uh(t){var e=t.data,n=t.params,r=n.yDomain,i=n.margins,o=n.betweenWidth,a=n.smallBarWidthRatio,s=n.allKeyword,c=this.chartArea(i),l=c.height,u=c.width,d=f.a.values(e.metric.brackets).map((function(t){return Number(f()(t).pick(["0","1"]).values().maxBy((function(t){return t.number_families})).number_families)})),h=qh.map((function(t,n){var r=t.bracket,i=t.small,o=qh[n+1]?qh[n+1].bracket:1/0,a=f()(e.metric.brackets).pickBy((function(t,e){return e>=r&&e<o})).values();return{start:r,brackets:a,small:i}})),p=f()(h).map((function(t){var e=t.brackets,n=t.small;return e.size()*(n?a:1)})).sum(),g=(u-(o*h.length-1))/p,m={},y=0,v=0;h.forEach((function(t){var e=t.start,n=t.brackets,r=t.small,i=n.map(s).map("darkhorse_income").sortBy((function(t){return Number(t)})).value(),c=g*i.length*(r?a:1);m[e]=C.scaleBand().domain(i).range([y,y+c]),v=y,y+=c+o})),m.range=function(){return[0,v]};var b=[0,Math.max.apply(Math,O()(d))];return{xScales:m,yScale:C.scaleLinear().domain(r||b).range([l,0])}}var Kh=function(){function t(e,n,r){var i=this;a()(this,t),this.chartType=m.IncomeDistribution,this.cssPrefix="income-distribution",this.width=n||1e3,this.height=r||200,this.margins={top:35,bottom:20,left:70,right:20},this.title=e.append("div").classed("chart-title",!0),this.subtitle=e.append("div").classed("chart-subtitle",!0),this.container=e.classed("income-distribution",!0).classed("dh-chart-wrapper",!0),this.topSvg=e.append("svg").classed("income-hover",!0),this.svg=e.append("svg").classed("income-distribution",!0),this.sourceContainer=e.append("div"),this.tooltip=new nn(e),this.sources=new en(this.sourceContainer),this.idNumber=0,this.setIDNumber(),this.initGroups(),this.ro=new _t.a((function(t){t.forEach((function(t){var e=t.contentRect.width;requestAnimationFrame((function(){i.width=e,i.redrawContent()}))}))})),this.ro.observe(e.node())}var e,n;return c()(t,[{key:"setIDNumber",value:function(){for(var t=0,e="income-mask-all-".concat(t),n=C.select("#".concat(e));!n.empty()&&t<50;)t+=1,e="".concat(e.split("-").slice(0,-1).join("-"),"-").concat(t),n=C.select("#".concat(e));this.idNumber=t}},{key:"initGroups",value:function(){this.topSvg.append("g").classed("income-top-all",!0),this.svg.append("defs").append("mask").attr("id","income-mask-all-".concat(this.idNumber)).append("rect");var t=this.svg.append("g").classed("income-chart-all",!0);t.append("g").classed("axis",!0).classed("x",!0),t.append("g").classed("axis",!0).classed("y",!0),t.append("g").classed("axis",!0).classed("x-label",!0),t.append("g").classed("axis",!0).classed("y-label",!0),t.append("g").classed("axis",!0).classed("top-axis",!0),t.append("g").classed("income-bars",!0),this.svg.append("g").classed("income-cutoffs",!0),Ze.call(this)}},{key:"data",value:(n=i()(u.a.mark((function t(e,n){var r;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return t.abrupt("return",{data:r.data,options:n});case 6:case"end":return t.stop()}}),t,this)}))),function(t,e){return n.apply(this,arguments)})},{key:"getDrawParams",value:function(t){var e=t.data,n=t.options,r=n.margins,i=void 0===r?{}:r,o=n.primaryColor,a=void 0===o?et.chartcolourdefault0:o,s=n.axisTextColor,c=void 0===s?dt:s,l=n.quintileColor,u=void 0===l?dt:l,d=n.cutoffFontSize,f=void 0===d?14:d,h=n.lineBreak,p=void 0===h||h,g=n.smallBarWidthRatio,m=void 0===g?.15:g,y=n.betweenWidth,v=void 0===y?20:y,b=n.allKeyword,k=void 0===b?"9999":b,x=n.showSourcesAndFootnotes,A=void 0===x||x,S=w()(n,Qh),O=Yh(Yh({},Qt({data:e,parent:null,options:S},this.margins)),{},{primaryColor:a,axisTextColor:c,quintileColor:u,cutoffFontSize:f,lineBreak:p,smallBarWidthRatio:m,betweenWidth:v,allKeyword:k,showSourcesAndFootnotes:A}),E=i.top,M=i.right,C=i.bottom,R=i.left;return O.margins={top:this.margins.top+(E||0),right:this.margins.right+(M||0),bottom:this.margins.bottom+(C||0)+20,left:this.margins.left+(R||0)},O}},{key:"chartArea",value:function(t){return{width:this.width-t.left-t.right,height:this.height-t.top-t.bottom}}},{key:"draw",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=s.length>1&&void 0!==s[1]?s[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=r.data,o=this.getDrawParams({data:i,options:n}),a={data:i[0],params:o},this.drawContent(a),t.abrupt("return",!0);case 11:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})},{key:"redrawContent",value:function(){this.cachedParams&&this.drawContent(this.cachedParams)}},{key:"drawContent",value:function(t){this.cachedParams=t;var e=t.data,n=t.params,r=n.lineBreak?40:20;this.topSvg.attr("viewBox","0 ".concat(10," ").concat(this.width," ").concat(r+20)),this.topSvg.attr("height",r+40),Nt.call(this,this.title,this.subtitle,{params:n}),n.showSourcesAndFootnotes&&this.sources.draw([e],n);var i=this.title.node().getBoundingClientRect().height,o=this.subtitle.node().getBoundingClientRect().height,a=this.container.node().getBoundingClientRect(),s=a.width,c=a.height,l=this.topSvg.node().getBoundingClientRect().height,u=this.sourceContainer.node().getBoundingClientRect().height,d=Math.max(200,c-i-o-l-u);this.height=d*this.width/s,this.svg.attr("viewBox","0 0 ".concat(this.width," ").concat(this.height));var f=Uh.call(this,{data:e,params:n}),h=f.xScales,p=f.yScale;this.xScales=h,this.yScale=p,this.drawIncomeMasks(t),this.drawQuintileMasks(t),this.drawTop(t),this.drawBars(t),this.drawAxes(t),this.drawQuintileLines(t),this.topSvg.select("g.income-top-all").attr("transform","translate(".concat(n.margins.left,", ").concat(20,")")),this.svg.select("g.income-chart-all").attr("transform","translate(".concat(n.margins.left,", ").concat(n.margins.top,")"));var g=this.svg.node().getBoundingClientRect();this.title.style("margin-left",n.margins.left*g.width/this.width),this.subtitle.style("margin-left",n.margins.left*g.width/this.width)}},{key:"getXScale",value:function(t){return f()(this.xScales).entries().sortBy((function(t){var e=M()(t,1)[0];return Number(e)})).findLast((function(e){var n=M()(e,1)[0];return Number(n)<=t}))[1]}},{key:"xAccessor",value:function(t){return this.getXScale(t.darkhorse_income)(t.darkhorse_income)}},{key:"widthAccessor",value:function(t){return this.getXScale(t.darkhorse_income).bandwidth()}},{key:"quintileStart",value:function(e){if(void 0===e.start_income)return 0;var n=f()(Nh).entries(),r=n.value(),i=n.sortBy((function(t){var e=M()(t,1)[0];return Number(e)})).findIndex((function(t){var n=M()(t,2)[1];return Number(n)>Number(e.start_income)})),o=(Number(e.start_income)-r[i-1][1])/(r[i][1]-r[i-1][1]),a=this.getXScale(t.getIncomeBracket(e.start_income));return a(Number(r[i-1][0]))+a.bandwidth()*o}},{key:"nextQuintileStart",value:function(t,e,n,r,i){return e+1>=n.length||i&&6===n.length&&4===e?this.chartArea(r.margins).width-this.quintileStart(n[e]):this.quintileStart(n[e+1])-this.quintileStart(n[e])}},{key:"showTooltip",value:function(e,n,r,i){var o=e.data,a=e.params,s=this.container.node().getBoundingClientRect(),c=this.svg.node().getBoundingClientRect(),l=Wh[r]+this.xScales[0].bandwidth(),u=i.clientX-s.left+l,d=c.top-s.top+c.height/2,f=("quintiles"===r?t.tooltipQuintileRows:t.tooltipBracketRows).call(this,e,n),h=Object.values(o.metric.brackets).map((function(t){return t[a.allKeyword]})),p={title:{value:"quintiles"===r?t.quintileTitle(n):t.bracketTitle(n,h,a)}};this.tooltip.draw(u,d,p,f,{primaryColour:a.primaryColor,secondaryColour:a.primaryColor},null,"center")}},{key:"highlightBracket",value:function(t){this.svg.select("g.income-bars").selectAll("rect.income-bar-rect").attr("mask","url(#income-mask-bracket-".concat(this.idNumber,"-").concat(t.darkhorse_income,")"))}},{key:"highlightQuintile",value:function(t){var e=this.topSvg.selectAll("g.income-quintile"),n=this.svg.selectAll("g.income-cutoff"),r=this.svg.select("g.income-bars");e.filter((function(n,r){return 6===e.data().length&&5===r?n.darkhorse_quintile===t.darkhorse_quintile||"5"===t.darkhorse_quintile:n.darkhorse_quintile===t.darkhorse_quintile})).style("opacity",null),n.filter((function(e){return Number(e.darkhorse_quintile)===Number(t.darkhorse_quintile)||Number(e.darkhorse_quintile)===Number(t.darkhorse_quintile)+1||"1"===e.top_1_indicator&&"5"===t.darkhorse_quintile})).style("opacity",null),r.selectAll("rect.income-bar-rect").attr("mask","url(#income-mask-quintile-".concat(this.idNumber,"-").concat(t.darkhorse_quintile,")"))}},{key:"unhighlight",value:function(){var t=this.topSvg.selectAll("g.income-quintile"),e=this.svg.selectAll("g.income-cutoff"),n=this.svg.select("g.income-bars");t.style("opacity",.75),e.style("opacity",.75),n.selectAll("rect.income-bar-rect").attr("mask","url(#income-mask-all-".concat(this.idNumber,")"))}},{key:"drawIncomeMasks",value:function(t){var e=this,n=t.data,r=t.params,i=this.svg.select("defs"),o=this.chartArea(r.margins),a=f.a.map(n.metric.brackets,(function(t){return t[r.allKeyword]}));i.select("#income-mask-all-".concat(this.idNumber)).select("rect").attr("width",o.width).attr("height",o.height).attr("fill","rgba(255,255,255,".concat(.75,")"));var s=i.selectAll("mask.income-mask-bracket").data(a,(function(t){return t.darkhorse_income})).join((function(t){var n=t.append("mask").classed("income-mask-bracket",!0).attr("id",(function(t){return"income-mask-bracket-".concat(e.idNumber,"-").concat(t.darkhorse_income)}));return n.append("rect").classed("income-mask-left",!0).attr("fill","rgb(255,255,255,".concat(.75,")")),n.append("rect").classed("income-mask-visible",!0).attr("fill","white"),n.append("rect").classed("income-mask-right",!0).attr("fill","rgb(255,255,255,".concat(.75,")")),n}),(function(t){return t}));s.select("rect.income-mask-left").attr("x",0).attr("y",0).attr("width",(function(t){return e.xAccessor(t)})).attr("height",o.height),s.select("rect.income-mask-visible").attr("x",(function(t){return e.xAccessor(t)})).attr("y",0).attr("width",(function(t){return e.widthAccessor(t)})).attr("height",o.height),s.select("rect.income-mask-right").attr("x",(function(t){return e.xAccessor(t)+e.widthAccessor(t)})).attr("y",0).attr("width",(function(t){return o.width-e.xAccessor(t)-e.widthAccessor(t)})).attr("height",o.height)}},{key:"drawQuintileMasks",value:function(e){var n=this,r=e.data,i=e.params,o=this.svg.select("defs"),a=this.chartArea(i.margins),s=o.selectAll("mask.income-mask-quintile").data(t.quintiles(r),(function(t){return t.darkhorse_quintile})).join((function(t){var e=t.append("mask").classed("income-mask-quintile",!0).attr("id",(function(t){return"income-mask-quintile-".concat(n.idNumber,"-").concat(t.darkhorse_quintile)}));return e.append("rect").classed("income-mask-left",!0).attr("fill","rgb(255,255,255,".concat(.75,")")),e.append("rect").classed("income-mask-visible",!0).attr("fill","white"),e.append("rect").classed("income-mask-right",!0).attr("fill","rgb(255,255,255,".concat(.75,")")),e}),(function(t){return t}));s.select("rect.income-mask-left").attr("x",0).attr("y",0).attr("width",(function(t){return n.quintileStart(t)})).attr("height",a.height),s.select("rect.income-mask-visible").attr("transform",(function(t){return"translate(".concat(n.quintileStart(t),", 0)")})).attr("x",0).attr("y",0).attr("width",(function(t,e){return n.nextQuintileStart(t,e,s.data(),i,!0)})).attr("height",a.height),s.select("rect.income-mask-right").attr("transform",(function(t){return"translate(".concat(n.quintileStart(t),", 0)")})).attr("x",(function(t,e){return n.nextQuintileStart(t,e,s.data(),i,!0)})).attr("y",0).attr("width",(function(t,e){return a.width-n.quintileStart(t)-n.nextQuintileStart(t,e,s.data(),i,!0)})).attr("height",a.height)}},{key:"drawTop",value:function(e){var n=this,r=this.topSvg.select("g.income-top-all"),i=e.data,o=e.params,a=this,s=r.selectAll("g.income-quintile").data(t.quintiles(i),(function(t){return t.darkhorse_quintile})).join((function(t){var e=t.append("g").classed("income-quintile",!0);return e.append("text").classed("quintile-top",!0),e.append("text").classed("quintile-bottom",!0),e.append("line").classed("quintile-underline",!0),e.append("rect").classed("quintile-hover",!0),e}),(function(t){return t})).attr("transform",(function(t){return"translate(".concat(n.quintileStart(t),", 0)")})).style("opacity",.75);s.select(".quintile-top").attr("y",0).attr("dy","1em").style("fill",o.quintileColor).text((function(e){return o.lineBreak?t.quintileText(e).left:t.quintileText(e).combined})),s.select(".quintile-bottom").attr("y",20).attr("dy","1em").style("fill",o.axisTextColor).text((function(e){return o.lineBreak?t.quintileText(e).right:""}));var c=o.lineBreak?40:20;s.select(".quintile-underline").attr("x1",0).attr("y1",c-2).attr("x2",(function(t,e){return n.nextQuintileStart(t,e,s.data(),o)-10})).attr("y2",c-2).style("stroke",o.quintileColor),s.select(".quintile-hover").attr("x",0).attr("y",0).attr("width",(function(t,e){return n.nextQuintileStart(t,e,s.data(),o)-10})).attr("height",c).on("mousemove",f.a.throttle((function(t,n){var r=s.select(".quintile-hover").nodes().indexOf(t.currentTarget);a.highlightQuintile(n,r),a.showTooltip(e,n,"quintiles",t)}),1e3/60,{trailing:!1})).on("mouseout",(function(){n.unhighlight(),n.tooltip.hide()}))}},{key:"drawQuintileLines",value:function(e){var n=this,r=e.data,i=e.params,o=this.svg.select("g.income-cutoffs").attr("transform","translate(".concat(i.margins.left,", 0)")).selectAll("g.income-cutoff").data(t.quintiles(r).filter((function(t){return Object.prototype.hasOwnProperty.call(t,"start_income")})),(function(t){return t.darkhorse_quintile})).join((function(t){var e=t.append("g").classed("income-cutoff",!0);return e.append("text").classed("cutoff-value",!0),e.append("line").classed("cutoff-line",!0),e}),(function(t){return t})).attr("transform",(function(t){return"translate(".concat(n.quintileStart(t),", 0)")})).style("opacity",.75);o.select(".cutoff-value").attr("x",0).attr("y",i.margins.top-5).style("fill",i.quintileColor).style("font-size","".concat(i.cutoffFontSize,"px")).text((function(t){var e=1e3*Math.round(t.start_income/1e3);return Pt({params:Yh(Yh({},i),{},{format:"dollars"})})(e)})),o.select(".cutoff-line").attr("x1",0).attr("y1",i.margins.top).attr("x2",0).attr("y2",i.margins.top+this.yScale.range()[0]).style("stroke",i.quintileColor)}},{key:"drawBars",value:function(t){var e=this,n=t.data,r=t.params,i=this.chartArea(r.margins).height,o=this,a=this.svg.select("g.income-bars"),s=f.a.map(n.metric.brackets,(function(t){return t[r.allKeyword]})),c=a.selectAll("g.income-bar").data(s,(function(t){return t.darkhorse_income})).join((function(t){var e=t.append("g").classed("income-bar",!0);return e.append("rect").classed("income-bar-rect",!0),e.append("rect").classed("income-bar-top",!0),e.append("rect").classed("income-bar-hover",!0),e}),(function(t){return t}));c.selectAll("rect.income-bar-rect").attr("x",(function(t){return e.xAccessor(t)})).attr("y",(function(t){return e.yScale(t.number_families)})).attr("width",(function(t){return e.widthAccessor(t)})).attr("height",(function(t){return i-e.yScale(t.number_families)})).attr("fill",r.primaryColor).attr("mask","url(#income-mask-all-".concat(this.idNumber,")")),c.selectAll("rect.income-bar-top").attr("x",(function(t){return e.xAccessor(t)})).attr("y",(function(t){return e.yScale(t.number_families)})).attr("width",(function(t){return e.widthAccessor(t)})).attr("height",(function(t){return Math.min(i-e.yScale(t.number_families),5)})).attr("fill",r.primaryColor),c.selectAll("rect.income-bar-hover").attr("x",(function(t){return e.xAccessor(t)})).attr("y",0).attr("width",(function(t){return e.widthAccessor(t)})).attr("height",i).on("mousemove",f.a.throttle((function(e,n){o.highlightBracket(n),o.showTooltip(t,n,"brackets",e)}),1e3/60,{trailing:!1})).on("mouseleave",(function(){e.unhighlight(),e.tooltip.hide()}))}},{key:"drawAxes",value:function(e){var n=this,r=e.data,i=e.params,o=this.xScales.range(),a=M()(o,2)[1],s=this.yScale.range(),c=M()(s,2),l=c[0],u=c[1],d=C.axisBottom(this.xScales[1]).tickValues(this.xScales[1].domain().filter((function(t,e){return e%2==0}))).tickFormat((function(t){var e=Nh[t];return void 0===e?"":Pt({params:Yh(Yh({},i),{},{format:"dollars"})})(e)}));this.svg.select(".axis.x").attr("transform","translate(".concat(-this.xScales[1].bandwidth()/2,", ").concat(l-u,")")).call(d).selectAll(".tick text").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor),this.svg.select(".x-label").selectAll("text").data(["Earned income"]).enter().append("text");var h=this.svg.selectAll(".axis.x text, .axis.top-axis text"),p=f.a.maxBy(h.nodes(),(function(t){return t.getBoundingClientRect().x})).getBoundingClientRect().width;this.svg.selectAll(".x-label text").attr("transform","translate(0, ".concat(l-u,")")).attr("x",a+p).attr("y",29).attr("dy","0.32em").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor).text((function(t){return t}));var g=t.totalFamilies({data:r,params:i}),m=[0,.07,.14].map((function(t){return t*g})),y=C.axisLeft(this.yScale).tickValues(m).tickFormat((function(e){var n=Number(e)/t.totalFamilies({data:r,params:i});return Pt({params:Yh(Yh({},i),{},{format:"percent"})})(n,{ticks:m})}));this.svg.select(".axis.y").call(y).selectAll(".tick text").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor),this.svg.select(".y-label").selectAll("text").data(["of families"]).enter().append("text"),this.svg.selectAll(".y-label text").attr("x",-y.tickSizeInner()-y.tickPadding()).attr("y",22).attr("dy","0.32em").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor).text((function(t){return t})),this.svg.select(".top-axis").attr("transform","translate(0, ".concat(l-u,")")).selectAll("text").data(Object.entries(Gh),(function(t){return t[0]})).enter().append("text"),this.svg.selectAll(".top-axis text").attr("x",(function(t){return n.getXScale(t[0])(t[0])})).attr("y",d.tickSizeInner()+d.tickPadding()).attr("dy","0.71em").style("font-size","".concat(i.fontSize,"px")).style("fill",i.axisTextColor).text((function(t){return t[1]}))}}],[{key:"quintiles",value:function(t){return Object.values(t.metric.quintiles)}},{key:"getIncomeBracket",value:function(t){return f()(Nh).entries().sortBy((function(t){var e=M()(t,1)[0];return Number(e)})).findLast((function(e){return M()(e,2)[1]<=t}))[0]}},{key:"totalFamilies",value:function(t){var e=t.data,n=t.params;return f()(e.metric.brackets).map((function(t){return t[n.allKeyword]})).sumBy((function(t){return Number(t.number_families)}))}},{key:"percentTotals",value:function(t,e){var n=t.data,r=t.params;return"quintiles"===e?{taxes:f()(n.metric.quintiles).values().filter((function(t){return"1"!==t.top_1_indicator})).sumBy((function(t){return Number(t.aggr_taxes_total)})),assistance:f()(n.metric.quintiles).values().filter((function(t){return"1"!==t.top_1_indicator})).sumBy((function(t){return Number(t.aggr_income_transfers)}))}:{taxes:f()(n.metric.brackets).values().sumBy((function(t){return Number(t[r.allKeyword].aggr_taxes_total)})),assistance:f()(n.metric.brackets).values().sumBy((function(t){return Number(t[r.allKeyword].aggr_income_transfers)}))}}},{key:"tooltipQuintileRows",value:function(e,n){var r=e.params,i=t.percentTotals(e,"quintiles"),o=i.taxes,a=i.assistance,s=Pt({params:Yh(Yh({},r),{},{format:"percent"})}),c=Pt({params:Yh(Yh({},r),{},{format:"dollars"})}),l=Number(n.aggr_taxes_total/o),u='Pay <span style="color: '.concat(r.primaryColor,'">').concat(s(l),"</span> of all US tax revenue"),d=Number(n.aggr_income_transfers/a),f='Receive <span style="color: '.concat(r.primaryColor,'">').concat(s(d),"</span> of all US gov't assistance");return[{type:"breakdown",key:"Average income",value:c(n.avg_income_market),breakdown:[{key:"avg taxes",value:c(n.avg_taxes_total),sign:"-"},{key:"avg assistance",value:c(n.avg_income_transfers),sign:"+"}]},{type:"value",html:!0,key:"taxes",value:u},{type:"bar",key:"taxes-bar",value:l},{type:"value",html:!0,key:"assistance",value:f},{type:"bar",key:"assistance-bar",value:d}]}},{key:"tooltipBracketRows",value:function(e,n){var r=e.params,i=Pt({params:Yh(Yh({},r),{},{format:"percent"})}),o=t.totalFamilies(e);return[{type:"value",key:"percent",value:i(n.number_families/o),styles:{"font-size":"24px"}},{type:"value",key:"extraText",value:"of all families",styles:{color:null,"font-size":"16px","font-weight":"normal","white-space":"nowrap"}}]}},{key:"quintileTitle",value:function(t){var e="1"===t.top_1_indicator?"1":"20";return"".concat(Jh[t.darkhorse_quintile]," ").concat(e,"% of US earners")}},{key:"bracketTitle",value:function(t,e,n){var r=Pt({params:Yh(Yh({},n),{},{format:"dollars"})});if(0===t.darkhorse_income)return"<$0";var i=r(Nh[t.darkhorse_income]);if(e.findIndex((function(e){return e.darkhorse_income===t.darkhorse_income}))+1>=e.length)return"".concat(i,"+");var o=e[e.findIndex((function(e){return e.darkhorse_income===t.darkhorse_income}))+1];return"".concat(r(Nh[t.darkhorse_income])," - ").concat(r(Nh[o.darkhorse_income])," income")}},{key:"quintileText",value:function(t){var e=Jh[t.darkhorse_quintile],n=1===Number(t.top_1_indicator)?"1%":"20%".concat("5"===t.darkhorse_quintile?" of US earners":"");return{left:e,right:n,combined:"".concat(e," ").concat(n)}}}]),t}(),Hh=["hideAxisLabels","hideGridlines","showZeroLine","primaryColor","axisTextColor","gridColor","positiveColour","negativeColour","selectedDates","transition","transitionDuration","yDomain","xValues","yValues","heightToWidthRatio","xTickFormat","hideTitle","showSourcesAndFootnotes"];function Vh(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Zh(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Vh(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Vh(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function Xh(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var _h={months:C.utcMonth,monthly:C.utcMonth,quarters:C.utcMonth.every(3),quarterly:C.utcMonth.every(3),days:C.utcDay,daily:C.utcDay,weeks:C.utcDay.every(7),weekly:C.utcDay.every(7),years:C.utcYear,yearly:C.utcYear},$h=function(t){Q()(o,t);var e,n,r=Xh(o);function o(t,e,n,i){var s;return a()(this,o),(s=r.call(this)).chartType=m.TimeBarChart,s.cssPrefix=i||"time-bar-chart",s.container=t,s.drawCanvas=void 0,s.initialDraw=!0,s.yTicks=4,s.xTicks=8,s.width=e||1e3,s.height=n||500,s.margins={top:20,bottom:50,left:10,right:10,minRightLabel:0,maxRightLabelRatio:void 0},s.title=t.append("div").classed("chart-title",!0),s.subtitle=t.append("div").classed("chart-subtitle",!0),s.svg=t.classed(s.cssPrefix,!0).classed("dh-chart-wrapper",!0).append("svg").classed(s.cssPrefix,!0).attr("viewBox","0 0 ".concat(s.width," ").concat(s.height)),s.sourceContainer=s.container.append("div"),s.sources=new en(s.sourceContainer),s.tooltip=new nn(t),s.initGroups(),s.ro=new _t.a((function(t){t.forEach((function(t){requestAnimationFrame((function(){s.resizeContent(t.contentRect)}))}))})),s.ro.observe(t.node()),s}return c()(o,[{key:"initGroups",value:function(){this.defs=this.svg.append("defs"),this.svg.append("g").classed("axis",!0).classed("y",!0),this.svg.append("g").classed("axis",!0).classed("x",!0),this.svg.append("g").classed("axis",!0).classed("".concat(this.cssPrefix,"-xline"),!0);var t=this.svg.append("g").classed("".concat(this.cssPrefix,"-chart"),!0);t.append("rect").classed("".concat(this.cssPrefix,"-touch-area"),!0),t.append("g").classed("".concat(this.cssPrefix,"-bars"),!0),t.append("g").classed("".concat(this.cssPrefix,"-hover"),!0),Ze.call(this)}},{key:"data",value:(n=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return i=r.data,o=r.parent,a=n.startDate||n.startYear,s=n.endDate||n.endYear,c=Zh(Zh({},i[0]),{},{metric:Zh(Zh({},i[0].metric),{},{data:i[0].metric.data.filter((function(t){var e=t.key,n=t.value;return!(null==n||a&&e<St(a,i[0].metric.xType)||s&&e>St(s,i[0].metric.xType))}))})}),t.abrupt("return",{data:c,parent:o});case 10:case"end":return t.stop()}}),t,this)}))),function(t,e){return n.apply(this,arguments)})},{key:"getDrawParams",value:function(t){var e=t.data,n=t.parent,r=t.options,i=r.hideAxisLabels,o=void 0!==i&&i,a=r.hideGridlines,s=void 0!==a&&a,c=r.showZeroLine,l=void 0!==c&&c,u=r.primaryColor,d=void 0===u?et.chartcolourdefault0:u,f=r.axisTextColor,h=void 0===f?null:f,p=r.gridColor,g=void 0===p?null:p,m=r.positiveColour,y=void 0===m?null:m,v=r.negativeColour,b=void 0===v?null:v,k=r.selectedDates,x=void 0===k?[]:k,A=r.transition,S=void 0!==A&&A,O=r.transitionDuration,E=void 0===O?1e3:O,M=r.yDomain,C=void 0===M?null:M,R=r.xValues,j=void 0===R?null:R,I=r.yValues,B=void 0===I?null:I,D=r.heightToWidthRatio,T=void 0===D?null:D,F=r.xTickFormat,P=void 0===F?null:F,z=r.hideTitle,Q=void 0!==z&&z,L=r.showSourcesAndFootnotes,Y=void 0===L||L,W=w()(r,Hh);return Zh(Zh({},Qt({data:[e],parent:n,options:W},this.margins)),{},{hideAxisLabels:o,hideGridlines:s,showZeroLine:l,primaryColor:d,axisTextColor:h,gridColor:g,positiveColour:y,negativeColour:b,selectedDates:x,transition:S,transitionDuration:E,yDomain:C,xValues:j,yValues:B,heightToWidthRatio:T,xTickFormat:P,hideTitle:Q,showSourcesAndFootnotes:Y})}},{key:"createYScale",value:function(t){var e=t.data,n=t.params,r=n.yDomain,i=n.margins,o=e.metric.data.map((function(t){var e=t.value;return Number(e)})),a=[Math.min(0,f.a.min(o)),Math.max(0,f.a.max(o))];return C.scaleLinear().domain(r||a).range([this.height-i.bottom,i.top]).nice(this.yTicks)}},{key:"yAxisOffset",value:function(t,e,n){var r=t.params,i=r.margins,o=r.hideAxisLabels,a=function(t,e,n){var r=Object(R.createCanvas)(300,300).getContext("2d");r.font="".concat(n,"px ").concat(nt);var i=Pt(t);return f.a.max(e.map((function(t){return r.measureText(i(t)).width})))}(t,e.ticks(this.yTicks),n),s=void 0===i.fixedAxis?a:parseFloat(i.fixedAxis);return!0===o||"y"===o?0:s}},{key:"createXScale",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,r=t.data,i=t.params,o=i.margins,a=i.fontSize,s=this.width-o.right-10,c=f.a.map(r.metric.data,"key"),l=r.metric.xType?_h[r.metric.xType.toLowerCase()]:C.utcYear,u=l.floor(f.a.max(c)),d=l.range(l.floor(f.a.min(c)),u);return d.push(u),C.scaleBand().paddingOuter(.1).paddingInner(.2).domain(d).range([o.left+this.yAxisOffset(t,e,a)+n,s])}},{key:"createScales",value:function(t){var e=this.createYScale(t);return{xScale:this.createXScale(t,e),yScale:e}}},{key:"resizeContent",value:function(t){var e=t.width,n=t.height;!this.cachedParams||this.width===e&&this.height===n||this.drawContent(this.cachedParams,!1)}},{key:"xAccessor",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return e?this.xScale(t.key):this.xScale(t.key)-(this.xScale.step()-this.xScale.bandwidth())/2}},{key:"heightAccessor",value:function(t){return Math.abs(this.yScale(t.value)-this.yScale(0))}},{key:"yAccessor",value:function(t){return t.value>=0?this.yScale(t.value):this.yScale(0)}},{key:"widthAccessor",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return t?this.xScale.bandwidth():this.xScale.step()}},{key:"posNegColours",value:function(t,e){return this.yAccessor(e)===this.yScale(0)?t.negativeColour:t.positiveColour}},{key:"entryColour",value:function(t,e,n){var r=t.primaryColor||(this.hasPosNegColours?this.posNegColours(e,t):Lt(t,0,e));if(e.selectedDates.length>0){var i=e.selectedDates.map((function(t){return St(t,n).getTime()}));return f.a.includes(i,t.key.getTime())?r:et.chartcolourgrey}return r}},{key:"setHovered",value:function(t){var e=this;this.cachedParams&&this.svg.select("g.".concat(this.cssPrefix,"-bars")).selectAll("g.".concat(this.cssPrefix,"-entry")).style("opacity",(function(n){return o.entryOpacity(n,e.cachedParams,t)})).selectAll("rect").classed("bar-hovered",(function(e){return t&&e.key.getTime()===t.getTime()}))}},{key:"areaHeight",value:function(){return Math.max(0,this.yScale.range()[0]+10)}},{key:"draw",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=c.length>1&&void 0!==c[1]?c[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=7;break}return this.trigger("dataLoaded",!1),t.abrupt("return",!1);case 7:return i=r.data,o=r.parent,a=this.getDrawParams({data:i,parent:o,options:n}),this.hasPosNegColours=null!==a.positiveColour&&null!==a.negativeColour,s={data:i,parent:o,params:a},this.drawContent(s),this.trigger("finishDraw"),this.trigger("dataLoaded",!0),t.abrupt("return",!0);case 15:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})},{key:"drawContent",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.cachedParams=t,this.width=this.container.node().getBoundingClientRect().width;var r=t.data,i=t.params,o=null!=n?n:i.transition;if("top"===i.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node()),this.container.node().insertBefore(this.subtitle.node(),this.svg.node())):"bottom"===i.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node())),i.hideTitle||Nt.call(this,this.title,this.subtitle,t),i.showSourcesAndFootnotes?(this.sources.draw([r]),this.container.node().append(this.sourceContainer.node())):this.sourceContainer.style("display","none"),i.heightToWidthRatio)this.height=i.heightToWidthRatio*this.width;else{var a=this.title.node().getBoundingClientRect(),s=a.height,c=this.subtitle.node().getBoundingClientRect(),l=c.height,u=this.container.node().getBoundingClientRect(),d=u.height,f=this.sourceContainer.node().getBoundingClientRect(),h=f.height;this.height=d-s-l-h}C.select(this.svg.node()).attr("viewBox","0 0 ".concat(this.width," ").concat(this.height));var p=this.xScale?this.xScale.domain():null,g=this.createScales({data:r,params:i}),m=g.xScale,y=g.yScale;this.xScale=m,this.yScale=y;var v=this.xScale.domain(),b=JSON.stringify(p)!==JSON.stringify(v),k=this.newDefsID();this.drawEntries(t,b,o),this.drawAxisMask(k),this.drawAxes(t,m,y,k,b,o),this.svg.select(".".concat(this.cssPrefix,"-touch-area")).attr("x",0).attr("y",0).attr("width",this.width).attr("height",this.areaHeight()).on("click",(function(){"ontouchstart"in window&&e.tooltip.hide()})),i.info&&"chart"===i.info.position&&T.inChart(this.container,i),this.initialDraw=!1}},{key:"createXAxis",value:function(t,e,n){var r=t.data,i=t.params,o=i.xValues,a=i.xTickFormat,s=i.transition,c=f.a.uniqBy(r.metric.data,(function(t){return t.key.getTime()})).map((function(t){return t.key})),l=c;["yearly","years"].includes(r.metric.xType)?(l=C.utcYear.range(C.min(c),C.max(c))).push(C.max(c)):["monthly","months"].includes(r.metric.xType)?(l=C.utcMonth.range(C.min(c),C.max(c))).push(C.max(c)):["weekly","weeks"].includes(r.metric.xType)?(l=C.utcWeek.range(C.min(c),C.max(c))).push(C.max(c)):["daily","days"].includes(r.metric.xType)&&(l=C.utcDay.range(C.min(c),C.max(c))).push(C.max(c));var u=n.range(),d=M()(u,1)[0],h=C.axisBottom(e).tickSize(0);o?h.tickValues(o.filter((function(t){return void 0!==e(t)}))):h.tickValues(function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"years",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10;if(t.length<n)return t;var r=e.toLowerCase();if("months"===r||"monthly"===r)return Ut(t,n);if("quarters"===r||"quarterly"===r)return Ut(t,n,1);if("days"===r||"daily"===r){var i=f.a.clone(t);return(i=i.filter((function(t,e){return e%7==0}))).length<=n?i:((i=C.utcMonth.range(C.utcMonth.floor(f.a.min(t)),C.utcMonth.floor(f.a.max(t)))).push(C.utcMonth.floor(f.a.max(t))),i[0].getTime()!==t[0].getTime()&&(i=i.slice(1)),i.length<=n?i:Ut(i,n))}return Ut(t,n,2)}(l,r.metric.xType,this.xTicks)),a?h.tickFormat(a):h.tickFormat(C.scaleUtc().tickFormat());var p=d+10,g=this.svg.select(".axis.x");return!this.initialDraw&&s?g.transition(Hf(i)).attr("transform","translate(0, ".concat(p,")")).call(h):g.attr("transform","translate(0, ".concat(p,")")).call(h),g}},{key:"createYAxis",value:function(t,e,n,r){var i=this,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4],a=t.params,s=t.params.yValues,c=e.range(),l=M()(c,2),u=l[0],d=l[1],f=C.axisLeft(n).tickSize(u-d).tickPadding(10);s?f.tickValues(s):f.ticks(this.yTicks).tickFormat((function(e){return Pt(t)(e,{ticks:n.ticks(i.yTicks)})}));var h=this.svg.select(".axis.y"),p=r?Vf:Hf;return!this.initialDraw&&o?h.transition(p(a)).call(f):h.call(f),h}},{key:"newDefsID",value:function(){for(var t=0,e="".concat(this.cssPrefix,"-mask-").concat(t),n=C.select("#".concat(e));!n.empty()&&t<1e3;)t+=1,e="".concat(this.cssPrefix,"-mask-").concat(t),n=C.select("#".concat(e));return e}},{key:"drawAxisMask",value:function(t){var e=this.defs.select("mask");e.empty()&&(e=this.defs.append("mask")).append("rect"),e.attr("id",t).select("rect").attr("x",-100).attr("y",0).attr("width",this.width+100).attr("height",this.areaHeight()).attr("fill","white")}},{key:"drawAxes",value:function(t,e,n,r,i){var o=arguments.length>5&&void 0!==arguments[5]&&arguments[5],a=t.params,s=a.hideGridlines,c=a.showZeroLine,l=a.hideAxisLabels,u=a.axisTextColor,d=a.gridColor,f=a.fontSize,h=e.range(),p=M()(h,2),g=p[0],m=p[1],y=m-g;this.xTicks=y>760?8:y>400?4:y>180?3:2,this.height>300?this.yTicks=4:this.yTicks=3;var v=this.createXAxis(t,e,n);v.selectAll(".tick text").style("display",!0===l||"x"===l?"none":null).style("fill",u).style("font-size","".concat(f,"px"));var b=this.createYAxis(t,e,n,i,o);return b.attr("mask","url(#".concat(r,")")).selectAll(".tick line").classed("bold",(function(t){return!n.domain().includes(0)&&0===t})).classed("zero-line",(function(t){return 0===t})).style("display",(function(t){return c&&0===t?null:s?"none":null})).style("stroke",d),b.selectAll(".tick text").style("fill",u).style("display",!0===l||"y"===l?"none":null).style("font-size","".concat(f,"px")),this.svg.select(".axis.y").attr("transform","translate(".concat(g,", 0)")),{xAxis:v,yAxis:b}}},{key:"drawEntries",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=t.data,a=t.params,s=this.svg.select("g.".concat(this.cssPrefix,"-chart")),c=s.select("g.".concat(this.cssPrefix,"-bars")),l=s.select("g.".concat(this.cssPrefix,"-hover")),u=function(e){e.on("mousemove",f.a.throttle((function(e,r){n.showTooltip(t,r,n.tooltipColour(r,a)),n.setHovered(r.key),n.trigger("hover",r),n.trigger("point",r)}),1e3/60,{trailing:!1})).on("mouseout",(function(){n.tooltip.hide(),n.setHovered(),n.trigger("mouseout"),n.trigger("point",null)})).on("click",(function(t,e){n.trigger("click",e)}))},d=c.selectAll("g.".concat(this.cssPrefix,"-entry")).data(i.metric.data,(function(t){return t.key.getTime()})),h=d.enter().append("g").classed("".concat(this.cssPrefix,"-entry"),!0).style("opacity",(function(e){return o.entryOpacity(e,t)})),p=d.exit(),g={enter:h,update:d,exit:p};this.drawEntryRects(t,g,e,r);var m=l.selectAll("g.".concat(this.cssPrefix,"-hover-bar")).data(i.metric.data,(function(t){return t.key.getTime()})).call(u),y=m.enter().append("g").classed("".concat(this.cssPrefix,"-hover-bar"),!0).call(u),v=m.exit(),b={enter:y,update:m,exit:v};this.drawEntryRects(t,b,e,r,(function(){return 0}),(function(){return n.areaHeight()}),!1),r&&!this.initialDraw?(d.transition(Hf(a)).style("opacity",(function(e){return o.entryOpacity(e,t)})),p.transition(Hf(a)).remove()):(d.style("opacity",(function(e){return o.entryOpacity(e,t)})),p.remove()),v.remove(),c.selectAll("g.".concat(this.cssPrefix,"-entry")).style("cursor",this.hasAction("click")?"pointer":null)}},{key:"drawEntryRects",value:function(t,e,n){var r=this,i=t.data,o=t.params,a=e.enter,s=e.update,c=e.exit,l=arguments.length>3&&void 0!==arguments[3]&&arguments[3],u=arguments.length>4&&void 0!==arguments[4]?arguments[4]:this.yAccessor,d=arguments.length>5&&void 0!==arguments[5]?arguments[5]:this.heightAccessor,f=!(arguments.length>6&&void 0!==arguments[6])||arguments[6];a.append("rect").classed("entry-rect",!0);var h=s.select(".entry-rect"),p=a.select(".entry-rect"),g=c.select(".entry-rect"),m=function(t){t.attr("width",r.widthAccessor(f)).attr("height",(function(t){return d.call(r,t)})).attr("fill",(function(t){return r.entryColour(t,o,i.metric.xType)})).attr("x",(function(t){return r.xAccessor(t,f)})).attr("y",(function(t){return u.call(r,t)})).style("opacity",0)},y=function(t){t.attr("x",(function(t){return r.xAccessor(t,f)})).attr("width",r.widthAccessor(f)).style("opacity",1)},v=function(t){t.attr("y",(function(t){return u.call(r,t)})).attr("height",(function(t){return d.call(r,t)}))},b=function(t){t.call(y).call(v)},k=n?Vf:Hf;l&&!this.initialDraw?(p.call(m).transition(k(o)).call(Uf),h.attr("fill",(function(t){return r.entryColour(t,o,i.metric.xType)})),n?h.transition(Hf(o)).call(y).transition(Hf(o)).call(v):h.transition(Hf(o)).call(b),g.transition(Hf(o)).call(Kf)):(p.call(m).call(Uf),h.attr("fill",(function(t){return r.entryColour(t,o,i.metric.xType)})).call(b)),p.merge(h).style("shape-rendering",this.xScale.step()-this.xScale.bandwidth()>=1?"crispEdges":null)}},{key:"tooltipColour",value:function(t,e){return this.hasPosNegColours?this.posNegColours(e,t):Yt(e,t)}},{key:"showTooltip",value:function(t,e,n){var r,i=t.data,o=this.container.node().getBoundingClientRect(),a=this.svg.node().getBoundingClientRect(),s=e.value;if(null!=s){var c=this.xAccessor(e)+this.xScale.bandwidth()/2,l=a.top-o.top+this.yAccessor(e),u=(i.metric.lexiconName||i.metric.name)+(i.metric.geo_id&&"US"!==i.metric.geo_id?" in ".concat(i.metric.geo_name):""),d=Ft(Zh(Zh({},t),{},{data:[i]})),f={title:{value:null!==(r=i.tooltipTitle)&&void 0!==r?r:u},subtitle:{value:Ot(e.key,i.metric.xType)}};this.tooltip.draw(c,l,f,[{type:"value",value:d(s)}],{primaryColour:n})}}}],[{key:"entryOpacity",value:function(t,e,n){var r=e.data,i=e.params;if(!i.selectedDates||0===i.selectedDates.length)return 1;var o=r.metric.xType,a=i.selectedDates.map((function(t){return St(t,o).getTime()}));return f.a.includes(a,t.key.getTime())||n&&t.key.getTime()===n.getTime()?1:.4}}]),o}(rn),tp=["selectedStates","vertical","tooltipOptions","domain","hideDropdown","selectableDropdowns","hideTitle","transitionDuration"];function ep(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}function np(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function rp(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?np(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):np(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function ip(t,e){var n,r=this,i=t.metric,o=t.x,a=t.y,s=t.primaryColor,c=t.tooltipTitle,l=e.params.tooltipOptions.customTooltip,u=this.container.node().getBoundingClientRect(),d=this.svg.node().getBoundingClientRect(),h=Lt({primaryColor:s},0,e),p={};if(void 0!==l)n=[{type:"value",value:l(t,St(this.dropdownSelected,i.xType)),html:!0}];else{var g=function(t,e,n){return null==e?"N/A":t(e,n)}(Ft(e),f.a.find(i.data,(function(t){return t.key.getTime()===St(r.dropdownSelected,i.xType).getTime()})).value);p={title:{value:null!=c?c:i.geo_name},subtitle:{value:this.dropdownSelected}},n=[{type:"value",value:g}]}this.tooltip.draw(o-u.left+d.left,a-u.top+d.top,p,n,{primaryColour:h},4)}function op(t){var e=this;this.cachedParams=t,this.height=this.container.node().getBoundingClientRect().height;var n=t.params,r=n.margins,i=n.vertical,o=n.info,a=n.hideYear,s=n.hideTitle,c=n.domain;this.container.classed("vertical",i);var l=t.data,u=t.params,d=function(t,e,n,r){var i=r.domain,o=r.reverse,a=f()(t).map("metric").flatMap((function(t){return t.data.map((function(e){return rp(rp({},e),{},{type:t.xType})}))})).filter((function(t){var n=t.key,r=t.type;return n.getTime()===St(e,r).getTime()})).map("value").value(),s=i||[f.a.min(a),f.a.max(a)];return C.scaleLinear(o?f.a.reverse(f.a.clone(s)):s,[20,n-20]).nice()}(l,this.dropdownSelected,i?this.height:this.width,{domain:c,reverse:i}),h=function(t){var n=t.metric;return(f.a.find(n.data,(function(t){return t.key.getTime()===St(e.dropdownSelected,n.xType).getTime()}))||{}).value},p=function(t){var e=t.metric;return d(h({metric:e}))},g=function(){return i?(r.left+e.width-r.right)/2:e.height/2};l=f.a.map(l,(function(t){return rp(rp({},t),{},{x:i?e.width:p,vx:0,y:i?p:g,vy:0})})),C.forceSimulation(l).force("x",C.forceX().strength((function(t){return i?.045:Math.max(1/(1+Math.pow(Math.abs(h(t)),3)),.2)})).x(i?g:p)).force("y",C.forceY().strength((function(t){return i?Math.max(1/(1+Math.pow(Math.abs(h(t)),3)),.2):.06})).y(i?p:g)).force("collision",C.forceCollide().radius((function(t){var e=t.ratioToMaxSize,n=void 0===e?1:e;return 20*Math.sqrt(n)+2}))).stop().tick(300),this.outlines.selectAll("circle").data(l).join((function(t){return t.append("circle").attr("cx",(function(t){return t.x})).attr("cy",(function(t){return t.y})).attr("r",0)})).style("display",(function(t){var e=t.fips;return f.a.includes(u.selectedStates,e)?null:"none"})).attr("fill","white").attr("stroke","black").attr("stroke-width",1).transition().duration(u.transitionDuration).attr("cx",(function(t){return t.x})).attr("cy",(function(t){return t.y})).attr("r",(function(t){var e=t.ratioToMaxSize,n=void 0===e?1:e;return 20*Math.sqrt(n)+1.5})),this.circles.selectAll("circle").data(l).join((function(t){return t.append("circle").attr("cx",(function(t){return t.x})).attr("cy",(function(t){return t.y})).attr("r",0)})).attr("fill",(function(t){return Lt(t,0,u)})).transition().duration(u.transitionDuration).attr("cx",(function(t){return t.x})).attr("cy",(function(t){return t.y})).attr("r",(function(t){var e=t.ratioToMaxSize,n=void 0===e?1:e;return 20*Math.sqrt(n)})),this.circles.selectAll("circle").on("mousemove",f.a.throttle((function(n,r){ip.call(e,r,t),n.stopPropagation()}),1e3/60,{trailing:!1})).on("click",(function(t,n){e.trigger("circleClicked",n),t.stopPropagation()})).on("mouseout",(function(){e.tooltip.hide()})),this.labels.selectAll("text").data(l).join((function(t){return t.append("text").attr("x",(function(t){return t.x})).attr("y",(function(t){return t.y})).attr("opacity",0)})).attr("fill",(function(t){return vs()(Lt(t,0,u)).isDark()?"white":"black"})).transition().duration(u.transitionDuration).attr("opacity",1).attr("x",(function(t){return t.x})).attr("y",(function(t){return t.y})).attr("dy","0.35em").text((function(t){var e=t.labelText;return void 0===e?"":e})),s||Nt.call(this,this.title,this.subtitle,t,a?null:this.dropdownSelected),function(t,e,n,r){var i=t.params,o=i.vertical,a=i.axisValues,s=i.margins,c=s.bottom,l=s.left;n.selectAll("*").remove();var u=o?C.axisLeft(e):C.axisBottom(e);u.tickSizeOuter(0).tickFormat(Pt(t)),a&&u.tickValues(a),n.style("transform",o?"translateX(".concat(l,"px)"):"translateY(".concat(r-c,"px)")),n.call(u)}(t,d,this.axis,this.height),this.trigger("updatedScale",d),o&&"chart"===o.position&&T.inChart(this.container,{info:o})}var ap=function(t){Q()(o,t);var e,n,r=ep(o);function o(t){var e;if(a()(this,o),(e=r.call(this)).chartType=m.Beeswarm,e.cssPrefix="beeswarm",e.dropdownSelected=null,e.margins={top:20,bottom:20,left:40,right:20},e.width=960,e.container=t,void 0===e.container)return e.draw=e.drawCanvas,Vt()(e);var n=function(t){var e=t.append("div").classed("chart-title",!0),n=t.append("div").classed("chart-subtitle",!0),r=t.classed("beeswarm",!0).classed("dh-chart-wrapper",!0).append("svg"),i=r.append("g").classed("outlines",!0),o=r.append("g").classed("circles",!0),a=r.append("g").classed("labels",!0),s=r.append("g").classed("axis",!0);return{title:e,subtitle:n,svg:r,outlines:i,circles:o,labels:a,axis:s}}(t);return e.title=n.title,e.subtitle=n.subtitle,e.svg=n.svg,e.outlines=n.outlines,e.circles=n.circles,e.labels=n.labels,e.axis=n.axis,e.hoveredArea=null,e.tooltip=new nn(t),e.svg.on("click",(function(){return e.tooltip.hide()})),Ze.call(kh()(e)),e.ro=new _t.a((function(t){t.forEach((function(t){var n=t.contentRect,r=n.width,i=n.height;requestAnimationFrame((function(){e.width=r,e.height=i,e.redrawContent()}))}))})),e.ro.observe(t.node()),e}return c()(o,[{key:"setDropdownSelected",value:function(t){this.dropdownSelected=t}},{key:"redrawContent",value:function(){this.cachedParams&&op.call(this,this.cachedParams)}},{key:"data",value:(n=i()(u.a.mark((function t(e,n){var r,i,o,a,s,c,l,d;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Xe.call(this,e);case 2:if(r=t.sent){t.next=5;break}return t.abrupt("return",null);case 5:return i=r.data,o=r.parent,a=n.startDate||n.startYear,s=n.endDate||n.endYear,c=!0,l=f()(i).flatMap((function(t){return t.metric.data.map((function(e){var n=e.key;return t.metric.xType&&"items"===t.metric.xType.toLowerCase()&&(c=!1),{key:n,xType:t.metric.xType}}))})).filter((function(t){return!((!t.xType||"items"!==t.xType.toLowerCase())&&(a&&t.key.getTime()<St(a,t.xType).getTime()||s&&t.key.getTime()>St(s,t.xType).getTime()))})).map((function(t){return Ot(t.key,t.xType)})).uniq().value(),d=n.selectedDropdown||n.selectedYear,null!==this.dropdownSelected&&l.includes(this.dropdownSelected)||(void 0!==d&&l.includes(d.toString())?this.dropdownSelected=d:this.dropdownSelected=c?f.a.maxBy(l,(function(t){return new Date(t)})):f.a.first(l)),n.forceYear&&l.includes(n.forceYear.toString())&&(this.dropdownSelected=n.forceYear),t.abrupt("return",{data:i,parent:o,keys:l});case 14:case"end":return t.stop()}}),t,this)}))),function(t,e){return n.apply(this,arguments)})},{key:"getDrawParams",value:function(t){var e=t.data,n=t.parent,r=t.options,i=r.selectedStates,o=void 0===i?[]:i,a=r.vertical,s=void 0!==a&&a,c=r.tooltipOptions,l=(c=void 0===c?{}:c).customTooltip,u=void 0===l?void 0:l,d=r.domain,f=void 0===d?void 0:d,h=r.hideDropdown,p=void 0!==h&&h,g=r.selectableDropdowns,m=void 0===g||g,y=r.hideTitle,v=void 0!==y&&y,b=r.transitionDuration,k=void 0===b?500:b,x=w()(r,tp);return rp(rp({},Qt({data:e,parent:n,options:x},this.margins)),{},{selectedStates:o,vertical:s,tooltipOptions:{customTooltip:u},domain:f,hideDropdown:p,selectableDropdowns:m,hideTitle:v,transitionDuration:k})}},{key:"draw",value:(e=i()(u.a.mark((function t(e){var n,r,i,o,a,s,c,l=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=l.length>1&&void 0!==l[1]?l[1]:{},t.next=3,this.data(e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",!1);case 6:return i=r.data,o=r.parent,a=r.keys,(s=this.getDrawParams({data:i,parent:o,options:n})).selectableYears=!Object.prototype.hasOwnProperty.call(n,"selectableYears")||n.selectableYears,c={data:i,parent:o,params:s,keys:a},"top"===s.titleVerticalPosition?(this.title.classed("below",!1),this.container.node().insertBefore(this.title.node(),this.svg.node()),this.container.node().insertBefore(this.subtitle.node(),this.svg.node())):"bottom"===s.titleVerticalPosition&&(this.title.classed("below",!0),this.container.node().append(this.title.node()),this.container.node().append(this.subtitle.node())),op.call(this,c),t.abrupt("return",!0);case 13:case"end":return t.stop()}}),t,this)}))),function(t){return e.apply(this,arguments)})}]),o}(rn);function sp(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function cp(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?sp(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):sp(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var lp=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:r=t.sent,i=r.map((function(t){var e=t.color,n=t.metric;return cp(cp({},n),{},{color:e,data:n.data.map((function(t){var e=t.key,r=t.value;return{key:Ot(e,n.x_type),value:r}}))})})),p.a.render(pn.a.createElement(nd,cp(cp({},n),{},{data:i})),this.container.node());case 5:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}],[{key:"drawCanvas",value:function(){}}]),t}();function up(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function dp(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?up(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):up(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var fp=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:r=t.sent,i=r.map((function(t){var e=t.color,n=t.metric;return dp(dp({},n),{},{color:e,data:n.data.map((function(t){var e=t.key,r=t.value;return{key:Ot(e,n.x_type),value:r}}))})})),p.a.render(pn.a.createElement(Ro,dp(dp({},n),{},{data:i})),this.container.node());case 5:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}],[{key:"drawCanvas",value:function(){}}]),t}(),hp=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:p.a.render(pn.a.createElement(ea,n),this.container.node());case 1:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}],[{key:"drawCanvas",value:function(){}}]),t}();function pp(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function gp(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?pp(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):pp(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var mp=function(){function t(e){a()(this,t),this.container=e}var e;return c()(t,[{key:"draw",value:(e=i()(u.a.mark((function t(e,n){var r,i;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.data;case 2:r=t.sent,i=r.map((function(t){var e=t.color,n=t.metric;return gp(gp({},n),{},{color:e,data:n.data.map((function(t){var e=t.key,r=t.value;return{key:Ot(e,n.x_type),value:r}}))})})),p.a.render(pn.a.createElement(Yc,gp(gp({},n),{},{data:i})),this.container.node());case 5:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})}],[{key:"drawCanvas",value:function(){}}]),t}(),yp=n(48),vp=n.n(yp),bp=n(32),kp=n.n(bp);function wp(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var xp=function(t){Q()(n,t);var e=wp(n);function n(t,r){var i;return a()(this,n),(i=e.call(this,t)).name="StoreError",i.metric=r,i}return n}(kp()(Error));function Ap(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r=Xt()(t);if(e){var i=Xt()(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Vt()(this,n)}}var Sp=function(t){Q()(n,t);var e=Ap(n);function n(t){var r;return a()(this,n),(r=e.call(this,t)).name="StoreRetryError",r}return n}(kp()(Error));function Op(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Ep(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Op(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Op(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var Mp=function(){function t(e){a()(this,t),this.datasets={},this.modifier=e||function(t){return t}}var e,n,r;return c()(t,[{key:"has",value:function(t){return!!t&&!(!this.datasets||!Object.prototype.hasOwnProperty.call(this.datasets,t)||!this.datasets[t].resolved)}},{key:"load",value:(r=i()(u.a.mark((function e(n,r,i){var o,a,s,c,l,d=this;return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:o=f()(n).flatten().partition((function(t){return Object.prototype.hasOwnProperty.call(t,"states")||!0===t.allStates})).value(),a=M()(o,2),s=a[0],c=a[1],l=f.a.groupBy(c,(function(e){return t.getMetricURLBase(e,i)})),Object.keys(l).forEach((function(e){var n=l[e].filter((function(e){return!d.has(t.datasetID(e,r))}));if(n.length>0){var i=n.map((function(t){return t.id})),o="".concat(e,"?Ids=").concat(i.join());r&&(o+="&Adjustment=".concat(r||""));var a=t.fetch(o);n.forEach((function(e){var n=a.then((function(n){var i=[n].flat().find((function(t){return t.id==e.id})),o=d.modifier(i);if(t.checkMetricValid(o))return Ct(o);var a=new xp("[RESTStore] ".concat(t.datasetID(e,r)," has empty data"),i);return Promise.reject(a)}));n.resolved=!0,d.datasets[t.datasetID(e,r)]=n}))}})),this.loadStates(s,r,i);case 4:case"end":return e.stop()}}),e,this)}))),function(t,e,n){return r.apply(this,arguments)})},{key:"loadStates",value:(n=i()(u.a.mark((function e(n,r,i){var o,a=this;return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:o=f.a.groupBy(n,(function(e){return t.getMetricURLBase(e,i)})),Object.keys(o).forEach((function(e){var n=f.a.groupBy(o[e],"id");f.a.forEach(n,(function(n,i){var o;if(0!==(o=(o=f.a.some(n,{allStates:!0})?Object.keys(y):f()(n).flatMap("states").map("fips").uniq().value()).filter((function(e){return!a.has(t.datasetID({id:i},r,e))}))).length){var s="".concat(e,"?Ids=").concat(i);r&&(s+="&Adjustment=".concat(r||"")),o&&o.length&&(s+="&fips=".concat(o.join(",")));var c=t.fetch(s).then((function(e){var n=a.modifier(e[0]);if(t.checkMetricValid(n))return n;var o=new xp("[RESTStore] ".concat(t.datasetID({id:i},r,"[fips]")," has empty data"),e);return Promise.reject(o)}));o.forEach((function(e){var n=c.then((function(n){var o=n.datasets.filter((function(t){return t.geo_id===e}));if(t.checkMetricValid(o[0]))return Ct(Ep(Ep({},n),{},{datasets:o}));var a=new xp("[RESTStore] ".concat(t.datasetID({id:i},r,e)," has empty data"),n);return Promise.reject(a)}));n.resolved=!0,a.datasets[t.datasetID({id:i},r,e)]=n}))}}))}));case 2:case"end":return e.stop()}}),e)}))),function(t,e,r){return n.apply(this,arguments)})},{key:"get",value:(e=i()(u.a.mark((function e(n,r,i){return u.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.datasets[t.datasetID(n,r,i)]);case 1:case"end":return e.stop()}}),e,this)}))),function(t,n,r){return e.apply(this,arguments)})}],[{key:"datasetID",value:function(t,e,n){return[String(t.id),e,n].filter((function(t){return t&&t.length})).join("-")}},{key:"fetch",value:function(t){return vp()(t,{headers:{"X-Forwarded-For":"https://usafacts.org"}}).then((function(e){return e.ok?e.json():Promise.reject(new Sp("[RESTStore] could not fetch ".concat(t)))}),(function(){return Promise.reject(new Sp("[RESTStore] could not fetch ".concat(t)))}))}},{key:"checkMetricValid",value:function(e){return t.checkDataValid(e)&&t.checkDatasetsValid(e)}},{key:"checkDataValid",value:function(t){return!t.data||(!Array.isArray(t.data)||t.data.length>0)}},{key:"checkDatasetsValid",value:function(e){return!e.datasets||(!Array.isArray(e.datasets)||e.datasets.length>0&&e.datasets.every((function(e){return t.checkDataValid(e)})))}},{key:"getMetricURLBase",value:function(t,e){var n=t.source||e;return n&&"sotu"===String(n).toLowerCase()?"https://sotu.usafacts.org/api/v1/metrics":"https://a.usafacts.org/api/v4/Metrics"}}]),t}();function Cp(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function Rp(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?Cp(Object(n),!0).forEach((function(e){A()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):Cp(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var jp=function(t,e){var n=m[t];if(void 0!==n)return n;var r=Number.parseInt(t,10);return r>=0?r:function(t){return t&&Object.prototype.hasOwnProperty.call(t,"data")&&t.data.length>3||t&&Object.prototype.hasOwnProperty.call(t,"length")&&t.length>3?2:0}(e)},Ip=function(){function t(e){a()(this,t),Array.isArray(e)?e.length>0?this.stores=e:this.stores=[new Mp]:this.stores=[e||new Mp]}return c()(t,[{key:"setModifier",value:function(t){this.stores.forEach((function(e){e.modifier&&(e.modifier=t)}))}},{key:"tryStoreGet",value:function(t,e,n,r){var i=this,o=r;if(void 0===o&&(o=0),o>=this.stores.length)throw new xp("Could not get dataset ".concat(t.id).concat(e?"-".concat(e):"").concat(n?"-".concat(n):""));var a=this.stores[o].get(t,e,n);return a?a.catch((function(r){if("StoreError"===r.name)throw r;return i.tryStoreGet(t,e,n,o+1)})):this.tryStoreGet(t,e,n,o+1)}},{key:"expandStates",value:function(t){var e=this,n=[];return t.forEach((function(t){Array.isArray(t)?n.push(e.expandStates(t)):t.allStates?Object.keys(y).forEach((function(e){n=n.concat({metric:t,fips:e})})):t.states?t.states.forEach((function(e){n=n.concat(Rp({metric:t},e))})):n.push({metric:t})})),n}},{key:"get",value:function(t,e,n,r){var o=this;this.stores.forEach((function(n){n.load(t,e,r)}));var a=f.a.sortBy(this.expandStates(t),(function(t){return Array.isArray(t)?t[0].fips:t.fips})).map((function(t){return Array.isArray(t)?t.filter((function(t){var e=t.fips;return!n||!e||n.includes(e)})):t})).filter((function(t){return Array.isArray(t)?t.length>0:!n||!t.fips||n.includes(t.fips)}));return Bt(a.map(function(){var t=i()(u.a.mark((function t(n){var r,i,a;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!Array.isArray(n)){t.next=5;break}return t.next=3,Promise.all(n.map((function(t){var n=t.metric,r=t.fips;return o.tryStoreGet(n,e,r)})));case 3:return r=t.sent,t.abrupt("return",n.map((function(t,e){return Rp(Rp({},t.metric),{},{metric:r[e]})})));case 5:return i=n.metric,a=n.fips,t.abrupt("return",o.tryStoreGet(i,e,a).then((function(t){var e,r=a;!a&&t&&(r=Object.prototype.hasOwnProperty.call(t,"datasets")&&t.datasets&&t.datasets[0]?t.datasets[0].geo_id||t.datasets[0].geoId:null!==(e=t.geo_id)&&void 0!==e?e:t.geoId);return Rp(Rp(Rp({},n.metric),n),{},{metric:t,fips:r})})));case 7:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}()))}},{key:"getParent",value:function(t,e,n){return this.stores.forEach((function(r){r.load([t],e,n)})),It(this.tryStoreGet(t,e).then((function(e){return Rp({metric:e},t)})))}},{key:"getChartData",value:function(t,e){var n=t.metrics,r=t.parentID,i=t.adjustment,o=t.topMetrics,a=t.bottomMetrics,s=t.source,c=t.chartType,l=n;f.a.has(f.a.first(n),"metrics")&&(l=f.a.flatMap(n,"metrics"));var u=f.a.map(l,(function(t){return void 0===t.allStates&&((e=jp(c))===m.Map||e===m.MapReactMigration||e===m.MapReact||e===m.CartogramReact)?Rp(Rp({},t),{},{allStates:!0}):t;var e}));return{parent:r?this.getParent({id:r},i,s):null,data:this.get(u,i,e,s),topMetrics:o?this.get(o,i,e,s):null,bottomMetrics:a?this.get(a,i,e,s):null}}}]),t}(),Bp=function(t,e){t.classed(f.a.kebabCase(f.a.findKey(m,(function(t){return t===e}))),!1)},Dp=function(){function t(e){if(a()(this,t),void 0!==e){if(this.container=Kt(e),null===this.container)throw new Error("[Chart] Constructor argument is not an Element or D3 selection, or two instances of D3 are being used");this.container.classed("dh-chart-wrapper",!0),this.chart=null,this.initLoading()}}var e,n;return c()(t,[{key:"draw",value:(n=i()(u.a.mark((function t(e){var n,r,i,o=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:{},r=n.chartType,i=jp(r,e),this.chart&&this.chart.chartType===i||(this.chart&&(Bp(this.container,this.chart.chartType),this.chart.ro&&this.chart.ro.disconnect()),p.a.unmountComponentAtNode(this.container.node()),this.container.selectAll("*").remove(),this.chart=this.createChart(i),this.initLoading()),this.container.select(".chart-error").style("display",null),this.setLoading(),t.next=8,this.chart.draw(e,n);case 8:if(!t.sent){t.next=10;break}this.container.select(".".concat(this.chart.cssPrefix)).style("visibility",null);case 10:this.container.select(".chart-loading").style("display",null);case 11:case"end":return t.stop()}}),t,this)}))),function(t){return n.apply(this,arguments)})},{key:"drawCanvas",value:(e=i()(u.a.mark((function t(e,n){var r,i,o,a,s=arguments;return u.a.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(r=s.length>2&&void 0!==s[2]?s[2]:{},i=s.length>3?s[3]:void 0,o=n.chartType,a=jp(o,e),this.chart&&this.chart.chartType===a||(this.chart=this.createChart(a)),void 0!==this.chart.drawCanvas){t.next=8;break}return console.error("Cannot draw chart type ".concat(a," to canvas.")),t.abrupt("return",i);case 8:return t.abrupt("return",this.chart.drawCanvas(e,n,r,i));case 9:case"end":return t.stop()}}),t,this)}))),function(t,n){return e.apply(this,arguments)})},{key:"initLoading",value:function(){this.container.append("div").classed("chart-loading",!0).append("img").attr("src","data:image/gif;base64,R0lGODlhpAEeAff/APfK4v3v9+2DvfP2+eUijeplruQUhvXB3pKyzelbqbrM2hBamYmsyqC91PGkzuhJoOdDne6LwUyDseDp8f31+vjQ5vrh7nSewfn7/LvP4P75/MTS3u3b5fKo0OlWpuc9mu+SxeUokC1tpP3w9/W72uzB2eTs8wlWl/3y+Oy61uY0ldXh7EV+ruQYiO3j6fbG4O3U4ultsmyYvuyYx5250c3c6QRSlex1tj14q+qbx+MEfvbg7PjU6IOoyNLb4+3y9+uz0uMKgfrl8eyrzsTV5ICmxrHI3OTo632kxezM3qnC2Ouky+xxtNHf6nCavhphnSNmodjk7e7p7Ojv9TJxpqvC1Zm2zvnZ6q7F2jVzqO/v7+x4uOrs7utqsSZpovDW5OYwlJa10FWJterw9mCQufTb6Th1qfGfzP/8/frc7P7+/vOx1ViLthZfnOdSo3qixOUei1yNt+Y6mPT09O19ut3n8F6OuOdOovv7++hRpPnq8s7Y4vHx8eQNg/39/fDw8OLm6fj4+Pzq9N/k6fr6+vn5+fCZyf////Os0+MGgEB6rOh2tfPz82mVu/Ly8o6vy/C11fz8/PX3+cna5+lfqtzm7w5Zmfb29vf391qMtvX19bbJ2e/s7qTA11CGs/zs9R1jnvCVx2aUvOUukv34+4aqyOl+uMfU3+jq7KS90gdUluUsknegwhJcmt3j6PGcyvOu1KO80R9ln3ihw7DF1+MBfbPH2H2jw0J8reqWxNng5gJRlOhorpy4z+Y3l+/w8el6t+uRwhRdm+Yuk//+/v7+/+MCfeQPhANSlP/9/uMDfvS11/3+/u/0+Pz9/vnc7KvF2mWTu/rf7u7t7vzo88fY5u7r7exvs/Sz1sDT4vr7/cbV4rTK3fj5+++YyOUrkeYrkuhztPj6/PfO5QtXl/r5+e7n6u3g5/Hr7vrb7Je20eqVw7jN38LU5PS32fK41/b09fHx8u7v78/c5+7H3Nji6vDx8ai/0/jW6e+PxOx6uUiAr36kxOlhrO7u7v///yH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTA2NUE4ODMzQUUyMTFFQUFGQTRFM0QwRjkyODM0MzIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTA2NUE4ODQzQUUyMTFFQUFGQTRFM0QwRjkyODM0MzIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMDY1QTg4MTNBRTIxMUVBQUZBNEUzRDBGOTI4MzQzMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMDY1QTg4MjNBRTIxMUVBQUZBNEUzRDBGOTI4MzQzMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAUDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVO1RSgjtCVOrLOmKLI2DsbS+ys5noXagNOEDl0KrwQqgwqptnPPUsQ7Bl2FtpAbf+6hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTG1MJRKKIEQV5yYaSKMNcGkJ3LvYHLMJCCM3z0RGRRvacGxztzzIDsVUN04RJGMrXnl2sctWWhvSCf3VBtq1T13Z913id13q913y914S8Fw19g2u9pRZRv7+8VnR8TW1dENRmyWf82KhCyabRdTeHuGGjoBhRrPZ01jd4YTm22BJCPm0M2WYMUaFlKyo52EX01H85gFbHmpK6EpU2BwtM2k7r1WjBh140aZQ6yyYhvHfLzAezNV0jPbYtxWmsH55dIb79EXiKSE9s1KNNr+ksE86sOoNTOBYTreDS3d7//d3gHd7iPd7kDTC4fRZrU55ml4X7mNJe+WkB1ry0/BbM6Jt/HW9D19wcIVkzyK5tZNDzbRarmcUu8aLeSYT67BhgFdXuptEBDhZV2yuSnTUXxgfRLRAA6MryOtbrsUgPrhXb27sRKlIcJYSO8MSCSz0RRW1tvDwO/uFQsSe3Jt+aW3cFTjknXhErXZg1dpw4Ks+cDeObVY2K2b0EUUyMp6djLXgRwXHihz15ZtPzLOR3lbHMi20IgV9JDJyenaMpJF/lKxGbY83x7F7NQ+XjSAgFtJhns+IjkrUbZJAznRBeVb2ZjQnT7U7tdV3NYyxoThI2WttafEE2HhPmDKOs/00QNQiQG1rbeYYtA+sukj7plF7pln7pmJ7plZ7jkuFlYBbLZqOiEaFmNdHUMp05K7WsgKPmxn3crr4x9+0USiulGrOo3mRZE+7cHH4rz7hSE80RdsbG1vzqj73lU6E1FMMvuFxypPyXpwLaDnXMvJLrp4EH+4JkxJ7tJP5xY5vda+ozyy4j2MyG3XXeEmK3vPLra/VlRpbB/ZKo2s6xFCQVBZlp6fgn8L448YwJZyQSxZTcQO3jKaPLf14TSeivRcPvpilGqm7d6K5kpFrwMoGGYlPmm4LbqHfhJPHORGOdEt8Suq0x0sUImnKweqJM0L4RK1XbZqPwHz9lQugv8/+CycFiFygHFPUkxzfhVZDRbOTaRgDDqC/vETan8TcRUuEMEzzP2HosYCR/crH+4YcE50thWUlOg1eZEJFg5c5a5j5t7oxSTEW7FKjX8CmxUh639RoLNCPP0/mHXWAPJFWk800hfDOB9hSxxq2e0IFCsIUirYeSf9pKtoRf+IZ/+Iif+Iq/+Iyv+H2t11HfaHMb98yU9ftl+Wu5NYcc75wvNJmbFaiX9EghVsY+ecBU+pQWpb3Z+azPK6i/jKci+kchX68fq/A7ZXNRMZg27K3/2OreFLhFr5TPf3CWbW1j9AkkMRTDM+j4J73v6infEyst+0YRSb+fZaeCtI0WMar/U7ZBqd3bHa1HVt7kX/7mD97lkv7qb7tgMf3DzxGR5M1EKSPCXR3/PhZ0SP04BpJgBBBz/A0k+CfSP4QJFS5k2NDhQ4gRJU6kWNHixYt4CA78owbjR5AhRRLaOJCPH5EpVUq8VNKfwZUN8fxx6QhlTJw5de7UqYbmRjw8hQ5lSLIkTKJJIwZy6Q/ToZxqBLqcA1XpVaxZQbbceEnr15R4tJTUEhQs1kJjS/Ixm1INJrUlA52lW1ern7j+HFm12xeiWJeF/A6N9LOkppsf1VzKS5DtYMiRU3IdqCWxZMmFXV7ii1mlGkZN/c1pO1FNodCiNXn03Np1QzV5Mb2W7IeP/0tGrGmHDNS44CVClxX6IYTJkWiTpXcvl1xooxbdzO2qOb72oHSMfqoj/+OIESNHjgwj96clUGfs6etOHahJfd9D7AlqEfy+IqHx5PVXxhTd/v+sxlMOQK0waWo1AiM6JJDb9iPPkUD8S3BCnvwoSUIKlSLEt5MyfIiQOXzTzxFMrvPwRJ2MGsgRFO9q8Ln6WlRIDUIucURELfhgBBNCMJTxx48MJMgrIJWSqqncilxIDT8iicQPP3xUckqLNNkoRiqFSsulPwjJ8kswU9rOHxPD1CmSFzeaQzgz23RTofGkfBOkQ6x0ybw582zzkI3+0DPF/FYs809CZVRjIz4Kxf9JDTtdQlBRSDO00LFIY8KvKS36q3RT+yY1idPPGj2qEPRANdWzQ+c7NaVIxkSU1FVjlSwvOWWNaMum+IDVVl7PGtPLXjFaTMSXIgz2WKUo88c9ZC/yQ1SyEGt22pxUfKlUaiGKRD7cds3224ti2whYcCfaljwtNBmwXHYZko+Rdil6lliOLlk33nI1Agpf0zAJ9ChNeuQXyEMiwYOQQgIJBJNLLsEkkEIIwYPNlNKEd2CJDinEVdFIxKNWjGkjDpM5xHOwzx2DS8laf8gNGSI//D3ZEU0CiQTblyE7BA9MGKH35LWAw1miNP8YOueEdtbkZy4ZuSQQQiIBGemh/Aj/xGegs36ONIz0JWg2qjPGQ5N/T9aiu/C+U3tttefQxOFCPg67opg51vpuf/gwtqLUCBp07oci6ZlpvPX7Y45AKJ5b475P7s7thwuRPOGFLym5bLI0nQivjfYCvKKdBy98dEbuffktwvOeg0fFIVIDj0DmwPwl0xcS8uvPP/KjkEsYmX30puaYulxGmXYEuOEpEjzNksBWkPnac5dIjUgICUSTkvlIXWukQkYdOS3mKCR5kCJh7MCjEYrkKPKlp0gNJqGUH0on6z844d7LLivkmZBjROCsqCEQgWJWRG43kDm4LzJWsxuW2HUkTGGidUZS1kCcBxFXzUWBkcED85aV/75efY9L5xnMhkoSvX9wbiN/22BdQFOTCeaJSU6CEvxgE4lChAhTJORgXvgAQpZ1pIU641Z5XKYnAfoOXX9gItOE1xrnbESDEakgI0A4RKwcEHd6Ohfw1oJCu8jHaBlzFZGw6BcTlqQqb3qWFzN3xenkxYEO8UN+5njGs2gHN3BEEa7cmLe9LUdZF5OI1yrDQjx+5RAV9IcVwfRC0ehoDnP4jiP4wIcmakGTfKBZIWLoGU+VB45M6dMnE6mUKG6kgFPqX00CqaRfVQRanjulXQBzJZD44X5Ra99XtGiSI07pgAmkyCFctcpansWQ5UEkHS/xLz5cwpRagWTz+OihUP9CpyI+Kckdk5mVVHJkan4oYvCmqRTNHKWZUxrTBSUSibwI8Zt0qaAjapVGB9EHPr8cTS9PFE55UiScTpknXYy5FsUtEm/u1EqrmjLFN3FzixWRjzYLChaJzoeHCNHYv7RAM01oAmuBAQseGlcQMFKJlJU5Zwq7edE8Bip8mCCZiPhACPQcghAeTOlKNiaaJBEqo428iKgICdO7/M5RQ1Poc9YZkw4iB6KEGqg3HbK+jfgTqSnRYz6tqhAt8kGrE2kqkloKpjFZxiJpCuZWlbIgpj1qIrO85jZP6pi2FgqrBKHlRJRlRrdSExMe/IM0L3JQVe6EOsHr6ZxW2p6KhPP/qIH9CnEkpzKQDJWgObkrI86ap5NO9SGh9BNlEwTPkuQ1SGT56qY021qOlqSupvXMMtWqkr1WprGKuiVBVAunrNI2QY/N21gT4qrdQmqg+4tImj4rXMxUkJghWSZDe6VFLfz2H2N6KnR3g1iCwBYijfthtqDlj6+O6bnejcxQLZqd1ILrvNZFiHPZS6BlTvcij01Uuc4b1IXkZbb3lUwFu9uQxtG3WYw0T2dIS2ACHcJiHxFQvIjLkRIxaUyThbB6lnngGT1nwKvq7X7E2+HXNA6Z70TUwLpquBGjeDCGfO9ErMVhdsEVXcmVsWTSBFiJWEu//BpWU/7A4x5H5rE1zI7IjZGm095xUnwxTvJghjrkv2wEx1XmMk6Ie+Lc9rfLY86JhE9oGhGTWc1QJYt2ETIeEK9Zzg/55VMiIh/RzlnPFCmiI9b52C3vWdAOic+BFJdbLVB50GOuk2jmwEI4L1rSEulNJF/ZODdPetEORQ7X/tG4E2t60IWY3dnOLGpUN0RjHhRNolP9apnokDyhhvWiBcjqzdZa1wwxX4PCF+ddp9q4wSZ2sY19bGQnW9nLZnaznf1saEdb2tOmdrWtfW1sZ1vb2+Z2t2sdEAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwAAAAAAQABAAAIBAD/BQQAIfkEBQMA/wAsAAAAAAEAAQAACAQA/wUEACH5BAUDAP8ALAAAAAABAAEAAAgEAP8FBAAh+QQFAwD/ACwOAHYAFAAGAAAISgD/CRz4L8AzAO4chNJHCUIIOQLDwTl2LEitixgzYuQgD4zGjx9L/BsFsuTFJPLymPyoQ4XAJcfgyBw2zNeDBF3o5HNwwAKagQEBACH5BAUDAP8ALA4AbwAsAA0AAAi6AP8JHEiwoMGDCAkmg5ewocOGabbAUSHloUWH1EB8UFar44yLIAlaCLWxo0ljEEJapIAtRgiTME0SmKbyYBoHBcDoiMmzFgEQNQXyyFdAzjFjPXkG8UCCWEI1fiIRKhTo0hxGfPz9+5C059IOFAr++aOlrL+zaNOmhdBVZgFYYQ+qnUvXX4yexlq4yXflYd2/Z0twrHXMVxcHFkICpvtH4DtsiYP+Kzv2Dx8+jhjN0YQpUCE8fg5JPhgQACH5BAkDAP8ALCEAYwAvABgAAAjxAP8JHEiwoMGDCA+SSJGwocOH/ygwMUZACsSLFwGEqMVxyDSMIA+S2qKDI8dFIVMOPLDRJMcYKkN+KmDMJUcDV2JeJPbKgE2OdwTphHjA189aBhwMffjMw9FaCYQuTfilX6KjBJZNpcoryNEgAkhtPUgvwdWjHqSNLYhmDYSntXwdWHsQ7qgldAWqCTTD2MCfdz+u9RPIkT9/M/66/ADLz1g1hDTxOUyZQ5C/OjwA2OqnkGTKoCmjFChAyFA8gTQ50hK6NWVOwca6nu1Py5xCatbSBv1HE6HceWn/mRPIcV6CoLU40lTI+PGDmAg5f54wIAAh+QQFAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vfz7+///8ABijggAQWaOCBCCao4IITXbGDPAxOloYHxnwjRYSQjcBEIrV0GAGEGDLWQQsdlvhBiItZ8ECJLBqAImLE5BMEiyWGgM2Lhn0BAY0dGuBNMjgWlssxPCrTxQhBEsbBHTzWMswLSRL2Dok0JiIAGlEKpsENxvA4Cj1ZCoYPGDzqEM6FYQLmzYw0wpFCmoB9kkeTHiAJ51T+5Knnnv78cUkkHZHQQpcs9nHGnVXxqaiejhRyCEYUMEEoi76kgWhVh+ARCCNaLLrnH5ioUREAIZRJB5aXYpXpJX94mqcWl/j/EREpW+jAIwFQptpVJKy6qoUmojZ0QKk8JoCCrmHhMYevoSr0SQGTlmgAIsiSpQYmrS76RyEIFcIkj3cIUq1ZhxTCh6eOADoQHo5MA4MBLTowrlqEnLvoJWr4sWye0yRBZi0JiDuvWuVmy2enik6TAj4Du3UIJgi76o8WmDza8Ft+MCLxHLJe7DAhGrt6icdu+dGrxHnOESzJZqkRiCMSR6wnHx2zHJYfL6PsCCFqaKKoFoTY3JUahGhi78bqClSIzHkGIvRVfhRiNMp5glozQX4cracmFj/dlKaaOMK0r3PgsZAa++7JyMpeK0X1nlrMUQjbC2GiqCN0t23U239o/8LzRIQwTbPeSbn6xxyBXE1RJAZXrTjhQsHtiCaFPH6RH433mTTkQs2BCSGWc6SG1hNzbvrpqKeu+uqst+7667DHLvvstNdu++2456777rz37vvvwAcv/PDEF2/88cgnr/zyzDfv/PPQRy/99NRXb/312Gev/fbcd+/99+CHL/745Jdv/vnop6/++uy37/778Mcv//z012///fjnr//+/Pfv//8ADKAAB0jAAhrwgAhMoAIXyMAGOvCBEIygBCdIwQpa8IIYzKAGN8jBDnrwgyAMoQhHSMISmvCEKEyhClfIwha68IUwjKEMZ0jDGtrwhjjMoQ53yMMe+vCHQAyiEBuHSMQiGvGISEyiEpfIxCY68YlQjKIUp4icgAAAIfkECQMA/wAsQwBRADkAHAAACPcA/wkcSLCgwYMIC4444I2JBwgqhoEb9eHODUPjiCXcyPEgCkQFQhirRbKkSZMhOqpMSMHBg0QnY8qstbLmwDTXDMzcadKAzZU8POjgSZTkg58refaBwMQQCR6fUPwLYOFAqAIEgCBNehIMHQBotopFSNKYgRv4xqolG+KMhrVwDSLSGLeu3bt48+pVeUnF3rGHLvmb8XdrJD7+EscobDOQlsSQc0BgzFHNHMiY56ihnBDPH8yJtRTijFCNYND+HPkhffAwan+YDrEuGPj1HzyzC+JBjFpz7oFqNL3WQug3wceoGW02LnD4aOYEQfuGbtDfn+LUCQYEACH5BAUDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABHbmDx+BqFHSCAd4w4QHEKgwDDijfHDHDYaMk0yBZvnjoRaaRPIRCogUEIIxtaSo4oorGpCHAxRwKJaHNPrDCB4aaeDAA4mw6OOPKvbRDw8yflVjjY7gWJEfl7gB5JNQPgBAkVxpcWSNjIgYUSRzeJgHlGD+aIwHFlCZlRqF8HEljXP44ZAfXXoojwA+9gEBE4aQwMMnKPwTgAUHhFIAAU8GEQEaZmaFByNreniJggmpccmVHPSRIhh0AIBoQ+nQQeiPKuCTaFZcNvpHIQgV8kejOdwg6kTEwP+iwo9BeDMqqXFeyYibA/nB6Jp8FHJIRmuE8KMHfd56VSSOrKlFIMMGYuWVfBDSERoRBOEjOGkoixUhq17pSLNXPjvsR8984KMBB3h71SGYTNsojZpAGhIxAujAYiJnuHuVr/MeqGRJB8DhowD+XjXpmpqce5IQvvgYAzEJS3XIwo0GopIGCfiYwKYVNxWJmgH7M4e9J9HhIyUhNyVtueHWyAevKL2izIoFtKyUGrnWeDLP5Q58EiI91gIHBzojhUfMNGqB6kCFyEujximREMQoSSRtlKRrOkLzQJEw7ajDJglhjdZFjbwmJmQTpAa5WKKMNloXr/mH0Acdoom4cs//TRYeJB95skOBUPu132GpsXe51kJEiNT+/KEl4mBFvSYjfTeEB+Ra4E35Vs4+TZEfYnf+uVdXDn6RGoF/6PnpVtX4R+MZvX2kFrTDrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9+Oev//789+///wAMoAAHSMACGvCACEygAhfIwAY68IEQjKAEJ0jBClrwghjMoAY3yMEOevCDIAyhCEdIwhKa8IQoTKEKV8jCFrrwhTCMoQxnSMMa2vCGOMyhDnfIwx768IdADKIQUIdIxCIa8YhITKISl8jEJjrxiVCMohSnSMUqWvGKWMyiFrfIxS568YtgDKMYx0jGMprxjGhMoxrXyMY2uvGNcIyjHOdIxzra8Y54zKMebxIQACH5BAkDAP8ALGQAUQBAACYAAAj/AP8JHChQDZ5Al+YwcsSnoSNGl/QQnEixosWLFdUQ0sTHn8ePID26aIGxpEmMagoxCskyJLCTMGMK1NKy5sdvMnOWtMkzkTGdQCfW1AIxEJ5IatT8U+MHz6ugUAeC5IMp0qGoWE1quRQpq9evYMOKHUu2rNmzaNOqXcu2rUUPGtxCrfUgrtyctfI+IHU3Zt6/d6z1Nfmiz9+8HgQPxvji2OFaiRdjTGH4cIJyki+mCPK4ALHMFacB4Xz4BmiLkEj/FXC64rJEj/O1pohI2eMzsyeeeayjQ26CIB4nWvZ7oIDDxhIdKC7wxuM+L5j/K/DYQAXmxBI8bnGFOZo7yFtYG2CuAYKxw7mkU5Dzl9I06f8CqCCwDv5ATgQDAgAh+QQJAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3jz6t3Lt6/fv4ADCx5MuLDhw4gTK17MuLHjx5AjS55MubLly5gza97MubPnz6BDix5NurTp06hTq17NurXr17Bjy55Nu7bt27hz697Nu7fv38CDCx9OvLjx48iTK1/OvLnz59CjS59Ovbr169iza9/Ovbv37+DDi/8fT768+fPo06tfz769+/fw48ufT7++/fv48+vfz7+///8ABijggAQapwYegVwyByOO8OGgI4xcUkgkhxS4mBqEaMKHPxx26OGHWsxRiBoWEqZGIYx8qOKKHmqhSSQlAnaJFizWaCMjMMbIl4082jiHHzrqxaIWEQaCRyRqkKiGHwhq8keNWmBSYZB2fcgHJhQ65AcmT67IR45UzsWhFpeAKREhjqyoRSAamRkmVXwUMuVFhGyo4hwkWhSIFm/SdcieKvJBCkVqpOhPn3X5kWaH04RjwAFn0sghonZh0iEvtdSSyBkPqTHHh5TahccfQGRqqgANEdKlh6Ha5cwNppr/GgMxCamhiZet2qVBArFmmgAaB4264iV55loXHb3W4oEGBKlxyYp/4GFsXq8o0+sDzP6Dh50falLstHchksi1pNyq4h+EgMsXCUH0eoc1d36r7lNzmvRCH716AO+YhcxLFSPykvTCMfnCi6e/VPnjSMAheZoCvrEmUA7CVXHIB5AkAepPCu3GWgCtFEvV4R9udhTJohxOA0THpt4QssgdaiGtR86yCAnLmaL68lMgzryRql5Ku8y4seazs1PcjunzRX58uqKUAyFibaycHr2UGiiPma5Fh2Ai6YeOYEzQGb3q0IHVVxvq4dYT1almvwiB0Gsiy6Ct1CFqd8j2Q37k/+3hwQoJEKsxiUBqN1KHOL12pzMG7RCssfbxwuGIm7s4Q4Ws2mIg9TJUQK8GVEA5UpbrrRAeWf/N8ELE8BprC1eMflTpHO49UNMs8rF0RGjcMXgLO8huFO3+7O3s15t3LpEGEBgTKwEwCF8U8emq4TWL3mpEgRy9hsCB9ETRHqXmHjIitkYBqNDrN9+DL5TiNjqye0Z9n/NNryro4b5cHNwfqwoB2B9c5AEDAuAvgAJ8SxkM+D8EJrAtFmCgqQD4QLdEsFfDEEQFISjBTIXAAhtkywWfF7sQqmWEmTJGC3hgQrVQAxygA0AL0/IJ9UWOBDNEywg+4DxTJcIBOTwLBf8ekKwIBNEsGvBAsgqQjCOShRgxSJY+nFiWCMQqCPT4AxXJ0oF29WEIWzQLAGIAA3mE8YxoTKMa18jGNrrxjXCMoxznSMc62vGOeMyjHvfIxz768Y+ADKQgB0nIQhrykIhMpCIXychGOvKRkIykJCdJyUpa8pKYzKQmN8nJTnryk6AMpShHScpSmvKUqEylKlfJyla68pWwjKUsZ0nLWtrylrjMpS53ycte+vKXwAymMIdJzGIa85jITKYyl8nMZjrzmdCMpjSnSc1qWvOa2MymNrfJzW5685vgDKc4x0nOcprznOhMpzrXyc52uvOd8IynPOdJz3ra8574zKc+98kQz376858ADahAB0rQgt4lIAAh+QQJAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3btywPRSJUqBAhP3Dz6kVKiJEWf4AD/7mEd6/hwzkjOQrMmLGWQogjS35J6G/jy4ADTd7MmSQezKABR+pMunRGNX8uO9J06ZLfxoxMy54NERPs0QTVaGpcmLbv3wT5MNaE8FDqwJiAK/etxrGahIEYO1pO3XQkxrET+uFdvfvm64GzJ/9cHFiz9/OHmwfms9B2ePTw9x73p2Xhdsa94+tfKzwwQ/KAzbHfgGoB6M9zChXSGGQENkiWgQgmdEh/gGmBh4MYggUhQ4RcZl6GIGY1nz8O7daYI/mFqGJUltHn0CGMXPbYijQ+dR9g7DmkRoyXJVfjj0l1GJiADx1yCWYfAqmkUEciJxEeFFaY4pJU7mQgIRMdYmJgl1Tp5U7qBRahRE0CNt2XaNoUXWBnUhSmP3+kKedMBiYpEXg42hQJJozw8YcWWvzBhyNzaIJJIIREMuac6H2Gn0VzMEakTH4YGFpjgxpaiKKMUscjYOJNJGRgWFI64qWowrkaJoku2ulmowL/diFFkbToDx+HzPRpqrzKOGihlxxaCB6R+KGGq6+mhZp0Fflx6qwxvemYrb1WC1qggjriCCNzdOvtt98yIu645JKr7bnoosvHuuy22+4f8MK77raFYjLslD/5UYhrfgKa7RysIgvXIZZCG5EaUfrT5UyO4kjImGr4gQchgVyiSZ/UWqvxxhx3nKoWqxWCb02H4KHJqZfyoQkeueYFY2PETaSGpYy0LFOsMes4FyaaOIKyx0AHLXRof8xRiMAuRaJJxtUONvJZlWKKtEIzS10TzhepEUkhmMzhCB9MDy322NVqwUghNrd0SCEJAz2HwWdFcgm1WuAW0cuM/TE1S3j6/zMpR1pPXEggmFjs9dfwAkr24otrocnTI6mByc+YKd4rI3aLVfLJlcP9UKR5Q95S36G2dKwfkUSCx+qss57667DHnroftNdu++3GHqv77rw/pzvqdPHMCOWXvY2SGnNfqgXAePhhs9ZcOxI2YJrsbZXJ01tIUZkVZk6TgkNypgYefE4PqvcfST79YJGknZAahMwR9h+lbrV22yeKDl1jdds0/paA8RFpSnYJ/A3JehRZG/GMJ7NAGLB6WVEgqv4QCPc9pGGB8ZxL/MA5zKCPNEoLmxYq2BEoXQsTCFzIIQiBPz58EComDM3yjlaRZTGGQTJZE2hy5ptDOBA0KNKIH/9AdxkKpvBFgcjYjKZiJKJdgmUYIWIAaQLA4lnQNyysHA4TmMTKoRAkapAil6SCt+JBMSOx8htN3IMZPmyROhIs3hELEsPLXGKOFClExuZwRaSUcTj6g4hx8oZHkWAQMH9gxBP1g7w2BjI3VRzSIzMSNdgUkieRZMQkHwK+DM5kQo55434i0TbtOYQQP+ODBkeiJdVcMiedrJAoNRKlv8FEh4CZ5X6aeBld5kaMFcJEH0uCSzO90iZ+sJUpPXLITUZuRLbEUGU8pBBUYmYOzvzINBnDh2PSxFL18wgAo+kSXGohm93xQ9sE+EvM0I9h1HKEN2MSS3+w0yMjWuVKBjn/xhrtyI4FseZlIEiTWp1oni5Rg60cMUyMvEkLDU1JGhG6nFY2ZmG6cac+X2JQ7EQ0J9zzxws1gsHSvUSK5FxRSO2Jh58RFCcdDQwP83XRkWBNJgplzEZDxMZL/WGnMsEDte7ZEwDqbSSxXBg9ufmlnmLmpTw5pD98eZMbZYYkSZ2JFImqJKcKJpw+qac/gKpVbn4UI7FKqUoOYSt0DiiMmGEERVfi1HP2xKpTLYlVcwQTDPKVSi0FTTeLUsXB7kSKfx1Ji+oTE+4pVUmH8CpsznqTP6pRJ3gFa0gOkTeZGIisDqokpmpKFIQ1xk41AWBiRbLXaDVmrsvZZt7wYNob/xYlprLCSWZPUtKYYLBN/oyk3xCUTMeMlCdptKtNVIuSnj62JT3VwqC2xS3W2CtRzhtlKd94yKMSxalqbUlxA0NVj+xKsysBJq/+QKhLDAu2bikmjvBVTIYWZVf+QO1LVEtZSr42JgbcWCLde1zJ/NOOw6zic4GS08D0j1K2Km9HuAdclwhXaGZ7InzBItC8oZcgBGvMh3uSRsPChL8n6Vteo4VfxjkCE+1DDC8t2ZDxdo+wjQnvSfAq4Y3UFpH9TcnpUCc4wmnCa8RD1fIephdSIgkiJd7wSUBp25PmLcgWcTJj9AuUQ0hsX32y1pKx3JUuYqrABwFvUWxMH7eSdP9BJfEhtUyaFLkUome9chxouQLXgb4Sv1wN64nIrBEq44jQEVFMEaVsk5KVL1V8CASjDTK+is2BEV+blyI3hegSokwLI26IDT1JFAWzJKShPo1w+eBmohAwwBXSBJplRghNwJp/Rps0Q2YsnVYLBLfKFcqPAZNqbeZ4JJH4mVy94odAWOoyjNjzQtRQiBaLWdYpES1jhKmRepo4KMD2dUSc5RhxK0S+9OHyVtTg7Es5QtoG8UPyxIY5k+ixiPBmSBVnCpT6dvpgCetxRSSrybjNO66zLkgk1Ds0bIqkzzmWcoi3XBQxBtojYuQ3R8T6B4F3hdoBdniNGe5gRQaCWMf/+kfE8BCIDnrx3wkJLP88LhE2j7W0pyo2RgqraxX7Y9luwYO1AXNHqq2UmzCmrB8mJ9iEv+joQTRkY/5g7pWoONgfCSnWO2Joou9l4aDpOEIKQTktXMLpBiHEs9OtES1fFOYOKea3+221j9Q13xCpp8bfAva45scPQ3cj3P+RRTlexMyzRYkYdawTMdbMIyvVeUW6bt/IKFpGJEQ8NyVfJM3P103WnoOui2OpBftk2P7YewKBqW6NpBHta+mwdNY+wsEfRNsVyrdsHUxzjpCb4kOx+cXH/ezWawSlA8SE+WQ6eoFI1uMQ73XSqMX5mkjV+A2ROfAfbivYuwXwKcM7/0W07yQO/YzblOGf+GEi1uFPe6WgLolfe7LwcXUrWJ3oBBFMwIybHD31tvcQuKcwVLNq3hcSxbR1P+FVl0Bmspd7JuFYPNFgl7EAu3CBqiAL/EBgAZhA/3dVKXEIwMRHB0F+XNJ8ZDJ1VacSKxV12bd2LkgS54VcoAEIF3iDu3ABDuYI7oWCBuF2oSF6KuFVJDgQjYRvOCFGVEcU8PdF71MIaweAKGErPngRPgcYp4CDFxgGQPREHQgdSoQyrKYSYvV4/1BHw1GFWYJfSzgURzdDnBI4j+ZO1XcandUTklUFWrgLGTBBK/OFRqheohd9EChR0MZBdDiBltKGQiFWHP8DVSZBOj+hNakjOPNQBI0gASIgDLtwBL3CPp4mI1t0b6elEkLFP9ekhlmziCuYEsnmMfW2ErGkekPxAyyHZ7ziCGjjUFA3Ja/4dilxijLUezBRNXlzgNFycL0yB8ioEbjkfkZRMoHwGj7lhBMBhMjRR8aIHap4hmEjhMKWMMskFPKWZGYSCK1IET2FfXWGB5eQZGbnTLwmGDtlUdKhhoRYIXVYE9tIXtFIPl7jJ+ylSEwmEwBEjEchN8TjOCmEhgcUd5cxhiThecNxFP1IdIBoFgC0j0qBBySnBdZ4EBklI3W4e3DSjA1xeaGRAwJwFCIIbd2oFVK0fkkhOZQjdgf/QYo09iR0Q5Pv83/yAximUAu10JLRuFJ/gJJsMZNgcT9AlDl4QHsIORC/52A+mXapdCGEIA9AQJREmQ8aoTV0EQhkiSicIhLoxo6GwZRiUXh2FDEMB44WgXrjaBFDBBroR3gQ4JVEeQYVsSfDM0FzgI4gIYzSVxpsqTlkVzlhx5EIcZHxZxGRxTQxKBAOwJe1oAMdEBHuaI6CFZJCVEpqCReJORaT+TF5GZYt5piEhz9LdBAggJmJsAyi9kNB4zjpaI/SoZRlUZpkAX5BmI4DYVn+sI/AaXgKIQB8aQyJcABGt3wbI3IbYZLUE5NQIUWsGRUrNHReJxIvKWIPgTxM/6NKDnEDmNkHLyCSyuhOjGAoZSk88Fh0G3GcjkFCkXGQv/mOvCKXH6GbxNYQi4l5QVYAmGkAFQBiykc0RiM6+hKUGtUROpk39mkY3DOaUsFuUVghESmcBRFJoRaVoMGfDkEMCYCZLXAFAvGAkkIIWMZuDwRf+YhIkmYYPQWNUtFsGWomDxNJkRkSHnp7DEeeFIEGd7CcLbADQ/cHoCkRbslN6eiQDkYYeoFLpjcV8GNrqcKMBBGhIOijlxFO4lk5E0oRGgABxsCXBAADRTSjGSFnosh1AYoZupiRUHFTVKEvWJoqSoov6jRQdCoQP6o+OzRXFCAHmBkCHOBgS+pQ6v+lCV9okzI0ByzKFr1lI7coPXnGQO8DTEAHElUEkpRTcBwRACqAmd+QqJDYESoqTx7BbvCYa2nRWqUFPINzCZd2a5UDqw7hVawaEiQnHVcZb4xwDt+AmSqgByVxYMfYn2wDaZdQkKbpGBM4B4ljOUPzB5oArVBGLRLZn7+Kk6pqGRxQrHypAgEQZ/CXnQvhkdB5K4NJW2ExIhzKEb/KMUVDmFZ4KoyoqlEIkoA4koAhDzBAAMZ6riVBnRYqERhqLeylKc3zpzgxgzrhmR8TMulYlYjEmwGVo1O5ENgIGGVAsOVqsCTxsVXqe+3WMdJFL5rAGsFSljAbszI7szNbFzb/e7N1QbM6u7M6Wyc7wZ1EQyisMq9GKI4aS3g5WogbQZEu9A8WILJeaa4mcZF+A7FGWAjUyjhau7XRuROA5y/yMijVJSwPqxKQiZJOGXbqF5bq1YAD8bSYOQyCYBL+6Q+9GomBkLVcu7d8y1QGhl8PdjCBQDyYY1l1eY2fpllwy5chYAEn4VX7ehLj0zVg07eWSzarZRiWFbnTxnSgEYv/YLg0iW6iahCL65UEgKL2JiPBehESUzEX4yeXO7vWoq5ksbmBFEJBiD5nKzPq5X6nWwvG0AI8wFsZ07GRQ2SEsLw427yDw7PQu7POO73UW703e7SmiV9zB2J9cSla+piW/xK4DmGCcEJW1AAOBQoAKYYyNposV3GRd2uEnls5j8MQvQuRMPkQn1CqfNkHJCC5zyai7vtxNGMzC5c9iwq+aztt1paw/zACH3CmXpkIDiC5wFSZA8xnCVM9tilYbAoRkLlR5PtTFEEBD4CZtRABKIGUrZvBRoGxqcII2RnCBxFZqWgRGuABKFwAyXAS6Na+LhwVNke/GkvDBDGA+ZURxBADKPwAKGC8yBnEWLF0txZpMPps9UOdSckREYDCqyANO9Y2JCzFd5qykdrCBaGs5AWwkiJlHRAEy2kAzjm1v2u1ZMwSONor28sRxPlpDvwQB2AAsgkCKIFuTXvHSSE3uP8KbRD7naFxyCHxDOiLmZRAAbx1fn3kZRMDu5eWadUKKKAcyqI8yqRcyqZ8yqicyqq8yqFcunBxpZ45ZqXHSiTnqCWBAieMmWCQBhbcRhfiB4TAMz5Du8RczGbyFgSUtOFBQwIxark0Eui2YiaBBuaJmceACIXcrsa8zbPLWMpCPtQYw8yscMqEvQVBnweVEh3QByjcBZZsEirKzfJMzHQGFvpyCcrsYLqaEGnkXRxBkVNnzg1RASGAwuBwoCEBy43Dygzd0A790BDdykQbFMDsGhQrGNnaXyFVzxSBxJXrGGjcECigw7KZD8TQEdQWzmVDKO45LMWScojsusHcM9r/XHIwRhGA1qaSpTAlkzF/fBEgkAgo/AHP0KbxU9MyIp8xPZc7E7tILR1emDUJo65Qeit206cwY8cFMQ4FjZlBAAIn3dHzmzIAszRBGNI0cgi/QzuVOJaFc6sXrTyMgAnwuhHh5iYM57a58WzxWxKkQKAoLAfFm2j1CieaMM4qt555gwkTTSAfyDh8MJgxBhL1VHmdN54v5Mj0qBJr0AISPMFb8M4MAaLudtPaYdaPzNguLFVkI13vqoamdkGumZoH8cMqEQAkjZlwAMbVlKOOgK+iptiYkq3WSRvRrLJCexdqA04pOXSurBCGGR4xiQgtgMJAALoEQdruJKUNtMg8/7gpc4JXecZec3AJZlncCMFmCnjEF/ZOEIHViZcSI1AAn90H5kA9vXGXQLSLGOGRK20oiaLVpSF052J/wCIshNA86B0RaWTZuSHcCnNJMarXKHEAk7wIjkEYCXpNAq1y1Wav9PKydbG8rVPiJn7iKJ7iKr7iLL7ijb0XsS2/YfPcEsGlVq0SaBABdyAF1fK9CV1tTz3P8vzTs9F1N6dyGx6Rrfux9iTg7L2fHa4QjpbPQi7PEBVatpKUST51/B2WBmh13AmuK1Fpc7DIVU7MC44WjuhFk0adER6COz0kaC0zW9M1mHrm28zR8XFhUdp86IxItiuAVK6LaW4Qaq06g/9TOBbTsuDS6I7+6JAe6ZI+6ZQOMIVuFmuToWanhgBN48z0aQHmOFG+1FBRjjLE3Sjx50Sna5IlhGqXMqpN6mexnTHsEnEqoV+o2fpIR/X62y8u6z6hu71C5KomWIEuEAOIwcgO4euxSMCuFVSMKjKcMKP+ECp5Irb7i8MRUdSmzMsD3M8OFXtya6L+a3Vn65TjCKwZ3fRBc6aup5Lt5OHune6Iq1ZcEMXEeMkK4YIXERwnftiTZ9892fPuE83moMqDbQiBX8jre3yupCkkX92aQCYT1zhS3vdS8PxICAXEK2bT5Y85IuL7EvpdOaiOEF7VqRmxJ1TuTu11Xc1jLBr/TxJ4auY/h9jreu4x0Xf7fUVESKdXavN5hi1h6y5Gf/RIn/RKv/RM3/RJr+6T4WVgVtNm88G1cWw1UfLbnTkrdbIozfF3judizzG/7hSvS9Mag63aKhGWRewhIW/mE2ny1iP7tDX4bPFjf+YNTxViWTEYwzFmY9qncSrVnjVjzStu72N4sC9IlveOHxiFP4HKm+i26jNBzj9zfUYlNHWXXhzdyytAvE9fZmSd3C/W+vh9S0FS4ZGZJpB/cvqLE9l0bcfFpOeUop+owgdRPfM1cYVcWzR0HZNi5PWf9PlKNphlz/sMEedDE9kEluaod+wk8djutKDK3xJrrjHS1Z72/1K2vV/OPLFSNh/4dX39cdavgTIvLB0sdoFyQFFP/nwTXgUZzQa0bQQwa2/+HWFz0g8Q/wQOJFjQ4EGECRVe8tewoSM1CiVOpKgQk0OHhQqqIaTpD0aQIR3+YaQpEB4/FVWuZNnS5UuYMWXOZIkHpJZINHXuHHiIEcg5PHdeBKkxYaRAc7SIZHqTz5xLgQhFiijU6lWsWbUKDQTyT8qtYROq4QPyktiVDIuqRDrnY1O4GLXwYQQ1UKGpfqqi5dvX79+DmrzuBbzVz1KMmAofVIvRaEs/hS45QhzX8k0tf/g4qqtJ06VLmALdLVSa0GnUqVWvZt3a9WvYrfHMpl3b9v/t2WAX7/YJkg/h3Vdtrg3+TzBxmYciSWb09vJz6NGlT6deXSSjQ8ULkwUJUTvWQiEfAz40RzxWNXgCaWpu3f17+PGtj//O14/zh8Dr0+yK3K+an/zbSjlCArmEEUfwk29BBht8TrH9/Iqksvwi5KmxjP7yoyyQCCnuED/wKBATTeZwhI8/KHRwRRapy8nCvvBQ0TsYaTousb4iUVALPGos6BA1/IhEREIKGQ0T0C7xbMk5mnTySSijlHJKKqu0MkpGstRySy61DAlCH9GSsTv9wmTpRocuyS6s/uTq0Uw4v2uzIUbiRIuQkGi088yQGClzJzXM8+rFPQv1a7iR/jT/dCc8fdNt0YkwbOgPQoXCQ0F/HHkUUk6vUkPBNzu9qlGMKBVVojkdwmRNnQIVaQ5WT5WVJknPmtWqMd289aBCVPSHj1BjUgMTX/0JZFdkYToMI0diTXamXB17diAdRdJk05XUuKRYYKf1tiIMtcD225eqNcvZXQFkao5gJ1KjkACtVZRcctWgEEx6Zdqwz3lPDaRYf/64hJBx//GDEEwcgavbfBsuKDyHtOjXYYrUUNi3SpP14+Km/uAMwQQv0yIQdCmmV9CGNDF5pvJC0oK+ZAnB1DotMJl45WTxaxdnl4gCSZObOT0kEA6tcySQoHm+1Q+QklYaIUJ85aPgXQlR/0o6RzDJ+Ol8Sc2Ua32LjhjmZzmarNi5GMGEEKfBvtVnf2x1+yVX+aU4yEgi8UOvublGk+y+Veo1pD88DPzwfDn2Z2vEK4pEbIfmoLpxyjnFr+3K/zkEzYiPzfxzoUsFvSWZRXKE8dFTt1ANjPhQPVvOHQL6ddojZNoh12uvqHSXbdb998Vubyh34CVSI/ZJCym5eOatYj3i5ieKRPHWlY/+eqsoxFz3wUXiw3rsw5dJccPFP0hbgP9A2nz208JI5fYP8gP5hrS4Nn78oS51+fgjQfk68OUvf/bCSPkESBD/wcV+Oztg+P5XpwYaZH4Am9QlGBjB4iGqIRds4LBmVv8qTbANg7tSjoiMFAgkheYuhECJUMQGwRH+qBDUY0rW8LC9GBbmYJgw0Qc7pjaCycRr/jBgDgfiB0z4sDsmiQT/jPiXQ+ABE4ygIHX4MDAnKkRsf8giBqOoiSoSjhFRmQoOn/gSPwSCii2qH7taokF/4OuMBPmiEuOSGUfksUtdmsNnMFGIG85RIUikIRuHtz6VxKshqBPkPyIxxTA66A9zCMTkvAgv6Xisj6IpTWmOdIkeisx3FFmWQ5rVSIVEEZKG7BMHDzisSP5qDmuz5PnU4xa4/MGVBIFbHFFZkcgcyI4LmoMZgXe8MDpiYMY0yCMhh6OJHAJyu/ylQdQQiQL/lehEscwkI80Hy6ZoYQ6FYKb0tmWtLkZiMNWkiRqCtDd47i1v8zShgdojEh4d8FJNYYQI+aKGQGAKfhLpZVDYGbxAFBJw16tb72qZFW19iSLU89xBF4OHZ2qii7UDJ+FIpp2ogYSapXSINy0aFnV156FKw5ve9FKmaxbiai77aH2i9asuDvEP5TwpTFp2kyKCDaD3ZEpm/pCiuBQTRhBzSEUXAhLs9HQxvWyIHJWWwAUxrEb/42I0qSc3qf4lpEDZqLfmx6CalXUxBMzQRO4joLDah4ZRxVn34sMHRMIJQzCUCBxxElfySMofdHVYSr1Xlzlk6UQoSpEWHLsZTRRi/6X1EZ4/tFDWVH0FsIBhquwots885ZVe5FMJ50652UOpaKESCVGRyhgmqv4qqPSCm0EpcgjqDRS1fPGrSQvih0vM7IqTRYthE6PWXVVWYir5FFx3u5XOBuxmfvhfUyT3HXOVyrffUpxVFTKhUvH0uSqRlJ6gxk3LrlYsh4itUp/W2Z2uJLreHS9WcOsohBxCsJehr1imJxKnshQ//UXI/5ZbX7E0Vy41FcghCjEzLThiSWs8z6EUORJqOmxO4lpJZf2hXgTv5K03mSUPuUUIZx2CEM/MsE5myBQ/BU7BdOKTQ/gaYq2MGDoaTYh+b7JdmWC0KQGeW3RBjMCm4VgsG/97zsso0svfZMXHMCauyRTHYZWIbbZKtsrQwji7ipgWucy9MO623Dd1MkutGAIrl7UyrGcKrMr3fZ/zCunG0aVKtxLp7I3dbJgi4aXKBJlxVYVSZkYMmmsXJjJCKvuHP0MKvAUcyk2OjLhCf/i2IBlzpLXjV0U38yYtbtxNiUiRy3l6UamK8vhEyrzo5lMiYgu1qncjKdu+BI4EVl0vtXBmgSgOyLauD53b+hJF8qHTlIvdahVXa2JvBz8HhkyHwhe7/tI62oaCY65XMifiYS92MTYIhZa97VuDZNgEUSSvfyfYkcXq0eg2lDQx4mdUY4TUtEvVpLQWJMXhm95hguP/uv/xvPqde3SmhsulB14fRe5Zeq3LH5Mt09WH70mD1KaI1wQePi8rcN8Z147Y2iwRr3k7fugTiS5JbqgNJ83jXiTEgTYzToW/XNoYUXlCNPhxnQddJam6dJqHJ3Skv8Te+q6YXHKe9Jf7FdgDwY/BoZ50qq5KIv9r9NW9fpDqZsqbcwL6183+058VzOiWfbrZB765dTGu6m6nO0L+xRS8EkaRU6+71/9r3Tcp0uF9T/qDFQgqwieejoV4ZlHbrviH42GmTRk85K8O0Mb70vKbL0gkLsEhcVqd824X7+hNf3rUp171q2d9613/etjHXvazp33tbX973Ode97vnfe99Bf/7SAcEACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8weaYALOAEbqJXrR14ASBW0cNIYQaClcKBRixTFQZRKk8xNakzpFJjxgUy128AQXsAKeJiNbdG+n/6USQsU/15SFWYOHIpgSyeYx9bYSsaR6Q1FpeBYaoLALpGgGnYABDgV1U5KJb5cSkShDvQcTVZM3BBgtB9crc1CLGoFL7mcUJRMIrxEYp0CKxLgLbVAEY1ARMYgcfTSL2EGJVhg2MyhsCbNMQiFvSWYmgXCJFNFT2FdneHAJqVEKxViM5OAEJnA3R/dTKhRJ8nQScVghZFgTzkhevkg+XuMn7KVITCYTABSLRxEJNCAL5ViMJyADP+AQV3hAcXcZUkgSTyhTR1GPRNeEZgFA85gUxZABcaAKBUmK/PCDCJFRMkKGuwcnutgQl3cpptdlwAR0syFF65cUY1AKBFmMqv+gC3CiS45IY09CNzP5PkfnN0N1FBaIkrQhk2ARCQ0gAsQoBtKROXhAewA5EL/nYEGZdql0IWmUXxqhNXQRCGKJKJwiEuj2jYahlGFRDNDglApgRxHDcNNoEahnjRYxRKCBfoTXS8rIJ9lYNNsIEq8ofaWhlmLBDNzwM/OTkSNpKfFnEZHFNCgoEGJFhuGYjYIlkhuhTphXmDplFpH5MXr5lS3GmISHP0t0EPKlc+x2a7ziONxoUSeSkmZhmGUBfjLIjQNhWf4wj7hpeApxd0a3fBsjchtxktQDjVEhRaYZFSs0dF4nEhl4GZyHPEyjSg6hdRpknRJoKGMpPElmdvD/9ZuOQUKR8Y9kgY28MpcfIZuk0hBkVznmWSL8kzmhGXZGIzr6Ij9hl5UF0ZN5M597wT1oORXsJoQV4pC6WRCRFGpTCRrs+TkhKBAMKCmEgGWtuUPwFY+IJGmG0VO9KBXNhqBm8jCR9Jgh0aC3x3DYmUBbKHRhp5mi0kLcuJAORhh6gUstKRXwY2upkosEAaBXJRIqeoO36GACqoXr5aEZIWeMyHXxCURo8xY3RRX64qOp8geYgC+cCTMWORAqqj4a+pUkqgUyehrqpQlEKDnEM2Zs0Vs2wnI9Q5wVwkDv85KjV0VmSjkFBzhtMw2pN3oV+o4dwW7hmWtp0VqlBTyD/3MJl+aaMoKoDuFVhAoSJCcd/lkQ5AkYSwABelASB0aL7ck2kHYJ/TgWnOVgEDgHiWM5Q6OGpwpl1PKQ7XmpYucRyLkExlALKhAAcQZ/zbkQeMCfkDYHJ6ecNzEiC8oRl5qGxipurCgYy6p2J9SEJNkYLmAAtbCtvWoSyFmgDUSiRbQq+pcVKqgTmPkxIcONV4lItJl2JFqVC7GMRLcE23qv3VoS9Lqjm9luHSNd9KIJrIF/Y1mwBnuwCHuwdbGwDFsXCfuwEPuwdbIT0Ek0hMIqy3qD1fiuFCqu9JGpA/GELvQPn0AA98qtvgqqz2aDkVMIrMo4MBuzxbkTgOcv8v8yKNUlLM3zpVTjmCl5P0Sjfl+pXgo4EBZgsic7DIJgEu5pTCgRCYHwsjI7tVTLVAaGXw92MIFAPJhjWXY5EdHqYJp1tCdbCyFgASfhVXl4PPhYiFX7tmOzWoZhWWvLEGwaGpv4D147k+jWpwZBtidLAFdwEmL1tSohMRVzMX4Ct4xrLcFKFnQbSCEkg+hDkVkLERzqfoC7rcbQAjzAWxkjr5FDZIRQug17uoMTsaoLsajbuq77ugzLsZCLX3MHYn1xKUDamPUZER0IJ2RFDeBQtgYAACmGMiGaLFdBkZV6g0x3LY9jtz77EH17RJ+gAmXbByQAjyuLrMh7ExRZhf//sHDZc6bv45hAFarb9xAj8AG7eq+J4ADwCEyT2b18ljDV80OhEWmFZLkb1bvsOBEU8ABlWwsRgBIr9b/0y2zpGh7Nyb8HEVmTaBEa4AEDXADJcBLodrwJHBU2VznY5lDmq6lrB64JQQwxMMAPgAKgC5wbjBVLd2v6CzjPVj/I+QeyKxARMMCrIA071jYI3MIi6q8yZKeF2mJHI1wRmhEdEAQnawwGcADxixmjCcRLMaK9UrscwZufRsIQcQDaerKJAAIogW4jS8VJITeQOlnS2axlHBLPELxlSwkUwFvn10deNjGJe2mZ1qqA0sd+/MeAHMiCPMiEXMiGfMiI7Md+/wsXPYqZY1Z6rERyaloSKCDAZQsGaRDFDnkhfkAIPOMzjRvKomwmb0FAHgsqNCQQo5ZLI4FuK2YSaHADA3wMiDDGdDrKuMy4jKUs5BOMqXI2yAJsN6yp0Lm8JdEBfTDAXTDH3rrAufzMMktnYKEvl3DKdZrKCZFG3sURESmqKFEBITDA4FABD1drzpxniZzO6rzO7NzOipyxQdHJrnHOsNpfISXNFAGAtwKUKYECFFy2iZAPxFCo1XbLjkEo3jksxZJyZnwRnfzJBl0hjABjFAFoTYqGCjiY5aESIJAIA/wBz9Ck8RPR/FN0DZ01O6O4JM0mTJg1CROsNnordtOlw//BswgxDuFctkEAAgOdz82LKnwAMEsjgyD7I4fwO7QjiGFZOI96ztcy0bTFEeHmJgxXtLnxbMZMEqRQAANcC3LwuYnWrHCiCdisckeaN1tKxUMJs0EdCBT4EfVUeZ13nS80nVNX1A6xBi3Qvu67BczMEA/qbhStHUOdv2lNv1JFNtJlrFFtEqZ2Qag5xQaRwSoRAP9ctnBQy9VEoo4QmDpy1piiCbE6J678rxd7F2oDTio5dIusEBoNKsqJCC3Q1RAA1nSEoE7jJviLKku4KXOCV3nGXnNwCWTJvQjBZgdIEHVohxBB04KB1w0xAgXA1/eqAwUgBFZJco4wpRgxrGX/syqJYtOzIXTnYn/AIiyE0DzGHRFpJNe5AdoKc0kcatUocQBwrNP6EADKB6HDrMrVlob0gn91UbqtU+AGfuAInuAKvuAMvuDwbBiPzbxh09oSIaQyrRJoEAHH0NUGYAouUDz9TWkFDc0kXi1c3EMJMyti2kaZSq/2JN4HQQ2UQN332uHnECAhrhCOZs0ljssQFVq2YsP77U7c/ZUDuBIVAAFdXQt9EAM7kFAsNwdp3OOMu95osYdeNGnIGd8YiAlDMApLnggJ8ALRsjVdIz1Ujsv4HB8XdqPNt6mI9LgPUUnTsASrsOS8egZ/LRNHrTqDUzgWI7DgMuiEXuiGfuiI/57oig4wVn4Wa4Og4onBTEPhzHQqnJADd77kx1AAxHvS3yeOMoSj2TZ0Jm13k0gMayAHeF4LqyAAaOvpjn67qLLmWPUzFESEdu0YYHUAbqADeK4D6ODZsL6Uhc0rJ+5jF8YHci4QADi/AmEBN/DFZfsA67FIw64VLzzrhRcYOQ4RK3kijxu21BNRFHAG7Ou+9ACojvGs1z4Ve3JrjoMbKobFKRGlqmGar52aDZEGWwAHibAEE2Ssb93u91hAkMakIXtssgjfghcRHId3xDACxa5kvT3wBM8TzUasyvPBB4Ffout7ba6lKSRftJpAJuPUQe1ezXPx9EgIBv8xZxNRq/98uS+Bl9ci6gnhVTCZEXvC4+M63NfVPMbC8iRxpVMOzBdUdzLRd1J6RTX4pT065egcL4LiLlZ/9Vif9Vq/9Vzf9VrvCMv+FV4GZgZtNghfGwpPEzYfdmdHECvFr4Dj8mie5nS/MQ8OFYg7pxoDq95kWcc+EvJmPpEmbz2yT1tTzU5d9yT+8VQBlhWDMSw40Te8yiKFE3drLX9fqHiwL0im+J5f+R9Hun/uqD6z0vwD1RbZXY0uIbKeKhq8T19mZHrcL676+VRLQVIxrJmmj39S+4sT1JhwRmYJGxgP6kDd0kRfE0kos0UT/MopRnDP562vPOye/DGBhmKT8pti5aj/F/Yjsdb4KTLW3xJYrjHSxQiasrN6okzdzhErNeVm4/zjP2VC6C/zgtDBYhcoBxT1BBB/1PwjWNDgQYQJFS5kWBCTP4gRC/3zE4hRRIwZM/KZg4nQwIYhRY4kWdLkSZQpVa5kudCPloyEWs6kmfBSRkcga9Z8mHGiQTWENP3RWDTjH0aaAuHxs9PpU6hRpU5diCejlkhUtTI8dBHjnK0ne2L8qTBSoDkwja6FqIXjpUCEIukMW9fuXbwlAx1tmnerGj4ZL/ldeNMnybNziLJl3JYPozlwC8n1Q5fwZcyZUWo6allzzZcZMX3+Z5hsSj+FLjlS29h1RC1a/vBxBFmT/6ZLlzAFClTI92RCwYUPJ17c+HHkyZUbx9Pc+XPo0Zv3JW2360bP1VlaPZyZc3eWhyKpZrT49Xn06dWvZ8+e0SHtdQHjzB4/ZSGNZfMempM/qho8AtGkvPYKNPBABNvTz76p/DAPopwYnGkv8O5Sw6vTwhKPkEAuYcSRBxMUcUQSXxtNQq0iaQ3C+lAkyTSJ8PIjsJgyO8QPPDjERJM5HOHjjxVLFHLI9bJykSo8gozwyJS+w+jEsCIJUQs8mDxEDT8iyZGQQnjDJLdLbhNzDjLLNPNMNNNUc00220STETjjlHPOODWCkkmpkqQPz800ugQ+rSjEiEo+C81LUIgYMf90KkI0WnJRkZyMiJEWZ1Kjv6OMhHTTPDvjFKpGN6LuU4VghOgPTZ3CI0R/HBmVVFhZUiPEKmPdKVSMULU1IUQjwgRQmi4tag5gdzXWJFMHO5YmPQetddl/CgnSHz6eXUkNTKb1JxBouxUptIgcKdbblJrNEFopi9Lk1ZLUuETbasmVt9RB2Z3XpHQFG3fXC42aw9qQ1CgEQ400qfTeZdVY8U6EUZpRI0q9DURbf/64hBB7KSIEE0fYirfhhvGD7WCQG1Kj441SPdYPlNf6o7YPQXRNi0D2LdlbTCHS5OaV+NNIiwWPJYTV9rTAhGSed30Q4KRNGgsjg709JBAa23P/JBCkm47Vj4yy1johQqblI+NdCUkrPUcwUflrcnFtlW2VHr4q6IQJWU1btxjxyGu4Y31a2b5PEhZivknFMpJI/Kgs8KQlpZtxkaTV6A+ZILe825b9WfvykCKp+iuyORe90AcLF/0QSWHjdnTWFz0k19ZNGrooRzaP/fbq1MCID9xJUiP1iKLuffjPuI6Id+JFmv3no5N3Pi/jIUL+eYZ+N+qPQmymfvuddIeN+4YiyXz37ME3f6cVTSde8qL4KP98+FXKvPL4EXKX4j+wrn//kWDcmX+E+AF4sFkXAA2IELf9QXv8i0TOisKI9x0QgArDCP0kWJAGskULmmDaBc3n/0BFefAgAqTYqS7RQRE6jzsRQeEFsUW0XGniIym0lXhy1KVAfEk3vSEEU5zyuRDS0CCHKMT4jJI2PKhPiNDbWI9g6DK9YYwlbvOHBZdIED9g4ok4UUokFnjFuxwCD5hgRAnXw4eLfZEhn1MgGA8iRk2YcXKMgItclOjGk1SkjERqy79OskKIMAyP/4DjFhkjG0ckkk50mgNuMFGIJA5SIVk0Ih+lpz+SEExzkkxIJMgoxxL9YQ6BCJ0IiajJxryskbv5DQ6/5MSZNe9bKxIXJxUixk9aEmItlCC2QEmtjkjRJABCyxb/wEuDPM0fgrRlAMljSBHN4Y7O+50cHXGxaf8ixJOfE41IDsFNZDYTKJHgEI989Mv06MqF2VqLFuZQiGx27l3qUuM/IuEpcV4LS4rjp+IQ988bdohARSHUAVe1FkbMUD6BYNX/GqJMsOQTeoGo5OPANzjmlXIq7rKTSMa3OonmBQ/c9Icm6jk8XxYlfyfVStgyEk5wRcR2IdVKv3Ci0aYdLnGVyY4axnO2n9WsOuaiVj2pKBCa7seBbbHi19RgkS3K5g9AYow07SOyiICUIaZ6T1LzosxAwi2DIvoYgxzYxoYcYnyA86pdXJoRYjVNgCMyGksJQ8EYhcRBFWprWFgGMbsai30I4gMmjwSjIDYEkP7ASl/DaCp/dLX/YTZtH2TmACcf/QhIsXGLIzRRCJxWJ3qMZWmv/hBax9YEq8Fr2EEdZVh5zY8kqatlautCVH9YtCE44pIdUQRWajVVXk+LqDfH51DbbmWxjSWJHy5BNDSiNiyUfVJgbTVaLXhtVnxN7lRWWzGk+WGp/pLuVPKVq5nOK3PMXIiKchXP7vZvTwx568x0u5VDANeqTVstUknyXfbG1ylqFdUtIeuaAKeoklpN2nZ9ZRIHZlfANZ2SUAtCRKJpwbO32aN/7oIHVFYsnAhDlBakO9rcTlgre71KRzAB1I0QYlyHIARJR0yTIholYn1zcKJMIqnEqjgqLD6PSRdyCFMxdyoj/10Lg+H23fse5J4Yga+QGfJX+4pEmXyockKQjNDyNixzJi7J54Rr5Z1MTY7CixROrDsS6u7uzH2bcrjsCiO2ovk/mCCpxcpLYKg95WTDuvHXeoXchqw2yHqWih+4NJkwF6THYd0JKhkR6aZp0smThB2jC+XeCvJkbsSbdIpD8jqMvNnTl1kupqV8lUJDDrdzNkjpVl2oXnG5JeOLteW+W9A1YsTVt86LqYpbrm5uT5laoPU/MpdeYmsH0HlNCcH4oGrLAU+3mRt2tC30IAk7rEbmA16AP9dtb9tlscfWy+7iB7wdH2RF2E53sTMCbYUQLMHOgyzNijXaP9SbT9/EyP+iRbK0/fXqVGrDUuYMLnAGLRbfB/FeW+jNOtyyJcoQJw3BEN05dwMQy4xBK8ePBMhwj8RtDz+fmjXYa5Nf5nN5bojb2M2/+6kU5jEnTIm9tnJT2o0RtHnnxXn+7a+QBJAsP3rTG9Krjdsz5E6n+kgIjpERV5y0Ved6SJbbbII8aOJdpzpYf9UQB26a7Gv/x3hrxxBEMZ3tVfdZwTJW563PXe+EHKA/5rA5se9d8BMzSmHpQjCwC77p4mOLH/9BsKgr/uiFiCqtJK94IpLUKFow+uXrjQcYGyXynqf6UzW/TNKnniCRuASN3Dl21c+9y7Gnfe1tf3vc5173u+d9730Y/3vgB1/4wyd+8Y1/fOQnX/nLZ37zkxcQACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHZULAx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpeBCoqwCXeoEf4YfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPhloxRCruADDKACg5WlWrZYgMpEEoZSvsjYqL2Q0HjONDYjdKxkmXBl2QBfv4wCMKwC54pAhvgN9A4EJblD+KomYanEHdndMu3MSK3EQ1JPcQYFVKUmGTUF4EhA565myegDqwETJyHPEyjSg6hdRoknBJoKEFpZFopQ0W3EajpGCQUGe6YmdbIGNNwATawm7spBgMgEpRJbA3/QZaYF2RV9GAC4ZdhZzSioy/yE3Y4SRAfmTfTaRjco5dRwW5C6A8KAAXc+ZlRMBKRFGoyCRpOCRE7WBgMKCmEgGXs9kDwBY5wImmG0VO3KBXNtp9mQggDQAb/uQutwA0CehnoNZVttH6W9VND9wd3KRGLuR7QWI8ORhh6gUsTKRXwY2upMosE0QmW8J828Agj6pg3GIsOVp8JNHRTR6EZIWeKyHXkiRmhCJBPcVNUoS86miosii9RIAIfKgrOIBIDqnLKt0Nz5Y/806IOpV6aQIQbKUNz0KBs0Vs2wnI905oVwkAJMQBi8KH7IAlimqaUU3CAA6EisaDy5BHsdo25/5YWrVVawDM4l3Bpt1Y5jdoQxVAKyPCfWTAGIkFy0hGfBBGdjGGbEHFgrvgRL4kqfHAJ7NiXjgGBc5A4ljM0aviqEKEEJ/CfXjABmwWqHdkRsckmL6iNbPkRBYmnfMCVtBUWIzKaHQGqaciV4jYJbfCfpQCthCeEB9mECuluRxib+Hkw7dY0q6J/WaGCOlGXHxMy0FgH/rkLqoAADimsGkqTC/GLRJcwiVoS+nqj0FmuLDgo1cUa+LecCJuwCruwClsXDvuwdcGwEjuxElsnO6GkREMorKKtAzEGVGAJVeBglqmYGtqAHPGELvQPNmlMJoGmNhg5hTCrjDOzNOuaO/8BeP4iLwRbL/nXPFSaEM0wD/zzkKvqTuqnluqlgDV5KnO3WZHUr38YCDJbs1RbtUxlYPiFnqcaCMSDOZYVlb74aZq1srfCsQbhVXp4POdoiFbbtmOzWoaRopv0pqCRif/wtXKIboQab6eStkglI6LaLCxnMX3Crm57uKTCGXILkUsjg+izlgQIju5HtirJWxmDr5FDZISwuRDbuUBJsaArsZ47uqRbug87smRhWU1LmrjpuO9jKVqbfSjzU6KWjKgLkShzoclyFf4ItTfIdNfyOAwBuQ+ht0e0loE7bc92oLvrFf5Yhf+wcNmjpiQJu0CFqtv3EGiKuQcDTHDZvHz/ljDVA5mCxaSnar0K0YFwIn7YO0UnsVK0C75fQbaowgimirwHEVmR2JZiVAICgAYngW66K79RYXOVg20Ohb6junbjihBNMg0pEAS18AAoYLmpScBYsXS3FmkR+mz1E5uVuxG2YQ5wUAsmvArSsGNtE78YPBUZqmR62hHtO1XfKilSVggzYMImbAwGcAAnIbk/28LiJbCsOnql+WkN7BBXYAA6bMKJAAIogW4pK8RJITeVCm0/m4GsersI8Qzg0MQmTAkUwFvn10deNjEVc2SYti60Cihu/MZwHMdyPMd0XMd2fMd4nMdvvLdwkaN1OWal95uh0aYlgQIPAMa1AAZp//DD6kWcfkAIPOMziDvJlGwmb0FAJRseNNSGp8K9DIFuK2YSaHADiHwMiBDFeFrJqny4jKUs5LOLqXI2yAJsXDyqSuq7JdEBfYDIXTDGJrGgqxzMk0xnYKEvl5DJDnapCZFG3nWyyxfCJ1EBIYDI4FABD1drhls2erzN3NzN3vzNe2y2QPHIrpHNcKIJclqcsOF7a8e2N5kSKOABiJwI+UAMMlxtqewYhKKcw1IsKUfFF/HIkZzPFcIIMEYRgNakaKiAX1keKgECiYDIH/AMTRo/BM0/zwnQT7kzF+POGrOEZ1RDCWOqVthCdqNOAxXEBjEO0wzGQQAC9kwRS8euy//KM9MTw0J8CL9DO4NIF4QzqYWLYQbdrBsRbm7CcEqbG8+GyyRBCgWAyLUgBzxwJ9J6zpvchkaaN5ggzgNydDS7rIFAgR9RT5XXecP5Qlo8dcnbEGvQAsYAxomwBb7MEAXqbgetHY0bGnyw1fIrVWQjXcyahaZ2QfjTrQshwCoRAPKMyHBwytWkoY7QlTqS1ZiCzrPpG6DcMSADMHehNuAEkUPHx+mbMRZ5EojQAlANAVNtEHXtTjTaQFe8hJsyJ3iVZ+w1B5eAKJwyE2x2gKN6Ye8EESit1ioxAgXw1mCsAwUgBDVJclOaEQVZNquSKCptGkJ3LvYHLMJCCM1z2aL/MmgJSdkKc0ngmNQocQBfjMhBoA8BUKbXVMsqV21pSC/4Vxeb2zr4nd/6vd/83d/+/d/+zdV6Mdi/GzaiLRHziSPwzRBoEAHHANUGYAouUDwLnhv4LMwYXi1JPBtdd3NkGjbEmRH6ak/VXRDUQAnIDcYRfg4BUuHFQT7InOGrDFGhZSsq6d5FJIo+NoArUQEQANW10AcxsAMJxXJzcMUyjrjerRZ86EWTNqwZbRKRNQSjAOSJkAAvEC1b0zXSk+SqTMz6cWEz2nykikgkLdzkMQ1LsApAXgsqcAZzLRM6rTqDUzgWowlHBi56vud83ud+/ueAHujUCx9rs59ml4X7/3jgzHQqnJADbA7kx1AAAKDRb8GMzingBVHmRKdrkiV6xLAGctDmtbAKAmABlI4WK4SxoOISUUqfRJjWjgFWB+AGOiDqKhABpn7qYRFCGp5QF8YHZ16TSz0yFnADTCzqw6APLxDTup7BmHBr9pswLu4QEXkiZ26KwxFRFHAGH5DiQG4AHuANKdzsUrEnt+Y4uKFiq5sSrS4dttnQ9EFzabAFJSzqJkwACRAKFZAM5E6NBQRp5isQxcR4JYGcbaTjnJSDEkEMB9AFx27vQf4B13AGFQDA/Z4vUtua6J4Q+OXJQiTmLJpC8pWPFYEGJNAF9Q7xTgwOebAFZzACmH7x2v9LCP/+MWcTUaNGH9M+bgb52gnhVaWNEeNAB3JQ6yqvw0sgD6qC29fVPMYi8ySBpUj+c1dN13UnE30HRAhPEDUIkCgAC10QAt7e5iWQZ9iis+6S9mq/9mzf9m7/9nDP9o4Q7C5pzLBs8wH/EGpWEyYadmdHECsFsBzxCWtwAx+wyxDOCV6++KER80whMS3X5Ydo2W2JXxvOWuKNI8+4UgPMEcnAAw7ABBCA2iYsAIx/+lepFlpDMfxy0QV916dxKjtfQ8Db6zERAC9AAvCAZKiP+rOvExGjOj5dOEjm+vwz1GzYXUu+a62bKp2/Vl9mZJeGOG7c+25LQVJRkJmWjn//UquMU9MhXYDrfLPXyapMCPV6grhFgwlErXiktROpzivLI9noDxNoKDbLSmDLr3IjDRD/BA4kWNDgQYQJFR685M/hQ4gRHf6ZU8jPQowZNW7k2NHjR5AhRY78WEjiSZQQtfBhpAlTITx+DpGkWTCSFpWRau5kKJFPSolaGGHCo4bnUaRJlS5l6vGQI5RatPzhw8eRozmaLr0khCeS0aY8TUL8AzYsSEwSC/3zE4gR0JN85mAiZPbsXbx59S71gxMiob15G0J0ZDdwwrQR1xJUQ0jTH7gn/7QMFPPwZcyZD+OJqEWnZqWH3kKcA9pgYoiLEUYKNMdv5KByLwUi9NX0/23cuTMGivjnou6aan5CvJR7cOqNrOdAhg10JaM5swvV9mMY+HXsYTX1tp69Y9+ImG4ff6j6e6FLjl43hy2VqiPomrRuDRSo0P3phPTv59/f/38AAxRwwP/wMPBABBNU0MDfvAtttIf46M5BjThTDLTtLiTpkEjQY4Q59kIUcUQSSzQRNkZmohAp4SIqbMWS1MLskDlkTEoNPALR5MMTe/TxRyBDNA/GmvwA0aEXieSINw33UgPC8vDikJBALmHEkSOD1HJLLoEST0mebnJxQjB7ahIvP4b7S7ND/MCDSkw0mcMRPv5Yr0s88wzxszJrwuPOJPtcKEOIvrwrkiy1wP+DwkPU8COSNwkppD5MLrFUPkzn0HRTTjv19FNQQxV1VE8ZMfVUVFM9VSJDBaXpzzFdHVSiS1RsikmVFpV115pwdYgRXmsiRKJAgyWI0IcYIZMmNWrsjU9jo+XIwofKknakYSPio8FryZsIWp7wyNIfR7i99tyE1MhSV3RBypYscKP19SFMbGXW2YjmsLddfgnytrh+QYI113YLudMfPtgVSQ1MDvYnkIAjHgi8hxzZV+IKDx4yWkRP0sRcjtS4xOGEMZaYPC1ANjmjjiOqFd0nUZpDYYzUKATKiDRZduVg1VivVZ43SlMiZdsNxGF//riEEJXZIgQTqFIqOeh+x3L/SIudqT5Ijagh4iNeY/3oGqU/4LsSy/YCuVhrafH1RxO2nXL76o2jJWRcE7XAJOu4ZT2S5r4zQg0inds9JBA1S3QkEL4DF9SPiBp3fCBCDt62X0JcE9ERTMCe3G7CPv8ucboDbiw9h5+jS3LRBR0c4NY1avakoiV2NJJI/KgudpORrZv3hAyW6A/AgDd+17E9P96gSEh3aI6ml5ceuyNZN/4QZB/SAuLpu8/uELK8z+jukxxRXnz0nfQ6/YXUyP6hwtmXfy/II5xfIfKD2vt+/puq3yE+9A8h7iNbIdYmQASCRA0qSeBBIjE2rxmwgRMEyXqslz7hxUWCFORgRsZW/7wOCkRkSPsD40J4QoOQB24oFIgf3qe9j7EQhe9K2gE5GIm5RYQRG5ThBH22ph4KBIfO0QTggng/twHriC3UBNImcgkjLlF81HJIFFnIMLyRRRN1kaKsOPSmSQWiUvSZjmV4kjgldvEfhygEBFHCuaKo0Tt+eNqcspiSydAlehqhoT9AKEc/YOKOLtJEICJhQzlKCQ+YYIQTScSHpSFSIYn7gyR7eAg8NDFEk5lNbS6YyI+0pZF68ocWZuYRKvoDaKDE5GPyVrarqEpVWdkKTD7JwkC6kZQIM+FGcHY+OUaCkY7sEkUCscdL3kxEZcsKJuyDH0pdwo7t2V9GKIYkS//KEZPD3KUOrYhChhETgHNhmkdw1JpB/uGbBBmcKkEpNA8NUktzuKX83EdMRyytng7EhPPolZFDkG6d79xaJKgkJzqJc0R/ACYCw5kSUxZinywbmccsGQnuEDQ4jtJdR3WHO5CCsUo8OomiUCiulDCCi3hRQyDGtcKFtLM0GsVMW3T5u/7NrqSYQCZTRMYqD0aEezTFDB6cp4lseu+hw1MbaCoXkYFe0yENJWpTYuainmrtdrmrTnfU0CHNBaWptxkYAC3ZR2tV9TI0Csof+9ZSkkblD3MlJj2BYzWHDFUh3kqRWjHTToesMmhDDNLUruO2SmLkKS7zK2aemq+knsv/hVrSW2QP88MoYcRIZ2qsXsRGNMsaK4M/4kMvHUSeNC4klZ7p7GEO4S1/9BVjV40LdOZgKjrVyU5SWYkjNGERJf2vlEmdl29aexi8OgSmAUMpsUzbrw9uJHsWO25gyuoQnC7ETZLyZHYAizC3BmxwMwUoBJdbXbyslqoTuwTeIJnVvNC2UKHllXCxthF1cRa9Z0luWrWbw5NAzzQtg5fWxibYhIipWhPdr0e8VayDPLY92T3LIb5rV63h1b8ZSS6CGxwaCF7uIK8lkYfD8sCT6JVq+f0nR9x23w/fhcXaG6tA2Ig3LfhWPqO0UV7wgLOJDFRivkoZR4TrDwrHmCeb/+3MXDARVm0RYl+HIITzhFyTNqKkdoGbcWw7gqzUKtl/8pQIUhNC4pyExagpUXHgkptkgmAUIgwWs0Y+O2HBaYvOCEEz7eDLs7EVeSOJC2+dQ3M0uMQvI9Olb0bk67VCT07OFYsseWBn6LAwzHlK+7ONzcsiXZ5yefM6r0LwGmZMh4WO9ymnArNk4o8AmRGd7hvO2owQ4f4h1X1S8EMi/ZF2agHOousykgEakUbvWjOrpfVqOnPl1l3XjxmpnrLLNC8JkQSC0I5dck26kMQ129qg8RZ5BRYe/gX71wJJ3rjBtFjkhARKfEi26N6X3bGJ292Z6TKMPXLkdYvvfR4O9/++wZRKcy9pfQl835YJsp56G/wy3lpvQaAE6/TBdnv2yrXE343Gj/yNgvOaSOccNTZUe9xBqay4CFUSceNJGyjDVjluoFTqhUwaYSG8M1wSW3MiUdHf44NIyhN4OEd+G+hEStylMULDhHNwhJLh9tJNQ2TJ0dDoFKSylaxSEZhbPTBdjnpCqLh1sae9I/Mats4DqHa4hySgUHX0y+N+d1R2JuACOVLL8Y53wNZrIW679d8Nf5Acmk8hvkL74R3P1jI3TedaCLvjVY49mYGt75bnPEIQHZfnQmnvnf87ilMiaijRnPR3L8Qgp0L31cd+IGz0Z0krL/ua4wHKKFE97v873tLaY9z3pI/EJYZjSr8Pv/N7Vn7znf986Edf+tOnfvWtf33sZ1/72+d+973/ffCHX/zjJ3/5zU/6gAAAIfkECQMA/wAsAAAAAKQBHgEACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27csD0UiVKgQIT9w8+pFSoiRFn+AA/+5hHev4cM5IzkKzJixlkKII0t+Sehv48uAA03ezJkkHsygAUfqTLp0RjV/LjvSdOmS38aMTMueDRET7NEE1WhqXJi2798E+TDWhPBQ6sCYgCv3rcaxmoSBGDtaTt10JMaxE/rhXb375uuBsyf/XBxYs/fzh5sH5rPQdnj08Pce96dl4XbGvePrXys8MEPygM2x34BqAejPcwoV0hhkBDZIloEIJnRIf4BpgYeDGIIFIUOEXGZehiBmNZ8/Du3WmCP5hahiVJbR59AhjFz22Io0PnUfYOw5pEaMlyVX449JdRiYgA8dcglmHwKppFBHIicRHhRWmOKSVO5kICETHWJiYJdU6eVO6gUWoURNAjbdl2jaFF1gZ1IUpj9/pCnnTAYmKRF4ONoUCSaM8PGHFlr8wYcjc2iCSSCERDLmnOh9hp9FczBGpEx+GBhaY4MaWoiijFLHI2DiTSRkYFhSOuKlqMK5GiaJLtrpZqMC/3YhRZG06A8fh8z0aaq8yjhooZccWggekfihhquvpoWadBX5ceqsMb3pmK29VgtaoII64ggjc3Tr7bffMiLuuOSSq+256KLLx7rsttvuH/DCu+62hWIy7JQ/+VGIa34Cmu0crCIL1yGWQhuRGlH60+VMjuJIyJhq+IEHIYFcokmf1Fqr8cYcd5yqFqsVgm9Nh+ChyamX8qEJHrnmBWNjxE2khqWMtCxTrDHrOBcmmjiCssdABy10aH/MUYjALkWiScbVDjbyWZViirRCM0tdE84XqRFJIZjM4QgfTA8t9tjVasFIITa3dEghCQM9h8FnRXIJtVrgFtHLjP0xNUt4+v8zKUdaT1xIIJhY7PXX8AJK9uKLa6HJ0yOpgcnPmCneKyN2i1XyyZXD/VCkeUPeUt+htnSsH5FEgsfqrLOe+uuwx566H7TXbvvtxh6r++68P6c76nTxzAjll72NkhpzX6oFwHj4YbPWXDsSNmCa7G2VydNbSFGZFWZOk4JDcqYGHnxOD6r3H0k+/WCRpJ2QGoTMEfYfpW61dtsnig5dY3XbNP6WgPERaUp2CfwNyXoUWRvxjCezQBiwellRIKr+EAj3PaRhgfGcS/zAOcygjzRKC5sWKtgRKF0LEwhcyCEIgT8+fBAqJgzN8o5WkWUxhkEyWRNocuabQzgQNCjSiB//QHcZCqbwRYHI2IymYiSiXYJlGCFiAGkCwOJZ0DcsrBwOE5jEyqEQJGqQIpekgrfiQTEjsfIbTdyDGT5skToSLN4RCxLDy1xijhQpRMbmcEWklHE4+oOIcfKGR5FgEDB/YMQT9YO8NgYyN1Uc0iMzEjXYFJInkWTEJB8CvgzOZEKOeeN+ItE27TmEED/jgwZHoiXVXDInnayQKDUSpb/BRIeAmeV+mngZXeZGjBXCRB9LgkszvdImfrCVKT1yyE1GbkS2xFBlPKQQVGJmDs78yDQZw4dj0sRS9fMIAKPpElxqIZvd8UPbBPhLzNCPYdRyhDdjEkt/sNMjI1rlSgY5/8Ya7ciOBbHmZSBIk1qdaJ4uUYOtHDFMjLxJCw1NSRoRupxWNmZhunGnPl9iUOxENCfc88cLNYLB0r1EiuRcUUjtiYefERQnHQ0MD/N10ZFgTSYKZcxGQ8TGS/1hpzLBA7Xu2RMA6m0ksVwYPbn5pZ5i5qU8OaQ/fHmTG2WGJEmdiRSJqiSnCiacPqmnP4CqVW5+FCOxSqlKDmErdA4ojJhhBEVX4tRz9sSqUy2JVXMEEwzylUotBU03i1LFwe5Ein8dSYvqExPuKVVJh/AqbM56kz+qUSd4BWtIDpE3mRiIrA6qJKZqShSENcZONQFgYkWy12g1Zq7L2Wbe8GDaG/8WJaaywklmT1LSmGCwTf6MpN8QlEzHjJQnabSrTVSLkp4+tiU91cKgtsUt1tgrUc4bZSnfeMijEsWpam1JcQNDVY/sSrMrASav/kCoSwwLtm4pJo7wVUyGFmVX/kDtS1RLWUq+NiYG3Fgi3XtcyfzTjsOs4nOBktPA9I9StipvR7gHXJcIV2hmeyJ8wSLQvKGXIARrzId7kkbDwoS/J+lbXqOFX8Y5AhPtQwwvLdmQ8XaPsI0J70nwKuGN1BaR/U3J6VAnOMJpwmvEQ9XyHqYXUiIJIiXe8ElAaduT5i3IFnEyY/QLlENIbF99staSsdyVLmKqwAcBb1FsTB+3knT/QSXxIbVMmhS5FKJnvXIcaLkC14G+Er9cDeuJyKwRKuOI0BFRTBGlbJOSlS9VfAgEow0yvorNgRFfm5ciN4XoEqJMCyNuiA09SRQFsySkoT6NcPngZqIQMMAV0gSaZUYITcCaf0abNENmLJ1WCwS3yhXKjwGTam3meCSR+JlcveKHQFjqMozY80LUUIgWi1nWKREtY4SpkXqaOCjA9nVEnOUYcStEvvTh8lbU4OxLOULaBvFD8sSGOZPosYjwZkgVZwqU+nb6YAnrcUUkq8m4zTuusy5IJNQ7NGyKpM85lnKIt1wUMQbaI2LkN0fE+geBd4XaAXZ4jRnuYEUGgljH//pHxPAQiA568d8JCSz/PC4RNo+1tKcqNkYKq2sV+2PZbsGDtQFzR6qtlJswpqwfJifYhL/o6EE0ZGP+YO6VqDjYHwkp1jtiaKLvZeGg6ThCCkE5LVzC6QYhxLPTrREtXxTmDinmt/tttY/UNd8QqafG3wL2uObHD0N3I9z/kUU5XsTMs0WJGHWsEzHWzCMr1XlFum7fyChaRiREPDclXyTNz9dN1p6DrotjqQX7ZNj+2HsCgalujaQR7WvpsHTWPsLBH0TbFcq3bB1Mc46Qm+JDsfnFx/3s1msEpQPEhPlkOnqBSNbjEO910qjF+ZpI1fgNkTnwH24r2LsF8CnDO/9FtO8kDv2M25Thn/hhItbhT3uloC6JX3uy8HF1K1iBuJftJ7zD/TsE9wpDNavmfSFRTFv3E151CWQme7lnEo7FEw02QZsWYy7Ba9SUEocATHx0EOTHJc1HJlNXdSqxUlGXfWtXgiRxXsjFMSDjXh9oEG4XGqKnEl61gQPRSPiGE2JEdUQBf1/0PoWwdqnnfwxhKy94ET63MY7wRESIEJ5HHyjDaiohVo/3D3U0HEeYJfjFg0NxdDPEKYHzaO5UfafRWT0hWRzzByvThAIRfQfkhvSxfhWRRj/HQWMIgZbChUIhVhwDVSZBOj+hNalTZMIDNtbCPp4mI1t0b6elEkL/xT/XlIVZk4cimBLJ5jH1thKxpHpDUWl4xiuOgDYOBXVTcolvlxKPKEO9BxNVkzcEGC0H1ytz8IoagUvuZxQlEwiv4VM/OBExiBx91IrYIYlWGDYzKGwJs0xCIW9JZiaBUIkU0VPYV2d4cAlJZnbOZIGItFMWJR1ZCIf0QYY1IYzkhYvk4zV+wl6KxGQyAUCreBRyQzyOk0JXeEBxdxlSSBJPKFNHQY5Ex4ZlAUDiqBR4QHJa0IsHkVEyQoa7Bye02BCXdymm12XABHSzIUVyiBSSQzlidxCMSGNPQjcZiRA4WDxDdRTa+AcPyRYYCRb3A0SZgwe0944D8XsONpIB/5VKF0KH0yhqczE4gRCUrTIS6NaTe9GSYlF4dhQxDHeMFoF6ymgRQwQa6Ed4vVQRezI8EzQHzwgSqSh9pYGUmkN2lRN2A0mSlhJ/FhFZTIOCAiFWZFiNzShYCClEpWSUbyGWY8GWH1OVGnFgjHGWhIc/S3QQ8qVz7HZrvOI40NiN0rGSZaGXZAF+MgiNA2FZ/iCOlGl4CnF3Rrd8GyNyG9GQ1EOMUSFFghkVKzR0XicSGXgZnIc8TKNKDqF1GiSbEmgoQWlkWilDRbcRm+kYJBQZ7jiZ1sgrTvkRjklsDUGWmBdkVfRgAsGXYWc0oqMv8hN2OEkQH5k3w2kY3IOXUf/BbkJYIfhomQURSaEmk6CRnJ8TggLBgJJCCFiWmDsEX+AIJ5JmGD11i1LRbOVpJg8TSWoZEup5ewxHmwm0hUIXdnUpEUrJTdBYjw5GGHqBSxMpFfBja6kyi9yZMeIpEQd6g7HoYN+5oOu1nxkhZ4rIdc6JGaEIkE9xU1ShLxyaKn+ACfiiTgMlo/9woOpzn38ZoAcpZeCoCUS4kTI0B/TJFr1lIyzXM6BZIQz0PhU5etHJdH7XEajHfCIhn/LkEex2jbmWFq1VWsAzOJdwaYopI2XqEF4VpiFBctKxnQQRnIFZEoApGJB5EC+JKnxwCey4l44BgXOQOJYzNGo4qFD/Ri35qJx02pEdQZps8oLaWKDMlJ2QxpW0FRYjgp4cQadpyJXiZop8ChJqd0JNqJDudoSkGaIQQZ6HuCr6lxUqqBNz+TEhA4026Q+D4AlNMKkBSpML8YtElzByShLGmqHA2W4dI130ogmsgX+7Wa3Weq3Yeq11sa3cWhfZ+q3g+q11shOsSTSEwiqgeoPCoQWn4AW70AbBikYB2oAc8YQu9A+96g/JGjnPZoORUwiHyjgCO7ChuROA5y/yMijVJSzN46NoSQutsAsSC69ryTZEo35/qV4KWJOnMnebFUn7qqyBELAEW7Imy1SSoQ37ILEsS7ESMaahgTmWFZW++Gma/5Wvj0oSXqWHx3OOhniyQDs2q2UYGCABLCuxTxAFsaqlCHeZ+EWzEIFuBXd7p8KzSCUjdtosLGcxfZKrQfu1pMIZRXu0uwAKEwCRSyOD6OOP0hmr6uV++aqSvJUxxBo5REYIeNuteguU4dq337q3gBu4gsutfUoWY3u0XjAGEtIXl+KhaMk/sNeBcEJWUFm4EIky/pksVyEJikC2WTAAlMa0MvI4DMG2Tie1R8S2WTtt/WqamosTkpAFZMsCGDAQC5c9D/o+aQlUe1oeL/tsdXswwOSWr8sVzSACZEsG9hkakVZIqqsQkvtToNcjKLFS0lu8X2ECskC2t3ApjJCaz/9rEJEViWsJTEh6EuiWudgbFVEgDGTbC6Pbp+Fbk2sHqwexUhbpGXvkuuv7EkvHB5twAkerCpuwHio6pLA5EKQptxvhVTk7Ejw6davbv7rlrIBBA2TbCntQpVzaYkcjXO6ZEd0ZhycBjn5JwUsBoKDBD2TrBc3gmi32afabfSCKEuh2ryicFHKjmHFAthLADK4pqjgcEhGMhbx1fn3kZRNTMUeGaeuCqIASxVI8xVRcxVZ8xVicxVq8xVwsxVObFxs6l0umDbhAtqzASiR3viTRu7eSrpSmXrTpB4TAMz4DtnZ8x2byFgQ0r+FBQwLxA1BAtp1AlKARvHcDf6kpEfv/iMeM3MiMpSzks4upcjbI0gSWcLTkUAMggafemBIjnHpZKJ+NPMp2TGdgoS+XwMcO9qYJAQ2YnApStsinihLGOsTpU2teWzZdvMu83Mu+/Mte7MZAIceukctwoglN6hBvILFesAE/53tr97M3KWTqNcNAKMllQyi6OSzFknI5fBFyTMdT6hiMAGMTUQwSIAGAUH4XMb6YoYBf6bspgW7EmyXxM86V85vf/JQ7czHSrDFLeEYVIQ72IGIXQaG3YjdFLFMOC4MJkwK+AALE0Cyiy7wAk7btOcErcgi/QzuDSBeEs6Zdi2Hl3KkbEW5uwnAbmxvPFrJrbCLyAASJUAu1/yAHPHAnonrMftyGJZo3OorCRzewfMCVFPgR9VR5nTebL/SaEqwSqGQOLUDTNJ0IW0ABDsGe7mbO2oHRdCnM8CFVZCNdnJqFpnZBhHnCBpG+KqEGkCDVbg0HiLAQqRoajtCVOtLTmILM/Dsb6OYxIAMwd6E24ASRQ/fFCxHPoGKaiBDVbk3TEHDTBoHV7mShDdSmS7gpc4JXecZec3AJiMIpM8FmB3inF/ZOELHQ26gSI1AAxtDYtaADBSAENUlyMZoRBZnNhpIoDW0aQncu9gcswkIIzbPXEZFGSJ0beK0wlwSOK40SBwAOrl0LQaAPAaB87Wm5N1htaUgv+FcXeP/bOuAd3uI93uRd3uZ93ubt1XpR1jdo3VtqEZ9syyaBBhFwDNFtAKbgAsWD3QlZbfhMygBuzabRdTencu6Nj9tprPa02wVBDZTQ2q6N3+cQIPytQuSjygA+yhAVWraikgc+daLoYwO4EhUAAdFdC30QAzuQUCw3B22a4XZM3GjBh140aZSqzyYRWUMwCieeCAnwAtGyNV0jPTDeyKasHxdWoc3HyXCSyKdNHtOwBKtw4rWgAmdg1TTB0aozOIVjMdIKLmAe5mI+5mRe5mZ+5gAj42exNuVpdlm4j4btlafCCTkw5Sd+DAUAAPv8Fszom+pdEEyu3CEhWaJHDGsgB1T/XgurIAAWsOdosZqT7BIv6p1EyNSOAVYH4AY6kOgqEAGN7uhhEULVIuBZc2F84OT0qxojYwE3YACJXgvDoA8vMNGgnhX/iyrfmzAVnmhC6AhObqoMvRAUcAYfAOFUbgAe4A3SUOtTsSe35ji4oWIeO4WU4+sVgdiF2RBpsAVw8Oo0TQAJEAoVkAzMTo0FBGkHLBDFxHh6mtyCFxEch3fEcABd4OrejuIfcA1nUAFoUO7DPLKgCe0JgV+GLERJnqMpJF8PLBFoQAJd0O33PtXgkAdbcAYvINv+ThPwc+4fczYRNWr0sesUMZXXQtkJ4VX5ixHjQAdysOkR79aJQAAQ/5AANyAAZ4ANL3AFQoACGU8SNvriP7fTDHFI0z46dFrbBlGDAIkCsNAFIWDsL5/ofXAMcFD1cDAMWE8J7rL1XN/1Xv/1YB/2Ys/11i4ZXgZm+Gw26f4QalYTJB92Z0cQK8WsHPEJa3ADH9AHUb/3xsABRR60f94UEtNyRH6Ier2W+EXqHyFv5hNp8ka9KpEMPOAATAABjL33iV4Cfw+0Ba+hc1ExGMOC5Wy5IC9SOKGk1qL4GREAL/AKN+ABKnD5mF8Lmr/5Jivyp3e3XL6mPvPflVPSbNhdar645bptOqEBV3AAHQACdFAAHvAAHzAMBGAAx3AMM+3WQWAOtk+wFP8kFQWZaen4J4nKOEONCQJdgLDBE30OqEzY83oCtkVj/qYpRnQvE5D+MaTq/jKBhmIDEHzmXCoUSc0/hAkVLmTY0OFDhGr4+KNIkRBEjBk1bkR4qeJHkCD/zCnkh+NJlClVrmTZ0uVLmCsLhaRZ86MWPow0YSqEx8+hmEH/RdJyM5JQpAk9gpxoE6QWRpjwHExa1epVrFm1JjzkqKYWLX/48HHkaI6mSzwJ4TG4NejMj3+ouk2JKWShf34CMXJKUyAmQnPpDiZc2LBLP0U/Xjy8dWlFR4IbN7QLEq9CNYQ0/elL84/OQD4njyZdWiuep0dNJz3E9+Oc1Qorf7zsMFL/oDmKO4fEOTAQobaxhQ8nrjCQSJPFX0oEeUn444q1M96ew3m3U5yMfBcC7keycvDhk2oS+V08x8QgMa2GTlH6ST+FLjnSfX03WLGOtGtCmzZQoEIC5I4QAgs08EAEE1RwQQYbTBAPCCOUcEIKIUzuPNZcq4gP8zDMCDXLSiMvxJcOiUQ+Rqyzb0UWW3TxRRh3YwQoD4Vi7qPIakQJLtomO2SOu6xSA49ANEkxRiSTVHLJFd/TETEVKcrxyY2OI7EwNTSMji4TCQnkEkYciZJJMss006n1qIyJKJCmVBOj9vxxUis/mlqMtEP8wMNLTDSZwxE+/qjvTEILXVG1N1/C/2NQNxN1aMSP0nQrkjG1wOO8Q9TwI5I9CSnkP0wuEZU/Uucw9VRUU1V1VVZbdfVVVRmRdVZaa501JEkddWnRNjvU9R9IK7qExqysvOnSX5NtyViKGFH2JUJCavRZYENixFeY1ABSJESp9fbD8r5lKVqmLvQ2zj+6FQqPMf1xxFxx411IjTGRlTclcuNS91lmK8KE2Gy3BWkOgO81uD3nDFaJ12PjLWRQf/iwtyU1MIHYn0AU1jiv+hwpeGONGO5RXEpp0gTek9S45GKJQVYYOi1Qdnm6docVN8ua5pg4IzUK0RIkTbCd+Vc16st16I3qtFboRAO52J8/LiFE5rwIwf/EK5taRlpeHv3Rgumt58X6Iz72VdaPsWv6Q78wxbwvkI/DflZgfzSRG6UfeZtTWULahVELTMC++80odx48o9k+CjreQwKx80VHAhH8cCr9AGlyyv8hBGI+qOY7NxYdwcTszPnGsXT4HqdIi72fzWy+i7MDDHPUqUw84do10pamazfWNJJI/PAu942DbZ14hh4O6Q/GkHf+zbRJf36hSFSnaA7Pp9d+uChpJ/6QYCvSIuPtyy/ukLjMz6hvmhyRXn34B1OD7PghUiP8ihavf//BLN+Q/4ewjzeBA2ABr+I/ivDBgA25n9oKEbcFRjAl8xOfBBkSibSR7YEW5GBK6uP/PfUpzy8b7GAJMZK25plQZU/7g+RM+EKGQMduMESIH/AnvpPREIb5ghoEOxgJulmLhDq0YNHuRESEABE7mjAcEvlHN2c5sYaaeBpFotZEKZoPRBXBIg0r5re4aCIwWXSUifb0qUCEyj/cEY1QHhdFMv7jEIXIYE1EN5U4hscPVvsTGG3yGcBkTyM89EcK4+gHTPixTZoIRCR8mEcu4QETjKiii/ggtUdC5HF/yCQRD4EHKq7oM5f4TXAgmRW9UNJQXtNZSrZIkaOd8pOb+dvaymIrW50lLT0BIQ0RWcdVRsyFHPnZ+/IYiUlW8kwjCYQgdTjHn3VmbWfBBIAEBKpL//TxPgTUSHog08k8fjKZwQQJI7oIw4opM4FzCOQEiVQdp/zhnLJRzynRgyJFkmkOvazf/ZTpCKnxsyHItJ6/NHII1c3TngyMhJf8BCh1tihdOkynTbRAEoFqJBIrM1knIxGuhWZLU8IjqfCAd9IzfulINLEUDNllE0aMkS5qCES7ZoiRxPkDNiGdjF6AeTz+7Y6lmHDmVVSGK41kkHw8nQwerKcJcJavosuDW2k2BxKFerMixmSqVnDWpqIi7XfB84551HAi0PGmqqsRWcQ6SUi5dNVHQfSaIeVG05V+5Q97VeY+idM1jGmkPTOS62RyCsvBKZFJWisO3TiZka40p/+wk7nqwKL6LRuSCXCXPYwRt5QRP4wJqJPFCtqsxVlliVBJfBimeKADR4y80mtcJa1VDhEnwvoumhvSzhxkBahACQosOHGEJkqiIwR6Lar9+kNYa5sUwNZtYy+VVmvvhUKOhM9jzzVMW+W0Ej15CjgZzcphI2bXeyVupwfN4E25OxjZaoG2CfHDJfx2See65avqQe2vkvs1jtDrSu+lC2DjClq60gR7pikZt7aWtlhChE0VOTCB6dKeaTGksvcZbVYOYV6/bq1rFdYIYCNs4atElmxUu62LTrwVDNJkqVsTsEFPQjcAo1i/lVorQuboNy0Ulz+qDBJh8LBbeR6OWTH/g8+AdYzKdl0UE5hIK1MIUbBDEMJ6Cn0LMP3Ru8PVuFkoCRZsnwxlFkH1IS02ymkKSpEZHw6wHU7IRz9C3jMnzct600hOOZTiOFWEEfkFWdqYzJHHoTfPVWmcMvWnEe32V3e7PS/y7PxNjkAHd4v2KiasFzVCqzh/SVEDMFv5vH65FyNdMzOn6eQp7hAaM2N68UqiOejy/SzOD0nuH1ytpglXRNEqySnr1Cdm9xwUJJL+NWniK+uBPoXLtfPusBXSvWZTqV9/dkkGp507wLYUI4+DdrZJ0571rkS2tdZesa39j+iZ+0miTjZLtMQHZpcOf8dLW7nlPRlk5zglyS3k/wLx92Jy//tJsk33SZilwAjiD8wLqU++Fd6Y9sx3IVpiN/ziND6A9fri836jSgrHwX5ZcXSaSlurRy4e2Wo8IjexOPK86xQ6vzw2WlL1dOhXQtNKs+Y6L8wrBT7Ij7g8go3GzreJvprHbXp9r/EiR5fn9KebZsmT46HSOZhlMJGFJEPPOpai1HCIvNLrZWc7SvpF50tHrO1zbwlCsao7mtNd7658yrsREiWZ733vh/0XRui2a8En3iF0dR9EmLV2xUc+byHJYbTFR/bIjxx8OTMb4DP/eYc4rSasFYyW/A56wcfYJqfWUs5Rr/dCKDIsd3997blSiDfzBvO2fzkeqj9cE9fzXvA0fXPHhY/6jTblooE/Pujx3HzoR1/606d+9a1/fexnX/vb5373vf998Idf/OMnf/nNf370p//1AQEAIfkECQMA/wAsAAAAAKQBHgEACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27csD0UiVKgQIT9w8+pFSoiRFn+AA/+5hHev4cM5IzkKzJixlkKII0t+Sehv48uAA03ezJkkHsygAUfqTLp0RjV/LjvSdOmS38aMTMueDRET7NEE1WhqXJi2798E+TDWhPBQ6sCYgCv3rcaxmoSBGDtaTt10JMaxE/rhXb375uuBsyf/XBxYs/fzh5sH5rPQdnj08Pce96dl4XbGvePrXys8MEPygM2x34BqAejPcwoV0hhkBDZIloEIJnRIf4BpgYeDGIIFIUOEXGZehiBmNZ8/Du3WmCP5hahiVJbR59AhjFz22Io0PnUfYOw5pEaMlyVX449JdRiYgA8dcglmHwKppFBHIicRHhRWmOKSVO5kICETHWJiYJdU6eVO6gUWoURNAjbdl2jaFF1gZ1IUpj9/pCnnTAYmKRF4ONoUCSaM8PGHFlr8wYcjc2iCSSCERDLmnOh9hp9FczBGpEx+GBhaY4MaWoiijFLHI2DiTSRkYFhSOuKlqMK5GiaJLtrpZqMC/3YhRZG06A8fh8z0aaq8yjhooZccWggekfihhquvpoWadBX5ceqsMb3pmK29VgtaoII64ggjc3Tr7bffMiLuuOSSq+256KLLx7rsttvuH/DCu+62hWIy7JQ/+VGIa34Cmu0crCIL1yGWQhuRGlH60+VMjuJIyJhq+IEHIYFcokmf1Fqr8cYcd5yqFqsVgm9Nh+ChyamX8qEJHrnmBWNjxE2khqWMtCxTrDHrOBcmmjiCssdABy10aH/MUYjALkWiScbVDjbyWZViirRCM0tdE84XqRFJIZjM4QgfTA8t9tjVasFIITa3dEghCQM9h8FnRXIJtVrgFtHLjP0xNUt4+v8zKUdaT1xIIJhY7PXX8AJK9uKLa6HJ0yOpgcnPmCneKyN2i1XyyZXD/VCkeUPeUt+htnSsH5FEgsfqrLOe+uuwx566H7TXbvvtxh6r++68P6c76nTxzAjll72NkhpzX6oFwHj4YbPWXDsSNmCa7G2VydNbSFGZFWZOk4JDcqYGHnxOD6r3H0k+/WCRpJ2QGoTMEfYfpW61dtsnig5dY3XbNP6WgPERaUp2CfwNyXoUWRvxjCezQBiwellRIKr+EAj3PaRhgfGcS/zAOcygjzRKC5sWKtgRKF0LEwhcyCEIgT8+fBAqJgzN8o5WkWUxhkEyWRNocuabQzgQNCjSiB//QHcZCqbwRYHI2IymYiSiXYJlGCFiAGkCwOJZ0DcsrBwOE5jEyqEQJGqQIpekgrfiQTEjsfIbTdyDGT5skToSLN4RCxLDy1xijhQpRMbmcEWklHE4+oOIcfKGR5FgEDB/YMQT9YO8NgYyN1Uc0iMzEjXYFJInkWTEJB8CvgzOZEKOeeN+ItE27TmEED/jgwZHoiXVXDInnayQKDUSpb/BRIeAmeV+mngZXeZGjBXCRB9LgkszvdImfrCVKT1yyE1GbkS2xFBlPKQQVGJmDs78yDQZw4dj0sRS9fMIAKPpElxqIZvd8UPbBPhLzNCPYdRyhDdjEkt/sNMjI1rlSgY5/8Ya7ciOBbHmZSBIk1qdaJ4uUYOtHDFMjLxJCw1NSRoRupxWNmZhunGnPl9iUOxENCfc88cLNYLB0r1EiuRcUUjtiYefERQnHQ0MD/N10ZFgTSYKZcxGQ8TGS/1hpzLBA7Xu2RMA6m0ksVwYPbn5pZ5i5qU8OaQ/fHmTG2WGJEmdiRSJqiSnCiacPqmnP4CqVW5+FCOxSqlKDmErdA4ojJhhBEVX4tRz9sSqUy2JVXMEEwzylUotBU03i1LFwe5Ein8dSYvqExPuKVVJh/AqbM56kz+qUSd4BWtIDpE3mRiIrA6qJKZqShSENcZONQFgYkWy12g1Zq7L2Wbe8GDaG/8WJaaywklmT1LSmGCwTf6MpN8QlEzHjJQnabSrTVSLkp4+tiU91cKgtsUt1tgrUc4bZSnfeMijEsWpam1JcQNDVY/sSrMrASav/kCoSwwLtm4pJo7wVUyGFmVX/kDtS1RLWUq+NiYG3Fgi3XtcyfzTjsOs4nOBktPA9I9StipvR7gHXJcIV2hmeyJ8wSLQvKGXIARrzId7kkbDwoS/J+lbXqOFX8Y5AhPtQwwvLdmQ8XaPsI0J70nwKuGN1BaR/U3J6VAnOMJpwmvEQ9XyHqYXUiIJIiXe8ElAaduT5i3IFnEyY/QLlENIbF99staSsdyVLmKqwAcBb1FsTB+3knT/QSXxIbVMmhS5FKJnvXIcaLkC14G+Er9cDeuJyKwRKuOI0BFRTBGlbJOSlS9VfAgEow0yvorNgRFfm5ciN4XoEqJMCyNuiA09SRQFsySkoT6NcPngZqIQMMAV0gSaZUYITcCaf0abNENmLJ1WCwS3yhXKjwGTam3meCSR+JlcveKHQFjqMozY80LUUIgWi1nWKREtY4SpkXqaOCjA9nVEnOUYcStEvvTh8lbU4OxLOULaBvFD8sSGOZPosYjwZkgVZwqU+nb6YAnrcUUkq8m4zTuusy5IJNQ7NGyKpM85lnKIt1wUMQbaI2LkN0fE+geBd4XaAXZ4jRnuYEUGgljH//pHxPAQiA568d8JCSz/PC4RNo+1tKcqNkYKq2sV+2PZbsGDtQFzR6qtlJswpqwfJifYhL/o6EE0ZGP+YO6VqDjYHwkp1jtiaKLvZeGg6ThCCkE5LVzC6QYhxLPTrREtXxTmDinmt/tttY/UNd8QqafG3wL2uObHD0N3I9z/kUU5XsTMs0WJGHWsEzHWzCMr1XlFum7fyChaRiREPDclXyTNz9dN1p6DrotjqQX7ZNj+2HsCgalujaQR7WvpsHTWPsLBH0TbFcq3bB1Mc46Qm+JDsfnFx/3s1msEpQPEhPlkOnqBSNbjEO910qjF+ZpI1fgNkTnwH24r2LsF8CnDO/9FtO8kDv2M25Thn/hhItbhT3uloC6JX3uy8HF1K1iBuJftJ7zD/TsE9wpDNavmfSFRTFv3E151CWQme7lnEo7FEw02QZsWYy7Ba9SUEocATHx0EOTHJc1HJlNXdSqxUlGXfWtXgiRxXsjFMSDjXh9oEG4XGqKnEl61gQPRSPiGE2JEdUQBf1/0PoWwdqnnfwxhKy94ET63MY7wRESIEJ5HHyjDaiohVo/3D3U0HEeYJfjFg0NxdDPEKYHzaO5UfafRWT0hWRzzByvThAIRfQfkhvSxfhWRRj/HQWMIgZbChUIhVhwDVSZBOj+hNalTZMIDNtbCPp4mI1t0b6elEkL/xT/XlIVZk4cimBLJ5jH1thKxpHpDUWl4xiuOgDYOBXVTcolvlxKPKEO9BxNVkzcEGC0H1ytz8IoagUvuZxQlEwiv4VM/OBExiBx91IrYIYlWGDYzKGwJs0xCIW9JZiaBUIkU0VPYV2d4cAlJZnbOZIGItFMWJR1ZCIf0QYY1IYzkhYvk4zV+wl6KxGQyAUCreBRyQzyOk0JXeEBxdxlSSBJPKFNHQY5Ex4ZlAUDiqBR4QHJa0IsHkVEyQoa7Bye02BCXdymm12XABHSzIUVyiBSSQzlidxCMSGNPQjcZiRA4WDxDdRTa+AcPyRYYCRb3A0SZgwe0944D8XsONpIB/5VKF0KH0yhqczE4gRCUrTIS6NaTe9GSYlF4dhQxDHeMFoF6ymgRQwQa6Ed4vVQRezI8EzQHzwgSqSh9pYGUmkN2lRN2A0mSlhJ/FhFZTIOCAiFWZFiNzShYCClEpWSUbyGWY8GWH1OVGnFgjHGWhIc/S3QQ8qVz7HZrvOI40NiN0rGSZaGXZAF+MgiNA2FZ/iCOlGl4CnF3Rrd8GyNyG9GQ1EOMUSFFghkVKzR0XicSGXgZnIc8TKNKDqF1GiSbEmgoQWlkWilDRbcRm+kYJBQZ7jiZ1sgrTvkRjklsDUGWmBdkVfRgAsGXYWc0oqMv8hN2OEkQH5k3w2kY3IOXUf/BbkJYIfhomQURSaEmk6CRnJ8TggLBgJJCCFiWmDsEX+AIJ5JmGD11i1LRbOVpJg8TSWoZEup5ewxHmwm0hUIXdnUpEUrJTdBYjw5GGHqBSxMpFfBja6kyi9yZMeIpEQd6g7HoYN+5oOu1nxkhZ4rIdc6JGaEIkE9xU1ShLxyaKn+ACfiiTgMlo/9woOpzn38ZoAcpZeCoCUS4kTI0B/TJFr1lIyzXM6BZIQz0PhU5etHJdH7XEajHfCIhn/LkEex2jbmWFq1VWsAzOJdwaYopI2XqEF4VpiFBctKxnQQRnIFZEoApGJB5EC+JKnxwCey4l44BgXOQOJYzNGo4qFD/Ri35qJx02pEdQZps8oLaWKDMlJ2QxpW0FRYjgp4cQadpyJXiZoqCAapqd0JNqJDudoSkGaIQQZ6HuCr6lxUqqBNz+TEhA402iUh9ShCpGho0uRC/SHQJI6ckUawZCpzt1jHSRS+awBr4t5vUWq3Weq3WWhfauq11ga3e+q3eWic7wZpEQyisAqo3mIy/GqzKY6cC8YQu9A+96g/IGjnPZoORUwiHyjj82q+huROA5y/yMijVJSzN46NoyT8P+afupH5/qV4KWJOnMnebFUn1mqyBsK/+urEcy1QGhl/SGauBQDyYY1lR6Yufplnz+qgk4VV6eDznaIgdO7Njs1qG/2FZL8sQSgoamfgPJiuH6FZwt3cqOSsSYnWyKiExFXMxfkKzTmstqVkWOBtIISSD6OOPIfsQ4Oh+86qSvJUxwxo5REYIZMutZguU4Jq23nq2bNu2brutv7qX+EWxl9kXl+KhCWtcEdGBcEJWUBm3DGGq5ZcsYuGPF6tyWlo5j6Ozael0QXtEWOuu03avpkm4OOGPVfgPC5c9D/o+aQlUe1oeEuGPK6anwOSWlstnCVM9PxQakVZIkasQfPtToNcjKLFStJu6XzGvqMIIqRm7BhFZkbiWwISkJ4Fu/qm7/wmajtOnwFuTawerB7FSFukZe1S5yvsSS3drrws4z1Y/pP/ptRvhVSw7Ejw6dZKbvbrVrEuavm3YYkcjXO6ZEd0ZhyextQirviwBoL1CtxuBmZ8mvdkHoiiBbvGqv0khN20aGPKwBzLADK4pqgccEueLhbx1fn3kZROztJeWaYgKKCAcwiI8wiRcwiZ8wiicwiq8wiEstHmxoXM5ZuRxD62wC6zASiRnvCQRureCrpSmXrTpB4TAMz7ztEZ8xGbyFgQUoNhBQ20oD06wC1K8C51AlKARthJxqVEbEfuIxF78xYylLOSzi6lyNshSCZYwxbtADjUAEnjqjSlRv6mXhfL5xXZsxHQGFvpyCUzsGG+aENCgxrsgCz/gEV3Mp5bYNhP/nD61lqtixsKQHMmSPMmU3MI+DBRC7BqOjEia0KQO8QaCvA/FAJxrJ7M3KWTqJcBASMZlQyi6OSzFknIIfBFCTMRT6hiMAGMTUQwSIMhFsKJoqIBfKbopgW6omyXxc8uV85uz/JQ7w7TKfCJMeBED4AVqbAPscBEUeit2U8Eylb8Kd5dSmbgpAzBLI4PuqyKH8Du0M4h0QThr2iebLEO53Kkb0QTkoMZtMAFuwnARmxvPdriRI1yO4H1951Oa4MRtWKJ5o6P6e3T9ygdcSYEf0QCCnAXacDf7uMggBky5ixJ1zMwLwZ7upsvacc6u69CpK1VkI12cmoWiIMgXABHb/3yQEYW8KgGO71RNAeoIXakjDI0pnYy9s4FuHgMyAHMXLSEOWSDI3ACRQ+fCI50x1WsSddyzBEHS7mShDdSmS7gpc4JXecZec3AJiMIpMzEBNTzFbWACCmGHdwgR3ryNOX1hiysQUwlEoogRBdnKhpIo4FwaQncu9gcswkIIzUPUERHIaowDzpCQQa0wlwSO/4wSNU0YyteegNuG1ZaG9IJ/dUG2rTPapF3apn3aqJ3aqp3al7wXMiDIb1AQQbqlFiHHHB1nh3xNm01p1RbNd3zHqmwa4kAF15wBbZjZbbSdxWpPgQ1Jl2IOAbLbCuFoffzbdwxRDoLGavwEJoDcRf+01385gFbXYvKQA30QAzuQUCw3Bwts3U+r2GjRCYLMAtPgRZNGqSIdZ5I1CrVQC4mQAC8QLVvTNdLj3l+cx/oRDb7MP/ntEW8MJ1v8EADoDxzQ3xZeCypwBhRAMoEzOIVjMdEKLiI+4iRe4iZ+4iie4gAD32exNlwgAmqsCgpQIQ1egEwj1V75aXxQAhd+4cdQAADQzG/BjIBxCvk8xaAwCFyNEg8u2SEhWTOIAnLQ4z2+CgJgAUKOFqt5GQggyBLgEi/qnUT4mvwDVgfgBjpA5ReuAhGA5VkeFlULGmIgyAiQUBfGBxGO1wE9MhZwAwag5hc+DPrwAsTw5lqxvb3/+wPWPMWq0MZJI4SOsMWCSz0RRQFn8AHGAOgWbgAe4A3SYOhTsSe31rwCUQOqoMZeMADsRzmRXhHDTB80lwZbAAeafuEEkAChUAHJAOrUWECQpqID0eVqrASwGDaCFxEch3fEcABd8Oe1buF98AHXcAYVgAa8jskZy7zYhhC9vAsn0Aulq70XBieda5jneRFoQAJdQOvPfuGJAA55sAVn8AJCcO3jSAi+/jFnE1E/AAptMOP0Id0UkdfLLDpeVdUXMQ50IAdp3u5UnggEAAEJcAMCcAbY8AJXIAQoYO8kYaPtbcYPUQM+wE0sThAHDaPgTRA1CJAoAAtdEAKZ7vAy/98HxwAHNg8Hw5DzOr/zPN/zPu8L6OAuQj/0RF/0Rn/0Qt/qkuFlYKbMZgPstXFsNUHwW505K7WsHPEJa3ADH9AHMv/1YC/zQ1DfBo4qrQ2lLVfghzjUa4lfwe3GkY0jz7hSydsRycADDsAEENACYd/3fh8BZZ8qWEwVWkMx/OLbFZLLcTtqonG55Mwrb68RAfACr3ADHqACfO/3mq/muSAPgX8pAn96Y+vha+oziM8/9cyG3VXyxWG3vFL3K6EBV3AAHQACdFAAHvAAHzAMBGAAx3AMibD5tZ4Enx92kZ8TBZlp6fgnico4Eo0JZyQSxYTgM0HkgDrNHF8TSeivRf8D/aYpRlgvE1v+MaSa/TKBhmIj0QQG36iX5yQB0URjnebfEny4MdLFCJpysHqiTKEPEP8EDiRY0KDBS/4ULuSz0OHDhVoYYcKj5uBFjBk1buTY0eNHkCFFjiRZcuAhRxAVatHyhw8fR47maLqEqRAhPJEsmuT5sdDDPzt7Di2ICWKhf34CMVLZVCGfOZgICSVa1epVrFm1hvSj5SGhrWE5JnToiKrYj0YfIiWohpCmP06d/mGkKRAeP2j17uXbFyueh1oi+d17iKnDOYQ3qnXI9mKkQHO8ynWqBeqlQIR0Kubc2TPaQEDzfs6qpqHDS6QJkm3sEfKcuJRlW2Y0B/P/zUh+zqrm3Zu3JqC7fZfs+hATb9YLHYP0U+iSo8mypUdsCbO2Jpo1AwUq1P0mIfDhxY8nX978efTpy+Nh3979e/jsRw9Ha/ghH+H0RQJeSxp4f54OicQ5RmKb7kAEE1RwQQYZZOQQ/cQy7SGzIuTpJwAVO2SOo0rDIxBNCmxwRBJLNLHB5SzEyg8DFapQRZJCy7AvNQ5rTS8BCQnkEkYcafFEIIMUcrrjYNQqkuhczM/IjZJTKEW0/DjNIbA8O8QPPHTERJM5HOHjjySHFHPMBQdjMis8wnzxzI/+c6hIvSL5UQs8jDxEDT8iyZKQQrbD5BJAsRN0DkILNfRQRBNV/3RRRhtFlBFII5V00kghgpPNq9KkcElMD3JzoUsgFEtGh+js9FTQHmIEVawIgWhNVjH6VCFGOOVJDQ6BMjNWXonib6Ggeq3K1fvmE7YgJ/35Y1er8PjRH0eMPXZakNT4sU5qeyLWoWWzJYjUN0UdCleV5hDXW3Q1cjK1dE3StFRs0S0kTH/4iLckNTCh159A2vUXo+IWcuTcf0N690Z05VRJE2k/UuOSfe0teOLVSm2YYteeDTXdGpua496N1CjERog0sRXjadVI8lKUmZtyoVrbDWRfZS8h5OKkCMEkJackbnliDFc6+eeL1ODZIT6YzdaPo5v6wxFIY3pWJS0CIf+Y6HRzVUgTrEfaECItoKSWkKkZ1AKTobvutUWQ1faIMYdMbveQQF5e0JFA0nY7Vj8e0ntvggihlw+cpyVEsgQdwURpwNPdFtrGRZISbLGzdeu5fWmT6u/IY4Wb3c4d1tqhmCnGM5LcdAv9508rXz2jeSH6o8rXa5+2acZtzygSuxWao3Ddg4exRc5tP2TWlfoVfnkmD+GWeY/IVsmR3KG3/jM1kL6eIzWQ37r47cO3qm+GxN9IerDRNn/9vch/iv2Mune6kKvht7+n7CO6H6NImkaa/v0FkCdJAt/1YqcSPgBQgAsESdNox8CBPIxmf8gbBC2YkeRw7YIE8YP3VsL/sA2GUCCP+0P9LBiJ0UGEEQoUIQNVRqUWEgSFctGCJtoWQ/iNblU4HEgHaaaQP1zihjzc3q8UMkQR5qtswNLEVIjYKwFlqU+B+JN2boIXq7xsh08UyCEK4b+mKK4iXISRH3TWpSU6bSI3M8nj/PFAMvoBE2ksi10iYUIy9uUQeMAEI364ID7YDI8aeVkJ80iQPWrij7JjBGY0U8BDMmcpiyyRFj5mMONEsiCJpCMNnxYTSlFqJjUpxBg1aRA5gpFMDKmgR0jmj+pFMhJ9pKSQ/jCHQAAvhl58pWyeNhNMcMc7froEGqVztrQFzEWDjOQeablKlTACiSHMVy2hIhVd/x5EDR+CjVz+ME2CwM0fLDvlRZrDo06eaA6QFF/3FukIm7HTILPs3ULIeZBD2A2c5SyIGiKhIy55qZYJ6lYS9VWZORRCnhuJBMQWxsx/RCI4/LwVnvxwUYzmCXWok+KORES1fcLPWU5hhBP3ooZAPEuDGhFnYiiqGKWo0nXwIxfVMJFNrTzMUhzxn/Jeqhg89E4TEL1eNVVCQaKKRXAP2acyFRLLn0qol9Gy3elSpwbh+LMQiAOb1XpzsHpB1I3BiiphvhYYOLoNpR9tSkv+ACbKrJM+QVOITzGoqqSW9SriVMg9fzZDIPlMP6MzpEZQ8hDQ6bUvS32IubrWwSCdLf+vinmhcjjCohkptn1gfBDRDmgiPrQSRsnZokaM6A/BaNYvh0hWZzHWsabwoTZziNpL3soSlsBEE4XAaW/ch9qkgktZvVVtVei6NYyN9FWi/ZcDPTKrgRW3L2D1x0wzgiU+PdJCfK1XWv8FN5dy5LBxk+50AwNVVF5iaoEkrl5ga5zJHuu3WtCbtTJb3rAcl6wa8UMKPdberShMV11rml8fk6T94lcsToLVQRh7TOuK5RDclWvX6JrgjRzXwAq2yngZgjPWLmjDYemfSuyKNfvaEySjoy+H0ZLiiHj1JIWYmhYcISg/qiTCmeqlskI6MXBpob2/ra6Lo/QsS2ICE1z/vQ8hCHYIQvTuxz35YlNKBzgY+6O0HPnUlo2cFcwiaKgYCXGp0NuToDrlxIA77o4HIlGHLPTLG2HadMLGEXHiRytljiaAMdY0IX/kZd6dc4dnRhm5dQS68e3Ie5usOzgLLK/JSWyhc4qJ3gURwB5GrlWMVq4pq024K80w6SzdPj7dxM8R/NGIQ9JLRqy6a69cszmfd2pMIekrRBHnnYv6ox07zyGMxrVnThtonkR6JaHuHHUJXRDiFRtTwtWzSfzH7NAd11SEdIispc0ZJ4V3JKd1tfB6/WyB4O7bbOJ0kUlCMj4Qe3XIm2nTvL1uwmS5xZLb9f2QZ+CX3Rvffjmt/7g/Ai4+CBB5VyZIkuQ9cMU46cwHIVm5r5esqp3rt3+AOLu1KBK2MVC4QFwcnprm5Y5b6LQTb0upHh486srFzSlXDclIzRFlJ9yCdfbly2lu3oj87XEoDyDd/rjtnzPpZZXWyOMMDkEJHhXbSe9MkPU29F0SgkcwSajPqU6jFj0dI0Yk+tfN3hHhujnnZ2d7SPLJVO65vO1z78ix0T2QFrGc7m3nKyaYObpa713wA/Ev9TICrrIPfu9nfQgID6JsLXhd8fg+nsdyl/fJZ/5bNAstVUh2d823vcROueQ/SDbz0Judxp6Ee+pT78V6Uk3yroc4HpjcFNTTvu0ojb3FdTQ/+IaexpJ6/33m5Vx85Cdf+ctnfvOd/3zoR1/606d+9a1/fexnX/vb5373vf998Icf1wEBACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVO1RSgjtCVOrLOmKLI2DsbS+ys5noXagNOEDl0KrwQqgwqptnPPUsQ7Bl2FtpAbf+6hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTG1MJRKKIEQV5yYaSKMNcGkJ3LvYHLMJCCM3z0RGRRvacGxztzzIDsVUN04RJGMrXnl2sctWWhvSCf3VBtq1T13Z913id13q913y914S8Fw19g2u9pRZRv7+8VnR8TW1dENRmyWf82KhCyabRdTeHuGGjoBhRrPZ01jd4YTm22BJCPm0M2WYMUaHVIlzwBiYw2EX01H85gFbHmpK6EpU2BwtM2k7r1WgBPq6gCLvAAtPgRZNGqbNsEsJ7t8x8MFvTNdKD21KcxvqhCRsgC7tQ3UXAP8X9EXiKSE9s1KP/Ta/pLBPOrDqDUzgWE63gkt7qvd7s3d7u/d7wDTC6fRZr8wtUUN3VrQoKUCHZLRL7mNJe+WkB1ry0/BbMCBinQA74vQugMAgzjRLbTXS6JlkzyK5tZNAFbhareRkIsOC7IAEu8aLeSYT67BhgFdXuptEZDhZVCxpi4OEIkFAXxgfdLRAA6MryOtZsUgYvQAwrrhXb27s/4AULrgo1wFFC6AhPLLjUE1HUFqD9UAsG4AHeIA0/PhV7cmsE/g81oAoL7gUDwH6Uo+QVsdKFWWPHeRkqUAtszuYEkAChUAHJcOXUWECQpqID0eELngmweNmu7RAcJ37Ywxij0OaGzuZ9//AB13AGFYAGdF7IGcu82IYQEuDhDUApnp2jKSRf5SsRm/MH03AHhz7qbZ4I4JAHW3AGLyAEjz6OhGDnH3M2EfUDoLDg5NAEQG2QD44QXlW9mQ0AcqADpD7shp4IBAABCXADAnAG2PACVyAEKNDqJGGjt63FD0EENoDfyADmBUWnMZpmVgQSKAALXRACxkDs6E7sfXAMcNDucDAM8B7v8j7v9F7v9n7v9z4E7rLv/N7v/j4vNf4VXgZmsWw2eA4RPeDhbIBMkXp2BLFSy8oRn7AGN/ABfZDuGJ/xGr/xHN/mvOC0fw2lLdfch+jRFsEMLADjVaXjt/KMKzXRHJEMPP/gAEwAAS3Q8Tif8zp/6JTgtElMFVpDMfyCyyVHyhoxBrWO36owCZd7zLwi2RsRAC/wCjfgASpw8zuf9Vp/6MDgtKB9emNb3mvqM0QvI9jMhkTg5fgtCz+QExvOKzCvEhpwBQfQASBABwXgAQ/wAcNAAAZwDMeQCFs/+KNuDCUwsxQkFQWZaen4J4nKOPGMCWckEo/g4ftQDACb5imjy9JeE0nor0Uj+ab54gv+Bj3x9kpGqp0vE2goNvFMYLo9AES+4NDgE+9MNNa5+i3BhxsjXYygKQdrE02g4PhtCbi+Eyt122Yj+ro/ZULoL/OCycFiFygHFA3g4bIwBTrhVZD/0Wzk2kYAw6jN7xE2F/A3cQEebgaSgBPcz9h6LGC/f3Ihf+WHlLVM4Qz74OFigPk1ARCY/A0kWOjfQYQJIwWao4XgQ4gRB2rhM+dSIEKR1CTk2NHjR5AhRY4kWdLkSZQpVa40GQjiHz8sZc40+cPLLpw4ndDkmfBSRIMlF875I9HoUYqMLAYqlNHPxp5RpU6lWtUqR00voV7lOrJOm5w4GXQ9+RNi0JR+Cl1y5PDo27datPzh40ipJk2XLmEKxLTQX0KBBQ8mXNjwYcSJFR/G09jxY8iRG8ckW1nlIUYQ+Wy13PlfO1VhdzXwDDLrWZ6HIq1lVBTua9ixZc+mXds2/0RGh0rvBqmGD0RHnHlz7WQjrA3Sw/8dmgPUqho8gTS1vl3d+nXs2f2hVa7cj2uCwbt3RSAa+XA1mVFbVk0o0CVGjsBrp1/fvmxM48dHchteuH6p3jCPnd38+A0iQvQ7xA883MNEkzkc4eOP/u6z8MLbIgGwOzwq9Ee8DakSJSxFUMmvs0jm80cLPEIM6RA1/IikQUIK6QsTvS7Ba8c5evTxRyCDFHJIIos0MkhGklRySSaVjOhEF3nrELj/omSpmGhwyuKIgS7RjSyXIGLRSjLL5ChMghgxczdCIgJxzZWwFEGXhxipMio1mntJQzj73BAPrfzsrE3NKBP0pGK4iP/oDz6pwkPFDw09dFLP1FCxRUrJIvQhRjNtSSJMvuwpT4nmENVTVK8yi6BLUu1qyofGdDWkQjz0hw9MZ1IDE1v9CWRWYKfyo0JHTg1WKlgf4u5YhFKUSBNJUVLjkl5xZfZamVZdMVpseXIWIi+7PSg9o+bIlSQ1ClHv2TvFdbcjNSqE8l2eDIzIzncD6dWfPy4hhNuD/CAEE0fespZehEEqJNZ2E5a2YM0a7dYPiI/6w6745INNi0CMdfhjPQfS5OOemItIi2WxJQTS6rTApGGS353v3JhlEigiTWB29ZBADqzOkUB0rnliiIQeeiRCbOUD4GsJaYg2RzCR+GiSN/3/kOp6fSYI5YTVIIStXpPChBCjse725i7NponUe8sGNsZIIvHjKbXrPm2glOtOqdZFE9T775gr9mdqwFGKRGuC5mC6cMaDnc/txhM65O5Yf438cmAP4RTzlVaWyBHCORcdTjUe4mP0lNSg/KGcUXfdTD9Mfx0lz09+eXbcAYydoNNzL0l1o/4oxGPfi++q9K2NF0pw04dX/nmuKoTcd74l4sN56LOPSnC/te+N2uCD9n78lbQdmXyQ/Fg9VmjRdx9pTol//59IQpaIEezn1/+feB/qfn+F2O9kmqAZAMdnPzUZsCPq29dA+lVABSoPUA+BoAJ3xTJOaYJsEWSWahpk/6NA4GgvTCEEHha3Eq0lkIMcOUQhmGeUqOFheiv0zsAihEGLMWJsJySJ1fzxPxoixA+YwCFwNBGISMgviLw5BB4wwYgG2oYP/lKiSLT2hypysImaiOKiGHGRjMxwiSzxQyCgiKGJmCslEyTIvMYoOTxooohwmYsj7NikJs0hL5gohAzfGJIhvhCNA+GD+EyyroGE7o8HicQTu3ifP8whEDxUYAsRCZuL6ZEvf/nLjS5xw43djiTDekixFvkiJ55xkLipoAF39chbzWGHqYsOUd7yh1ZyBG0DceMp08eaOdJnDmI0nuq66Ah/EdMjjUTcQ3rpkUMgLpe+9IgaIuEeCP9JCJa06ZQreYWUORRCmSSJBPhwlkX6BYqaa4vR3Nw5t7jF84PvoY5EZKW/Rx2FERvsjBoCAanziWSX/pjDOrtTRkHmTXtssx0lrzKtJ5GEeZYzqHLw0ExNoBN3r5TIHzoGoKRBZJr/IOVDFFlRy5ALOA6lGtzk9pQqWbMQTzvZR0OUrFuh04d/GCdKZWIyMQFRbf6sp1Hm8gcKwWWYZFrYQygaEm35Izc+Vc5Aeam3+tXnYGWyHxZHcgjmtYqqwwkpREyFNfXVx2Ua7U7/CjJKFSl0rGSh2L3Yiq3qZaeQPbWMtlQoEjZO5KRz5cohoirVuwZLpdZTyhySJKEJUUj/LhRxhCYKwdIQ7W4ibEWTAzFLWKk0lXUky6ebDJkw7plkdaYEbWlwup2VMKhGYVyTVW8lVITtsqAlAStEAtrazgR2RYNd4CVYNsXPVmaxzkzssTS7orJZaj3A7YxoHSg0PwiwXMm9yrc4RVx6Ce6ZIOEPp/hKXZNE9U0fKevG5Moe2y4Va9bl6Ums64/xorcqvTUd0wxrm/ySJRKCfGpL5xNgj9hPC+fV70ikW7lTtZBlWqgsXlQ53eBe0oEj/VhntfDZ58K2wZX5zslkiQmaaoYQxjoEIZrJ4Z640Cj4+tuDB/JXklAOxyO+Solnk1GQ/DdW4KXJRY9SYL3d970d/4lE0XhMYkHac8kHGehmriLk+3H3Y4L78Em0htsnU4VnXWxdSVbb3N9pmJBg/luTS3lXbYk1zGTZVTP7lVz+EuS3oxKkGkfXWX/smVZ1mrNnBAYYLY9LRQhOiYYZkWiqXRLJH3nuHwrtqfL6LyoD5dpG40oSzT0EzZfWj3C7TBM3bw3GjXstmxPyOFJnCtBWngnzVh25+94TJFqDdKyVE9XdskS4jB4dp139D8ER2dcuyjPeZIJIPoy6cet7r+B6vWze2Bi6sUWQ99aXX15jm1LCDTZKOts7b7fNIxWStrh/DRFlcwSRxMbdYTl2qkq7m1LRJHRKZuY+QDtQajES3P+O9Q0n4cZ7XLFqt+he+5YpHzxKiBS0SFJ9K/3V9TVelfihArvgk1jN4OMbc1xu3XEAaU3OPXxIuec3rV7hEuWU8nDZRB7BFsOnLuFs+MyzPR+XhySwI/d50U8C6Iink3dGZ/pK+E1BdDG86VM/iamPfZD5KJzqTbdqqERiv0lvXewc0S7oQtJZoo997ED1LdMuroWeq13fkytX6LIud7x3RF9G2WtCEHn1vE99wG/xMyKTHvimF6KIcxEp4h1/kBY206hxf/zB8ZBioxy+8lT3p+Txu3nQK+QSB9LCHLQeerUzGPWrZ33rXf962Mde9rOnfe1tf3vc5173u+d9730M/3vgB1/4wyf+GwMCACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVO1RSgjtCVOrLOmKLI2DsbS+ys5noXagNOEDl0KrwQqgwqptnPPUsQ7Bl2FtpAbf+6hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTG1MJRKKIEQV5yYaSKMNcGkJ3LvYHLMJCCM3z0RGRRvacGxztzzIDsVUN04RJGMrXnl2sctWWhvSCf3VBtq1T13Z913id13q913y914S8Fw19g2u9pRZRv7+8VnR8TW1dENRmyWf82KhCyabRdTeHuGGjoBhRrPZ01jd4YTm22BJCPm0M2WYMUaFlKyo52EX01H85gFbHmpK6EpU2BwtM2k7r1WjBh140aZQ6yyYhvHfLzAezNV0jPbYtxWmsH55dIb79EXiKSE9s1KNNr+ksE86sOoNTOBYTreDS3d7//d3gHd7iPd7kDTC4fRZrU55ml4X7mNJe+WkB1ry0/BbM6Jt/HW9D19wcIVkzyK5tZNDzbRarmcUu8aLeSYT67BhgFdXuptEBDhZV2yuSnTUXxgfRLRAA6MryOtbrsUgPrhXb27sRKlIcJYSO8MSCSz0RRW1tvDwO/uFQsSe3Jt+aW3cFTjknXhErXZg1dpw4Ks+cDeObVY2K2b0EUUyMp6djLXgRwXHihz15ZtPzLOR3lbHMi20IgV9JDJyenaMpJF/lKxGbY83xfAn48AJCQOXjSAgFtJhns+IjkrUbZJAznRBeVb2ZjQnTHRhgUAu1kAgEAAEJcAMCcAbY8AJX/yAEKKDmJGGjta3FF2TjMWHOMMraBFGDALmhiukCxuDnnv7poF4LfXAMcFDqcDAMqJ7qqr7qrN7qrv7qsB7rsj4MMeAutj4oF/4VXgZmsWw2KhoRalYTTS3TmbNSywo4bG7clwEDod7szv7s0B7t0j7t1B7tYNAr9+0USiulGrOo3mRZE+7cHH4rz7hSE80RdsbGqTENLlDt7v7u8B7v7u4LvbLlU6E1FMMvuFxypPyXpwLaDnXMvBLup4EHhQACHqACLSDvDN/wDh/tBdArAN8TEaM60lw4SLbvMoLNbHhItPADOTHgvHLuKqEBV3AAHQACdFAAHvAAHzAMBGAAx/9wDInw8DZ/86FeAjhK8DhRkJmWjn+SqIwTz5hwRiKhQ49gA/tQDADr4ymjy4xeE0nor0VT9KY5B9PACruw9W/QEyKvZKQa9TKBhmJT5puC22pwAVu/9tDgE+9MNNYp9i2h2xojXYygKQdrE01ADmu/C5bQBDyxUrVtNlYv91MmhP4yL5gcLHaBckDRAH2/C7IwBTrhVZDRbOTaRgDDqIbvETaX6zeh9n1vBpKAE5bP2HosYHd/ctn+4Yck50vhDPsQ+WLA9DVx+gkRCVburGXu0+fdKcVUtEvxA14Q+U5QEyvlcbqvsUBj9zydf9j1+0pSRXLsFHXQBpHPADOR/BT/scbKntCBQrCFIq2Hkn/aSrbon/7qv/7s3/7u//7w7/59rdet32hzK/0f0Q6qEPkNABD/BA4kWNDgQYQJCWry19BhIYURCR6KVOgSoz8ONW7k2NHjR5AhRY4kWdKkR0aHJK5k2dLly4Jq+Gx0pAbmTZw5B3ayscvnLhsNdA79d2gOR4hED6rBE0gTxpNRpU6lWlVqUqVZta70k1Fjza1hiSL46TOoWJZqGCFFi5AioUAXHXm1WtfuXbz+MLXlGzaSFpo2+w6O+KYsUBqEDfqZuZGQ4oiH/OCBi0nTHEd8/gDO29lz3kiQRcPEw9kh2NGjRR3exWB0JLoNteBJjfOQ/xo/kSgTKhQoEKZLwTUNHz7H+HHkyZUvZ97c+XPljKRPp159Ose9tbVHLB14O+Fi0Vg7caY4EMfZ39Wvb3teIyP28QUS4oha/tbwrFk066vm6MY/QrtvQAJXwgNAwQrcjr6N+PBDQaWKuYA1KCZpC4/YGnLkQQg7hFCNDGnzUDsGNQpwRJ0eYU2VHpjZyr+O5lAJRRrju2SjS2qsrTuN0tPxpU5OYI0KIpRSAxPTNArkRya18yNJR2ZsUjEeNcJqyohqkIU1ZMiIIic1LknSIT5ExPLMvm50SAsO0RwMNo4ukdJNg8ZggTWgxCCimJbUKGQtjzRJkE5CjUwyu0L5Yv+MI0YGTfQfZhAQEk9QnDDCBIT8IAQTR0Aq81FQdSqkR0dD1UqNThsU0NQocMCzrCeyYGEfFuLJ0CMtApnTVF5X+q8hTXpFyyj0rgwVGiheZe0UkbTApFRhoz0oNjOl1QqTjgTtFQN1RFD2JytAciQQaK019x8/Nir3XJwIGdMfB4Uthh0xJsVTho4cwWRVdvud7yt/tVp0Iy2MNVUSbi7AoY3DFPFHCz4YwYSQdQO2FluHcrTYyF/fqxhUSSaooYZKTPh443MZegjlrAp594/HWJbZ4lQb4ndmnCJpbKM52sT5Z2FjOxlohQ5RmeAliVb60UNMXFonQm71x5Gbn7b/+kc1NOLjapzUOHojbbkWG8V0yRz7pqg7cnbos9sereyGtnbbJa89+qOQXefWe7Ss19zbpUhqbhDvvwuHLEm2DXfZIz4IN/xxtASPGfKIwny3oT/IpXxzotQElnOJ/PiaYE18Bv10iUr054+8UScoko4Zddx12mNKcvLaDYIdJC00qTZ31zuGD/hMNbncoT8u+Z14yg/UaHnmBTpSahM1oTh6pnXjzTfgLsEkkEIIwcN0onb2Z3jsDTqkEME/0hePxNOPT1NMMKP+oz8kJoT8l1T3B3f5EcQPmLgfTTQRiEi0LoDfOQQeMMGI402FD5cghAIlYj7WLfAgDTSeSfJ3/4lAECIS8dMgUfwQCAh+pkdzgB53NoKoEhaEgwUMiRb+4AgcWsc6c9CE9woBvxgqZIDtU2GDNNcSQDmkakEcSCQeGEEV/mEOgeBfANeXRJLckIffK0QXe/ObS9hvJGtjyZO+YkEmFsWBKSxiRxjRQuYdCYpkmsPEqqgQpgRiDgX8AxwLgjGHwDCNQrQIVNrokDmQEHJem6MjKKhIhTjRfC9cySEm6cdBLiUScLlMZuYolRPFEUkf0cIcCgFJwIkpW2gUSCQQlEkj4cYPs6RlbiJxS+315iLU81HuMPQRRlxPNGoIxK2CJRFANmQOsFTPCYnoD4NxDkZqw8QdCRMm7P+spH1JY+Z38DBJf2iClXqTY0cyN07FuGsjmETXmJbYzWFiUUPWZBlubjlLNUBLDRWZw+VyhU7RVAle4/TfH1AJT6UQi2AArCcKC2jDP2wmJIlU0KiUtBLPNSQlCP1OMgM5s93h5VMd6lgGI9M+jXGURO+S0cZElxdnAfQ7akhSNBeTIZuqlDB+IOJG/bW4u/DhiCjKKPpc2KN36nQwh8ioRmVKKLV8JGLGkU5mNLMZLWSVD47QRCHoWSC4PQyg7kHeV5WKFotq5JjW+mV9hhotybVkdFE6647GlNOITIY3IjyoYjwaN4ZGK5nLZMkh2rfWugaUYEk9iB8uIbUJmpX/b/JsCCaeWqiwaiFxINoIXhOL1leGLnYe6Zl84AQgxsJVI4KMyF9M1NfPwqSp9kGIOklSsPUc4q/+oOjG0rq6+P1WL7EVjWEbVEWmSoW1oglcR7i5Mc5+1CUd0yxxIRPdNelqIoWQmha4Ohw2dnZHlF0dO81F1odJViBhhaZ1IdMV9NSxfpfjQwVlSAhwmrdlzzwfbB+F3fO95GtGdW9f4GsScSYkuUglzDc/8lycCdezBXGlRvxbYK7wt1gr8SgfLuyWpr5Hvf0SHJtcYr7AYlgshwjEHMO2krleNi3khVeKcVbh08g0oylV8WCOBM7kjbgohxULqmKkX5ahN5wt//ktgXs8GE11cX9gytBydUJZRgiZZfKEcELC+ocnT8m1GrExTDyK27kBuL0SaZpGZBxm9jhvTVo+CI5lg2SiCfR/KxEanJukZA8TpX14Vppwe5kQ89HZz+tpKmFzIufKQu7MZf6H4FK76AIZ10pX1tqblTa6NSNEcIrG9ExjU92bsJfSbgO1lf+R6FIzCdK8xQl65cY5UDfqIEnydKy/09RLHwSLri5ciP8pQKf5+keWfM9NqOU6JWNuX7gRnJOVPaJZB5sgfZNNr7mmZ5BM+NoEwiJiV2LnW7uOpyMx6bhrBGlUs0R11gYdi6F4aHfTyHw8Tp1GHJ07y5mT0PlmD8x6491vh9DbdYcgxEW2akpvE1w7AP73UTUqcYwTRcni/ge6M/5x21xyJdwWK8hN7pJZa2HV/4iNtk9+8r9aNiId6/LLbW6Q0VJNIehV+M1vrlCwVdHOWoi4z5VtNNIuseVGZ7pBWsy4t2Jx5U0HeXM/wkKBYJHjVAc5d3kXIq6HXSDrAyeuii72a+OhnyHZOtpPTsyyD9ftc2/iJRpTSpfTnekf1nvf/f53wAde8IMnfOENf3jEJ17xi2d84x3/eMhHXvKTp3zlLR/EgAAAIfkECQMA/wAsAAAAAKQBHgEACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as2bNo06pdy7at27csD0UiVKgQIT9w8+pFSoiRFn+AA/+5hHev4cM5IzkKzJixlkKII0t+Sehv48uAA03ezJkkHsygAUfqTLp0RjV/LjvSdOmS38aMTMueDRET7NEE1WhqXJi2798E+TDWhPBQ6sCYgCv3rcaxmoSBGDtaTt10JMaxE/rhXb375uuBsyf/XBxYs/fzh5sH5rPQdnj08Pce96dl4XbGvePrXys8MEPygM2x34BqAejPcwoV0hhkBDZIloEIJnRIf4BpgYeDGIIFIUOEXGZehiBmNZ8/Du3WmCP5hahiVJbR59AhjFz22Io0PnUfYOw5pEaMlyVX449JdRiYgA8dcglmHwKppFBHIicRHhRWmOKSVO5kICETHWJiYJdU6eVO6gUWoURNAjbdl2jaFF1gZ1IUpj9/pCnnTAYmKRF4ONoUCSaM8PGHFlr8wYcjc2iCSSCERDLmnOh9hp9FczBGpEx+GBhaY4MaWoiijFLHI2DiTSRkYFhSOuKlqMK5GiaJLtrpZqMC/3YhRZG06A8fh8z0aaq8yjhooZccWggekfihhquvpoWadBX5ceqsMb3pmK29VgtaoII64ggjc3Tr7bffMiLuuOSSq+256KLLx7rsttvuH/DCu+62hWIy7JQ/+VGIa34Cmu0crCIL1yGWQhuRGlH60+VMjuJIyJhq+IEHIYFcokmf1Fqr8cYcd5yqFqsVgm9Nh+ChyamX8qEJHrnmBWNjxE2khqWMtCxTrDHrOBcmmjiCssdABy10aH/MUYjALkWiScbVDjbyWZViirRCM0tdE84XqRFJIZjM4QgfTA8t9tjVasFIITa3dEghCQM9h8FnRXIJtVrgFtHLjP0xNUt4+v8zKUdaT1xIIJhY7PXX8AJK9uKLa6HJ0yOpgcnPmCneKyN2i1XyyZXD/VCkeUPeUt+htnSsH5FEgsfqrLOe+uuwx566H7TXbvvtxh6r++68P6c76nTxzAjll72NkhpzX6oFwHj4YbPWXDsSNmCa7G2VydNbSFGZFWZOk4JDcqYGHnxOD6r3H0k+/WCRpJ2QGoTMEfYfpW61dtsnig5dY3XbNP6WgPERaUp2CfwNyXoUWRvxjCezQBiwellRIKr+EAj3PaRhgfGcS/zAOcygjzRKC5sWKtgRKF0LEwhcyCEIgT8+fBAqJgzN8o5WkWUxhkEyWRNocuabQzgQNCjSiB//QHcZCqbwRYHI2IymYiSiXYJlGCFiAGkCwOJZ0DcsrBwOE5jEyqEQJGqQIpekgrfiQTEjsfIbTdyDGT5skToSLN4RCxLDy1xijhQpRMbmcEWklHE4+oOIcfKGR5FgEDB/YMQT9YO8NgYyN1Uc0iMzEjXYFJInkWTEJB8CvgzOZEKOeeN+ItE27TmEED/jgwZHoiXVXDInnayQKDUSpb/BRIeAmeV+mngZXeZGjBXCRB9LgkszvdImfrCVKT1yyE1GbkS2xFBlPKQQVGJmDs78yDQZw4dj0sRS9fMIAKPpElxqIZvd8UPbBPhLzNCPYdRyhDdjEkt/sNMjI1rlSgY5/8Ya7ciOBbHmZSBIk1qdaJ4uUYOtHDFMjLxJCw1NSRoRupxWNmZhunGnPl9iUOxENCfc88cLNYLB0r1EiuRcUUjtiYefERQnHQ0MD/N10ZFgTSYKZcxGQ8TGS/1hpzLBA7Xu2RMA6m0ksVwYPbn5pZ5i5qU8OaQ/fHmTG2WGJEmdiRSJqiSnCiacPqmnP4CqVW5+FCOxSqlKDmErdA4ojJhhBEVX4tRz9sSqUy2JVXMEEwzylUotBU03i1LFwe5Ein8dSYvqExPuKVVJh/AqbM56kz+qUSd4BWtIDpE3mRiIrA6qJKZqShSENcZONQFgYkWy12g1Zq7L2Wbe8GDaG/8WJaaywklmT1LSmGCwTf6MpN8QlEzHjJQnabSrTVSLkp4+tiU91cKgtsUt1tgrUc4bZSnfeMijEsWpam1JcQNDVY/sSrMrASav/kCoSwwLtm4pJo7wVUyGFmVX/kDtS1RLWUq+NiYG3Fgi3XtcyfzTjsOs4nOBktPA9I9StipvR7gHXJcIV2hmeyJ8wSLQvKGXIARrzId7kkbDwoS/J+lbXqOFX8Y5AhPtQwwvLdmQ8XaPsI0J70nwKuGN1BaR/U3J6VAnOMJpwmvEQ9XyHqYXUiIJIiXe8ElAaduT5i3IFnEyY/QLlENIbF99staSsdyVLmKqwAcBb1FsTB+3knT/QSXxIbVMmhS5FKJnvXIcaLkC14G+Er9cDeuJyKwRKuOI0BFRTBGlbJOSlS9VfAgEow0yvorNgRFfm5ciN4XoEqJMCyNuiA09SRQFsySkoT6NcPngZqIQMMAV0gSaZUYITcCaf0abNENmLJ1WCwS3yhXKjwGTam3meCSR+JlcveKHQFjqMozY80LUUIgWi1nWKREtY4SpkXqaOCjA9nVEnOUYcStEvvTh8lbU4OxLOULaBvFD8sSGOZPosYjwZkgVZwqU+nb6YAnrcUUkq8m4zTuusy5IJNQ7NGyKpM85lnKIt1wUMQbaI2LkN0fE+geBd4XaAXZ4jRnuYEUGgljH//pHxPAQiA568d8JCSz/PC4RNo+1tKcqNkYKq2sV+2PZbsGDtQFzR6qtlJswpqwfJifYhL/o6EE0ZGP+YO6VqDjYHwkp1jtiaKLvZeGg6ThCCkE5LVzC6QYhxLPTrREtXxTmDinmt/tttY/UNd8QqafG3wL2uObHD0N3I9z/kUU5XsTMs0WJGHWsEzHWzCMr1XlFum7fyChaRiREPDclXyTNz9dN1p6DrotjqQX7ZNj+2HsCgalujaQR7WvpsHTWPsLBH0TbFcq3bB1Mc46Qm+JDsfnFx/3s1msEpQPEhPlkOnqBSNbjEO910qjF+ZpI1fgNkTnwH24r2LsF8CnDO/9FtO8kDv2M25Thn/hhItbhT3uloC6JX3uy8HF1K1iBuJftJ7zD/TsE9wpDNavmfSFRTFv3E151CWQme7lnEo7FEw02QZsWYy7Ba9SUEocATHx0EOTHJc1HJlNXdSqxUlGXfWtXgiRxXsjFMSDjXh9oEG4XGqKnEl61gQPRSPiGE2JEdUQBf1/0PoWwdqnnfwxhKy94ET63MY7wRESIEJ5HHyjDaiohVo/3D3U0HEeYJfjFg0NxdDPEKYHzaO5UfafRWT0hWRzzByvThAIRfQfkhvSxfhWRRj/HQWMIgZbChUIhVhwDVSZBOj+hNalTZMIDNtbCPp4mI1t0b6elEkL/xT/XlIVZk4cimBLJ5jH1thKxpHpDUWl4xiuOgDYOBXVTcolvlxKPKEO9BxNVkzcEGC0H1ytz8IoagUvuZxQlEwiv4VM/OBExiBx91IrYIYlWGDYzKGwJs0xCIW9JZiaBUIkU0VPYV2d4cAlJZnbOZIGItFMWJR1ZCIf0QYY1IYzkhYvk4zV+wl6KxGQyAUCreBRyQzyOk0JXeEBxdxlSSBJPKFNHQY5Ex4ZlAUDiqBR4QHJa0IsHkVEyQoa7Bye02BCXdymm12XABHSzIUVyiBSSQzlidxCMSGNPQjcZiRA4WDxDdRTa+AcPyRYYCRb3A0SZgwe0944D8XsONpIB/5VKF0KH0yhqczE4gRCUrTIS6NaTe9GSYlF4dhQxDHeMFoF6ymgRQwQa6Ed4vVQRezI8EzQHzwgSqSh9pYGUmkN2lRN2A0mSlhJ/FhFZTIOCAiFWZFiNzShYCClEpWSUbyGWY8GWH1OVGnFgjHGWhIc/S3QQ8qVz7HZrvOI40NiN0rGSZaGXZAF+MgiNA2FZ/iCOlGl4CnF3Rrd8GyNyG9GQ1EOMUSFFghkVKzR0XicSGXgZnIc8TKNKDqF1GiSbEmgoQWlkWilDRbcRm+kYJBQZ7jiZ1sgrTvkRjklsDUGWmBdkVfRgAsGXYWc0oqMv8hN2OEkQH5k3w2kY3IOXUf/BbkJYIfhomQURSaEmk6CRnJ8TggLBgJJCCFiWmDsEX+AIJ5JmGD11i1LRbOVpJg8TSWoZEup5ewxHmwm0hUIXdnUpEUrJTdBYjw5GGHqBSxMpFfBja6kyi9yZMeIpEQd6g7HoYN+5oOu1nxkhZ4rIdc6JGaEIkE9xU1ShLxyaKn+ACfiiTgMlo/9woOpzn38ZoAcpZeCoCUS4kTI0B/TJFr1lIyzXM6BZIQz0PhU5etHJdH7XEajHfCIhn/LkEex2jbmWFq1VWsAzOJdwaYopI2XqEF4VpiFBctKxnQQRnIFZEoApGJB5EC+JKnxwCey4l44BgXOQOJYzNGo4qFD/Ri35qJx02pEdQZps8oLaWKDMlJ2QxpW0FRYjgp4cQadpyJXiZoqCAapqd0JNqJDudoSkGaIQQZ6HuCr6lxUqqBNz+TEhA402iUh9ShCpGho0uRC/SHQJI6ckUawZCpzt1jHSRS+awBr4t5vUWq3Weq3WWhfauq11ga3e+q3eWic7wZpEQyisAqo3mIy/GqzKY6cC8YQu9A+96g/IGjnPZoORUwiHyjj82q+huROA5y/yMijVJSzN46NoyT8P+afupH5/qV4KWJOnMnebFUn1mqyBsK/+urEcy1QGhl/SGauBQDyYY1lR6Yufplnz+qgk4VV6eDznaIgdO7Njs1qG/2FZL8sQSgoamfgPJiuH6FZwt3cqOSsSYnWyKiExFXMxfkKzTmstqVkWOBtIISSD6OOPIfsQ4Oh+86qSvJUxwxo5REYIZMutZguU4Jq23nq2bNu2brutv7qX+EWxl9kXl+KhCWtcEdGBcEJWUBm3DGGq5ZcsYuGPF6tyWlo5j6Ozael0QXtEWOuu03avpkm4OOGPVfgPC5c9D/o+aQlUe1oeEuGPK6anwOSWlstnCVM9PxQakVZIkasQfPtToNcjKLFStJu6XzGvqMIIqRm7BhFZkbiWwISkJ4Fu/qm7/wmajtOnwFuTawerB7FSFukZe1S5yvsSS3drrws4z1Y/pP/ptRvhVSw7Ejw6dZKbvbrVrEuavm3YYkcjXO6ZEd0ZhyextQirviwBoL1CtxuBmZ8mvdkHoiiBbvGqv0khN206Wa4pqgccEueLhbx1fn3kZROztJeWaYgKKBzcwR78wSAcwiI8wiRcwiZ8wh0stHmxoXM5ZqXHSiRnvCQRureCrpSmXrTpB4TAMz7ztD78w2byFgQUoNhBQ214KmHbEOhWunEGf1EbEfsIxFI8xYylLOSzi6lyNsgCbIB7p6x5uEiVMX74pbk6xWa8sXQGFvpyCUTsGG+aEGnkXRwRxXxqiW3zwOlTa2VcNijcx378x4AcyClsw0Chw66xx3CiCU3/Wpuw4XtrJ7M3KWTqJcBAiMVlQyi6OSzFknIIfBE6zMNT6hiMAGMUAWgrioYK+JWimxLohrpZEj+hXDm/2clPuTNMG8snwoRZkzBRS6G3YjcRLFP5q3B3KZWJmzIAszQy6L4qcgi/QzuDSBeEs6Z9gsjXMsqduhHh5iYMF7G58Wxg/HDC5Qje13c+pQlG3IYlmjc6qr9H1698wJUU+BH1VHmdN5sv9JroqxLyqTD0SMQvdlwcZD580M6pK1VkI12cmoWmdkGE6ZeGiRnJCzjq9U7VFKCO0JU6ss6YosjYOxtL7KzmehdqA04QOXQqvBCqDCqm2c89SxDsGXYW2kBt/7qEmzIneJVn7DUHl4AonDITbHaAd3phFv0QwbyNKsGqMNMbUwlEoogRBXnJhpIow1waQncu9gcswkIIzfPREZFG9pwbHO3PMgOxVQ3ThEkYyteeXaxy1ZaG9IJ/dUG2rVPXdn3XeJ3Xer3XfL3XhLwXDX2Da72lFlG/v7xWdHxNbV0Q1GbJZ/zYqELJptF1N4e4YaOgGFGs9nTWN3hhObbYEkI+bQzZZgxRoWUrKjnYRfTUfzmAVseakroSlTYHC0zaTuvVaMGHXjRplDrLJiG8d8vMB7M1XSM9ti3Faawfnl0hvv0ReIpIT2zUo02v6SwTzqw6g1M4FhOt4NLd3v/93eAd3uI93uQNMLh9FmtTnmaXhfuY0l75aQHWvLT8Fszom38db0PX3BwhWTPIrm1k0PNtFquZxS7xot5JhPrsGGAV1e6m0QEOFlXbK5KdNRfGB9EtEADoyvI61uuxSA+uFdvbuxEqUhwlhI7wxIJLPRFFbW28PA7+4VCxJ7cm35pbdwVOOSdeEStdmDV2nDgqz5wN45tVjYrZvQRRTIynp2MteBHBceKHPXlm0/Ms5HeVscyLbQiBX0kMnJ6doykkX+UrEZtjzfHsXs1D5eNICAW0mGez4iOStRtkkDOdEF5VvZmNCdPtTu11Xc1jLGhOEjZa21p8QTYeE+YMo6z/TRA1CJAbWtt5FijBAAdwMAyUXumWfumYnumavumc3ume/unD8AHLMBleBmaxbDYqGhFqVhNNLdOZs1LLCjhqbtxiMwq1cOu4nuu6vuu83uu+/uvAHuzCnuuJkAZ7obRSqjGL6k2WNeHOzeG38owrNdEcYWdsbM2NkQjDvu3c3u3ezu1nsBZaQzH8gsslR8p/eSqg7VDHzCvOfhp4sC9IVi3a/u32fu/4Luzj4BURozrSXDhIZu4ygs1s2F3nLSF2yyvUvlZfZmQZ3C+AAgb5PvEUf+/GYAAgIBUFmWnp+CeJyjjxjAlnJBLFlNxA7eMpo8t/XhNJ6K9FI/KmKUax/27dCa9kpLryMoGGYlPmm4LbqHfhJPHORGOdON8Suq0x0sUImnKweqJM674RK1XbZgPzRT9lQugv84LJwWIXKAcU9STHN+FVkNFs5NpGAMOoVe8RNgf0NxFS4QwTYs/YeixgSn9y9w3jhwTnS2FZSU6DV5kQkWDlzlrmPn3wjFJMRbsUqDfzKbFSHhf4Ggs0Sc/T+Yddhg8kVQT2TSF8M+H4FLHGtJ7QgUKwhSKth5J/2kq2qr/6rN/6rv/6sB/7sg/7fa3Xd19Zc3v5zPT3+8X7a7k1h3zcwt+xmZsVqPf2SCFWW068vg84Udqbwx/9Q7P8RDGvyH8U8kX9EiEJXP/Q/K45FxWDadgu/cO/8E2BW/Sq+/wHZylhAlSwD9OQpy9hwRTDM+j4J+Sf/yTuFSsNEI7U/CNY0OBBhAkVLmTY0GFBTf4kTsT00OLDSU927SoiUQueiyFFPjykxk8kPIQIFQoUCNMlmJpkypxT0+ZNnDl17uTZ02dORkGFDiUqdCLFkUmVLk2KR8tRfwKZTqXqMOJRQAycVXWoTtXGXTZsfeRa1uxZtGgDQWWU1u3bgoSgRh0I127Dq/5Q4drFohncZmzAgqUi7u5hxImV4oH6p65iyCLlQuXjJ3LiS/6mCd4IZZLbDLIGbzRj4vJp1IjV/IEKMvVrhZOP/okE+y3/pgujVfVgZnZKptEb4xi2Xdy40sxHLx0/7hQqWeZlO50IToVI1QFFLAVXhSD6d/AJ/Tyd6OhQeNjOoRZCP7WG6NHIyERZOmVWq+C7vFRr3z96co8s8w+1SFiD6pLzBhRpDBbys0EMIoq5aAAlJPgqP1EkUXDD1NQgT6KKOLzMDz7mYuQxERtiBgHq8gPFCSNMQ6iYCYxAQpEL8xMhmxR7VKyQo7RA0cfD1HBkLj5qI5KhKHDIb7AnsmBhHxyykCXHJ3dp4xFtlvTyrTmO0uTLxA4J8zn2yEwIGiiydPPJNooYQE06yzJQItfqtAuTufzRZEg6MVBHhDcLzUIdDfVU/3QpP6ACdNGzCPlwosog/acYdsRosdCNbMgCCfosFTUk2aIa9S0S59IiTUsl4eYCHNrIbwERPEHCiB9O1dUiPidable01DiTrUcXlWSCGmqoY4I5gXX2obz8YfXZsgqZVKI/CKF2W24VOnIiJbutKpIS55pDQHHTdfZOf4pVV6RDop1Ii0DetVfUQ2a7typC2C0v3H0D9lKNo/gQeCo15J3oz4MbTrFRSh1mqt8+tcDEXYkzLg5iiQzWOKmE+/Tnj0IS/Phk2wieF+WkIvkWyZJZlvm0STGeOSFrReYj5pt7tutlf7T12SI1Lrl2oj8CsXlopkUC0M+mLfJD4Xk1Qf83aqwlm83krBeKZNg+GeG5a7IX8vAoocv2GmxVNclTbbj/AbutuBea+ujZLnm7bqwZO2pvvg1SAxN/5/pDE0KWDpzDQ1BaqaWXLsEkkEIIwePqqsqViO7FEzqkEKBFjgoTPBTv/Dg/CMFkDkcKFx1bRjAhBPORSg36dLsJf/0oRzQJJBKucbftEDwwYQTv3V/n4xJCgr9I85GdF54g4jVBXuQ/GLkkEEIiMX36svwI5Pjky39dizkAd8hvpMBXqHrXzdfiD0fqL6qoOTSRvJDS3W/ID0yEznwD1JnSQsIIqADMfwiJhPGuR0AC/mEOgaDd9D6HwAg6In+TK0QHWeL/kkuwLn7PuZjUJmWeBTaEeA6EYAtNpL7FDe6BlJqD7CrYEDXgIRBzGOHIYIiQXrUvhQ/xQyEuwYgeulB0c/he1BI2Q0cwr4kOaSD0oBIiFVrxh0M0WyQIEQhNsI4PM3QhbWKIieuhrxBTHEkkjNYnTUjvIJFoDBu5qBA1mMQPe+TjSSLxR8ex5Ijxg07c8DBCRiROMWoIROHG5JAgSmQOd3yN+AQoLbgJS2QWu2GRngaih4SuXpR8DR6s6Cc59kyGfUpaKhUjqdY4ZDwJJOVr1IBB3nUyXSb54x7zmBA1RKIQc8AbvVwZGfV07Jj/sJ1japkaM6kqbepiJBLP9wds/86Qid8B0lFG2ZBPMmKZz4RLJIXYra8pUWdbhA3Y/rDMQ4TuV+Q8DSyhModxLmpq6qwYJvKJmrNNZFp289dA6akYPwhQnNTKGT8LZkD/PI1zDWGfRxR40DJ90h8L3dUtRccHRtQkKI7gAx+yqQWU8qF3hdDldzjmDy3kcy2zaSlG39JNMe3qkH1yBERHBbRp4gUqKLQpMq9lUKmlpHLeQ485OxbUUUVykhaJJ1QeWVTIVBSmF2WIHy7huuXVFDIenYs/n/VSIV1kNevBamRwii3F+YFtIjtXcQpkOK7qCmhYfEgkJuXMtirmk1JhiD3Lt6rXHMKp/tgmt94KWIu81f8ffA3sXapasBseQqPlo6xiXNanb3Jrred8CNjSWlnV+MuYBvmc67TQO5mQby5ItQsecDkbdu5qpgEKyUsxiVrE+KFw6MPE6vDGh+Yd5BCEOGVuq3XJjdpxUaPdnEiiNVHg2kW4EIzjQjT7nLyaxZSiC+27JEtbhdDxKNLN7kgSKj/0GsScfGCvQ74rMkaIlVpA04J+CQI9qLbXLYcIxAwZZhF5EfUsZEVSgO2l3vL882nzFPBdBnfKP1zCv9QL3VXLYqQ+pU9ju5WIhxvyVuxW+C6p6+DslkJdUJrltpvbcLpmXF676UvFKfIrVBycFHMilmUw/q0KofLPHTfnOTX/Tu9znCuwZErkxwZhV32TjBoS+4O+VAndkw8m2UIuBHpMvrJtPjnVpWi1szIL8pT/AbTwljk8lxUoU27LByQ3TGHxBRqZ5WxLdp3WvT7GmsLW/N+j+PnPqdEqmkVCYo8V2kSPmlSeF21mWo7ktof2mUZXW5CX/uHSIjoE9FL8EHZ5GWVZxhYmvPfeiZx61O3RapyBGSRLfyzKu4vvrMFzWxNTsWBxg/Xu3ulrDlVU0A8playxRuAHhhnZA4IehR1SKkdn8o2GU/W0i0PiZTek2Z1b7hFVOoexeVtBMM42QyrqbHXH+9Fs7euw5X3vpZQ6lg5RmUdyjW98a1ULbiYIlrtsDXCEA7GsxwQbjhP+cIXM1RFxJjG8IX7xaM7Fak2e178v7u140ZWrBv94yRVS4AKi6LYEN3nCP7tE19y21y2HeCF6OL9901zn1CvEKTfp8Z2rGw/E5HXQjS64QPh8skdnukHcWC70HbzpOrfy1K1+daxnXetb53rXvf51sIdd7GMne9nNfna0p13ta2d7293+di4GBAAh+QQJAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3btywPRSJUqBAhP3Dz6kVKiJEWf4AD/7mEd6/hwzkjOQrMmLGWQogjS35J6G/jy4ADTd7MmSQezKABR+pMunRGNX8uO9J06ZLfxoxMy54NERPs0QTVaGpcmLbv3wT5MNaE8FDqwJiAK/etxrGahIEYO1pO3XQkxrET+uFdvfvm64GzJ/9cHFiz9/OHmwfms9B2ePTw9x73p2Xhdsa94+tfKzwwQ/KAzbHfgGoB6M9zChXSGGQENkiWgQgmdEh/gGmBh4MYggUhQ4RcZl6GIGY1nz8O7daYI/mFqGJUltHn0CGMXPbYijQ+dR9g7DmkRoyXJVfjj0l1GJiADx1yCWYfAqmkUEciJxEeFFaY4pJU7mQgIRMdYmJgl1Tp5U7qBRahRE0CNt2XaNoUXWBnUhSmP3+kKedMBiYpEXg42hQJJozw8YcWWvzBhyNzaIJJIIREMuac6H2Gn0VzMEakTH4YGFpjgxpaiKKMUscjYOJNJGRgWFI64qWowrkaJoku2ulmowL/diFFkbToDx+HzPRpqrzKOGihlxxaCB6R+KGGq6+mhZp0Fflx6qwxvemYrb1WC1qggjriCCNzdOvtt98yIu645JKr7bnoosvHuuy22+4f8MK77raFYjLslD/5UYhrfgKa7RysIgvXIZZCG5EaUfrT5UyO4kjImGr4gQchgVyiSZ/UWqvxxhx3nKoWqxWCb02H4KHJqZfyoQkeueYFY2PETaSGpYy0LFOsMes4FyaaOIKyx0AHLXRof8xRiMAuRaJJxtUONvJZlWKKtEIzS10TzhepEUkhmMzhCB9MDy322NVqwUghNrd0SCEJAz2HwWdFcgm1WuAW0cuM/TE1S3j6/zMpR1pPXEggmFjs9dfwAkr24otrocnTI6mByc+YKd4rI3aLVfLJlcP9UKR5Q95S36G2dKwfkUSCx+qss57667DHnroftNdu++3GHqv77rw/pzvqdPHMCOWXvY2SGnNfqgXAePhhs9ZcOxI2YJrsbZXJ01tIUZkVZk6TgkNypgYefE4PqvcfST79YJGknZAahMwR9h+lbrV22yeKDl1jdds0/paA8RFpSnYJ/A3JehRZG/GMJ7NAGLB6WVEgqv4QCPc9pGGB8ZxL/MA5zKCPNEoLmxYq2BEoXQsTCFzIIQiBPz58EComDM3yjlaRZTGGQTJZE2hy5ptDOBA0KNKIH/9AdxkKpvBFgcjYjKZiJKJdgmUYIWIAaQLA4lnQNyysHA4TmMTKoRAkapAil6SCt+JBMSOx8htN3IMZPmyROhIs3hELEsPLXGKOFClExuZwRaSUcTj6g4hx8oZHkWAQMH9gxBP1g7w2BjI3VRzSIzMSNdgUkieRZMQkHwK+DM5kQo55434i0TbtOYQQP+ODBkeiJdVcMiedrJAoNRKlv8FEh4CZ5X6aeBld5kaMFcJEH0uCSzO90iZ+sJUpPXLITUZuRLbEUGU8pBBUYmYOzvzINBnDh2PSxFL18wgAo+kSXGohm93xQ9sE+EvM0I9h1HKEN2MSS3+w0yMjWuVKBjn/xhrtyI4FseZlIEiTWp1oni5Rg60cMUyMvEkLDU1JGhG6nFY2ZmG6cac+X2JQ7EQ0J9zzxws1gsHSvUSK5FxRSO2Jh58RFCcdDQwP83XRkWBNJgplzEZDxMZL/WGnMsEDte7ZEwDqbSSxXBg9ufmlnmLmpTw5pD98eZMbZYYkSZ2JFImqJKcKJpw+qac/gKpVbn4UI7FKqUoOYSt0DiiMmGEERVfi1HP2xKpTLYlVcwQTDPKVSi0FTTeLUsXB7kSKfx1Ji+oTE+4pVUmH8CpsznqTP6pRJ3gFa0gOkTeZGIisDqokpmpKFIQ1xk41AWBiRbLXaDVmrsvZZt7wYNob/xYlprLCSWZPUtKYYLBN/oyk3xCUTMeMlCdptKtNVIuSnj62JT3VwqC2xS3W2CtRzhtlKd94yKMSxalqbUlxA0NVj+xKsysBJq/+QKhLDAu2bikmjvBVTIYWZVf+QO1LVEtZSr42JgbcWCLde1zJ/NOOw6zic4GS08D0j1K2Km9HuAdclwhXaGZ7InzBItC8oZcgBGvMh3uSRsPChL8n6Vteo4VfxjkCE+1DDC8t2ZDxdo+wjQnvSfAq4Y3UFpH9TcnpUCc4wmnCa8RD1fIephdSIgkiJd7wSUBp25PmLcgWcTJj9AuUQ0hsX32y1pKx3JUuYqrABwFvUWxMH7eSdP9BJfEhtUyaFLkUome9chxouQLXgb4Sv1wN64nIrBEq44jQEVFMEaVsk5KVL1V8CASjDTK+is2BEV+blyI3hegSokwLI26IDT1JFAWzJKShPo1w+eBmohAwwBXSBJplRghNwJp/Rps0Q2YsnVYLBLfKFcqPAZNqbeZ4JJH4mVy94odAWOoyjNjzQtRQiBaLWdYpES1jhKmRepo4KMD2dUSc5RhxK0S+9OHyVtTg7Es5QtoG8UPyxIY5k+ixiPBmSBVnCpT6dvpgCetxRSSrybjNO66zLkgk1Ds0bIqkzzmWcoi3XBQxBtojYuQ3R8T6B4F3hdoBdniNGe5gRQaCWMf/+kfE8BCIDnrx3wkJLP88LhE2j7W0pyo2RgqraxX7Y9luwYO1AXNHqq2UmzCmrB8mJ9iEv+joQTRkY/5g7pWoONgfCSnWO2Joou9l4aDpOEIKQTktXMLpBiHEs9OtES1fFOYOKea3+221j9Q13xCpp8bfAva45scPQ3cj3P+RRTlexMyzRYkYdawTMdbMIyvVeUW6bt/IKFpGJEQ8NyVfJM3P103WnoOui2OpBftk2P7YewKBqW6NpBHta+mwdNY+wsEfRNsVyrdsHUxzjpCb4kOx+cXH/ezWawSlA8SE+WQ6eoFI1uMQ73XSqMX5mkjV+A2ROfAfbivYuwXwKcM7/0W07yQO/YzblOGf+GEi1uFPe6WgLolfe7LwcXUrWIG4l+0nvMP9OwT3CkM1q+Z9IVFMW/cTXnUJZCZ7uWcSjsUTDTZBmxZjLsFr1JQShwBMfHQQ5MclzUcmU1d1KrFSUZd9a1eCJHFeyMUxIONeH2gQbhcaoqcSXrWBA9FI+IYTYkR1RAF/X/Q+hbB2qed/DGErL3gRPrcxjvBERIgQnkcfKMNqKiFWj/cPdTQcR5gl+MWDQ3F0M8QpgfNo7lR9p9FZPSFZHPMHK9OEAhF9B+SG9LF+FZFGP8dBYwiBlsKFQiFWHANVJkE6P6E1qVNkwgM21sI+niYjW3Rvp6USQv/FP9eUhVmThyKYEsnmMfW2ErGkekNRaXjGK46ANg4FdVNyiW+XEo8oQ70HE1WTNwQYLQfXK3PwihqBS+5nFCUTCK/hUz84ETGIHH3UitghiVYYNjMobAmzTEIhb0lmJoFQiRTRU9hXZ3hwCUlmds5kgYi0UxYlHVkIh/RBhjUhjOSFi+TjNX7CXorEZDIBQKt4FHJDPI6TQld4QHF3GVJIEk8oU0dBjkTHhmUBQOKoFHhAclrQiweRUTJChrsHJ7TYEJd3KabXZcAEdLMhRXKIFJJDOWJ3EIxIY09CNxmJEDhYPEN1FNr4Bw/JFhgJFvcDRJmDB7T3jgPxew42kgH/lUoXQofTKGpzMTiBEJStMhLo1pN70ZJiUXh2FDEMd4wWgXrKaBFDBBroR3i9VBF7MjwTNAfPCBKpKH2lgZSaQ3aVE3YDSZKWEn8WEVlMg4ICIVZkWI3NKFgIKUSlZJRvIZZjwZYfU5UacWCMcZaEhz9LdBDypXPsdmu84jjQ2I3SsZJloZdkAX4yCI0DYVn+II6UaXgKcXdGt3wbI3Ib0ZDUQ4xRIUWCGRUrNHReJxIZeBmchzxMo0oOoXUaJJsSaChBaWRaKUNFtxGb6RgkFBnuOJnWyCtO+RGOSWwNQZaYF2RV9GACwZdhZzSioy/yE3Y4SRAfmTfDaRjcg5dR/8FuQlgh+GiZBRFJoSaToJGcnxOCAsGAkkIIWJaYOwRf4AgnkmYYPXWLUtFs5WkmDxNJahkS6nl7DEebCbSFQhd2dSkRSslN0FiPDkYYeoFLEykV8GNrqTKL3Jkx4ikRB3qDsehg37mg67WfGSFnish1zokZoQiQT3FTVKEvHJoqf4AJ+KJOAyWj/3Cg6nOffxmgByll4KgJRLiRMjQH9MkWvWUjLNczoFkhDPQ+FTl60cl0ftcRqMd8IiGf8uQR7HaNuZYWrVVawDM4l3BpiikjZeoQXhWmIUFy0rGdBBGcgVkSgCkYkHkQL4kqfHAJ7LiXjgGBc5A4ljM0ajioUP9GLfmonHTakR1BmmzygtpYoMyUnZDGlbQVFiOCnhxBp2nIleJmioIBqmp3Qk2okO52hKQZohBBnoe4KvqXFSqoE3P5MSEDjTaJSH1KEKkaGjS5EL9IdAkjpyRRrBkKnO3WMdJFL5rAGvi3m9RardZ6rdZaF9q6rXWBrd76rd5aJzvBmkRDKKwCqjeYjL8arMpjpwLxhC70D73qD8gaOc9mg5FTCIfKOPzar6G5E4DnL/IyKNUlLM3jo2jJPw/5p+6kfn+pXgpYk6cyd5sVSfWarIGwr/66sRzLVAaGX9IZq4FAPJhjWVHpi5+mWfP6qCThVXp4POdoiB07s2OzWob/YVkvyxBKChqZ+A8mK4foVnC3dyo5KxJidbIqITEVczF+QrNOay2pWRY4G0ghJIPo448h+xDg6H7zqpK8lTHDGjlERghky61mC5TgmrbeerZs27Zuu62/upf4RbGX2ReX4qEJa1wR0YFwQlZQGbcMYarllyxi4Y8Xq3JaWjmPo7Np6XRBe0RY667Tdq+mSbg44Y9V+A8Llz0P+j5pCVR7Wh4S4Y8rpqfA5JaWy2cJUz0/FBqRVkiRqxB8+1Og1yMosVK0m7pfMa+owgipGbsGEVmRuJbAhKQngW7+qbv/CZqO06fAW5NrB6sHsVIW6Rl7VLnK+xJLd2uvCzjPVj+k/+m1G+FVLDsSPDp1kpu9utWsS5q+bdhiRyNc7pkR3RmHJ7G1CKu+LAGgvUK3G4GZnya92QeiKIFu8aq/SSE3bTpZrimqBxwS54uFvHV+feRlE7O0l5ZpiAooHNzBHvzBIBzCIjzCJFzCJnzCHSy0ebGhczlmpcdKJGe8JBG6t4KulKZetOkHhMAzPvO0PvzDZvIWBBSg2EFDbXgqYdsQ6Fa6cQZ/URsR+wjEUjzFjKUs5LOLqXI2yAJsgHunrHm4SJUxfviluTrFZryxdAYW+nIJROwYb5oQaeRdHBHFfGqJbfPA6VNrZVw2KNzHfvzHgBzIKWzDQKHDrrHHcKIJTf9am7Dhe2snszcpZOolwECIxWVDKLo5LMWScgh8ETrMw1PqGIwAYxQBaCuKhgr4laKbEuiGulkSP6FcOb/ZyU+5M0wbyyfChFmTMFFLobdiNxEsU/mrcHcplYmbMgCzNDLovipyCL9DO4NIF4Szpn2CyNcyyp26EeHmJgwXsbnxbGD8cMLlCN7Xdz6lCUbchiWaNzqqv0fXr3zAlRT4EfVUeZ03my/0muirEvKpMPRIxC92XBxkPnzQzqkrVWQjXZyahaZ2QYTpl4aJGckLOOr1TtUUoI7QlTqyzpiiyNg7G0vsrOZ6F2oDThA5dCq8EKoMKqbZzz1LEOwZdhbaQG3/uoSbMid4lWfsNQeXgCicMhNsdoB3emEW/RDBvI0qwaow0xtTCUSiiBEFecmGkijDXBpCdy72ByzCQgjN89ERkUb2nBsc7c8yA7FVDdOESRjK155drHLVlob0gn91QbatU9d2fdd4ndd6vdd8vdeEvBcNfYNrvaUWUb+/vFZ0fE1tXRDUZsln/NioQsmm0XU3h7hho6AYUaz2dNY3eGE5ttgSQj5tDNlmDFGhZSsqOdhF9NR/OYBWx5qSuhKVNgcLTNpO69VowYdeNGmUOssmIbx3y8wHszVdIz22LcVprB+eXSG+/RF4ikhPbNSjTa/pLBPOrDqDUzgWE63g0t3e//3d4B3e4j3e5A0wuH0Wa1OeZpeF+5jSXvlpAda8tPwWzOibfx1vQ9fcHCFZM8iubWTQ820Wq5nFLvGi3kmE+uwYYBXV7qbRAQ4WVdsrkp01F8YH0S0QAOjK8jrW67FID64V29u7ESpSHCWEjvDEgks9EUVtbbw8Dv7hULEntybfmlt3BU45J14RK12YNXacOCrPnA3jm1WNitm9BFFMjKenYy14EcFx4oc9eWbT8yzkd5WxzIttCIFfSQycnp2jKRQGVoApvrY51hzP7tU8VD6OhFBAi3k2Kz4iWbtBBjnTCcEAu2ADqRAe8LUn0+1O7XVdzWMsaU4SNlrbWnxBNv8eE+YMo6xNEEiwC5CuClXgNwC5obWdZ9gysO6y6ewyBMPw6aAe6qI+6qRe6qZ+6qhu6h+wDJPhZWAWy2ajohGhZjXR1DKdORcA6bpODvVgEvDDxrjMOHdQC8Re7MZ+7Mie7Mq+7Mze7MyeCGmwF0orpRqzqN5kWRPu3Bx+K8+Y67oO6QywT1vDxtYsNGDg7Oie7uq+7sl+BmuhNRTDL8FeIaMct6MmGpd7zJfhBN++C8iAADiFB/uCZBv7Aex+8Aif8MU+Dl4RMaojzYWDZPPOP9jMht113hJit/ve7zbQADphwdl9ZJjWL4laLdMQAwqf8iqv7MZgACAgFQWZaen/+CclvzjxjAlnJBLFlNxA7eP+wO/fbgNhHqg5P+gzkYT+WjQ4b5pitKyf1BdAr+tCj2svbvQugYZiY+abgtuod+Ek4e1SH+ZEY51W3xK6rTHSxQiacrB6okygzRFvwPG9UDbYjPEBPnEyEijzgsnBYhcoBxT1JMc30QMc7/HNRq5tBDCMWvbOTX1SEVLhDBOEH/Qenxt6LGBqf3L3DeOHFOdLYVlJrhKTL/WVjxCRYOXOauY+bfdzUkxFuxSo5/QqwQqF/xCnr7FAk/Y8nX/Yxfo/UkWC3xTCJxPFAPaQ3vEUscbG3Th6D63Seij5p61kO/3UX/3Wf/3Yn/3av/3Z/9/Xer35lTW3vl9CV/kSxRANtY8RdnbIx93+HZu5WYF6kY8UYrXlFqENcZD+YhqlvQkQ/gQOJFjQ4EGECRUuZNjQ4UOHhf5NpFjR4kWMGTVu5NjR40Q/fwo6UvPR5EmUKf8FMihR5cuKkljsoklTlRKYKQ9FIhToEiNHIiEOJVrU6FGImHIuZdo0kpaRJZtOpTrxUsuqH01QqWkTS1aVh/zg6YlJ0xxHfP5ARdrW7dujkcDOpTsRD9uBJOvu/ajJoFK+FSc96brrRIbATQ+p8ROJLKFCgQJhulRZ0+XLczRv5tzZ82fQoUWP9szI9GnUqU//Tdw6592ormVP9Fvw0v+hxOpUFW5FZPZv4MFZEmQU3PhGQgb1Ht9bm7hUus3YFN4lawVz7Nmn4in4B7p25skL8vEDHuzV7nLnZpBF3YwJ8/Hlc1QjdCCe+eEN/lGff+nwgjDBjaopMqFulzjE8W/B/NAb6BIGjYONIC3wi/ClQvAaiA8LlxqgCEuoUwWBC0vMzg8NHRnQRNkmJMglFk2KxD6CNCnvpSlmaeVAL6qJ8cffHPRHixuBbG1Gg24zsiM1GEFojg49GkAJCXY7UBRJltRyLzU0BGzLwPzgwyBGvgPTokA0JOiPSwgpsqJiJjACCUWsPFCEbM7Us6pCKDRzT7DUcMQgPvoDFKRBFfr/YxBc9sEhC1nsPJCmNh7R5lBMYZqjxkzrOmTTgrSAMVNCaDQog0knbaOIATp1FSUao3y1KkwO0uTPPQ8JZMyDqki1sCzUyXJWYjnyoyBci12KEDX9IW9WQuZQ04pfbcgCiSiU1VYj8QRyZNusxDRIVGLVIOQSR6AqorAFRPAECSN+AHfei2p9kF6q1AC1oDK1VeOHGmqoY4JW8TXYIuf8GfXgnDLcjxCGIzY4UYEMlfilSHgtaI43L/bYVRqT/fijQxIeSItARlb50EPWXDmnUg9yxOKXa2ZRDYL4sPklNUwe6Nadg77w2A2FVinmcTER2WimgyNaIJ2bPqlnhP4o/2RFqbP+DeeTtT4pEorHu9prslvTcOmyK3L4ID7GTvvtrMKGGG76LmlWoD8CQZtuvjkSUpO+jfX5ZBsDN/yjbv35A+vDLYpk34MYcbtxyinqkqC5K7/ocYW00ERWzQOHvLjQMfJDk7sHYhP00tPmjiDWW1cDE1P304SQvVtncSeyIpusMkwCKYQQPDpmSmN/SNf9okMKCTshRzDBI/flwfODEEzQqn2hPxjBxM1lC8q8eov8oN0hRzQJJBLGyWfuEDwwYSR1o/hos/2PkF/cfYzgRx2i7l0iEISIBPX4NxU/BGJ+cEmIFqCUktcN5EsHtIj/tucQLfzBERtUjWrmoP+JS2CiENOj4EbM9zwGKoQPejuJkwhCsxJSJBLyo18K1zSHQBjPfc1z4UM0+MHgFUKIvqOM9hqiBaV9BEUEUVEMNwI/GtqQIYyIXelmV8MNzeF7OqQPHgIxhwvirYoWsZcEnajEQvwkjDacgwHp1jMsOqJNbuzIDJEXII8c4o5jPCNG1MCTQJwlLVgsCn9khwn6ObAQdExJJOxmK/w5rjuM7KMfGeMHTGayMZHgpGMg4xNGXLBCocNDGBmBO9moIRC1A1xHyiiQOVTyOAlEocIopy+EIJGLiVGDkAQyQY08L2WyPA4e7ugPTUSSbFc8SN6UKRtmFYSP/1jiC4l5nCb/KWeXEWMMJzGpBlz9sRDSOgjKnvkbFznrnP9InOIoec2pfGpc4+OmAteYwT+sZSFtnE+fCDJMv/FrnfCsyyvNGDHOMZBDC4Lc/jhyiOdBiKDBiebGBtqp06UQiRc1zuUGsrCMhKQgIJ1oa/yAQkZwFFBre8sK3xkk4nwkggLRAgxLGphD+DJ5KgVTNhHCB0ZoxjRpUctatHBUPqSvENucz9OGdFEA4Y2pN6WLPzmlrFLKjIXFkptJTNZEqs4mnbZUyVggQ8CXJsagUKMnsV4ZS5I9r5VhbVGobBrSS2zPflOdjU8DxNMzOVULBqzPSOk6G6viLXd+gFxCOKYdJKVn/2IEASZHnrKmtB42Jb5cDrcIeTKSyuYQa/UHPw2WWO+cJLH+qKxmPfW8Z/VPpw1p7ZFqCVCDFfagJoHcYF3bGt2eLBBYa972tJC+yywQK2Lt4ZqmqayoEukkTiXrb8NUOwdiInt34wMhGHcIQhzzuVNxHkL6dbHgJg8lCVOedfkiUogkUyM5tWtgjJkQ3F5staHNSCSQ5d7EnBSD/K2IQfmQ2SfOViCM4Cu9wiZdkyCvrQCei66wCLS+jASwHvHreCbsMf8ykaNCkiiFAzO7Y7KpwRSBaEHmmq9aPjBoUUWmSRLbXhOHCTLDW/FF0svarDR3wT2OmJDzqxGn/iHHQP+6LOaoYlBySe3HBGZxQTa8ZObMdEhE7m+oxquysX7YIiHD8o9ofGCmPO/LK1vtKDmCPC6XGTu+hCtMtFzbpkFZzBMJ213lnJ8WvygnzeXDlUfmMwKHLc5/xiaNfFtW8fHNZ3iGM6NjpOU6oySqUZM0mXClIUNbOji+9LNGmotnsunUnBVJsqhjpMeYpiRWh6Mx3jBRQAEPBMeujpCWS+1jCoXaZmNVCJV5LZ/mvtgjIYZa5XLNPWEfW6x+Oknidh04C3duzdLODvJK7JHEZfqWj9zPtrmNnega0Nq6A+9PkjqHyZ27ROkV90Zmem1551vThl12zvT975fAGnYcDjaiwA1+Ei1rYc8UodGvD/7wf6xVQByB3JEhfvGKNNYfM9tIVPGN8YvL0yCFwwiznwpylFekZE+CYcNT/vKJpOmnW51IcxcOc4CDTSEybq6xcQ7wQtzTVOb+Obebd8xcRrvorsYDOYu9dKirEulAhnrV/+FIXjnQ4VZPOYK5/nWwh13sYyd72c1+drSnXe1rZ3vb3f52uMdd7nOne93tfne8ly0gACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl606QeEwDM+87Q+/MNm8hYEFKDYQUNteCph2xDoVrpxBn9RGxH7CMRSPMWMpSzks4upcjbIAmyAe6esebhIlTF++KW5OsVmvLF0Bhb6cglE7BhvmhBp5F0cEcV8aolt88DpU2tlXDYo3Md+/MeAHMgpbMNAocOuscdwoglN/1qbsOF7ayezNylk6iXAQIjFZUMoujksxZJyCHwROszDU+oYjABjFAFoK4qGCviVopsS6Ia6WRI/oVw5v9nJT7kzTBvLJ8KEWZMwUUuht2I3ESxT+atwdymViZsyALM0Mui+KnIIv0M7g0gXhLOmfYLI1zLKnboR4eYmDBexufFsYPxwwuUI3td3PqUJRtyGJZo3Oqq/R9evfMCVFPgR9VR5nTebL/Sa6KsS8qkw9EjEL3ZcHGQ+fNDOqStVZCNdnJqFpnZBhOmXhokZyQs46vVOCsEOruBuXakj64wpioy9s7HEzmqud6E24ASRQ6fCC6HKoGKa/dyzBFENirALZP/gThbaQG26hJsyJ3iVZ+w1B5eAKJwyE2x2gHd6YRb9EMG8jSrBqjDTGyaQCbsw1argA9IhihhRkJdsKIkyzKUhdOdif8AiLITQPCAdEWlkz7nR0f4sMxDr1QThy2bXDaVADlN91zXtN12sctWWhvSCf3VBtq0z2IRd2IZ92Iid2Iqd2IS8Fw19g8rHs75Wv7+8Vk+oAF5w15p9Akew1wVBbZZ8xqKNKpRsGl13c4gbNgqKEcVqT3B9g1uCCjJgA5p9156wAijhaG082mYMUaFlKyoZ2e6E1X85gFbHCJhd27uADCKQDQnFcnOwwLzttGeNFnzoRZNGqbNsEs6ABLT/Xdut8Ahc4DfMfDBb0zXSM91SnMb6cWEV2nx4ikhP/BAmMNPKbQcZfdXVHbyBMziFYzHRCi4CPuAEXuAGfuAInuAAs99msTblaXZZuI8qDRIZ0AbKDQq0IEPYRsvfd5zXctMoEd9Ep2ul8N2abQfNQHgBWtCNzeGuZre96xIv6p1EKA5SDd7QQEei6ggb7eJgUbW9UtpZc2F8MN8CYQJZoNxZUAkIIW/LF6jl7eOYhQm35rsJ49kQEZEn8sRNAArKLQMYMG1B+DGkKuVTsSe31ry/VncyTjmOIJjZsAC1fQINABHMuF7y/NpmvlnVqJjdSxDFxHh6ytaCFxFKoAq1/90G1TB+yryYOj3Pe35XGcu8G34Q+JXEwOneOZpCYWDiU00FJnARm2PN8exezRPp40gIBbSYZxNRo0YfWD4RU/nhosMAys0CksARe7LbYdde19U8xoLqJGGj0q3FF8TmMWHOMErcBIEE943lGyrdeYYtA+su1n7t2H7tQDAM3N7t3v7t4B7u4j7u5D4MH7AMk+FlYBbLZqOiEaFmNTHrYXd2BHEBys0KxaCnqp7e6p0qMVALAB/wAj/wBF/wBn/wCA/wiZAGe6G0Uqoxi+pNliXkH+HkKfOM9l7bDLBPW8PG1gzElJDwIj/yJG/wZ7AWWkMx/ILLJUfKf3kqsZ41x/98GU5Q28iAADiFB/uCZP2+CCX/80CP8OPgFRGjOtJcOEjG8jKCzWzYXQxeHDDeGDWv2TZQ5zlhwf59ZJjWL4nKsSkQ9GAf9MZgACAgFQWZaen4J12/OPGMCWckEsXE3kTt4f4w9XdtA1ZwK7os7DWRhP5aNG5vmmK0rJ/UF3Y/1XiPaz3O9y+BhmJT6ptS3ahn5CSR8Xef90RjnYzfEtetMdLFCJpysHqiTDGvEW9Q2zbQC2WDzU/P4RMnI4EyL5gcLHaBckBRT3J8Ez2A+nXebOTaRgDDqJtf8dQnFSEVzjCx+1Rv9TeoxwIG+ifX4mZ+SFnLFJYl6Cqh/HfP/Af/EQmT7qylLtStLyfFVLRLgXqErxKswPsP4f0aCzSfD9T5h13jXyNVlPtNIXwyUQyWDxC7dtlo8M/gQYQJE/opdMmRFn8RJU6kWNFiRC1a/vBxxGiOJk2XLmEKFKjQyUKEVK5k2dLlS5gxZc6EicfmTZw5ddr0o9DnT6BBhQ4lWvTgIUYU+agx2tTpU6N4KhaCWhVosWgCtRK0ivBQpIaM/lwkW9bsWbRp1a5lu5bRoa5x5cZVw4eiI6Zz9e41WGgq36fa4mgVyBWwQTV4AmkS29bxY8iRJaOletiyZT9jJ+K93LlpoL+egUpiQXiXKiWivUYiFOgSI0eaJ8+mXXsy/ybVua1Ggrg5r27gBi+FDm6CimlVWIL/POQHT2tMmuY44vOnt23s2WtHWt59KJ7rETl7z62pIm7gk56YPpGBvNNDavxEek6oUElMIi+B5D/H/38AAxRwQAILNPBAARlRcEEGG1zwvPciVAi8u36T0DLzKLoELtXUUcW0Voi4cEQS4wJtIkZKvJCQisZTca8MUbTwsGbYMG0XWVZ4cUcef5Jqoj9m7BE4FpXqaci4hqPoD+4sy0CWG80wAUkqX1RDtojwqLK7IoFscsunTqQIEw71EieTG3eJQxww24xQSYkucTM4CifSQss5jSokvIj4wJMuTLSwAzkE8jQUOD/Cc/+kzEM9q3OiyhoNKhIsJdLkSKjUuKS3QdYTyItqJBX1Mjj90QLTUS+jtKINU/VJjaQsmuNPotQoJNaJUhFIFElc9VUuNcJD71fM7KKIESF9DYRPif64hBBUEfKDEEwcKUuGbIjVtiq/JNIi2W2BtVapL7X1Y1yy/ugIttjQ0iIQRsOVV6g5JtJk3sMOqZciLSLdlpBKI9MCE3DxNfggLGk9eC5MLNKk4FEPCcRYyBwJBOKF8fWDIowzdooQZvmIVltC5mDWLEcwKddjlv/p0h9HWt7LD4q99TdcNQhx6GQt+GAEE0I6lnnehuMcWi819j1WaFfliyQSP/xg+miDY/T/52aqrdqzoj8Iyfrro9H1Z2WwoYqkZonmGLlstrfFcuq2fTrEam8DiftuYg8BEu+uALbIEbL5FrxNNSbiY/Cq1KDbUrgRd/y9jSU6/PGn/K5o4MYp11y1yPvc3CnFL/qjkHg/Nz24wr09valIxDac9NVj1y28zE3f2iI+YJd9d8vE9pr3oTQ92Z8/Lgb+eLlKvRd5ofxY3NtLmZe+qZf/KH16hCJR2iJGdMf++4SCneh38H3SviwtNFG4/Om3T5H9n5wfPiJn14ef9x8lsv/+f9TAJOAlaSJo/PvVV55zn0DkZyQmIQQe1taVmr2PgAo5RCFcd5GU4aF2E4QctaYD/8Cy/OFn0IrLy/xBPg4u5H9pcYQmAhGJ66XwPYfAAyYYMT/H8OFZMRxKzawnQ7nhQRM45BojLhEIQkRig0Csih8CcUPt2GlWT8lfRIbFxITQUBMgdJe6HLEuBzHoIyMphAaxGBQ/VCuKZeGD8YyCq4gE7owGiYQNiZidP8whEA/kYAXhiBZ1fYQkKEFgfj7oLoIVJVGb4eEc/0FDO67xIozY3/38d0d/8GEOQOMjUBITiDlwkXiVTEjRJHJFR6IxLKK0zRyWuDrFEdERz3qlQuqItomgkjloI2UqX8WaxUyHD5hkC5P4d0myaGEOhajlUCKxKYc1ko5LaqYv+yefqP9lM2pP4+YBXdMYi9wJfnjgIiMGCBw1BCJgyxOKKSMyB2tGyIkXvBr4knaRgXVSNJqC0FBcZ7d4RggPuNSENE2HTK7Ba0Qgo0gv/7HIicgxoLqBVYv0STWnQU1qyVIDWEwWToWW6FGZNKgJgzTRGW4PIyj8WjrBic8/xJSIruRRtyQCUKGUyh9vQel73HlKsJ2vNn5C0vZ+KJRDuE5OPSUPQykyB4PKy3m2GVhUIyQ+iWDNJ5mhiFaZmptzVYSnLbvdbNpYzdyUSoJCqaKpJPpVzxxCpzu1atP+aDiPzEFB1KmOdTLSsxYW4qIv6pyprCom+g0WroexqaUyRs6/udH/YL4zCt0WtdjujLSeUHGOfZKI1sv8tE8sNZg74VmUpFKEnZgFTlu18FaF+OESANShYtF5V3+QqWWF/ZZRrtRV1i6nscQTmh9UehG1kWhVS4LtvMSmy0mF56TBBY5OXfQTp7rLq8A5hGj9QdOjNXa6RRkudKl7mdQa7oFydYx5c9M6i+D0aL8FalO219vz5oa+dWNUBQGohRaCBIrEaS1u/+DQhSH2VE0p7Gbzy7mAKRMTmPhoRfhAiHgdghC4RLBeLDhJ0I5qvzt1itXW+mDPcHUtBQUKe+3UXLkMlCzyLdtwt2s+jqEYrPQM540P8tOldMbF3LMty8S2YKPUjLQ6/7aMxIj4sMrepa5NqSjulsy2SEjZKKVaKpNV4z9cOqvIj3TdapFGzyk6DrH+MHNQGntiL4tmWichYeIq5d6q3JURY87aH2kMlML+Ic6G4g1FrgyVn/broJXysUH0NpEpD5pEruUzju3U4btp9tAIeZuk87TmIMfFdZjG23DFKZSaVdrTEtLpaa3SVjxTLtGb/ofYYLxqFaU3q12BIx8izbfF3Vhsqsb1e0aM36c0mNabW5x7U13sObXV1U5B7OSQtzhk+SQ8v4Y2qyly64TAMdanm+u7GBXobs/pEBGESsKwt2b6qUw+YoNzuqnUVnAjxk7cfpxmy9Joe78Ijm0WSvGWJVe+sJ7lqAEHUxWRTZSX1Zt5TkYfqRk+opp1GeITmbY9ock1i1/8QgqeWsQJqOHXcGSZ/Ba5sbHU8aBUUeItp/lngEsUg3uu5juHyrobWqt981zoTXHtsv+BpXwPneei1W1QtvdnpUddIccFXFAQO3OpS11fDntgzg2bdbBT8HnfDRzSw352hCzrImdFCByNjvadw5csaYYjwOHO80KIUiM/v/vdK4hLfLK87xfHQ4XJYvfBKz2dgM9t4h2fvUsYS5lJf3zWQ1x5zGde85vnfOc9/3nQh170oyd96U1/etSnXvWrZ33rXf962MeeiQEBACH5BAkDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3LA9FIlSoECE/cPPqRUqIkRZ/gAP/uYR3r+HDOSM5CsyYsZZCiCNLfknob+PLgANN3syZJB7MoAFH6ky6dEY1fy470nTpkt/GjEzLng0RE+zRBNVoalyYtu/fBPkw1oTwUOrAmIAr963GsZqEgRg7Wk7ddCTGsRP64V29++brgbMn/1wcWLP384ebB+az0HZ49PD3HvenZeF2xr3j618rPDBD8oDNsd+AagHoz3MKFdIYZAQ2SJaBCCZ0SH+AaYGHgxiCBSFDhFxmXoYgZjWfPw7t1pgj+YWoYlSW0efQIYxc9tiKND51H2DsOaRGjJclV+OPSXUYmIAPHXIJZh8CqaRQRyInER4UVpjiklTuZCAhEx1iYmCXVOnlTuoFFqFETQI23Zdo2hRdYGdSFKY/f6Qp50wGJikReDjaFAkmjPDxhxZa/MGHI3NogkkghEQy5pzofYafRXMwRqRMfhgYWmODGlqIooxSxyNg4k0kZGBYUjripajCuRomiS7a6WajAv92IUWRtOgPH4fM9GmqvMo4aKGXHFoIHpH4oYarr6aFmnQV+XHqrDG96ZitvVYLWqCCOuIII3N06+233zIi7rjkkqvtueiiy8e67Lbb7h/wwrvutoViMuyUP/lRiGt+AprtHKwiC9chlkIbkRpR+tPlTI7iSMiYaviBByGBXKJJn9Raq/HGHHecqharFYJvTYfgocmpl/KhCR655gVjY8RNpIaljLQsU6wx6zgXJpo4grLHQActdGh/zFGIwC5FoknG1Q428lmVYoq0QjNLXRPOF6kRSSGYzOEIH0wPLfbY1WrBSCE2t3RIIQkDPYfBZ0VyCbVa4BbRy4z9MTVLePr/MylHWk9cSCCYWOz11/ACSvbii2uhydMjqYHJz5gp3isjdotV8smVw/1QpHlD3lLfobZ0rB+RRILH6qyznvrrsMeeuh+012777cYeq/vuvD+nO+p08cwI5Ze9jZIac1+qBcB4+GGz1lw7EjZgmuxtlcnTW0hRmRVmTpOCQ3KmBh58Tg+q9x9JPv1gkaSdkBqEzBH2H6VutXbbJ4oOXWN12zT+loDxEWlKdgn8Dcl6FFkb8Ywns0AYsHpZUSCq/hAI9z2kYYHxnEv8wDnMoI80SgubFirYEShdCxMIXMghCIE/PnwQKiYMzfKOVpFlMYZBMlkTaHLmm0M4EDQo0ogf/0B3GQqm8EWByNiMpmIkol2CZRghYgBpAsDiWdA3LKwcDhOYxMqhECRqkCKXpIK34kExI7HyG03cgxk+bJE6EizeEQsSw8tcYo4UKUTG5nBFpJRxOPqDiHHyhkeRYBAwf2DEE/WDvDYGMjdVHNIjMxI12BSSJ5FkxCQfAr4MzmRCjnnjfiLRNu05hBA/44MGR6Il1VwyJ52skCg1EqW/wUSHgJnlfpp4GV3mRowVwkQfS4JLM73SJn6wlSk9cshNRm5EtsRQZTykEFRiZg7O/Mg0GcOHY9LEUvXzCACj6RJcaiGb3fFD2wT4S8zQj2HUcoQ3YxJLf7DTIyNa5UoGOf/GGu3IjgWx5mUgSJNanWieLlGDrRwxTIy8SQsNTUkaEbqcVjZmYbpxpz5fYlDsRDQn3PPHCzWCwdK9RIrkXFFI7YmHnxEUJx0NDA/zddGRYE0mCmXMRkPExkv9YacywQO17tkTAOptJLFcGD25+aWeYualPDmkP3x5kxtlhiRJnYkUiaokpwomnD6ppz+AqlVufhQjsUqpSg5hK3QOKIyYYQRFV+LUc/bEqlMtiVVzBBMM8pVKLQVNN4tSxcHuRIp/HUmL6hMT7ilVSYfwKmzOepM/qlEneAVrSA6RN5kYiKwOqiSmakoUhDXGTjUBYGJFstdoNWauy9lm3vBg2hv/FiWmssJJZk9S0phgsE3+jKTfEJRMx4yUJ2m0q01Ui5KePrYlPdXCoLbFLdbYK1HOG2Up33jIoxLFqWptSXEDQ1WP7EqzKwEmr/5AqEsMC7ZuKSaO8FVMhhZlV/5A7UtUS1lKvjYmBtxYIt17XMn8047DrOJzgZLTwPSPUrYqb0e4B1yXCFdoZnsifMEi0LyhlyAEa8yHe5JGw8KEvyfpW16jhV/GOQIT7UMMLy3ZkPF2j7CNCe9J8CrhjdQWkf1NyelQJzjCacJrxEPV8h6mF1IiCSIl3vBJQGnbk+YtyBZxMmP0C5RDSGxffbLWkrHclS5iqsAHAW9RbEwft5J0/0El8SG1TJoUuRSiZ71yHGi5AteBvhK/XA3ricisESrjiNARUUwRpWyTkpUvVXwIBKMNMr6KzYERX5uXIjeF6BKiTAsjbogNPUkUBbMkpKE+jXD54GaiEDDAFdIEmmVGCE3Amn9GmzRDZiydVgsEt8oVyo8Bk2pt5ngkkfiZXL3ih0BY6jKM2PNC1FCIFotZ1ikRLWOEqZF6mjgowPZ1RJzlGHErRL704fJW1ODsSzlC2gbxQ/LEhjmT6LGI8GZIFWcKlPp2+mAJ63FFJKvJuM07rrMuSCTUOzRsiqTPOZZyiLdcFDEG2iNi5DdHxPoHgXeF2gF2eI0Z7mBFBoJYx//6R8TwEIgOevHfCQks/zwuETaPtbSnKjZGCqtrFftj2W7Bg7UBc0eqrZSbMKasHyYn2IS/6OhBNGRj/mDulag42B8JKdY7Ymii72XhoOk4QgpBOS1cwukGIcSz060RLV8U5g4p5rf7bbWP1DXfEKmnxt8C9rjmxw9DdyPc/5FFOV7EzLNFiRh1rBMx1swjK9V5Rbpu38goWkYkRDw3JV8kzc/XTdaeg66LY6kF+2TY/th7AoGpbo2kEe1r6bB01j7CwR9E2xXKt2wdTHOOkJviQ7H5xcf97NZrBKUDxIT5ZDp6gUjW4xDvddKoxfmaSNX4DZE58B9uK9i7BfApwzv/RbTvJA79jNuU4Z/4YSLW4U97paAuiV97svBxdStYgbiX7Se8w/07BPcKQzWr5n0hUUxb9xNedQlkJnu5ZxKOxRMNNkGbFmMuwWvUlBKHAEx8dBDkxyXNRyZTV3UqsVJRl31rV4IkcV7IxTEg414faBBuFxqipxJetYED0Uj4hhNiRHVEAX9f9D6FsHap538MYSsveBE+tzGO8EREiBCeRx8ow2oqIVaP9w91NBxHmCX4xYNDcXQzxCmB82juVH2n0Vk9IVkc8wcr04QCEX0H5Ib0sX4VkUY/x0FjCIGWwoVCIVYcA1UmQTo/oTWpU2TCAzbWwj6eJiNbdG+npRJC/8U/15SFWZOHIpgSyeYx9bYSsaR6Q1FpeMYrjoA2DgV1U3KJb5cSjyhDvQcTVZM3BBgtB9crc/CKGoFL7mcUJRMIr+FTPzgRMYgcfdSK2CGJVhg2MyhsCbNMQiFvSWYmgVCJFNFT2FdneHAJSWZ2zmSBiLRTFiUdWQiH9EGGNSGM5IWL5OM1fsJeisRkMgFAq3gUckM8jpNCV3hAcXcZUkgSTyhTR0GORMeGZQFA4qgUeEByWtCLB5FRMkKGuwcntNgQl3cpptdlwAR0syFFcogUkkM5YncQjEhjT0I3GYkQOFg8Q3UU2vgHD8kWGAkW9wNEmYMHtPeOA/F7DjaSAf+VShdCh9MoanMxOIEQlK0yEujWk3vRkmJReHYUMQx3jBaBespoEUMEGuhHeL1UEXsyPBM0B88IEqkofaWBlJpDdpUTdgNJkpYSfxYRWUyDggIhVmRYjc0oWAgpRKVklG8hlmPBlh9TlRpxYIxxloSHP0t0EPKlc+x2a7ziONDYjdKxkmWhl2QBfjIIjQNhWf4gjpRpeApxd0a3fBsjchvRkNRDjFEhRYIZFSs0dF4nEhl4GZyHPEyjSg6hdRokmxJoKEFpZFopQ0W3EZvpGCQUGe44mdbIK075EY5JbA1BlpgXZFX0YALBl2FnNKKjL/ITdjhJEB+ZN8NpGNyDl1H/wW5CWCH4aJkFEUmhJpOgkZyfE4ICwYCSQghYlpg7BF/gCCeSZhg9dYtS0WzlaSYPE0lqGRLqeXsMR5sJtIVCF3Z1KRFKyU3QWI8ORhh6gUsTKRXwY2upMovcmTHiKREHeoOx6GDfuaDrtZ8ZIWeKyHXOiRmhCJBPcVNUoS8cmip/gAn4ok4DJaP/cKDqc59/GaAHKWXgqAlEuJEyNAf0yRa9ZSMs1zOgWSEM9D4VOXrRyXR+1xGox3wiIZ/y5BHsdo25lhatVVrAMziXcGmKKSNl6hBeFaYhQXLSsZ0EEZyBWRKAKRiQeRAviSp8cAnsuJeOAYFzkDiWMzRqOKhQ/0Yt+aicdNqRHUGabPKC2ligzJSdkMaVtBUWI4KeHEGnaciV4maKggGqandCTaiQ7naEpBmiEEGeh7gq+pcVKqgTc/kxIQONNolIfUoQqRoaNLkQv0h0CSOnJFGsGQqc7dYx0kUvmsAa+Leb1Fqt1nqt1loX2rqtdYGt3vqt3lonO8GaREMorAKqN5iMvxqsymOnAvGELvQPveoPyBo5z2aDkVMIh8o4/NqvobkTgOcv8jIo1SUszeOjaMk/D/mn7qR+f6leCliTpzJ3mxVJ9ZqsgbCv/rqxHMtUBoZf0hmrgUA8mGNZUemLn6ZZ8/qoJOFVeng852iIHTuzY7Nahv9hWS/LEEoKGpn4DyYrh+hWcLd3KjkrEmJ1siohMRVzMX5Cs05rLalZFjgbSCEkg+jjjyH7EODofvOqkryVMcMaOURGCGTLrWYLlOCatt56tmzbtm67rb+6l/hFsZfZF5fioQlrXBHRgXBCVlAZtwxhquWXLGLhjxerclpaOY+js2npdEF7RFjrrtN2r6ZJuDjhj1X4DwuXPQ/6PmkJVHtaHhLhjyump8DklpbLZwlTPT8UGpFWSJGrEHz7U6DXIyixUrSbul8xr6jCCKkZuwYRWZG4lsCEpCeBbv6pu/8Jmo7Tp8Bbk2sHqwexUhbpGXtUucr7Ekt3a68LOM9WP6T/6bUb4VUsOxI8OnWSm7261axLmr5t2GJHI1zumRHdGYcnsbUIq74sAaC9QrcbgZmfJr3ZB6IogW7xqr9JITdtOlmuKaoHHBLni4W8dX595GUTs7SXlmmICigc3MEe/MEgHMIiPMIkXMImfMIdLLR5saFzOWalx0okZ7wkEbq3gq6Upl6qVAx+QAg84zNP+8NAbCZvQUABih001IanErYNgW6lG2fwF7URgXh7YAWNgANmEMRYjMWMpSzks4upcjbIAmyAe6esebhIlTF+KBJNwAAS0Aa78Ma7oAqokMV07LR0Bhb6cglF7BhvmhBp5F0csY+uaIlt88AfIQlYQAZP/wDHjPzGG8CCKBzJkjzJlFzJKWzDQLHDrpGrgqEJTVqbsOF7ayezNylk6iXACTEAneAJJ9DIrrwLVsA/hKKbw1IsKYfAF7HDPTyljsEIMEYRgLaiaKiAXym6KYFuqCsz3CAGrfzKrqwKpcA/v4nLT7kzTMvLqsGEWZMwUUuht2I3ESxT+atwd2kRJlAEoODMjewFdhAG28AFMui+KnIIv0M7g0gXhLOmfcLJyuPLnboR4eYmDBexufFsZvxwwuUI3jcJbKAK6vzGUBANSjAGuVGieaOj+nt0/coHXEmBH1FPldd5s/lCr4m+KiGfCpNCGaAID40MOMAAK6AQHGQ+fP+A0akrVWQjXZyahaZ2QYTpl4aJGckLOOr1TgrBDlnw0GaAACagtRaNKZ6MvbPBxM5qrnehNuAEkUOnwgtRzKBimijdswRRDSztzG3AClHgJq2LKku4KXOCV3nGXnNwCYjCKTPBZgd4pxdm1A8RztuoEqwKM71hApmgzjigBNqQEQVZNquSKONcGkJ3LvYHLMJCCM0j1RGRRiFd0WEzzbEKsY9NEN5sdt1QCuTwysggBpMgptWWhvSCf3VBtq0z27Rd27Z927id27qd25i8Fz19g8rHs75Wv9+8Vk+oAF7wyjYQB2n9cNWGzXUc3ahsGl13c4gbNgqKEcVqT6F9g1v/ggoyYAOv7AkxPWXks8fRXccQFVq2opLB7U6i6GMDaHWMgNyujAwikA0JxXJzsMDp/bSYjRZ86EWTRqmeXRLOgATi3cit8AjwXKUJtTVdIz3/ncV3rB8XVqHNh6eIBMUPYQJl3ch24AoncsSfFDiDUzgWE63g0uIu/uIwHuMyPuM0DjABfhZrU55ml4X7yNUgkQFu3MigQAsyhG3U/H3HeS0Wmm1Dd+AcUQoLzsh20AyEF6A13dtH7mp227su8aLeSYTiUNgMDg10JKqO0JVZHhZV2yvTnTUXxgceLhAmkNSNnAWVgBDytnyBKs9pDrCYcGu+mzBjfCdC6AhQ3ATp/9zIMoAB0xaEH0OqfT4Ve3JrzftrddfllGPoFZENC9DIJ9AAEMGM69XR3R3pm1WNitm9BFFMjKenT30r8f0QSuDQjNwG1TB+S5Nnbe3Rpn5XGcu8Rn4Q+KXEwJnhOZpCYRDlb0wFTb2WJsPPODLX99Lr40gIBbSYZxNRo0Yfg94sBrnkCcEArswCksARe4LeYdde19U8xkLtJGGj/g3GF3TpMdF3QBTrBIEErmwH3a5ytebfeYYtA+suBF/wBn/wCF/w9DAMDN/wDv/wEB/xEj8MH7AMk+FlYIbNZqOiEaFmNTGVTpQ5F+DKrFAMemrtFF7h/boOtdDyLv/yMB/zMv8/8y2fCGmwF0orpRqzqN5kWW3+EXmeMs848o3MAPu0NXoM7SqPKsFA807/9DR/BmuhNRTDL9Bdcr/8l6fS7w6VuJjhBI2MDAiAU3iwL0i29ByTAlC/9mw/Dl4RMaqDz4WDZFcvI/7Mht114xKy5Y0B9oxsA6CeExac4keGaf2SqGjPCXDA9owf88ZgACAgFQWZaen4J4i/OByNCWckEsV04Xed5P7g93BsA7G856Xu7hD5tEWj+aYpRsv6SX0h+m9M+riG5qgPE2goNhxNYAGOenFOEkQ/+rFMNNZ5+y0x4BojXYygKQerJ8rE9RvxBo1sA71QNv6s91k+cTISKPP/MsvBYhcoBxT1BMg3EQbTD+rNRq5tBDCMavxAT31SEVIHjft7IAyjH/g3WGtKDyfLDxCB8Pj5V9DgQYQJFS5k2NDhQ4gRJU6kWNHixYl4/G3cqCUSRpAhJR5ixHHjHJEpE2LauEnVLhsNGkYKNEeLSZw5cWrhM+dSIEKR1KgkWtToUaRJJwbC+YegUqgQ1fDBeSlqxUsme8WUSHPOH51hxfJk5DNQoaB+hl5l29bt24qamq6F29bPTZOY6jLMinPeRT+FLjnCK9bwWC1/+Dgqq0nTpUuYAp0tVJnQZcyZNW/m3NnzZ9Cd8YwmXdr06dFP964+SBInH7qslWrEWUi2/0G5tVMeiiSYEdjDwYUPJ17c+HHkOBkdus16Kk5HsZsbLZTTNutDc6wnVYMnkKbfycWPJ1/evL/r0+v6Ac4xunqkTHXvVVNyPlvehAJdYuSo/XkAAxSQOL3gqyuSwjZ6z8Ci+jIpPbf8oAonQpo7xA889MNEkzkc4eOPBAcUcUTkPmIQLjxCXPDElHLL661I/vNHCzxYTOgQNfyIJENCCpkME8gucWzIOYo08kgkk1RySSabdDJJRqKUckoqpcypQBvdShE66bK0yEWOLmHuKvlMotFLNBkscyNG0nSLkJxWdJMiMNnssig1tGvKxDn73Is2jv6400+j4HxNNUIhcv8wUD6NwkNGfxxBNFFKlVJDxhorVcpQk/5oVNOF1uQIkzFVylOnOUoFdVWiFvXHKlaR2tLMTGNNqJAQ/eGjVpDUwCRXfwKxddiQ7jLJEVWJTWnWB5U9KEadNJl0IjUuAXZXZ7OdaFEtptUWI2irSnbY+sKag9eH1CjEvmgH/fbdgtRIEEt4i53QJEbcZTUQYP354xJCvP3HD0IwccQwbOtVGKHqONJC34UjUuPg1z4l1g+KxfqDsf78E06LQMaNGF49N9JkZJGyy0kLCJ0lBFLxtMAEYpSd/Q/dmi1iKSdNaNb0kEDuTc6RQHzOeVg/cDL6aIYIyZUPgYclxCbjHMH/xGKm4eU00qztXbnlbNUgZDBgycKEkKW7HnbnjWBV+6JTc8o34hwjicQPtd7OGkyw9Z4I15z+qNBvwuvN2B+sC4coEqE5miNqxSOv9L+0JS/okDo7EtZyzis9pNPOK3pZJ0cSD/10BtUwiQ/Uqc3c5Mpbl/2qpDliffaIRl95Ztx7Z632jW733SE1Xve3EJGHV/4o1R1e/qFIDl8d+eerPyrB2HEHXCc+qLf++5AOHxx8hart94+iyVd/W5NOXl8hP4yfUdr3619o6z+Sfz+SknVixHv72U9eJhlfAJ/Vv5VpAmcG/F7/2sTAhMSvXxv51wIhODxAbcSCDPQVzDql/wm0XXBYvMmQjwIBpMichRADMYrQHihChByiENILi9XwkD0YroZgmOiQBzXGiLNBDiJb80cBc2gQP2DCh9DRRCAiob8j1uUQeMAEIyaIHD4ADIoNEVr+ongjPGjiioFjxE+CgsMvWsQPgbAiiTpyropk0B/0SqNBpqiJJR4mMY7gY5WqNIfHYKIQN6wjQ5JIQzcGL30SYddGTFfHSFRxjAP6wxwCIUQIyrCRwtkYICVTmcr86BI9/BjvIGIs92yxjlOUZCLltkED+mqSuppDECvSnZos8Q+wPAjbNkLHQjYkMPzJI4DmgEbfFW+MjgAYMhMSyca96CGHaBwvg1m+SP/oh0MemqVxPAVBWY5lDoVwJvSsFS1VRmIu1zRVjvD2TrzZTZ4l3E94dHKmAD5KLIwIoVvUEAhIuc8hvvQHStgpmzUism/Wi9vuMGkpV80RItLb3EFlg4doakKVswtn4EI2HafhxJqo5MgjLcqWckHnoUer293Ucic19IZqK/sofJilK1USUVAnlY3KdmLErv3TnmFJzB9AdJhjsqhhHKloQ1y1HJ7KhqC/fBv/ApQwG/XPiw45hPTcFtW9hBQnqWJa/AIks43KZoAcWShC2HMfsK6HhlCt2fbMw4dFpmlRL3SIHD0S19UcIqJ0XVhKuVeWOUTJQx8CkRYcuxhNFGL/pfAB3ozSKiqnAHY1S+WIQOulzzjlFV7ik0idkKXZP4WorQ7BUI/O6KWp6gqo8PKlQSHSVZx4FrVa2olJ3XoJmGVxsm0xbF7SejEzLe1ScN1tWzjrL5/5AYHmGi5UwtUp337rcMCcSYJ22ty3uEpOChHrx1aLn9gmlWmc/W5Enstd8CoFt6sTmGCRA1+2RE8nTWXpf/C7kP49LL7+lBHIVCVDmGnBEUNq43ZQtEkKWnNha+rWRCqLngFHCFJaqCUPr0WIZB2CENGUsEpmGJa56W25HOErRMDU4gxD5a3F0ShD7Gum7IYEo2Lh79uee16EqNMk5YxxRDA2HJZBhKCw/5FvRFlc3YgdrsISEdpsi4wUoI2xZ6WFznGpBeHgWVlvQk6lRBb11StHxVfR/Fd159tZ5iESjqETlW4bwlkYpzkqBLMMlA2y4lEZBcKM8DPTNtnjhVT2D3quFIIoRBSCJpmjMgLyPz5nEi8z2qY7KXSQd1Jixd20iBChnKYpJSomh0+kynsuPrlokk6bWjausu1F5Phf1EVazAU5XI5lbaA3b6TSDGkkHzItucyt9nCx/vVqAD0jHF5417PLHH6Fxuxm/2msF1mT8KyXuRQjJEHHznZzXOXrgzQS172LqIEPouhyJ4qa+LLIzdYnKgpeLUeHy3O80SRHdP+jeR0h9//pRG2YYfvbQI20s0PIrCv7HTk4W1V4nzIoYIlsrd/fy7JhXF3xPgkNzQ7ZWq3rZz6d7BLkiaLw0jR+QRHzZzHjLPjK1fofkzckgxu3ec8pIqphP9zbPid6ReZtEgkP3LJFZ3ocf0pqkwS86UyfKqkc0j9ET13rCplu6RqyJp5vXew+za3AHq6Fmosd5JgzF9b+I3W1+5xfYcFrbBo57bhvXb9imXMjE573phdiiYlZNeANH8NCRJOoaT+8zfEwU7H8vfFa/6fiJTp5zCskEpeYEIfhnnm1Exn0oyd96U1/etSnXvWrZ33rXf962Mde9rOnfe1tf3vc5173u+e94QMBAgAh+QQFAwD/ACwAAAAApAEeAQAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6tzJs6fPn0CDCh1KtKjRo0iTKl3KtKnTp1CjSp1KtarVq1izat3KtavXr2DDih1LtqzZs2jTql3Ltq3btywPRSJUqBAhP3Dz6kVKiJEWf4AD/7mEd6/hwzkjOQrMmLGWQogjS35J6G/jy4ADTd7MmSQezKABR+pMunRGNX8uO9J06ZLfxoxMy54NERPs0QTVaGpcmLbv3wT5MNaE8FDqwJiAK/etxrGahIEYO1pO3XQkxrET+uFdvfvm64GzJ/9cHFiz9/OHmwfms9B2ePTw9x73p2Xhdsa94+tfKzwwQ/KAzbHfgGoB6M9zChXSGGQENkiWgQgmdEh/gGmBh4MYggUhQ4RcZl6GIGY1nz8O7daYI/mFqGJUltHn0CGMXPbYijQ+dR9g7DmkRoyXJVfjj0l1GJiADx1yCWYfAqmkUEciJxEeFFaY4pJU7mQgIRMdYmJgl1Tp5U7qBRahRE0CNt2XaNoUXWBnUhSmP3+kKedMBiYpEXg42hQJJozw8YcWWvzBhyNzaIJJIIREMuac6H2Gn0VzMEakTH4YGFpjgxpaiKKMUscjYOJNJGRgWFI64qWowrkaJoku2ulmowL/diFFkbToDx+HzPRpqrzKOGihlxxaCB6R+KGGq6+mhZp0Fflx6qwxvemYrb1WC1qggjriCCNzdOvtt98yIu645JKr7bnoosvHuuy22+4f8MK77raFYjLslD/5UYhrfgKa7RysIgvXIZZCG5EaUfrT5UyO4kjImGr4gQchgVyiSZ/UWqvxxhx3nKoWqxWCb02H4KHJqZfyoQkeueYFY2PETaSGpYy0LFOsMes4FyaaOIKyx0AHLXRof8xRiMAuRaJJxtUONvJZlWKKtEIzS10TzhepEUkhmMzhCB9MDy322NVqwUghNrd0SCEJAz2HwWdFcgm1WuAW0cuM/TE1S3j6/zMpR1pPXEggmFjs9dfwAkr24otrocnTI6mByc+YKd4rI3aLVfLJlcP9UKR5Q95S36G2dKwfkUSCx+qss57667DHnroftNdu++3GHqv77rw/pzvqdPHMCOWXvY2SGnNfqgXAePhhs9ZcOxI2YJrsbZXJ01tIUZkVZk6TgkNypgYefE4PqvcfST79YJGknZAahMwR9h+lbrV22yeKDl1jdds0/paA8RFpSnYJ/A3JehRZG/GMJ7NAGLB6WVEgqv4QCPc9pGGB8ZxL/MA5zKCPNEoLmxYq2BEoXQsTCFzIIQiBPz58EComDM3yjlaRZTGGQTJZE2hy5ptDOBA0KNKIH/9AdxkKpvBFgcjYjKZiJKJdgmUYIWIAaQLA4lnQNyysHA4TmMTKoRAkapAil6SCt+JBMSOx8htN3IMZPmyROhIs3hELEsPLXGKOFClExuZwRaSUcTj6g4hx8oZHkWAQMH9gxBP1g7w2BjI3VRzSIzMSNdgUkieRZMQkHwK+DM5kQo55434i0TbtOYQQP+ODBkeiJdVcMiedrJAoNRKlv8FEh4CZ5X6aeBld5kaMFcJEH0uCSzO90iZ+sJUpPXLITUZuRLbEUGU8pBBUYmYOzvzINBnDh2PSxFL18wgAo+kSXGohm93xQ9sE+EvM0I9h1HKEN2MSS3+w0yMjWuVKBjn/xhrtyI4FseZlIEiTWp1oni5Rg60cMUyMvEkLDU1JGhG6nFY2ZmG6cac+X2JQ7EQ0J9zzxws1gsHSvUSK5FxRSO2Jh58RFCcdDQwP83XRkWBNJgplzEZDxMZL/WGnMsEDte7ZEwDqbSSxXBg9ufmlnmLmpTw5pD98eZMbZYYkSZ2JFImqJKcKJpw+qac/gKpVbn4UI7FKqUoOYSt0DiiMmGEERVfi1HP2xKpTLYlVcwQTDPKVSi0FTTeLUsXB7kSKfx1Ji+oTE+4pVUmH8CpsznqTP6pRJ3gFa0gOkTeZGIisDqokpmpKFIQ1xk41AWBiRbLXaDVmrsvZZt7wYNob/xYlprLCSWZPUtKYYLBN/oyk3xCUTMeMlCdptKtNVIuSnj62JT3VwqC2xS3W2CtRzhtlKd94yKMSxalqbUlxA0NVj+xKsysBJq/+QKhLDAu2bikmjvBVTIYWZVf+QO1LVEtZSr42JgbcWCLde1zJ/NOOw6zic4GS08D0j1K2Km9HuAdclwhXaGZ7InzBItC8oZcgBGvMh3uSRsPChL8n6Vteo4VfxjkCE+1DDC8t2ZDxdo+wjQnvSfAq4Y3UFpH9TcnpUCc4wmnCa8RD1fIephdSIgkiJd7wSUBp25PmLcgWcTJj9AuUQ0hsX32y1pKx3JUuYqrABwFvUWxMH7eSdP9BJfEhtUyaFLkUome9chxouQLXgb4Sv1wN64nIrBEq44jQEVFMEaVsk5KVL1V8CASjDTK+is2BEV+blyI3hegSokwLI26IDT1JFAWzJKShPo1w+eBmohAwwBXSBJplRghNwJp/Rps0Q2YsnVYLBLfKFcqPAZNqbeZ4JJH4mVy94odAWOoyjNjzQtRQiBaLWdYpES1jhKmRepo4KMD2dUSc5RhxK0S+9OHyVtTg7Es5QtoG8UPyxIY5k+ixiPBmSBVnCpT6dvpgCetxRSSrybjNO66zLkgk1Ds0bIqkzzmWcoi3XBQxBtojYuQ3R8T6B4F3hdoBdniNGe5gRQaCWMf/+kfE8BCIDnrx3wkJLP88LhE2j7W0pyo2RgqraxX7Y9luwYO1AXNHqq2UmzCmrB8mJ9iEv+joQTRkY/5g7pWoONgfCSnWO2Joou9l4aDpOEIKQTktXMLpBiHEs9OtES1fFOYOKea3+221j9Q13xCpp8bfAva45scPQ3cj3P+RRTlexMyzRYkYdawTMdbMIyvVeUW6bt/IKFpGJEQ8NyVfJM3P103WnoOui2OpBftk2P7YewKBqW6NpBHta+mwdNY+wsEfRNsVyrdsHUxzjpCb4kOx+cXH/ezWawSlA8SE+WQ6eoFI1uMQ73XSqMX5mkjV+A2ROfAfbivYuwXwKcM7/0W07yQO/YzblOGf+GEi1uFPe6WgLolfe7LwcXUrWIG4l+0nvMP9OwT3CkM1q+Z9IVFMW/cTXnUJZCZ7uWcSjsUTDTZBmxZjLsFr1JQShwBMfHQQ5MclzUcmU1d1KrFSUZd9a1eCJHFeyMUxIONeH2gQbhcaoqcSXrWBA9FI+IYTYkR1RAF/X/Q+hbB2qed/DGErL3gRPrcxjvBERIgQnkcfKMNqKiFWj/cPdTQcR5gl+MWDQ3F0M8QpgfNo7lR9p9FZPSFZHPMHK9OEAhF9B+SG9LF+FZFGP8dBYwiBlsKFQiFWHANVJkE6P6E1qVNkwgM21sI+niYjW3Rvp6USQv/FP9eUhVmThyKYEsnmMfW2ErGkekNRaXjGK46ANg4FdVNyiW+XEo8oQ70HE1WTNwQYLQfXK3PwihqBS+5nFCUTCK/hUz84ETGIHH3UitghiVYYNjMobAmzTEIhb0lmJoFQiRTRU9hXZ3hwCUlmds5kgYi0UxYlHVkIh/RBhjUhjOSFi+TjNX7CXorEZDIBQKt4FHJDPI6TQld4QHF3GVJIEk8oU0dBjkTHhmUBQOKoFHhAclrQiweRUTJChrsHJ7TYEJd3KabXZcAEdLMhRXKIFJJDOWJ3EIxIY09CNxmJEDhYPEN1FNr4Bw/JFhgJFvcDRJmDB7T3jgPxew42kgH/lUoXQofTKGpzMTiBEJStMhLo1pN70ZJiUXh2FDEMd4wWgXrKaBFDBBroR3i9VBF7MjwTNAfPCBKpKH2lgZSaQ3aVE3YDSZKWEn8WEVlMg4ICIVZkWI3NKFgIKUSlZJRvIZZjwZYfU5UacWCMcZaEhz9LdBDypXPsdmu84jjQ2I3SsZJloZdkAX4yCI0DYVn+II6UaXgKcXdGt3wbI3Ib0ZDUQ4xRIUWCGRUrNHReJxIZeBmchzxMo0oOoXUaJJsSaChBaWRaKUNFtxGb6RgkFBnuOJnWyCtO+RGOSWwNQZaYF2RV9GACwZdhZzSioy/yE3Y4SRAfmTfDaRjcg5dR/8FuQlgh+GiZBRFJoSaToJGcnxOCAsGAkkIIWJaYOwRf4AgnkmYYPXWLUtFs5WkmDxNJahkS6nl7DEebCbSFQhd2dSkRSslN0FiPDkYYeoFLEykV8GNrqTKL3Jkx4ikRB3qDsehg37mg67WfGSFnish1zokZoQiQT3FTVKEvHJoqf4AJ+KJOAyWj/3Cg6nOffxmgByll4KgJRLiRMjQH9MkWvWUjLNczoFkhDPQ+FTl60cl0ftcRqMd8IiGf8uQR7HaNuZYWrVVawDM4l3BpiikjZeoQXhWmIUFy0rGdBBGcgVkSgCkYkHkQL4kqfHAJ7LiXjgGBc5A4ljM0ajioUP9GLfmonHTakR1BmmzygtpYoMyUnZDGlbQVFiOCnhxBp2nIleJmioIBqmp3Qk2okO52hKQZohBBnoe4KvqXFSqoE3P5MSEDjTaJSH1KEKkaGjS5EL9IdAkjpyRRrBkKnO3WMdJFL5rAGvi3m9RardZ6rdZaF9q6rXWBrd76rd5aJzvBmkRDKKwCqjeYjL8arMpjpwLxhC70D73qD8gaOc9mg5FTCIfKOPzar6G5E4DnL/IyKNUlLM3jo2jJPw/5p+6kfn+pXgpYk6cyd5sVSfWarIGwr/66sRzLVAaGX9IZq4FAPJhjWVHpi5+mWfP6qCThVXp4POdoiB07s2OzWob/YVkvyxBKChqZ+A8mK4foVnC3dyo5KxJidbIqITEVczF+QrNOay2pWRY4G0ghJIPo448h+xDg6H7zqpK8lTHDGjlERghky61mC5TgmrbeerZs27Zuu62/upf4RbGX2ReX4qEJa1wR0YFwQlZQGbcMYarllyxi4Y8Xq3JaWjmPo7Np6XRBe0RY667Tdq+mSbg44Y9V+A8Llz0P+j5pCVR7Wh4S4Y8rpqfA5JaWy2cJUz0/FBqRVkiRqxB8+1Og1yMosVK0m7pfMa+owgipGbsGEVmRuJbAhKQngW7+qbv/CZqO06fAW5NrB6sHsVIW6Rl7VLnK+xJLd2uvCzjPVj+k/+m1G+FVLDsSPDp1kpu9utWsS5q+bdhiRyNc7pkR3RmHJ7G1CKu+LAGgvUK3G4GZnya92QeiKIFu8aq/SSE3bTpZrimqBxwS54uFvHV+faQNE0AESoAAbyADbLAPiiACXiALT7AAJFzCEgAoKJzCKrzCLNzCLvzCMBzDMizDQpsXGzqXY1Z6rERyxksSoXsr6Epp6qVKxVAHRsAAZKAIsmADu9DETvzEUPzEbPC0VBw0FaYWBBSg2EFDbXgqYdsQ6Fa6cQZ/URsRiLcHVtAIOGAJUdzGbgzFMlDFcsyCazE+YpgqZ4MswAa4d8qah4tUGeOHItEEDCABbfDGiJzIu/9QBHPcyNVCZ2ChL5egxY7xpgmRRt7FEfvoipbYNg/8EZKABWTwBIpcyk98AiVMwjQww6zcyq78yrCcwjW8u4TgGrkqGJrQpLUJG763djJ7k0KmXgKcEAPQCZ5wAqb8xG2QBZ4gCkWgDkqQATVQB2PQDAiMEX5ACDwjPRpjNjBGEYC2omiogF8puimBbqgrM9wgBshcyqogAmxwC7FwCkdgdthbJVqjzUw7pTDKhFmTMFFLobdiNxEsU/mrcHdpESZQBKBQyl5gB2GwDVwgg+6rIofwO7QziHRBOGvaJ7esPIyACZ26EeHmJgwXsbnxbH/8cMLlCN43CWygCokMBdH/oARjkBslmjc6qr9H1698wJUU+BH1VHmdN5sv9JroqxLyqTAplAGKgMjIgAMMsAIKwUHmwwc7nbpSRTbSxalZaGoXRJh+aZiYkbyAo17vpBDskAWIbAYIYAJam9OYksv3LBth7KzmehdqA04QOXSzLLsZU70msdQ9SxDV8NRu3AasEAVu0rqosoSbMid4lWfsNQeXgCicMhNsdoB3emFp/RAFvY0qwaow0xsmkAlvjANKoA0ZUZBlsyqJctClIXTnYn/AIiyE0Dx1DWWDlpByzdQyA7GyTRACbXbdUArk0MbIIAaTIKbVlob0gn91QbatU93Wfd3Ynd3avd3cvd1B/2wYYH2Dysezvla/A71WT6gAXtDGNhAHjP1w1cbPjjzf5kwgXXdziBs2CooRxWpPw32DW4IKMsDEUewJVD1l5EPJ9D3fEBVatqKS4+1OouhjA2h1jKDeUYwMIpANCcVyc7DAC/60u30WfOhFk0apv3kSzoAEBP7ErfAIE12lCbU1XcPNIT7HkKwfF1ahzYeniFTGD2ECiA3FduAKJ8LFnxQ4g1M4FhOt4PLkUB7lUj7lVF7lVg4wI24Wa1Oe9ny8TPPXH5EBhwzFoEALMoRt1/wWzOib3317Q5fiHlEKLe7EdmDN7NpGWZ3mZ7GaeOwSL+qdRCgOqA3FrQANdCSqjv/QlXouFlXbK8PsUBfGB0AuECbA1lCcBZWAEPK2fIFa0YvOE9vbuxEqUhwlhI5QxmPQ0HCMAdMWhB9Dqp9OFXtya837a3Xn55Rz6hUhVAxwyg0AEWuOo0D937HumtWomN1LEMXEeHr624IXEZ3ED03cBtUwfkuTZ5Ad1MXuE82mqcqD5geBX18MnDueoylkTk5ABXC9libz0Thi2fey7f5Ty21qNhP+PiOStRtkkBbamdAmDhyxJwoedu11Xc1jLPKuV3cG4nl8QbceE30HRPdOEDUIkBsK4nmGLQPrLhzf8R7/8SAf8iK/LvFwDsNw8iif8iqP8h+wDJPhZWAm32b/o6IRoWY1MZVOlDkrtayAU8s2fuMhXgK1MPREX/RGX/SJkAZ7obRSqjGL6k2W9eggsekp84wrZdYcYWeT7O5AvzjyQA9HH/ZhfwZ1PBcVgzEsGNJxO2qicbmJ6+g4hQf7gmRdT7NScAzGIPZ6Xwvj4BURozobXThIJt/XEtJnVEJTl+XFYbe8gvVr9WVGdmmIg8J1HzQxsPdHbwwGAAJSUZCZlo5/kqiM89Minb/FlOOafZyA6s8JrydPWzQibZpixPMyweevruitHxNoKDY/TWC7jXqTThI9TTTWmft+PjTSxQiacrB6okx8nHX4WDaGr/h6PnEyEijzQijWZRco/wcU9ZTJN+FVkNFs5NpGAMOoxj/11CcVIbXSMCH+BXHDAqb8J9fm235I+r4UlsXsNAgQ/gQOLPTP4EGEkQLN0TLQ4UOIArXwmXMpEKFIahBu5NjR40eQIUWOJFnS5EmUKVWWDPTwj5+VMWWWVMPn4aWZORFegliQpMI5fyIOJTqRUcVAhTD60ajT6VOoUaVO3ajJZVOqWUX6aegQk1aTPB/6ROmn0CVHXYmuLarlDx9HRzVpunQJU6CkhfQS4tvX71/AgQUPJlxYMB7EiRUvZowYJljIKQ8xesgHa2TM//D0zPzR6tichyKdZSSU7WnUqVWvZt3a9UNGhzrP/ljzof+jy7SzFuKs+9+hOb2jqsETSFPp18mVL2fe3B9Z3779mB6IO7rWlqBpq6GsHbJoQoEuMXJE3fl59OlVf70ePZJagdbbTxXrEHpkPzYfEmp/yA+e8DDRZA5H+PgDPvUSVNC1SOaLDg8E5XMQqs+8yiwS8/zRAo8JQTpEDT8iAZCQQvDCpK5L5lJxDhZbdPFFGGOUcUYaa4SRERxz1HHHHCFir0PaILwtNyBlqnCgS2QDKzuHNizySSg3YlIgRqKcjRCIJLRSpSOpJPIpNYJzqcEty3RwM4f++NLMqbCs7DE2T6pvoD/IjAqPDP1xBM44+8xMjQw59BMsN9O0c1CRphz/CBMldQozojkaRXRSqub0BydKsxKySUEz/agQBP3ho9OY1MAkVH8C8XRVqLhyyBFJWX1qU/tk7QjDiDTh8yQ1LkF1VFuDjWlOLXYVNidcb4rVVu6GmoNUkdQopLtc1zz2Wo/UgO9HbHXKDyJGrF01EFT9+eMSQow1yA9CMHFkLWC7lTck3gbSQtx5eX23skOF9WNfov6Ii7zyUNMikGXzVfgfMQXSZGGdgINIi/uEJSTP5LTABF+IsTUP2o5XwqTabg8JRL/kHAmE45CP9eMhllsWiZBQ+VA3WEIYYs0RTPqVeeFC9fw5p28fojhfNQhBC1WjMCEk5qGPHRnJqGd6/xRcqFcFMZJI/GCqarCPrBhslECF6A/+yFa7Y4D98XltkyJB2aE5bob7blbNyxpvhA7pUiJV+RZ81UPSHFyliyNy5O3DG7dSDYf4cBwlNf52eO/JM8/s5YEk19ykxCfe+HPS5+NcIM9LH6nyof4oJGHVY88Kcntl/6ntyF+3ffes4MO8dLMj4kN33ot3qu20ja/N19ZXVv55leZ8GPqP/LBcIl2p137mNGHfPpKGI2KE+O3LP0hbh5I3fyPw19JCE5DXfz78KuXvyPpyBTo3fvttR3Mg/tnPVBhLkyae1r9giQZAJQrEieySFELgwW4qmVv9EMiRQxQCd0PhGR5+d/9B6bSLQAQMGCOcNsGRBM0f6gMhQvyACRLeRhOBiIT3WkibQ+ABE4zIn2v4gC4bgmRufwgiAnOoiR6ejREWwcgHb7gSPwSChwuSyLNQ8j+BcOuJGzliDNniFkeEkUc8mgNdMFEID24xJC/cIBVR57ySUEsgjFOjQSKxwySq5w9zCAQK+5dBOaJGYGW8i170YqJLjNBgoxuJq6pTRDXmEI9uBFcA5WeqPIpqDiekXHGCspY/WBIhU1tUHU1ilvF48TxzcGLsKpdER6CrlRy549weokWPHMKWojRltiIRngEVKJOsqVP/MFmUORRiliKJBPMgookiRuIqvXSKGkDkNWz/eo1r21ygeJATESetD09EYcQBMaOGQORpeiEhpUDmQM32RLGNYzPe1UTnR6r0ykcjwV3g4HkdPNjSH9CE3jHPhrD50OwhvHTkQOj4z3MGUk/4/NnWusaUL6lhNDqbGEInRCtRFVGFaoLodSRmNBZWDZ3fHIpb/nAgtrDySfUaiD9BYqnYlPQ67Swl2Np3nnhBKXxEFMkhcIcpnfpGoQ+J1NCshx6NQTI66CNIIzNEz6TiZ4M5bVnwmsMHOJZpThYMCRY19NCsauUQlvIHVxfWrKHw4ShzwFGBDHQgLeQVLpooBEUndDoNSVVRL0mrb2g6kHXma5xZCuu8kFeSLsGq/7C6AelzVPIfEjXRSjxFXUrn1c53ksSoD0nsZDNjVi2gdSN+uATGfujXyMD1llINFmDvRZOrmpY2hzUXy/wQPqLUzUHJMtTQ2oZLkLwnTcvULUospaWOLNVgWI3MITjrD5kO7bAkLQlvkdvcrIw2cjdbq2u+C5lItNGmFTXPeT0SvtuC95wZOpikMogxLThCRVMUDmbwIFFz8XJhUyrWKb0jX8hMZ2KbxARHK0OIWB2CEAIVsE40OJRwrQ1QDiHrSI7UYQRrRcGrIWguLZVasASUKOslG2+pS0uYhRgz/0rN0UTCU8tQpbwYhi3bmgTbuXlWxlMxWRI1AbXI0tYksv998OGk+SrazgmpQ4aMqQR6rh6LF7HDaaMVHaeo0oLksCCmMljYtZceI2TDFnqKRBmR5qgFksUeAewfykwp5abPKTy18efWXNWiPkTJd+4QauEMY07FrrJC3ojeCD0pReVYJrirsOB4G04hOuTQj26PpUK7ErO6N3N8ZrRB2qZaTj9JywJ5cUjkyIdBC+5v1G3bplM9VfPEtyz7Ud7fzjs3W9/aN2b99EmmlDrj/S3DHIFPrIU9H0uhmiNyFLXq2FpfFxru2YPSJYdT8jHtKUp/PQNR28i87TKZVdrna5KzJ1fZtbQa3U+SY5hD8mTUmY/GpyHqvP2ERV2n0NvmK7Lj+yrt7w7NbcrcG0ixy9crVIUS4YgiMNSCdm7tSXg8cEmmuyd+nT9jtyRYxPjHTZ4SRcn7H/gW1cldPpNuO0TAtJOIx1/+ctSW+iDmWffNfT5KHwUxfHP+edE/Alw9PXRKJTd60w1yUtLejOVasLnTEe43Z72N51bnukfIFdfGylHnXTd6etfiZTmqnOw/L0QM3bLQtce9b4UQaEurLveJ48HBQ1E73o2Ozrr7o9p+J3sz9aOFOfSc8GRn7uId/3jIR17yk6d85S1/ecxnXvOb53znPf950Ide9KMnfelNf/q1BwQAIfkEBQMA/wAswgCIAKoAIQAACP8A/wkcSLCgwYMIEypcaHCBw4cQI0qUuIGhxYsYM2rcyHHjro8gQ4ocOXLDtI4oU6pcydIgyZcwQVZsSbOmzZv/Yuoc6QOnz59AGU4cSvRhz6BIkypdyrSp06dQo0qdSrWq1atYs2rdyrUrVRNew1r1M4eLF7Fon/rBpMWfv1hp4yp1S9fftCxy8+Ksy9eW3r8t+db9Uwiw4Y6HMAmue7hxRj+OFrt1TNkinj+CtfCpzFmhYsFz1HQeXfDQnMyESKsWCFmwIz+rVUfCzFfTodir+WopjDs23T94euN2ywe28N6ijytfnpWP8+fQo0d3lJq5WMnY6xq3zjW7d3+8uXcN/y45kniv5Pn+CfQvIAAh+QQJAwD/ACzTAIgAbQAQAAAItgD/CRxIsKDBgwgTKlzIkOCChxAjSpwokUXDixgzajy4q6PHjyBDgsSxsaTJkwRFqlzZkSTKlzAZspw5MqMaQppQqYrJUyHFn0AfulyophAjLf6SDu3JtOnCQ4TmIE1KtYjTq1gH+sH0h6rXpBuyiu0Zac7Xs/5+XRjL1iQeR2i9OsIUqa3djITgxvXnKJCfu4Abvt3759LfwIgX7nVU6FDix4q/zqkLuXJCr5Mta76cebNnggEBACH5BAUDAP8ALAAAAACkAR4BAAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzps2bOHPq3Mmzp8+fQIMKHUq0qNGjSJMqXcq0qdOnUKNKnUq1qtWrWLNq3cq1q9evYMOKHUu2rNmzaNOqXcu2rdu3cOPKnUu3rt27ePPq3cu3r9+/gAMLHky4sOHDiBMrXsy4sePHkCNLnky5suXLmDNr3sy5s+fPoEOLHk26tOnTqFOrXs26tevXsGPLnk27tu3buHPr3s27t+/fwIMLH068uPHjyJMrX868ufPn0KNLn069uvXr2LNr3869u/fv4MOL/x9Pvrz58+jTq1/Pvr379/Djy59Pv779+/jz69/Pv7///wAGKOCABBZo4IEIJqjgggw26OCDEEYo4YQUVmjhhRhmqOGGHHbo4YcghijiiCSWaOKJKKao4oostujiizDGKOOMNNZo44045qjjjjz26OOPQAYp5JBEFmnkkUgmqeSSTDbp5JNQRiklTnj84c+VWPqDySEIHeIHHoQEgoAMbOyjiAheyPLEAmy26eabcMYp55x01mmnnLG0qMYcWWLJBx7/+EEIJpo4YmWWZuyi6KKMNuroo5BGKumklFa6KAIvBqJFn5x26g8LloYq6qikWorpi4Qc6qmnnpTq6quwUv/KAItqEKKJqqt6SgakJ9zp66/ABkvnIymqUQgjm+baqRaOzKEJJu0okUENdYzRzJQsHULIHMkq66kWl6iBrUx+YILrqnzMQWi3nM4B6LgsRcKnsn9oUoi4A6lxCbt9/oGJH/CehIcjyjqCSSQK+aEJv33y8W/AIRFC8KqOBAKwQ/oy3LAmhOALMUYDr/rHJRdLpEYgfHjrjyOXFILwxxRRXAiXIM+rMrPPEhIJzTAv1OkcL3NkLCMqc/qHI4zMcQkmgRRSCCGE4CH11FRXbfXVWL9bY59AjzS0xkWHLbayN2LZ9UmH4IHJxGO37XaWPcct99x012333XjnrffefPec7fffgAcu+OCEF2744YgnrvjijDfu+OOQRy755JRXbvnlmGeu+eacd+7556CHLvropJdu+umop6766qy37vrrsMcu++y012777bjnrvvuvPfu++/ABy/88MQXb/zxyCev/PLMN+/889BHL/301Fdv/fXYZ6/99tx37/334Icv/vjkl2/++einr/767Lfv/vvwxy///PTXb//9CAUEACH5BAUDAP8ALPsAiAB5AAYAAAh8AC9pmsPIER8+f/5oWciwoZYq/yJKnEixosWLGDNqvLigo8ePIEN6xDXBn8mTKFOmRLCxpcuXMCfumkmzps2bNXGo3LmzR8yfQIPiHEp0lyWeSE+yCsq0qcaiUGviQuqwqhOnWLNGFMmVaysWEwIVwhPJjxo1WtOqXTsxIAAh+QQFAwD/ACwPAYgAFQAFAAAIIQC1CBxIsGBBH/4SKlzIkOGehhAbTtsQsaLCDQYzZtwQEAAh+QQFAwD/ACwiAYgAFwAFAAAIIwC1CBxIsKBBLaD8KVzIsKFDf08eSnwoa6LFhbIOajQoT0RAACH5BAUDAP8ALDcBiAAWAAUAAAggALUIHEiwoEE7/hIqXMiwYaaGECM+jEhRYSaDGDM6CQgAIfkEBQMA/wAsTAGIABUABQAACCAAtQgcSLBgwV7+EipcyJAhgoYQIaaKSFFhKoMYMdoKCAA7")}},{key:"setLoading",value:function(){this.container.select(".chart-loading").style("display","flex")}},{key:"createChart",value:function(t){switch(t){case m.LineChart:return new fn(this.container);case m.LineChartReactMigration:return new Fd(this.container);case m.LineChartReact:return new Qd(this.container);case m.Map:return new uf(this.container);case m.MapReactMigration:return new Tf(this.container);case m.MapReact:return new zf(this.container);case m.TimeSeriesBarChart:return new Yf(this.container);case m.CartogramReact:return new Nf(this.container);case m.DotPlot:return new eh(this.container);case m.DotPlotReactMigration:return new ih(this.container);case m.DotPlotReact:return new sh(this.container);case m.BarChart:return new fh(this.container);case m.BarChartReactMigration:return new gh(this.container);case m.BarChartReact:return new vh(this.container);case m.SmallMultiples:return new Sh(this.container);case m.BubbleChart:return new Rh(this.container);case m.Sankey:return new zh(this.container);case m.IncomeDistribution:return new Kh(this.container);case m.TimeBarChart:return new $h(this.container);case m.Beeswarm:return new ap(this.container);case m.MosaicPlot:return new lp(this.container);case m.SankeyVertical:return new fp(this.container);case m.SOTU2021Education:return new hp(this.container);case m.GroupedBars:return new mp(this.container);default:return null}}}]),t}()}])}));

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "90ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _number_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e317");


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(_number_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "91e0":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("0efc");
var walk = __webpack_require__("7dfc");
var stringify = __webpack_require__("1060");

function ValueParser(value) {
  if (this instanceof ValueParser) {
    this.nodes = parse(value);
    return this;
  }
  return new ValueParser(value);
}

ValueParser.prototype.toString = function() {
  return Array.isArray(this.nodes) ? stringify(this.nodes) : "";
};

ValueParser.prototype.walk = function(cb, bubble) {
  walk(this.nodes, cb, bubble);
  return this;
};

ValueParser.unit = __webpack_require__("5b87");

ValueParser.walk = walk;

ValueParser.stringify = stringify;

module.exports = ValueParser;


/***/ }),

/***/ "91e9":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "93d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "93ed":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "950a":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("30c9");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "9520":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObject = __webpack_require__("1a8c");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "95ae":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("100e"),
    eq = __webpack_require__("9638"),
    isIterateeCall = __webpack_require__("9aff"),
    keysIn = __webpack_require__("9934");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),

/***/ "9603":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return months; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");


var month = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),

/***/ "9638":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "966f":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    baseIsEqual = __webpack_require__("c05f");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "97d3":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("48a0"),
    isArrayLike = __webpack_require__("30c9");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "986d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.corePluginList = void 0;
const corePluginList = ['preflight', 'container', 'space', 'divideWidth', 'divideColor', 'divideStyle', 'divideOpacity', 'accessibility', 'appearance', 'backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'gradientColorStops', 'backgroundOpacity', 'backgroundPosition', 'backgroundRepeat', 'backgroundSize', 'borderCollapse', 'borderColor', 'borderOpacity', 'borderRadius', 'borderStyle', 'borderWidth', 'boxSizing', 'cursor', 'display', 'flexDirection', 'flexWrap', 'placeItems', 'placeContent', 'placeSelf', 'alignItems', 'alignContent', 'alignSelf', 'justifyItems', 'justifyContent', 'justifySelf', 'flex', 'flexGrow', 'flexShrink', 'order', 'float', 'clear', 'fontFamily', 'fontWeight', 'height', 'fontSize', 'lineHeight', 'listStylePosition', 'listStyleType', 'margin', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'objectFit', 'objectPosition', 'opacity', 'outline', 'overflow', 'overscrollBehavior', 'padding', 'placeholderColor', 'placeholderOpacity', 'pointerEvents', 'position', 'inset', 'resize', 'boxShadow', 'fill', 'stroke', 'strokeWidth', 'tableLayout', 'textAlign', 'textColor', 'textOpacity', 'fontStyle', 'textTransform', 'textDecoration', 'fontSmoothing', 'fontVariantNumeric', 'letterSpacing', 'userSelect', 'verticalAlign', 'visibility', 'whitespace', 'wordBreak', 'width', 'zIndex', 'gap', 'gridAutoFlow', 'gridTemplateColumns', 'gridAutoColumns', 'gridColumn', 'gridColumnStart', 'gridColumnEnd', 'gridTemplateRows', 'gridAutoRows', 'gridRow', 'gridRowStart', 'gridRowEnd', 'transform', 'transformOrigin', 'scale', 'rotate', 'translate', 'skew', 'transitionProperty', 'transitionTimingFunction', 'transitionDuration', 'transitionDelay', 'animation'];
exports.corePluginList = corePluginList;

/***/ }),

/***/ "98e5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9934":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("6fcd"),
    baseKeysIn = __webpack_require__("41c3"),
    isArrayLike = __webpack_require__("30c9");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "99cd":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "99d3":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("585a");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "9ab5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return min; });
function min(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  }
  return min;
}


/***/ }),

/***/ "9aff":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("9638"),
    isArrayLike = __webpack_require__("30c9"),
    isIndex = __webpack_require__("c098"),
    isObject = __webpack_require__("1a8c");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "9b02":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("656b");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9e69":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "9fc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ src_area; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ bounds; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ centroid; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ src_circle; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ clip_antimeridian; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ clip_circle; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ clip_extent; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ clipRectangle; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ contains; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ distance; });
__webpack_require__.d(__webpack_exports__, "C", function() { return /* reexport */ graticule_graticule; });
__webpack_require__.d(__webpack_exports__, "D", function() { return /* reexport */ graticule10; });
__webpack_require__.d(__webpack_exports__, "F", function() { return /* reexport */ src_interpolate; });
__webpack_require__.d(__webpack_exports__, "G", function() { return /* reexport */ src_length; });
__webpack_require__.d(__webpack_exports__, "N", function() { return /* reexport */ src_path; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ albers; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ projection_albersUsa; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ azimuthalEqualArea; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ azimuthalEqualAreaRaw; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ azimuthalEquidistant; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ azimuthalEquidistantRaw; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ conicConformal; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ conicConformalRaw; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ conicEqualArea; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ conicEqualAreaRaw; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ conicEquidistant; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ conicEquidistantRaw; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ equalEarth; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ equalEarthRaw; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ equirectangular; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ equirectangularRaw; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ gnomonic; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* reexport */ gnomonicRaw; });
__webpack_require__.d(__webpack_exports__, "E", function() { return /* reexport */ projection_identity; });
__webpack_require__.d(__webpack_exports__, "O", function() { return /* reexport */ projection_projection; });
__webpack_require__.d(__webpack_exports__, "P", function() { return /* reexport */ projectionMutator; });
__webpack_require__.d(__webpack_exports__, "H", function() { return /* reexport */ mercator; });
__webpack_require__.d(__webpack_exports__, "I", function() { return /* reexport */ mercatorRaw; });
__webpack_require__.d(__webpack_exports__, "J", function() { return /* reexport */ naturalEarth1; });
__webpack_require__.d(__webpack_exports__, "K", function() { return /* reexport */ naturalEarth1Raw; });
__webpack_require__.d(__webpack_exports__, "L", function() { return /* reexport */ orthographic; });
__webpack_require__.d(__webpack_exports__, "M", function() { return /* reexport */ orthographicRaw; });
__webpack_require__.d(__webpack_exports__, "R", function() { return /* reexport */ stereographic; });
__webpack_require__.d(__webpack_exports__, "S", function() { return /* reexport */ stereographicRaw; });
__webpack_require__.d(__webpack_exports__, "V", function() { return /* reexport */ transverseMercator; });
__webpack_require__.d(__webpack_exports__, "W", function() { return /* reexport */ transverseMercatorRaw; });
__webpack_require__.d(__webpack_exports__, "Q", function() { return /* reexport */ src_rotation; });
__webpack_require__.d(__webpack_exports__, "T", function() { return /* reexport */ src_stream; });
__webpack_require__.d(__webpack_exports__, "U", function() { return /* reexport */ src_transform; });

// EXTERNAL MODULE: ./node_modules/d3-array/src/fsum.js
var fsum = __webpack_require__("c4e3");

// CONCATENATED MODULE: ./node_modules/d3-geo/src/math.js
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var math_sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/noop.js
function noop() {}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/stream.js
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ var src_stream = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/area.js





var areaRingSum = new fsum["a" /* Adder */]();

// hello?

var areaSum = new fsum["a" /* Adder */](),
    area_lambda00,
    phi00,
    area_lambda0,
    area_cosPhi0,
    area_sinPhi0;

var areaStream = {
  point: noop,
  lineStart: noop,
  lineEnd: noop,
  polygonStart: function() {
    areaRingSum = new fsum["a" /* Adder */]();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop;
  },
  sphere: function() {
    areaSum.add(tau);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(area_lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  area_lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  area_lambda0 = lambda, area_cosPhi0 = cos(phi = phi / 2 + quarterPi), area_sinPhi0 = sin(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - area_lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos(phi),
      sinPhi = sin(phi),
      k = area_sinPhi0 * sinPhi,
      u = area_cosPhi0 * cosPhi + k * cos(adLambda),
      v = k * sdLambda * sin(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  area_lambda0 = lambda, area_cosPhi0 = cosPhi, area_sinPhi0 = sinPhi;
}

/* harmony default export */ var src_area = (function(object) {
  areaSum = new fsum["a" /* Adder */]();
  src_stream(object, areaStream);
  return areaSum * 2;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/cartesian.js


function cartesian_spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian_cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/bounds.js






var bounds_lambda0, bounds_phi0, bounds_lambda1, bounds_phi1, // bounds
    bounds_lambda2, // previous lambda-coordinate
    bounds_lambda00, bounds_phi00, // first point
    bounds_p0, // previous 3D point
    deltaSum,
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum = new fsum["a" /* Adder */]();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) bounds_lambda0 = -(bounds_lambda1 = 180), bounds_phi0 = -(bounds_phi1 = 90);
    else if (deltaSum > epsilon) bounds_phi1 = 90;
    else if (deltaSum < -epsilon) bounds_phi0 = -90;
    range[0] = bounds_lambda0, range[1] = bounds_lambda1;
  },
  sphere: function() {
    bounds_lambda0 = -(bounds_lambda1 = 180), bounds_phi0 = -(bounds_phi1 = 90);
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [bounds_lambda0 = lambda, bounds_lambda1 = lambda]);
  if (phi < bounds_phi0) bounds_phi0 = phi;
  if (phi > bounds_phi1) bounds_phi1 = phi;
}

function bounds_linePoint(lambda, phi) {
  var p = cartesian_cartesian([lambda * radians, phi * radians]);
  if (bounds_p0) {
    var normal = cartesianCross(bounds_p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = cartesian_spherical(inflection);
    var delta = lambda - bounds_lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees * sign,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign * bounds_lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * degrees;
      if (phii > bounds_phi1) bounds_phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * bounds_lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * degrees;
      if (phii < bounds_phi0) bounds_phi0 = phii;
    } else {
      if (phi < bounds_phi0) bounds_phi0 = phi;
      if (phi > bounds_phi1) bounds_phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < bounds_lambda2) {
        if (bounds_angle(bounds_lambda0, lambda) > bounds_angle(bounds_lambda0, bounds_lambda1)) bounds_lambda1 = lambda;
      } else {
        if (bounds_angle(lambda, bounds_lambda1) > bounds_angle(bounds_lambda0, bounds_lambda1)) bounds_lambda0 = lambda;
      }
    } else {
      if (bounds_lambda1 >= bounds_lambda0) {
        if (lambda < bounds_lambda0) bounds_lambda0 = lambda;
        if (lambda > bounds_lambda1) bounds_lambda1 = lambda;
      } else {
        if (lambda > bounds_lambda2) {
          if (bounds_angle(bounds_lambda0, lambda) > bounds_angle(bounds_lambda0, bounds_lambda1)) bounds_lambda1 = lambda;
        } else {
          if (bounds_angle(lambda, bounds_lambda1) > bounds_angle(bounds_lambda0, bounds_lambda1)) bounds_lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [bounds_lambda0 = lambda, bounds_lambda1 = lambda]);
  }
  if (phi < bounds_phi0) bounds_phi0 = phi;
  if (phi > bounds_phi1) bounds_phi1 = phi;
  bounds_p0 = p, bounds_lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = bounds_linePoint;
}

function boundsLineEnd() {
  range[0] = bounds_lambda0, range[1] = bounds_lambda1;
  boundsStream.point = boundsPoint;
  bounds_p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (bounds_p0) {
    var delta = lambda - bounds_lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    bounds_lambda00 = lambda, bounds_phi00 = phi;
  }
  areaStream.point(lambda, phi);
  bounds_linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(bounds_lambda00, bounds_phi00);
  areaStream.lineEnd();
  if (abs(deltaSum) > epsilon) bounds_lambda0 = -(bounds_lambda1 = 180);
  range[0] = bounds_lambda0, range[1] = bounds_lambda1;
  bounds_p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function bounds_angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ var bounds = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  bounds_phi1 = bounds_lambda1 = -(bounds_lambda0 = bounds_phi0 = Infinity);
  ranges = [];
  src_stream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (bounds_angle(a[0], b[1]) > bounds_angle(a[0], a[1])) a[1] = b[1];
        if (bounds_angle(b[0], a[1]) > bounds_angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = bounds_angle(a[1], b[0])) > deltaMax) deltaMax = delta, bounds_lambda0 = b[0], bounds_lambda1 = a[1];
    }
  }

  ranges = range = null;

  return bounds_lambda0 === Infinity || bounds_phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[bounds_lambda0, bounds_phi0], [bounds_lambda1, bounds_phi1]];
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/centroid.js





var W0, W1,
    centroid_X0, centroid_Y0, Z0,
    centroid_X1, centroid_Y1, Z1,
    X2, Y2, Z2,
    centroid_lambda00, centroid_phi00, // first point
    centroid_x0, centroid_y0, z0; // previous point

var centroidStream = {
  sphere: noop,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi);
  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  centroid_X0 += (x - centroid_X0) / W0;
  centroid_Y0 += (y - centroid_Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi);
  centroid_x0 = cosPhi * cos(lambda);
  centroid_y0 = cosPhi * sin(lambda);
  z0 = sin(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(centroid_x0, centroid_y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi),
      x = cosPhi * cos(lambda),
      y = cosPhi * sin(lambda),
      z = sin(phi),
      w = atan2(sqrt((w = centroid_y0 * z - z0 * y) * w + (w = z0 * x - centroid_x0 * z) * w + (w = centroid_x0 * y - centroid_y0 * x) * w), centroid_x0 * x + centroid_y0 * y + z0 * z);
  W1 += w;
  centroid_X1 += w * (centroid_x0 + (centroid_x0 = x));
  centroid_Y1 += w * (centroid_y0 + (centroid_y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(centroid_x0, centroid_y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(centroid_lambda00, centroid_phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  centroid_lambda00 = lambda, centroid_phi00 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos(phi);
  centroid_x0 = cosPhi * cos(lambda);
  centroid_y0 = cosPhi * sin(lambda);
  z0 = sin(phi);
  centroidPointCartesian(centroid_x0, centroid_y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi),
      x = cosPhi * cos(lambda),
      y = cosPhi * sin(lambda),
      z = sin(phi),
      cx = centroid_y0 * z - z0 * y,
      cy = z0 * x - centroid_x0 * z,
      cz = centroid_x0 * y - centroid_y0 * x,
      m = hypot(cx, cy, cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2.add(v * cx);
  Y2.add(v * cy);
  Z2.add(v * cz);
  W1 += w;
  centroid_X1 += w * (centroid_x0 + (centroid_x0 = x));
  centroid_Y1 += w * (centroid_y0 + (centroid_y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(centroid_x0, centroid_y0, z0);
}

/* harmony default export */ var centroid = (function(object) {
  W0 = W1 =
  centroid_X0 = centroid_Y0 = Z0 =
  centroid_X1 = centroid_Y1 = Z1 = 0;
  X2 = new fsum["a" /* Adder */]();
  Y2 = new fsum["a" /* Adder */]();
  Z2 = new fsum["a" /* Adder */]();
  src_stream(object, centroidStream);

  var x = +X2,
      y = +Y2,
      z = +Z2,
      m = hypot(x, y, z);

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2) {
    x = centroid_X1, y = centroid_Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon) x = centroid_X0, y = centroid_Y0, z = Z0;
    m = hypot(x, y, z);
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2) return [NaN, NaN];
  }

  return [atan2(y, x) * degrees, asin(z / m) * degrees];
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/compose.js
/* harmony default export */ var compose = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/rotation.js



function rotationIdentity(lambda, phi) {
  return [abs(lambda) > pi ? lambda + Math.round(-lambda / tau) * tau : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos(deltaPhi),
      sinDeltaPhi = sin(deltaPhi),
      cosDeltaGamma = cos(deltaGamma),
      sinDeltaGamma = sin(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = cos(phi),
        x = cos(lambda) * cosPhi,
        y = sin(lambda) * cosPhi,
        z = sin(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = cos(phi),
        x = cos(lambda) * cosPhi,
        y = sin(lambda) * cosPhi,
        z = sin(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ var src_rotation = (function(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
  };

  return forward;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/circle.js





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos(radius),
      sinRadius = sin(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = cartesian_spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian_cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
}

/* harmony default export */ var src_circle = (function() {
  var center = constant([0, 0]),
      radius = constant(90),
      precision = constant(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= degrees, x[1] *= degrees;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * radians,
        p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
  };

  return circle;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/buffer.js


/* harmony default export */ var buffer = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/pointEqual.js


/* harmony default export */ var pointEqual = (function(a, b) {
  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/rejoin.js



function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ var rejoin = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    if (pointEqual(p0, p1)) {
      if (!p0[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
        stream.lineEnd();
        return;
      }
      // handle degenerate cases by moving the point
      p1[0] += 2 * epsilon;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  rejoin_link(subject);
  rejoin_link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function rejoin_link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/polygonContains.js




function longitude(point) {
  if (abs(point[0]) <= pi)
    return point[0];
  else
    return math_sign(point[0]) * ((abs(point[0]) + pi) % tau - pi);
}

/* harmony default export */ var polygonContains = (function(polygon, point) {
  var lambda = longitude(point),
      phi = point[1],
      sinPhi = sin(phi),
      normal = [sin(lambda), -cos(lambda), 0],
      angle = 0,
      winding = 0;

  var sum = new fsum["a" /* Adder */]();

  if (sinPhi === 1) phi = halfPi + epsilon;
  else if (sinPhi === -1) phi = -halfPi - epsilon;

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = longitude(point0),
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin(phi0),
        cosPhi0 = cos(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = longitude(point1),
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin(phi1),
          cosPhi1 = cos(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > pi,
          k = sinPhi0 * sinPhi1;

      sum.add(atan2(k * sign * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
      angle += antimeridian ? delta + sign * tau : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian_cartesian(point0), cartesian_cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -epsilon || angle < epsilon && sum < -epsilon2) ^ (winding & 1);
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/merge.js
var merge = __webpack_require__("1539");

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/index.js






/* harmony default export */ var src_clip = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = buffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(merge["a" /* default */])(segments);
        var startInside = polygonContains(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          rejoin(segments, clip_compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function clip_compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/antimeridian.js



/* harmony default export */ var clip_antimeridian = (src_clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi, -halfPi]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi : -pi,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi) < epsilon) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon
      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi;
    stream.point(-pi, phi);
    stream.point(0, phi);
    stream.point(pi, phi);
    stream.point(pi, 0);
    stream.point(pi, -phi);
    stream.point(0, -phi);
    stream.point(-pi, -phi);
    stream.point(-pi, 0);
    stream.point(-pi, phi);
  } else if (abs(from[0] - to[0]) > epsilon) {
    var lambda = from[0] < to[0] ? pi : -pi;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/circle.js






/* harmony default export */ var clip_circle = (function(radius) {
  var cr = cos(radius),
      delta = 6 * radians,
      smallRadius = cr > 0,
      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return cos(lambda) * cos(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2))
            point1[2] = 1;
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian_cartesian(a),
        pb = cartesian_cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = cartesianCross(pa, pb),
        n2n2 = cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = cartesianCross(n1, n2),
        A = cartesianScale(n1, c1),
        B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = cartesianDot(A, u),
        uu = cartesianDot(u, u),
        t2 = w * w - uu * (cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = sqrt(t2),
        q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = cartesian_spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = abs(delta - pi) < epsilon,
        meridian = polar || delta < epsilon;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, cartesian_spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return src_clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/line.js
/* harmony default export */ var clip_line = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/rectangle.js






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = buffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(merge["a" /* default */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          rejoin(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clip_line(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/extent.js


/* harmony default export */ var clip_extent = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/length.js





var lengthSum,
    length_lambda0,
    length_sinPhi0,
    length_cosPhi0;

var lengthStream = {
  sphere: noop,
  point: noop,
  lineStart: lengthLineStart,
  lineEnd: noop,
  polygonStart: noop,
  polygonEnd: noop
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  length_lambda0 = lambda, length_sinPhi0 = sin(phi), length_cosPhi0 = cos(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin(phi),
      cosPhi = cos(phi),
      delta = abs(lambda - length_lambda0),
      cosDelta = cos(delta),
      sinDelta = sin(delta),
      x = cosPhi * sinDelta,
      y = length_cosPhi0 * sinPhi - length_sinPhi0 * cosPhi * cosDelta,
      z = length_sinPhi0 * sinPhi + length_cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  length_lambda0 = lambda, length_sinPhi0 = sinPhi, length_cosPhi0 = cosPhi;
}

/* harmony default export */ var src_length = (function(object) {
  lengthSum = new fsum["a" /* Adder */]();
  src_stream(object, lengthStream);
  return +lengthSum;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/distance.js


var distance_coordinates = [null, null],
    distance_object = {type: "LineString", coordinates: distance_coordinates};

/* harmony default export */ var distance = (function(a, b) {
  distance_coordinates[0] = a;
  distance_coordinates[1] = b;
  return src_length(distance_object);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/contains.js




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ao, bo, ab;
  for (var i = 0, n = coordinates.length; i < n; i++) {
    bo = distance(coordinates[i], point);
    if (bo === 0) return true;
    if (i > 0) {
      ab = distance(coordinates[i], coordinates[i - 1]);
      if (
        ab > 0 &&
        ao <= ab &&
        bo <= ab &&
        (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab
      )
        return true;
    }
    ao = bo;
  }
  return false;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

/* harmony default export */ var contains = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/range.js
var src_range = __webpack_require__("365b");

// CONCATENATED MODULE: ./node_modules/d3-geo/src/graticule.js



function graticuleX(y0, y1, dy) {
  var y = Object(src_range["a" /* default */])(y0, y1 - epsilon, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(src_range["a" /* default */])(x0, x1 - epsilon, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule_graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(src_range["a" /* default */])(ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(src_range["a" /* default */])(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(src_range["a" /* default */])(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
        .concat(Object(src_range["a" /* default */])(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
}

function graticule10() {
  return graticule_graticule()();
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/interpolate.js


/* harmony default export */ var src_interpolate = (function(a, b) {
  var x0 = a[0] * radians,
      y0 = a[1] * radians,
      x1 = b[0] * radians,
      y1 = b[1] * radians,
      cy0 = cos(y0),
      sy0 = sin(y0),
      cy1 = cos(y1),
      sy1 = sin(y1),
      kx0 = cy0 * cos(x0),
      ky0 = cy0 * sin(x0),
      kx1 = cy1 * cos(x1),
      ky1 = cy1 * sin(x1),
      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
      k = sin(d);

  var interpolate = d ? function(t) {
    var B = sin(t *= d) / k,
        A = sin(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      atan2(y, x) * degrees,
      atan2(z, sqrt(x * x + y * y)) * degrees
    ];
  } : function() {
    return [x0 * degrees, y0 * degrees];
  };

  interpolate.distance = d;

  return interpolate;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/identity.js
/* harmony default export */ var identity = (x => x);

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/area.js




var area_areaSum = new fsum["a" /* Adder */](),
    area_areaRingSum = new fsum["a" /* Adder */](),
    area_x00,
    area_y00,
    area_x0,
    area_y0;

var area_areaStream = {
  point: noop,
  lineStart: noop,
  lineEnd: noop,
  polygonStart: function() {
    area_areaStream.lineStart = area_areaRingStart;
    area_areaStream.lineEnd = area_areaRingEnd;
  },
  polygonEnd: function() {
    area_areaStream.lineStart = area_areaStream.lineEnd = area_areaStream.point = noop;
    area_areaSum.add(abs(area_areaRingSum));
    area_areaRingSum = new fsum["a" /* Adder */]();
  },
  result: function() {
    var area = area_areaSum / 2;
    area_areaSum = new fsum["a" /* Adder */]();
    return area;
  }
};

function area_areaRingStart() {
  area_areaStream.point = area_areaPointFirst;
}

function area_areaPointFirst(x, y) {
  area_areaStream.point = area_areaPoint;
  area_x00 = area_x0 = x, area_y00 = area_y0 = y;
}

function area_areaPoint(x, y) {
  area_areaRingSum.add(area_y0 * x - area_x0 * y);
  area_x0 = x, area_y0 = y;
}

function area_areaRingEnd() {
  area_areaPoint(area_x00, area_y00);
}

/* harmony default export */ var path_area = (area_areaStream);

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/bounds.js


var bounds_x0 = Infinity,
    bounds_y0 = bounds_x0,
    bounds_x1 = -bounds_x0,
    bounds_y1 = bounds_x1;

var bounds_boundsStream = {
  point: bounds_boundsPoint,
  lineStart: noop,
  lineEnd: noop,
  polygonStart: noop,
  polygonEnd: noop,
  result: function() {
    var bounds = [[bounds_x0, bounds_y0], [bounds_x1, bounds_y1]];
    bounds_x1 = bounds_y1 = -(bounds_y0 = bounds_x0 = Infinity);
    return bounds;
  }
};

function bounds_boundsPoint(x, y) {
  if (x < bounds_x0) bounds_x0 = x;
  if (x > bounds_x1) bounds_x1 = x;
  if (y < bounds_y0) bounds_y0 = y;
  if (y > bounds_y1) bounds_y1 = y;
}

/* harmony default export */ var path_bounds = (bounds_boundsStream);

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/centroid.js


// TODO Enforce positive area for exterior, negative area for interior?

var path_centroid_X0 = 0,
    path_centroid_Y0 = 0,
    centroid_Z0 = 0,
    path_centroid_X1 = 0,
    path_centroid_Y1 = 0,
    centroid_Z1 = 0,
    centroid_X2 = 0,
    centroid_Y2 = 0,
    centroid_Z2 = 0,
    centroid_x00,
    centroid_y00,
    path_centroid_x0,
    path_centroid_y0;

var centroid_centroidStream = {
  point: centroid_centroidPoint,
  lineStart: centroid_centroidLineStart,
  lineEnd: centroid_centroidLineEnd,
  polygonStart: function() {
    centroid_centroidStream.lineStart = centroid_centroidRingStart;
    centroid_centroidStream.lineEnd = centroid_centroidRingEnd;
  },
  polygonEnd: function() {
    centroid_centroidStream.point = centroid_centroidPoint;
    centroid_centroidStream.lineStart = centroid_centroidLineStart;
    centroid_centroidStream.lineEnd = centroid_centroidLineEnd;
  },
  result: function() {
    var centroid = centroid_Z2 ? [centroid_X2 / centroid_Z2, centroid_Y2 / centroid_Z2]
        : centroid_Z1 ? [path_centroid_X1 / centroid_Z1, path_centroid_Y1 / centroid_Z1]
        : centroid_Z0 ? [path_centroid_X0 / centroid_Z0, path_centroid_Y0 / centroid_Z0]
        : [NaN, NaN];
    path_centroid_X0 = path_centroid_Y0 = centroid_Z0 =
    path_centroid_X1 = path_centroid_Y1 = centroid_Z1 =
    centroid_X2 = centroid_Y2 = centroid_Z2 = 0;
    return centroid;
  }
};

function centroid_centroidPoint(x, y) {
  path_centroid_X0 += x;
  path_centroid_Y0 += y;
  ++centroid_Z0;
}

function centroid_centroidLineStart() {
  centroid_centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroid_centroidStream.point = centroidPointLine;
  centroid_centroidPoint(path_centroid_x0 = x, path_centroid_y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - path_centroid_x0, dy = y - path_centroid_y0, z = sqrt(dx * dx + dy * dy);
  path_centroid_X1 += z * (path_centroid_x0 + x) / 2;
  path_centroid_Y1 += z * (path_centroid_y0 + y) / 2;
  centroid_Z1 += z;
  centroid_centroidPoint(path_centroid_x0 = x, path_centroid_y0 = y);
}

function centroid_centroidLineEnd() {
  centroid_centroidStream.point = centroid_centroidPoint;
}

function centroid_centroidRingStart() {
  centroid_centroidStream.point = centroidPointFirstRing;
}

function centroid_centroidRingEnd() {
  centroidPointRing(centroid_x00, centroid_y00);
}

function centroidPointFirstRing(x, y) {
  centroid_centroidStream.point = centroidPointRing;
  centroid_centroidPoint(centroid_x00 = path_centroid_x0 = x, centroid_y00 = path_centroid_y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - path_centroid_x0,
      dy = y - path_centroid_y0,
      z = sqrt(dx * dx + dy * dy);

  path_centroid_X1 += z * (path_centroid_x0 + x) / 2;
  path_centroid_Y1 += z * (path_centroid_y0 + y) / 2;
  centroid_Z1 += z;

  z = path_centroid_y0 * x - path_centroid_x0 * y;
  centroid_X2 += z * (path_centroid_x0 + x);
  centroid_Y2 += z * (path_centroid_y0 + y);
  centroid_Z2 += z * 3;
  centroid_centroidPoint(path_centroid_x0 = x, path_centroid_y0 = y);
}

/* harmony default export */ var path_centroid = (centroid_centroidStream);

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/context.js



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau);
        break;
      }
    }
  },
  result: noop
};

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/measure.js




var measure_lengthSum = new fsum["a" /* Adder */](),
    lengthRing,
    measure_x00,
    measure_y00,
    measure_x0,
    measure_y0;

var measure_lengthStream = {
  point: noop,
  lineStart: function() {
    measure_lengthStream.point = measure_lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) measure_lengthPoint(measure_x00, measure_y00);
    measure_lengthStream.point = noop;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +measure_lengthSum;
    measure_lengthSum = new fsum["a" /* Adder */]();
    return length;
  }
};

function measure_lengthPointFirst(x, y) {
  measure_lengthStream.point = measure_lengthPoint;
  measure_x00 = measure_x0 = x, measure_y00 = measure_y0 = y;
}

function measure_lengthPoint(x, y) {
  measure_x0 -= x, measure_y0 -= y;
  measure_lengthSum.add(sqrt(measure_x0 * measure_x0 + measure_y0 * measure_y0));
  measure_x0 = x, measure_y0 = y;
}

/* harmony default export */ var measure = (measure_lengthStream);

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/string.js
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: string_circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = string_circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function string_circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/index.js









/* harmony default export */ var src_path = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      src_stream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    src_stream(object, projectionStream(path_area));
    return path_area.result();
  };

  path.measure = function(object) {
    src_stream(object, projectionStream(measure));
    return measure.result();
  };

  path.bounds = function(object) {
    src_stream(object, projectionStream(path_bounds));
    return path_bounds.result();
  };

  path.centroid = function(object) {
    src_stream(object, projectionStream(path_centroid));
    return path_centroid.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/transform.js
/* harmony default export */ var src_transform = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/fit.js



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  src_stream(object, projection.stream(path_bounds));
  fitBounds(path_bounds.result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/resample.js




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = cos(30 * radians); // cos(minimum angular distance)

/* harmony default export */ var resample = (function(project, delta2) {
  return +delta2 ? resample_resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample_resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = sqrt(a * a + b * b + c * c),
          phi2 = asin(c /= m),
          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = cartesian_cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/index.js











var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function transformRotate(rotate) {
  return transformer({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function scaleTranslate(k, dx, dy, sx, sy) {
  function transform(x, y) {
    x *= sx; y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function(x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform;
}

function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
  if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
  var cosAlpha = cos(alpha),
      sinAlpha = sin(alpha),
      a = cosAlpha * k,
      b = sinAlpha * k,
      ai = cosAlpha / k,
      bi = sinAlpha / k,
      ci = (sinAlpha * dy - cosAlpha * dx) / k,
      fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    x *= sx; y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function(x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform;
}

function projection_projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, // pre-rotate
      alpha = 0, // post-rotate angle
      sx = 1, // reflectX
      sy = 1, // reflectX
      theta = null, preclip = clip_antimeridian, // pre-clip angle
      x0 = null, y0, x1, y1, postclip = identity, // post-clip extent
      delta2 = 0.5, // precision
      projectResample,
      projectTransform,
      projectRotateTransform,
      cache,
      cacheStream;

  function projection(point) {
    return projectRotateTransform(point[0] * radians, point[1] * radians);
  }

  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * degrees, point[1] * degrees];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clip_circle(theta = _ * radians) : (theta = null, clip_antimeridian), reset()) : theta * degrees;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
  };

  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
  };

  projection.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };

  projection.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return fitWidth(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return fitHeight(projection, height, object);
  };

  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)),
        transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform);
    projectRotateTransform = compose(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conic.js



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = pi / 3,
      m = projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
  };

  return p;
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/cylindricalEqualArea.js


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conicEqualArea.js




function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;

  function project(x, y) {
    var r = sqrt(c - 2 * n * sin(y)) / n;
    return [r * sin(x *= n), r0 - r * cos(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y,
        l = atan2(x, abs(r0y)) * math_sign(r0y);
    if (r0y * n < 0)
      l -= pi * math_sign(x) * math_sign(r0y);
    return [l / n, asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ var conicEqualArea = (function() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/albers.js


/* harmony default export */ var albers = (function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/albersUsa.js





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* harmony default export */ var projection_albersUsa = (function() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return fitSize(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return fitWidth(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return fitHeight(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/azimuthal.js


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos(x),
        cy = cos(y),
        k = scale(cx * cy);
        if (k === Infinity) return [2, 0];
    return [
      k * cy * sin(x),
      k * sin(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin(c),
        cc = cos(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/azimuthalEqualArea.js




var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

/* harmony default export */ var azimuthalEqualArea = (function() {
  return projection_projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/azimuthalEquidistant.js




var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

/* harmony default export */ var azimuthalEquidistant = (function() {
  return projection_projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/mercator.js




function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi];
};

/* harmony default export */ var mercator = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / tau);
});

function mercatorProjection(project) {
  var m = projection_projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = pi * scale(),
        t = m(src_rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conicConformal.js




function tany(y) {
  return tan((halfPi + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = cos(y0),
      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
      f = cy0 * pow(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
    var r = f / pow(tany(y), n);
    return [r * sin(n * x), f - r * cos(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = math_sign(n) * sqrt(x * x + fy * fy),
      l = atan2(x, abs(fy)) * math_sign(fy);
    if (fy * n < 0)
      l -= pi * math_sign(x) * math_sign(fy);
    return [l / n, 2 * atan(pow(f / r, 1 / n)) - halfPi];
  };

  return project;
}

/* harmony default export */ var conicConformal = (function() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/equirectangular.js


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ var equirectangular = (function() {
  return projection_projection(equirectangularRaw)
      .scale(152.63);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conicEquidistant.js




function conicEquidistantRaw(y0, y1) {
  var cy0 = cos(y0),
      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (abs(n) < epsilon) return equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin(nx), g - gy * cos(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y,
        l = atan2(x, abs(gy)) * math_sign(gy);
    if (gy * n < 0)
      l -= pi * math_sign(x) * math_sign(gy);
    return [l / n, g - math_sign(n) * sqrt(x * x + gy * gy)];
  };

  return project;
}

/* harmony default export */ var conicEquidistant = (function() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/equalEarth.js



var A1 = 1.340264,
    A2 = -0.081106,
    A3 = 0.000893,
    A4 = 0.003796,
    M = sqrt(3) / 2,
    iterations = 12;

function equalEarthRaw(lambda, phi) {
  var l = asin(M * sin(phi)), l2 = l * l, l6 = l2 * l2 * l2;
  return [
    lambda * cos(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
    l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
  ];
}

equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (abs(delta) < epsilon2) break;
  }
  return [
    M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos(l),
    asin(sin(l) / M)
  ];
};

/* harmony default export */ var equalEarth = (function() {
  return projection_projection(equalEarthRaw)
      .scale(177.158);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/gnomonic.js




function gnomonicRaw(x, y) {
  var cy = cos(y), k = cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

/* harmony default export */ var gnomonic = (function() {
  return projection_projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/identity.js






/* harmony default export */ var projection_identity = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, // scale, translate and reflect
      alpha = 0, ca, sa, // angle
      x0 = null, y0, x1, y1, // clip extent
      kx = 1, ky = 1,
      transform = transformer({
        point: function(x, y) {
          var p = projection([x, y])
          this.stream.point(p[0], p[1]);
        }
      }),
      postclip = identity,
      cache,
      cacheStream;

  function reset() {
    kx = k * sx;
    ky = k * sy;
    cache = cacheStream = null;
    return projection;
  }

  function projection (p) {
    var x = p[0] * kx, y = p[1] * ky;
    if (alpha) {
      var t = y * ca - x * sa;
      x = x * ca + y * sa;
      y = t;
    }    
    return [x + tx, y + ty];
  }
  projection.invert = function(p) {
    var x = p[0] - tx, y = p[1] - ty;
    if (alpha) {
      var t = y * ca + x * sa;
      x = x * ca - y * sa;
      y = t;
    }
    return [x / kx, y / ky];
  };
  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
  };
  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };
  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  projection.scale = function(_) {
    return arguments.length ? (k = +_, reset()) : k;
  };
  projection.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
  }
  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians, sa = sin(alpha), ca = cos(alpha), reset()) : alpha * degrees;
  };
  projection.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
  };
  projection.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
  };
  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };
  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };
  projection.fitWidth = function(width, object) {
    return fitWidth(projection, width, object);
  };
  projection.fitHeight = function(height, object) {
    return fitHeight(projection, height, object);
  };

  return projection;
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/naturalEarth1.js



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (abs(delta) > epsilon && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* harmony default export */ var naturalEarth1 = (function() {
  return projection_projection(naturalEarth1Raw)
      .scale(175.295);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/orthographic.js




function orthographicRaw(x, y) {
  return [cos(y) * sin(x), sin(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

/* harmony default export */ var orthographic = (function() {
  return projection_projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + epsilon);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/stereographic.js




function stereographicRaw(x, y) {
  var cy = cos(y), k = 1 + cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

/* harmony default export */ var stereographic = (function() {
  return projection_projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/transverseMercator.js



function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi];
};

/* harmony default export */ var transverseMercator = (function() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});

// CONCATENATED MODULE: ./node_modules/d3-geo/src/index.js






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).





























/***/ }),

/***/ "a029":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("087d"),
    getPrototype = __webpack_require__("2dcb"),
    getSymbols = __webpack_require__("32f4"),
    stubArray = __webpack_require__("d327");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "a15a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return years; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");


var year = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a1eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "R", function() { return /* reexport */ category10; });
__webpack_require__.d(__webpack_exports__, "M", function() { return /* reexport */ Accent; });
__webpack_require__.d(__webpack_exports__, "S", function() { return /* reexport */ Dark2; });
__webpack_require__.d(__webpack_exports__, "Z", function() { return /* reexport */ Paired; });
__webpack_require__.d(__webpack_exports__, "ab", function() { return /* reexport */ Pastel1; });
__webpack_require__.d(__webpack_exports__, "bb", function() { return /* reexport */ Pastel2; });
__webpack_require__.d(__webpack_exports__, "ob", function() { return /* reexport */ Set1; });
__webpack_require__.d(__webpack_exports__, "pb", function() { return /* reexport */ Set2; });
__webpack_require__.d(__webpack_exports__, "qb", function() { return /* reexport */ Set3; });
__webpack_require__.d(__webpack_exports__, "sb", function() { return /* reexport */ Tableau10; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ BrBG; });
__webpack_require__.d(__webpack_exports__, "O", function() { return /* reexport */ BrBG_scheme; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ PRGn; });
__webpack_require__.d(__webpack_exports__, "Y", function() { return /* reexport */ PRGn_scheme; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ PiYG; });
__webpack_require__.d(__webpack_exports__, "cb", function() { return /* reexport */ PiYG_scheme; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ PuOr; });
__webpack_require__.d(__webpack_exports__, "fb", function() { return /* reexport */ PuOr_scheme; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ RdBu; });
__webpack_require__.d(__webpack_exports__, "ib", function() { return /* reexport */ RdBu_scheme; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ RdGy; });
__webpack_require__.d(__webpack_exports__, "jb", function() { return /* reexport */ RdGy_scheme; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ RdYlBu; });
__webpack_require__.d(__webpack_exports__, "lb", function() { return /* reexport */ RdYlBu_scheme; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* reexport */ RdYlGn; });
__webpack_require__.d(__webpack_exports__, "mb", function() { return /* reexport */ RdYlGn_scheme; });
__webpack_require__.d(__webpack_exports__, "E", function() { return /* reexport */ Spectral; });
__webpack_require__.d(__webpack_exports__, "rb", function() { return /* reexport */ Spectral_scheme; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ BuGn; });
__webpack_require__.d(__webpack_exports__, "P", function() { return /* reexport */ BuGn_scheme; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ BuPu; });
__webpack_require__.d(__webpack_exports__, "Q", function() { return /* reexport */ BuPu_scheme; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ GnBu; });
__webpack_require__.d(__webpack_exports__, "T", function() { return /* reexport */ GnBu_scheme; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ OrRd; });
__webpack_require__.d(__webpack_exports__, "W", function() { return /* reexport */ OrRd_scheme; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ PuBuGn; });
__webpack_require__.d(__webpack_exports__, "eb", function() { return /* reexport */ PuBuGn_scheme; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ PuBu; });
__webpack_require__.d(__webpack_exports__, "db", function() { return /* reexport */ PuBu_scheme; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ PuRd; });
__webpack_require__.d(__webpack_exports__, "gb", function() { return /* reexport */ PuRd_scheme; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ RdPu; });
__webpack_require__.d(__webpack_exports__, "kb", function() { return /* reexport */ RdPu_scheme; });
__webpack_require__.d(__webpack_exports__, "J", function() { return /* reexport */ YlGnBu; });
__webpack_require__.d(__webpack_exports__, "ub", function() { return /* reexport */ YlGnBu_scheme; });
__webpack_require__.d(__webpack_exports__, "I", function() { return /* reexport */ YlGn; });
__webpack_require__.d(__webpack_exports__, "tb", function() { return /* reexport */ YlGn_scheme; });
__webpack_require__.d(__webpack_exports__, "K", function() { return /* reexport */ YlOrBr; });
__webpack_require__.d(__webpack_exports__, "vb", function() { return /* reexport */ YlOrBr_scheme; });
__webpack_require__.d(__webpack_exports__, "L", function() { return /* reexport */ YlOrRd; });
__webpack_require__.d(__webpack_exports__, "wb", function() { return /* reexport */ YlOrRd_scheme; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Blues; });
__webpack_require__.d(__webpack_exports__, "N", function() { return /* reexport */ Blues_scheme; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ Greens; });
__webpack_require__.d(__webpack_exports__, "U", function() { return /* reexport */ Greens_scheme; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ Greys; });
__webpack_require__.d(__webpack_exports__, "V", function() { return /* reexport */ Greys_scheme; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ Purples; });
__webpack_require__.d(__webpack_exports__, "hb", function() { return /* reexport */ Purples_scheme; });
__webpack_require__.d(__webpack_exports__, "C", function() { return /* reexport */ Reds; });
__webpack_require__.d(__webpack_exports__, "nb", function() { return /* reexport */ Reds_scheme; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ Oranges; });
__webpack_require__.d(__webpack_exports__, "X", function() { return /* reexport */ Oranges_scheme; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ cividis; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ sequential_multi_cubehelix; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ rainbow; });
__webpack_require__.d(__webpack_exports__, "H", function() { return /* reexport */ warm; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ cool; });
__webpack_require__.d(__webpack_exports__, "D", function() { return /* reexport */ sinebow; });
__webpack_require__.d(__webpack_exports__, "F", function() { return /* reexport */ turbo; });
__webpack_require__.d(__webpack_exports__, "G", function() { return /* reexport */ viridis; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ magma; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ inferno; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ plasma; });

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/colors.js
/* harmony default export */ var colors = (function(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
});

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/category10.js


/* harmony default export */ var category10 = (colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Accent.js


/* harmony default export */ var Accent = (colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Dark2.js


/* harmony default export */ var Dark2 = (colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Paired.js


/* harmony default export */ var Paired = (colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Pastel1.js


/* harmony default export */ var Pastel1 = (colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Pastel2.js


/* harmony default export */ var Pastel2 = (colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Set1.js


/* harmony default export */ var Set1 = (colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Set2.js


/* harmony default export */ var Set2 = (colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Set3.js


/* harmony default export */ var Set3 = (colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/categorical/Tableau10.js


/* harmony default export */ var Tableau10 = (colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"));

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/rgb.js
var rgb = __webpack_require__("e360");

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/ramp.js


/* harmony default export */ var ramp = (scheme => Object(rgb["b" /* rgbBasis */])(scheme[scheme.length - 1]));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/BrBG.js



var BrBG_scheme = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(colors);

/* harmony default export */ var BrBG = (ramp(BrBG_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/PRGn.js



var PRGn_scheme = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(colors);

/* harmony default export */ var PRGn = (ramp(PRGn_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/PiYG.js



var PiYG_scheme = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(colors);

/* harmony default export */ var PiYG = (ramp(PiYG_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/PuOr.js



var PuOr_scheme = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(colors);

/* harmony default export */ var PuOr = (ramp(PuOr_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/RdBu.js



var RdBu_scheme = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(colors);

/* harmony default export */ var RdBu = (ramp(RdBu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/RdGy.js



var RdGy_scheme = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(colors);

/* harmony default export */ var RdGy = (ramp(RdGy_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/RdYlBu.js



var RdYlBu_scheme = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(colors);

/* harmony default export */ var RdYlBu = (ramp(RdYlBu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/RdYlGn.js



var RdYlGn_scheme = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(colors);

/* harmony default export */ var RdYlGn = (ramp(RdYlGn_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/diverging/Spectral.js



var Spectral_scheme = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(colors);

/* harmony default export */ var Spectral = (ramp(Spectral_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/BuGn.js



var BuGn_scheme = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(colors);

/* harmony default export */ var BuGn = (ramp(BuGn_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/BuPu.js



var BuPu_scheme = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(colors);

/* harmony default export */ var BuPu = (ramp(BuPu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/GnBu.js



var GnBu_scheme = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(colors);

/* harmony default export */ var GnBu = (ramp(GnBu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/OrRd.js



var OrRd_scheme = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(colors);

/* harmony default export */ var OrRd = (ramp(OrRd_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/PuBuGn.js



var PuBuGn_scheme = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(colors);

/* harmony default export */ var PuBuGn = (ramp(PuBuGn_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/PuBu.js



var PuBu_scheme = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(colors);

/* harmony default export */ var PuBu = (ramp(PuBu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/PuRd.js



var PuRd_scheme = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(colors);

/* harmony default export */ var PuRd = (ramp(PuRd_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/RdPu.js



var RdPu_scheme = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(colors);

/* harmony default export */ var RdPu = (ramp(RdPu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/YlGnBu.js



var YlGnBu_scheme = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(colors);

/* harmony default export */ var YlGnBu = (ramp(YlGnBu_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/YlGn.js



var YlGn_scheme = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(colors);

/* harmony default export */ var YlGn = (ramp(YlGn_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/YlOrBr.js



var YlOrBr_scheme = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(colors);

/* harmony default export */ var YlOrBr = (ramp(YlOrBr_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/YlOrRd.js



var YlOrRd_scheme = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(colors);

/* harmony default export */ var YlOrRd = (ramp(YlOrRd_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-single/Blues.js



var Blues_scheme = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(colors);

/* harmony default export */ var Blues = (ramp(Blues_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-single/Greens.js



var Greens_scheme = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(colors);

/* harmony default export */ var Greens = (ramp(Greens_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-single/Greys.js



var Greys_scheme = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(colors);

/* harmony default export */ var Greys = (ramp(Greys_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-single/Purples.js



var Purples_scheme = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(colors);

/* harmony default export */ var Purples = (ramp(Purples_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-single/Reds.js



var Reds_scheme = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(colors);

/* harmony default export */ var Reds = (ramp(Reds_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-single/Oranges.js



var Oranges_scheme = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(colors);

/* harmony default export */ var Oranges = (ramp(Oranges_scheme));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/cividis.js
/* harmony default export */ var cividis = (function(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb("
      + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67)))))))
      + ")";
});

// EXTERNAL MODULE: ./node_modules/d3-color/src/cubehelix.js
var cubehelix = __webpack_require__("15a7");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/cubehelix.js
var src_cubehelix = __webpack_require__("3872");

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/cubehelix.js



/* harmony default export */ var sequential_multi_cubehelix = (Object(src_cubehelix["a" /* cubehelixLong */])(Object(cubehelix["a" /* default */])(300, 0.5, 0.0), Object(cubehelix["a" /* default */])(-240, 0.5, 1.0)));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/rainbow.js



var warm = Object(src_cubehelix["a" /* cubehelixLong */])(Object(cubehelix["a" /* default */])(-100, 0.75, 0.35), Object(cubehelix["a" /* default */])(80, 1.50, 0.8));

var cool = Object(src_cubehelix["a" /* cubehelixLong */])(Object(cubehelix["a" /* default */])(260, 0.75, 0.35), Object(cubehelix["a" /* default */])(80, 1.50, 0.8));

var c = Object(cubehelix["a" /* default */])();

/* harmony default export */ var rainbow = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c.h = 360 * t - 100;
  c.s = 1.5 - 1.5 * ts;
  c.l = 0.8 - 0.9 * ts;
  return c + "";
});

// EXTERNAL MODULE: ./node_modules/d3-color/src/color.js
var color = __webpack_require__("166a");

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/sinebow.js


var sinebow_c = Object(color["g" /* rgb */])(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = Math.PI * 2 / 3;

/* harmony default export */ var sinebow = (function(t) {
  var x;
  t = (0.5 - t) * Math.PI;
  sinebow_c.r = 255 * (x = Math.sin(t)) * x;
  sinebow_c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  sinebow_c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return sinebow_c + "";
});

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/turbo.js
/* harmony default export */ var turbo = (function(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb("
      + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66)))))))
      + ")";
});

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/sequential-multi/viridis.js


function viridis_ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ var viridis = (viridis_ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = viridis_ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = viridis_ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = viridis_ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

// CONCATENATED MODULE: ./node_modules/d3-scale-chromatic/src/index.js













































/***/ }),

/***/ "a1f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusIndicator_vue_vue_type_style_index_0_id_5ef20966_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae0d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusIndicator_vue_vue_type_style_index_0_id_5ef20966_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusIndicator_vue_vue_type_style_index_0_id_5ef20966_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusIndicator_vue_vue_type_style_index_0_id_5ef20966_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a2be":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("d612"),
    arraySome = __webpack_require__("4284"),
    cacheHas = __webpack_require__("c584");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "a2bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__("e8b5");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "a2db":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "a317":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),

/***/ "a43d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ value["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ array["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ basis["b" /* default */]; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ basisClosed["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ date["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ discrete; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ src_hue; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ number["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ numberArray["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ object["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ round["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ string["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ transform["a" /* interpolateTransformCss */]; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ transform["b" /* interpolateTransformSvg */]; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ zoom["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ rgb["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ rgb["b" /* rgbBasis */]; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ rgb["c" /* rgbBasisClosed */]; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ src_hsl; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ hslLong; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ lab_lab; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ src_hcl; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ hclLong; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ cubehelix["b" /* default */]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ cubehelix["a" /* cubehelixLong */]; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ piecewise["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ quantize; });

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/value.js
var value = __webpack_require__("ea1d");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/array.js
var array = __webpack_require__("6730");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/basis.js
var basis = __webpack_require__("c84a");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/basisClosed.js
var basisClosed = __webpack_require__("4bcd");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/date.js
var date = __webpack_require__("1b6d");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/discrete.js
/* harmony default export */ var discrete = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/color.js
var color = __webpack_require__("b055");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hue.js


/* harmony default export */ var src_hue = (function(a, b) {
  var i = Object(color["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/number.js
var number = __webpack_require__("e317");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/numberArray.js
var numberArray = __webpack_require__("51de");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/object.js
var object = __webpack_require__("71bd");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/round.js
var round = __webpack_require__("5857");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/string.js
var string = __webpack_require__("90ef");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/transform/index.js + 2 modules
var transform = __webpack_require__("4b79");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/zoom.js
var zoom = __webpack_require__("ce75");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/rgb.js
var rgb = __webpack_require__("e360");

// EXTERNAL MODULE: ./node_modules/d3-color/src/color.js
var src_color = __webpack_require__("166a");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hsl.js



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(src_color["f" /* hsl */])(start)).h, (end = Object(src_color["f" /* hsl */])(end)).h),
        s = Object(color["a" /* default */])(start.s, end.s),
        l = Object(color["a" /* default */])(start.l, end.l),
        opacity = Object(color["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ var src_hsl = (hsl(color["c" /* hue */]));
var hslLong = hsl(color["a" /* default */]);

// EXTERNAL MODULE: ./node_modules/d3-color/src/lab.js
var lab = __webpack_require__("62f0");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/lab.js



function lab_lab(start, end) {
  var l = Object(color["a" /* default */])((start = Object(lab["a" /* default */])(start)).l, (end = Object(lab["a" /* default */])(end)).l),
      a = Object(color["a" /* default */])(start.a, end.a),
      b = Object(color["a" /* default */])(start.b, end.b),
      opacity = Object(color["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hcl.js



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(lab["c" /* hcl */])(start)).h, (end = Object(lab["c" /* hcl */])(end)).h),
        c = Object(color["a" /* default */])(start.c, end.c),
        l = Object(color["a" /* default */])(start.l, end.l),
        opacity = Object(color["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ var src_hcl = (hcl(color["c" /* hue */]));
var hclLong = hcl(color["a" /* default */]);

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/cubehelix.js
var cubehelix = __webpack_require__("3872");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/piecewise.js
var piecewise = __webpack_require__("ac0c");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/quantize.js
/* harmony default export */ var quantize = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/index.js























/***/ }),

/***/ "a454":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("72f0"),
    defineProperty = __webpack_require__("3b4a"),
    identity = __webpack_require__("cd9d");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a524":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "a591":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatLocale; });
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2739");
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6eb2");
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b14c");
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("742c");
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("a15a");
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("77ae");


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcMonday */ "c"].ceil(week) : Object(d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcMonday */ "c"])(week);
          week = d3_time__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? d3_time__WEBPACK_IMPORTED_MODULE_2__[/* monday */ "c"].ceil(week) : Object(d3_time__WEBPACK_IMPORTED_MODULE_2__[/* monday */ "c"])(week);
          week = d3_time__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + d3_time__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(d3_time__WEBPACK_IMPORTED_MODULE_2__[/* sunday */ "g"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? Object(d3_time__WEBPACK_IMPORTED_MODULE_2__[/* thursday */ "i"])(d) : d3_time__WEBPACK_IMPORTED_MODULE_2__[/* thursday */ "i"].ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(d3_time__WEBPACK_IMPORTED_MODULE_2__[/* thursday */ "i"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(d), d) + (Object(d3_time__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(d3_time__WEBPACK_IMPORTED_MODULE_2__[/* monday */ "c"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(d3_time__WEBPACK_IMPORTED_MODULE_2__[/* thursday */ "i"])(d) : d3_time__WEBPACK_IMPORTED_MODULE_2__[/* thursday */ "i"].ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + d3_time__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcSunday */ "g"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? Object(d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcThursday */ "i"])(d) : d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcThursday */ "i"].ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcThursday */ "i"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(d), d) + (Object(d3_time__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcMonday */ "c"].count(Object(d3_time__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcThursday */ "i"])(d) : d3_time__WEBPACK_IMPORTED_MODULE_0__[/* utcThursday */ "i"].ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),

/***/ "a61c":
/***/ (function(module, exports, __webpack_require__) {

const cloneDeep = __webpack_require__("0644")
const defaultConfig = __webpack_require__("0906")

module.exports = cloneDeep(defaultConfig)


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a7fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _formatDecimal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aa74");


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(_formatDecimal_js__WEBPACK_IMPORTED_MODULE_0__[/* formatDecimalParts */ "b"])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),

/***/ "a994":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("7d1f"),
    getSymbols = __webpack_require__("32f4"),
    keys = __webpack_require__("ec69");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aa3a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defaultConfig = _interopRequireDefault(__webpack_require__("a61c"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  dark: 'media',
  variants: {
    backgroundColor: [..._defaultConfig.default.variants.backgroundColor, 'dark'],
    gradientColorStops: [..._defaultConfig.default.variants.gradientColorStops, 'dark'],
    borderColor: [..._defaultConfig.default.variants.borderColor, 'dark'],
    divideColor: [..._defaultConfig.default.variants.divideColor, 'dark'],
    placeholderColor: [..._defaultConfig.default.variants.placeholderColor, 'dark'],
    textColor: [..._defaultConfig.default.variants.textColor, 'dark']
  }
};
exports.default = _default;

/***/ }),

/***/ "aa74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDecimalParts; });
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
});

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "abe2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "abe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_drag; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ nodrag["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ nodrag["b" /* yesdrag */]; });

// EXTERNAL MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var src_dispatch = __webpack_require__("c68f");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/select.js
var src_select = __webpack_require__("00a5");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/pointer.js
var pointer = __webpack_require__("5e81");

// EXTERNAL MODULE: ./node_modules/d3-drag/src/nodrag.js
var nodrag = __webpack_require__("b54f");

// EXTERNAL MODULE: ./node_modules/d3-drag/src/noevent.js
var noevent = __webpack_require__("71d2");

// CONCATENATED MODULE: ./node_modules/d3-drag/src/constant.js
/* harmony default export */ var constant = (x => () => x);

// CONCATENATED MODULE: ./node_modules/d3-drag/src/event.js
function DragEvent(type, {
  sourceEvent,
  subject,
  target,
  identifier,
  active,
  x, y, dx, dy,
  dispatch
}) {
  Object.defineProperties(this, {
    type: {value: type, enumerable: true, configurable: true},
    sourceEvent: {value: sourceEvent, enumerable: true, configurable: true},
    subject: {value: subject, enumerable: true, configurable: true},
    target: {value: target, enumerable: true, configurable: true},
    identifier: {value: identifier, enumerable: true, configurable: true},
    active: {value: active, enumerable: true, configurable: true},
    x: {value: x, enumerable: true, configurable: true},
    y: {value: y, enumerable: true, configurable: true},
    dx: {value: dx, enumerable: true, configurable: true},
    dy: {value: dy, enumerable: true, configurable: true},
    _: {value: dispatch}
  });
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// CONCATENATED MODULE: ./node_modules/d3-drag/src/drag.js







// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
  return !event.ctrlKey && !event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(event, d) {
  return d == null ? {x: event.x, y: event.y} : d;
}

function defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

/* harmony default export */ var src_drag = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(src_dispatch["a" /* default */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned(event, d) {
    if (touchending || !filter.call(this, event, d)) return;
    var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
    if (!gesture) return;
    Object(src_select["a" /* default */])(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(nodrag["a" /* default */])(event.view);
    Object(noevent["b" /* nopropagation */])(event);
    mousemoving = false;
    mousedownx = event.clientX;
    mousedowny = event.clientY;
    gesture("start", event);
  }

  function mousemoved(event) {
    Object(noevent["a" /* default */])(event);
    if (!mousemoving) {
      var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag", event);
  }

  function mouseupped(event) {
    Object(src_select["a" /* default */])(event.view).on("mousemove.drag mouseup.drag", null);
    Object(nodrag["b" /* yesdrag */])(event.view, mousemoving);
    Object(noevent["a" /* default */])(event);
    gestures.mouse("end", event);
  }

  function touchstarted(event, d) {
    if (!filter.call(this, event, d)) return;
    var touches = event.changedTouches,
        c = container.call(this, event, d),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
        Object(noevent["b" /* nopropagation */])(event);
        gesture("start", event, touches[i]);
      }
    }
  }

  function touchmoved(event) {
    var touches = event.changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(noevent["a" /* default */])(event);
        gesture("drag", event, touches[i]);
      }
    }
  }

  function touchended(event) {
    var touches = event.changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(noevent["b" /* nopropagation */])(event);
        gesture("end", event, touches[i]);
      }
    }
  }

  function beforestart(that, container, event, d, identifier, touch) {
    var dispatch = listeners.copy(),
        p = Object(pointer["a" /* default */])(touch || event, container), dx, dy,
        s;

    if ((s = subject.call(that, new DragEvent("beforestart", {
        sourceEvent: event,
        target: drag,
        identifier,
        active,
        x: p[0],
        y: p[1],
        dx: 0,
        dy: 0,
        dispatch
      }), d)) == null) return;

    dx = s.x - p[0] || 0;
    dy = s.y - p[1] || 0;

    return function gesture(type, event, touch) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[identifier] = gesture, n = active++; break;
        case "end": delete gestures[identifier], --active; // nobreak
        case "drag": p = Object(pointer["a" /* default */])(touch || event, container), n = active; break;
      }
      dispatch.call(
        type,
        that,
        new DragEvent(type, {
          sourceEvent: event,
          subject: s,
          target: drag,
          identifier,
          active: n,
          x: p[0] + dx,
          y: p[1] + dy,
          dx: p[0] - p0[0],
          dy: p[1] - p0[1],
          dispatch
        }),
        d
      );
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});

// CONCATENATED MODULE: ./node_modules/d3-drag/src/index.js




/***/ }),

/***/ "ac0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return piecewise; });
/* harmony import */ var _value_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea1d");


function piecewise(interpolate, values) {
  if (values === undefined) values = interpolate, interpolate = _value_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"];
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ac41":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "ad19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TinyCardView_vue_vue_type_style_index_0_id_2fe5ad04_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("445e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TinyCardView_vue_vue_type_style_index_0_id_2fe5ad04_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TinyCardView_vue_vue_type_style_index_0_id_2fe5ad04_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TinyCardView_vue_vue_type_style_index_0_id_2fe5ad04_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ad68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _defaultLocale_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1231");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _defaultLocale_js__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _defaultLocale_js__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _defaultLocale_js__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony import */ var _locale_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b170");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _locale_js__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _formatSpecifier_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("09b8");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _formatSpecifier_js__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _formatSpecifier_js__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _precisionFixed_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("dad1");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _precisionFixed_js__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _precisionPrefix_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d933");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _precisionPrefix_js__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _precisionRound_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("d989");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _precisionRound_js__WEBPACK_IMPORTED_MODULE_5__["a"]; });









/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae0d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "afe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerElementContainer_vue_vue_type_style_index_0_id_2b0803a7_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ad6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerElementContainer_vue_vue_type_style_index_0_id_2b0803a7_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerElementContainer_vue_vue_type_style_index_0_id_2b0803a7_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DrawerElementContainer_vue_vue_type_style_index_0_id_2b0803a7_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b047":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "b055":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gamma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nogamma; });
/* harmony import */ var _constant_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c698");


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(_constant_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(_constant_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(_constant_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(isNaN(a) ? b : a);
}


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b108":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ src_transition_transition; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_active; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ interrupt; });

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selection/index.js + 35 modules
var selection = __webpack_require__("e48b");

// EXTERNAL MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var dispatch = __webpack_require__("c68f");

// EXTERNAL MODULE: ./node_modules/d3-timer/src/timer.js
var timer = __webpack_require__("74f4");

// EXTERNAL MODULE: ./node_modules/d3-timer/src/timeout.js
var timeout = __webpack_require__("3e07");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/schedule.js



var emptyOn = Object(dispatch["a" /* default */])("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ var transition_schedule = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(timer["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(timeout["a" /* default */])(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(timeout["a" /* default */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

// CONCATENATED MODULE: ./node_modules/d3-transition/src/interrupt.js


/* harmony default export */ var interrupt = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/interrupt.js


/* harmony default export */ var selection_interrupt = (function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
});

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/transform/index.js + 2 modules
var transform = __webpack_require__("4b79");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/namespace.js
var namespace = __webpack_require__("6cd4");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/tween.js


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ var transition_tween = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get(node, id).value[name];
  };
}

// EXTERNAL MODULE: ./node_modules/d3-color/src/color.js
var color = __webpack_require__("166a");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/number.js
var number = __webpack_require__("e317");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/rgb.js
var rgb = __webpack_require__("e360");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/string.js
var string = __webpack_require__("90ef");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/interpolate.js



/* harmony default export */ var transition_interpolate = (function(a, b) {
  var c;
  return (typeof b === "number" ? number["a" /* default */]
      : b instanceof color["e" /* default */] ? rgb["a" /* default */]
      : (c = Object(color["e" /* default */])(b)) ? (b = c, rgb["a" /* default */])
      : string["a" /* default */])(a, b);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attr.js





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

/* harmony default export */ var attr = (function(name, value) {
  var fullname = Object(namespace["a" /* default */])(name), i = fullname === "transform" ? transform["b" /* interpolateTransformSvg */] : transition_interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attrTween.js


function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_attrTween = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(namespace["a" /* default */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/delay.js


function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

/* harmony default export */ var delay = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get(this.node(), id).delay;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/duration.js


function durationFunction(id, value) {
  return function() {
    set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set(this, id).duration = value;
  };
}

/* harmony default export */ var duration = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get(this.node(), id).duration;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/ease.js


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set(this, id).ease = value;
  };
}

/* harmony default export */ var ease = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get(this.node(), id).ease;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/easeVarying.js


function easeVarying(id, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error;
    set(this, id).ease = v;
  };
}

/* harmony default export */ var transition_easeVarying = (function(value) {
  if (typeof value !== "function") throw new Error;
  return this.each(easeVarying(this._id, value));
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/matcher.js
var matcher = __webpack_require__("0a78");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/filter.js



/* harmony default export */ var filter = (function(match) {
  if (typeof match !== "function") match = Object(matcher["b" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/merge.js


/* harmony default export */ var transition_merge = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/on.js


function on_start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = on_start(name) ? init : set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ var transition_on = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/remove.js
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ var transition_remove = (function() {
  return this.on("end.remove", removeFunction(this._id));
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selector.js
var selector = __webpack_require__("6fd3");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/select.js




/* harmony default export */ var transition_select = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(selector["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        transition_schedule(subgroup[i], name, id, i, subgroup, get(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selectorAll.js
var selectorAll = __webpack_require__("4230");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selectAll.js




/* harmony default export */ var selectAll = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(selectorAll["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            transition_schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selection.js


var Selection = selection["b" /* default */].prototype.constructor;

/* harmony default export */ var transition_selection = (function() {
  return new Selection(this._groups, this._parents);
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selection/style.js
var style = __webpack_require__("364b");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/style.js






function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = Object(style["b" /* styleValue */])(this, name),
        string1 = (this.style.removeProperty(name), Object(style["b" /* styleValue */])(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = Object(style["b" /* styleValue */])(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = Object(style["b" /* styleValue */])(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), Object(style["b" /* styleValue */])(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

/* harmony default export */ var transition_style = (function(name, value, priority) {
  var i = (name += "") === "transform" ? transform["a" /* interpolateTransformCss */] : transition_interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/styleTween.js
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_styleTween = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/text.js


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ var transition_text = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(tweenValue(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/textTween.js
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_textTween = (function(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/transition.js



/* harmony default export */ var transition_transition = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get(node, id0);
        transition_schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/end.js


/* harmony default export */ var transition_end = (function() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });

    // The selection was empty, resolve end immediately
    if (size === 0) resolve();
  });
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/index.js






















var transition_id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function src_transition_transition(name) {
  return Object(selection["b" /* default */])().transition(name);
}

function newId() {
  return ++transition_id;
}

var selection_prototype = selection["b" /* default */].prototype;

Transition.prototype = src_transition_transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: selectAll,
  filter: filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: delay,
  duration: duration,
  ease: ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

// EXTERNAL MODULE: ./node_modules/d3-ease/src/cubic.js
var cubic = __webpack_require__("8921");

// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/transition.js





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubic["b" /* cubicInOut */]
};

function transition_inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id} not found`);
    }
  }
  return timing;
}

/* harmony default export */ var selection_transition = (function(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = Object(timer["b" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        transition_schedule(node, name, id, i, group, timing || transition_inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/index.js




selection["b" /* default */].prototype.interrupt = selection_interrupt;
selection["b" /* default */].prototype.transition = selection_transition;

// CONCATENATED MODULE: ./node_modules/d3-transition/src/active.js



var root = [null];

/* harmony default export */ var src_active = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root, name, +i);
      }
    }
  }

  return null;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/index.js






/***/ }),

/***/ "b14c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return monday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return tuesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return wednesday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return thursday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return friday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saturday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sundays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mondays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tuesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return wednesdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return thursdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fridays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return saturdays; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



function weekday(i) {
  return Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"]) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationWeek */ "e"];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),

/***/ "b170":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/d3-format/src/exponent.js
var src_exponent = __webpack_require__("a7fd");

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatGroup.js
/* harmony default export */ var formatGroup = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatNumerals.js
/* harmony default export */ var formatNumerals = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});

// EXTERNAL MODULE: ./node_modules/d3-format/src/formatSpecifier.js
var formatSpecifier = __webpack_require__("09b8");

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatTrim.js
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ var formatTrim = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});

// EXTERNAL MODULE: ./node_modules/d3-format/src/formatDecimal.js
var formatDecimal = __webpack_require__("aa74");

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatPrefixAuto.js


var prefixExponent;

/* harmony default export */ var formatPrefixAuto = (function(x, p) {
  var d = Object(formatDecimal["b" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(formatDecimal["b" /* formatDecimalParts */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatRounded.js


/* harmony default export */ var formatRounded = (function(x, p) {
  var d = Object(formatDecimal["b" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatTypes.js




/* harmony default export */ var formatTypes = ({
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal["a" /* default */],
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/identity.js
/* harmony default export */ var identity = (function(x) {
  return x;
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/locale.js









var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ var src_locale = __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = Object(formatSpecifier["b" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(formatSpecifier["b" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(src_exponent["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),

/***/ "b1e5":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("a994");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "b1fa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  theme: {
    extend: {
      fontSize: {
        '7xl': ['5rem', {
          lineHeight: '1'
        }],
        '8xl': ['6rem', {
          lineHeight: '1'
        }],
        '9xl': ['8rem', {
          lineHeight: '1'
        }]
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "b218":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "b2e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ blob; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ buffer; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ dsv_dsv; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ dsv_csv; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ dsv_tsv; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ src_image; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ json; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ src_text; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ xml; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ html; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ svg; });

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/blob.js
function responseBlob(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.blob();
}

/* harmony default export */ var blob = (function(input, init) {
  return fetch(input, init).then(responseBlob);
});

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/buffer.js
function responseArrayBuffer(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.arrayBuffer();
}

/* harmony default export */ var buffer = (function(input, init) {
  return fetch(input, init).then(responseArrayBuffer);
});

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/dsv.js
var dsv = __webpack_require__("3512");

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/csv.js
var csv = __webpack_require__("5626");

// EXTERNAL MODULE: ./node_modules/d3-dsv/src/tsv.js
var tsv = __webpack_require__("c165");

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/text.js
function responseText(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.text();
}

/* harmony default export */ var src_text = (function(input, init) {
  return fetch(input, init).then(responseText);
});

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/dsv.js



function dsvParse(parse) {
  return function(input, init, row) {
    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
    return src_text(input, init).then(function(response) {
      return parse(response, row);
    });
  };
}

function dsv_dsv(delimiter, input, init, row) {
  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
  var format = Object(dsv["a" /* default */])(delimiter);
  return src_text(input, init).then(function(response) {
    return format.parse(response, row);
  });
}

var dsv_csv = dsvParse(csv["f" /* csvParse */]);
var dsv_tsv = dsvParse(tsv["f" /* tsvParse */]);

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/image.js
/* harmony default export */ var src_image = (function(input, init) {
  return new Promise(function(resolve, reject) {
    var image = new Image;
    for (var key in init) image[key] = init[key];
    image.onerror = reject;
    image.onload = function() { resolve(image); };
    image.src = input;
  });
});

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/json.js
function responseJson(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  if (response.status === 204 || response.status === 205) return;
  return response.json();
}

/* harmony default export */ var json = (function(input, init) {
  return fetch(input, init).then(responseJson);
});

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/xml.js


function parser(type) {
  return (input, init) => src_text(input, init)
    .then(text => (new DOMParser).parseFromString(text, type));
}

/* harmony default export */ var xml = (parser("application/xml"));

var html = parser("text/html");

var svg = parser("image/svg+xml");

// CONCATENATED MODULE: ./node_modules/d3-fetch/src/index.js









/***/ }),

/***/ "b3c3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hours; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var hour = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationSecond */ "d"] - date.getMinutes() * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"]);
}, function(date, step) {
  date.setTime(+date + step * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationHour */ "b"]);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationHour */ "b"];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),

/***/ "b4c0":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "b548":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_area; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ centroid; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ hull; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ contains; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ src_length; });

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/area.js
/* harmony default export */ var src_area = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/centroid.js
/* harmony default export */ var centroid = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/cross.js
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
/* harmony default export */ var cross = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/hull.js


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  const n = points.length,
      indexes = [0, 1];
  let size = 2, i;

  for (i = 2; i < n; ++i) {
    while (size > 1 && cross(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

/* harmony default export */ var hull = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/contains.js
/* harmony default export */ var contains = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/length.js
/* harmony default export */ var src_length = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.hypot(xa, ya);
  }

  return perimeter;
});

// CONCATENATED MODULE: ./node_modules/d3-polygon/src/index.js







/***/ }),

/***/ "b54f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return yesdrag; });
/* harmony import */ var d3_selection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00a5");
/* harmony import */ var _noevent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("71d2");



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(d3_selection__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(view).on("dragstart.drag", _noevent_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", _noevent_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(d3_selection__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", _noevent_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var classof = __webpack_require__("c6b6");
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b5a7":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "b5ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ timer["b" /* now */]; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ timer["c" /* timer */]; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ timer["d" /* timerFlush */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ timeout["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ interval; });

// EXTERNAL MODULE: ./node_modules/d3-timer/src/timer.js
var timer = __webpack_require__("74f4");

// EXTERNAL MODULE: ./node_modules/d3-timer/src/timeout.js
var timeout = __webpack_require__("3e07");

// CONCATENATED MODULE: ./node_modules/d3-timer/src/interval.js


/* harmony default export */ var interval = (function(callback, delay, time) {
  var t = new timer["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  t._restart = t.restart;
  t.restart = function(callback, delay, time) {
    delay = +delay, time = time == null ? Object(timer["b" /* now */])() : +time;
    t._restart(function tick(elapsed) {
      elapsed += total;
      t._restart(tick, total += delay, time);
      callback(elapsed);
    }, delay, time);
  }
  t.restart(callback, delay, time);
  return t;
});

// CONCATENATED MODULE: ./node_modules/d3-timer/src/index.js







/***/ }),

/***/ "b607":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _interval_js__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _millisecond_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1809");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _millisecond_js__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _millisecond_js__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _millisecond_js__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _millisecond_js__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony import */ var _second_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5edf");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _second_js__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _second_js__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "V", function() { return _second_js__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "W", function() { return _second_js__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony import */ var _minute_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2c38");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _minute_js__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _minute_js__WEBPACK_IMPORTED_MODULE_3__["b"]; });

/* harmony import */ var _hour_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b3c3");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _hour_js__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _hour_js__WEBPACK_IMPORTED_MODULE_4__["b"]; });

/* harmony import */ var _day_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("742c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _day_js__WEBPACK_IMPORTED_MODULE_5__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _day_js__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _week_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b14c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["n"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _week_js__WEBPACK_IMPORTED_MODULE_6__["f"]; });

/* harmony import */ var _month_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9603");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _month_js__WEBPACK_IMPORTED_MODULE_7__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _month_js__WEBPACK_IMPORTED_MODULE_7__["b"]; });

/* harmony import */ var _year_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("a15a");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _year_js__WEBPACK_IMPORTED_MODULE_8__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _year_js__WEBPACK_IMPORTED_MODULE_8__["b"]; });

/* harmony import */ var _utcMinute_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("f8ee");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _utcMinute_js__WEBPACK_IMPORTED_MODULE_9__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _utcMinute_js__WEBPACK_IMPORTED_MODULE_9__["b"]; });

/* harmony import */ var _utcHour_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("f623");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _utcHour_js__WEBPACK_IMPORTED_MODULE_10__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _utcHour_js__WEBPACK_IMPORTED_MODULE_10__["b"]; });

/* harmony import */ var _utcDay_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("6eb2");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _utcDay_js__WEBPACK_IMPORTED_MODULE_11__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _utcDay_js__WEBPACK_IMPORTED_MODULE_11__["b"]; });

/* harmony import */ var _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2739");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "X", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "db", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["n"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "U", function() { return _utcWeek_js__WEBPACK_IMPORTED_MODULE_12__["f"]; });

/* harmony import */ var _utcMonth_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("55f8");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "R", function() { return _utcMonth_js__WEBPACK_IMPORTED_MODULE_13__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "S", function() { return _utcMonth_js__WEBPACK_IMPORTED_MODULE_13__["b"]; });

/* harmony import */ var _utcYear_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("77ae");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return _utcYear_js__WEBPACK_IMPORTED_MODULE_14__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return _utcYear_js__WEBPACK_IMPORTED_MODULE_14__["b"]; });
































/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b662":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LegendView_vue_vue_type_style_index_0_id_2f315d6d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4c7e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LegendView_vue_vue_type_style_index_0_id_2f315d6d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LegendView_vue_vue_type_style_index_0_id_2f315d6d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LegendView_vue_vue_type_style_index_0_id_2f315d6d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "b749":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const ansiStyles = __webpack_require__("c047");
const {stdout: stdoutColor, stderr: stderrColor} = __webpack_require__("694c");
const {
	stringReplaceAll,
	stringEncaseCRLFWithFirstIndex
} = __webpack_require__("1416");

const {isArray} = Array;

// `supportsColor.level` → `ansiStyles.color[name]` mapping
const levelMapping = [
	'ansi',
	'ansi',
	'ansi256',
	'ansi16m'
];

const styles = Object.create(null);

const applyOptions = (object, options = {}) => {
	if (options.level && !(Number.isInteger(options.level) && options.level >= 0 && options.level <= 3)) {
		throw new Error('The `level` option should be an integer from 0 to 3');
	}

	// Detect level if not set manually
	const colorLevel = stdoutColor ? stdoutColor.level : 0;
	object.level = options.level === undefined ? colorLevel : options.level;
};

class ChalkClass {
	constructor(options) {
		// eslint-disable-next-line no-constructor-return
		return chalkFactory(options);
	}
}

const chalkFactory = options => {
	const chalk = {};
	applyOptions(chalk, options);

	chalk.template = (...arguments_) => chalkTag(chalk.template, ...arguments_);

	Object.setPrototypeOf(chalk, Chalk.prototype);
	Object.setPrototypeOf(chalk.template, chalk);

	chalk.template.constructor = () => {
		throw new Error('`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.');
	};

	chalk.template.Instance = ChalkClass;

	return chalk.template;
};

function Chalk(options) {
	return chalkFactory(options);
}

for (const [styleName, style] of Object.entries(ansiStyles)) {
	styles[styleName] = {
		get() {
			const builder = createBuilder(this, createStyler(style.open, style.close, this._styler), this._isEmpty);
			Object.defineProperty(this, styleName, {value: builder});
			return builder;
		}
	};
}

styles.visible = {
	get() {
		const builder = createBuilder(this, this._styler, true);
		Object.defineProperty(this, 'visible', {value: builder});
		return builder;
	}
};

const usedModels = ['rgb', 'hex', 'keyword', 'hsl', 'hsv', 'hwb', 'ansi', 'ansi256'];

for (const model of usedModels) {
	styles[model] = {
		get() {
			const {level} = this;
			return function (...arguments_) {
				const styler = createStyler(ansiStyles.color[levelMapping[level]][model](...arguments_), ansiStyles.color.close, this._styler);
				return createBuilder(this, styler, this._isEmpty);
			};
		}
	};
}

for (const model of usedModels) {
	const bgModel = 'bg' + model[0].toUpperCase() + model.slice(1);
	styles[bgModel] = {
		get() {
			const {level} = this;
			return function (...arguments_) {
				const styler = createStyler(ansiStyles.bgColor[levelMapping[level]][model](...arguments_), ansiStyles.bgColor.close, this._styler);
				return createBuilder(this, styler, this._isEmpty);
			};
		}
	};
}

const proto = Object.defineProperties(() => {}, {
	...styles,
	level: {
		enumerable: true,
		get() {
			return this._generator.level;
		},
		set(level) {
			this._generator.level = level;
		}
	}
});

const createStyler = (open, close, parent) => {
	let openAll;
	let closeAll;
	if (parent === undefined) {
		openAll = open;
		closeAll = close;
	} else {
		openAll = parent.openAll + open;
		closeAll = close + parent.closeAll;
	}

	return {
		open,
		close,
		openAll,
		closeAll,
		parent
	};
};

const createBuilder = (self, _styler, _isEmpty) => {
	const builder = (...arguments_) => {
		if (isArray(arguments_[0]) && isArray(arguments_[0].raw)) {
			// Called as a template literal, for example: chalk.red`2 + 3 = {bold ${2+3}}`
			return applyStyle(builder, chalkTag(builder, ...arguments_));
		}

		// Single argument is hot path, implicit coercion is faster than anything
		// eslint-disable-next-line no-implicit-coercion
		return applyStyle(builder, (arguments_.length === 1) ? ('' + arguments_[0]) : arguments_.join(' '));
	};

	// We alter the prototype because we must return a function, but there is
	// no way to create a function with a different prototype
	Object.setPrototypeOf(builder, proto);

	builder._generator = self;
	builder._styler = _styler;
	builder._isEmpty = _isEmpty;

	return builder;
};

const applyStyle = (self, string) => {
	if (self.level <= 0 || !string) {
		return self._isEmpty ? '' : string;
	}

	let styler = self._styler;

	if (styler === undefined) {
		return string;
	}

	const {openAll, closeAll} = styler;
	if (string.indexOf('\u001B') !== -1) {
		while (styler !== undefined) {
			// Replace any instances already present with a re-opening code
			// otherwise only the part of the string until said closing code
			// will be colored, and the rest will simply be 'plain'.
			string = stringReplaceAll(string, styler.close, styler.open);

			styler = styler.parent;
		}
	}

	// We can move both next actions out of loop, because remaining actions in loop won't have
	// any/visible effect on parts we add here. Close the styling before a linebreak and reopen
	// after next line to fix a bleed issue on macOS: https://github.com/chalk/chalk/pull/92
	const lfIndex = string.indexOf('\n');
	if (lfIndex !== -1) {
		string = stringEncaseCRLFWithFirstIndex(string, closeAll, openAll, lfIndex);
	}

	return openAll + string + closeAll;
};

let template;
const chalkTag = (chalk, ...strings) => {
	const [firstString] = strings;

	if (!isArray(firstString) || !isArray(firstString.raw)) {
		// If chalk() was called by itself or with a string,
		// return the string itself as a string.
		return strings.join(' ');
	}

	const arguments_ = strings.slice(1);
	const parts = [firstString.raw[0]];

	for (let i = 1; i < firstString.length; i++) {
		parts.push(
			String(arguments_[i - 1]).replace(/[{}\\]/g, '\\$&'),
			String(firstString.raw[i])
		);
	}

	if (template === undefined) {
		template = __webpack_require__("d8af");
	}

	return template(chalk, parts.join(''));
};

Object.defineProperties(Chalk.prototype, styles);

const chalk = Chalk(); // eslint-disable-line new-cap
chalk.supportsColor = stdoutColor;
chalk.stderr = Chalk({level: stderrColor ? stderrColor.level : 0}); // eslint-disable-line new-cap
chalk.stderr.supportsColor = stderrColor;

module.exports = chalk;


/***/ }),

/***/ "b760":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("872a"),
    eq = __webpack_require__("9638");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "b8df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfoTooltip_vue_vue_type_style_index_0_id_642b5c0d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2702");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfoTooltip_vue_vue_type_style_index_0_id_642b5c0d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfoTooltip_vue_vue_type_style_index_0_id_642b5c0d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InfoTooltip_vue_vue_type_style_index_0_id_642b5c0d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b969":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  theme: {
    fontSize: {
      xs: ['0.75rem', {
        lineHeight: '1rem'
      }],
      sm: ['0.875rem', {
        lineHeight: '1.25rem'
      }],
      base: ['1rem', {
        lineHeight: '1.5rem'
      }],
      lg: ['1.125rem', {
        lineHeight: '1.75rem'
      }],
      xl: ['1.25rem', {
        lineHeight: '1.75rem'
      }],
      '2xl': ['1.5rem', {
        lineHeight: '2rem'
      }],
      '3xl': ['1.875rem', {
        lineHeight: '2.25rem'
      }],
      '4xl': ['2.25rem', {
        lineHeight: '2.5rem'
      }],
      '5xl': ['3rem', {
        lineHeight: '1'
      }],
      '6xl': ['4rem', {
        lineHeight: '1'
      }]
    }
  }
};
exports.default = _default;

/***/ }),

/***/ "ba27":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "badf":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("642a"),
    baseMatchesProperty = __webpack_require__("1838"),
    identity = __webpack_require__("cd9d"),
    isArray = __webpack_require__("6747"),
    property = __webpack_require__("f9ce");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "bb99":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='5' height='10' viewBox='0 0 5 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.84004 5.43401L0.946639 9.82041C0.720131 10.0599 0.373242 10.0599 0.159961 9.82041C-0.0533207 9.58095 -0.0533207 9.17664 0.159961 8.93719L3.66679 5L0.159961 1.06281C-0.0533204 0.808506 -0.0533204 0.419047 0.159961 0.179592C0.373243 -0.0598638 0.72014 -0.0598638 0.94664 0.179592L4.84004 4.55079C5.05332 4.8051 5.05332 5.19455 4.84004 5.43401Z' fill='%23969696'/%3E %3C/svg%3E"

/***/ }),

/***/ "bbc0":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "bc17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ bisect["d" /* default */]; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ bisect["c" /* bisectRight */]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ bisect["b" /* bisectLeft */]; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ bisect["a" /* bisectCenter */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ ascending["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ bisector["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ count["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ cross; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ cumsum; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ descending; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ deviation; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ extent["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ fsum["b" /* default */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ fsum["a" /* Adder */]; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ group; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ groups; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ group_index; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ indexes; });
__webpack_require__.d(__webpack_exports__, "L", function() { return /* reexport */ rollup; });
__webpack_require__.d(__webpack_exports__, "M", function() { return /* reexport */ rollups; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ src_bin; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ src_bin; });
__webpack_require__.d(__webpack_exports__, "R", function() { return /* reexport */ freedmanDiaconis; });
__webpack_require__.d(__webpack_exports__, "S", function() { return /* reexport */ scott; });
__webpack_require__.d(__webpack_exports__, "T", function() { return /* reexport */ sturges["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ src_max["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ maxIndex; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ mean; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* reexport */ median; });
__webpack_require__.d(__webpack_exports__, "C", function() { return /* reexport */ merge["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "D", function() { return /* reexport */ src_min["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "E", function() { return /* reexport */ minIndex; });
__webpack_require__.d(__webpack_exports__, "F", function() { return /* reexport */ pairs; });
__webpack_require__.d(__webpack_exports__, "G", function() { return /* reexport */ permute; });
__webpack_require__.d(__webpack_exports__, "H", function() { return /* reexport */ quantile["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "I", function() { return /* reexport */ quantile["b" /* quantileSorted */]; });
__webpack_require__.d(__webpack_exports__, "J", function() { return /* reexport */ quickselect["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "K", function() { return /* reexport */ range["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ least; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ leastIndex; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ greatest; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ greatestIndex; });
__webpack_require__.d(__webpack_exports__, "N", function() { return /* reexport */ scan; });
__webpack_require__.d(__webpack_exports__, "O", function() { return /* reexport */ shuffle; });
__webpack_require__.d(__webpack_exports__, "P", function() { return /* reexport */ shuffler; });
__webpack_require__.d(__webpack_exports__, "Q", function() { return /* reexport */ sum; });
__webpack_require__.d(__webpack_exports__, "W", function() { return /* reexport */ ticks["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "U", function() { return /* reexport */ ticks["b" /* tickIncrement */]; });
__webpack_require__.d(__webpack_exports__, "V", function() { return /* reexport */ ticks["c" /* tickStep */]; });
__webpack_require__.d(__webpack_exports__, "X", function() { return /* reexport */ src_transpose; });
__webpack_require__.d(__webpack_exports__, "Y", function() { return /* reexport */ variance; });
__webpack_require__.d(__webpack_exports__, "Z", function() { return /* reexport */ zip; });

// EXTERNAL MODULE: ./node_modules/d3-array/src/bisect.js
var bisect = __webpack_require__("87c9");

// EXTERNAL MODULE: ./node_modules/d3-array/src/ascending.js
var ascending = __webpack_require__("00fb");

// EXTERNAL MODULE: ./node_modules/d3-array/src/bisector.js
var bisector = __webpack_require__("2a2d");

// EXTERNAL MODULE: ./node_modules/d3-array/src/count.js
var count = __webpack_require__("8627");

// CONCATENATED MODULE: ./node_modules/d3-array/src/cross.js
function cross_length(array) {
  return array.length | 0;
}

function empty(length) {
  return !(length > 0);
}

function arrayify(values) {
  return typeof values !== "object" || "length" in values ? values : Array.from(values);
}

function reducer(reduce) {
  return values => reduce(...values);
}

function cross(...values) {
  const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
  values = values.map(arrayify);
  const lengths = values.map(cross_length);
  const j = values.length - 1;
  const index = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty)) return product;
  while (true) {
    product.push(index.map((j, i) => values[i][j]));
    let i = j;
    while (++index[i] === lengths[i]) {
      if (i === 0) return reduce ? product.map(reduce) : product;
      index[i--] = 0;
    }
  }
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/cumsum.js
function cumsum(values, valueof) {
  var sum = 0, index = 0;
  return Float64Array.from(values, valueof === undefined
    ? v => (sum += +v || 0)
    : v => (sum += +valueof(v, index++, values) || 0));
}
// CONCATENATED MODULE: ./node_modules/d3-array/src/descending.js
/* harmony default export */ var descending = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/variance.js
function variance(values, valueof) {
  let count = 0;
  let delta;
  let mean = 0;
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  }
  if (count > 1) return sum / (count - 1);
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/deviation.js


function deviation(values, valueof) {
  const v = variance(values, valueof);
  return v ? Math.sqrt(v) : v;
}

// EXTERNAL MODULE: ./node_modules/d3-array/src/extent.js
var extent = __webpack_require__("c33f");

// EXTERNAL MODULE: ./node_modules/d3-array/src/fsum.js
var fsum = __webpack_require__("c4e3");

// CONCATENATED MODULE: ./node_modules/d3-array/src/identity.js
/* harmony default export */ var identity = (function(x) {
  return x;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/group.js


function group(values, ...keys) {
  return nest(values, identity, identity, keys);
}

function groups(values, ...keys) {
  return nest(values, Array.from, identity, keys);
}

function rollup(values, reduce, ...keys) {
  return nest(values, identity, reduce, keys);
}

function rollups(values, reduce, ...keys) {
  return nest(values, Array.from, reduce, keys);
}

function group_index(values, ...keys) {
  return nest(values, identity, unique, keys);
}

function indexes(values, ...keys) {
  return nest(values, Array.from, unique, keys);
}

function unique(values) {
  if (values.length !== 1) throw new Error("duplicate key");
  return values[0];
}

function nest(values, map, reduce, keys) {
  return (function regroup(values, i) {
    if (i >= keys.length) return reduce(values);
    const groups = new Map();
    const keyof = keys[i++];
    let index = -1;
    for (const value of values) {
      const key = keyof(value, ++index, values);
      const group = groups.get(key);
      if (group) group.push(value);
      else groups.set(key, [value]);
    }
    for (const [key, values] of groups) {
      groups.set(key, regroup(values, i));
    }
    return map(groups);
  })(values, 0);
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/array.js
var array = Array.prototype;

var slice = array.slice;
var map = array.map;

// CONCATENATED MODULE: ./node_modules/d3-array/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/ticks.js
var ticks = __webpack_require__("eecb");

// EXTERNAL MODULE: ./node_modules/d3-array/src/threshold/sturges.js
var sturges = __webpack_require__("365e");

// CONCATENATED MODULE: ./node_modules/d3-array/src/bin.js








/* harmony default export */ var src_bin = (function() {
  var value = identity,
      domain = extent["a" /* default */],
      threshold = sturges["a" /* default */];

  function histogram(data) {
    if (!Array.isArray(data)) data = Array.from(data);

    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(ticks["a" /* default */])(x0, x1, tz);
      if (tz[tz.length - 1] === x1) tz.pop(); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(bisect["d" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/quantile.js
var quantile = __webpack_require__("1875");

// CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/freedmanDiaconis.js



/* harmony default export */ var freedmanDiaconis = (function(values, min, max) {
  return Math.ceil((max - min) / (2 * (Object(quantile["a" /* default */])(values, 0.75) - Object(quantile["a" /* default */])(values, 0.25)) * Math.pow(Object(count["a" /* default */])(values), -1 / 3)));
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/scott.js



/* harmony default export */ var scott = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(Object(count["a" /* default */])(values), -1 / 3)));
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/max.js
var src_max = __webpack_require__("823f");

// CONCATENATED MODULE: ./node_modules/d3-array/src/maxIndex.js
function maxIndex(values, valueof) {
  let max;
  let maxIndex = -1;
  let index = -1;
  if (valueof === undefined) {
    for (const value of values) {
      ++index;
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value, maxIndex = index;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value, maxIndex = index;
      }
    }
  }
  return maxIndex;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/mean.js
function mean(values, valueof) {
  let count = 0;
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  }
  if (count) return sum / count;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/median.js


/* harmony default export */ var median = (function(values, valueof) {
  return Object(quantile["a" /* default */])(values, 0.5, valueof);
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/merge.js
var merge = __webpack_require__("1539");

// EXTERNAL MODULE: ./node_modules/d3-array/src/min.js
var src_min = __webpack_require__("9ab5");

// CONCATENATED MODULE: ./node_modules/d3-array/src/minIndex.js
function minIndex(values, valueof) {
  let min;
  let minIndex = -1;
  let index = -1;
  if (valueof === undefined) {
    for (const value of values) {
      ++index;
      if (value != null
          && (min > value || (min === undefined && value >= value))) {
        min = value, minIndex = index;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (min > value || (min === undefined && value >= value))) {
        min = value, minIndex = index;
      }
    }
  }
  return minIndex;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/pairs.js
function pairs(values, pairof = pair) {
  const pairs = [];
  let previous;
  let first = false;
  for (const value of values) {
    if (first) pairs.push(pairof(previous, value));
    previous = value;
    first = true;
  }
  return pairs;
}

function pair(a, b) {
  return [a, b];
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/permute.js
/* harmony default export */ var permute = (function(source, keys) {
  return Array.from(keys, key => source[key]);
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/quickselect.js
var quickselect = __webpack_require__("5878");

// EXTERNAL MODULE: ./node_modules/d3-array/src/range.js
var range = __webpack_require__("365b");

// CONCATENATED MODULE: ./node_modules/d3-array/src/least.js


function least(values, compare = ascending["a" /* default */]) {
  let min;
  let defined = false;
  if (compare.length === 1) {
    let minValue;
    for (const element of values) {
      const value = compare(element);
      if (defined
          ? Object(ascending["a" /* default */])(value, minValue) < 0
          : Object(ascending["a" /* default */])(value, value) === 0) {
        min = element;
        minValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined
          ? compare(value, min) < 0
          : compare(value, value) === 0) {
        min = value;
        defined = true;
      }
    }
  }
  return min;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/leastIndex.js



function leastIndex(values, compare = ascending["a" /* default */]) {
  if (compare.length === 1) return minIndex(values, compare);
  let minValue;
  let min = -1;
  let index = -1;
  for (const value of values) {
    ++index;
    if (min < 0
        ? compare(value, value) === 0
        : compare(value, minValue) < 0) {
      minValue = value;
      min = index;
    }
  }
  return min;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/greatest.js


function greatest(values, compare = ascending["a" /* default */]) {
  let max;
  let defined = false;
  if (compare.length === 1) {
    let maxValue;
    for (const element of values) {
      const value = compare(element);
      if (defined
          ? Object(ascending["a" /* default */])(value, maxValue) > 0
          : Object(ascending["a" /* default */])(value, value) === 0) {
        max = element;
        maxValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined
          ? compare(value, max) > 0
          : compare(value, value) === 0) {
        max = value;
        defined = true;
      }
    }
  }
  return max;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/greatestIndex.js



function greatestIndex(values, compare = ascending["a" /* default */]) {
  if (compare.length === 1) return maxIndex(values, compare);
  let maxValue;
  let max = -1;
  let index = -1;
  for (const value of values) {
    ++index;
    if (max < 0
        ? compare(value, value) === 0
        : compare(value, maxValue) > 0) {
      maxValue = value;
      max = index;
    }
  }
  return max;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/scan.js


function scan(values, compare) {
  const index = leastIndex(values, compare);
  return index < 0 ? undefined : index;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/shuffle.js
/* harmony default export */ var shuffle = (shuffler(Math.random));

function shuffler(random) {
  return function shuffle(array, i0 = 0, i1 = array.length) {
    let m = i1 - (i0 = +i0);
    while (m) {
      const i = random() * m-- | 0, t = array[m + i0];
      array[m + i0] = array[i + i0];
      array[i + i0] = t;
    }
    return array;
  };
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/sum.js
function sum(values, valueof) {
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value = +value) {
        sum += value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index, values)) {
        sum += value;
      }
    }
  }
  return sum;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/transpose.js


/* harmony default export */ var src_transpose = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(src_min["a" /* default */])(matrix, transpose_length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function transpose_length(d) {
  return d.length;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/zip.js


/* harmony default export */ var zip = (function() {
  return src_transpose(arguments);
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/index.js











 // Deprecated; use bin.



















 // Deprecated; use leastIndex.








/***/ }),

/***/ "c047":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

const wrapAnsi16 = (fn, offset) => (...args) => {
	const code = fn(...args);
	return `\u001B[${code + offset}m`;
};

const wrapAnsi256 = (fn, offset) => (...args) => {
	const code = fn(...args);
	return `\u001B[${38 + offset};5;${code}m`;
};

const wrapAnsi16m = (fn, offset) => (...args) => {
	const rgb = fn(...args);
	return `\u001B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
};

const ansi2ansi = n => n;
const rgb2rgb = (r, g, b) => [r, g, b];

const setLazyProperty = (object, property, get) => {
	Object.defineProperty(object, property, {
		get: () => {
			const value = get();

			Object.defineProperty(object, property, {
				value,
				enumerable: true,
				configurable: true
			});

			return value;
		},
		enumerable: true,
		configurable: true
	});
};

/** @type {typeof import('color-convert')} */
let colorConvert;
const makeDynamicStyles = (wrap, targetSpace, identity, isBackground) => {
	if (colorConvert === undefined) {
		colorConvert = __webpack_require__("355f");
	}

	const offset = isBackground ? 10 : 0;
	const styles = {};

	for (const [sourceSpace, suite] of Object.entries(colorConvert)) {
		const name = sourceSpace === 'ansi16' ? 'ansi' : sourceSpace;
		if (sourceSpace === targetSpace) {
			styles[name] = wrap(identity, offset);
		} else if (typeof suite === 'object') {
			styles[name] = wrap(suite[targetSpace], offset);
		}
	}

	return styles;
};

function assembleStyles() {
	const codes = new Map();
	const styles = {
		modifier: {
			reset: [0, 0],
			// 21 isn't widely supported and 22 does the same thing
			bold: [1, 22],
			dim: [2, 22],
			italic: [3, 23],
			underline: [4, 24],
			inverse: [7, 27],
			hidden: [8, 28],
			strikethrough: [9, 29]
		},
		color: {
			black: [30, 39],
			red: [31, 39],
			green: [32, 39],
			yellow: [33, 39],
			blue: [34, 39],
			magenta: [35, 39],
			cyan: [36, 39],
			white: [37, 39],

			// Bright color
			blackBright: [90, 39],
			redBright: [91, 39],
			greenBright: [92, 39],
			yellowBright: [93, 39],
			blueBright: [94, 39],
			magentaBright: [95, 39],
			cyanBright: [96, 39],
			whiteBright: [97, 39]
		},
		bgColor: {
			bgBlack: [40, 49],
			bgRed: [41, 49],
			bgGreen: [42, 49],
			bgYellow: [43, 49],
			bgBlue: [44, 49],
			bgMagenta: [45, 49],
			bgCyan: [46, 49],
			bgWhite: [47, 49],

			// Bright color
			bgBlackBright: [100, 49],
			bgRedBright: [101, 49],
			bgGreenBright: [102, 49],
			bgYellowBright: [103, 49],
			bgBlueBright: [104, 49],
			bgMagentaBright: [105, 49],
			bgCyanBright: [106, 49],
			bgWhiteBright: [107, 49]
		}
	};

	// Alias bright black as gray (and grey)
	styles.color.gray = styles.color.blackBright;
	styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
	styles.color.grey = styles.color.blackBright;
	styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;

	for (const [groupName, group] of Object.entries(styles)) {
		for (const [styleName, style] of Object.entries(group)) {
			styles[styleName] = {
				open: `\u001B[${style[0]}m`,
				close: `\u001B[${style[1]}m`
			};

			group[styleName] = styles[styleName];

			codes.set(style[0], style[1]);
		}

		Object.defineProperty(styles, groupName, {
			value: group,
			enumerable: false
		});
	}

	Object.defineProperty(styles, 'codes', {
		value: codes,
		enumerable: false
	});

	styles.color.close = '\u001B[39m';
	styles.bgColor.close = '\u001B[49m';

	setLazyProperty(styles.color, 'ansi', () => makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, false));
	setLazyProperty(styles.color, 'ansi256', () => makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, false));
	setLazyProperty(styles.color, 'ansi16m', () => makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, false));
	setLazyProperty(styles.bgColor, 'ansi', () => makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, true));
	setLazyProperty(styles.bgColor, 'ansi256', () => makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, true));
	setLazyProperty(styles.bgColor, 'ansi16m', () => makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, true));

	return styles;
}

// Make the export immutable
Object.defineProperty(module, 'exports', {
	enumerable: true,
	get: assembleStyles
});

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c05f":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("7b97"),
    isObjectLike = __webpack_require__("1310");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "c098":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "c165":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tsvParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tsvParseRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tsvFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tsvFormatBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tsvFormatRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tsvFormatRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tsvFormatValue; });
/* harmony import */ var _dsv_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3512");


var tsv = Object(_dsv_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatBody = tsv.formatBody;
var tsvFormatRows = tsv.formatRows;
var tsvFormatRow = tsv.formatRow;
var tsvFormatValue = tsv.formatValue;


/***/ }),

/***/ "c1c9":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("a454"),
    shortOut = __webpack_require__("f3c1");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "c20d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var trim = __webpack_require__("58a8").trim;
var whitespaces = __webpack_require__("5899");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "c226":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
});


/***/ }),

/***/ "c2b6":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af"),
    cloneDataView = __webpack_require__("5d89"),
    cloneRegExp = __webpack_require__("6f6c"),
    cloneSymbol = __webpack_require__("a2db"),
    cloneTypedArray = __webpack_require__("c8fe");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "c33f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  let min;
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  }
  return [min, max];
});


/***/ }),

/***/ "c3fc":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("42a2"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c4e3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Adder; });
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
  constructor() {
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  add(x) {
    const p = this._partials;
    let i = 0;
    for (let j = 0; j < this._n && j < 32; j++) {
      const y = p[j],
        hi = x + y,
        lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
      if (lo) p[i++] = lo;
      x = hi;
    }
    p[i] = x;
    this._n = i + 1;
    return this;
  }
  valueOf() {
    const p = this._partials;
    let n = this._n, x, y, lo, hi = 0;
    if (n > 0) {
      hi = p[--n];
      while (n > 0) {
        x = hi;
        y = p[--n];
        hi = x + y;
        lo = y - (hi - x);
        if (lo) break;
      }
      if (n > 0 && ((lo < 0 && p[n - 1] < 0) || (lo > 0 && p[n - 1] > 0))) {
        y = lo * 2;
        x = hi + y;
        if (y == x - hi) hi = x;
      }
    }
    return hi;
  }
}

/* harmony default export */ __webpack_exports__["b"] = (function(values, valueof) {
  const adder = new Adder();
  if (valueof === undefined) {
    for (let value of values) {
      if (value = +value) {
        adder.add(value);
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index, values)) {
        adder.add(value);
      }
    }
  }
  return +adder;
});


/***/ }),

/***/ "c584":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "c68f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: () => {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),

/***/ "c698":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (x => () => x);


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c84a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return basis; });
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),

/***/ "c869":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "c87c":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8fe":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "c947":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ cluster; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ hierarchy; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ src_pack; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ siblings; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ enclose; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ src_partition; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ src_stratify; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ tree; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ src_treemap; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ binary; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ dice; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ slice; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ sliceDice; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ squarify; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ treemap_resquarify; });

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/cluster.js
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* harmony default export */ var cluster = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/count.js
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ var hierarchy_count = (function() {
  return this.eachAfter(count);
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/each.js
/* harmony default export */ var each = (function(callback, that) {
  let index = -1;
  for (const node of this) {
    callback.call(that, node, ++index, this);
  }
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/eachBefore.js
/* harmony default export */ var eachBefore = (function(callback, that) {
  var node = this, nodes = [node], children, i, index = -1;
  while (node = nodes.pop()) {
    callback.call(that, node, ++index, this);
    if (children = node.children) {
      for (i = children.length - 1; i >= 0; --i) {
        nodes.push(children[i]);
      }
    }
  }
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/eachAfter.js
/* harmony default export */ var eachAfter = (function(callback, that) {
  var node = this, nodes = [node], next = [], children, i, n, index = -1;
  while (node = nodes.pop()) {
    next.push(node);
    if (children = node.children) {
      for (i = 0, n = children.length; i < n; ++i) {
        nodes.push(children[i]);
      }
    }
  }
  while (node = next.pop()) {
    callback.call(that, node, ++index, this);
  }
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/find.js
/* harmony default export */ var find = (function(callback, that) {
  let index = -1;
  for (const node of this) {
    if (callback.call(that, node, ++index, this)) {
      return node;
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/sum.js
/* harmony default export */ var sum = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/sort.js
/* harmony default export */ var sort = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/path.js
/* harmony default export */ var path = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/ancestors.js
/* harmony default export */ var ancestors = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/descendants.js
/* harmony default export */ var descendants = (function() {
  return Array.from(this);
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/leaves.js
/* harmony default export */ var leaves = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/links.js
/* harmony default export */ var links = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/iterator.js
/* harmony default export */ var iterator = (function*() {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      yield node;
      if (children = node.children) {
        for (i = 0, n = children.length; i < n; ++i) {
          next.push(children[i]);
        }
      }
    }
  } while (next.length);
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/index.js














function hierarchy(data, children) {
  if (data instanceof Map) {
    data = [undefined, data];
    if (children === undefined) children = mapChildren;
  } else if (children === undefined) {
    children = objectChildren;
  }

  var root = new Node(data),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  while (node = nodes.pop()) {
    if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
      node.children = childs;
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function objectChildren(d) {
  return d.children;
}

function mapChildren(d) {
  return Array.isArray(d) ? d[1] : null;
}

function copyData(node) {
  if (node.data.value !== undefined) node.value = node.data.value;
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: hierarchy_count,
  each: each,
  eachAfter: eachAfter,
  eachBefore: eachBefore,
  find: find,
  sum: sum,
  sort: sort,
  path: path,
  ancestors: ancestors,
  descendants: descendants,
  leaves: leaves,
  links: links,
  copy: node_copy,
  [Symbol.iterator]: iterator
};

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/array.js
/* harmony default export */ var array = (function(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
});

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/pack/enclose.js


/* harmony default export */ var enclose = (function(circles) {
  var i = 0, n = (circles = shuffle(Array.from(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/pack/siblings.js



function place(b, a, c) {
  var dx = b.x - a.x, x, a2,
      dy = b.y - a.y, y, b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function siblings_Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = (circles = array(circles)).length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new siblings_Node(a), b = new siblings_Node(b), c = new siblings_Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new siblings_Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* harmony default export */ var siblings = (function(circles) {
  packEnclose(circles);
  return circles;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/accessors.js
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/constant.js
function constantZero() {
  return 0;
}

/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/pack/index.js




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ var src_pack = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/round.js
/* harmony default export */ var treemap_round = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/dice.js
/* harmony default export */ var dice = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/partition.js



/* harmony default export */ var src_partition = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(treemap_round);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        dice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/stratify.js



var preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ var src_stratify = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var nodes = Array.from(data),
        n = nodes.length,
        d,
        i,
        root,
        parent,
        node,
        nodeId,
        nodeKey,
        nodeByKey = new Map;

    for (i = 0; i < n; ++i) {
      d = nodes[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = node.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
      }
      if ((nodeId = parentId(d, i, data)) != null && (nodeId += "")) {
        node.parent = nodeId;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (nodeId = node.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      } else {
        if (root) throw new Error("multiple roots");
        root = node;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/tree.js


function tree_defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ var tree = (function() {
  var separation = tree_defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/slice.js
/* harmony default export */ var slice = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/squarify.js



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) dice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else slice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ var squarify = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/index.js





/* harmony default export */ var src_treemap = (function() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(treemap_round);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
  };

  return treemap;
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/binary.js
/* harmony default export */ var binary = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/sliceDice.js



/* harmony default export */ var sliceDice = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? slice : dice)(parent, x0, y0, x1, y1);
});

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/resquarify.js




/* harmony default export */ var treemap_resquarify = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) dice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
        else slice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(phi));

// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/index.js

















/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cb5a":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("9638");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc45":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__("1a2d"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "cc69":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ccc7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ src_contours; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_density; });

// EXTERNAL MODULE: ./node_modules/d3-array/src/threshold/sturges.js
var sturges = __webpack_require__("365e");

// EXTERNAL MODULE: ./node_modules/d3-array/src/extent.js
var extent = __webpack_require__("c33f");

// EXTERNAL MODULE: ./node_modules/d3-array/src/ticks.js
var ticks = __webpack_require__("eecb");

// EXTERNAL MODULE: ./node_modules/d3-array/src/range.js
var range = __webpack_require__("365b");

// CONCATENATED MODULE: ./node_modules/d3-contour/src/array.js
var array = Array.prototype;

var slice = array.slice;

// CONCATENATED MODULE: ./node_modules/d3-contour/src/ascending.js
/* harmony default export */ var ascending = (function(a, b) {
  return a - b;
});

// CONCATENATED MODULE: ./node_modules/d3-contour/src/area.js
/* harmony default export */ var src_area = (function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
});

// CONCATENATED MODULE: ./node_modules/d3-contour/src/constant.js
/* harmony default export */ var constant = (x => () => x);

// CONCATENATED MODULE: ./node_modules/d3-contour/src/contains.js
/* harmony default export */ var contains = (function(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
});

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}

// CONCATENATED MODULE: ./node_modules/d3-contour/src/noop.js
/* harmony default export */ var noop = (function() {});

// CONCATENATED MODULE: ./node_modules/d3-contour/src/contours.js








var cases = [
  [],
  [[[1.0, 1.5], [0.5, 1.0]]],
  [[[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [0.5, 1.0]]],
  [[[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 0.5], [1.0, 1.5]]],
  [[[1.0, 0.5], [0.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 0.5]]],
  [[[1.0, 1.5], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.5, 1.0]]],
  [[[1.0, 1.5], [1.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 1.5]]],
  []
];

/* harmony default export */ var src_contours = (function() {
  var dx = 1,
      dy = 1,
      threshold = sturges["a" /* default */],
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = Object(extent["a" /* default */])(values), start = domain[0], stop = domain[1];
      tz = Object(ticks["c" /* tickStep */])(start, stop, tz);
      tz = Object(range["a" /* default */])(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(ascending);
    }

    return tz.map(function(value) {
      return contour(values, value);
    });
  }

  // Accumulate, smooth contour rings, assign holes to exterior rings.
  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
  function contour(values, value) {
    var polygons = [],
        holes = [];

    isorings(values, value, function(ring) {
      smooth(ring, values, value);
      if (src_area(ring) > 0) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (contains((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });

    return {
      type: "MultiPolygon",
      value: value,
      coordinates: polygons
    };
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.contour = contour;

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
    if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : noop, contours) : smooth === smoothLinear;
  };

  return contours;
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/max.js
var max = __webpack_require__("823f");

// CONCATENATED MODULE: ./node_modules/d3-contour/src/blur.js
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}

// CONCATENATED MODULE: ./node_modules/d3-contour/src/density.js






function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

function defaultWeight() {
  return 1;
}

/* harmony default export */ var src_density = (function() {
  var x = defaultX,
      y = defaultY,
      weight = defaultWeight,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = constant(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (+x(d, i, data) + o) >> k,
          yi = (+y(d, i, data) + o) >> k,
          wi = +weight(d, i, data);
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        values0[xi + yi * n] += wi;
      }
    });

    // TODO Optimize.
    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = Object(max["a" /* default */])(values0);
      tz = Object(ticks["c" /* tickStep */])(0, stop, tz);
      tz = Object(range["a" /* default */])(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return src_contours()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), density) : y;
  };

  density.weight = function(_) {
    return arguments.length ? (weight = typeof _ === "function" ? _ : constant(+_), density) : weight;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = +_[0], _1 = +_[1];
    if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
});

// CONCATENATED MODULE: ./node_modules/d3-contour/src/index.js




/***/ }),

/***/ "cd9d":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ band; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ point; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ identity_identity; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ linear; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ log; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ symlog; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ ordinal; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ implicit; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ pow; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ sqrt; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ radial; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ quantile_quantile; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ quantize; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ threshold; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ time; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ utcTime; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ sequential; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ sequentialLog; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ sequentialPow; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ sequentialSqrt; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ sequentialSymlog; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ sequentialQuantile; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ diverging; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ divergingLog; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ divergingPow; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ divergingSqrt; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ divergingSymlog; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* reexport */ src_tickFormat; });

// EXTERNAL MODULE: ./node_modules/d3-array/src/range.js
var src_range = __webpack_require__("365b");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/init.js
function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/ordinal.js


const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/band.js




function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(src_range["a" /* default */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

// EXTERNAL MODULE: ./node_modules/d3-array/src/ticks.js
var ticks = __webpack_require__("eecb");

// EXTERNAL MODULE: ./node_modules/d3-array/src/bisect.js
var bisect = __webpack_require__("87c9");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/value.js
var src_value = __webpack_require__("ea1d");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/number.js
var number = __webpack_require__("e317");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/round.js
var src_round = __webpack_require__("5857");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/number.js
/* harmony default export */ var src_number = (function(x) {
  return +x;
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/continuous.js





var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(bisect["d" /* default */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = src_value["a" /* default */],
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), number["a" /* default */])))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, src_number), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate = src_round["a" /* default */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(identity, identity);
}

// EXTERNAL MODULE: ./node_modules/d3-format/src/formatSpecifier.js
var formatSpecifier = __webpack_require__("09b8");

// EXTERNAL MODULE: ./node_modules/d3-format/src/precisionPrefix.js
var precisionPrefix = __webpack_require__("d933");

// EXTERNAL MODULE: ./node_modules/d3-format/src/defaultLocale.js
var defaultLocale = __webpack_require__("1231");

// EXTERNAL MODULE: ./node_modules/d3-format/src/precisionRound.js
var precisionRound = __webpack_require__("d989");

// EXTERNAL MODULE: ./node_modules/d3-format/src/precisionFixed.js
var precisionFixed = __webpack_require__("dad1");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/tickFormat.js



/* harmony default export */ var src_tickFormat = (function(start, stop, count, specifier) {
  var step = Object(ticks["c" /* tickStep */])(start, stop, count),
      precision;
  specifier = Object(formatSpecifier["b" /* default */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(precisionPrefix["a" /* default */])(step, value))) specifier.precision = precision;
      return Object(defaultLocale["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(precisionRound["a" /* default */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(precisionFixed["a" /* default */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(defaultLocale["b" /* format */])(specifier);
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/linear.js





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(ticks["a" /* default */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return src_tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = Object(ticks["b" /* tickIncrement */])(start, stop, count);
      if (step === prestep) {
        d[i0] = start
        d[i1] = stop
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/identity.js



function identity_identity(domain) {
  var unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = Array.from(_, src_number), scale) : domain.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return identity_identity(domain).unknown(unknown);
  };

  domain = arguments.length ? Array.from(domain, src_number) : [0, 1];

  return linearish(scale);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/nice.js
/* harmony default export */ var nice = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/log.js






function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = Object(ticks["a" /* default */])(u, v, n);
    } else {
      z = Object(ticks["a" /* default */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(defaultLocale["b" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(transformer()).domain([1, 10]);

  scale.copy = function() {
    return copy(scale, log()).base(scale.base());
  };

  initRange.apply(scale, arguments);

  return scale;
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/symlog.js




function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return linearish(scale);
}

function symlog() {
  var scale = symlogish(transformer());

  scale.copy = function() {
    return copy(scale, symlog()).constant(scale.constant());
  };

  return initRange.apply(scale, arguments);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/pow.js




function transformPow(exponent) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(identity, identity),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(identity, identity)
        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
        : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return linearish(scale);
}

function pow() {
  var scale = powish(transformer());

  scale.copy = function() {
    return copy(scale, pow()).exponent(scale.exponent());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/radial.js





function square(x) {
  return Math.sign(x) * x * x;
}

function unsquare(x) {
  return Math.sign(x) * Math.sqrt(Math.abs(x));
}

function radial() {
  var squared = continuous(),
      range = [0, 1],
      round = false,
      unknown;

  function scale(x) {
    var y = unsquare(squared(x));
    return isNaN(y) ? unknown : round ? Math.round(y) : y;
  }

  scale.invert = function(y) {
    return squared.invert(square(y));
  };

  scale.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };

  scale.range = function(_) {
    return arguments.length ? (squared.range((range = Array.from(_, src_number)).map(square)), scale) : range.slice();
  };

  scale.rangeRound = function(_) {
    return scale.range(_).round(true);
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, scale) : round;
  };

  scale.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return radial(squared.domain(), range)
        .round(round)
        .clamp(squared.clamp())
        .unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

// EXTERNAL MODULE: ./node_modules/d3-array/src/quantile.js
var quantile = __webpack_require__("1875");

// EXTERNAL MODULE: ./node_modules/d3-array/src/ascending.js
var ascending = __webpack_require__("00fb");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/quantile.js



function quantile_quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(quantile["a" /* default */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : range[Object(bisect["d" /* default */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending["a" /* default */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile_quantile()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/quantize.js




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x <= x ? range[Object(bisect["d" /* default */])(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function() {
    return domain.slice();
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(linearish(scale), arguments);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/threshold.js



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x <= x ? range[Object(bisect["d" /* default */])(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

// EXTERNAL MODULE: ./node_modules/d3-array/src/bisector.js
var bisector = __webpack_require__("2a2d");

// EXTERNAL MODULE: ./node_modules/d3-time/src/year.js
var src_year = __webpack_require__("a15a");

// EXTERNAL MODULE: ./node_modules/d3-time/src/month.js
var src_month = __webpack_require__("9603");

// EXTERNAL MODULE: ./node_modules/d3-time/src/week.js
var src_week = __webpack_require__("b14c");

// EXTERNAL MODULE: ./node_modules/d3-time/src/day.js
var src_day = __webpack_require__("742c");

// EXTERNAL MODULE: ./node_modules/d3-time/src/hour.js
var src_hour = __webpack_require__("b3c3");

// EXTERNAL MODULE: ./node_modules/d3-time/src/minute.js
var src_minute = __webpack_require__("2c38");

// EXTERNAL MODULE: ./node_modules/d3-time/src/second.js
var src_second = __webpack_require__("5edf");

// EXTERNAL MODULE: ./node_modules/d3-time/src/millisecond.js
var src_millisecond = __webpack_require__("1809");

// EXTERNAL MODULE: ./node_modules/d3-time-format/src/defaultLocale.js
var src_defaultLocale = __webpack_require__("4c23");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/time.js







var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function time_number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = continuous(),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(bisector["a" /* default */])(function(i) { return i[2]; }).right(tickIntervals, target),
          step;
      if (i === tickIntervals.length) {
        step = Object(ticks["c" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(ticks["c" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
      return interval.every(step);
    }

    return interval;
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, time_number)) : domain().map(date);
  };

  scale.ticks = function(interval) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1]))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ var time = (function() {
  return initRange.apply(calendar(src_year["a" /* default */], src_month["a" /* default */], src_week["g" /* sunday */], src_day["b" /* default */], src_hour["a" /* default */], src_minute["a" /* default */], src_second["a" /* default */], src_millisecond["a" /* default */], src_defaultLocale["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
});

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcYear.js
var utcYear = __webpack_require__("77ae");

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcMonth.js
var utcMonth = __webpack_require__("55f8");

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcWeek.js
var utcWeek = __webpack_require__("2739");

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcDay.js
var utcDay = __webpack_require__("6eb2");

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcHour.js
var utcHour = __webpack_require__("f623");

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcMinute.js
var utcMinute = __webpack_require__("f8ee");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/utcTime.js





/* harmony default export */ var utcTime = (function() {
  return initRange.apply(calendar(utcYear["a" /* default */], utcMonth["a" /* default */], utcWeek["g" /* utcSunday */], utcDay["a" /* default */], utcHour["a" /* default */], utcMinute["a" /* default */], src_second["a" /* default */], src_millisecond["a" /* default */], src_defaultLocale["d" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/sequential.js








function sequential_transformer() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = identity,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }

  scale.range = range(src_value["a" /* default */]);

  scale.rangeRound = range(src_round["a" /* default */]);

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function sequential_copy(source, target) {
  return target
      .domain(source.domain())
      .interpolator(source.interpolator())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function sequential() {
  var scale = linearish(sequential_transformer()(identity));

  scale.copy = function() {
    return sequential_copy(scale, sequential());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialLog() {
  var scale = loggish(sequential_transformer()).domain([1, 10]);

  scale.copy = function() {
    return sequential_copy(scale, sequentialLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = symlogish(sequential_transformer());

  scale.copy = function() {
    return sequential_copy(scale, sequentialSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialPow() {
  var scale = powish(sequential_transformer());

  scale.copy = function() {
    return sequential_copy(scale, sequentialPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/sequentialQuantile.js




function sequentialQuantile() {
  var domain = [],
      interpolator = identity;

  function scale(x) {
    if (!isNaN(x = +x)) return interpolator((Object(bisect["d" /* default */])(domain, x, 1) - 1) / (domain.length - 1));
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending["a" /* default */]);
    return scale;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.range = function() {
    return domain.map((d, i) => interpolator(i / (domain.length - 1)));
  };

  scale.quantiles = function(n) {
    return Array.from({length: n + 1}, (_, i) => Object(quantile["a" /* default */])(domain, i / n));
  };

  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return initInterpolator.apply(scale, arguments);
}

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/piecewise.js
var src_piecewise = __webpack_require__("ac0c");

// CONCATENATED MODULE: ./node_modules/d3-scale/src/diverging.js









function diverging_transformer() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      s = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = identity,
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = Object(src_piecewise["a" /* default */])(interpolate, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }

  scale.range = range(src_value["a" /* default */]);

  scale.rangeRound = range(src_round["a" /* default */]);

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
    return scale;
  };
}

function diverging() {
  var scale = linearish(diverging_transformer()(identity));

  scale.copy = function() {
    return sequential_copy(scale, diverging());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingLog() {
  var scale = loggish(diverging_transformer()).domain([0.1, 1, 10]);

  scale.copy = function() {
    return sequential_copy(scale, divergingLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSymlog() {
  var scale = symlogish(diverging_transformer());

  scale.copy = function() {
    return sequential_copy(scale, divergingSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingPow() {
  var scale = powish(diverging_transformer());

  scale.copy = function() {
    return sequential_copy(scale, divergingPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/index.js



































/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ce75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

/* harmony default export */ __webpack_exports__["a"] = ((function zoomRho(rho, rho2, rho4) {

  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S;

    // Special case for u0 ≅ u1.
    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;
      i = function(t) {
        return [
          ux0 + t * dx,
          uy0 + t * dy,
          w0 * Math.exp(rho * t * S)
        ];
      }
    }

    // General case.
    else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function(t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [
          ux0 + u * dx,
          uy0 + u * dy,
          w0 * coshr0 / cosh(rho * s + r0)
        ];
      }
    }

    i.duration = S * 1000 * rho / Math.SQRT2;

    return i;
  }

  zoom.rho = function(_) {
    var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
    return zoomRho(_1, _2, _4);
  };

  return zoom;
})(Math.SQRT2, 2, 4));


/***/ }),

/***/ "ce86":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    arrayMap = __webpack_require__("7948"),
    isArray = __webpack_require__("6747"),
    isSymbol = __webpack_require__("ffd6");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "cfa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ quadtree; });

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/add.js
/* harmony default export */ var add = (function(d) {
  const x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add_add(this.cover(x, y), x, y, d);
});

function add_add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, abort.
  if (x0 > x1 || y0 > y1) return this;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add_add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/cover.js
/* harmony default export */ var cover = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else {
    var z = x1 - x0 || 1,
        node = this._root,
        parent,
        i;

    while (x0 > x || x >= x1 || y0 > y || y >= y1) {
      i = (y < y0) << 1 | (x < x0);
      parent = new Array(4), parent[i] = node, node = parent, z *= 2;
      switch (i) {
        case 0: x1 = x0 + z, y1 = y0 + z; break;
        case 1: x0 = x1 - z, y1 = y0 + z; break;
        case 2: x1 = x0 + z, y0 = y1 - z; break;
        case 3: x0 = x1 - z, y0 = y1 - z; break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/data.js
/* harmony default export */ var src_data = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/extent.js
/* harmony default export */ var extent = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/quad.js
/* harmony default export */ var quad = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/find.js


/* harmony default export */ var find = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new quad(node[3], xm, ym, x2, y2),
        new quad(node[2], x1, ym, xm, y2),
        new quad(node[1], xm, y1, x2, ym),
        new quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/remove.js
/* harmony default export */ var remove = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/root.js
/* harmony default export */ var root = (function() {
  return this._root;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/size.js
/* harmony default export */ var size = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/visit.js


/* harmony default export */ var visit = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
    }
  }
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/visitAfter.js


/* harmony default export */ var visitAfter = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/x.js
function defaultX(d) {
  return d[0];
}

/* harmony default export */ var src_x = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/y.js
function defaultY(d) {
  return d[1];
}

/* harmony default export */ var src_y = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});

// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/quadtree.js













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = add;
treeProto.addAll = addAll;
treeProto.cover = cover;
treeProto.data = src_data;
treeProto.extent = extent;
treeProto.find = find;
treeProto.remove = remove;
treeProto.removeAll = removeAll;
treeProto.root = root;
treeProto.size = size;
treeProto.visit = visit;
treeProto.visitAfter = visitAfter;
treeProto.x = src_x;
treeProto.y = src_y;


/***/ }),

/***/ "cfca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ delaunay_Delaunay; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ voronoi_Voronoi; });

// CONCATENATED MODULE: ./node_modules/delaunator/index.js

const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);

class Delaunator {

    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);

        for (let i = 0; i < n; i++) {
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }

        return new Delaunator(coords);
    }

    constructor(coords) {
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');

        this.coords = coords;

        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);

        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash

        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);

        this.update();
    }

    update() {
        const {coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash} =  this;
        const n = coords.length >> 1;

        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;

        for (let i = 0; i < n; i++) {
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;

        let minDist = Infinity;
        let i0, i1, i2;

        // pick a seed point close to the center
        for (let i = 0; i < n; i++) {
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];

        minDist = Infinity;

        // find the point closest to the seed
        for (let i = 0; i < n; i++) {
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];

        let minRadius = Infinity;

        // find the third point which forms the smallest circumcircle with the first two
        for (let i = 0; i < n; i++) {
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];

        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for (let i = 0; i < n; i++) {
                this._dists[i] = (coords[2 * i] - coords[0]) || (coords[2 * i + 1] - coords[1]);
            }
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for (let i = 0, d0 = -Infinity; i < n; i++) {
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }

        // swap the order of the seed points for counter-clockwise orientation
        if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }

        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;

        for (let i = 0; i < n; i++) {
            this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        }

        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);

        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;

        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;

        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;

        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;

        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);

        for (let k = 0, xp, yp; k < this._ids.length; k++) {
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];

            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;

            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;

            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for (let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++) {
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }

            start = hullPrev[start];
            let e = start, q;
            while (q = hullNext[e], !orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])) {
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it

            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);

            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;

            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while (q = hullNext[n], orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])) {
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }

            // walk backward from the other side, adding more triangles and flipping
            if (e === start) {
                while (q = hullPrev[e], orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])) {
                    t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                    this._legalize(t + 2);
                    hullTri[q] = t;
                    hullNext[e] = e; // mark as removed
                    hullSize--;
                    e = q;
                }
            }

            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;

            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }

        this.hull = new Uint32Array(hullSize);
        for (let i = 0, e = this._hullStart; i < hullSize; i++) {
            this.hull[i] = e;
            e = hullNext[e];
        }

        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }

    _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }

    _legalize(a) {
        const {_triangles: triangles, _halfedges: halfedges, coords} = this;

        let i = 0;
        let ar = 0;

        // recursion eliminated with a fixed-size stack
        while (true) {
            const b = halfedges[a];

            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */
            const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;

            if (b === -1) { // convex hull edge
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }

            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;

            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];

            const illegal = inCircle(
                coords[2 * p0], coords[2 * p0 + 1],
                coords[2 * pr], coords[2 * pr + 1],
                coords[2 * pl], coords[2 * pl + 1],
                coords[2 * p1], coords[2 * p1 + 1]);

            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;

                const hbl = halfedges[bl];

                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    } while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);

                const br = b0 + (b + 1) % 3;

                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) {
                    EDGE_STACK[i++] = br;
                }
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }

        return ar;
    }

    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }

    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;

        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;

        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);

        this.trianglesLen += 3;

        return t;
    }
}

// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}

function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}

// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function orient(rx, ry, qx, qy, px, py) {
    const sign = orientIfSure(px, py, rx, ry, qx, qy) ||
    orientIfSure(rx, ry, qx, qy, px, py) ||
    orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
}

function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;

    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;

    return dx * (ey * cp - bp * fy) -
           dy * (ex * cp - bp * fx) +
           ap * (ex * fy - ey * fx) < 0;
}

function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;

    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);

    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;

    return x * x + y * y;
}

function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;

    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);

    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;

    return {x, y};
}

function quicksort(ids, dists, left, right) {
    if (right - left <= 20) {
        for (let i = left + 1; i <= right; i++) {
            const temp = ids[i];
            const tempDist = dists[temp];
            let j = i - 1;
            while (j >= left && dists[ids[j]] > tempDist) ids[j + 1] = ids[j--];
            ids[j + 1] = temp;
        }
    } else {
        const median = (left + right) >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);

        const temp = ids[i];
        const tempDist = dists[temp];
        while (true) {
            do i++; while (dists[ids[i]] < tempDist);
            do j--; while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;

        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}

function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

function defaultGetX(p) {
    return p[0];
}
function defaultGetY(p) {
    return p[1];
}

// CONCATENATED MODULE: ./node_modules/d3-delaunay/src/path.js
const epsilon = 1e-6;

class Path {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
  }
  moveTo(x, y) {
    this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  }
  lineTo(x, y) {
    this._ += `L${this._x1 = +x},${this._y1 = +y}`;
  }
  arc(x, y, r) {
    x = +x, y = +y, r = +r;
    const x0 = x + r;
    const y0 = y;
    if (r < 0) throw new Error("negative radius");
    if (this._x1 === null) this._ += `M${x0},${y0}`;
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
    if (!r) return;
    this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
  }
  rect(x, y, w, h) {
    this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
  }
  value() {
    return this._ || null;
  }
}

// CONCATENATED MODULE: ./node_modules/d3-delaunay/src/polygon.js
class Polygon {
  constructor() {
    this._ = [];
  }
  moveTo(x, y) {
    this._.push([x, y]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(x, y) {
    this._.push([x, y]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}

// CONCATENATED MODULE: ./node_modules/d3-delaunay/src/voronoi.js



class voronoi_Voronoi {
  constructor(delaunay, [xmin, ymin, xmax, ymax] = [0, 0, 960, 500]) {
    if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
    this.delaunay = delaunay;
    this._circumcenters = new Float64Array(delaunay.points.length * 2);
    this.vectors = new Float64Array(delaunay.points.length * 2);
    this.xmax = xmax, this.xmin = xmin;
    this.ymax = ymax, this.ymin = ymin;
    this._init();
  }
  update() {
    this.delaunay.update();
    this._init();
    return this;
  }
  _init() {
    const {delaunay: {points, hull, triangles}, vectors} = this;

    // Compute circumcenters.
    const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
    for (let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2) {
      const t1 = triangles[i] * 2;
      const t2 = triangles[i + 1] * 2;
      const t3 = triangles[i + 2] * 2;
      const x1 = points[t1];
      const y1 = points[t1 + 1];
      const x2 = points[t2];
      const y2 = points[t2 + 1];
      const x3 = points[t3];
      const y3 = points[t3 + 1];

      const dx = x2 - x1;
      const dy = y2 - y1;
      const ex = x3 - x1;
      const ey = y3 - y1;
      const bl = dx * dx + dy * dy;
      const cl = ex * ex + ey * ey;
      const ab = (dx * ey - dy * ex) * 2;

      if (!ab) {
        // degenerate case (collinear diagram)
        x = (x1 + x3) / 2 - 1e8 * ey;
        y = (y1 + y3) / 2 + 1e8 * ex;
      }
      else if (Math.abs(ab) < 1e-8) {
        // almost equal points (degenerate triangle)
        x = (x1 + x3) / 2;
        y = (y1 + y3) / 2;
      } else {
        const d = 1 / ab;
        x = x1 + (ey * bl - dy * cl) * d;
        y = y1 + (dx * cl - ex * bl) * d;
      }
      circumcenters[j] = x;
      circumcenters[j + 1] = y;
    }

    // Compute exterior cell rays.
    let h = hull[hull.length - 1];
    let p0, p1 = h * 4;
    let x0, x1 = points[2 * h];
    let y0, y1 = points[2 * h + 1];
    vectors.fill(0);
    for (let i = 0; i < hull.length; ++i) {
      h = hull[i];
      p0 = p1, x0 = x1, y0 = y1;
      p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
      vectors[p0 + 2] = vectors[p1] = y0 - y1;
      vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
    }
  }
  render(context) {
    const buffer = context == null ? context = new Path : undefined;
    const {delaunay: {halfedges, inedges, hull}, circumcenters, vectors} = this;
    if (hull.length <= 1) return null;
    for (let i = 0, n = halfedges.length; i < n; ++i) {
      const j = halfedges[i];
      if (j < i) continue;
      const ti = Math.floor(i / 3) * 2;
      const tj = Math.floor(j / 3) * 2;
      const xi = circumcenters[ti];
      const yi = circumcenters[ti + 1];
      const xj = circumcenters[tj];
      const yj = circumcenters[tj + 1];
      this._renderSegment(xi, yi, xj, yj, context);
    }
    let h0, h1 = hull[hull.length - 1];
    for (let i = 0; i < hull.length; ++i) {
      h0 = h1, h1 = hull[i];
      const t = Math.floor(inedges[h1] / 3) * 2;
      const x = circumcenters[t];
      const y = circumcenters[t + 1];
      const v = h0 * 4;
      const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
      if (p) this._renderSegment(x, y, p[0], p[1], context);
    }
    return buffer && buffer.value();
  }
  renderBounds(context) {
    const buffer = context == null ? context = new Path : undefined;
    context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
    return buffer && buffer.value();
  }
  renderCell(i, context) {
    const buffer = context == null ? context = new Path : undefined;
    const points = this._clip(i);
    if (points === null || !points.length) return;
    context.moveTo(points[0], points[1]);
    let n = points.length;
    while (points[0] === points[n-2] && points[1] === points[n-1] && n > 1) n -= 2;
    for (let i = 2; i < n; i += 2) {
      if (points[i] !== points[i-2] || points[i+1] !== points[i-1])
        context.lineTo(points[i], points[i + 1]);
    }
    context.closePath();
    return buffer && buffer.value();
  }
  *cellPolygons() {
    const {delaunay: {points}} = this;
    for (let i = 0, n = points.length / 2; i < n; ++i) {
      const cell = this.cellPolygon(i);
      if (cell) cell.index = i, yield cell;
    }
  }
  cellPolygon(i) {
    const polygon = new Polygon;
    this.renderCell(i, polygon);
    return polygon.value();
  }
  _renderSegment(x0, y0, x1, y1, context) {
    let S;
    const c0 = this._regioncode(x0, y0);
    const c1 = this._regioncode(x1, y1);
    if (c0 === 0 && c1 === 0) {
      context.moveTo(x0, y0);
      context.lineTo(x1, y1);
    } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
      context.moveTo(S[0], S[1]);
      context.lineTo(S[2], S[3]);
    }
  }
  contains(i, x, y) {
    if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
    return this.delaunay._step(i, x, y) === i;
  }
  *neighbors(i) {
    const ci = this._clip(i);
    if (ci) for (const j of this.delaunay.neighbors(i)) {
      const cj = this._clip(j);
      // find the common edge
      if (cj) loop: for (let ai = 0, li = ci.length; ai < li; ai += 2) {
        for (let aj = 0, lj = cj.length; aj < lj; aj += 2) {
          if (ci[ai] == cj[aj]
          && ci[ai + 1] == cj[aj + 1]
          && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj]
          && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]
          ) {
            yield j;
            break loop;
          }
        }
      }
    }
  }
  _cell(i) {
    const {circumcenters, delaunay: {inedges, halfedges, triangles}} = this;
    const e0 = inedges[i];
    if (e0 === -1) return null; // coincident point
    const points = [];
    let e = e0;
    do {
      const t = Math.floor(e / 3);
      points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) break; // bad triangulation
      e = halfedges[e];
    } while (e !== e0 && e !== -1);
    return points;
  }
  _clip(i) {
    // degenerate case (1 valid point: return the box)
    if (i === 0 && this.delaunay.hull.length === 1) {
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    }
    const points = this._cell(i);
    if (points === null) return null;
    const {vectors: V} = this;
    const v = i * 4;
    return V[v] || V[v + 1]
        ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3])
        : this._clipFinite(i, points);
  }
  _clipFinite(i, points) {
    const n = points.length;
    let P = null;
    let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
    let c0, c1 = this._regioncode(x1, y1);
    let e0, e1;
    for (let j = 0; j < n; j += 2) {
      x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
      c0 = c1, c1 = this._regioncode(x1, y1);
      if (c0 === 0 && c1 === 0) {
        e0 = e1, e1 = 0;
        if (P) P.push(x1, y1);
        else P = [x1, y1];
      } else {
        let S, sx0, sy0, sx1, sy1;
        if (c0 === 0) {
          if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
          [sx0, sy0, sx1, sy1] = S;
        } else {
          if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
          [sx1, sy1, sx0, sy0] = S;
          e0 = e1, e1 = this._edgecode(sx0, sy0);
          if (e0 && e1) this._edge(i, e0, e1, P, P.length);
          if (P) P.push(sx0, sy0);
          else P = [sx0, sy0];
        }
        e0 = e1, e1 = this._edgecode(sx1, sy1);
        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        if (P) P.push(sx1, sy1);
        else P = [sx1, sy1];
      }
    }
    if (P) {
      e0 = e1, e1 = this._edgecode(P[0], P[1]);
      if (e0 && e1) this._edge(i, e0, e1, P, P.length);
    } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    }
    return P;
  }
  _clipSegment(x0, y0, x1, y1, c0, c1) {
    while (true) {
      if (c0 === 0 && c1 === 0) return [x0, y0, x1, y1];
      if (c0 & c1) return null;
      let x, y, c = c0 || c1;
      if (c & 0b1000) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
      else if (c & 0b0100) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
      else if (c & 0b0010) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
      else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
      if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
      else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
    }
  }
  _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
    let P = Array.from(points), p;
    if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
    if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
    if (P = this._clipFinite(i, P)) {
      for (let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2) {
        c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
        if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
      }
    } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
      P = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax];
    }
    return P;
  }
  _edge(i, e0, e1, P, j) {
    while (e0 !== e1) {
      let x, y;
      switch (e0) {
        case 0b0101: e0 = 0b0100; continue; // top-left
        case 0b0100: e0 = 0b0110, x = this.xmax, y = this.ymin; break; // top
        case 0b0110: e0 = 0b0010; continue; // top-right
        case 0b0010: e0 = 0b1010, x = this.xmax, y = this.ymax; break; // right
        case 0b1010: e0 = 0b1000; continue; // bottom-right
        case 0b1000: e0 = 0b1001, x = this.xmin, y = this.ymax; break; // bottom
        case 0b1001: e0 = 0b0001; continue; // bottom-left
        case 0b0001: e0 = 0b0101, x = this.xmin, y = this.ymin; break; // left
      }
      if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) {
        P.splice(j, 0, x, y), j += 2;
      }
    }
    if (P.length > 4) {
      for (let i = 0; i < P.length; i+= 2) {
        const j = (i + 2) % P.length, k = (i + 4) % P.length;
        if (P[i] === P[j] && P[j] === P[k]
        || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1])
          P.splice(j, 2), i -= 2;
      }
    }
    return j;
  }
  _project(x0, y0, vx, vy) {
    let t = Infinity, c, x, y;
    if (vy < 0) { // top
      if (y0 <= this.ymin) return null;
      if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
    } else if (vy > 0) { // bottom
      if (y0 >= this.ymax) return null;
      if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
    }
    if (vx > 0) { // right
      if (x0 >= this.xmax) return null;
      if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
    } else if (vx < 0) { // left
      if (x0 <= this.xmin) return null;
      if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
    }
    return [x, y];
  }
  _edgecode(x, y) {
    return (x === this.xmin ? 0b0001
        : x === this.xmax ? 0b0010 : 0b0000)
        | (y === this.ymin ? 0b0100
        : y === this.ymax ? 0b1000 : 0b0000);
  }
  _regioncode(x, y) {
    return (x < this.xmin ? 0b0001
        : x > this.xmax ? 0b0010 : 0b0000)
        | (y < this.ymin ? 0b0100
        : y > this.ymax ? 0b1000 : 0b0000);
  }
}

// CONCATENATED MODULE: ./node_modules/d3-delaunay/src/delaunay.js





const tau = 2 * Math.PI, pow = Math.pow;

function pointX(p) {
  return p[0];
}

function pointY(p) {
  return p[1];
}

// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
  const {triangles, coords} = d;
  for (let i = 0; i < triangles.length; i += 3) {
    const a = 2 * triangles[i],
          b = 2 * triangles[i + 1],
          c = 2 * triangles[i + 2],
          cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1])
                - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
    if (cross > 1e-10) return false;
  }
  return true;
}

function jitter(x, y, r) {
  return [x + Math.sin(x + y) * r, y + Math.cos(x - y) * r];
}

class delaunay_Delaunay {
  static from(points, fx = pointX, fy = pointY, that) {
    return new delaunay_Delaunay("length" in points
        ? flatArray(points, fx, fy, that)
        : Float64Array.from(flatIterable(points, fx, fy, that)));
  }
  constructor(points) {
    this._delaunator = new Delaunator(points);
    this.inedges = new Int32Array(points.length / 2);
    this._hullIndex = new Int32Array(points.length / 2);
    this.points = this._delaunator.coords;
    this._init();
  }
  update() {
    this._delaunator.update();
    this._init();
    return this;
  }
  _init() {
    const d = this._delaunator, points = this.points;

    // check for collinear
    if (d.hull && d.hull.length > 2 && collinear(d)) {
      this.collinear = Int32Array.from({length: points.length/2}, (_,i) => i)
        .sort((i, j) => points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
      const e = this.collinear[0], f = this.collinear[this.collinear.length - 1],
        bounds = [ points[2 * e], points[2 * e + 1], points[2 * f], points[2 * f + 1] ],
        r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
      for (let i = 0, n = points.length / 2; i < n; ++i) {
        const p = jitter(points[2 * i], points[2 * i + 1], r);
        points[2 * i] = p[0];
        points[2 * i + 1] = p[1];
      }
      this._delaunator = new Delaunator(points);
    } else {
      delete this.collinear;
    }

    const halfedges = this.halfedges = this._delaunator.halfedges;
    const hull = this.hull = this._delaunator.hull;
    const triangles = this.triangles = this._delaunator.triangles;
    const inedges = this.inedges.fill(-1);
    const hullIndex = this._hullIndex.fill(-1);

    // Compute an index from each point to an (arbitrary) incoming halfedge
    // Used to give the first neighbor of each point; for this reason,
    // on the hull we give priority to exterior halfedges
    for (let e = 0, n = halfedges.length; e < n; ++e) {
      const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
      if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
    }
    for (let i = 0, n = hull.length; i < n; ++i) {
      hullIndex[hull[i]] = i;
    }

    // degenerate case: 1 or 2 (distinct) points
    if (hull.length <= 2 && hull.length > 0) {
      this.triangles = new Int32Array(3).fill(-1);
      this.halfedges = new Int32Array(3).fill(-1);
      this.triangles[0] = hull[0];
      this.triangles[1] = hull[1];
      this.triangles[2] = hull[1];
      inedges[hull[0]] = 1;
      if (hull.length === 2) inedges[hull[1]] = 0;
    }
  }
  voronoi(bounds) {
    return new voronoi_Voronoi(this, bounds);
  }
  *neighbors(i) {
    const {inedges, hull, _hullIndex, halfedges, triangles, collinear} = this;

    // degenerate case with several collinear points
    if (collinear) {
      const l = collinear.indexOf(i);
      if (l > 0) yield collinear[l - 1];
      if (l < collinear.length - 1) yield collinear[l + 1];
      return;
    }

    const e0 = inedges[i];
    if (e0 === -1) return; // coincident point
    let e = e0, p0 = -1;
    do {
      yield p0 = triangles[e];
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) return; // bad triangulation
      e = halfedges[e];
      if (e === -1) {
        const p = hull[(_hullIndex[i] + 1) % hull.length];
        if (p !== p0) yield p;
        return;
      }
    } while (e !== e0);
  }
  find(x, y, i = 0) {
    if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
    const i0 = i;
    let c;
    while ((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0) i = c;
    return c;
  }
  _step(i, x, y) {
    const {inedges, hull, _hullIndex, halfedges, triangles, points} = this;
    if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
    let c = i;
    let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
    const e0 = inedges[i];
    let e = e0;
    do {
      let t = triangles[e];
      const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
      if (dt < dc) dc = dt, c = t;
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) break; // bad triangulation
      e = halfedges[e];
      if (e === -1) {
        e = hull[(_hullIndex[i] + 1) % hull.length];
        if (e !== t) {
          if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
        }
        break;
      }
    } while (e !== e0);
    return c;
  }
  render(context) {
    const buffer = context == null ? context = new Path : undefined;
    const {points, halfedges, triangles} = this;
    for (let i = 0, n = halfedges.length; i < n; ++i) {
      const j = halfedges[i];
      if (j < i) continue;
      const ti = triangles[i] * 2;
      const tj = triangles[j] * 2;
      context.moveTo(points[ti], points[ti + 1]);
      context.lineTo(points[tj], points[tj + 1]);
    }
    this.renderHull(context);
    return buffer && buffer.value();
  }
  renderPoints(context, r = 2) {
    const buffer = context == null ? context = new Path : undefined;
    const {points} = this;
    for (let i = 0, n = points.length; i < n; i += 2) {
      const x = points[i], y = points[i + 1];
      context.moveTo(x + r, y);
      context.arc(x, y, r, 0, tau);
    }
    return buffer && buffer.value();
  }
  renderHull(context) {
    const buffer = context == null ? context = new Path : undefined;
    const {hull, points} = this;
    const h = hull[0] * 2, n = hull.length;
    context.moveTo(points[h], points[h + 1]);
    for (let i = 1; i < n; ++i) {
      const h = 2 * hull[i];
      context.lineTo(points[h], points[h + 1]);
    }
    context.closePath();
    return buffer && buffer.value();
  }
  hullPolygon() {
    const polygon = new Polygon;
    this.renderHull(polygon);
    return polygon.value();
  }
  renderTriangle(i, context) {
    const buffer = context == null ? context = new Path : undefined;
    const {points, triangles} = this;
    const t0 = triangles[i *= 3] * 2;
    const t1 = triangles[i + 1] * 2;
    const t2 = triangles[i + 2] * 2;
    context.moveTo(points[t0], points[t0 + 1]);
    context.lineTo(points[t1], points[t1 + 1]);
    context.lineTo(points[t2], points[t2 + 1]);
    context.closePath();
    return buffer && buffer.value();
  }
  *trianglePolygons() {
    const {triangles} = this;
    for (let i = 0, n = triangles.length / 3; i < n; ++i) {
      yield this.trianglePolygon(i);
    }
  }
  trianglePolygon(i) {
    const polygon = new Polygon;
    this.renderTriangle(i, polygon);
    return polygon.value();
  }
}

function flatArray(points, fx, fy, that) {
  const n = points.length;
  const array = new Float64Array(n * 2);
  for (let i = 0; i < n; ++i) {
    const p = points[i];
    array[i * 2] = fx.call(that, p, i, points);
    array[i * 2 + 1] = fy.call(that, p, i, points);
  }
  return array;
}

function* flatIterable(points, fx, fy, that) {
  let i = 0;
  for (const p of points) {
    yield fx.call(that, p, i, points);
    yield fy.call(that, p, i, points);
    ++i;
  }
}

// CONCATENATED MODULE: ./node_modules/d3-delaunay/src/index.js




/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d018":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("7948"),
    copyArray = __webpack_require__("4359"),
    isArray = __webpack_require__("6747"),
    isSymbol = __webpack_require__("ffd6"),
    stringToPath = __webpack_require__("18d8"),
    toKey = __webpack_require__("f4d6"),
    toString = __webpack_require__("76dd");

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),

/***/ "d02c":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e"),
    Map = __webpack_require__("79bc"),
    MapCache = __webpack_require__("7b83");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d26c":
/***/ (function(module, exports) {

module.exports = {
  purge: {
    content: ['./public/**/*.html', './src/**/*.vue'],
    safelist: ['chart-loading', 'chart-error', 'dh-chart-wrapper', 'tooltip-wrapper']
  },
  theme: {
    screens: {
      mobile: {
        max: '639px'
      },
      sm: '640px',
      // => @media (min-width: 640px) { ... }
      md: '768px',
      // => @media (min-width: 768px) { ... }
      lg: '1024px',
      // => @media (min-width: 1024px) { ... }
      xl: '1280px',
      // => @media (min-width: 1280px) { ... }
      '2xl': '1440px',
      '3xl': '1600px'
    }
  },
  corePlugins: {
    preflight: "production" !== 'production'
  }
};

/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d327":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "d370":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("253c"),
    isObjectLike = __webpack_require__("1310");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d612":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("7b83"),
    setCacheAdd = __webpack_require__("7ed2"),
    setCacheHas = __webpack_require__("dc0f");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d7ee":
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__("c3fc"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const TEMPLATE_REGEX = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
const STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
const STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
const ESCAPE_REGEX = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi;

const ESCAPES = new Map([
	['n', '\n'],
	['r', '\r'],
	['t', '\t'],
	['b', '\b'],
	['f', '\f'],
	['v', '\v'],
	['0', '\0'],
	['\\', '\\'],
	['e', '\u001B'],
	['a', '\u0007']
]);

function unescape(c) {
	const u = c[0] === 'u';
	const bracket = c[1] === '{';

	if ((u && !bracket && c.length === 5) || (c[0] === 'x' && c.length === 3)) {
		return String.fromCharCode(parseInt(c.slice(1), 16));
	}

	if (u && bracket) {
		return String.fromCodePoint(parseInt(c.slice(2, -1), 16));
	}

	return ESCAPES.get(c) || c;
}

function parseArguments(name, arguments_) {
	const results = [];
	const chunks = arguments_.trim().split(/\s*,\s*/g);
	let matches;

	for (const chunk of chunks) {
		const number = Number(chunk);
		if (!Number.isNaN(number)) {
			results.push(number);
		} else if ((matches = chunk.match(STRING_REGEX))) {
			results.push(matches[2].replace(ESCAPE_REGEX, (m, escape, character) => escape ? unescape(escape) : character));
		} else {
			throw new Error(`Invalid Chalk template style argument: ${chunk} (in style '${name}')`);
		}
	}

	return results;
}

function parseStyle(style) {
	STYLE_REGEX.lastIndex = 0;

	const results = [];
	let matches;

	while ((matches = STYLE_REGEX.exec(style)) !== null) {
		const name = matches[1];

		if (matches[2]) {
			const args = parseArguments(name, matches[2]);
			results.push([name].concat(args));
		} else {
			results.push([name]);
		}
	}

	return results;
}

function buildStyle(chalk, styles) {
	const enabled = {};

	for (const layer of styles) {
		for (const style of layer.styles) {
			enabled[style[0]] = layer.inverse ? null : style.slice(1);
		}
	}

	let current = chalk;
	for (const [styleName, styles] of Object.entries(enabled)) {
		if (!Array.isArray(styles)) {
			continue;
		}

		if (!(styleName in current)) {
			throw new Error(`Unknown Chalk style: ${styleName}`);
		}

		current = styles.length > 0 ? current[styleName](...styles) : current[styleName];
	}

	return current;
}

module.exports = (chalk, temporary) => {
	const styles = [];
	const chunks = [];
	let chunk = [];

	// eslint-disable-next-line max-params
	temporary.replace(TEMPLATE_REGEX, (m, escapeCharacter, inverse, style, close, character) => {
		if (escapeCharacter) {
			chunk.push(unescape(escapeCharacter));
		} else if (style) {
			const string = chunk.join('');
			chunk = [];
			chunks.push(styles.length === 0 ? string : buildStyle(chalk, styles)(string));
			styles.push({inverse, styles: parseStyle(style)});
		} else if (close) {
			if (styles.length === 0) {
				throw new Error('Found extraneous } in Chalk template literal');
			}

			chunks.push(buildStyle(chalk, styles)(chunk.join('')));
			chunk = [];
			styles.pop();
		} else {
			chunk.push(character);
		}
	});

	chunks.push(chunk.join(''));

	if (styles.length > 0) {
		const errMessage = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? '' : 's'} (\`}\`)`;
		throw new Error(errMessage);
	}

	return chunks.join('');
};


/***/ }),

/***/ "d933":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _exponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a7fd");


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(_exponent_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value) / 3))) * 3 - Object(_exponent_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Math.abs(step)));
});


/***/ }),

/***/ "d934":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ d3_zoom_src_zoom; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ transform_transform; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ identity; });

// EXTERNAL MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var dispatch = __webpack_require__("c68f");

// EXTERNAL MODULE: ./node_modules/d3-drag/src/nodrag.js
var nodrag = __webpack_require__("b54f");

// EXTERNAL MODULE: ./node_modules/d3-interpolate/src/zoom.js
var src_zoom = __webpack_require__("ce75");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/select.js
var src_select = __webpack_require__("00a5");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/pointer.js
var pointer = __webpack_require__("5e81");

// EXTERNAL MODULE: ./node_modules/d3-transition/src/index.js + 28 modules
var src = __webpack_require__("b108");

// CONCATENATED MODULE: ./node_modules/d3-zoom/src/constant.js
/* harmony default export */ var constant = (x => () => x);

// CONCATENATED MODULE: ./node_modules/d3-zoom/src/event.js
function ZoomEvent(type, {
  sourceEvent,
  target,
  transform,
  dispatch
}) {
  Object.defineProperties(this, {
    type: {value: type, enumerable: true, configurable: true},
    sourceEvent: {value: sourceEvent, enumerable: true, configurable: true},
    target: {value: target, enumerable: true, configurable: true},
    transform: {value: transform, enumerable: true, configurable: true},
    _: {value: dispatch}
  });
}

// CONCATENATED MODULE: ./node_modules/d3-zoom/src/transform.js
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform_transform.prototype = Transform.prototype;

function transform_transform(node) {
  while (!node.__zoom) if (!(node = node.parentNode)) return identity;
  return node.__zoom;
}

// CONCATENATED MODULE: ./node_modules/d3-zoom/src/noevent.js
function nopropagation(event) {
  event.stopImmediatePropagation();
}

/* harmony default export */ var noevent = (function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
});

// CONCATENATED MODULE: ./node_modules/d3-zoom/src/zoom.js










// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
  return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}

function defaultExtent() {
  var e = this;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    if (e.hasAttribute("viewBox")) {
      e = e.viewBox.baseVal;
      return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
    }
    return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
  }
  return [[0, 0], [e.clientWidth, e.clientHeight]];
}

function defaultTransform() {
  return this.__zoom || identity;
}

function defaultWheelDelta(event) {
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}

function defaultTouchable() {
  return navigator.maxTouchPoints || ("ontouchstart" in this);
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* harmony default export */ var d3_zoom_src_zoom = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = src_zoom["a" /* default */],
      listeners = Object(dispatch["a" /* default */])("start", "zoom", "end"),
      touchstarting,
      touchfirst,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0,
      tapDistance = 10;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform, point, event) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform, point, event);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
          .event(event)
          .start()
          .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
          .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k, p, event) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    }, p, event);
  };

  zoom.scaleTo = function(selection, k, p, event) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p,
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    }, p, event);
  };

  zoom.translateBy = function(selection, x, y, event) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    }, null, event);
  };

  zoom.translateTo = function(selection, x, y, p, event) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
      return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    }, p, event);
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, point, event) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).event(event).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).event(event).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args).event(event),
              e = extent.apply(that, args),
              p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point,
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args, clean) {
    return (!clean && that.__zooming) || new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.sourceEvent = null;
    this.extent = extent.apply(that, args);
    this.taps = 0;
  }

  Gesture.prototype = {
    event: function(event) {
      if (event) this.sourceEvent = event;
      return this;
    },
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      var d = Object(src_select["a" /* default */])(this.that).datum();
      listeners.call(
        type,
        this.that,
        new ZoomEvent(type, {
          sourceEvent: this.sourceEvent,
          target: zoom,
          type,
          transform: this.that.__zoom,
          dispatch: listeners
        }),
        d
      );
    }
  };

  function wheeled(event, ...args) {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, args).event(event),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(pointer["a" /* default */])(event);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(src["b" /* interrupt */])(this);
      g.start();
    }

    noevent(event);
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned(event, ...args) {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, args, true).event(event),
        v = Object(src_select["a" /* default */])(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(pointer["a" /* default */])(event, currentTarget),
        currentTarget = event.currentTarget,
        x0 = event.clientX,
        y0 = event.clientY;

    Object(nodrag["a" /* default */])(event.view);
    nopropagation(event);
    g.mouse = [p, this.__zoom.invert(p)];
    Object(src["b" /* interrupt */])(this);
    g.start();

    function mousemoved(event) {
      noevent(event);
      if (!g.moved) {
        var dx = event.clientX - x0, dy = event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.event(event)
       .zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(pointer["a" /* default */])(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped(event) {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(nodrag["b" /* yesdrag */])(event.view, g.moved);
      noevent(event);
      g.event(event).end();
    }
  }

  function dblclicked(event, ...args) {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(pointer["a" /* default */])(event.changedTouches ? event.changedTouches[0] : event, this),
        p1 = t0.invert(p0),
        k1 = t0.k * (event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);

    noevent(event);
    if (duration > 0) Object(src_select["a" /* default */])(this).transition().duration(duration).call(schedule, t1, p0, event);
    else Object(src_select["a" /* default */])(this).call(zoom.transform, t1, p0, event);
  }

  function touchstarted(event, ...args) {
    if (!filter.apply(this, arguments)) return;
    var touches = event.touches,
        n = touches.length,
        g = gesture(this, args, event.changedTouches.length === n).event(event),
        started, i, t, p;

    nopropagation(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(pointer["a" /* default */])(t, this);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
      else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
    }

    if (touchstarting) touchstarting = clearTimeout(touchstarting);

    if (started) {
      if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(src["b" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event),
        touches = event.changedTouches,
        n = touches.length, i, t, p, l;

    noevent(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(pointer["a" /* default */])(t, this);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;

    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event),
        touches = event.changedTouches,
        n = touches.length, i, t;

    nopropagation(event);
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else {
      g.end();
      // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
      if (g.taps === 2) {
        t = Object(pointer["a" /* default */])(t, this);
        if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
          var p = Object(src_select["a" /* default */])(this).on("dblclick.zoom");
          if (p) p.apply(this, arguments);
        }
      }
    }
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  zoom.tapDistance = function(_) {
    return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
  };

  return zoom;
});

// CONCATENATED MODULE: ./node_modules/d3-zoom/src/index.js




/***/ }),

/***/ "d989":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _exponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a7fd");


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(_exponent_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(max) - Object(_exponent_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(step)) + 1;
});


/***/ }),

/***/ "da03":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dad1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _exponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a7fd");


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(_exponent_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Math.abs(step)));
});


/***/ }),

/***/ "daf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* unused harmony export $mobx */
/* unused harmony export FlowCancellationError */
/* unused harmony export IDerivationState */
/* unused harmony export ObservableMap */
/* unused harmony export ObservableSet */
/* unused harmony export Reaction */
/* unused harmony export _allowStateChanges */
/* unused harmony export _allowStateChangesInsideComputed */
/* unused harmony export _allowStateReadsEnd */
/* unused harmony export _allowStateReadsStart */
/* unused harmony export _endAction */
/* unused harmony export _getAdministration */
/* unused harmony export _getGlobalState */
/* unused harmony export _interceptReads */
/* unused harmony export _isComputingDerivation */
/* unused harmony export _resetGlobalState */
/* unused harmony export _startAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return action; });
/* unused harmony export autorun */
/* unused harmony export comparer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computed; });
/* unused harmony export configure */
/* unused harmony export createAtom */
/* unused harmony export decorate */
/* unused harmony export entries */
/* unused harmony export extendObservable */
/* unused harmony export flow */
/* unused harmony export get */
/* unused harmony export getAtom */
/* unused harmony export getDebugName */
/* unused harmony export getDependencyTree */
/* unused harmony export getObserverTree */
/* unused harmony export has */
/* unused harmony export intercept */
/* unused harmony export isAction */
/* unused harmony export isArrayLike */
/* unused harmony export isBoxedObservable */
/* unused harmony export isComputed */
/* unused harmony export isComputedProp */
/* unused harmony export isFlowCancellationError */
/* unused harmony export isObservable */
/* unused harmony export isObservableArray */
/* unused harmony export isObservableMap */
/* unused harmony export isObservableObject */
/* unused harmony export isObservableProp */
/* unused harmony export isObservableSet */
/* unused harmony export keys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return observable; });
/* unused harmony export observe */
/* unused harmony export onBecomeObserved */
/* unused harmony export onBecomeUnobserved */
/* unused harmony export onReactionError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reaction; });
/* unused harmony export remove */
/* unused harmony export runInAction */
/* unused harmony export set */
/* unused harmony export spy */
/* unused harmony export toJS */
/* unused harmony export trace */
/* unused harmony export transaction */
/* unused harmony export untracked */
/* unused harmony export values */
/* unused harmony export when */
/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is a production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
        return dataStructure;
    }
    else if (Array.isArray(dataStructure)) {
        return new Map(dataStructure);
    }
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for (var key in dataStructure) {
            map.set(key, dataStructure[key]);
        }
        return map;
    }
    else {
        return fail("Cannot convert to map from '" + dataStructure + "'");
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if (false)
        {}
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
/**
 * Returns the following: own keys, prototype keys & own symbol keys, if they are enumerable.
 */
function getPlainObjectKeys(object) {
    var enumerables = new Set();
    for (var key in object)
        enumerables.add(key); // *all* enumerables
    Object.getOwnPropertySymbols(object).forEach(function (k) {
        if (Object.getOwnPropertyDescriptor(object, k).enumerable)
            enumerables.add(k);
    }); // *own* symbols
    // Note: this implementation is missing enumerable, inherited, symbolic property names! That would however pretty expensive to add,
    // as there is no efficient iterator that returns *all* properties
    return Array.from(enumerables);
}
function stringifyKey(key) {
    if (key && key.toString)
        return key.toString();
    else
        return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys
    ? Reflect.ownKeys
    : Object.getOwnPropertySymbols
        ? function (obj) { return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj)); }
        : /* istanbul ignore next */ Object.getOwnPropertyNames;

var $mobx = Symbol("mobx administration");
var Atom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    Atom.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom.prototype.reportObserved = function () {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function () {
        return this.name;
    };
    return Atom;
}());
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) {
        onBecomeObserved(atom, onBecomeObservedHandler);
    }
    if (onBecomeUnobservedHandler !== noop) {
        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    }
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    var e_1, _a;
    if (target[mobxDidRunLazyInitializersSymbol] === true)
        return;
    var decorators = target[mobxPendingDecorators];
    if (decorators) {
        addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
        // Build property key array from both strings and symbols
        var keys = __spread(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                {}
            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
                var inheritedDecorators = target[mobxPendingDecorators];
                addHiddenProp(target, mobxPendingDecorators, __assign({}, inheritedDecorators));
            }
            target[mobxPendingDecorators][prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) &&
        (typeof args[1] === "string" || typeof args[1] === "symbol")) ||
        (args.length === 4 && args[3] === true));
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    if (isES6Set(v))
        return observable.set(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    if (isES6Set(v))
        return observable.set(v, { name: name, deep: false });
    return fail( false &&
        false);
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false)
        {}
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {}
        var initialValue = descriptor
            ? descriptor.initializer
                ? descriptor.initializer.call(target)
                : descriptor.value
            : undefined;
        asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && Object({"NODE_ENV":"production","BASE_URL":"/"}) && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key))
        fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true, proxy: true };
    if (false) {}
    return thing;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false
            ? referenceEnhancer
            : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v)
            ? observable.array(v, arg2)
            : isES6Map(v)
                ? observable.map(v, arg2)
                : isES6Set(v)
                    ? observable.set(v, arg2)
                    : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail( false &&
        false);
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        if (o.proxy === false) {
            return extendObservable({}, props, decorators, o);
        }
        else {
            var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
            var base = extendObservable({}, undefined, undefined, o);
            var proxy = createDynamicObservableObject(base);
            extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
            return proxy;
        }
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    if (false) {}
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    asObservableObject(instance).addComputedProp(instance, propertyName, __assign({ get: get,
        set: set, context: instance }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {}
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.size > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers)
        fail( false &&
            false);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict"))
        fail( false &&
            false);
}
function checkIfStateReadsAreAllowed(observable) {
    if (false) {}
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (true)
        return;
    if (derivation.observing.length !== 0)
        return;
    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
    }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    }
    finally {
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () { }, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn, ref) {
    if (false) {}
    var res = function () {
        return executeAction(actionName, fn, ref || this, arguments);
    };
    res.isMobxAction = true;
    if (false) {}
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    }
    catch (err) {
        runInfo.error = err;
        throw err;
    }
    finally {
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy && "production" !== "production") {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) {
        fail("invalid action stack. did you forget to finish an action?");
    }
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) {
        globalState.suppressReactionErrors = true;
    }
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy && "production" !== "production") {
        spyReportEnd({ time: Date.now() - runInfo.startTime });
    }
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    }
    finally {
        globalState.computationDepth = prev;
    }
    return res;
}

var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        if (equals === void 0) { equals = comparer.default; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled() && "production" !== "production") {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy && "production" !== "production") {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ObservableValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom));
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        invariant(options.get, "missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
        }
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing)
            fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false,  false &&
                false);
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled() && "production" !== "production") {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ComputedValue;
}());
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */
        this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */
        this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */
        this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */
        this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}());
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = (function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED)
            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals());
    }
})();
function isolateGlobalState() {
    if (globalState.pendingReactions.length ||
        globalState.inBatch ||
        globalState.isRunningReactions)
        fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0)
            getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.size > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers.add(node);
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers.delete(node);
    if (observable.observers.size === 0) {
        // deleting last observer
        queueForUnobservation(observable);
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observable of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.size === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    });
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    });
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    });
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        if (requiresObservable === void 0) { requiresObservable = false; }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending &&
                        isSpyEnabled() &&
                        "production" !== "production") {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        if (this.isDisposed) {
            return;
            // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        }
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify && "production" !== "production") {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify && "production" !== "production") {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        }
        else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function isSpyEnabled() {
    return  false && false;
}
function spyReport(event) {
    if (true)
        return; // dead code elimination can do the rest
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    if (true)
        return;
    var change = __assign(__assign({}, event), { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (true)
        return;
    if (change)
        spyReport(__assign(__assign({}, change), { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    if (true) {
        console.warn("[mobx.spy] Is a no-op in production builds");
        return function () { };
    }
    else {}
}

function dontReassignFields() {
    fail( false && false);
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {}
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {}
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {}
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay
            ? function (f) { return setTimeout(f, opts.delay); }
            : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {}
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var listenersKey = hook + "Listeners";
    if (atom[listenersKey]) {
        atom[listenersKey].add(cb);
    }
    else {
        atom[listenersKey] = new Set([cb]);
    }
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail( false && false);
    return function () {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) {
                delete atom[listenersKey];
            }
        }
    };
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (reactionRequiresObservable !== undefined) {
        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    }
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) {
        globalState.computedConfigurable = !!computedConfigurable;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

function decorate(thing, decorators) {
     false &&
        false;
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function (prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
         false &&
            false;
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendObservable(target, properties, decorators, options) {
    if (false) {}
    options = asCreateObservableOptions(options);
    var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
    initializeInstance(target); // Fixes #1740
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    if (properties)
        extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
    return target;
}
function getDefaultDecoratorFromObjectOptions(options) {
    return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
}
function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
    var e_1, _a, e_2, _b;
    if (false) { var key, keys_1, keys_1_1, keys; }
    startBatch();
    try {
        var keys = ownKeys(properties);
        try {
            for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                var key = keys_2_1.value;
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
                if (false) {}
                var decorator = decorators && key in decorators
                    ? decorators[key]
                    : descriptor.get
                        ? computedDecorator
                        : defaultDecorator;
                if (false)
                    {}
                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
                )
                    Object.defineProperty(target, key, resultDescriptor);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    finally {
        endBatch();
    }
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1)
        fail( true && "Flow expects 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail( false &&
                false);
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail( false &&
            false);
    }
    if (target.dehancer !== undefined)
        return fail( false && false);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value[$mobx].values.has(property))
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail( false &&
            false);
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail( false &&
            false);
    return _isComputed(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            {}
        if (isObservableObject(value)) {
            return value[$mobx].values.has(property);
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value[$mobx] ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail( false &&
            false);
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail( false && false);
    return _isObservable(value, propName);
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj[$mobx].getKeys();
    }
    if (isObservableMap(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) { return index; });
    }
    return fail( false &&
        false);
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.values());
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail( false &&
        false);
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.entries());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail( false &&
        false);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj[$mobx];
        var existingObservable = adm.values.get(key);
        if (existingObservable) {
            adm.write(key, value);
        }
        else {
            adm.addObservableProp(key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableSet(obj)) {
        obj.add(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail( false &&
            false);
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        obj[$mobx].remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableSet(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail( false &&
            false);
    }
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        return adm.has(key);
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableSet(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail( false &&
            false);
    }
}
function get(obj, key) {
    if (!has(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail( false &&
            false);
    }
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source))
        return source;
    if (typeof source !== "object")
        return source;
    // Directly return null if source is null
    if (source === null)
        return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date)
        return source;
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source))
        keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function (value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        }
        else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function (value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        }
        else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    getPlainObjectKeys(source).forEach(function (key) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    });
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    options.detectCycles =
        options.detectCycles === undefined
            ? options.recurseEverything === true
            : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail( false &&
            false);
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        {}
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function getAdm(target) {
    return target[$mobx];
}
function isPropertyKey(val) {
    return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function (target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
            return true;
        var adm = getAdm(target);
        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
        // TODO: check performance stats!
        // if (adm.values.get(name as string)) return true
        if (isPropertyKey(name))
            return adm.has(name);
        return name in target;
    },
    get: function (target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
            return target[name];
        var adm = getAdm(target);
        var observable = adm.values.get(name);
        if (observable instanceof Atom) {
            var result = observable.get();
            if (result === undefined) {
                // This fixes #1796, because deleting a prop that has an
                // undefined value won't retrigger a observer (no visible effect),
                // the autorun wouldn't subscribe to future key changes (see also next comment)
                adm.has(name);
            }
            return result;
        }
        // make sure we start listening to future keys
        // note that we only do this here for optimization
        if (isPropertyKey(name))
            adm.has(name);
        return target[name];
    },
    set: function (target, name, value) {
        if (!isPropertyKey(name))
            return false;
        set(target, name, value);
        return true;
    },
    deleteProperty: function (target, name) {
        if (!isPropertyKey(name))
            return false;
        var adm = getAdm(target);
        adm.remove(name);
        return true;
    },
    ownKeys: function (target) {
        var adm = getAdm(target);
        adm.keysAtom.reportObserved();
        return Reflect.ownKeys(target);
    },
    preventExtensions: function (target) {
        fail("Dynamic observable objects cannot be frozen");
        return false;
    }
};
function createDynamicObservableObject(base) {
    var proxy = new Proxy(base, objectProxyTraps);
    base[$mobx].proxy = proxy;
    return proxy;
}

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = __spread((interceptable.interceptors || []));
        for (var i = 0, l = interceptors.length; i < l; i++) {
            change = interceptors[i](change);
            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
            if (!change)
                break;
        }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function (target, name) {
        if (name === $mobx)
            return target[$mobx];
        if (name === "length")
            return target[$mobx].getArrayLength();
        if (typeof name === "number") {
            return arrayExtensions.get.call(target, name);
        }
        if (typeof name === "string" && !isNaN(name)) {
            return arrayExtensions.get.call(target, parseInt(name));
        }
        if (arrayExtensions.hasOwnProperty(name)) {
            return arrayExtensions[name];
        }
        return target[name];
    },
    set: function (target, name, value) {
        if (name === "length") {
            target[$mobx].setArrayLength(value);
        }
        if (typeof name === "number") {
            arrayExtensions.set.call(target, name, value);
        }
        if (typeof name === "symbol" || isNaN(name)) {
            target[name] = value;
        }
        else {
            // numeric string
            arrayExtensions.set.call(target, parseInt(name), value);
        }
        return true;
    },
    preventExtensions: function (target) {
        fail("Observable arrays cannot be frozen");
        return false;
    }
};
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) { name = "ObservableArray@" + getNextId(); }
    if (owned === void 0) { owned = false; }
    var adm = new ObservableArrayAdministration(name, enhancer, owned);
    addHiddenFinalProp(adm.values, $mobx, adm);
    var proxy = new Proxy(adm.values, arrayTraps);
    adm.proxy = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, owned) {
        this.owned = owned;
        this.values = [];
        this.proxy = undefined;
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.proxy,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
        this.lastKnownLength += delta;
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        if (false) { var lengthDelta; }
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var arrayExtensions = {
    intercept: function (handler) {
        return this[$mobx].intercept(handler);
    },
    observe: function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        var adm = this[$mobx];
        return adm.observe(listener, fireImmediately);
    },
    clear: function () {
        return this.splice(0);
    },
    replace: function (newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(0, adm.values.length, newItems);
    },
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    toJS: function () {
        return this.slice();
    },
    toJSON: function () {
        // Used by JSON.stringify
        return this.toJS();
    },
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    splice: function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        var adm = this[$mobx];
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray(index);
            case 2:
                return adm.spliceWithArray(index, deleteCount);
        }
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    spliceWithArray: function (index, deleteCount, newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    push: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    },
    pop: function () {
        return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
    },
    shift: function () {
        return this.splice(0, 1)[0];
    },
    unshift: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    },
    reverse: function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        if (false) {}
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    },
    sort: function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (false) {}
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    },
    remove: function (value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues(adm.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    },
    get: function (index) {
        var adm = this[$mobx];
        if (adm) {
            if (index < adm.values.length) {
                adm.atom.reportObserved();
                return adm.dehanceValue(adm.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    },
    set: function (index, newValue) {
        var adm = this[$mobx];
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: adm.proxy,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    }
};
[
    "concat",
    "flat",
    "includes",
    "indexOf",
    "join",
    "lastIndexOf",
    "slice",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    // Feature detection (eg flat may not be available)
    if (typeof Array.prototype[funcName] !== "function") {
        return;
    }
    arrayExtensions[funcName] = function () {
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
});
["every", "filter", "find", "findIndex", "flatMap", "forEach", "map", "some"].forEach(function (funcName) {
    // Feature detection (eg flatMap may not be available)
    if (typeof Array.prototype[funcName] !== "function") {
        return;
    }
    arrayExtensions[funcName] = function (callback, thisArg) {
        var _this = this;
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName](function (element, index) {
            return callback.call(thisArg, element, index, _this);
        }, thisArg);
    };
});
["reduce", "reduceRight"].forEach(function (funcName) {
    arrayExtensions[funcName] = function () {
        var _this = this;
        var adm = this[$mobx];
        adm.atom.reportObserved();
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function (accumulator, currentValue, index) {
            currentValue = adm.dehanceValue(currentValue);
            return callback(accumulator, currentValue, index, _this);
        };
        return adm.values[funcName].apply(adm.values, arguments);
    };
});
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var _a;
var ObservableMapMarker = {};
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this[_a] = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        this[Symbol.toStringTag] = "Map";
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        var _this = this;
        if (!globalState.trackingDerivation)
            return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = (entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false));
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function () { return _this._hasMap.delete(key); });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            transaction(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function () {
                var _b = keys.next(), done = _b.done, value = _b.value;
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function () {
                var _b = keys.next(), done = _b.done, value = _b.value;
                return {
                    done: done,
                    value: done ? undefined : [value, self.get(value)]
                };
            }
        });
    };
    ObservableMap.prototype[(_a = $mobx, Symbol.iterator)] = function () {
        return this.entries();
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var e_1, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                callback.call(thisArg, value, key, this);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (isPlainObject(other))
                    getPlainObjectKeys(other).forEach(function (key) {
                        return _this.set(key, other[key]);
                    });
                else if (Array.isArray(other))
                    other.forEach(function (_b) {
                        var _c = __read(_b, 2), key = _c[0], value = _c[1];
                        return _this.set(key, value);
                    });
                else if (isES6Map(other)) {
                    if (other.constructor !== Map)
                        fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                    other.forEach(function (value, key) { return _this.set(key, value); });
                }
                else if (other !== null && other !== undefined)
                    fail("Cannot initialize map from " + other);
            }
            finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_2, _b;
                try {
                    for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var key = _d.value;
                        _this.delete(key);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function () {
            var e_3, _b, e_4, _c;
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            try {
                // Delete keys that don't exist in replacement map
                // if the key deletion is prevented by interceptor
                // add entry at the beginning of the result map
                for (var _d = __values(_this._data.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var key = _e.value;
                    // Concurrently iterating/deleting keys
                    // iterator should handle this correctly
                    if (!replacementMap.has(key)) {
                        var deleted = _this.delete(key);
                        // Was the key removed?
                        if (deleted) {
                            // _keysAtom.reportChanged() was already called
                            keysReportChangedCalled = true;
                        }
                        else {
                            // Delete prevented by interceptor
                            var value = _this._data.get(key);
                            orderedData.set(key, value);
                        }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                }
                finally { if (e_3) throw e_3.error; }
            }
            try {
                // Merge entries
                for (var _f = __values(replacementMap.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var _h = __read(_g.value, 2), key = _h[0], value = _h[1];
                    // We will want to know whether a new key is added
                    var keyExisted = _this._data.has(key);
                    // Add or update value
                    _this.set(key, value);
                    // The addition could have been prevent by interceptor
                    if (_this._data.has(key)) {
                        // The update could have been prevented by interceptor
                        // and also we want to preserve existing values
                        // so use value from _data map (instead of replacement map)
                        var value_1 = _this._data.get(key);
                        orderedData.set(key, value_1);
                        // Was a new key added?
                        if (!keyExisted) {
                            // _keysAtom.reportChanged() was already called
                            keysReportChangedCalled = true;
                        }
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                }
                finally { if (e_4) throw e_4.error; }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this._data.size !== orderedData.size) {
                    // If size differs, keys are definitely modified
                    _this._keysAtom.reportChanged();
                }
                else {
                    var iter1 = _this._data.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while (!next1.done) {
                        if (next1.value !== next2.value) {
                            _this._keysAtom.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this._data = orderedData;
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var e_5, _b;
        var res = {};
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                // We lie about symbol key types due to https://github.com/Microsoft/TypeScript/issues/1863
                res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            Array.from(this.keys())
                .map(function (key) { return stringifyKey(key) + ": " + ("" + _this.get(key)); })
                .join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
         false &&
            false;
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var _a$1;
var ObservableSetMarker = {};
var ObservableSet = /** @class */ (function () {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableSet@" + getNextId(); }
        this.name = name;
        this[_a$1] = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        this[Symbol.toStringTag] = "Set";
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_1, _b;
                try {
                    for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var value = _d.value;
                        _this.delete(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        });
    };
    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
        var e_2, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var value = _d.value;
                callbackFn.call(thisArg, value, value, this);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function () {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change)
                return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "add",
                    object: this,
                    newValue: value
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(change);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
        return this;
    };
    ObservableSet.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change)
                return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: value
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name }));
            transaction(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function () {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function () {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length
                    ? { value: [keys[index], values[index]], done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.keys = function () {
        return this.values();
    };
    ObservableSet.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues = Array.from(this._data.values());
        return makeIterable({
            next: function () {
                return nextIndex < observableValues.length
                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (Array.isArray(other)) {
                    _this.clear();
                    other.forEach(function (value) { return _this.add(value); });
                }
                else if (isES6Set(other)) {
                    _this.clear();
                    other.forEach(function (value) { return _this.add(value); });
                }
                else if (other !== null && other !== undefined) {
                    fail("Cannot initialize set from " + other);
                }
            }
            finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
         false &&
            false;
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function () {
        return this.name + "[ " + Array.from(this).join(", ") + " ]";
    };
    ObservableSet.prototype[(_a$1 = $mobx, Symbol.iterator)] = function () {
        return this.values();
    };
    return ObservableSet;
}());
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, values, name, defaultEnhancer) {
        if (values === void 0) { values = new Map(); }
        this.target = target;
        this.values = values;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.keysAtom = new Atom(name + ".keys");
    }
    ObservableObjectAdministration.prototype.read = function (key) {
        return this.values.get(key).get();
    };
    ObservableObjectAdministration.prototype.write = function (key, newValue) {
        var instance = this.target;
        var observable = this.values.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: this.proxy || instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this.proxy || instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.has = function (key) {
        var map = this.pendingKeys || (this.pendingKeys = new Map());
        var entry = map.get(key);
        if (entry)
            return entry.get();
        else {
            var exists = !!this.values.get(key);
            // Possible optimization: Don't have a separate map for non existing keys,
            // but store them in the values map instead, using a special symbol to denote "not existing"
            entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            map.set(key, entry);
            return entry.get(); // read to subscribe
        }
    };
    ObservableObjectAdministration.prototype.addObservableProp = function (propName, newValue, enhancer) {
        if (enhancer === void 0) { enhancer = this.defaultEnhancer; }
        var target = this.target;
        assertPropertyConfigurable(target, propName);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        var observable = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
        this.values.set(propName, observable);
        newValue = observable.value; // observableValue might have changed it
        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
        this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
    propName, options) {
        var target = this.target;
        options.name = options.name || this.name + "." + stringifyKey(propName);
        this.values.set(propName, new ComputedValue(options));
        if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName))
            Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values.has(key))
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldObservable = this.values.get(key);
            var oldValue = oldObservable && oldObservable.get();
            oldObservable && oldObservable.set(undefined);
            // notify key and keyset listeners
            this.keysAtom.reportChanged();
            this.values.delete(key);
            if (this.pendingKeys) {
                var entry = this.pendingKeys.get(key);
                if (entry)
                    entry.set(false);
            }
            // delete the prop
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: this.proxy || target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
         false &&
            false;
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.notifyPropertyAddition = function (key, newValue) {
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this.proxy || this.target,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd();
        if (this.pendingKeys) {
            var entry = this.pendingKeys.get(key);
            if (entry)
                entry.set(true);
        }
        this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var e_1, _a;
        this.keysAtom.reportObserved();
        // return Reflect.ownKeys(this.values) as any
        var res = [];
        try {
            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (value instanceof ObservableValue)
                    res.push(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return res;
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    if (Object.prototype.hasOwnProperty.call(target, $mobx))
        return target[$mobx];
     false &&
        false;
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), stringifyKey(name), defaultEnhancer);
    addHiddenProp(target, $mobx, adm);
    return adm;
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this[$mobx].read(propName);
            },
            set: function (v) {
                this[$mobx].write(propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner[$mobx];
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner[$mobx];
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: globalState.computedConfigurable,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(propName, v);
            }
        }));
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing[$mobx]);
    }
    return false;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail( false &&
                    false);
            return thing[$mobx].atom;
        }
        if (isObservableSet(thing)) {
            return thing[$mobx];
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail( false &&
                    false);
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing[$mobx])
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail( false && false);
            var observable = thing[$mobx].values.get(property);
            if (!observable)
                fail( false &&
                    false);
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing[$mobx])) {
            // disposer function
            return thing[$mobx];
        }
    }
    return fail( false && false);
}
function getAdministration(thing, property) {
    if (!thing)
        fail("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing) || isObservableSet(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing[$mobx])
        return thing[$mobx];
    fail( false && false);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) { depth = -1; }
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) {
                depth++;
            }
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    if (depth === 0) {
        return false;
    }
    else if (depth < 0) {
        depth = -1;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], depth - 1, aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.slice();
    if (isES6Map(a) || isObservableMap(a))
        return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a))
        return Array.from(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}

/**
 * (c) Michel Weststrate 2015 - 2018
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
}
catch (e) {
    var g = getGlobal();
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}
(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "production" !== "production" &&
        typeof process !== 'undefined' && Object({"NODE_ENV":"production","BASE_URL":"/"}).IGNORE_MOBX_MINIFY_WARNING !== "true") {
        // trick so it doesn't get replaced
        var varName = ["process", "env", "NODE_ENV"].join(".");
        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
}



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362"), __webpack_require__("c8ba")))

/***/ }),

/***/ "db7a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveConfig;

var _some = _interopRequireDefault(__webpack_require__("3092"));

var _mergeWith = _interopRequireDefault(__webpack_require__("2411"));

var _isFunction = _interopRequireDefault(__webpack_require__("9520"));

var _isUndefined = _interopRequireDefault(__webpack_require__("4cfe"));

var _defaults = _interopRequireDefault(__webpack_require__("95ae"));

var _map = _interopRequireDefault(__webpack_require__("dd61"));

var _get = _interopRequireDefault(__webpack_require__("9b02"));

var _toPath = _interopRequireDefault(__webpack_require__("d018"));

var _negateValue = _interopRequireDefault(__webpack_require__("e3e7"));

var _corePluginList = __webpack_require__("986d");

var _configurePlugins = _interopRequireDefault(__webpack_require__("3d77"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const configUtils = {
  negative(scale) {
    return Object.keys(scale).filter(key => scale[key] !== '0').reduce((negativeScale, key) => ({ ...negativeScale,
      [`-${key}`]: (0, _negateValue.default)(scale[key])
    }), {});
  },

  breakpoints(screens) {
    return Object.keys(screens).filter(key => typeof screens[key] === 'string').reduce((breakpoints, key) => ({ ...breakpoints,
      [`screen-${key}`]: screens[key]
    }), {});
  }

};

function value(valueToResolve, ...args) {
  return (0, _isFunction.default)(valueToResolve) ? valueToResolve(...args) : valueToResolve;
}

function mergeThemes(themes) {
  const theme = (({
    extend: _,
    ...t
  }) => t)(themes.reduce((merged, t) => {
    return (0, _defaults.default)(merged, t);
  }, {}));

  return { ...theme,
    // In order to resolve n config objects, we combine all of their `extend` properties
    // into arrays instead of objects so they aren't overridden.
    extend: themes.reduce((merged, {
      extend
    }) => {
      return (0, _mergeWith.default)(merged, extend, (mergedValue, extendValue) => {
        if ((0, _isUndefined.default)(mergedValue)) {
          return [extendValue];
        }

        if (Array.isArray(mergedValue)) {
          return [extendValue, ...mergedValue];
        }

        return [extendValue, mergedValue];
      });
    }, {})
  };
}

function mergeExtensions({
  extend,
  ...theme
}) {
  return (0, _mergeWith.default)(theme, extend, (themeValue, extensions) => {
    // The `extend` property is an array, so we need to check if it contains any functions
    if (!(0, _isFunction.default)(themeValue) && !(0, _some.default)(extensions, _isFunction.default)) {
      return { ...themeValue,
        ...Object.assign({}, ...extensions)
      };
    }

    return (resolveThemePath, utils) => ({ ...value(themeValue, resolveThemePath, utils),
      ...Object.assign({}, ...extensions.map(e => value(e, resolveThemePath, utils)))
    });
  });
}

function resolveFunctionKeys(object) {
  const resolvePath = (key, defaultValue) => {
    const path = (0, _toPath.default)(key);
    let index = 0;
    let val = object;

    while (val !== undefined && val !== null && index < path.length) {
      val = val[path[index++]];
      val = (0, _isFunction.default)(val) ? val(resolvePath, configUtils) : val;
    }

    return val === undefined ? defaultValue : val;
  };

  return Object.keys(object).reduce((resolved, key) => {
    return { ...resolved,
      [key]: (0, _isFunction.default)(object[key]) ? object[key](resolvePath, configUtils) : object[key]
    };
  }, {});
}

function extractPluginConfigs(configs) {
  let allConfigs = [];
  configs.forEach(config => {
    allConfigs = [...allConfigs, config];
    const plugins = (0, _get.default)(config, 'plugins', []);

    if (plugins.length === 0) {
      return;
    }

    plugins.forEach(plugin => {
      if (plugin.__isOptionsFunction) {
        plugin = plugin();
      }

      allConfigs = [...allConfigs, ...extractPluginConfigs([(0, _get.default)(plugin, 'config', {})])];
    });
  });
  return allConfigs;
}

function resolveVariants([firstConfig, ...variantConfigs]) {
  if (Array.isArray(firstConfig)) {
    return firstConfig;
  }

  return [firstConfig, ...variantConfigs].reverse().reduce((resolved, variants) => {
    Object.entries(variants || {}).forEach(([plugin, pluginVariants]) => {
      if ((0, _isFunction.default)(pluginVariants)) {
        resolved[plugin] = pluginVariants({
          variants(path) {
            return (0, _get.default)(resolved, path, []);
          },

          before(toInsert, variant, existingPluginVariants = (0, _get.default)(resolved, plugin, [])) {
            if (variant === undefined) {
              return [...toInsert, ...existingPluginVariants];
            }

            const index = existingPluginVariants.indexOf(variant);

            if (index === -1) {
              return [...existingPluginVariants, ...toInsert];
            }

            return [...existingPluginVariants.slice(0, index), ...toInsert, ...existingPluginVariants.slice(index)];
          },

          after(toInsert, variant, existingPluginVariants = (0, _get.default)(resolved, plugin, [])) {
            if (variant === undefined) {
              return [...existingPluginVariants, ...toInsert];
            }

            const index = existingPluginVariants.indexOf(variant);

            if (index === -1) {
              return [...toInsert, ...existingPluginVariants];
            }

            return [...existingPluginVariants.slice(0, index + 1), ...toInsert, ...existingPluginVariants.slice(index + 1)];
          },

          without(toRemove, existingPluginVariants = (0, _get.default)(resolved, plugin, [])) {
            return existingPluginVariants.filter(v => !toRemove.includes(v));
          }

        });
      } else {
        resolved[plugin] = pluginVariants;
      }
    });
    return resolved;
  }, {});
}

function resolveCorePlugins(corePluginConfigs) {
  const result = [...corePluginConfigs].reverse().reduce((resolved, corePluginConfig) => {
    if ((0, _isFunction.default)(corePluginConfig)) {
      return corePluginConfig({
        corePlugins: resolved
      });
    }

    return (0, _configurePlugins.default)(corePluginConfig, resolved);
  }, _corePluginList.corePluginList);
  return result;
}

function resolvePluginLists(pluginLists) {
  const result = [...pluginLists].reverse().reduce((resolved, pluginList) => {
    return [...resolved, ...pluginList];
  }, []);
  return result;
}

function resolveConfig(configs) {
  const allConfigs = extractPluginConfigs(configs);
  return (0, _defaults.default)({
    theme: resolveFunctionKeys(mergeExtensions(mergeThemes((0, _map.default)(allConfigs, t => (0, _get.default)(t, 'theme', {}))))),
    variants: resolveVariants(allConfigs.map(c => c.variants)),
    corePlugins: resolveCorePlugins(allConfigs.map(c => c.corePlugins)),
    plugins: resolvePluginLists(configs.map(c => (0, _get.default)(c, 'plugins', [])))
  }, ...allConfigs);
}

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc0f":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "dc57":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "dcbe":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("30c9"),
    isObjectLike = __webpack_require__("1310");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "dd61":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("7948"),
    baseIteratee = __webpack_require__("badf"),
    baseMap = __webpack_require__("97d3"),
    isArray = __webpack_require__("6747");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _dispatch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c68f");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _dispatch_js__WEBPACK_IMPORTED_MODULE_0__["a"]; });




/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e24b":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("49f4"),
    hashDelete = __webpack_require__("1efc"),
    hashGet = __webpack_require__("bbc0"),
    hashHas = __webpack_require__("7a48"),
    hashSet = __webpack_require__("2524");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "e25e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var parseIntImplementation = __webpack_require__("c20d");

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2c0":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("e2e4"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isIndex = __webpack_require__("c098"),
    isLength = __webpack_require__("b218"),
    toKey = __webpack_require__("f4d6");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e2e4":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("6747"),
    isKey = __webpack_require__("f608"),
    stringToPath = __webpack_require__("18d8"),
    toString = __webpack_require__("76dd");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "e311":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),

/***/ "e317":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
});


/***/ }),

/***/ "e360":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var d3_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("166a");
/* harmony import */ var _basis_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c84a");
/* harmony import */ var _basisClosed_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4bcd");
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b055");





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(_color_js__WEBPACK_IMPORTED_MODULE_3__[/* gamma */ "b"])(y);

  function rgb(start, end) {
    var r = color((start = Object(d3_color__WEBPACK_IMPORTED_MODULE_0__[/* rgb */ "g"])(start)).r, (end = Object(d3_color__WEBPACK_IMPORTED_MODULE_0__[/* rgb */ "g"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(_color_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(d3_color__WEBPACK_IMPORTED_MODULE_0__[/* rgb */ "g"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(_basis_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"]);
var rgbBasisClosed = rgbSpline(_basisClosed_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]);


/***/ }),

/***/ "e380":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("7b83");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "e3e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _reduceCssCalc = _interopRequireDefault(__webpack_require__("2df2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(value) {
  try {
    return (0, _reduceCssCalc.default)(`calc(${value} * -1)`);
  } catch (e) {
    return value;
  }
}

/***/ }),

/***/ "e3f8":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("656b");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e48b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ root; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Selection; });

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selector.js
var selector = __webpack_require__("6fd3");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/select.js



/* harmony default export */ var selection_select = (function(select) {
  if (typeof select !== "function") select = Object(selector["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/array.js
var array = __webpack_require__("c226");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selectorAll.js
var selectorAll = __webpack_require__("4230");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectAll.js




function arrayAll(select) {
  return function() {
    var group = select.apply(this, arguments);
    return group == null ? [] : Object(array["a" /* default */])(group);
  };
}

/* harmony default export */ var selectAll = (function(select) {
  if (typeof select === "function") select = arrayAll(select);
  else select = Object(selectorAll["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/matcher.js
var matcher = __webpack_require__("0a78");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectChild.js


var find = Array.prototype.find;

function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

/* harmony default export */ var selectChild = (function(match) {
  return this.select(match == null ? childFirst
      : childFind(typeof match === "function" ? match : Object(matcher["a" /* childMatcher */])(match)));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectChildren.js


var filter = Array.prototype.filter;

function children() {
  return this.children;
}

function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}

/* harmony default export */ var selectChildren = (function(match) {
  return this.selectAll(match == null ? children
      : childrenFilter(typeof match === "function" ? match : Object(matcher["a" /* childMatcher */])(match)));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/filter.js



/* harmony default export */ var selection_filter = (function(match) {
  if (typeof match !== "function") match = Object(matcher["b" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sparse.js
/* harmony default export */ var sparse = (function(update) {
  return new Array(update.length);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/enter.js



/* harmony default export */ var selection_enter = (function() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

// CONCATENATED MODULE: ./node_modules/d3-selection/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/data.js





function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = new Map,
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue.get(keyValues[i]) === node)) {
      exit[i] = node;
    }
  }
}

function datum(node) {
  return node.__data__;
}

/* harmony default export */ var selection_data = (function(value, key) {
  if (!arguments.length) return Array.from(this, datum);

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = Object(array["a" /* default */])(value.call(parent, parent && parent.__data__, j, parents)),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/exit.js



/* harmony default export */ var selection_exit = (function() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/join.js
/* harmony default export */ var join = (function(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/merge.js


/* harmony default export */ var selection_merge = (function(selection) {
  if (!(selection instanceof Selection)) throw new Error("invalid merge");

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/order.js
/* harmony default export */ var order = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sort.js


/* harmony default export */ var sort = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/call.js
/* harmony default export */ var call = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/nodes.js
/* harmony default export */ var nodes = (function() {
  return Array.from(this);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/node.js
/* harmony default export */ var selection_node = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/size.js
/* harmony default export */ var size = (function() {
  let size = 0;
  for (const node of this) ++size; // eslint-disable-line no-unused-vars
  return size;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/empty.js
/* harmony default export */ var empty = (function() {
  return !this.node();
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/each.js
/* harmony default export */ var each = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/namespace.js
var namespace = __webpack_require__("6cd4");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/attr.js


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ var attr = (function(name, value) {
  var fullname = Object(namespace["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selection/style.js
var style = __webpack_require__("364b");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/property.js
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ var property = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/classed.js
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ var classed = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/text.js
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ var selection_text = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/html.js
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ var html = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/raise.js
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ var selection_raise = (function() {
  return this.each(raise);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/lower.js
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ var selection_lower = (function() {
  return this.each(lower);
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/creator.js
var creator = __webpack_require__("57f5");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/append.js


/* harmony default export */ var append = (function(name) {
  var create = typeof name === "function" ? name : Object(creator["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/insert.js



function constantNull() {
  return null;
}

/* harmony default export */ var insert = (function(name, before) {
  var create = typeof name === "function" ? name : Object(creator["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(selector["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/remove.js
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ var selection_remove = (function() {
  return this.each(remove);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/clone.js
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

/* harmony default export */ var clone = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/datum.js
/* harmony default export */ var selection_datum = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/on.js
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, options: options};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ var on = (function(typename, value, options) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options));
  return this;
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/window.js
var src_window = __webpack_require__("a317");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/dispatch.js


function dispatchEvent(node, type, params) {
  var window = Object(src_window["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ var dispatch = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/iterator.js
/* harmony default export */ var iterator = (function*() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) yield node;
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/index.js



































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection_selection() {
  return new Selection([[document.documentElement]], root);
}

function selection_selection_selection() {
  return this;
}

Selection.prototype = selection_selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selectAll,
  selectChild: selectChild,
  selectChildren: selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: join,
  merge: selection_merge,
  selection: selection_selection_selection,
  order: order,
  sort: sort,
  call: call,
  nodes: nodes,
  node: selection_node,
  size: size,
  empty: empty,
  each: each,
  attr: attr,
  style: style["a" /* default */],
  property: property,
  classed: classed,
  text: selection_text,
  html: html,
  raise: selection_raise,
  lower: selection_lower,
  append: append,
  insert: insert,
  remove: selection_remove,
  clone: clone,
  datum: selection_datum,
  on: on,
  dispatch: dispatch,
  [Symbol.iterator]: iterator
};

/* harmony default export */ var src_selection = __webpack_exports__["b"] = (selection_selection);


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5383":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("2b3e");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var isObject = __webpack_require__("861d");
var aFunction = __webpack_require__("1c0b");
var anInstance = __webpack_require__("19aa");
var classof = __webpack_require__("c6b6");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e850":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "ea1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var d3_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("166a");
/* harmony import */ var _rgb_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e360");
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6730");
/* harmony import */ var _date_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1b6d");
/* harmony import */ var _number_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e317");
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("71bd");
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("90ef");
/* harmony import */ var _constant_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("c698");
/* harmony import */ var _numberArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("51de");










/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(_constant_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(b)
      : (t === "number" ? _number_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]
      : t === "string" ? ((c = Object(d3_color__WEBPACK_IMPORTED_MODULE_0__[/* default */ "e"])(b)) ? (b = c, _rgb_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]) : _string_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])
      : b instanceof d3_color__WEBPACK_IMPORTED_MODULE_0__[/* default */ "e"] ? _rgb_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]
      : b instanceof Date ? _date_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]
      : Object(_numberArray_js__WEBPACK_IMPORTED_MODULE_8__[/* isNumberArray */ "b"])(b) ? _numberArray_js__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]
      : Array.isArray(b) ? _array_js__WEBPACK_IMPORTED_MODULE_2__[/* genericArray */ "b"]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object_js__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]
      : _number_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(a, b);
});


/***/ }),

/***/ "eac5":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "eadc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),

/***/ "ec69":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("6fcd"),
    baseKeys = __webpack_require__("03dd"),
    isArrayLike = __webpack_require__("30c9");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "ec8c":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "ecc4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ uniform; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ src_int; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ normal; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ logNormal; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ bates; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ irwinHall; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ exponential; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ pareto; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ bernoulli; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ geometric; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ binomial; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ gamma; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ beta; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ weibull; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ cauchy; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ logistic; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ poisson; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ lcg; });

// CONCATENATED MODULE: ./node_modules/d3-random/src/defaultSource.js
/* harmony default export */ var defaultSource = (Math.random);

// CONCATENATED MODULE: ./node_modules/d3-random/src/uniform.js


/* harmony default export */ var uniform = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/int.js


/* harmony default export */ var src_int = ((function sourceRandomInt(source) {
  function randomInt(min, max) {
    if (arguments.length < 2) max = min, min = 0;
    min = Math.floor(min);
    max = Math.floor(max) - min;
    return function() {
      return Math.floor(source() * max + min);
    };
  }

  randomInt.source = sourceRandomInt;

  return randomInt;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/normal.js


/* harmony default export */ var normal = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/logNormal.js



/* harmony default export */ var logNormal = ((function sourceRandomLogNormal(source) {
  var N = normal.source(source);

  function randomLogNormal() {
    var randomNormal = N.apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/irwinHall.js


/* harmony default export */ var irwinHall = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    if ((n = +n) <= 0) return () => 0;
    return function() {
      for (var sum = 0, i = n; i > 1; --i) sum += source();
      return sum + i * source();
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/bates.js



/* harmony default export */ var bates = ((function sourceRandomBates(source) {
  var I = irwinHall.source(source);

  function randomBates(n) {
    // use limiting distribution at n === 0
    if ((n = +n) === 0) return source;
    var randomIrwinHall = I(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/exponential.js


/* harmony default export */ var exponential = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log1p(-source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/pareto.js


/* harmony default export */ var pareto = ((function sourceRandomPareto(source) {
  function randomPareto(alpha) {
    if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
    alpha = 1 / -alpha;
    return function() {
      return Math.pow(1 - source(), alpha);
    };
  }

  randomPareto.source = sourceRandomPareto;

  return randomPareto;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/bernoulli.js


/* harmony default export */ var bernoulli = ((function sourceRandomBernoulli(source) {
  function randomBernoulli(p) {
    if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
    return function() {
      return Math.floor(source() + p);
    };
  }

  randomBernoulli.source = sourceRandomBernoulli;

  return randomBernoulli;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/geometric.js


/* harmony default export */ var geometric = ((function sourceRandomGeometric(source) {
  function randomGeometric(p) {
    if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
    if (p === 0) return () => Infinity;
    if (p === 1) return () => 1;
    p = Math.log1p(-p);
    return function() {
      return 1 + Math.floor(Math.log1p(-source()) / p);
    };
  }

  randomGeometric.source = sourceRandomGeometric;

  return randomGeometric;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/gamma.js



/* harmony default export */ var gamma = ((function sourceRandomGamma(source) {
  var randomNormal = normal.source(source)();

  function randomGamma(k, theta) {
    if ((k = +k) < 0) throw new RangeError("invalid k");
    // degenerate distribution if k === 0
    if (k === 0) return () => 0;
    theta = theta == null ? 1 : +theta;
    // exponential distribution if k === 1
    if (k === 1) return () => -Math.log1p(-source()) * theta;

    var d = (k < 1 ? k + 1 : k) - 1 / 3,
        c = 1 / (3 * Math.sqrt(d)),
        multiplier = k < 1 ? () => Math.pow(source(), 1 / k) : () => 1;
    return function() {
      do {
        do {
          var x = randomNormal(),
              v = 1 + c * x;
        } while (v <= 0);
        v *= v * v;
        var u = 1 - source();
      } while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
      return d * v * multiplier() * theta;
    };
  }

  randomGamma.source = sourceRandomGamma;

  return randomGamma;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/beta.js



/* harmony default export */ var beta = ((function sourceRandomBeta(source) {
  var G = gamma.source(source);

  function randomBeta(alpha, beta) {
    var X = G(alpha),
        Y = G(beta);
    return function() {
      var x = X();
      return x === 0 ? 0 : x / (x + Y());
    };
  }

  randomBeta.source = sourceRandomBeta;

  return randomBeta;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/binomial.js




/* harmony default export */ var binomial = ((function sourceRandomBinomial(source) {
  var G = geometric.source(source),
      B = beta.source(source);

  function randomBinomial(n, p) {
    n = +n;
    if ((p = +p) >= 1) return () => n;
    if (p <= 0) return () => 0;
    return function() {
      var acc = 0, nn = n, pp = p;
      while (nn * pp > 16 && nn * (1 - pp) > 16) {
        var i = Math.floor((nn + 1) * pp),
            y = B(i, nn - i + 1)();
        if (y <= pp) {
          acc += i;
          nn -= i;
          pp = (pp - y) / (1 - y);
        } else {
          nn = i - 1;
          pp /= y;
        }
      }
      var sign = pp < 0.5,
          pFinal = sign ? pp : 1 - pp,
          g = G(pFinal);
      for (var s = g(), k = 0; s <= nn; ++k) s += g();
      return acc + (sign ? k : nn - k);
    };
  }

  randomBinomial.source = sourceRandomBinomial;

  return randomBinomial;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/weibull.js


/* harmony default export */ var weibull = ((function sourceRandomWeibull(source) {
  function randomWeibull(k, a, b) {
    var outerFunc;
    if ((k = +k) === 0) {
      outerFunc = x => -Math.log(x);
    } else {
      k = 1 / k;
      outerFunc = x => Math.pow(x, k);
    }
    a = a == null ? 0 : +a;
    b = b == null ? 1 : +b;
    return function() {
      return a + b * outerFunc(-Math.log1p(-source()));
    };
  }

  randomWeibull.source = sourceRandomWeibull;

  return randomWeibull;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/cauchy.js


/* harmony default export */ var cauchy = ((function sourceRandomCauchy(source) {
  function randomCauchy(a, b) {
    a = a == null ? 0 : +a;
    b = b == null ? 1 : +b;
    return function() {
      return a + b * Math.tan(Math.PI * source());
    };
  }

  randomCauchy.source = sourceRandomCauchy;

  return randomCauchy;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/logistic.js


/* harmony default export */ var logistic = ((function sourceRandomLogistic(source) {
  function randomLogistic(a, b) {
    a = a == null ? 0 : +a;
    b = b == null ? 1 : +b;
    return function() {
      var u = source();
      return a + b * Math.log(u / (1 - u));
    };
  }

  randomLogistic.source = sourceRandomLogistic;

  return randomLogistic;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/poisson.js




/* harmony default export */ var poisson = ((function sourceRandomPoisson(source) {
  var G = gamma.source(source),
      B = binomial.source(source);

  function randomPoisson(lambda) {
    return function() {
      var acc = 0, l = lambda;
      while (l > 16) {
        var n = Math.floor(0.875 * l),
            t = G(n)();
        if (t > l) return acc + B(n - 1, l / t)();
        acc += n;
        l -= t;
      }
      for (var s = -Math.log1p(-source()), k = 0; s <= l; ++k) s -= Math.log1p(-source());
      return acc + k;
    };
  }

  randomPoisson.source = sourceRandomPoisson;

  return randomPoisson;
})(defaultSource));

// CONCATENATED MODULE: ./node_modules/d3-random/src/lcg.js
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const mul = 0x19660D;
const inc = 0x3C6EF35F;
const eps = 1 / 0x100000000;

function lcg(seed = Math.random()) {
  let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
  return () => (state = mul * state + inc | 0, eps * (state >>> 0));
}

// CONCATENATED MODULE: ./node_modules/d3-random/src/index.js




















/***/ }),

/***/ "edfa":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "eecb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tickIncrement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tickStep; });
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    step = -step;
    start = Math.ceil(start * step);
    stop = Math.floor(stop * step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),

/***/ "ef5d":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "efb6":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f1df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_arc; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ src_area; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ src_line; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ src_pie; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ areaRadial; });
__webpack_require__.d(__webpack_exports__, "C", function() { return /* reexport */ areaRadial; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ src_lineRadial; });
__webpack_require__.d(__webpack_exports__, "D", function() { return /* reexport */ src_lineRadial; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* reexport */ pointRadial; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ linkHorizontal; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ linkVertical; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ linkRadial; });
__webpack_require__.d(__webpack_exports__, "Q", function() { return /* reexport */ src_symbol; });
__webpack_require__.d(__webpack_exports__, "Y", function() { return /* reexport */ symbols; });
__webpack_require__.d(__webpack_exports__, "R", function() { return /* reexport */ circle; });
__webpack_require__.d(__webpack_exports__, "S", function() { return /* reexport */ cross; });
__webpack_require__.d(__webpack_exports__, "T", function() { return /* reexport */ diamond; });
__webpack_require__.d(__webpack_exports__, "U", function() { return /* reexport */ square; });
__webpack_require__.d(__webpack_exports__, "V", function() { return /* reexport */ star; });
__webpack_require__.d(__webpack_exports__, "W", function() { return /* reexport */ triangle; });
__webpack_require__.d(__webpack_exports__, "X", function() { return /* reexport */ wye; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ basisClosed; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ basisOpen; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ basis; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ curve_bundle; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ cardinalClosed; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ cardinalOpen; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ cardinal; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ catmullRomClosed; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ catmullRomOpen; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ curve_catmullRom; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ linearClosed; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ linear; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ monotoneX; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ monotoneY; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ natural; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ step; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ stepAfter; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ stepBefore; });
__webpack_require__.d(__webpack_exports__, "E", function() { return /* reexport */ src_stack; });
__webpack_require__.d(__webpack_exports__, "G", function() { return /* reexport */ expand; });
__webpack_require__.d(__webpack_exports__, "F", function() { return /* reexport */ diverging; });
__webpack_require__.d(__webpack_exports__, "H", function() { return /* reexport */ none; });
__webpack_require__.d(__webpack_exports__, "I", function() { return /* reexport */ silhouette; });
__webpack_require__.d(__webpack_exports__, "J", function() { return /* reexport */ wiggle; });
__webpack_require__.d(__webpack_exports__, "K", function() { return /* reexport */ appearance; });
__webpack_require__.d(__webpack_exports__, "L", function() { return /* reexport */ ascending; });
__webpack_require__.d(__webpack_exports__, "M", function() { return /* reexport */ order_descending; });
__webpack_require__.d(__webpack_exports__, "N", function() { return /* reexport */ insideOut; });
__webpack_require__.d(__webpack_exports__, "O", function() { return /* reexport */ order_none; });
__webpack_require__.d(__webpack_exports__, "P", function() { return /* reexport */ reverse; });

// EXTERNAL MODULE: ./node_modules/d3-path/src/path.js
var path = __webpack_require__("eadc");

// CONCATENATED MODULE: ./node_modules/d3-shape/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function constant() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/math.js
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/arc.js




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ var src_arc = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(path["a" /* default */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/array.js
var slice = Array.prototype.slice;

/* harmony default export */ var array = (function(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ var linear = (function(context) {
  return new Linear(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/point.js
function point_x(p) {
  return p[0];
}

function point_y(p) {
  return p[1];
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/line.js






/* harmony default export */ var src_line = (function(x, y) {
  var defined = constant(true),
      context = null,
      curve = linear,
      output = null;

  x = typeof x === "function" ? x : (x === undefined) ? point_x : constant(x);
  y = typeof y === "function" ? y : (y === undefined) ? point_y : constant(y);

  function line(data) {
    var i,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(path["a" /* default */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/area.js







/* harmony default export */ var src_area = (function(x0, y0, y1) {
  var x1 = null,
      defined = constant(true),
      context = null,
      curve = linear,
      output = null;

  x0 = typeof x0 === "function" ? x0 : (x0 === undefined) ? point_x : constant(+x0);
  y0 = typeof y0 === "function" ? y0 : (y0 === undefined) ? constant(0) : constant(+y0);
  y1 = typeof y1 === "function" ? y1 : (y1 === undefined) ? point_y : constant(+y1);

  function area(data) {
    var i,
        j,
        k,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(path["a" /* default */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return src_line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/descending.js
/* harmony default export */ var descending = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/identity.js
/* harmony default export */ var identity = (function(d) {
  return d;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/pie.js






/* harmony default export */ var src_pie = (function() {
  var value = identity,
      sortValues = descending,
      sort = null,
      startAngle = constant(0),
      endAngle = constant(tau),
      padAngle = constant(0);

  function pie(data) {
    var i,
        n = (data = array(data)).length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
  };

  return pie;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/radial.js


var curveRadialLinear = curveRadial(linear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/lineRadial.js



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ var src_lineRadial = (function() {
  return lineRadial(src_line().curve(curveRadialLinear));
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/areaRadial.js




/* harmony default export */ var areaRadial = (function() {
  var a = src_area().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/pointRadial.js
/* harmony default export */ var pointRadial = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/link/index.js






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link_link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = point_x,
      y = point_y,
      context = null;

  function link() {
    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(path["a" /* default */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function link_curveRadial(context, x0, y0, x1, y1) {
  var p0 = pointRadial(x0, y0),
      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
      p2 = pointRadial(x1, y0),
      p3 = pointRadial(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link_link(curveHorizontal);
}

function linkVertical() {
  return link_link(curveVertical);
}

function linkRadial() {
  var l = link_link(link_curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/circle.js


/* harmony default export */ var circle = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/cross.js
/* harmony default export */ var cross = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/diamond.js
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ var diamond = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/star.js


var ka = 0.89081309152928522810,
    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
    kx = Math.sin(tau / 10) * kr,
    ky = -Math.cos(tau / 10) * kr;

/* harmony default export */ var star = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/square.js
/* harmony default export */ var square = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/triangle.js
var sqrt3 = Math.sqrt(3);

/* harmony default export */ var triangle = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/wye.js
var wye_c = -0.5,
    wye_s = Math.sqrt(3) / 2,
    wye_k = 1 / Math.sqrt(12),
    wye_a = (wye_k / 2 + 1) * 3;

/* harmony default export */ var wye = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / wye_a),
        x0 = r / 2,
        y0 = r * wye_k,
        x1 = x0,
        y1 = r * wye_k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(wye_c * x0 - wye_s * y0, wye_s * x0 + wye_c * y0);
    context.lineTo(wye_c * x1 - wye_s * y1, wye_s * x1 + wye_c * y1);
    context.lineTo(wye_c * x2 - wye_s * y2, wye_s * x2 + wye_c * y2);
    context.lineTo(wye_c * x0 + wye_s * y0, wye_c * y0 - wye_s * x0);
    context.lineTo(wye_c * x1 + wye_s * y1, wye_c * y1 - wye_s * x1);
    context.lineTo(wye_c * x2 + wye_s * y2, wye_c * y2 - wye_s * x2);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol.js










var symbols = [
  circle,
  cross,
  diamond,
  square,
  star,
  triangle,
  wye
];

/* harmony default export */ var src_symbol = (function(type, size) {
  var context = null;
  type = typeof type === "function" ? type : constant(type || circle);
  size = typeof size === "function" ? size : constant(size === undefined ? 64 : +size);

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(path["a" /* default */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/noop.js
/* harmony default export */ var noop = (function() {});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/basis.js
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ var basis = (function(context) {
  return new Basis(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/basisClosed.js



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ var basisClosed = (function(context) {
  return new BasisClosed(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/basisOpen.js


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ var basisOpen = (function(context) {
  return new BasisOpen(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/bundle.js


function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ var curve_bundle = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/cardinal.js
function cardinal_point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: cardinal_point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: cardinal_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var cardinal = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/cardinalClosed.js



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: cardinal_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var cardinalClosed = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/cardinalOpen.js


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: cardinal_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var cardinalOpen = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/catmullRom.js



function catmullRom_point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: catmullRom_point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var curve_catmullRom = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/catmullRomClosed.js




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: catmullRom_point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var catmullRomClosed = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/catmullRomOpen.js



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: catmullRom_point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var catmullRomOpen = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/linearClosed.js


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ var linearClosed = (function(context) {
  return new LinearClosed(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/monotone.js
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function monotone_point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: monotone_point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; monotone_point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: monotone_point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/natural.js
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ var natural = (function(context) {
  return new Natural(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/step.js
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ var step = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/none.js
/* harmony default export */ var none = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/none.js
/* harmony default export */ var order_none = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/stack.js





function stackValue(d, key) {
  return d[key];
}

function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}

/* harmony default export */ var src_stack = (function() {
  var keys = constant([]),
      order = order_none,
      offset = none,
      value = stackValue;

  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries),
        i, n = sz.length, j = -1,
        oz;

    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }

    for (i = 0, oz = array(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(Array.from(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? order_none : typeof _ === "function" ? _ : constant(Array.from(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
  };

  return stack;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/expand.js


/* harmony default export */ var expand = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none(series, order);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/diverging.js
/* harmony default export */ var diverging = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/silhouette.js


/* harmony default export */ var silhouette = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none(series, order);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/wiggle.js


/* harmony default export */ var wiggle = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none(series, order);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/appearance.js


/* harmony default export */ var appearance = (function(series) {
  var peaks = series.map(peak);
  return order_none(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
});

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/ascending.js


/* harmony default export */ var ascending = (function(series) {
  var sums = series.map(ascending_sum);
  return order_none(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function ascending_sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/descending.js


/* harmony default export */ var order_descending = (function(series) {
  return ascending(series).reverse();
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/insideOut.js



/* harmony default export */ var insideOut = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(ascending_sum),
      order = appearance(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/reverse.js


/* harmony default export */ var reverse = (function(series) {
  return order_none(series).reverse();
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/index.js




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!










































/***/ }),

/***/ "f37c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _path_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eadc");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _path_js__WEBPACK_IMPORTED_MODULE_0__["a"]; });




/***/ }),

/***/ "f3c1":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "f4d6":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("ffd6");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f608":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("6747"),
    isSymbol = __webpack_require__("ffd6");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "f623":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcHours; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var utcHour = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationHour */ "b"]);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationHour */ "b"];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),

/***/ "f748":
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.github.io/ecma262/#sec-math.sign
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f8af":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("2474");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "f8ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMinutes; });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18e2");
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1738");



var utcMinute = Object(_interval_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"]);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__[/* durationMinute */ "c"];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),

/***/ "f909":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    assignMergeValue = __webpack_require__("b760"),
    baseFor = __webpack_require__("72af"),
    baseMergeDeep = __webpack_require__("4f50"),
    isObject = __webpack_require__("1a8c"),
    keysIn = __webpack_require__("9934"),
    safeGet = __webpack_require__("8adb");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "f9ce":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("ef5d"),
    basePropertyDeep = __webpack_require__("e3f8"),
    isKey = __webpack_require__("f608"),
    toKey = __webpack_require__("f4d6");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "fa21":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("7530"),
    getPrototype = __webpack_require__("2dcb"),
    isPrototype = __webpack_require__("eac5");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "runCovid", function() { return /* reexport */ runCovid; });
__webpack_require__.d(__webpack_exports__, "drawLegend", function() { return /* reexport */ drawLegend; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("2b0e");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/BigChartCardView/BigChartCardView.vue?vue&type=template&id=657117e7&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$screens.mobile)?_c('div',{staticClass:"big-chart-card flex flex-col sm:rounded",attrs:{"id":_vm.containerID}},[_c('div',{staticClass:"h-full relative"},[_c('BigCardHeader',{attrs:{"metric":_vm.metric,"fips":_vm.currentFips,"scale":_vm.colourScale,"not-scaled":_vm.notScaled,"show-exact-number":_vm.showExactNumber,"default-colour":_vm.defaultColour,"date":_vm.date,"date-line":_vm.dateLine,"tooltip-content":_vm.tooltipContent}}),_c('Tabs',{attrs:{"tabs":_vm.tabs,"selected":_vm.selectedTab,"learn-more":_vm.learnMore},on:{"click":_vm.onTabClick}}),_c('div',{staticClass:"self-start px-8"},[_c('DeltaMessage',{attrs:{"metric":_vm.metric,"fips":_vm.currentFips,"date":_vm.date,"delta-colour":_vm.deltaColour,"invert-scale":_vm.invertScale,"custom-auto-text":_vm.customAutoText,"show-exact-number":_vm.showExactNumber,"national-only":_vm.noStates,"include-category":true}})],1),_c('div',{staticClass:"chart-ratio relative"},[_c('DHAChart',{attrs:{"data":_vm.chartData,"chart-options":_vm.chartOptions,"start-loading":true,"on-draw":_vm.onDraw,"hovered-fips":_vm.hoveredFips,"hovered-category":_vm.hoveredCategory,"should-draw":!_vm.$screens.mobile},on:{"hover":_vm.onSpaghettiHover,"state-data-loaded":_vm.onStateDataLoaded,"click":_vm.onSpaghettiClick,"point":_vm.onTooltipData,"finish-draw":_vm.colourHovered}})],1),_c('Sources',{style:({ width: '95%' }),attrs:{"data":_vm.allData}}),(_vm.drawerEnabled)?_c('BigCardDrawer',{attrs:{"model":_vm.model,"single-select":_vm.singleSelectOnly}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/views/BigChartCardView/BigChartCardView.vue?vue&type=template&id=657117e7&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BigCardHeader/BigCardHeader.vue?vue&type=template&id=bf5efe12&scoped=true&
var BigCardHeadervue_type_template_id_bf5efe12_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-card-header flex p-2 md:p-6 justify-between"},[_c('div',[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"header-title text-xl font-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.tooltipContent)?_c('InfoTooltip',{staticClass:"self-center",attrs:{"content":_vm.tooltipContent},scopedSlots:_vm._u([{key:"button",fn:function(buttonProps){return [_c('InfoBubble',_vm._b({},'InfoBubble',buttonProps,false))]}},{key:"content",fn:function(contentProps){return [_c('BigCardTooltip',_vm._b({},'BigCardTooltip',contentProps,false))]}}],null,false,1974711606)}):_vm._e()],1),_c('div',{staticClass:"header-subtitle text-sm pt-1"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])]),_c('div',{staticClass:"flex flex-col items-end"},[_c('div',{staticClass:"big-card-date text-xs pb-1 font-bold"},[_vm._v(" "+_vm._s(_vm.dateLine)+" ")]),_c('Delta',{attrs:{"font-size":'2rem',"line-height":'2rem',"values":_vm.deltaValue,"type":_vm.deltaType,"colour":_vm.deltaColour,"show-exact-number":_vm.showExactNumber}}),_c('div',{staticClass:"big-delta-caption flex justify-end items-end whitespace-no-wrap pt-1",class:{
                'flex-col': _vm.captionBreak,
                'flex-row': !_vm.captionBreak
            }},[_c('div',{staticClass:"text-xs pr-1",class:{
                    'font-semibold': _vm.deltaCaption.timePeriod === '',
                }},[_vm._v(" "+_vm._s(_vm.deltaCaption.prefix || '\xa0')+" ")]),_c('div',{staticClass:"big-delta-time-period text-xs font-bold"},[_vm._v(" "+_vm._s(_vm.deltaCaption.timePeriod)+" ")])])],1)])}
var BigCardHeadervue_type_template_id_bf5efe12_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BigCardHeader/BigCardHeader.vue?vue&type=template&id=bf5efe12&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__("0d03");

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("6dd8");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Delta/Delta.vue?vue&type=template&id=1d0602ca&scoped=true&
var Deltavue_type_template_id_1d0602ca_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"delta-arrow flex-none mr-1",style:({
            transform: ("scale(1, " + _vm.arrowDirection + ")"),
            display: _vm.arrowDisplay
        })},[_c('svg',{staticClass:"delta-arrow",attrs:{"viewBox":"0 -1 22 28","width":"100%","height":"100%","fill":"none"}},[_c('path',{attrs:{"d":_vm.arrowHeadPoints,"fill":_vm.arrowColour}}),_c('path',{attrs:{"d":_vm.arrowBodyPoints,"fill":_vm.arrowColour}})])]),_c('div',{staticClass:"delta font-bold whitespace-no-wrap",style:({ color: _vm.colour })},[_vm._v(" "+_vm._s(_vm.deltaValue)+" ")])])}
var Deltavue_type_template_id_1d0602ca_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Delta/Delta.vue?vue&type=template&id=1d0602ca&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat-map.js
var es_array_flat_map = __webpack_require__("5db7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__("26e9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
var es_array_unscopables_flat_map = __webpack_require__("73d9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__("2af1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.parse-int.js
var es_number_parse_int = __webpack_require__("25eb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.is-array.js
var es_array_is_array = __webpack_require__("277d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js








function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("2ef0");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/d3/dist/package.js
var package_name = "d3";
var version = "6.2.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "dist/d3.node.js";
var unpkg = "dist/d3.min.js";
var jsdelivr = "dist/d3.min.js";
var package_module = "index.js";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var files = ["dist/**/*.js","index.js"];
var scripts = {"pretest":"rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c","test":"tape 'test/**/*-test.js'","prepublishOnly":"yarn test","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"};
var devDependencies = {"json2module":"0.0","rimraf":"3","rollup":"2","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"5","rollup-plugin-terser":"7","tape":"4","tape-await":"0.1"};
var dependencies = {"d3-array":"2","d3-axis":"2","d3-brush":"2","d3-chord":"2","d3-color":"2","d3-contour":"2","d3-delaunay":"5","d3-dispatch":"2","d3-drag":"2","d3-dsv":"2","d3-ease":"2","d3-fetch":"2","d3-force":"2","d3-format":"2","d3-geo":"2","d3-hierarchy":"2","d3-interpolate":"2","d3-path":"2","d3-polygon":"2","d3-quadtree":"2","d3-random":"2","d3-scale":"3","d3-scale-chromatic":"2","d3-selection":"2","d3-shape":"2","d3-time":"2","d3-time-format":"3","d3-timer":"2","d3-transition":"2","d3-zoom":"2"};

// EXTERNAL MODULE: ./node_modules/d3-brush/src/index.js + 4 modules
var d3_brush_src = __webpack_require__("5f8f");

// EXTERNAL MODULE: ./node_modules/d3-scale/src/index.js + 22 modules
var d3_scale_src = __webpack_require__("ce24");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/index.js + 4 modules
var d3_selection_src = __webpack_require__("fd32");

// EXTERNAL MODULE: ./node_modules/d3-transition/src/index.js + 28 modules
var d3_transition_src = __webpack_require__("b108");

// EXTERNAL MODULE: ./node_modules/d3-zoom/src/index.js + 5 modules
var d3_zoom_src = __webpack_require__("d934");

// CONCATENATED MODULE: ./node_modules/d3/index.js
































// EXTERNAL MODULE: ./node_modules/@usafacts/frontend-library-metrics/dist/usafacts-metrics.js
var usafacts_metrics = __webpack_require__("8ff4");

// CONCATENATED MODULE: ./src/util/helpers.ts


























var STATE_CODES = {
  '01': 'Alabama',
  '02': 'Alaska',
  '04': 'Arizona',
  '05': 'Arkansas',
  '06': 'California',
  '08': 'Colorado',
  '09': 'Connecticut',
  10: 'Delaware',
  11: 'District of Columbia',
  12: 'Florida',
  13: 'Georgia',
  15: 'Hawaii',
  16: 'Idaho',
  17: 'Illinois',
  18: 'Indiana',
  19: 'Iowa',
  20: 'Kansas',
  21: 'Kentucky',
  22: 'Louisiana',
  23: 'Maine',
  24: 'Maryland',
  25: 'Massachusetts',
  26: 'Michigan',
  27: 'Minnesota',
  28: 'Mississippi',
  29: 'Missouri',
  30: 'Montana',
  31: 'Nebraska',
  32: 'Nevada',
  33: 'New Hampshire',
  34: 'New Jersey',
  35: 'New Mexico',
  36: 'New York',
  37: 'North Carolina',
  38: 'North Dakota',
  39: 'Ohio',
  40: 'Oklahoma',
  41: 'Oregon',
  42: 'Pennsylvania',
  44: 'Rhode Island',
  45: 'South Carolina',
  46: 'South Dakota',
  47: 'Tennessee',
  48: 'Texas',
  49: 'Utah',
  50: 'Vermont',
  51: 'Virginia',
  53: 'Washington',
  54: 'West Virginia',
  55: 'Wisconsin',
  56: 'Wyoming'
};
function matchesFips(toMatch, fips) {
  return fips === toMatch || fips === 'US' && toMatch === '00' || fips === '00' && toMatch === 'US';
}
var monthToIdx = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
  '01': 0,
  '02': 1,
  '03': 2,
  '04': 3,
  '05': 4,
  '06': 5,
  '07': 6,
  '08': 7,
  '09': 8,
  10: 9,
  11: 10,
  12: 11,
  q1: 0,
  q2: 3,
  q3: 6,
  q4: 9
};
var monthToQuarter = {
  jan: 'Q1',
  feb: 'Q1',
  mar: 'Q1',
  apr: 'Q2',
  may: 'Q2',
  jun: 'Q2',
  jul: 'Q3',
  aug: 'Q3',
  sep: 'Q3',
  oct: 'Q4',
  nov: 'Q4',
  dec: 'Q4'
};
var helpers_dateParser = function dateParser(date) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';

  try {
    var parsedDate = null;

    if (type.toLowerCase() === 'months' || type.toLowerCase() === 'monthly' || type.toLowerCase() === 'quarters' || type.toLowerCase() === 'quarterly') {
      var _date$split = date.split(/[ -/]/),
          _date$split2 = _slicedToArray(_date$split, 2),
          month = _date$split2[0],
          year = _date$split2[1];

      if (monthToIdx[month.toLowerCase()] !== undefined) {
        parsedDate = new Date(Date.UTC(Number(year), monthToIdx[month.toLowerCase()]));
      } else {
        parsedDate = new Date(Date.UTC(Number(year), Number(month)));
      }
    } else if (type.toLowerCase() === 'days' || type.toLowerCase() === 'daily') {
      var _date$split3 = date.split(/[ -/]/),
          _date$split4 = _slicedToArray(_date$split3, 3),
          _year = _date$split4[0],
          _month = _date$split4[1],
          day = _date$split4[2];

      var parsedDay = day ? Number.parseInt(day, 10) : 1; // parseInt so we catch eg '1st'

      if (monthToIdx[_month.toLowerCase()] !== undefined) {
        parsedDate = new Date(Date.UTC(Number(_year), monthToIdx[_month.toLowerCase()], parsedDay));
      } else {
        parsedDate = new Date(Date.UTC(Number(_year), Number(_month), parsedDay));
      }
    } else {
      parsedDate = new Date(Date.UTC(Number(date), 0));
    }

    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    throw new Error("Date ".concat(date, " is invalid"));
  }

  throw new Error("Date ".concat(date, " is invalid"));
};
var helpers_dateFormat = function dateFormat(date) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';

  var _date$toUTCString$spl = date.toUTCString().split(' '),
      _date$toUTCString$spl2 = _slicedToArray(_date$toUTCString$spl, 4),
      day = _date$toUTCString$spl2[1],
      month = _date$toUTCString$spl2[2],
      year = _date$toUTCString$spl2[3];

  if (type.toLowerCase() === 'months' || type.toLowerCase() === 'months') {
    return "".concat(month, " ").concat(year);
  }

  if (type.toLowerCase() === 'quarters' || type.toLowerCase() === 'quarterly') {
    return "".concat(monthToQuarter[month.toLowerCase()], " ").concat(year);
  }

  if (type.toLowerCase() === 'days' || type.toLowerCase() === 'daily') {
    return "".concat(month, " ").concat(day.replace(/^0+/, ''), ", ").concat(year);
  }

  return year;
};
var helpers_shortXTick = function shortXTick(tick, i) {
  var _tick$toLocaleDateStr = tick.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    month: 'long',
    day: 'numeric'
  }).split(' '),
      _tick$toLocaleDateStr2 = _slicedToArray(_tick$toLocaleDateStr, 2),
      month = _tick$toLocaleDateStr2[0],
      day = _tick$toLocaleDateStr2[1];

  if (day === '1') {
    if (month === 'January') {
      // start of a year (January 1 -> 2020)
      return tick.getUTCFullYear().toString();
    } // start of a month (August -> A)


    return month[0];
  }

  if (i === 0) {
    // add month to first tick (August 23 -> A 23)
    return "".concat(month[0], " ").concat(day);
  } // day number (August 23 -> 23)


  return day;
};
var helpers_niceXDomain = function niceXDomain(chartData) {
  var dates = chartData.data.flatMap(function (d) {
    return d.metric.datasets.flatMap(function (dd) {
      return dd.data.map(function (_ref) {
        var key = _ref.key;
        return helpers_dateParser(key, dd.x_type || dd.xType);
      });
    });
  });

  var start = lodash_default.a.min(dates);

  var end = lodash_default.a.max(dates);

  if (start === undefined || end === undefined) {
    return {
      start: start,
      end: end,
      niceDomain: undefined
    };
  }

  if (start.getUTCDate() <= 15) {
    start = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth()));
  }

  if (end.getUTCDate() > 15) {
    end = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1));
  }

  return {
    start: lodash_default.a.min(dates),
    end: lodash_default.a.max(dates),
    niceDomain: [start, end]
  };
};

var helpers_keyToMonthYear = function keyToMonthYear(key, xType) {
  var minus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var date = helpers_dateParser(key, xType);

  if (xType.toLowerCase() === 'quarters' || xType.toLowerCase() === 'quarterly') {
    var _date$toUTCString$spl3 = date.toUTCString().split(' '),
        _date$toUTCString$spl4 = _slicedToArray(_date$toUTCString$spl3, 3),
        _month2 = _date$toUTCString$spl4[2];

    return "".concat(monthToQuarter[_month2.toLowerCase()], " ").concat(date.getUTCFullYear() - minus);
  }

  var options = {
    timeZone: 'UTC',
    month: 'long'
  };
  var includeDay = xType.toLowerCase() === 'days' || xType.toLowerCase() === 'daily';

  if (includeDay) {
    options.day = 'numeric';
  }

  var month = date.toLocaleDateString('en-US', options);
  return "".concat(month).concat(includeDay ? ',' : '', " ").concat(date.getUTCFullYear() - minus);
};

var helpers_getDeltaCaption = function getDeltaCaption(dataset, xType, metadata, lastPeriodDate) {
  if (metadata === undefined) {
    return {
      prefix: '',
      timePeriod: ''
    };
  }

  var changeIndex = metadata.changeIndex,
      displayUnits = metadata.displayUnits;

  if (metadata.changeIndex === 'null' || metadata.changeIndex === null) {
    return {
      prefix: displayUnits.toLowerCase() || '',
      timePeriod: ''
    };
  }

  if (changeIndex === 'firstPeriod') {
    var firstDateDatum = lodash_default()(dataset.data).filter(function (_ref2) {
      var value = _ref2.value;
      return value !== null && value !== undefined;
    }).minBy(function (_ref3) {
      var key = _ref3.key;
      return helpers_dateParser(key, xType);
    });

    if (firstDateDatum === undefined) {
      return {
        prefix: '',
        timePeriod: ''
      };
    }

    return {
      prefix: 'from',
      timePeriod: helpers_keyToMonthYear(firstDateDatum.key, xType)
    };
  }

  var lastTwoDates = lodash_default()(dataset.data) // .filter(({ value }) => value !== null && value !== undefined)
  .sortBy(function (_ref4) {
    var key = _ref4.key;
    return helpers_dateParser(key, xType);
  }).filter(function (_ref5) {
    var key = _ref5.key;
    if (!lastPeriodDate) return true;
    return helpers_dateParser(key, xType).getTime() <= lastPeriodDate.getTime();
  }).slice(-2).value();

  if (changeIndex === 'lastYear') {
    if (lastTwoDates.length === 0) {
      return {
        prefix: '',
        timePeriod: ''
      };
    }

    return {
      prefix: 'compared to',
      timePeriod: helpers_keyToMonthYear(lastTwoDates.slice(-1)[0].key, xType, 1)
    };
  } // lastPeriod


  if (lastTwoDates.length < 2) {
    return {
      prefix: '',
      timePeriod: ''
    };
  }

  return {
    prefix: 'from',
    timePeriod: helpers_keyToMonthYear(lastTwoDates[0].key, xType, 0)
  };
};
var deltaIndices = {
  lastPeriod: [-2, -1],
  firstPeriod: [0, -1],
  lastYear: [-13, -1],
  "null": [null, -1],
  undefined: [null, -1]
};

var getIndexOffset = function getIndexOffset(originalIndex, values, dateIndex) {
  return originalIndex - values.length + dateIndex + 1;
};

var getDeltaIndices = function getDeltaIndices(values, metadata, xType, date) {
  // the indices from the data we would grab if a manual date is not set
  var nonDateIndices = deltaIndices[String(metadata === null || metadata === void 0 ? void 0 : metadata.changeIndex)];
  var indices = nonDateIndices || [null, -1];

  if (date) {
    // find the date in the sorted values
    var dateIndex = values.findIndex(function (_ref6) {
      var key = _ref6.key;
      return date.getTime() === helpers_dateParser(key, xType).getTime();
    });

    if (dateIndex === 0) {
      indices = [null, dateIndex];
    } else if ((metadata === null || metadata === void 0 ? void 0 : metadata.changeIndex) === 'firstPeriod') {
      // offset indices[1]
      indices = [0, getIndexOffset(indices[1], values, dateIndex)];
    } else {
      // offset indices so they compare to the manually set date
      indices = [indices[0] !== null ? getIndexOffset(indices[0], values, dateIndex) : null, getIndexOffset(indices[1], values, dateIndex)];
    }
  }

  return {
    indices: indices,
    // delta values that do not compare to a previous date do not have a direction (eg. nominal metrics)
    giveDirection: indices[0] !== null
  };
};

var helpers_getDeltaParams = function getDeltaParams(metric, metadata, options) {
  if (metric.data.length === 0) return undefined;

  var _ref7 = options || {
    date: null
  },
      date = _ref7.date;

  if (metric.data.length === 1) {
    return {
      value: metric.data.slice(-1)[0].value,
      previous: undefined,
      percent: undefined,
      direction: undefined
    };
  }

  var compareValues = lodash_default.a.sortBy(metric.data, function (_ref8) {
    var key = _ref8.key;
    return helpers_dateParser(key, metric.xType || metric.x_type);
  });

  var _getDeltaIndices = getDeltaIndices(compareValues, metadata, metric.xType || metric.x_type, date),
      indices = _getDeltaIndices.indices,
      giveDirection = _getDeltaIndices.giveDirection;

  var value = compareValues.slice(indices[1])[0].value;

  if (indices[0] === null) {
    return {
      value: value,
      previous: undefined,
      percent: value,
      direction: giveDirection ? Math.sign(value) : undefined
    };
  }

  var previous = compareValues.slice(indices[0])[0].value;
  var percent = (value - previous) / Math.abs(previous);
  return {
    value: value,
    previous: previous,
    percent: (metadata === null || metadata === void 0 ? void 0 : metadata.transformation.toLowerCase()) === 'pctchange' ? value : percent,
    direction: giveDirection ? Math.sign(value) : undefined
  };
};
var getDeltaColour = function getDeltaColour(defaultColour, notScaled, params, scale) {
  if (!params || !scale) return defaultColour;
  var value = params.value;
  if (notScaled || value === undefined) return defaultColour;
  return scale(value) || defaultColour;
};

function getUnifiedScale(min, max, range) {
  var scale = d3_scale_src["o" /* scaleQuantize */]().domain([min, max]).range(range);
  return function (value) {
    return scale(value);
  };
}

function getSplitScale(min, max, range) {
  var posScale = d3_scale_src["o" /* scaleQuantize */]().domain([0, Math.max(0, max)]).range(range.slice(Math.ceil(range.length / 2)));
  var negScale = d3_scale_src["o" /* scaleQuantize */]().domain([Math.min(0, min), 0]).range(range.slice(0, range.length / 2));
  return function (value) {
    return value < 0 ? negScale(value) : posScale(value);
  };
}

var helpers_getColourScale = function getColourScale(metric, palette, invert, centerZero) {
  var data = metric.datasets[0].data.map(function (d) {
    return d.value;
  });

  var min = lodash_default.a.min(data);

  var max = lodash_default.a.max(data);

  if (min === undefined || max === undefined) return undefined;
  var preparedPalette = invert ? lodash_default.a.reverse(lodash_default.a.clone(palette)) : palette;

  if (centerZero) {
    return getSplitScale(min, max, preparedPalette);
  }

  return getUnifiedScale(min, max, preparedPalette);
};
var helpers_getIndexScale = function getIndexScale(metric, length, invert, centerZero) {
  var data = metric.datasets[0].data.map(function (d) {
    return d.value;
  });

  var min = lodash_default.a.min(data);

  var max = lodash_default.a.max(data);

  if (min === undefined || max === undefined) return undefined;
  var indices = Array(length).fill(0).map(function (d, i) {
    return i;
  });
  if (invert) indices.reverse();

  if (centerZero) {
    return getSplitScale(min, max, indices);
  }

  return getUnifiedScale(min, max, indices);
};
var helpers_getLinearScale = function getLinearScale(metric, centerZero) {
  var data = metric.datasets[0].data.map(function (d) {
    return d.value;
  });

  var min = lodash_default.a.min(data);

  var max = lodash_default.a.max(data);

  if (min === undefined || max === undefined) return undefined;

  if (centerZero) {
    var posScale = d3_scale_src["i" /* scaleLinear */]().domain([0, Math.max(0, max)]).range([0.5, 1]);
    var negScale = d3_scale_src["i" /* scaleLinear */]().domain([Math.min(0, min), 0]).range([0, 0.5]);
    return function (value) {
      return value < 0 ? negScale(value) : posScale(value);
    };
  }

  var scale = d3_scale_src["i" /* scaleLinear */]().domain([min, max]).range([0, 1]);
  return function (value) {
    return scale(value);
  };
};
var getSubtitle = function getSubtitle(metadata, dataset, title, metricTitle) {
  var formFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'small';
  var childName = '';
  var compareTitle = title === (metadata === null || metadata === void 0 ? void 0 : metadata.displayName) ? metricTitle : title;

  if (dataset && dataset.name.toLowerCase() !== compareTitle.toLowerCase()) {
    childName = dataset.name;
  }

  if (metadata && metadata.transformation !== 'null' && metadata.transformation !== 'nominal') {
    if (formFactor !== 'tiny') {
      return "".concat(childName ? "".concat(childName, " \u2014 ") : '').concat(metadata === null || metadata === void 0 ? void 0 : metadata.shortName);
    }

    return "".concat(childName ? "".concat(childName) : '');
  }

  return childName;
};
function treeIsMultilevel(tree) {
  for (var _i = 0, _Object$keys = Object.keys(tree); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (_typeof(tree[key]) === 'object') {
      return true;
    }
  }

  return false;
}
function getDataValueFromDate(dataset, date) {
  var value = null;

  if (date && dataset) {
    value = lodash_default.a.find(dataset.data, function (d) {
      return date.getTime() === helpers_dateParser(d.key, dataset.x_type).getTime();
    });
  }

  return value ? value.value : null;
}
var helpers_getFormat = function getFormat(type) {
  var lowerType = type.toLowerCase();
  var hasFormat = Object.prototype.hasOwnProperty.call(usafacts_metrics["VALUE_FORMATS"], lowerType);

  if (hasFormat) {
    return usafacts_metrics["VALUE_FORMATS"][lowerType];
  }

  return usafacts_metrics["VALUE_FORMATS"]["default"];
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/Delta/Delta.ts?vue&type=script&lang=ts&





/* harmony default export */ var Deltavue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    values: {
      type: Object,
      "default": function _default() {
        return {
          value: undefined,
          previous: undefined,
          percent: undefined,
          direction: undefined
        };
      }
    },
    type: {
      type: String,
      "default": 'Items'
    },
    colour: {
      type: String,
      "default": 'black'
    },
    colourArrow: {
      type: Boolean,
      "default": true
    },
    showExactNumber: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      arrowHeadPoints: 'M21.991 11.0246L19.6925 13.303L10.9953 4.68056L2.29804 13.303L-0.000488181 11.0246L10.9953 0.126955L21.991 11.0246Z',
      arrowBodyPoints: 'M9.08086 24.0693L9.08086 3.83008L12.7696 3.83008L12.7696 24.0693L9.08086 24.0693Z'
    };
  },
  computed: {
    deltaValue: function deltaValue() {
      var value = this.values.value;

      if (value === undefined) {
        return '--';
      }

      var format = helpers_getFormat(this.type);
      return this.showExactNumber ? format(value, {
        truncate: false
      }) : format(value);
    },
    arrowDisplay: function arrowDisplay() {
      var direction = this.values.direction;
      return direction ? 'initial' : 'none';
    },
    arrowDirection: function arrowDirection() {
      var direction = this.values.direction;
      return direction || 1;
    },
    arrowColour: function arrowColour() {
      return this.colourArrow ? this.colour : '#4D4D4D';
    }
  },
  methods: {}
}));
// CONCATENATED MODULE: ./src/components/Delta/Delta.ts?vue&type=script&lang=ts&
 /* harmony default export */ var Delta_Deltavue_type_script_lang_ts_ = (Deltavue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Delta/Delta.vue?vue&type=style&index=0&id=1d0602ca&lang=postcss&scoped=true&
var Deltavue_type_style_index_0_id_1d0602ca_lang_postcss_scoped_true_ = __webpack_require__("3671");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/Delta/Delta.vue






/* normalize component */

var component = normalizeComponent(
  Delta_Deltavue_type_script_lang_ts_,
  Deltavue_type_template_id_1d0602ca_scoped_true_render,
  Deltavue_type_template_id_1d0602ca_scoped_true_staticRenderFns,
  false,
  null,
  "1d0602ca",
  null
  
)

/* harmony default export */ var Delta = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/InfoTooltip/InfoBubble.vue?vue&type=template&id=b467aaa0&scoped=true&
var InfoBubblevue_type_template_id_b467aaa0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"h-full mx-2 cursor-pointer",attrs:{"viewBox":"0 0 24 24","width":"18px","height":"18px","fill":_vm.bubbleFill}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"}})])}
var InfoBubblevue_type_template_id_b467aaa0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/InfoTooltip/InfoBubble.vue?vue&type=template&id=b467aaa0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/InfoTooltip/InfoBubble.ts?vue&type=script&lang=ts&

/* harmony default export */ var InfoBubblevue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    hovered: {
      type: Boolean,
      "default": false
    },
    clicked: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    bubbleFill: function bubbleFill() {
      return this.hovered || this.clicked ? '#BBBBBB' : '#CCCCCC';
    }
  }
}));
// CONCATENATED MODULE: ./src/components/InfoTooltip/InfoBubble.ts?vue&type=script&lang=ts&
 /* harmony default export */ var InfoTooltip_InfoBubblevue_type_script_lang_ts_ = (InfoBubblevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/InfoTooltip/InfoBubble.vue





/* normalize component */

var InfoBubble_component = normalizeComponent(
  InfoTooltip_InfoBubblevue_type_script_lang_ts_,
  InfoBubblevue_type_template_id_b467aaa0_scoped_true_render,
  InfoBubblevue_type_template_id_b467aaa0_scoped_true_staticRenderFns,
  false,
  null,
  "b467aaa0",
  null
  
)

/* harmony default export */ var InfoBubble = (InfoBubble_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/InfoTooltip/InfoTooltip.vue?vue&type=template&id=642b5c0d&scoped=true&
var InfoTooltipvue_type_template_id_642b5c0d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseOutButton,"touchend":_vm.onTouch}},[_vm._t("button",null,{"hovered":_vm.infoHovered})],2),(_vm.infoHovered)?_c('div',{staticClass:"info-tooltip absolute z-20 bg-white px-3 py-1",style:(_vm.position),on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseOutTooltip}},[(_vm.title)?_c('div',{staticClass:"info-title font-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"info-body"},[_vm._t("content",null,{"content":_vm.content})],2)]):_vm._e()])}
var InfoTooltipvue_type_template_id_642b5c0d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/InfoTooltip/InfoTooltip.vue?vue&type=template&id=642b5c0d&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("18a5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__("1d1c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__("7a82");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js











function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/InfoTooltip/InfoTooltip.ts?vue&type=script&lang=ts&




/* harmony default export */ var InfoTooltipvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    title: {
      type: String,
      "default": null
    },
    dx: {
      type: String,
      "default": '0'
    },
    dy: {
      type: String,
      "default": '0'
    },
    anchor: {
      type: String,
      "default": 'left'
    },
    content: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      infoHovered: false
    };
  },
  computed: {
    position: function position() {
      var transform = {
        transform: "translate(".concat(this.dx, ", ").concat(this.dy, ")")
      };

      if (this.anchor === 'right') {
        return _objectSpread2(_objectSpread2({}, transform), {}, {
          right: '0'
        });
      }

      return _objectSpread2(_objectSpread2({}, transform), {}, {
        left: '0'
      });
    }
  },
  methods: {
    onTouch: function onTouch() {
      this.infoHovered = !this.infoHovered;
    },
    onMouseOver: function onMouseOver() {
      this.infoHovered = true;
    },
    onMouseOutButton: function onMouseOutButton(e) {
      if (window.TouchEvent && e instanceof TouchEvent) {
        this.infoHovered = false;
      } else {
        var buttonBox = this.$el.getBoundingClientRect();

        if (e.clientY < Math.floor(buttonBox.bottom)) {
          this.infoHovered = false;
        }
      }
    },
    onMouseOutTooltip: function onMouseOutTooltip() {
      this.infoHovered = false;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/InfoTooltip/InfoTooltip.ts?vue&type=script&lang=ts&
 /* harmony default export */ var InfoTooltip_InfoTooltipvue_type_script_lang_ts_ = (InfoTooltipvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/InfoTooltip/InfoTooltip.vue?vue&type=style&index=0&id=642b5c0d&lang=postcss&scoped=true&
var InfoTooltipvue_type_style_index_0_id_642b5c0d_lang_postcss_scoped_true_ = __webpack_require__("b8df");

// CONCATENATED MODULE: ./src/components/InfoTooltip/InfoTooltip.vue






/* normalize component */

var InfoTooltip_component = normalizeComponent(
  InfoTooltip_InfoTooltipvue_type_script_lang_ts_,
  InfoTooltipvue_type_template_id_642b5c0d_scoped_true_render,
  InfoTooltipvue_type_template_id_642b5c0d_scoped_true_staticRenderFns,
  false,
  null,
  "642b5c0d",
  null
  
)

/* harmony default export */ var InfoTooltip = (InfoTooltip_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BigCardTooltip/BigCardTooltip.vue?vue&type=template&id=4994a5de&scoped=true&
var BigCardTooltipvue_type_template_id_4994a5de_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-card-tooltip mb-2"},_vm._l((_vm.filteredContent),function(items,key){return _c('div',{key:key,staticClass:"mb-2"},[_c('div',{staticClass:"big-tooltip-title uppercase tracking-widest mb-1 font-semibold"},[_vm._v(" "+_vm._s(key)+" ")]),_vm._l((items),function(item,i){return _c('div',{key:i},[(item.url)?_c('a',{attrs:{"href":item.url}},[_vm._v(" "+_vm._s(item.text)+" ")]):_c('div',[_vm._v(" "+_vm._s(item.text)+" ")])])})],2)}),0)}
var BigCardTooltipvue_type_template_id_4994a5de_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BigCardTooltip/BigCardTooltip.vue?vue&type=template&id=4994a5de&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/BigCardTooltip/BigCardTooltip.ts?vue&type=script&lang=ts&


/* harmony default export */ var BigCardTooltipvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    content: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  computed: {
    filteredContent: function filteredContent() {
      return lodash_default.a.pickBy(this.content, function (v) {
        return v.length > 0;
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/BigCardTooltip/BigCardTooltip.ts?vue&type=script&lang=ts&
 /* harmony default export */ var BigCardTooltip_BigCardTooltipvue_type_script_lang_ts_ = (BigCardTooltipvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/BigCardTooltip/BigCardTooltip.vue?vue&type=style&index=0&id=4994a5de&lang=postcss&scoped=true&
var BigCardTooltipvue_type_style_index_0_id_4994a5de_lang_postcss_scoped_true_ = __webpack_require__("2fa9");

// CONCATENATED MODULE: ./src/components/BigCardTooltip/BigCardTooltip.vue






/* normalize component */

var BigCardTooltip_component = normalizeComponent(
  BigCardTooltip_BigCardTooltipvue_type_script_lang_ts_,
  BigCardTooltipvue_type_template_id_4994a5de_scoped_true_render,
  BigCardTooltipvue_type_template_id_4994a5de_scoped_true_staticRenderFns,
  false,
  null,
  "4994a5de",
  null
  
)

/* harmony default export */ var BigCardTooltip = (BigCardTooltip_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/BigCardHeader/BigCardHeader.ts?vue&type=script&lang=ts&












/* harmony default export */ var BigCardHeadervue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    Delta: Delta,
    InfoBubble: InfoBubble,
    InfoTooltip: InfoTooltip,
    BigCardTooltip: BigCardTooltip
  },
  props: {
    metric: {
      type: Object,
      "default": function _default() {
        return {
          metric: {
            name: '',
            datasets: []
          }
        };
      }
    },
    fips: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    scale: {
      type: Function,
      "default": null
    },
    notScaled: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    defaultColour: {
      type: String,
      "default": function _default() {
        return 'black';
      }
    },
    date: {
      type: Date,
      "default": null
    },
    dateLine: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    tooltipContent: {
      type: Object,
      "default": function _default() {
        return null;
      }
    },
    showExactNumber: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      captionBreak: false
    };
  },
  computed: {
    dataset: function dataset() {
      var _this = this;

      if (this.metric.metric.datasets.length === 0) return undefined;
      var fipsSet = this.metric.metric.datasets.find(function (dataset) {
        return matchesFips(_this.fips, dataset.geoId || dataset.geo_id);
      });
      return fipsSet || undefined;
    },
    title: function title() {
      return this.metric.metric.name;
    },
    subtitle: function subtitle() {
      if (this.dataset && this.dataset.name.toLowerCase() !== this.title.toLowerCase()) {
        return this.dataset.name;
      }

      return '';
    },
    metadata: function metadata() {
      return this.metric.metric.metadata;
    },
    footnote: function footnote() {
      var _this$metadata;

      return (_this$metadata = this.metadata) === null || _this$metadata === void 0 ? void 0 : _this$metadata.footnote;
    },
    deltaValue: function deltaValue() {
      var dset = this.dataset;
      if (!dset) return undefined;
      return helpers_getDeltaParams(dset, this.metadata, {
        date: this.date
      });
    },
    deltaType: function deltaType() {
      var _this$dataset, _this$dataset2;

      return ((_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.yType) || ((_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.y_type);
    },
    deltaCaption: function deltaCaption() {
      if (!this.dataset) return {
        prefix: '',
        timePeriod: ''
      };
      var xType = this.dataset.xType || this.dataset.x_type || 'Items';

      if (this.date) {
        return helpers_getDeltaCaption(this.dataset, xType, this.metadata, this.date);
      }

      return helpers_getDeltaCaption(this.dataset, xType, this.metadata);
    },
    deltaColour: function deltaColour() {
      var scale = this.scale;
      return getDeltaColour(this.defaultColour, this.notScaled, this.deltaValue, scale);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var ro = new ResizeObserver_es["a" /* default */](function (entries) {
      entries.forEach(function () {
        requestAnimationFrame(function () {
          _this2.setCaptionBreak();
        });
      });
    });
    ro.observe(this.$el);
  },
  methods: {
    setCaptionBreak: function setCaptionBreak() {
      if (this.deltaCaption.prefix.length > 5 && this.$el.getBoundingClientRect().width < 500) {
        this.captionBreak = true;
      } else {
        this.captionBreak = false;
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/BigCardHeader/BigCardHeader.ts?vue&type=script&lang=ts&
 /* harmony default export */ var BigCardHeader_BigCardHeadervue_type_script_lang_ts_ = (BigCardHeadervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/BigCardHeader/BigCardHeader.vue?vue&type=style&index=0&id=bf5efe12&lang=postcss&scoped=true&
var BigCardHeadervue_type_style_index_0_id_bf5efe12_lang_postcss_scoped_true_ = __webpack_require__("44b1");

// CONCATENATED MODULE: ./src/components/BigCardHeader/BigCardHeader.vue






/* normalize component */

var BigCardHeader_component = normalizeComponent(
  BigCardHeader_BigCardHeadervue_type_script_lang_ts_,
  BigCardHeadervue_type_template_id_bf5efe12_scoped_true_render,
  BigCardHeadervue_type_template_id_bf5efe12_scoped_true_staticRenderFns,
  false,
  null,
  "bf5efe12",
  null
  
)

/* harmony default export */ var BigCardHeader = (BigCardHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DHAChart/DHAChart.vue?vue&type=template&id=d0176724&
var DHAChartvue_type_template_id_d0176724_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dha-chart w-full h-full box-border flex-1"})}
var DHAChartvue_type_template_id_d0176724_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DHAChart/DHAChart.vue?vue&type=template&id=d0176724&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/DHAChart/DHAChart.ts?vue&type=script&lang=ts&






/* harmony default export */ var DHAChartvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    chartOptions: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    dataSelector: {
      type: Function,
      "default": null
    },
    startLoading: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    onDraw: {
      type: Function,
      "default": null
    },
    hoveredFips: {
      type: String,
      "default": null
    },
    hoveredCategory: {
      type: String,
      "default": null
    },
    shouldDraw: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      chart: null,
      recentHeight: 0,
      didFirstLoading: false,
      didFirstDraw: false
    };
  },
  computed: {
    optsWithSelector: function optsWithSelector() {
      return _objectSpread2(_objectSpread2({}, this.chartOptions), {}, {
        dataSelector: this.dataSelector
      });
    },
    optsSkipTransition: function optsSkipTransition() {
      return _objectSpread2(_objectSpread2({}, this.optsWithSelector), {}, {
        transition: false
      });
    }
  },
  watch: {
    optsWithSelector: function optsWithSelector(newOpts, oldOpts) {
      if (JSON.stringify(newOpts) !== JSON.stringify(oldOpts)) {
        this.drawChart();
      }
    },
    data: function data() {
      this.drawChart();
    },
    hoveredFips: function hoveredFips() {
      this.setHovered(this.hoveredFips);
    },
    hoveredCategory: function hoveredCategory() {
      this.setHovered(this.hoveredCategory);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.chart = new usafacts_metrics["Chart"](this.$el);

    if (this.shouldDraw) {
      this.drawChart();
    }

    this.recentHeight = this.$el.getBoundingClientRect().height;
    var ro = new ResizeObserver_es["a" /* default */](function (entries) {
      entries.forEach(function () {
        requestAnimationFrame(function () {
          var height = _this.$el.getBoundingClientRect().height;

          if (height !== _this.recentHeight) {
            _this.recentHeight = height;

            if (_this.shouldDraw) {
              _this.drawChart(true);
            }
          }
        });
      });
    });
    ro.observe(this.$el);
  },
  methods: {
    drawChart: function drawChart() {
      var _this2 = this;

      var skipTransition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.chart) {
        if (!this.didFirstLoading && this.startLoading) {
          this.chart.setLoading();
        }

        this.didFirstLoading = true;

        if (this.data.data) {
          var opts = skipTransition ? this.optsSkipTransition : this.optsWithSelector;
          this.chart.draw(this.data, opts);

          if (this.onDraw && !this.didFirstDraw && this.chart.chart) {
            this.onDraw(this.$el);
          }

          this.didFirstDraw = true;
        }

        if (this.chart.chart) {
          this.chart.chart.on('dataLoaded', function (d) {
            _this2.$emit('state-data-loaded', d);
          });
          this.chart.chart.on('point', function (d) {
            _this2.$emit('point', d);
          });
          this.chart.chart.on('hover', function (d) {
            _this2.$emit('hover', d);
          });
          this.chart.chart.on('click', function (d) {
            if (_this2.chartOptions.chartType !== 9) {
              _this2.$emit('click', d);
            }
          });
        }

        this.$emit('finish-draw');
      }
    },
    setHovered: function setHovered(selector) {
      var _this$chart;

      if (this.chartOptions.chartType !== 9 && ((_this$chart = this.chart) === null || _this$chart === void 0 ? void 0 : _this$chart.chart.setHovered)) {
        this.chart.chart.setHovered(selector);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/DHAChart/DHAChart.ts?vue&type=script&lang=ts&
 /* harmony default export */ var DHAChart_DHAChartvue_type_script_lang_ts_ = (DHAChartvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/DHAChart/DHAChart.vue?vue&type=style&index=0&lang=postcss&
var DHAChartvue_type_style_index_0_lang_postcss_ = __webpack_require__("6db8");

// CONCATENATED MODULE: ./src/components/DHAChart/DHAChart.vue






/* normalize component */

var DHAChart_component = normalizeComponent(
  DHAChart_DHAChartvue_type_script_lang_ts_,
  DHAChartvue_type_template_id_d0176724_render,
  DHAChartvue_type_template_id_d0176724_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DHAChart = (DHAChart_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Tabs/Tabs.vue?vue&type=template&id=29812017&scoped=true&
var Tabsvue_type_template_id_29812017_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-outer mb-2 lg:mb-6"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"tabs-container ml-8",class:{ 'scrolling': !_vm.arrowsHidden }},_vm._l((_vm.tabs),function(tab,i){return _c('a',{key:(tab + "-" + i),class:{ 'tabs-tab': true, 'is-active': i === _vm.selected },on:{"click":function($event){return _vm.onClick(i)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0),(_vm.learnMoreParams)?_c('InfoTooltip',{staticClass:"mx-6",attrs:{"content":_vm.learnMoreParams,"anchor":'right'},scopedSlots:_vm._u([{key:"button",fn:function(buttonProps){return [_c('a',{staticClass:"tabs-tab learn-more",class:{ hovered: buttonProps.hovered || buttonProps.clicked }},[_vm._v(" Learn More ")])]}},{key:"content",fn:function(contentProps){return [_c('BigCardTooltip',_vm._b({},'BigCardTooltip',contentProps,false))]}}],null,false,1674386772)}):_vm._e()],1),_c('a',{staticClass:"tabs-prev block w-4 h-4 text-gray-500 absolute -mt-2",class:{ 'arrow-hidden': _vm.arrowsHidden },on:{"click":_vm.onAdjustLeft}},[_c('svg',{staticClass:"tabs-arrow w-4 h-4 fill-current",attrs:{"viewBox":"0 0 100 100","width":"100%","height":"100%"}},[_c('polygon',{attrs:{"points":_vm.arrowPoints}})])]),_c('a',{staticClass:"tabs-next block w-4 h-4 text-gray-500 absolute -mt-2",class:{ 'arrow-hidden': _vm.arrowsHidden },on:{"click":_vm.onAdjustRight}},[_c('svg',{staticClass:"tabs-arrow w-4 h-4 fill-current",attrs:{"viewBox":"0 0 100 100","width":"100%","height":"100%"}},[_c('polygon',{attrs:{"points":_vm.arrowPoints}})])])])}
var Tabsvue_type_template_id_29812017_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Tabs/Tabs.vue?vue&type=template&id=29812017&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/Tabs/Tabs.ts?vue&type=script&lang=ts&







/* harmony default export */ var Tabsvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    BigCardTooltip: BigCardTooltip,
    InfoTooltip: InfoTooltip
  },
  props: {
    tabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    selected: {
      type: Number,
      "default": null
    },
    learnMore: {
      type: Object,
      "default": null
    }
  },
  data: function data() {
    return {
      arrowPoints: '50,74.4 10,34.4 18.8,25.6 50,56.8 81.2,25.6 90,34.4',
      arrowsHidden: true
    };
  },
  computed: {
    learnMoreParams: function learnMoreParams() {
      if (this.learnMore && (this.learnMore.articles && this.learnMore.articles.length > 0 || this.learnMore.data && this.learnMore.data.length > 0 || this.learnMore.visualizations && this.learnMore.visualizations.length > 0)) {
        return this.learnMore;
      }

      return null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var ro = new ResizeObserver_es["a" /* default */](function (entries) {
      entries.forEach(function () {
        requestAnimationFrame(function () {
          _this.setArrowVisibility();
        });
      });
    });
    ro.observe(this.$el.querySelector('.tabs-container') || this.$el);
  },
  methods: {
    onClick: function onClick(tab) {
      this.$emit('click', tab);
    },
    onAdjustLeft: function onAdjustLeft() {
      var container = this.$el.querySelector('.tabs-container');

      if (container) {
        container.scrollLeft -= 100;
      }
    },
    onAdjustRight: function onAdjustRight() {
      var container = this.$el.querySelector('.tabs-container');

      if (container) {
        container.scrollLeft += 100;
      }
    },
    setArrowVisibility: function setArrowVisibility() {
      var scroller = this.$el.querySelector('.tabs-container');

      if (scroller && scroller.scrollWidth > scroller.clientWidth) {
        this.arrowsHidden = false;
      } else {
        this.arrowsHidden = true;
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/Tabs/Tabs.ts?vue&type=script&lang=ts&
 /* harmony default export */ var Tabs_Tabsvue_type_script_lang_ts_ = (Tabsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Tabs/Tabs.vue?vue&type=style&index=0&id=29812017&lang=postcss&scoped=true&
var Tabsvue_type_style_index_0_id_29812017_lang_postcss_scoped_true_ = __webpack_require__("58a0");

// CONCATENATED MODULE: ./src/components/Tabs/Tabs.vue






/* normalize component */

var Tabs_component = normalizeComponent(
  Tabs_Tabsvue_type_script_lang_ts_,
  Tabsvue_type_template_id_29812017_scoped_true_render,
  Tabsvue_type_template_id_29812017_scoped_true_staticRenderFns,
  false,
  null,
  "29812017",
  null
  
)

/* harmony default export */ var Tabs = (Tabs_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/BigCardDrawer/BigCardDrawer.vue?vue&type=template&id=3ace17c3&scoped=true&
var BigCardDrawervue_type_template_id_3ace17c3_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-card-drawer w-full flex flex-col pt-4"},[_c('div',{staticClass:"button-wrapper flex flex-row justify-between"},[_c('div',{staticClass:"flex flex-row flex-1"},[(_vm.drawerOpen && !_vm.singleSelect)?_c('div',{staticClass:"compare-buttons flex flex-row flex-1 md:flex-initial items-center justify-center h-10 pb-2"},[_c('p',{staticClass:"text-xs md:text-base md:pr-4"},[_vm._v(" Compare: ")]),(_vm.isStateDataLoaded)?_c('div',{staticClass:"compare-button flex items-center ml-1 md:mr-4 px-2 md:px-4 uppercase h-full cursor-pointer",class:{
                        'compare-selected': _vm.model.compareBy === _vm.compareLeft.by,
                    },on:{"click":function($event){return _vm.onCompareClick(_vm.compareLeft.by)}}},[_c('div',{staticClass:"compare-indicator mr-2 md:mr-4 w-4 h-4",class:{
                            'compare-selected': _vm.model.compareBy === _vm.compareLeft.by,
                        }}),_c('div',[_vm._v(_vm._s(_vm.compareLeft.text))])]):_vm._e(),(_vm.hasCategories)?_c('div',{staticClass:"compare-button flex items-center ml-1 md:mr-4 px-2 md:px-4 uppercase h-full cursor-pointer",class:{
                        'compare-selected': _vm.model.compareBy === _vm.compareRight.by,
                    },on:{"click":function($event){return _vm.onCompareClick(_vm.compareRight.by)}}},[_c('div',{staticClass:"compare-indicator mr-2 md:mr-4 w-4 h-4",class:{
                            'compare-selected': _vm.model.compareBy === _vm.compareRight.by,
                        }}),_c('div',[_vm._v(_vm._s(_vm.compareRight.text))])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"flex-0 md:flex-1"})])]),_c('div',{staticClass:"drawer-div"},[_c('div',{staticClass:"drawer-button-div compare-buttons flex flex-row z-10",class:{
                'cursor-pointer': _vm.drawerActive,
                'absolute': _vm.drawerOpen,
                'p-3': !_vm.drawerOpen,
                'm-3': _vm.drawerOpen
            },on:{"click":_vm.toggleButton}},[_c('div',{staticClass:"drawer-button flex items-center rounded-full text-center align-top justify-center",class:{ 'opacity-25': !_vm.drawerActive }},[_c('svg',{staticClass:"button-x align-middle m-auto",style:({ display: _vm.displayX }),attrs:{"viewBox":"0 0 14 14","width":"14","height":"14"}},[_c('path',{attrs:{"d":_vm.xPoints,"fill":"#969696"}})]),_c('svg',{staticClass:"button-v align-middle m-auto",style:({ display: _vm.displayV }),attrs:{"viewBox":"0 0 12 8","width":"14"}},[_c('path',{attrs:{"d":_vm.drawerActive ? _vm.vPoints : '',"fill":"#969696"}})])]),_c('div',{staticClass:"side-text flex items-center uppercase pl-2 text-xs",class:{ 'opacity-25': !_vm.drawerActive }},[_vm._v(" "+_vm._s(_vm.sideText)+" ")])]),_c('div',{staticClass:"drawer-content w-full",class:{
                'pl-4': _vm.drawerOpen,
                'open-height': _vm.drawerOpen
            },style:({ height: _vm.displayHeight })},[_c('div',{staticClass:"drawer-autosize flex flex-col md:flex-row"},[(_vm.isStateDataLoaded)?_c('DrawerElementContainer',{staticClass:"carto-el-container",class:{
                        'opacity-0': !_vm.drawerOpen
                    },attrs:{"bottom-tab":_vm.bottomTab,"selected-tab":_vm.selectedCartoTab,"title":_vm.selectLocation},on:{"select-tab":_vm.onSelectTab}},[_c('CartoSelector',{attrs:{"fips":_vm.currentFips,"hovered-fips":_vm.hoveredFips},on:{"click":_vm.onCartoClick,"hover":_vm.onCartoHover,"reset-hover":_vm.onResetHover}})],1):_vm._e(),(_vm.hasCategories)?_c('DrawerElementContainer',{staticClass:"categories-container pb-4",class:{
                        'opacity-0': !_vm.drawerOpen
                    },attrs:{"selected-tab":_vm.selectedCategoryTab,"title":_vm.selectCategory},on:{"select-tab":_vm.onSelectTab}},[_c('CategorySelector',{attrs:{"parent-name":_vm.parentName,"categories-tree":_vm.categoriesTree,"categories":_vm.categories,"selected-tab":_vm.selectedCategoryTab,"selected-category":_vm.selectedCategory,"is-state-data-loaded":_vm.isStateDataLoaded,"hovered-category-chart":_vm.hoveredCategoryChart,"disable-child-categories":_vm.disableChildCategories},on:{"select-category":_vm.onSelectCategory,"hover-category":_vm.onHoverCategory,"on-mouse-leave":_vm.onMouseLeave}})],1):_vm._e()],1)])])])}
var BigCardDrawervue_type_template_id_3ace17c3_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/BigCardDrawer/BigCardDrawer.vue?vue&type=template&id=3ace17c3&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/DrawerElementContainer/DrawerElementContainer.vue?vue&type=template&id=2b0803a7&scoped=true&
var DrawerElementContainervue_type_template_id_2b0803a7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"de-container pt-2 md:pt-6 de-grid w-full h-auto md:pb-8",class:{
        'grid-full': _vm.tabs.length === 0
    }},[_c('div',{staticClass:"de-title pl-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"de-tabs-container"},[(_vm.tabs.length > 0)?_c('DrawerTabs',{staticClass:"de-tabs",attrs:{"tabs":_vm.tabs,"bottom-tab":_vm.bottomTab,"selected":_vm.selectedTab},on:{"click":_vm.onTabClick}}):_vm._e()],1),_c('div',{staticClass:"de-content-container w-full box-border"},[_vm._t("default")],2)])}
var DrawerElementContainervue_type_template_id_2b0803a7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/DrawerElementContainer/DrawerElementContainer.vue?vue&type=template&id=2b0803a7&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DrawerTabs/DrawerTabs.vue?vue&type=template&id=601b5907&scoped=true&
var DrawerTabsvue_type_template_id_601b5907_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-container flex flex-col justify-between ml-8 text-right border-r h-full text-xs"},[_c('div',_vm._l((_vm.tabs),function(tab,i){return _c('a',{key:((tab.name) + "-" + i),class:{
                'tabs-tab flex uppercase cursor-pointer': true,
                'is-active': tab.name === _vm.selected
            },on:{"click":function($event){return _vm.onClick(tab)}}},[_c('p',[_vm._v(" "+_vm._s(tab.name)+" ")])])}),0),(_vm.bottomTab)?_c('a',{class:{
            'tabs-tab flex cursor-pointer tracking-normal': true,
            'is-active': _vm.selected === null
        },on:{"click":function($event){return _vm.onClick(_vm.bottomTab)}}},[_c('p',[_vm._v(" "+_vm._s(_vm.bottomTab.name)+" ")])]):_vm._e()])}
var DrawerTabsvue_type_template_id_601b5907_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DrawerTabs/DrawerTabs.vue?vue&type=template&id=601b5907&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/DrawerTabs/DrawerTabs.ts?vue&type=script&lang=ts&

/* harmony default export */ var DrawerTabsvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    tabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    bottomTab: {
      type: Object,
      "default": function _default() {
        return null;
      }
    },
    selected: {
      type: String,
      "default": function _default() {
        return '';
      }
    }
  },
  computed: {},
  methods: {
    onClick: function onClick(tab) {
      this.$emit('click', tab);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/DrawerTabs/DrawerTabs.ts?vue&type=script&lang=ts&
 /* harmony default export */ var DrawerTabs_DrawerTabsvue_type_script_lang_ts_ = (DrawerTabsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/DrawerTabs/DrawerTabs.vue?vue&type=style&index=0&id=601b5907&lang=postcss&scoped=true&
var DrawerTabsvue_type_style_index_0_id_601b5907_lang_postcss_scoped_true_ = __webpack_require__("758c");

// CONCATENATED MODULE: ./src/components/DrawerTabs/DrawerTabs.vue






/* normalize component */

var DrawerTabs_component = normalizeComponent(
  DrawerTabs_DrawerTabsvue_type_script_lang_ts_,
  DrawerTabsvue_type_template_id_601b5907_scoped_true_render,
  DrawerTabsvue_type_template_id_601b5907_scoped_true_staticRenderFns,
  false,
  null,
  "601b5907",
  null
  
)

/* harmony default export */ var DrawerTabs = (DrawerTabs_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/DrawerElementContainer/DrawerElementContainer.ts?vue&type=script&lang=ts&


/* harmony default export */ var DrawerElementContainervue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    DrawerTabs: DrawerTabs
  },
  props: {
    title: {
      type: String,
      "default": ''
    },
    selectedTab: {
      type: String,
      "default": ''
    },
    tabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    bottomTab: {
      type: Object,
      "default": function _default() {
        return null;
      }
    }
  },
  computed: {},
  methods: {
    onTabClick: function onTabClick(tab) {
      this.$emit('select-tab', tab);
    }
  }
}));
// CONCATENATED MODULE: ./src/views/DrawerElementContainer/DrawerElementContainer.ts?vue&type=script&lang=ts&
 /* harmony default export */ var DrawerElementContainer_DrawerElementContainervue_type_script_lang_ts_ = (DrawerElementContainervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/DrawerElementContainer/DrawerElementContainer.vue?vue&type=style&index=0&id=2b0803a7&lang=postcss&scoped=true&
var DrawerElementContainervue_type_style_index_0_id_2b0803a7_lang_postcss_scoped_true_ = __webpack_require__("afe8");

// CONCATENATED MODULE: ./src/views/DrawerElementContainer/DrawerElementContainer.vue






/* normalize component */

var DrawerElementContainer_component = normalizeComponent(
  DrawerElementContainer_DrawerElementContainervue_type_script_lang_ts_,
  DrawerElementContainervue_type_template_id_2b0803a7_scoped_true_render,
  DrawerElementContainervue_type_template_id_2b0803a7_scoped_true_staticRenderFns,
  false,
  null,
  "2b0803a7",
  null
  
)

/* harmony default export */ var DrawerElementContainer = (DrawerElementContainer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CartoSelector/CartoSelector.vue?vue&type=template&id=58f07280&
var CartoSelectorvue_type_template_id_58f07280_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dha-cartogram-selector w-full box-border flex-1 text-center p-3"})}
var CartoSelectorvue_type_template_id_58f07280_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CartoSelector/CartoSelector.vue?vue&type=template&id=58f07280&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/CartoSelector/CartoSelector.ts?vue&type=script&lang=ts&


/* harmony default export */ var CartoSelectorvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    fips: {
      type: String,
      "default": null
    },
    hoveredFips: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      cartogram: null
    };
  },
  computed: {
    options: function options() {
      return {
        usaData: true,
        cartogramOptions: {
          selectableCartogram: true,
          useCartogramBounds: true,
          makeUSABigger: true,
          showUSA: true,
          greyHexes: true,
          fillSelected: '#000000',
          fillHovered: function fillHovered() {
            return '#BBBBBB';
          },
          autoLabelColour: true,
          cartogramOutlineColour: 'white',
          colourFunction: this.colourFunction,
          outlineFunction: this.outlineFunction
        },
        selectedStates: [this.fips]
      };
    }
  },
  watch: {
    options: function options() {
      this.setSelected();
      this.setPointerEvents();
    },
    hoveredFips: function hoveredFips() {
      this.setHovered(this.hoveredFips);
    }
  },
  mounted: function mounted() {
    this.cartogram = new usafacts_metrics["Cartogram"](this.$el);
    this.initialDrawChart();
  },
  methods: {
    initialDrawChart: function initialDrawChart() {
      var _this = this;

      var cartogram = this.cartogram;

      if (cartogram) {
        cartogram.draw(this.options);
        cartogram.on('click', function (d) {
          _this.$emit('click', d.properties);
        });
        cartogram.on('hover', function (d) {
          _this.$emit('hover', d.properties);
        });
        cartogram.on('mouseout', function () {
          _this.$emit('reset-hover');
        });
      }
    },
    setSelected: function setSelected() {
      var cartogram = this.cartogram;

      if (cartogram) {
        cartogram.setSelected(this.options);
      }
    },
    setHovered: function setHovered(fips) {
      var cartogram = this.cartogram;

      if (cartogram) {
        cartogram.setHovered(fips);
      }
    },
    setPointerEvents: function setPointerEvents() {
      var cartogram = this.cartogram;

      if (cartogram) {
        cartogram.setPointerEvents(this.options);
      }
    },
    colourFunction: function colourFunction() {
      return 'white';
    },
    outlineFunction: function outlineFunction() {
      return 'white';
    }
  }
}));
// CONCATENATED MODULE: ./src/components/CartoSelector/CartoSelector.ts?vue&type=script&lang=ts&
 /* harmony default export */ var CartoSelector_CartoSelectorvue_type_script_lang_ts_ = (CartoSelectorvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/CartoSelector/CartoSelector.vue





/* normalize component */

var CartoSelector_component = normalizeComponent(
  CartoSelector_CartoSelectorvue_type_script_lang_ts_,
  CartoSelectorvue_type_template_id_58f07280_render,
  CartoSelectorvue_type_template_id_58f07280_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CartoSelector = (CartoSelector_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CategorySelector/CategorySelector.vue?vue&type=template&id=0b1bb948&scoped=true&
var CategorySelectorvue_type_template_id_0b1bb948_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-selector pt-1 pl-4 overflow-y-auto"},_vm._l((_vm.selectables),function(str){return _c('div',{key:str,staticClass:"category-selectable",class:{
            'category-selected': _vm.selected(str),
            'category-hovered': _vm.hovered(str),
            'indented': _vm.indented(str),
            'category-disabled': _vm.disabled(str)
        },attrs:{"title":_vm.disabled(str) ? _vm.disabledText : ''},on:{"click":function($event){return _vm.onClick(str)},"mouseover":function($event){return _vm.onHover(str)},"mouseleave":function($event){return _vm.onMouseLeave()}}},[_vm._v(" "+_vm._s(str)+" ")])}),0)}
var CategorySelectorvue_type_template_id_0b1bb948_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CategorySelector/CategorySelector.vue?vue&type=template&id=0b1bb948&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/CategorySelector/CategorySelector.ts?vue&type=script&lang=ts&







/* harmony default export */ var CategorySelectorvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    parentName: {
      type: String,
      "default": function _default() {
        return 'All';
      }
    },
    categoriesTree: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    categories: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    selectedCategory: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    selectedTab: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    hoveredCategoryChart: {
      type: String,
      "default": null
    },
    disableChildCategories: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      disabledText: '⚠ Categories are available at the national level only.',
      parentCategoryID: '__parent'
    };
  },
  computed: {
    multilevel: function multilevel() {
      var tree = Array.isArray(this.categoriesTree) ? this.categoriesTree[0] : this.categoriesTree;
      return treeIsMultilevel(tree);
    },
    selectables: function selectables() {
      return [this.parentName].concat(_toConsumableArray(this.categories));
    },
    parentSelected: function parentSelected() {
      return !this.selectables.includes(this.selectedCategory);
    }
  },
  methods: {
    selected: function selected(selectable) {
      return selectable === this.selectedCategory || this.parentSelected && selectable === this.parentName;
    },
    hovered: function hovered(selectable) {
      return this.hoveredCategoryChart === selectable || this.hoveredCategoryChart === this.parentCategoryID && selectable === this.parentName;
    },
    indented: function indented(selectable) {
      return selectable !== this.parentName;
    },
    disabled: function disabled(selectable) {
      return this.disableChildCategories && selectable !== this.parentName;
    },
    onClick: function onClick(selectable) {
      if (!this.disabled(selectable)) {
        this.$emit('select-category', selectable === this.parentName ? this.parentCategoryID : selectable);
      }
    },
    onHover: function onHover(selectable) {
      if (!this.disabled(selectable)) {
        this.$emit('hover-category', selectable === this.parentName ? this.parentCategoryID : selectable);
      }
    },
    onMouseLeave: function onMouseLeave() {
      this.$emit('on-mouse-leave');
    }
  }
}));
// CONCATENATED MODULE: ./src/components/CategorySelector/CategorySelector.ts?vue&type=script&lang=ts&
 /* harmony default export */ var CategorySelector_CategorySelectorvue_type_script_lang_ts_ = (CategorySelectorvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/CategorySelector/CategorySelector.vue?vue&type=style&index=0&id=0b1bb948&lang=postcss&scoped=true&
var CategorySelectorvue_type_style_index_0_id_0b1bb948_lang_postcss_scoped_true_ = __webpack_require__("3d7f");

// CONCATENATED MODULE: ./src/components/CategorySelector/CategorySelector.vue






/* normalize component */

var CategorySelector_component = normalizeComponent(
  CategorySelector_CategorySelectorvue_type_script_lang_ts_,
  CategorySelectorvue_type_template_id_0b1bb948_scoped_true_render,
  CategorySelectorvue_type_template_id_0b1bb948_scoped_true_staticRenderFns,
  false,
  null,
  "0b1bb948",
  null
  
)

/* harmony default export */ var CategorySelector = (CategorySelector_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/BigCardDrawer/BigCardDrawer.ts?vue&type=script&lang=ts&














/* harmony default export */ var BigCardDrawervue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    DrawerElementContainer: DrawerElementContainer,
    CartoSelector: CartoSelector,
    CategorySelector: CategorySelector
  },
  props: {
    model: {
      type: Object,
      "default": null
    },
    singleSelect: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    var _this = this;

    return {
      buttonExpanded: false,
      oldButtonExpanded: null,
      xPoints: 'M14 1.40951L12.59 -0.000488281L7 5.58951L1.41 -0.000488281L0 1.40951L5.59 6.99951L0 12.5895L1.41 13.9995L7 8.40951L12.59 13.9995L14 12.5895L8.41 6.99951L14 1.40951Z',
      vPoints: 'M1.41 0.589996L6 5.17L10.59 0.589996L12 2L6 8L0 2L1.41 0.589996Z',
      compareLeft: {
        text: 'Locations',
        by: 'location'
      },
      compareRight: {
        text: 'Categories',
        by: 'category'
      },
      userSelectedCategoryTab: null,
      defaultCartoTab: 'States',
      selectedCartoTab: 'States',
      selectLocation: 'Select Location',
      selectCategory: 'Select Category',
      cartoTabs: [{
        name: 'States',
        action: function action(name) {
          // @ts-ignore
          _this.selectedCartoTab = name; // @ts-ignore

          _this.model.setCompareBy(_this.compareLeft.by);
        }
      }],
      bottomTab: {
        name: "Don't compare",
        action: function action() {
          // @ts-ignore
          _this.selectedCartoTab = null;

          _this.model.setCompareBy(null);
        }
      },
      calculatedDisplayHeight: '0px'
    };
  },
  computed: {
    drawerActive: function drawerActive() {
      return this.isStateDataLoaded || this.hasCategories;
    },
    drawerOpen: function drawerOpen() {
      return this.drawerActive && this.buttonExpanded;
    },
    categoriesTree: function categoriesTree() {
      return this.model.childrenTree;
    },
    categories: function categories() {
      // need to do this assignment for reactivity apparently
      var catTab = this.selectedCategoryTab;
      var tree = Array.isArray(this.categoriesTree) ? this.categoriesTree[0] : this.categoriesTree;

      if (!tree) {
        return [];
      }

      if (!treeIsMultilevel(tree)) {
        return Object.keys(tree);
      } // @ts-ignore - using null as an index type :)


      if (tree[catTab]) {
        // @ts-ignore
        return Object.keys(tree[catTab]);
      }

      return [];
    },
    hasCategories: function hasCategories() {
      return this.categories.length > 0;
    },
    sideText: function sideText() {
      return this.buttonExpanded ? 'Close' : 'Select location & categories';
    },
    displayX: function displayX() {
      return this.buttonExpanded ? 'block' : 'none';
    },
    displayV: function displayV() {
      return this.buttonExpanded ? 'none' : 'block';
    },
    displayHeight: function displayHeight() {
      if (!this.buttonExpanded) return '0px';
      return this.calculatedDisplayHeight;
    },
    chartData: function chartData() {
      return this.model.data;
    },
    chartOptions: function chartOptions() {
      var _this$xDomain;

      return {
        chartType: 0,
        primaryColor: 'black',
        hideTitle: true,
        showXGridlines: true,
        hideLineLabels: true,
        fips: this.currentFips,
        xDomain: (_this$xDomain = this.xDomain) === null || _this$xDomain === void 0 ? void 0 : _this$xDomain.niceDomain
      };
    },
    currentFips: function currentFips() {
      return this.model.combinedFips;
    },
    hoveredFips: function hoveredFips() {
      return this.model.hoveredFips;
    },
    xDomain: function xDomain() {
      if (!this.chartData) return null;
      return helpers_niceXDomain(this.chartData);
    },
    categoryTabs: function categoryTabs() {
      if (!this.categoriesTree || !treeIsMultilevel(this.categoriesTree)) return [];
      return Object.keys(this.categoriesTree).map(function (cat) {
        return {
          name: cat
        };
      });
    },
    selectedCategoryTab: function selectedCategoryTab() {
      var _this2 = this;

      if (!this.categoryTabs || this.categoryTabs.length === 0) return null;

      if (!this.userSelectedCategoryTab || !this.categoryTabs.find(function (_ref) {
        var name = _ref.name;
        return name === _this2.userSelectedCategoryTab;
      })) {
        return this.categoryTabs[0].name;
      }

      return this.userSelectedCategoryTab;
    },
    selectedCategory: function selectedCategory() {
      return this.model.selectedCategory;
    },
    hoveredCategoryChart: function hoveredCategoryChart() {
      return this.model.hoveredCategoryChart;
    },
    isStateDataLoaded: function isStateDataLoaded() {
      return this.model.stateDataStatus[this.model.containerID];
    },
    parentName: function parentName() {
      var _this$model$currentPa;

      return (_this$model$currentPa = this.model.currentParentMetric) === null || _this$model$currentPa === void 0 ? void 0 : _this$model$currentPa.metric.name;
    },
    disableChildCategories: function disableChildCategories() {
      return this.model.categoriesByStateMissing && this.model.combinedFips !== 'US';
    }
  },
  watch: {
    drawerActive: function drawerActive(active) {
      if (!active) {
        this.oldButtonExpanded = this.buttonExpanded;
        this.buttonExpanded = false;
      } else {
        var _this$oldButtonExpand;

        this.buttonExpanded = (_this$oldButtonExpand = this.oldButtonExpanded) !== null && _this$oldButtonExpand !== void 0 ? _this$oldButtonExpand : false;
        this.oldButtonExpanded = null;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var el = d3_selection_src["i" /* select */](this.$el).select('.drawer-autosize');
    var ro = new ResizeObserver_es["a" /* default */](function (entries) {
      entries.forEach(function (entry) {
        requestAnimationFrame(function () {
          _this3.calculatedDisplayHeight = "".concat(Math.ceil(entry.contentRect.height), "px");
        });
      });
    });
    ro.observe(el.node());
  },
  methods: {
    toggleButton: function toggleButton() {
      if (this.drawerActive) {
        this.buttonExpanded = !this.buttonExpanded;

        if (this.buttonExpanded) {
          if (!this.model.compareBy && this.isStateDataLoaded) {
            this.model.setCompareBy(this.compareLeft.by);
            this.selectedCartoTab = this.defaultCartoTab;
          }
        } else {
          this.model.setCompareBy(null);
        }
      }
    },
    onCompareClick: function onCompareClick(by) {
      if (this.model.compareBy === by) {
        this.model.setCompareBy(null);
      } else {
        this.model.setCompareBy(by);
      }
    },
    onCartoClick: function onCartoClick(d) {
      this.model.setSelectedFips(d.fips);
    },
    onCartoHover: function onCartoHover(d) {
      this.model.setCurrentHoverFips(d.fips);
    },
    onResetHover: function onResetHover() {
      this.model.resetHoverFips();
    },
    onSelectCategory: function onSelectCategory(category) {
      this.model.setSelectedCategory(category);
    },
    onHoverCategory: function onHoverCategory(category) {
      this.model.setHoveredCategory(category);
    },
    onMouseLeave: function onMouseLeave() {
      this.model.setHoveredCategory(undefined);
    },
    onSelectTab: function onSelectTab(tab) {
      if (tab.action) {
        tab.action(tab.name);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/views/BigCardDrawer/BigCardDrawer.ts?vue&type=script&lang=ts&
 /* harmony default export */ var BigCardDrawer_BigCardDrawervue_type_script_lang_ts_ = (BigCardDrawervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/BigCardDrawer/BigCardDrawer.vue?vue&type=style&index=0&id=3ace17c3&lang=postcss&scoped=true&
var BigCardDrawervue_type_style_index_0_id_3ace17c3_lang_postcss_scoped_true_ = __webpack_require__("8fce");

// CONCATENATED MODULE: ./src/views/BigCardDrawer/BigCardDrawer.vue






/* normalize component */

var BigCardDrawer_component = normalizeComponent(
  BigCardDrawer_BigCardDrawervue_type_script_lang_ts_,
  BigCardDrawervue_type_template_id_3ace17c3_scoped_true_render,
  BigCardDrawervue_type_template_id_3ace17c3_scoped_true_staticRenderFns,
  false,
  null,
  "3ace17c3",
  null
  
)

/* harmony default export */ var BigCardDrawer = (BigCardDrawer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DeltaMessage/DeltaMessage.vue?vue&type=template&id=03dda0af&scoped=true&
var DeltaMessagevue_type_template_id_03dda0af_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deltaType)?_c('div',[(_vm.customAutoText)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.formattedCustomAutoText)}},[_vm._v(" "+_vm._s(_vm.formattedCustomAutoText)+" ")]):(_vm.deltaType === 'index')?_c('span',[_vm._v(" The "+_vm._s(_vm.formattedTitle)+" closed at "),_c('span',{staticClass:"font-bold",style:({ color: _vm.deltaColour })},[_vm._v(" "+_vm._s(_vm.infoValue)+" ")]),_vm._v(" points on "+_vm._s(_vm.dateString)+". ")]):(_vm.isSpecialCase)?_c('span',[_vm._v(" The federal government spent "),_c('span',{staticClass:"font-bold",style:({ color: _vm.deltaColour })},[_vm._v(" "+_vm._s(_vm.infoValue)+" ")]),_c('span',[_vm._v(_vm._s(_vm.comparisonText))])]):_c('span',[(!_vm.nationalOnly)?_c('span',[_vm._v(" In "),(_vm.regionText === 'US')?_c('span',[_vm._v("the")]):_vm._e(),_c('span',{staticClass:"font-bold"},[_vm._v(" "+_vm._s(_vm.regionText))]),_vm._v(", "),_c('span',[_vm._v(_vm._s((_vm.deltaType === 'people' || _vm.deltaType === 'number') ? 'there' : _vm.formattedTitle))])]):_c('span',[_vm._v(_vm._s((_vm.deltaType === 'people' || _vm.deltaType === 'number') ? 'There' : _vm.formattedTitle))]),_vm._v(" "+_vm._s(_vm.pastTenseBe)+" "),_c('span',{staticClass:"font-bold",style:({ color: _vm.deltaColour })},[_vm._v(" "+_vm._s(_vm.upDownText)+" "+_vm._s(_vm.infoValue)+" ")]),_c('span',[_vm._v(_vm._s(_vm.comparisonText))])])]):_c('div',[_vm._v(" "+_vm._s('\xa0')+" ")])}
var DeltaMessagevue_type_template_id_03dda0af_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/DeltaMessage/DeltaMessage.vue?vue&type=template&id=03dda0af&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/DeltaMessage/DeltaMessage.ts?vue&type=script&lang=ts&













/* harmony default export */ var DeltaMessagevue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    metric: {
      type: Object,
      "default": function _default() {
        return {
          metric: {
            name: '',
            datasets: []
          }
        };
      }
    },
    fips: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    date: {
      type: Date,
      "default": null
    },
    deltaColour: {
      type: String,
      required: true
    },
    invertScale: {
      type: Boolean,
      required: false,
      "default": function _default() {
        return false;
      }
    },
    customAutoText: {
      type: String,
      "default": null
    },
    showExactNumber: {
      type: Boolean,
      required: true
    },
    nationalOnly: {
      type: Boolean,
      required: true
    },
    includeCategory: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dataset: function dataset() {
      var _this = this;

      if (this.metric.metric.datasets.length === 0) return null;
      var fipsSet = this.metric.metric.datasets.find(function (dataset) {
        return matchesFips(_this.fips, dataset.geoId) || matchesFips(_this.fips, dataset.geo_id);
      });
      return fipsSet || null;
    },
    metadata: function metadata() {
      return this.metric.metric.metadata;
    },
    state: function state() {
      return STATE_CODES[this.fips] || 'National';
    },
    isMonthly: function isMonthly() {
      var _this$dataset, _this$dataset2;

      var xType = ((_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.x_type) || ((_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.xType);
      return (xType === null || xType === void 0 ? void 0 : xType.toLowerCase()) === 'months';
    },
    dateString: function dateString() {
      var _this$dataset3, _this$dataset4;

      if (!this.date) return '';
      var xType = (((_this$dataset3 = this.dataset) === null || _this$dataset3 === void 0 ? void 0 : _this$dataset3.xType) || ((_this$dataset4 = this.dataset) === null || _this$dataset4 === void 0 ? void 0 : _this$dataset4.x_type) || 'Items').toLowerCase();

      if (xType === 'quarters' || xType === 'quarterly') {
        return helpers_dateFormat(this.date, xType);
      }

      var dayFormat = this.isMonthly ? undefined : 'numeric';
      return this.date.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'long',
        day: dayFormat
      });
    },
    deltaValues: function deltaValues() {
      var dset = this.dataset;
      if (!dset) return undefined;
      return helpers_getDeltaParams(dset, this.metadata, {
        date: this.date
      });
    },
    deltaType: function deltaType() {
      var _this$dataset$yType, _this$dataset$y_type;

      if (this.dataset === null) return undefined;
      return ((_this$dataset$yType = this.dataset.yType) === null || _this$dataset$yType === void 0 ? void 0 : _this$dataset$yType.toLowerCase()) || ((_this$dataset$y_type = this.dataset.y_type) === null || _this$dataset$y_type === void 0 ? void 0 : _this$dataset$y_type.toLowerCase());
    },
    deltaCaption: function deltaCaption() {
      if (!this.dataset) return {
        prefix: '',
        timePeriod: ''
      };
      var xType = this.dataset.xType || this.dataset.x_type || 'Items';

      if (this.date) {
        return helpers_getDeltaCaption(this.dataset, xType, this.metadata, this.date);
      }

      return helpers_getDeltaCaption(this.dataset, xType, this.metadata);
    },
    title: function title() {
      var _this$metadata;

      return ((_this$metadata = this.metadata) === null || _this$metadata === void 0 ? void 0 : _this$metadata.displayName) || this.metric.metric.name;
    },
    formattedTitle: function formattedTitle() {
      if (this.title === undefined) return ''; // Index titles are the names of stocks so capitalization is left untouched

      if (this.deltaType === 'index') return this.title; // Set the title to lowercase before processing

      var title = this.title.toLowerCase(); // Add "the" to the front of singular metrics that end with "rate"
      // E.g. The saving rate; The unemployment rate; The birth rate; The death rate; etc.

      if (!title.startsWith('the') && title.endsWith('rate')) {
        title = "the ".concat(title);
      }

      var words = title.split(' ');

      for (var i = 0; i < words.length; i++) {
        if (words[i] === 'govt') {
          words[i] = 'government';
        } // National-only metrics need to be capitalized because the message does not start with "In the US,"


        if (i === 0 && this.nationalOnly && this.deltaType !== 'people' && this.deltaType !== 'number') {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        } // Capitalize COVID-19 when it is found


        if (words[i] === 'covid-19') {
          words[i] = 'COVID-19';
        }
      }

      return words.join(' ');
    },
    infoValue: function infoValue() {
      var _this$metadata2;

      if (this.deltaValues === undefined || this.deltaValues.value === undefined) return '--';
      var value = ((_this$metadata2 = this.metadata) === null || _this$metadata2 === void 0 ? void 0 : _this$metadata2.changeIndex) === 'null' ? this.deltaValues.value : Math.abs(this.deltaValues.value);

      if (this.deltaType !== undefined) {
        var format = helpers_getFormat(this.deltaType);
        return this.showExactNumber ? format(value, {
          truncate: false
        }) : format(value);
      }

      return '--';
    },
    regionText: function regionText() {
      if (this.state === 'National') return 'US';
      return this.state;
    },
    upDownText: function upDownText() {
      var _this$metadata3;

      // If the value is not reported as a change, then don't include "up/down"
      if (((_this$metadata3 = this.metadata) === null || _this$metadata3 === void 0 ? void 0 : _this$metadata3.changeIndex) === 'null') return ''; // Return an empty string if there is no value to compare

      if (this.deltaValues === undefined || this.deltaValues.value === undefined) return '';
      if (this.deltaValues.value === 0) return this.invertScale ? 'up' : 'down';
      return this.deltaValues.value > 0 ? 'up' : 'down';
    },
    pastTenseBe: function pastTenseBe() {
      var _this$title;

      // Use the pluralization of the title to determine the correct past tense
      return ((_this$title = this.title) === null || _this$title === void 0 ? void 0 : _this$title.endsWith('s')) ? 'were' : 'was';
    },
    perCapitaText: function perCapitaText() {
      if (this.metadata === undefined) return '';
      if (this.metadata.transformation === 'per100000') return 'per 100K people ';
      if (this.metadata.transformation === 'perCapita') return 'per capita ';
      return '';
    },
    categoryText: function categoryText() {
      var _this$formattedTitle;

      if (!this.includeCategory || !this.dataset) return ''; // Only show the category if the information is not redundant from the title

      var datasetName = this.dataset.name.toLowerCase();
      return datasetName !== ((_this$formattedTitle = this.formattedTitle) === null || _this$formattedTitle === void 0 ? void 0 : _this$formattedTitle.toLowerCase()) ? "(".concat(this.dataset.name, ") ") : '';
    },
    comparisonText: function comparisonText() {
      var _this$deltaType, _this$deltaType2, _this$deltaType3, _this$deltaType4;

      if (this.metadata === undefined || !this.dataset) return '';
      var xType = (this.dataset.xType || this.dataset.x_type || 'Items').toLowerCase(); // Values comparing to the same month of last year have a unique comparison text

      if (this.metadata.changeIndex === 'lastYear') {
        var compareType = xType === 'quarters' || xType === 'quarterly' ? 'quarter' : 'month';
        return "".concat(this.categoryText, "compared to the same ").concat(compareType, " last year.");
      } // People begin with region text (if applicable) and then "there were"


      if (((_this$deltaType = this.deltaType) === null || _this$deltaType === void 0 ? void 0 : _this$deltaType.toLowerCase()) === 'people' || ((_this$deltaType2 = this.deltaType) === null || _this$deltaType2 === void 0 ? void 0 : _this$deltaType2.toLowerCase()) === 'number') {
        if (this.isMonthly) {
          return "".concat(this.formattedTitle, " ").concat(this.perCapitaText).concat(this.categoryText, "in ").concat(this.dateString, ".");
        }

        return "".concat(this.formattedTitle, " ").concat(this.perCapitaText).concat(this.categoryText, "on ").concat(this.dateString, ".");
      } // Nominal metrics that are not people metrics begin with a formatted title
      // The comparison text does not include "per capita" text or a formatted title, but still use "on"


      if (this.metadata.changeIndex === 'null' && this.metadata.transformation === 'nominal') {
        if (this.isMonthly || xType === 'quarters' || xType === 'quarterly') {
          return "".concat(this.categoryText, "in ").concat(this.dateString, ".");
        }

        return "".concat(this.categoryText, "on ").concat(this.dateString, ".");
      } // Taking precedence over specific styling for percent and dollar metrics, use the generated delta caption
      // when it is available


      if (this.deltaCaption.prefix !== '' && this.deltaCaption.timePeriod !== '') {
        return "".concat(this.categoryText).concat(this.deltaCaption.prefix, " ").concat(this.deltaCaption.timePeriod, ".");
      } // Finally, percent metrics use "from" for wording while dollars metrics use "compared to" as per mock-up


      if (((_this$deltaType3 = this.deltaType) === null || _this$deltaType3 === void 0 ? void 0 : _this$deltaType3.toLowerCase()) === 'percent') return "".concat(this.categoryText, "from ").concat(this.dateString, ".");

      if (((_this$deltaType4 = this.deltaType) === null || _this$deltaType4 === void 0 ? void 0 : _this$deltaType4.toLowerCase()) === 'dollars') {
        return "".concat(this.perCapitaText).concat(this.categoryText, "compared to ").concat(this.dateString, ".");
      }

      return '';
    },
    isSpecialCase: function isSpecialCase() {
      var _this$metadata4, _this$metadata5, _this$title2;

      return ((_this$metadata4 = this.metadata) === null || _this$metadata4 === void 0 ? void 0 : _this$metadata4.changeIndex) === 'null' && ((_this$metadata5 = this.metadata) === null || _this$metadata5 === void 0 ? void 0 : _this$metadata5.transformation) === 'nominal' && ((_this$title2 = this.title) === null || _this$title2 === void 0 ? void 0 : _this$title2.toLowerCase()) === 'federal govt spending';
    },
    formattedCustomAutoText: function formattedCustomAutoText() {
      if (!this.customAutoText) return undefined;
      var valueText = "<span style=\"color: ".concat(this.deltaColour, ";\" class=\"font-bold\">").concat(this.infoValue, "</span>");
      var regionText = "".concat(this.regionText === 'US' ? 'the' : '', " <span class=\"font-bold\">").concat(this.regionText, "</span>"); // Replace [[value]], [[date]], [[state]] (or [[region]]) with their respective dynamic values

      return this.customAutoText.replace(/\[\[value\]\]/g, valueText).replace(/\[\[date\]\]/g, this.dateString).replace(/\[\[(state|region)\]\]/g, regionText);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/DeltaMessage/DeltaMessage.ts?vue&type=script&lang=ts&
 /* harmony default export */ var DeltaMessage_DeltaMessagevue_type_script_lang_ts_ = (DeltaMessagevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/DeltaMessage/DeltaMessage.vue





/* normalize component */

var DeltaMessage_component = normalizeComponent(
  DeltaMessage_DeltaMessagevue_type_script_lang_ts_,
  DeltaMessagevue_type_template_id_03dda0af_scoped_true_render,
  DeltaMessagevue_type_template_id_03dda0af_scoped_true_staticRenderFns,
  false,
  null,
  "03dda0af",
  null
  
)

/* harmony default export */ var DeltaMessage = (DeltaMessage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Sources/Sources.vue?vue&type=template&id=67eb31d1&
var Sourcesvue_type_template_id_67eb31d1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dha-sources w-full box-border flex-1"})}
var Sourcesvue_type_template_id_67eb31d1_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Sources/Sources.vue?vue&type=template&id=67eb31d1&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/Sources/Sources.ts?vue&type=script&lang=ts&


/* harmony default export */ var Sourcesvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    data: {
      type: Array,
      "default": null
    },
    shouldDraw: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      sources: null
    };
  },
  computed: {},
  watch: {
    data: function data() {
      this.draw();
    }
  },
  mounted: function mounted() {
    this.sources = new usafacts_metrics["SourcesAndFootnotes"](this.$el);

    if (this.shouldDraw) {
      this.draw();
    }
  },
  methods: {
    draw: function draw() {
      var _this$data;

      if (this.sources && ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.length) > 0) {
        this.sources.draw(this.data);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/Sources/Sources.ts?vue&type=script&lang=ts&
 /* harmony default export */ var Sources_Sourcesvue_type_script_lang_ts_ = (Sourcesvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/Sources/Sources.vue





/* normalize component */

var Sources_component = normalizeComponent(
  Sources_Sourcesvue_type_script_lang_ts_,
  Sourcesvue_type_template_id_67eb31d1_render,
  Sourcesvue_type_template_id_67eb31d1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sources = (Sources_component.exports);
// EXTERNAL MODULE: ./src/main.scss
var src_main = __webpack_require__("abe2");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/BigChartCardView/BigChartCardView.ts?vue&type=script&lang=ts&












/* harmony default export */ var BigChartCardViewvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    BigCardHeader: BigCardHeader,
    DHAChart: DHAChart,
    Tabs: Tabs,
    BigCardDrawer: BigCardDrawer,
    DeltaMessage: DeltaMessage,
    Sources: Sources
  },
  props: {
    model: {
      type: Object,
      "default": null
    },
    onDraw: {
      type: Function,
      "default": null
    }
  },
  data: function data() {
    return {
      drawerEnabled: true,
      tooltipDate: null
    };
  },
  computed: {
    containerID: function containerID() {
      return this.model.containerID;
    },
    chartData: function chartData() {
      return this.model.dataPromises;
    },
    tooltipContent: function tooltipContent() {
      return this.model.metricPurpose ? {
        'Metric Purpose': [{
          text: this.model.metricPurpose
        }]
      } : null;
    },
    xDomain: function xDomain() {
      if (!this.model.data) return null;
      return helpers_niceXDomain(this.model.data);
    },
    highlighted: function highlighted() {
      if (this.compareBy === 'category') {
        return [this.selectedCategory || this.currentFips];
      }

      return [this.currentFips];
    },
    chartOptions: function chartOptions() {
      var _this$metric;

      return {
        chartType: this.model.useBarChart ? 9 : 0,
        primaryColor: this.model.useBarChart ? 'rgba(0,0,0,0.85)' : 'black',
        // common options
        hideTitle: true,
        transition: true,
        // spaghetti options
        highlighted: this.highlighted,
        showXGridlines: true,
        hideLineLabels: false,
        useStateAbbreviations: true,
        // xDomain was causing transition issues and we don't really need it anyway
        // xDomain: this.xDomain?.niceDomain,
        tooltipOptions: {
          title: (_this$metric = this.metric) === null || _this$metric === void 0 ? void 0 : _this$metric.metric.datasets[0].name
        },
        labelTextMode: this.compareBy === 'location' ? 'states' : 'categories',
        showLastPoint: true,
        showLegend: false,
        showSourcesAndFootnotes: false,
        chartStyle: 'spaghetti',
        labelOpacities: this.compareBy === 'category' ? {
          inactive: 0,
          hovered: 0,
          active: 0
        } : null
      };
    },
    allData: function allData() {
      var _this$model$focusMetr, _this$model$data;

      return ((_this$model$focusMetr = this.model.focusMetric) === null || _this$model$focusMetr === void 0 ? void 0 : _this$model$focusMetr.data) || ((_this$model$data = this.model.data) === null || _this$model$data === void 0 ? void 0 : _this$model$data.data);
    },
    metric: function metric() {
      var _this = this;

      return this.allData ? this.allData.find(function (d) {
        return matchesFips(_this.currentFips, d.metric.fips);
      }) : undefined;
    },
    date: function date() {
      var _this$xDomain;

      return this.tooltipDate || ((_this$xDomain = this.xDomain) === null || _this$xDomain === void 0 ? void 0 : _this$xDomain.end) || null;
    },
    dateLine: function dateLine() {
      var _this$dataset, _this$dataset2;

      if (!this.date) return '';
      var xType = (((_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.xType) || ((_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.x_type) || 'Items').toLowerCase();

      if (xType === 'quarters' || xType === 'quarterly') {
        return helpers_dateFormat(this.date, xType);
      }

      return this.date.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    currentFips: function currentFips() {
      return this.model.combinedFips !== '00' ? this.model.combinedFips : 'US';
    },
    hoveredFips: function hoveredFips() {
      return this.model.hoveredFips;
    },
    tabs: function tabs() {
      return this.model.tabs;
    },
    selectedTab: function selectedTab() {
      return this.model.selectedTab;
    },
    selectedCategory: function selectedCategory() {
      return this.model.selectedCategory;
    },
    hoveredCategory: function hoveredCategory() {
      return this.model.hoveredCategory;
    },
    isPercentMetric: function isPercentMetric() {
      var _this$metric2, _this$metric2$metric$;

      return ((_this$metric2 = this.metric) === null || _this$metric2 === void 0 ? void 0 : (_this$metric2$metric$ = _this$metric2.metric.metadata) === null || _this$metric2$metric$ === void 0 ? void 0 : _this$metric2$metric$.transformation.toLowerCase()) === 'pctchange';
    },
    invertScale: function invertScale() {
      return this.model.invertScale;
    },
    notScaled: function notScaled() {
      return this.model.notScaled;
    },
    colourScale: function colourScale() {
      if (this.metric === undefined || this.notScaled) return undefined;
      return helpers_getColourScale(this.metric.metric, this.$appModel.colourPalette, this.model.invertScale, this.model.centerZero);
    },
    defaultColour: function defaultColour() {
      return this.$appModel.notScaled;
    },
    dataset: function dataset() {
      var _this$metric3,
          _this$metric4,
          _this2 = this;

      if (((_this$metric3 = this.metric) === null || _this$metric3 === void 0 ? void 0 : _this$metric3.metric.datasets.length) === 0) return null;
      var fipsSet = (_this$metric4 = this.metric) === null || _this$metric4 === void 0 ? void 0 : _this$metric4.metric.datasets.find(function (dataset) {
        return matchesFips(_this2.currentFips, dataset.geoId) || matchesFips(_this2.currentFips, dataset.geo_id);
      });
      return fipsSet || null;
    },
    metadata: function metadata() {
      var _this$metric5;

      return (_this$metric5 = this.metric) === null || _this$metric5 === void 0 ? void 0 : _this$metric5.metric.metadata;
    },
    deltaValues: function deltaValues() {
      var dset = this.dataset;
      if (!dset) return undefined;
      return helpers_getDeltaParams(dset, this.metadata, {
        date: this.date
      });
    },
    deltaColour: function deltaColour() {
      return getDeltaColour(this.defaultColour, this.notScaled, this.deltaValues, this.colourScale);
    },
    customAutoText: function customAutoText() {
      return this.model.currentCustomAutoText;
    },
    showExactNumber: function showExactNumber() {
      return this.model.showExactNumber;
    },
    compareBy: function compareBy() {
      return this.model.compareBy;
    },
    noStates: function noStates() {
      return this.model.noStates;
    },
    singleSelectOnly: function singleSelectOnly() {
      return this.model.useBarChart;
    },
    learnMore: function learnMore() {
      return this.model.learnMore;
    }
  },
  watch: {
    deltaValues: function deltaValues() {
      this.colourHovered();
    }
  },
  methods: {
    onTabClick: function onTabClick(tab) {
      this.model.setSelectedTab(tab);
    },
    onSpaghettiHover: function onSpaghettiHover(d) {
      if (this.compareBy === 'location') {
        this.model.setCurrentHoverFips(d === null || d === undefined ? null : d.fips);
      } else if (this.compareBy === 'category') {
        this.model.setCurrentHoverCategory(d === null || d === undefined ? null : d.selector || null);
      }
    },
    onStateDataLoaded: function onStateDataLoaded(d) {
      if (this.noStates) {
        this.model.setStateDataLoaded(this.containerID, false);
      } else {
        this.model.setStateDataLoaded(this.containerID, d);
      }
    },
    onSpaghettiClick: function onSpaghettiClick(d) {
      if (this.compareBy === 'location') {
        this.model.setSelectedFips(d === null || d === undefined ? null : d.fips);
      } else if (this.compareBy === 'category') {
        this.model.setSelectedCategory(d === null || d === undefined ? null : d.selector);
      }
    },
    onTooltipData: function onTooltipData(d) {
      this.tooltipDate = d ? d === null || d === void 0 ? void 0 : d.key : null;
    },
    colourHovered: function colourHovered() {
      // this was sometimes firing even when on mobile and there's no big card
      if (!this.$screens.mobile && this.$el.nodeType !== this.$el.COMMENT_NODE) {
        var hoverFill = getDeltaColour(this.defaultColour, this.notScaled, this.deltaValues, this.colourScale);
        var circle = d3_selection_src["i" /* select */](this.$el).select('.visible');
        circle.style('fill', hoverFill);
        var bars = d3_selection_src["i" /* select */](this.$el).selectAll('.time-bar-chart-entry rect');
        bars.style('fill', function (d, i, el) {
          return d3_selection_src["i" /* select */](el[i]).classed('bar-hovered') ? hoverFill : null;
        });
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/views/BigChartCardView/BigChartCardView.ts?vue&type=script&lang=ts&
 /* harmony default export */ var BigChartCardView_BigChartCardViewvue_type_script_lang_ts_ = (BigChartCardViewvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/BigChartCardView/BigChartCardView.vue?vue&type=style&index=0&lang=postcss&
var BigChartCardViewvue_type_style_index_0_lang_postcss_ = __webpack_require__("ffbf");

// CONCATENATED MODULE: ./src/views/BigChartCardView/BigChartCardView.vue






/* normalize component */

var BigChartCardView_component = normalizeComponent(
  BigChartCardView_BigChartCardViewvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BigChartCardView = (BigChartCardView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/SmallChartCardView/SmallChartCardView.vue?vue&type=template&id=73975600&scoped=true&
var SmallChartCardViewvue_type_template_id_73975600_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-graph-card relative flex flex-col w-full h-full pl-4 pt-5 pb-2 pr-0 md:pr-4",class:{
        faded: !_vm.matchesGlobalFips,
        'shadow-lg': _vm.$screens.mobile && _vm.buttonExpanded
    }},[_c('div',{staticClass:"flex",on:{"click":_vm.toggleButton}},[_c('SmallCardInfo',{attrs:{"metric":_vm.metric,"fips":_vm.currentFips,"scale":_vm.colourScale,"linear-scale":_vm.linearScale,"invert-scale":_vm.invertScale,"not-scaled":_vm.notScaled,"default-colour":_vm.defaultColour,"date":_vm.date,"show-exact-number":_vm.showExactNumber,"button-expanded":_vm.buttonExpanded}}),(_vm.$screens.mobile)?_c('div',{staticClass:"drawer-button-div compare-buttons flex",class:{ 'pl-4 pr-2': _vm.buttonExpanded }},[_c('button',{staticClass:"text-center align-center justify-center",class:{ 'rounded-full': _vm.buttonExpanded,
                          'drawer-button': _vm.buttonExpanded,
                          'sparkline-size': !_vm.buttonExpanded }},[(!_vm.buttonExpanded)?_c('Sparkline',{staticClass:"align-middle w-full h-full",attrs:{"data":_vm.chartData}}):_vm._e(),_c('svg',{staticClass:"button-x align-middle m-auto",style:({ display: _vm.displayX }),attrs:{"viewBox":"0 0 14 14","width":"14","height":"14"}},[_c('path',{attrs:{"d":_vm.xPoints,"fill":"#969696"}})])],1)]):_vm._e()],1),_c('SmallCardDrawer',{attrs:{"model":_vm.model,"button-expanded":!_vm.$screens.mobile || _vm.buttonExpanded,"date":_vm.date,"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"data-selector":_vm.dataSelector,"metric":_vm.metric,"fips":_vm.currentFips,"show-exact-number":_vm.showExactNumber,"default-colour":_vm.defaultColour,"invert-scale":_vm.invertScale,"not-scaled":_vm.notScaled,"scale":_vm.colourScale,"chart-index":_vm.chartIndex,"on-draw":_vm.onDraw,"custom-auto-text":_vm.customAutoText},on:{"chart-hover":_vm.onChartHover,"explore":_vm.onExplore}})],1)}
var SmallChartCardViewvue_type_template_id_73975600_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/SmallChartCardView/SmallChartCardView.vue?vue&type=template&id=73975600&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SmallCardInfo/SmallCardInfo.vue?vue&type=template&id=22113fa5&scoped=true&
var SmallCardInfovue_type_template_id_22113fa5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-card-info overflow-visible z-10 pointer-events-none",class:{
        'adjusted-width': _vm.formFactor === 'tiny',
        'w-full': _vm.formFactor !== 'tiny'
    }},[_c('div',{staticClass:"flex flex-row relative justify-between",class:{ 'mb-1': _vm.formFactor === 'tiny' }},[_c('div',{staticClass:"small-info-titles flex flex-col relative"},[_c('div',{staticClass:"info-title inline-block text-black font-bold",class:{ 'adjusted-width': _vm.formFactor !== 'tiny' },style:({ 'font-size': (_vm.$screens.mobile || _vm.formFactor === 'tiny') ? '13px' : '16px' })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"info-subtitle h-8 md:h-auto md:truncate"},[_vm._v(" "+_vm._s(_vm.subtitle || _vm.extraSpace)+" ")])]),(_vm.formFactor !== 'tiny')?_c('div',{staticClass:"small-card-status-indicator relative"},[_c('status-indicator',{staticClass:"status-indicator",attrs:{"legend-mode":false,"not-scaled":_vm.notScaled,"default-colour":_vm.defaultColour,"metric":_vm.metric,"type":_vm.deltaType,"fips":_vm.fips,"date":_vm.date,"scale":_vm.scale,"invert-scale":_vm.invertScale,"linear-scale":_vm.linearScale,"show-exact-number":_vm.showExactNumber}})],1):_vm._e()]),(!_vm.$screens.mobile && _vm.buttonExpanded && _vm.formFactor !== 'tiny')?_c('div',{staticClass:"info-date text-xs pb-1"},[_vm._v(" "+_vm._s(_vm.dateString)+" ")]):_vm._e()])}
var SmallCardInfovue_type_template_id_22113fa5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/SmallCardInfo/SmallCardInfo.vue?vue&type=template&id=22113fa5&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/StatusIndicator/StatusIndicator.vue?vue&type=template&id=5ef20966&scoped=true&
var StatusIndicatorvue_type_template_id_5ef20966_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-indicator-container flex flex-col relative w-full"},[(_vm.$screens.mobile && _vm.legendMode)?_c('div',{staticClass:"range-label-container flex flex-row relative w-full items-center mb-2"},[_c('div',{staticClass:"top-margin-line left-margin-line"}),_c('div',{staticClass:"range-label"},[_vm._v(" "+_vm._s(_vm.dateRangeLabel)+" ")]),_c('div',{staticClass:"top-margin-line right-margin-line"})]):_vm._e(),_c('div',{staticClass:"value-label-container flex flex-row relative w-full items-center overflow-visible mb-1"},[_c('div',{staticClass:"value-label left-value-label absolute",class:{
                focused: _vm.centerValueLabel === _vm.leftValueLabel,
                legend: _vm.legendMode
            }},[_vm._v(" "+_vm._s(_vm.leftValueLabel)+" ")]),(_vm.centerValueLabel !== _vm.leftValueLabel && _vm.centerValueLabel !== _vm.rightValueLabel)?_c('div',{ref:"center-value-label",staticClass:"value-label center-value-label focused absolute"},[_vm._v(" "+_vm._s(_vm.centerValueLabel)+" ")]):_vm._e(),_c('div',{staticClass:"value-label right-value-label absolute",class:{
                focused: _vm.centerValueLabel === _vm.rightValueLabel,
                legend: _vm.legendMode
            }},[_vm._v(" "+_vm._s(_vm.rightValueLabel)+" ")])]),_c('div',{staticClass:"status-box-container flex flex-row relative w-full justify-center"},[_vm._l((_vm.colourPalette),function(colour,i){return _c('div',{key:i,staticClass:"status-box inline-block relative flex-grow",class:{
                first: i === 0,
                last: i === _vm.colourPalette.length - 1,
                'status-rounded': _vm.isRounded(i),
                unscaled: _vm.notScaled,
                legend: _vm.legendMode
            },style:({ backgroundColor: colour })})}),_c('div',{staticClass:"indicator-circle absolute",style:({
                left: ("calc(" + _vm.deltaOffset + " - 7px)"),
                backgroundColor: _vm.deltaColour
            })})],2),(!_vm.$screens.mobile && _vm.legendMode)?_c('div',{staticClass:"range-label-container flex flex-row relative w-full items-center"},[_c('div',{staticClass:"bottom-margin-line left-margin-line"}),_c('div',{staticClass:"range-label"},[_vm._v(" "+_vm._s(_vm.dateRangeLabel)+" ")]),_c('div',{staticClass:"bottom-margin-line right-margin-line"})]):_vm._e()])}
var StatusIndicatorvue_type_template_id_5ef20966_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/StatusIndicator/StatusIndicator.vue?vue&type=template&id=5ef20966&scoped=true&

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/StatusIndicator/StatusIndicator.ts?vue&type=script&lang=ts&











function StatusIndicatorvue_type_script_lang_ts_matchesFips(toMatch, fips) {
  return fips === toMatch || fips === 'US' && toMatch === '00' || fips === '00' && toMatch === 'US';
}

/* harmony default export */ var StatusIndicatorvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {},
  props: {
    metric: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          metric: {
            datasets: []
          }
        };
      }
    },
    type: {
      type: String,
      required: false,
      "default": 'Items'
    },
    fips: {
      type: String,
      required: false,
      "default": function _default() {
        return '';
      }
    },
    date: {
      type: Date,
      "default": null
    },
    legendMode: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    scale: {
      type: Function,
      "default": null
    },
    linearScale: {
      type: Function,
      "default": null
    },
    invertScale: {
      type: Boolean,
      required: false,
      "default": function _default() {
        return false;
      }
    },
    notScaled: {
      type: Boolean,
      required: false,
      "default": function _default() {
        return false;
      }
    },
    showExactNumber: {
      type: Boolean,
      required: false,
      "default": false
    },
    roundedEdges: {
      type: Boolean,
      required: false,
      "default": function _default() {
        return true;
      }
    }
  },
  computed: {
    dataset: function dataset() {
      var _this = this;

      if (this.metric.metric.datasets.length === 0) return null;
      var fipsSet = this.metric.metric.datasets.find(function (dataset) {
        return StatusIndicatorvue_type_script_lang_ts_matchesFips(_this.fips, dataset.geoId) || StatusIndicatorvue_type_script_lang_ts_matchesFips(_this.fips, dataset.geo_id);
      });
      return fipsSet || null;
    },
    metadata: function metadata() {
      return this.metric.metric.metadata;
    },
    minValue: function minValue() {
      if (!this.dataset) return undefined;
      var data = this.dataset.data.map(function (d) {
        return d.value;
      });

      var min = lodash_default.a.min(data);

      return min !== undefined ? min : undefined;
    },
    maxValue: function maxValue() {
      if (!this.dataset) return undefined;
      var data = this.dataset.data.map(function (d) {
        return d.value;
      });

      var max = lodash_default.a.max(data);

      return max !== undefined ? max : undefined;
    },
    deltaValue: function deltaValue() {
      return this.dataset ? helpers_getDeltaParams(this.dataset, this.metadata, {
        date: this.date
      }) : undefined;
    },
    deltaOffset: function deltaOffset() {
      if (this.legendMode) return '50%';
      if (this.deltaValue === undefined || !this.linearScale) return '0%';
      var value = this.deltaValue.value;
      if (value === undefined) return '0%';
      return "".concat(Math.round(this.linearScale(value) * 100), "%");
    },
    deltaColour: function deltaColour() {
      if (this.legendMode) return 'black';
      var scale = this.scale;
      return getDeltaColour('black', this.notScaled, this.deltaValue, scale);
    },
    colourPalette: function colourPalette() {
      var palette = this.$appModel.colourPalette;
      return this.invertScale ? palette.slice().reverse() : palette;
    },
    leftValueLabel: function leftValueLabel() {
      if (this.legendMode) return 'better';
      if (this.minValue === undefined) return '--';
      return this.formatValue(this.minValue);
    },
    rightValueLabel: function rightValueLabel() {
      if (this.legendMode) return 'worse';
      if (this.maxValue === undefined) return '--';
      return this.formatValue(this.maxValue);
    },
    centerValueLabel: function centerValueLabel() {
      if (this.legendMode) return 'current';
      if (this.deltaValue === undefined || this.deltaValue.value === undefined) return '--';
      return this.formatValue(this.deltaValue.value);
    },
    dateRangeLabel: function dateRangeLabel() {
      return 'Range from Jan 2020';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$nextTick();

            case 2:
              _this2.adjustCenterLabel();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  updated: function updated() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$nextTick();

            case 2:
              _this3.adjustCenterLabel();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    formatValue: function formatValue(value) {
      var _this$metadata;

      if (value === undefined) return '--';
      var format = helpers_getFormat(this.type);

      if (((_this$metadata = this.metadata) === null || _this$metadata === void 0 ? void 0 : _this$metadata.transformation) === 'nominal' && Math.abs(value) > 10000) {
        return format(value, {
          decimals: 0
        });
      }

      if (this.type.toLowerCase() === 'percent' && value === 0) {
        return format(value, {
          decimals: 0
        });
      } // return this.showExactNumber ? format(value, { truncate: false }) : format(value);


      return format(value);
    },
    isRounded: function isRounded(i) {
      return this.roundedEdges && (i === 0 || i === this.colourPalette.length - 1);
    },
    adjustCenterLabel: function adjustCenterLabel() {
      var centerLabel = this.$refs['center-value-label'];
      if (centerLabel === undefined) return;
      centerLabel.style.left = "calc(".concat(this.deltaOffset, ")");
      centerLabel.style.transform = 'translateX(-50%)';
      if (!this.deltaValue || !this.linearScale) return;
      var value = this.deltaValue.value;
      if (!value) return;
      var offsetFraction = this.linearScale(value);

      if (offsetFraction <= 0.25) {
        centerLabel.style.left = '20px';
        centerLabel.style.transform = '';
        return;
      }

      if (offsetFraction >= 0.75) {
        centerLabel.style.left = 'calc(100% - 20px)';
        centerLabel.style.transform = 'translateX(-100%)';
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/StatusIndicator/StatusIndicator.ts?vue&type=script&lang=ts&
 /* harmony default export */ var StatusIndicator_StatusIndicatorvue_type_script_lang_ts_ = (StatusIndicatorvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/StatusIndicator/StatusIndicator.vue?vue&type=style&index=0&id=5ef20966&scoped=true&lang=css&
var StatusIndicatorvue_type_style_index_0_id_5ef20966_scoped_true_lang_css_ = __webpack_require__("a1f7");

// CONCATENATED MODULE: ./src/components/StatusIndicator/StatusIndicator.vue






/* normalize component */

var StatusIndicator_component = normalizeComponent(
  StatusIndicator_StatusIndicatorvue_type_script_lang_ts_,
  StatusIndicatorvue_type_template_id_5ef20966_scoped_true_render,
  StatusIndicatorvue_type_template_id_5ef20966_scoped_true_staticRenderFns,
  false,
  null,
  "5ef20966",
  null
  
)

/* harmony default export */ var StatusIndicator = (StatusIndicator_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Explore/Explore.vue?vue&type=template&id=4041c414&scoped=true&
var Explorevue_type_template_id_4041c414_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"explore-button flex flex-row pt-1 pb-6 pointer-events-auto",on:{"click":_vm.onClick}},[_c('span',{staticClass:"font-bold text-xs pr-2 uppercase"},[_vm._v(" explore ")]),_c('img',{attrs:{"src":_vm.arrow}})])}
var Explorevue_type_template_id_4041c414_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Explore/Explore.vue?vue&type=template&id=4041c414&scoped=true&

// EXTERNAL MODULE: ./src/components/Explore/Vector.svg
var Vector = __webpack_require__("bb99");
var Vector_default = /*#__PURE__*/__webpack_require__.n(Vector);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/Explore/Explore.ts?vue&type=script&lang=ts&


/* harmony default export */ var Explorevue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    link: {
      type: String,
      "default": function _default() {
        return '';
      }
    }
  },
  computed: {
    arrow: function arrow() {
      return Vector_default.a;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  }
}));
// CONCATENATED MODULE: ./src/components/Explore/Explore.ts?vue&type=script&lang=ts&
 /* harmony default export */ var Explore_Explorevue_type_script_lang_ts_ = (Explorevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Explore/Explore.vue?vue&type=style&index=0&id=4041c414&lang=postcss&scoped=true&
var Explorevue_type_style_index_0_id_4041c414_lang_postcss_scoped_true_ = __webpack_require__("6cd1");

// CONCATENATED MODULE: ./src/components/Explore/Explore.vue






/* normalize component */

var Explore_component = normalizeComponent(
  Explore_Explorevue_type_script_lang_ts_,
  Explorevue_type_template_id_4041c414_scoped_true_render,
  Explorevue_type_template_id_4041c414_scoped_true_staticRenderFns,
  false,
  null,
  "4041c414",
  null
  
)

/* harmony default export */ var Explore = (Explore_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/SmallCardInfo/SmallCardInfo.ts?vue&type=script&lang=ts&









function SmallCardInfovue_type_script_lang_ts_matchesFips(toMatch, fips) {
  return fips === toMatch || fips === 'US' && toMatch === '00' || fips === '00' && toMatch === 'US';
}

/* harmony default export */ var SmallCardInfovue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    StatusIndicator: StatusIndicator,
    Delta: Delta,
    Explore: Explore
  },
  props: {
    formFactor: {
      type: String,
      "default": function _default() {
        return 'small';
      }
    },
    metric: {
      type: Object,
      "default": function _default() {
        return {
          metric: {
            datasets: []
          }
        };
      }
    },
    fips: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    scale: {
      type: Function,
      "default": null
    },
    linearScale: {
      type: Function,
      "default": null
    },
    notScaled: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    invertScale: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    defaultColour: {
      type: String,
      "default": function _default() {
        return 'black';
      }
    },
    date: {
      type: Date,
      "default": null
    },
    showExactNumber: {
      type: Boolean,
      "default": false
    },
    buttonExpanded: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    dataset: function dataset() {
      var _this = this;

      if (this.metric.metric.datasets.length === 0) return null;
      var fipsSet = this.metric.metric.datasets.find(function (dataset) {
        return SmallCardInfovue_type_script_lang_ts_matchesFips(_this.fips, dataset.geoId) || SmallCardInfovue_type_script_lang_ts_matchesFips(_this.fips, dataset.geo_id);
      });
      return fipsSet || null;
    },
    title: function title() {
      var _this$metadata;

      return ((_this$metadata = this.metadata) === null || _this$metadata === void 0 ? void 0 : _this$metadata.displayName) || this.metric.metric.name;
    },
    subtitle: function subtitle() {
      return getSubtitle(this.metadata, this.dataset, this.title, this.metric.metric.name, this.formFactor);
    },
    dateString: function dateString() {
      var _this$dataset, _this$dataset2;

      if (!this.date) return '';
      var xType = (((_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.xType) || ((_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.x_type) || 'Items').toLowerCase();

      if (xType === 'quarters' || xType === 'quarterly') {
        return helpers_dateFormat(this.date, xType);
      }

      return this.date.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    extraSpace: function extraSpace() {
      return this.subtitle === '' ? '\xa0' : '';
    },
    metadata: function metadata() {
      return this.metric.metric.metadata;
    },
    deltaValue: function deltaValue() {
      var dset = this.dataset;
      if (!dset) return undefined;
      return helpers_getDeltaParams(dset, this.metadata, {
        date: this.date
      });
    },
    deltaType: function deltaType() {
      var _this$dataset3, _this$dataset4;

      return ((_this$dataset3 = this.dataset) === null || _this$dataset3 === void 0 ? void 0 : _this$dataset3.yType) || ((_this$dataset4 = this.dataset) === null || _this$dataset4 === void 0 ? void 0 : _this$dataset4.y_type);
    },
    deltaCaption: function deltaCaption() {
      if (!this.dataset) return {
        prefix: '',
        timePeriod: ''
      };
      var xType = this.dataset.xType || this.dataset.x_type || 'Items';
      return helpers_getDeltaCaption(this.dataset, xType, this.metadata);
    },
    captionFlex: function captionFlex() {
      if (this.formFactor === 'tiny') return 'flex-row';
      return this.deltaCaption.prefix.length > 5 ? 'flex-col' : 'flex-row';
    },
    captionLighter: function captionLighter() {
      return this.deltaCaption.timePeriod !== '' ? 'caption-lighter' : '';
    },
    state: function state() {
      return STATE_CODES[this.fips] || 'National';
    }
  }
}));
// CONCATENATED MODULE: ./src/components/SmallCardInfo/SmallCardInfo.ts?vue&type=script&lang=ts&
 /* harmony default export */ var SmallCardInfo_SmallCardInfovue_type_script_lang_ts_ = (SmallCardInfovue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/SmallCardInfo/SmallCardInfo.vue?vue&type=style&index=0&id=22113fa5&lang=postcss&scoped=true&
var SmallCardInfovue_type_style_index_0_id_22113fa5_lang_postcss_scoped_true_ = __webpack_require__("21de");

// CONCATENATED MODULE: ./src/components/SmallCardInfo/SmallCardInfo.vue






/* normalize component */

var SmallCardInfo_component = normalizeComponent(
  SmallCardInfo_SmallCardInfovue_type_script_lang_ts_,
  SmallCardInfovue_type_template_id_22113fa5_scoped_true_render,
  SmallCardInfovue_type_template_id_22113fa5_scoped_true_staticRenderFns,
  false,
  null,
  "22113fa5",
  null
  
)

/* harmony default export */ var SmallCardInfo = (SmallCardInfo_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/SmallCardDrawer/SmallCardDrawer.vue?vue&type=template&id=252962b8&scoped=true&
var SmallCardDrawervue_type_template_id_252962b8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-card-drawer w-full flex"},[_c('div',{staticClass:"drawer-div w-full flex-col"},[_c('div',{staticClass:"drawer-content w-full flex flex-col",class:{
                'pt-2': !_vm.$screens.mobile && _vm.buttonExpanded,
                'opacity-0': !_vm.buttonExpanded
            },style:({ height: _vm.displayHeight })},[_c('div',{staticClass:"small-drawer-info flex flex-row flex-shrink-0 overflow-y-hidden",staticStyle:{"height":"120px"}},[(_vm.title && _vm.deltaColour)?_c('div',{staticClass:"flex w-2/5 self-center text-sm md:text-base"},[_c('DeltaMessage',{attrs:{"metric":_vm.metric,"fips":_vm.fips,"date":_vm.date,"delta-colour":_vm.deltaColour,"invert-scale":_vm.invertScale,"show-exact-number":_vm.showExactNumber,"national-only":_vm.noStates,"custom-auto-text":_vm.customAutoText,"include-category":false}})],1):_vm._e(),_c('div',{staticClass:"w-3/5"},[_c('DHAChart',{attrs:{"data":_vm.chartData,"chart-options":_vm.chartOptions,"data-selector":_vm.dataSelector,"on-draw":_vm.onDraw},on:{"point":_vm.onChartHover}})],1)]),(!_vm.$screens.mobile)?_c('Explore',{on:{"click":_vm.onExplore}}):_vm._e(),_c('div',{staticClass:"small-drawer-buttons flex flex-row flex-wrap flex-shrink-0 justify-around",style:({ visibility: _vm.buttonsVisible ? 'visible' : 'hidden' })},_vm._l((_vm.tabs),function(tab,i){return _c('div',{key:(tab + "-" + i),staticClass:"tab-button whitespace-no-wrap flex items-center px-2 py-1 text-xs uppercase cursor-pointer tracking-widest",class:{ 'tab-selected': i === _vm.selectedTab },on:{"click":function($event){return _vm.onSelectTab(i)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0)],1)])])}
var SmallCardDrawervue_type_template_id_252962b8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/SmallCardDrawer/SmallCardDrawer.vue?vue&type=template&id=252962b8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/SmallCardDrawer/SmallCardDrawer.ts?vue&type=script&lang=ts&














/* harmony default export */ var SmallCardDrawervue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    DrawerElementContainer: DrawerElementContainer,
    CartoSelector: CartoSelector,
    CategorySelector: CategorySelector,
    DHAChart: DHAChart,
    DeltaMessage: DeltaMessage,
    Explore: Explore
  },
  props: {
    model: {
      type: Object,
      "default": null
    },
    buttonExpanded: {
      type: Boolean,
      "default": false
    },
    date: {
      type: Date,
      "default": null
    },
    chartData: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    chartOptions: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    dataSelector: {
      type: Function,
      "default": null
    },
    metric: {
      type: Object,
      "default": function _default() {
        return {
          metric: {
            datasets: []
          }
        };
      }
    },
    fips: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    showExactNumber: {
      type: Boolean,
      "default": false
    },
    defaultColour: {
      type: String,
      "default": function _default() {
        return 'black';
      }
    },
    invertScale: {
      type: Boolean,
      required: false,
      "default": function _default() {
        return false;
      }
    },
    notScaled: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    scale: {
      type: Function,
      "default": null
    },
    chartIndex: {
      type: Number,
      "default": function _default() {
        return 0;
      }
    },
    onDraw: {
      type: Function,
      "default": null
    },
    customAutoText: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      calculatedDisplayHeight: '0px'
    };
  },
  computed: {
    buttonsVisible: function buttonsVisible() {
      return !!this.$screens.mobile;
    },
    displayHeight: function displayHeight() {
      if (!this.buttonExpanded) return '0px';
      return this.calculatedDisplayHeight;
    },
    metadata: function metadata() {
      return this.metric.metric.metadata;
    },
    dataset: function dataset() {
      var _this = this;

      if (this.metric.metric.datasets.length === 0) return null;
      var fipsSet = this.metric.metric.datasets.find(function (dataset) {
        return matchesFips(_this.fips, dataset.geoId) || matchesFips(_this.fips, dataset.geo_id);
      });
      return fipsSet || null;
    },
    deltaValues: function deltaValues() {
      var dset = this.dataset;
      if (!dset) return undefined;
      return helpers_getDeltaParams(dset, this.metadata);
    },
    deltaValue: function deltaValue() {
      return this.dataset ? helpers_getDeltaParams(this.dataset, this.metadata, {
        date: this.date
      }) : undefined;
    },
    deltaType: function deltaType() {
      var _this$dataset, _this$dataset2;

      return ((_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.yType) || ((_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.y_type);
    },
    deltaCaption: function deltaCaption() {
      if (!this.dataset) return {
        prefix: '',
        timePeriod: ''
      };
      var xType = this.dataset.xType || this.dataset.x_type || 'Items';
      return helpers_getDeltaCaption(this.dataset, xType, this.metadata);
    },
    deltaColour: function deltaColour() {
      var scale = this.scale;
      return getDeltaColour(this.defaultColour, this.notScaled, this.deltaValue, scale);
    },
    title: function title() {
      var _this$metadata;

      return ((_this$metadata = this.metadata) === null || _this$metadata === void 0 ? void 0 : _this$metadata.displayName) || this.metric.metric.name;
    },
    subtitle: function subtitle() {
      return getSubtitle(this.metadata, this.dataset, this.title, this.metric.metric.name);
    },
    tabs: function tabs() {
      return this.model.tabs[this.chartIndex];
    },
    selectedTab: function selectedTab() {
      return this.model.selectedTabs[this.chartIndex];
    },
    state: function state() {
      return STATE_CODES[this.fips] || 'National';
    },
    noStates: function noStates() {
      return this.model.noStates[this.chartIndex];
    }
  },
  watch: {
    buttonsVisible: function buttonsVisible() {
      var _this2 = this;

      if (this.buttonsVisible) {
        this.$nextTick(function () {
          var smallInfo = d3_selection_src["i" /* select */](_this2.$el).select('.small-drawer-info').node();
          var totalHeight = smallInfo.getBoundingClientRect().height;
          _this2.calculatedDisplayHeight = "".concat(totalHeight + 30, "px");
        });
      }
    },
    deltaValue: function deltaValue() {
      var circle = d3_selection_src["i" /* select */](this.$el).select('.visible');
      var scale = this.scale;
      circle.style('fill', getDeltaColour(this.defaultColour, this.notScaled, this.deltaValue, scale) || 'black');
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var smallInfo = d3_selection_src["i" /* select */](this.$el).select('.small-drawer-info').node();
    var ro = new ResizeObserver_es["a" /* default */](function (entries) {
      requestAnimationFrame(function () {
        _this3.calculatedDisplayHeight = "".concat(entries[0].contentRect.height + 30, "px");
      });
    });
    ro.observe(smallInfo);
  },
  methods: {
    onSelectTab: function onSelectTab(index) {
      this.model.setSelectedTab(this.chartIndex, index);
    },
    onChartHover: function onChartHover(datum) {
      this.$emit('chart-hover', datum);
    },
    onExplore: function onExplore() {
      this.$emit('explore');
    }
  }
}));
// CONCATENATED MODULE: ./src/views/SmallCardDrawer/SmallCardDrawer.ts?vue&type=script&lang=ts&
 /* harmony default export */ var SmallCardDrawer_SmallCardDrawervue_type_script_lang_ts_ = (SmallCardDrawervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/SmallCardDrawer/SmallCardDrawer.vue?vue&type=style&index=0&id=252962b8&lang=postcss&scoped=true&
var SmallCardDrawervue_type_style_index_0_id_252962b8_lang_postcss_scoped_true_ = __webpack_require__("2adf");

// CONCATENATED MODULE: ./src/views/SmallCardDrawer/SmallCardDrawer.vue






/* normalize component */

var SmallCardDrawer_component = normalizeComponent(
  SmallCardDrawer_SmallCardDrawervue_type_script_lang_ts_,
  SmallCardDrawervue_type_template_id_252962b8_scoped_true_render,
  SmallCardDrawervue_type_template_id_252962b8_scoped_true_staticRenderFns,
  false,
  null,
  "252962b8",
  null
  
)

/* harmony default export */ var SmallCardDrawer = (SmallCardDrawer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Sparkline/Sparkline.vue?vue&type=template&id=2a128585&
var Sparklinevue_type_template_id_2a128585_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dha-chart box-border flex-1 sparkline"})}
var Sparklinevue_type_template_id_2a128585_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Sparkline/Sparkline.vue?vue&type=template&id=2a128585&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/components/Sparkline/Sparkline.ts?vue&type=script&lang=ts&


/* harmony default export */ var Sparklinevue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  props: {
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    formFactor: {
      type: String,
      "default": function _default() {
        return 'small';
      }
    }
  },
  data: function data() {
    return {
      chart: null,
      didFirstLoading: false,
      didFirstDraw: false
    };
  },
  computed: {
    chartOptions: function chartOptions() {
      return {
        chartType: 0,
        primaryColor: 'black',
        hideTitle: true,
        hideGridlines: true,
        showXGridlines: false,
        showZeroLine: false,
        hideAxisLabels: true,
        hideLineLabels: true,
        lineSize: this.formFactor === 'tiny' ? 1.5 : 1,
        fontSize: 10,
        hideTooltip: true,
        showLastPoint: true,
        heightToWidthRatio: this.formFactor === 'tiny' ? 0.5 : 1,
        margins: {
          top: this.marginY,
          bottom: this.marginY,
          left: this.marginX,
          right: this.marginX
        },
        showLegend: false,
        showSourcesAndFootnotes: false
      };
    },
    marginX: function marginX() {
      return this.formFactor === 'tiny' ? 10 : 2;
    },
    marginY: function marginY() {
      return this.formFactor === 'tiny' ? 10 : 10;
    }
  },
  watch: {
    data: function data() {
      this.drawChart();
    }
  },
  mounted: function mounted() {
    this.chart = new usafacts_metrics["Chart"](this.$el);
    this.drawChart();
  },
  methods: {
    drawChart: function drawChart() {
      if (this.chart) {
        if (!this.didFirstLoading) {
          this.chart.setLoading();
        }

        this.didFirstLoading = true;

        if (this.data.data) {
          this.chart.draw(this.data, this.chartOptions);
          this.didFirstDraw = true;
        }
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/Sparkline/Sparkline.ts?vue&type=script&lang=ts&
 /* harmony default export */ var Sparkline_Sparklinevue_type_script_lang_ts_ = (Sparklinevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/Sparkline/Sparkline.vue?vue&type=style&index=0&lang=postcss&
var Sparklinevue_type_style_index_0_lang_postcss_ = __webpack_require__("6a23");

// CONCATENATED MODULE: ./src/components/Sparkline/Sparkline.vue






/* normalize component */

var Sparkline_component = normalizeComponent(
  Sparkline_Sparklinevue_type_script_lang_ts_,
  Sparklinevue_type_template_id_2a128585_render,
  Sparklinevue_type_template_id_2a128585_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sparkline = (Sparkline_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/SmallChartCardView/SmallChartCardView.ts?vue&type=script&lang=ts&








/* harmony default export */ var SmallChartCardViewvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    SmallCardInfo: SmallCardInfo,
    SmallCardDrawer: SmallCardDrawer,
    DHAChart: DHAChart,
    Sparkline: Sparkline
  },
  props: {
    model: {
      type: Object,
      "default": null
    },
    chartIndex: {
      type: Number,
      "default": function _default() {
        return 0;
      }
    },
    dataSelector: {
      type: Function,
      "default": undefined
    },
    onDraw: {
      type: Function,
      "default": null
    }
  },
  data: function data() {
    return {
      buttonExpanded: false,
      xPoints: 'M14 1.40951L12.59 -0.000488281L7 5.58951L1.41 -0.000488281L0 1.40951L5.59 6.99951L0 12.5895L1.41 13.9995L7 8.40951L12.59 13.9995L14 12.5895L8.41 6.99951L14 1.40951Z',
      chartScrubDate: null
    };
  },
  computed: {
    isMobile: function isMobile() {
      return !!this.$screens.mobile;
    },
    chartData: function chartData() {
      var _this$model$dataPromi;

      return (_this$model$dataPromi = this.model.dataPromises) === null || _this$model$dataPromi === void 0 ? void 0 : _this$model$dataPromi[this.chartIndex];
    },
    resolvedData: function resolvedData() {
      var _this$model$data;

      return (_this$model$data = this.model.data) === null || _this$model$data === void 0 ? void 0 : _this$model$data[this.chartIndex];
    },
    xDomain: function xDomain() {
      if (!this.resolvedData) return null;
      return helpers_niceXDomain(this.resolvedData);
    },
    metric: function metric() {
      var _this$resolvedData;

      var allData = (_this$resolvedData = this.resolvedData) === null || _this$resolvedData === void 0 ? void 0 : _this$resolvedData.data;
      return allData ? allData[0] : undefined;
    },
    dataset: function dataset() {
      var _this$metric;

      return (_this$metric = this.metric) === null || _this$metric === void 0 ? void 0 : _this$metric.metric.datasets[0];
    },
    chartOptions: function chartOptions() {
      var _this$dataset;

      var xType = this.dataset ? this.dataset.xType || this.dataset.x_type : null;
      return {
        chartType: 0,
        primaryColor: '#666666',
        hideTitle: true,
        hideGridlines: true,
        showXGridlines: true,
        showZeroLine: true,
        hideAxisLabels: 'y',
        hideLineLabels: true,
        fips: this.currentFips,
        // xDomain: this.xDomain?.niceDomain,
        lineSize: 3,
        fontSize: 10,
        xTickFormat: xType ? helpers_shortXTick : null,
        tooltipOptions: {
          title: (_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.name,
          position: 'above',
          tooltipStyle: 'scrub'
        },
        margins: {
          top: 0,
          bottom: 30,
          left: 0,
          right: 0
        },
        chartStyle: 'spaghetti',
        showLastPoint: true,
        showLegend: false,
        showSourcesAndFootnotes: false
      };
    },
    date: function date() {
      var _this$xDomain;

      return this.chartScrubDate || ((_this$xDomain = this.xDomain) === null || _this$xDomain === void 0 ? void 0 : _this$xDomain.end) || null;
    },
    currentFips: function currentFips() {
      return this.model.currentFips[this.chartIndex];
    },
    colourPalette: function colourPalette() {
      return this.$appModel.colourPalette;
    },
    isPercentMetric: function isPercentMetric() {
      var _this$metric2, _this$metric2$metric$;

      return ((_this$metric2 = this.metric) === null || _this$metric2 === void 0 ? void 0 : (_this$metric2$metric$ = _this$metric2.metric.metadata) === null || _this$metric2$metric$ === void 0 ? void 0 : _this$metric2$metric$.transformation.toLowerCase()) === 'pctchange';
    },
    notScaled: function notScaled() {
      return this.model.notScaled[this.chartIndex];
    },
    invertScale: function invertScale() {
      return this.model.invertScales[this.chartIndex];
    },
    centerZero: function centerZero() {
      return this.model.centerZero[this.chartIndex];
    },
    colourScale: function colourScale() {
      if (this.metric === undefined || this.notScaled) return undefined;
      return helpers_getColourScale(this.metric.metric, this.$appModel.colourPalette, this.invertScale, this.centerZero);
    },
    indexScale: function indexScale() {
      if (this.metric === undefined) return undefined;
      return helpers_getIndexScale(this.metric.metric, this.$appModel.colourPalette.length, this.invertScale, this.centerZero);
    },
    linearScale: function linearScale() {
      if (this.metric === undefined) return undefined;
      return helpers_getLinearScale(this.metric.metric, this.centerZero);
    },
    defaultColour: function defaultColour() {
      return this.$appModel.notScaled;
    },
    customAutoText: function customAutoText() {
      var _this$model$currentCu;

      return (_this$model$currentCu = this.model.currentCustomAutoText) === null || _this$model$currentCu === void 0 ? void 0 : _this$model$currentCu[this.chartIndex];
    },
    showExactNumber: function showExactNumber() {
      return this.model.showExactNumber[this.chartIndex];
    },
    displayX: function displayX() {
      return this.buttonExpanded ? 'block' : 'none';
    },
    displayV: function displayV() {
      return this.buttonExpanded ? 'none' : 'block';
    },
    matchesGlobalFips: function matchesGlobalFips() {
      return this.model.matchesGlobalFips[this.chartIndex];
    }
  },
  watch: {
    isMobile: function isMobile() {
      if (!this.isMobile) {
        this.buttonExpanded = true;
      }
    }
  },
  mounted: function mounted() {
    if (this.$screens.md) this.buttonExpanded = true;
    var startOpen = this.model.startOpen;

    if (startOpen[this.chartIndex]) {
      this.buttonExpanded = true;
    }
  },
  methods: {
    onExplore: function onExplore() {
      this.model.setSelectedMetric(this.chartIndex);

      if (this.model.linkAction) {
        this.model.linkAction();
      }
    },
    toggleButton: function toggleButton() {
      if (this.$screens.md) {
        this.buttonExpanded = true;
      } else {
        this.buttonExpanded = !this.buttonExpanded;
      }
    },
    onChartHover: function onChartHover(datum) {
      if (!datum) {
        this.chartScrubDate = null;
        return;
      }

      this.chartScrubDate = datum.key;
    }
  }
}));
// CONCATENATED MODULE: ./src/views/SmallChartCardView/SmallChartCardView.ts?vue&type=script&lang=ts&
 /* harmony default export */ var SmallChartCardView_SmallChartCardViewvue_type_script_lang_ts_ = (SmallChartCardViewvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/SmallChartCardView/SmallChartCardView.vue?vue&type=style&index=0&id=73975600&lang=postcss&scoped=true&
var SmallChartCardViewvue_type_style_index_0_id_73975600_lang_postcss_scoped_true_ = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/views/SmallChartCardView/SmallChartCardView.vue






/* normalize component */

var SmallChartCardView_component = normalizeComponent(
  SmallChartCardView_SmallChartCardViewvue_type_script_lang_ts_,
  SmallChartCardViewvue_type_template_id_73975600_scoped_true_render,
  SmallChartCardViewvue_type_template_id_73975600_scoped_true_staticRenderFns,
  false,
  null,
  "73975600",
  null
  
)

/* harmony default export */ var SmallChartCardView = (SmallChartCardView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/TinyCardView/TinyCardView.vue?vue&type=template&id=2fe5ad04&scoped=true&
var TinyCardViewvue_type_template_id_2fe5ad04_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$screens.mobile)?_c('div',{staticClass:"tiny-card relative flex flex-col w-full h-full p-2 cursor-pointer sm:rounded",class:{
        selected: _vm.selected,
        unselected: !_vm.selected
    },on:{"click":_vm.onClick}},[_c('div',{staticClass:"flex flex-row h-12"},[_c('SmallCardInfo',{staticClass:"pl-4",attrs:{"form-factor":"tiny","metric":_vm.metric,"fips":_vm.currentFips,"scale":_vm.colourScale,"not-scaled":_vm.notScaled,"default-colour":_vm.defaultColour,"date":_vm.date,"show-exact-number":_vm.showExactNumber}}),_c('Sparkline',{staticClass:"align-middle w-full h-full",attrs:{"data":_vm.chartData,"form-factor":"tiny"}})],1),_c('div',{staticClass:"tiny-card-status-container"},[_c('StatusIndicator',{staticClass:"status-indicator",attrs:{"legend-mode":false,"not-scaled":_vm.notScaled,"default-colour":_vm.defaultColour,"metric":_vm.metric,"type":_vm.deltaType,"fips":_vm.currentFips,"scale":_vm.colourScale,"invert-scale":_vm.invertScale,"index-scale":_vm.indexScale,"linear-scale":_vm.linearScale,"show-exact-number":_vm.showExactNumber}})],1)]):_vm._e()}
var TinyCardViewvue_type_template_id_2fe5ad04_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/TinyCardView/TinyCardView.vue?vue&type=template&id=2fe5ad04&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/TinyCardView/TinyCardView.ts?vue&type=script&lang=ts&






/* harmony default export */ var TinyCardViewvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    SmallCardInfo: SmallCardInfo,
    StatusIndicator: StatusIndicator,
    Sparkline: Sparkline
  },
  props: {
    model: {
      type: Object,
      "default": null
    },
    chartIndex: {
      type: Number,
      "default": function _default() {
        return 0;
      }
    },
    dataSelector: {
      type: Function,
      "default": undefined
    }
  },
  computed: {
    selected: function selected() {
      return this.chartIndex === this.model.selectedMetric;
    },
    chartData: function chartData() {
      var _this$model$dataPromi;

      return (_this$model$dataPromi = this.model.dataPromises) === null || _this$model$dataPromi === void 0 ? void 0 : _this$model$dataPromi[this.chartIndex];
    },
    resolvedData: function resolvedData() {
      var _this$model$data;

      return (_this$model$data = this.model.data) === null || _this$model$data === void 0 ? void 0 : _this$model$data[this.chartIndex];
    },
    xDomain: function xDomain() {
      if (!this.resolvedData) return null;
      return helpers_niceXDomain(this.resolvedData);
    },
    metric: function metric() {
      var _this$resolvedData;

      var allData = (_this$resolvedData = this.resolvedData) === null || _this$resolvedData === void 0 ? void 0 : _this$resolvedData.data;
      return allData ? allData[0] : undefined;
    },
    date: function date() {
      var _this$xDomain;

      return ((_this$xDomain = this.xDomain) === null || _this$xDomain === void 0 ? void 0 : _this$xDomain.end) || null;
    },
    currentFips: function currentFips() {
      return this.model.currentFips[this.chartIndex];
    },
    colourPalette: function colourPalette() {
      return this.$appModel.colourPalette;
    },
    isPercentMetric: function isPercentMetric() {
      var _this$metric, _this$metric$metric$m;

      return ((_this$metric = this.metric) === null || _this$metric === void 0 ? void 0 : (_this$metric$metric$m = _this$metric.metric.metadata) === null || _this$metric$metric$m === void 0 ? void 0 : _this$metric$metric$m.transformation.toLowerCase()) === 'pctchange';
    },
    notScaled: function notScaled() {
      return this.model.notScaled[this.chartIndex];
    },
    invertScale: function invertScale() {
      return this.model.invertScales[this.chartIndex];
    },
    centerZero: function centerZero() {
      return this.model.centerZero[this.chartIndex];
    },
    colourScale: function colourScale() {
      if (this.metric === undefined || this.notScaled) return undefined;
      return helpers_getColourScale(this.metric.metric, this.$appModel.colourPalette, this.invertScale, this.centerZero);
    },
    indexScale: function indexScale() {
      if (this.metric === undefined || this.notScaled) return undefined;
      return helpers_getIndexScale(this.metric.metric, this.$appModel.colourPalette.length, this.invertScale, this.centerZero);
    },
    linearScale: function linearScale() {
      if (this.metric === undefined) return undefined;
      return helpers_getLinearScale(this.metric.metric, this.centerZero);
    },
    deltaType: function deltaType() {
      var _this$metric2;

      var dataset = (_this$metric2 = this.metric) === null || _this$metric2 === void 0 ? void 0 : _this$metric2.metric.datasets[0];
      return (dataset === null || dataset === void 0 ? void 0 : dataset.yType) || (dataset === null || dataset === void 0 ? void 0 : dataset.y_type);
    },
    defaultColour: function defaultColour() {
      return this.$appModel.notScaled;
    },
    showExactNumber: function showExactNumber() {
      return this.model.showExactNumber[this.chartIndex];
    }
  },
  methods: {
    onClick: function onClick() {
      this.model.setSelectedMetric(this.chartIndex);
    }
  }
}));
// CONCATENATED MODULE: ./src/views/TinyCardView/TinyCardView.ts?vue&type=script&lang=ts&
 /* harmony default export */ var TinyCardView_TinyCardViewvue_type_script_lang_ts_ = (TinyCardViewvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/TinyCardView/TinyCardView.vue?vue&type=style&index=0&id=2fe5ad04&scoped=true&lang=css&
var TinyCardViewvue_type_style_index_0_id_2fe5ad04_scoped_true_lang_css_ = __webpack_require__("ad19");

// CONCATENATED MODULE: ./src/views/TinyCardView/TinyCardView.vue






/* normalize component */

var TinyCardView_component = normalizeComponent(
  TinyCardView_TinyCardViewvue_type_script_lang_ts_,
  TinyCardViewvue_type_template_id_2fe5ad04_scoped_true_render,
  TinyCardViewvue_type_template_id_2fe5ad04_scoped_true_staticRenderFns,
  false,
  null,
  "2fe5ad04",
  null
  
)

/* harmony default export */ var TinyCardView = (TinyCardView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"a686b7d6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/LegendView/LegendView.vue?vue&type=template&id=2f315d6d&scoped=true&
var LegendViewvue_type_template_id_2f315d6d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-container w-full flex flex-col relative"},[_c('div',{staticClass:"legend-status-indicator px-8"},[_c('StatusIndicator',{attrs:{"legend-mode":true,"invert-scale":true}})],1)])}
var LegendViewvue_type_template_id_2f315d6d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/LegendView/LegendView.vue?vue&type=template&id=2f315d6d&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/eslint-loader??ref--13-0!./src/views/LegendView/LegendView.ts?vue&type=script&lang=ts&





/* harmony default export */ var LegendViewvue_type_script_lang_ts_ = (vue_runtime_esm["a" /* default */].extend({
  useMobxComputed: true,
  components: {
    StatusIndicator: StatusIndicator
  },
  props: {},
  data: function data() {
    return {
      greyItem: {
        colour: this.$appModel.notScaled,
        text: 'not scaled',
        lrRounded: [true, true],
        textBelow: true
      }
    };
  },
  computed: {
    divergingItems: function divergingItems() {
      var _this = this;

      var legendArray = [];
      this.$appModel.colourPalette.forEach(function (d, i) {
        var lRounded = false;
        var rRounded = false;
        var textString = '';

        if (i === 0) {
          lRounded = true;
          textString = _this.$appModel.scaleLabels[0];
        }

        if (i === _this.$appModel.colourPalette.length - 1) {
          rRounded = true;
          textString = _this.$appModel.scaleLabels[_this.$appModel.scaleLabels.length - 1];
        }

        var item = {
          colour: d,
          text: textString,
          lrRounded: [lRounded, rRounded],
          textBelow: true
        };
        legendArray.push(item);
      });
      return legendArray;
    },
    sequentialItems: function sequentialItems() {
      var _this2 = this;

      return this.$appModel.sequentialPalette.map(function (d, i) {
        return {
          colour: d,
          text: _this2.$appModel.sequentialLabels[i],
          lrRounded: [true, true],
          textBelow: true
        };
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/views/LegendView/LegendView.ts?vue&type=script&lang=ts&
 /* harmony default export */ var LegendView_LegendViewvue_type_script_lang_ts_ = (LegendViewvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/views/LegendView/LegendView.vue?vue&type=style&index=0&id=2f315d6d&lang=postcss&scoped=true&
var LegendViewvue_type_style_index_0_id_2f315d6d_lang_postcss_scoped_true_ = __webpack_require__("b662");

// CONCATENATED MODULE: ./src/views/LegendView/LegendView.vue






/* normalize component */

var LegendView_component = normalizeComponent(
  LegendView_LegendViewvue_type_script_lang_ts_,
  LegendViewvue_type_template_id_2f315d6d_scoped_true_render,
  LegendViewvue_type_template_id_2f315d6d_scoped_true_staticRenderFns,
  false,
  null,
  "2f315d6d",
  null
  
)

/* harmony default export */ var LegendView = (LegendView_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__("e25e");

// EXTERNAL MODULE: ./node_modules/tailwindcss/resolveConfig.js
var resolveConfig = __webpack_require__("1c0d");
var resolveConfig_default = /*#__PURE__*/__webpack_require__.n(resolveConfig);

// EXTERNAL MODULE: ./tailwind.config.js
var tailwind_config = __webpack_require__("d26c");
var tailwind_config_default = /*#__PURE__*/__webpack_require__.n(tailwind_config);

// CONCATENATED MODULE: ./src/screens.ts



/**
 * Provides a reactive check for the tailwind screen type.
 *
 * When window resizes, the screens will change reactively using Vue observable.
 *
 * Contains the width and height of the window, the current tailwind screen class
 * AND a flag for each class that is false if that class is not used.
 *
 */


 // @ts-ignore


var fullConfig = resolveConfig_default()(tailwind_config_default.a);

var tailwindScreens = lodash_default.a.mapValues(fullConfig.theme.screens, function (tailwindScreen) {
  var screen = {
    min: 0,
    max: Infinity
  };

  if (tailwindScreen.max) {
    screen.max = parseInt(tailwindScreen.max, 10);
  }

  if (tailwindScreen.min) {
    screen.min = parseInt(tailwindScreen.min, 10);
  }

  if (!tailwindScreen.min && !tailwindScreen.max) {
    screen.min = parseInt(tailwindScreen, 10);
  }

  return screen;
}); // Calculates which screen is currently used based on the width, and sets the flags for each
// breakpoint.


function currentScreens() {
  var width = window.innerWidth;

  var current = lodash_default.a.mapValues(tailwindScreens, function (screen) {
    return screen.max >= width && screen.min <= width && screen;
  });

  return current;
}

var screens = vue_runtime_esm["a" /* default */].observable(_objectSpread2({
  w: window.innerWidth,
  h: window.innerHeight
}, currentScreens()));

function updateScreens() {
  screens.w = window.innerWidth;
  screens.h = window.innerHeight;

  lodash_default.a.assign(screens, currentScreens());
}

updateScreens();
window.addEventListener('resize', lodash_default.a.debounce(updateScreens, 150)); // @ts-ignore

screens.install = function () {
  vue_runtime_esm["a" /* default */].prototype.$screens = screens;
};

/* harmony default export */ var src_screens = (screens);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ./node_modules/mobx/lib/mobx.module.js
var mobx_module = __webpack_require__("daf9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./src/model/helpers.ts











// formats a getChartData response into an object holding each of its parts, like a chart would
var gatherDataPromises = function gatherDataPromises(promises) {
  return Promise.all([promises.data, promises.parent, promises.topMetrics ? promises.topMetrics : [], promises.bottomMetrics ? promises.bottomMetrics : []]).then(function (data) {
    return {
      data: data[0],
      parent: data[1],
      topMetrics: data[2],
      bottomMetrics: data[3]
    };
  });
}; // formats multiple getChartDataResponses

function formatResolvedData(promises) {
  return Promise.all(promises.map(function (arr) {
    return Promise.all(arr.map(function (promise) {
      return gatherDataPromises(promise);
    }));
  }));
}
/**
 *
 * for a tree such as:
 *
 * {
 *     "By category": {
 *         "Health": "sotu10005",
 *         "Unemployment": "sotu10006",
 *         "Treasury": "sotu10007",
 *         "Social Security": "sotu10008"
 *     }
 * }
 *
 * return an array of TreeChildren which contains every leaf of tree:
 *
 * [
 *     {
 *          name: "Health",
 *          spec: {
 *              id: "sotu10005"
 *          }
 *     },
 *     {
 *          name: "Unemployment",
 *          spec: {
 *              id: "sotu10006"
 *          }
 *     },
 *     ...
 * ]
 */

var helpers_getAllChildren = function getAllChildren(tree) {
  var values = [];
  Object.entries(tree).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value === 'string') {
      values.push({
        name: key,
        spec: {
          id: value
        }
      });
    } else {
      values = values.concat(getAllChildren(value));
    }
  });
  return values;
};
// CONCATENATED MODULE: ./src/model/CardModel/cardModelHelpers.ts









function getAllCategoryIDs(defaultIDs, fips, children, showParent) {
  var ids = defaultIDs.map(function (spec) {
    return _objectSpread2(_objectSpread2({}, spec), {}, {
      selector: '__parent'
    });
  });

  if (children && children.length > 0) {
    if (showParent) {
      ids = ids.concat(children.map(function (_ref) {
        var spec = _ref.spec,
            name = _ref.name;
        return _objectSpread2(_objectSpread2({}, spec), {}, {
          selector: name
        });
      }));
    } else {
      ids = children.map(function (_ref2) {
        var spec = _ref2.spec,
            name = _ref2.name;
        return _objectSpread2(_objectSpread2({}, spec), {}, {
          selector: name
        });
      });
    }
  }

  if (fips) {
    if (fips === 'US' || fips === '00') {
      return ids;
    }

    return ids.map(function (spec) {
      var stateID = "".concat(spec.id).concat(fips);
      return _objectSpread2(_objectSpread2({}, spec), {}, {
        id: stateID
      });
    });
  }

  return ids;
}
function getAllLocationIDs(defaultIDs, category, children, showParent) {
  var allFips = Object.keys(STATE_CODES);

  if (showParent) {
    allFips.unshift('');
  }

  if (category) {
    var _children$find;

    var categoryID = (_children$find = children.find(function (_ref3) {
      var name = _ref3.name;
      return name === category;
    })) === null || _children$find === void 0 ? void 0 : _children$find.spec.id;

    if (categoryID) {
      return allFips.map(function (fips) {
        return {
          id: "".concat(categoryID).concat(fips)
        };
      });
    }

    return defaultIDs.flatMap(function (spec) {
      return allFips.map(function (fips) {
        return {
          id: "".concat(spec.id).concat(fips)
        };
      });
    });
  }

  return defaultIDs.flatMap(function (spec) {
    return allFips.map(function (fips) {
      return {
        id: "".concat(spec.id).concat(fips)
      };
    });
  });
}
function getSingleCategoryID(defaultID, category, fips, children) {
  var _children$find2;

  var outID = defaultID.id;
  var categoryID = (_children$find2 = children.find(function (_ref4) {
    var name = _ref4.name;
    return name === category;
  })) === null || _children$find2 === void 0 ? void 0 : _children$find2.spec.id;

  if (categoryID) {
    outID = categoryID;
  }

  if (fips && fips !== 'US' && fips !== '00') {
    outID = "".concat(outID).concat(fips);
  }

  return [{
    id: outID
  }];
}
function getSingleNormalID(spec, fips) {
  var outID = spec.id;

  if (fips && fips !== 'US' && fips !== '00') {
    outID = "".concat(outID).concat(fips);
  }

  return _objectSpread2(_objectSpread2({}, spec), {}, {
    id: outID
  });
}
// CONCATENATED MODULE: ./src/model/CardModel/BigChartCardModel.ts













var PARENT_CATEGORY_ID = '__parent';
var BigChartCardModel_BigChartCardModel = /*#__PURE__*/function () {
  function BigChartCardModel(model) {
    var _this = this;

    _classCallCheck(this, BigChartCardModel);

    // properties that might be modified by clicking around in the tabs/drawer
    this.userSelectedTab = null;
    this.userSelectedCategory = undefined;
    this.userHoveredCategory = undefined;
    this.selectedFips = null;
    this.hoveredFips = null;
    this.hoveredCategoryChart = null;
    this.locationTab = 'states';
    this.compareBy = null;
    this.stateDataStatus = {}; // parent TopicModel

    this.model = model; // container where corresponding BigChartCardView will be mounted

    this.containerID = model.bigContainer; // if selectedTab, selectedMetric, selectedFips, locationTab, or compareBy change, update the data

    Object(mobx_module["d" /* reaction */])(function () {
      return _this.drawerIDs;
    }, function (ids) {
      var drawerPromises = _this.getNewData(ids); // store the promises for consumption by charts


      _this.dataPromises = drawerPromises;

      if (drawerPromises) {
        // when the promises resolve, dump the results into this.data
        gatherDataPromises(drawerPromises).then(function (resolved) {
          _this.setData(resolved);

          _this.setCustomAutoText(_this.customAutoText);
        });
      } else {
        _this.setData(undefined);

        _this.setCustomAutoText(undefined);
      }
    });
    Object(mobx_module["d" /* reaction */])(function () {
      return _this.focusMetricID;
    }, function (ids) {
      var parentPromise = _this.getNewData(ids);

      if (parentPromise) {
        // when the promises resolve, dump the results into this.focusMetric
        gatherDataPromises(parentPromise).then(function (resolved) {
          _this.setFocusMetric(resolved);
        });
      } else {
        _this.setFocusMetric(undefined);
      }
    });
  }

  _createClass(BigChartCardModel, [{
    key: "getNewData",
    value: function getNewData(ids) {
      if (!ids) return undefined;
      var options = {
        metrics: ids,
        source: 'SOTU'
      };
      return this.model.getChartData(options);
    }
  }, {
    key: "setCompareBy",
    value: function setCompareBy(by) {
      var oldCompareBy = this.compareBy;
      this.compareBy = by;

      if (oldCompareBy === 'category' && by === null) {
        this.userSelectedCategory = undefined;
      }

      if (oldCompareBy === null && by === 'category') {
        if (!this.userSelectedCategory || this.userSelectedCategory === PARENT_CATEGORY_ID) {
          this.userSelectedCategory = this.allChildren[0].name;
        }
      }

      if (this.categoriesByStateMissing) {
        if (by === 'category') {
          this.selectedFips = null;
        }

        if (by === 'location') {
          this.userSelectedCategory = undefined;
        }
      }
    }
  }, {
    key: "setSelectedTab",
    value: function setSelectedTab(index) {
      var _this$model$bigChartD;

      this.userSelectedTab = index; // reset category if it doesn't exist for this tab

      var children = (_this$model$bigChartD = this.model.bigChartData) === null || _this$model$bigChartD === void 0 ? void 0 : _this$model$bigChartD[this.userSelectedTab].data[0].metric.childrenTree;

      if (children && this.selectedCategory && !helpers_getAllChildren(children).map(function (_ref) {
        var name = _ref.name;
        return name;
      }).includes(this.selectedCategory)) {
        this.userSelectedCategory = PARENT_CATEGORY_ID;
      }
    }
  }, {
    key: "setSelectedFips",
    value: function setSelectedFips(fips) {
      this.selectedFips = fips;

      if (this.categoriesByStateMissing && fips !== 'US') {
        this.userSelectedCategory = undefined;

        if (this.compareBy) {
          this.compareBy = 'location';
        }
      }
    }
  }, {
    key: "setCurrentHoverFips",
    value: function setCurrentHoverFips(fips) {
      this.hoveredFips = fips;
    }
  }, {
    key: "setCurrentHoverCategory",
    value: function setCurrentHoverCategory(selector) {
      this.hoveredCategoryChart = selector;
    }
  }, {
    key: "resetHoverFips",
    value: function resetHoverFips() {
      this.hoveredFips = null;
    }
  }, {
    key: "setStateDataLoaded",
    value: function setStateDataLoaded(containerID, loaded) {
      this.stateDataStatus[containerID] = loaded;
    }
  }, {
    key: "setSelectedCategory",
    value: function setSelectedCategory(category) {
      if (!category) {
        this.userSelectedCategory = PARENT_CATEGORY_ID;
      } else {
        this.userSelectedCategory = category;

        if (this.categoriesByStateMissing) {
          this.selectedFips = null;

          if (this.compareBy) {
            this.compareBy = 'category';
          }
        }
      }
    }
  }, {
    key: "setHoveredCategory",
    value: function setHoveredCategory(category) {
      if (!category) {
        this.userHoveredCategory = null;
      } else {
        this.userHoveredCategory = category;
      }
    }
  }, {
    key: "setData",
    value: function setData(resolved) {
      this.data = resolved;
    }
  }, {
    key: "setFocusMetric",
    value: function setFocusMetric(resolved) {
      this.focusMetric = resolved;
    }
  }, {
    key: "setCustomAutoText",
    value: function setCustomAutoText(text) {
      this.currentCustomAutoText = text;
    }
  }, {
    key: "currentSpecChart",
    get: function get() {
      return this.model.chartSpec[this.model.selectedMetric];
    }
  }, {
    key: "currentSpecOptions",
    get: function get() {
      return this.currentSpecChart.options[this.selectedTab];
    }
  }, {
    key: "parentID",
    get: function get() {
      var _this$model$bigChartD2;

      return (_this$model$bigChartD2 = this.model.bigChartData) === null || _this$model$bigChartD2 === void 0 ? void 0 : _this$model$bigChartD2[this.selectedTab].data[0].id;
    }
  }, {
    key: "selectedCategoryID",
    get: function get() {
      var _getAllChildren$find,
          _this2 = this;

      if (!this.selectedCategory || !this.childrenTree) return this.parentID;
      return (_getAllChildren$find = helpers_getAllChildren(this.childrenTree).find(function (_ref2) {
        var name = _ref2.name;
        return name === _this2.selectedCategory;
      })) === null || _getAllChildren$find === void 0 ? void 0 : _getAllChildren$find.spec.id;
    }
  }, {
    key: "showParentMetric",
    get: function get() {
      if (this.useBarChart) return false;
      var data = this.currentParentMetric;
      var fips = this.combinedFips;

      if (data) {
        var metadata = data.metric.metadata;

        if (metadata) {
          if (this.compareBy === 'category') {
            return metadata.transformation.toLowerCase() === 'pctchange' || !this.aggregateNominalCategories || this.selectedCategory === PARENT_CATEGORY_ID;
          }

          return metadata.transformation.toLowerCase() === 'pctchange' || fips === 'US' || fips === '00';
        }

        return true;
      }

      return true;
    } // get set of IDs we need to fetch from the API given the options selected in the drawer

  }, {
    key: "drawerIDs",
    get: function get() {
      var _this$model$bigChartD3;

      var data = (_this$model$bigChartD3 = this.model.bigChartData) === null || _this$model$bigChartD3 === void 0 ? void 0 : _this$model$bigChartD3[this.selectedTab].data[0];

      if (!data) {
        return undefined;
      } // default national IDs


      var ids = this.currentSpecOptions.metrics;
      var children = this.allChildren;

      if (!this.useBarChart) {
        if (this.compareBy === 'category') {
          // get IDs for all categories in the selected location
          return getAllCategoryIDs(ids, this.combinedFips, children, this.showParentMetric);
        }

        if (this.compareBy === 'location' && !this.noStates) {
          // get IDs for the selected category in all locations
          return getAllLocationIDs(ids, this.selectedCategory, children, this.showParentMetric);
        }
      }

      if (this.selectedCategory) {
        // get ID for the selected category (if any) nationally
        return getSingleCategoryID(ids[0], this.selectedCategory, this.combinedFips, children);
      }

      var fips = this.noStates ? null : this.combinedFips;
      return ids.map(function (spec) {
        return getSingleNormalID(spec, fips);
      });
    }
  }, {
    key: "focusMetricID",
    get: function get() {
      // default national IDs
      var ids = this.currentSpecOptions.metrics;
      var children = this.allChildren; // get ID for the selected category (if any) nationally

      return getSingleCategoryID(ids[0], this.selectedCategory, this.combinedFips, children);
    }
  }, {
    key: "currentParentMetric",
    get: function get() {
      var _this$model$bigChartD4;

      return (_this$model$bigChartD4 = this.model.bigChartData) === null || _this$model$bigChartD4 === void 0 ? void 0 : _this$model$bigChartD4[this.selectedTab].data[0];
    }
  }, {
    key: "childrenTree",
    get: function get() {
      var _this$currentParentMe;

      var tree = (_this$currentParentMe = this.currentParentMetric) === null || _this$currentParentMe === void 0 ? void 0 : _this$currentParentMe.metric.childrenTree;

      if (tree && Object.keys(tree).length > 0) {
        return tree;
      }

      return undefined;
    }
  }, {
    key: "allChildren",
    get: function get() {
      return this.childrenTree ? helpers_getAllChildren(this.childrenTree) : [];
    } // the selected FIPS for this card, or the top level fips if none selected

  }, {
    key: "combinedFips",
    get: function get() {
      if (this.noStates) {
        return 'US';
      }

      if (this.categoriesByStateMissing) {
        if (this.compareBy === 'category' || this.selectedCategory !== PARENT_CATEGORY_ID) {
          return 'US';
        }
      }

      return this.selectedFips || this.model.currentFips;
    }
  }, {
    key: "invertScale",
    get: function get() {
      var _this$currentSpecChar;

      return (_this$currentSpecChar = this.currentSpecChart.invertScale) !== null && _this$currentSpecChar !== void 0 ? _this$currentSpecChar : false;
    }
  }, {
    key: "categoriesByStateMissing",
    get: function get() {
      var _this$currentSpecChar2;

      return (_this$currentSpecChar2 = this.currentSpecChart.categoriesByStateMissing) !== null && _this$currentSpecChar2 !== void 0 ? _this$currentSpecChar2 : false;
    }
  }, {
    key: "centerZero",
    get: function get() {
      var _this$currentSpecChar3;

      return (_this$currentSpecChar3 = this.currentSpecChart.centerZero) !== null && _this$currentSpecChar3 !== void 0 ? _this$currentSpecChar3 : false;
    }
  }, {
    key: "learnMore",
    get: function get() {
      return this.currentSpecChart.learnMore;
    }
  }, {
    key: "metricPurpose",
    get: function get() {
      var _this$currentSpecChar4;

      return (_this$currentSpecChar4 = this.currentSpecChart.metricPurpose) !== null && _this$currentSpecChar4 !== void 0 ? _this$currentSpecChar4 : null;
    }
  }, {
    key: "notScaled",
    get: function get() {
      var _this$currentSpecChar5;

      return (_this$currentSpecChar5 = this.currentSpecChart.notScaled) !== null && _this$currentSpecChar5 !== void 0 ? _this$currentSpecChar5 : false;
    }
  }, {
    key: "noStates",
    get: function get() {
      var _this$currentSpecChar6;

      return (_this$currentSpecChar6 = this.currentSpecChart.noStates) !== null && _this$currentSpecChar6 !== void 0 ? _this$currentSpecChar6 : false;
    }
  }, {
    key: "metadata",
    get: function get() {
      var _this$data;

      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.data[0].metric.metadata;
    }
  }, {
    key: "aggregateNominalCategories",
    get: function get() {
      var _this$currentSpecOpti;

      return (_this$currentSpecOpti = this.currentSpecOptions.aggregateNominalCategories) !== null && _this$currentSpecOpti !== void 0 ? _this$currentSpecOpti : true;
    }
  }, {
    key: "customAutoText",
    get: function get() {
      return this.currentSpecOptions.customAutoText;
    }
  }, {
    key: "showExactNumber",
    get: function get() {
      var _this$currentSpecOpti2;

      return (_this$currentSpecOpti2 = this.currentSpecOptions.showExactNumber) !== null && _this$currentSpecOpti2 !== void 0 ? _this$currentSpecOpti2 : false;
    }
  }, {
    key: "useBarChart",
    get: function get() {
      return this.currentSpecOptions.useBarChart || false;
    }
  }, {
    key: "tabs",
    get: function get() {
      if (!this.model.bigChartData) return []; // use shortName from metadata as tab name if it exists; otherwise use metric name

      return this.model.bigChartData.map(function (_ref3) {
        var data = _ref3.data;
        var metric = data[0].metric;

        if (metric.metadata && metric.metadata.shortName) {
          return metric.metadata.shortName;
        }

        return metric.datasets[0].name || 'tab';
      });
    } // the user-selected tab, if they've selected one; otherwise, the tab index defined in the main options, or 0

  }, {
    key: "selectedTab",
    get: function get() {
      var defaultTab = this.currentSpecChart.index || 0;

      if (this.userSelectedTab !== null) {
        // if we switch chart sources (eg. by clicking an explore link) this is out of bounds protection
        if (this.model.bigChartData && this.model.bigChartData.length <= this.userSelectedTab) {
          return defaultTab;
        }

        return this.userSelectedTab;
      }

      return defaultTab;
    }
  }, {
    key: "selectedTabName",
    get: function get() {
      return this.tabs[this.selectedTab || 0];
    }
  }, {
    key: "selectedCategory",
    get: function get() {
      var _this3 = this;

      if (this.userSelectedCategory === PARENT_CATEGORY_ID) return PARENT_CATEGORY_ID;

      if (this.categoriesByStateMissing && this.compareBy === 'location') {
        return PARENT_CATEGORY_ID;
      }

      if (this.userSelectedCategory === undefined || this.userSelectedCategory && this.allChildren.findIndex(function (d) {
        return d.name === _this3.userSelectedCategory;
      }) < 0) {
        return this.currentSpecChart.initialCategory || PARENT_CATEGORY_ID;
      }

      return this.userSelectedCategory;
    }
  }, {
    key: "hoveredCategory",
    get: function get() {
      var _this4 = this;

      if (this.userHoveredCategory === PARENT_CATEGORY_ID) return PARENT_CATEGORY_ID;

      if (this.userHoveredCategory === undefined || this.userHoveredCategory && this.allChildren.findIndex(function (d) {
        return d.name === _this4.userHoveredCategory;
      }) < 0) {
        return this.currentSpecChart.initialCategory || PARENT_CATEGORY_ID;
      }

      return this.userHoveredCategory;
    }
  }]);

  return BigChartCardModel;
}();

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "userSelectedTab", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "userSelectedCategory", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "userHoveredCategory", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "selectedFips", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "hoveredFips", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "hoveredCategoryChart", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "locationTab", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "compareBy", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "stateDataStatus", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "dataPromises", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "data", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "focusMetric", void 0);

__decorate([mobx_module["c" /* observable */]], BigChartCardModel_BigChartCardModel.prototype, "currentCustomAutoText", void 0);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "currentSpecChart", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "currentSpecOptions", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "parentID", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "selectedCategoryID", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "showParentMetric", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "drawerIDs", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "focusMetricID", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "currentParentMetric", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "childrenTree", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "allChildren", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "combinedFips", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "invertScale", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "categoriesByStateMissing", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "centerZero", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "learnMore", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "metricPurpose", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "notScaled", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "noStates", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "metadata", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "aggregateNominalCategories", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "customAutoText", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "showExactNumber", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "useBarChart", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "tabs", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "selectedTab", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "selectedTabName", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "selectedCategory", null);

__decorate([mobx_module["b" /* computed */]], BigChartCardModel_BigChartCardModel.prototype, "hoveredCategory", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setCompareBy", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setSelectedTab", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setSelectedFips", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setCurrentHoverFips", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setCurrentHoverCategory", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "resetHoverFips", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setStateDataLoaded", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setSelectedCategory", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setHoveredCategory", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setData", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setFocusMetric", null);

__decorate([mobx_module["a" /* action */].bound], BigChartCardModel_BigChartCardModel.prototype, "setCustomAutoText", null);
// CONCATENATED MODULE: ./src/model/CardModel/SmallChartCardModel.ts

















var SmallChartCardModel_SmallChartCardModel = /*#__PURE__*/function () {
  function SmallChartCardModel(model) {
    var _this = this;

    _classCallCheck(this, SmallChartCardModel);

    this.userSelectedTabs = [];
    this.model = model;
    this.model.chartSpec.forEach(function () {
      _this.userSelectedTabs.push(undefined);
    });
    Object(mobx_module["d" /* reaction */])(function () {
      return _this.cardIDs;
    }, function (allIDs) {
      var promises = _this.getNewDataArray(allIDs); // store the promises for consumption by charts


      _this.dataPromises = promises;

      if (promises) {
        // when the promises resolve, dump the results into this.data
        Promise.all(promises.map(gatherDataPromises)).then(function (resolved) {
          _this.setData(resolved);

          _this.setCustomAutoText(_this.customAutoText);
        });
      } else {
        _this.setData(undefined);

        _this.setCustomAutoText(undefined);
      }
    });
  }

  _createClass(SmallChartCardModel, [{
    key: "getNewDataArray",
    value: function getNewDataArray(allIDs) {
      var _this2 = this;

      if (!allIDs) return undefined;
      return allIDs.map(function (ids) {
        return _this2.getNewData(ids);
      });
    }
  }, {
    key: "getNewPercentArray",
    value: function getNewPercentArray(allIDs) {
      var _this3 = this;

      if (!allIDs) return undefined;
      return allIDs.map(function (ids) {
        if (!ids) return undefined;
        return _this3.getNewData(ids);
      });
    }
  }, {
    key: "getNewData",
    value: function getNewData(ids) {
      var options = {
        metrics: ids,
        source: 'SOTU'
      };
      return this.model.getChartData(options);
    }
  }, {
    key: "setSelectedTab",
    // @computed get selectedCategory(): string | null {
    //     if (this.userSelectedCategory === undefined
    //         || (this.userSelectedCategory && this.allChildren.findIndex(d => d.name === this.userSelectedCategory) < 0)) {
    //         return this.currentSpecChart.initialCategory || null;
    //     }
    //     return this.userSelectedCategory;
    // }
    value: function setSelectedTab(chartIndex, index) {
      this.userSelectedTabs[chartIndex] = index; // reset category if it doesn't exist for this tab
      // const children = this.model.smallChartData?.[chartIndex][index].data[0].metric.childrenTree;
      // if (children && this.selectedCategory
      //     && !getAllChildren(children).map(({ name }) => name).includes(this.selectedCategory)) {
      //     this.userSelectedCategory = null;
      // }
    }
  }, {
    key: "setSelectedMetric",
    value: function setSelectedMetric(index) {
      this.model.setSelectedMetric(index);
    }
  }, {
    key: "setData",
    value: function setData(resolved) {
      this.data = resolved;
    }
  }, {
    key: "setCustomAutoText",
    value: function setCustomAutoText(text) {
      this.currentCustomAutoText = text;
    }
  }, {
    key: "currentFips",
    get: function get() {
      var _this4 = this;

      return this.noStates.map(function (bool) {
        return bool ? 'US' : _this4.model.currentFips;
      });
    }
  }, {
    key: "matchesGlobalFips",
    get: function get() {
      var _this5 = this;

      return this.currentFips.map(function (bool) {
        return bool === _this5.model.currentFips;
      });
    }
  }, {
    key: "initialCategories",
    get: function get() {
      return this.model.chartSpec.map(function (_ref) {
        var initialCategory = _ref.initialCategory;
        return initialCategory;
      });
    }
  }, {
    key: "startOpen",
    get: function get() {
      return this.model.chartSpec.map(function (_ref2) {
        var startOpen = _ref2.startOpen;
        return startOpen || false;
      });
    }
  }, {
    key: "cardIDs",
    get: function get() {
      var _this6 = this;

      var data = this.model.smallChartData;

      if (!data) {
        return undefined;
      } // default national IDs


      var ids = this.model.chartSpec.map(function (chart, i) {
        return chart.options[_this6.selectedTabs[i]];
      });
      var allChildren = this.allChildren; // create a list of IDs per chart based on whether or not initialCategory is set for that chart

      return this.initialCategories.map(function (category, i) {
        var defaultID = {
          id: ids[i].metrics[0].id
        };
        return getSingleCategoryID(defaultID, category, _this6.currentFips[i], allChildren[i]);
      });
    }
  }, {
    key: "childrenTrees",
    get: function get() {
      var _this$model$smallChar,
          _this7 = this;

      var tree = (_this$model$smallChar = this.model.smallChartData) === null || _this$model$smallChar === void 0 ? void 0 : _this$model$smallChar.map(function (data, i) {
        return data[_this7.selectedTabs[i]].data[0].metric.childrenTree;
      });

      if (tree && Object.keys(tree).length > 0) {
        return tree;
      }

      return undefined;
    }
  }, {
    key: "allChildren",
    get: function get() {
      return this.childrenTrees ? this.childrenTrees.map(function (tree) {
        return tree ? helpers_getAllChildren(tree) : [];
      }) : [];
    }
  }, {
    key: "linkAction",
    get: function get() {
      return this.model.scrollTo || undefined;
    }
  }, {
    key: "invertScales",
    get: function get() {
      return this.model.chartSpec.map(function (spec) {
        return spec.invertScale || false;
      });
    }
  }, {
    key: "centerZero",
    get: function get() {
      return this.model.chartSpec.map(function (spec) {
        return spec.centerZero || false;
      });
    }
  }, {
    key: "notScaled",
    get: function get() {
      return this.model.chartSpec.map(function (spec) {
        return spec.notScaled || false;
      });
    }
  }, {
    key: "noStates",
    get: function get() {
      return this.model.chartSpec.map(function (spec) {
        return spec.noStates || false;
      });
    }
  }, {
    key: "metadata",
    get: function get() {
      var _this$data;

      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.map(function (d) {
        return d.data[0].metric.metadata;
      });
    }
  }, {
    key: "customAutoText",
    get: function get() {
      return this.model.chartSpec.map(function (chart) {
        return chart.options[chart.index || 0].customAutoText;
      });
    }
  }, {
    key: "showExactNumber",
    get: function get() {
      return this.model.chartSpec.map(function (chart) {
        return chart.options[chart.index || 0].showExactNumber || false;
      });
    }
  }, {
    key: "selectedMetric",
    get: function get() {
      return this.model.selectedMetric;
    }
  }, {
    key: "tabs",
    get: function get() {
      if (!this.model.smallChartData) return []; // use shortName from metadata as tab name if it exists; otherwise use metric name

      return this.model.smallChartData.map(function (chart) {
        return chart.map(function (_ref3) {
          var data = _ref3.data;
          var metric = data[0].metric;

          if (metric.metadata && metric.metadata.shortName) {
            return metric.metadata.shortName;
          }

          return metric.datasets[0].name || 'tab';
        });
      });
    } // the user-selected tab, if they've selected one; otherwise, the tab index defined in the main options, or 0

  }, {
    key: "selectedTabs",
    get: function get() {
      var _this8 = this;

      var defaultTabs = this.model.chartSpec.map(function (chart) {
        return chart.index || 0;
      });
      return defaultTabs.map(function (tab, i) {
        var userTab = _this8.userSelectedTabs[i];

        if (userTab !== undefined) {
          // if we switch chart sources (eg. by clicking an explore link) this is out of bounds protection
          if (_this8.model.smallChartData && _this8.model.smallChartData[i].length <= userTab) {
            return tab;
          }

          return userTab;
        }

        return tab;
      });
    }
  }]);

  return SmallChartCardModel;
}();



__decorate([mobx_module["c" /* observable */]], SmallChartCardModel_SmallChartCardModel.prototype, "dataPromises", void 0);

__decorate([mobx_module["c" /* observable */]], SmallChartCardModel_SmallChartCardModel.prototype, "data", void 0);

__decorate([mobx_module["c" /* observable */]], SmallChartCardModel_SmallChartCardModel.prototype, "tabData", void 0);

__decorate([mobx_module["c" /* observable */]], SmallChartCardModel_SmallChartCardModel.prototype, "userSelectedTabs", void 0);

__decorate([mobx_module["c" /* observable */]], SmallChartCardModel_SmallChartCardModel.prototype, "currentCustomAutoText", void 0);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "currentFips", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "matchesGlobalFips", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "initialCategories", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "startOpen", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "cardIDs", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "childrenTrees", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "allChildren", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "linkAction", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "invertScales", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "centerZero", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "notScaled", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "noStates", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "metadata", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "customAutoText", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "showExactNumber", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "selectedMetric", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "tabs", null);

__decorate([mobx_module["b" /* computed */]], SmallChartCardModel_SmallChartCardModel.prototype, "selectedTabs", null);

__decorate([mobx_module["a" /* action */].bound], SmallChartCardModel_SmallChartCardModel.prototype, "setSelectedTab", null);

__decorate([mobx_module["a" /* action */].bound], SmallChartCardModel_SmallChartCardModel.prototype, "setData", null);

__decorate([mobx_module["a" /* action */].bound], SmallChartCardModel_SmallChartCardModel.prototype, "setCustomAutoText", null);
// CONCATENATED MODULE: ./src/model/TopicModel.ts












var TopicModel_TopicModel = /*#__PURE__*/function () {
  function TopicModel(model, options) {
    var _this = this;

    _classCallCheck(this, TopicModel);

    // the index of the focused dataset; can be modified by clicking "explore" on a card with a non-focused dataset
    this.selectedMetric = 0;
    this.metadataReaction = null;
    this.name = options.name;
    this.bigContainer = options.bigContainer.replace(/#/g, '');
    this.scrollTo = options.scrollTo || null;
    this.chartSpec = options.charts;
    this.model = model;
    this.bigChartModel = new BigChartCardModel_BigChartCardModel(this);
    this.smallChartModel = new SmallChartCardModel_SmallChartCardModel(this); // get parent data, then dump it into topLevelData when resolved

    this.initData().then(function (fullData) {
      _this.setTopLevelData(fullData);
    });
  }

  _createClass(TopicModel, [{
    key: "initData",
    value: function initData() {
      var _this2 = this;

      var promises = this.chartSpec.map(function (chart) {
        return chart.options.map(function (options) {
          return _this2.getChartData(options);
        });
      });
      this.topLevelDataPromises = promises;
      return formatResolvedData(promises);
    }
  }, {
    key: "getChartData",
    value: function getChartData(params, states) {
      return this.model.getChartData(params, states);
    }
  }, {
    key: "setSelectedMetric",
    value: function setSelectedMetric(index) {
      var _this$smallChartData;

      this.selectedMetric = Math.min(((_this$smallChartData = this.smallChartData) === null || _this$smallChartData === void 0 ? void 0 : _this$smallChartData.length) || 0, Math.max(0, index));
    }
  }, {
    key: "setTopLevelData",
    value: function setTopLevelData(data) {
      this.topLevelData = data;
    }
  }, {
    key: "onMetadataAvailable",
    value: function onMetadataAvailable(callback) {
      var _this3 = this;

      this.metadataReaction = Object(mobx_module["d" /* reaction */])(function () {
        return _this3.smallChartModel.metadata;
      }, function (metadata) {
        callback(metadata);
      });
    }
  }, {
    key: "smallChartData",
    get: function get() {
      return this.topLevelData;
    }
  }, {
    key: "smallChartDataPromises",
    get: function get() {
      return this.topLevelDataPromises;
    }
  }, {
    key: "bigChartData",
    get: function get() {
      var _this$topLevelData;

      return (_this$topLevelData = this.topLevelData) === null || _this$topLevelData === void 0 ? void 0 : _this$topLevelData[this.selectedMetric];
    }
  }, {
    key: "currentFips",
    get: function get() {
      return this.model.currentFips;
    }
  }]);

  return TopicModel;
}();



__decorate([mobx_module["c" /* observable */]], TopicModel_TopicModel.prototype, "selectedMetric", void 0);

__decorate([mobx_module["c" /* observable */]], TopicModel_TopicModel.prototype, "topLevelDataPromises", void 0);

__decorate([mobx_module["c" /* observable */]], TopicModel_TopicModel.prototype, "topLevelData", void 0);

__decorate([mobx_module["a" /* action */].bound], TopicModel_TopicModel.prototype, "initData", null);

__decorate([mobx_module["b" /* computed */]], TopicModel_TopicModel.prototype, "smallChartData", null);

__decorate([mobx_module["b" /* computed */]], TopicModel_TopicModel.prototype, "smallChartDataPromises", null);

__decorate([mobx_module["b" /* computed */]], TopicModel_TopicModel.prototype, "bigChartData", null);

__decorate([mobx_module["b" /* computed */]], TopicModel_TopicModel.prototype, "currentFips", null);

__decorate([mobx_module["a" /* action */].bound], TopicModel_TopicModel.prototype, "setSelectedMetric", null);

__decorate([mobx_module["a" /* action */].bound], TopicModel_TopicModel.prototype, "setTopLevelData", null);
// CONCATENATED MODULE: ./src/model/config.ts
var colourPalette = ['#960F5A', '#E83296', '#F295CA', '#68C4EB', '#249EDC', '#015193'];
var sequentialPalette = ['#D1B4E7', '#A66ED1', '#9248C7', '#7834A8', '#5D2882', '#401C5A'];
var notScaled = '#4D4D4D';
var scaleLabels = ['worse', 'Retrograde', 'Constant', 'Improving', 'better'];
var sequentialLabels = ['low', '', '', '', '', 'high'];
// CONCATENATED MODULE: ./src/model/AppModel.ts









var AppModel_AppModel = /*#__PURE__*/function () {
  function AppModel(chartOptionsSet) {
    _classCallCheck(this, AppModel);

    this.topicModels = [];
    this.colourPalette = colourPalette;
    this.sequentialPalette = sequentialPalette;
    this.notScaled = notScaled;
    this.scaleLabels = scaleLabels;
    this.sequentialLabels = sequentialLabels; // top-level FIPS for the whole page - lower-level models may specify their own according to user input

    this.currentFips = 'US';
    this.chartModel = new usafacts_metrics["ChartModel"]();
    this.chartModel.setModifier(function (d) {
      var fips = d.datasets[0].geo_id || d.datasets[0].geoId;

      if (fips) {
        // eslint-disable-next-line
        d.fips = fips;
      }

      return d;
    });
    this.setTopicModels(chartOptionsSet);
  }

  _createClass(AppModel, [{
    key: "getChartData",
    value: function getChartData(params, states) {
      return this.chartModel.getChartData(params, states);
    }
  }, {
    key: "setTopicModels",
    value: function setTopicModels(chartOptionsSet) {
      var _this = this;

      this.topicModels = chartOptionsSet.map(function (topic) {
        return new TopicModel_TopicModel(_this, topic);
      });
    }
  }, {
    key: "setCurrentFips",
    value: function setCurrentFips(fips) {
      this.currentFips = fips;
    }
  }]);

  return AppModel;
}();



__decorate([mobx_module["c" /* observable */].shallow], AppModel_AppModel.prototype, "topicModels", void 0);

__decorate([mobx_module["c" /* observable */]], AppModel_AppModel.prototype, "colourPalette", void 0);

__decorate([mobx_module["c" /* observable */]], AppModel_AppModel.prototype, "sequentialPalette", void 0);

__decorate([mobx_module["c" /* observable */]], AppModel_AppModel.prototype, "notScaled", void 0);

__decorate([mobx_module["c" /* observable */]], AppModel_AppModel.prototype, "scaleLabels", void 0);

__decorate([mobx_module["c" /* observable */]], AppModel_AppModel.prototype, "sequentialLabels", void 0);

__decorate([mobx_module["c" /* observable */]], AppModel_AppModel.prototype, "currentFips", void 0);

__decorate([mobx_module["a" /* action */].bound], AppModel_AppModel.prototype, "setTopicModels", null);

__decorate([mobx_module["a" /* action */].bound], AppModel_AppModel.prototype, "setCurrentFips", null);
// CONCATENATED MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.module.js


var vue_composition_api_module_toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) &&
    typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noopFn,
    set: noopFn,
};
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    sharedPropertyDefinition.get = get || noopFn;
    sharedPropertyDefinition.set = set || noopFn;
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
var vue_composition_api_module_hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return vue_composition_api_module_hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition)
        throw new Error("[vue-composition-api] " + msg);
}
function isArray(x) {
    return Array.isArray(x);
}
function isPlainObject(x) {
    return vue_composition_api_module_toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function warn(msg, vm) {
    vue_runtime_esm["a" /* default */].util.warn(msg, vm);
}
function logError(err, vm, info) {
    {
        warn("Error in " + info + ": \"" + err.toString() + "\"", vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

var currentVue = null;
var currentVM = null;
function getCurrentVue() {
    {
        assert(currentVue, "must call Vue.use(plugin) before using any function.");
    }
    return currentVue;
}
function setCurrentVue(vue) {
    currentVue = vue;
}
function getCurrentVM() {
    return currentVM;
}
function setCurrentVM(vm) {
    currentVM = vm;
}

function ensureCurrentVMInFn(hook) {
    var vm = getCurrentVM();
    {
        assert(vm, "\"" + hook + "\" get called outside of \"setup()\"");
    }
    return vm;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    return currentVue && obj instanceof currentVue;
}
function createSlotProxy(vm, slotName) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            return warn("slots." + slotName + "() got called outside of the \"render()\" scope", vm);
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    };
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('vfa.key.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('vfa.key.postFlushQueue');
var AccessControlIdentifierKey = createSymbol('vfa.key.accessControlIdentifier');
var ReactiveIdentifierKey = createSymbol('vfa.key.reactiveIdentifier');
var NonReactiveIdentifierKey = createSymbol('vfa.key.nonReactiveIdentifier');
// must be a string, symbol key is ignored in reactive
var RefKey = 'vfa.key.refKey';

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options) {
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shoulnd't extend it.
    // related issues: #79
    return Object.seal(new RefImpl(options));
}
// implementation
function ref(raw) {
    // if (isRef(raw)) {
    //   return {} as any;
    // }
    var _a;
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function toRefs(obj) {
    if (!isPlainObject(obj))
        return obj;
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var val = obj[key];
        // use ref to proxy the property
        if (!isRef(val)) {
            val = createRef({
                get: function () { return obj[key]; },
                set: function (v) { return (obj[key] = v); },
            });
        }
        // todo
        res[key] = val;
    });
    return res;
}

var AccessControlIdentifier = {};
var ReactiveIdentifier = {};
var NonReactiveIdentifier = {};
function isNonReactive(obj) {
    return (hasOwn(obj, NonReactiveIdentifierKey) && obj[NonReactiveIdentifierKey] === NonReactiveIdentifier);
}
function isReactive(obj) {
    return hasOwn(obj, ReactiveIdentifierKey) && obj[ReactiveIdentifierKey] === ReactiveIdentifier;
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isNonReactive(target) ||
        Array.isArray(target) ||
        isRef(target) ||
        isComponentInstance(target)) {
        return;
    }
    if (hasOwn(target, AccessControlIdentifierKey) &&
        target[AccessControlIdentifierKey] === AccessControlIdentifier) {
        return;
    }
    if (Object.isExtensible(target)) {
        def(target, AccessControlIdentifierKey, AccessControlIdentifier);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ && arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            var value = getter ? getter.call(target) : val;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getCurrentVue();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!obj) {
        warn('"reactive()" is called without provide an "object".');
        // @ts-ignore
        return;
    }
    if (!isPlainObject(obj) || isReactive(obj) || isNonReactive(obj) || !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    def(observed, ReactiveIdentifierKey, ReactiveIdentifier);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function nonReactive(obj) {
    if (!isPlainObject(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    def(obj, '__ob__', observe({}).__ob__);
    // mark as nonReactive
    def(obj, NonReactiveIdentifierKey, NonReactiveIdentifier);
    return obj;
}

function isUndef(v) {
    return v === undefined || v === null;
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set(target, key, val) {
    var Vue = getCurrentVue();
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (isUndef(target) || isPrimitive(target)) {
        warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ob.dep.notify();
    return val;
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            (isPlainObject(toVal) && !isRef(toVal)) &&
            (isPlainObject(fromVal) && !isRef(fromVal))) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue, _install) {
    if (currentVue && currentVue === Vue) {
        {
            assert(false, 'already installed. Vue.use(plugin) should be called only once');
        }
        return;
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(typeof parent === 'function' ? parent(props, context) || {} : {}, typeof child === 'function' ? child(props, context) || {} : {});
        };
    };
    setCurrentVue(Vue);
    _install(Vue);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var vue_composition_api_module_assign = function() {
    vue_composition_api_module_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return vue_composition_api_module_assign.apply(this, arguments);
};

function vue_composition_api_module_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function vue_composition_api_module_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(vue_composition_api_module_read(arguments[i]));
    return ar;
}

function set$1(vm, key, value) {
    var state = (vm.__secret_vfa_state__ = vm.__secret_vfa_state__ || {});
    state[key] = value;
}
function vue_composition_api_module_get(vm, key) {
    return (vm.__secret_vfa_state__ || {})[key];
}
var vmStateManager = {
    set: set$1,
    get: vue_composition_api_module_get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        proxy(vm, propName, {
            get: function () { return propValue.value; },
            set: function (val) {
                propValue.value = val;
            },
        });
        {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                proxy(vm._data, propName, {
                    get: function () { return propValue.value; },
                    set: function (val) {
                        propValue.value = val;
                    },
                });
            });
        }
    }
    else {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"" + propName + "\" is already declared as a prop.", vm);
        }
        else {
            warn("The setup binding property \"" + propName + "\" is already declared.", vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVode = vm.$options._parentVnode;
    if (!parentVode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(vm, fn, onError) {
    var preVm = getCurrentVM();
    setCurrentVM(vm);
    try {
        return fn(vm);
    }
    catch (err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentVM(preVm);
    }
}
function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            updateTemplateRef(this);
        },
        updated: function () {
            updateTemplateRef(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(vm, function () { return render.apply(_this, args); });
            };
        }
        if (!setup) {
            return;
        }
        if (typeof setup !== 'function') {
            {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return typeof data === 'function'
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(vm, function () {
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(vm, function () { return bindingFunc_1(); });
            };
            return;
        }
        if (isPlainObject(binding)) {
            var bindingObj_1 = binding;
            vmStateManager.set(vm, 'rawBindings', binding);
            Object.keys(binding).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                // only make primitive value reactive
                if (!isRef(bindingValue)) {
                    if (isReactive(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                    else {
                        // a non-reactive should not don't get reactivity
                        bindingValue = ref(nonReactive(bindingValue));
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"" + Object.prototype.toString
                .call(binding)
                .slice(8, -1) + "\"");
        }
    }
    function createSetupContext(vm) {
        var ctx = {
            slots: {},
        };
        var props = [
            'root',
            'parent',
            'refs',
            'attrs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        props.forEach(function (key) {
            var _a;
            var targetKey;
            var srcKey;
            if (Array.isArray(key)) {
                _a = vue_composition_api_module_read(key, 2), targetKey = _a[0], srcKey = _a[1];
            }
            else {
                targetKey = srcKey = key;
            }
            srcKey = "$" + srcKey;
            proxy(ctx, targetKey, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    warn("Cannot assign to '" + targetKey + "' because it is a read-only property", vm);
                },
            });
        });
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$" + key;
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        return ctx;
    }
}

var fallbackCreateElement;
var createElement = function createElement() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!currentVM) {
        warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getCurrentVue()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return currentVM.$createElement.apply(currentVM, args);
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}
// implementation, deferring to defineComponent, but logging a warning in dev mode
function createComponent(options) {
    {
        vue_runtime_esm["a" /* default */].util.warn('`createComponent` has been renamed to `defineComponent`.');
    }
    return defineComponent(options);
}

var genName = function (name) { return "on" + (name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback) {
        var vm = ensureCurrentVMInFn(genName(lifeCyclehook));
        injectHookOption(getCurrentVue(), vm, lifeCyclehook, callback);
    };
}
function injectHookOption(Vue, vm, hook, val) {
    var options = vm.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    options[hook] = mergeFn(options[hook], val);
}
// export const onCreated = createLifeCycle('created');
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return vue_composition_api_module_assign({
        lazy: false,
        deep: false,
        flush: 'post',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getCurrentVue());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got " + mode);
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
function createWatcher(vm, source, cb, options) {
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync || /* without a current active instance, ignore pre|post mode */ vm === fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, vue_composition_api_module_spread(args));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var getter_1 = function () { return source(registerCleanup); };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            noRun: true,
            deep: options.deep,
            sync: isSync,
            before: runCleanup,
        });
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        if (isSync) {
            watcher_1.get();
        }
        else {
            vm.$nextTick(originGet);
        }
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
            runCleanup();
        };
    }
    var getter;
    if (Array.isArray(source)) {
        getter = function () { return source.map(function (s) { return (isRef(s) ? s.value : s()); }); };
    }
    else if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else {
        getter = source;
    }
    var applyCb = function (n, o) {
        // cleanup before running cb again
        runCleanup();
        cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (!options.lazy) {
        var originalCallbck_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallbck_1;
            applyCb(n, o);
        };
        callback = function (n, o) {
            shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: !options.lazy,
        deep: options.deep,
        sync: isSync,
    });
    return function () {
        stop();
        runCleanup();
    };
}
function watchEffect(effect, options) {
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watch(source, cb, options) {
    var callback = null;
    if (typeof cb === 'function') {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}

// implement
function computed(options) {
    var vm = getCurrentVM();
    var get, set;
    if (typeof options === 'function') {
        get = options;
    }
    else {
        get = options.get;
        set = options.set;
    }
    var computedHost = defineComponentInstance(getCurrentVue(), {
        computed: {
            $$state: {
                get: get,
                set: set,
            },
        },
    });
    return createRef({
        get: function () { return computedHost.$$state; },
        set: function (v) {
            if (!set) {
                warn('Computed property was assigned to but it has no setter.', vm);
                return;
            }
            computedHost.$$state = v;
        },
    });
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var vm = ensureCurrentVMInFn('provide');
    if (!vm._provided) {
        var provideCache_1 = {};
        Object.defineProperty(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue) {
    if (!key) {
        return defaultValue;
    }
    var vm = ensureCurrentVMInFn('inject');
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    else if (defaultValue !== undefined) {
        return defaultValue;
    }
    else {
        warn("Injection \"" + String(key) + "\" not found", vm);
    }
}

var _install = function (Vue) { return install(Vue, mixin); };
var vue_composition_api_module_plugin = {
    install: _install,
};
// Auto install if it is not done yet and `window` has `Vue`.
// To allow users to avoid auto-installation in some cases,
if (currentVue && typeof window !== 'undefined' && window.Vue) {
    _install(window.Vue);
}

/* harmony default export */ var vue_composition_api_module = (vue_composition_api_module_plugin);


// CONCATENATED MODULE: ./src/model/useMobxPlugin.ts








function mobxComputed(objs) {
  var vueDataObject = lodash_default.a.mapValues(objs, function () {
    return null;
  }); // Create the vue ref object if it doesn't exist, otherwise return it
  //
  // We do this lazily so we have access to `this` in our getters so we can
  // react to _both_ MobX and Vue changes in the same function


  var lazyInitializeRef = function lazyInitializeRef(key) {
    var _this = this;

    // @ts-ignore
    if (vueDataObject[key] !== null) {
      return vueDataObject[key];
    } // // console.log('actuallyInitializeRef', key);


    var vdo = {
      ref: ref(null),
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      dispose: function dispose() {}
    };
    vueDataObject[key] = vdo; // Mobx reaction - catch mobx observable changes

    var mobxDisposer = Object(mobx_module["d" /* reaction */])(function () {
      return objs[key].call(_this);
    }, function (value) {
      // // console.log(key, 'reaction');
      vdo.ref.value = value;
    }); // Vue watch - catch vue reactive changes
    // @ts-ignore

    var vueDisposer = watch(function () {
      return objs[key].call(_this);
    }, function (value) {
      // // console.log(key, 'watch');
      vdo.ref.value = value;
    });

    vdo.dispose = function () {
      mobxDisposer();
      vueDisposer();
    };

    return vdo;
  }; // @ts-ignore


  return {
    wrappedComputed: lodash_default.a.mapValues(objs, function (value, key) {
      return function () {
        return lazyInitializeRef.call(this, key).ref.value;
      };
    }),
    dispose: function dispose() {
      // eslint-disable-next-line no-shadow
      lodash_default()(vueDataObject).values().forEach(function (ref) {
        if (ref) {
          ref.dispose();
        }
      });
    }
  };
}

mobxComputed.install = function (Vue) {
  Vue.use(vue_composition_api_module);
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;

      if (options.useMobxComputed && options.computed) {
        var _mobxComputed = mobxComputed(options.computed),
            wrappedComputed = _mobxComputed.wrappedComputed,
            dispose = _mobxComputed.dispose;

        options.computed = wrappedComputed;

        var oldBeforeDestroy = options.beforeDestroy || function () {
          return null;
        };

        options.beforeDestroy = function () {
          oldBeforeDestroy();
          dispose();
        };
      }
    }
  });
};
// CONCATENATED MODULE: ./src/model/injectAppModel.ts

vue_runtime_esm["a" /* default */].mixin({
  beforeCreate: function beforeCreate() {
    this.$appModel = this.$options.appModel || this.$parent && this.$parent.$appModel;
  }
});
// EXTERNAL MODULE: ./src/lib/tailwind.css
var tailwind = __webpack_require__("7165");

// EXTERNAL MODULE: ./node_modules/@usafacts/frontend-library-metrics/dist/usafacts-metrics.css
var dist_usafacts_metrics = __webpack_require__("808d");

// CONCATENATED MODULE: ./src/index.ts













function runCovid(topics, onSmallDraw, onBigDraw) {
  vue_runtime_esm["a" /* default */].config.productionTip = false;
  vue_runtime_esm["a" /* default */].use(mobxComputed); // @ts-ignore

  vue_runtime_esm["a" /* default */].use(src_screens);
  var appModel = new AppModel_AppModel(topics);
  appModel.topicModels.forEach(function (topicModel) {
    new BigChartCardView({
      appModel: appModel,
      propsData: {
        model: topicModel.bigChartModel,
        onDraw: onBigDraw
      }
    }).$mount("#".concat(topicModel.bigContainer));
    topicModel.chartSpec.forEach(function (chart, i) {
      new SmallChartCardView({
        appModel: appModel,
        propsData: {
          model: topicModel.smallChartModel,
          chartIndex: i,
          onDraw: onSmallDraw
        }
      }).$mount("#".concat(chart.container));

      if (chart.tinyContainer) {
        new TinyCardView({
          appModel: appModel,
          propsData: {
            model: topicModel.smallChartModel,
            chartIndex: i
          }
        }).$mount("#".concat(chart.tinyContainer));
      }
    });
  });
  return appModel;
}
function drawLegend(appModel, container) {
  vue_runtime_esm["a" /* default */].config.productionTip = false;
  vue_runtime_esm["a" /* default */].use(mobxComputed);
  new LegendView({
    appModel: appModel
  }).$mount("#".concat(container));
}
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "faee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ src_chord; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ chordTranspose; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ chordDirected; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ src_ribbon; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ ribbonArrow; });

// CONCATENATED MODULE: ./node_modules/d3-chord/src/math.js
var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;
var epsilon = 1e-12;

// CONCATENATED MODULE: ./node_modules/d3-chord/src/chord.js


function range(i, j) {
  return Array.from({length: j - i}, (_, k) => i + k);
}

function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* harmony default export */ var src_chord = (function() {
  return chord_chord(false, false);
});

function chordTranspose() {
  return chord_chord(false, true);
}

function chordDirected() {
  return chord_chord(true, false);
}

function chord_chord(directed, transpose) {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = new Array(n),
        groupIndex = range(0, n),
        chords = new Array(n * n),
        groups = new Array(n),
        k = 0, dx;

    matrix = Float64Array.from({length: n * n}, transpose
        ? (_, i) => matrix[i % n][i / n | 0]
        : (_, i) => matrix[i / n | 0][i % n]);

    // Compute the scaling factor from value to angle in [0, 2pi].
    for (let i = 0; i < n; ++i) {
      let x = 0;
      for (let j = 0; j < n; ++j) x += matrix[i * n + j] + directed * matrix[j * n + i];
      k += groupSums[i] = x;
    }
    k = max(0, tau - padAngle * n) / k;
    dx = k ? padAngle : tau / n;

    // Compute the angles for each group and constituent chord.
    {
      let x = 0;
      if (sortGroups) groupIndex.sort((a, b) => sortGroups(groupSums[a], groupSums[b]));
      for (const i of groupIndex) {
        const x0 = x;
        if (directed) {
          const subgroupIndex = range(~n + 1, n).filter(j => j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
          if (sortSubgroups) subgroupIndex.sort((a, b) => sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
          for (const j of subgroupIndex) {
            if (j < 0) {
              const chord = chords[~j * n + i] || (chords[~j * n + i] = {source: null, target: null});
              chord.target = {index: i, startAngle: x, endAngle: x += matrix[~j * n + i] * k, value: matrix[~j * n + i]};
            } else {
              const chord = chords[i * n + j] || (chords[i * n + j] = {source: null, target: null});
              chord.source = {index: i, startAngle: x, endAngle: x += matrix[i * n + j] * k, value: matrix[i * n + j]};
            }
          }
          groups[i] = {index: i, startAngle: x0, endAngle: x, value: groupSums[i]};
        } else {
          const subgroupIndex = range(0, n).filter(j => matrix[i * n + j] || matrix[j * n + i]);
          if (sortSubgroups) subgroupIndex.sort((a, b) => sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
          for (const j of subgroupIndex) {
            let chord;
            if (i < j) {
              chord = chords[i * n + j] || (chords[i * n + j] = {source: null, target: null});
              chord.source = {index: i, startAngle: x, endAngle: x += matrix[i * n + j] * k, value: matrix[i * n + j]};
            } else {
              chord = chords[j * n + i] || (chords[j * n + i] = {source: null, target: null});
              chord.target = {index: i, startAngle: x, endAngle: x += matrix[i * n + j] * k, value: matrix[i * n + j]};
              if (i === j) chord.source = chord.target;
            }
            if (chord.source && chord.target && chord.source.value < chord.target.value) {
              const source = chord.source;
              chord.source = chord.target;
              chord.target = source;
            }
          }
          groups[i] = {index: i, startAngle: x0, endAngle: x, value: groupSums[i]};
        }
        x += dx;
      }
    }

    // Remove empty chords.
    chords = Object.values(chords);
    chords.groups = groups;
    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
}

// EXTERNAL MODULE: ./node_modules/d3-path/src/path.js
var path = __webpack_require__("eadc");

// CONCATENATED MODULE: ./node_modules/d3-chord/src/array.js
var slice = Array.prototype.slice;

// CONCATENATED MODULE: ./node_modules/d3-chord/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-chord/src/ribbon.js





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

function defaultPadAngle() {
  return 0;
}

function defaultArrowheadRadius() {
  return 10;
}

function ribbon_ribbon(headRadius) {
  var source = defaultSource,
      target = defaultTarget,
      sourceRadius = defaultRadius,
      targetRadius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      padAngle = defaultPadAngle,
      context = null;

  function ribbon() {
    var buffer,
        s = source.apply(this, arguments),
        t = target.apply(this, arguments),
        ap = padAngle.apply(this, arguments) / 2,
        argv = slice.call(arguments),
        sr = +sourceRadius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - halfPi,
        sa1 = endAngle.apply(this, argv) - halfPi,
        tr = +targetRadius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - halfPi,
        ta1 = endAngle.apply(this, argv) - halfPi;

    if (!context) context = buffer = Object(path["a" /* default */])();

    if (ap > epsilon) {
      if (abs(sa1 - sa0) > ap * 2 + epsilon) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
      else sa0 = sa1 = (sa0 + sa1) / 2;
      if (abs(ta1 - ta0) > ap * 2 + epsilon) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
      else ta0 = ta1 = (ta0 + ta1) / 2;
    }

    context.moveTo(sr * cos(sa0), sr * sin(sa0));
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) {
      if (headRadius) {
        var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
        context.quadraticCurveTo(0, 0, tr2 * cos(ta0), tr2 * sin(ta0));
        context.lineTo(tr * cos(ta2), tr * sin(ta2));
        context.lineTo(tr2 * cos(ta1), tr2 * sin(ta1));
      } else {
        context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
        context.arc(0, 0, tr, ta0, ta1);
      }
    }
    context.quadraticCurveTo(0, 0, sr * cos(sa0), sr * sin(sa0));
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  if (headRadius) ribbon.headRadius = function(_) {
    return arguments.length ? (headRadius = typeof _ === "function" ? _ : constant(+_), ribbon) : headRadius;
  };

  ribbon.radius = function(_) {
    return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : constant(+_), ribbon) : sourceRadius;
  };

  ribbon.sourceRadius = function(_) {
    return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : constant(+_), ribbon) : sourceRadius;
  };

  ribbon.targetRadius = function(_) {
    return arguments.length ? (targetRadius = typeof _ === "function" ? _ : constant(+_), ribbon) : targetRadius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : endAngle;
  };

  ribbon.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : padAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
}

/* harmony default export */ var src_ribbon = (function() {
  return ribbon_ribbon();
});

function ribbonArrow() {
  return ribbon_ribbon(defaultArrowheadRadius);
}

// CONCATENATED MODULE: ./node_modules/d3-chord/src/index.js




/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fb77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ linear; });
__webpack_require__.d(__webpack_exports__, "D", function() { return /* reexport */ quadInOut; });
__webpack_require__.d(__webpack_exports__, "E", function() { return /* reexport */ quadIn; });
__webpack_require__.d(__webpack_exports__, "G", function() { return /* reexport */ quadOut; });
__webpack_require__.d(__webpack_exports__, "F", function() { return /* reexport */ quadInOut; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ cubic["b" /* cubicInOut */]; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ cubic["a" /* cubicIn */]; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ cubic["c" /* cubicOut */]; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ cubic["b" /* cubicInOut */]; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* reexport */ polyInOut; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* reexport */ polyIn; });
__webpack_require__.d(__webpack_exports__, "C", function() { return /* reexport */ polyOut; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* reexport */ polyInOut; });
__webpack_require__.d(__webpack_exports__, "H", function() { return /* reexport */ sinInOut; });
__webpack_require__.d(__webpack_exports__, "I", function() { return /* reexport */ sinIn; });
__webpack_require__.d(__webpack_exports__, "K", function() { return /* reexport */ sinOut; });
__webpack_require__.d(__webpack_exports__, "J", function() { return /* reexport */ sinInOut; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ expInOut; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ expIn; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ expOut; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ expInOut; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ circleInOut; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ circleIn; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ circleOut; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ circleInOut; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ bounceOut; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ bounceIn; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ bounceOut; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ bounceInOut; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ backInOut; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ backIn; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ backOut; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ backInOut; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ elastic_elasticOut; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ elastic_elasticIn; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ elastic_elasticOut; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ elastic_elasticInOut; });

// CONCATENATED MODULE: ./node_modules/d3-ease/src/linear.js
const linear = t => +t;

// CONCATENATED MODULE: ./node_modules/d3-ease/src/quad.js
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

// EXTERNAL MODULE: ./node_modules/d3-ease/src/cubic.js
var cubic = __webpack_require__("8921");

// CONCATENATED MODULE: ./node_modules/d3-ease/src/poly.js
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

// CONCATENATED MODULE: ./node_modules/d3-ease/src/sin.js
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return (+t === 1) ? 1 : 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/math.js
// tpmt is two power minus ten times t scaled to [0,1]
function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/exp.js


function expIn(t) {
  return tpmt(1 - +t);
}

function expOut(t) {
  return 1 - tpmt(t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/circle.js
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/bounce.js
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/back.js
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return (t = +t) * t * (s * (t - 1) + t);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((t + 1) * s + t) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

// CONCATENATED MODULE: ./node_modules/d3-ease/src/elastic.js


var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elastic_elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * tpmt(-(--t)) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elastic_elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elastic_elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * tpmt(-t) * Math.sin((s - t) / p)
        : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

// CONCATENATED MODULE: ./node_modules/d3-ease/src/index.js





















/***/ }),

/***/ "fba5":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fd32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ create; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ creator["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ local; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ matcher["b" /* default */]; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ namespace["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ namespaces["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ pointer["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ pointers; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ src_select["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ selectAll; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ selection["b" /* default */]; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ src_selector["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ selectorAll["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ style["b" /* styleValue */]; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ src_window["a" /* default */]; });

// EXTERNAL MODULE: ./node_modules/d3-selection/src/creator.js
var creator = __webpack_require__("57f5");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/select.js
var src_select = __webpack_require__("00a5");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/create.js



/* harmony default export */ var create = (function(name) {
  return Object(src_select["a" /* default */])(Object(creator["a" /* default */])(name).call(document.documentElement));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/local.js
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

// EXTERNAL MODULE: ./node_modules/d3-selection/src/matcher.js
var matcher = __webpack_require__("0a78");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/namespace.js
var namespace = __webpack_require__("6cd4");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/namespaces.js
var namespaces = __webpack_require__("e311");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/pointer.js
var pointer = __webpack_require__("5e81");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/sourceEvent.js
var sourceEvent = __webpack_require__("4fd4");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/pointers.js



/* harmony default export */ var pointers = (function(events, node) {
  if (events.target) { // i.e., instanceof Event, not TouchList or iterable
    events = Object(sourceEvent["a" /* default */])(events);
    if (node === undefined) node = events.currentTarget;
    events = events.touches || [events];
  }
  return Array.from(events, event => Object(pointer["a" /* default */])(event, node));
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/array.js
var array = __webpack_require__("c226");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selection/index.js + 35 modules
var selection = __webpack_require__("e48b");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selectAll.js



/* harmony default export */ var selectAll = (function(selector) {
  return typeof selector === "string"
      ? new selection["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new selection["a" /* Selection */]([selector == null ? [] : Object(array["a" /* default */])(selector)], selection["c" /* root */]);
});

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selector.js
var src_selector = __webpack_require__("6fd3");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selectorAll.js
var selectorAll = __webpack_require__("4230");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/selection/style.js
var style = __webpack_require__("364b");

// EXTERNAL MODULE: ./node_modules/d3-selection/src/window.js
var src_window = __webpack_require__("a317");

// CONCATENATED MODULE: ./node_modules/d3-selection/src/index.js

















/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ffbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigChartCardView_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("36d6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigChartCardView_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigChartCardView_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BigChartCardView_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ffd6":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ })

/******/ });
});